import { defineComponent as ye, inject as Ft, ref as E, computed as p, onMounted as ot, onBeforeUnmount as gt, reactive as rl, provide as nn, openBlock as c, createElementBlock as g, normalizeClass as C, renderSlot as $e, useId as Ve, toValue as Rt, watch as Ie, readonly as rx, onUpdated as qi, nextTick as qe, Fragment as se, createBlock as K, resolveDynamicComponent as dt, mergeProps as Oe, withKeys as ut, withCtx as ve, Teleport as Bn, unref as I, toDisplayString as P, createCommentVNode as k, createVNode as te, Transition as wt, createTextVNode as at, createElementVNode as v, useSlots as Mn, withModifiers as Ue, normalizeStyle as Ne, useAttrs as Fn, normalizeProps as en, guardReactiveProps as tn, renderList as Me, mergeDefaults as Bb, toHandlers as Rl, h as Gn, onUnmounted as kt, shallowReactive as ox, createStaticVNode as Xr, Comment as Mb, shallowRef as Qr, getCurrentInstance as wu, watchEffect as Db, markRaw as ix, customRef as sx, toRef as qn, createSlots as _n, withDirectives as Gl, vModelText as zb, onBeforeUpdate as dx, useModel as Ob, mergeModels as wd, vModelDynamic as ux, vShow as Cu, useTemplateRef as xs, TransitionGroup as Mr, isRef as Ho, toRefs as qc, resolveComponent as cx } from "vue";
const Pb = Symbol("AccordionContext"), Fb = Symbol("AccordionItemContext"), fx = ["data-accordion-root"], CW = /* @__PURE__ */ ye({
  __name: "Accordion",
  props: {
    variant: { default: "default" },
    size: { default: void 0 },
    multiple: { type: Boolean, default: void 0 },
    headingLevel: { default: void 0 }
  },
  setup(e) {
    const n = e, t = Ft(Fb, null), a = E(), l = E(!!t), r = p(() => l.value && (t == null ? void 0 : t.variant.value) === "multi-level");
    let o;
    ot(() => {
      var x, y;
      l.value = !!t && !!((y = (x = a.value) == null ? void 0 : x.parentElement) != null && y.closest("[data-accordion-item]")), l.value && (o = t == null ? void 0 : t.registerChildAccordion());
    }), gt(() => o == null ? void 0 : o());
    const i = p(() => r.value ? "multi-level" : n.variant), s = p(() => n.size ?? (r.value && t ? t.size.value : "md")), d = p(() => n.headingLevel ? n.headingLevel : l.value && t ? Math.min(t.headingLevel.value + 1, 6) : 3), u = p(
      () => n.multiple ?? !["separate-cards", "multi-level"].includes(i.value)
    ), f = rl(/* @__PURE__ */ new Set());
    function b(x) {
      f.has(x) ? f.delete(x) : (u.value || f.clear(), f.add(x));
    }
    function h(x) {
      f.add(x);
    }
    nn(Pb, {
      variant: i,
      size: s,
      headingLevel: d,
      isChildLevel: r,
      openItems: f,
      toggleItem: b,
      openItem: h
    });
    const m = p(() => {
      if (r.value) return "";
      switch (i.value) {
        case "flush":
          return "";
        case "separate-cards":
          return "flex flex-col gap-3";
        default:
          return "border border-(--colors-border-base-soft) rounded-(--border-border-radius-rounded-l) overflow-hidden";
      }
    });
    return (x, y) => (c(), g("div", {
      ref_key: "rootEl",
      ref: a,
      class: C(m.value),
      "data-accordion-root": r.value ? void 0 : "",
      "data-testid": "accordion"
    }, [
      $e(x.$slots, "default")
    ], 10, fx));
  }
});
function Vb(e = {}) {
  const n = e.id ?? Ve(), t = `${n}-trigger`, a = `${n}-content`, l = E(!1), r = p(() => Rt(e.open) !== void 0), o = p(() => r.value ? Rt(e.open) : e.store ? e.store.isOpen() : l.value);
  ot(() => {
    r.value || !Rt(e.defaultOpen) || o.value || (e.store ? e.store.open() : l.value = !0);
  });
  const i = () => {
    var y;
    const x = !o.value;
    return r.value || (e.store ? e.store.toggle() : l.value = x), (y = e.onOpenChange) == null || y.call(e, x), x;
  }, s = E(!1), d = () => {
    var x;
    return typeof window < "u" && !!((x = window.matchMedia) != null && x.call(window, "(prefers-reduced-motion: reduce)").matches);
  };
  let u = !1;
  ot(() => requestAnimationFrame(() => u = !0)), Ie(
    o,
    (x) => {
      s.value = x && (!u || d());
    },
    { immediate: !0 }
  );
  const f = (x) => {
    x.target === x.currentTarget && x.propertyName === "grid-template-rows" && o.value && (s.value = !0);
  }, b = p(() => ({
    id: t,
    "aria-expanded": o.value,
    "aria-controls": a
  })), h = p(() => ({
    id: a,
    role: "region",
    "aria-labelledby": t,
    "aria-hidden": !o.value,
    inert: !o.value || void 0
  })), m = p(() => [
    "accordion-content",
    { "accordion-content--expanded": o.value, "accordion-content--open": s.value }
  ]);
  return {
    id: n,
    triggerId: t,
    panelId: a,
    isOpen: o,
    isControlled: r,
    isFullyOpen: rx(s),
    toggle: i,
    onTransitionEnd: f,
    triggerProps: b,
    panelProps: h,
    panelClasses: m
  };
}
var sn = "top", Ln = "bottom", En = "right", dn = "left", Su = "auto", _r = [sn, Ln, En, dn], Bl = "start", Dr = "end", hx = "clippingParents", Nb = "viewport", Ql = "popper", bx = "reference", Uc = /* @__PURE__ */ _r.reduce(function(e, n) {
  return e.concat([n + "-" + Bl, n + "-" + Dr]);
}, []), Hb = /* @__PURE__ */ [].concat(_r, [Su]).reduce(function(e, n) {
  return e.concat([n, n + "-" + Bl, n + "-" + Dr]);
}, []), gx = "beforeRead", px = "read", mx = "afterRead", vx = "beforeMain", xx = "main", yx = "afterMain", kx = "beforeWrite", wx = "write", Cx = "afterWrite", Sx = [gx, px, mx, vx, xx, yx, kx, wx, Cx];
function Jn(e) {
  return e ? (e.nodeName || "").toLowerCase() : null;
}
function gn(e) {
  if (e == null)
    return window;
  if (e.toString() !== "[object Window]") {
    var n = e.ownerDocument;
    return n && n.defaultView || window;
  }
  return e;
}
function ol(e) {
  var n = gn(e).Element;
  return e instanceof n || e instanceof Element;
}
function wn(e) {
  var n = gn(e).HTMLElement;
  return e instanceof n || e instanceof HTMLElement;
}
function $u(e) {
  if (typeof ShadowRoot > "u")
    return !1;
  var n = gn(e).ShadowRoot;
  return e instanceof n || e instanceof ShadowRoot;
}
function $x(e) {
  var n = e.state;
  Object.keys(n.elements).forEach(function(t) {
    var a = n.styles[t] || {}, l = n.attributes[t] || {}, r = n.elements[t];
    !wn(r) || !Jn(r) || (Object.assign(r.style, a), Object.keys(l).forEach(function(o) {
      var i = l[o];
      i === !1 ? r.removeAttribute(o) : r.setAttribute(o, i === !0 ? "" : i);
    }));
  });
}
function Ix(e) {
  var n = e.state, t = {
    popper: {
      position: n.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  return Object.assign(n.elements.popper.style, t.popper), n.styles = t, n.elements.arrow && Object.assign(n.elements.arrow.style, t.arrow), function() {
    Object.keys(n.elements).forEach(function(a) {
      var l = n.elements[a], r = n.attributes[a] || {}, o = Object.keys(n.styles.hasOwnProperty(a) ? n.styles[a] : t[a]), i = o.reduce(function(s, d) {
        return s[d] = "", s;
      }, {});
      !wn(l) || !Jn(l) || (Object.assign(l.style, i), Object.keys(r).forEach(function(s) {
        l.removeAttribute(s);
      }));
    });
  };
}
const Tx = {
  name: "applyStyles",
  enabled: !0,
  phase: "write",
  fn: $x,
  effect: Ix,
  requires: ["computeStyles"]
};
function Kn(e) {
  return e.split("-")[0];
}
var _a = Math.max, Xo = Math.min, Ml = Math.round;
function Cd() {
  var e = navigator.userAgentData;
  return e != null && e.brands && Array.isArray(e.brands) ? e.brands.map(function(n) {
    return n.brand + "/" + n.version;
  }).join(" ") : navigator.userAgent;
}
function jb() {
  return !/^((?!chrome|android).)*safari/i.test(Cd());
}
function Dl(e, n, t) {
  n === void 0 && (n = !1), t === void 0 && (t = !1);
  var a = e.getBoundingClientRect(), l = 1, r = 1;
  n && wn(e) && (l = e.offsetWidth > 0 && Ml(a.width) / e.offsetWidth || 1, r = e.offsetHeight > 0 && Ml(a.height) / e.offsetHeight || 1);
  var o = ol(e) ? gn(e) : window, i = o.visualViewport, s = !jb() && t, d = (a.left + (s && i ? i.offsetLeft : 0)) / l, u = (a.top + (s && i ? i.offsetTop : 0)) / r, f = a.width / l, b = a.height / r;
  return {
    width: f,
    height: b,
    top: u,
    right: d + f,
    bottom: u + b,
    left: d,
    x: d,
    y: u
  };
}
function Iu(e) {
  var n = Dl(e), t = e.offsetWidth, a = e.offsetHeight;
  return Math.abs(n.width - t) <= 1 && (t = n.width), Math.abs(n.height - a) <= 1 && (a = n.height), {
    x: e.offsetLeft,
    y: e.offsetTop,
    width: t,
    height: a
  };
}
function Wb(e, n) {
  var t = n.getRootNode && n.getRootNode();
  if (e.contains(n))
    return !0;
  if (t && $u(t)) {
    var a = n;
    do {
      if (a && e.isSameNode(a))
        return !0;
      a = a.parentNode || a.host;
    } while (a);
  }
  return !1;
}
function ua(e) {
  return gn(e).getComputedStyle(e);
}
function Lx(e) {
  return ["table", "td", "th"].indexOf(Jn(e)) >= 0;
}
function Pa(e) {
  return ((ol(e) ? e.ownerDocument : (
    // $FlowFixMe[prop-missing]
    e.document
  )) || window.document).documentElement;
}
function Ui(e) {
  return Jn(e) === "html" ? e : (
    // this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    e.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    e.parentNode || // DOM Element detected
    ($u(e) ? e.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    Pa(e)
  );
}
function Gc(e) {
  return !wn(e) || // https://github.com/popperjs/popper-core/issues/837
  ua(e).position === "fixed" ? null : e.offsetParent;
}
function Ex(e) {
  var n = /firefox/i.test(Cd()), t = /Trident/i.test(Cd());
  if (t && wn(e)) {
    var a = ua(e);
    if (a.position === "fixed")
      return null;
  }
  var l = Ui(e);
  for ($u(l) && (l = l.host); wn(l) && ["html", "body"].indexOf(Jn(l)) < 0; ) {
    var r = ua(l);
    if (r.transform !== "none" || r.perspective !== "none" || r.contain === "paint" || ["transform", "perspective"].indexOf(r.willChange) !== -1 || n && r.willChange === "filter" || n && r.filter && r.filter !== "none")
      return l;
    l = l.parentNode;
  }
  return null;
}
function eo(e) {
  for (var n = gn(e), t = Gc(e); t && Lx(t) && ua(t).position === "static"; )
    t = Gc(t);
  return t && (Jn(t) === "html" || Jn(t) === "body" && ua(t).position === "static") ? n : t || Ex(e) || n;
}
function Tu(e) {
  return ["top", "bottom"].indexOf(e) >= 0 ? "x" : "y";
}
function gr(e, n, t) {
  return _a(e, Xo(n, t));
}
function Ax(e, n, t) {
  var a = gr(e, n, t);
  return a > t ? t : a;
}
function qb() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
function Ub(e) {
  return Object.assign({}, qb(), e);
}
function Gb(e, n) {
  return n.reduce(function(t, a) {
    return t[a] = e, t;
  }, {});
}
var Rx = function(n, t) {
  return n = typeof n == "function" ? n(Object.assign({}, t.rects, {
    placement: t.placement
  })) : n, Ub(typeof n != "number" ? n : Gb(n, _r));
};
function Bx(e) {
  var n, t = e.state, a = e.name, l = e.options, r = t.elements.arrow, o = t.modifiersData.popperOffsets, i = Kn(t.placement), s = Tu(i), d = [dn, En].indexOf(i) >= 0, u = d ? "height" : "width";
  if (!(!r || !o)) {
    var f = Rx(l.padding, t), b = Iu(r), h = s === "y" ? sn : dn, m = s === "y" ? Ln : En, x = t.rects.reference[u] + t.rects.reference[s] - o[s] - t.rects.popper[u], y = o[s] - t.rects.reference[s], w = eo(r), S = w ? s === "y" ? w.clientHeight || 0 : w.clientWidth || 0 : 0, $ = x / 2 - y / 2, T = f[h], L = S - b[u] - f[m], A = S / 2 - b[u] / 2 + $, R = gr(T, A, L), z = s;
    t.modifiersData[a] = (n = {}, n[z] = R, n.centerOffset = R - A, n);
  }
}
function Mx(e) {
  var n = e.state, t = e.options, a = t.element, l = a === void 0 ? "[data-popper-arrow]" : a;
  l != null && (typeof l == "string" && (l = n.elements.popper.querySelector(l), !l) || Wb(n.elements.popper, l) && (n.elements.arrow = l));
}
const Dx = {
  name: "arrow",
  enabled: !0,
  phase: "main",
  fn: Bx,
  effect: Mx,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};
function zl(e) {
  return e.split("-")[1];
}
var zx = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function Ox(e, n) {
  var t = e.x, a = e.y, l = n.devicePixelRatio || 1;
  return {
    x: Ml(t * l) / l || 0,
    y: Ml(a * l) / l || 0
  };
}
function Kc(e) {
  var n, t = e.popper, a = e.popperRect, l = e.placement, r = e.variation, o = e.offsets, i = e.position, s = e.gpuAcceleration, d = e.adaptive, u = e.roundOffsets, f = e.isFixed, b = o.x, h = b === void 0 ? 0 : b, m = o.y, x = m === void 0 ? 0 : m, y = typeof u == "function" ? u({
    x: h,
    y: x
  }) : {
    x: h,
    y: x
  };
  h = y.x, x = y.y;
  var w = o.hasOwnProperty("x"), S = o.hasOwnProperty("y"), $ = dn, T = sn, L = window;
  if (d) {
    var A = eo(t), R = "clientHeight", z = "clientWidth";
    if (A === gn(t) && (A = Pa(t), ua(A).position !== "static" && i === "absolute" && (R = "scrollHeight", z = "scrollWidth")), A = A, l === sn || (l === dn || l === En) && r === Dr) {
      T = Ln;
      var D = f && A === L && L.visualViewport ? L.visualViewport.height : (
        // $FlowFixMe[prop-missing]
        A[R]
      );
      x -= D - a.height, x *= s ? 1 : -1;
    }
    if (l === dn || (l === sn || l === Ln) && r === Dr) {
      $ = En;
      var V = f && A === L && L.visualViewport ? L.visualViewport.width : (
        // $FlowFixMe[prop-missing]
        A[z]
      );
      h -= V - a.width, h *= s ? 1 : -1;
    }
  }
  var Y = Object.assign({
    position: i
  }, d && zx), _ = u === !0 ? Ox({
    x: h,
    y: x
  }, gn(t)) : {
    x: h,
    y: x
  };
  if (h = _.x, x = _.y, s) {
    var j;
    return Object.assign({}, Y, (j = {}, j[T] = S ? "0" : "", j[$] = w ? "0" : "", j.transform = (L.devicePixelRatio || 1) <= 1 ? "translate(" + h + "px, " + x + "px)" : "translate3d(" + h + "px, " + x + "px, 0)", j));
  }
  return Object.assign({}, Y, (n = {}, n[T] = S ? x + "px" : "", n[$] = w ? h + "px" : "", n.transform = "", n));
}
function Px(e) {
  var n = e.state, t = e.options, a = t.gpuAcceleration, l = a === void 0 ? !0 : a, r = t.adaptive, o = r === void 0 ? !0 : r, i = t.roundOffsets, s = i === void 0 ? !0 : i, d = {
    placement: Kn(n.placement),
    variation: zl(n.placement),
    popper: n.elements.popper,
    popperRect: n.rects.popper,
    gpuAcceleration: l,
    isFixed: n.options.strategy === "fixed"
  };
  n.modifiersData.popperOffsets != null && (n.styles.popper = Object.assign({}, n.styles.popper, Kc(Object.assign({}, d, {
    offsets: n.modifiersData.popperOffsets,
    position: n.options.strategy,
    adaptive: o,
    roundOffsets: s
  })))), n.modifiersData.arrow != null && (n.styles.arrow = Object.assign({}, n.styles.arrow, Kc(Object.assign({}, d, {
    offsets: n.modifiersData.arrow,
    position: "absolute",
    adaptive: !1,
    roundOffsets: s
  })))), n.attributes.popper = Object.assign({}, n.attributes.popper, {
    "data-popper-placement": n.placement
  });
}
const Fx = {
  name: "computeStyles",
  enabled: !0,
  phase: "beforeWrite",
  fn: Px,
  data: {}
};
var ho = {
  passive: !0
};
function Vx(e) {
  var n = e.state, t = e.instance, a = e.options, l = a.scroll, r = l === void 0 ? !0 : l, o = a.resize, i = o === void 0 ? !0 : o, s = gn(n.elements.popper), d = [].concat(n.scrollParents.reference, n.scrollParents.popper);
  return r && d.forEach(function(u) {
    u.addEventListener("scroll", t.update, ho);
  }), i && s.addEventListener("resize", t.update, ho), function() {
    r && d.forEach(function(u) {
      u.removeEventListener("scroll", t.update, ho);
    }), i && s.removeEventListener("resize", t.update, ho);
  };
}
const Nx = {
  name: "eventListeners",
  enabled: !0,
  phase: "write",
  fn: function() {
  },
  effect: Vx,
  data: {}
};
var Hx = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function jo(e) {
  return e.replace(/left|right|bottom|top/g, function(n) {
    return Hx[n];
  });
}
var jx = {
  start: "end",
  end: "start"
};
function Yc(e) {
  return e.replace(/start|end/g, function(n) {
    return jx[n];
  });
}
function Lu(e) {
  var n = gn(e), t = n.pageXOffset, a = n.pageYOffset;
  return {
    scrollLeft: t,
    scrollTop: a
  };
}
function Eu(e) {
  return Dl(Pa(e)).left + Lu(e).scrollLeft;
}
function Wx(e, n) {
  var t = gn(e), a = Pa(e), l = t.visualViewport, r = a.clientWidth, o = a.clientHeight, i = 0, s = 0;
  if (l) {
    r = l.width, o = l.height;
    var d = jb();
    (d || !d && n === "fixed") && (i = l.offsetLeft, s = l.offsetTop);
  }
  return {
    width: r,
    height: o,
    x: i + Eu(e),
    y: s
  };
}
function qx(e) {
  var n, t = Pa(e), a = Lu(e), l = (n = e.ownerDocument) == null ? void 0 : n.body, r = _a(t.scrollWidth, t.clientWidth, l ? l.scrollWidth : 0, l ? l.clientWidth : 0), o = _a(t.scrollHeight, t.clientHeight, l ? l.scrollHeight : 0, l ? l.clientHeight : 0), i = -a.scrollLeft + Eu(e), s = -a.scrollTop;
  return ua(l || t).direction === "rtl" && (i += _a(t.clientWidth, l ? l.clientWidth : 0) - r), {
    width: r,
    height: o,
    x: i,
    y: s
  };
}
function Au(e) {
  var n = ua(e), t = n.overflow, a = n.overflowX, l = n.overflowY;
  return /auto|scroll|overlay|hidden/.test(t + l + a);
}
function Kb(e) {
  return ["html", "body", "#document"].indexOf(Jn(e)) >= 0 ? e.ownerDocument.body : wn(e) && Au(e) ? e : Kb(Ui(e));
}
function pr(e, n) {
  var t;
  n === void 0 && (n = []);
  var a = Kb(e), l = a === ((t = e.ownerDocument) == null ? void 0 : t.body), r = gn(a), o = l ? [r].concat(r.visualViewport || [], Au(a) ? a : []) : a, i = n.concat(o);
  return l ? i : (
    // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
    i.concat(pr(Ui(o)))
  );
}
function Sd(e) {
  return Object.assign({}, e, {
    left: e.x,
    top: e.y,
    right: e.x + e.width,
    bottom: e.y + e.height
  });
}
function Ux(e, n) {
  var t = Dl(e, !1, n === "fixed");
  return t.top = t.top + e.clientTop, t.left = t.left + e.clientLeft, t.bottom = t.top + e.clientHeight, t.right = t.left + e.clientWidth, t.width = e.clientWidth, t.height = e.clientHeight, t.x = t.left, t.y = t.top, t;
}
function Jc(e, n, t) {
  return n === Nb ? Sd(Wx(e, t)) : ol(n) ? Ux(n, t) : Sd(qx(Pa(e)));
}
function Gx(e) {
  var n = pr(Ui(e)), t = ["absolute", "fixed"].indexOf(ua(e).position) >= 0, a = t && wn(e) ? eo(e) : e;
  return ol(a) ? n.filter(function(l) {
    return ol(l) && Wb(l, a) && Jn(l) !== "body";
  }) : [];
}
function Kx(e, n, t, a) {
  var l = n === "clippingParents" ? Gx(e) : [].concat(n), r = [].concat(l, [t]), o = r[0], i = r.reduce(function(s, d) {
    var u = Jc(e, d, a);
    return s.top = _a(u.top, s.top), s.right = Xo(u.right, s.right), s.bottom = Xo(u.bottom, s.bottom), s.left = _a(u.left, s.left), s;
  }, Jc(e, o, a));
  return i.width = i.right - i.left, i.height = i.bottom - i.top, i.x = i.left, i.y = i.top, i;
}
function Yb(e) {
  var n = e.reference, t = e.element, a = e.placement, l = a ? Kn(a) : null, r = a ? zl(a) : null, o = n.x + n.width / 2 - t.width / 2, i = n.y + n.height / 2 - t.height / 2, s;
  switch (l) {
    case sn:
      s = {
        x: o,
        y: n.y - t.height
      };
      break;
    case Ln:
      s = {
        x: o,
        y: n.y + n.height
      };
      break;
    case En:
      s = {
        x: n.x + n.width,
        y: i
      };
      break;
    case dn:
      s = {
        x: n.x - t.width,
        y: i
      };
      break;
    default:
      s = {
        x: n.x,
        y: n.y
      };
  }
  var d = l ? Tu(l) : null;
  if (d != null) {
    var u = d === "y" ? "height" : "width";
    switch (r) {
      case Bl:
        s[d] = s[d] - (n[u] / 2 - t[u] / 2);
        break;
      case Dr:
        s[d] = s[d] + (n[u] / 2 - t[u] / 2);
        break;
    }
  }
  return s;
}
function zr(e, n) {
  n === void 0 && (n = {});
  var t = n, a = t.placement, l = a === void 0 ? e.placement : a, r = t.strategy, o = r === void 0 ? e.strategy : r, i = t.boundary, s = i === void 0 ? hx : i, d = t.rootBoundary, u = d === void 0 ? Nb : d, f = t.elementContext, b = f === void 0 ? Ql : f, h = t.altBoundary, m = h === void 0 ? !1 : h, x = t.padding, y = x === void 0 ? 0 : x, w = Ub(typeof y != "number" ? y : Gb(y, _r)), S = b === Ql ? bx : Ql, $ = e.rects.popper, T = e.elements[m ? S : b], L = Kx(ol(T) ? T : T.contextElement || Pa(e.elements.popper), s, u, o), A = Dl(e.elements.reference), R = Yb({
    reference: A,
    element: $,
    placement: l
  }), z = Sd(Object.assign({}, $, R)), D = b === Ql ? z : A, V = {
    top: L.top - D.top + w.top,
    bottom: D.bottom - L.bottom + w.bottom,
    left: L.left - D.left + w.left,
    right: D.right - L.right + w.right
  }, Y = e.modifiersData.offset;
  if (b === Ql && Y) {
    var _ = Y[l];
    Object.keys(V).forEach(function(j) {
      var M = [En, Ln].indexOf(j) >= 0 ? 1 : -1, W = [sn, Ln].indexOf(j) >= 0 ? "y" : "x";
      V[j] += _[W] * M;
    });
  }
  return V;
}
function Yx(e, n) {
  n === void 0 && (n = {});
  var t = n, a = t.placement, l = t.boundary, r = t.rootBoundary, o = t.padding, i = t.flipVariations, s = t.allowedAutoPlacements, d = s === void 0 ? Hb : s, u = zl(a), f = u ? i ? Uc : Uc.filter(function(m) {
    return zl(m) === u;
  }) : _r, b = f.filter(function(m) {
    return d.indexOf(m) >= 0;
  });
  b.length === 0 && (b = f);
  var h = b.reduce(function(m, x) {
    return m[x] = zr(e, {
      placement: x,
      boundary: l,
      rootBoundary: r,
      padding: o
    })[Kn(x)], m;
  }, {});
  return Object.keys(h).sort(function(m, x) {
    return h[m] - h[x];
  });
}
function Jx(e) {
  if (Kn(e) === Su)
    return [];
  var n = jo(e);
  return [Yc(e), n, Yc(n)];
}
function Zx(e) {
  var n = e.state, t = e.options, a = e.name;
  if (!n.modifiersData[a]._skip) {
    for (var l = t.mainAxis, r = l === void 0 ? !0 : l, o = t.altAxis, i = o === void 0 ? !0 : o, s = t.fallbackPlacements, d = t.padding, u = t.boundary, f = t.rootBoundary, b = t.altBoundary, h = t.flipVariations, m = h === void 0 ? !0 : h, x = t.allowedAutoPlacements, y = n.options.placement, w = Kn(y), S = w === y, $ = s || (S || !m ? [jo(y)] : Jx(y)), T = [y].concat($).reduce(function(be, ke) {
      return be.concat(Kn(ke) === Su ? Yx(n, {
        placement: ke,
        boundary: u,
        rootBoundary: f,
        padding: d,
        flipVariations: m,
        allowedAutoPlacements: x
      }) : ke);
    }, []), L = n.rects.reference, A = n.rects.popper, R = /* @__PURE__ */ new Map(), z = !0, D = T[0], V = 0; V < T.length; V++) {
      var Y = T[V], _ = Kn(Y), j = zl(Y) === Bl, M = [sn, Ln].indexOf(_) >= 0, W = M ? "width" : "height", G = zr(n, {
        placement: Y,
        boundary: u,
        rootBoundary: f,
        altBoundary: b,
        padding: d
      }), B = M ? j ? En : dn : j ? Ln : sn;
      L[W] > A[W] && (B = jo(B));
      var F = jo(B), X = [];
      if (r && X.push(G[_] <= 0), i && X.push(G[B] <= 0, G[F] <= 0), X.every(function(be) {
        return be;
      })) {
        D = Y, z = !1;
        break;
      }
      R.set(Y, X);
    }
    if (z)
      for (var H = m ? 3 : 1, q = function(ke) {
        var ee = T.find(function(oe) {
          var ge = R.get(oe);
          if (ge)
            return ge.slice(0, ke).every(function(re) {
              return re;
            });
        });
        if (ee)
          return D = ee, "break";
      }, N = H; N > 0; N--) {
        var J = q(N);
        if (J === "break") break;
      }
    n.placement !== D && (n.modifiersData[a]._skip = !0, n.placement = D, n.reset = !0);
  }
}
const Xx = {
  name: "flip",
  enabled: !0,
  phase: "main",
  fn: Zx,
  requiresIfExists: ["offset"],
  data: {
    _skip: !1
  }
};
function Zc(e, n, t) {
  return t === void 0 && (t = {
    x: 0,
    y: 0
  }), {
    top: e.top - n.height - t.y,
    right: e.right - n.width + t.x,
    bottom: e.bottom - n.height + t.y,
    left: e.left - n.width - t.x
  };
}
function Xc(e) {
  return [sn, En, Ln, dn].some(function(n) {
    return e[n] >= 0;
  });
}
function Qx(e) {
  var n = e.state, t = e.name, a = n.rects.reference, l = n.rects.popper, r = n.modifiersData.preventOverflow, o = zr(n, {
    elementContext: "reference"
  }), i = zr(n, {
    altBoundary: !0
  }), s = Zc(o, a), d = Zc(i, l, r), u = Xc(s), f = Xc(d);
  n.modifiersData[t] = {
    referenceClippingOffsets: s,
    popperEscapeOffsets: d,
    isReferenceHidden: u,
    hasPopperEscaped: f
  }, n.attributes.popper = Object.assign({}, n.attributes.popper, {
    "data-popper-reference-hidden": u,
    "data-popper-escaped": f
  });
}
const _x = {
  name: "hide",
  enabled: !0,
  phase: "main",
  requiresIfExists: ["preventOverflow"],
  fn: Qx
};
function e0(e, n, t) {
  var a = Kn(e), l = [dn, sn].indexOf(a) >= 0 ? -1 : 1, r = typeof t == "function" ? t(Object.assign({}, n, {
    placement: e
  })) : t, o = r[0], i = r[1];
  return o = o || 0, i = (i || 0) * l, [dn, En].indexOf(a) >= 0 ? {
    x: i,
    y: o
  } : {
    x: o,
    y: i
  };
}
function t0(e) {
  var n = e.state, t = e.options, a = e.name, l = t.offset, r = l === void 0 ? [0, 0] : l, o = Hb.reduce(function(u, f) {
    return u[f] = e0(f, n.rects, r), u;
  }, {}), i = o[n.placement], s = i.x, d = i.y;
  n.modifiersData.popperOffsets != null && (n.modifiersData.popperOffsets.x += s, n.modifiersData.popperOffsets.y += d), n.modifiersData[a] = o;
}
const n0 = {
  name: "offset",
  enabled: !0,
  phase: "main",
  requires: ["popperOffsets"],
  fn: t0
};
function a0(e) {
  var n = e.state, t = e.name;
  n.modifiersData[t] = Yb({
    reference: n.rects.reference,
    element: n.rects.popper,
    placement: n.placement
  });
}
const l0 = {
  name: "popperOffsets",
  enabled: !0,
  phase: "read",
  fn: a0,
  data: {}
};
function r0(e) {
  return e === "x" ? "y" : "x";
}
function o0(e) {
  var n = e.state, t = e.options, a = e.name, l = t.mainAxis, r = l === void 0 ? !0 : l, o = t.altAxis, i = o === void 0 ? !1 : o, s = t.boundary, d = t.rootBoundary, u = t.altBoundary, f = t.padding, b = t.tether, h = b === void 0 ? !0 : b, m = t.tetherOffset, x = m === void 0 ? 0 : m, y = zr(n, {
    boundary: s,
    rootBoundary: d,
    padding: f,
    altBoundary: u
  }), w = Kn(n.placement), S = zl(n.placement), $ = !S, T = Tu(w), L = r0(T), A = n.modifiersData.popperOffsets, R = n.rects.reference, z = n.rects.popper, D = typeof x == "function" ? x(Object.assign({}, n.rects, {
    placement: n.placement
  })) : x, V = typeof D == "number" ? {
    mainAxis: D,
    altAxis: D
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, D), Y = n.modifiersData.offset ? n.modifiersData.offset[n.placement] : null, _ = {
    x: 0,
    y: 0
  };
  if (A) {
    if (r) {
      var j, M = T === "y" ? sn : dn, W = T === "y" ? Ln : En, G = T === "y" ? "height" : "width", B = A[T], F = B + y[M], X = B - y[W], H = h ? -z[G] / 2 : 0, q = S === Bl ? R[G] : z[G], N = S === Bl ? -z[G] : -R[G], J = n.elements.arrow, be = h && J ? Iu(J) : {
        width: 0,
        height: 0
      }, ke = n.modifiersData["arrow#persistent"] ? n.modifiersData["arrow#persistent"].padding : qb(), ee = ke[M], oe = ke[W], ge = gr(0, R[G], be[G]), re = $ ? R[G] / 2 - H - ge - ee - V.mainAxis : q - ge - ee - V.mainAxis, ue = $ ? -R[G] / 2 + H + ge + oe + V.mainAxis : N + ge + oe + V.mainAxis, O = n.elements.arrow && eo(n.elements.arrow), U = O ? T === "y" ? O.clientTop || 0 : O.clientLeft || 0 : 0, Q = (j = Y == null ? void 0 : Y[T]) != null ? j : 0, ae = B + re - Q - U, Z = B + ue - Q, ie = gr(h ? Xo(F, ae) : F, B, h ? _a(X, Z) : X);
      A[T] = ie, _[T] = ie - B;
    }
    if (i) {
      var fe, de = T === "x" ? sn : dn, ne = T === "x" ? Ln : En, le = A[L], Le = L === "y" ? "height" : "width", Te = le + y[de], xe = le - y[ne], we = [sn, dn].indexOf(w) !== -1, he = (fe = Y == null ? void 0 : Y[L]) != null ? fe : 0, De = we ? Te : le - R[Le] - z[Le] - he + V.altAxis, Ee = we ? le + R[Le] + z[Le] - he - V.altAxis : xe, je = h && we ? Ax(De, le, Ee) : gr(h ? De : Te, le, h ? Ee : xe);
      A[L] = je, _[L] = je - le;
    }
    n.modifiersData[a] = _;
  }
}
const i0 = {
  name: "preventOverflow",
  enabled: !0,
  phase: "main",
  fn: o0,
  requiresIfExists: ["offset"]
};
function s0(e) {
  return {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  };
}
function d0(e) {
  return e === gn(e) || !wn(e) ? Lu(e) : s0(e);
}
function u0(e) {
  var n = e.getBoundingClientRect(), t = Ml(n.width) / e.offsetWidth || 1, a = Ml(n.height) / e.offsetHeight || 1;
  return t !== 1 || a !== 1;
}
function c0(e, n, t) {
  t === void 0 && (t = !1);
  var a = wn(n), l = wn(n) && u0(n), r = Pa(n), o = Dl(e, l, t), i = {
    scrollLeft: 0,
    scrollTop: 0
  }, s = {
    x: 0,
    y: 0
  };
  return (a || !a && !t) && ((Jn(n) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
  Au(r)) && (i = d0(n)), wn(n) ? (s = Dl(n, !0), s.x += n.clientLeft, s.y += n.clientTop) : r && (s.x = Eu(r))), {
    x: o.left + i.scrollLeft - s.x,
    y: o.top + i.scrollTop - s.y,
    width: o.width,
    height: o.height
  };
}
function f0(e) {
  var n = /* @__PURE__ */ new Map(), t = /* @__PURE__ */ new Set(), a = [];
  e.forEach(function(r) {
    n.set(r.name, r);
  });
  function l(r) {
    t.add(r.name);
    var o = [].concat(r.requires || [], r.requiresIfExists || []);
    o.forEach(function(i) {
      if (!t.has(i)) {
        var s = n.get(i);
        s && l(s);
      }
    }), a.push(r);
  }
  return e.forEach(function(r) {
    t.has(r.name) || l(r);
  }), a;
}
function h0(e) {
  var n = f0(e);
  return Sx.reduce(function(t, a) {
    return t.concat(n.filter(function(l) {
      return l.phase === a;
    }));
  }, []);
}
function b0(e) {
  var n;
  return function() {
    return n || (n = new Promise(function(t) {
      Promise.resolve().then(function() {
        n = void 0, t(e());
      });
    })), n;
  };
}
function g0(e) {
  var n = e.reduce(function(t, a) {
    var l = t[a.name];
    return t[a.name] = l ? Object.assign({}, l, a, {
      options: Object.assign({}, l.options, a.options),
      data: Object.assign({}, l.data, a.data)
    }) : a, t;
  }, {});
  return Object.keys(n).map(function(t) {
    return n[t];
  });
}
var Qc = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function _c() {
  for (var e = arguments.length, n = new Array(e), t = 0; t < e; t++)
    n[t] = arguments[t];
  return !n.some(function(a) {
    return !(a && typeof a.getBoundingClientRect == "function");
  });
}
function p0(e) {
  e === void 0 && (e = {});
  var n = e, t = n.defaultModifiers, a = t === void 0 ? [] : t, l = n.defaultOptions, r = l === void 0 ? Qc : l;
  return function(i, s, d) {
    d === void 0 && (d = r);
    var u = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, Qc, r),
      modifiersData: {},
      elements: {
        reference: i,
        popper: s
      },
      attributes: {},
      styles: {}
    }, f = [], b = !1, h = {
      state: u,
      setOptions: function(w) {
        var S = typeof w == "function" ? w(u.options) : w;
        x(), u.options = Object.assign({}, r, u.options, S), u.scrollParents = {
          reference: ol(i) ? pr(i) : i.contextElement ? pr(i.contextElement) : [],
          popper: pr(s)
        };
        var $ = h0(g0([].concat(a, u.options.modifiers)));
        return u.orderedModifiers = $.filter(function(T) {
          return T.enabled;
        }), m(), h.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function() {
        if (!b) {
          var w = u.elements, S = w.reference, $ = w.popper;
          if (_c(S, $)) {
            u.rects = {
              reference: c0(S, eo($), u.options.strategy === "fixed"),
              popper: Iu($)
            }, u.reset = !1, u.placement = u.options.placement, u.orderedModifiers.forEach(function(V) {
              return u.modifiersData[V.name] = Object.assign({}, V.data);
            });
            for (var T = 0; T < u.orderedModifiers.length; T++) {
              if (u.reset === !0) {
                u.reset = !1, T = -1;
                continue;
              }
              var L = u.orderedModifiers[T], A = L.fn, R = L.options, z = R === void 0 ? {} : R, D = L.name;
              typeof A == "function" && (u = A({
                state: u,
                options: z,
                name: D,
                instance: h
              }) || u);
            }
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: b0(function() {
        return new Promise(function(y) {
          h.forceUpdate(), y(u);
        });
      }),
      destroy: function() {
        x(), b = !0;
      }
    };
    if (!_c(i, s))
      return h;
    h.setOptions(d).then(function(y) {
      !b && d.onFirstUpdate && d.onFirstUpdate(y);
    });
    function m() {
      u.orderedModifiers.forEach(function(y) {
        var w = y.name, S = y.options, $ = S === void 0 ? {} : S, T = y.effect;
        if (typeof T == "function") {
          var L = T({
            state: u,
            name: w,
            instance: h,
            options: $
          }), A = function() {
          };
          f.push(L || A);
        }
      });
    }
    function x() {
      f.forEach(function(y) {
        return y();
      }), f = [];
    }
    return h;
  };
}
var m0 = [Nx, l0, Fx, Tx, n0, Xx, i0, Dx, _x], Fa = /* @__PURE__ */ p0({
  defaultModifiers: m0
});
const Ol = [];
function Zn(e) {
  Ol.includes(e) || Ol.push(e);
}
function An(e) {
  const n = Ol.indexOf(e);
  n !== -1 && Ol.splice(n, 1);
}
function Va(e) {
  return Ol[Ol.length - 1] === e;
}
const Jb = {
  top: ["bottom"],
  bottom: ["top"],
  left: ["right", "top", "bottom"],
  right: ["left", "top", "bottom"]
}, Zb = 8, Pl = [
  "a[href]",
  "area[href]",
  "button:not([disabled])",
  "input:not([disabled]):not([type='hidden'])",
  "select:not([disabled])",
  "textarea:not([disabled])",
  "iframe",
  "object",
  "embed",
  "[contenteditable]",
  "[tabindex]:not([tabindex^='-'])"
].join(",");
function va(e) {
  const n = Array.from(e.querySelectorAll(Pl)).filter(
    (a) => a.offsetParent !== null && Xb(a)
  ), t = v0(n);
  return n.filter((a) => !Qo(a) || t.has(a));
}
function Qo(e) {
  return e instanceof HTMLInputElement && e.type === "radio" && e.name !== "";
}
function $d(e) {
  return e.form ?? e.getRootNode();
}
function ef(e, n) {
  return e === n ? !0 : !e || !Qo(e) || !Qo(n) ? !1 : e.name === n.name && $d(e) === $d(n);
}
function v0(e) {
  const n = /* @__PURE__ */ new Map();
  for (const a of e) {
    if (!Qo(a)) continue;
    const l = $d(a), r = n.get(l) ?? /* @__PURE__ */ new Map();
    r.set(a.name, [...r.get(a.name) ?? [], a]), n.set(l, r);
  }
  const t = /* @__PURE__ */ new Set();
  for (const a of n.values())
    for (const l of a.values()) t.add(l.find((r) => r.checked) ?? l[0]);
  return t;
}
function Xb(e) {
  if (e.hasAttribute("disabled")) return !1;
  const n = e.getAttribute("tabindex");
  return n === null || !n.startsWith("-");
}
function x0(e) {
  return Array.from(e.querySelectorAll(Pl)).filter(
    (n) => {
      var t;
      return (((t = n.checkVisibility) == null ? void 0 : t.call(n)) ?? !0) && Xb(n);
    }
  );
}
const Id = "[data-focus-trap-allow-outside]", y0 = "data-focus-trap-return";
function tf(e) {
  return e instanceof Element && e.closest(Id) !== null;
}
const _l = [];
function Gi(e) {
  const {
    active: n,
    container: t,
    autoFocus: a = !0,
    restoreFocus: l = !0,
    restoreFocusTo: r,
    containFocus: o = !1,
    allowOutsideElements: i
  } = e, s = Symbol("focus-trap");
  let d = null, u = null, f = null;
  const b = () => _l[_l.length - 1] === s;
  function h(A) {
    if (!b() || A.key !== "Tab" || !t.value) return;
    if (!t.value.contains(document.activeElement) && tf(document.activeElement)) {
      if (A.shiftKey) return;
      const Y = document.activeElement.closest(
        Id
      ), _ = Y ? va(Y) : [];
      if (!(_.length === 0 || document.activeElement === _[_.length - 1])) return;
      const M = va(t.value);
      if (M.length === 0) {
        A.preventDefault();
        return;
      }
      const W = f ? M.indexOf(f) : -1;
      A.preventDefault(), M[W === -1 ? 0 : (W + 1) % M.length].focus();
      return;
    }
    const R = va(t.value);
    if (R.length === 0) {
      A.preventDefault();
      return;
    }
    const z = R[0], D = R[R.length - 1], V = document.activeElement;
    A.shiftKey ? (ef(V, z) || !t.value.contains(V)) && (A.preventDefault(), D.focus()) : ef(V, D) && (A.preventDefault(), z.focus());
  }
  function m() {
    var A;
    t.value && ((A = va(t.value)[0]) == null || A.focus({ preventScroll: !0 }));
  }
  function x(A) {
    if (!b() || !t.value) return;
    const R = A.target;
    R && t.value.contains(R) && (f = R);
  }
  function y(A) {
    return tf(A) ? !0 : i ? i().some((R) => R && A && R.contains(A)) : !1;
  }
  function w(A) {
    if (!b() || !t.value) return;
    const R = A.target;
    R && t.value.contains(R) || y(R) || m();
  }
  function S(A) {
    !b() || A.relatedTarget !== null || requestAnimationFrame(() => {
      !n.value || !b() || !t.value || t.value.contains(document.activeElement) || y(document.activeElement) || m();
    });
  }
  function $() {
    o && (document.addEventListener("focusin", w), document.addEventListener("focusout", S));
  }
  function T() {
    document.removeEventListener("focusin", w), document.removeEventListener("focusout", S);
  }
  function L() {
    const A = _l.indexOf(s);
    A !== -1 && _l.splice(A, 1);
  }
  Ie(n, (A) => {
    var R;
    if (A)
      _l.push(s), d = document.activeElement, u = ((R = d == null ? void 0 : d.closest(Id)) == null ? void 0 : R.getAttribute(y0)) ?? null, document.addEventListener("keydown", h), document.addEventListener("focusin", x), $(), a && requestAnimationFrame(() => {
        var D;
        if (!t.value || t.value.contains(document.activeElement) || y(document.activeElement)) return;
        (D = va(t.value)[0]) == null || D.focus();
      });
    else if (L(), document.removeEventListener("keydown", h), T(), document.removeEventListener("focusin", x), f = null, l) {
      const z = (d == null ? void 0 : d.isConnected) === !1 && u ? document.getElementById(u) : null, D = (r == null ? void 0 : r()) ?? z ?? d;
      D == null || D.focus(), d = null, u = null;
    }
  }, { immediate: !0 }), gt(() => {
    L(), document.removeEventListener("keydown", h), T(), document.removeEventListener("focusin", x);
  });
}
const k0 = ["id"], w0 = 100, C0 = /* @__PURE__ */ ye({
  inheritAttrs: !1,
  __name: "Tooltip",
  props: {
    text: {},
    position: { default: "top" },
    delay: { default: 300 },
    disabled: { type: Boolean, default: !1 },
    open: { type: Boolean, default: void 0 },
    as: { default: "div" },
    labelsTrigger: { type: Boolean, default: !1 }
  },
  setup(e, { expose: n }) {
    const t = e, a = Ve(), l = E(null), r = E(null), o = E(null), i = E(!1), s = p(() => t.disabled ? !1 : t.open !== void 0 ? t.open : i.value);
    let d = null, u = null, f = null, b = null;
    const h = (j) => {
      if (j.nodeType === Node.TEXT_NODE) return j.textContent ?? "";
      if (!(j instanceof Element) || j.getAttribute("aria-hidden") === "true") return "";
      const M = j.getAttribute("aria-label");
      return M !== null ? M : [...j.childNodes].map(h).join(" ");
    }, m = () => {
      const j = l.value;
      if (!j) return null;
      const W = j.hasAttribute("tabindex") && j.getAttribute("tabindex") !== "-1" ? j : j.querySelector(Pl) ?? j, G = (F) => F.trim().replace(/\s+/g, " ").toLowerCase(), B = W.getAttribute("aria-label") ?? [...W.childNodes].map(h).join(" ");
      return G(B) === G(t.text) ? null : W;
    }, x = (j) => {
      const M = (j.getAttribute("aria-describedby") ?? "").split(/\s+/).filter(Boolean);
      M.includes(a) || j.setAttribute("aria-describedby", [...M, a].join(" ")), b = j;
    }, y = () => {
      if (!b) return;
      const j = (b.getAttribute("aria-describedby") ?? "").split(/\s+/).filter((M) => M && M !== a);
      j.length ? b.setAttribute("aria-describedby", j.join(" ")) : b.removeAttribute("aria-describedby"), b = null;
    }, w = p(
      () => !t.labelsTrigger && !t.disabled && (t.open === void 0 || t.open)
    ), S = () => {
      const j = w.value ? m() : null;
      j !== b && y(), j && x(j);
    };
    ot(S), qi(S), Ie(w, S, { flush: "post" });
    const $ = Symbol("tooltip"), T = (j) => {
      j.key !== "Escape" || j.defaultPrevented || Va($) && _(j);
    }, L = () => {
      document.removeEventListener("keydown", T), An($);
    }, A = p(() => s.value && t.open === void 0);
    Ie(A, (j) => {
      j ? (Zn($), document.addEventListener("keydown", T)) : L();
    });
    const R = () => {
      d == null || d.destroy(), d = null;
    };
    Ie(s, async (j) => {
      j && (await qe(), l.value && r.value && (R(), d = Fa(l.value, r.value, {
        // Fixed keeps the tooltip in the viewport layer so it does not expand
        // document scroll width/height (avoids double scrollbars with nested overflow:auto regions).
        strategy: "fixed",
        placement: t.position,
        modifiers: [
          {
            name: "offset",
            options: { offset: [0, 8] }
          },
          {
            name: "arrow",
            // Own class and an element ref, not the conventional `[data-popper-arrow]` /
            // `.tooltip-arrow` hooks: no global stylesheet aimed at those names can hide or redraw it.
            // Padding keeps the arrow off the corners when the bubble is shifted. At most
            // (36px one-line height - 16px arrow) / 2, or Popper pushes a left/right arrow off-centre.
            options: { element: o.value, padding: 10 }
          },
          {
            // Reflow at 320px (RGAA 10.11): when neither side has room, a left/right bubble moves
            // above or below instead of leaving the viewport.
            name: "flip",
            options: { fallbackPlacements: Jb[t.position] }
          },
          {
            name: "preventOverflow",
            options: { padding: Zb }
          }
        ]
      })));
    }, { immediate: !0 });
    const z = () => {
      f && (clearTimeout(f), f = null);
    }, D = () => {
      t.disabled || (z(), !(u || i.value) && (u = setTimeout(() => {
        i.value = !0, u = null;
      }, t.delay)));
    }, V = () => {
      u && (clearTimeout(u), u = null), z(), i.value = !1;
    };
    Ie(
      () => t.disabled,
      (j) => {
        var M;
        j ? V() : (M = l.value) != null && M.contains(document.activeElement) && D();
      }
    );
    const Y = () => {
      u && (clearTimeout(u), u = null), i.value && (z(), f = setTimeout(() => {
        i.value = !1, f = null;
      }, w0));
    }, _ = (j) => {
      t.open !== void 0 || !s.value || (j.stopPropagation(), j.preventDefault(), V());
    };
    return n({ isVisible: s, hide: V }), gt(() => {
      u && clearTimeout(u), f && clearTimeout(f), L(), y(), R();
    }), (j, M) => (c(), g(se, null, [
      (c(), K(dt(e.as), Oe({
        ref_key: "triggerRef",
        ref: l,
        class: "inline-flex"
      }, j.$attrs, {
        onMouseenter: D,
        onMouseleave: Y,
        onFocusin: D,
        onFocusout: V,
        onKeydown: ut(_, ["escape"])
      }), {
        default: ve(() => [
          $e(j.$slots, "default", {}, void 0, !0)
        ]),
        _: 3
      }, 16)),
      (c(), K(Bn, { to: "body" }, [
        e.labelsTrigger ? k("", !0) : (c(), g("span", {
          key: 0,
          id: I(a),
          hidden: ""
        }, P(e.text), 9, k0)),
        te(wt, {
          name: "tooltip",
          onAfterLeave: R
        }, {
          default: ve(() => [
            s.value ? (c(), g("div", {
              key: 0,
              ref_key: "bubbleRef",
              ref: r,
              role: "tooltip",
              class: "tooltip-bubble fixed z-9999 rounded-(--border-border-radius-rounded-l) shadow-(--shadow-m) min-w-33.5 max-w-50 py-2 px-3 text-center text-(length:--size-m) leading-(--line-height-l) font-(--weight-medium) wrap-break-word",
              onMouseenter: z,
              onMouseleave: Y
            }, [
              at(P(e.text) + " ", 1),
              v("div", {
                ref_key: "arrowRef",
                ref: o,
                class: "tooltip-pointer",
                "aria-hidden": "true"
              }, [...M[0] || (M[0] = [
                v("svg", {
                  width: "16",
                  height: "8",
                  viewBox: "0 0 16 8"
                }, [
                  v("path", { d: "M0 0L6.59 6.59A2 2 0 0 0 9.41 6.59L16 0Z" })
                ], -1)
              ])], 512)
            ], 544)) : k("", !0)
          ]),
          _: 1
        })
      ]))
    ], 64));
  }
}), lt = (e, n) => {
  const t = e.__vccOpts || e;
  for (const [a, l] of n)
    t[a] = l;
  return t;
}, ft = /* @__PURE__ */ lt(C0, [["__scopeId", "data-v-82534dc2"]]);
function S0(e, n, t = "horizontal") {
  const a = E(!1);
  let l = null;
  function r() {
    const o = e.value;
    a.value = !!o && (t === "vertical" ? o.scrollHeight > o.clientHeight : o.scrollWidth > o.offsetWidth);
  }
  return Ie(
    e,
    (o) => {
      if (l == null || l.disconnect(), l = null, !o) {
        a.value = !1;
        return;
      }
      typeof ResizeObserver < "u" && (l = new ResizeObserver(r), l.observe(o)), r();
    },
    { flush: "post" }
  ), Ie(n, r, { flush: "post" }), gt(() => {
    l == null || l.disconnect(), l = null;
  }), { isTruncated: a };
}
const $0 = ["id", "aria-hidden"], I0 = ["id", "aria-hidden"], bt = /* @__PURE__ */ ye({
  __name: "TruncatedText",
  props: {
    text: {},
    lines: { default: 1 },
    textClass: { default: "" },
    position: { default: "top" },
    focusable: { type: Boolean, default: !0 },
    open: { type: Boolean, default: void 0 }
  },
  setup(e, { expose: n }) {
    const t = e, a = E(null), { isTruncated: l } = S0(
      a,
      () => t.text,
      t.lines > 1 ? "vertical" : "horizontal"
    ), r = t.lines > 1 ? "line-clamp-2 break-words" : "truncate", o = E(!1), i = p(() => t.focusable && (l.value || o.value)), s = Ve(), d = Ve(), u = Mn();
    return n({ isTruncated: l, isTabStop: i }), (f, b) => (c(), K(ft, {
      as: "span",
      class: "w-full min-w-0 rounded-xs focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-(--border-border-accent)",
      text: e.text,
      position: e.position,
      disabled: !I(l),
      open: e.open,
      "labels-trigger": "",
      tabindex: i.value ? 0 : void 0,
      role: i.value ? "group" : void 0,
      "aria-labelledby": i.value ? I(u).default ? `${I(s)} ${I(d)}` : I(s) : void 0,
      onFocusin: b[0] || (b[0] = (h) => o.value = !0),
      onFocusout: b[1] || (b[1] = (h) => o.value = !1)
    }, {
      default: ve(() => [
        v("span", {
          id: I(s),
          ref_key: "textEl",
          ref: a,
          "data-testid": "truncated-text",
          "aria-hidden": i.value ? "true" : void 0,
          class: C(["w-full min-w-0", I(r), e.textClass])
        }, P(e.text), 11, $0),
        I(u).default ? (c(), g("span", {
          key: 0,
          id: I(d),
          "aria-hidden": i.value ? "true" : void 0
        }, [
          $e(f.$slots, "default")
        ], 8, I0)) : k("", !0)
      ]),
      _: 3
    }, 8, ["text", "position", "disabled", "open", "tabindex", "role", "aria-labelledby"]));
  }
}), T0 = ["src"], nf = /* @__PURE__ */ ye({
  __name: "AvatarCircle",
  props: {
    img: {},
    name: {},
    label: {},
    size: {},
    entity: {},
    avatarStyle: {},
    logo: { type: Boolean },
    presentational: { type: Boolean },
    as: {},
    imageError: { type: Boolean }
  },
  emits: ["image-error"],
  setup(e, { emit: n }) {
    const t = e, a = n, l = {
      // 3xs / 2xs: Badge only. Figma shows them with a picture; initials and square radius keep the xs values.
      "3xs": { container: "h-3 w-3", text: "text-(length:--size-2xs) leading-(--line-height-xs)" },
      "2xs": { container: "h-3.5 w-3.5", text: "text-(length:--size-2xs) leading-(--line-height-xs)" },
      xs: { container: "h-[18px] w-[18px]", text: "text-(length:--size-2xs) leading-(--line-height-s)" },
      sm: { container: "h-6 w-6", text: "text-(length:--size-sm) leading-(--line-height-l)" },
      md: { container: "h-9 w-9", text: "text-(length:--size-m) leading-(--line-height-l)" },
      lg: { container: "h-11 w-11", text: "text-(length:--size-xl) leading-(--line-height-xxl)" },
      xl: { container: "h-14 w-14", text: "text-(length:--size-xxl) leading-(--line-height-xxl)" },
      "2xl": { container: "h-16 w-16", text: "text-(length:--size-4xl) leading-(--line-height-xxl)" }
    }, r = p(() => l[t.size]), o = {
      "3xs": "rounded-(--border-border-radius-rounded-xs)",
      "2xs": "rounded-(--border-border-radius-rounded-xs)",
      xs: "rounded-(--border-border-radius-rounded-xs)",
      sm: "rounded-(--border-border-radius-rounded-xs)",
      md: "rounded-(--border-border-radius-rounded-sm)",
      lg: "rounded-(--border-border-radius-rounded-sm)",
      xl: "rounded-(--border-border-radius-rounded-l)",
      "2xl": "rounded-(--border-border-radius-rounded-l)"
    }, i = p(() => t.logo && !!t.img && !t.imageError), s = p(
      () => i.value ? "avatar-container--logo bg-(--background-background-white)" : (
        // Figma "Avatar gradient" (4230:55188) as CSS: its gradientTransform is skewed, so the
        // colour runs at 85deg with stops at 10.83 % / 86.95 % (the 138deg handle line is not it).
        "bg-[linear-gradient(85deg,var(--colors-avatar-gradient-start)_10.83%,var(--colors-avatar-gradient-end)_86.95%)]"
      )
    ), d = p(
      () => t.avatarStyle === "square" ? o[t.size] : "rounded-full"
    ), u = (b) => b.normalize("NFD").replace(/[\u0300-\u036f]/g, "").charAt(0).toUpperCase(), f = p(() => {
      var x;
      const b = (x = t.name) == null ? void 0 : x.trim();
      if (!b)
        return "?";
      const h = b.split(/\s+/), m = t.entity === "organisation" ? 1 : 2;
      return h.slice(0, m).map(u).join("");
    });
    return (b, h) => (c(), K(dt(t.as), {
      class: C(["avatar-container flex shrink-0 items-center justify-center overflow-hidden", [r.value.container, d.value, s.value]]),
      role: e.presentational ? void 0 : "img",
      "aria-hidden": e.presentational ? "true" : void 0,
      "aria-label": e.presentational ? void 0 : t.label
    }, {
      default: ve(() => [
        t.img && !t.imageError ? (c(), g("img", {
          key: 0,
          src: t.img,
          alt: "",
          class: C(["h-full w-full", t.logo ? "object-contain" : "object-cover"]),
          loading: "lazy",
          onError: h[0] || (h[0] = (m) => a("image-error"))
        }, null, 42, T0)) : (c(), g("span", {
          key: 1,
          "aria-hidden": "true",
          class: C(["font-(--weight-medium) text-(--text-text-body-subtle)", r.value.text])
        }, P(f.value), 3))
      ]),
      _: 1
    }, 8, ["class", "role", "aria-hidden", "aria-label"]));
  }
}), L0 = ["aria-label"], E0 = ["aria-label"], af = "text-(length:--icon-size-xs)", ys = "text-(length:--size-sm)", lf = "text-(length:--icon-size-2xs)", A0 = "text-(length:--size-2xs)", rf = "absolute flex cursor-pointer items-center justify-center rounded-full focus-visible:outline-hidden focus-visible:shadow-(--shadow-focus-l) before:absolute before:left-1/2 before:top-1/2 before:size-6 before:-translate-x-1/2 before:-translate-y-1/2 before:content-['']", Kt = /* @__PURE__ */ ye({
  __name: "Avatar",
  props: {
    img: { default: void 0 },
    name: {},
    email: { default: void 0 },
    size: { default: "md" },
    entity: { default: "contact" },
    avatarStyle: { default: "circle" },
    logo: { type: Boolean, default: !1 },
    presentational: { type: Boolean, default: !1 },
    as: { default: "div" },
    status: { default: void 0 },
    statusLabel: { default: void 0 },
    removable: { type: Boolean, default: !1 },
    removeLabel: { default: void 0 },
    editable: { type: Boolean, default: !1 },
    editLabel: { default: void 0 }
  },
  emits: ["remove", "edit"],
  setup(e, { emit: n }) {
    var w;
    const t = (S) => S !== "3xs" && S !== "2xs", a = e, l = n, r = E(!1);
    Ie(
      () => a.img,
      () => {
        r.value = !1;
      }
    );
    const o = p(() => !t(a.size)), i = p(
      () => !o.value && (!!a.status || a.removable || a.editable)
    ), s = p(() => t(a.size) ? a.size : "xs"), d = p(
      () => {
        var S;
        return a.status && !o.value ? (S = a.statusLabel) == null ? void 0 : S.trim() : void 0;
      }
    ), u = p(
      () => {
        var S;
        return [(S = a.name) == null ? void 0 : S.trim(), d.value].filter(Boolean).join(", ") || a.name;
      }
    ), f = p(() => ({
      img: a.img,
      name: a.name,
      label: u.value,
      size: a.size,
      entity: a.entity,
      avatarStyle: a.avatarStyle,
      logo: a.logo,
      presentational: a.presentational,
      imageError: r.value
    })), b = {
      online: "bg-(--icons-icon-success-subtle)",
      offline: "bg-(--icons-icon-error)",
      alternative: "bg-(--icons-icon-disabled-strong)"
    }, h = {
      xs: "size-1.5 top-[1px] -right-[2px]",
      sm: "size-2 top-[1px] -right-[2px]",
      md: "size-3 top-[1px] right-[1px]",
      lg: "size-3 top-[4px] -right-[3px]",
      xl: "size-4 top-[2px] -right-[2px]",
      "2xl": "size-4 top-[4px] -right-[1px]"
    }, m = {
      xs: { button: "size-3.5 -top-[2px] -right-[8px]", icon: lf },
      sm: { button: "size-3.5 -top-[2px] -right-[6px]", icon: lf },
      md: { button: "size-4 top-0 -right-[4px]", icon: ys },
      lg: { button: "size-4 top-[3px] -right-[6px]", icon: ys },
      xl: { button: "size-5 top-[1px] -right-[6px]", icon: af },
      "2xl": { button: "size-5 top-[3px] -right-[5px]", icon: af }
    }, x = {
      ...m,
      xs: { button: "size-3 -top-[2px] -right-[6px]", icon: A0 },
      md: { button: "size-4 top-0 -right-[2px]", icon: ys }
    };
    return typeof process < "u" && ((w = process.env) == null ? void 0 : w.NODE_ENV) !== "production" && Ie(
      () => [
        a.status,
        a.statusLabel,
        a.removable,
        a.removeLabel,
        a.editable,
        a.editLabel,
        a.presentational,
        a.as,
        a.size
      ],
      () => {
        var $, T, L;
        const S = (A) => console.warn(`[OPAL Avatar] ${A}`);
        a.status && !(($ = a.statusLabel) != null && $.trim()) && S("`status` is set without `statusLabel`: assistive tech gets no presence text (WCAG 1.1.1 / 4.1.2)."), a.removable && !((T = a.removeLabel) != null && T.trim()) && S("`removable` is set without `removeLabel`: the remove button has no accessible name."), a.editable && !((L = a.editLabel) != null && L.trim()) && S("`editable` is set without `editLabel`: the edit button has no accessible name."), o.value && (a.status || a.removable || a.editable) && S(`size "${a.size}" shows no status dot, remove or edit button.`), a.removable && a.editable && S("`removable` and `editable` are both set; they share the same corner. Use one."), (a.removable || a.editable) && (a.presentational || a.as === "span") && S(
          '`removable`/`editable` with `presentational` or `as="span"` means the avatar sits inside another control: its buttons would be nested inside that control.'
        );
      },
      { immediate: !0 }
    ), (S, $) => i.value ? (c(), K(dt(e.as), {
      key: 1,
      class: "relative flex w-fit shrink-0"
    }, {
      default: ve(() => [
        te(nf, Oe(f.value, {
          as: e.as === "span" ? "span" : "div",
          onImageError: $[1] || ($[1] = (T) => r.value = !0)
        }), null, 16, ["as"]),
        e.status ? (c(), g("span", {
          key: 0,
          class: C(["absolute rounded-full", [b[e.status], h[s.value]]]),
          "aria-hidden": "true",
          "data-testid": "avatar-status"
        }, null, 2)) : k("", !0),
        e.removable ? (c(), g("button", {
          key: 1,
          type: "button",
          class: C([
            rf,
            m[s.value].button,
            "bg-(--background-background-gray) text-(--icons-icon-dark-default)"
          ]),
          "aria-label": e.removeLabel,
          "data-testid": "avatar-remove",
          onClick: $[2] || ($[2] = Ue((T) => l("remove"), ["stop"]))
        }, [
          v("i", {
            class: C(["ri-close-fill", m[s.value].icon]),
            "aria-hidden": "true"
          }, null, 2)
        ], 10, L0)) : k("", !0),
        e.editable ? (c(), g("button", {
          key: 2,
          type: "button",
          class: C([
            rf,
            x[s.value].button,
            "border border-(--border-border-white-full) bg-(--background-background-white) text-(--icons-icon-dark-default)",
            "hover:border-transparent hover:text-(--icons-icon-hover)"
          ]),
          "aria-label": e.editLabel,
          "data-testid": "avatar-edit",
          onClick: $[3] || ($[3] = Ue((T) => l("edit"), ["stop"]))
        }, [
          v("i", {
            class: C(["ri-pencil-line", x[s.value].icon]),
            "aria-hidden": "true"
          }, null, 2)
        ], 10, E0)) : k("", !0)
      ]),
      _: 1
    })) : (c(), K(nf, Oe({ key: 0 }, f.value, {
      as: e.as,
      onImageError: $[0] || ($[0] = (T) => r.value = !0)
    }), null, 16, ["as"]));
  }
}), R0 = ["role", "aria-hidden"], B0 = {
  class: "opal-spinner-rotate size-full",
  viewBox: "0 0 100 100",
  fill: "none",
  "aria-hidden": "true",
  focusable: "false"
}, M0 = { key: 0 }, D0 = ["x1", "y1", "x2", "y2"], z0 = ["r", "stroke-width"], O0 = ["d", "stroke", "stroke-width"], P0 = {
  key: 0,
  class: "sr-only"
}, F0 = { value: 0 }, V0 = /* @__PURE__ */ ye({
  __name: "Spinner",
  props: {
    size: { default: "sm" },
    color: { default: "sky" },
    track: { type: Boolean, default: !0 },
    label: { default: void 0 }
  },
  setup(e) {
    const n = e, t = {
      xs: "size-(--spacing-3)",
      sm: "size-(--spacing-6)",
      md: "size-[50px]",
      base: "size-[75px]",
      lg: "size-[100px]",
      inherit: "size-[1em]"
    }, a = { r: 42.5, width: 15, arc: "M 49.834 7.5 A 42.5 42.5 0 0 1 92.458 48.107" }, l = { r: 45.459, width: 9.081, arc: "M 42.9 5.099 A 45.459 45.459 0 0 1 92.594 34.116" }, r = p(
      () => n.size === "md" || n.size === "base" || n.size === "lg" ? l : a
    ), o = {
      sky: {
        x1: 3.01,
        y1: 0,
        x2: 85.17,
        y2: -7.21,
        start: "--colors-spinner-sky-start",
        end: "--colors-spinner-sky-end"
      },
      primary: {
        x1: 0,
        y1: 50,
        x2: 100,
        y2: 50,
        start: "--colors-spinner-primary-start",
        end: "--colors-spinner-primary-end"
      }
    }, i = {
      sky: { x1: 42.76, y1: 0, x2: 91.22, y2: -4.43 },
      primary: { x1: 40.98, y1: 28.31, x2: 100, y2: 28.31 }
    }, s = `opal-spinner-${++F0.value}`, d = p(() => {
      if (n.color === "current") return;
      const y = o[n.color];
      return n.size === "xs" ? { ...y, ...i[n.color] } : y;
    }), u = p(() => d.value ? `url(#${s})` : "currentColor"), f = p(
      () => n.color === "current" ? "var(--spinner-track, transparent)" : "var(--colors-spinner-track)"
    ), b = 100, h = E("");
    let m;
    const x = p(() => {
      var y;
      return ((y = n.label) == null ? void 0 : y.trim()) || void 0;
    });
    return Ie(
      x,
      (y) => {
        clearTimeout(m), h.value = "", y && (m = setTimeout(() => h.value = y, b));
      },
      { immediate: !0 }
    ), gt(() => clearTimeout(m)), (y, w) => (c(), g("span", {
      class: C(["inline-flex shrink-0 align-middle", t[e.size]]),
      role: x.value ? "status" : void 0,
      "aria-hidden": x.value ? void 0 : "true",
      "data-testid": "spinner"
    }, [
      (c(), g("svg", B0, [
        d.value ? (c(), g("defs", M0, [
          v("linearGradient", {
            id: s,
            gradientUnits: "userSpaceOnUse",
            x1: d.value.x1,
            y1: d.value.y1,
            x2: d.value.x2,
            y2: d.value.y2
          }, [
            v("stop", {
              offset: "0",
              style: Ne({ stopColor: `var(${d.value.start})` })
            }, null, 4),
            v("stop", {
              offset: "1",
              style: Ne({ stopColor: `var(${d.value.end})` })
            }, null, 4)
          ], 8, D0)
        ])) : k("", !0),
        e.track ? (c(), g("circle", {
          key: 1,
          cx: "50",
          cy: "50",
          r: r.value.r,
          "stroke-width": r.value.width,
          style: Ne({ stroke: f.value }),
          "data-testid": "spinner-track"
        }, null, 12, z0)) : k("", !0),
        v("path", {
          d: r.value.arc,
          stroke: u.value,
          "stroke-width": r.value.width,
          "stroke-linecap": "round",
          "data-testid": "spinner-arc"
        }, null, 8, O0)
      ])),
      x.value ? (c(), g("span", P0, P(h.value), 1)) : k("", !0)
    ], 10, R0));
  }
}), Ru = /* @__PURE__ */ lt(V0, [["__scopeId", "data-v-1ef84c80"]]);
function Fl(e) {
  return e.startsWith("ri-");
}
const N0 = /^ri-[a-z0-9-]+$/, H0 = new RegExp("^(?:\\p{Extended_Pictographic}[\\p{Emoji_Modifier}️]*(?:‍\\p{Extended_Pictographic}[\\p{Emoji_Modifier}️]*)*|\\p{Regional_Indicator}{2})$", "u");
function bo(e) {
  return N0.test(e) || H0.test(e);
}
const Qb = {
  label: "",
  theme: "neutral",
  size: "sm",
  type: "default",
  badgeStyle: "rounded",
  leftIcon: void 0,
  rightIcon: void 0,
  showLeftIcon: !0,
  showCloseIcon: !1,
  removeLabel: void 0,
  closeIconInactive: !1,
  showText: !0,
  dropdownIcon: !1,
  secondaryText: "",
  avatarSrc: void 0,
  avatarAlt: void 0,
  iconOnly: !1,
  textOnly: !1,
  value: void 0,
  truncate: !1,
  truncationFocusable: !0,
  tooltipText: void 0
}, j0 = {
  // Figma component `eudonet` 4728:62829.
  eudonet: [
    "M24.0709 0C23.1879 0 22.3161 0.0495821 21.4578 0.141985C33.4426 1.44915 42.7738 11.6315 42.7738 24C42.7738 36.3685 33.4448 46.5531 21.4578 47.858C22.3161 47.9527 23.1879 48 24.0709 48C37.287 48 48 37.2542 48 23.9977C48 10.7413 37.2847 0 24.0709 0Z",
    "M23.0574 8.97662C22.5046 8.97662 21.9586 9.00818 21.4216 9.06677C28.9239 9.88488 34.7636 16.2584 34.7636 24.0023C34.7636 31.7461 28.9239 38.1196 21.4216 38.9377C21.9586 38.9963 22.5046 39.0279 23.0574 39.0279C31.3303 39.0279 38.035 32.3005 38.035 24.0045C38.035 15.7085 31.3281 8.98113 23.0574 8.98113V8.97662Z",
    "M22.525 16.4297C22.2464 16.4297 21.9723 16.4455 21.7004 16.4748C25.4819 16.8872 28.4253 20.0988 28.4253 24.0022C28.4253 27.9057 25.4819 31.1173 21.7004 31.5297C21.9723 31.559 22.2464 31.5748 22.525 31.5748C26.6952 31.5748 30.0745 28.1852 30.0745 24.0022C30.0745 19.8193 26.6952 16.4297 22.525 16.4297Z",
    "M17.2874 41.3424C17.9255 41.3424 18.5547 41.3064 19.1748 41.2388C10.5154 40.2944 3.77474 32.9383 3.77474 24.0022C3.77474 15.0662 10.5154 7.70772 19.1748 6.76566C18.5547 6.69805 17.9255 6.66199 17.2874 6.66199C7.74047 6.66199 0 14.4261 0 24.0022C0 33.5783 7.74047 41.3424 17.2874 41.3424Z",
    "M19.4895 35.0478C19.8962 35.0478 20.2961 35.0252 20.6916 34.9824C15.1755 34.3806 10.8817 29.6951 10.8817 24.0022C10.8817 18.3093 15.1755 13.6215 20.6916 13.022C20.2961 12.9792 19.8962 12.9567 19.4895 12.9567C13.4072 12.9567 8.47534 17.9036 8.47534 24.0045C8.47534 30.1053 13.4072 35.0523 19.4895 35.0523V35.0478Z"
  ]
}, W0 = {
  class: "size-full",
  viewBox: "0 0 48 48",
  fill: "currentColor",
  "aria-hidden": "true",
  focusable: "false",
  "data-testid": "badge-brand-icon"
}, q0 = ["d"], U0 = {
  key: 5,
  class: "sr-only"
}, G0 = ["aria-hidden"], K0 = { "aria-hidden": "true" }, Y0 = ["id", "aria-hidden"], J0 = ["id", "aria-hidden"], Z0 = ["aria-label"], X0 = /* @__PURE__ */ ye({
  inheritAttrs: !1,
  __name: "BadgeBase",
  props: /* @__PURE__ */ Bb({
    brandIcon: {},
    fitWidth: { type: Boolean },
    label: {},
    theme: {},
    size: {},
    type: {},
    badgeStyle: {},
    leftIcon: {},
    showLeftIcon: { type: Boolean },
    rightIcon: {},
    showCloseIcon: { type: Boolean },
    removeLabel: {},
    closeIconInactive: { type: Boolean },
    showText: { type: Boolean },
    dropdownIcon: { type: Boolean },
    secondaryText: {},
    avatarSrc: {},
    avatarAlt: {},
    iconOnly: { type: Boolean },
    textOnly: { type: Boolean },
    value: {},
    truncate: { type: Boolean },
    truncationFocusable: { type: Boolean },
    tooltipText: {}
  }, { ...Qb, brandIcon: void 0, fitWidth: !1 }),
  emits: ["close"],
  setup(e, { emit: n }) {
    var H;
    const t = Fn(), a = p(() => {
      const { class: q, ...N } = t;
      return N;
    }), l = e, r = n, o = {
      disabled: {
        bg: "bg-(--components-badge-background-badge-disabled-bg)",
        border: "",
        text: "text-(--components-badge-text-badge-disabled-strong-text)",
        icon: "text-(--components-badge-icon-badge-disabled-icon)",
        separator: "bg-(--components-badge-border-badge-white-default-border)",
        secondaryText: "text-(--components-badge-text-badge-disabled-strong-text)",
        dot: "bg-(--components-badge-background-badge-gray-bg)",
        dotText: "text-(--components-badge-text-badge-disabled-strong-text)",
        dotIcon: "text-(--components-badge-icon-badge-disabled-icon)",
        spinner: "text-(--components-badge-spinner-disabled-arc) [--spinner-track:var(--components-badge-spinner-disabled-track)]"
      },
      red: {
        bg: "bg-(--components-badge-background-badge-error-bg)",
        border: "",
        text: "text-(--components-badge-text-badge-black-default-text)",
        icon: "text-(--components-badge-icon-badge-black-default-icon)",
        separator: "bg-(--components-badge-border-badge-black-border)",
        secondaryText: "text-(--components-badge-text-badge-body-text)",
        dot: "bg-(--components-badge-background-badge-error-strong-bg)",
        dotText: "text-(--components-badge-text-badge-black-default-text)",
        dotIcon: "text-(--components-badge-icon-badge-black-default-icon)",
        spinner: "text-(--components-badge-spinner-red-arc) [--spinner-track:var(--components-badge-spinner-red-track)]"
      },
      orange: {
        bg: "bg-(--components-badge-background-badge-orange-bg)",
        border: "",
        text: "text-(--components-badge-text-badge-black-default-text)",
        icon: "text-(--components-badge-icon-badge-black-default-icon)",
        separator: "bg-(--border-border-black-default)",
        secondaryText: "text-(--components-badge-text-badge-body-text)",
        dot: "bg-(--components-badge-background-badge-orange-strong-bg)",
        dotText: "text-(--components-badge-text-badge-black-default-text)",
        dotIcon: "text-(--components-badge-icon-badge-black-icon)",
        spinner: "text-(--components-badge-spinner-orange-arc) [--spinner-track:var(--components-badge-spinner-orange-track)]"
      },
      yellow: {
        bg: "bg-(--components-badge-background-badge-yellow-bg)",
        border: "",
        text: "text-(--components-badge-text-badge-black-default-text)",
        icon: "text-(--components-badge-icon-badge-black-default-icon)",
        separator: "bg-(--components-badge-border-badge-dark-default-border)",
        secondaryText: "text-(--components-badge-text-badge-body-text)",
        dot: "bg-(--components-badge-background-badge-yellow-strong-bg)",
        dotText: "text-(--components-badge-text-badge-black-default-text)",
        dotIcon: "text-(--components-badge-icon-badge-black-default-icon)",
        spinner: "text-(--components-badge-spinner-yellow-arc) [--spinner-track:var(--components-badge-spinner-yellow-track)]"
      },
      green: {
        bg: "bg-(--components-badge-background-badge-green-bg)",
        border: "",
        text: "text-(--components-badge-text-badge-black-default-text)",
        icon: "text-(--components-badge-icon-badge-black-default-icon)",
        separator: "bg-(--components-badge-border-badge-dark-default-border)",
        secondaryText: "text-(--components-badge-text-badge-body-text)",
        dot: "bg-(--components-badge-background-badge-green-strong-bg)",
        dotText: "text-(--components-badge-text-badge-black-default-text)",
        dotIcon: "text-(--components-badge-icon-badge-black-default-icon)",
        spinner: "text-(--components-badge-spinner-green-arc) [--spinner-track:var(--components-badge-spinner-green-track)]"
      },
      indigo: {
        bg: "bg-(--components-badge-background-badge-indigo-soft-bg)",
        border: "",
        text: "text-(--components-badge-text-badge-black-default-text)",
        icon: "text-(--components-badge-icon-badge-black-default-icon)",
        separator: "bg-(--components-badge-border-badge-dark-default-border)",
        secondaryText: "text-(--components-badge-text-badge-body-text)",
        dot: "bg-(--components-badge-background-badge-indigo-strong-bg)",
        dotText: "text-(--components-badge-text-badge-black-default-text)",
        dotIcon: "text-(--components-badge-icon-badge-black-default-icon)",
        spinner: "text-(--components-badge-spinner-indigo-arc) [--spinner-track:var(--components-badge-spinner-indigo-track)]"
      },
      // OPAL-only (no Figma variant): accent fill with indigo text, Indigo's dot and spinner.
      active: {
        bg: "bg-(--components-badge-background-badge-accent-bg)",
        border: "",
        text: "text-(--components-badge-background-badge-indigo-strong-bg)",
        icon: "text-(--components-badge-background-badge-indigo-strong-bg)",
        separator: "bg-(--components-badge-background-badge-indigo-strong-bg)",
        secondaryText: "text-(--components-badge-background-badge-indigo-strong-bg)",
        dot: "bg-(--components-badge-background-badge-indigo-strong-bg)",
        dotText: "text-(--components-badge-text-badge-black-default-text)",
        dotIcon: "text-(--components-badge-icon-badge-black-default-icon)",
        spinner: "text-(--components-badge-spinner-indigo-arc) [--spinner-track:var(--components-badge-spinner-indigo-track)]"
      },
      violet: {
        bg: "bg-(--components-badge-background-badge-violet-bg)",
        border: "",
        text: "text-(--components-badge-text-badge-black-default-text)",
        icon: "text-(--components-badge-icon-badge-black-default-icon)",
        separator: "bg-(--components-badge-border-badge-dark-default-border)",
        secondaryText: "text-(--components-badge-text-badge-body-text)",
        dot: "bg-(--components-badge-background-badge-violet-strong-bg)",
        dotText: "text-(--components-badge-text-badge-black-default-text)",
        dotIcon: "text-(--components-badge-icon-badge-black-default-icon)",
        spinner: "text-(--components-badge-spinner-violet-arc) [--spinner-track:var(--components-badge-spinner-violet-track)]"
      },
      purple: {
        bg: "bg-(--components-badge-background-badge-purple-bg)",
        border: "",
        text: "text-(--components-badge-text-badge-black-default-text)",
        icon: "text-(--components-badge-icon-badge-black-default-icon)",
        separator: "bg-(--components-badge-border-badge-dark-default-border)",
        secondaryText: "text-(--components-badge-text-badge-body-text)",
        dot: "bg-(--components-badge-background-badge-purple-strong-bg)",
        dotText: "text-(--components-badge-text-badge-black-default-text)",
        dotIcon: "text-(--components-badge-icon-badge-black-default-icon)",
        spinner: "text-(--components-badge-spinner-purple-arc) [--spinner-track:var(--components-badge-spinner-purple-track)]"
      },
      neutral: {
        bg: "bg-(--components-badge-background-badge-neutral-bg)",
        border: "",
        text: "text-(--components-badge-text-badge-black-default-text)",
        icon: "text-(--components-badge-icon-badge-black-default-icon)",
        separator: "bg-(--components-badge-border-badge-dark-default-border)",
        secondaryText: "text-(--components-badge-text-badge-black-default-text)",
        dot: "bg-(--components-badge-background-badge-neutral-strong-bg)",
        dotText: "text-(--components-badge-text-badge-black-default-text)",
        dotIcon: "text-(--components-badge-icon-badge-black-default-icon)",
        spinner: "text-(--components-badge-spinner-neutral-arc) [--spinner-track:var(--components-badge-spinner-neutral-track)]"
      },
      // Only theme with a dark fill: light text and icon on the fill, dark text once `with-dot` drops it.
      dark: {
        bg: "bg-(--components-badge-background-badge-dark-bg)",
        border: "",
        text: "text-(--components-badge-text-badge-white-default-text)",
        icon: "text-(--components-badge-icon-badge-white-default-icon)",
        separator: "bg-(--components-badge-border-badge-base-soft-border)",
        secondaryText: "text-(--components-badge-text-badge-white-default-text)",
        dot: "bg-(--components-badge-background-badge-dark-bg)",
        dotText: "text-(--components-badge-text-badge-black-default-text)",
        dotIcon: "text-(--components-badge-icon-badge-dark-icon)",
        spinner: "text-(--components-badge-spinner-dark-arc) [--spinner-track:var(--components-badge-spinner-dark-track)]"
      },
      cyan: {
        bg: "bg-(--components-badge-background-badge-cyan-bg)",
        border: "",
        text: "text-(--components-badge-text-badge-black-default-text)",
        icon: "text-(--components-badge-icon-badge-black-default-icon)",
        separator: "bg-(--components-badge-border-badge-dark-default-border)",
        secondaryText: "text-(--components-badge-text-badge-black-default-text)",
        dot: "bg-(--components-badge-background-badge-cyan-strong-bg)",
        dotText: "text-(--text-text-black-default)",
        dotIcon: "text-(--icons-icon-dark-default)",
        spinner: "text-(--components-badge-spinner-cyan-arc) [--spinner-track:var(--components-badge-spinner-cyan-track)]"
      },
      white: {
        bg: "bg-(--components-badge-background-badge-white-bg)",
        border: "border-(--components-badge-border-badge-base-soft-border)",
        text: "text-(--components-badge-text-badge-black-default-text)",
        icon: "text-(--components-badge-icon-badge-black-default-icon)",
        separator: "bg-(--components-badge-border-badge-base-soft-border)",
        secondaryText: "text-(--components-badge-text-badge-black-default-text)",
        dot: "bg-(--components-badge-background-badge-neutral-bg)",
        dotText: "text-(--components-badge-text-badge-black-default-text)",
        dotIcon: "text-(--components-badge-icon-badge-black-default-icon)",
        spinner: "text-(--components-badge-spinner-white-arc) [--spinner-track:var(--components-badge-spinner-white-track)]"
      },
      "gradient-light": {
        bg: "badge-gradient-light",
        border: "border-transparent",
        text: "text-(--components-badge-text-badge-black-default-text)",
        icon: "text-(--components-badge-icon-badge-black-default-icon)",
        separator: "bg-(--components-badge-border-badge-dark-default-border)",
        secondaryText: "text-(--components-badge-text-badge-black-default-text)",
        dot: "badge-dot-gradient",
        dotText: "text-(--text-text-black-default)",
        dotIcon: "text-(--icons-icon-dark-default)",
        spinner: "text-(--components-badge-spinner-gradient-light-arc) [--spinner-track:var(--components-badge-spinner-gradient-light-track)]"
      }
    }, i = p(() => o[l.theme]), s = {
      xs: {
        padding: "gap-1 px-1 h-[18px]",
        withDot: "gap-1 px-1 min-h-5",
        compact: "px-1 min-w-5 h-[18px]",
        compactCircle: "px-1 min-w-[18px] h-[18px]",
        text: "text-(length:--size-xs) leading-(--line-height-s)",
        countText: "text-(length:--size-xs) leading-(--line-height-s)",
        icon: "size-2.5",
        glyph: "text-(length:--icon-size-2xs)",
        secondaryGap: "gap-1",
        separator: "h-2.5",
        avatar: "3xs"
      },
      sm: {
        padding: "gap-1 px-1 min-h-6",
        withDot: "gap-1 px-1 min-h-5",
        compact: "px-1 min-w-[22px] h-5",
        compactCircle: "px-1 min-w-[22px] h-[22px]",
        text: "text-(length:--size-sm) leading-(--line-height-l)",
        countText: "text-(length:--size-sm) leading-(--line-height-l)",
        icon: "size-3",
        glyph: "text-(length:--size-sm)",
        secondaryGap: "gap-1.5",
        separator: "h-3",
        avatar: "2xs"
      },
      lg: {
        padding: "gap-1.5 px-1.5 min-h-7",
        withDot: "gap-1.5 px-1.5 min-h-[22px]",
        compact: "px-1 min-w-[22px] h-6",
        compactCircle: "px-1 min-w-6 h-6",
        text: "text-(length:--size-m) leading-(--line-height-l)",
        countText: "text-(length:--size-sm) leading-(--line-height-l)",
        icon: "size-3.5",
        glyph: "text-(length:--icon-size-xs)",
        secondaryGap: "gap-2",
        separator: "h-3",
        avatar: "2xs"
      }
    }, d = p(() => l.iconOnly || l.textOnly), u = p(() => l.type === "with-dot" && !d.value), f = p(() => s[u.value && l.size === "xs" ? "sm" : l.size]), b = p(
      () => l.badgeStyle === "circle" ? "rounded-(--border-border-radius-rounded-full)" : "rounded-(--border-border-radius-rounded-xs)"
    ), h = p(() => {
      const q = i.value, N = f.value;
      let J = u.value ? N.withDot : N.padding;
      return d.value && (J = l.badgeStyle === "circle" ? N.compactCircle : N.compact), [
        "opal-badge inline-flex items-center justify-center font-inter whitespace-nowrap",
        b.value,
        u.value ? "bg-transparent" : [q.bg, q.border && ["border-solid border-[1px]", q.border]],
        u.value ? q.dotText : q.text,
        J
      ];
    }), m = p(() => [f.value.text, "font-(--weight-medium)", l.fitWidth && "min-w-0"]), x = p(() => [f.value.countText, "font-(--weight-medium)"]), y = p(() => [
      ...m.value,
      l.size === "xs" ? i.value.text : i.value.secondaryText
    ]), w = p(() => u.value ? i.value.dotIcon : i.value.icon), S = p(() => !!l.leftIcon && Fl(l.leftIcon)), $ = p(() => l.brandIcon ? j0[l.brandIcon] : void 0), T = p(
      () => (
        // Not a glyph (typo, extra classes): render nothing rather than the raw string as text.
        (!!$.value || !!l.leftIcon && bo(l.leftIcon)) && !l.textOnly && (l.iconOnly || l.showLeftIcon && ["default", "with-secondary-text", "with-dot"].includes(l.type))
      )
    ), L = p(() => !!l.rightIcon && Fl(l.rightIcon)), A = p(
      () => !!l.rightIcon && bo(l.rightIcon) && !d.value && ["default", "with-secondary-text", "with-dot"].includes(l.type)
    ), R = p(
      () => !d.value && l.showText && (!!l.label || l.type === "with-secondary-text" && !!l.secondaryText)
    ), z = p(() => l.showCloseIcon && !d.value && l.type !== "with-dot"), D = p(() => Array.from(l.label ?? "")), V = p(() => l.truncate && !l.textOnly && D.value.length > 14), Y = p(
      () => V.value ? `${D.value.slice(0, 14).join("")}…` : l.label ?? ""
    ), _ = p(() => !!l.tooltipText || V.value), j = (q, { slots: N }) => {
      var J;
      return (J = N.default) == null ? void 0 : J.call(N);
    }, M = p(() => l.truncationFocusable && V.value), W = p(() => M.value && R.value), G = Ve(), B = Ve(), F = p(
      () => _.value ? {
        text: l.tooltipText || l.label,
        labelsTrigger: W.value && !l.tooltipText,
        tabindex: M.value ? 0 : void 0,
        role: W.value ? "group" : void 0,
        "aria-labelledby": W.value ? l.type === "with-secondary-text" && l.secondaryText ? `${G} ${B}` : G : void 0,
        position: "top",
        as: "span"
      } : {}
    );
    return typeof process < "u" && ((H = process.env) == null ? void 0 : H.NODE_ENV) !== "production" && Ie(
      () => [l.iconOnly, l.leftIcon, l.rightIcon, l.brandIcon, l.label, z.value, l.closeIconInactive, l.removeLabel],
      () => {
        var N, J;
        const q = (be) => console.warn(`[OPAL Badge] ${be}`);
        l.iconOnly && !l.leftIcon && !l.brandIcon && q("`iconOnly` is set without `leftIcon`: the badge renders empty."), l.leftIcon && !bo(l.leftIcon) && q(`\`leftIcon\` "${l.leftIcon}" is neither a single \`ri-*\` class nor an emoji: no icon is rendered.`), l.rightIcon && !bo(l.rightIcon) && q(`\`rightIcon\` "${l.rightIcon}" is neither a single \`ri-*\` class nor an emoji: no icon is rendered.`), l.iconOnly && !((N = l.label) != null && N.trim()) && q("`iconOnly` is set without `label`: the badge has no accessible name (WCAG 4.1.2)."), z.value && !l.closeIconInactive && !((J = l.removeLabel) != null && J.trim()) && q("`showCloseIcon` is set without `removeLabel`: the remove button has no accessible name.");
      },
      { immediate: !0 }
    ), (q, N) => (c(), K(dt(_.value ? ft : j), en(tn(F.value)), {
      default: ve(() => [
        v("span", Oe(a.value, {
          class: [h.value, I(t).class]
        }), [
          u.value ? (c(), g("span", {
            key: 0,
            class: C(["size-1.5 shrink-0 rounded-(--border-border-radius-rounded-full)", i.value.dot]),
            "aria-hidden": "true",
            "data-testid": "badge-dot"
          }, null, 2)) : k("", !0),
          e.type === "with-avatar" && !d.value ? (c(), K(Kt, {
            key: 1,
            img: e.avatarSrc,
            name: e.avatarAlt || e.label,
            size: f.value.avatar,
            presentational: !e.avatarAlt,
            as: "span",
            class: C({ "opacity-60": e.theme === "disabled" })
          }, null, 8, ["img", "name", "size", "presentational", "class"])) : k("", !0),
          e.type === "with-loader" && !d.value ? (c(), K(Ru, {
            key: 2,
            size: "xs",
            color: "current",
            class: C(i.value.spinner)
          }, null, 8, ["class"])) : k("", !0),
          T.value && $.value ? (c(), g("span", {
            key: 3,
            class: C([f.value.icon, "text-(--icons-icon-dark-default) shrink-0 inline-flex items-center justify-center"]),
            "aria-hidden": "true",
            "data-testid": "badge-left-icon"
          }, [
            (c(), g("svg", W0, [
              (c(!0), g(se, null, Me($.value, (J, be) => (c(), g("path", {
                key: be,
                d: J
              }, null, 8, q0))), 128))
            ]))
          ], 2)) : T.value ? (c(), g("span", {
            key: 4,
            class: C([f.value.icon, f.value.glyph, w.value, "shrink-0 inline-flex items-center justify-center"]),
            "aria-hidden": "true",
            "data-testid": "badge-left-icon"
          }, [
            S.value ? (c(), g("i", {
              key: 0,
              class: C(e.leftIcon)
            }, null, 2)) : (c(), g(se, { key: 1 }, [
              at(P(e.leftIcon), 1)
            ], 64))
          ], 2)) : k("", !0),
          e.iconOnly && e.label ? (c(), g("span", U0, P(e.label), 1)) : k("", !0),
          e.textOnly ? (c(), g("span", {
            key: 6,
            class: C(x.value)
          }, P(e.value ?? e.label), 3)) : k("", !0),
          R.value ? (c(), g("span", {
            key: 7,
            class: C(e.type === "with-secondary-text" ? ["inline-flex items-center", f.value.secondaryGap] : "contents")
          }, [
            v("span", {
              class: C(m.value),
              "aria-hidden": W.value ? "true" : void 0
            }, [
              V.value ? (c(), g(se, { key: 0 }, [
                v("span", K0, P(Y.value), 1),
                v("span", {
                  id: I(G),
                  class: "sr-only",
                  "aria-hidden": W.value ? "true" : void 0
                }, P(e.label), 9, Y0)
              ], 64)) : e.fitWidth ? (c(), K(bt, {
                key: 1,
                text: e.label ?? "",
                focusable: !1
              }, null, 8, ["text"])) : (c(), g(se, { key: 2 }, [
                at(P(e.label), 1)
              ], 64))
            ], 10, G0),
            e.type === "with-secondary-text" ? (c(), g(se, { key: 0 }, [
              v("span", {
                class: C(["w-px shrink-0", f.value.separator, i.value.separator]),
                "aria-hidden": "true",
                "data-testid": "badge-separator"
              }, null, 2),
              v("span", {
                id: I(B),
                class: C(y.value),
                "aria-hidden": W.value ? "true" : void 0
              }, P(e.secondaryText), 11, J0)
            ], 64)) : k("", !0)
          ], 2)) : k("", !0),
          A.value ? (c(), g("span", {
            key: 8,
            class: C([f.value.icon, f.value.glyph, w.value, "shrink-0 inline-flex items-center justify-center"]),
            "aria-hidden": "true",
            "data-testid": "badge-right-icon"
          }, [
            L.value ? (c(), g("i", {
              key: 0,
              class: C(e.rightIcon)
            }, null, 2)) : (c(), g(se, { key: 1 }, [
              at(P(e.rightIcon), 1)
            ], 64))
          ], 2)) : k("", !0),
          z.value && e.closeIconInactive ? (c(), g("span", {
            key: 9,
            class: C([f.value.icon, f.value.glyph, w.value, "shrink-0 inline-flex items-center justify-center"]),
            "aria-hidden": "true",
            "data-testid": "badge-close-icon"
          }, [...N[3] || (N[3] = [
            v("i", { class: "ri-close-fill" }, null, -1)
          ])], 2)) : z.value ? (c(), g("button", {
            key: 10,
            type: "button",
            class: C([
              f.value.icon,
              f.value.glyph,
              w.value,
              "relative shrink-0 inline-flex items-center justify-center cursor-pointer bg-transparent border-none p-0",
              "rounded-(--border-border-radius-rounded-xs) hover:opacity-70 transition-opacity",
              "focus-visible:outline-hidden focus-visible:shadow-(--shadow-focus-l)",
              "before:absolute before:left-1/2 before:top-1/2 before:size-6 before:-translate-x-1/2 before:-translate-y-1/2 before:content-['']"
            ]),
            "aria-label": e.removeLabel,
            onClick: N[0] || (N[0] = Ue((J) => r("close"), ["stop"])),
            onKeydown: [
              N[1] || (N[1] = ut(Ue(() => {
              }, ["stop"]), ["enter"])),
              N[2] || (N[2] = ut(Ue(() => {
              }, ["stop"]), ["space"]))
            ]
          }, [...N[4] || (N[4] = [
            v("i", {
              class: "ri-close-fill",
              "aria-hidden": "true"
            }, null, -1)
          ])], 42, Z0)) : k("", !0),
          e.dropdownIcon && !d.value ? (c(), g("span", {
            key: 11,
            class: C([w.value, "size-3 shrink-0 inline-flex items-center justify-center text-(length:--size-sm)"]),
            "aria-hidden": "true",
            "data-testid": "badge-chevron"
          }, [...N[5] || (N[5] = [
            v("i", { class: "ri-arrow-down-s-line" }, null, -1)
          ])], 2)) : k("", !0),
          N[6] || (N[6] = v("span", { class: "sr-only" }, " ", -1))
        ], 16)
      ]),
      _: 1
    }, 16));
  }
}), Bu = /* @__PURE__ */ lt(X0, [["__scopeId", "data-v-05eecf91"]]), ct = /* @__PURE__ */ ye({
  inheritAttrs: !1,
  __name: "Badge",
  props: /* @__PURE__ */ Bb({
    label: {},
    theme: {},
    size: {},
    type: {},
    badgeStyle: {},
    leftIcon: {},
    showLeftIcon: { type: Boolean },
    rightIcon: {},
    showCloseIcon: { type: Boolean },
    removeLabel: {},
    closeIconInactive: { type: Boolean },
    showText: { type: Boolean },
    dropdownIcon: { type: Boolean },
    secondaryText: {},
    avatarSrc: {},
    avatarAlt: {},
    iconOnly: { type: Boolean },
    textOnly: { type: Boolean },
    value: {},
    truncate: { type: Boolean },
    truncationFocusable: { type: Boolean },
    tooltipText: {}
  }, Qb),
  emits: ["close"],
  setup(e, { emit: n }) {
    const t = Fn(), a = p(() => {
      const { brandIcon: o, "brand-icon": i, ...s } = t;
      return s;
    }), l = e, r = n;
    return (o, i) => (c(), K(Bu, Oe({ ...a.value, ...l }, {
      onClose: i[0] || (i[0] = (s) => r("close"))
    }), null, 16));
  }
});
function _b(e, n) {
  const t = Number.isFinite(n) ? Math.max(0, Math.floor(n)) : e.length, a = e.slice(0, t), l = e.length - a.length;
  return l > 0 ? [...a, { label: `+${l}` }] : a;
}
const Q0 = /* @__PURE__ */ ye({
  __name: "IconShape",
  props: {
    color: {},
    size: { default: "md" },
    type: { default: "square" },
    variant: { default: "filled" },
    icon: { default: void 0 },
    label: { default: void 0 },
    as: { default: "div" }
  },
  setup(e) {
    const n = e, t = {
      xs: "h-4 w-4",
      sm: "h-6 w-6",
      md: "h-9 w-9",
      lg: "h-12 w-12",
      xl: "h-16 w-16",
      "2xl": "h-24 w-24"
    }, a = {
      xs: "rounded-(--border-border-radius-rounded-xs)",
      sm: "rounded-(--border-border-radius-rounded-xs)",
      md: "rounded-(--border-border-radius-rounded-sm)",
      lg: "rounded-(--border-border-radius-rounded-sm)",
      xl: "rounded-(--border-border-radius-rounded-l)",
      "2xl": "rounded-(--border-border-radius-rounded-l)"
    }, l = {
      xs: "border-(length:--border-border-width-border)",
      sm: "border-(length:--border-border-width-border)",
      md: "border-(length:--border-border-width-border-sm)",
      lg: "border-(length:--border-border-width-border-sm)",
      xl: "border-(length:--border-border-width-border-sm)",
      "2xl": "border-(length:--border-border-width-border-sm)"
    }, r = {
      xs: "text-(length:--icon-size-2xs)",
      sm: "text-(length:--icon-size-sm)",
      md: "text-(length:--icon-size-md)",
      lg: "text-(length:--icon-size-xl)",
      xl: "text-(length:--icon-size-2xl)",
      "2xl": "text-(length:--icon-size-3xl)"
    }, o = {
      xs: "text-(length:--size-sm) leading-(--line-height-l) font-(--weight-medium)",
      sm: "text-(length:--size-m) leading-(--line-height-l) font-(--weight-medium)",
      md: "text-(length:--size-l) leading-(--line-height-xxl) font-(--weight-medium)",
      lg: "text-(length:--size-xl) leading-(--line-height-xl) font-(--weight-semi-bold)",
      xl: "text-(length:--size-xxl) leading-(--line-height-xxl) font-(--weight-bold)",
      "2xl": "text-(length:--size-6xl) leading-(--line-height-6xl) font-(--weight-bold)"
    }, i = {
      red: { bg: "bg-(--components-icon-shape-background-iconshape-red-bg)", icon: "text-(--components-icon-shape-icon-iconshape-red-icon)" },
      orange: { bg: "bg-(--components-icon-shape-background-iconshape-orange-bg)", icon: "text-(--components-icon-shape-icon-iconshape-orange-icon)" },
      yellow: { bg: "bg-(--components-icon-shape-background-iconshape-yellow-bg)", icon: "text-(--components-icon-shape-icon-iconshape-yellow-icon)" },
      green: { bg: "bg-(--components-icon-shape-background-iconshape-green-bg)", icon: "text-(--components-icon-shape-icon-iconshape-success-icon)" },
      purple: { bg: "bg-(--components-icon-shape-background-iconshape-purple-bg)", icon: "text-(--components-icon-shape-icon-iconshape-purple-icon)" },
      violet: { bg: "bg-(--components-icon-shape-background-iconshape-violet-bg)", icon: "text-(--components-icon-shape-icon-iconshape-violet-icon)" },
      indigo: { bg: "bg-(--components-icon-shape-background-iconshape-indigo-bg)", icon: "text-(--components-icon-shape-icon-iconshape-indigo-icon)" },
      dark: { bg: "bg-(--components-icon-shape-background-iconshape-black-bg)", icon: "text-(--components-icon-shape-icon-iconshape-white-icon)" },
      white: { bg: "bg-(--components-icon-shape-background-iconshape-white-bg)", icon: "text-(--components-icon-shape-icon-iconshape-black-icon)" },
      default: { bg: "bg-(--components-icon-shape-background-iconshape-cyan-bg)", icon: "text-(--components-icon-shape-icon-iconshape-default-icon)", text: "text-(--components-icon-shape-text-iconshape-default-text)" },
      success: { bg: "bg-(--components-icon-shape-background-iconshape-success-bg)", icon: "text-(--components-icon-shape-icon-iconshape-white-default-icon)" },
      error: { bg: "bg-(--components-icon-shape-background-iconshape-error-bg)", icon: "text-(--components-icon-shape-icon-iconshape-white-default-icon)" },
      text: {
        bg: "bg-(--components-icon-shape-background-iconshape-black-default-bg)",
        icon: "text-(--components-icon-shape-text-iconshape-white-default-text)",
        text: "text-(--components-icon-shape-text-iconshape-white-default-text)"
      },
      disabled: {
        bg: "bg-(--components-icon-shape-background-iconshape-disabled-bg)",
        border: "border-(--components-icon-shape-border-iconshape-disabled-border)",
        icon: "text-(--components-icon-shape-icon-iconshape-disabled-strong-icon)",
        text: "text-(--components-icon-shape-text-iconshape-disabled-text)"
      },
      gradient: { icon: "text-(--components-icon-shape-icon-iconshape-white-icon)", text: "text-(--components-icon-shape-text-iconshape-white-default-text)" },
      "sunny-gradient": {
        icon: "text-(--components-icon-shape-icon-iconshape-accent-gradient-icon)",
        text: "text-(--components-icon-shape-text-iconshape-accent-gradient-text)"
      }
    }, s = {
      ...i,
      red: { icon: "text-(--components-icon-shape-icon-iconshape-red-icon)" },
      orange: { icon: "text-(--components-icon-shape-icon-iconshape-orange-icon)" },
      yellow: { icon: "text-(--components-icon-shape-icon-iconshape-yellow-icon)" },
      green: { icon: "text-(--components-icon-shape-icon-iconshape-green-icon)" },
      purple: { icon: "text-(--components-icon-shape-icon-iconshape-purple-icon)" },
      violet: { icon: "text-(--components-icon-shape-icon-iconshape-violet-icon)" },
      indigo: { icon: "text-(--components-icon-shape-icon-iconshape-indigo-icon)" },
      white: { icon: "text-(--components-icon-shape-icon-iconshape-black-icon)" },
      default: { icon: "text-(--components-icon-shape-icon-iconshape-default-icon)", text: "text-(--components-icon-shape-text-iconshape-default-text)" },
      success: { border: "border-(--components-icon-shape-border-iconshape-success-border)", icon: "text-(--components-icon-shape-icon-iconshape-success-icon)" },
      error: { border: "border-(--components-icon-shape-border-iconshape-error-border)", icon: "text-(--components-icon-shape-icon-iconshape-error-icon)" },
      text: { icon: "text-(--components-icon-shape-text-iconshape-black-default-text)", text: "text-(--components-icon-shape-text-iconshape-black-default-text)" },
      disabled: {
        border: "border-(--components-icon-shape-border-iconshape-disabled-border)",
        icon: "text-(--components-icon-shape-icon-iconshape-disabled-strong-icon)",
        text: "text-(--components-icon-shape-text-iconshape-disabled-text)"
      },
      gradient: { icon: "text-(--components-icon-shape-icon-iconshape-brand-icon)", text: "text-(--components-icon-shape-text-iconshape-black-default-text)" }
    }, d = p(
      () => n.color === "white" || n.variant === "outlined" && n.color !== "dark"
    ), u = p(() => (d.value ? s : i)[n.color]), f = p(() => !n.icon && n.label !== void 0), b = p(() => !!n.icon && Fl(n.icon)), h = p(() => {
      if (n.color === "gradient") return "var(--gradient-brand-border)";
      if (n.color === "sunny-gradient" && d.value) return "var(--gradient-sunny)";
    }), m = p(() => {
      if (h.value) {
        const y = d.value ? "var(--components-icon-shape-background-iconshape-white-bg)" : "var(--components-icon-shape-background-iconshape-black-default-bg)";
        return { backgroundImage: `linear-gradient(${y}, ${y}), ${h.value}` };
      }
      if (n.color === "sunny-gradient") return { backgroundImage: "var(--gradient-sunny)" };
    }), x = p(() => {
      const y = u.value;
      return [
        t[n.size],
        n.type === "circle" ? "rounded-(--border-border-radius-rounded-full)" : a[n.size],
        "border-solid",
        l[n.size],
        h.value ? "icon-shape-gradient-ring border-transparent" : y.border ?? "border-(--components-icon-shape-border-iconshape-default-border)",
        h.value || n.color === "sunny-gradient" ? void 0 : y.bg ?? "bg-(--components-icon-shape-background-iconshape-white-bg)",
        f.value && y.text ? y.text : y.icon
      ];
    });
    return (y, w) => (c(), K(dt(e.as), {
      class: C(["flex shrink-0 items-center justify-center", x.value]),
      style: Ne(m.value),
      "aria-hidden": "true",
      "data-testid": "icon-shape"
    }, {
      default: ve(() => [
        b.value ? (c(), g("i", {
          key: 0,
          class: C([e.icon, r[e.size], "leading-none"])
        }, null, 2)) : e.icon ? (c(), g("span", {
          key: 1,
          class: C([r[e.size], "leading-none", e.color === "disabled" && "opacity-50"])
        }, P(e.icon), 3)) : e.label !== void 0 ? (c(), g("span", {
          key: 2,
          class: C(["font-inter whitespace-nowrap", o[e.size]])
        }, P(e.label), 3)) : k("", !0)
      ]),
      _: 1
    }, 8, ["class", "style"]));
  }
}), Xt = /* @__PURE__ */ lt(Q0, [["__scopeId", "data-v-3fd4680f"]]), Mu = Symbol("CheckboxGroupErrorId");
function eg(e) {
  const n = Ft(Mu, void 0);
  return p(() => {
    const t = [...e(), n == null ? void 0 : n.value].filter(Boolean);
    return t.length > 0 ? t.join(" ") : void 0;
  });
}
function _0() {
  nn(Mu, p(() => {
  }));
}
const ks = "opal:checked-resync";
function ey(e) {
  if (e.type !== "radio" || e.name === "") return [e];
  const n = e.getRootNode();
  return Array.from(n.querySelectorAll('input[type="radio"]')).filter(
    (t) => t.name === e.name && t.form === e.form
  );
}
function Ki(e, n, t = () => !1) {
  const a = () => {
    e.value && (e.value.checked = n(), e.value.indeterminate = t());
  };
  Ie(
    e,
    (r, o, i) => {
      r && (r.addEventListener(ks, a), i(() => r.removeEventListener(ks, a)));
    },
    { immediate: !0, flush: "post" }
  );
  function l() {
    const r = e.value;
    r && qe(() => {
      for (const o of ey(r)) o.dispatchEvent(new Event(ks));
    });
  }
  return { resync: l };
}
const tg = "mb-2 text-(length:--size-m) leading-(--line-height-l) font-(--weight-medium) text-(--text-text-heading) dark:text-(--colors-text-white-default)", ng = "flex items-center gap-1 text-(length:--size-sm) leading-(--line-height-m) text-(--text-text-error-strong) dark:text-(--text-text-error)", ag = "ri-error-warning-fill text-(--text-text-error-strong) dark:text-(--text-text-error)", ty = ["id", "name", "checked", "disabled", "indeterminate", "value", "aria-label", "aria-labelledby", "aria-describedby", "aria-invalid"], ny = ["for"], ay = ["for"], ly = {
  key: 0,
  class: "absolute left-1/2 top-1/2 size-6 -translate-x-1/2 -translate-y-1/2",
  "data-testid": "checkbox-hit-area"
}, ry = ["for"], oy = ["for"], iy = ["id"], Cn = /* @__PURE__ */ ye({
  __name: "Checkbox",
  props: {
    label: { default: void 0 },
    modelValue: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    indeterminate: { type: Boolean, default: !1 },
    labelPosition: { default: "right" },
    variant: { default: "default" },
    labelWrap: { type: Boolean, default: !1 },
    name: { default: void 0 },
    id: { default: void 0 },
    value: { type: [String, Number, Boolean], default: void 0 },
    ariaLabel: { default: void 0 },
    ariaLabelledby: { default: void 0 },
    ariaDescribedby: { default: void 0 },
    error: { default: void 0 },
    presentational: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue", "change"],
  setup(e, { emit: n }) {
    const t = e, a = Ve(), l = p(() => t.id ?? a), r = p(() => `${l.value}-error`), o = p(() => !!t.error && !t.presentational), i = p(() => t.presentational ? "span" : "div"), s = eg(() => [
      t.ariaDescribedby,
      o.value ? r.value : void 0
    ]), d = n, u = E(null), { resync: f } = Ki(
      u,
      () => t.modelValue,
      () => t.indeterminate
    ), b = p(() => t.modelValue || t.indeterminate), h = p(
      () => !t.presentational && !!t.label && (t.labelPosition === "left" || t.labelPosition === "right")
    ), m = p(() => {
      const L = "relative size-4 shrink-0 box-border flex items-center justify-center rounded-(--border-border-radius-rounded-xs) border border-solid transition-all duration-200 motion-reduce:transition-none peer-focus-visible:shadow-(--shadow-focus-l) peer-focus-visible:outline-2 peer-focus-visible:outline-transparent" + (h.value ? " mt-0.5" : ""), A = b.value ? "" : " peer-focus-visible:border-(--border-border-hover)";
      if (t.disabled)
        return `${L} bg-(--background-background-disabled-strong) border-(--border-border-disabled) cursor-not-allowed`;
      if (t.variant === "dark") {
        const R = b.value ? "bg-(--background-background-black-default)" : "bg-transparent";
        return `${L} ${R} border-(--border-border-white-full) cursor-pointer${A}`;
      }
      return b.value ? t.variant === "light" ? `${L} bg-(--background-background-white) dark:bg-(--background-background-black-default) border-(--border-border-white-default) dark:border-(--border-border-base) cursor-pointer` : `${L} bg-(--background-background-black-default) border-(--border-border-base) cursor-pointer` : `${L} bg-(--background-background-white) dark:bg-(--background-background-black-default) border-(--border-border-base-medium) cursor-pointer${A}`;
    }), x = p(() => {
      const T = `${t.indeterminate ? "ri-subtract-fill" : "ri-check-fill"} text-(length:--size-l) leading-none forced-colors:forced-color-adjust-none`;
      return t.disabled ? `${T} text-(--icons-icon-disabled-strong) forced-colors:text-[GrayText]` : t.variant === "light" ? `${T} text-(--icons-icon-black) dark:text-(--icons-icon-white-default) forced-colors:text-[CanvasText]` : `${T} text-(--icons-icon-white-default) forced-colors:text-[CanvasText]`;
    }), y = p(() => {
      let T = "relative flex text-left font-inter text-(length:--size-m) leading-(--line-height-l) font-(--weight-medium) select-none";
      return t.labelPosition === "top" || t.labelPosition === "bottom" ? T += " flex-col items-center gap-2 w-auto" : T += h.value ? " flex-row items-start gap-2 w-full min-w-0" : " flex-row items-center gap-2 w-full min-w-0", h.value && (T += " min-h-6 px-px py-0.5"), o.value && (T += " flex-wrap"), t.presentational && (T += " pointer-events-none"), t.disabled ? `${T} text-(--text-text-disabled-strong) dark:text-(--colors-text-disabled)` : t.variant === "dark" ? `${T} text-(--text-text-white-default)` : `${T} text-(--text-text-heading) dark:text-(--text-text-white-default)`;
    }), w = p(() => {
      const T = "relative cursor-pointer flex-1 min-w-0";
      return t.labelWrap ? `${T} break-words` : T;
    }), S = (T) => {
      if (T.preventDefault(), T.stopPropagation(), t.disabled) return;
      const L = !t.modelValue;
      d("update:modelValue", L), d("change", T);
    }, $ = (T) => {
      if (t.disabled) return;
      const L = T.target;
      d("update:modelValue", L.checked), d("change", T), f();
    };
    return (T, L) => (c(), K(dt(i.value), Oe({
      class: y.value,
      "data-testid": "checkbox-container"
    }, Rl(e.presentational ? {} : { click: S })), {
      default: ve(() => [
        e.presentational ? k("", !0) : (c(), g("input", {
          key: 0,
          id: l.value,
          ref_key: "inputRef",
          ref: u,
          name: e.name,
          type: "checkbox",
          checked: e.modelValue,
          disabled: e.disabled,
          indeterminate: e.indeterminate || void 0,
          value: e.value,
          "aria-label": e.ariaLabel,
          "aria-labelledby": e.ariaLabelledby,
          "aria-describedby": I(s),
          "aria-invalid": o.value ? "true" : void 0,
          class: "peer sr-only pointer-events-none",
          onChange: $,
          onClick: L[0] || (L[0] = Ue(() => {
          }, ["stop"]))
        }, null, 40, ty)),
        e.label && e.labelPosition === "top" ? (c(), g("label", {
          key: 1,
          for: l.value,
          class: "relative cursor-pointer text-center"
        }, P(e.label), 9, ny)) : k("", !0),
        e.label && e.labelPosition === "left" ? (c(), g("label", {
          key: 2,
          for: l.value,
          class: C(w.value)
        }, [
          e.labelWrap ? (c(), g(se, { key: 0 }, [
            at(P(e.label), 1)
          ], 64)) : (c(), K(bt, {
            key: 1,
            text: e.label,
            focusable: !1
          }, null, 8, ["text"]))
        ], 10, ay)) : k("", !0),
        (c(), K(dt(i.value), {
          class: C(m.value),
          "data-testid": "checkbox-box",
          "aria-hidden": "true"
        }, {
          default: ve(() => [
            e.presentational ? k("", !0) : (c(), g("span", ly)),
            e.indeterminate || e.modelValue ? (c(), g("i", {
              key: 1,
              class: C(x.value),
              "aria-hidden": "true"
            }, null, 2)) : k("", !0)
          ]),
          _: 1
        }, 8, ["class"])),
        e.label && e.labelPosition === "right" ? (c(), g("label", {
          key: 3,
          for: l.value,
          class: C(w.value)
        }, [
          e.labelWrap ? (c(), g(se, { key: 0 }, [
            at(P(e.label), 1)
          ], 64)) : (c(), K(bt, {
            key: 1,
            text: e.label,
            focusable: !1
          }, null, 8, ["text"]))
        ], 10, ry)) : k("", !0),
        e.label && e.labelPosition === "bottom" ? (c(), g("label", {
          key: 4,
          for: l.value,
          class: "relative cursor-pointer text-center"
        }, P(e.label), 9, oy)) : k("", !0),
        o.value ? (c(), g("div", {
          key: 5,
          id: r.value,
          "data-testid": "checkbox-error",
          class: C(["basis-full self-stretch", I(ng)]),
          role: "alert",
          onClick: L[1] || (L[1] = Ue(() => {
          }, ["stop"]))
        }, [
          v("i", {
            class: C(I(ag)),
            "aria-hidden": "true"
          }, null, 2),
          v("span", null, P(e.error), 1)
        ], 10, iy)) : k("", !0)
      ]),
      _: 1
    }, 16, ["class"]));
  }
}), sy = {
  key: 0,
  class: "absolute left-5 top-1/2 z-[1] flex -translate-y-1/2"
}, dy = ["id", "aria-expanded", "aria-controls", "aria-pressed", "aria-disabled", "disabled"], uy = {
  key: 0,
  class: "flex-shrink-0",
  "aria-hidden": "true"
}, cy = {
  key: 1,
  class: "flex flex-1 min-w-0 items-center gap-2"
}, fy = {
  key: 0,
  class: "flex shrink-0",
  "aria-hidden": "true"
}, hy = {
  key: 4,
  class: "flex shrink-0",
  "aria-hidden": "true"
}, by = ["id"], gy = {
  key: 0,
  class: "sr-only"
}, py = {
  key: 0,
  class: "flex max-w-full shrink-0 flex-wrap items-center gap-1",
  "data-testid": "accordion-item-badges"
}, my = ["id", "aria-labelledby", "aria-hidden", "inert"], vy = { class: "accordion-content-inner" }, xy = /* @__PURE__ */ ye({
  __name: "AccordionItem",
  props: {
    title: {},
    subtitle: { default: void 0 },
    icon: { default: void 0 },
    disabled: { type: Boolean, default: !1 },
    defaultOpen: { type: Boolean, default: !1 },
    type: { default: "default" },
    badgeLabel: { default: void 0 },
    badgeTheme: { default: "active" },
    expandable: { type: Boolean, default: !0 },
    selected: { type: Boolean, default: !1 },
    open: { type: Boolean, default: void 0 },
    size: { default: void 0 },
    headingLevel: { default: void 0 },
    avatarSrc: { default: void 0 },
    avatarAlt: { default: void 0 },
    completed: { type: Boolean, default: !1 },
    completedLabel: { default: void 0 },
    badges: { default: () => [] },
    maxBadges: { default: 3 },
    selectable: { type: Boolean, default: !1 },
    checked: { type: Boolean, default: !1 }
  },
  emits: ["toggle", "select", "update:open", "update:checked"],
  setup(e, { emit: n }) {
    var ne;
    const t = e, a = n, l = {
      variant: E("default"),
      size: E("md"),
      headingLevel: E(3),
      isChildLevel: E(!1),
      openItems: /* @__PURE__ */ new Set(),
      toggleItem: () => {
      },
      openItem: () => {
      }
    }, r = Ft(Pb, l), o = Ve(), i = p(() => t.headingLevel ?? r.headingLevel.value), s = E(0);
    nn(Fb, {
      variant: r.variant,
      headingLevel: i,
      size: p(() => T.value),
      registerChildAccordion: () => (s.value++, () => s.value--)
    });
    const d = r === l, {
      triggerId: u,
      panelId: f,
      isOpen: b,
      isControlled: h,
      onTransitionEnd: m,
      panelClasses: x,
      toggle: y
    } = Vb({
      id: o,
      open: () => t.open,
      defaultOpen: () => t.defaultOpen && t.expandable,
      onOpenChange: (le) => {
        h.value && a("update:open", le);
      },
      store: d ? void 0 : {
        isOpen: () => r.openItems.has(o),
        toggle: () => r.toggleItem(o),
        open: () => r.openItem(o)
      }
    }), w = () => {
      if (!t.disabled) {
        if (!A.value) {
          a("select");
          return;
        }
        a("toggle", y());
      }
    }, S = (le) => {
      var he, De, Ee, je;
      if (!A.value && ["Enter", " "].includes(le.key)) {
        le.preventDefault(), w();
        return;
      }
      if (!["ArrowUp", "ArrowDown", "Home", "End"].includes(le.key)) return;
      const Le = le.currentTarget, Te = Le.closest("[data-accordion-root]");
      if (!Te) return;
      const xe = Array.from(
        Te.querySelectorAll(
          '[data-testid="accordion-item-trigger"]:not([disabled])'
        )
      ).filter((Ge) => {
        if (Ge.closest("[data-accordion-root]") !== Te) return !1;
        const Qe = Ge.closest('[inert], [aria-hidden="true"]');
        return !Qe || !Te.contains(Qe);
      }), we = xe.indexOf(Le);
      switch (le.preventDefault(), le.key) {
        case "ArrowDown":
          (he = xe[(we + 1) % xe.length]) == null || he.focus();
          break;
        case "ArrowUp":
          (De = xe[(we - 1 + xe.length) % xe.length]) == null || De.focus();
          break;
        case "Home":
          (Ee = xe[0]) == null || Ee.focus();
          break;
        case "End":
          (je = xe[xe.length - 1]) == null || je.focus();
          break;
      }
    }, $ = r.variant, T = p(() => t.size ?? r.size.value), L = p(() => t.type === "time-slot"), A = p(() => t.expandable), R = p(() => r.isChildLevel.value), z = p(() => $.value === "flush"), D = p(() => $.value === "with-sub-header"), V = p(() => !!(t.avatarSrc || t.avatarAlt)), Y = p(() => t.completed && D.value), _ = p(() => t.selectable && !L.value && !R.value), j = p(() => `${o}-title`);
    typeof process < "u" && ((ne = process.env) == null ? void 0 : ne.NODE_ENV) !== "production" && Ie(
      () => [Y.value, t.completedLabel],
      ([le, Le]) => {
        le && !(Le != null && Le.trim()) && console.warn("[OPAL AccordionItem] `completed` is set without `completedLabel`: the done state is visual only (WCAG 1.1.1 / 1.3.1).");
      },
      { immediate: !0 }
    );
    const W = p(() => L.value ? "div" : `h${i.value}`), G = p(() => L.value ? [`[&:not(:last-child)]:mb-4 ${ae.value ? "overflow-visible" : "overflow-hidden"} rounded-xl`, Z.value].join(" ") : $.value === "separate-cards" ? "border border-(--colors-border-base-soft) rounded-(--border-border-radius-rounded-l) overflow-hidden shadow-(--blur-shadow-sm)" : z.value ? A.value && b.value ? "last:[&>.accordion-content>*>*]:border-b-0" : `last:[&>*>*>button]:border-b-0 ${X.value.restoreLast}` : R.value ? "" : [
      `[&:not(:first-child)>*>*>button]:border-t [&:not(:first-child)>*>*>button]:border-solid [&:not(:first-child)>*>*>button]:border-(--colors-border-base-soft) ${X.value.nonFirst}`,
      "first:[&>*>*>button]:rounded-t-(--border-border-radius-rounded-l)",
      A.value && b.value ? "" : "last:[&>*>*>button]:rounded-b-(--border-border-radius-rounded-l)"
    ].join(" ").trim()), B = p(() => L.value ? A.value && b.value ? "rounded-t-xl" : "rounded-xl" : $.value === "separate-cards" ? A.value && b.value ? "rounded-t-(--border-border-radius-rounded-l)" : "rounded-(--border-border-radius-rounded-l)" : ""), F = {
      1: {
        both: "py-1",
        lessBottom: "pt-1 pb-[calc(var(--spacing-1)-1px)]",
        restoreLast: "last:[&>*>*>button]:pb-1",
        nonFirst: "[&:not(:first-child)>*>*>button]:pt-[calc(var(--spacing-1)-1px)]"
      },
      3: {
        both: "py-3",
        lessBottom: "pt-3 pb-[calc(var(--spacing-3)-1px)]",
        restoreLast: "last:[&>*>*>button]:pb-3",
        nonFirst: "[&:not(:first-child)>*>*>button]:pt-[calc(var(--spacing-3)-1px)]"
      },
      5: {
        both: "py-5",
        lessBottom: "pt-5 pb-[calc(var(--spacing-5)-1px)]",
        restoreLast: "last:[&>*>*>button]:pb-5",
        nonFirst: "[&:not(:first-child)>*>*>button]:pt-[calc(var(--spacing-5)-1px)]"
      }
    }, X = p(
      () => F[T.value === "sm" ? 1 : D.value || V.value || _.value ? 5 : 3]
    ), H = p(() => {
      if (L.value) return "p-3";
      if (R.value) return "pt-[calc(var(--spacing-5)-1px)] pr-6 pb-5 pl-12";
      const le = z.value ? X.value.lessBottom : X.value.both, Le = _.value ? "pr-5 pl-[calc(var(--spacing-5)_+_var(--spacing-4)_+_var(--spacing-6))]" : "px-5";
      return `${le} ${Le}`;
    }), q = p(() => L.value ? "gap-2.5" : D.value ? "gap-3.5" : "gap-6"), N = p(() => [
      q.value,
      "@max-[40rem]/row:flex-col @max-[40rem]/row:items-stretch @max-[40rem]/row:gap-2"
    ]), J = p(() => L.value || $.value === "separate-cards" ? "" : z.value ? "border-b border-solid border-(--colors-border-base-soft)" : R.value ? "border-t border-solid border-(--colors-border-base-soft)" : ""), be = p(() => L.value ? "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-(--border-border-info-strong)" : "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-(--border-border-accent)"), ke = p(() => L.value ? t.disabled ? "cursor-not-allowed" : "cursor-pointer" : z.value ? t.disabled ? "cursor-not-allowed opacity-60" : "cursor-pointer" : t.disabled ? "cursor-not-allowed opacity-60 bg-(--background-background-white)" : [
      "cursor-pointer",
      b.value ? "bg-(--colors-background-selected)" : `bg-(--background-background-white) ${_.value ? "group-hover/header:" : "hover:"}bg-(--colors-background-hover)`
    ].join(" ")), ee = p(() => z.value && !t.disabled && !b.value), oe = p(() => ee.value ? "group-hover/trigger:text-(--text-text-hover)" : ""), ge = p(() => [
      "text-(--icons-icon-dark-default)",
      ee.value ? "group-hover/trigger:text-(--icons-icon-hover)" : ""
    ]), re = p(() => [
      "text-(length:--size-l) leading-(--line-height-xxl) text-(--colors-text-heading)",
      R.value ? "font-(--weight-medium)" : "font-(--weight-bold)",
      oe.value
    ]), ue = p(() => [
      "text-(length:--size-m) leading-(--line-height-l) font-(--weight-medium) text-(--colors-text-body)",
      oe.value
    ]), O = p(() => T.value === "sm" ? "sm" : "md"), U = p(() => $.value !== "separate-cards" || R.value ? "text-(length:--icon-size-lg)" : T.value === "sm" ? "text-(length:--icon-size-sm)" : "text-(length:--icon-size-md)"), Q = p(
      () => _b(t.badges, t.maxBadges).map((le) => ({
        ...le,
        theme: le.theme ?? "gradient-light"
      }))
    ), ae = p(() => !t.disabled && A.value && b.value), Z = p(() => L.value ? t.disabled || !A.value && t.selected ? "border border-(--border-border-base-medium)" : ae.value ? "relative border border-transparent accordion-time-slot-gradient-border" : "border border-(--border-border-info) hover:border-(--border-border-info-strong)" : ""), ie = p(() => L.value ? t.disabled ? "bg-(--background-background-disabled-subtle)" : !A.value && t.selected ? "bg-(--components-badge-background-badge-indigo-strong-bg)" : "bg-(--background-background-info)" : ""), fe = p(() => L.value ? t.disabled ? "font-medium text-(--text-text-disabled-strong) line-through" : !A.value && t.selected ? "font-bold text-(--colors-text-white-default)" : "font-medium text-(--text-text-link)" : ""), de = p(() => L.value ? "flex flex-col gap-1 px-2 py-1.5 rounded-b-xl bg-(--background-background-white) dark:bg-(--colors-background-black-default)" : $.value === "multi-level" && !R.value && s.value > 0 ? "flex flex-col" : [
      "flex flex-col gap-3 bg-(--background-background-white) dark:bg-(--colors-background-black-default) border-(--colors-border-base-soft)",
      z.value ? "border-b" : "border-t",
      T.value === "sm" ? "py-3 px-5" : "p-5"
    ].join(" "));
    return (le, Le) => (c(), g("div", {
      class: C(G.value),
      "data-accordion-item": "",
      "data-testid": "accordion-item"
    }, [
      v("div", {
        class: C(L.value ? "contents" : ["relative group/header", Q.value.length ? "@container/row" : ""]),
        "data-testid": "accordion-item-header"
      }, [
        _.value ? (c(), g("div", sy, [
          te(Cn, {
            "model-value": e.checked,
            disabled: e.disabled,
            "aria-labelledby": j.value,
            "data-testid": "accordion-item-checkbox",
            "onUpdate:modelValue": Le[0] || (Le[0] = (Te) => a("update:checked", Te))
          }, null, 8, ["model-value", "disabled", "aria-labelledby"])
        ])) : k("", !0),
        (c(), K(dt(W.value), {
          class: C(L.value ? "contents" : "m-0")
        }, {
          default: ve(() => [
            v("button", {
              id: L.value ? void 0 : I(u),
              type: "button",
              class: C(["flex w-full items-center text-left transition-colors", [
                B.value,
                q.value,
                J.value,
                H.value,
                ke.value,
                ie.value,
                be.value,
                L.value ? "" : "group/trigger",
                L.value && !A.value ? "justify-center" : ""
              ]]),
              "aria-expanded": A.value ? I(b) : void 0,
              "aria-controls": A.value ? I(f) : void 0,
              "aria-pressed": L.value && !A.value ? e.selected : void 0,
              "aria-disabled": L.value && e.disabled ? "true" : void 0,
              disabled: L.value ? !1 : e.disabled,
              "data-testid": "accordion-item-trigger",
              onClick: w,
              onKeydown: S
            }, [
              L.value ? (c(), g(se, { key: 0 }, [
                e.icon && A.value ? (c(), g("div", uy, [
                  v("i", {
                    class: C([
                      e.icon,
                      "text-[16px]",
                      e.disabled ? "text-(--text-text-disabled-strong)" : "text-(--text-text-link)"
                    ])
                  }, null, 2)
                ])) : k("", !0),
                v("div", {
                  class: C(["flex flex-1 min-w-0 flex-wrap items-center gap-2", A.value ? "" : "justify-center"]),
                  "data-testid": "accordion-item-time-wrapper"
                }, [
                  v("span", {
                    "data-testid": "accordion-item-time",
                    class: C(["text-base leading-6", fe.value])
                  }, P(e.title), 3),
                  e.badgeLabel && A.value ? (c(), K(ct, {
                    key: 0,
                    "data-testid": "accordion-item-badge",
                    label: e.badgeLabel,
                    theme: e.disabled ? "disabled" : e.badgeTheme,
                    size: "sm",
                    "show-left-icon": !1,
                    "show-close-icon": !1
                  }, null, 8, ["label", "theme"])) : k("", !0)
                ], 2)
              ], 64)) : (c(), g("span", cy, [
                R.value && A.value ? (c(), g("span", fy, [
                  v("i", {
                    class: C(["ri-arrow-down-s-line text-(length:--icon-size-lg) leading-none transition-transform duration-300 ease-in-out motion-reduce:transition-none", [ge.value, I(b) ? "rotate-180" : ""]])
                  }, null, 2)
                ])) : V.value ? (c(), K(Kt, {
                  key: 1,
                  as: "span",
                  img: e.avatarSrc,
                  name: e.avatarAlt || e.title,
                  presentational: !e.avatarAlt,
                  size: T.value === "sm" ? "sm" : "md"
                }, null, 8, ["img", "name", "presentational", "size"])) : Y.value ? (c(), K(Xt, {
                  key: 2,
                  as: "span",
                  color: "success",
                  variant: "filled",
                  type: "circle",
                  icon: "ri-check-fill",
                  size: O.value
                }, null, 8, ["size"])) : D.value && e.icon ? (c(), K(Xt, {
                  key: 3,
                  as: "span",
                  color: "white",
                  variant: "outlined",
                  type: "circle",
                  icon: e.icon,
                  size: O.value
                }, null, 8, ["icon", "size"])) : e.icon && !R.value ? (c(), g("span", hy, [
                  v("i", {
                    class: C([e.icon, "text-(length:--icon-size-md) leading-none", ge.value])
                  }, null, 2)
                ])) : k("", !0),
                v("span", {
                  class: C(["flex min-w-0 flex-1 items-center", N.value])
                }, [
                  v("span", {
                    class: C(["flex min-w-0 flex-1 flex-col", D.value || V.value ? "gap-px" : ""])
                  }, [
                    v("span", {
                      id: j.value,
                      class: C(re.value),
                      "data-testid": "accordion-item-title"
                    }, [
                      at(P(e.title), 1),
                      Y.value && e.completedLabel ? (c(), g("span", gy, ", " + P(e.completedLabel), 1)) : k("", !0)
                    ], 10, by),
                    e.subtitle ? (c(), g("span", {
                      key: 0,
                      class: C(ue.value),
                      "data-testid": "accordion-item-subtitle"
                    }, P(e.subtitle), 3)) : k("", !0)
                  ], 2),
                  Q.value.length ? (c(), g("span", py, [
                    (c(!0), g(se, null, Me(Q.value, (Te, xe) => (c(), K(ct, {
                      key: xe,
                      label: Te.label,
                      theme: Te.theme,
                      size: "xs",
                      truncate: Te.truncate ?? !1,
                      "truncation-focusable": !1,
                      "show-left-icon": !1,
                      "show-close-icon": !1
                    }, null, 8, ["label", "theme", "truncate"]))), 128))
                  ])) : k("", !0)
                ], 2)
              ])),
              A.value && !R.value ? (c(), K(dt(L.value ? "div" : "span"), {
                key: 2,
                class: C(L.value ? "flex-shrink-0 ml-auto" : "flex shrink-0 ml-auto"),
                "aria-hidden": "true"
              }, {
                default: ve(() => [
                  L.value ? (c(), g("i", {
                    key: 0,
                    class: C(["ri-arrow-down-s-line text-2xl transition-transform duration-300", [
                      e.disabled ? "text-(--text-text-disabled-strong)" : "text-(--text-text-link)",
                      I(b) ? "rotate-180" : ""
                    ]])
                  }, null, 2)) : (c(), g("i", {
                    key: 1,
                    class: C(["ri-arrow-down-s-line block leading-none transition-transform duration-300 ease-in-out motion-reduce:transition-none", [U.value, ge.value, I(b) ? "rotate-180" : ""]])
                  }, null, 2))
                ]),
                _: 1
              }, 8, ["class"])) : k("", !0)
            ], 42, dy)
          ]),
          _: 1
        }, 8, ["class"]))
      ], 2),
      A.value ? (c(), g("div", {
        key: 0,
        id: I(f),
        class: C(I(x)),
        role: "region",
        "aria-labelledby": L.value ? void 0 : I(u),
        "aria-hidden": !I(b),
        inert: !I(b) || void 0,
        onTransitionend: Le[1] || (Le[1] = //@ts-ignore
        (...Te) => I(m) && I(m)(...Te))
      }, [
        v("div", vy, [
          v("div", {
            class: C(de.value)
          }, [
            $e(le.$slots, "default", {}, void 0, !0)
          ], 2)
        ])
      ], 42, my)) : k("", !0)
    ], 2));
  }
}), SW = /* @__PURE__ */ lt(xy, [["__scopeId", "data-v-51731afc"]]);
function yy(e, n) {
  return `${e}-tab-${String(n).replace(/\s+/g, "-")}`;
}
const lg = Symbol("ButtonGroupContext"), ws = "bg-(--components-button-button-disabled) border-(--border-border-disabled) text-(--text-text-disabled-strong)", wl = "border-transparent text-(--text-text-disabled-strong) dark:text-(--components-button-button-disabled)", ky = "border-transparent [background:var(--btn-fill-image,linear-gradient(var(--btn-fill),var(--btn-fill)))_padding-box,linear-gradient(var(--btn-stroke),var(--btn-stroke))_border-box]", of = "border-(--border-border-disabled) text-(--text-text-disabled-strong) dark:text-(--components-button-button-disabled)", sf = "before:-inset-px before:[background:linear-gradient(var(--btn-ring-angle,85deg),var(--gradient-brand-start)_10.83%,var(--gradient-brand-end)_86.95%)] after:bg-(--background-background-white)", wy = {
  tertiary: { label: "[--btn-ring-angle:69deg]", iconOnly: "[--btn-ring-angle:85deg]" },
  tab: { label: "[--btn-ring-angle:72deg]", iconOnly: "[--btn-ring-angle:85deg]" }
}, df = "focus-visible:overflow-visible focus-visible:border-transparent focus-visible:before:opacity-100 focus-visible:after:opacity-100", Cy = {
  primary: {
    shape: `rounded-full ${ky}`,
    rest: "[--btn-fill:var(--components-button-primary-button-primary)] [--btn-stroke:var(--border-border-primary-button)] text-(--text-text-white-secondary) dark:text-(--text-text-white-default)",
    interactive: "hover:[--btn-fill-image:var(--gradient-button-primary-hover)] hover:[--btn-stroke:var(--border-border-primary-button-hover)] focus-visible:[--btn-stroke:var(--border-border-accent)]",
    labelInteractive: "dark:hover:[--btn-fill-image:linear-gradient(90deg,_var(--text-text-white-default),_var(--colors-indigo-100))] dark:hover:text-(--text-text-black-default)",
    disabled: "[--btn-fill:var(--components-button-button-disabled)] [--btn-stroke:var(--border-border-disabled)] text-(--text-text-disabled-strong)",
    icon: "text-(--icons-icon-white-default)",
    iconInteractive: ""
  },
  // Figma fades the Secondary hover in (Dissolve), hence the `before` layer.
  secondary: {
    shape: "rounded-full before:inset-0 before:[background:var(--gradient-button-secondary-hover)]",
    rest: "bg-(--components-button-secondary-button-secondary) border-(--border-border-secondary-button) text-(--text-text-black-default)",
    interactive: "hover:border-(--border-border-secondary-button-hover) hover:before:opacity-100 dark:hover:bg-(--components-button-secondary-button-secondary-hover) dark:hover:text-(--text-text-white-secondary) focus-visible:text-(--text-text-accent) focus-visible:border-(--border-border-accent)",
    disabled: ws,
    icon: "text-(--icons-icon-dark-default)",
    iconInteractive: "group-focus-visible/button:text-(--icons-icon-accent)"
  },
  // background-hover has no dark value; the Tertiary hover token carries the dark one.
  tertiary: {
    shape: `${sf} after:inset-[calc(var(--border-border-width-border-sm)-1px)] dark:after:bg-(--components-button-tertiary-button-tertiary-focused)`,
    rest: "border-transparent text-(--text-text-black-default) dark:text-(--text-text-white-secondary)",
    interactive: `hover:bg-(--background-background-hover) dark:hover:bg-(--components-button-tertiary-button-tertiary-hover) dark:hover:text-(--text-text-black-default) hover:border-(--border-border-tertiary-hover) dark:hover:border-(--components-button-tertiary-button-tertiary-hover) ${df}`,
    disabled: wl,
    icon: "text-(--icons-icon-dark-default)",
    iconInteractive: ""
  },
  ghost: {
    shape: "",
    rest: "bg-transparent border-transparent text-(--text-text-black-default) dark:text-(--text-text-white-default)",
    interactive: "hover:bg-(--components-button-ghost-button-ghost-hover) dark:hover:text-(--text-text-black-default)",
    disabled: wl,
    icon: "text-(--icons-icon-dark-default)",
    iconInteractive: ""
  },
  text: {
    shape: "",
    rest: "bg-transparent border-transparent text-(--components-button-text-button-text) dark:text-(--text-text-white-default)",
    interactive: "hover:text-(--components-button-text-button-text-hover) dark:hover:text-(--text-text-hover)",
    disabled: wl,
    icon: "text-(--icons-icon-dark-default)",
    iconInteractive: "group-hover/button:text-(--icons-icon-hover)"
  },
  // Stroke on top and sides only; the bottom edge joins the content below. Figma rounds Initial to
  // rounded-sm and every other state to rounded-l; OPAL keeps rounded-l in all states so hover doesn't reshape the tab.
  tab: {
    shape: `rounded-t-(--border-border-radius-rounded-l) rounded-b-none border-b-0 before:[clip-path:inset(0_0_1px_0)] dark:after:bg-(--components-button-tab-button-tab-active) after:inset-0 ${sf}`,
    rest: "bg-(--components-button-tab-button-tab-default) border-(--border-border-tab) text-(--text-text-black-default)",
    interactive: `hover:bg-(--components-button-tab-button-tab) hover:border-(--border-border-hover) ${df}`,
    disabled: "bg-(--colors-white-50-opacity-light) dark:bg-(--components-button-button-disabled) border-(--border-border-disabled-subtle) dark:border-(--border-border-disabled) text-(--text-text-disabled-strong)",
    icon: "text-(--icons-icon-dark-default)",
    iconInteractive: ""
  },
  success: {
    shape: "rounded-full",
    rest: "bg-(--components-button-functional-success-button-success) border-transparent text-(--text-text-white-secondary) dark:text-(--text-text-black-default)",
    interactive: "hover:bg-(--components-button-functional-success-button-success-hover) focus-visible:[--btn-fill:var(--components-button-functional-success-button-success-focused)] focus-visible:[--btn-stroke:var(--border-border-success)] dark:focus-visible:[--btn-stroke:var(--colors-border-success-sublte)] focus-visible:[background:linear-gradient(var(--btn-fill),var(--btn-fill))_padding-box,linear-gradient(var(--btn-stroke),var(--btn-stroke))_border-box]",
    disabled: ws,
    icon: "text-(--icons-icon-white-default)",
    iconInteractive: ""
  },
  "success-secondary": {
    shape: "rounded-full",
    rest: "bg-transparent border-(--components-button-functional-success-button-success) text-(--text-text-black-default) dark:text-(--text-text-white-default)",
    interactive: "hover:border-(--components-button-functional-success-button-success-hover) focus-visible:border-(--components-button-functional-success-button-success-focused)",
    disabled: of,
    icon: "text-(--icons-icon-dark-default)",
    iconInteractive: ""
  },
  error: {
    shape: "rounded-full",
    // CONSTRAINT: white-default, not white-secondary like the other filled variants: #f2f0f0 on the
    // error red #d92d20 is 4.26:1 and fails WCAG AA (4.5:1); #fafafa reaches 4.63:1.
    rest: "bg-(--components-button-functional-desctructive-error-background-button-error) border-transparent text-(--text-text-white-default) dark:text-(--text-text-black-default)",
    interactive: "hover:bg-(--components-button-functional-desctructive-error-background-button-error-hover) focus-visible:[--btn-fill:var(--components-button-functional-desctructive-error-background-button-error-focused)] focus-visible:[--btn-stroke:var(--border-border-error)] dark:focus-visible:[--btn-stroke:var(--border-border-error-subtle)] focus-visible:[background:linear-gradient(var(--btn-fill),var(--btn-fill))_padding-box,linear-gradient(var(--btn-stroke),var(--btn-stroke))_border-box]",
    disabled: ws,
    icon: "text-(--icons-icon-white-default)",
    iconInteractive: ""
  },
  "error-secondary": {
    shape: "rounded-full",
    rest: "bg-transparent border-(--components-button-functional-desctructive-error-background-button-error) text-(--text-text-black-default) dark:text-(--text-text-white-default)",
    interactive: "hover:border-(--components-button-functional-desctructive-error-background-button-error-hover) focus-visible:border-(--components-button-functional-desctructive-error-background-button-error-focused)",
    disabled: of,
    icon: "text-(--icons-icon-dark-default)",
    iconInteractive: ""
  },
  // Red at rest; icons follow the text colour through every state.
  "error-text": {
    shape: "",
    rest: "bg-transparent border-transparent text-(--components-button-functional-desctructive-error-background-button-error)",
    interactive: "hover:text-(--components-button-functional-desctructive-error-background-button-error-hover) focus-visible:text-(--components-button-functional-desctructive-error-background-button-error-focused) focus-visible:border-(--components-button-functional-desctructive-error-icons-button-error-focused-icon)",
    iconOnlyInteractive: "hover:bg-(--background-background-error) dark:hover:bg-transparent",
    disabled: wl,
    icon: "",
    iconInteractive: ""
  }
}, Sy = {
  "success-secondary": {
    shape: "rounded-full",
    rest: "bg-transparent border-transparent text-(--text-text-black-default) dark:text-(--text-text-white-default)",
    interactive: "hover:bg-(--background-background-success) dark:hover:bg-transparent",
    disabled: wl,
    icon: "text-(--icons-icon-dark-default)",
    iconInteractive: ""
  },
  "error-secondary": {
    shape: "rounded-full",
    rest: "bg-transparent border-transparent text-(--text-text-black-default) dark:text-(--text-text-white-default)",
    interactive: "hover:bg-(--background-background-error) dark:hover:bg-transparent",
    disabled: wl,
    icon: "text-(--icons-icon-dark-default)",
    iconInteractive: "group-hover/button:text-(--components-button-functional-desctructive-error-icons-button-error-icon)"
  }
}, $y = /* @__PURE__ */ new Set(["primary", "secondary", "ghost"]), Iy = /* @__PURE__ */ new Set(["tertiary", "ghost", "text", "error-text"]);
function rg(e) {
  return Object.fromEntries(Object.entries(e).filter(([n]) => !/^onClick(?:Once|Capture|Passive)*$/.test(n)));
}
const Ty = ["src"], Ly = ["src"], Ey = {
  key: 1,
  class: "relative z-10 min-w-0 whitespace-nowrap *:align-top"
}, Ay = ["src"], Ry = "group/button relative inline-flex max-w-full items-center justify-center gap-1.5 overflow-hidden border border-solid font-inter font-(--weight-medium) transition-colors duration-150 ease-in-out motion-reduce:transition-none focus-visible:outline-hidden before:content-[''] before:absolute before:rounded-[inherit] before:opacity-0 before:transition-opacity before:duration-150 before:z-0 motion-reduce:before:transition-none after:content-[''] after:absolute after:rounded-[inherit] after:opacity-0 after:transition-opacity after:duration-150 after:z-[1] motion-reduce:after:transition-none", By = /* @__PURE__ */ ye({
  inheritAttrs: !1,
  __name: "Button",
  props: {
    as: { default: "button" },
    variant: { default: "primary" },
    outline: { type: Boolean, default: !0 },
    label: { default: "" },
    iconLeft: { default: void 0 },
    iconRight: { default: void 0 },
    dropdownIcon: { type: Boolean, default: !1 },
    size: { default: "md" },
    fullWidth: { type: Boolean, default: !1 },
    shrink: { type: Boolean, default: !1 },
    iconOnly: { type: Boolean, default: !1 },
    ariaLabel: { default: void 0 },
    disabled: { type: Boolean, default: !1 },
    ariaDisabled: { type: Boolean, default: !1 },
    loading: { type: Boolean, default: !1 },
    loadingLabel: { default: void 0 },
    active: { type: Boolean, default: !1 },
    value: { default: void 0 },
    type: { default: "button" }
  },
  emits: ["click"],
  setup(e, { emit: n }) {
    var N;
    const t = e, a = n, l = Fn(), r = Mn(), o = Ft(lg, null), i = E(null), s = p(() => t.value === void 0 || o == null ? void 0 : o.mode.value), d = p(
      () => s.value && t.value !== void 0 ? o.isSelected(t.value) : t.active
    ), u = {
      xs: {
        button: "py-[calc(--spacing(1.5)-1px)] px-[calc(--spacing(3)-1px)] text-(length:--size-sm) leading-(--line-height-l)",
        tabBottom: "pb-1.5",
        iconOnly: "size-8 p-0"
      },
      sm: {
        button: "py-[calc(--spacing(2)-1px)] px-[calc(--spacing(3)-1px)] text-(length:--size-m) leading-(--line-height-l)",
        tabBottom: "pb-2",
        iconOnly: "size-9 p-0"
      },
      md: {
        button: "py-[calc(--spacing(2.5)-1px)] px-[calc(--spacing(4)-1px)] text-(length:--size-m) leading-(--line-height-l)",
        tabBottom: "pb-2.5",
        iconOnly: "size-10 p-0"
      },
      lg: {
        button: "py-[calc(--spacing(3)-1px)] px-[calc(--spacing(5)-1px)] text-(length:--size-l) leading-(--line-height-xxl)",
        tabBottom: "pb-3",
        iconOnly: "size-12 p-0"
      },
      xl: {
        button: "py-[calc(--spacing(3.5)-1px)] px-[calc(--spacing(6)-1px)] text-(length:--size-l) leading-(--line-height-xxl)",
        tabBottom: "pb-3.5",
        iconOnly: "size-13 p-0"
      }
    }, f = { font: "text-(length:--icon-size-xs) leading-(--icon-size-xs)", box: "size-(--icon-size-xs)" }, b = { font: "text-(length:--icon-size-sm) leading-(--icon-size-sm)", box: "size-(--icon-size-sm)" }, h = { font: "text-(length:--icon-size-md) leading-(--icon-size-md)", box: "size-(--icon-size-md)" }, m = { xs: f, sm: b, md: b, lg: b, xl: h }, x = { xs: f, sm: b, md: h, lg: h, xl: h }, y = p(() => (t.iconOnly ? x : m)[t.size]), w = p(
      () => !t.outline && (t.variant === "success-secondary" || t.variant === "error-secondary") ? Sy[t.variant] : Cy[t.variant]
    ), S = p(() => t.disabled && !t.loading && t.as === "button"), $ = p(() => t.disabled || t.ariaDisabled || t.loading), T = p(() => (t.disabled || t.ariaDisabled) && !t.loading), L = p(() => !d.value || T.value ? "" : t.variant === "tertiary" ? "active bg-(--background-background-white) dark:bg-[var(--colors-background-black-default)] overflow-visible before:opacity-100 after:opacity-100" : t.variant === "tab" ? "bg-(--background-background-white) dark:bg-[var(--colors-background-black-default)] border-transparent text-(--text-text-black-default) overflow-visible before:opacity-100 after:opacity-100" : ""), A = p(() => {
      var be;
      const J = u[t.size];
      return [
        Ry,
        w.value.shape,
        (be = wy[t.variant]) == null ? void 0 : be[t.iconOnly ? "iconOnly" : "label"],
        T.value ? ["cursor-not-allowed", w.value.disabled] : t.loading ? ["cursor-progress", !(d.value && t.variant === "tab") && w.value.rest] : [
          "cursor-pointer",
          // An active Tab replaces its rest colours instead of competing with them.
          !(d.value && t.variant === "tab") && w.value.rest,
          w.value.interactive,
          t.iconOnly ? w.value.iconOnlyInteractive : w.value.labelInteractive
        ],
        // The OPAL focus ring on every variant, also while `ariaDisabled`/`loading` keep the button
        // focusable: the Figma focus of Ghost and Text is too faint to see (RGAA 10.7).
        $y.has(t.variant) && !T.value ? "focus-visible:shadow-[var(--shadow-focus-l),var(--shadow-focus-s)]" : "focus-visible:shadow-(--shadow-focus-l)",
        Iy.has(t.variant) && (t.iconOnly ? "rounded-full" : "rounded-(--border-border-radius-rounded-base)"),
        t.iconOnly ? J.iconOnly : J.button,
        t.variant === "tab" && !t.iconOnly && J.tabBottom,
        t.fullWidth && !t.iconOnly && "w-full",
        t.shrink && !t.iconOnly ? "min-w-0" : "shrink-0",
        L.value
      ];
    }), R = p(() => [
      "relative z-10 inline-flex shrink-0 items-center justify-center dark:text-current",
      y.value.font,
      T.value ? "text-(--icons-icon-disabled-strong)" : [w.value.icon, !t.loading && w.value.iconInteractive]
    ]), z = p(() => {
      const J = T.value, be = t.variant === "error" || t.variant === "success" || t.variant === "error-text";
      return [
        "relative z-10 shrink-0",
        y.value.box,
        !J && !be && "dark:invert",
        J && "grayscale opacity-60"
      ];
    });
    function D(J) {
      return !!J && !J.includes("/");
    }
    const V = p(() => t.iconOnly ? `${t.variant}-icon-button` : `${t.variant}-button`);
    function Y() {
      const J = $.value ? rg(l) : l;
      return {
        ...t.as === "button" ? { type: t.type, disabled: S.value || void 0 } : {},
        ...J,
        ...t.ariaLabel ? { "aria-label": t.ariaLabel } : {},
        ...$.value && !S.value ? { "aria-disabled": "true" } : {},
        ..._()
      };
    }
    if (o) {
      const J = o.register({
        value: () => t.value,
        unreachable: () => t.disabled || t.loading,
        blocked: () => $.value,
        el: () => i.value
      });
      ot(o.sort), gt(J);
    }
    function _() {
      if (!s.value || t.value === void 0) return {};
      const J = o.isTabStop(t.value), be = o.panelId();
      return {
        "data-button-group-item": "",
        tabindex: J ? 0 : -1,
        ...s.value === "tabs" ? { role: "tab", "aria-selected": String(d.value) } : { role: "radio", "aria-checked": String(d.value) },
        ...be && {
          id: l.id ?? yy(be, t.value),
          "aria-controls": l["aria-controls"] ?? be
        }
      };
    }
    function j(J) {
      if ($.value) {
        J.preventDefault();
        return;
      }
      s.value && t.value !== void 0 && o.select(t.value), a("click", J);
    }
    const M = E(null), W = E(!1), G = E(!1), B = p(() => G.value ? !1 : W.value ? !0 : void 0);
    function F(J) {
      try {
        W.value = J.target.matches(":focus-visible");
      } catch {
        W.value = !0;
      }
    }
    function X() {
      W.value = !1, G.value = !1;
    }
    Ie(
      () => t.disabled,
      (J) => {
        J && X();
      }
    );
    function H(J) {
      var be;
      s.value && o.onItemKeydown(J), !(J.key !== "Escape" || G.value) && (!W.value || !((be = M.value) != null && be.isTruncated) || (J.stopPropagation(), J.preventDefault(), G.value = !0));
    }
    const q = typeof process < "u" && ((N = process.env) == null ? void 0 : N.NODE_ENV) !== "production";
    return Ie(
      () => t.iconOnly && !t.ariaLabel,
      (J) => {
        q && J && !l["aria-label"] && !l["aria-labelledby"] && console.warn("[OPAL Button] `iconOnly` without `ariaLabel` or `aria-labelledby`: the button has no accessible name (WCAG 1.1.1 / 4.1.2).");
      },
      { immediate: !0 }
    ), (J, be) => (c(), K(dt(e.as), Oe({
      ref_key: "rootRef",
      ref: i,
      "data-testid": V.value
    }, Y(), {
      class: A.value,
      onClick: j,
      onFocus: F,
      onBlur: X,
      onKeydown: H
    }), {
      default: ve(() => [
        e.loading ? (c(), K(Ru, {
          key: 0,
          size: "inherit",
          color: "current",
          label: e.loadingLabel,
          class: C(R.value)
        }, null, 8, ["label", "class"])) : k("", !0),
        !e.loading && e.iconOnly && (e.iconLeft || e.iconRight) ? (c(), g(se, { key: 1 }, [
          D(e.iconLeft || e.iconRight) ? (c(), g("i", {
            key: 0,
            class: C([e.iconLeft || e.iconRight, R.value]),
            "aria-hidden": "true"
          }, null, 2)) : (c(), g("img", {
            key: 1,
            src: e.iconLeft || e.iconRight,
            class: C(z.value),
            alt: ""
          }, null, 10, Ty))
        ], 64)) : k("", !0),
        e.iconOnly ? k("", !0) : (c(), g(se, { key: 2 }, [
          !e.loading && e.iconLeft ? (c(), g(se, { key: 0 }, [
            D(e.iconLeft) ? (c(), g("i", {
              key: 0,
              class: C([e.iconLeft, R.value]),
              "aria-hidden": "true"
            }, null, 2)) : (c(), g("img", {
              key: 1,
              src: e.iconLeft,
              class: C(z.value),
              alt: ""
            }, null, 10, Ly))
          ], 64)) : k("", !0),
          r.default ? (c(), g("span", Ey, [
            $e(J.$slots, "default", {}, void 0, !0)
          ])) : e.label ? (c(), g("span", {
            key: 2,
            class: C(["relative z-10 flex min-w-0", e.variant === "tab" && "max-w-(--tab-label-max-width)"])
          }, [
            te(bt, {
              ref_key: "labelRef",
              ref: M,
              as: "span",
              text: e.label,
              focusable: !1,
              open: B.value
            }, null, 8, ["text", "open"])
          ], 2)) : k("", !0),
          !e.loading && e.iconRight ? (c(), g(se, { key: 3 }, [
            D(e.iconRight) ? (c(), g("i", {
              key: 0,
              class: C([e.iconRight, R.value]),
              "aria-hidden": "true"
            }, null, 2)) : (c(), g("img", {
              key: 1,
              src: e.iconRight,
              class: C(z.value),
              alt: ""
            }, null, 10, Ay))
          ], 64)) : k("", !0),
          e.dropdownIcon ? (c(), g("i", {
            key: 4,
            class: C(["ri-arrow-down-s-line transition-transform duration-200 ease-in-out motion-reduce:transition-none group-aria-expanded/button:rotate-180", R.value]),
            "aria-hidden": "true"
          }, null, 2)) : k("", !0)
        ], 64))
      ]),
      _: 3
    }, 16, ["data-testid", "class"]));
  }
}), Re = /* @__PURE__ */ lt(By, [["__scopeId", "data-v-793b8637"]]), Du = (e, n) => typeof e == "function" ? e(n) : e.replace("{count}", String(n)), Ga = /* @__PURE__ */ ye({
  __name: "ToggleSwitch",
  props: {
    modelValue: { type: Boolean, default: !1 },
    type: { default: "boolean" },
    size: { default: "base" },
    disabled: { type: Boolean, default: !1 },
    ariaDisabled: { type: Boolean, default: !1 },
    presentational: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: n }) {
    const t = e, a = n, l = p(() => t.disabled || t.ariaDisabled), r = p(() => t.size === "lg"), o = p(() => t.type === "default"), i = p(() => o.value ? !t.modelValue : t.modelValue), s = p(() => {
      const m = `relative box-border inline-block ${r.value ? "h-6.5 w-11.5" : "h-5.5 w-9.5"} shrink-0 rounded-(--border-border-radius-rounded-full) border transition-[color,background-color,border-color] duration-100 ease-in-out motion-reduce:transition-none`, x = t.presentational ? "" : " focus-visible:shadow-(--shadow-focus-l) focus-visible:outline-2 focus-visible:outline-transparent";
      if (l.value)
        return `${m}${x} cursor-not-allowed border-(--components-toggle-border-toggle-disabled-border) bg-(--components-toggle-background-toggle-disabled)`;
      const y = t.presentational ? "" : " cursor-pointer";
      return t.modelValue || o.value ? `${m}${x}${y} border-(--components-toggle-border-toggle-active-border) bg-(--components-toggle-background-toggle-active)` : `${m}${x}${y} border-(--components-toggle-border-toggle-unactive-border) bg-(--components-toggle-background-toggle-unactive)`;
    }), d = p(() => {
      const m = `absolute top-0.5 box-border flex ${r.value ? "size-5" : "size-4"} border items-center justify-center rounded-(--border-border-radius-rounded-full) shadow-(--blur-shadow-xs) transition-[inset-inline-start] duration-150 ease-in-out motion-reduce:transition-none`, x = r.value ? "start-5.25" : "start-4.5", y = t.modelValue ? x : "start-0.5";
      return l.value ? `${m} ${y} border-transparent bg-(--components-toggle-background-toggle-disabled-switch)` : o.value ? `${m} ${y} border-transparent bg-(--components-toggle-background-toggle-active-switch)` : t.modelValue ? `${m} ${y} border-transparent bg-(--colors-background-white-secondary-soft)` : `${m} ${y} border-(--components-toggle-border-toggle-unactive-border) bg-(--components-toggle-background-toggle-active-switch)`;
    }), u = p(() => {
      const h = r.value ? "text-(length:--icon-size-md)" : "text-(length:--icon-size-sm)";
      return l.value ? `ri-check-fill ${h} leading-none text-(--components-toggle-icon-toggle-icon-disabled)` : `ri-check-fill ${h} leading-none text-(--icons-icon-accent)`;
    }), f = p(
      () => t.presentational ? {} : {
        type: "button",
        role: "switch",
        "aria-checked": t.modelValue,
        "aria-disabled": t.ariaDisabled ? "true" : void 0,
        disabled: t.disabled
      }
    ), b = () => {
      t.presentational || l.value || a("update:modelValue", !t.modelValue);
    };
    return (h, m) => (c(), K(dt(e.presentational ? "span" : "button"), Oe(f.value, {
      class: s.value,
      onClick: b
    }), {
      default: ve(() => [
        v("span", {
          class: C(d.value)
        }, [
          te(wt, {
            "enter-active-class": "transition-opacity duration-150 ease-in-out motion-reduce:transition-none",
            "enter-from-class": "opacity-0"
          }, {
            default: ve(() => [
              i.value ? (c(), g("i", {
                key: 0,
                class: C(u.value),
                "aria-hidden": "true"
              }, null, 2)) : k("", !0)
            ]),
            _: 1
          })
        ], 2)
      ]),
      _: 1
    }, 16, ["class"]));
  }
});
function og(e, n) {
  const t = n.trim(), a = t ? new RegExp(t.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"), "i").exec(e) : null;
  if (!a) return { before: e, match: "", after: "" };
  const l = a.index;
  return {
    before: e.slice(0, l),
    match: a[0],
    after: e.slice(l + a[0].length)
  };
}
const Na = "rounded-(--border-border-radius-rounded-l) border border-solid border-(--border-border-base-soft) bg-(--background-background-white) shadow-(--blur-shadow-m) [backdrop-filter:blur(4px)] dark:border-(--colors-border-base) dark:bg-(--colors-background-black-default) dark:shadow-(--blur-shadow-m-dark)", zu = "text-(--text-text-black-default) dark:text-(--colors-text-white-default)", ig = "box-border flex flex-col gap-1.5 p-[calc(--spacing(2)-1px)]", _o = `${Na} ${zu} ${ig}`, Ou = "focus-visible:outline-hidden focus-visible:shadow-(--shadow-focus-l)", My = `flex min-h-8 w-full cursor-pointer items-center rounded-(--border-border-radius-rounded-sm) px-2 py-1.5 text-(length:--size-m) leading-(--line-height-l) font-(--weight-medium) text-(--text-text-black-default) transition-colors hover:bg-(--background-background-hover) ${Ou} dark:text-(--colors-text-white-default) dark:hover:bg-white/8`, Dy = "bg-(--background-background-hover) dark:bg-white/8", sg = {
  success: "text-(--icons-icon-success)",
  base: "text-(--icons-icon-base)",
  error: "text-(--icons-icon-error)"
}, zy = {
  key: 0,
  class: "flex shrink-0",
  "data-testid": "dropdown-list-item-checkbox"
}, Oy = {
  key: 0,
  class: "h-5.5 w-9.5 shrink-0",
  "aria-hidden": "true",
  "data-testid": "dropdown-list-item-toggle-placeholder"
}, Py = ["src"], Fy = ["id"], Vy = ["id"], Ny = {
  key: 1,
  class: "min-w-0 break-words"
}, Hy = {
  class: "text-(--text-text-link)",
  "data-testid": "dropdown-list-item-highlight"
}, jy = {
  key: 1,
  class: "flex min-w-0",
  "data-testid": "dropdown-list-item-secondary-label"
}, Wy = {
  class: "flex min-w-0",
  "data-testid": "dropdown-list-item-secondary-label"
}, qy = {
  key: 1,
  class: "flex shrink-0"
}, Uy = {
  key: 4,
  class: "flex shrink-0",
  "data-testid": "dropdown-list-item-more-actions"
}, Gy = "inline-flex size-(--icon-size-sm) shrink-0 items-center justify-center", go = "text-(length:--icon-size-sm) leading-(--icon-size-sm) size-(--icon-size-sm) inline-flex items-center justify-center shrink-0", Gt = /* @__PURE__ */ ye({
  inheritAttrs: !1,
  __name: "DropdownListItem",
  props: {
    as: { default: "div" },
    type: { default: "default" },
    label: { default: void 0 },
    icon: { default: void 0 },
    iconColor: { default: void 0 },
    trailingIcon: { default: "ri-arrow-right-s-line" },
    secondaryLabel: { default: void 0 },
    secondaryIcon: { default: void 0 },
    flag: { default: void 0 },
    description: { default: void 0 },
    count: { default: void 0 },
    badge: { default: void 0 },
    checked: { type: Boolean, default: !1 },
    indeterminate: { type: Boolean, default: !1 },
    selected: { type: Boolean, default: !1 },
    highlighted: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    ariaDisabled: { type: Boolean, default: !1 },
    loading: { type: Boolean, default: !1 },
    danger: { type: Boolean, default: !1 },
    header: { type: Boolean, default: !1 },
    moreActions: { default: void 0 },
    moreActionsLabel: { default: void 0 },
    moreActionsTabindex: { default: void 0 },
    labelWrap: { type: Boolean, default: !1 },
    avatar: { default: void 0 },
    highlight: { default: void 0 },
    keyboardActive: { type: Boolean, default: !1 }
  },
  setup(e) {
    const n = e, t = Ve(), a = Ve(), l = p(() => n.disabled || n.ariaDisabled || n.loading), r = p(() => n.selected && ["default", "two-icons", "two-labels", "flag", "secondary-text"].includes(n.type)), o = p(() => !!n.description), i = p(() => ["checkbox", "badge-checkbox", "checkbox-badge"].includes(n.type)), s = p(() => n.type === "badge" || n.type === "badge-checkbox"), d = p(() => ["default", "two-icons", "two-labels", "switch", "autocomplete", "secondary-text"].includes(n.type)), u = p(() => n.type === "flag"), f = p(() => n.type === "secondary-text"), b = p(() => n.type === "autocomplete"), h = p(() => !!n.badge && (n.type === "checkbox-badge" || b.value)), m = p(() => {
      if (!b.value || !n.highlight) return null;
      const re = og(n.label ?? "", n.highlight);
      return re.match ? re : null;
    }), x = p(() => {
      var re;
      return n.type === "toggle" && !!((re = n.moreActions) != null && re.length);
    }), y = p(() => n.type === "checkbox" && l.value), w = p(() => {
      var re;
      return l.value ? "disabled" : ((re = n.badge) == null ? void 0 : re.theme) ?? "neutral";
    }), S = p(() => n.as === "button" ? { type: "button", disabled: n.disabled || void 0, "aria-disabled": n.ariaDisabled ? "true" : void 0 } : { "aria-disabled": n.disabled || n.ariaDisabled ? "true" : void 0 }), $ = E(!1), T = E(null), L = p(() => $.value || n.keyboardActive), A = p(() => L.value ? !0 : void 0), R = p(() => {
      var re;
      return L.value && !((re = T.value) != null && re.isTruncated) ? !0 : void 0;
    });
    function z(re) {
      if (re.target === re.currentTarget)
        try {
          $.value = re.target.matches(":focus-visible");
        } catch {
          $.value = !0;
        }
    }
    function D(re) {
      re.target === re.currentTarget && ($.value = !1);
    }
    const V = Fn(), Y = p(() => {
      const re = { ...S.value, onFocusin: z, onFocusout: D };
      o.value && Object.assign(re, { "aria-labelledby": t, "aria-describedby": a });
      for (const ue of Object.keys(re)) re[ue] === void 0 && delete re[ue];
      return Oe(V, re);
    }), _ = ({ badge: re, theme: ue }) => [
      re && Gn(Bu, {
        label: re.label,
        theme: ue,
        leftIcon: re.icon,
        rightIcon: re.rightIcon,
        brandIcon: re.brandIcon,
        size: "sm",
        fitWidth: !0,
        class: "min-w-0 max-w-full",
        "aria-hidden": "true",
        "data-testid": "dropdown-list-item-badge"
      }),
      Gn("span", { class: "sr-only", "data-testid": "dropdown-list-item-badge-name" }, re == null ? void 0 : re.label)
    ];
    _.props = ["badge", "theme"];
    const j = p(() => o.value ? "py-2" : b.value ? n.badge ? "py-1.5" : "py-2" : n.type === "switch" || n.type === "toggle" ? "py-[calc(--spacing(1.5)-1px)]" : n.type === "badge" || n.type === "badge-checkbox" || n.type === "checkbox-badge" ? "py-1" : "py-1.5"), M = p(() => l.value ? n.type === "two-labels" ? "text-(--text-text-disabled-strong) dark:text-(--colors-text-disabled)" : "text-(--text-text-disabled-light) dark:text-(--colors-text-disabled)" : r.value ? "text-(--colors-text-accent-strong)" : b.value ? "text-(--text-text-body) dark:text-(--colors-text-white-secondary)" : u.value ? n.highlighted ? "text-(--text-text-black-default) dark:text-(--colors-text-white-default)" : "text-(--text-text-body) group-hover:text-(--text-text-black-default) dark:text-(--colors-text-white-secondary) dark:group-hover:text-(--colors-text-white-default)" : n.type === "toggle" || n.type === "switch" ? "text-(--text-text-heading) dark:text-(--colors-text-white-default)" : "text-(--text-text-black-default) group-hover:text-text-black-default dark:group-hover:text-text-black-default dark:text-(--colors-text-white-default)"), W = Ou, G = p(() => l.value ? "cursor-not-allowed" : "cursor-pointer"), B = p(() => [
      "group flex w-full min-w-0 min-h-8 items-center gap-1.5 text-left rounded-(--border-border-radius-rounded-sm) transition-colors",
      // With more actions the item element inside takes the start padding, the focus ring and the cursor.
      x.value ? "pe-2" : ["px-2", j.value, W, G.value],
      M.value,
      !l.value && "hover:bg-background-hover dark:hover:bg-white/8",
      n.highlighted && !l.value && "bg-background-hover dark:bg-white/8",
      n.type === "toggle" && l.value && "bg-(--background-background-white)"
    ]), F = p(() => [
      "self-stretch ps-2 rounded-(--border-border-radius-rounded-sm)",
      j.value,
      W,
      G.value
    ]), X = p(() => [
      "flex min-w-0 flex-1 items-center text-(length:--size-m) leading-(--line-height-l)",
      n.type === "checkbox-badge" ? "font-(--weight-regular)" : "font-(--weight-medium)",
      n.type === "toggle" ? "gap-2" : "gap-1.5"
    ]), H = p(() => {
      const re = "text-(--text-text-error-strong) group-hover:text-(--text-text-error-strong)";
      return l.value ? "text-(--icons-icon-disabled-strong) dark:text-(--colors-text-disabled)" : n.danger ? re : r.value ? "text-(--icons-icon-accent-strong) dark:text-(--colors-text-accent-strong)" : "text-(--icons-icon-dark-default) dark:text-(--colors-text-white-default)";
    }), q = p(
      () => n.iconColor && !l.value && !n.danger && !r.value ? sg[n.iconColor] : H.value
    ), N = p(
      () => n.type === "two-labels" && r.value && !l.value ? "text-(--icons-icon-dark-default) dark:text-(--colors-text-white-default)" : H.value
    ), J = p(() => {
      if (n.type === "two-icons") return r.value ? "ri-check-fill" : n.trailingIcon;
      if (n.type === "two-labels") return n.trailingIcon;
      if ((n.type === "default" || u.value || f.value) && r.value) return "ri-check-fill";
    }), be = p(() => [
      "min-w-0",
      n.labelWrap ? "break-words" : "flex",
      (n.type === "two-labels" || f.value) && "flex-1",
      !n.icon && n.danger && !l.value && "text-(--text-text-error-strong) group-hover:text-(--text-text-error-strong)"
    ]), ke = p(() => [
      "shrink-0 text-(length:--size-sm) leading-(--line-height-xs) font-(--weight-regular)",
      // Figma Left form Hover/Active turns the count to the label's black.
      l.value ? "text-(--text-text-disabled-light) dark:text-(--colors-text-disabled)" : n.highlighted ? "text-(--text-text-black-default) dark:text-(--colors-text-white-default)" : "text-(--colors-text-body) dark:text-(--colors-text-white-secondary) group-hover:text-(--text-text-black-default) dark:group-hover:text-(--colors-text-white-default)"
    ]), ee = p(() => l.value ? "text-(--text-text-disabled-light) dark:text-(--colors-text-disabled)" : n.highlighted ? "text-(--text-text-black-default) dark:text-(--colors-text-white-default)" : "text-(--text-text-body) group-hover:text-(--text-text-black-default) dark:text-(--colors-text-white-secondary) dark:group-hover:text-(--colors-text-white-default)"), oe = p(() => l.value ? "text-(--text-text-disabled-light) dark:text-(--colors-text-disabled)" : r.value ? "text-(--icons-icon-accent-strong) dark:text-(--colors-text-accent-strong)" : "text-(--icons-icon-dark-default) dark:text-(--colors-text-white-default)");
    function ge(re) {
      return re.startsWith("ri-");
    }
    return (re, ue) => (c(), K(dt(x.value ? "div" : e.as), Oe(x.value ? void 0 : Y.value, { class: B.value }), {
      default: ve(() => [
        (c(), K(dt(x.value ? e.as : "div"), Oe({ "data-testid": "dropdown-list-item-content" }, x.value ? Y.value : void 0, {
          class: x.value ? [X.value, F.value] : X.value
        }), {
          default: ve(() => [
            i.value ? (c(), g("span", zy, [
              te(Cn, {
                presentational: "",
                "model-value": e.checked,
                indeterminate: e.indeterminate,
                disabled: y.value
              }, null, 8, ["model-value", "indeterminate", "disabled"])
            ])) : k("", !0),
            e.type === "toggle" ? (c(), g(se, { key: 1 }, [
              e.header ? (c(), g("span", Oy)) : (c(), K(Ga, {
                key: 1,
                presentational: "",
                class: "shrink-0",
                "data-testid": "dropdown-list-item-toggle",
                "model-value": e.checked,
                disabled: l.value
              }, null, 8, ["model-value", "disabled"]))
            ], 64)) : k("", !0),
            u.value ? (c(), g("span", {
              key: 2,
              class: C(Gy),
              "aria-hidden": "true",
              "data-testid": "dropdown-list-item-flag-box"
            }, [
              e.flag ? (c(), g("span", {
                key: 0,
                class: C(["fi", `fi-${e.flag.toLowerCase()}`, "fis", "rounded-full", "text-[13.33px]"]),
                "data-testid": "dropdown-list-item-flag"
              }, null, 2)) : k("", !0)
            ])) : k("", !0),
            d.value ? (c(), g(se, { key: 3 }, [
              e.loading ? (c(), g("i", {
                key: 0,
                class: C(["dropdown-icon ri-loader-4-line animate-spin", go, H.value]),
                "aria-hidden": "true",
                "data-testid": "dropdown-list-item-icon"
              }, null, 2)) : b.value && e.avatar ? (c(), K(Kt, {
                key: 1,
                name: e.avatar.name,
                img: e.avatar.img,
                logo: e.avatar.logo ?? !1,
                size: "xs",
                presentational: "",
                class: "shrink-0",
                "data-testid": "dropdown-list-item-avatar"
              }, null, 8, ["name", "img", "logo"])) : e.icon ? (c(), g(se, { key: 2 }, [
                ge(e.icon) ? (c(), g("i", {
                  key: 0,
                  class: C([e.icon, "dropdown-icon", go, q.value]),
                  "aria-hidden": "true",
                  "data-testid": "dropdown-list-item-icon"
                }, null, 2)) : (c(), g("img", {
                  key: 1,
                  class: C(["dropdown-icon relative h-4 w-4 shrink-0 transition dark:invert dark:filter", [e.highlighted && "dark:invert-0", l.value ? "opacity-50" : "dark:group-hover:invert-0"]]),
                  src: e.icon,
                  alt: "",
                  "data-testid": "dropdown-list-item-icon"
                }, null, 10, Py))
              ], 64)) : k("", !0)
            ], 64)) : k("", !0),
            o.value ? (c(), g("span", {
              key: 4,
              class: C(["flex min-w-0 flex-col gap-px", (e.type === "two-labels" || f.value) && "flex-1"])
            }, [
              v("span", {
                id: I(t),
                class: C(be.value),
                "data-testid": "dropdown-list-item-label"
              }, [
                s.value ? (c(), K(_, {
                  key: 0,
                  badge: e.badge,
                  theme: w.value
                }, null, 8, ["badge", "theme"])) : e.labelWrap ? (c(), g(se, { key: 1 }, [
                  at(P(e.label), 1)
                ], 64)) : (c(), K(bt, {
                  key: 2,
                  ref_key: "labelRef",
                  ref: T,
                  text: e.label ?? "",
                  focusable: !1,
                  open: A.value
                }, null, 8, ["text", "open"]))
              ], 10, Fy),
              v("span", {
                id: I(a),
                "data-testid": "dropdown-item-description",
                class: C(["text-(length:--size-sm) leading-(--line-height-l) font-(--weight-regular)", !l.value && "text-(--colors-text-body) dark:text-(--colors-text-white-secondary)"])
              }, P(e.description), 11, Vy)
            ], 2)) : (c(), g("span", {
              key: 5,
              class: C(be.value),
              "data-testid": "dropdown-list-item-label"
            }, [
              s.value ? (c(), K(_, {
                key: 0,
                badge: e.badge,
                theme: w.value
              }, null, 8, ["badge", "theme"])) : m.value ? (c(), g("span", Ny, [
                at(P(m.value.before), 1),
                v("span", Hy, P(m.value.match), 1),
                at(P(m.value.after), 1)
              ])) : e.labelWrap ? (c(), g(se, { key: 2 }, [
                at(P(e.label), 1)
              ], 64)) : (c(), K(bt, {
                key: 3,
                ref_key: "labelRef",
                ref: T,
                text: e.label ?? "",
                focusable: !1,
                open: A.value
              }, null, 8, ["text", "open"]))
            ], 2)),
            b.value && e.secondaryLabel ? (c(), g("span", {
              key: 6,
              class: C(["flex min-w-0 text-(length:--size-sm) leading-(--line-height-xs) font-(--weight-regular)", !l.value && "text-(--text-text-body-subtle) dark:text-(--colors-text-white-secondary)"]),
              "data-testid": "dropdown-list-item-secondary-label"
            }, [
              te(bt, {
                text: e.secondaryLabel,
                focusable: !1,
                open: R.value
              }, null, 8, ["text", "open"])
            ], 2)) : k("", !0),
            f.value && (e.secondaryLabel || e.secondaryIcon) ? (c(), g("span", {
              key: 7,
              class: C(["flex min-w-0 max-w-1/2 shrink items-center justify-end gap-0.5 text-(length:--size-sm) leading-(--line-height-l) font-(--weight-regular)", ee.value]),
              "data-testid": "dropdown-list-item-secondary"
            }, [
              e.secondaryIcon ? (c(), g("i", {
                key: 0,
                class: C([e.secondaryIcon, "size-3 shrink-0 text-(length:--size-sm) leading-(--size-sm) inline-flex items-center justify-center", oe.value]),
                "aria-hidden": "true",
                "data-testid": "dropdown-list-item-secondary-icon"
              }, null, 2)) : k("", !0),
              e.secondaryLabel ? (c(), g("span", jy, [
                te(bt, {
                  text: e.secondaryLabel,
                  focusable: !1,
                  open: R.value
                }, null, 8, ["text", "open"])
              ])) : k("", !0)
            ], 2)) : k("", !0),
            e.type === "two-labels" && e.secondaryLabel ? (c(), g(se, { key: 8 }, [
              e.secondaryIcon ? (c(), g("i", {
                key: 0,
                class: C([e.secondaryIcon, go, H.value]),
                "aria-hidden": "true",
                "data-testid": "dropdown-list-item-secondary-icon"
              }, null, 2)) : k("", !0),
              v("span", Wy, [
                te(bt, {
                  text: e.secondaryLabel,
                  focusable: !1,
                  open: R.value
                }, null, 8, ["text", "open"])
              ])
            ], 64)) : k("", !0)
          ]),
          _: 1
        }, 16, ["class"])),
        e.type === "checkbox" && e.count !== void 0 && e.count !== "" ? (c(), g("span", {
          key: 0,
          class: C(ke.value),
          "data-testid": "dropdown-list-item-count"
        }, P(e.count), 3)) : k("", !0),
        h.value && e.badge ? (c(), g("span", qy, [
          te(_, {
            badge: e.badge,
            theme: w.value
          }, null, 8, ["badge", "theme"])
        ])) : k("", !0),
        e.type === "switch" ? (c(), K(Ga, {
          key: 2,
          presentational: "",
          class: "ms-auto shrink-0",
          "data-testid": "dropdown-list-item-toggle",
          "model-value": e.checked,
          disabled: l.value
        }, null, 8, ["model-value", "disabled"])) : k("", !0),
        J.value ? (c(), g("i", {
          key: 3,
          class: C([J.value, "ms-auto", go, N.value]),
          "aria-hidden": "true",
          "data-testid": "dropdown-list-item-trailing"
        }, null, 2)) : k("", !0),
        x.value ? (c(), g("span", Uy, [
          te(Sn, {
            items: e.moreActions,
            "menu-align": "right"
          }, {
            trigger: ve(({ triggerProps: O }) => [
              te(Re, Oe(O, {
                variant: "ghost",
                size: "xs",
                "icon-only": "",
                "icon-left": "ri-more-fill",
                "aria-label": e.moreActionsLabel,
                tabindex: e.moreActionsTabindex,
                "aria-disabled": l.value,
                "data-testid": "dropdown-list-item-more-actions-trigger"
              }), null, 16, ["aria-label", "tabindex", "aria-disabled"])
            ]),
            _: 1
          }, 8, ["items"])
        ])) : k("", !0)
      ]),
      _: 1
    }, 16, ["class"]));
  }
}), Ky = ["role", "data-testid", "data-menu-label", "disabled", "aria-disabled", "aria-current"], Yy = { class: "me-auto flex items-center gap-1.5 font-(--weight-medium) leading-(--line-height-l)" }, Jy = ["src"], uf = /* @__PURE__ */ ye({
  __name: "DropdownItemButton",
  props: {
    item: {},
    variant: { default: "default" },
    fallbackTestId: { default: "dropdown-item" },
    selectionStyle: { default: "highlight" }
  },
  emits: ["click"],
  setup(e, { emit: n }) {
    const t = e, a = n, l = p(() => !!(t.item.disabled || t.item.loading)), r = p(() => t.variant === "default" && !!t.item.description), o = p(
      () => l.value && (!!t.item.tooltip || r.value)
    ), i = p(() => t.variant === "default" && !t.item.hasSwitch && t.item.active === !0), s = p(() => t.variant === "nav" ? "menuitem" : t.item.hasSwitch ? "menuitemcheckbox" : typeof t.item.active == "boolean" ? "menuitemradio" : "menuitem"), d = p(() => {
      if (s.value === "menuitemcheckbox") return !!t.item.switchChecked;
      if (s.value === "menuitemradio") return t.item.active === !0;
    }), u = p(
      () => t.item.danger ? "text-(--text-text-error-strong) group-hover:text-(--text-text-error-strong)" : void 0
    ), f = p(() => [
      Ou,
      "py-1 px-0 hover:text-(--colors-text-link)",
      t.item.active ? "text-(--colors-text-link)" : "text-(--colors-text-body)",
      l.value ? "cursor-not-allowed opacity-50" : "cursor-pointer"
    ]);
    function b() {
      l.value || a("click", t.item);
    }
    function h(m) {
      return m.startsWith("ri-");
    }
    return (m, x) => e.variant === "default" ? (c(), K(Gt, {
      key: 0,
      as: "button",
      type: e.item.hasSwitch ? "switch" : "default",
      role: s.value,
      "data-testid": e.item.testId || e.fallbackTestId,
      "data-menu-label": e.item.label,
      label: e.item.label,
      icon: e.item.icon,
      description: e.item.description,
      checked: !!e.item.switchChecked,
      selected: i.value && e.selectionStyle === "check",
      highlighted: i.value && e.selectionStyle === "highlight",
      disabled: l.value && !o.value,
      "aria-disabled": o.value,
      loading: e.item.loading,
      danger: e.item.danger,
      "aria-checked": d.value,
      "label-wrap": "",
      onClick: b
    }, null, 8, ["type", "role", "data-testid", "data-menu-label", "label", "icon", "description", "checked", "selected", "highlighted", "disabled", "aria-disabled", "loading", "danger", "aria-checked"])) : (c(), g("button", {
      key: 1,
      type: "button",
      role: s.value,
      "data-testid": e.item.testId || e.fallbackTestId,
      "data-menu-label": e.item.label,
      disabled: o.value ? void 0 : l.value,
      "aria-disabled": o.value ? "true" : void 0,
      "aria-current": e.item.active ? "true" : void 0,
      class: C(["group inline-flex w-full items-center text-left rounded-(--border-border-radius-rounded-sm) transition-colors", f.value]),
      onClick: b
    }, [
      v("div", Yy, [
        e.item.loading ? (c(), g("i", {
          key: 0,
          class: C(["dropdown-icon ri-loader-4-line animate-spin text-(length:--icon-size-sm) leading-(--icon-size-sm) size-(--icon-size-sm) inline-flex items-center justify-center shrink-0", u.value]),
          "aria-hidden": "true"
        }, null, 2)) : e.item.icon ? (c(), g(se, { key: 1 }, [
          h(e.item.icon) ? (c(), g("i", {
            key: 0,
            class: C([e.item.icon, "dropdown-icon text-(length:--icon-size-sm) leading-(--icon-size-sm) size-(--icon-size-sm) inline-flex items-center justify-center shrink-0", u.value]),
            "aria-hidden": "true"
          }, null, 2)) : (c(), g("img", {
            key: 1,
            class: C(["dropdown-icon relative h-4 w-4 transition dark:invert dark:filter dark:group-hover:invert-0", e.item.active && "dark:invert-0"]),
            src: e.item.icon,
            alt: ""
          }, null, 10, Jy))
        ], 64)) : k("", !0),
        v("span", {
          class: C(["relative me-1.5", !e.item.icon && u.value])
        }, P(e.item.label), 3)
      ])
    ], 10, Ky));
  }
}), po = /* @__PURE__ */ ye({
  __name: "DropdownMenuItem",
  props: {
    item: {},
    variant: {},
    fallbackTestId: {},
    selectionStyle: {},
    tooltipRef: { type: Function }
  },
  emits: ["click"],
  setup(e) {
    return (n, t) => e.item.tooltip ? (c(), K(ft, {
      key: 0,
      ref: e.tooltipRef,
      text: e.item.tooltip,
      class: "w-full"
    }, {
      default: ve(() => [
        te(uf, {
          item: e.item,
          variant: e.variant,
          "fallback-test-id": e.fallbackTestId,
          "selection-style": e.selectionStyle,
          onClick: t[0] || (t[0] = (a) => n.$emit("click", e.item))
        }, null, 8, ["item", "variant", "fallback-test-id", "selection-style"])
      ]),
      _: 1
    }, 8, ["text"])) : (c(), K(uf, {
      key: 1,
      item: e.item,
      variant: e.variant,
      "fallback-test-id": e.fallbackTestId,
      "selection-style": e.selectionStyle,
      onClick: t[1] || (t[1] = (a) => n.$emit("click", e.item))
    }, null, 8, ["item", "variant", "fallback-test-id", "selection-style"]));
  }
}), Zy = {}, Xy = {
  class: "w-full py-1",
  "data-testid": "dropdown-separator",
  "aria-hidden": "true"
};
function Qy(e, n) {
  return c(), g("div", Xy, [...n[0] || (n[0] = [
    v("div", { class: "border-t border-(--border-border-base-soft) dark:border-(--colors-border-base)" }, null, -1)
  ])]);
}
const cf = /* @__PURE__ */ lt(Zy, [["render", Qy]]);
function Aa(e) {
  return e.normalize("NFD").replace(new RegExp("\\p{Diacritic}", "gu"), "").toLowerCase();
}
function Pu(e, n) {
  return Aa(e).includes(Aa(n.trim()));
}
function _y(e) {
  return typeof e.getModifierState == "function" && e.getModifierState("AltGraph") ? !0 : e.ctrlKey && e.altKey;
}
function Fu(e = 500) {
  const n = E("");
  let t = null;
  function a() {
    n.value = "", t && (clearTimeout(t), t = null);
  }
  function l() {
    t && clearTimeout(t), t = setTimeout(a, e);
  }
  kt(() => {
    t && clearTimeout(t);
  });
  function r(o) {
    if (o.repeat) return !1;
    if (o.key === "Backspace")
      return n.value ? (n.value = n.value.slice(0, -1), n.value ? l() : a(), !0) : !1;
    if (o.isComposing) return !1;
    const i = _y(o);
    return o.key.length !== 1 || o.metaKey || o.ctrlKey && !i || o.altKey && !i ? !1 : (n.value += o.key, l(), !0);
  }
  return { query: n, handleKey: r, reset: a };
}
const ek = {
  key: 0,
  class: "flex items-center"
}, tk = { class: "flex items-center gap-0.5" }, nk = { class: "relative leading-(--line-height-l) font-(--weight-medium) dark:text-(--colors-text-white-default)" }, ak = {
  key: 0,
  class: "relative leading-(--line-height-l) font-(--weight-medium) dark:text-(--colors-text-white-default)"
}, lk = ["id", "aria-expanded", "aria-label"], rk = {
  key: 1,
  class: "flex items-center gap-1.5 px-3 py-1 text-(length:--size-sm) leading-(--line-height-l)"
}, ok = ["src"], ik = {
  key: 1,
  class: "relative leading-(--line-height-l) font-(--weight-medium) dark:text-(--colors-text-white-default)"
}, sk = ["title"], dk = ["src"], uk = ["src"], ck = ["role", "aria-labelledby", "aria-label", "data-focus-trap-return"], fk = {
  key: 0,
  class: "flex w-full items-center gap-1.5 rounded-(--border-border-radius-rounded-sm) bg-(--colors-background-white-secondary) p-2 px-3"
}, hk = { class: "flex min-w-0 flex-1 flex-col gap-0.5 text-(length:--size-m) leading-(--line-height-l)" }, bk = { class: "truncate font-(--weight-semi-bold) text-(--colors-text-heading)" }, gk = { class: "truncate font-(--weight-regular) text-(--colors-text-body)" }, pk = {
  key: 1,
  class: "absolute top-3 right-3"
}, mk = {
  key: 2,
  role: "presentation",
  "data-testid": "dropdown-menu-header",
  class: "flex h-4 w-full items-end px-2 text-(length:--size-sm) leading-(--line-height-l) font-(--weight-semi-bold) text-(--text-text-body-subtle) dark:text-(--colors-text-white-secondary)"
}, vk = ["id"], xk = { class: "overflow-y-auto flex-1 min-h-0 pr-6 -my-0.5 -ml-0.5 py-0.5 pl-0.5" }, yk = {
  key: 0,
  "data-testid": "dropdown-megamenu-col-header",
  role: "presentation",
  class: "leading-(--line-height-l) font-(--weight-semi-bold) text-(length:--size-sm) text-(--colors-text-body-subtle)"
}, kk = {
  key: 1,
  class: "flex flex-col gap-3 sm:flex-row sm:items-start"
}, wk = ["role", "aria-label"], Ck = { class: "w-full" }, Sk = /* @__PURE__ */ ye({
  __name: "Dropdown",
  props: {
    label: { default: "Dropdown" },
    triggerIconLeft: { default: void 0 },
    triggerIcon: { default: void 0 },
    triggerIconInfo: { default: void 0 },
    triggerIconInfoTooltip: { default: void 0 },
    items: { default: () => [] },
    groups: { default: void 0 },
    defaultOpen: { type: Boolean, default: !1 },
    menuWidth: { default: "auto" },
    fullWidth: { type: Boolean, default: !1 },
    menuAlign: { default: "left" },
    fieldLabel: { default: void 0 },
    required: { type: Boolean, default: !1 },
    avatar: { default: void 0 },
    ghost: { type: Boolean, default: !1 },
    tab: { type: Boolean, default: !1 },
    profileType: { default: void 0 },
    ariaLabel: { default: void 0 },
    menuHeader: { default: void 0 },
    bare: { type: Boolean, default: !1 },
    menuItemVariant: { default: "default" },
    selectionStyle: { default: "highlight" },
    columns: { default: void 0 },
    closeable: { type: Boolean, default: !1 },
    closeLabel: { default: void 0 },
    menuOffset: { default: 4 }
  },
  setup(e, { expose: n }) {
    const t = e, a = p(() => {
      var ue;
      if (t.ariaLabel) return t.ariaLabel;
      if (t.avatar) {
        const O = (ue = t.avatar.name) == null ? void 0 : ue.trim();
        return O ? `Open account menu, ${O}` : "Open account menu";
      }
    }), l = (ue) => {
      var O;
      ((O = ue.currentTarget) == null ? void 0 : O.getAttribute("aria-disabled")) !== "true" && !r.value && (ue.key === "ArrowDown" || ue.key === "ArrowUp") && (ue.preventDefault(), r.value = !0);
    }, r = E(t.defaultOpen), o = E(null), i = E(null), s = E(null), d = E(null), u = p(() => !t.tab && !t.avatar), f = () => {
      var ue;
      return ((ue = s.value) == null ? void 0 : ue.$el) ?? i.value;
    }, b = Ve(), h = Ve(), m = E(void 0), x = () => {
      r.value = !r.value;
    }, y = () => {
      r.value = !1;
    }, w = p(() => ({
      id: h,
      "aria-haspopup": "menu",
      "aria-expanded": r.value,
      onClick: x,
      onKeydown: l
    })), S = (ue) => {
      var ae, Z;
      const O = ue.target, U = ((ae = d.value) == null ? void 0 : ae.contains(O)) ?? !1, Q = ((Z = o.value) == null ? void 0 : Z.contains(O)) ?? !1;
      !U && !Q && y();
    };
    ot(() => document.addEventListener("mousedown", S)), kt(() => document.removeEventListener("mousedown", S));
    let $ = null;
    const T = () => {
      const ue = f() ?? d.value;
      !ue || !o.value || ($ == null || $.destroy(), $ = Fa(ue, o.value, {
        strategy: "fixed",
        placement: t.menuAlign === "right" ? "bottom-end" : "bottom-start",
        modifiers: [
          { name: "offset", options: { offset: [0, t.menuOffset] } },
          { name: "flip", options: { fallbackPlacements: t.menuAlign === "right" ? ["bottom-start", "top-end", "top-start"] : ["bottom-end", "top-start", "top-end"] } },
          { name: "preventOverflow", options: { padding: 8 } },
          // Disable GPU acceleration so Popper uses top/left instead of transform,
          // avoiding conflict with the Vue Transition's transform: scale(...)
          { name: "computeStyles", options: { gpuAcceleration: !1 } }
        ]
      }));
    }, L = () => {
      $ == null || $.destroy(), $ = null;
    };
    Ie(r, async (ue) => {
      var O;
      ue ? (J = !1, m.value = ((O = ee()) == null ? void 0 : O.id) || void 0, await qe(), T(), R()) : (z.reset(), L());
    }), ot(() => {
      var ue;
      r.value && (m.value = ((ue = ee()) == null ? void 0 : ue.id) || void 0, qe(T));
    }), kt(() => L());
    const A = () => o.value ? Array.from(
      o.value.querySelectorAll(
        '[role="menuitem"]:not([disabled]), [role="menuitemradio"]:not([disabled]), [role="menuitemcheckbox"]:not([disabled])'
      )
    ) : [], R = () => {
      qe(() => {
        var O;
        const ue = A();
        (O = ue.find((U) => U.getAttribute("role") === "menuitemradio" && U.getAttribute("aria-checked") === "true") ?? ue[0]) == null || O.focus();
      });
    }, z = Fu(), D = (ue, O) => {
      const U = Aa(z.query.value), Q = U.length === 1 ? O + 1 : O;
      for (let ae = 0; ae < ue.length; ae++) {
        const Z = ue[(Q + ae) % ue.length];
        if (Aa(Z.dataset.menuLabel ?? Z.textContent ?? "").trim().startsWith(U)) {
          Z.focus();
          return;
        }
      }
    }, V = (ue) => {
      var U;
      const O = A();
      (U = O[Math.max(0, Math.min(ue, O.length - 1))]) == null || U.focus();
    }, Y = (ue) => {
      if (!r.value) {
        ue.key === "Tab" && oe();
        return;
      }
      const O = A(), U = document.activeElement, Q = O.indexOf(U);
      if (Q !== -1 && !(ue.key === " " && !z.query.value) && z.handleKey(ue)) {
        ue.preventDefault(), D(O, Q);
        return;
      }
      switch (ue.key) {
        case "ArrowDown":
          ue.preventDefault(), V(Q < O.length - 1 ? Q + 1 : 0);
          break;
        case "ArrowUp":
          ue.preventDefault(), V(Q > 0 ? Q - 1 : O.length - 1);
          break;
        case "Home":
          ue.preventDefault(), V(0);
          break;
        case "End":
          ue.preventDefault(), V(O.length - 1);
          break;
        case "Escape":
          W(ue);
          break;
        case "Tab":
          oe(), y();
          break;
      }
    }, _ = /* @__PURE__ */ new Map(), j = (ue) => (O) => {
      O ? _.set(ue, O) : _.delete(ue);
    }, M = () => {
      for (const ue of _.values())
        if (ue.isVisible) return ue;
    }, W = (ue) => {
      ue.stopPropagation(), ue.preventDefault();
      const O = M();
      if (O) {
        O.hide();
        return;
      }
      be();
    }, G = (ue) => {
      r.value && W(ue);
    }, B = p(() => {
      var O;
      if (!t.columns || !((O = t.groups) != null && O.length)) return null;
      const ue = t.groups.filter((U) => U.items.length > 0);
      return ue.length > 0 ? ue : null;
    }), F = p(
      () => B.value ? Math.min(B.value.length, t.columns ?? B.value.length) : 0
    ), X = p(() => {
      var O;
      if (t.columns || !((O = t.groups) != null && O.length)) return null;
      const ue = t.groups.filter((U) => U.items.length > 0);
      return ue.length > 0 ? ue : null;
    }), H = p(() => {
      if (!t.columns || B.value) return null;
      const ue = Math.ceil(t.items.length / t.columns), O = Array.from({ length: t.columns }, () => []);
      return t.items.forEach((U, Q) => {
        const ae = Math.floor(Q / ue);
        O[ae] && O[ae].push(U);
      }), O.filter((U) => U.length > 0);
    }), q = p(() => !!(B.value || H.value)), N = (ue) => {
      ue.disabled || ue.loading || (ue.onClick && ue.onClick(), (!ue.hasSwitch || t.menuItemVariant === "nav") && be());
    };
    let J = !1;
    const be = () => {
      J = !0, y();
    }, ke = () => {
      if (!J) return;
      J = !1;
      const ue = document.activeElement;
      ue && ue !== document.body || oe();
    }, ee = () => {
      var ue;
      return f() ?? ((ue = d.value) == null ? void 0 : ue.querySelector('button, [tabindex="0"], [tabindex]:not([tabindex="-1"])'));
    }, oe = () => {
      var ue;
      return (ue = ee()) == null ? void 0 : ue.focus();
    }, ge = p(() => {
      var ue;
      return t.fullWidth ? { width: `${((ue = d.value) == null ? void 0 : ue.offsetWidth) ?? 0}px` } : t.menuWidth !== "auto" ? { width: t.menuWidth } : t.columns || t.bare ? {} : { minWidth: "208px", maxWidth: "320px" };
    }), re = (ue) => !!ue && ue.startsWith("ri-");
    return n({ isOpen: r }), (ue, O) => (c(), g("div", {
      class: C(["text-text-black-default relative text-left dark:text-(--colors-text-white-default)", [e.tab ? "flex h-full items-stretch" : "inline-block", { "w-full": e.fullWidth }]]),
      onKeydown: ut(G, ["escape"])
    }, [
      e.fieldLabel ? (c(), g("div", ek, [
        v("div", tk, [
          v("div", nk, P(e.fieldLabel), 1),
          e.required ? (c(), g("div", ak, " * ")) : k("", !0)
        ])
      ])) : k("", !0),
      v("div", {
        class: C(["text-text-black-default relative flex flex-col items-start text-left dark:text-(--colors-text-white-default)", { "w-full": e.fullWidth, "h-full": e.tab }])
      }, [
        v("div", {
          ref_key: "triggerWrapperRef",
          ref: d,
          class: C({ "w-full": e.fullWidth, "h-full": e.tab })
        }, [
          $e(ue.$slots, "trigger", {
            toggle: x,
            isOpen: r.value,
            triggerProps: w.value
          }, () => [
            u.value ? (c(), K(Re, Oe({
              key: 0,
              ref_key: "triggerButtonRef",
              ref: s,
              "data-testid": "dropdown-trigger",
              size: "xs",
              variant: e.ghost ? "ghost" : "secondary",
              label: e.label,
              "icon-left": e.triggerIconLeft,
              "icon-right": e.triggerIcon,
              "dropdown-icon": !!e.label && !e.triggerIcon,
              "icon-only": !e.label,
              "aria-label": e.ariaLabel,
              "full-width": e.fullWidth
            }, w.value), null, 16, ["variant", "label", "icon-left", "icon-right", "dropdown-icon", "icon-only", "aria-label", "full-width"])) : (c(), g("button", {
              key: 1,
              id: I(h),
              ref_key: "triggerRef",
              ref: i,
              type: "button",
              "data-testid": "dropdown-trigger",
              class: C(["focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-royalblue z-0 cursor-pointer transition-colors", [
                e.tab ? "focus-visible:ring-inset shrink-0 h-full flex items-center rounded-tl-(--border-border-radius-rounded-sm) rounded-tr-(--border-border-radius-rounded-sm) border-t border-r border-l border-(--border-border-tab) bg-(--colors-background-white-tertiary) text-(--colors-text-black-default) hover:bg-whitesmoke dark:bg-white/5 dark:text-(--colors-text-white-secondary) dark:hover:bg-white/10 duration-200" : [
                  "focus-visible:ring-offset-2 rounded-(--border-border-radius-rounded-full) border border-solid duration-300",
                  "border-border-secondary-button hover:border-royalblue bg-white dark:border-(--colors-border-base) dark:bg-(--colors-background-black-default)"
                ],
                {
                  "w-full justify-between": e.fullWidth,
                  "justify-center": !e.fullWidth && !e.tab
                }
              ]]),
              "aria-expanded": r.value,
              "aria-haspopup": "menu",
              "aria-label": a.value,
              onClick: x,
              onKeydown: l
            }, [
              t.avatar ? (c(), K(Kt, {
                key: 0,
                presentational: "",
                as: "span",
                name: t.avatar.name,
                img: t.avatar.img
              }, null, 8, ["name", "img"])) : (c(), g("div", rk, [
                e.triggerIconLeft ? (c(), g(se, { key: 0 }, [
                  re(e.triggerIconLeft) ? (c(), g("i", {
                    key: 0,
                    class: C([e.triggerIconLeft, "dropdown-icon text-(length:--icon-size-sm) leading-(--icon-size-sm) size-(--icon-size-sm) inline-flex items-center justify-center"])
                  }, null, 2)) : (c(), g("img", {
                    key: 1,
                    class: "dropdown-icon relative h-4 w-4",
                    src: e.triggerIconLeft,
                    alt: ""
                  }, null, 8, ok))
                ], 64)) : k("", !0),
                e.label ? (c(), g("div", ik, P(e.label), 1)) : k("", !0),
                e.triggerIconInfo ? (c(), g("span", {
                  key: 2,
                  class: "inline-flex items-center",
                  title: e.triggerIconInfoTooltip,
                  onClick: O[0] || (O[0] = Ue(() => {
                  }, ["stop"]))
                }, [
                  re(e.triggerIconInfo) ? (c(), g("i", {
                    key: 0,
                    class: C([e.triggerIconInfo, "dropdown-icon text-(length:--size-xl) leading-(--size-xl) size-(--size-xl) inline-flex items-center justify-center"])
                  }, null, 2)) : (c(), g("img", {
                    key: 1,
                    class: "dropdown-icon relative h-4.5 w-4.5",
                    src: e.triggerIconInfo,
                    alt: ""
                  }, null, 8, dk))
                ], 8, sk)) : k("", !0),
                e.triggerIcon ? (c(), g(se, { key: 3 }, [
                  re(e.triggerIcon) ? (c(), g("i", {
                    key: 0,
                    class: C([
                      e.triggerIcon,
                      "dropdown-icon text-(length:--icon-size-sm) leading-(--icon-size-sm) size-(--icon-size-sm) inline-flex items-center justify-center transition-transform duration-200 ease-in-out"
                    ]),
                    style: Ne({ transform: r.value ? "rotate(180deg)" : "rotate(0deg)" })
                  }, null, 6)) : (c(), g("img", {
                    key: 1,
                    class: "dropdown-icon relative h-4 w-4 transition-transform duration-200 ease-in-out",
                    style: Ne({ transform: r.value ? "rotate(180deg)" : "rotate(0deg)" }),
                    src: e.triggerIcon,
                    alt: ""
                  }, null, 12, uk))
                ], 64)) : e.label ? (c(), g("svg", {
                  key: 4,
                  class: "relative h-4 w-4 transition-transform duration-200 ease-in-out",
                  style: Ne({ transform: r.value ? "rotate(180deg)" : "rotate(0deg)" }),
                  fill: "none",
                  stroke: "currentColor",
                  viewBox: "0 0 24 24",
                  xmlns: "http://www.w3.org/2000/svg"
                }, [...O[1] || (O[1] = [
                  v("path", {
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "stroke-width": "2",
                    d: "M19 9l-7 7-7-7"
                  }, null, -1)
                ])], 4)) : k("", !0)
              ]))
            ], 42, lk))
          ], !0)
        ], 2),
        (c(), K(Bn, { to: "body" }, [
          te(wt, {
            "enter-active-class": "transition duration-100 ease-out motion-reduce:transition-none",
            "enter-from-class": "transform scale-95 opacity-0",
            "enter-to-class": "transform scale-100 opacity-100",
            "leave-active-class": "transition duration-75 ease-out motion-reduce:transition-none",
            "leave-from-class": "transform scale-100 opacity-100",
            "leave-to-class": "transform scale-95 opacity-0",
            onAfterLeave: ke
          }, {
            default: ve(() => [
              r.value ? (c(), g("div", {
                key: 0,
                ref_key: "menuRef",
                ref: o,
                role: e.bare ? void 0 : "menu",
                "aria-labelledby": q.value ? I(b) : e.bare ? void 0 : m.value,
                "aria-label": e.bare || q.value ? void 0 : e.ariaLabel,
                "data-focus-trap-return": m.value,
                "data-testid": "dropdown-menu",
                "data-focus-trap-allow-outside": "",
                class: C(["fixed z-50", [
                  I(Na),
                  I(zu),
                  e.menuAlign === "right" ? "origin-top-right" : "origin-top-left",
                  q.value && "relative flex flex-col pt-6 pb-6 pl-6 max-h-[calc(100vh-90px)] max-w-[calc(100vw-32px)]",
                  !e.bare && !q.value && [I(ig), "max-h-[min(400px,calc(100vh-24px))] items-start overflow-y-auto"],
                  e.bare && "max-h-[calc(100vh-90px)] overflow-y-auto"
                ]]),
                style: Ne(ge.value),
                onKeydown: Y
              }, [
                t.avatar ? (c(), g("div", fk, [
                  te(Kt, {
                    name: t.avatar.name,
                    img: t.avatar.img,
                    presentational: ""
                  }, null, 8, ["name", "img"]),
                  v("div", hk, [
                    v("div", bk, P(t.avatar.name), 1),
                    v("div", gk, P(t.avatar.email), 1)
                  ]),
                  t.profileType ? (c(), K(ct, {
                    key: 0,
                    class: "ms-auto",
                    theme: "white",
                    size: "sm",
                    label: t.profileType
                  }, null, 8, ["label"])) : k("", !0)
                ])) : k("", !0),
                e.closeable ? (c(), g("div", pk, [
                  te(Re, {
                    "data-testid": "dropdown-close",
                    variant: "ghost",
                    "icon-only": "",
                    size: "sm",
                    "icon-left": "ri-close-line",
                    "aria-label": e.closeLabel,
                    onClick: y
                  }, null, 8, ["aria-label"])
                ])) : k("", !0),
                e.menuHeader && !t.avatar && !q.value ? (c(), g("div", mk, P(e.menuHeader), 1)) : k("", !0),
                $e(ue.$slots, "menu", { close: y }, () => [
                  q.value ? (c(), g(se, { key: 0 }, [
                    v("div", {
                      class: C(["mb-3", e.closeable ? "pr-12" : "pr-6"])
                    }, [
                      v("h5", {
                        id: I(b),
                        class: "text-(length:--size-xl) font-(--weight-semi-bold)",
                        style: { color: "var(--text-text-black-default)", "line-height": "var(--line-height-xl)" }
                      }, P(e.menuHeader), 9, vk)
                    ], 2),
                    v("div", xk, [
                      B.value ? (c(), g("div", {
                        key: 0,
                        "data-testid": "dropdown-megamenu-groups",
                        class: "dropdown-megamenu-groups",
                        style: Ne({ "--dropdown-megamenu-cols": F.value })
                      }, [
                        (c(!0), g(se, null, Me(B.value, (U) => (c(), g("div", {
                          key: U.key,
                          "data-testid": "dropdown-megamenu-col",
                          class: "flex flex-col items-start gap-3.5 min-w-0"
                        }, [
                          U.label ? (c(), g("div", yk, P(U.label), 1)) : k("", !0),
                          (c(!0), g(se, null, Me(U.items, (Q, ae) => (c(), K(po, {
                            key: ae,
                            item: Q,
                            variant: e.menuItemVariant,
                            "selection-style": e.selectionStyle,
                            "tooltip-ref": j(`${U.key}-${ae}`),
                            "fallback-test-id": "dropdown-megamenu-item",
                            onClick: (Z) => N(Q)
                          }, null, 8, ["item", "variant", "selection-style", "tooltip-ref", "onClick"]))), 128))
                        ]))), 128))
                      ], 4)) : (c(), g("div", kk, [
                        (c(!0), g(se, null, Me(H.value, (U, Q) => (c(), g("div", {
                          key: Q,
                          "data-testid": "dropdown-megamenu-col",
                          class: "flex flex-col items-start gap-3.5 w-full sm:w-52 shrink-0"
                        }, [
                          (c(!0), g(se, null, Me(U, (ae, Z) => (c(), K(po, {
                            key: Z,
                            item: ae,
                            variant: e.menuItemVariant,
                            "selection-style": e.selectionStyle,
                            "tooltip-ref": j(`col-${Q}-${Z}`),
                            "fallback-test-id": "dropdown-megamenu-item",
                            onClick: (ie) => N(ae)
                          }, null, 8, ["item", "variant", "selection-style", "tooltip-ref", "onClick"]))), 128))
                        ]))), 128))
                      ]))
                    ])
                  ], 64)) : X.value ? (c(!0), g(se, { key: 1 }, Me(X.value, (U, Q) => (c(), g(se, {
                    key: U.key
                  }, [
                    Q > 0 ? (c(), K(cf, { key: 0 })) : k("", !0),
                    v("div", {
                      class: "flex w-full flex-col gap-1.5",
                      role: U.items.length > 1 && U.label ? "group" : void 0,
                      "aria-label": U.items.length > 1 && U.label ? U.label : void 0
                    }, [
                      (c(!0), g(se, null, Me(U.items, (ae, Z) => (c(), K(po, {
                        key: Z,
                        item: ae,
                        variant: e.menuItemVariant,
                        "selection-style": e.selectionStyle,
                        "tooltip-ref": j(`group-${U.key}-${Z}`),
                        "fallback-test-id": "dropdown-item",
                        onClick: (ie) => N(ae)
                      }, null, 8, ["item", "variant", "selection-style", "tooltip-ref", "onClick"]))), 128))
                    ], 8, wk)
                  ], 64))), 128)) : (c(!0), g(se, { key: 2 }, Me(e.items, (U, Q) => (c(), g(se, { key: Q }, [
                    v("div", Ck, [
                      te(po, {
                        item: U,
                        variant: e.menuItemVariant,
                        "selection-style": e.selectionStyle,
                        "tooltip-ref": j(`flat-${Q}`),
                        "fallback-test-id": "dropdown-item",
                        onClick: (ae) => N(U)
                      }, null, 8, ["item", "variant", "selection-style", "tooltip-ref", "onClick"])
                    ]),
                    U.hasDividerAfter && Q < e.items.length - 1 ? (c(), K(cf, { key: 0 })) : k("", !0)
                  ], 64))), 128))
                ], !0)
              ], 46, ck)) : k("", !0)
            ]),
            _: 3
          })
        ]))
      ], 2)
    ], 34));
  }
}), Sn = /* @__PURE__ */ lt(Sk, [["__scopeId", "data-v-40d8a9e5"]]), dg = /* @__PURE__ */ ye({
  inheritAttrs: !1,
  __name: "LinkBase",
  props: {
    as: { default: "button" },
    iconLeft: {},
    iconRight: {},
    size: { default: "m" },
    ariaLabel: {},
    disabled: { type: Boolean, default: !1 },
    ariaDisabled: { type: [Boolean, String], default: !1 },
    underline: {}
  },
  setup(e) {
    const n = e, t = p(() => n.disabled && n.as === "button"), a = p(() => !!n.ariaDisabled && n.ariaDisabled !== "false"), l = p(() => n.disabled || a.value), r = Fn();
    function o() {
      const b = l.value ? rg(r) : r;
      return { ...n.as === "button" ? { type: "button" } : {}, ...b };
    }
    const i = {
      s: "text-(length:--size-sm) leading-(--line-height-l)",
      m: "text-(length:--size-m) leading-(--line-height-l)",
      l: "text-(length:--size-l) leading-(--line-height-xxl)"
    }, s = p(() => [
      "group/link inline-flex items-center gap-1.5 py-0.5 font-(--weight-medium) transition-colors duration-150 ease-in-out motion-reduce:transition-none focus-visible:outline-hidden focus-visible:shadow-(--shadow-focus-l)",
      i[n.size],
      l.value ? "cursor-not-allowed text-(--text-text-disabled-strong)" : "cursor-pointer text-(--text-text-link) hover:text-(--text-text-hover)"
    ]), d = p(() => [
      "text-num-16",
      l.value ? "text-(--icons-icon-disabled-strong)" : "text-(--icons-icon-link) group-hover/link:text-(--icons-icon-hover)"
    ]), u = p(() => n.underline === "always" ? "underline" : l.value ? "" : "group-hover/link:underline group-focus-visible/link:underline");
    function f(b) {
      l.value && b.preventDefault();
    }
    return (b, h) => (c(), K(dt(e.as), Oe(o(), {
      "aria-label": e.ariaLabel,
      disabled: t.value || void 0,
      "aria-disabled": l.value && !t.value ? "true" : void 0,
      class: s.value,
      onClickCapture: f,
      onAuxclickCapture: f
    }), {
      default: ve(() => [
        e.iconLeft ? (c(), g("i", {
          key: 0,
          class: C([e.iconLeft, d.value]),
          "aria-hidden": "true"
        }, null, 2)) : k("", !0),
        v("span", {
          class: C(u.value)
        }, [
          $e(b.$slots, "default")
        ], 2),
        e.iconRight ? (c(), g("i", {
          key: 1,
          class: C([e.iconRight, d.value]),
          "aria-hidden": "true"
        }, null, 2)) : k("", !0)
      ]),
      _: 3
    }, 16, ["aria-label", "disabled", "aria-disabled", "class"]));
  }
}), $n = /* @__PURE__ */ ye({
  __name: "TextLink",
  props: {
    as: {},
    iconLeft: {},
    iconRight: {},
    size: {},
    ariaLabel: {},
    disabled: { type: Boolean },
    ariaDisabled: { type: [Boolean, String] }
  },
  setup(e) {
    const n = e;
    return (t, a) => (c(), K(dg, Oe(n, { underline: "hover" }), {
      default: ve(() => [
        $e(t.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), ug = /* @__PURE__ */ ye({
  __name: "FieldLabelTooltip",
  props: {
    text: {}
  },
  setup(e) {
    return (n, t) => (c(), K(ft, {
      as: "span",
      text: e.text,
      class: "shrink-0",
      "data-field-label-tooltip": "",
      tabindex: "0",
      role: "group",
      "aria-label": e.text
    }, {
      default: ve(() => [...t[0] || (t[0] = [
        v("i", {
          class: "ri-information-line inline-flex size-3.5 shrink-0 items-center justify-center cursor-help text-(length:--size-m) text-(--icons-icon-dark-default) dark:text-(--icons-icon-white-default)",
          "aria-hidden": "true"
        }, null, -1)
      ])]),
      _: 1
    }, 8, ["text", "aria-label"]));
  }
}), $k = {
  key: 1,
  class: "sr-only"
}, xt = /* @__PURE__ */ ye({
  __name: "FieldLabel",
  props: {
    text: {},
    inputId: { default: void 0 },
    id: { default: void 0 },
    required: { type: Boolean, default: !1 },
    requiredIndicator: { default: "*" },
    tooltip: { default: void 0 },
    focused: { type: Boolean, default: !1 },
    inline: { type: Boolean, default: !1 },
    testId: { default: void 0 },
    secondaryText: { default: void 0 },
    secondaryPosition: { default: "right" },
    textClass: { default: void 0 },
    as: { default: "div" }
  },
  setup(e, { expose: n }) {
    const t = e, a = E(null), l = E(!1), r = p(() => l.value ? !1 : t.focused ? !0 : void 0);
    Ie(
      () => t.focused,
      (d) => {
        d || (l.value = !1);
      }
    ), n({ handleFieldKeydown: (d) => {
      var u;
      d.key !== "Escape" || l.value || !t.focused || !((u = a.value) != null && u.isTruncated) || (d.stopPropagation(), d.preventDefault(), l.value = !0);
    } });
    const i = p(
      () => t.textClass ?? "text-(length:--size-m) leading-(--line-height-l) font-(--weight-medium)"
    ), s = p(() => t.secondaryText && t.secondaryPosition === "below" ? [
      "grid min-w-0 max-w-full grid-cols-[minmax(0,auto)_auto] items-center justify-start gap-1",
      t.inline ? "shrink-0" : ""
    ] : [
      "flex min-w-0 max-w-full items-center gap-1",
      t.inline ? "shrink-0" : "",
      t.secondaryText && !t.inline ? "w-full" : ""
    ]);
    return (d, u) => (c(), K(dt(e.as), {
      class: C(s.value)
    }, {
      default: ve(() => [
        (c(), K(dt(e.inputId ? "label" : "span"), {
          id: e.id,
          for: e.inputId,
          "data-testid": e.testId,
          class: "flex min-w-0 items-center text-(--text-text-black-default) dark:text-(--colors-text-white-default)"
        }, {
          default: ve(() => [
            te(bt, {
              ref_key: "labelRef",
              ref: a,
              text: e.text,
              lines: 1,
              "text-class": i.value,
              focusable: !1,
              open: r.value
            }, null, 8, ["text", "text-class", "open"]),
            e.required ? (c(), g("span", {
              key: 0,
              class: C(["shrink-0 whitespace-pre", i.value])
            }, P(` ${e.requiredIndicator}`), 3)) : k("", !0),
            e.secondaryText ? (c(), g("span", $k, P(` ${e.secondaryText}`), 1)) : k("", !0)
          ]),
          _: 1
        }, 8, ["id", "for", "data-testid"])),
        e.tooltip ? (c(), K(ug, {
          key: 0,
          text: e.tooltip
        }, null, 8, ["text"])) : k("", !0),
        e.secondaryText ? (c(), g("span", {
          key: 1,
          "aria-hidden": "true",
          class: C([
            "text-(length:--size-sm) leading-(--line-height-l) font-(--weight-regular) text-(--text-text-body) dark:text-(--colors-text-white-default)",
            e.secondaryPosition === "below" ? "col-span-full min-w-0 break-words" : "ml-auto shrink-0 whitespace-nowrap"
          ])
        }, P(e.secondaryText), 3)) : k("", !0)
      ]),
      _: 1
    }, 8, ["class"]));
  }
}), Ik = ["data-type"], Tk = ["id"], il = /* @__PURE__ */ ye({
  __name: "DropdownPanelFooter",
  props: {
    type: {},
    buttons: { default: () => {
    } },
    label: { default: () => {
    } },
    seeAllLabel: { default: () => {
    } },
    createLabel: { default: () => {
    } },
    createIcon: { default: "ri-add-line" },
    seeAllOption: { default: () => {
    } },
    createOption: { default: () => {
    } },
    description: { default: () => {
    } }
  },
  emits: ["button-click", "see-all", "create", "option-hover"],
  setup(e, { emit: n }) {
    const t = Ve(), a = (r, o) => r ? {
      id: r.id,
      role: "option",
      "aria-selected": !!r.active,
      "aria-label": o,
      "data-testid": r.testId,
      class: [
        "w-full rounded-(--border-border-radius-rounded-full)",
        r.active && "shadow-(--shadow-focus-l)"
      ]
    } : { class: "contents" }, l = n;
    return (r, o) => (c(), g("div", {
      "data-testid": "dropdown-panel-footer",
      "data-type": e.type,
      class: C([
        "relative flex flex-col gap-1.5 rounded-b-(--border-border-radius-rounded-l) bg-(--background-background-white) px-3 py-4 shadow-(--blur-shadow-m) dark:bg-(--colors-background-black-default) dark:shadow-(--blur-shadow-m-dark)",
        e.label ? "items-start" : ""
      ])
    }, [
      e.label ? (c(), K(xt, {
        key: 0,
        text: e.label,
        "test-id": "dropdown-panel-footer-label"
      }, null, 8, ["text"])) : k("", !0),
      e.type === "see-all-create" ? (c(), g(se, { key: 1 }, [
        e.seeAllLabel ? (c(), g("div", Oe({ key: 0 }, a(e.seeAllOption, e.seeAllLabel), {
          onMouseenter: o[1] || (o[1] = (i) => e.seeAllOption && l("option-hover", "see-all"))
        }), [
          te(Re, {
            variant: "secondary",
            size: "md",
            "icon-left": "ri-eye-line",
            label: e.seeAllLabel,
            "full-width": "",
            tabindex: e.seeAllOption ? -1 : void 0,
            "aria-hidden": e.seeAllOption ? "true" : void 0,
            "data-testid": "dropdown-panel-footer-see-all",
            onClick: o[0] || (o[0] = (i) => l("see-all"))
          }, null, 8, ["label", "tabindex", "aria-hidden"])
        ], 16)) : k("", !0),
        e.createLabel ? (c(), g("div", Oe({ key: 1 }, a(e.createOption, e.createLabel), {
          onMouseenter: o[3] || (o[3] = (i) => e.createOption && l("option-hover", "create"))
        }), [
          te($n, {
            size: "m",
            "icon-left": e.createIcon,
            class: "w-full justify-center",
            tabindex: e.createOption ? -1 : void 0,
            "aria-hidden": e.createOption ? "true" : void 0,
            "data-testid": "dropdown-panel-footer-create",
            onClick: o[2] || (o[2] = (i) => l("create"))
          }, {
            default: ve(() => [
              at(P(e.createLabel), 1)
            ]),
            _: 1
          }, 8, ["icon-left", "tabindex", "aria-hidden"])
        ], 16)) : k("", !0)
      ], 64)) : e.buttons ? (c(), g("div", {
        key: 2,
        "data-testid": "dropdown-panel-footer-buttons",
        class: C(e.type === "buttons-inline" ? "flex w-full gap-1.5" : "flex w-full flex-col gap-3")
      }, [
        (c(!0), g(se, null, Me(e.buttons, (i, s) => (c(), K(Re, {
          key: s,
          variant: i.variant ?? "secondary",
          size: "sm",
          label: i.label,
          "icon-left": i.icon,
          disabled: i.disabled,
          "aria-disabled": i.ariaDisabled,
          "aria-describedby": i.ariaDisabled && e.description ? I(t) : void 0,
          "full-width": "",
          shrink: e.type === "buttons-inline",
          class: C(e.type === "buttons-inline" ? "flex-1" : ""),
          "data-testid": i.testId ?? `dropdown-panel-footer-button-${s}`,
          onClick: (d) => l("button-click", s)
        }, null, 8, ["variant", "label", "icon-left", "disabled", "aria-disabled", "aria-describedby", "shrink", "class", "data-testid", "onClick"]))), 128))
      ], 2)) : k("", !0),
      e.description ? (c(), g("p", {
        key: 3,
        id: I(t),
        "data-testid": "dropdown-panel-footer-description",
        class: "text-(length:--size-sm) leading-(--line-height-l) font-(--weight-regular) text-(--colors-text-body) dark:text-(--colors-text-white-secondary)"
      }, P(e.description), 9, Tk)) : k("", !0)
    ], 10, Ik));
  }
}), Lk = { class: "inline-flex min-w-0 max-w-full text-(--text-text-black-default) dark:text-(--colors-text-white-default)" }, Ek = {
  "data-testid": "label-dropdown-label",
  class: "inline-flex min-w-0 items-center gap-1 px-px"
}, Ak = {
  "data-testid": "label-dropdown-text-frame",
  class: "inline-flex min-w-0 whitespace-nowrap"
}, Rk = ["id"], Bk = { class: "sr-only" }, Or = /* @__PURE__ */ ye({
  __name: "LabelDropdown",
  props: {
    label: {},
    type: { default: "14px" },
    infoLeft: { default: () => {
    } },
    iconLeft: { default: () => {
    } },
    infoRight: { default: () => {
    } },
    required: { type: Boolean, default: !1 },
    requiredLabel: { default: () => {
    } },
    id: { default: () => {
    } }
  },
  setup(e) {
    const n = {
      "14px": {
        text: "text-(length:--size-m) leading-(--line-height-l) font-(--weight-medium)",
        icon: "text-(length:--icon-size-xs) leading-(--icon-size-xs)"
      },
      h6: {
        text: "font-(family-name:--family-heading) text-(length:--size-l) leading-(--line-height-l) font-(--weight-bold)",
        icon: "text-(length:--icon-size-sm) leading-(--icon-size-sm)"
      },
      h5: {
        text: "font-(family-name:--family-heading) text-(length:--size-xl) leading-(--line-height-xl) font-(--weight-semi-bold)",
        icon: "text-(length:--icon-size-md) leading-(--icon-size-md)"
      }
    }, t = p(() => n[e.type]);
    return (a, l) => (c(), g("span", Lk, [
      v("span", Ek, [
        e.iconLeft ? (c(), g("i", {
          key: 0,
          class: C([e.iconLeft, "shrink-0 text-(--icons-icon-dark-default) dark:text-(--icons-icon-white-default)", t.value.icon]),
          "aria-hidden": "true",
          "data-testid": "label-dropdown-icon-left"
        }, null, 2)) : k("", !0),
        e.infoLeft ? (c(), K(ft, {
          key: 1,
          as: "span",
          text: e.infoLeft,
          tabindex: "0",
          role: "img",
          "aria-label": e.infoLeft,
          "data-testid": "label-dropdown-info-left",
          class: "shrink-0 rounded-(--border-border-radius-rounded-full) focus-visible:shadow-(--shadow-focus-l) focus-visible:outline-2 focus-visible:outline-transparent"
        }, {
          default: ve(() => [
            v("i", {
              class: C(["ri-information-line text-(--icons-icon-dark-default) dark:text-(--icons-icon-white-default)", t.value.icon]),
              "aria-hidden": "true"
            }, null, 2)
          ]),
          _: 1
        }, 8, ["text", "aria-label"])) : k("", !0),
        v("span", Ak, [
          v("span", {
            "data-testid": "label-dropdown-text",
            class: C(["flex min-w-0", t.value.text])
          }, [
            $e(a.$slots, "default", {}, () => [
              te(bt, { text: e.label }, null, 8, ["text"])
            ])
          ], 2),
          e.id ? (c(), g("span", {
            key: 0,
            id: e.id,
            hidden: "",
            "data-testid": "label-dropdown-name"
          }, P(e.label), 9, Rk)) : k("", !0),
          e.required ? (c(), g(se, { key: 1 }, [
            l[0] || (l[0] = v("span", {
              "aria-hidden": "true",
              "data-testid": "label-dropdown-required",
              class: "w-(--spacing-2) text-(length:--size-m) leading-(--line-height-l) font-(--weight-medium) text-(--icons-icon-dark-default) dark:text-(--icons-icon-white-default)"
            }, "*", -1)),
            v("span", Bk, P(e.requiredLabel), 1)
          ], 64)) : k("", !0)
        ]),
        e.infoRight ? (c(), K(ft, {
          key: 2,
          as: "span",
          text: e.infoRight,
          tabindex: "0",
          role: "img",
          "aria-label": e.infoRight,
          "data-testid": "label-dropdown-info-right",
          class: "shrink-0 rounded-(--border-border-radius-rounded-full) focus-visible:shadow-(--shadow-focus-l) focus-visible:outline-2 focus-visible:outline-transparent"
        }, {
          default: ve(() => [
            v("i", {
              class: C(["ri-information-line text-(--icons-icon-dark-default) dark:text-(--icons-icon-white-default)", t.value.icon]),
              "aria-hidden": "true"
            }, null, 2)
          ]),
          _: 1
        }, 8, ["text", "aria-label"])) : k("", !0)
      ])
    ]));
  }
}), Cs = 1;
function cg({ strip: e, arrow: n, backArrow: t, enabled: a, selection: l }) {
  const r = E(!1), o = E(!1), i = E(!1), s = p(() => r.value && o.value), d = p(() => r.value && i.value);
  function u() {
    const D = e.value;
    if (!D || !a()) {
      r.value = !1, o.value = !1, i.value = !1;
      return;
    }
    const V = D.scrollWidth - D.clientWidth;
    r.value = V > Cs, o.value = r.value && D.scrollLeft < V - Cs, i.value = r.value && D.scrollLeft > Cs;
  }
  const f = () => {
    var D;
    return s.value ? ((D = n.value) == null ? void 0 : D.offsetWidth) ?? 0 : 0;
  }, b = () => {
    var D;
    return d.value ? ((D = t.value) == null ? void 0 : D.offsetWidth) ?? 0 : 0;
  }, h = (D) => f() || parseFloat(getComputedStyle(D).scrollPaddingInlineEnd) || 0, m = (D) => b() || parseFloat(getComputedStyle(D).scrollPaddingInlineStart) || 0;
  let x = !1;
  const y = () => (!s.value || !!n.value) && (!d.value || !!t.value);
  function w(D) {
    const V = D.querySelector(":scope > [aria-selected='true'], :scope > .active");
    if (V) return V;
    let Y = D.querySelector("[role='tab'][aria-selected='true']");
    for (; Y && Y.parentElement !== D; ) Y = Y.parentElement;
    return Y;
  }
  function S() {
    x = !1;
    const D = e.value;
    if (!D || !r.value) return;
    const V = w(D);
    if (!V) return;
    const Y = D.getBoundingClientRect(), _ = V.getBoundingClientRect(), j = Y.left + D.clientLeft, M = m(D), W = h(D), G = j + M, B = j + D.clientWidth - W;
    if (_.left < G) {
      const F = D.scrollLeft - (G - _.left);
      D.scrollLeft = V === D.firstElementChild || F < M ? 0 : F;
    } else if (_.right > B) {
      const F = D.scrollWidth - D.clientWidth, X = D.scrollLeft + Math.min(_.right - B, _.left - G);
      D.scrollLeft = V === D.lastElementChild || X > F - W ? F : X;
    }
    u(), x = !y();
  }
  Ie(
    () => (s.value || d.value) && y(),
    (D) => {
      D && x && S();
    },
    { flush: "post" }
  );
  function $(D) {
    const V = e.value;
    if (!V) return;
    const Y = typeof window.matchMedia == "function" && window.matchMedia("(prefers-reduced-motion: reduce)").matches, _ = Math.max(V.clientWidth - f() - b(), 1);
    V.scrollBy({ left: D * _, behavior: Y ? "auto" : "smooth" });
  }
  function T(D, V) {
    const Y = e.value;
    if (!Y || !D || document.activeElement !== D) return;
    const _ = Y.querySelectorAll(":scope > [data-button-group-item]"), j = _.length ? _ : Y.querySelectorAll("[role='tab']"), M = V === "first" ? j[0] ?? Y.firstElementChild : j[j.length - 1] ?? Y.lastElementChild;
    M == null || M.focus({ preventScroll: !0 });
  }
  Ie(s, (D) => D || T(n.value, "last")), Ie(d, (D) => D || T(t.value, "first"));
  let L = null, A = 0;
  const R = () => {
    cancelAnimationFrame(A), A = requestAnimationFrame(u);
  };
  function z() {
    if (!L) return;
    L.disconnect();
    const D = e.value;
    !D || !a() || (L.observe(D), Array.from(D.children).forEach((V) => L.observe(V)));
  }
  return ot(async () => {
    var D;
    typeof ResizeObserver < "u" && (L = new ResizeObserver(R)), z(), u(), await qe(), u(), S(), (D = document.fonts) == null || D.ready.then(() => {
      u(), S();
    });
  }), qi(() => {
    z(), u();
  }), Ie(l, () => qe(S)), gt(() => {
    L == null || L.disconnect(), L = null, cancelAnimationFrame(A);
  }), {
    overflowing: r,
    showArrow: s,
    showBackArrow: d,
    measure: u,
    scrollForward: () => $(1),
    scrollBack: () => $(-1)
  };
}
const Mk = {
  key: 0,
  class: "inline-flex flex-col gap-1"
}, Dk = { class: "flex items-center justify-between gap-2.5 px-2" }, zk = ["role", "aria-labelledby"], Ok = ["aria-label"], Pk = ["role", "tabindex"], Fk = ["aria-label"], Vk = ["role"], Nk = /* @__PURE__ */ ye({
  inheritAttrs: !1,
  __name: "ButtonGroup",
  props: {
    variant: { default: "pill" },
    color: { default: () => {
    } },
    size: { default: "sm" },
    labelLeft: { default: () => {
    } },
    labelRight: { default: () => {
    } },
    labelLeftInfo: { default: () => {
    } },
    labelRightInfo: { default: () => {
    } },
    modelValue: { default: () => {
    } },
    panelId: { default: () => {
    } },
    overflowLabel: {},
    overflowPreviousLabel: {}
  },
  emits: ["update:modelValue"],
  setup(e, { emit: n }) {
    const t = n, a = Mn();
    ot(() => {
      var X;
      const G = ((X = a.default) == null ? void 0 : X.call(a, {})) ?? [], B = e.variant === "tab" ? "tab" : "tertiary";
      G.some((H) => {
        var N;
        const q = (N = H.props) == null ? void 0 : N.variant;
        return q !== void 0 && q !== B;
      }) && console.warn(
        `[ButtonGroup] variant="${e.variant}" expects <Button variant="${B}"> children. Other button variants will not render the active state correctly.`
      );
    });
    const l = p(
      () => e.variant === "group" || e.variant === "pill" && e.color === "dark"
    ), r = p(() => l.value && (e.color ?? "dark") === "dark"), o = p(() => e.variant !== "tab" && !!(e.labelLeft || e.labelRight)), i = E(!1);
    let s = 0;
    function d() {
      i.value = !0, cancelAnimationFrame(s), s = requestAnimationFrame(() => {
        s = requestAnimationFrame(() => {
          i.value = !1;
        });
      });
    }
    Ie(() => e.modelValue, (G, B) => {
      B !== void 0 && G !== B && d();
    }), gt(() => cancelAnimationFrame(s));
    const u = p(() => e.variant === "tab" ? ["inline-flex items-center gap-px shadow-(--blur-shadow-xs)", i.value && "button-group-strip--switching"] : [
      i.value && "button-group-strip--switching",
      "button-group-strip inline-flex items-center",
      "rounded-(--border-border-radius-rounded-base)",
      l.value ? ["border border-(--border-border-base-medium) -space-x-px bg-(--colors-white-50-opacity-light) shadow-(--blur-shadow-xs)", r.value && "button-group--dark"] : [
        "gap-0",
        // A scrolling strip clips its items at its padding box: the overflow wrapper's layer draws the surface instead.
        !R.overflowing.value && [
          "border border-(--border-border-base-medium) bg-(--colors-white-50-opacity-medium)",
          e.size !== "xs" && "shadow-(--blur-shadow-xs)"
        ]
      ]
    ]), f = p(() => e.variant === "pill" && !l.value && !o.value), b = E(null), h = E(null), m = {
      xs: { scroll: "scroll-px-8", arrow: "size-[calc(--spacing(8)-2px)]", icon: "text-(length:--icon-size-xs) leading-(--icon-size-xs)" },
      sm: { scroll: "scroll-px-9", arrow: "size-[calc(--spacing(9)-2px)]", icon: "text-(length:--icon-size-sm) leading-(--icon-size-sm)" },
      md: { scroll: "scroll-px-10", arrow: "size-[calc(--spacing(10)-2px)]", icon: "text-(length:--icon-size-sm) leading-(--icon-size-sm)" },
      lg: { scroll: "scroll-px-12", arrow: "size-[calc(--spacing(12)-2px)]", icon: "text-(length:--icon-size-sm) leading-(--icon-size-sm)" }
    }, x = p(() => {
      if (e.modelValue !== void 0)
        return l.value ? "radio" : "tabs";
    }), y = p(() => x.value === "radio" ? "radiogroup" : e.variant === "tab" || x.value === "tabs" ? "tablist" : "group"), w = Fn(), S = Ve(), $ = Ve();
    function T() {
      if (!(!x.value || !o.value || w["aria-label"] || w["aria-labelledby"]))
        return [e.labelLeft && S, e.labelRight && $].filter(Boolean).join(" ");
    }
    const L = ox([]), A = E(null), R = cg({
      strip: A,
      arrow: b,
      backArrow: h,
      enabled: () => f.value,
      selection: () => e.modelValue
    }), z = p(
      () => R.overflowing.value ? [
        "relative isolate inline-flex min-w-0 max-w-full",
        "before:pointer-events-none before:absolute before:inset-0 before:-z-1",
        "before:border before:border-(--border-border-base-medium) before:rounded-(--border-border-radius-rounded-base)",
        "before:bg-(--colors-white-50-opacity-medium)",
        e.size !== "xs" && "before:shadow-(--blur-shadow-xs)"
      ] : "contents"
    ), D = p(() => [
      "max-w-full",
      R.overflowing.value && ["button-group-strip--scroll min-w-0 overflow-x-auto overflow-y-hidden", m[e.size].scroll],
      R.showBackArrow.value && "button-group-strip--clip-start",
      R.showArrow.value && "button-group-strip--clip-end"
    ]), V = (G) => [
      "absolute top-px z-20 inline-flex items-center justify-center cursor-pointer",
      G,
      "rounded-(--border-border-radius-rounded-base) bg-(--background-background-white) hover:bg-(--background-background-hover)",
      "text-(--icons-icon-dark-default) transition-colors duration-150 motion-reduce:transition-none",
      "focus-visible:outline-hidden focus-visible:shadow-(--shadow-focus-l)",
      m[e.size].arrow
    ];
    function Y() {
      L.sort((G, B) => {
        const F = G.el(), X = B.el();
        return !F || !X ? 0 : F.compareDocumentPosition(X) & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : 1;
      });
    }
    qi(Y);
    function _(G) {
      G !== e.modelValue && (d(), t("update:modelValue", G));
    }
    function j(G) {
      const B = L.filter((X) => !X.unreachable() && X.value() !== void 0), F = B.find((X) => X.value() === e.modelValue) ?? B[0];
      return F !== void 0 && F.value() === G;
    }
    const M = (G) => L.find((B) => B.el() === G);
    function W(G) {
      if (!x.value || G.altKey || G.ctrlKey || G.metaKey || !(x.value === "radio" ? ["ArrowRight", "ArrowLeft", "ArrowDown", "ArrowUp", "Home", "End"] : ["ArrowRight", "ArrowLeft", "Home", "End"]).includes(G.key)) return;
      const F = A.value, X = G.currentTarget;
      if (!F || !X) return;
      const H = Array.from(F.querySelectorAll("[data-button-group-item]")).filter(
        (ke) => ke.closest("[data-button-group-strip]") === F
      ), q = (ke) => {
        var ee;
        return ((ee = M(ke)) == null ? void 0 : ee.unreachable()) === !1;
      }, N = H.filter(q);
      if (!N.length) return;
      let J;
      if (G.key === "Home") J = N[0];
      else if (G.key === "End") J = N[N.length - 1];
      else {
        const ke = G.key === "ArrowRight" || G.key === "ArrowDown" ? 1 : -1, ee = H.indexOf(X);
        for (let oe = 1; oe <= H.length && !J; oe++) {
          const ge = H[((ee + ke * oe) % H.length + H.length) % H.length];
          q(ge) && (J = ge);
        }
      }
      if (!J) return;
      G.preventDefault(), G.stopPropagation(), J.focus();
      const be = M(J);
      if (x.value === "radio" && be && !be.blocked()) {
        const ke = be.value();
        ke !== void 0 && _(ke);
      }
    }
    return nn(lg, {
      mode: x,
      isSelected: (G) => G === e.modelValue,
      select: _,
      isTabStop: j,
      register(G) {
        return L.push(G), () => {
          const B = L.indexOf(G);
          B !== -1 && L.splice(B, 1);
        };
      },
      sort: Y,
      onItemKeydown: W,
      panelId: () => x.value === "tabs" ? e.panelId : void 0
    }), (G, B) => o.value ? (c(), g("div", Mk, [
      v("div", Dk, [
        e.labelLeft ? (c(), K(Or, {
          key: 0,
          id: I(S),
          label: e.labelLeft,
          type: "14px",
          "info-right": e.labelLeftInfo,
          "data-testid": "button-group-label-left"
        }, null, 8, ["id", "label", "info-right"])) : k("", !0),
        e.labelRight ? (c(), K(Or, {
          key: 1,
          id: I($),
          label: e.labelRight,
          type: "14px",
          "info-right": e.labelRightInfo,
          "data-testid": "button-group-label-right"
        }, null, 8, ["id", "label", "info-right"])) : k("", !0)
      ]),
      v("div", Oe({
        ref_key: "stripRef",
        ref: A,
        role: y.value,
        "aria-labelledby": T(),
        "data-button-group-strip": ""
      }, G.$attrs, { class: u.value }), [
        $e(G.$slots, "default", {}, void 0, !0)
      ], 16, zk)
    ])) : f.value ? (c(), g("div", {
      key: 1,
      class: C(z.value)
    }, [
      I(R).showBackArrow.value ? (c(), g("button", {
        key: 0,
        ref_key: "backArrowRef",
        ref: h,
        type: "button",
        "aria-label": e.overflowPreviousLabel,
        "data-testid": "button-group-overflow-back-arrow",
        class: C(V("left-px")),
        onClick: B[0] || (B[0] = //@ts-ignore
        (...F) => I(R).scrollBack && I(R).scrollBack(...F))
      }, [
        v("i", {
          class: C(["ri-arrow-left-line", m[e.size].icon]),
          "aria-hidden": "true"
        }, null, 2)
      ], 10, Ok)) : k("", !0),
      v("div", Oe({
        ref_key: "stripRef",
        ref: A,
        role: y.value,
        tabindex: I(R).overflowing.value ? -1 : void 0,
        "data-button-group-strip": ""
      }, G.$attrs, {
        class: [u.value, D.value],
        onScrollPassive: B[1] || (B[1] = //@ts-ignore
        (...F) => I(R).measure && I(R).measure(...F))
      }), [
        $e(G.$slots, "default", {}, void 0, !0)
      ], 16, Pk),
      I(R).showArrow.value ? (c(), g("button", {
        key: 1,
        ref_key: "arrowRef",
        ref: b,
        type: "button",
        "aria-label": e.overflowLabel,
        "data-testid": "button-group-overflow-arrow",
        class: C(V("right-px")),
        onClick: B[2] || (B[2] = //@ts-ignore
        (...F) => I(R).scrollForward && I(R).scrollForward(...F))
      }, [
        v("i", {
          class: C(["ri-arrow-right-line", m[e.size].icon]),
          "aria-hidden": "true"
        }, null, 2)
      ], 10, Fk)) : k("", !0)
    ], 2)) : (c(), g("div", Oe({
      key: 2,
      ref_key: "stripRef",
      ref: A,
      role: y.value,
      "data-button-group-strip": ""
    }, G.$attrs, { class: u.value }), [
      $e(G.$slots, "default", {}, void 0, !0)
    ], 16, Vk));
  }
}), Hk = /* @__PURE__ */ lt(Nk, [["__scopeId", "data-v-f3b2c0c4"]]), jk = ["id"], Wk = ["id"], qk = ["aria-valuemax", "aria-valuenow", "aria-valuetext"], Ss = "text-(length:--size-sm) leading-(--line-height-l) font-(--weight-medium) text-(--text-text-black-default)", Vu = /* @__PURE__ */ ye({
  inheritAttrs: !1,
  __name: "ProgressBar",
  props: {
    value: { default: 0 },
    max: { default: 100 },
    color: { default: "primary" },
    size: { default: "base" },
    labelPosition: { default: "top" },
    label: { default: void 0 },
    valueLabel: { default: void 0 },
    ariaLabel: { default: void 0 }
  },
  setup(e) {
    var A;
    const n = e, t = {
      base: "h-1.5",
      lg: "h-2.5"
    }, a = {
      primary: "bg-[linear-gradient(90deg,var(--gradient-brand-start)_7.4%,var(--gradient-brand-end)_90.2%)]",
      gray: "bg-(--border-border-accessibility)",
      dark: "bg-(--background-background-black-default)",
      success: "bg-(--border-border-success-strong)",
      danger: "bg-(--border-border-error-strong)",
      warning: "bg-(--border-border-warning)"
    }, l = {
      top: "flex-col",
      side: "flex-row items-center",
      bottom: "flex-col"
    }, r = Fn(), o = p(() => ({ class: r.class, style: r.style })), i = p(() => {
      const { class: R, style: z, ...D } = r;
      return D;
    }), s = Ve(), d = p(() => {
      var R;
      return ((R = n.label) == null ? void 0 : R.trim()) || void 0;
    }), u = p(() => {
      var R;
      return ((R = n.valueLabel) == null ? void 0 : R.trim()) || void 0;
    }), f = () => u.value ?? r["aria-valuetext"], b = p(() => !!(d.value || u.value)), h = p(() => n.labelPosition === "side"), m = p(
      () => n.labelPosition === "bottom" ? ["track", "row"] : ["row", "track"]
    ), x = p(() => Number.isFinite(n.max) && n.max > 0 ? n.max : 0), y = p(() => {
      const R = Number.isFinite(n.value) ? n.value : 0;
      return Math.min(Math.max(R, 0), x.value);
    }), w = p(() => x.value > 0 ? y.value / x.value * 100 : 0), S = E(null), $ = (R) => {
      S.value = R ?? null;
    }, T = p(() => {
      var D, V;
      if (r["aria-labelledby"]) return {};
      const R = h.value && !!((D = S.value) != null && D.isTabStop);
      return d.value && !R ? { "aria-labelledby": s } : { "aria-label": (d.value ?? ((V = n.ariaLabel) == null ? void 0 : V.trim())) || void 0 };
    });
    return typeof process < "u" && ((A = process.env) == null ? void 0 : A.NODE_ENV) !== "production" && Ie(
      () => {
        var R;
        return !d.value && !((R = n.ariaLabel) != null && R.trim()) && !r["aria-labelledby"];
      },
      (R) => {
        R && console.warn("[OPAL ProgressBar] No `label` and no `ariaLabel`: the progress bar has no accessible name.");
      },
      { immediate: !0 }
    ), (R, z) => (c(), g("div", Oe(o.value, {
      class: ["flex w-full min-w-0 gap-1.5", l[e.labelPosition]],
      "data-testid": "progress-bar"
    }), [
      (c(!0), g(se, null, Me(m.value, (D) => (c(), g(se, { key: D }, [
        D === "row" && b.value ? (c(), g("div", {
          key: 0,
          class: C(h.value ? "contents" : "flex w-full min-w-0"),
          "data-testid": "progress-bar-label-row"
        }, [
          d.value && h.value ? (c(), g("span", {
            key: 0,
            id: I(s),
            class: "order-first flex min-w-0 max-w-1/2",
            "data-testid": "progress-bar-label"
          }, [
            te(bt, {
              ref_for: !0,
              ref: $,
              text: d.value,
              "text-class": Ss
            }, null, 8, ["text"])
          ], 8, jk)) : d.value ? (c(), g("span", {
            key: 1,
            id: I(s),
            class: C([Ss, "min-w-0 flex-1 break-words"]),
            "data-testid": "progress-bar-label"
          }, P(d.value), 11, Wk)) : k("", !0),
          u.value ? (c(), g("span", {
            key: 2,
            class: C([Ss, "text-right", h.value ? "order-last max-w-1/4 shrink-0 break-words" : "min-w-0 flex-1 break-words"]),
            "aria-hidden": "true",
            "data-testid": "progress-bar-value-label"
          }, P(u.value), 3)) : k("", !0)
        ], 2)) : D === "track" ? (c(), g("div", Oe({
          key: 1,
          ref_for: !0
        }, { ...i.value, ...T.value }, {
          class: ["overflow-hidden rounded-(--border-border-radius-rounded-l) bg-(--background-background-gray)", [t[e.size], h.value ? "min-w-0 flex-1" : "w-full"]],
          role: "progressbar",
          "aria-valuemin": "0",
          "aria-valuemax": x.value > 0 ? x.value : 100,
          "aria-valuenow": y.value,
          "aria-valuetext": f(),
          "data-testid": "progress-bar-track"
        }), [
          v("div", {
            class: C(["h-full rounded-(--border-border-radius-rounded-l) transition-[width] duration-300 motion-reduce:transition-none", a[e.color]]),
            style: Ne({ width: `${w.value}%` }),
            "data-testid": "progress-bar-fill"
          }, null, 6)
        ], 16, qk)) : k("", !0)
      ], 64))), 128))
    ], 16));
  }
}), Uk = ["id"], Gk = ["id", "role"], Kk = ["data-testid"], Yk = {
  key: 3,
  class: "col-start-2 row-start-1 flex shrink-0 items-center"
}, Jk = ["data-testid"], Zk = ["data-testid"], Xk = { class: "min-w-0 break-words" }, Qk = ["data-testid"], _k = {
  key: 1,
  class: "flex min-w-0 flex-col gap-(--spacing-2-5)"
}, ew = ["id"], tw = ["aria-labelledby"], nw = { class: "sr-only" }, aw = ["data-testid"], lw = ["data-testid"], rw = {
  key: 0,
  class: "h-4.5 w-0 shrink-0 border-l-(length:--border-border-width-border) border-(--border-border-base-medium)",
  "aria-hidden": "true"
}, ow = { class: "flex min-w-0 items-center gap-1.5" }, $s = "text-(length:--size-m) leading-(--line-height-l)", vt = /* @__PURE__ */ ye({
  __name: "FieldHelper",
  props: {
    hint: { default: void 0 },
    hintIcon: { default: void 0 },
    hintLines: { default: 1 },
    disabled: { type: Boolean, default: !1 },
    error: { default: void 0 },
    hintId: { default: void 0 },
    errorId: { default: void 0 },
    errorLive: { type: Boolean, default: !0 },
    focused: { type: Boolean, default: !1 },
    testIdPrefix: { default: void 0 },
    endText: { default: void 0 },
    endIcon: { default: void 0 },
    progress: { default: void 0 },
    progressLabel: { default: void 0 },
    checklistTitle: { default: void 0 },
    checklist: { default: void 0 },
    features: { default: void 0 },
    tags: { default: void 0 },
    labels: { default: () => ({ met: "Met", unmet: "Not met", failed: "Failed", progress: "Progress" }) }
  },
  emits: ["endClick", "removeTag"],
  setup(e, { expose: n, emit: t }) {
    const a = e, l = t, r = p(() => !!a.endText), o = p(
      () => {
        var S;
        return a.progress !== void 0 || !!a.checklistTitle || !!((S = a.checklist) != null && S.length);
      }
    ), i = Ve(), s = {
      met: { icon: "ri-checkbox-circle-fill text-(--icons-icon-success)", text: "text-(--text-text-success-strong)" },
      unmet: { icon: "ri-checkbox-blank-circle-line text-(--icons-icon-base)", text: "text-(--text-text-body-subtle)" },
      failed: { icon: "ri-close-circle-fill text-(--icons-icon-error)", text: "text-(--text-text-error-strong)" }
    }, d = p(
      () => r.value ? "min-h-5 grid min-w-0 self-stretch grid-cols-[minmax(0,1fr)_auto] items-center gap-x-(--spacing-2-5) gap-y-px" : "min-h-5 flex min-w-0 self-stretch flex-col gap-px"
    ), u = E(null), f = E(!1), b = p(() => f.value ? !1 : a.focused ? !0 : void 0);
    Ie(
      () => a.focused,
      (S) => {
        S || (f.value = !1);
      }
    );
    const h = (S) => {
      var $;
      S.key !== "Escape" || S.defaultPrevented || f.value || !a.focused || !a.hint || !(($ = u.value) != null && $.isTruncated) || (S.stopPropagation(), S.preventDefault(), f.value = !0);
    }, m = E(null), x = E(null), y = E(null), w = (S) => {
      var $;
      y.value = { index: S, count: (($ = a.tags) == null ? void 0 : $.length) ?? 0 }, l("removeTag", S);
    };
    return Ie(
      () => a.tags,
      (S) => {
        var A, R, z, D;
        const $ = y.value;
        if (y.value = null, !$ || ((S == null ? void 0 : S.length) ?? 0) >= $.count) return;
        const { index: T } = $, L = (A = x.value) == null ? void 0 : A.querySelectorAll(":scope > li button");
        if (L != null && L.length) {
          L[Math.min(Math.max(T - 1, 0), L.length - 1)].focus();
          return;
        }
        (D = (z = (R = m.value) == null ? void 0 : R.parentElement) == null ? void 0 : z.querySelector("input:not([type='hidden']), textarea, select")) == null || D.focus();
      },
      // deep: consumers also splice the array in place
      { flush: "post", deep: !0 }
    ), n({ handleFieldKeydown: h }), (S, $) => {
      var T, L, A, R;
      return c(), g("div", {
        ref_key: "rootRef",
        ref: m,
        "data-field-helper": "",
        class: C(d.value)
      }, [
        e.hint ? (c(), g("span", {
          key: 0,
          id: e.hintId,
          class: "sr-only"
        }, P(e.hint), 9, Uk)) : k("", !0),
        e.error ? (c(), g("span", {
          key: 1,
          id: e.errorId,
          role: e.errorLive ? "alert" : void 0,
          class: "sr-only"
        }, P(e.error), 9, Gk)) : k("", !0),
        e.hint ? (c(), g("div", {
          key: 2,
          "data-testid": e.testIdPrefix ? `${e.testIdPrefix}-hint` : void 0,
          "aria-hidden": "true",
          class: C([
            "flex min-w-0 gap-1 text-(length:--size-sm) leading-(--line-height-l)",
            e.disabled ? "text-(--text-text-disabled-light)" : "text-(--text-text-body) dark:text-(--colors-text-white-default)",
            e.hintLines === 2 ? "items-start" : "items-center"
          ])
        }, [
          !r.value || e.hintIcon ? (c(), g("i", {
            key: 0,
            class: C([
              e.hintIcon ?? "ri-error-warning-line",
              "inline-flex w-3 shrink-0 items-center justify-center text-(length:--size-sm)",
              e.disabled ? "text-(--icons-icon-disabled-light)" : "text-(--icons-icon-dark-default) dark:text-(--icons-icon-white-default)",
              e.hintLines === 2 ? "h-(--line-height-l)" : "h-3"
            ]),
            "aria-hidden": "true"
          }, null, 2)) : k("", !0),
          (c(), K(bt, {
            ref_key: "hintRef",
            ref: u,
            key: e.hintLines,
            text: e.hint,
            lines: e.hintLines,
            "text-class": e.hintLines === 2 ? "whitespace-pre-line" : "",
            focusable: !1,
            open: b.value,
            position: "bottom"
          }, null, 8, ["text", "lines", "text-class", "open"]))
        ], 10, Kk)) : k("", !0),
        r.value ? (c(), g("div", Yk, [
          v("button", {
            type: "button",
            class: "relative inline-flex cursor-pointer items-center gap-1 rounded-(--border-border-radius-rounded-xs) before:absolute before:left-1/2 before:top-1/2 before:h-6 before:w-full before:min-w-6 before:-translate-x-1/2 before:-translate-y-1/2 before:content-[''] text-(length:--size-sm) leading-(--line-height-l) font-(--weight-regular) text-(--text-text-link) focus-visible:outline-hidden focus-visible:shadow-(--shadow-focus-l)",
            "data-testid": e.testIdPrefix ? `${e.testIdPrefix}-end` : void 0,
            onClick: $[0] || ($[0] = (z) => l("endClick"))
          }, [
            e.endIcon ? (c(), g("i", {
              key: 0,
              class: C([e.endIcon, "inline-flex size-3 shrink-0 items-center justify-center text-(length:--size-sm) text-(--icons-icon-link)"]),
              "aria-hidden": "true"
            }, null, 2)) : k("", !0),
            v("span", null, P(e.endText), 1)
          ], 8, Jk)
        ])) : k("", !0),
        e.error ? (c(), g("div", {
          key: 4,
          "data-testid": e.testIdPrefix ? `${e.testIdPrefix}-error` : void 0,
          "aria-hidden": "true",
          class: C([
            "flex min-w-0 items-start gap-1 text-(length:--size-sm) leading-(--line-height-l) text-(--text-text-error-strong) dark:text-(--text-text-error)",
            r.value ? "col-span-full" : ""
          ])
        }, [
          $[1] || ($[1] = v("span", { class: "inline-flex h-(--line-height-l) shrink-0 items-center" }, [
            v("i", {
              class: "ri-close-circle-line inline-flex size-3 items-center justify-center text-(length:--size-sm) text-(--icons-icon-error)",
              "aria-hidden": "true"
            })
          ], -1)),
          v("span", Xk, P(e.error), 1)
        ], 10, Zk)) : k("", !0),
        o.value ? (c(), g("div", {
          key: 5,
          class: "col-span-full flex min-w-0 flex-col gap-(--spacing-2-5)",
          "data-testid": e.testIdPrefix ? `${e.testIdPrefix}-progress` : void 0
        }, [
          e.progress !== void 0 ? (c(), K(Vu, {
            key: 0,
            value: e.progress,
            "aria-label": e.progressLabel ?? e.labels.progress
          }, null, 8, ["value", "aria-label"])) : k("", !0),
          e.checklistTitle || (T = e.checklist) != null && T.length ? (c(), g("div", _k, [
            e.checklistTitle ? (c(), g("span", {
              key: 0,
              id: I(i),
              class: C([$s, "font-(--weight-medium) text-(--text-text-heading) dark:text-(--colors-text-white-default)"])
            }, P(e.checklistTitle), 11, ew)) : k("", !0),
            (L = e.checklist) != null && L.length ? (c(), g("ul", {
              key: 1,
              class: "flex min-w-0 flex-col gap-1.5",
              "aria-labelledby": e.checklistTitle ? I(i) : void 0
            }, [
              (c(!0), g(se, null, Me(e.checklist, (z, D) => (c(), g("li", {
                key: D,
                class: "flex min-w-0 items-center gap-1.5"
              }, [
                v("i", {
                  class: C([
                    s[z.status].icon,
                    "inline-flex size-3.5 shrink-0 items-center justify-center text-(length:--icon-size-xs)"
                  ]),
                  "aria-hidden": "true"
                }, null, 2),
                v("span", {
                  class: C([$s, "min-w-0 flex-1 break-words font-(--weight-regular)", s[z.status].text])
                }, [
                  v("span", nw, P(`${z.statusLabel ?? e.labels[z.status]}: `), 1),
                  at(P(z.text), 1)
                ], 2)
              ]))), 128))
            ], 8, tw)) : k("", !0)
          ])) : k("", !0)
        ], 8, Qk)) : k("", !0),
        (A = e.tags) != null && A.length ? (c(), g("ul", {
          key: 6,
          ref_key: "tagListRef",
          ref: x,
          class: "col-span-full flex min-w-0 flex-wrap items-center gap-(--spacing-2-5)",
          "data-testid": e.testIdPrefix ? `${e.testIdPrefix}-tags` : void 0
        }, [
          (c(!0), g(se, null, Me(e.tags, (z, D) => (c(), g("li", {
            key: `${z.label}-${D}`,
            class: "flex min-w-0"
          }, [
            te(ct, {
              label: z.label,
              theme: "white",
              size: "sm",
              type: "with-avatar",
              "avatar-src": z.avatarSrc,
              "avatar-alt": z.avatarAlt,
              "show-close-icon": "",
              "remove-label": z.removeLabel,
              onClose: (V) => w(D)
            }, null, 8, ["label", "avatar-src", "avatar-alt", "remove-label", "onClose"])
          ]))), 128))
        ], 8, aw)) : k("", !0),
        (R = e.features) != null && R.length ? (c(), g("ul", {
          key: 7,
          class: "col-span-full flex min-w-0 flex-wrap items-center gap-3",
          "data-testid": e.testIdPrefix ? `${e.testIdPrefix}-features` : void 0
        }, [
          (c(!0), g(se, null, Me(e.features, (z, D) => (c(), g("li", {
            key: D,
            class: "flex min-w-0 items-center gap-3"
          }, [
            D > 0 ? (c(), g("span", rw)) : k("", !0),
            v("span", ow, [
              v("i", {
                class: C([
                  z.icon,
                  "inline-flex size-4 shrink-0 items-center justify-center text-(length:--icon-size-sm) text-(--icons-icon-dark-default) dark:text-(--icons-icon-white-default)"
                ]),
                "aria-hidden": "true"
              }, null, 2),
              v("span", {
                class: C([
                  $s,
                  "min-w-0 break-words font-(--weight-regular) text-(--text-text-heading) dark:text-(--colors-text-white-default)"
                ])
              }, P(z.text), 3)
            ])
          ]))), 128))
        ], 8, lw)) : k("", !0)
      ], 2);
    };
  }
}), Rn = /* @__PURE__ */ ye({
  __name: "FieldShell",
  props: {
    size: { default: "md" },
    disabled: { type: Boolean, default: !1 },
    readonly: { type: Boolean, default: !1 },
    error: { type: Boolean, default: !1 },
    success: { type: Boolean, default: !1 },
    focused: { type: Boolean, default: !1 },
    focusScope: { default: "control" },
    hasValue: { type: Boolean, default: !1 },
    rounded: { default: "l" },
    flush: { type: Boolean, default: !1 },
    innerButton: { type: Boolean, default: !1 },
    stacked: { type: Boolean, default: !1 },
    tags: { type: Boolean, default: !1 },
    multiline: { type: Boolean, default: !1 }
  },
  setup(e) {
    const n = e, t = E(!1), a = E(null), l = E(!1), r = p(() => !n.disabled && (n.focused || l.value));
    function o(D) {
      var V;
      return !(D instanceof Element) || !((V = a.value) != null && V.contains(D)) ? !1 : n.focusScope === "any" || D === a.value || D.matches("input, textarea, select");
    }
    function i(D) {
      l.value = o(D.target);
    }
    function s(D) {
      l.value = o(D.relatedTarget);
    }
    Ie(
      () => n.disabled,
      () => {
        l.value = o(document.activeElement);
      }
    );
    const d = {
      sm: {
        height: "h-[32px]",
        container: "h-[32px] px-[calc(--spacing(2)-1px)] py-[calc(--spacing(1.5)-1px)] gap-2",
        text: "text-(length:--size-m) leading-(--line-height-l)"
      },
      md: {
        height: "h-[36px]",
        container: "h-[36px] px-[calc(--spacing(3)-1px)] py-[calc(--spacing(2)-1px)] gap-2",
        text: "text-(length:--size-m) leading-(--line-height-l)"
      },
      lg: {
        height: "h-[48px]",
        container: "h-[48px] px-[calc(--spacing(3.5)-1px)] py-[calc(--spacing(3)-1px)] gap-2",
        text: "text-(length:--size-l) leading-(--line-height-xxl)"
      },
      xl: {
        height: "h-[52px]",
        container: "h-[52px] px-[calc(--spacing(4)-1px)] py-[calc(--spacing(3.5)-1px)] gap-2",
        text: "text-(length:--size-l) leading-(--line-height-xxl)"
      }
    }, u = {
      sm: {
        height: "h-[48px] pr-[calc(--spacing(2)-1px)]",
        container: "h-[48px] pl-[calc(--spacing(2.5)-1px)] pr-[calc(--spacing(2)-1px)] gap-2"
      },
      md: {
        height: "h-[52px] pr-[calc(--spacing(2.5)-1px)]",
        container: "h-[52px] pl-[calc(--spacing(3)-1px)] pr-[calc(--spacing(2.5)-1px)] gap-2"
      },
      lg: {
        height: "h-[56px] pr-[calc(--spacing(3)-1px)]",
        container: "h-[56px] pl-[calc(--spacing(3.5)-1px)] pr-[calc(--spacing(3)-1px)] gap-2"
      },
      xl: {
        height: "h-[60px] pr-[calc(--spacing(3.5)-1px)]",
        container: "h-[60px] pl-[calc(--spacing(4)-1px)] pr-[calc(--spacing(3.5)-1px)] gap-2"
      }
    }, f = {
      sm: {
        container: "h-[56px] p-[calc(--spacing(2)-1px)] flex-col justify-center",
        text: "text-(length:--size-sm) leading-(--line-height-l)",
        topText: "text-(length:--size-m) leading-(--line-height-l)"
      },
      md: {
        container: "h-[62px] p-[calc(--spacing(2.5)-1px)] flex-col justify-center gap-0.5",
        text: "text-(length:--size-sm) leading-(--line-height-l)",
        topText: "text-(length:--size-m) leading-(--line-height-l)"
      },
      lg: {
        container: "h-[70px] p-[calc(--spacing(3)-1px)] flex-col justify-center gap-0.5",
        text: "text-(length:--size-m) leading-(--line-height-l)",
        topText: "text-(length:--size-l) leading-(--line-height-xxl)"
      },
      xl: {
        container: "h-[74px] p-[calc(--spacing(3.5)-1px)] flex-col justify-center gap-0.5",
        text: "text-(length:--size-m) leading-(--line-height-l)",
        topText: "text-(length:--size-l) leading-(--line-height-xxl)"
      }
    }, b = {
      sm: "min-h-[32px] flex-wrap gap-2 py-[calc(--spacing(1)-1px)] px-[calc(--spacing(2)-1px)]",
      md: "min-h-[36px] flex-wrap gap-2 py-[calc(--spacing(1.5)-1px)] px-[calc(--spacing(2.5)-1px)]",
      lg: "min-h-[48px] flex-wrap gap-2 py-[calc(--spacing(2.5)-1px)] px-[calc(--spacing(3)-1px)]",
      xl: "min-h-[52px] flex-wrap gap-2 py-[calc(--spacing(3)-1px)] px-[calc(--spacing(3.5)-1px)]"
    }, h = p(() => d[n.size]), m = p(
      () => n.stacked ? f[n.size].text : h.value.text
    ), x = p(() => n.stacked ? f[n.size].topText : ""), y = p(() => {
      if (n.stacked) return f[n.size].container;
      if (n.tags) return b[n.size];
      if (n.multiline)
        return "h-[144px] overflow-hidden px-[calc(--spacing(3)-1px)] py-[calc(--spacing(2)-1px)]";
      if (n.innerButton) {
        const D = u[n.size];
        return n.flush ? D.height : D.container;
      }
      return n.flush ? `${h.value.height} overflow-hidden` : h.value.container;
    }), w = p(() => {
      const V = `relative ${n.rounded === "full" ? "rounded-full" : "rounded-(--border-border-radius-rounded-l)"} border-solid box-border flex items-center text-left font-inter border-[1px]`, Y = "shadow-[0_0_2px_2px_var(--background-background-hover)]", _ = r.value ? Y : "dark:shadow-(--blur-shadow-m-dark)";
      if (n.disabled)
        return `${V} dark:shadow-(--blur-shadow-m-dark) bg-(--background-background-disabled-opacity) dark:bg-(--colors-background-disabled) border-(--border-border-disabled-subtle) dark:border-(--colors-border-disabled-subtle) text-(--text-text-disabled-light) dark:text-(--colors-text-disabled)`;
      if (n.readonly) {
        const M = r.value ? `${Y} border-(--border-border-accent)` : "border-(--border-border-base-soft) dark:border-(--border-border-base)";
        return `${V} dark:shadow-(--blur-shadow-m-dark) bg-(--background-background-white-secondary-soft) dark:bg-(--colors-background-disabled) ${M} text-(--text-text-black-default) dark:text-(--text-text-white-default) cursor-default`;
      }
      if (n.error)
        return `${V} ${_} bg-(--background-background-white) dark:bg-(--background-background-black-default) border-(--border-border-error-strong) dark:border-(--border-border-error) text-(--text-text-black-default) dark:text-(--text-text-white-default)`;
      if (n.success)
        return `${V} ${_} bg-(--background-background-white) dark:bg-(--background-background-black-default) border-(--border-border-success-strong) dark:border-(--border-border-success-strong) text-(--text-text-black-default) dark:text-(--text-text-white-default)`;
      if (r.value)
        return `${V} ${Y} bg-(--background-background-selected) dark:bg-[rgba(255,255,255,0.05)] border-(--border-border-accent) text-(--text-text-black-default) dark:text-(--text-text-white-default)`;
      if (t.value)
        return `${V} ${Y} bg-(--background-background-white) dark:bg-(--background-background-black-default) border-(--border-border-accent) text-(--text-text-black-default) dark:text-(--text-text-white-default)`;
      const j = n.hasValue ? "text-(--text-text-black-default)" : "text-(--text-text-body-subtle)";
      return `${V} dark:shadow-(--blur-shadow-m-dark) bg-(--background-background-white) dark:bg-(--background-background-black-default) border-(--border-border-base-medium) dark:border-(--border-border-base) ${j} dark:text-(--text-text-white-default)`;
    }), S = p(() => n.disabled ? "text-(--icons-icon-disabled-strong) dark:text-(--text-text-disabled-light)" : n.readonly ? "text-(--icons-icon-dark-default) dark:text-(--icons-icon-white-default)" : n.error ? "text-(--icons-icon-error)" : n.success ? "text-(--icons-icon-success)" : r.value ? "text-(--icons-icon-accent)" : "text-(--icons-icon-dark-default) dark:text-(--icons-icon-white-default)"), $ = p(() => n.disabled ? "border-(--border-border-disabled-subtle) dark:border-(--colors-border-disabled-subtle)" : n.readonly ? r.value ? "border-(--border-border-accent)" : "border-(--border-border-base-soft) dark:border-(--border-border-base)" : n.error ? "border-(--border-border-error-strong) dark:border-(--border-border-error)" : n.success ? "border-(--border-border-success-strong)" : r.value || t.value ? "border-(--border-border-accent)" : "border-(--border-border-base-medium) dark:border-(--border-border-base)"), T = p(() => n.disabled ? "text-(--text-text-disabled-light)" : n.readonly ? "text-(--text-text-black-default) dark:text-(--text-text-white-default)" : n.error ? "text-(--text-text-error-strong) dark:text-(--text-text-error)" : n.success ? "text-(--text-text-success-strong)" : r.value ? "text-(--text-text-accent)" : "text-(--text-text-black-default) dark:text-(--text-text-white-default)"), L = p(
      () => n.stacked && (n.size === "sm" || n.size === "md") ? "inline-flex size-3.5 shrink-0 items-center justify-center text-(length:--icon-size-xs)" : "inline-flex size-4 shrink-0 items-center justify-center text-(length:--size-l)"
    ), A = p(
      () => !n.stacked && (n.size === "lg" || n.size === "xl") ? "inline-flex size-5 shrink-0 items-center justify-center text-(length:--icon-size-md)" : L.value
    ), R = () => {
      !n.disabled && !n.readonly && !n.tags && (t.value = !0);
    }, z = () => {
      t.value = !1;
    };
    return (D, V) => (c(), g("div", {
      ref_key: "rootRef",
      ref: a,
      class: C([w.value, y.value]),
      onFocusin: i,
      onFocusout: s,
      onMouseenter: R,
      onMouseleave: z
    }, [
      $e(D.$slots, "default", {
        hovered: t.value,
        borderColorClass: $.value,
        addonTextClass: T.value,
        iconBoxClass: L.value,
        leftIconBoxClass: A.value,
        iconColorClass: S.value,
        textClass: m.value,
        topTextClass: x.value
      })
    ], 34));
  }
});
function fg(e, n) {
  return n === 1 ? "only" : e === 0 ? "first" : e === n - 1 ? "last" : "middle";
}
const iw = { sm: "xs", md: "sm", lg: "lg", xl: "xl" }, sw = { sm: "xs", md: "xs", lg: "sm", xl: "md" };
function Ra(e, n) {
  return (n === "stacked" ? sw : iw)[e];
}
const dw = {
  l: { left: "rounded-l-(--border-border-radius-rounded-l)", right: "rounded-r-(--border-border-radius-rounded-l)" },
  full: { left: "rounded-l-full", right: "rounded-r-full" }
};
function hg(e, n) {
  const t = dw[n], a = e === "first" || e === "only" ? "" : "-ml-px ", l = {
    first: `${t.left} rounded-r-none`,
    middle: "rounded-l-none rounded-r-none",
    last: `rounded-l-none ${t.right}`,
    only: `${t.left} ${t.right}`
  }[e];
  return { part: `${a}relative hover:z-[1] focus-within:z-[1]`, corners: l };
}
function bg(e) {
  return `flex w-full items-stretch ${e === "full" ? "rounded-full" : "rounded-(--border-border-radius-rounded-l)"} shadow-(--blur-shadow-xs)`;
}
function Yn(e, n) {
  return {
    variant: e.color ?? "secondary",
    label: e.iconOnly ? "" : e.label,
    iconLeft: e.icon,
    iconOnly: !!e.iconOnly,
    dropdownIcon: !!e.dropdown,
    ariaLabel: e.iconOnly ? e.label : e.ariaLabel,
    disabled: n || !!e.disabled,
    "data-field-button": e.id
  };
}
function Nu(e) {
  return { icon: "ri-delete-bin-line", ...e, iconOnly: !0 };
}
const to = /* @__PURE__ */ ye({
  __name: "FieldButtons",
  props: {
    buttons: { default: () => [] },
    layout: { default: "attached" },
    size: { default: "md" },
    rounded: { default: "l" },
    disabled: { type: Boolean, default: !1 },
    buttonSize: { default: void 0 }
  },
  emits: ["button-click"],
  setup(e, { emit: n }) {
    const t = e, a = n, l = Mn(), r = p(() => t.buttons.filter(($) => $.position === "start")), o = p(() => t.buttons.filter(($) => $.position !== "start")), i = p(
      () => t.layout === "stacked" ? [null, ...r.value, ...o.value] : [...r.value, null, ...o.value]
    ), s = p(
      () => t.buttonSize ?? Ra(t.size, t.layout)
    ), d = p(() => t.layout === "attached"), u = p(() => t.layout === "stacked" ? "flex w-full flex-col gap-4" : t.layout === "spaced" ? "flex w-full items-center gap-4" : bg(t.rounded)), f = () => l.leading ? 1 : 0, b = () => f() + t.buttons.length > 0, h = () => f() + r.value.length + 1 + o.value.length, m = () => f() + r.value.length;
    function x($) {
      return hg(fg($, h()), t.rounded);
    }
    function y() {
      return t.layout === "stacked" ? "w-full" : d.value ? `min-w-0 flex-1 ${x(m()).part}` : "min-w-0 flex-1";
    }
    function w() {
      return d.value ? x(m()).corners : "";
    }
    function S($) {
      if (!d.value) return "";
      const { part: T, corners: L } = x($);
      return `${T} ${L}`;
    }
    return ($, T) => b() ? (c(), g("div", {
      key: 1,
      class: C(u.value)
    }, [
      $e($.$slots, "leading", {
        partClass: S(0),
        buttonSize: s.value
      }),
      (c(!0), g(se, null, Me(i.value, (L, A) => (c(), g(se, {
        key: L ? `button-${L.id}` : "field"
      }, [
        L ? (c(), K(Re, Oe({
          key: 1,
          class: S(f() + A)
        }, { ref_for: !0 }, I(Yn)(L, e.disabled), {
          size: s.value,
          "full-width": e.layout === "stacked",
          onClick: (R) => a("button-click", L.id)
        }), null, 16, ["class", "size", "full-width", "onClick"])) : (c(), g("div", {
          key: 0,
          class: C(y())
        }, [
          $e($.$slots, "default", {
            fieldClass: w()
          })
        ], 2))
      ], 64))), 128))
    ], 2)) : $e($.$slots, "default", {
      key: 0,
      fieldClass: ""
    });
  }
});
function Kl(e, n, t) {
  return e && n ? {
    root: "grid grid-cols-[auto_minmax(0,1fr)] items-center gap-x-4 gap-y-0.5",
    label: "",
    field: "col-start-2",
    helper: "col-start-2",
    remove: "",
    removeInFieldRow: !0,
    reservesHelper: !1
  } : t ? {
    root: "grid grid-cols-[minmax(0,1fr)_auto] gap-x-3 gap-y-0.5",
    label: "col-start-1",
    field: "col-start-1",
    helper: "col-start-1",
    remove: `col-start-2 self-end ${n ? "row-start-2" : "row-start-1"}`,
    removeInFieldRow: !1,
    reservesHelper: !0
  } : {
    root: "flex flex-col items-start gap-0.5",
    label: "",
    field: "",
    helper: "",
    remove: "",
    removeInFieldRow: !1,
    reservesHelper: !0
  };
}
const uw = ["src"], cw = ["src"], fw = ["id", "name", "value", "placeholder", "disabled", "aria-label", "aria-labelledby", "aria-disabled", "aria-invalid", "aria-describedby", "aria-required"], hw = ["aria-label", "onKeydown"], bw = ["src"], gw = /* @__PURE__ */ ye({
  __name: "SearchInput",
  props: {
    label: { default: void 0 },
    required: { type: Boolean, default: !1 },
    requiredIndicator: { default: "*" },
    labelTooltip: { default: void 0 },
    helpIcon: { default: void 0 },
    labelInline: { type: Boolean, default: !1 },
    placeholder: { default: void 0 },
    modelValue: { default: "" },
    iconLeft: { default: void 0 },
    iconRight: { default: void 0 },
    showSearchIcon: { type: Boolean, default: !0 },
    size: { default: "md" },
    disabled: { type: Boolean, default: !1 },
    name: { default: void 0 },
    id: { default: void 0 },
    fullWidth: { type: Boolean, default: !1 },
    width: { default: void 0 },
    rounded: { default: "full" },
    hint: { default: void 0 },
    error: { default: void 0 },
    labels: { default: () => ({ clear: "Clear search" }) },
    buttons: { default: () => [] },
    buttonLayout: { default: "attached" },
    buttonSize: { default: void 0 },
    innerButton: { default: void 0 },
    ariaLabel: { default: void 0 },
    ariaLabelledby: { default: void 0 }
  },
  emits: ["update:modelValue", "input", "focus", "blur", "keydown", "search", "clear", "button-click"],
  setup(e, { emit: n }) {
    const t = e, a = n, l = Ve(), r = p(() => t.id || l), o = p(() => `${r.value}-hint`), i = p(() => `${r.value}-error`), s = E(!1), d = E(null), u = E(null), f = E(null), b = p(() => t.rounded === "full" ? "full" : "l"), h = p(() => !!t.modelValue && t.modelValue.trim() !== ""), m = p(() => !!t.hint || !!t.error), x = p(() => t.buttons.length > 0), y = p(() => {
      const j = [];
      return t.hint && j.push(o.value), t.error && j.push(i.value), j.length > 0 ? j.join(" ") : void 0;
    }), w = p(() => s.value && h.value && !t.disabled), S = p(() => Kl(t.labelInline, !!t.label, !1)), $ = p(() => t.fullWidth || t.width === void 0), T = p(() => t.labelInline && !!t.label && !$.value), L = (j) => !!j && j.startsWith("ri-"), A = p(() => $.value ? {} : { width: t.width }), R = p(() => x.value ? { style: A.value } : {}), z = (j) => {
      const M = j.target;
      a("update:modelValue", M.value), a("input", j);
    }, D = (j) => {
      var M, W;
      a("keydown", j), j.key === "Enter" && !j.isComposing && a("search", j.target.value), j.key === "Escape" && !j.isComposing && t.modelValue && !t.disabled && (j.preventDefault(), j.stopPropagation(), _()), (M = u.value) == null || M.handleFieldKeydown(j), (W = f.value) == null || W.handleFieldKeydown(j);
    }, V = (j) => {
      t.disabled || (s.value = !0), a("focus", j);
    }, Y = (j) => {
      s.value = !1, a("blur", j);
    }, _ = () => {
      var j;
      a("update:modelValue", ""), a("clear"), (j = d.value) == null || j.focus();
    };
    return (j, M) => (c(), g("div", {
      class: C([
        "relative min-w-0 text-left text-(length:--size-m) text-(--text-text-black-default) dark:text-(--colors-text-white-default) font-inter",
        T.value ? "w-fit" : "w-full",
        S.value.root
      ])
    }, [
      e.label ? (c(), g("div", {
        key: 0,
        class: C(["flex min-w-0 max-w-full items-center gap-1", S.value.label])
      }, [
        te(xt, {
          ref_key: "labelRef",
          ref: u,
          text: e.label,
          "input-id": r.value,
          required: e.required,
          "required-indicator": e.requiredIndicator,
          tooltip: e.labelTooltip,
          focused: s.value,
          inline: e.labelInline,
          "test-id": "search-input-label"
        }, null, 8, ["text", "input-id", "required", "required-indicator", "tooltip", "focused", "inline"]),
        e.helpIcon && !e.labelTooltip ? (c(), g("img", {
          key: 0,
          src: e.helpIcon,
          class: "h-3 w-3 relative search-input-icon",
          alt: ""
        }, null, 8, uw)) : k("", !0)
      ], 2)) : k("", !0),
      v("div", {
        class: C(["flex w-full", S.value.field])
      }, [
        te(to, Oe({
          buttons: e.buttons,
          layout: e.buttonLayout,
          size: e.size,
          rounded: b.value,
          disabled: e.disabled,
          "button-size": e.buttonSize
        }, R.value, {
          onButtonClick: M[2] || (M[2] = (W) => a("button-click", W))
        }), {
          default: ve(({ fieldClass: W }) => [
            te(Rn, {
              size: e.size,
              rounded: b.value,
              "inner-button": !!e.innerButton,
              disabled: e.disabled,
              error: !!e.error,
              "has-value": h.value,
              class: C([
                x.value || $.value ? "w-full" : "",
                x.value && e.buttonLayout === "attached" ? "min-h-full" : "",
                W
              ]),
              style: Ne(x.value ? {} : A.value)
            }, {
              default: ve(({ iconBoxClass: G, leftIconBoxClass: B, iconColorClass: F, textClass: X }) => [
                e.showSearchIcon ? (c(), g(se, { key: 0 }, [
                  !e.iconLeft || L(e.iconLeft) ? (c(), g("i", {
                    key: 0,
                    class: C([e.iconLeft || "ri-search-line", B, F]),
                    "aria-hidden": "true"
                  }, null, 2)) : (c(), g("img", {
                    key: 1,
                    src: e.iconLeft,
                    class: C([B, "search-input-icon"]),
                    alt: ""
                  }, null, 10, cw))
                ], 64)) : k("", !0),
                v("input", {
                  id: r.value,
                  ref_key: "inputRef",
                  ref: d,
                  name: e.name,
                  "data-testid": "search-input",
                  type: "search",
                  value: e.modelValue,
                  placeholder: e.placeholder,
                  disabled: e.disabled,
                  "aria-label": e.label || e.ariaLabelledby ? void 0 : e.ariaLabel ?? e.placeholder,
                  "aria-labelledby": e.label ? void 0 : e.ariaLabelledby,
                  "aria-disabled": e.disabled ? "true" : void 0,
                  "aria-invalid": e.error ? "true" : void 0,
                  "aria-describedby": y.value,
                  "aria-required": e.required ? "true" : void 0,
                  class: C([
                    "flex-1 min-w-0 text-ellipsis relative bg-transparent border-0 outline-none focus:outline-none focus:ring-0 focus:border-0 p-0 placeholder:text-(--text-text-body-subtle) dark:placeholder:text-(--colors-text-white-secondary) [&::-webkit-search-cancel-button]:appearance-none [&::-webkit-search-decoration]:appearance-none",
                    X
                  ]),
                  onInput: z,
                  onFocus: V,
                  onBlur: Y,
                  onKeydown: D
                }, null, 42, fw),
                w.value ? (c(), g("i", {
                  key: 1,
                  class: C(["ri-close-fill cursor-pointer text-(--icons-icon-dark-default) dark:text-(--icons-icon-white-default)", G]),
                  role: "button",
                  tabindex: "-1",
                  "aria-label": e.labels.clear,
                  "data-testid": "search-input-clear",
                  onMousedown: M[0] || (M[0] = Ue(() => {
                  }, ["prevent"])),
                  onClick: Ue(_, ["stop"]),
                  onKeydown: [
                    ut(_, ["enter"]),
                    ut(Ue(_, ["prevent"]), ["space"])
                  ]
                }, null, 42, hw)) : k("", !0),
                e.iconRight ? (c(), g("img", {
                  key: 2,
                  src: e.iconRight,
                  class: C([G, "search-input-icon"]),
                  alt: ""
                }, null, 10, bw)) : k("", !0),
                e.innerButton ? (c(), K(Re, Oe({ key: 3 }, I(Yn)(e.innerButton, e.disabled), {
                  size: "xs",
                  onClick: M[1] || (M[1] = (H) => a("button-click", e.innerButton.id))
                }), null, 16)) : k("", !0)
              ]),
              _: 1
            }, 8, ["size", "rounded", "inner-button", "disabled", "error", "has-value", "class", "style"])
          ]),
          _: 1
        }, 16, ["buttons", "layout", "size", "rounded", "disabled", "button-size"])
      ], 2),
      m.value ? (c(), K(vt, {
        key: 1,
        ref_key: "helperRef",
        ref: f,
        class: C(S.value.helper),
        focused: s.value,
        hint: e.hint,
        error: e.error,
        "hint-id": o.value,
        "error-id": i.value,
        disabled: e.disabled,
        "test-id-prefix": "search-input"
      }, null, 8, ["class", "focused", "hint", "error", "hint-id", "error-id", "disabled"])) : k("", !0)
    ], 2));
  }
}), Yi = /* @__PURE__ */ lt(gw, [["__scopeId", "data-v-fbb12341"]]), pw = {
  key: 0,
  "data-testid": "dropdown-panel-header-labels",
  class: "flex items-center justify-between gap-2.5 px-2"
}, sl = /* @__PURE__ */ ye({
  __name: "DropdownPanelHeader",
  props: {
    labelLeft: { default: void 0 },
    labelLeftInfo: { default: void 0 },
    labelRight: { default: void 0 },
    labelRightInfo: { default: void 0 },
    showSearch: { type: Boolean, default: !1 },
    searchQuery: { default: "" },
    searchPlaceholder: { default: void 0 },
    searchLabel: { default: void 0 },
    searchClearLabel: { default: "Clear search" },
    groupButtons: { default: () => [] },
    activeGroup: { default: void 0 },
    groupLabelLeft: { default: void 0 },
    groupLabelLeftInfo: { default: void 0 },
    groupLabelRight: { default: void 0 },
    groupLabelRightInfo: { default: void 0 },
    groupAriaLabel: { default: void 0 }
  },
  emits: ["update:searchQuery", "update:activeGroup"],
  setup(e, { expose: n, emit: t }) {
    const a = e, l = t, r = Ve(), o = Ve(), i = p(() => !!(a.labelLeft || a.labelRight)), s = p(() => {
      if (!(a.searchLabel || !i.value))
        return [a.labelLeft && r, a.labelRight && o].filter(Boolean).join(" ");
    }), d = p(() => !!(a.groupLabelLeft || a.groupLabelRight)), u = E(null);
    function f() {
      var h;
      const b = (h = u.value) == null ? void 0 : h.querySelector('[data-testid="search-input"]');
      return b == null || b.focus({ preventScroll: !0 }), !!b;
    }
    return n({ focusSearch: f }), (b, h) => (c(), g("div", {
      ref_key: "rootRef",
      ref: u,
      "data-testid": "dropdown-panel-header",
      class: "relative flex flex-col gap-3 border-b border-(--border-border-base-soft) bg-(--background-background-white) px-3 pt-4 pb-[calc(--spacing(4)-1px)] shadow-(--shadow-bottom-dropdown) dark:border-(--colors-border-base) dark:bg-(--colors-background-black-default) dark:shadow-(--shadow-bottom-dropdown-dark)"
    }, [
      i.value ? (c(), g("div", pw, [
        e.labelLeft ? (c(), K(Or, {
          key: 0,
          id: I(r),
          label: e.labelLeft,
          "info-right": e.labelLeftInfo,
          "data-testid": "dropdown-panel-header-label-left"
        }, null, 8, ["id", "label", "info-right"])) : k("", !0),
        e.labelRight ? (c(), K(Or, {
          key: 1,
          id: I(o),
          label: e.labelRight,
          "info-right": e.labelRightInfo,
          class: "ml-auto",
          "data-testid": "dropdown-panel-header-label-right"
        }, null, 8, ["id", "label", "info-right"])) : k("", !0)
      ])) : k("", !0),
      e.showSearch ? (c(), K(Yi, {
        key: 1,
        "model-value": e.searchQuery,
        placeholder: e.searchPlaceholder,
        "aria-label": e.searchLabel,
        "aria-labelledby": s.value,
        labels: { clear: e.searchClearLabel },
        size: "sm",
        "full-width": "",
        "onUpdate:modelValue": h[0] || (h[0] = (m) => l("update:searchQuery", m))
      }, null, 8, ["model-value", "placeholder", "aria-label", "aria-labelledby", "labels"])) : k("", !0),
      e.groupButtons.length ? (c(), K(Hk, {
        key: 2,
        "model-value": e.activeGroup ?? "",
        variant: "group",
        color: "dark",
        size: "sm",
        "label-left": e.groupLabelLeft,
        "label-left-info": e.groupLabelLeftInfo,
        "label-right": e.groupLabelRight,
        "label-right-info": e.groupLabelRightInfo,
        "aria-label": d.value ? void 0 : e.groupAriaLabel,
        class: "w-full",
        "data-testid": "dropdown-panel-header-group",
        "onUpdate:modelValue": h[1] || (h[1] = (m) => l("update:activeGroup", String(m)))
      }, {
        default: ve(() => [
          (c(!0), g(se, null, Me(e.groupButtons, (m) => (c(), K(Re, {
            key: m.value,
            variant: "tertiary",
            size: "sm",
            label: m.label,
            value: m.value,
            shrink: "",
            class: "flex-1"
          }, null, 8, ["label", "value"]))), 128))
        ]),
        _: 1
      }, 8, ["model-value", "label-left", "label-left-info", "label-right", "label-right-info", "aria-label"])) : k("", !0)
    ], 512));
  }
});
function no() {
  const e = E(0);
  function n(o, i) {
    var s;
    o && ((s = o.querySelector(`[data-listbox-index="${i}"]`)) == null || s.focus());
  }
  function t(o, i) {
    for (let s = 0; s < o; s++)
      if (!(i != null && i(s))) return s;
    return 0;
  }
  function a(o, i, s) {
    if (i === 0) return;
    let d;
    switch (o.key) {
      case "ArrowDown":
        d = (e.value + 1) % i;
        break;
      case "ArrowUp":
        d = (e.value - 1 + i) % i;
        break;
      case "Home":
        d = 0;
        break;
      case "End":
        d = i - 1;
        break;
      default:
        return;
    }
    o.preventDefault(), o.stopPropagation(), e.value = d, n(s, d);
  }
  function l(o, i, s, { downIndex: d = 0, upIndex: u = i - 1 } = {}) {
    if (o.key !== "ArrowDown" && o.key !== "ArrowUp" || i === 0) return !1;
    const f = o.key === "ArrowDown" ? d : u, b = s == null ? void 0 : s.querySelector(`[data-listbox-index="${f}"]`);
    return b ? (o.preventDefault(), e.value = f, b.focus({ preventScroll: !0 }), b.scrollIntoView({ block: "nearest" }), !0) : !1;
  }
  function r(o) {
    e.value = Math.min(e.value, Math.max(0, o - 1));
  }
  return {
    focusedIndex: e,
    focusListboxOption: n,
    handleRovingKeydown: a,
    handleSearchFieldKeydown: l,
    clampFocusedIndex: r,
    firstEnabledIndex: t
  };
}
const Hu = Symbol("FieldGroup"), mw = { part: "", corners: "" };
function ju(e) {
  const n = Ft(Hu, null);
  let t = null;
  return ot(() => {
    t = e.value, n && t && n.register(t);
  }), gt(() => {
    n && t && n.unregister(t);
  }), {
    inGroup: !!n,
    groupPart: p(() => n ? n.partOf(e.value) : mw)
  };
}
const vw = ["src"], xw = ["src"], yw = ["name", "value"], kw = ["id", "aria-expanded", "aria-haspopup", "aria-labelledby", "aria-label", "aria-describedby", "aria-disabled", "aria-readonly", "aria-required", "aria-invalid", "tabindex", "onClick", "onKeydown"], ww = {
  key: 0,
  class: "inline-flex size-4 shrink-0 items-center justify-center",
  "aria-hidden": "true",
  "data-testid": "select-prefix-flag"
}, Cw = ["src"], Sw = {
  key: 2,
  class: "flex min-w-0 flex-1",
  "data-testid": "select-value"
}, $w = ["src"], Iw = ["role", "aria-labelledby", "aria-label"], Tw = ["onKeydown"], Lw = {
  key: 1,
  "aria-live": "polite",
  role: "status",
  class: "sr-only",
  "data-testid": "select-status"
}, Ew = {
  key: 0,
  "data-testid": "select-results-heading",
  class: "flex shrink-0 px-2.5 pt-2 text-(length:--size-m) leading-(--line-height-l) font-(--weight-semi-bold) text-(--text-text-heading) dark:text-(--colors-text-white-default)"
}, Aw = ["aria-labelledby", "aria-label"], Rw = ["aria-labelledby"], Bw = ["id"], Mw = {
  "data-testid": "select-no-results",
  class: "flex px-2.5 py-2 text-(length:--size-m) leading-(--line-height-l) font-(--weight-semi-bold) text-(--text-text-heading) dark:text-(--colors-text-white-default)"
}, mo = -1, Tl = /* @__PURE__ */ ye({
  __name: "SelectInput",
  props: {
    placeholder: { default: void 0 },
    modelValue: { default: "" },
    options: {},
    size: { default: "md" },
    disabled: { type: Boolean, default: !1 },
    name: { default: void 0 },
    id: { default: void 0 },
    fullWidth: { type: Boolean, default: !1 },
    width: { default: "384px" },
    label: { default: void 0 },
    ariaLabel: { default: void 0 },
    required: { type: Boolean, default: !1 },
    requiredIndicator: { default: "*" },
    labelTooltip: { default: void 0 },
    labelInline: { type: Boolean, default: !1 },
    helpIcon: { default: void 0 },
    prefixIcon: { default: void 0 },
    prefixFlag: { default: void 0 },
    iconLeft: { default: void 0 },
    error: { default: void 0 },
    errorLive: { type: Boolean, default: !0 },
    hint: { default: void 0 },
    noResultsLabel: { default: void 0 },
    readonly: { type: Boolean, default: !1 },
    searchable: { type: Boolean, default: !1 },
    searchPlaceholder: { default: void 0 },
    searchLabel: { default: void 0 },
    resultsCountLabel: { type: [String, Function], default: "{count} results" },
    resultsLabel: { default: void 0 },
    seeAllLabel: { default: void 0 },
    createLabel: { default: void 0 },
    createIcon: { default: "ri-add-line" },
    buttons: { default: () => [] },
    buttonLayout: { default: "attached" },
    buttonSize: { default: void 0 }
  },
  emits: ["update:modelValue", "change", "focus", "blur", "see-all", "create", "button-click"],
  setup(e, { emit: n }) {
    const t = e, a = n, l = Ve(), r = p(() => t.id || l), o = p(() => t.label ? `${r.value}-label` : void 0), i = p(() => `${r.value}-error`), s = p(() => `${r.value}-hint`), d = p(() => !!t.error), u = p(
      () => t.options.find((me) => !me.heading && me.value === t.modelValue) ?? null
    ), f = p(() => {
      var Ae;
      const me = (Ae = u.value) == null ? void 0 : Ae.iconColor;
      return me && !t.disabled ? sg[me] : void 0;
    }), b = p(() => {
      var me;
      return ((me = u.value) == null ? void 0 : me.label) ?? "";
    }), h = p(() => {
      const me = [];
      return t.hint && me.push(s.value), d.value && me.push(i.value), me.length > 0 ? me.join(" ") : void 0;
    }), m = E(!1), x = E(null), y = E(null), w = E(null), S = (me) => {
      var Ae, Ke;
      (Ae = y.value) == null || Ae.handleFieldKeydown(me), (Ke = w.value) == null || Ke.handleFieldKeydown(me);
    }, $ = {
      sm: { container: "h-8 px-[calc(--spacing(2)-1px)] gap-2", text: "text-(length:--size-m) leading-(--line-height-l)", icon: "h-4 w-4" },
      md: { container: "h-9 px-3 py-2 gap-2", text: "text-(length:--size-m) leading-(--line-height-l)", icon: "h-4 w-4" },
      lg: { container: "h-12 px-3.5 gap-2", text: "text-(length:--size-l) leading-(--line-height-xxl)", icon: "h-5 w-5" },
      xl: { container: "h-13 px-4 gap-2", text: "text-(length:--size-l) leading-(--line-height-xxl)", icon: "h-5 w-5" }
    }, T = p(() => $[t.size]), L = (me) => {
      const Ae = "relative flex items-center w-full rounded-xl border border-solid box-border text-left font-inter transition-colors select-none focus:outline-none";
      if (t.disabled)
        return `${Ae} bg-gainsboro-200 border-border-disabled-subtle text-text-disabled dark:bg-(--colors-background-disabled) dark:border-(--colors-border-disabled-subtle) dark:text-(--colors-text-disabled)`;
      if (t.readonly) {
        const Ke = m.value ? "border-(--border-border-accent) shadow-[0px_0px_2px_var(--border-border-accent)]" : "border-(--border-border-base-soft) dark:border-(--border-border-base)";
        return `${Ae} cursor-default bg-(--colors-background-white-secondary-soft) dark:bg-(--colors-background-disabled) ${Ke} text-text-black-default dark:text-(--colors-text-white-default)`;
      }
      if (d.value) {
        const Ke = m.value ? " shadow-[0px_0px_2px_var(--border-border-accent)]" : "";
        return `${Ae} cursor-pointer bg-white border-(--border-border-error-strong) text-text-black-default dark:bg-(--colors-background-black-default) dark:border-(--border-border-error) dark:text-(--colors-text-white-default)${Ke}`;
      }
      return m.value || me ? `${Ae} cursor-pointer bg-(--background-background-selected) border-(--border-border-accent) shadow-[0px_0px_2px_var(--border-border-accent)] text-text-black-default dark:bg-[rgba(255,255,255,0.05)] dark:text-(--colors-text-white-default)` : `${Ae} cursor-pointer bg-(--background-background-white) border-(--border-border-base-medium) hover:border-(--border-border-accent) text-text-black-default dark:bg-(--colors-background-black-default) dark:border-(--colors-border-base) dark:text-(--colors-text-white-default)`;
    }, A = p(() => !!t.label || t.labelInline && !!t.iconLeft), R = p(() => t.labelInline && A.value), z = p(() => Kl(t.labelInline, A.value, !1)), D = E(null), { inGroup: V, groupPart: Y } = ju(D), _ = p(() => t.fullWidth || V), j = p(() => {
      const me = `relative ${V ? Y.value.part : "pb-0.5"} text-sm text-text-black-default dark:text-(--colors-text-white-default) font-inter`, Ae = R.value ? z.value.root : "flex flex-col gap-0.5";
      return `${me} ${Ae} ${_.value ? "w-full" : ""}`;
    }), M = {
      xs: "min-h-8",
      sm: "min-h-9",
      md: "min-h-10",
      lg: "min-h-12",
      xl: "min-h-13"
    }, W = p(
      () => t.buttons.length > 0 && t.buttonLayout === "attached" ? M[t.buttonSize ?? Ra(t.size, "attached")] : ""
    ), G = p(() => _.value ? {} : { width: t.width }), B = p(() => t.labelInline && !_.value ? { width: t.width } : _.value ? {} : { width: t.width }), F = (me) => !!me && me.startsWith("ri-"), X = (me) => {
      a("update:modelValue", me), a("change", me);
    }, H = (me, Ae) => {
      me.disabled || (X(me.value), ge.reset(), Ae(), qe(() => {
        var Ke;
        return (Ke = x.value) == null ? void 0 : Ke.focus();
      }));
    }, q = (me, Ae, Ke) => {
      ge.query.value.length > 0 || (Ke.preventDefault(), Ke.stopPropagation(), H(me, Ae));
    }, N = E(null), { focusedIndex: J, focusListboxOption: be, handleRovingKeydown: ke, handleSearchFieldKeydown: ee, firstEnabledIndex: oe } = no(), ge = Fu(), re = E(""), ue = E(null), O = E(null), U = p(() => {
      const me = Aa(ge.query.value.trim()), Ae = [{ options: [] }];
      let Ke = 0;
      return t.options.forEach((Je, _e) => {
        if (Je.disabled, Je.label, Je.value, Je.heading) {
          Ae.push({ heading: Je, headingId: `${r.value}-group-${_e}`, options: [] });
          return;
        }
        (t.searchable ? Pu(Je.label, re.value) : !me || Aa(Je.label).startsWith(me)) && Ae[Ae.length - 1].options.push({ option: Je, index: Ke++ });
      }), Ae.filter((Je) => Je.options.length > 0);
    }), Q = p(
      () => U.value.flatMap((me) => me.options.map(({ option: Ae }) => Ae))
    ), ae = (me) => {
      var Ae;
      return ((Ae = Q.value[me]) == null ? void 0 : Ae.disabled) === !0;
    };
    function Z() {
      if (Q.value.length === 0) return mo;
      const me = Q.value.findIndex((Ae) => Ae.value === t.modelValue);
      return me >= 0 ? me : oe(Q.value.length, ae);
    }
    function ie(me) {
      be(N.value, me);
    }
    Ie(
      N,
      (me) => {
        var Ae;
        if (!me) {
          ge.reset(), re.value = "";
          return;
        }
        if (J.value = Z(), t.searchable) {
          (Ae = O.value) == null || Ae.focusSearch();
          return;
        }
        J.value === mo ? me.focus() : ie(J.value);
      },
      { flush: "post" }
    ), Ie(
      Q,
      () => {
        var Ae, Ke, Je;
        if (!N.value) return;
        if ((Ae = ue.value) != null && Ae.contains(document.activeElement)) {
          J.value = Z();
          return;
        }
        if (document.activeElement !== N.value && N.value.contains(document.activeElement)) {
          const _e = Number(
            (Ke = document.activeElement.closest("[data-listbox-index]")) == null ? void 0 : Ke.dataset.listboxIndex
          );
          if (!Number.isNaN(_e)) {
            J.value = _e;
            return;
          }
        }
        J.value = Math.min(Math.max(J.value, 0), Q.value.length - 1), J.value === mo ? t.searchable ? (Je = O.value) == null || Je.focusSearch() : N.value.focus() : ie(J.value);
      },
      { flush: "post" }
    );
    const fe = (me) => me.key.length === 1 && !me.ctrlKey && !me.metaKey && !me.altKey;
    function de(me) {
      var Ae;
      if (t.searchable) {
        if (me.key === "Tab" && (me.shiftKey || xe.value)) {
          me.stopPropagation();
          return;
        }
        const Ke = me.key === "Backspace";
        if (Ke || fe(me) && me.key !== " ") {
          me.preventDefault(), me.stopPropagation(), re.value = Ke ? re.value.slice(0, -1) : re.value + me.key, (Ae = O.value) == null || Ae.focusSearch();
          return;
        }
      } else if (ge.handleKey(me)) {
        me.preventDefault(), me.stopPropagation();
        return;
      }
      ke(me, Q.value.length, N.value);
    }
    const ne = (me, Ae) => ({
      ...{
        type: me.badgeTheme ? "badge" : t.searchable ? "autocomplete" : "default",
        label: me.label,
        icon: me.badgeTheme ? void 0 : me.icon,
        iconColor: me.iconColor,
        badge: me.badgeTheme ? { label: me.label, theme: me.badgeTheme, icon: me.icon } : void 0,
        highlighted: me.value === t.modelValue,
        ariaDisabled: !!me.disabled,
        description: me.disabled ? me.disabledReason : void 0
      },
      role: "option",
      "aria-selected": me.value === t.modelValue,
      tabindex: Ae === J.value ? 0 : -1,
      "data-listbox-index": Ae,
      "data-testid": `select-option-${me.value}`,
      style: me.fontFamily ? { fontFamily: me.fontFamily } : void 0
    }), le = (me, Ae, Ke) => ({
      click: () => H(me, Ke),
      focus: () => {
        J.value = Ae;
      },
      keydown: (Je) => {
        Je.key === "Enter" ? (Je.preventDefault(), H(me, Ke)) : Je.key === " " && q(me, Ke, Je);
      }
    }), Le = p(
      () => t.searchLabel ?? t.searchPlaceholder ?? t.label ?? t.ariaLabel
    ), Te = p(() => {
      if (!(t.searchable ? re.value : ge.query.value)) return "";
      const Ae = Q.value.length;
      return t.searchable ? Ae === 0 && t.noResultsLabel ? t.noResultsLabel : Du(t.resultsCountLabel, Ae) : String(Ae);
    }), xe = p(() => t.searchable && !!(t.seeAllLabel || t.createLabel)), we = (me) => {
      me(), qe(() => {
        var Ae;
        return (Ae = x.value) == null ? void 0 : Ae.focus();
      });
    };
    function he(me, Ae) {
      we(Ae), a(me === "see-all" ? "see-all" : "create");
    }
    function De(me, Ae) {
      const Ke = Q.value.length;
      switch (me.key) {
        case "ArrowDown":
        case "ArrowUp":
          me.preventDefault(), me.stopPropagation(), ee(me, Ke, N.value, { downIndex: Math.max(J.value, 0) });
          break;
        case "Home":
        case "End":
          me.stopPropagation();
          break;
        case "Tab":
          me.shiftKey ? (me.preventDefault(), me.stopPropagation(), we(Ae)) : (J.value !== mo || xe.value) && me.stopPropagation();
          break;
      }
    }
    function Ee(me) {
      if (me.key !== "Tab") return;
      const Ae = me.currentTarget.querySelectorAll("button, a[href]");
      (me.shiftKey || me.target !== Ae[Ae.length - 1]) && me.stopPropagation();
    }
    let je = !1;
    const Ge = (me) => {
      var Ae;
      return ((Ae = me.target) == null ? void 0 : Ae.closest("[data-field-label-tooltip]")) != null;
    }, Qe = (me) => {
      Ge(me) || (je = N.value !== null);
    }, Ce = (me) => {
      var Ke, Je;
      if (Ge(me)) return;
      const Ae = je;
      if (je = !1, !t.disabled) {
        if (Ae) {
          (Ke = x.value) == null || Ke.focus();
          return;
        }
        (Je = x.value) == null || Je.click();
      }
    };
    return (me, Ae) => (c(), g("div", {
      ref_key: "rootRef",
      ref: D,
      class: C(j.value),
      style: Ne(e.labelInline ? {} : G.value)
    }, [
      A.value ? (c(), g("div", {
        key: 0,
        class: C([
          "flex min-w-0 max-w-full items-center gap-1",
          e.labelInline ? "shrink-0" : "",
          !e.disabled && !e.readonly ? "cursor-pointer" : ""
        ]),
        onMousedown: Qe,
        onClick: Ce
      }, [
        e.iconLeft && e.labelInline ? (c(), g("img", {
          key: 0,
          src: e.iconLeft,
          class: "mr-1 h-6 w-6 rounded-full object-cover shrink-0",
          alt: ""
        }, null, 8, vw)) : k("", !0),
        e.label ? (c(), K(xt, {
          key: 1,
          id: o.value,
          ref_key: "labelRef",
          ref: y,
          text: e.label,
          required: e.required,
          "required-indicator": e.requiredIndicator,
          tooltip: e.labelTooltip,
          focused: m.value,
          inline: e.labelInline,
          "test-id": "select-label"
        }, null, 8, ["id", "text", "required", "required-indicator", "tooltip", "focused", "inline"])) : k("", !0),
        e.helpIcon && !e.labelTooltip ? (c(), g(se, { key: 2 }, [
          F(e.helpIcon) ? (c(), g("i", {
            key: 0,
            class: C([e.helpIcon, "text-(length:--size-m) leading-(--line-height-s) text-(--text-text-body-subtle) ml-0.5 cursor-help"])
          }, null, 2)) : (c(), g("img", {
            key: 1,
            src: e.helpIcon,
            class: "h-3.5 w-3.5 ml-0.5 cursor-help",
            alt: "Help"
          }, null, 8, xw))
        ], 64)) : k("", !0)
      ], 34)) : k("", !0),
      v("div", {
        style: Ne(B.value),
        class: C([{ "w-full": _.value }, R.value ? z.value.field : ""])
      }, [
        v("input", {
          type: "hidden",
          name: e.name,
          value: e.modelValue
        }, null, 8, yw),
        te(to, {
          buttons: e.buttons,
          layout: e.buttonLayout,
          size: e.size,
          disabled: e.disabled,
          "button-size": e.buttonSize,
          onButtonClick: Ae[3] || (Ae[3] = (Ke) => a("button-click", Ke))
        }, {
          default: ve(({ fieldClass: Ke }) => [
            te(Sn, {
              "full-width": !0,
              "menu-width": B.value.width ?? "100%",
              disabled: e.disabled,
              bare: ""
            }, {
              trigger: ve(({ toggle: Je, isOpen: _e }) => {
                var At, Be, ze;
                return [
                  v("div", {
                    id: r.value,
                    ref_key: "triggerRef",
                    ref: x,
                    role: "combobox",
                    "aria-expanded": _e,
                    "aria-haspopup": e.searchable ? "dialog" : "listbox",
                    "aria-labelledby": o.value,
                    "aria-label": e.label ? void 0 : e.ariaLabel,
                    "aria-describedby": h.value,
                    "aria-disabled": e.disabled ? "true" : void 0,
                    "aria-readonly": e.readonly ? "true" : void 0,
                    "aria-required": e.required ? "true" : void 0,
                    "aria-invalid": d.value ? "true" : void 0,
                    tabindex: e.disabled ? -1 : 0,
                    "data-testid": "select-input",
                    class: C([L(_e), T.value.container, W.value, Ke || I(Y).corners]),
                    onClick: (He) => !e.disabled && !e.readonly && Je(),
                    onKeydown: [
                      (He) => !_e && S(He),
                      ut(Ue((He) => !e.disabled && !e.readonly && Je(), ["prevent"]), ["enter"]),
                      ut(Ue((He) => !e.disabled && !e.readonly && Je(), ["prevent"]), ["space"])
                    ],
                    onFocus: Ae[0] || (Ae[0] = (He) => {
                      m.value = !0, me.$emit("focus");
                    }),
                    onBlur: Ae[1] || (Ae[1] = (He) => {
                      m.value = !1, me.$emit("blur");
                    })
                  }, [
                    e.prefixFlag ? (c(), g("span", ww, [
                      v("span", {
                        class: C(["fi fis size-[13.33px] rounded-full", `fi-${e.prefixFlag.toLowerCase()}`])
                      }, null, 2)
                    ])) : e.prefixIcon ? (c(), g(se, { key: 1 }, [
                      F(e.prefixIcon) ? (c(), g("i", {
                        key: 0,
                        class: C([e.prefixIcon, "shrink-0 text-base leading-none", T.value.icon])
                      }, null, 2)) : (c(), g("img", {
                        key: 1,
                        src: e.prefixIcon,
                        class: C(["shrink-0 object-cover", T.value.icon]),
                        alt: ""
                      }, null, 10, Cw))
                    ], 64)) : k("", !0),
                    (At = u.value) != null && At.badgeTheme ? (c(), g("span", Sw, [
                      te(ct, {
                        label: u.value.label,
                        theme: u.value.badgeTheme,
                        "left-icon": u.value.icon,
                        size: "sm",
                        "data-testid": "select-value-badge"
                      }, null, 8, ["label", "theme", "left-icon"])
                    ])) : (c(), g(se, { key: 3 }, [
                      (Be = u.value) != null && Be.icon && !e.prefixFlag && !e.prefixIcon ? (c(), g(se, { key: 0 }, [
                        F(u.value.icon) ? (c(), g("i", {
                          key: 0,
                          class: C([u.value.icon, "shrink-0 text-(length:--icon-size-sm) leading-(--icon-size-sm)", T.value.icon, f.value]),
                          "aria-hidden": "true",
                          "data-testid": "select-value-icon"
                        }, null, 2)) : (c(), g("img", {
                          key: 1,
                          src: u.value.icon,
                          class: C(["shrink-0 object-cover", T.value.icon]),
                          alt: "",
                          "data-testid": "select-value-icon"
                        }, null, 10, $w))
                      ], 64)) : k("", !0),
                      v("span", {
                        class: C(["flex min-w-0 flex-1", [
                          T.value.text,
                          e.disabled ? "" : b.value ? "text-text-black-default dark:text-(--colors-text-white-default)" : "text-(--text-text-body-subtle) dark:text-(--colors-text-white-secondary)"
                        ]]),
                        style: Ne((ze = u.value) != null && ze.fontFamily ? { fontFamily: u.value.fontFamily } : void 0),
                        "data-testid": "select-value"
                      }, [
                        te(bt, {
                          text: b.value || e.placeholder || "",
                          focusable: !1
                        }, null, 8, ["text"])
                      ], 6)
                    ], 64)),
                    v("i", {
                      class: C(["ri-arrow-down-s-line shrink-0 text-base leading-none transition-transform duration-200 ease-in-out", [T.value.icon, e.disabled ? "text-text-disabled" : "text-(--text-text-body-subtle)"]]),
                      style: Ne({ transform: _e ? "rotate(180deg)" : "rotate(0deg)" })
                    }, null, 6)
                  ], 42, kw)
                ];
              }),
              menu: ve(({ close: Je }) => [
                v("div", {
                  role: e.searchable ? "dialog" : void 0,
                  "aria-labelledby": e.searchable ? o.value : void 0,
                  "aria-label": e.searchable && !e.label ? e.ariaLabel : void 0,
                  "data-testid": "select-panel",
                  class: C(
                    e.searchable ? "flex max-h-[calc(100vh-90px)] flex-col" : "box-border flex max-h-[min(400px,calc(100vh-24px))] flex-col gap-1.5 overflow-y-auto p-[calc(--spacing(2)-1px)]"
                  )
                }, [
                  e.searchable ? (c(), g("div", {
                    key: 0,
                    ref_key: "searchAreaRef",
                    ref: ue,
                    class: "shrink-0",
                    onKeydown: (_e) => De(_e, Je)
                  }, [
                    te(sl, {
                      ref_key: "headerRef",
                      ref: O,
                      "show-search": "",
                      "search-query": re.value,
                      "search-placeholder": e.searchPlaceholder,
                      "search-label": Le.value,
                      "onUpdate:searchQuery": Ae[2] || (Ae[2] = (_e) => re.value = _e)
                    }, null, 8, ["search-query", "search-placeholder", "search-label"])
                  ], 40, Tw)) : k("", !0),
                  e.searchable || I(ge).query.value ? (c(), g("span", Lw, P(Te.value), 1)) : k("", !0),
                  v("div", {
                    "data-testid": "select-list",
                    class: C(
                      e.searchable ? ["flex max-h-100 min-h-0 flex-col overflow-y-auto p-1", !Q.value.length && "hidden"] : "contents"
                    )
                  }, [
                    e.searchable && e.resultsLabel ? (c(), g("div", Ew, P(e.resultsLabel), 1)) : k("", !0),
                    v("ul", {
                      ref_key: "listboxRef",
                      ref: N,
                      role: "listbox",
                      "aria-labelledby": o.value,
                      "aria-label": e.label ? void 0 : e.ariaLabel,
                      tabindex: "-1",
                      class: C(["flex w-full flex-col focus-visible:outline-none", !e.searchable && "gap-1.5"]),
                      onKeydown: de
                    }, [
                      (c(!0), g(se, null, Me(U.value, (_e) => (c(), g(se, {
                        key: _e.headingId ?? "ungrouped"
                      }, [
                        _e.heading ? (c(), g("li", {
                          key: 0,
                          role: "group",
                          "aria-labelledby": _e.headingId,
                          class: C(["flex flex-col", !e.searchable && "gap-1.5"])
                        }, [
                          v("div", {
                            id: _e.headingId,
                            role: "presentation",
                            "data-testid": "select-group-heading",
                            class: "flex shrink-0 px-2.5 pt-2 text-(length:--size-m) leading-(--line-height-l) font-(--weight-semi-bold) text-(--text-text-heading) dark:text-(--colors-text-white-default)"
                          }, P(_e.heading.label), 9, Bw),
                          (c(!0), g(se, null, Me(_e.options, ({ option: At, index: Be }) => (c(), K(Gt, Oe({
                            key: At.value,
                            as: "div"
                          }, { ref_for: !0 }, ne(At, Be), Rl(le(At, Be, Je))), null, 16))), 128))
                        ], 10, Rw)) : (c(!0), g(se, { key: 1 }, Me(_e.options, ({ option: At, index: Be }) => (c(), K(Gt, Oe({
                          key: At.value,
                          as: "li"
                        }, { ref_for: !0 }, ne(At, Be), Rl(le(At, Be, Je))), null, 16))), 128))
                      ], 64))), 128))
                    ], 42, Aw)
                  ], 2),
                  Q.value.length === 0 && e.noResultsLabel ? (c(), g("div", {
                    key: 2,
                    class: C(e.searchable && "p-1")
                  }, [
                    v("div", Mw, P(e.noResultsLabel), 1)
                  ], 2)) : k("", !0),
                  xe.value ? (c(), K(il, {
                    key: 3,
                    type: "see-all-create",
                    "see-all-label": e.seeAllLabel,
                    "create-label": e.createLabel,
                    "create-icon": e.createIcon,
                    class: "shrink-0",
                    onKeydown: Ee,
                    onSeeAll: (_e) => he("see-all", Je),
                    onCreate: (_e) => he("create", Je)
                  }, null, 8, ["see-all-label", "create-label", "create-icon", "onSeeAll", "onCreate"])) : k("", !0)
                ], 10, Iw)
              ]),
              _: 2
            }, 1032, ["menu-width", "disabled"])
          ]),
          _: 1
        }, 8, ["buttons", "layout", "size", "disabled", "button-size"])
      ], 6),
      !I(V) && z.value.reservesHelper || e.hint || e.error ? (c(), K(vt, {
        key: 1,
        ref_key: "helperRef",
        ref: w,
        class: C(R.value ? z.value.helper : ""),
        focused: m.value,
        hint: e.hint,
        error: e.error,
        "hint-id": s.value,
        "error-id": i.value,
        "error-live": e.errorLive,
        "test-id-prefix": "select"
      }, null, 8, ["class", "focused", "hint", "error", "hint-id", "error-id", "error-live"])) : k("", !0)
    ], 6));
  }
}), Is = "None", Td = /* @__PURE__ */ ye({
  __name: "AccessLevelSelect",
  props: {
    modelValue: {},
    label: {},
    levels: {},
    allowNone: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    disabledLevels: { default: () => [] },
    hint: { default: void 0 }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: n }) {
    const t = e, a = n, l = p(() => [
      { value: "Edit", label: t.levels.edit, disabled: t.disabledLevels.includes("Edit") },
      { value: "View", label: t.levels.view, disabled: t.disabledLevels.includes("View") },
      ...t.allowNone ? [{ value: Is, label: t.levels.none }] : []
    ]), r = p(() => t.modelValue ?? Is), o = p(() => l.value.every((s) => s.disabled)), i = (s) => {
      a("update:modelValue", s === Is ? null : s);
    };
    return (s, d) => (c(), K(Tl, {
      "model-value": r.value,
      options: l.value,
      label: e.label,
      disabled: e.disabled || o.value,
      hint: e.hint,
      "full-width": "",
      "onUpdate:modelValue": i
    }, null, 8, ["model-value", "options", "label", "disabled", "hint"]));
  }
});
function Ji(e, n, t = {}) {
  const { ignoreSelectors: a, ignoreElements: l, isActive: r } = t, o = (i) => {
    if (r && !r()) return;
    const s = e.value, d = i.target;
    if (!(!s || !d || s.contains(d)) && d.isConnected && !(l != null && l().some((u) => u && u.contains(d)))) {
      if (a != null && a.length) {
        const u = d instanceof Element ? d : d.parentElement;
        if (u && a.some((f) => u.closest(f))) return;
      }
      n();
    }
  };
  ot(() => {
    document.addEventListener("click", o, !0);
  }), kt(() => {
    document.removeEventListener("click", o, !0);
  });
}
function Yl(e = {}) {
  const { defaultOpen: n = !1, onClose: t, ignoreSelectors: a } = e, l = E(n), r = E(null), o = () => {
    l.value = !l.value;
  }, i = () => {
    l.value = !0;
  }, s = () => {
    l.value = !1, t == null || t();
  };
  return Ji(r, s, { ignoreSelectors: a }), {
    isOpen: l,
    dropdownRef: r,
    toggleDropdown: o,
    openDropdown: i,
    closeDropdown: s
  };
}
const $W = /* @__PURE__ */ ye({
  __name: "ButtonLink",
  props: {
    as: {},
    iconLeft: {},
    iconRight: {},
    size: {},
    ariaLabel: {},
    disabled: { type: Boolean },
    ariaDisabled: { type: [Boolean, String] }
  },
  setup(e) {
    const n = e;
    return (t, a) => (c(), K(dg, Oe(n, { underline: "always" }), {
      default: ve(() => [
        $e(t.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
});
function Dw(e) {
  const n = E(null), t = E(null);
  function a(i) {
    n.value = i;
  }
  function l(i) {
    n.value !== i && (t.value = i);
  }
  function r(i) {
    const s = n.value;
    if (!s || s === i) return;
    const d = e.value.find((b) => b.id === s), u = e.value.find((b) => b.id === i);
    if (!d || !u || u.disabled) return;
    const f = d.order;
    d.order = u.order, u.order = f, n.value = null, t.value = null;
  }
  function o() {
    n.value = null, t.value = null;
  }
  return { draggedId: n, dragOverId: t, onDragStart: a, onDragOver: l, onDrop: r, onDragEnd: o };
}
const Wu = {
  m: "320px",
  l: "498px",
  xl: "768px"
}, zw = ["aria-expanded"], Ow = ["src"], Pw = { class: "relative dark:text-(--colors-text-white-default)" }, Fw = ["src"], Vw = ["aria-label"], Nw = {
  key: 1,
  "data-testid": "filter-dropdown-content",
  class: "flex min-h-0 flex-col gap-1.5 pb-2"
}, Hw = ["role", "aria-label", "aria-multiselectable"], jw = ["role"], Ww = ["role", "onFocusin"], qw = { key: 1 }, ff = '[data-testid="dropdown-list-item-more-actions-trigger"]', Ts = "text-(length:--icon-size-sm) leading-(--icon-size-sm)", qu = /* @__PURE__ */ ye({
  inheritAttrs: !1,
  __name: "FilterDropdown",
  props: {
    label: { default: "Filters" },
    triggerIconLeft: { default: void 0 },
    triggerIcon: { default: void 0 },
    defaultOpen: { type: Boolean, default: !1 },
    size: { default: void 0 },
    menuWidth: { default: "auto" },
    menuAlign: { default: "left" },
    tab: { type: Boolean, default: !1 },
    ariaLabel: { default: void 0 },
    headerLabelLeft: { default: void 0 },
    headerLabelRight: { default: void 0 },
    showSearch: { type: Boolean, default: !1 },
    searchQuery: { default: "" },
    searchPlaceholder: { default: "Search…" },
    searchClearLabel: { default: "Clear search" },
    groupButtons: { default: () => [] },
    groupButtonsLabel: { default: void 0 },
    activeGroupButton: { default: void 0 },
    items: { default: () => [] },
    maxListHeight: { default: void 0 },
    reserveListHeight: { type: Boolean, default: !1 },
    emptyLabel: { default: void 0 },
    emptyIcon: { default: void 0 },
    checkboxPosition: { default: void 0 },
    moreActionsLabel: { default: "More actions" },
    footerLabel: { default: void 0 },
    footerButtons: { default: () => [] },
    stickyItem: { default: void 0 },
    disableInternalSearchFilter: { type: Boolean, default: !1 },
    reorderable: { type: Boolean, default: !1 },
    freezeOnOpen: { type: Boolean, default: !1 }
  },
  emits: ["update:searchQuery", "update:activeGroupButton", "open", "close", "reorder"],
  setup(e, { expose: n, emit: t }) {
    const a = e, l = t, { isOpen: r, dropdownRef: o, toggleDropdown: i, openDropdown: s, closeDropdown: d } = Yl({
      defaultOpen: a.defaultOpen,
      ignoreSelectors: ['[data-testid="dropdown-menu"]']
    }), u = E(null), f = E(null), b = E(null), h = E(null), m = E(null), x = E(null);
    function y() {
      var Ae, Ke;
      const Ce = ((Ae = f.value) == null ? void 0 : Ae.$el) ?? u.value;
      if (Ce) return Ce;
      const me = ((Ke = o.value) == null ? void 0 : Ke.querySelectorAll("[aria-expanded]")) ?? [];
      return Array.from(me).find((Je) => !Je.closest('[data-testid="filter-dropdown-menu"]')) ?? null;
    }
    function w() {
      if (!a.freezeOnOpen) return;
      const Ce = y() ?? o.value;
      if (!Ce) return;
      const me = Ce.getBoundingClientRect();
      x.value = a.menuAlign === "right" ? { top: me.bottom + 4, right: Math.max(0, window.innerWidth - me.right) } : { top: me.bottom + 4, left: me.left };
    }
    function S() {
      d(), qe(() => {
        var Ce;
        return (Ce = y()) == null ? void 0 : Ce.focus();
      });
    }
    const $ = (Ce) => {
      r.value && (Ce.stopPropagation(), Ce.preventDefault(), S());
    }, T = (Ce) => {
      var Ae;
      const me = a.footerButtons[Ce];
      !me || me.disabled || ((Ae = me.onClick) == null || Ae.call(me), me.keepOpen || S());
    };
    function L() {
      var Ce, me;
      (Ce = m.value) != null && Ce.focusSearch() || (me = b.value) == null || me.focus();
    }
    n({ openDropdown: s, closeDropdown: d, isOpen: r }), Ie(
      r,
      (Ce) => {
        Ce ? (w(), l("open"), L()) : (x.value = null, l("close"));
      },
      { flush: "post" }
    );
    const A = p(() => {
      var Ae, Ke;
      let Ce = a.items ?? [];
      a.activeGroupButton && ((Ae = a.groupButtons) != null && Ae.length) && (Ce = Ce.filter((Je) => !Je.group || Je.group === a.activeGroupButton));
      const me = (Ke = a.searchQuery) == null ? void 0 : Ke.trim().toLowerCase();
      return me && !a.disableInternalSearchFilter && (Ce = Ce.filter((Je) => Je.label.toLowerCase().includes(me))), Ce;
    }), R = E([]);
    Ie(
      A,
      (Ce) => {
        R.value = Ce.map((me, Ae) => ({ id: me.id, order: Ae, disabled: me.disabled }));
      },
      { immediate: !0, deep: !1 }
    );
    const { onDragStart: z, onDragOver: D, onDrop: V, onDragEnd: Y } = Dw(R), _ = p(() => {
      if (!a.reorderable) return A.value;
      const Ce = new Map(A.value.map((me) => [me.id, me]));
      return [...R.value].sort((me, Ae) => me.order - Ae.order).map((me) => Ce.get(me.id)).filter((me) => !!me);
    });
    function j(Ce) {
      V(Ce), l("reorder", [...R.value].sort((me, Ae) => me.order - Ae.order).map((me) => me.id));
    }
    const M = p(
      () => {
        var Ce, me, Ae;
        return !!((Ce = a.headerLabelLeft) != null && Ce.text || (me = a.headerLabelRight) != null && me.text || a.showSearch || (Ae = a.groupButtons) != null && Ae.length);
      }
    ), W = p(() => !!a.stickyItem), G = p(() => _.value.length > 0), B = p(() => !G.value && !!a.emptyLabel), F = p(
      () => B.value || !G.value && a.reserveListHeight && !!a.maxListHeight
    ), X = p(() => W.value || G.value), H = p(() => {
      var Ce;
      return a.ariaLabel || ((Ce = a.headerLabelLeft) == null ? void 0 : Ce.text) || a.label;
    }), q = p(
      () => {
        var Ce, me, Ae;
        return !!((Ce = a.items) != null && Ce.some((Ke) => Ke.hasCheckbox || Ke.hasSwitch)) || !!((me = a.stickyItem) != null && me.hasCheckbox) || !!((Ae = a.stickyItem) != null && Ae.hasSwitch);
      }
    ), N = p(() => {
      var Ce;
      return !!((Ce = a.items) != null && Ce.some((me) => {
        var Ae;
        return (Ae = me.moreActions) == null ? void 0 : Ae.length;
      }));
    }), J = p(() => {
      var Ce, me;
      return !!((Ce = a.items) != null && Ce.some((Ae) => Ae.hasCheckbox)) || !!((me = a.stickyItem) != null && me.hasCheckbox);
    }), be = p(() => [
      "flex flex-col px-2",
      J.value ? "gap-0.5" : "gap-0",
      W.value ? "py-0.5" : "py-1.5"
    ]), ke = p(
      () => a.maxListHeight ? { [a.reserveListHeight ? "height" : "maxHeight"]: a.maxListHeight } : {}
    );
    function ee(Ce) {
      return Ce.hasSwitch ? "toggle" : Ce.hasCheckbox ? Ce.badgeTheme ? "badge-checkbox" : "checkbox" : Ce.badgeTheme ? "badge" : "default";
    }
    function oe(Ce) {
      return Ce.map((me) => ({ label: me.label, icon: me.icon, danger: me.variant === "danger", onClick: me.onClick }));
    }
    const ge = p(() => {
      const Ce = /* @__PURE__ */ new Map();
      for (const me of [a.stickyItem, ...a.items ?? []])
        me != null && me.moreActions && Ce.set(me.id, oe(me.moreActions));
      return Ce;
    });
    function re(Ce) {
      return ee(Ce) === "checkbox" && Ce.count !== void 0 ? `(${Ce.count})` : void 0;
    }
    function ue(Ce, me) {
      var Ke, Je;
      const Ae = ee(Ce);
      return {
        as: "div",
        type: Ae,
        label: Ce.label,
        icon: Ae === "default" ? Ce.icon : void 0,
        count: re(Ce),
        badge: Ce.badgeTheme ? { label: Ce.label, theme: Ce.badgeTheme, rightIcon: Ce.badgeRightIcon } : void 0,
        checked: Ae === "toggle" ? !!Ce.switchChecked : !!Ce.checked,
        indeterminate: !!Ce.indeterminate,
        ariaDisabled: !!Ce.disabled,
        // The reason wins: it is what the user needs to know about a disabled option.
        description: Ce.disabled && Ce.disabledReason || Ce.secondaryText,
        moreActions: ge.value.get(Ce.id),
        moreActionsLabel: (Ke = Ce.moreActions) != null && Ke.length ? a.moreActionsLabel : void 0,
        moreActionsTabindex: (Je = Ce.moreActions) != null && Je.length ? fe(me, 1) ? 0 : -1 : void 0
      };
    }
    function O(Ce) {
      var me;
      Ce && !Ce.disabled && ((me = Ce.onClick) == null || me.call(Ce));
    }
    const { focusedIndex: U, handleRovingKeydown: Q, handleSearchFieldKeydown: ae, clampFocusedIndex: Z } = no(), ie = E(0);
    function fe(Ce, me) {
      return U.value === Ce && (N.value ? ie.value === me : me === 0);
    }
    function de(Ce) {
      return W.value ? Ce + 1 : Ce;
    }
    const ne = p(() => _.value.length + (W.value ? 1 : 0));
    Ie(ne, (Ce) => Z(Ce));
    function le(Ce) {
      return Ce.hasSwitch ? "switch" : Ce.hasCheckbox ? "checkbox" : "button";
    }
    function Le(Ce) {
      if (Ce.hasSwitch) return Ce.switchChecked ? "true" : "false";
      if (Ce.hasCheckbox) return Ce.indeterminate ? "mixed" : Ce.checked ? "true" : "false";
    }
    function Te(Ce, me) {
      return {
        role: N.value ? le(Ce) : "option",
        "aria-selected": N.value ? void 0 : !!(Ce.checked || Ce.switchChecked),
        "aria-checked": N.value ? Le(Ce) : void 0,
        "aria-label": [Ce.label, re(Ce)].filter(Boolean).join(" "),
        tabindex: fe(me, 0) ? 0 : -1,
        "data-listbox-index": me,
        onClick: () => O(Ce),
        onKeydown: ut(Ue(() => O(Ce), ["self", "prevent"]), ["enter", "space"]),
        onFocus: () => {
          U.value = me, ie.value = 0;
        }
      };
    }
    function xe(Ce, me) {
      var Ae;
      (Ae = Ce.target) != null && Ae.closest(ff) && (U.value = me, ie.value = 1);
    }
    function we(Ce) {
      if (Ce.key !== "ArrowRight" && Ce.key !== "ArrowLeft") return !1;
      const me = Ce.target, Ae = me.closest('[role="listitem"]');
      if (!Ae) return !1;
      const Ke = Ae.querySelector("[data-listbox-index]"), Je = Ae.querySelector(ff), _e = Ce.key === "ArrowRight" ? Je : Ke;
      return !_e || _e === me || !Ke ? !1 : (Ce.preventDefault(), U.value = Number(Ke.dataset.listboxIndex), ie.value = _e === Je ? 1 : 0, _e.focus(), !0);
    }
    function he(Ce) {
      if (!Ce.defaultPrevented) {
        if (N.value) {
          if (we(Ce)) return;
          ["ArrowDown", "ArrowUp", "Home", "End"].includes(Ce.key) && (ie.value = 0);
        }
        Q(Ce, ne.value, h.value);
      }
    }
    function De(Ce) {
      if (Ce.defaultPrevented) return;
      const me = Ce.target;
      !(me instanceof HTMLTextAreaElement || me instanceof HTMLInputElement && !["checkbox", "radio", "button", "submit", "reset"].includes(me.type)) && me !== b.value || ae(Ce, ne.value, h.value) && (ie.value = 0);
    }
    const Ee = p(() => {
      const [Ce, me] = a.footerButtons.slice(0, 2).map((Ke) => ({ label: Ke.label, variant: Ke.variant, icon: Ke.icon, disabled: Ke.disabled }));
      if (!Ce) return null;
      const Ae = a.footerLabel;
      return me ? Ae ? { type: "buttons-column", buttons: [Ce, me], label: Ae } : { type: "buttons-inline", buttons: [Ce, me] } : Ae ? { type: "label-button", buttons: [Ce], label: Ae } : { type: "button", buttons: [Ce] };
    }), je = p(() => a.size ? { width: Wu[a.size] } : a.menuWidth && a.menuWidth !== "auto" ? { width: a.menuWidth, maxWidth: "594px" } : { maxWidth: "594px" }), Ge = p(() => {
      if (!x.value) return je.value;
      const Ce = { position: "fixed", top: `${x.value.top}px` };
      return x.value.left !== void 0 ? Ce.left = `${x.value.left}px` : x.value.right !== void 0 && (Ce.right = `${x.value.right}px`), { ...Ce, ...je.value };
    }), Qe = (Ce) => !!Ce && Ce.startsWith("ri-");
    return (Ce, me) => (c(), g("div", Oe({
      ref_key: "dropdownRef",
      ref: o
    }, Ce.$attrs, {
      class: ["relative dark:text-(--colors-text-white-default)", e.tab ? "flex h-full items-stretch" : "inline-block text-left"],
      onKeydown: ut($, ["escape"])
    }), [
      $e(Ce.$slots, "trigger", {
        toggle: I(i),
        isOpen: I(r)
      }, () => [
        e.tab ? (c(), g("button", {
          key: 0,
          ref_key: "triggerRef",
          ref: u,
          type: "button",
          "data-testid": "filter-dropdown-trigger",
          class: "inline-flex shrink-0 h-full cursor-pointer items-center gap-1.5 px-3 rounded-tl-(--border-border-radius-rounded-sm) rounded-tr-(--border-border-radius-rounded-sm) border-t border-r border-l border-(--border-border-tab) bg-(--colors-background-white-tertiary) text-(length:--size-sm) leading-(--line-height-l) font-(--weight-medium) text-(--colors-text-black-default) transition-colors duration-200 hover:bg-whitesmoke focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-royalblue dark:bg-white/5 dark:text-(--colors-text-white-secondary) dark:hover:bg-white/10",
          "aria-expanded": I(r),
          "aria-haspopup": "dialog",
          onClick: me[0] || (me[0] = //@ts-ignore
          (...Ae) => I(i) && I(i)(...Ae))
        }, [
          e.triggerIconLeft ? (c(), g(se, { key: 0 }, [
            Qe(e.triggerIconLeft) ? (c(), g("i", {
              key: 0,
              class: C([e.triggerIconLeft, Ts]),
              "aria-hidden": "true"
            }, null, 2)) : (c(), g("img", {
              key: 1,
              class: "h-4 w-4",
              src: e.triggerIconLeft,
              alt: ""
            }, null, 8, Ow))
          ], 64)) : k("", !0),
          v("span", Pw, P(e.label), 1),
          e.triggerIcon ? (c(), g(se, { key: 1 }, [
            Qe(e.triggerIcon) ? (c(), g("i", {
              key: 0,
              class: C([e.triggerIcon, Ts, "transition-transform duration-200 ease-in-out"]),
              style: Ne({ transform: I(r) ? "rotate(180deg)" : "rotate(0deg)" }),
              "aria-hidden": "true"
            }, null, 6)) : (c(), g("img", {
              key: 1,
              class: "h-4 w-4 transition-transform duration-200 ease-in-out",
              style: Ne({ transform: I(r) ? "rotate(180deg)" : "rotate(0deg)" }),
              src: e.triggerIcon,
              alt: ""
            }, null, 12, Fw))
          ], 64)) : (c(), g("i", {
            key: 2,
            class: C(["ri-arrow-down-s-line", Ts, "transition-transform duration-200 ease-in-out"]),
            style: Ne({ transform: I(r) ? "rotate(180deg)" : "rotate(0deg)" }),
            "aria-hidden": "true"
          }, null, 6))
        ], 8, zw)) : (c(), K(I(Re), {
          key: 1,
          ref_key: "triggerButtonRef",
          ref: f,
          "data-testid": "filter-dropdown-trigger",
          size: "xs",
          variant: "secondary",
          label: e.label,
          "icon-left": e.triggerIconLeft,
          "icon-right": e.triggerIcon,
          "dropdown-icon": !e.triggerIcon,
          "aria-expanded": I(r),
          "aria-haspopup": "dialog",
          onClick: I(i)
        }, null, 8, ["label", "icon-left", "icon-right", "dropdown-icon", "aria-expanded", "onClick"]))
      ]),
      te(wt, {
        "enter-active-class": "transition duration-100 ease-out motion-reduce:transition-none",
        "enter-from-class": "transform scale-95 opacity-0",
        "enter-to-class": "transform scale-100 opacity-100",
        "leave-active-class": "transition duration-75 ease-out motion-reduce:transition-none",
        "leave-from-class": "transform scale-100 opacity-100",
        "leave-to-class": "transform scale-95 opacity-0"
      }, {
        default: ve(() => {
          var Ae, Ke, Je;
          return [
            I(r) ? (c(), g("div", {
              key: 0,
              ref_key: "menuRef",
              ref: b,
              role: "dialog",
              "aria-label": H.value,
              "data-testid": "filter-dropdown-menu",
              tabindex: "-1",
              class: C([
                I(Na),
                "z-50 flex min-w-[220px] flex-col overflow-hidden focus-visible:outline-none",
                x.value ? "" : ["absolute top-full mt-1", e.menuAlign === "right" ? "right-0" : "left-0"]
              ]),
              style: Ne(Ge.value),
              onKeydown: De
            }, [
              M.value ? (c(), K(sl, {
                key: 0,
                ref_key: "headerRef",
                ref: m,
                "label-left": (Ae = e.headerLabelLeft) == null ? void 0 : Ae.text,
                "label-right": (Ke = e.headerLabelRight) == null ? void 0 : Ke.text,
                "show-search": e.showSearch,
                "search-query": e.searchQuery,
                "search-placeholder": e.searchPlaceholder,
                "search-clear-label": e.searchClearLabel,
                "group-buttons": e.groupButtons,
                "active-group": e.activeGroupButton,
                "group-label-left": e.groupButtonsLabel,
                "group-aria-label": ((Je = e.headerLabelLeft) == null ? void 0 : Je.text) || e.label,
                class: "shrink-0",
                "onUpdate:searchQuery": me[1] || (me[1] = (_e) => l("update:searchQuery", _e)),
                "onUpdate:activeGroup": me[2] || (me[2] = (_e) => l("update:activeGroupButton", _e))
              }, null, 8, ["label-left", "label-right", "show-search", "search-query", "search-placeholder", "search-clear-label", "group-buttons", "active-group", "group-label-left", "group-aria-label"])) : k("", !0),
              X.value || F.value ? (c(), g("div", Nw, [
                X.value ? (c(), g("div", {
                  key: 0,
                  ref_key: "listboxRef",
                  ref: h,
                  role: N.value ? "list" : "listbox",
                  "aria-label": H.value,
                  "aria-multiselectable": q.value && !N.value ? "true" : void 0,
                  class: "flex min-h-0 flex-col",
                  onKeydown: he
                }, [
                  e.stickyItem ? (c(), g("div", {
                    key: 0,
                    "data-testid": "filter-dropdown-select-all",
                    role: N.value ? "listitem" : void 0,
                    class: "shrink-0 border-b border-(--border-border-base-soft) px-2 pt-2 pb-[calc(--spacing(2)-1px)] dark:border-(--colors-border-base)"
                  }, [
                    te(Gt, Oe({ ...ue(e.stickyItem, 0), ...Te(e.stickyItem, 0) }, { "data-testid": "filter-dropdown-sticky-item" }), null, 16)
                  ], 8, jw)) : k("", !0),
                  G.value ? (c(), g("div", {
                    key: 1,
                    "data-testid": "filter-dropdown-list",
                    class: C(["min-h-0", { "overflow-y-auto": !!e.maxListHeight }]),
                    style: Ne(ke.value)
                  }, [
                    v("div", {
                      class: C(be.value)
                    }, [
                      (c(!0), g(se, null, Me(_.value, (_e, At) => (c(), g("div", {
                        key: _e.id,
                        role: N.value ? "listitem" : void 0,
                        class: "flex",
                        onFocusin: (Be) => xe(Be, de(At))
                      }, [
                        te(Gt, Oe({ ref_for: !0 }, { ...ue(_e, de(At)), ...Te(_e, de(At)) }, {
                          class: "filter-item-row",
                          "data-testid": `filter-dropdown-item-${_e.id}`,
                          draggable: e.reorderable && !_e.disabled,
                          onDragstart: (Be) => e.reorderable && I(z)(_e.id),
                          onDragover: Ue((Be) => e.reorderable && I(D)(_e.id), ["prevent"]),
                          onDrop: (Be) => e.reorderable && j(_e.id),
                          onDragend: me[3] || (me[3] = (Be) => e.reorderable && I(Y)())
                        }), null, 16, ["data-testid", "draggable", "onDragstart", "onDragover", "onDrop"])
                      ], 40, Ww))), 128))
                    ], 2)
                  ], 6)) : k("", !0)
                ], 40, Hw)) : k("", !0),
                F.value ? (c(), g("div", {
                  key: 1,
                  "data-testid": "filter-dropdown-empty",
                  class: C([{ "overflow-y-auto": e.reserveListHeight && !!e.maxListHeight }, "flex flex-col items-center justify-center gap-1.5 px-4 py-6 text-center text-(length:--size-m) leading-(--line-height-l) font-(--weight-regular) text-(--colors-text-body-subtle) dark:text-(--colors-text-white-secondary)"]),
                  style: Ne(e.reserveListHeight ? ke.value : void 0)
                }, [
                  e.emptyIcon && e.emptyLabel ? (c(), g("i", {
                    key: 0,
                    class: C([e.emptyIcon, "text-(length:--icon-size-md) leading-(--icon-size-md)"]),
                    "aria-hidden": "true",
                    "data-testid": "filter-dropdown-empty-icon"
                  }, null, 2)) : k("", !0),
                  e.emptyLabel ? (c(), g("span", qw, P(e.emptyLabel), 1)) : k("", !0)
                ], 6)) : k("", !0)
              ])) : k("", !0),
              Ee.value ? (c(), K(il, Oe({ key: 2 }, Ee.value, {
                class: "shrink-0",
                onButtonClick: T
              }), null, 16)) : k("", !0)
            ], 46, Vw)) : k("", !0)
          ];
        }),
        _: 1
      })
    ], 16));
  }
}), Uw = ["aria-label", "data-step"], Gw = { class: "flex min-h-0 flex-col pb-2" }, Kw = ["aria-label"], Yw = ["aria-label"], Jw = { class: "flex min-h-0 flex-col pb-2" }, Zw = ["aria-label"], Xw = ["aria-labelledby"], Qw = ["id"], _w = {
  key: 1,
  role: "none",
  class: "flex min-h-0 flex-col overflow-y-auto px-2 py-1.5",
  "data-testid": "sort-dropdown-field-list"
}, e1 = ["aria-label"], t1 = ["src"], n1 = { class: "leading-(--line-height-l) font-(--weight-medium)" }, IW = /* @__PURE__ */ ye({
  __name: "SortDropdown",
  props: {
    modelValue: { default: "" },
    options: { default: () => [] },
    fields: { default: void 0 },
    sort: { default: null },
    ariaLabel: { default: void 0 },
    align: { default: "right" },
    triggerIconLeft: { default: "ri-filter-3-fill" },
    headerLabel: { default: void 0 },
    searchPlaceholder: { default: "Search a field" },
    searchLabel: { default: void 0 },
    noResultsLabel: { default: void 0 },
    appliedSortLabel: { default: void 0 },
    directionsLabel: { default: "Sort direction" },
    backLabel: { default: "Back" },
    defaultOpen: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue", "update:sort"],
  setup(e, { emit: n }) {
    const t = e, a = n, l = p(
      () => {
        var O;
        return ((O = t.options.find((U) => U.value === t.modelValue)) == null ? void 0 : O.label) ?? "";
      }
    ), r = p(() => t.options.length === 1), o = p(
      () => t.options.map((O) => ({
        label: O.label,
        active: O.value === t.modelValue,
        testId: `sort-option-${O.value}`,
        onClick: () => a("update:modelValue", O.value)
      }))
    ), i = (O) => !!O && O.startsWith("ri-"), s = p(() => t.fields !== void 0), { isOpen: d, dropdownRef: u, toggleDropdown: f, closeDropdown: b } = Yl({ defaultOpen: t.defaultOpen }), h = E(null), m = E(null), x = E(null), y = E(null), w = E(null), S = Ve(), $ = E(""), T = E(null), L = { asc: "ri-sort-asc", desc: "ri-sort-desc" }, A = ["asc", "desc"], R = p(() => {
      var O;
      return (O = t.fields) == null ? void 0 : O.find((U) => {
        var Q;
        return U.key === ((Q = t.sort) == null ? void 0 : Q.field);
      });
    }), z = p(() => {
      var O;
      return (O = t.fields) == null ? void 0 : O.find((U) => U.key === T.value);
    }), D = p(() => $.value.trim() ? void 0 : R.value), V = p(
      () => (t.fields ?? []).filter((O) => O !== D.value && Pu(O.label, $.value))
    ), Y = p(() => D.value ? [D.value, ...V.value] : V.value), _ = p(() => {
      var O;
      return ((O = R.value) == null ? void 0 : O.label) ?? t.headerLabel ?? "";
    }), { focusedIndex: j, handleRovingKeydown: M, handleSearchFieldKeydown: W, clampFocusedIndex: G } = no();
    Ie(
      () => Y.value.length,
      (O) => G(O)
    );
    function B() {
      var O;
      return ((O = h.value) == null ? void 0 : O.$el) ?? null;
    }
    function F(O, U) {
      const Q = O == null ? void 0 : O.querySelector(`[data-listbox-index="${U}"]`);
      return Q ? (j.value = U, Q.focus({ preventScroll: !0 }), Q.scrollIntoView({ block: "nearest" }), !0) : !1;
    }
    function X() {
      var O, U;
      (U = (O = m.value) == null ? void 0 : O.querySelector('[data-testid="sort-dropdown-back"]')) == null || U.focus();
    }
    function H() {
      b(), qe(() => {
        var O;
        return (O = B()) == null ? void 0 : O.focus();
      });
    }
    Ie(
      d,
      (O) => {
        var U;
        O && (T.value = null, $.value = "", j.value = 0, (U = w.value) == null || U.focusSearch());
      },
      { flush: "post" }
    );
    function q(O) {
      var Q;
      if (O.disabled) return;
      T.value = O.key;
      const U = ((Q = t.sort) == null ? void 0 : Q.field) === O.key ? A.indexOf(t.sort.direction) : 0;
      j.value = Math.max(0, U), qe(X);
    }
    function N() {
      const O = T.value;
      T.value = null, qe(() => {
        var Q;
        const U = Y.value.findIndex((ae) => ae.key === O);
        F(x.value, Math.max(0, U)) || (Q = w.value) == null || Q.focusSearch();
      });
    }
    function J(O) {
      T.value && (a("update:sort", { field: T.value, direction: O }), H());
    }
    function be(O) {
      d.value && (O.stopPropagation(), O.preventDefault(), H());
    }
    function ke(O) {
      O.target instanceof HTMLInputElement && W(O, Y.value.length, x.value);
    }
    function ee(O) {
      M(O, Y.value.length, x.value);
    }
    function oe(O) {
      if (O.key === "ArrowLeft") {
        O.preventDefault(), N();
        return;
      }
      M(O, A.length, y.value);
    }
    const ge = p(() => [
      { label: t.backLabel, icon: "ri-arrow-left-line", variant: "secondary", testId: "sort-dropdown-back" }
    ]);
    function re(O) {
      return {
        tabindex: O === j.value ? 0 : -1,
        "data-listbox-index": O,
        onFocus: () => {
          j.value = O;
        }
      };
    }
    function ue(O) {
      return {
        as: "button",
        role: "menuitem",
        label: O.label,
        icon: O.icon,
        ariaDisabled: !!O.disabled,
        description: O.disabled ? O.disabledReason : void 0,
        onClick: () => q(O)
      };
    }
    return (O, U) => s.value ? (c(), g("div", {
      key: 0,
      ref_key: "dropdownRef",
      ref: u,
      class: "relative inline-block text-left dark:text-(--colors-text-white-default)",
      "data-testid": "sort-dropdown",
      onKeydown: ut(be, ["escape"])
    }, [
      te(Re, {
        ref_key: "triggerRef",
        ref: h,
        "data-testid": "sort-dropdown-trigger",
        size: "xs",
        variant: "ghost",
        label: _.value,
        "icon-left": e.triggerIconLeft,
        "dropdown-icon": !!_.value,
        "icon-only": !_.value,
        "aria-label": e.ariaLabel,
        "aria-expanded": I(d),
        "aria-haspopup": "dialog",
        onClick: I(f)
      }, null, 8, ["label", "icon-left", "dropdown-icon", "icon-only", "aria-label", "aria-expanded", "onClick"]),
      te(wt, {
        "enter-active-class": "transition duration-100 ease-out motion-reduce:transition-none",
        "enter-from-class": "transform scale-95 opacity-0",
        "enter-to-class": "transform scale-100 opacity-100",
        "leave-active-class": "transition duration-75 ease-out motion-reduce:transition-none",
        "leave-from-class": "transform scale-100 opacity-100",
        "leave-to-class": "transform scale-95 opacity-0"
      }, {
        default: ve(() => [
          I(d) ? (c(), g("div", {
            key: 0,
            ref_key: "panelRef",
            ref: m,
            role: "dialog",
            "aria-label": e.headerLabel ?? e.ariaLabel,
            "data-testid": "sort-dropdown-panel",
            "data-step": z.value ? "directions" : "fields",
            class: C(["absolute top-full z-50 mt-1 flex max-h-105 w-80 max-w-[calc(100vw-32px)] flex-col overflow-hidden", [I(Na), e.align === "right" ? "right-0 origin-top-right" : "left-0 origin-top-left"]])
          }, [
            z.value ? (c(), g(se, { key: 0 }, [
              te(sl, {
                "label-left": z.value.label,
                class: "shrink-0"
              }, null, 8, ["label-left"]),
              v("div", Gw, [
                v("div", {
                  ref_key: "directionMenuRef",
                  ref: y,
                  role: "menu",
                  "aria-label": e.directionsLabel,
                  class: "flex flex-col px-2 py-1.5",
                  "data-testid": "sort-dropdown-directions",
                  onKeydown: oe
                }, [
                  v("div", {
                    role: "group",
                    "aria-label": z.value.label,
                    class: "flex flex-col"
                  }, [
                    (c(), g(se, null, Me(A, (Q, ae) => {
                      var Z, ie;
                      return te(Gt, Oe({ key: Q }, { ref_for: !0 }, re(ae), {
                        as: "button",
                        role: "menuitemradio",
                        "aria-checked": ((Z = e.sort) == null ? void 0 : Z.field) === z.value.key && e.sort.direction === Q,
                        "aria-label": z.value.directions[Q].ariaLabel,
                        label: z.value.directions[Q].label,
                        icon: L[Q],
                        selected: ((ie = e.sort) == null ? void 0 : ie.field) === z.value.key && e.sort.direction === Q,
                        class: "shrink-0",
                        "data-testid": `sort-direction-${Q}`,
                        onClick: (fe) => J(Q)
                      }), null, 16, ["aria-checked", "aria-label", "label", "icon", "selected", "data-testid", "onClick"]);
                    }), 64))
                  ], 8, Yw)
                ], 40, Kw)
              ]),
              te(il, {
                type: "button",
                buttons: ge.value,
                class: "shrink-0",
                onButtonClick: N
              }, null, 8, ["buttons"])
            ], 64)) : (c(), g(se, { key: 1 }, [
              te(sl, {
                ref_key: "headerRef",
                ref: w,
                class: "shrink-0",
                "label-left": e.headerLabel,
                "show-search": "",
                "search-query": $.value,
                "search-placeholder": e.searchPlaceholder,
                "search-label": e.searchLabel ?? e.searchPlaceholder,
                onKeydown: ke,
                "onUpdate:searchQuery": U[0] || (U[0] = (Q) => $.value = Q)
              }, null, 8, ["label-left", "search-query", "search-placeholder", "search-label"]),
              v("div", Jw, [
                Y.value.length ? (c(), g("div", {
                  key: 0,
                  ref_key: "fieldMenuRef",
                  ref: x,
                  role: "menu",
                  "aria-label": e.headerLabel,
                  class: "flex min-h-0 flex-col",
                  "data-testid": "sort-dropdown-fields",
                  onKeydown: ee
                }, [
                  D.value && e.sort ? (c(), g("div", {
                    key: 0,
                    role: "group",
                    "aria-labelledby": e.appliedSortLabel ? I(S) : void 0,
                    class: "flex shrink-0 flex-col border-b border-(--border-border-base-soft) pt-2 pe-3 ps-2 pb-[calc(--spacing(2)-1px)] dark:border-(--colors-border-base)",
                    "data-testid": "sort-dropdown-applied"
                  }, [
                    e.appliedSortLabel ? (c(), g("span", {
                      key: 0,
                      id: I(S),
                      class: "px-2 text-(length:--size-sm) leading-(--line-height-l) font-(--weight-semi-bold) text-(--text-text-body-subtle) dark:text-(--colors-text-white-secondary)",
                      "data-testid": "sort-dropdown-applied-heading"
                    }, P(e.appliedSortLabel), 9, Qw)) : k("", !0),
                    te(Gt, Oe({ ...ue(D.value), ...re(0) }, {
                      type: "two-labels",
                      selected: "",
                      "secondary-icon": L[e.sort.direction],
                      "secondary-label": D.value.directions[e.sort.direction].label,
                      class: "shrink-0",
                      "data-testid": `sort-field-${D.value.key}`
                    }), null, 16, ["secondary-icon", "secondary-label", "data-testid"])
                  ], 8, Xw)) : k("", !0),
                  V.value.length ? (c(), g("div", _w, [
                    (c(!0), g(se, null, Me(V.value, (Q, ae) => (c(), K(Gt, Oe({
                      key: Q.key
                    }, { ref_for: !0 }, { ...ue(Q), ...re(D.value ? ae + 1 : ae) }, {
                      type: "two-icons",
                      class: "shrink-0",
                      "data-testid": `sort-field-${Q.key}`
                    }), null, 16, ["data-testid"]))), 128))
                  ])) : k("", !0)
                ], 40, Zw)) : k("", !0),
                v("div", {
                  role: "status",
                  "aria-live": "polite",
                  class: C(Y.value.length || !e.noResultsLabel ? "sr-only" : "px-4 py-6 text-center text-(length:--size-m) leading-(--line-height-l) font-(--weight-regular) text-(--colors-text-body-subtle) dark:text-(--colors-text-white-secondary)"),
                  "data-testid": "sort-dropdown-status"
                }, P(Y.value.length ? "" : e.noResultsLabel), 3)
              ])
            ], 64))
          ], 10, Uw)) : k("", !0)
        ]),
        _: 1
      })
    ], 544)) : r.value ? (c(), g("div", {
      key: 1,
      class: "inline-flex items-center gap-1.5 px-3 py-2 text-(length:--size-m) text-(--colors-text-black-default) dark:text-(--colors-text-white-default)",
      "aria-label": e.ariaLabel,
      "data-testid": "sort-dropdown-static"
    }, [
      e.triggerIconLeft ? (c(), g(se, { key: 0 }, [
        i(e.triggerIconLeft) ? (c(), g("i", {
          key: 0,
          class: C([e.triggerIconLeft, "text-(length:--icon-size-sm) leading-(--icon-size-sm) size-(--icon-size-sm) inline-flex items-center justify-center"]),
          "aria-hidden": "true"
        }, null, 2)) : (c(), g("img", {
          key: 1,
          class: "relative h-4 w-4",
          src: e.triggerIconLeft,
          alt: ""
        }, null, 8, t1))
      ], 64)) : k("", !0),
      v("span", n1, P(l.value), 1)
    ], 8, e1)) : (c(), K(Sn, {
      key: 2,
      label: l.value,
      "trigger-icon-left": e.triggerIconLeft,
      items: o.value,
      "menu-align": e.align,
      "selection-style": "check",
      "menu-header": e.headerLabel,
      "aria-label": e.ariaLabel,
      ghost: "",
      "data-testid": "sort-dropdown"
    }, null, 8, ["label", "trigger-icon-left", "items", "menu-align", "menu-header", "aria-label"]));
  }
}), a1 = { class: "flex flex-col gap-0.5 pb-0.5" }, l1 = {
  key: 0,
  class: "flex min-w-0 flex-1"
}, r1 = {
  key: 1,
  class: "inline-flex shrink-0"
}, o1 = {
  "data-field-controls": "",
  class: "ms-auto flex shrink-0 items-center gap-2"
}, i1 = ["aria-label"], s1 = /* @__PURE__ */ ye({
  __name: "MultipleSelect",
  props: {
    options: {},
    modelValue: { default: () => [] },
    draft: { default: void 0 },
    label: { default: void 0 },
    required: { type: Boolean, default: !1 },
    requiredIndicator: { default: "*" },
    helpTooltip: { default: void 0 },
    placeholder: {},
    confirmLabel: {},
    seeAllLabel: { default: void 0 },
    seeAllThreshold: { default: 20 },
    searchPlaceholder: {},
    searchClearLabel: { default: "Clear search" },
    selectAllLabel: {},
    clearAllLabel: {},
    removeChipLabel: {},
    emptyLabel: {},
    error: { default: void 0 },
    hint: { default: void 0 },
    success: { type: Boolean, default: !1 },
    size: { default: "md" },
    async: { type: Boolean, default: !1 },
    loading: { type: Boolean, default: !1 },
    loadingLabel: { default: void 0 },
    selectAllResolver: { type: Function, default: void 0 },
    chipTheme: { default: "neutral" },
    totalCount: { default: void 0 },
    maxListHeight: { default: "252px" },
    disabled: { type: Boolean, default: !1 },
    readonly: { type: Boolean, default: !1 },
    removeOnly: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue", "update:draft", "see-all", "search"],
  setup(e, { emit: n }) {
    const t = e, a = n, l = p(() => t.async), r = Ve(), o = p(() => `${r}-input`), i = p(() => t.label ? `${r}-label` : void 0), s = `${r}-error`, d = `${r}-hint`, u = p(() => !!t.error), f = p(() => {
      const ne = [];
      return t.hint && ne.push(d), u.value && ne.push(s), ne.length > 0 ? ne.join(" ") : void 0;
    }), b = p(
      () => t.options.filter((ne) => (t.modelValue ?? []).includes(ne.id))
    ), h = E([...t.modelValue ?? []]), m = E(!1), x = E(!1), y = (ne, le) => ne.length === le.length && ne.every((Le, Te) => Le === le[Te]);
    Ie(
      () => t.draft,
      (ne) => {
        ne && !y(ne, h.value) && (h.value = [...ne]);
      }
    ), Ie(h, (ne) => {
      (!t.draft || !y(t.draft, ne)) && a("update:draft", [...ne]);
    });
    const w = () => {
      m.value = !0, h.value = [...t.modelValue ?? []];
    }, S = () => {
      m.value = !1, h.value = [...t.modelValue ?? []];
    }, $ = () => {
      a("update:modelValue", [...h.value]);
    }, T = E(null), L = E(null), A = p(() => t.size === "lg" || t.size === "xl" ? "lg" : "sm"), R = p(() => t.disabled || t.readonly), z = p(
      () => t.disabled ? "text-(--icons-icon-disabled-strong) dark:text-(--text-text-disabled-light)" : "text-(--icons-icon-dark-default) dark:text-(--icons-icon-white-default)"
    );
    function D(ne) {
      ne.currentTarget.contains(ne.relatedTarget) || (x.value = !1);
    }
    const V = E(null), Y = () => {
      var ne;
      return ((ne = V.value) == null ? void 0 : ne.$el) ?? null;
    }, _ = E(1 / 0), j = E(void 0);
    let M = null;
    const W = p(() => {
      const ne = _.value === 1 / 0 ? b.value.length : Math.min(_.value, b.value.length);
      return b.value.slice(0, ne);
    }), G = p(
      () => Math.max(0, b.value.length - W.value.length)
    ), B = async () => {
      _.value = 1 / 0, await qe();
      const ne = Y();
      if (!ne || b.value.length === 0) {
        _.value = b.value.length;
        return;
      }
      const le = Array.from(ne.querySelectorAll("[data-badge-chip]"));
      if (!le.length) {
        _.value = b.value.length;
        return;
      }
      const Le = ne.getBoundingClientRect(), Te = getComputedStyle(ne), xe = parseFloat(Te.columnGap) || 0, we = ne.querySelector("[data-field-controls]"), he = (parseFloat(Te.paddingRight) || 0) + (we ? we.getBoundingClientRect().width + xe : 0), De = 56, Ee = Le.right - he;
      let je = le.length;
      for (let Ge = 0; Ge < le.length; Ge++) {
        const Qe = le[Ge].getBoundingClientRect().right;
        if ((Ge === le.length - 1 ? Qe : Qe + De) > Ee) {
          je = Ge;
          break;
        }
      }
      _.value = Math.max(je, 1);
    }, F = () => {
      const ne = Y();
      ne && (j.value = `${ne.offsetWidth}px`);
    };
    ot(() => {
      M = new ResizeObserver(() => {
        F(), B();
      });
      const ne = Y();
      ne && M.observe(ne), F(), B();
    }), kt(() => {
      M == null || M.disconnect(), clearTimeout(H);
    }), Ie(
      () => t.modelValue,
      (ne) => {
        _.value = 1 / 0, B(), m.value || (h.value = [...ne ?? []]);
      }
    );
    const X = E("");
    let H;
    Ie(X, (ne) => {
      t.async && (clearTimeout(H), H = setTimeout(() => a("search", ne), 300));
    });
    const q = E(!1), N = p(() => t.loading || q.value), J = p(
      () => t.loading ? t.loadingLabel ?? t.emptyLabel : t.emptyLabel
    ), be = p(() => t.options.filter((ne) => !ne.disabled)), ke = p(
      () => be.value.length > 0 && be.value.every((ne) => h.value.includes(ne.id))
    ), ee = p(
      () => !ke.value && be.value.some((ne) => h.value.includes(ne.id))
    ), oe = async () => {
      if (t.selectAllResolver) {
        q.value = !0;
        try {
          const ne = await t.selectAllResolver(), le = new Set(ne);
          if (ne.length > 0 && ne.every((Te) => h.value.includes(Te)))
            h.value = h.value.filter((Te) => !le.has(Te));
          else {
            const Te = new Set(h.value);
            ne.forEach((xe) => Te.add(xe)), h.value = Array.from(Te);
          }
        } catch {
        } finally {
          q.value = !1;
        }
        return;
      }
      if (ke.value)
        h.value = h.value.filter(
          (ne) => !be.value.some((le) => le.id === ne)
        );
      else {
        const ne = new Set(h.value);
        be.value.forEach((le) => ne.add(le.id)), h.value = Array.from(ne);
      }
    }, ge = (ne) => {
      h.value.includes(ne) ? h.value = h.value.filter((le) => le !== ne) : h.value = [...h.value, ne];
    }, re = () => {
      const ne = Y();
      ne && ne !== document.activeElement && ne.contains(document.activeElement) && ne.focus();
    }, ue = (ne) => {
      re(), h.value = h.value.filter((le) => le !== ne), a(
        "update:modelValue",
        (t.modelValue ?? []).filter((le) => le !== ne)
      );
    }, O = (ne) => {
      ne.stopPropagation(), re(), h.value = [], a("update:modelValue", []);
    }, U = p(() => ({
      id: "__select-all__",
      label: t.selectAllLabel,
      hasCheckbox: !0,
      checked: ke.value,
      indeterminate: ee.value,
      onClick: oe
    })), Q = p(() => [
      ...t.options.map((ne) => ({
        id: ne.id,
        label: ne.label,
        hasCheckbox: !0,
        checked: h.value.includes(ne.id),
        badgeTheme: ne.badgeTheme ?? t.chipTheme,
        badgeRightIcon: ne.badgeRightIcon,
        secondaryText: ne.secondaryText,
        disabled: ne.disabled,
        onClick: () => ge(ne.id)
      }))
    ]), ae = p(() => {
      const ne = [], le = t.totalCount ?? t.options.length;
      return t.seeAllLabel && le > (t.seeAllThreshold ?? 20) && ne.push({
        label: t.seeAllLabel,
        variant: "secondary",
        keepOpen: !0,
        onClick: () => a("see-all")
      }), ne.push({ label: t.confirmLabel, variant: "primary", onClick: $ }), ne;
    }), Z = (ne, le, Le) => {
      var Te, xe;
      if (ne.key === "Escape" && Le) {
        ne.stopPropagation(), ne.preventDefault(), le();
        return;
      }
      if (Le || ((Te = T.value) == null || Te.handleFieldKeydown(ne), (xe = L.value) == null || xe.handleFieldKeydown(ne)), ne.key === "Backspace" && ne.target === ne.currentTarget && !t.disabled && !t.readonly && b.value.length > 0) {
        const we = b.value[b.value.length - 1];
        h.value = h.value.filter((he) => he !== we.id), a(
          "update:modelValue",
          (t.modelValue ?? []).filter((he) => he !== we.id)
        );
      }
    };
    let ie = !1;
    const fe = () => {
      ie = m.value;
    }, de = () => {
      var le, Le;
      const ne = ie;
      if (ie = !1, !t.disabled) {
        if (ne || t.removeOnly) {
          (le = Y()) == null || le.focus();
          return;
        }
        (Le = Y()) == null || Le.click();
      }
    };
    return (ne, le) => (c(), g("div", a1, [
      e.label ? (c(), K(xt, {
        key: 0,
        id: i.value,
        ref_key: "labelRef",
        ref: T,
        text: e.label,
        required: e.required,
        "required-indicator": e.requiredIndicator,
        tooltip: e.helpTooltip,
        focused: x.value,
        "test-id": "multiple-select-label",
        class: C(!e.disabled && !e.readonly && !e.removeOnly && "cursor-pointer"),
        onMousedown: fe,
        onClick: Ue(de, ["stop"])
      }, null, 8, ["id", "text", "required", "required-indicator", "tooltip", "focused", "class"])) : k("", !0),
      te(I(qu), {
        "search-query": X.value,
        "onUpdate:searchQuery": le[1] || (le[1] = (Le) => X.value = Le),
        "aria-label": e.label || e.placeholder,
        items: Q.value,
        "sticky-item": U.value,
        "show-search": !0,
        "search-placeholder": e.searchPlaceholder,
        "search-clear-label": e.searchClearLabel,
        "empty-label": J.value,
        "disable-internal-search-filter": l.value,
        "max-list-height": e.maxListHeight,
        "footer-buttons": ae.value,
        "menu-width": j.value,
        class: "w-full",
        onOpen: w,
        onClose: S
      }, {
        trigger: ve(({ toggle: Le, isOpen: Te }) => [
          te(Rn, {
            id: o.value,
            ref_key: "shellRef",
            ref: V,
            role: "combobox",
            "aria-expanded": Te,
            "aria-haspopup": "dialog",
            "aria-labelledby": i.value,
            "aria-describedby": f.value,
            "aria-required": e.required ? "true" : void 0,
            "aria-invalid": u.value ? "true" : void 0,
            "aria-disabled": e.disabled ? "true" : void 0,
            "aria-readonly": e.readonly ? "true" : void 0,
            "aria-busy": N.value ? "true" : void 0,
            tabindex: e.disabled ? -1 : 0,
            tags: "",
            size: e.size,
            disabled: e.disabled,
            readonly: e.readonly || e.removeOnly,
            error: u.value,
            success: e.success,
            focused: Te,
            "focus-scope": "any",
            "has-value": b.value.length > 0,
            class: C(["w-full flex-nowrap! overflow-hidden focus:outline-none", !e.disabled && !e.readonly && !e.removeOnly && "cursor-pointer"]),
            onClick: (xe) => !e.disabled && !e.readonly && !e.removeOnly && Le(),
            onKeydown: [
              (xe) => Z(xe, Le, Te),
              ut(Ue((xe) => !e.disabled && !e.readonly && !e.removeOnly && Le(), ["self", "prevent"]), ["enter"]),
              ut(Ue((xe) => !e.disabled && !e.readonly && !e.removeOnly && Le(), ["self", "prevent"]), ["space"])
            ],
            onFocusin: le[0] || (le[0] = (xe) => x.value = !0),
            onFocusout: D
          }, {
            default: ve(({ textClass: xe, iconBoxClass: we }) => [
              b.value.length === 0 ? (c(), g("span", l1, [
                te(bt, {
                  text: e.placeholder,
                  focusable: !1,
                  "text-class": [xe, e.disabled ? "" : "text-(--text-text-body-subtle) dark:text-(--colors-text-white-secondary)"].join(" ")
                }, null, 8, ["text", "text-class"])
              ])) : k("", !0),
              (c(!0), g(se, null, Me(W.value, (he) => (c(), g("div", {
                key: he.id,
                "data-badge-chip": "",
                class: "inline-flex shrink-0"
              }, [
                te(I(ct), {
                  label: he.label,
                  theme: e.disabled ? "disabled" : he.badgeTheme ?? e.chipTheme,
                  "tooltip-text": he.tooltipText,
                  "right-icon": he.badgeRightIcon,
                  size: A.value,
                  truncate: "",
                  "truncation-focusable": !1,
                  "show-close-icon": "",
                  "close-icon-inactive": R.value,
                  "remove-label": e.removeChipLabel(he.label),
                  onClose: (De) => ue(he.id)
                }, null, 8, ["label", "theme", "tooltip-text", "right-icon", "size", "close-icon-inactive", "remove-label", "onClose"])
              ]))), 128)),
              G.value > 0 ? (c(), g("div", r1, [
                te(I(ct), {
                  label: `+${G.value}`,
                  theme: e.disabled ? "disabled" : e.chipTheme,
                  size: A.value,
                  "show-close-icon": !1
                }, null, 8, ["label", "theme", "size"])
              ])) : k("", !0),
              v("span", o1, [
                b.value.length > 0 && !e.disabled && !e.readonly ? (c(), g("button", {
                  key: 0,
                  type: "button",
                  class: C([
                    we,
                    "relative cursor-pointer rounded-(--border-border-radius-rounded-xs) border-none bg-transparent p-0 text-(--text-text-body-subtle) transition-colors hover:text-(--text-text-black-default) focus-visible:shadow-(--shadow-focus-l) focus-visible:outline-hidden dark:text-(--colors-text-white-secondary) dark:hover:text-(--colors-text-white-default)",
                    "before:absolute before:top-1/2 before:left-1/2 before:size-6 before:-translate-x-1/2 before:-translate-y-1/2 before:content-['']"
                  ]),
                  "aria-label": e.clearAllLabel,
                  onClick: Ue(O, ["stop"])
                }, [...le[2] || (le[2] = [
                  v("i", {
                    class: "ri-close-line",
                    "aria-hidden": "true"
                  }, null, -1)
                ])], 10, i1)) : k("", !0),
                e.removeOnly ? k("", !0) : (c(), g("i", {
                  key: 1,
                  class: C([
                    "ri-arrow-down-s-line transition-transform duration-200 ease-in-out motion-reduce:transition-none",
                    we,
                    z.value
                  ]),
                  style: Ne({ transform: Te ? "rotate(180deg)" : "rotate(0deg)" }),
                  "aria-hidden": "true"
                }, null, 6))
              ])
            ]),
            _: 2
          }, 1032, ["id", "aria-expanded", "aria-labelledby", "aria-describedby", "aria-required", "aria-invalid", "aria-disabled", "aria-readonly", "aria-busy", "tabindex", "size", "disabled", "readonly", "error", "success", "focused", "has-value", "class", "onClick", "onKeydown"])
        ]),
        _: 1
      }, 8, ["search-query", "aria-label", "items", "sticky-item", "search-placeholder", "search-clear-label", "empty-label", "disable-internal-search-filter", "max-list-height", "footer-buttons", "menu-width"]),
      te(vt, {
        ref_key: "helperRef",
        ref: L,
        focused: x.value,
        hint: e.hint,
        error: e.error,
        "hint-id": d,
        "error-id": s,
        "test-id-prefix": "multiple-select"
      }, null, 8, ["focused", "hint", "error"])
    ]));
  }
}), d1 = ["aria-label"], u1 = { class: "w-full sm:w-56 sm:shrink-0" }, c1 = /* @__PURE__ */ ye({
  __name: "AccessRuleRow",
  props: {
    rule: {},
    position: {},
    options: {},
    labels: {},
    loading: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    disabledLevels: { default: () => [] },
    levelHint: { default: void 0 },
    removeOnly: { type: Boolean, default: !1 }
  },
  emits: ["update:userIds", "update:level", "remove", "search", "activate"],
  setup(e, { expose: n, emit: t }) {
    const a = t, l = E(null), r = () => {
      var i, s;
      (s = (i = l.value) == null ? void 0 : i.querySelector('[role="combobox"]')) == null || s.focus();
    }, o = (i) => {
      i && a("update:level", i);
    };
    return n({ focusPicker: r }), (i, s) => (c(), g("div", {
      role: "group",
      "aria-label": e.labels.ruleGroupLabel(e.position),
      "data-testid": "access-rule",
      class: "flex flex-col gap-3 sm:flex-row sm:items-start"
    }, [
      v("div", {
        ref_key: "pickerRef",
        ref: l,
        class: "min-w-0 flex-1",
        onFocusin: s[2] || (s[2] = (d) => a("activate"))
      }, [
        te(s1, {
          "model-value": e.rule.userIds,
          options: e.options,
          label: e.labels.rulePeopleLabel,
          placeholder: e.labels.pickerPlaceholder,
          "confirm-label": e.labels.pickerConfirm,
          "search-placeholder": e.labels.pickerSearchPlaceholder,
          "select-all-label": e.labels.pickerSelectAll,
          "clear-all-label": e.labels.pickerClearAll,
          "remove-chip-label": e.labels.removeUser,
          "empty-label": e.labels.pickerEmpty,
          "loading-label": e.labels.pickerLoading,
          loading: e.loading,
          disabled: e.disabled,
          "remove-only": e.removeOnly,
          async: "",
          "onUpdate:modelValue": s[0] || (s[0] = (d) => a("update:userIds", d)),
          onSearch: s[1] || (s[1] = (d) => a("search", d))
        }, null, 8, ["model-value", "options", "label", "placeholder", "confirm-label", "search-placeholder", "select-all-label", "clear-all-label", "remove-chip-label", "empty-label", "loading-label", "loading", "disabled", "remove-only"])
      ], 544),
      v("div", u1, [
        te(Td, {
          "model-value": e.rule.level,
          label: e.labels.ruleLevelLabel,
          levels: e.labels.levels,
          "disabled-levels": e.disabledLevels,
          hint: e.levelHint,
          disabled: e.disabled,
          "onUpdate:modelValue": o
        }, null, 8, ["model-value", "label", "levels", "disabled-levels", "hint", "disabled"])
      ]),
      te(Re, {
        variant: "secondary",
        size: "sm",
        "icon-only": "",
        "icon-left": "ri-delete-bin-line",
        "aria-label": e.labels.removeRule,
        disabled: e.disabled,
        class: "self-start sm:mt-5.5",
        "data-testid": "access-rule-remove",
        onClick: s[3] || (s[3] = (d) => a("remove"))
      }, null, 8, ["aria-label", "disabled"])
    ], 8, d1));
  }
}), Ls = ["Edit", "View"];
function f1() {
  let e = 0;
  return () => `rule-${++e}`;
}
function hf(e, n) {
  const t = /* @__PURE__ */ new Map();
  for (const { id: a, level: l } of e) {
    const r = t.get(a);
    (!r || Ls.indexOf(l) < Ls.indexOf(r)) && t.set(a, l);
  }
  return Ls.map((a) => ({
    key: n(),
    level: a,
    userIds: [...t].filter(([, l]) => l === a).map(([l]) => l)
  })).filter((a) => a.userIds.length > 0);
}
function bf(e) {
  const n = /* @__PURE__ */ new Set(), t = [];
  for (const a of e)
    for (const l of a.userIds)
      n.has(l) || (n.add(l), t.push({ id: l, level: a.level }));
  return t;
}
function gf(e, n) {
  if (e.organization !== n.organization || e.users.length !== n.users.length) return !1;
  const t = new Map(e.users.map((a) => [a.id, a.level]));
  return n.users.every((a) => t.get(a.id) === a.level);
}
const h1 = {
  class: "flex flex-col gap-6",
  "data-testid": "access-settings"
}, b1 = ["aria-labelledby"], g1 = { class: "flex flex-col gap-1" }, p1 = ["id"], m1 = { class: "text-sm leading-5 font-normal text-text-black-default dark:text-(--colors-text-white-default)" }, v1 = { class: "grid grid-cols-1 gap-4 sm:grid-cols-2" }, x1 = { "data-testid": "access-organization" }, y1 = ["aria-labelledby", "aria-describedby"], k1 = { class: "flex flex-col gap-1" }, w1 = ["id"], C1 = { class: "text-sm leading-5 font-normal text-text-black-default dark:text-(--colors-text-white-default)" }, S1 = { class: "text-sm leading-5 font-normal text-text-black-default dark:text-(--colors-text-white-default)" }, $1 = {
  "aria-live": "polite",
  "data-testid": "access-people-status"
}, I1 = ["id"], T1 = {
  key: 0,
  class: "flex flex-col rounded-xl border border-(--border-border-base-soft) dark:border-(--colors-border-base)"
}, L1 = { class: "self-start" }, E1 = ["tabindex"], TW = /* @__PURE__ */ ye({
  __name: "AccessSettings",
  props: {
    modelValue: {},
    userOptions: {},
    knownUsers: { default: () => [] },
    usersLoading: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    showTeam: { type: Boolean, default: !0 },
    labels: {}
  },
  emits: ["update:modelValue", "search"],
  setup(e, { emit: n }) {
    const t = e, a = n, l = Ve(), r = Ve(), o = Ve(), i = f1(), s = E(hf(t.modelValue.users, i));
    let d = null;
    const u = E(t.modelValue.organization), f = p(() => u.value === "Edit" ? ["Edit", "View"] : u.value === "View" ? ["View"] : []), b = p(() => u.value === "Edit"), h = p(() => u.value === "View" ? t.labels.viewWithoutEffect : void 0);
    Ie(
      () => t.modelValue,
      (G) => {
        const B = { organization: u.value, users: bf(s.value) };
        gf(G, B) || (s.value = hf(G.users, i), u.value = G.organization, d = null);
      },
      { deep: !0 }
    );
    const m = (G = u.value) => {
      const B = { organization: G, users: bf(s.value) };
      gf(B, d ?? t.modelValue) || (d = { organization: B.organization, users: B.users.map((F) => ({ ...F })) }, u.value = B.organization, a("update:modelValue", B));
    }, x = /* @__PURE__ */ new Map();
    let y = null, w = "";
    const S = (G) => {
      G !== w && (w = G, a("search", G));
    }, $ = (G, B) => {
      x.set(G, B), !(y !== null && y !== G) && (y = G, w = B, a("search", B));
    }, T = (G) => {
      y !== G && (y = G, S(x.get(G) ?? ""));
    }, L = E(/* @__PURE__ */ new Map());
    Ie(
      () => [t.userOptions, t.knownUsers],
      ([G, B]) => {
        for (const F of [...G, ...B]) L.value.set(F.id, F);
      },
      { immediate: !0, deep: !0 }
    );
    const A = (G) => {
      const B = new Set(s.value.filter((X) => X.key !== G.key).flatMap((X) => X.userIds));
      return [.../* @__PURE__ */ new Set([...G.userIds, ...t.userOptions.map((X) => X.id)])].map((X) => {
        const H = L.value.get(X) ?? { name: X }, q = B.has(X), N = f.value.includes(G.level) && !G.userIds.includes(X);
        return {
          id: X,
          label: H.inactive ? t.labels.inactiveUser(H.name) : H.name,
          secondaryText: q ? t.labels.alreadyInOtherRule : H.secondaryText,
          disabled: q || N,
          // A warning colour, not the "disabled" theme: the chip stays removable, so its text must keep 4.5:1 contrast.
          badgeTheme: H.inactive ? "orange" : void 0
        };
      });
    }, R = /* @__PURE__ */ new Map(), z = (G) => (B) => {
      B ? R.set(G, B) : R.delete(G);
    }, D = E(null), V = E(null), Y = () => {
      var G, B;
      return (B = b.value ? D.value : (G = V.value) == null ? void 0 : G.$el) == null ? void 0 : B.focus();
    }, _ = async () => {
      var B;
      const G = { key: i(), level: u.value === "View" ? "Edit" : "View", userIds: [] };
      s.value.push(G), T(G.key), await qe(), (B = R.get(G.key)) == null || B.focusPicker();
    }, j = async (G) => {
      var X;
      const [B] = s.value.splice(G, 1);
      B && x.delete(B.key), m(), await qe();
      const F = s.value[G - 1] ?? s.value[G];
      F ? (X = R.get(F.key)) == null || X.focusPicker() : Y();
    }, M = (G, B) => {
      s.value[G].userIds = B, m();
    }, W = (G, B) => {
      s.value[G].level = B, m();
    };
    return (G, B) => (c(), g("div", h1, [
      v("section", {
        role: "group",
        "aria-labelledby": I(l),
        class: "flex flex-col gap-3"
      }, [
        v("div", g1, [
          v("p", {
            id: I(l),
            class: "text-base leading-5 font-bold text-text-black-default dark:text-(--colors-text-white-default)"
          }, P(e.labels.generalTitle), 9, p1),
          v("p", m1, P(e.labels.generalDescription), 1)
        ]),
        v("div", v1, [
          v("div", x1, [
            te(Td, {
              "model-value": u.value,
              label: e.labels.organizationLabel,
              levels: e.labels.levels,
              disabled: e.disabled,
              "allow-none": "",
              "onUpdate:modelValue": B[0] || (B[0] = (F) => m(F))
            }, null, 8, ["model-value", "label", "levels", "disabled"])
          ]),
          e.showTeam ? (c(), K(ft, {
            key: 0,
            text: e.labels.teamUnavailableTooltip,
            role: "group",
            "aria-label": e.labels.teamLabel,
            "aria-disabled": "true",
            tabindex: "0",
            "data-testid": "access-team-row"
          }, {
            default: ve(() => [
              te(Td, {
                "model-value": null,
                label: e.labels.teamLabel,
                levels: e.labels.levels,
                "allow-none": "",
                disabled: ""
              }, null, 8, ["label", "levels"])
            ]),
            _: 1
          }, 8, ["text", "aria-label"])) : k("", !0)
        ])
      ], 8, b1),
      v("section", {
        role: "group",
        "aria-labelledby": I(r),
        "aria-describedby": b.value ? I(o) : void 0,
        class: "flex flex-col gap-3"
      }, [
        v("div", k1, [
          v("p", {
            id: I(r),
            class: "text-base leading-5 font-bold text-text-black-default dark:text-(--colors-text-white-default)"
          }, P(e.labels.peopleTitle), 9, w1),
          v("p", C1, P(e.labels.peopleDescription), 1),
          v("p", S1, P(e.labels.groupingHint), 1),
          v("div", $1, [
            b.value ? (c(), g("p", {
              key: 0,
              id: I(o),
              class: "text-sm leading-5 font-medium text-text-black-default dark:text-(--colors-text-white-default)",
              "data-testid": "access-people-without-effect"
            }, P(e.labels.peopleWithoutEffect), 9, I1)) : k("", !0)
          ])
        ]),
        s.value.length > 0 ? (c(), g("div", T1, [
          (c(!0), g(se, null, Me(s.value, (F, X) => (c(), K(c1, {
            key: F.key,
            ref_for: !0,
            ref: z(F.key),
            class: "border-t border-(--border-border-base-soft) p-4 first:border-t-0 dark:border-(--colors-border-base)",
            rule: F,
            position: X + 1,
            options: A(F),
            "disabled-levels": f.value,
            "level-hint": h.value,
            "remove-only": b.value,
            labels: e.labels,
            loading: e.usersLoading,
            disabled: e.disabled,
            "onUpdate:userIds": (H) => M(X, H),
            "onUpdate:level": (H) => W(X, H),
            onRemove: (H) => j(X),
            onSearch: (H) => $(F.key, H),
            onActivate: (H) => T(F.key)
          }, null, 8, ["rule", "position", "options", "disabled-levels", "level-hint", "remove-only", "labels", "loading", "disabled", "onUpdate:userIds", "onUpdate:level", "onRemove", "onSearch", "onActivate"]))), 128))
        ])) : k("", !0),
        v("div", L1, [
          te(ft, {
            text: e.labels.peopleWithoutEffect,
            disabled: !b.value
          }, {
            default: ve(() => [
              v("span", {
                ref_key: "addRuleStop",
                ref: D,
                class: "inline-flex rounded-full focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-royalblue focus-visible:ring-offset-2",
                tabindex: b.value ? 0 : void 0,
                "data-testid": "access-add-rule-stop"
              }, [
                te(Re, {
                  ref_key: "addRuleButton",
                  ref: V,
                  variant: "secondary",
                  size: "sm",
                  "icon-left": "ri-add-line",
                  label: e.labels.addRule,
                  disabled: e.disabled || b.value,
                  "data-testid": "access-add-rule",
                  onClick: _
                }, null, 8, ["label", "disabled"])
              ], 8, E1)
            ]),
            _: 1
          }, 8, ["text", "disabled"])
        ])
      ], 8, y1)
    ]));
  }
}), LW = /* @__PURE__ */ ye({
  __name: "WeekNavigator",
  props: {
    weekStartDate: {},
    weekEndDate: {},
    locale: { default: "en" },
    previousLabel: { default: "Previous week" },
    nextLabel: { default: "Next week" },
    todayLabel: { default: "Today" },
    previousDisabled: { type: Boolean, default: !1 },
    todayDisabled: { type: Boolean, default: !1 },
    previousDisabledReason: { default: void 0 },
    todayDisabledReason: { default: void 0 },
    showToday: { type: Boolean, default: !0 },
    fullWidth: { type: Boolean, default: !1 }
  },
  emits: ["previous-week", "next-week", "today-week"],
  setup(e, { emit: n }) {
    const t = e, a = n, l = p(() => {
      const r = new Intl.DateTimeFormat(t.locale, {
        day: "numeric",
        month: "long",
        timeZone: "UTC"
      }), o = new Intl.DateTimeFormat(t.locale, {
        day: "numeric",
        month: "long",
        ...t.fullWidth ? { year: "numeric" } : {},
        timeZone: "UTC"
      }), i = r.format(/* @__PURE__ */ new Date(`${t.weekStartDate}T00:00:00Z`)), s = o.format(/* @__PURE__ */ new Date(`${t.weekEndDate}T00:00:00Z`));
      return `${i} - ${s}`;
    });
    return (r, o) => (c(), g("div", {
      class: C(["flex flex-wrap items-center gap-(--spacing-2)", e.fullWidth ? "w-full" : void 0])
    }, [
      e.showToday ? (c(), K(ft, {
        key: 0,
        text: e.todayDisabledReason ?? "",
        disabled: !e.todayDisabled || !e.todayDisabledReason,
        tabindex: e.todayDisabled && e.todayDisabledReason ? 0 : void 0
      }, {
        default: ve(() => [
          te(Re, {
            variant: "secondary",
            size: "sm",
            label: e.todayLabel,
            disabled: e.todayDisabled,
            "data-testid": "week-navigator-today",
            onClick: o[0] || (o[0] = (i) => a("today-week"))
          }, null, 8, ["label", "disabled"])
        ]),
        _: 1
      }, 8, ["text", "disabled", "tabindex"])) : k("", !0),
      v("div", {
        class: C(["flex items-center gap-(--spacing-2)", e.fullWidth ? "w-full justify-between" : void 0])
      }, [
        te(ft, {
          text: e.previousDisabledReason ?? "",
          disabled: !e.previousDisabled || !e.previousDisabledReason,
          tabindex: e.previousDisabled && e.previousDisabledReason ? 0 : void 0
        }, {
          default: ve(() => [
            te(Re, {
              variant: "ghost",
              size: e.fullWidth ? "md" : "sm",
              "icon-only": "",
              "icon-left": "ri-arrow-left-line",
              "aria-label": e.previousLabel,
              disabled: e.previousDisabled,
              onClick: o[1] || (o[1] = (i) => a("previous-week"))
            }, null, 8, ["size", "aria-label", "disabled"])
          ]),
          _: 1
        }, 8, ["text", "disabled", "tabindex"]),
        v("p", {
          "aria-live": "polite",
          class: C([
            "font-(--weight-semi-bold)",
            e.fullWidth ? "flex-1 text-center text-(length:--size-xl) leading-(--line-height-xl)" : "text-(length:--size-m)"
          ])
        }, P(l.value), 3),
        te(Re, {
          variant: "ghost",
          size: e.fullWidth ? "md" : "sm",
          "icon-only": "",
          "icon-right": "ri-arrow-right-line",
          "aria-label": e.nextLabel,
          onClick: o[2] || (o[2] = (i) => a("next-week"))
        }, null, 8, ["size", "aria-label"])
      ], 2)
    ], 2));
  }
}), A1 = {
  "data-testid": "metric-card-simple",
  class: "shadow-[0px_0px_4px_rgba(0,0,0,0.1)] dark:shadow-[0px_0px_4px_rgba(255,255,255,0.1)] rounded-num-12 bg-white dark:bg-[var(--colors-background-black-default)] w-num-301.5 flex flex-col items-center p-num-24 box-border gap-2"
}, R1 = { class: "relative leading-num-29 text-[24px] text-gray-300 dark:text-[var(--colors-text-white-default)] font-inter" }, B1 = { class: "relative text-num-16 leading-6 text-text-body dark:text-[var(--colors-text-white-secondary)]" }, EW = /* @__PURE__ */ ye({
  __name: "MetricCardSimple",
  props: {
    value: { default: "" },
    label: { default: "" },
    loading: { type: Boolean, default: !1 }
  },
  setup(e) {
    return (n, t) => (c(), g("div", A1, [
      e.loading ? (c(), g(se, { key: 0 }, [
        t[0] || (t[0] = v("div", { class: "skeleton h-[29px] w-24" }, null, -1)),
        t[1] || (t[1] = v("div", { class: "skeleton h-6 w-40" }, null, -1))
      ], 64)) : (c(), g(se, { key: 1 }, [
        v("b", R1, P(e.value), 1),
        v("div", B1, P(e.label), 1)
      ], 64))
    ]));
  }
}), M1 = {
  "data-testid": "metric-card-with-icon",
  class: "shadow-[0px_0px_4px_rgba(0,0,0,0.1)] dark:shadow-[0px_0px_4px_rgba(255,255,255,0.1)] rounded-num-12 bg-white dark:bg-[var(--colors-background-black-default)] w-num-301.5 flex items-center p-num-24 box-border gap-3.5"
}, D1 = { class: "h-16 w-[63.9px] rounded-num-12 bg-white dark:bg-[var(--colors-background-black-default)] border-gainsboro dark:border-[var(--colors-border-base)] border-solid border box-border flex items-center justify-center" }, z1 = ["src", "alt"], O1 = { class: "flex flex-col items-start gap-2" }, P1 = { class: "relative leading-num-29 text-[24px] text-gray-300 dark:text-[var(--colors-text-white-default)] font-inter" }, F1 = { class: "relative text-num-16 leading-6 text-slategray dark:text-[var(--colors-text-white-secondary)]" }, AW = /* @__PURE__ */ ye({
  __name: "MetricCardWithIcon",
  props: {
    value: { default: "" },
    label: { default: "" },
    icon: { default: void 0 },
    iconAlt: { default: "" },
    loading: { type: Boolean, default: !1 }
  },
  setup(e) {
    return (n, t) => (c(), g("div", M1, [
      e.loading ? (c(), g(se, { key: 0 }, [
        t[0] || (t[0] = v("div", { class: "skeleton h-16 w-[63.9px] rounded-num-12" }, null, -1)),
        t[1] || (t[1] = v("div", { class: "flex flex-col items-start gap-2 flex-1" }, [
          v("div", { class: "skeleton h-[29px] w-24" }),
          v("div", { class: "skeleton h-6 w-40" })
        ], -1))
      ], 64)) : (c(), g(se, { key: 1 }, [
        v("div", D1, [
          $e(n.$slots, "icon", {}, () => [
            e.icon ? (c(), g("img", {
              key: 0,
              src: e.icon,
              alt: e.iconAlt,
              class: "h-9 w-9 relative"
            }, null, 8, z1)) : k("", !0)
          ])
        ]),
        v("div", O1, [
          v("b", P1, P(e.value), 1),
          v("div", F1, P(e.label), 1)
        ])
      ], 64))
    ]));
  }
}), V1 = { class: "shadow-[0px_0px_4px_rgba(0,0,0,0.1)] dark:shadow-[0px_0px_4px_rgba(255,255,255,0.1)] rounded-num-12 bg-white dark:bg-[var(--colors-background-black-default)] w-num-301.5 flex flex-col items-center p-num-24 box-border gap-3" }, N1 = { class: "flex flex-col items-center gap-2" }, H1 = { class: "relative leading-num-29 text-[24px] text-gray-300 dark:text-[var(--colors-text-white-default)] font-inter" }, j1 = { class: "relative text-num-16 leading-6 text-text-body dark:text-[var(--colors-text-white-secondary)]" }, W1 = { class: "rounded-sm bg-honeydew dark:bg-[var(--colors-background-success)] flex items-center justify-center py-0.5 px-1 gap-1 text-center text-[12px]" }, q1 = ["src"], U1 = { class: "relative leading-num-20 font-medium dark:text-[var(--colors-text-success-strong)]" }, RW = /* @__PURE__ */ ye({
  __name: "MetricCardWithTrend",
  props: {
    value: { default: "" },
    label: { default: "" },
    trendText: { default: "" },
    trendIcon: { default: void 0 },
    loading: { type: Boolean, default: !1 }
  },
  setup(e) {
    return (n, t) => (c(), g("div", V1, [
      e.loading ? (c(), g(se, { key: 0 }, [
        t[0] || (t[0] = v("div", { class: "flex flex-col items-center gap-2" }, [
          v("div", { class: "skeleton h-[29px] w-24" }),
          v("div", { class: "skeleton h-6 w-40" })
        ], -1)),
        t[1] || (t[1] = v("div", { class: "skeleton h-5 w-32 rounded-sm" }, null, -1))
      ], 64)) : (c(), g(se, { key: 1 }, [
        v("div", N1, [
          v("b", H1, P(e.value), 1),
          v("div", j1, P(e.label), 1)
        ]),
        v("div", W1, [
          $e(n.$slots, "trend-icon", {}, () => [
            e.trendIcon ? (c(), g("img", {
              key: 0,
              src: e.trendIcon,
              alt: "trend",
              class: "h-3 w-3 relative"
            }, null, 8, q1)) : k("", !0)
          ]),
          v("div", U1, P(e.trendText), 1)
        ])
      ], 64))
    ]));
  }
}), G1 = {
  "data-testid": "metric-card-with-badge",
  class: "shadow-[0px_0px_4px_rgba(0,0,0,0.1)] dark:shadow-[0px_0px_4px_rgba(255,255,255,0.1)] rounded-num-12 bg-white dark:bg-[var(--colors-background-black-default)] w-num-301.5 flex flex-col items-start justify-center p-num-24 box-border gap-2 relative"
}, K1 = { class: "relative leading-num-29 text-[24px] text-gray-300 dark:text-[var(--colors-text-white-default)] font-inter z-0" }, Y1 = { class: "relative text-num-16 leading-6 text-slategray dark:text-[var(--colors-text-white-secondary)] z-1" }, J1 = {
  key: 0,
  class: "absolute top-[10px] right-[11px] rounded-sm bg-honeydew dark:bg-[var(--colors-background-success)] flex items-center justify-center py-0.5 px-1 z-2 text-center text-[12px]"
}, Z1 = { class: "relative leading-num-20 font-medium dark:text-[var(--colors-text-success-strong)]" }, BW = /* @__PURE__ */ ye({
  __name: "MetricCardWithBadge",
  props: {
    value: { default: "" },
    label: { default: "" },
    badgeText: { default: "" },
    loading: { type: Boolean, default: !1 }
  },
  setup(e) {
    return (n, t) => (c(), g("div", G1, [
      e.loading ? (c(), g(se, { key: 0 }, [
        t[0] || (t[0] = v("div", { class: "skeleton h-[29px] w-24" }, null, -1)),
        t[1] || (t[1] = v("div", { class: "skeleton h-6 w-40" }, null, -1)),
        t[2] || (t[2] = v("div", { class: "skeleton h-5 w-12 rounded-sm absolute top-[10px] right-[11px]" }, null, -1))
      ], 64)) : (c(), g(se, { key: 1 }, [
        v("b", K1, P(e.value), 1),
        v("div", Y1, P(e.label), 1),
        e.badgeText ? (c(), g("div", J1, [
          v("div", Z1, P(e.badgeText), 1)
        ])) : k("", !0)
      ], 64))
    ]));
  }
}), X1 = { class: "shadow-[0px_0px_4px_rgba(0,0,0,0.1)] dark:shadow-[0px_0px_4px_rgba(255,255,255,0.1)] rounded-num-12 bg-white dark:bg-[var(--colors-background-black-default)] w-num-301.5 flex items-center p-num-24 box-border text-num-16 text-slategray dark:text-[var(--colors-text-white-secondary)]" }, Q1 = {
  key: 0,
  class: "flex-1 flex flex-col items-start gap-3"
}, _1 = {
  key: 1,
  class: "flex-1 flex flex-col items-start gap-3"
}, e2 = { class: "flex items-center gap-2" }, t2 = ["src"], n2 = { class: "relative leading-6 dark:text-[var(--colors-text-white-secondary)]" }, a2 = { class: "relative text-[24px] leading-num-29 text-gray-300 dark:text-[var(--colors-text-white-default)] font-inter" }, l2 = { class: "flex items-center gap-2 text-[14px] text-text-success dark:text-[var(--colors-text-success-subtle)]" }, r2 = { class: "flex items-center justify-end" }, o2 = ["src"], i2 = { class: "relative leading-num-20 font-medium" }, s2 = { class: "relative leading-num-20 text-dimgray dark:text-[var(--colors-text-white-secondary)]" }, MW = /* @__PURE__ */ ye({
  __name: "MetricCardWithChart",
  props: {
    title: { default: "" },
    value: { default: "" },
    trendValue: { default: "" },
    trendLabel: { default: "" },
    chartIcon: { default: void 0 },
    trendIcon: { default: void 0 },
    loading: { type: Boolean, default: !1 }
  },
  setup(e) {
    return (n, t) => (c(), g("div", X1, [
      e.loading ? (c(), g("div", Q1, [...t[0] || (t[0] = [
        Xr('<div class="flex items-center gap-2"><div class="skeleton h-5 w-5 rounded"></div><div class="skeleton h-6 w-28"></div></div><div class="skeleton h-[29px] w-32"></div><div class="flex items-center gap-2"><div class="skeleton h-5 w-16"></div><div class="skeleton h-5 w-24"></div></div>', 3)
      ])])) : (c(), g("div", _1, [
        v("div", e2, [
          $e(n.$slots, "chart-icon", {}, () => [
            e.chartIcon ? (c(), g("img", {
              key: 0,
              src: e.chartIcon,
              alt: "chart",
              class: "h-5 w-5 relative"
            }, null, 8, t2)) : k("", !0)
          ]),
          v("div", n2, P(e.title), 1)
        ]),
        v("b", a2, P(e.value), 1),
        v("div", l2, [
          v("div", r2, [
            $e(n.$slots, "trend-icon", {}, () => [
              e.trendIcon ? (c(), g("img", {
                key: 0,
                src: e.trendIcon,
                alt: "trend",
                class: "h-4 w-4 relative"
              }, null, 8, o2)) : k("", !0)
            ]),
            v("div", i2, P(e.trendValue), 1)
          ]),
          v("div", s2, P(e.trendLabel), 1)
        ])
      ]))
    ]));
  }
}), d2 = {
  class: "flex flex-col justify-center gap-6 rounded-(--border-border-radius-rounded-l) border border-(--border-border-base-soft) bg-(--colors-background-white) p-6 shadow-(--blur-shadow-s) dark:border-(--colors-border-base) dark:bg-(--colors-background-black-default) dark:shadow-[0px_0px_4px_rgba(255,255,255,0.1)]",
  "data-testid": "metric-card-progress"
}, u2 = { class: "flex flex-col gap-2" }, c2 = {
  class: "text-base leading-6 text-(--colors-text-body) dark:text-(--colors-text-white-secondary)",
  "data-testid": "metric-card-progress-title"
}, f2 = { class: "flex items-end gap-2" }, h2 = {
  class: "text-2xl leading-[29px] font-bold text-(--colors-text-heading) dark:text-(--colors-text-white-default)",
  "data-testid": "metric-card-progress-value"
}, b2 = {
  key: 0,
  class: "text-sm leading-5 text-(--colors-text-body) dark:text-(--colors-text-white-secondary)",
  "data-testid": "metric-card-progress-target"
}, g2 = { class: "flex flex-col gap-1.5" }, p2 = ["aria-label", "aria-valuenow", "aria-valuetext"], m2 = {
  key: 0,
  class: "flex items-center justify-between gap-2"
}, v2 = {
  class: "text-sm leading-5 text-(--colors-text-body) dark:text-(--colors-text-white-secondary)",
  "data-testid": "metric-card-progress-label"
}, DW = /* @__PURE__ */ ye({
  __name: "MetricCardProgress",
  props: {
    title: { default: "" },
    value: { default: "" },
    target: { default: void 0 },
    used: { default: 0 },
    total: { default: 0 },
    unit: { default: "" },
    loading: { type: Boolean, default: !1 },
    progressFormat: { type: Function, default: void 0 },
    progressLabel: { default: void 0 }
  },
  setup(e) {
    const n = e, t = p(() => n.total <= 0 ? 0 : Math.min(Math.max(n.used / n.total * 100, 0), 100)), a = p(() => n.progressLabel !== void 0 ? n.progressLabel : n.total <= 0 || !n.progressFormat ? "" : n.progressFormat(n.used, n.total, n.unit));
    return (l, r) => (c(), g("div", d2, [
      e.loading ? (c(), g(se, { key: 0 }, [
        r[0] || (r[0] = Xr('<div class="flex flex-col gap-2"><div class="skeleton h-6 w-32"></div><div class="skeleton h-[29px] w-24"></div></div><div class="flex flex-col gap-1.5"><div class="skeleton h-2.5 w-full rounded-full"></div><div class="skeleton h-5 w-40"></div></div>', 2))
      ], 64)) : (c(), g(se, { key: 1 }, [
        v("div", u2, [
          v("span", c2, P(e.title), 1),
          v("div", f2, [
            v("b", h2, P(e.value), 1),
            e.target ? (c(), g("span", b2, "/ " + P(e.target), 1)) : k("", !0)
          ])
        ]),
        v("div", g2, [
          v("div", {
            class: "h-2.5 w-full overflow-hidden rounded-full bg-(--colors-background-gray)",
            role: "progressbar",
            "aria-label": e.title || void 0,
            "aria-valuemin": 0,
            "aria-valuemax": 100,
            "aria-valuenow": e.total > 0 ? t.value : void 0,
            "aria-valuetext": a.value || void 0
          }, [
            v("div", {
              class: "h-full rounded-full transition-[width] duration-300",
              style: Ne({
                width: `${t.value}%`,
                backgroundImage: "var(--gradient-brand-horizontal)"
              })
            }, null, 4)
          ], 8, p2),
          a.value || l.$slots.trend ? (c(), g("div", m2, [
            v("span", v2, P(a.value), 1),
            $e(l.$slots, "trend")
          ])) : k("", !0)
        ])
      ], 64))
    ]));
  }
}), x2 = { class: "shadow-[0px_0px_4px_rgba(0,0,0,0.1)] dark:shadow-[0px_0px_4px_rgba(255,255,255,0.1)] rounded-num-12 bg-white dark:bg-[var(--colors-background-black-default)] w-num-301.5 flex flex-col items-start p-num-24 box-border text-num-16 text-slategray dark:text-[var(--colors-text-white-secondary)]" }, y2 = {
  key: 0,
  class: "self-stretch flex flex-col items-start gap-2"
}, k2 = {
  key: 1,
  class: "self-stretch flex flex-col items-start gap-2"
}, w2 = { class: "self-stretch flex items-center justify-between gap-5" }, C2 = { class: "flex items-center gap-1.5" }, S2 = { class: "relative leading-6 dark:text-[var(--colors-text-white-secondary)]" }, $2 = ["src"], I2 = { class: "relative text-[24px] leading-num-29 text-gray-300 dark:text-[var(--colors-text-white-default)] font-inter" }, T2 = { class: "relative leading-6 text-text-body dark:text-[var(--colors-text-white-secondary)]" }, zW = /* @__PURE__ */ ye({
  __name: "MetricCardAction",
  props: {
    title: { default: "" },
    value: { default: "" },
    subtitle: { default: "" },
    actionText: { default: "" },
    dropdownIcon: { default: void 0 },
    loading: { type: Boolean, default: !1 }
  },
  emits: ["action"],
  setup(e) {
    return (n, t) => (c(), g("div", x2, [
      e.loading ? (c(), g("div", y2, [...t[1] || (t[1] = [
        Xr('<div class="self-stretch flex items-center justify-between gap-5"><div class="skeleton h-6 w-24"></div><div class="skeleton h-8 w-16 rounded"></div></div><div class="skeleton h-[29px] w-32"></div><div class="skeleton h-6 w-40"></div>', 3)
      ])])) : (c(), g("div", k2, [
        v("div", w2, [
          v("div", C2, [
            v("div", S2, P(e.title), 1),
            $e(n.$slots, "dropdown-icon", {}, () => [
              e.dropdownIcon ? (c(), g("img", {
                key: 0,
                src: e.dropdownIcon,
                alt: "dropdown",
                class: "h-[18px] w-[18px] relative"
              }, null, 8, $2)) : k("", !0)
            ])
          ]),
          e.actionText ? (c(), K(I(Re), {
            key: 0,
            variant: "secondary",
            label: e.actionText,
            size: "sm",
            onClick: t[0] || (t[0] = (a) => n.$emit("action"))
          }, null, 8, ["label"])) : k("", !0)
        ]),
        v("b", I2, P(e.value), 1),
        v("div", T2, P(e.subtitle), 1)
      ]))
    ]));
  }
}), gg = Symbol("FieldBelow"), L2 = new Proxy({}, { get: () => {
} });
function Ht() {
  const e = Mn();
  return (n) => {
    var t;
    return !!((t = e[n]) != null && t.call(e, L2).some((a) => a.type !== Mb));
  };
}
const Sa = {
  sm: {
    addon: "pl-[calc(--spacing(2)-1px)] pr-[calc(--spacing(2)-1px)]",
    input: "pl-[calc(--spacing(2))]",
    inputEnd: "pr-[calc(--spacing(2)-1px)]"
  },
  md: {
    addon: "pl-[calc(--spacing(2.5)-1px)] pr-[calc(--spacing(2.5)-1px)]",
    input: "pl-[calc(--spacing(2.5))]",
    inputEnd: "pr-[calc(--spacing(2.5)-1px)]"
  },
  lg: {
    addon: "pl-[calc(--spacing(3)-1px)] pr-[calc(--spacing(3)-1px)]",
    input: "pl-[calc(--spacing(3))]",
    inputEnd: "pr-[calc(--spacing(3)-1px)]"
  },
  xl: {
    addon: "pl-[calc(--spacing(3.5)-1px)] pr-[calc(--spacing(3.5)-1px)]",
    input: "pl-[calc(--spacing(3.5))]",
    inputEnd: "pr-[calc(--spacing(3.5)-1px)]"
  }
}, E2 = ["id", "name", "type", "value", "placeholder", "disabled", "readonly", "inputmode", "autocomplete", "pattern", "maxlength", "minlength", "min", "max", "aria-labelledby", "aria-label", "aria-disabled", "aria-invalid", "aria-describedby", "aria-required"], A2 = ["aria-label", "onKeydown"], R2 = {
  key: 0,
  class: "shrink-0"
}, B2 = /* @__PURE__ */ ye({
  __name: "TextInput",
  props: {
    placeholder: { default: void 0 },
    modelValue: { default: "" },
    iconLeft: { default: void 0 },
    size: { default: "md" },
    disabled: { type: Boolean, default: !1 },
    success: { type: Boolean, default: !1 },
    labels: { default: () => ({ clear: "Clear input" }) },
    type: { default: "text" },
    name: { default: void 0 },
    id: { default: void 0 },
    fullWidth: { type: Boolean, default: !1 },
    width: { default: void 0 },
    label: { default: void 0 },
    labelTooltip: { default: void 0 },
    required: { type: Boolean, default: !1 },
    requiredIndicator: { default: "*" },
    labelInline: { type: Boolean, default: !1 },
    ariaLabel: { default: void 0 },
    inputmode: { default: void 0 },
    autocomplete: { default: "off" },
    pattern: { default: void 0 },
    maxlength: { default: void 0 },
    minlength: { default: void 0 },
    min: { default: void 0 },
    max: { default: void 0 },
    error: { default: void 0 },
    hint: { default: void 0 },
    ariaDescribedby: { default: void 0 },
    readonly: { type: Boolean, default: !1 },
    readonlyChrome: { type: Boolean, default: !0 },
    valueVariant: { default: "default" },
    showEditIcon: { type: Boolean, default: !0 },
    variant: { default: "default" },
    buttons: { default: () => [] },
    buttonLayout: { default: "attached" },
    buttonSize: { default: void 0 },
    innerButton: { default: void 0 },
    prefix: { default: void 0 },
    removeButton: { default: void 0 }
  },
  emits: ["update:modelValue", "input", "focus", "blur", "clear", "keydown", "button-click"],
  setup(e, { emit: n }) {
    const t = e, a = (U, { slots: Q }) => {
      var ae;
      return (ae = Q.default) == null ? void 0 : ae.call(Q);
    }, l = n, r = E(!1), o = E(null), i = E(null), s = E(null), d = Mn(), u = Ht(), f = p(() => u("actions")), b = Ft(gg, null), h = p(() => (b == null ? void 0 : b()) ?? null), m = p(() => t.modelValue !== void 0 && t.modelValue !== null && t.modelValue.trim() !== ""), x = p(() => !!t.error), y = Ve(), w = p(() => t.id || y), S = p(() => t.label ? `${w.value}-label` : void 0), $ = p(() => `${w.value}-error`), T = p(() => `${w.value}-hint`), L = p(() => {
      if (t.ariaDescribedby) return t.ariaDescribedby;
      const U = [];
      return t.hint && T.value && U.push(T.value), x.value && $.value && U.push($.value), U.length > 0 ? U.join(" ") : void 0;
    }), A = p(() => x.value ? "true" : void 0), R = p(() => t.valueVariant === "link" ? "text-(--text-text-link) font-(--weight-semi-bold)" : ""), z = (U) => t.showEditIcon && U && !r.value && !t.disabled && !t.readonly, D = p(() => r.value && m.value && !t.disabled && !t.readonly), V = p(() => t.fullWidth || t.width === void 0), Y = p(() => V.value ? "w-full" : ""), _ = p(() => V.value ? {} : { width: t.width }), j = p(
      () => t.buttons.length > 0 && t.labelInline ? { style: _.value } : {}
    ), M = p(() => t.buttons.length > 0), W = p(
      () => Kl(t.labelInline, !!t.label && !N.value, !!t.removeButton)
    ), G = p(() => t.removeButton && Nu(t.removeButton)), B = E(null), { inGroup: F, groupPart: X } = ju(B), H = p(() => `${`relative min-w-0 ${F ? X.value.part : "pb-0.5"} text-left text-(length:--size-m) text-(--text-text-black-default) dark:text-(--colors-text-white-default) font-inter`} ${W.value.root}${V.value ? " w-full" : ""}`), q = p(() => V.value || t.labelInline ? {} : { width: t.width }), N = p(() => t.variant === "stacked"), J = p(() => !!t.prefix && !N.value), be = p(() => {
      if (N.value)
        return { class: "relative flex w-full min-w-0 items-center justify-center gap-0.5 px-6" };
      if (J.value) {
        const U = Sa[t.size];
        return {
          class: [
            "flex h-full min-w-0 flex-1 items-center gap-2",
            U.input,
            t.innerButton ? "" : U.inputEnd
          ]
        };
      }
      return null;
    }), ke = p(() => t.disabled ? "text-(--text-text-disabled-light) dark:text-(--colors-text-disabled)" : !t.readonly && !x.value && !t.success && !r.value && !m.value ? "text-(--text-text-heading) dark:text-(--colors-text-white-default)" : "text-(--text-text-black-default) dark:text-(--colors-text-white-default)"), ee = (U) => {
      var ie;
      if (!N.value || t.disabled) return;
      const Q = U.target;
      if (Q === o.value) return;
      const ae = U.currentTarget, Z = Q == null ? void 0 : Q.closest('button, a, [role="button"], input, select, textarea, [tabindex]');
      Z && Z !== ae && ae.contains(Z) || (U.preventDefault(), (ie = o.value) == null || ie.focus());
    }, oe = (U) => {
      const Q = U.target;
      l("update:modelValue", Q.value), l("input", U);
    }, ge = (U) => {
      var Q;
      t.disabled || (r.value = !0, (Q = U.target) == null || Q.select()), l("focus", U);
    }, re = (U) => {
      r.value = !1, l("blur", U);
    }, ue = (U) => {
      var Q, ae;
      l("keydown", U), (Q = i.value) == null || Q.handleFieldKeydown(U), (ae = s.value) == null || ae.handleFieldKeydown(U);
    }, O = () => {
      l("update:modelValue", ""), l("clear");
    };
    return (U, Q) => (c(), g("div", {
      ref_key: "rootRef",
      ref: B,
      class: C(H.value),
      style: Ne(q.value)
    }, [
      e.label && !N.value ? (c(), K(xt, {
        key: 0,
        id: S.value,
        ref_key: "labelRef",
        ref: i,
        text: e.label,
        "input-id": w.value,
        required: e.required,
        "required-indicator": e.requiredIndicator,
        tooltip: e.labelTooltip,
        focused: r.value,
        inline: e.labelInline,
        class: C(W.value.label),
        "test-id": "text-input-label"
      }, null, 8, ["id", "text", "input-id", "required", "required-indicator", "tooltip", "focused", "inline", "class"])) : k("", !0),
      v("div", {
        class: C(["flex items-end gap-3 w-full", W.value.field])
      }, [
        te(to, Oe({
          buttons: e.buttons,
          layout: e.buttonLayout,
          size: e.size,
          disabled: e.disabled,
          "button-size": e.buttonSize
        }, j.value, {
          onButtonClick: Q[2] || (Q[2] = (ae) => l("button-click", ae))
        }), {
          default: ve(({ fieldClass: ae }) => [
            te(Rn, {
              size: e.size,
              stacked: N.value,
              flush: J.value,
              "inner-button": !!e.innerButton,
              disabled: e.disabled,
              readonly: e.readonly && e.readonlyChrome,
              error: x.value,
              success: e.success,
              "has-value": m.value,
              class: C([
                e.disabled && e.valueVariant === "link" ? "cursor-pointer" : "",
                M.value ? "w-full" : Y.value,
                !M.value && f.value ? "flex-1 min-w-0" : "",
                ae || I(X).corners
              ]),
              style: Ne(M.value || f.value ? {} : _.value),
              onMousedown: ee
            }, {
              default: ve(({
                hovered: Z,
                iconBoxClass: ie,
                leftIconBoxClass: fe,
                iconColorClass: de,
                textClass: ne,
                topTextClass: le,
                borderColorClass: Le,
                addonTextClass: Te
              }) => [
                N.value && e.label ? (c(), K(xt, {
                  key: 0,
                  id: S.value,
                  ref_key: "labelRef",
                  ref: i,
                  text: e.label,
                  "input-id": w.value,
                  required: e.required,
                  "required-indicator": e.requiredIndicator,
                  focused: r.value,
                  "text-class": `${le} ${ke.value}`,
                  "test-id": "text-input-label"
                }, null, 8, ["id", "text", "input-id", "required", "required-indicator", "focused", "text-class"])) : k("", !0),
                J.value ? (c(), g("span", {
                  key: 1,
                  "data-testid": "text-input-prefix",
                  class: C([
                    "flex shrink-0 select-none items-center gap-2 self-stretch border-r",
                    I(Sa)[e.size].addon,
                    "text-(length:--size-m) leading-(--line-height-l)",
                    Le,
                    Te
                  ])
                }, [
                  e.iconLeft ? (c(), g("i", {
                    key: 0,
                    class: C([e.iconLeft, fe, de])
                  }, null, 2)) : k("", !0),
                  at(" " + P(e.prefix), 1)
                ], 2)) : k("", !0),
                (c(), K(dt(be.value ? "div" : a), en(tn(be.value ?? {})), {
                  default: ve(() => [
                    e.iconLeft && !J.value ? (c(), g("i", {
                      key: 0,
                      class: C([e.iconLeft, fe, de])
                    }, null, 2)) : k("", !0),
                    v("input", {
                      id: w.value,
                      ref_key: "inputRef",
                      ref: o,
                      name: e.name,
                      type: e.type,
                      value: e.modelValue,
                      placeholder: e.placeholder,
                      disabled: e.disabled,
                      readonly: e.readonly,
                      inputmode: e.inputmode,
                      autocomplete: e.autocomplete,
                      pattern: e.pattern,
                      maxlength: e.maxlength,
                      minlength: e.minlength,
                      min: e.min,
                      max: e.max,
                      "aria-labelledby": S.value,
                      "aria-label": e.label ? void 0 : e.ariaLabel,
                      "aria-disabled": e.disabled ? "true" : void 0,
                      "aria-invalid": A.value,
                      "aria-describedby": L.value,
                      "aria-required": e.required ? "true" : void 0,
                      "data-testid": "text-input",
                      class: C([
                        N.value ? "field-sizing-content not-supports-[field-sizing:content]:flex-1 max-w-full min-w-0 text-center text-ellipsis relative bg-transparent border-0 outline-none focus:outline-none focus:ring-0 focus:border-0 placeholder:text-(--text-text-body-subtle) dark:placeholder:text-(--colors-text-white-secondary) p-0" : "flex-1 min-w-0 text-ellipsis relative bg-transparent border-0 outline-none focus:outline-none focus:ring-0 focus:border-0 placeholder:text-(--text-text-body-subtle) dark:placeholder:text-(--colors-text-white-secondary) pl-0",
                        ne,
                        e.readonly ? "cursor-default" : "",
                        R.value,
                        e.valueVariant === "link" ? "pointer-events-none" : ""
                      ]),
                      onInput: oe,
                      onFocus: ge,
                      onBlur: re,
                      onKeydown: ue
                    }, null, 42, E2),
                    $e(U.$slots, "suffix", {}, void 0, !0),
                    (c(), K(dt(N.value ? "span" : a), en(tn(
                      N.value ? { class: "absolute right-0 top-1/2 flex -translate-y-1/2 items-center" } : {}
                    )), {
                      default: ve(() => [
                        $e(U.$slots, "iconRight", {
                          iconColorClass: de,
                          iconBoxClass: ie
                        }, void 0, !0),
                        !d.iconRight && z(Z) ? (c(), g("i", {
                          key: 0,
                          class: C(["ri-pencil-line text-(--icons-icon-accent)", ie])
                        }, null, 2)) : !d.iconRight && D.value ? (c(), g("i", {
                          key: 1,
                          class: C(["ri-close-fill cursor-pointer text-(--icons-icon-dark-default) dark:text-(--icons-icon-white-default)", ie]),
                          role: "button",
                          tabindex: "-1",
                          "aria-label": e.labels.clear,
                          onMousedown: Q[0] || (Q[0] = Ue(() => {
                          }, ["prevent"])),
                          onClick: Ue(O, ["stop"]),
                          onKeydown: [
                            ut(O, ["enter"]),
                            ut(Ue(O, ["prevent"]), ["space"])
                          ]
                        }, null, 42, A2)) : k("", !0)
                      ]),
                      _: 2
                    }, 1040))
                  ]),
                  _: 2
                }, 1040)),
                e.innerButton ? (c(), K(Re, Oe({ key: 2 }, I(Yn)(e.innerButton, e.disabled), {
                  size: "xs",
                  onClick: Q[1] || (Q[1] = (xe) => l("button-click", e.innerButton.id))
                }), null, 16)) : k("", !0)
              ]),
              _: 3
            }, 8, ["size", "stacked", "flush", "inner-button", "disabled", "readonly", "error", "success", "has-value", "class", "style"])
          ]),
          _: 3
        }, 16, ["buttons", "layout", "size", "disabled", "button-size"]),
        f.value ? (c(), g("div", R2, [
          $e(U.$slots, "actions", {}, void 0, !0)
        ])) : k("", !0),
        G.value && W.value.removeInFieldRow ? (c(), K(Re, Oe({ key: 1 }, I(Yn)(G.value, e.disabled), {
          size: I(Ra)(e.size, "attached"),
          onClick: Q[3] || (Q[3] = (ae) => l("button-click", G.value.id))
        }), null, 16, ["size"])) : k("", !0)
      ], 2),
      h.value ? (c(), g("div", {
        key: 1,
        class: C(["w-full", W.value.helper])
      }, [
        (c(), K(dt(() => h.value)))
      ], 2)) : k("", !0),
      !I(F) && W.value.reservesHelper || e.hint || e.error ? (c(), K(vt, {
        key: 2,
        ref_key: "helperRef",
        ref: s,
        class: C(W.value.helper),
        focused: r.value,
        hint: e.hint,
        error: e.error,
        "hint-id": T.value,
        "error-id": $.value,
        "test-id-prefix": "text-input"
      }, null, 8, ["class", "focused", "hint", "error", "hint-id", "error-id"])) : k("", !0),
      G.value && !W.value.removeInFieldRow ? (c(), K(Re, Oe({ key: 3 }, I(Yn)(G.value, e.disabled), {
        class: W.value.remove,
        size: I(Ra)(e.size, "attached"),
        onClick: Q[4] || (Q[4] = (ae) => l("button-click", G.value.id))
      }), null, 16, ["class", "size"])) : k("", !0)
    ], 6));
  }
}), zt = /* @__PURE__ */ lt(B2, [["__scopeId", "data-v-a4da8935"]]), M2 = ["aria-labelledby", "aria-describedby"], D2 = { class: "mt-px flex min-w-0 flex-col gap-px" }, OW = /* @__PURE__ */ ye({
  __name: "FieldGroup",
  props: {
    label: {},
    required: { type: Boolean, default: !1 },
    requiredIndicator: { default: "*" },
    labelTooltip: { default: void 0 },
    hint: { default: void 0 },
    error: { default: void 0 },
    layout: { default: "attached" },
    fullWidth: { type: Boolean, default: !1 }
  },
  setup(e) {
    const n = e, t = Ve(), a = `${t}-hint`, l = `${t}-error`, r = `${t}-label`, o = p(
      () => [n.hint ? a : "", n.error ? l : ""].filter(Boolean).join(" ") || void 0
    ), i = Qr([]), s = (y, w) => y.compareDocumentPosition(w) & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : 1, d = { part: "", corners: "" };
    nn(Hu, {
      register: (y) => {
        i.value = [...i.value, y].sort(s);
      },
      unregister: (y) => {
        i.value = i.value.filter((w) => w !== y);
      },
      partOf: (y) => {
        const w = y ? i.value.indexOf(y) : -1;
        return n.layout !== "attached" || w < 0 ? d : hg(fg(w, i.value.length), "l");
      }
    });
    const u = p(
      () => n.layout === "attached" ? bg("l") : "flex w-full items-start gap-(--spacing-2-5)"
    ), f = E(!1), b = E(null), h = E(null);
    function m(y) {
      const w = y.relatedTarget;
      (!w || !y.currentTarget.contains(w)) && (f.value = !1);
    }
    function x(y) {
      var w, S;
      (w = b.value) == null || w.handleFieldKeydown(y), (S = h.value) == null || S.handleFieldKeydown(y);
    }
    return (y, w) => (c(), g("fieldset", {
      "aria-labelledby": e.labelTooltip ? r : void 0,
      "aria-describedby": o.value,
      class: C(["m-0 w-full min-w-0 border-0 p-0 font-inter", { "max-w-sm": !e.fullWidth }]),
      "data-testid": "field-group",
      onFocusin: w[0] || (w[0] = (S) => f.value = !0),
      onFocusout: m,
      onKeydown: x
    }, [
      te(xt, {
        id: r,
        ref_key: "labelRef",
        ref: b,
        as: "legend",
        class: "p-0",
        text: e.label,
        required: e.required,
        "required-indicator": e.requiredIndicator,
        tooltip: e.labelTooltip,
        focused: f.value,
        "test-id": "field-group-label"
      }, null, 8, ["text", "required", "required-indicator", "tooltip", "focused"]),
      v("div", D2, [
        v("div", {
          class: C([u.value, "*:min-w-0 *:flex-1"]),
          "data-testid": "field-group-row"
        }, [
          $e(y.$slots, "default")
        ], 2),
        te(vt, {
          ref_key: "helperRef",
          ref: h,
          focused: f.value,
          hint: e.hint,
          error: e.error,
          "hint-id": a,
          "error-id": l,
          "test-id-prefix": "field-group"
        }, null, 8, ["focused", "hint", "error"])
      ])
    ], 42, M2));
  }
}), z2 = ["id", "value", "placeholder", "disabled", "aria-labelledby", "aria-label", "aria-invalid", "aria-describedby", "aria-required"], O2 = {
  role: "status",
  class: "sr-only",
  "data-testid": "copy-input-status"
}, Es = "copy-to-clipboard", P2 = 2e3, PW = /* @__PURE__ */ ye({
  __name: "CopyInput",
  props: {
    modelValue: { default: "" },
    variant: { default: "attached" },
    iconOnly: { type: Boolean, default: !1 },
    buttons: { default: () => [] },
    prefix: { default: void 0 },
    iconLeft: { default: void 0 },
    placeholder: { default: void 0 },
    label: { default: void 0 },
    labelTooltip: { default: void 0 },
    required: { type: Boolean, default: !1 },
    ariaLabel: { default: void 0 },
    hint: { default: void 0 },
    error: { default: void 0 },
    disabled: { type: Boolean, default: !1 },
    size: { default: "md" },
    width: { default: void 0 },
    id: { default: void 0 },
    labels: { default: () => ({}) }
  },
  emits: ["copy", "copy-error", "button-click"],
  setup(e, { emit: n }) {
    const t = e, a = n, l = p(() => t.labels.copy ?? "Copy"), r = p(() => t.labels.copied ?? "Copied!"), o = E(!1), i = E("");
    let s, d = !1;
    async function u() {
      try {
        await navigator.clipboard.writeText(t.modelValue);
      } catch (R) {
        a("copy-error", R);
        return;
      }
      clearTimeout(s), i.value = "", await qe(), !d && (o.value = !0, i.value = r.value, a("copy", t.modelValue), s = setTimeout(() => {
        o.value = !1, i.value = "";
      }, P2));
    }
    gt(() => {
      d = !0, clearTimeout(s);
    });
    const f = {
      attached: "ri-file-copy-2-line",
      spaced: void 0,
      inner: "ri-file-copy-line",
      large: "ri-file-copy-2-line"
    }, b = p(() => {
      const R = t.iconOnly && (t.variant === "attached" || t.variant === "spaced");
      return {
        id: Es,
        label: o.value && !R ? r.value : l.value,
        // The button keeps its name so only the status announces the copy, not also a name change
        ariaLabel: o.value && !R ? l.value : void 0,
        icon: R ? "ri-file-copy-line" : f[t.variant],
        iconOnly: R,
        color: t.variant === "inner" || t.variant === "large" ? "tertiary" : "secondary",
        position: "end"
      };
    }), h = p(
      () => t.variant === "inner" ? t.buttons : [...t.buttons, b.value]
    );
    function m(R) {
      R === Es ? u() : a("button-click", R);
    }
    const x = Ve(), y = p(() => t.id || x), w = p(() => t.label ? `${y.value}-label` : void 0), S = p(() => `${y.value}-hint`), $ = p(() => `${y.value}-error`), T = p(() => {
      const R = [t.hint ? S.value : "", t.error ? $.value : ""].filter(Boolean);
      return R.length ? R.join(" ") : void 0;
    }), L = E(!1), A = p(() => Kl(!1, !!t.label, !1));
    return (R, z) => (c(), g("div", {
      class: C(["relative min-w-0", e.width ? "" : "w-full"]),
      style: Ne(e.width ? { width: e.width } : void 0),
      "data-testid": "copy-input"
    }, [
      e.variant === "large" ? (c(), g("div", {
        key: 0,
        class: C([
          "relative w-full min-w-0 pb-0.5 text-left font-inter text-(length:--size-m) text-(--text-text-black-default) dark:text-(--colors-text-white-default)",
          A.value.root
        ])
      }, [
        e.label ? (c(), K(xt, {
          key: 0,
          id: w.value,
          text: e.label,
          "input-id": y.value,
          required: e.required,
          tooltip: e.labelTooltip,
          focused: L.value,
          "test-id": "copy-input-label"
        }, null, 8, ["id", "text", "input-id", "required", "tooltip", "focused"])) : k("", !0),
        te(Rn, {
          multiline: "",
          disabled: e.disabled,
          error: !!e.error,
          "has-value": !!e.modelValue,
          class: "w-full gap-2"
        }, {
          default: ve(() => [
            v("textarea", {
              id: y.value,
              value: e.modelValue,
              placeholder: e.placeholder,
              disabled: e.disabled,
              readonly: "",
              "aria-labelledby": w.value,
              "aria-label": e.label ? void 0 : e.ariaLabel,
              "aria-invalid": e.error ? "true" : void 0,
              "aria-describedby": T.value,
              "aria-required": e.required ? "true" : void 0,
              "data-testid": "copy-input-value",
              class: "h-full min-w-0 flex-1 self-stretch resize-none cursor-default border-0 bg-transparent p-0 text-(length:--size-sm) leading-(--line-height-l-tight) outline-none focus:border-0 focus:outline-none focus:ring-0 placeholder:text-(--text-text-body-subtle) dark:placeholder:text-(--colors-text-white-secondary)",
              onFocus: z[0] || (z[0] = (D) => L.value = !0),
              onBlur: z[1] || (z[1] = (D) => L.value = !1)
            }, null, 40, z2),
            te(Re, {
              class: "-mr-1 mt-[calc(--spacing(2)+1px)] shrink-0 self-start",
              variant: "tertiary",
              size: "xs",
              "icon-left": b.value.icon,
              label: b.value.label,
              "aria-label": b.value.ariaLabel,
              disabled: e.disabled,
              "data-field-button": Es,
              onClick: u
            }, null, 8, ["icon-left", "label", "aria-label", "disabled"])
          ]),
          _: 1
        }, 8, ["disabled", "error", "has-value"]),
        te(vt, {
          hint: e.hint,
          error: e.error,
          "hint-id": S.value,
          "error-id": $.value,
          focused: L.value,
          "test-id-prefix": "copy-input"
        }, null, 8, ["hint", "error", "hint-id", "error-id", "focused"])
      ], 2)) : (c(), K(zt, {
        key: 1,
        id: e.id,
        "model-value": e.modelValue,
        readonly: "",
        "readonly-chrome": !1,
        placeholder: e.placeholder,
        label: e.label,
        "label-tooltip": e.labelTooltip,
        required: e.required,
        "aria-label": e.ariaLabel,
        hint: e.hint,
        error: e.error,
        disabled: e.disabled,
        size: e.size,
        "icon-left": e.iconLeft,
        prefix: e.prefix,
        buttons: h.value,
        "button-layout": e.variant === "spaced" ? "spaced" : "attached",
        "inner-button": e.variant === "inner" ? b.value : void 0,
        onButtonClick: m
      }, null, 8, ["id", "model-value", "placeholder", "label", "label-tooltip", "required", "aria-label", "hint", "error", "disabled", "size", "icon-left", "prefix", "buttons", "button-layout", "inner-button"])),
      v("span", O2, P(i.value), 1)
    ], 6));
  }
}), F2 = ["id"], V2 = ["id", "name", "value", "placeholder", "disabled", "readonly", "min", "max", "step", "aria-labelledby", "aria-label", "aria-invalid", "aria-describedby", "aria-required"], N2 = ["aria-label", "onKeydown"], H2 = /* @__PURE__ */ ye({
  __name: "NumberInput",
  props: {
    modelValue: { default: "" },
    label: { default: void 0 },
    ariaLabel: { default: void 0 },
    iconLeft: { default: void 0 },
    required: { type: Boolean, default: !1 },
    labelTooltip: { default: void 0 },
    requiredIndicator: { default: "*" },
    disabled: { type: Boolean, default: !1 },
    placeholder: { default: void 0 },
    prefix: { default: void 0 },
    min: { default: void 0 },
    max: { default: void 0 },
    step: { default: void 0 },
    error: { default: void 0 },
    success: { type: Boolean, default: !1 },
    hint: { default: void 0 },
    fullWidth: { type: Boolean, default: !1 },
    width: { default: void 0 },
    size: { default: "md" },
    name: { default: void 0 },
    id: { default: void 0 },
    readonly: { type: Boolean, default: !1 },
    labels: { default: () => ({ clear: "Clear input" }) },
    labelInline: { type: Boolean, default: !1 },
    buttons: { default: () => [] },
    buttonLayout: { default: "attached" },
    buttonSize: { default: void 0 },
    removeButton: { default: void 0 }
  },
  emits: ["update:modelValue", "input", "focus", "blur", "clear", "button-click"],
  setup(e, { emit: n }) {
    const t = e, a = n, l = E(!1), r = E(null), o = E(null), i = Ve(), s = p(() => t.id ?? i), d = p(() => t.label ? `${s.value}-label` : void 0), u = p(() => t.prefix ? `${s.value}-prefix` : void 0), f = p(() => `${s.value}-error`), b = p(() => `${s.value}-hint`), h = p(
      () => d.value ? [d.value, u.value].filter(Boolean).join(" ") : void 0
    ), m = p(() => !!t.error), x = p(
      () => t.modelValue !== void 0 && t.modelValue !== null && String(t.modelValue).trim() !== ""
    ), y = (G) => G && !l.value && !t.disabled && !t.readonly, w = p(
      () => l.value && x.value && !t.disabled && !t.readonly
    ), S = p(() => {
      const G = [];
      return t.hint && G.push(b.value), m.value && G.push(f.value), G.join(" ") || void 0;
    }), $ = p(() => t.fullWidth || t.width === void 0), T = p(
      () => Kl(t.labelInline, !!t.label, !!t.removeButton)
    ), L = p(() => t.removeButton && Nu(t.removeButton)), A = E(null), { inGroup: R, groupPart: z } = ju(A), D = p(
      () => `relative min-w-0 ${R ? z.value.part : "pb-0.5"} text-left text-(length:--size-m) font-inter ${T.value.root}${$.value ? " w-full" : ""}`
    ), V = p(() => $.value ? {} : { width: t.width });
    function Y(G) {
      a("update:modelValue", G.target.value), a("input", G);
    }
    function _(G) {
      t.disabled || (l.value = !0), a("focus", G);
    }
    function j(G) {
      l.value = !1, a("blur", G);
    }
    function M(G) {
      var B, F;
      (B = r.value) == null || B.handleFieldKeydown(G), (F = o.value) == null || F.handleFieldKeydown(G);
    }
    function W() {
      a("update:modelValue", ""), a("clear");
    }
    return (G, B) => (c(), g("div", {
      ref_key: "rootRef",
      ref: A,
      class: C(D.value),
      style: Ne(V.value)
    }, [
      e.label ? (c(), K(xt, {
        key: 0,
        id: d.value,
        ref_key: "labelRef",
        ref: r,
        text: e.label,
        "input-id": s.value,
        required: e.required,
        "required-indicator": e.requiredIndicator,
        tooltip: e.labelTooltip,
        focused: l.value,
        inline: e.labelInline,
        class: C(T.value.label),
        "test-id": "number-input-label"
      }, null, 8, ["id", "text", "input-id", "required", "required-indicator", "tooltip", "focused", "inline", "class"])) : k("", !0),
      v("div", {
        class: C(["flex w-full items-end gap-3", T.value.field])
      }, [
        te(to, {
          buttons: e.buttons,
          layout: e.buttonLayout,
          size: e.size,
          disabled: e.disabled,
          "button-size": e.buttonSize,
          onButtonClick: B[1] || (B[1] = (F) => a("button-click", F))
        }, {
          default: ve(({ fieldClass: F }) => [
            te(Rn, {
              class: C(["w-full", F || I(z).corners]),
              flush: !!e.prefix,
              size: e.size,
              disabled: e.disabled,
              readonly: e.readonly,
              error: m.value,
              success: e.success,
              "has-value": x.value
            }, {
              default: ve(({ hovered: X, iconBoxClass: H, leftIconBoxClass: q, iconColorClass: N, borderColorClass: J, addonTextClass: be, textClass: ke }) => [
                e.prefix ? (c(), g("span", {
                  key: 0,
                  id: u.value,
                  class: C([
                    "flex shrink-0 select-none items-center self-stretch border-r",
                    I(Sa)[e.size].addon,
                    "text-(length:--size-m) leading-(--line-height-l)",
                    J,
                    be
                  ])
                }, P(e.prefix), 11, F2)) : k("", !0),
                v("div", {
                  class: C(
                    e.prefix ? ["flex h-full min-w-0 flex-1 items-center gap-2", I(Sa)[e.size].input, I(Sa)[e.size].inputEnd] : "contents"
                  )
                }, [
                  e.iconLeft && !e.prefix ? (c(), g("i", {
                    key: 0,
                    class: C([e.iconLeft, q, N]),
                    "aria-hidden": "true"
                  }, null, 2)) : k("", !0),
                  v("input", {
                    id: s.value,
                    name: e.name,
                    type: "number",
                    value: e.modelValue,
                    placeholder: e.placeholder,
                    disabled: e.disabled,
                    readonly: e.readonly,
                    min: e.min,
                    max: e.max,
                    step: e.step,
                    "aria-labelledby": h.value,
                    "aria-label": e.label ? void 0 : e.ariaLabel,
                    "aria-invalid": m.value ? "true" : void 0,
                    "aria-describedby": S.value,
                    "aria-required": e.required ? "true" : void 0,
                    "data-testid": "number-input",
                    class: C([
                      "relative min-w-0 flex-1 text-ellipsis border-0 bg-transparent p-0 outline-none focus:border-0 focus:outline-none focus:ring-0 placeholder:text-(--text-text-body-subtle) dark:placeholder:text-(--colors-text-white-secondary)",
                      ke,
                      e.readonly ? "cursor-default" : ""
                    ]),
                    onInput: Y,
                    onFocus: _,
                    onBlur: j,
                    onKeydown: M
                  }, null, 42, V2),
                  y(X) ? (c(), g("i", {
                    key: 1,
                    class: C(["ri-pencil-line text-(--icons-icon-accent)", H])
                  }, null, 2)) : w.value ? (c(), g("i", {
                    key: 2,
                    class: C([
                      "ri-close-fill cursor-pointer text-(--icons-icon-dark-default) dark:text-(--icons-icon-white-default)",
                      H
                    ]),
                    role: "button",
                    tabindex: "-1",
                    "aria-label": e.labels.clear,
                    onMousedown: B[0] || (B[0] = Ue(() => {
                    }, ["prevent"])),
                    onClick: Ue(W, ["stop"]),
                    onKeydown: [
                      ut(W, ["enter"]),
                      ut(Ue(W, ["prevent"]), ["space"])
                    ]
                  }, null, 42, N2)) : k("", !0)
                ], 2)
              ]),
              _: 1
            }, 8, ["class", "flush", "size", "disabled", "readonly", "error", "success", "has-value"])
          ]),
          _: 1
        }, 8, ["buttons", "layout", "size", "disabled", "button-size"]),
        L.value && T.value.removeInFieldRow ? (c(), K(Re, Oe({ key: 0 }, I(Yn)(L.value, e.disabled), {
          size: I(Ra)(e.size, "attached"),
          onClick: B[2] || (B[2] = (F) => a("button-click", L.value.id))
        }), null, 16, ["size"])) : k("", !0)
      ], 2),
      !I(R) && T.value.reservesHelper || e.hint || e.error ? (c(), K(vt, {
        key: 1,
        ref_key: "helperRef",
        ref: o,
        class: C(T.value.helper),
        focused: l.value,
        hint: e.hint,
        error: e.error,
        "hint-id": b.value,
        "error-id": f.value,
        "test-id-prefix": "number-input"
      }, null, 8, ["class", "focused", "hint", "error", "hint-id", "error-id"])) : k("", !0),
      L.value && !T.value.removeInFieldRow ? (c(), K(Re, Oe({ key: 2 }, I(Yn)(L.value, e.disabled), {
        class: T.value.remove,
        size: I(Ra)(e.size, "attached"),
        onClick: B[3] || (B[3] = (F) => a("button-click", L.value.id))
      }), null, 16, ["class", "size"])) : k("", !0)
    ], 6));
  }
}), pf = /* @__PURE__ */ lt(H2, [["__scopeId", "data-v-2b2a52df"]]), j2 = ["id", "name", "checked", "disabled", "value", "aria-label", "aria-labelledby", "aria-describedby"], W2 = {
  key: 1,
  class: "absolute left-1/2 top-1/2 size-6 -translate-x-1/2 -translate-y-1/2",
  "data-testid": "radio-hit-area"
}, q2 = ["for"], U2 = /* @__PURE__ */ ye({
  __name: "RadioButton",
  props: {
    label: { default: void 0 },
    modelValue: { type: [String, Number, Boolean], default: void 0 },
    disabled: { type: Boolean, default: !1 },
    name: { default: void 0 },
    id: { default: void 0 },
    value: { type: [String, Number, Boolean], default: void 0 },
    presentational: { type: Boolean, default: !1 },
    ariaLabel: { default: void 0 },
    ariaLabelledby: { default: void 0 },
    ariaDescribedby: { default: void 0 }
  },
  emits: ["update:modelValue", "change"],
  setup(e, { emit: n }) {
    const t = e, a = n, l = p(() => t.modelValue === t.value), r = E(null), { resync: o } = Ki(r, () => l.value), i = Ve(), s = p(() => t.id ?? i), d = p(() => t.presentational ? "span" : "div"), u = p(() => !t.presentational && !!t.label), f = p(() => {
      const S = "relative box-border flex size-4 shrink-0 items-center justify-center rounded-(--border-border-radius-rounded-full) border border-solid transition-all duration-200 motion-reduce:transition-none peer-focus-visible:shadow-(--shadow-focus-l) peer-focus-visible:outline-2 peer-focus-visible:outline-transparent", $ = u.value ? " mt-0.5" : "";
      return t.disabled ? `${S}${$} bg-(--background-background-disabled) border-(--border-border-disabled) cursor-not-allowed` : l.value ? `${S}${$} bg-(--background-background-white) border-(--border-border-black-default) dark:bg-(--background-background-black-default) dark:border-(--border-border-base-medium) cursor-pointer` : `${S}${$} bg-(--background-background-white) border-(--border-border-base-medium) dark:bg-(--background-background-black-default) cursor-pointer peer-focus-visible:border-(--border-border-hover)`;
    }), b = p(() => {
      const S = "size-2 rounded-(--border-border-radius-rounded-full)";
      return t.disabled ? `${S} bg-(--background-background-disabled-strong) forced-colors:bg-[GrayText]` : `${S} bg-(--background-background-black-default) dark:bg-(--background-background-white-secondary) forced-colors:bg-[CanvasText]`;
    }), h = p(() => t.presentational ? "pointer-events-none flex items-center justify-center" : `${u.value ? "min-h-6 px-px " : ""}self-stretch flex items-center`), m = p(() => u.value ? "flex min-w-0 items-start gap-2" : "flex items-center gap-2 shrink-0"), x = p(() => {
      const S = "relative min-w-0 flex-1 break-words text-(length:--size-m) leading-(--line-height-l) font-(--weight-medium)";
      return t.disabled ? `${S} text-(--text-text-disabled-strong) dark:text-(--colors-text-disabled) cursor-not-allowed` : `${S} text-(--text-text-heading) dark:text-(--text-text-white-default) cursor-pointer`;
    }), y = (S) => {
      S.preventDefault(), !(t.disabled || l.value) && (t.value !== void 0 && a("update:modelValue", t.value), a("change", S));
    }, w = (S) => {
      if (t.disabled || l.value) return;
      S.target.checked && t.value !== void 0 && (a("update:modelValue", t.value), a("change", S), o());
    };
    return (S, $) => (c(), K(dt(d.value), Oe({
      "data-testid": "radio-container",
      class: h.value
    }, Rl(e.presentational ? {} : { click: y })), {
      default: ve(() => [
        (c(), K(dt(d.value), {
          class: C(m.value)
        }, {
          default: ve(() => [
            e.presentational ? k("", !0) : (c(), g("input", {
              key: 0,
              id: s.value,
              ref_key: "inputRef",
              ref: r,
              name: e.name,
              type: "radio",
              checked: l.value,
              disabled: e.disabled,
              value: e.value,
              "aria-label": e.ariaLabel,
              "aria-labelledby": e.ariaLabelledby,
              "aria-describedby": e.ariaDescribedby,
              class: "peer sr-only",
              onChange: w,
              onClick: $[0] || ($[0] = Ue(() => {
              }, ["stop"]))
            }, null, 40, j2)),
            (c(), K(dt(d.value), {
              "data-testid": "radio-button",
              class: C(f.value)
            }, {
              default: ve(() => [
                l.value ? (c(), K(dt(d.value), {
                  key: 0,
                  class: C(b.value)
                }, null, 8, ["class"])) : k("", !0),
                e.presentational ? k("", !0) : (c(), g("span", W2))
              ]),
              _: 1
            }, 8, ["class"])),
            !e.presentational && e.label ? (c(), g("label", {
              key: 1,
              for: s.value,
              class: C(x.value)
            }, P(e.label), 11, q2)) : k("", !0)
          ]),
          _: 1
        }, 8, ["class"]))
      ]),
      _: 1
    }, 16, ["class"]));
  }
}), pg = "rounded-(--border-border-radius-rounded-l) border border-solid", mg = `${pg} p-[calc(--spacing(4)-1px)]`, vg = "shadow-(--blur-shadow-xs)", Ld = "transition-[border-color,box-shadow,background-color] motion-reduce:transition-none", xg = "bg-(--background-background-white) dark:bg-(--colors-background-black-default)", yg = "border-(--border-border-base-medium) dark:border-(--colors-border-base)", kg = "hover:bg-(--background-background-hover) dark:hover:bg-white/5", wg = "border-(--border-border-disabled) dark:border-(--colors-border-disabled-subtle)", Cg = "bg-(--background-background-disabled-opacity) dark:bg-(--colors-background-disabled)", Zi = "text-(--text-text-disabled-strong)", G2 = "text-(length:--size-sm) leading-(--line-height-l) font-(--weight-regular)", K2 = "text-(length:--size-sm) leading-(--line-height-l) font-(--weight-medium)", Sg = "text-(length:--size-m) leading-(--line-height-l) font-(--weight-regular)", Y2 = "text-(length:--size-m) leading-(--line-height-l) font-(--weight-medium)", ei = "text-(length:--size-m) leading-(--line-height-l) font-(--weight-semi-bold)", J2 = "text-(length:--size-l) leading-(--line-height-xxl) font-(--weight-medium)", Z2 = "text-(length:--size-l) leading-(--line-height-xxl) font-(--weight-bold)";
function $g(e) {
  return e ? Zi : "text-(--text-text-heading) dark:text-(--colors-text-white-default)";
}
function Ig(e) {
  return e ? Zi : "text-(--text-text-body) dark:text-(--colors-text-white-secondary)";
}
const Ed = "[&_.opal-badge]:whitespace-normal [&_.opal-badge]:break-words [&_.opal-badge]:text-left [&_.opal-badge]:max-w-full";
function Tg(e, n) {
  return n ? "disabled" : e.theme ?? "neutral";
}
const Lg = "bg-(--background-background-selected)", Ad = "border-(--border-border-accent)", Rd = "border-(--border-border-hover)", mr = "has-[[data-selectable-card-input]:focus-visible]:shadow-(--shadow-focus-l) has-[[data-selectable-card-input]:focus-visible]:outline-2 has-[[data-selectable-card-input]:focus-visible]:outline-transparent", Eg = "has-[[data-selectable-card-input]:focus-visible]:border-(--border-border-hover)", X2 = ["id", "role", "aria-label", "data-name"], Q2 = ["id"], _2 = ["id", "name", "value", "checked", "disabled", "aria-label", "aria-labelledby", "aria-describedby"], eC = ["id"], tC = ["id"], nC = {
  key: 0,
  class: "flex flex-wrap items-center gap-1"
}, aC = ["id"], lC = ["id"], FW = /* @__PURE__ */ ye({
  __name: "RadioForm",
  props: {
    modelValue: { type: [String, Number, Boolean], default: void 0 },
    value: { type: [String, Number, Boolean] },
    label: {},
    helper: { default: void 0 },
    icon: { default: void 0 },
    name: { default: void 0 },
    id: { default: void 0 },
    disabled: { type: Boolean, default: !1 },
    readonly: { type: Boolean, default: !1 },
    type: { default: "card" },
    ctaLabel: { default: void 0 },
    ctaIcon: { default: "ri-eye-line" },
    ctaSecondaryLabel: { default: void 0 },
    ariaLabel: { default: void 0 },
    labelTooltip: { default: void 0 },
    badges: { default: void 0 },
    indicatorPosition: { default: "right" }
  },
  emits: ["update:modelValue", "cta", "cta-secondary"],
  setup(e, { emit: n }) {
    const t = e, a = n, l = Ht(), r = p(() => t.modelValue === t.value), o = p(() => t.type === "simple"), i = p(() => !t.readonly && !t.disabled), s = Ve(), d = Ve(), u = p(() => !!t.helper && !o.value), f = Ve(), b = Ve(), h = E(null), m = E(!1);
    Ie(
      h,
      (ie, fe, de) => {
        const ne = () => {
          m.value = !!ie && !ie.querySelector(Pl);
        };
        if (ne(), !ie) return;
        const le = new MutationObserver(ne);
        le.observe(ie, {
          childList: !0,
          subtree: !0,
          attributes: !0,
          attributeFilter: ["tabindex", "disabled", "href", "contenteditable", "type"]
        }), de(() => le.disconnect());
      },
      { immediate: !0, flush: "post" }
    );
    const x = p(() => {
      const ie = [];
      return u.value && ie.push(d), m.value && ie.push(b), t.labelTooltip && ie.push(f), ie.length > 0 ? ie.join(" ") : void 0;
    }), y = E(null), w = E(null), S = E(null), { resync: $ } = Ki(S, () => r.value), T = E(null), L = E(null), A = E(!1), R = E(!1), z = p(() => {
      if (t.labelTooltip)
        return R.value ? !1 : A.value ? !0 : void 0;
    });
    function D(ie) {
      try {
        return ie.matches(":focus-visible");
      } catch {
        return !0;
      }
    }
    function V(ie) {
      var fe;
      return ie instanceof Node && !!((fe = y.value) != null && fe.contains(ie));
    }
    function Y(ie) {
      t.labelTooltip && ie.target === S.value && ie.target instanceof Element && D(ie.target) && (A.value = !0);
    }
    function _(ie) {
      V(ie.relatedTarget) || (A.value = !1, R.value = !1);
    }
    const j = p(
      () => t.labelTooltip ? "flex items-center gap-1" : ""
    ), M = p(
      () => t.disabled ? Zi : "text-(--colors-icon-dark-default) dark:text-(--colors-text-white-default)"
    );
    function W() {
      A.value || (R.value = !1);
    }
    const G = p(() => {
      const ie = i.value ? " cursor-pointer" : t.disabled ? " cursor-not-allowed" : "";
      return o.value ? `flex w-full flex-wrap items-center gap-3${ie}` : `flex w-full flex-wrap items-start ${t.type === "card" && t.icon && u.value ? "gap-3" : "gap-2"}${ie}`;
    }), B = p(() => o.value || !t.icon || u.value ? "none" : Fl(t.icon) ? "icon" : "emoji"), F = p(
      () => ({ none: "", icon: "pt-1.5", emoji: "pt-1" })[B.value]
    ), X = p(
      () => t.type === "card-cta" && !!t.ctaLabel && !t.readonly
    ), H = p(() => X.value && !!t.ctaSecondaryLabel), q = p(
      () => `relative flex flex-col gap-4 ${o.value ? "justify-center" : "min-w-60"} ${mg} ${Ld} ${Ed}`
    ), N = () => l("default");
    function J() {
      return t.type !== "card" ? Ad : N() ? Rd : t.icon && u.value ? Ad : Rd;
    }
    function be() {
      const ie = `${vg} ${xg} ${yg}`;
      return t.readonly ? `${q.value} ${ie}` : t.disabled ? `${q.value} ${Cg} ${wg} cursor-not-allowed` : r.value ? `${q.value} ${Lg} ${J()} cursor-pointer ${mr}` : `${q.value} ${ie} ${kg} cursor-pointer ${mr} ${Eg}`;
    }
    const ke = p(() => $g(t.disabled)), ee = () => t.type === "card-cta" || t.type === "card" && N() ? Z2 : ei, oe = p(() => [Sg, Ig(t.disabled)]);
    function ge() {
      i.value && (a("update:modelValue", t.value), $());
    }
    const re = `${Pl},a,button,input,select,textarea,[aria-disabled="true"]`;
    function ue(ie) {
      var de, ne;
      if ((de = T.value) != null && de.contains(ie)) return !0;
      const fe = ie.closest(re);
      return !!fe && fe !== S.value && !!((ne = y.value) != null && ne.contains(fe));
    }
    function O(ie) {
      !i.value || !(ie.target instanceof Element) || ue(ie.target) || ie.preventDefault();
    }
    function U(ie) {
      var de, ne, le;
      if (!i.value || !(ie.target instanceof Element)) return;
      const fe = ie.target;
      (de = w.value) != null && de.contains(fe) || ue(fe) || ((ne = S.value) == null || ne.focus({ preventScroll: !0 }), (le = S.value) == null || le.click());
    }
    function Q(ie) {
      var fe, de;
      ie.key !== "Escape" || !t.labelTooltip || ((fe = L.value) != null && fe.isVisible && (ie.stopPropagation(), ie.preventDefault()), R.value = !0, (de = L.value) == null || de.hide());
    }
    function ae() {
      t.disabled || a("cta");
    }
    function Z() {
      t.disabled || a("cta-secondary");
    }
    return (ie, fe) => (c(), g("div", {
      id: e.readonly ? e.id : void 0,
      ref_key: "cardRef",
      ref: y,
      "data-testid": "radio-form",
      role: e.readonly ? "group" : void 0,
      "aria-label": e.readonly ? e.ariaLabel ?? e.label : void 0,
      "data-name": e.name,
      class: C(be()),
      onMousedown: O,
      onClick: U,
      onKeydown: Q,
      onFocusin: Y,
      onFocusout: _,
      onMouseleave: W
    }, [
      e.labelTooltip ? (c(), g("span", {
        key: 0,
        id: I(f),
        class: "sr-only"
      }, P(e.labelTooltip), 9, Q2)) : k("", !0),
      (c(), K(dt(e.readonly ? "div" : "label"), {
        ref_key: "labelRef",
        ref: w,
        "data-testid": "radio-form-label",
        class: C(G.value)
      }, {
        default: ve(() => [
          e.readonly ? k("", !0) : (c(), g("input", {
            key: 0,
            id: e.id,
            ref_key: "inputRef",
            ref: S,
            type: "radio",
            class: "sr-only",
            name: e.name,
            value: String(e.value),
            checked: r.value,
            disabled: e.disabled,
            "aria-label": e.ariaLabel,
            "aria-labelledby": e.ariaLabel ? void 0 : I(s),
            "aria-describedby": x.value,
            "data-selectable-card-input": "",
            onChange: ge
          }, null, 40, _2)),
          e.icon ? (c(), g(se, { key: 1 }, [
            I(Fl)(e.icon) ? (c(), K(Xt, {
              key: 0,
              as: "span",
              size: "md",
              type: "square",
              variant: "outlined",
              color: e.disabled ? "disabled" : "white",
              icon: e.icon
            }, null, 8, ["color", "icon"])) : (c(), g("span", {
              key: 1,
              class: C(["text-num-32 leading-none shrink-0", e.disabled ? "opacity-50" : ""]),
              "aria-hidden": "true"
            }, P(e.icon), 3))
          ], 64)) : k("", !0),
          o.value ? (c(), g("span", {
            key: 2,
            id: I(s),
            class: C(["min-w-0 flex-1", I(ei), j.value, ke.value])
          }, [
            at(P(e.label) + " ", 1),
            e.labelTooltip ? (c(), K(ft, {
              key: 0,
              ref_key: "tooltipRef",
              ref: L,
              as: "span",
              text: e.labelTooltip,
              open: z.value,
              class: "shrink-0"
            }, {
              default: ve(() => [
                v("i", {
                  class: C(["ri-information-line cursor-help text-(length:--size-sm) leading-none", M.value]),
                  "aria-hidden": "true"
                }, null, 2)
              ]),
              _: 1
            }, 8, ["text", "open"])) : k("", !0)
          ], 10, eC)) : (c(), g("span", {
            key: 3,
            class: C(["flex min-w-0 flex-1 flex-col gap-1", F.value])
          }, [
            v("span", {
              "data-testid": "radio-form-title-row",
              class: C(["flex flex-wrap items-start justify-between gap-1", u.value ? "" : "min-h-6"])
            }, [
              v("span", {
                id: I(s),
                "data-testid": "radio-form-title",
                class: C(["min-w-0 grow", ee(), j.value, ke.value])
              }, [
                at(P(e.label) + " ", 1),
                e.labelTooltip ? (c(), K(ft, {
                  key: 0,
                  ref_key: "tooltipRef",
                  ref: L,
                  as: "span",
                  text: e.labelTooltip,
                  open: z.value,
                  class: "shrink-0"
                }, {
                  default: ve(() => [
                    v("i", {
                      class: C(["ri-information-line cursor-help text-(length:--size-sm) leading-none", M.value]),
                      "aria-hidden": "true"
                    }, null, 2)
                  ]),
                  _: 1
                }, 8, ["text", "open"])) : k("", !0)
              ], 10, tC),
              e.badges && e.badges.length > 0 ? (c(), g("span", nC, [
                (c(!0), g(se, null, Me(e.badges, (de, ne) => (c(), K(ct, Oe({ key: ne }, { ref_for: !0 }, de, {
                  theme: I(Tg)(de, e.disabled),
                  "show-close-icon": !1,
                  "truncation-focusable": !1
                }), null, 16, ["theme"]))), 128))
              ])) : k("", !0)
            ], 2),
            u.value ? (c(), g("span", {
              key: 0,
              id: I(d),
              class: C(oe.value)
            }, P(e.helper), 11, aC)) : k("", !0)
          ], 2)),
          e.readonly ? k("", !0) : (c(), g("span", {
            key: 4,
            "data-testid": "radio-form-indicator",
            class: C(["pointer-events-none w-4 shrink-0", [F.value, e.indicatorPosition === "left" ? "order-first" : void 0]]),
            "aria-hidden": "true"
          }, [
            v("span", {
              "data-testid": "radio-form-indicator-line",
              class: C(o.value || u.value ? "block" : "block py-1")
            }, [
              te(U2, {
                "model-value": e.modelValue,
                value: e.value,
                disabled: e.disabled,
                presentational: ""
              }, null, 8, ["model-value", "value", "disabled"])
            ], 2)
          ], 2))
        ]),
        _: 1
      }, 8, ["class"])),
      N() ? (c(), g("div", {
        key: 1,
        id: I(b),
        ref_key: "bodyRef",
        ref: h,
        "data-testid": "radio-form-body",
        class: "flex w-full flex-col gap-3"
      }, [
        $e(ie.$slots, "default")
      ], 8, lC)) : k("", !0),
      X.value ? (c(), g("div", {
        key: 2,
        ref_key: "footerRef",
        ref: T,
        "data-testid": "radio-form-footer",
        class: "flex items-center justify-between gap-4"
      }, [
        te(Re, {
          "data-testid": "radio-form-cta",
          variant: "secondary",
          size: "xs",
          "icon-left": e.ctaIcon,
          label: e.ctaLabel,
          disabled: e.disabled,
          onClick: ae
        }, null, 8, ["icon-left", "label", "disabled"]),
        H.value ? (c(), K(Re, {
          key: 0,
          "data-testid": "radio-form-cta-secondary",
          variant: "secondary",
          size: "xs",
          label: e.ctaSecondaryLabel,
          disabled: e.disabled,
          onClick: Z
        }, null, 8, ["label", "disabled"])) : k("", !0)
      ], 512)) : k("", !0)
    ], 42, X2));
  }
}), rC = ["aria-labelledby"], oC = ["id"], VW = /* @__PURE__ */ ye({
  __name: "RadioFormGroup",
  props: {
    legend: {}
  },
  setup(e) {
    const n = Ve();
    return (t, a) => (c(), g("div", {
      role: "radiogroup",
      "aria-labelledby": e.legend && !t.$attrs["aria-label"] ? I(n) : void 0
    }, [
      e.legend ? (c(), g("div", {
        key: 0,
        id: I(n),
        "data-testid": "radio-form-group-legend",
        class: C(I(tg))
      }, P(e.legend), 11, oC)) : k("", !0),
      $e(t.$slots, "default")
    ], 8, rC));
  }
}), iC = ["aria-labelledby"], sC = {
  key: 0,
  "data-testid": "checkbox-group-required",
  class: "whitespace-pre"
}, dC = {
  "data-testid": "checkbox-group-items",
  class: "flex flex-wrap items-start gap-2 *:w-auto"
}, NW = /* @__PURE__ */ ye({
  inheritAttrs: !1,
  __name: "CheckboxGroup",
  props: {
    legend: { default: void 0 },
    ariaLabelledby: { default: void 0 },
    error: { default: void 0 },
    required: { type: Boolean, default: !1 },
    requiredIndicator: { default: "*" },
    labelTooltip: { default: void 0 }
  },
  setup(e) {
    const n = e, t = Fn(), a = Mn(), l = Ve(), r = `${l}-error`, o = `${l}-legend`, i = p(
      () => n.ariaLabelledby ?? (n.labelTooltip && (n.legend || a.legend) ? o : void 0)
    ), s = p(() => {
      const d = [t["aria-describedby"], n.error ? r : void 0].filter(Boolean);
      return d.length > 0 ? d.join(" ") : void 0;
    });
    return nn(
      Mu,
      p(() => n.error ? r : void 0)
    ), (d, u) => (c(), g("fieldset", Oe({ ...I(t), "aria-describedby": s.value }, {
      "aria-labelledby": i.value,
      class: "m-0 min-w-0 border-0 p-0"
    }), [
      e.legend || I(a).legend ? (c(), g("legend", {
        key: 0,
        "data-testid": "checkbox-group-legend",
        class: C([I(tg), "p-0", e.labelTooltip ? "flex items-center gap-1" : ""])
      }, [
        v("span", { id: o }, [
          $e(d.$slots, "legend", {}, () => [
            at(P(e.legend), 1)
          ]),
          e.required ? (c(), g("span", sC, P(` ${e.requiredIndicator}`), 1)) : k("", !0)
        ]),
        e.labelTooltip ? (c(), K(ug, {
          key: 0,
          text: e.labelTooltip
        }, null, 8, ["text"])) : k("", !0)
      ], 2)) : k("", !0),
      v("div", dC, [
        $e(d.$slots, "default")
      ]),
      e.error ? (c(), g("div", {
        key: 1,
        id: r,
        "data-testid": "checkbox-group-error",
        role: "alert",
        class: C(["mt-2", I(ng)])
      }, [
        v("i", {
          class: C(I(ag)),
          "aria-hidden": "true"
        }, null, 2),
        v("span", null, P(e.error), 1)
      ], 2)) : k("", !0)
    ], 16, iC));
  }
}), uC = ["id", "role", "aria-label", "data-name"], cC = ["id", "name", "checked", "disabled", "aria-label", "aria-labelledby", "aria-describedby"], fC = ["id"], hC = {
  key: 2,
  class: "flex min-w-0 flex-1 flex-col gap-2"
}, bC = ["src"], gC = { class: "flex w-full flex-col gap-1" }, pC = ["id"], mC = ["id"], vC = ["id"], xC = {
  key: 0,
  class: "flex min-w-0 flex-wrap items-center gap-3"
}, yC = {
  key: 1,
  class: "flex flex-wrap items-center gap-3"
}, kC = ["id"], wC = ["id"], HW = /* @__PURE__ */ ye({
  __name: "CheckboxForm",
  props: {
    modelValue: { type: Boolean, default: !1 },
    label: {},
    helper: { default: void 0 },
    name: { default: void 0 },
    id: { default: void 0 },
    disabled: { type: Boolean, default: !1 },
    readonly: { type: Boolean, default: !1 },
    type: { default: "card" },
    ariaLabel: { default: void 0 },
    align: { default: void 0 },
    badgesAlign: { default: void 0 },
    badges: { default: void 0 },
    icons: { default: void 0 },
    avatar: { default: void 0 },
    imageSrc: { default: void 0 },
    icon: { default: void 0 },
    subtitle: { default: void 0 }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: n }) {
    const t = e, a = n, l = Ht(), r = p(() => !t.readonly && !t.disabled), o = p(() => t.type === "inline"), i = Ve(), s = Ve(), d = Ve(), u = p(() => t.type === "simple" && !t.icon), f = p(() => !!t.helper && !u.value), b = p(() => !!t.subtitle && t.type === "card"), h = p(() => t.type === "card" ? t.avatar : void 0), m = p(() => t.type === "card" ? t.icon : void 0), x = () => !u.value && t.type !== "big-card" && l("trailing"), y = p(() => !!t.icon && (t.type === "simple" || t.type === "card")), w = eg(() => [
      b.value ? d : void 0,
      f.value ? s : void 0
    ]);
    _0();
    const S = E(null), { resync: $ } = Ki(S, () => t.modelValue), T = E(null), L = p(() => (t.align ?? (t.avatar ? "center" : void 0) ?? (t.type === "simple" && t.icon ? "center" : void 0) ?? "top") === "center" ? "items-center" : "items-start"), A = p(
      () => t.badgesAlign ?? (t.avatar || b.value ? "title" : "end")
    ), R = p(() => o.value ? "flex flex-wrap items-start gap-1" : A.value === "title" ? "flex flex-wrap items-center gap-3" : "flex flex-wrap items-start justify-between gap-1"), z = `group relative flex flex-wrap gap-2 p-px min-w-60 ${Ed}`, D = `relative flex flex-wrap ${mg} ${Ld} ${Ed}`, V = `relative flex items-center justify-center ${pg} px-[calc(--spacing(3)-1px)] py-[calc(--spacing(2)-1px)] ${Ld}`, Y = p(() => {
      const oe = t.type === "simple" ? "gap-3" : "gap-2";
      return `flex ${L.value} min-w-0 flex-1 ${oe}`;
    });
    function _() {
      if (o.value)
        return t.readonly ? z : t.disabled ? `${z} cursor-not-allowed` : `${z} cursor-pointer ${mr}`;
      const oe = t.type === "big-card" ? "min-w-46" : "min-w-60", ge = u.value ? V : `${D} ${oe} ${h.value ? "gap-2" : "gap-1"}`, ue = `${x() || b.value ? "" : `${vg} `}${xg} ${yg}`;
      if (t.readonly) return `${ge} ${ue}`;
      if (t.disabled)
        return `${ge} ${Cg} ${wg} cursor-not-allowed`;
      if (t.modelValue) {
        const O = y.value ? Rd : Ad;
        return `${ge} ${Lg} ${O} cursor-pointer ${mr}`;
      }
      return `${ge} ${ue} ${kg} cursor-pointer ${mr} ${Eg}`;
    }
    const j = p(() => $g(t.disabled)), M = p(
      () => t.type === "inline" && r.value ? "group-hover:text-(--text-text-hover)" : ""
    ), W = p(() => t.type === "advanced" && t.modelValue), G = p(() => {
      if (u.value) return `${ei} text-center ${j.value}`;
      if (t.type === "simple" || m.value) return `min-w-0 flex-1 ${ei} ${j.value}`;
      const oe = t.type === "big-card" ? J2 : Y2, ge = o.value ? "min-w-0 flex-1" : "min-w-0", re = W.value ? " line-through" : "";
      return `${ge} ${oe} ${j.value} ${M.value}${re}`;
    }), B = p(
      () => t.disabled ? Zi : "text-(--text-text-black-default) dark:text-(--colors-text-white-secondary)"
    ), F = p(() => {
      if (b.value || h.value)
        return `${G2} ${B.value}`;
      const oe = Ig(t.disabled), ge = W.value ? " line-through" : "";
      return `${Sg} ${oe} ${M.value}${ge}`;
    }), X = p(() => `${K2} ${B.value}`), H = p(() => `flex min-w-0 flex-1 flex-col ${h.value ? "gap-1" : "gap-3"}`), q = p(() => `flex flex-wrap items-center ${h.value ? "gap-3" : "gap-4"}`), N = p(() => b.value ? "flex flex-col gap-px" : t.avatar || t.type === "simple" || m.value ? "flex flex-col gap-1" : "flex flex-col gap-0.5"), J = p(() => {
      const oe = r.value ? " cursor-pointer" : t.disabled ? " cursor-not-allowed" : "";
      return `flex min-w-0 flex-1${u.value ? " justify-center" : ""}${oe}`;
    });
    function be(oe) {
      const ge = oe.target;
      a("update:modelValue", ge.checked), $();
    }
    function ke(oe) {
      var ue;
      const ge = oe.currentTarget;
      if (!r.value || !(oe.target instanceof Element) || (ue = T.value) != null && ue.contains(oe.target)) return;
      const re = oe.target.closest(Pl);
      re && re !== S.value && ge.contains(re) || oe.preventDefault();
    }
    function ee(oe) {
      var ge, re;
      !r.value || oe.target !== oe.currentTarget || ((ge = S.value) == null || ge.focus({ preventScroll: !0 }), (re = S.value) == null || re.click());
    }
    return (oe, ge) => (c(), g("div", {
      id: e.readonly ? e.id : void 0,
      "data-testid": "checkbox-form",
      role: e.readonly ? "group" : void 0,
      "aria-label": e.readonly ? e.ariaLabel ?? e.label : void 0,
      "data-name": e.name,
      class: C(_()),
      onMousedown: ke,
      onClick: ee
    }, [
      (c(), K(dt(e.readonly ? "div" : "label"), {
        "data-testid": "checkbox-form-label",
        class: C(J.value)
      }, {
        default: ve(() => [
          e.readonly ? k("", !0) : (c(), g("input", {
            key: 0,
            id: e.id,
            ref_key: "inputRef",
            ref: S,
            type: "checkbox",
            class: "sr-only",
            name: e.name,
            checked: e.modelValue,
            disabled: e.disabled,
            "aria-label": e.ariaLabel,
            "aria-labelledby": e.ariaLabel ? void 0 : I(i),
            "aria-describedby": I(w),
            "data-selectable-card-input": "",
            onChange: be
          }, null, 40, cC)),
          u.value ? (c(), g("span", {
            key: 1,
            id: I(i),
            class: C(G.value)
          }, P(e.label), 11, fC)) : e.type === "big-card" ? (c(), g("span", hC, [
            e.imageSrc ? (c(), g("img", {
              key: 0,
              src: e.imageSrc,
              alt: "",
              class: "size-8 shrink-0 object-contain"
            }, null, 8, bC)) : k("", !0),
            v("span", gC, [
              v("span", {
                id: I(i),
                class: C(G.value)
              }, P(e.label), 11, pC),
              f.value ? (c(), g("span", {
                key: 0,
                id: I(s),
                class: C(F.value)
              }, P(e.helper), 11, mC)) : k("", !0)
            ])
          ])) : (c(), g("span", {
            key: 3,
            "data-testid": "checkbox-form-content-group",
            class: C(Y.value)
          }, [
            !e.readonly && e.type !== "simple" ? (c(), g("span", {
              key: 0,
              "data-testid": "checkbox-form-indicator",
              class: C(["pointer-events-none w-4 shrink-0 py-1", m.value ? "me-1" : ""]),
              "aria-hidden": "true"
            }, [
              te(Cn, {
                "model-value": e.modelValue,
                disabled: e.disabled,
                presentational: ""
              }, null, 8, ["model-value", "disabled"])
            ], 2)) : k("", !0),
            y.value && e.icon ? (c(), g(se, { key: 1 }, [
              I(Fl)(e.icon) ? (c(), K(Xt, {
                key: 0,
                as: "span",
                size: "md",
                type: "square",
                variant: "outlined",
                color: e.disabled ? "disabled" : e.type === "card" ? "default" : "white",
                icon: e.icon
              }, null, 8, ["color", "icon"])) : (c(), g("span", {
                key: 1,
                class: C([
                  "text-num-32 leading-none shrink-0",
                  e.disabled ? "opacity-50" : "",
                  e.type === "card" ? "me-1" : ""
                ]),
                "aria-hidden": "true"
              }, P(e.icon), 3))
            ], 64)) : k("", !0),
            h.value ? (c(), K(Kt, {
              key: 2,
              img: h.value.img,
              name: h.value.name,
              as: "span",
              size: "md",
              presentational: ""
            }, null, 8, ["img", "name"])) : k("", !0),
            v("span", {
              class: C(H.value)
            }, [
              v("span", {
                class: C(N.value)
              }, [
                v("span", {
                  "data-testid": "checkbox-form-title-row",
                  class: C(R.value)
                }, [
                  v("span", {
                    id: I(i),
                    class: C(G.value)
                  }, P(e.label), 11, vC),
                  e.badges && e.badges.length > 0 || e.icons && e.icons.length > 0 ? (c(), g("span", xC, [
                    e.badges && e.badges.length > 0 ? (c(), g("span", {
                      key: 0,
                      class: C(["flex flex-wrap items-center", A.value === "title" ? "gap-3" : "gap-1"])
                    }, [
                      (c(!0), g(se, null, Me(e.badges, (re, ue) => (c(), K(ct, Oe({ key: ue }, { ref_for: !0 }, re, {
                        theme: I(Tg)(re, e.disabled),
                        "show-close-icon": !1,
                        "truncation-focusable": !1
                      }), null, 16, ["theme"]))), 128))
                    ], 2)) : k("", !0),
                    e.icons && e.icons.length > 0 ? (c(), g("span", yC, [
                      (c(!0), g(se, null, Me(e.icons, (re, ue) => (c(), g("i", {
                        key: ue,
                        class: C([`ri-${re}`, "text-(length:--size-4xl) leading-none"]),
                        "aria-hidden": "true"
                      }, null, 2))), 128))
                    ])) : k("", !0)
                  ])) : k("", !0)
                ], 2),
                b.value ? (c(), g("span", {
                  key: 0,
                  id: I(d),
                  "data-testid": "checkbox-form-subtitle",
                  class: C(X.value)
                }, P(e.subtitle), 11, kC)) : k("", !0),
                f.value ? (c(), g("span", {
                  key: 1,
                  id: I(s),
                  class: C(F.value)
                }, P(e.helper), 11, wC)) : k("", !0)
              ], 2),
              (e.type === "advanced" || e.type === "card") && I(l)("details") ? (c(), g("span", {
                key: 0,
                "data-testid": "checkbox-form-details",
                class: C(q.value)
              }, [
                $e(oe.$slots, "details")
              ], 2)) : k("", !0)
            ], 2)
          ], 2))
        ]),
        _: 3
      }, 8, ["class"])),
      x() ? (c(), g("div", {
        key: 0,
        ref_key: "trailingRef",
        ref: T,
        "data-testid": "checkbox-form-trailing",
        class: "flex shrink-0 items-start justify-end"
      }, [
        $e(oe.$slots, "trailing")
      ], 512)) : k("", !0)
    ], 42, uC));
  }
}), CC = { class: "w-full flex flex-col gap-2" }, SC = {
  key: 0,
  class: "text-sm font-medium text-text-black-default dark:text-(--colors-text-white-default)"
}, $C = { class: "flex flex-col items-center gap-2" }, IC = ["src"], TC = { class: "relative text-sm leading-5 dark:text-(--colors-text-white-default)" }, LC = {
  key: 1,
  class: "flex flex-col items-center gap-5"
}, EC = { class: "flex-1 flex flex-col items-center gap-1.5" }, AC = { class: "flex-1 flex flex-col items-center gap-1.5" }, RC = { class: "flex-1 flex flex-col items-center gap-1.5" }, BC = ["id", "name", "accept", "disabled"], MC = {
  key: 1,
  class: "text-sm text-red-600 dark:text-red-400"
}, DC = /* @__PURE__ */ ye({
  __name: "ImageInput",
  props: {
    variant: { default: "default" },
    uploadText: { default: "Click to upload or drag and drop" },
    maxFileSizeText: { default: "Max. File Size: 30MB" },
    browseButtonText: { default: "Browse file" },
    uploadIcon: { default: void 0 },
    browseButtonIcon: { default: void 0 },
    dragDropText: { default: "Drag and drop a file here, or:" },
    browseLabel: { default: "Browse" },
    browseIcon: { default: void 0 },
    libraryLabel: { default: "Library" },
    libraryIcon: { default: void 0 },
    linkLabel: { default: "Link" },
    linkIcon: { default: void 0 },
    accept: { default: "image/*" },
    maxFileSize: { default: 30 * 1024 * 1024 },
    size: { default: "md" },
    success: { type: Boolean, default: !1 },
    error: { type: [String, Boolean], default: !1 },
    disabled: { type: Boolean, default: !1 },
    label: { default: void 0 },
    name: { default: void 0 },
    id: { default: void 0 },
    modelValue: { default: null }
  },
  emits: ["update:modelValue", "change", "error", "browse", "library", "link"],
  setup(e, { emit: n }) {
    const t = e, a = p(() => !!t.error), l = p(() => typeof t.error == "string" ? t.error : void 0), r = n, o = E(null), i = E(!1), s = E(!1), d = Ve(), u = `${d}-browse`, f = `${d}-library`, b = `${d}-link`, m = {
      sm: {
        container: "h-[180px]",
        text: "text-xs",
        icon: "w-5 h-5",
        gap: "gap-3"
      },
      md: {
        container: "h-[228px]",
        text: "text-sm",
        icon: "w-6 h-6",
        gap: "gap-4"
      },
      lg: {
        container: "h-[280px]",
        text: "text-base",
        icon: "w-7 h-7",
        gap: "gap-5"
      },
      xl: {
        container: "h-[320px]",
        text: "text-lg",
        icon: "w-8 h-8",
        gap: "gap-6"
      }
    }[t.size], x = p(() => {
      const M = t.variant === "buttons" ? "border-border-base" : "border-border-primary-button", W = `w-full relative rounded-xl border-dashed border-[1px] box-border flex flex-col items-center justify-center text-center text-sm font-inter transition-[border-color,background-color,box-shadow,color] duration-200 ${m.container}`;
      return t.disabled ? `${W} bg-background-disabled-subtle dark:bg-(--colors-background-disabled) border-[#D1D5DC] dark:border-(--colors-border-disabled-subtle) text-text-disabled dark:text-(--colors-text-disabled) cursor-not-allowed` : a.value ? `${W} bg-background-white dark:bg-(--colors-background-black-default) border-[#B42318] dark:border-[#B42318] text-[#B42318] dark:text-[#B42318] cursor-pointer` : t.success ? `${W} bg-background-white dark:bg-(--colors-background-black-default) border-[#009966] dark:border-[#009966] text-text-body dark:text-(--colors-text-white-default) cursor-pointer` : i.value ? `${W} shadow-[0px_0px_2px_#7c86ff] bg-background-hover dark:bg-[rgba(255,255,255,0.05)] border-[#7c86ff] dark:border-[#7c86ff] text-text-black-default dark:text-(--colors-text-white-default) cursor-pointer` : s.value ? `${W} shadow-[0px_0px_2px_#7c86ff] bg-background-hover dark:bg-[rgba(255,255,255,0.05)] border-[#7c86ff] dark:border-[#7c86ff] text-text-black-default dark:text-(--colors-text-white-default) cursor-pointer` : `${W} bg-background-white dark:bg-(--colors-background-black-default) ${M} dark:border-(--colors-border-base) text-text-black-default dark:text-(--colors-text-white-default) cursor-pointer`;
    }), y = (M) => {
      if (!M || M.length === 0 || t.disabled) return;
      const W = Array.from(M);
      if (W.filter((X) => X.size > t.maxFileSize).length > 0) {
        r("error", `File size exceeds the maximum allowed size of ${t.maxFileSizeText}`);
        return;
      }
      const B = W.length === 1 ? W[0] : W;
      r("update:modelValue", B);
      const F = new Event("change", { bubbles: !0 });
      r("change", F);
    }, w = () => {
      var M;
      t.disabled || (M = o.value) == null || M.click();
    }, S = (M) => {
      var W;
      t.disabled || (r("browse", M), (W = o.value) == null || W.click());
    }, $ = (M) => {
      t.disabled || r("library", M);
    }, T = (M) => {
      t.disabled || r("link", M);
    }, L = (M) => {
      const W = M.target;
      y(W.files);
    }, A = (M) => {
      M.preventDefault(), M.stopPropagation(), t.disabled || (i.value = !0);
    }, R = (M) => {
      M.preventDefault(), M.stopPropagation(), i.value = !1;
    }, z = (M) => {
      var G;
      if (M.preventDefault(), M.stopPropagation(), i.value = !1, t.disabled) return;
      const W = (G = M.dataTransfer) == null ? void 0 : G.files;
      W && y(W);
    }, D = () => {
      var M;
      t.disabled || (M = o.value) == null || M.click();
    }, V = (M, W) => {
      try {
        if (M.startsWith("data:image/svg+xml")) {
          const G = M.split(",")[1];
          if (!G) return M;
          const F = decodeURIComponent(G).replace(/fill=["']currentColor["']/gi, `fill="${W}"`).replace(/fill=["']#[0-9A-Fa-f]{6}["']/gi, `fill="${W}"`);
          return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(F)}`;
        }
        return M.replace(/color=%[0-9A-Fa-f]{6}/, `color=%23${W.slice(1)}`);
      } catch {
        return M;
      }
    }, Y = p(() => {
      if (t.browseIcon)
        return t.success && t.variant === "buttons" ? V(t.browseIcon, "#007A55") : t.browseIcon;
    }), _ = p(() => {
      if (t.libraryIcon)
        return t.success && t.variant === "buttons" ? V(t.libraryIcon, "#007A55") : t.libraryIcon;
    }), j = p(() => {
      if (t.linkIcon)
        return t.success && t.variant === "buttons" ? V(t.linkIcon, "#007A55") : t.linkIcon;
    });
    return (M, W) => (c(), g("div", CC, [
      e.label ? (c(), g("div", SC, P(e.label), 1)) : k("", !0),
      v("div", {
        class: C(x.value),
        onDragover: A,
        onDragleave: R,
        onDrop: z,
        onClick: W[0] || (W[0] = (G) => e.variant === "default" ? D() : void 0),
        onMouseenter: W[1] || (W[1] = (G) => s.value = !0),
        onMouseleave: W[2] || (W[2] = (G) => s.value = !1)
      }, [
        e.variant === "default" ? (c(), g("div", {
          key: 0,
          class: C(["flex flex-col items-center", I(m).gap])
        }, [
          v("div", $C, [
            e.uploadIcon ? (c(), g("img", {
              key: 0,
              src: e.uploadIcon,
              class: C([I(m).icon, "relative", "image-input-icon"]),
              alt: ""
            }, null, 10, IC)) : k("", !0),
            v("div", TC, P(e.uploadText), 1),
            v("div", {
              class: C([
                "relative text-xs! leading-4 font-medium",
                e.success ? "text-[#007A55] dark:text-[#007A55]" : !e.disabled && !e.error ? "text-text-body dark:text-(--colors-text-white-default)" : "dark:text-(--colors-text-disabled)"
              ])
            }, P(e.maxFileSizeText), 3)
          ]),
          te(I(Re), {
            variant: "primary",
            label: e.browseButtonText,
            "icon-left": e.browseButtonIcon,
            size: "xs",
            disabled: e.disabled,
            type: "button",
            onClick: Ue(w, ["stop"])
          }, null, 8, ["label", "icon-left", "disabled"])
        ], 2)) : (c(), g("div", LC, [
          v("div", {
            class: C([
              "relative leading-5 text-sm!",
              e.disabled ? "text-text-disabled dark:text-(--colors-text-disabled)" : a.value ? "text-[#B42318] dark:text-[#B42318]" : e.success ? "text-text-body dark:text-(--colors-text-white-default)" : "text-text-black-default dark:text-(--colors-text-white-default)"
            ])
          }, P(e.dragDropText), 3),
          v("div", {
            class: C([
              "self-stretch flex items-start gap-6 text-xs!",
              e.disabled ? "text-text-disabled dark:text-(--colors-text-disabled)" : "text-text-body dark:text-(--colors-text-white-default)"
            ])
          }, [
            v("div", EC, [
              v("div", {
                class: C([
                  "w-9 h-9 rounded-[9999px] border-solid box-border flex items-center justify-center overflow-hidden [&_button]:border-0",
                  e.disabled ? "bg-background-white dark:bg-(--colors-background-black-default) border-[#D1D5DC] dark:border-(--colors-border-disabled-subtle) border" : a.value ? "bg-background-white dark:bg-(--colors-background-black-default) border-[#B42318] dark:border-[#B42318] border" : e.success ? "bg-background-success dark:bg-background-success border-transparent border-0" : "bg-background-white dark:bg-(--colors-background-black-default) border-border-base-medium dark:border-(--colors-border-base) border"
                ])
              }, [
                Y.value ? (c(), K(I(Re), {
                  key: 0,
                  variant: "secondary",
                  "icon-left": Y.value,
                  "icon-only": "",
                  size: "sm",
                  disabled: e.disabled,
                  "aria-labelledby": u,
                  onClick: Ue(S, ["stop"])
                }, null, 8, ["icon-left", "disabled"])) : k("", !0)
              ], 2),
              v("div", {
                id: u,
                class: C([
                  "relative leading-5 font-medium text-sm!",
                  e.disabled ? "text-text-disabled dark:text-(--colors-text-disabled)" : a.value ? "text-[#B42318] dark:text-[#B42318]" : e.success ? "text-[#007A55] dark:text-[#007A55]" : "text-text-black-default dark:text-(--colors-text-white-default)"
                ])
              }, P(e.browseLabel), 3)
            ]),
            v("div", AC, [
              v("div", {
                class: C([
                  "w-9 h-9 rounded-[9999px] border-solid box-border flex items-center justify-center overflow-hidden [&_button]:border-0",
                  e.disabled ? "bg-background-white dark:bg-(--colors-background-black-default) border-[#D1D5DC] dark:border-(--colors-border-disabled-subtle) border" : a.value ? "bg-background-white dark:bg-(--colors-background-black-default) border-[#B42318] dark:border-[#B42318] border" : e.success ? "bg-background-success dark:bg-background-success border-transparent border-0" : "bg-background-white dark:bg-(--colors-background-black-default) border-border-base-medium dark:border-(--colors-border-base) border"
                ])
              }, [
                _.value ? (c(), K(I(Re), {
                  key: 0,
                  variant: "secondary",
                  "icon-left": _.value,
                  "icon-only": "",
                  size: "sm",
                  disabled: e.disabled,
                  "aria-labelledby": f,
                  onClick: Ue($, ["stop"])
                }, null, 8, ["icon-left", "disabled"])) : k("", !0)
              ], 2),
              v("div", {
                id: f,
                class: C([
                  "relative leading-5 font-medium text-sm!",
                  e.disabled ? "text-text-disabled dark:text-(--colors-text-disabled)" : a.value ? "text-[#B42318] dark:text-[#B42318]" : e.success ? "text-[#007A55] dark:text-[#007A55]" : "text-text-black-default dark:text-(--colors-text-white-default)"
                ])
              }, P(e.libraryLabel), 3)
            ]),
            v("div", RC, [
              v("div", {
                class: C([
                  "w-9 h-9 rounded-[9999px] border-solid box-border flex items-center justify-center overflow-hidden [&_button]:border-0",
                  e.disabled ? "bg-background-white dark:bg-(--colors-background-black-default) border-[#D1D5DC] dark:border-(--colors-border-disabled-subtle) border" : a.value ? "bg-background-white dark:bg-(--colors-background-black-default) border-[#B42318] dark:border-[#B42318] border" : e.success ? "bg-background-success dark:bg-background-success border-transparent border-0" : "bg-background-white dark:bg-(--colors-background-black-default) border-border-base-medium dark:border-(--colors-border-base) border"
                ])
              }, [
                j.value ? (c(), K(I(Re), {
                  key: 0,
                  variant: "secondary",
                  "icon-left": j.value,
                  "icon-only": "",
                  size: "sm",
                  disabled: e.disabled,
                  "aria-labelledby": b,
                  onClick: Ue(T, ["stop"])
                }, null, 8, ["icon-left", "disabled"])) : k("", !0)
              ], 2),
              v("div", {
                id: b,
                class: C([
                  "relative leading-5 font-medium text-sm!",
                  e.disabled ? "text-text-disabled dark:text-(--colors-text-disabled)" : a.value ? "text-[#B42318] dark:text-[#B42318]" : e.success ? "text-[#007A55] dark:text-[#007A55]" : "text-text-black-default dark:text-(--colors-text-white-default)"
                ])
              }, P(e.linkLabel), 3)
            ])
          ], 2)
        ])),
        v("input", {
          id: e.id,
          ref_key: "fileInputRef",
          ref: o,
          "data-testid": "image-input",
          name: e.name,
          type: "file",
          accept: e.accept,
          disabled: e.disabled,
          class: "sr-only",
          onChange: L
        }, null, 40, BC)
      ], 34),
      l.value ? (c(), g("div", MC, P(l.value), 1)) : k("", !0)
    ]));
  }
}), jW = /* @__PURE__ */ lt(DC, [["__scopeId", "data-v-5b729c92"]]), zC = { class: "w-full flex flex-col gap-2" }, OC = {
  key: 1,
  class: "flex flex-col gap-0.5"
}, PC = { class: "relative" }, FC = ["id", "name", "accept", "disabled", "multiple", "aria-describedby", "aria-invalid"], VC = ["disabled"], NC = ["aria-label"], HC = {
  key: 2,
  class: "w-full flex flex-col gap-4"
}, jC = { class: "flex flex-col gap-0.5" }, WC = { class: "flex flex-col items-center gap-2" }, qC = { class: "text-(length:--size-m) leading-(--line-height-l) text-(--text-text-black-default) dark:text-(--text-text-white-default) text-center" }, UC = { class: "text-(length:--size-sm) leading-(--line-height-l) text-(--text-text-body) dark:text-(--text-text-white-default) text-center whitespace-pre-line" }, GC = ["id", "name", "accept", "disabled", "multiple", "aria-describedby", "aria-invalid"], KC = {
  key: 0,
  class: "flex flex-col gap-3"
}, YC = { class: "flex flex-1 items-center gap-2.5 min-w-0" }, JC = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  class: "shrink-0"
}, ZC = ["id"], XC = ["stroke", "stroke-dashoffset"], QC = { class: "flex flex-col min-w-0" }, _C = { class: "text-(length:--size-m) leading-(--line-height-l) font-(--weight-medium) text-(--text-text-black-default) dark:text-(--text-text-white-default) truncate" }, eS = { class: "flex gap-2 text-(length:--size-sm)" }, tS = { class: "font-(--weight-medium) text-(--text-text-black-default) dark:text-(--text-text-white-default)" }, nS = { class: "flex items-center gap-1 shrink-0" }, aS = {
  key: 1,
  class: "h-9 w-9 flex items-center justify-center shrink-0"
}, lS = {
  key: 2,
  class: "h-9 w-9 flex items-center justify-center shrink-0"
}, rS = {
  key: 3,
  class: "flex flex-col gap-0.5"
}, oS = { class: "flex flex-col items-center gap-2" }, iS = ["src"], sS = { class: "flex flex-col items-center gap-2" }, dS = ["src"], uS = {
  key: 1,
  class: "flex flex-col items-center gap-5"
}, cS = { class: "flex-1 flex flex-col items-center gap-1.5" }, fS = { class: "flex-1 flex flex-col items-center gap-1.5" }, hS = { class: "flex-1 flex flex-col items-center gap-1.5" }, bS = ["id", "name", "accept", "disabled", "multiple", "aria-describedby", "aria-invalid"], gS = {
  key: 4,
  class: "mt-3 space-y-1"
}, pS = { class: "flex-shrink-0" }, mS = {
  key: 0,
  class: "w-5 h-5 text-(--text-text-success-strong)",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}, vS = {
  key: 1,
  class: "w-5 h-5 text-(--text-text-error-strong)",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}, xS = { class: "flex-1 min-w-0" }, yS = { key: 0 }, kS = ["disabled", "onClick"], As = 10.2, mf = 3.6, wS = /* @__PURE__ */ ye({
  __name: "FileUploadInput",
  props: {
    variant: { default: "default" },
    uploadText: { default: "Click to upload or drag and drop" },
    maxFileSizeText: { default: "Max. File Size: 30MB" },
    hint: { default: void 0 },
    errorLive: { type: Boolean, default: !0 },
    fileTypeErrorText: { default: void 0 },
    fileSizeErrorText: { default: void 0 },
    browseButtonText: { default: "Select file" },
    placeholder: { default: "Placeholder text" },
    uploadIcon: { default: void 0 },
    browseButtonIcon: { default: void 0 },
    dragDropText: { default: "Drag and drop a file here, or:" },
    browseLabel: { default: "Browse" },
    browseIcon: { default: void 0 },
    libraryLabel: { default: "Library" },
    libraryIcon: { default: void 0 },
    linkLabel: { default: "Link" },
    linkIcon: { default: void 0 },
    accept: { default: "*" },
    maxFileSize: { default: 30 * 1024 * 1024 },
    size: { default: "md" },
    success: { type: Boolean, default: !1 },
    error: { type: [String, Boolean], default: !1 },
    disabled: { type: Boolean, default: !1 },
    label: { default: void 0 },
    name: { default: void 0 },
    id: { default: void 0 },
    modelValue: { default: null },
    uploadedFile: { default: null },
    uploadedFiles: { default: () => [] },
    multiple: { type: Boolean, default: !1 },
    addFilesText: { default: "Add file(s)" },
    addMoreText: { default: "Add more" },
    addMoreIcon: { default: void 0 },
    progressFiles: { default: () => [] },
    pauseLabel: { default: "Pause" },
    resumeLabel: { default: "Resume" },
    removeLabel: { default: "Remove file" },
    clearFileLabel: { default: "Clear file" },
    required: { type: Boolean, default: !1 },
    requiredIndicator: { default: "*" },
    labelTooltip: { default: void 0 }
  },
  emits: ["update:modelValue", "change", "error", "browse", "library", "link", "addMore", "fileClick", "removeFile", "pauseFile", "resumeFile", "removeProgressFile", "clear"],
  setup(e, { emit: n }) {
    const t = e, a = p(() => !!t.error), l = p(() => typeof t.error == "string" ? t.error : void 0), r = Ve(), o = `${r}-browse`, i = `${r}-library`, s = `${r}-link`, d = p(() => !!t.uploadedFile), u = (de) => de ? de < 1024 ? `${de}B` : de < 1024 * 1024 ? `${(de / 1024).toFixed(0)}Ko` : `${(de / (1024 * 1024)).toFixed(1)}Mo` : "", f = p(() => {
      if (!t.uploadedFile) return "";
      const de = t.uploadedFile.name, ne = t.uploadedFile.size ? ` (${u(t.uploadedFile.size)})` : "";
      return `${de}${ne}`;
    }), b = n;
    function h() {
      m.value && (m.value.value = ""), b("update:modelValue", null), b("clear");
    }
    const m = E(null), x = Ve(), y = p(() => t.id || x), w = E(!1), S = E(null), $ = E(null), T = p(() => `${y.value}-hint`), L = p(() => `${y.value}-error`), A = p(() => t.hint ? t.hint : (t.variant === "basic" || t.variant === "dropzone") && t.maxFileSizeText || void 0), R = p(() => {
      var de;
      return (de = A.value) != null && de.includes(`
`) ? 2 : 1;
    }), z = p(() => {
      const de = [];
      return A.value && de.push(T.value), l.value && de.push(L.value), de.length > 0 ? de.join(" ") : void 0;
    });
    function D(de) {
      var ne, le;
      (ne = S.value) == null || ne.handleFieldKeydown(de), (le = $.value) == null || le.handleFieldKeydown(de);
    }
    const V = E(!1), Y = E(!1), _ = E(/* @__PURE__ */ new Set());
    function j(de) {
      _.value.has(de) ? (_.value.delete(de), b("resumeFile", de)) : (_.value.add(de), b("pauseFile", de)), _.value = new Set(_.value);
    }
    const M = 2 * Math.PI * As;
    function W(de) {
      return M * (1 - Math.min(Math.max(de, 0), 100) / 100);
    }
    const B = {
      sm: {
        container: "h-[180px]",
        text: "text-xs",
        icon: "w-5 h-5",
        gap: "gap-3"
      },
      md: {
        container: "h-[228px]",
        text: "text-sm",
        icon: "w-6 h-6",
        gap: "gap-4"
      },
      lg: {
        container: "h-[280px]",
        text: "text-base",
        icon: "w-7 h-7",
        gap: "gap-5"
      },
      xl: {
        container: "h-[320px]",
        text: "text-lg",
        icon: "w-8 h-8",
        gap: "gap-6"
      }
    }[t.size], F = p(() => {
      const de = t.variant === "dropzone" ? "border-(--border-border-base)" : "border-(--border-border-primary-button)", ne = `w-full relative rounded-xl border-dashed border-[1px] box-border flex flex-col items-center justify-center text-center text-sm font-inter transition-[border-color,background-color,box-shadow,color] duration-200 ${B.container}`;
      return t.disabled ? `${ne} bg-(--background-background-disabled-subtle) dark:bg-(--background-background-disabled) border-(--border-border-disabled) dark:border-(--border-border-disabled-subtle) text-(--text-text-disabled-light) dark:text-(--text-text-disabled-light) cursor-not-allowed` : a.value ? `${ne} bg-(--background-background-white) dark:bg-(--background-background-black-default) border-(--border-border-error-strong) dark:border-(--border-border-error-strong) text-(--text-text-black-default) dark:text-(--text-text-white-default) cursor-pointer` : t.success || d.value ? `${ne} bg-(--background-background-white) dark:bg-(--background-background-black-default) border-(--border-border-success-strong) dark:border-(--border-border-success-strong) text-(--text-text-black-default) dark:text-(--text-text-white-default) cursor-pointer` : V.value ? `${ne} shadow-[0px_0px_2px_var(--border-border-hover)] bg-(--background-background-hover) dark:bg-[rgba(255,255,255,0.05)] border-(--border-border-hover) dark:border-(--border-border-hover) text-(--text-text-black-default) dark:text-(--text-text-white-default) cursor-pointer` : Y.value ? `${ne} shadow-[0px_0px_2px_var(--border-border-hover)] bg-(--background-background-hover) dark:bg-[rgba(255,255,255,0.05)] border-(--border-border-hover) dark:border-(--border-border-hover) text-(--text-text-black-default) dark:text-(--text-text-white-default) cursor-pointer` : `${ne} bg-(--background-background-white) dark:bg-(--background-background-black-default) ${de} dark:border-(--border-border-base) text-(--text-text-black-default) dark:text-(--text-text-white-default) cursor-pointer`;
    }), X = (de, ne) => {
      if (!ne || ne === "*" || ne === "*/*") return !0;
      const le = ne.split(",").map((xe) => xe.trim().toLowerCase()).filter((xe) => xe.length > 0);
      if (le.length === 0) return !0;
      const Le = (de.type || "").toLowerCase(), Te = (de.name || "").toLowerCase();
      return le.some((xe) => xe.startsWith(".") ? Te.endsWith(xe) : xe.endsWith("/*") ? Le.startsWith(xe.slice(0, -1)) : Le === xe);
    }, H = (de) => {
      if (!de || de.length === 0 || t.disabled) return;
      const ne = Array.from(de);
      if (ne.filter((we) => !X(we, t.accept)).length > 0) {
        b("error", t.fileTypeErrorText || "File type not supported.");
        return;
      }
      if (ne.filter((we) => we.size > t.maxFileSize).length > 0) {
        b(
          "error",
          t.fileSizeErrorText || `File size exceeds the maximum allowed size of ${t.maxFileSizeText}`
        );
        return;
      }
      const Te = t.multiple ? ne : ne[0];
      b("update:modelValue", Te);
      const xe = new Event("change", { bubbles: !0 });
      b("change", xe);
    }, q = () => {
      var de;
      t.disabled || (de = m.value) == null || de.click();
    }, N = (de) => {
      var ne;
      t.disabled || (b("browse", de), (ne = m.value) == null || ne.click());
    }, J = (de) => {
      t.disabled || b("library", de);
    }, be = (de) => {
      t.disabled || b("link", de);
    }, ke = (de) => {
      var ne;
      t.disabled || (b("addMore", de), (ne = m.value) == null || ne.click());
    }, ee = () => {
      t.uploadedFile && b("fileClick", t.uploadedFile);
    }, oe = (de, ne) => {
      t.disabled || b("removeFile", de, ne);
    }, ge = (de) => {
      const ne = de.target;
      H(ne.files);
    }, re = (de) => {
      de.preventDefault(), de.stopPropagation(), t.disabled || (V.value = !0);
    }, ue = (de) => {
      de.preventDefault(), de.stopPropagation(), V.value = !1;
    }, O = (de) => {
      var le;
      if (de.preventDefault(), de.stopPropagation(), V.value = !1, t.disabled) return;
      const ne = (le = de.dataTransfer) == null ? void 0 : le.files;
      ne && H(ne);
    }, U = () => {
      var de;
      t.disabled || d.value || (de = m.value) == null || de.click();
    }, Q = (de, ne) => {
      try {
        if (de.startsWith("data:image/svg+xml")) {
          const le = de.split(",")[1];
          if (!le) return de;
          const Te = decodeURIComponent(le).replace(/fill=["']currentColor["']/gi, `fill="${ne}"`).replace(/fill=["']#[0-9A-Fa-f]{6}["']/gi, `fill="${ne}"`);
          return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(Te)}`;
        }
        return de.replace(/color=%[0-9A-Fa-f]{6}/, `color=%23${ne.slice(1)}`);
      } catch {
        return de;
      }
    }, ae = {
      // --icons-icon-dark-default
      error: "#b42318",
      // --icons-icon-error
      success: "#007a55",
      // --text-text-success-strong
      disabled: "#99a1af"
      // --icons-icon-disabled-light
    }, Z = p(() => {
      if (t.browseIcon)
        return t.disabled && t.variant === "dropzone" ? Q(t.browseIcon, ae.disabled) : a.value && t.variant === "dropzone" ? Q(t.browseIcon, ae.error) : (t.success || d.value) && t.variant === "dropzone" ? Q(t.browseIcon, ae.success) : t.browseIcon;
    }), ie = p(() => {
      if (t.libraryIcon)
        return t.disabled && t.variant === "dropzone" ? Q(t.libraryIcon, ae.disabled) : a.value && t.variant === "dropzone" ? Q(t.libraryIcon, ae.error) : (t.success || d.value) && t.variant === "dropzone" ? Q(t.libraryIcon, ae.success) : t.libraryIcon;
    }), fe = p(() => {
      if (t.linkIcon)
        return t.disabled && t.variant === "dropzone" ? Q(t.linkIcon, ae.disabled) : a.value && t.variant === "dropzone" ? Q(t.linkIcon, ae.error) : (t.success || d.value) && t.variant === "dropzone" ? Q(t.linkIcon, ae.success) : t.linkIcon;
    });
    return (de, ne) => (c(), g("div", zC, [
      e.label ? (c(), K(xt, {
        key: 0,
        ref_key: "labelRef",
        ref: S,
        text: e.label,
        "input-id": y.value,
        required: e.required,
        "required-indicator": e.requiredIndicator,
        tooltip: e.labelTooltip,
        focused: w.value,
        "test-id": "file-upload-label"
      }, null, 8, ["text", "input-id", "required", "required-indicator", "tooltip", "focused"])) : k("", !0),
      e.variant === "basic" ? (c(), g("div", OC, [
        v("div", PC, [
          v("input", {
            id: y.value,
            ref_key: "fileInputRef",
            ref: m,
            "data-testid": "file-upload-input-basic",
            name: e.name,
            type: "file",
            accept: e.accept,
            disabled: e.disabled,
            multiple: e.multiple,
            "aria-describedby": z.value,
            "aria-invalid": a.value ? "true" : void 0,
            class: "absolute inset-0 w-full h-full opacity-0 cursor-pointer z-10",
            onChange: ge,
            onFocus: ne[0] || (ne[0] = (le) => w.value = !0),
            onBlur: ne[1] || (ne[1] = (le) => w.value = !1),
            onKeydown: D
          }, null, 40, FC),
          v("div", {
            class: C([
              "flex items-center w-full bg-(--background-background-white) dark:bg-(--background-background-black-default) border rounded-lg shadow-xs transition-colors",
              e.disabled ? "border-(--border-border-disabled) dark:border-(--border-border-disabled-subtle) cursor-not-allowed" : a.value ? "border-(--border-border-error-strong) dark:border-(--border-border-error-strong) focus-within:ring-4 focus-within:ring-(--border-border-error-medium)" : "border-(--border-border-base-medium) dark:border-(--border-border-base) focus-within:ring-4 focus-within:ring-(--border-border-hover-medium) focus-within:border-(--border-border-hover)"
            ])
          }, [
            v("button", {
              type: "button",
              class: C([
                "flex-shrink-0 px-3 py-2 text-sm font-medium rounded-l-lg border-r transition-colors",
                e.disabled ? "bg-(--background-background-disabled-subtle) dark:bg-(--background-background-disabled) border-(--border-border-disabled) dark:border-(--border-border-disabled-subtle) text-(--text-text-disabled-light) dark:text-(--text-text-disabled-light) cursor-not-allowed" : a.value ? "bg-(--background-background-white) dark:bg-(--background-background-black-default) border-(--border-border-error-strong) dark:border-(--border-border-error-strong) text-(--text-text-error-strong) dark:text-(--text-text-error-strong)" : "bg-(--background-background-white) dark:bg-(--background-background-black-default) border-(--border-border-base-medium) dark:border-(--border-border-base) text-(--text-text-black-default) dark:text-(--text-text-white-default) hover:bg-(--background-background-hover) dark:hover:bg-[rgba(255,255,255,0.05)]"
              ]),
              disabled: e.disabled,
              onClick: Ue(q, ["stop"])
            }, P(e.browseButtonText), 11, VC),
            v("div", {
              class: C([
                "flex-1 px-3 py-2 text-sm pointer-events-none truncate",
                e.disabled ? "text-(--text-text-disabled-light) dark:text-(--text-text-disabled-light)" : e.modelValue ? "text-(--text-text-black-default) dark:text-(--text-text-white-default)" : "text-(--text-text-body) dark:text-(--text-text-white-default)"
              ])
            }, P(e.modelValue ? Array.isArray(e.modelValue) ? `${e.modelValue.length} file(s) selected` : e.modelValue.name : e.placeholder), 3),
            e.modelValue && !e.disabled ? (c(), g("button", {
              key: 0,
              type: "button",
              class: "relative z-20 shrink-0 flex items-center justify-center px-2 self-stretch text-(--text-text-black-default) dark:text-(--text-text-white-default) hover:text-(--text-text-body)",
              "aria-label": e.clearFileLabel,
              onClick: Ue(h, ["stop"])
            }, [...ne[9] || (ne[9] = [
              v("i", {
                class: "ri-close-fill text-base",
                "aria-hidden": "true"
              }, null, -1)
            ])], 8, NC)) : k("", !0)
          ], 2)
        ]),
        te(vt, {
          ref_key: "helperRef",
          ref: $,
          focused: w.value,
          hint: A.value,
          "hint-lines": R.value,
          disabled: e.disabled,
          error: l.value,
          "hint-id": T.value,
          "error-id": L.value,
          "error-live": e.errorLive,
          "test-id-prefix": "file-upload"
        }, null, 8, ["focused", "hint", "hint-lines", "disabled", "error", "hint-id", "error-id", "error-live"])
      ])) : e.variant === "advanced" ? (c(), g("div", HC, [
        v("div", jC, [
          v("div", {
            class: "w-full rounded-xl border border-dashed border-(--border-border-base-medium) dark:border-(--border-border-base) bg-(--background-background-white-secondary-soft) dark:bg-(--background-background-black-default) flex h-[228px] flex-col items-center justify-center gap-4 px-5",
            onDragover: re,
            onDragleave: ue,
            onDrop: O
          }, [
            v("div", WC, [
              ne[10] || (ne[10] = v("i", {
                class: "ri-upload-2-line text-(length:--size-xl) text-(--text-text-black-default) dark:text-(--text-text-white-default)",
                "aria-hidden": "true"
              }, null, -1)),
              v("p", qC, P(e.uploadText), 1),
              v("p", UC, P(e.maxFileSizeText), 1)
            ]),
            te(I(Re), {
              variant: "primary",
              label: e.addFilesText,
              "icon-left": "ri-add-line",
              size: "xs",
              disabled: e.disabled,
              type: "button",
              onClick: Ue(q, ["stop"])
            }, null, 8, ["label", "disabled"]),
            v("input", {
              id: y.value,
              ref_key: "fileInputRef",
              ref: m,
              "data-testid": "file-upload-input",
              name: e.name,
              type: "file",
              accept: e.accept,
              disabled: e.disabled,
              multiple: e.multiple,
              "aria-describedby": z.value,
              "aria-invalid": a.value ? "true" : void 0,
              class: "sr-only",
              onChange: ge,
              onFocus: ne[2] || (ne[2] = (le) => w.value = !0),
              onBlur: ne[3] || (ne[3] = (le) => w.value = !1),
              onKeydown: D
            }, null, 40, GC)
          ], 32),
          te(vt, {
            ref_key: "helperRef",
            ref: $,
            focused: w.value,
            hint: A.value,
            "hint-lines": R.value,
            disabled: e.disabled,
            error: l.value,
            "hint-id": T.value,
            "error-id": L.value,
            "error-live": e.errorLive,
            "test-id-prefix": "file-upload"
          }, null, 8, ["focused", "hint", "hint-lines", "disabled", "error", "hint-id", "error-id", "error-live"])
        ]),
        e.progressFiles.length ? (c(), g("div", KC, [
          (c(!0), g(se, null, Me(e.progressFiles, (le) => (c(), g("div", {
            key: le.id,
            "data-testid": "upload-progress-row",
            class: "flex w-full items-center justify-between gap-2.5"
          }, [
            v("div", YC, [
              (c(), g("svg", JC, [
                v("defs", null, [
                  v("linearGradient", {
                    id: `upload-ring-gradient-${le.id}`,
                    x1: "0%",
                    y1: "0%",
                    x2: "100%",
                    y2: "100%"
                  }, [...ne[11] || (ne[11] = [
                    v("stop", {
                      offset: "0%",
                      style: { "stop-color": "var(--gradient-brand-start)" }
                    }, null, -1),
                    v("stop", {
                      offset: "100%",
                      style: { "stop-color": "var(--gradient-brand-end)" }
                    }, null, -1)
                  ])], 8, ZC)
                ]),
                v("circle", {
                  cx: "12",
                  cy: "12",
                  r: As,
                  fill: "none",
                  "stroke-width": mf,
                  class: "stroke-(--border-border-base-soft) dark:stroke-(--border-border-base-soft)"
                }),
                v("circle", {
                  "data-testid": "progress-ring-fill",
                  cx: "12",
                  cy: "12",
                  r: As,
                  fill: "none",
                  "stroke-width": mf,
                  "stroke-linecap": "round",
                  transform: "rotate(-90 12 12)",
                  stroke: `url(#upload-ring-gradient-${le.id})`,
                  "stroke-dasharray": M,
                  "stroke-dashoffset": W(le.percent)
                }, null, 8, XC)
              ])),
              v("div", QC, [
                v("p", _C, P(le.name), 1),
                v("div", eS, [
                  v("span", tS, P(le.percent) + "%", 1),
                  v("span", {
                    class: C(
                      le.status === "success" ? "text-(--text-text-success-strong) dark:text-(--text-text-success-strong)" : le.status === "error" ? "text-(--text-text-error-strong) dark:text-(--text-text-error-strong)" : "text-(--text-text-body) dark:text-(--text-text-white-default)"
                    )
                  }, P(le.statusText), 3)
                ])
              ])
            ]),
            v("div", nS, [
              le.status === "uploading" ? (c(), K(I(Re), {
                key: 0,
                variant: "text",
                "icon-only": "",
                size: "sm",
                "icon-left": _.value.has(le.id) ? "ri-play-line" : "ri-pause-line",
                "aria-label": _.value.has(le.id) ? e.resumeLabel : e.pauseLabel,
                "data-testid": "pause-icon",
                onClick: (Le) => j(le.id)
              }, null, 8, ["icon-left", "aria-label", "onClick"])) : k("", !0),
              le.status === "success" ? (c(), g("span", aS, [...ne[12] || (ne[12] = [
                v("i", {
                  "data-testid": "progress-success-icon",
                  class: "ri-checkbox-circle-line text-(length:--size-xxl) text-(--icons-icon-success) dark:text-(--icons-icon-success)",
                  "aria-hidden": "true"
                }, null, -1)
              ])])) : le.status === "error" ? (c(), g("span", lS, [...ne[13] || (ne[13] = [
                v("i", {
                  "data-testid": "progress-error-icon",
                  class: "ri-error-warning-line text-(length:--size-xxl) text-(--icons-icon-error) dark:text-(--icons-icon-error)",
                  "aria-hidden": "true"
                }, null, -1)
              ])])) : k("", !0),
              te(I(Re), {
                variant: "text",
                "icon-only": "",
                size: "sm",
                "icon-left": "ri-close-line",
                "aria-label": e.removeLabel,
                "data-testid": "delete-icon",
                onClick: (Le) => b("removeProgressFile", le.id)
              }, null, 8, ["aria-label", "onClick"])
            ])
          ]))), 128))
        ])) : k("", !0)
      ])) : (c(), g("div", rS, [
        v("div", {
          class: C(F.value),
          onDragover: re,
          onDragleave: ue,
          onDrop: O,
          onClick: ne[6] || (ne[6] = (le) => e.variant === "default" ? U() : void 0),
          onMouseenter: ne[7] || (ne[7] = (le) => Y.value = !0),
          onMouseleave: ne[8] || (ne[8] = (le) => Y.value = !1)
        }, [
          e.variant === "default" ? (c(), g(se, { key: 0 }, [
            d.value ? (c(), g("div", {
              key: 1,
              class: C(["flex flex-col items-center", I(B).gap])
            }, [
              v("div", sS, [
                e.uploadIcon ? (c(), g("img", {
                  key: 0,
                  src: e.uploadIcon,
                  class: C([
                    I(B).icon,
                    "relative",
                    e.disabled ? "file-input-icon-disabled" : "file-input-icon"
                  ]),
                  alt: ""
                }, null, 10, dS)) : k("", !0),
                v("div", {
                  class: C([
                    "relative text-sm leading-5",
                    e.disabled ? "text-(--text-text-disabled-light) dark:text-(--text-text-disabled-light)" : "text-(--text-text-black-default) dark:text-(--text-text-white-default)"
                  ])
                }, P(e.uploadText), 3),
                v("button", {
                  type: "button",
                  class: C([
                    "relative text-sm leading-5 font-medium cursor-pointer hover:underline",
                    a.value ? "text-(--text-text-error-strong) dark:text-(--text-text-error-strong)" : "text-(--text-text-success-strong) dark:text-(--text-text-success-strong)"
                  ]),
                  onClick: Ue(ee, ["stop"])
                }, P(f.value), 3)
              ]),
              te(I(Re), {
                variant: "secondary",
                label: `+ ${e.addMoreText}`,
                size: "xs",
                disabled: e.disabled,
                type: "button",
                onClick: Ue(ke, ["stop"])
              }, null, 8, ["label", "disabled"])
            ], 2)) : (c(), g("div", {
              key: 0,
              class: C(["flex flex-col items-center", I(B).gap])
            }, [
              v("div", oS, [
                e.uploadIcon ? (c(), g("img", {
                  key: 0,
                  src: e.uploadIcon,
                  class: C([
                    I(B).icon,
                    "relative",
                    e.disabled ? "file-input-icon-disabled" : "file-input-icon"
                  ]),
                  alt: ""
                }, null, 10, iS)) : k("", !0),
                v("div", {
                  class: C([
                    "relative text-sm leading-5",
                    e.disabled ? "text-(--text-text-disabled-light) dark:text-(--text-text-disabled-light)" : "text-(--text-text-black-default) dark:text-(--text-text-white-default)"
                  ])
                }, P(e.uploadText), 3),
                v("div", {
                  class: C([
                    "relative text-xs! leading-4 font-medium",
                    e.disabled ? "text-(--text-text-disabled-light) dark:text-(--text-text-disabled-light)" : e.success || d.value || e.error ? "text-(--text-text-black-default) dark:text-(--text-text-white-default)" : "text-(--text-text-body) dark:text-(--text-text-white-default)"
                  ])
                }, P(e.maxFileSizeText), 3)
              ]),
              te(I(Re), {
                variant: "primary",
                label: e.browseButtonText,
                "icon-left": e.browseButtonIcon,
                size: "xs",
                disabled: e.disabled,
                type: "button",
                onClick: Ue(q, ["stop"])
              }, null, 8, ["label", "icon-left", "disabled"])
            ], 2))
          ], 64)) : (c(), g("div", uS, [
            v("div", {
              class: C([
                "relative leading-5 text-sm!",
                e.disabled ? "text-(--text-text-disabled-light) dark:text-(--text-text-disabled-light)" : "text-(--text-text-black-default) dark:text-(--text-text-white-default)"
              ])
            }, P(e.dragDropText), 3),
            v("div", {
              class: C([
                "self-stretch flex items-start gap-6 text-xs!",
                e.disabled ? "text-(--text-text-disabled-light) dark:text-(--text-text-disabled-light)" : "text-(--text-text-body) dark:text-(--text-text-white-default)"
              ])
            }, [
              v("div", cS, [
                v("div", {
                  class: C([
                    "w-9 h-9 rounded-[9999px] border-solid box-border flex items-center justify-center overflow-hidden [&_button]:border-0",
                    e.disabled ? "bg-(--background-background-white) dark:bg-(--background-background-black-default) border-(--border-border-disabled) dark:border-(--border-border-disabled-subtle) border" : a.value ? "bg-(--background-background-white) dark:bg-(--background-background-black-default) border-(--border-border-error-strong) dark:border-(--border-border-error-strong) border" : e.success || d.value ? "bg-(--background-background-success) dark:bg-(--background-background-success) border-transparent border-0" : "bg-(--background-background-white) dark:bg-(--background-background-black-default) border-(--border-border-base-medium) dark:border-(--border-border-base) border"
                  ])
                }, [
                  Z.value ? (c(), K(I(Re), {
                    key: 0,
                    variant: "secondary",
                    "icon-left": Z.value,
                    "icon-only": "",
                    size: "sm",
                    disabled: e.disabled,
                    "aria-labelledby": o,
                    onClick: Ue(N, ["stop"])
                  }, null, 8, ["icon-left", "disabled"])) : k("", !0)
                ], 2),
                v("div", {
                  id: o,
                  class: C([
                    "relative leading-5 font-medium text-sm!",
                    e.disabled ? "text-(--text-text-disabled-light) dark:text-(--text-text-disabled-light)" : a.value ? "text-(--text-text-error-strong) dark:text-(--text-text-error-strong)" : e.success || d.value ? "text-(--text-text-success-strong) dark:text-(--text-text-success-strong)" : "text-(--text-text-black-default) dark:text-(--text-text-white-default)"
                  ])
                }, P(e.browseLabel), 3)
              ]),
              v("div", fS, [
                v("div", {
                  class: C([
                    "w-9 h-9 rounded-[9999px] border-solid box-border flex items-center justify-center overflow-hidden [&_button]:border-0",
                    e.disabled ? "bg-(--background-background-white) dark:bg-(--background-background-black-default) border-(--border-border-disabled) dark:border-(--border-border-disabled-subtle) border" : a.value ? "bg-(--background-background-white) dark:bg-(--background-background-black-default) border-(--border-border-error-strong) dark:border-(--border-border-error-strong) border" : e.success || d.value ? "bg-(--background-background-success) dark:bg-(--background-background-success) border-transparent border-0" : "bg-(--background-background-white) dark:bg-(--background-background-black-default) border-(--border-border-base-medium) dark:border-(--border-border-base) border"
                  ])
                }, [
                  ie.value ? (c(), K(I(Re), {
                    key: 0,
                    variant: "secondary",
                    "icon-left": ie.value,
                    "icon-only": "",
                    size: "sm",
                    disabled: e.disabled,
                    "aria-labelledby": i,
                    onClick: Ue(J, ["stop"])
                  }, null, 8, ["icon-left", "disabled"])) : k("", !0)
                ], 2),
                v("div", {
                  id: i,
                  class: C([
                    "relative leading-5 font-medium text-sm!",
                    e.disabled ? "text-(--text-text-disabled-light) dark:text-(--text-text-disabled-light)" : a.value ? "text-(--text-text-error-strong) dark:text-(--text-text-error-strong)" : e.success || d.value ? "text-(--text-text-success-strong) dark:text-(--text-text-success-strong)" : "text-(--text-text-black-default) dark:text-(--text-text-white-default)"
                  ])
                }, P(e.libraryLabel), 3)
              ]),
              v("div", hS, [
                v("div", {
                  class: C([
                    "w-9 h-9 rounded-[9999px] border-solid box-border flex items-center justify-center overflow-hidden [&_button]:border-0",
                    e.disabled ? "bg-(--background-background-white) dark:bg-(--background-background-black-default) border-(--border-border-disabled) dark:border-(--border-border-disabled-subtle) border" : a.value ? "bg-(--background-background-white) dark:bg-(--background-background-black-default) border-(--border-border-error-strong) dark:border-(--border-border-error-strong) border" : e.success || d.value ? "bg-(--background-background-success) dark:bg-(--background-background-success) border-transparent border-0" : "bg-(--background-background-white) dark:bg-(--background-background-black-default) border-(--border-border-base-medium) dark:border-(--border-border-base) border"
                  ])
                }, [
                  fe.value ? (c(), K(I(Re), {
                    key: 0,
                    variant: "secondary",
                    "icon-left": fe.value,
                    "icon-only": "",
                    size: "sm",
                    disabled: e.disabled,
                    "aria-labelledby": s,
                    onClick: Ue(be, ["stop"])
                  }, null, 8, ["icon-left", "disabled"])) : k("", !0)
                ], 2),
                v("div", {
                  id: s,
                  class: C([
                    "relative leading-5 font-medium text-sm!",
                    e.disabled ? "text-(--text-text-disabled-light) dark:text-(--text-text-disabled-light)" : a.value ? "text-(--text-text-error-strong) dark:text-(--text-text-error-strong)" : e.success || d.value ? "text-(--text-text-success-strong) dark:text-(--text-text-success-strong)" : "text-(--text-text-black-default) dark:text-(--text-text-white-default)"
                  ])
                }, P(e.linkLabel), 3)
              ])
            ], 2)
          ])),
          v("input", {
            id: y.value,
            ref_key: "fileInputRef",
            ref: m,
            "data-testid": "file-upload-input",
            name: e.name,
            type: "file",
            accept: e.accept,
            disabled: e.disabled,
            multiple: e.multiple,
            "aria-describedby": z.value,
            "aria-invalid": a.value ? "true" : void 0,
            class: "sr-only",
            onChange: ge,
            onFocus: ne[4] || (ne[4] = (le) => w.value = !0),
            onBlur: ne[5] || (ne[5] = (le) => w.value = !1),
            onKeydown: D
          }, null, 40, bS)
        ], 34),
        te(vt, {
          ref_key: "helperRef",
          ref: $,
          focused: w.value,
          hint: A.value,
          "hint-lines": R.value,
          disabled: e.disabled,
          error: l.value,
          "hint-id": T.value,
          "error-id": L.value,
          "error-live": e.errorLive,
          "test-id-prefix": "file-upload"
        }, null, 8, ["focused", "hint", "hint-lines", "disabled", "error", "hint-id", "error-id", "error-live"])
      ])),
      e.variant === "dropzone" && e.uploadedFiles && e.uploadedFiles.length > 0 ? (c(), g("div", gS, [
        (c(!0), g(se, null, Me(e.uploadedFiles, (le, Le) => (c(), g("div", {
          key: `file-${Le}-${le.name}`,
          class: "flex items-center gap-2"
        }, [
          v("div", pS, [
            le.status === "success" ? (c(), g("svg", mS, [...ne[14] || (ne[14] = [
              v("path", {
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                "stroke-width": "2",
                d: "M5 13l4 4L19 7"
              }, null, -1)
            ])])) : le.status === "error" ? (c(), g("svg", vS, [...ne[15] || (ne[15] = [
              v("path", {
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                "stroke-width": "2",
                d: "M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
              }, null, -1)
            ])])) : k("", !0)
          ]),
          v("div", xS, [
            v("p", {
              class: C([
                "text-sm truncate",
                le.status === "error" ? "text-(--text-text-error-strong) dark:text-(--text-text-error-strong)" : "text-(--text-text-black-default) dark:text-(--text-text-white-default)"
              ])
            }, [
              at(P(le.name) + " ", 1),
              le.size ? (c(), g("span", yS, " (" + P(u(le.size)) + ") ", 1)) : k("", !0)
            ], 2)
          ]),
          v("button", {
            type: "button",
            class: "flex-shrink-0 p-0.5 transition-colors",
            disabled: e.disabled,
            onClick: (Te) => oe(le, Le)
          }, [
            (c(), g("svg", {
              class: C([
                "w-5 h-5",
                e.disabled ? "text-(--text-text-disabled-light) dark:text-(--text-text-disabled-light)" : "text-(--text-text-body) dark:text-(--text-text-white-default)"
              ]),
              xmlns: "http://www.w3.org/2000/svg",
              fill: "none",
              viewBox: "0 0 24 24",
              stroke: "currentColor"
            }, [...ne[16] || (ne[16] = [
              v("path", {
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                "stroke-width": "2",
                d: "M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
              }, null, -1)
            ])], 2))
          ], 8, kS)
        ]))), 128))
      ])) : k("", !0)
    ]));
  }
}), CS = /* @__PURE__ */ lt(wS, [["__scopeId", "data-v-8ebe268e"]]), SS = {
  "aria-hidden": "true",
  focusable: "false",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "textarea-icon pointer-events-none text-(--colors-icon-dark-default) dark:text-(--icons-icon-white-default)"
}, Ag = /* @__PURE__ */ ye({
  __name: "ResizeGrip",
  setup(e) {
    return (n, t) => (c(), g("svg", SS, [...t[0] || (t[0] = [
      v("path", {
        d: "M21 11L11 21",
        stroke: "currentColor",
        "stroke-width": "1.5",
        "stroke-linecap": "round"
      }, null, -1),
      v("path", {
        d: "M21 15L15 21",
        stroke: "currentColor",
        "stroke-width": "1.5",
        "stroke-linecap": "round"
      }, null, -1),
      v("path", {
        d: "M21 19L19 21",
        stroke: "currentColor",
        "stroke-width": "1.5",
        "stroke-linecap": "round"
      }, null, -1)
    ])]));
  }
}), $S = { class: "flex min-w-0 items-center gap-4" }, IS = {
  key: 0,
  class: "flex items-center gap-1"
}, ti = /* @__PURE__ */ ye({
  __name: "TextareaFooter",
  props: {
    labels: { default: () => ({}) },
    actions: { default: () => [] },
    disabled: { type: Boolean, default: !1 }
  },
  emits: ["send", "action"],
  setup(e, { emit: n }) {
    const t = e, a = n, l = p(() => t.labels.send ?? "Send message");
    return (r, o) => (c(), g("div", $S, [
      te(Re, {
        variant: "primary",
        size: "sm",
        label: l.value,
        disabled: e.disabled,
        "data-testid": "field-footer-send",
        onClick: o[0] || (o[0] = (i) => a("send"))
      }, null, 8, ["label", "disabled"]),
      e.actions.length ? (c(), g("div", IS, [
        (c(!0), g(se, null, Me(e.actions, (i) => (c(), K(Re, {
          key: i.id,
          variant: "tertiary",
          size: "xs",
          "icon-only": "",
          "icon-left": i.icon,
          "aria-label": i.label,
          disabled: e.disabled,
          "data-field-footer-action": i.id,
          onClick: (s) => a("action", i.id)
        }, null, 8, ["icon-left", "aria-label", "disabled", "data-field-footer-action", "onClick"]))), 128))
      ])) : k("", !0)
    ]));
  }
}), TS = ["data-type"], LS = {
  key: 0,
  class: "flex min-w-0 max-w-full items-center gap-1"
}, ES = ["src"], AS = {
  key: 0,
  class: "flex w-full items-center gap-2 p-2 rounded-(--border-border-radius-rounded-sm) bg-(--background-background-white-secondary) dark:bg-(--background-background-black-default)",
  "data-testid": "textarea-chatroom"
}, RS = {
  key: 0,
  class: "flex shrink-0 items-center gap-1"
}, BS = { class: "self-stretch flex flex-1 min-h-0 p-2" }, MS = ["rows"], DS = {
  key: 0,
  class: "absolute bottom-2 right-2 flex items-center justify-center"
}, zS = ["src"], OS = {
  key: 1,
  class: "text-(length:--size-sm) leading-(--line-height-l) text-(--text-text-body-subtle) dark:text-(--colors-text-white-secondary)"
}, PS = {
  key: 1,
  class: "flex items-center gap-4",
  "data-testid": "textarea-footer"
}, FS = "border border-solid rounded-b-(--border-border-radius-rounded-l) p-[calc(--spacing(2.5)-1px)] border-(--border-border-base-medium) dark:border-(--border-border-base) bg-(--background-background-white) dark:bg-(--background-background-black-default)", vf = "w-full relative bg-transparent border-0 outline-none focus:outline-none focus:ring-0 focus:border-0 p-0 text-(length:--size-m) leading-(--line-height-l) placeholder:text-(--text-text-body-subtle) dark:placeholder:text-(--colors-text-white-secondary)", VS = "w-full relative flex flex-col items-start gap-0.5 pb-0.5 text-left text-(length:--size-m) text-(--text-text-black-default) dark:text-(--colors-text-white-default) font-inter", NS = /* @__PURE__ */ ye({
  __name: "Textarea",
  props: {
    type: { default: "Default" },
    label: { default: void 0 },
    required: { type: Boolean, default: !1 },
    requiredIndicator: { default: "*" },
    labelTooltip: { default: void 0 },
    helpIcon: { default: void 0 },
    placeholder: { default: void 0 },
    showPlaceholder: { type: Boolean, default: void 0 },
    modelValue: { default: "" },
    bottomRightIcon: { default: void 0 },
    helpText: { default: void 0 },
    helpTextIcon: { default: void 0 },
    error: { default: void 0 },
    showError: { type: Boolean, default: void 0 },
    rows: { default: void 0 },
    disabled: { type: Boolean, default: !1 },
    readonly: { type: Boolean, default: !1 },
    name: { default: void 0 },
    id: { default: void 0 },
    fullWidth: { type: Boolean, default: !0 },
    width: { default: void 0 },
    height: { default: void 0 },
    maxLength: { default: void 0 },
    resizable: { type: Boolean, default: !1 },
    autocomplete: { default: "off" },
    labels: { default: () => ({}) },
    submitLabel: { default: void 0 },
    actions: { default: () => [] }
  },
  emits: ["update:modelValue", "input", "focus", "blur", "send", "action"],
  setup(e, { emit: n }) {
    const t = e, a = n, l = Ve(), r = p(() => t.id || l), o = p(() => t.label ? `${r.value}-label` : void 0), i = p(() => `${r.value}-error`), s = p(() => `${r.value}-help`), d = E(!1), u = E(null), f = E(null), b = p(() => t.type === "Chatroom"), h = p(() => t.type === "Buttons inside"), m = p(() => t.type === "Buttons outside"), x = p(() => !!t.error), y = p(() => t.showError !== void 0 ? t.showError : x.value), w = p(() => {
      const ee = [];
      return y.value && x.value && ee.push(i.value), t.helpText && ee.push(s.value), ee.length ? ee.join(" ") : void 0;
    }), S = p(() => !!t.modelValue), $ = p(() => t.showPlaceholder === !1 ? !1 : t.showPlaceholder === !0 ? !0 : !S.value), T = p(() => $.value ? t.placeholder : void 0), L = E("auto"), A = E(null), R = { send: "Send message", field: "Message" }, z = p(() => ({ ...R, ...t.labels })), D = p(() => {
      const oe = `relative self-stretch box-border flex flex-col items-start justify-between gap-2 border-solid px-[calc(--spacing(1)-1px)] pt-[calc(--spacing(1)-1px)] font-inter ${h.value ? "rounded-t-(--border-border-radius-rounded-l) rounded-b-none border-x border-t border-b-0 pb-1" : "rounded-(--border-border-radius-rounded-l) border pb-[calc(--spacing(1)-1px)]"}`, ge = "shadow-[0_0_2px_2px_var(--background-background-hover)]", re = "shadow-(--blur-shadow-xs)", ue = "dark:shadow-(--blur-shadow-m-dark)";
      if (t.disabled)
        return `${oe} ${re} ${ue} bg-(--background-background-disabled-opacity) dark:bg-(--colors-background-disabled) border-(--border-border-disabled-subtle) dark:border-(--colors-border-disabled-subtle)`;
      if (t.readonly)
        return `${oe} ${re} ${ue} bg-(--background-background-white-secondary-soft) dark:bg-(--colors-background-disabled) border-(--border-border-base-soft) dark:border-(--border-border-base)`;
      if (x.value)
        return `${oe} ${d.value ? ge : `${re} ${ue}`} bg-(--background-background-white) dark:bg-(--background-background-black-default) border-(--border-border-error-strong) dark:border-(--border-border-error)`;
      if (d.value)
        return `${oe} ${ge} bg-(--background-background-selected) dark:bg-(--background-background-black-default) border-(--border-border-accent)`;
      const O = S.value ? "" : re;
      return `${oe} ${O} ${ue} bg-(--background-background-white) dark:bg-(--background-background-black-default) border-(--border-border-base-medium) dark:border-(--border-border-base)`;
    }), V = p(() => t.disabled ? "text-(--text-text-disabled-light) dark:text-(--colors-text-disabled)" : t.readonly ? "text-(--text-text-black-default) dark:text-(--text-text-white-default)" : d.value || S.value ? "text-(--text-text-body) dark:text-(--colors-text-white-default)" : "text-(--text-text-body-subtle) dark:text-(--colors-text-white-default)"), Y = p(() => !t.fullWidth && t.width ? { width: t.width } : {}), _ = p(() => [
      "flex flex-col",
      m.value ? "gap-4" : "",
      h.value ? "rounded-(--border-border-radius-rounded-l) shadow-(--blur-shadow-xs)" : "",
      "w-full"
    ]), j = p(() => {
      const ee = t.height ?? (t.type === "Default" ? "204px" : "184px");
      return t.resizable ? { minHeight: ee } : { height: ee };
    }), M = p(() => {
      var ee;
      if (t.maxLength)
        return ((ee = t.modelValue) == null ? void 0 : ee.length) || 0;
    }), W = p(() => t.resizable ? "resize-y" : "resize-none"), G = p(() => ({
      id: r.value,
      "data-testid": "textarea",
      name: t.name,
      autocomplete: t.autocomplete,
      value: t.modelValue,
      placeholder: T.value,
      disabled: t.disabled,
      readonly: t.readonly,
      maxlength: t.maxLength,
      "aria-labelledby": o.value,
      // The Chatroom row has no room for a visible label
      "aria-label": b.value && !t.label ? z.value.field : void 0,
      "aria-required": t.required ? !0 : void 0,
      "aria-invalid": x.value ? !0 : void 0,
      "aria-disabled": t.disabled,
      "aria-describedby": w.value
    })), B = (ee) => {
      const oe = ee.target;
      a("update:modelValue", oe.value), a("input", ee);
    }, F = (ee) => {
      t.disabled || (d.value = !0), a("focus", ee);
    }, X = (ee) => {
      d.value = !1, a("blur", ee);
    }, H = (ee) => {
      var oe, ge;
      (oe = u.value) == null || oe.handleFieldKeydown(ee), (ge = f.value) == null || ge.handleFieldKeydown(ee);
    }, q = p(() => t.disabled || t.readonly), N = () => a("send", t.modelValue), J = (ee) => a("action", ee), be = () => {
      if (A.value && t.resizable) {
        const ee = A.value.offsetHeight;
        ee > 0 && (L.value = `${ee}px`);
      }
    };
    Ie(
      () => t.resizable,
      (ee) => {
        ee || (L.value = "auto");
      }
    );
    let ke = null;
    return ot(() => {
      t.resizable && A.value && (ke = new ResizeObserver(() => {
        be();
      }), ke.observe(A.value));
    }), kt(() => {
      ke && ke.disconnect();
    }), Ie(
      () => A.value,
      (ee) => {
        ke && ke.disconnect(), ee && t.resizable && (ke = new ResizeObserver(() => {
          be();
        }), ke.observe(ee));
      }
    ), (ee, oe) => (c(), g("div", {
      class: C(VS),
      style: Ne(Y.value),
      "data-type": e.type
    }, [
      e.label ? (c(), g("div", LS, [
        te(xt, {
          id: o.value,
          ref_key: "labelRef",
          ref: u,
          text: e.label,
          "input-id": r.value,
          required: e.required,
          "required-indicator": e.requiredIndicator,
          tooltip: e.labelTooltip,
          focused: d.value,
          "test-id": "textarea-label"
        }, null, 8, ["id", "text", "input-id", "required", "required-indicator", "tooltip", "focused"]),
        e.helpIcon && !e.labelTooltip ? (c(), g("img", {
          key: 0,
          class: "h-3.5 w-3.5 relative textarea-icon",
          src: e.helpIcon,
          alt: ""
        }, null, 8, ES)) : k("", !0)
      ])) : k("", !0),
      v("div", {
        class: C(_.value),
        "data-testid": "textarea-field"
      }, [
        b.value ? (c(), g("div", AS, [
          e.actions.length ? (c(), g("div", RS, [
            (c(!0), g(se, null, Me(e.actions, (ge) => (c(), K(Re, {
              key: ge.id,
              variant: "tertiary",
              size: "xs",
              "icon-only": "",
              "icon-left": ge.icon,
              "aria-label": ge.label,
              disabled: q.value,
              "data-textarea-action": ge.id,
              onClick: (re) => J(ge.id)
            }, null, 8, ["icon-left", "aria-label", "disabled", "data-textarea-action", "onClick"]))), 128))
          ])) : k("", !0),
          te(Rn, {
            size: "sm",
            flush: "",
            disabled: e.disabled,
            readonly: e.readonly,
            error: x.value,
            "has-value": S.value,
            class: "min-w-0 flex-1"
          }, {
            default: ve(() => [
              v("textarea", Oe({
                ref_key: "textareaRef",
                ref: A
              }, G.value, {
                rows: "1",
                class: [vf, V.value, "h-5 resize-none overflow-hidden px-[calc(--spacing(2.5)-1px)]"],
                onInput: B,
                onFocus: F,
                onBlur: X,
                onKeydown: H
              }), null, 16)
            ]),
            _: 1
          }, 8, ["disabled", "readonly", "error", "has-value"]),
          te(Re, {
            variant: "tertiary",
            size: "xs",
            "icon-only": "",
            "icon-left": "ri-send-plane-2-line",
            "aria-label": z.value.send,
            disabled: q.value,
            "data-testid": "textarea-send",
            onClick: N
          }, null, 8, ["aria-label", "disabled"])
        ])) : (c(), g(se, { key: 1 }, [
          v("div", {
            class: C(D.value),
            style: Ne(j.value),
            "data-testid": "textarea-box"
          }, [
            v("div", BS, [
              v("textarea", Oe({
                ref_key: "textareaRef",
                ref: A
              }, G.value, {
                rows: e.rows,
                style: { height: L.value },
                class: [vf, V.value, W.value],
                onInput: B,
                onFocus: F,
                onBlur: X,
                onKeydown: H
              }), null, 16, MS)
            ]),
            e.bottomRightIcon || e.maxLength || e.resizable ? (c(), g("div", DS, [
              e.bottomRightIcon ? (c(), g("img", {
                key: 0,
                class: "w-[24.2px] h-[24.2px] textarea-icon",
                src: e.bottomRightIcon,
                alt: ""
              }, null, 8, zS)) : e.maxLength ? (c(), g("div", OS, P(M.value) + "/" + P(e.maxLength), 1)) : e.resizable ? (c(), K(Ag, { key: 2 })) : k("", !0)
            ])) : k("", !0)
          ], 6),
          h.value ? (c(), K(ti, {
            key: 0,
            class: C(FS),
            labels: { send: z.value.send },
            actions: e.actions,
            disabled: q.value,
            "data-testid": "textarea-footer",
            onSend: N,
            onAction: J
          }, null, 8, ["labels", "actions", "disabled"])) : k("", !0),
          m.value ? (c(), g("div", PS, [
            te(ti, {
              class: "shrink-0",
              labels: { send: z.value.send },
              actions: e.actions,
              disabled: q.value,
              onSend: N,
              onAction: J
            }, null, 8, ["labels", "actions", "disabled"]),
            te(vt, {
              ref_key: "helperRef",
              ref: f,
              class: "min-w-0 flex-1",
              focused: d.value,
              hint: e.helpText,
              error: y.value ? e.error : void 0,
              "hint-id": s.value,
              "error-id": i.value,
              "hint-icon": e.helpTextIcon,
              "test-id-prefix": "textarea"
            }, null, 8, ["focused", "hint", "error", "hint-id", "error-id", "hint-icon"])
          ])) : k("", !0)
        ], 64))
      ], 2),
      m.value ? k("", !0) : (c(), K(vt, {
        key: 1,
        ref_key: "helperRef",
        ref: f,
        focused: d.value,
        hint: e.helpText,
        error: y.value ? e.error : void 0,
        "hint-id": s.value,
        "error-id": i.value,
        "hint-icon": e.helpTextIcon,
        "test-id-prefix": "textarea"
      }, null, 8, ["focused", "hint", "error", "hint-id", "error-id", "hint-icon"])),
      e.submitLabel && !h.value && !m.value && !b.value ? (c(), K(Re, {
        key: 2,
        variant: "primary",
        size: "xs",
        label: e.submitLabel,
        disabled: q.value,
        "data-testid": "textarea-submit",
        onClick: N
      }, null, 8, ["label", "disabled"])) : k("", !0)
    ], 12, TS));
  }
}), WW = /* @__PURE__ */ lt(NS, [["__scopeId", "data-v-1e8ea3bc"]]);
function jt(e) {
  this.content = e;
}
jt.prototype = {
  constructor: jt,
  find: function(e) {
    for (var n = 0; n < this.content.length; n += 2)
      if (this.content[n] === e) return n;
    return -1;
  },
  // :: (string) → ?any
  // Retrieve the value stored under `key`, or return undefined when
  // no such key exists.
  get: function(e) {
    var n = this.find(e);
    return n == -1 ? void 0 : this.content[n + 1];
  },
  // :: (string, any, ?string) → OrderedMap
  // Create a new map by replacing the value of `key` with a new
  // value, or adding a binding to the end of the map. If `newKey` is
  // given, the key of the binding will be replaced with that key.
  update: function(e, n, t) {
    var a = t && t != e ? this.remove(t) : this, l = a.find(e), r = a.content.slice();
    return l == -1 ? r.push(t || e, n) : (r[l + 1] = n, t && (r[l] = t)), new jt(r);
  },
  // :: (string) → OrderedMap
  // Return a map with the given key removed, if it existed.
  remove: function(e) {
    var n = this.find(e);
    if (n == -1) return this;
    var t = this.content.slice();
    return t.splice(n, 2), new jt(t);
  },
  // :: (string, any) → OrderedMap
  // Add a new key to the start of the map.
  addToStart: function(e, n) {
    return new jt([e, n].concat(this.remove(e).content));
  },
  // :: (string, any) → OrderedMap
  // Add a new key to the end of the map.
  addToEnd: function(e, n) {
    var t = this.remove(e).content.slice();
    return t.push(e, n), new jt(t);
  },
  // :: (string, string, any) → OrderedMap
  // Add a key after the given key. If `place` is not found, the new
  // key is added to the end.
  addBefore: function(e, n, t) {
    var a = this.remove(n), l = a.content.slice(), r = a.find(e);
    return l.splice(r == -1 ? l.length : r, 0, n, t), new jt(l);
  },
  // :: ((key: string, value: any))
  // Call the given function for each key/value pair in the map, in
  // order.
  forEach: function(e) {
    for (var n = 0; n < this.content.length; n += 2)
      e(this.content[n], this.content[n + 1]);
  },
  // :: (union<Object, OrderedMap>) → OrderedMap
  // Create a new map by prepending the keys in this map that don't
  // appear in `map` before the keys in `map`.
  prepend: function(e) {
    return e = jt.from(e), e.size ? new jt(e.content.concat(this.subtract(e).content)) : this;
  },
  // :: (union<Object, OrderedMap>) → OrderedMap
  // Create a new map by appending the keys in this map that don't
  // appear in `map` after the keys in `map`.
  append: function(e) {
    return e = jt.from(e), e.size ? new jt(this.subtract(e).content.concat(e.content)) : this;
  },
  // :: (union<Object, OrderedMap>) → OrderedMap
  // Create a map containing all the keys in this map that don't
  // appear in `map`.
  subtract: function(e) {
    var n = this;
    e = jt.from(e);
    for (var t = 0; t < e.content.length; t += 2)
      n = n.remove(e.content[t]);
    return n;
  },
  // :: () → Object
  // Turn ordered map into a plain object.
  toObject: function() {
    var e = {};
    return this.forEach(function(n, t) {
      e[n] = t;
    }), e;
  },
  // :: number
  // The amount of keys in this map.
  get size() {
    return this.content.length >> 1;
  }
};
jt.from = function(e) {
  if (e instanceof jt) return e;
  var n = [];
  if (e) for (var t in e) n.push(t, e[t]);
  return new jt(n);
};
function Rg(e, n, t) {
  for (let a = 0; ; a++) {
    if (a == e.childCount || a == n.childCount)
      return e.childCount == n.childCount ? null : t;
    let l = e.child(a), r = n.child(a);
    if (l == r) {
      t += l.nodeSize;
      continue;
    }
    if (!l.sameMarkup(r))
      return t;
    if (l.isText && l.text != r.text) {
      for (let o = 0; l.text[o] == r.text[o]; o++)
        t++;
      return t;
    }
    if (l.content.size || r.content.size) {
      let o = Rg(l.content, r.content, t + 1);
      if (o != null)
        return o;
    }
    t += l.nodeSize;
  }
}
function Bg(e, n, t, a) {
  for (let l = e.childCount, r = n.childCount; ; ) {
    if (l == 0 || r == 0)
      return l == r ? null : { a: t, b: a };
    let o = e.child(--l), i = n.child(--r), s = o.nodeSize;
    if (o == i) {
      t -= s, a -= s;
      continue;
    }
    if (!o.sameMarkup(i))
      return { a: t, b: a };
    if (o.isText && o.text != i.text) {
      let d = 0, u = Math.min(o.text.length, i.text.length);
      for (; d < u && o.text[o.text.length - d - 1] == i.text[i.text.length - d - 1]; )
        d++, t--, a--;
      return { a: t, b: a };
    }
    if (o.content.size || i.content.size) {
      let d = Bg(o.content, i.content, t - 1, a - 1);
      if (d)
        return d;
    }
    t -= s, a -= s;
  }
}
class Pe {
  /**
  @internal
  */
  constructor(n, t) {
    if (this.content = n, this.size = t || 0, t == null)
      for (let a = 0; a < n.length; a++)
        this.size += n[a].nodeSize;
  }
  /**
  Invoke a callback for all descendant nodes between the given two
  positions (relative to start of this fragment). Doesn't descend
  into a node when the callback returns `false`.
  */
  nodesBetween(n, t, a, l = 0, r) {
    for (let o = 0, i = 0; i < t; o++) {
      let s = this.content[o], d = i + s.nodeSize;
      if (d > n && a(s, l + i, r || null, o) !== !1 && s.content.size) {
        let u = i + 1;
        s.nodesBetween(Math.max(0, n - u), Math.min(s.content.size, t - u), a, l + u);
      }
      i = d;
    }
  }
  /**
  Call the given callback for every descendant node. `pos` will be
  relative to the start of the fragment. The callback may return
  `false` to prevent traversal of a given node's children.
  */
  descendants(n) {
    this.nodesBetween(0, this.size, n);
  }
  /**
  Extract the text between `from` and `to`. See the same method on
  [`Node`](https://prosemirror.net/docs/ref/#model.Node.textBetween).
  */
  textBetween(n, t, a, l) {
    let r = "", o = !0;
    return this.nodesBetween(n, t, (i, s) => {
      let d = i.isText ? i.text.slice(Math.max(n, s) - s, t - s) : i.isLeaf ? l ? typeof l == "function" ? l(i) : l : i.type.spec.leafText ? i.type.spec.leafText(i) : "" : "";
      i.isBlock && (i.isLeaf && d || i.isTextblock) && a && (o ? o = !1 : r += a), r += d;
    }, 0), r;
  }
  /**
  Create a new fragment containing the combined content of this
  fragment and the other.
  */
  append(n) {
    if (!n.size)
      return this;
    if (!this.size)
      return n;
    let t = this.lastChild, a = n.firstChild, l = this.content.slice(), r = 0;
    for (t.isText && t.sameMarkup(a) && (l[l.length - 1] = t.withText(t.text + a.text), r = 1); r < n.content.length; r++)
      l.push(n.content[r]);
    return new Pe(l, this.size + n.size);
  }
  /**
  Cut out the sub-fragment between the two given positions.
  */
  cut(n, t = this.size) {
    if (n == 0 && t == this.size)
      return this;
    let a = [], l = 0;
    if (t > n)
      for (let r = 0, o = 0; o < t; r++) {
        let i = this.content[r], s = o + i.nodeSize;
        s > n && ((o < n || s > t) && (i.isText ? i = i.cut(Math.max(0, n - o), Math.min(i.text.length, t - o)) : i = i.cut(Math.max(0, n - o - 1), Math.min(i.content.size, t - o - 1))), a.push(i), l += i.nodeSize), o = s;
      }
    return new Pe(a, l);
  }
  /**
  @internal
  */
  cutByIndex(n, t) {
    return n == t ? Pe.empty : n == 0 && t == this.content.length ? this : new Pe(this.content.slice(n, t));
  }
  /**
  Create a new fragment in which the node at the given index is
  replaced by the given node.
  */
  replaceChild(n, t) {
    let a = this.content[n];
    if (a == t)
      return this;
    let l = this.content.slice(), r = this.size + t.nodeSize - a.nodeSize;
    return l[n] = t, new Pe(l, r);
  }
  /**
  Create a new fragment by prepending the given node to this
  fragment.
  */
  addToStart(n) {
    return new Pe([n].concat(this.content), this.size + n.nodeSize);
  }
  /**
  Create a new fragment by appending the given node to this
  fragment.
  */
  addToEnd(n) {
    return new Pe(this.content.concat(n), this.size + n.nodeSize);
  }
  /**
  Compare this fragment to another one.
  */
  eq(n) {
    if (this.content.length != n.content.length)
      return !1;
    for (let t = 0; t < this.content.length; t++)
      if (!this.content[t].eq(n.content[t]))
        return !1;
    return !0;
  }
  /**
  The first child of the fragment, or `null` if it is empty.
  */
  get firstChild() {
    return this.content.length ? this.content[0] : null;
  }
  /**
  The last child of the fragment, or `null` if it is empty.
  */
  get lastChild() {
    return this.content.length ? this.content[this.content.length - 1] : null;
  }
  /**
  The number of child nodes in this fragment.
  */
  get childCount() {
    return this.content.length;
  }
  /**
  Get the child node at the given index. Raise an error when the
  index is out of range.
  */
  child(n) {
    let t = this.content[n];
    if (!t)
      throw new RangeError("Index " + n + " out of range for " + this);
    return t;
  }
  /**
  Get the child node at the given index, if it exists.
  */
  maybeChild(n) {
    return this.content[n] || null;
  }
  /**
  Call `f` for every child node, passing the node, its offset
  into this parent node, and its index.
  */
  forEach(n) {
    for (let t = 0, a = 0; t < this.content.length; t++) {
      let l = this.content[t];
      n(l, a, t), a += l.nodeSize;
    }
  }
  /**
  Find the first position at which this fragment and another
  fragment differ, or `null` if they are the same.
  */
  findDiffStart(n, t = 0) {
    return Rg(this, n, t);
  }
  /**
  Find the first position, searching from the end, at which this
  fragment and the given fragment differ, or `null` if they are
  the same. Since this position will not be the same in both
  nodes, an object with two separate positions is returned.
  */
  findDiffEnd(n, t = this.size, a = n.size) {
    return Bg(this, n, t, a);
  }
  /**
  Find the index and inner offset corresponding to a given relative
  position in this fragment. The result object will be reused
  (overwritten) the next time the function is called. @internal
  */
  findIndex(n) {
    if (n == 0)
      return vo(0, n);
    if (n == this.size)
      return vo(this.content.length, n);
    if (n > this.size || n < 0)
      throw new RangeError(`Position ${n} outside of fragment (${this})`);
    for (let t = 0, a = 0; ; t++) {
      let l = this.child(t), r = a + l.nodeSize;
      if (r >= n)
        return r == n ? vo(t + 1, r) : vo(t, a);
      a = r;
    }
  }
  /**
  Return a debugging string that describes this fragment.
  */
  toString() {
    return "<" + this.toStringInner() + ">";
  }
  /**
  @internal
  */
  toStringInner() {
    return this.content.join(", ");
  }
  /**
  Create a JSON-serializeable representation of this fragment.
  */
  toJSON() {
    return this.content.length ? this.content.map((n) => n.toJSON()) : null;
  }
  /**
  Deserialize a fragment from its JSON representation.
  */
  static fromJSON(n, t) {
    if (!t)
      return Pe.empty;
    if (!Array.isArray(t))
      throw new RangeError("Invalid input for Fragment.fromJSON");
    return Pe.fromArray(t.map(n.nodeFromJSON));
  }
  /**
  Build a fragment from an array of nodes. Ensures that adjacent
  text nodes with the same marks are joined together.
  */
  static fromArray(n) {
    if (!n.length)
      return Pe.empty;
    let t, a = 0;
    for (let l = 0; l < n.length; l++) {
      let r = n[l];
      a += r.nodeSize, l && r.isText && n[l - 1].sameMarkup(r) ? (t || (t = n.slice(0, l)), t[t.length - 1] = r.withText(t[t.length - 1].text + r.text)) : t && t.push(r);
    }
    return new Pe(t || n, a);
  }
  /**
  Create a fragment from something that can be interpreted as a
  set of nodes. For `null`, it returns the empty fragment. For a
  fragment, the fragment itself. For a node or array of nodes, a
  fragment containing those nodes.
  */
  static from(n) {
    if (!n)
      return Pe.empty;
    if (n instanceof Pe)
      return n;
    if (Array.isArray(n))
      return this.fromArray(n);
    if (n.attrs)
      return new Pe([n], n.nodeSize);
    throw new RangeError("Can not convert " + n + " to a Fragment" + (n.nodesBetween ? " (looks like multiple versions of prosemirror-model were loaded)" : ""));
  }
}
Pe.empty = new Pe([], 0);
const Rs = { index: 0, offset: 0 };
function vo(e, n) {
  return Rs.index = e, Rs.offset = n, Rs;
}
function ni(e, n) {
  if (e === n)
    return !0;
  if (!(e && typeof e == "object") || !(n && typeof n == "object"))
    return !1;
  let t = Array.isArray(e);
  if (Array.isArray(n) != t)
    return !1;
  if (t) {
    if (e.length != n.length)
      return !1;
    for (let a = 0; a < e.length; a++)
      if (!ni(e[a], n[a]))
        return !1;
  } else {
    for (let a in e)
      if (!(a in n) || !ni(e[a], n[a]))
        return !1;
    for (let a in n)
      if (!(a in e))
        return !1;
  }
  return !0;
}
let mt = class Bd {
  /**
  @internal
  */
  constructor(n, t) {
    this.type = n, this.attrs = t;
  }
  /**
  Given a set of marks, create a new set which contains this one as
  well, in the right position. If this mark is already in the set,
  the set itself is returned. If any marks that are set to be
  [exclusive](https://prosemirror.net/docs/ref/#model.MarkSpec.excludes) with this mark are present,
  those are replaced by this one.
  */
  addToSet(n) {
    let t, a = !1;
    for (let l = 0; l < n.length; l++) {
      let r = n[l];
      if (this.eq(r))
        return n;
      if (this.type.excludes(r.type))
        t || (t = n.slice(0, l));
      else {
        if (r.type.excludes(this.type))
          return n;
        !a && r.type.rank > this.type.rank && (t || (t = n.slice(0, l)), t.push(this), a = !0), t && t.push(r);
      }
    }
    return t || (t = n.slice()), a || t.push(this), t;
  }
  /**
  Remove this mark from the given set, returning a new set. If this
  mark is not in the set, the set itself is returned.
  */
  removeFromSet(n) {
    for (let t = 0; t < n.length; t++)
      if (this.eq(n[t]))
        return n.slice(0, t).concat(n.slice(t + 1));
    return n;
  }
  /**
  Test whether this mark is in the given set of marks.
  */
  isInSet(n) {
    for (let t = 0; t < n.length; t++)
      if (this.eq(n[t]))
        return !0;
    return !1;
  }
  /**
  Test whether this mark has the same type and attributes as
  another mark.
  */
  eq(n) {
    return this == n || this.type == n.type && ni(this.attrs, n.attrs);
  }
  /**
  Convert this mark to a JSON-serializeable representation.
  */
  toJSON() {
    let n = { type: this.type.name };
    for (let t in this.attrs) {
      n.attrs = this.attrs;
      break;
    }
    return n;
  }
  /**
  Deserialize a mark from JSON.
  */
  static fromJSON(n, t) {
    if (!t)
      throw new RangeError("Invalid input for Mark.fromJSON");
    let a = n.marks[t.type];
    if (!a)
      throw new RangeError(`There is no mark type ${t.type} in this schema`);
    let l = a.create(t.attrs);
    return a.checkAttrs(l.attrs), l;
  }
  /**
  Test whether two sets of marks are identical.
  */
  static sameSet(n, t) {
    if (n == t)
      return !0;
    if (n.length != t.length)
      return !1;
    for (let a = 0; a < n.length; a++)
      if (!n[a].eq(t[a]))
        return !1;
    return !0;
  }
  /**
  Create a properly sorted mark set from null, a single mark, or an
  unsorted array of marks.
  */
  static setFrom(n) {
    if (!n || Array.isArray(n) && n.length == 0)
      return Bd.none;
    if (n instanceof Bd)
      return [n];
    let t = n.slice();
    return t.sort((a, l) => a.type.rank - l.type.rank), t;
  }
};
mt.none = [];
class ai extends Error {
}
class Ye {
  /**
  Create a slice. When specifying a non-zero open depth, you must
  make sure that there are nodes of at least that depth at the
  appropriate side of the fragment—i.e. if the fragment is an
  empty paragraph node, `openStart` and `openEnd` can't be greater
  than 1.
  
  It is not necessary for the content of open nodes to conform to
  the schema's content constraints, though it should be a valid
  start/end/middle for such a node, depending on which sides are
  open.
  */
  constructor(n, t, a) {
    this.content = n, this.openStart = t, this.openEnd = a;
  }
  /**
  The size this slice would add when inserted into a document.
  */
  get size() {
    return this.content.size - this.openStart - this.openEnd;
  }
  /**
  @internal
  */
  insertAt(n, t) {
    let a = Dg(this.content, n + this.openStart, t, this.openStart + 1, this.openEnd + 1);
    return a && new Ye(a, this.openStart, this.openEnd);
  }
  /**
  @internal
  */
  removeBetween(n, t) {
    return new Ye(Mg(this.content, n + this.openStart, t + this.openStart), this.openStart, this.openEnd);
  }
  /**
  Tests whether this slice is equal to another slice.
  */
  eq(n) {
    return this.content.eq(n.content) && this.openStart == n.openStart && this.openEnd == n.openEnd;
  }
  /**
  @internal
  */
  toString() {
    return this.content + "(" + this.openStart + "," + this.openEnd + ")";
  }
  /**
  Convert a slice to a JSON-serializable representation.
  */
  toJSON() {
    if (!this.content.size)
      return null;
    let n = { content: this.content.toJSON() };
    return this.openStart > 0 && (n.openStart = this.openStart), this.openEnd > 0 && (n.openEnd = this.openEnd), n;
  }
  /**
  Deserialize a slice from its JSON representation.
  */
  static fromJSON(n, t) {
    if (!t)
      return Ye.empty;
    let a = t.openStart || 0, l = t.openEnd || 0;
    if (typeof a != "number" || typeof l != "number")
      throw new RangeError("Invalid input for Slice.fromJSON");
    return new Ye(Pe.fromJSON(n, t.content), a, l);
  }
  /**
  Create a slice from a fragment by taking the maximum possible
  open value on both side of the fragment.
  */
  static maxOpen(n, t = !0) {
    let a = 0, l = 0;
    for (let r = n.firstChild; r && !r.isLeaf && (t || !r.type.spec.isolating); r = r.firstChild)
      a++;
    for (let r = n.lastChild; r && !r.isLeaf && (t || !r.type.spec.isolating); r = r.lastChild)
      l++;
    return new Ye(n, a, l);
  }
}
Ye.empty = new Ye(Pe.empty, 0, 0);
function Mg(e, n, t) {
  let { index: a, offset: l } = e.findIndex(n), r = e.maybeChild(a), { index: o, offset: i } = e.findIndex(t);
  if (l == n || r.isText) {
    if (i != t && !e.child(o).isText)
      throw new RangeError("Removing non-flat range");
    return e.cut(0, n).append(e.cut(t));
  }
  if (a != o)
    throw new RangeError("Removing non-flat range");
  return e.replaceChild(a, r.copy(Mg(r.content, n - l - 1, t - l - 1)));
}
function Dg(e, n, t, a, l, r) {
  let { index: o, offset: i } = e.findIndex(n), s = e.maybeChild(o);
  if (i == n || s.isText)
    return r && a <= 0 && l <= 0 && !r.canReplace(o, o, t) ? null : e.cut(0, n).append(t).append(e.cut(n));
  let d = Dg(s.content, n - i - 1, t, o == 0 ? a - 1 : 0, o == e.childCount - 1 ? l - 1 : 0, s);
  return d && e.replaceChild(o, s.copy(d));
}
function HS(e, n, t) {
  if (t.openStart > e.depth)
    throw new ai("Inserted content deeper than insertion position");
  if (e.depth - t.openStart != n.depth - t.openEnd)
    throw new ai("Inconsistent open depths");
  return zg(e, n, t, 0);
}
function zg(e, n, t, a) {
  let l = e.index(a), r = e.node(a);
  if (l == n.index(a) && a < e.depth - t.openStart) {
    let o = zg(e, n, t, a + 1);
    return r.copy(r.content.replaceChild(l, o));
  } else if (t.content.size)
    if (!t.openStart && !t.openEnd && e.depth == a && n.depth == a) {
      let o = e.parent, i = o.content;
      return tl(o, i.cut(0, e.parentOffset).append(t.content).append(i.cut(n.parentOffset)));
    } else {
      let { start: o, end: i } = jS(t, e);
      return tl(r, Pg(e, o, i, n, a));
    }
  else return tl(r, li(e, n, a));
}
function Og(e, n) {
  if (!n.type.compatibleContent(e.type))
    throw new ai("Cannot join " + n.type.name + " onto " + e.type.name);
}
function Md(e, n, t) {
  let a = e.node(t);
  return Og(a, n.node(t)), a;
}
function el(e, n) {
  let t = n.length - 1;
  t >= 0 && e.isText && e.sameMarkup(n[t]) ? n[t] = e.withText(n[t].text + e.text) : n.push(e);
}
function vr(e, n, t, a) {
  let l = (n || e).node(t), r = 0, o = n ? n.index(t) : l.childCount;
  e && (r = e.index(t), e.depth > t ? r++ : e.textOffset && (el(e.nodeAfter, a), r++));
  for (let i = r; i < o; i++)
    el(l.child(i), a);
  n && n.depth == t && n.textOffset && el(n.nodeBefore, a);
}
function tl(e, n) {
  return e.type.checkContent(n), e.copy(n);
}
function Pg(e, n, t, a, l) {
  let r = e.depth > l && Md(e, n, l + 1), o = a.depth > l && Md(t, a, l + 1), i = [];
  return vr(null, e, l, i), r && o && n.index(l) == t.index(l) ? (Og(r, o), el(tl(r, Pg(e, n, t, a, l + 1)), i)) : (r && el(tl(r, li(e, n, l + 1)), i), vr(n, t, l, i), o && el(tl(o, li(t, a, l + 1)), i)), vr(a, null, l, i), new Pe(i);
}
function li(e, n, t) {
  let a = [];
  if (vr(null, e, t, a), e.depth > t) {
    let l = Md(e, n, t + 1);
    el(tl(l, li(e, n, t + 1)), a);
  }
  return vr(n, null, t, a), new Pe(a);
}
function jS(e, n) {
  let t = n.depth - e.openStart, l = n.node(t).copy(e.content);
  for (let r = t - 1; r >= 0; r--)
    l = n.node(r).copy(Pe.from(l));
  return {
    start: l.resolveNoCache(e.openStart + t),
    end: l.resolveNoCache(l.content.size - e.openEnd - t)
  };
}
class Pr {
  /**
  @internal
  */
  constructor(n, t, a) {
    this.pos = n, this.path = t, this.parentOffset = a, this.depth = t.length / 3 - 1;
  }
  /**
  @internal
  */
  resolveDepth(n) {
    return n == null ? this.depth : n < 0 ? this.depth + n : n;
  }
  /**
  The parent node that the position points into. Note that even if
  a position points into a text node, that node is not considered
  the parent—text nodes are ‘flat’ in this model, and have no content.
  */
  get parent() {
    return this.node(this.depth);
  }
  /**
  The root node in which the position was resolved.
  */
  get doc() {
    return this.node(0);
  }
  /**
  The ancestor node at the given level. `p.node(p.depth)` is the
  same as `p.parent`.
  */
  node(n) {
    return this.path[this.resolveDepth(n) * 3];
  }
  /**
  The index into the ancestor at the given level. If this points
  at the 3rd node in the 2nd paragraph on the top level, for
  example, `p.index(0)` is 1 and `p.index(1)` is 2.
  */
  index(n) {
    return this.path[this.resolveDepth(n) * 3 + 1];
  }
  /**
  The index pointing after this position into the ancestor at the
  given level.
  */
  indexAfter(n) {
    return n = this.resolveDepth(n), this.index(n) + (n == this.depth && !this.textOffset ? 0 : 1);
  }
  /**
  The (absolute) position at the start of the node at the given
  level.
  */
  start(n) {
    return n = this.resolveDepth(n), n == 0 ? 0 : this.path[n * 3 - 1] + 1;
  }
  /**
  The (absolute) position at the end of the node at the given
  level.
  */
  end(n) {
    return n = this.resolveDepth(n), this.start(n) + this.node(n).content.size;
  }
  /**
  The (absolute) position directly before the wrapping node at the
  given level, or, when `depth` is `this.depth + 1`, the original
  position.
  */
  before(n) {
    if (n = this.resolveDepth(n), !n)
      throw new RangeError("There is no position before the top-level node");
    return n == this.depth + 1 ? this.pos : this.path[n * 3 - 1];
  }
  /**
  The (absolute) position directly after the wrapping node at the
  given level, or the original position when `depth` is `this.depth + 1`.
  */
  after(n) {
    if (n = this.resolveDepth(n), !n)
      throw new RangeError("There is no position after the top-level node");
    return n == this.depth + 1 ? this.pos : this.path[n * 3 - 1] + this.path[n * 3].nodeSize;
  }
  /**
  When this position points into a text node, this returns the
  distance between the position and the start of the text node.
  Will be zero for positions that point between nodes.
  */
  get textOffset() {
    return this.pos - this.path[this.path.length - 1];
  }
  /**
  Get the node directly after the position, if any. If the position
  points into a text node, only the part of that node after the
  position is returned.
  */
  get nodeAfter() {
    let n = this.parent, t = this.index(this.depth);
    if (t == n.childCount)
      return null;
    let a = this.pos - this.path[this.path.length - 1], l = n.child(t);
    return a ? n.child(t).cut(a) : l;
  }
  /**
  Get the node directly before the position, if any. If the
  position points into a text node, only the part of that node
  before the position is returned.
  */
  get nodeBefore() {
    let n = this.index(this.depth), t = this.pos - this.path[this.path.length - 1];
    return t ? this.parent.child(n).cut(0, t) : n == 0 ? null : this.parent.child(n - 1);
  }
  /**
  Get the position at the given index in the parent node at the
  given depth (which defaults to `this.depth`).
  */
  posAtIndex(n, t) {
    t = this.resolveDepth(t);
    let a = this.path[t * 3], l = t == 0 ? 0 : this.path[t * 3 - 1] + 1;
    for (let r = 0; r < n; r++)
      l += a.child(r).nodeSize;
    return l;
  }
  /**
  Get the marks at this position, factoring in the surrounding
  marks' [`inclusive`](https://prosemirror.net/docs/ref/#model.MarkSpec.inclusive) property. If the
  position is at the start of a non-empty node, the marks of the
  node after it (if any) are returned.
  */
  marks() {
    let n = this.parent, t = this.index();
    if (n.content.size == 0)
      return mt.none;
    if (this.textOffset)
      return n.child(t).marks;
    let a = n.maybeChild(t - 1), l = n.maybeChild(t);
    if (!a) {
      let i = a;
      a = l, l = i;
    }
    let r = a.marks;
    for (var o = 0; o < r.length; o++)
      r[o].type.spec.inclusive === !1 && (!l || !r[o].isInSet(l.marks)) && (r = r[o--].removeFromSet(r));
    return r;
  }
  /**
  Get the marks after the current position, if any, except those
  that are non-inclusive and not present at position `$end`. This
  is mostly useful for getting the set of marks to preserve after a
  deletion. Will return `null` if this position is at the end of
  its parent node or its parent node isn't a textblock (in which
  case no marks should be preserved).
  */
  marksAcross(n) {
    let t = this.parent.maybeChild(this.index());
    if (!t || !t.isInline)
      return null;
    let a = t.marks, l = n.parent.maybeChild(n.index());
    for (var r = 0; r < a.length; r++)
      a[r].type.spec.inclusive === !1 && (!l || !a[r].isInSet(l.marks)) && (a = a[r--].removeFromSet(a));
    return a;
  }
  /**
  The depth up to which this position and the given (non-resolved)
  position share the same parent nodes.
  */
  sharedDepth(n) {
    for (let t = this.depth; t > 0; t--)
      if (this.start(t) <= n && this.end(t) >= n)
        return t;
    return 0;
  }
  /**
  Returns a range based on the place where this position and the
  given position diverge around block content. If both point into
  the same textblock, for example, a range around that textblock
  will be returned. If they point into different blocks, the range
  around those blocks in their shared ancestor is returned. You can
  pass in an optional predicate that will be called with a parent
  node to see if a range into that parent is acceptable.
  */
  blockRange(n = this, t) {
    if (n.pos < this.pos)
      return n.blockRange(this);
    for (let a = this.depth - (this.parent.inlineContent || this.pos == n.pos ? 1 : 0); a >= 0; a--)
      if (n.pos <= this.end(a) && (!t || t(this.node(a))))
        return new ri(this, n, a);
    return null;
  }
  /**
  Query whether the given position shares the same parent node.
  */
  sameParent(n) {
    return this.pos - this.parentOffset == n.pos - n.parentOffset;
  }
  /**
  Return the greater of this and the given position.
  */
  max(n) {
    return n.pos > this.pos ? n : this;
  }
  /**
  Return the smaller of this and the given position.
  */
  min(n) {
    return n.pos < this.pos ? n : this;
  }
  /**
  @internal
  */
  toString() {
    let n = "";
    for (let t = 1; t <= this.depth; t++)
      n += (n ? "/" : "") + this.node(t).type.name + "_" + this.index(t - 1);
    return n + ":" + this.parentOffset;
  }
  /**
  @internal
  */
  static resolve(n, t) {
    if (!(t >= 0 && t <= n.content.size))
      throw new RangeError("Position " + t + " out of range");
    let a = [], l = 0, r = t;
    for (let o = n; ; ) {
      let { index: i, offset: s } = o.content.findIndex(r), d = r - s;
      if (a.push(o, i, l + s), !d || (o = o.child(i), o.isText))
        break;
      r = d - 1, l += s + 1;
    }
    return new Pr(t, a, r);
  }
  /**
  @internal
  */
  static resolveCached(n, t) {
    let a = xf.get(n);
    if (a)
      for (let r = 0; r < a.elts.length; r++) {
        let o = a.elts[r];
        if (o.pos == t)
          return o;
      }
    else
      xf.set(n, a = new WS());
    let l = a.elts[a.i] = Pr.resolve(n, t);
    return a.i = (a.i + 1) % qS, l;
  }
}
class WS {
  constructor() {
    this.elts = [], this.i = 0;
  }
}
const qS = 12, xf = /* @__PURE__ */ new WeakMap();
class ri {
  /**
  Construct a node range. `$from` and `$to` should point into the
  same node until at least the given `depth`, since a node range
  denotes an adjacent set of nodes in a single parent node.
  */
  constructor(n, t, a) {
    this.$from = n, this.$to = t, this.depth = a;
  }
  /**
  The position at the start of the range.
  */
  get start() {
    return this.$from.before(this.depth + 1);
  }
  /**
  The position at the end of the range.
  */
  get end() {
    return this.$to.after(this.depth + 1);
  }
  /**
  The parent node that the range points into.
  */
  get parent() {
    return this.$from.node(this.depth);
  }
  /**
  The start index of the range in the parent node.
  */
  get startIndex() {
    return this.$from.index(this.depth);
  }
  /**
  The end index of the range in the parent node.
  */
  get endIndex() {
    return this.$to.indexAfter(this.depth);
  }
}
const US = /* @__PURE__ */ Object.create(null);
let $a = class Dd {
  /**
  @internal
  */
  constructor(n, t, a, l = mt.none) {
    this.type = n, this.attrs = t, this.marks = l, this.content = a || Pe.empty;
  }
  /**
  The array of this node's child nodes.
  */
  get children() {
    return this.content.content;
  }
  /**
  The size of this node, as defined by the integer-based [indexing
  scheme](https://prosemirror.net/docs/guide/#doc.indexing). For text nodes, this is the
  amount of characters. For other leaf nodes, it is one. For
  non-leaf nodes, it is the size of the content plus two (the
  start and end token).
  */
  get nodeSize() {
    return this.isLeaf ? 1 : 2 + this.content.size;
  }
  /**
  The number of children that the node has.
  */
  get childCount() {
    return this.content.childCount;
  }
  /**
  Get the child node at the given index. Raises an error when the
  index is out of range.
  */
  child(n) {
    return this.content.child(n);
  }
  /**
  Get the child node at the given index, if it exists.
  */
  maybeChild(n) {
    return this.content.maybeChild(n);
  }
  /**
  Call `f` for every child node, passing the node, its offset
  into this parent node, and its index.
  */
  forEach(n) {
    this.content.forEach(n);
  }
  /**
  Invoke a callback for all descendant nodes recursively overlapping
  the given two positions that are relative to start of this
  node's content. This includes all ancestors of the nodes
  containing the two positions. The callback is invoked with the
  node, its position relative to the original node (method receiver),
  its parent node, and its child index. When the callback returns
  false for a given node, that node's children will not be
  recursed over. The last parameter can be used to specify a
  starting position to count from.
  */
  nodesBetween(n, t, a, l = 0) {
    this.content.nodesBetween(n, t, a, l, this);
  }
  /**
  Call the given callback for every descendant node. Doesn't
  descend into a node when the callback returns `false`.
  */
  descendants(n) {
    this.nodesBetween(0, this.content.size, n);
  }
  /**
  Concatenates all the text nodes found in this fragment and its
  children.
  */
  get textContent() {
    return this.isLeaf && this.type.spec.leafText ? this.type.spec.leafText(this) : this.textBetween(0, this.content.size, "");
  }
  /**
  Get all text between positions `from` and `to`. When
  `blockSeparator` is given, it will be inserted to separate text
  from different block nodes. If `leafText` is given, it'll be
  inserted for every non-text leaf node encountered, otherwise
  [`leafText`](https://prosemirror.net/docs/ref/#model.NodeSpec.leafText) will be used.
  */
  textBetween(n, t, a, l) {
    return this.content.textBetween(n, t, a, l);
  }
  /**
  Returns this node's first child, or `null` if there are no
  children.
  */
  get firstChild() {
    return this.content.firstChild;
  }
  /**
  Returns this node's last child, or `null` if there are no
  children.
  */
  get lastChild() {
    return this.content.lastChild;
  }
  /**
  Test whether two nodes represent the same piece of document.
  */
  eq(n) {
    return this == n || this.sameMarkup(n) && this.content.eq(n.content);
  }
  /**
  Compare the markup (type, attributes, and marks) of this node to
  those of another. Returns `true` if both have the same markup.
  */
  sameMarkup(n) {
    return this.hasMarkup(n.type, n.attrs, n.marks);
  }
  /**
  Check whether this node's markup correspond to the given type,
  attributes, and marks.
  */
  hasMarkup(n, t, a) {
    return this.type == n && ni(this.attrs, t || n.defaultAttrs || US) && mt.sameSet(this.marks, a || mt.none);
  }
  /**
  Create a new node with the same markup as this node, containing
  the given content (or empty, if no content is given).
  */
  copy(n = null) {
    return n == this.content ? this : new Dd(this.type, this.attrs, n, this.marks);
  }
  /**
  Create a copy of this node, with the given set of marks instead
  of the node's own marks.
  */
  mark(n) {
    return n == this.marks ? this : new Dd(this.type, this.attrs, this.content, n);
  }
  /**
  Create a copy of this node with only the content between the
  given positions. If `to` is not given, it defaults to the end of
  the node.
  */
  cut(n, t = this.content.size) {
    return n == 0 && t == this.content.size ? this : this.copy(this.content.cut(n, t));
  }
  /**
  Cut out the part of the document between the given positions, and
  return it as a `Slice` object.
  */
  slice(n, t = this.content.size, a = !1) {
    if (n == t)
      return Ye.empty;
    let l = this.resolve(n), r = this.resolve(t), o = a ? 0 : l.sharedDepth(t), i = l.start(o), d = l.node(o).content.cut(l.pos - i, r.pos - i);
    return new Ye(d, l.depth - o, r.depth - o);
  }
  /**
  Replace the part of the document between the given positions with
  the given slice. The slice must 'fit', meaning its open sides
  must be able to connect to the surrounding content, and its
  content nodes must be valid children for the node they are placed
  into. If any of this is violated, an error of type
  [`ReplaceError`](https://prosemirror.net/docs/ref/#model.ReplaceError) is thrown.
  */
  replace(n, t, a) {
    return HS(this.resolve(n), this.resolve(t), a);
  }
  /**
  Find the node directly after the given position.
  */
  nodeAt(n) {
    for (let t = this; ; ) {
      let { index: a, offset: l } = t.content.findIndex(n);
      if (t = t.maybeChild(a), !t)
        return null;
      if (l == n || t.isText)
        return t;
      n -= l + 1;
    }
  }
  /**
  Find the (direct) child node after the given offset, if any,
  and return it along with its index and offset relative to this
  node.
  */
  childAfter(n) {
    let { index: t, offset: a } = this.content.findIndex(n);
    return { node: this.content.maybeChild(t), index: t, offset: a };
  }
  /**
  Find the (direct) child node before the given offset, if any,
  and return it along with its index and offset relative to this
  node.
  */
  childBefore(n) {
    if (n == 0)
      return { node: null, index: 0, offset: 0 };
    let { index: t, offset: a } = this.content.findIndex(n);
    if (a < n)
      return { node: this.content.child(t), index: t, offset: a };
    let l = this.content.child(t - 1);
    return { node: l, index: t - 1, offset: a - l.nodeSize };
  }
  /**
  Resolve the given position in the document, returning an
  [object](https://prosemirror.net/docs/ref/#model.ResolvedPos) with information about its context.
  */
  resolve(n) {
    return Pr.resolveCached(this, n);
  }
  /**
  @internal
  */
  resolveNoCache(n) {
    return Pr.resolve(this, n);
  }
  /**
  Test whether a given mark or mark type occurs in this document
  between the two given positions.
  */
  rangeHasMark(n, t, a) {
    let l = !1;
    return t > n && this.nodesBetween(n, t, (r) => (a.isInSet(r.marks) && (l = !0), !l)), l;
  }
  /**
  True when this is a block (non-inline node)
  */
  get isBlock() {
    return this.type.isBlock;
  }
  /**
  True when this is a textblock node, a block node with inline
  content.
  */
  get isTextblock() {
    return this.type.isTextblock;
  }
  /**
  True when this node allows inline content.
  */
  get inlineContent() {
    return this.type.inlineContent;
  }
  /**
  True when this is an inline node (a text node or a node that can
  appear among text).
  */
  get isInline() {
    return this.type.isInline;
  }
  /**
  True when this is a text node.
  */
  get isText() {
    return this.type.isText;
  }
  /**
  True when this is a leaf node.
  */
  get isLeaf() {
    return this.type.isLeaf;
  }
  /**
  True when this is an atom, i.e. when it does not have directly
  editable content. This is usually the same as `isLeaf`, but can
  be configured with the [`atom` property](https://prosemirror.net/docs/ref/#model.NodeSpec.atom)
  on a node's spec (typically used when the node is displayed as
  an uneditable [node view](https://prosemirror.net/docs/ref/#view.NodeView)).
  */
  get isAtom() {
    return this.type.isAtom;
  }
  /**
  Return a string representation of this node for debugging
  purposes.
  */
  toString() {
    if (this.type.spec.toDebugString)
      return this.type.spec.toDebugString(this);
    let n = this.type.name;
    return this.content.size && (n += "(" + this.content.toStringInner() + ")"), Fg(this.marks, n);
  }
  /**
  Get the content match in this node at the given index.
  */
  contentMatchAt(n) {
    let t = this.type.contentMatch.matchFragment(this.content, 0, n);
    if (!t)
      throw new Error("Called contentMatchAt on a node with invalid content");
    return t;
  }
  /**
  Test whether replacing the range between `from` and `to` (by
  child index) with the given replacement fragment (which defaults
  to the empty fragment) would leave the node's content valid. You
  can optionally pass `start` and `end` indices into the
  replacement fragment.
  */
  canReplace(n, t, a = Pe.empty, l = 0, r = a.childCount) {
    let o = this.contentMatchAt(n).matchFragment(a, l, r), i = o && o.matchFragment(this.content, t);
    if (!i || !i.validEnd)
      return !1;
    for (let s = l; s < r; s++)
      if (!this.type.allowsMarks(a.child(s).marks))
        return !1;
    return !0;
  }
  /**
  Test whether replacing the range `from` to `to` (by index) with
  a node of the given type would leave the node's content valid.
  */
  canReplaceWith(n, t, a, l) {
    if (l && !this.type.allowsMarks(l))
      return !1;
    let r = this.contentMatchAt(n).matchType(a), o = r && r.matchFragment(this.content, t);
    return o ? o.validEnd : !1;
  }
  /**
  Test whether the given node's content could be appended to this
  node. If that node is empty, this will only return true if there
  is at least one node type that can appear in both nodes (to avoid
  merging completely incompatible nodes).
  */
  canAppend(n) {
    return n.content.size ? this.canReplace(this.childCount, this.childCount, n.content) : this.type.compatibleContent(n.type);
  }
  /**
  Check whether this node and its descendants conform to the
  schema, and raise an exception when they do not.
  */
  check() {
    this.type.checkContent(this.content), this.type.checkAttrs(this.attrs);
    let n = mt.none;
    for (let t = 0; t < this.marks.length; t++) {
      let a = this.marks[t];
      a.type.checkAttrs(a.attrs), n = a.addToSet(n);
    }
    if (!mt.sameSet(n, this.marks))
      throw new RangeError(`Invalid collection of marks for node ${this.type.name}: ${this.marks.map((t) => t.type.name)}`);
    this.content.forEach((t) => t.check());
  }
  /**
  Return a JSON-serializeable representation of this node.
  */
  toJSON() {
    let n = { type: this.type.name };
    for (let t in this.attrs) {
      n.attrs = this.attrs;
      break;
    }
    return this.content.size && (n.content = this.content.toJSON()), this.marks.length && (n.marks = this.marks.map((t) => t.toJSON())), n;
  }
  /**
  Deserialize a node from its JSON representation.
  */
  static fromJSON(n, t) {
    if (!t)
      throw new RangeError("Invalid input for Node.fromJSON");
    let a;
    if (t.marks) {
      if (!Array.isArray(t.marks))
        throw new RangeError("Invalid mark data for Node.fromJSON");
      a = t.marks.map(n.markFromJSON);
    }
    if (t.type == "text") {
      if (typeof t.text != "string")
        throw new RangeError("Invalid text node in JSON");
      return n.text(t.text, a);
    }
    let l = Pe.fromJSON(n, t.content), r = n.nodeType(t.type).create(t.attrs, l, a);
    return r.type.checkAttrs(r.attrs), r;
  }
};
$a.prototype.text = void 0;
class oi extends $a {
  /**
  @internal
  */
  constructor(n, t, a, l) {
    if (super(n, t, null, l), !a)
      throw new RangeError("Empty text nodes are not allowed");
    this.text = a;
  }
  toString() {
    return this.type.spec.toDebugString ? this.type.spec.toDebugString(this) : Fg(this.marks, JSON.stringify(this.text));
  }
  get textContent() {
    return this.text;
  }
  textBetween(n, t) {
    return this.text.slice(n, t);
  }
  get nodeSize() {
    return this.text.length;
  }
  mark(n) {
    return n == this.marks ? this : new oi(this.type, this.attrs, this.text, n);
  }
  withText(n) {
    return n == this.text ? this : new oi(this.type, this.attrs, n, this.marks);
  }
  cut(n = 0, t = this.text.length) {
    return n == 0 && t == this.text.length ? this : this.withText(this.text.slice(n, t));
  }
  eq(n) {
    return this.sameMarkup(n) && this.text == n.text;
  }
  toJSON() {
    let n = super.toJSON();
    return n.text = this.text, n;
  }
}
function Fg(e, n) {
  for (let t = e.length - 1; t >= 0; t--)
    n = e[t].type.name + "(" + n + ")";
  return n;
}
class dl {
  /**
  @internal
  */
  constructor(n) {
    this.validEnd = n, this.next = [], this.wrapCache = [];
  }
  /**
  @internal
  */
  static parse(n, t) {
    let a = new GS(n, t);
    if (a.next == null)
      return dl.empty;
    let l = Vg(a);
    a.next && a.err("Unexpected trailing text");
    let r = _S(QS(l));
    return e$(r, a), r;
  }
  /**
  Match a node type, returning a match after that node if
  successful.
  */
  matchType(n) {
    for (let t = 0; t < this.next.length; t++)
      if (this.next[t].type == n)
        return this.next[t].next;
    return null;
  }
  /**
  Try to match a fragment. Returns the resulting match when
  successful.
  */
  matchFragment(n, t = 0, a = n.childCount) {
    let l = this;
    for (let r = t; l && r < a; r++)
      l = l.matchType(n.child(r).type);
    return l;
  }
  /**
  @internal
  */
  get inlineContent() {
    return this.next.length != 0 && this.next[0].type.isInline;
  }
  /**
  Get the first matching node type at this match position that can
  be generated.
  */
  get defaultType() {
    for (let n = 0; n < this.next.length; n++) {
      let { type: t } = this.next[n];
      if (!(t.isText || t.hasRequiredAttrs()))
        return t;
    }
    return null;
  }
  /**
  @internal
  */
  compatible(n) {
    for (let t = 0; t < this.next.length; t++)
      for (let a = 0; a < n.next.length; a++)
        if (this.next[t].type == n.next[a].type)
          return !0;
    return !1;
  }
  /**
  Try to match the given fragment, and if that fails, see if it can
  be made to match by inserting nodes in front of it. When
  successful, return a fragment of inserted nodes (which may be
  empty if nothing had to be inserted). When `toEnd` is true, only
  return a fragment if the resulting match goes to the end of the
  content expression.
  */
  fillBefore(n, t = !1, a = 0) {
    let l = [this];
    function r(o, i) {
      let s = o.matchFragment(n, a);
      if (s && (!t || s.validEnd))
        return Pe.from(i.map((d) => d.createAndFill()));
      for (let d = 0; d < o.next.length; d++) {
        let { type: u, next: f } = o.next[d];
        if (!(u.isText || u.hasRequiredAttrs()) && l.indexOf(f) == -1) {
          l.push(f);
          let b = r(f, i.concat(u));
          if (b)
            return b;
        }
      }
      return null;
    }
    return r(this, []);
  }
  /**
  Find a set of wrapping node types that would allow a node of the
  given type to appear at this position. The result may be empty
  (when it fits directly) and will be null when no such wrapping
  exists.
  */
  findWrapping(n) {
    for (let a = 0; a < this.wrapCache.length; a += 2)
      if (this.wrapCache[a] == n)
        return this.wrapCache[a + 1];
    let t = this.computeWrapping(n);
    return this.wrapCache.push(n, t), t;
  }
  /**
  @internal
  */
  computeWrapping(n) {
    let t = /* @__PURE__ */ Object.create(null), a = [{ match: this, type: null, via: null }];
    for (; a.length; ) {
      let l = a.shift(), r = l.match;
      if (r.matchType(n)) {
        let o = [];
        for (let i = l; i.type; i = i.via)
          o.push(i.type);
        return o.reverse();
      }
      for (let o = 0; o < r.next.length; o++) {
        let { type: i, next: s } = r.next[o];
        !i.isLeaf && !i.hasRequiredAttrs() && !(i.name in t) && (!l.type || s.validEnd) && (a.push({ match: i.contentMatch, type: i, via: l }), t[i.name] = !0);
      }
    }
    return null;
  }
  /**
  The number of outgoing edges this node has in the finite
  automaton that describes the content expression.
  */
  get edgeCount() {
    return this.next.length;
  }
  /**
  Get the _n_​th outgoing edge from this node in the finite
  automaton that describes the content expression.
  */
  edge(n) {
    if (n >= this.next.length)
      throw new RangeError(`There's no ${n}th edge in this content match`);
    return this.next[n];
  }
  /**
  @internal
  */
  toString() {
    let n = [];
    function t(a) {
      n.push(a);
      for (let l = 0; l < a.next.length; l++)
        n.indexOf(a.next[l].next) == -1 && t(a.next[l].next);
    }
    return t(this), n.map((a, l) => {
      let r = l + (a.validEnd ? "*" : " ") + " ";
      for (let o = 0; o < a.next.length; o++)
        r += (o ? ", " : "") + a.next[o].type.name + "->" + n.indexOf(a.next[o].next);
      return r;
    }).join(`
`);
  }
}
dl.empty = new dl(!0);
class GS {
  constructor(n, t) {
    this.string = n, this.nodeTypes = t, this.inline = null, this.pos = 0, this.tokens = n.split(/\s*(?=\b|\W|$)/), this.tokens[this.tokens.length - 1] == "" && this.tokens.pop(), this.tokens[0] == "" && this.tokens.shift();
  }
  get next() {
    return this.tokens[this.pos];
  }
  eat(n) {
    return this.next == n && (this.pos++ || !0);
  }
  err(n) {
    throw new SyntaxError(n + " (in content expression '" + this.string + "')");
  }
}
function Vg(e) {
  let n = [];
  do
    n.push(KS(e));
  while (e.eat("|"));
  return n.length == 1 ? n[0] : { type: "choice", exprs: n };
}
function KS(e) {
  let n = [];
  do
    n.push(YS(e));
  while (e.next && e.next != ")" && e.next != "|");
  return n.length == 1 ? n[0] : { type: "seq", exprs: n };
}
function YS(e) {
  let n = XS(e);
  for (; ; )
    if (e.eat("+"))
      n = { type: "plus", expr: n };
    else if (e.eat("*"))
      n = { type: "star", expr: n };
    else if (e.eat("?"))
      n = { type: "opt", expr: n };
    else if (e.eat("{"))
      n = JS(e, n);
    else
      break;
  return n;
}
function yf(e) {
  /\D/.test(e.next) && e.err("Expected number, got '" + e.next + "'");
  let n = Number(e.next);
  return e.pos++, n;
}
function JS(e, n) {
  let t = yf(e), a = t;
  return e.eat(",") && (e.next != "}" ? a = yf(e) : a = -1), e.eat("}") || e.err("Unclosed braced range"), { type: "range", min: t, max: a, expr: n };
}
function ZS(e, n) {
  let t = e.nodeTypes, a = t[n];
  if (a)
    return [a];
  let l = [];
  for (let r in t) {
    let o = t[r];
    o.isInGroup(n) && l.push(o);
  }
  return l.length == 0 && e.err("No node type or group '" + n + "' found"), l;
}
function XS(e) {
  if (e.eat("(")) {
    let n = Vg(e);
    return e.eat(")") || e.err("Missing closing paren"), n;
  } else if (/\W/.test(e.next))
    e.err("Unexpected token '" + e.next + "'");
  else {
    let n = ZS(e, e.next).map((t) => (e.inline == null ? e.inline = t.isInline : e.inline != t.isInline && e.err("Mixing inline and block content"), { type: "name", value: t }));
    return e.pos++, n.length == 1 ? n[0] : { type: "choice", exprs: n };
  }
}
function QS(e) {
  let n = [[]];
  return l(r(e, 0), t()), n;
  function t() {
    return n.push([]) - 1;
  }
  function a(o, i, s) {
    let d = { term: s, to: i };
    return n[o].push(d), d;
  }
  function l(o, i) {
    o.forEach((s) => s.to = i);
  }
  function r(o, i) {
    if (o.type == "choice")
      return o.exprs.reduce((s, d) => s.concat(r(d, i)), []);
    if (o.type == "seq")
      for (let s = 0; ; s++) {
        let d = r(o.exprs[s], i);
        if (s == o.exprs.length - 1)
          return d;
        l(d, i = t());
      }
    else if (o.type == "star") {
      let s = t();
      return a(i, s), l(r(o.expr, s), s), [a(s)];
    } else if (o.type == "plus") {
      let s = t();
      return l(r(o.expr, i), s), l(r(o.expr, s), s), [a(s)];
    } else {
      if (o.type == "opt")
        return [a(i)].concat(r(o.expr, i));
      if (o.type == "range") {
        let s = i;
        for (let d = 0; d < o.min; d++) {
          let u = t();
          l(r(o.expr, s), u), s = u;
        }
        if (o.max == -1)
          l(r(o.expr, s), s);
        else
          for (let d = o.min; d < o.max; d++) {
            let u = t();
            a(s, u), l(r(o.expr, s), u), s = u;
          }
        return [a(s)];
      } else {
        if (o.type == "name")
          return [a(i, void 0, o.value)];
        throw new Error("Unknown expr type");
      }
    }
  }
}
function Ng(e, n) {
  return n - e;
}
function kf(e, n) {
  let t = [];
  return a(n), t.sort(Ng);
  function a(l) {
    let r = e[l];
    if (r.length == 1 && !r[0].term)
      return a(r[0].to);
    t.push(l);
    for (let o = 0; o < r.length; o++) {
      let { term: i, to: s } = r[o];
      !i && t.indexOf(s) == -1 && a(s);
    }
  }
}
function _S(e) {
  let n = /* @__PURE__ */ Object.create(null);
  return t(kf(e, 0));
  function t(a) {
    let l = [];
    a.forEach((o) => {
      e[o].forEach(({ term: i, to: s }) => {
        if (!i)
          return;
        let d;
        for (let u = 0; u < l.length; u++)
          l[u][0] == i && (d = l[u][1]);
        kf(e, s).forEach((u) => {
          d || l.push([i, d = []]), d.indexOf(u) == -1 && d.push(u);
        });
      });
    });
    let r = n[a.join(",")] = new dl(a.indexOf(e.length - 1) > -1);
    for (let o = 0; o < l.length; o++) {
      let i = l[o][1].sort(Ng);
      r.next.push({ type: l[o][0], next: n[i.join(",")] || t(i) });
    }
    return r;
  }
}
function e$(e, n) {
  for (let t = 0, a = [e]; t < a.length; t++) {
    let l = a[t], r = !l.validEnd, o = [];
    for (let i = 0; i < l.next.length; i++) {
      let { type: s, next: d } = l.next[i];
      o.push(s.name), r && !(s.isText || s.hasRequiredAttrs()) && (r = !1), a.indexOf(d) == -1 && a.push(d);
    }
    r && n.err("Only non-generatable nodes (" + o.join(", ") + ") in a required position (see https://prosemirror.net/docs/guide/#generatable)");
  }
}
function Hg(e) {
  let n = /* @__PURE__ */ Object.create(null);
  for (let t in e) {
    let a = e[t];
    if (!a.hasDefault)
      return null;
    n[t] = a.default;
  }
  return n;
}
function jg(e, n) {
  let t = /* @__PURE__ */ Object.create(null);
  for (let a in e) {
    let l = n && n[a];
    if (l === void 0) {
      let r = e[a];
      if (r.hasDefault)
        l = r.default;
      else
        throw new RangeError("No value supplied for attribute " + a);
    }
    t[a] = l;
  }
  return t;
}
function Wg(e, n, t, a) {
  for (let l in n)
    if (!(l in e))
      throw new RangeError(`Unsupported attribute ${l} for ${t} of type ${l}`);
  for (let l in e) {
    let r = e[l];
    r.validate && r.validate(n[l]);
  }
}
function qg(e, n) {
  let t = /* @__PURE__ */ Object.create(null);
  if (n)
    for (let a in n)
      t[a] = new n$(e, a, n[a]);
  return t;
}
let wf = class Ug {
  /**
  @internal
  */
  constructor(n, t, a) {
    this.name = n, this.schema = t, this.spec = a, this.markSet = null, this.groups = a.group ? a.group.split(" ") : [], this.attrs = qg(n, a.attrs), this.defaultAttrs = Hg(this.attrs), this.contentMatch = null, this.inlineContent = null, this.isBlock = !(a.inline || n == "text"), this.isText = n == "text";
  }
  /**
  True if this is an inline type.
  */
  get isInline() {
    return !this.isBlock;
  }
  /**
  True if this is a textblock type, a block that contains inline
  content.
  */
  get isTextblock() {
    return this.isBlock && this.inlineContent;
  }
  /**
  True for node types that allow no content.
  */
  get isLeaf() {
    return this.contentMatch == dl.empty;
  }
  /**
  True when this node is an atom, i.e. when it does not have
  directly editable content.
  */
  get isAtom() {
    return this.isLeaf || !!this.spec.atom;
  }
  /**
  Return true when this node type is part of the given
  [group](https://prosemirror.net/docs/ref/#model.NodeSpec.group).
  */
  isInGroup(n) {
    return this.groups.indexOf(n) > -1;
  }
  /**
  The node type's [whitespace](https://prosemirror.net/docs/ref/#model.NodeSpec.whitespace) option.
  */
  get whitespace() {
    return this.spec.whitespace || (this.spec.code ? "pre" : "normal");
  }
  /**
  Tells you whether this node type has any required attributes.
  */
  hasRequiredAttrs() {
    for (let n in this.attrs)
      if (this.attrs[n].isRequired)
        return !0;
    return !1;
  }
  /**
  Indicates whether this node allows some of the same content as
  the given node type.
  */
  compatibleContent(n) {
    return this == n || this.contentMatch.compatible(n.contentMatch);
  }
  /**
  @internal
  */
  computeAttrs(n) {
    return !n && this.defaultAttrs ? this.defaultAttrs : jg(this.attrs, n);
  }
  /**
  Create a `Node` of this type. The given attributes are
  checked and defaulted (you can pass `null` to use the type's
  defaults entirely, if no required attributes exist). `content`
  may be a `Fragment`, a node, an array of nodes, or
  `null`. Similarly `marks` may be `null` to default to the empty
  set of marks.
  */
  create(n = null, t, a) {
    if (this.isText)
      throw new Error("NodeType.create can't construct text nodes");
    return new $a(this, this.computeAttrs(n), Pe.from(t), mt.setFrom(a));
  }
  /**
  Like [`create`](https://prosemirror.net/docs/ref/#model.NodeType.create), but check the given content
  against the node type's content restrictions, and throw an error
  if it doesn't match.
  */
  createChecked(n = null, t, a) {
    return t = Pe.from(t), this.checkContent(t), new $a(this, this.computeAttrs(n), t, mt.setFrom(a));
  }
  /**
  Like [`create`](https://prosemirror.net/docs/ref/#model.NodeType.create), but see if it is
  necessary to add nodes to the start or end of the given fragment
  to make it fit the node. If no fitting wrapping can be found,
  return null. Note that, due to the fact that required nodes can
  always be created, this will always succeed if you pass null or
  `Fragment.empty` as content.
  */
  createAndFill(n = null, t, a) {
    if (n = this.computeAttrs(n), t = Pe.from(t), t.size) {
      let o = this.contentMatch.fillBefore(t);
      if (!o)
        return null;
      t = o.append(t);
    }
    let l = this.contentMatch.matchFragment(t), r = l && l.fillBefore(Pe.empty, !0);
    return r ? new $a(this, n, t.append(r), mt.setFrom(a)) : null;
  }
  /**
  Returns true if the given fragment is valid content for this node
  type.
  */
  validContent(n) {
    let t = this.contentMatch.matchFragment(n);
    if (!t || !t.validEnd)
      return !1;
    for (let a = 0; a < n.childCount; a++)
      if (!this.allowsMarks(n.child(a).marks))
        return !1;
    return !0;
  }
  /**
  Throws a RangeError if the given fragment is not valid content for this
  node type.
  @internal
  */
  checkContent(n) {
    if (!this.validContent(n))
      throw new RangeError(`Invalid content for node ${this.name}: ${n.toString().slice(0, 50)}`);
  }
  /**
  @internal
  */
  checkAttrs(n) {
    Wg(this.attrs, n, "node", this.name);
  }
  /**
  Check whether the given mark type is allowed in this node.
  */
  allowsMarkType(n) {
    return this.markSet == null || this.markSet.indexOf(n) > -1;
  }
  /**
  Test whether the given set of marks are allowed in this node.
  */
  allowsMarks(n) {
    if (this.markSet == null)
      return !0;
    for (let t = 0; t < n.length; t++)
      if (!this.allowsMarkType(n[t].type))
        return !1;
    return !0;
  }
  /**
  Removes the marks that are not allowed in this node from the given set.
  */
  allowedMarks(n) {
    if (this.markSet == null)
      return n;
    let t;
    for (let a = 0; a < n.length; a++)
      this.allowsMarkType(n[a].type) ? t && t.push(n[a]) : t || (t = n.slice(0, a));
    return t ? t.length ? t : mt.none : n;
  }
  /**
  @internal
  */
  static compile(n, t) {
    let a = /* @__PURE__ */ Object.create(null);
    n.forEach((r, o) => a[r] = new Ug(r, t, o));
    let l = t.spec.topNode || "doc";
    if (!a[l])
      throw new RangeError("Schema is missing its top node type ('" + l + "')");
    if (!a.text)
      throw new RangeError("Every schema needs a 'text' type");
    for (let r in a.text.attrs)
      throw new RangeError("The text node type should not have attributes");
    return a;
  }
};
function t$(e, n, t) {
  let a = t.split("|");
  return (l) => {
    let r = l === null ? "null" : typeof l;
    if (a.indexOf(r) < 0)
      throw new RangeError(`Expected value of type ${a} for attribute ${n} on type ${e}, got ${r}`);
  };
}
class n$ {
  constructor(n, t, a) {
    this.hasDefault = Object.prototype.hasOwnProperty.call(a, "default"), this.default = a.default, this.validate = typeof a.validate == "string" ? t$(n, t, a.validate) : a.validate;
  }
  get isRequired() {
    return !this.hasDefault;
  }
}
class Xi {
  /**
  @internal
  */
  constructor(n, t, a, l) {
    this.name = n, this.rank = t, this.schema = a, this.spec = l, this.attrs = qg(n, l.attrs), this.excluded = null;
    let r = Hg(this.attrs);
    this.instance = r ? new mt(this, r) : null;
  }
  /**
  Create a mark of this type. `attrs` may be `null` or an object
  containing only some of the mark's attributes. The others, if
  they have defaults, will be added.
  */
  create(n = null) {
    return !n && this.instance ? this.instance : new mt(this, jg(this.attrs, n));
  }
  /**
  @internal
  */
  static compile(n, t) {
    let a = /* @__PURE__ */ Object.create(null), l = 0;
    return n.forEach((r, o) => a[r] = new Xi(r, l++, t, o)), a;
  }
  /**
  When there is a mark of this type in the given set, a new set
  without it is returned. Otherwise, the input set is returned.
  */
  removeFromSet(n) {
    for (var t = 0; t < n.length; t++)
      n[t].type == this && (n = n.slice(0, t).concat(n.slice(t + 1)), t--);
    return n;
  }
  /**
  Tests whether there is a mark of this type in the given set.
  */
  isInSet(n) {
    for (let t = 0; t < n.length; t++)
      if (n[t].type == this)
        return n[t];
  }
  /**
  @internal
  */
  checkAttrs(n) {
    Wg(this.attrs, n, "mark", this.name);
  }
  /**
  Queries whether a given mark type is
  [excluded](https://prosemirror.net/docs/ref/#model.MarkSpec.excludes) by this one.
  */
  excludes(n) {
    return this.excluded.indexOf(n) > -1;
  }
}
class Gg {
  /**
  Construct a schema from a schema [specification](https://prosemirror.net/docs/ref/#model.SchemaSpec).
  */
  constructor(n) {
    this.linebreakReplacement = null, this.cached = /* @__PURE__ */ Object.create(null);
    let t = this.spec = {};
    for (let l in n)
      t[l] = n[l];
    t.nodes = jt.from(n.nodes), t.marks = jt.from(n.marks || {}), this.nodes = wf.compile(this.spec.nodes, this), this.marks = Xi.compile(this.spec.marks, this);
    let a = /* @__PURE__ */ Object.create(null);
    for (let l in this.nodes) {
      if (l in this.marks)
        throw new RangeError(l + " can not be both a node and a mark");
      let r = this.nodes[l], o = r.spec.content || "", i = r.spec.marks;
      if (r.contentMatch = a[o] || (a[o] = dl.parse(o, this.nodes)), r.inlineContent = r.contentMatch.inlineContent, r.spec.linebreakReplacement) {
        if (this.linebreakReplacement)
          throw new RangeError("Multiple linebreak nodes defined");
        if (!r.isInline || !r.isLeaf)
          throw new RangeError("Linebreak replacement nodes must be inline leaf nodes");
        this.linebreakReplacement = r;
      }
      r.markSet = i == "_" ? null : i ? Cf(this, i.split(" ")) : i == "" || !r.inlineContent ? [] : null;
    }
    for (let l in this.marks) {
      let r = this.marks[l], o = r.spec.excludes;
      r.excluded = o == null ? [r] : o == "" ? [] : Cf(this, o.split(" "));
    }
    this.nodeFromJSON = (l) => $a.fromJSON(this, l), this.markFromJSON = (l) => mt.fromJSON(this, l), this.topNodeType = this.nodes[this.spec.topNode || "doc"], this.cached.wrappings = /* @__PURE__ */ Object.create(null);
  }
  /**
  Create a node in this schema. The `type` may be a string or a
  `NodeType` instance. Attributes will be extended with defaults,
  `content` may be a `Fragment`, `null`, a `Node`, or an array of
  nodes.
  */
  node(n, t = null, a, l) {
    if (typeof n == "string")
      n = this.nodeType(n);
    else if (n instanceof wf) {
      if (n.schema != this)
        throw new RangeError("Node type from different schema used (" + n.name + ")");
    } else throw new RangeError("Invalid node type: " + n);
    return n.createChecked(t, a, l);
  }
  /**
  Create a text node in the schema. Empty text nodes are not
  allowed.
  */
  text(n, t) {
    let a = this.nodes.text;
    return new oi(a, a.defaultAttrs, n, mt.setFrom(t));
  }
  /**
  Create a mark with the given type and attributes.
  */
  mark(n, t) {
    return typeof n == "string" && (n = this.marks[n]), n.create(t);
  }
  /**
  @internal
  */
  nodeType(n) {
    let t = this.nodes[n];
    if (!t)
      throw new RangeError("Unknown node type: " + n);
    return t;
  }
}
function Cf(e, n) {
  let t = [];
  for (let a = 0; a < n.length; a++) {
    let l = n[a], r = e.marks[l], o = r;
    if (r)
      t.push(r);
    else
      for (let i in e.marks) {
        let s = e.marks[i];
        (l == "_" || s.spec.group && s.spec.group.split(" ").indexOf(l) > -1) && t.push(o = s);
      }
    if (!o)
      throw new SyntaxError("Unknown mark type: '" + n[a] + "'");
  }
  return t;
}
function a$(e) {
  return e.tag != null;
}
function l$(e) {
  return e.style != null;
}
class Ia {
  /**
  Create a parser that targets the given schema, using the given
  parsing rules.
  */
  constructor(n, t) {
    this.schema = n, this.rules = t, this.tags = [], this.styles = [];
    let a = this.matchedStyles = [];
    t.forEach((l) => {
      if (a$(l))
        this.tags.push(l);
      else if (l$(l)) {
        let r = /[^=]*/.exec(l.style)[0];
        a.indexOf(r) < 0 && a.push(r), this.styles.push(l);
      }
    }), this.normalizeLists = !this.tags.some((l) => {
      if (!/^(ul|ol)\b/.test(l.tag) || !l.node)
        return !1;
      let r = n.nodes[l.node];
      return r.contentMatch.matchType(r);
    });
  }
  /**
  Parse a document from the content of a DOM node.
  */
  parse(n, t = {}) {
    let a = new $f(this, t, !1);
    return a.addAll(n, mt.none, t.from, t.to), a.finish();
  }
  /**
  Parses the content of the given DOM node, like
  [`parse`](https://prosemirror.net/docs/ref/#model.DOMParser.parse), and takes the same set of
  options. But unlike that method, which produces a whole node,
  this one returns a slice that is open at the sides, meaning that
  the schema constraints aren't applied to the start of nodes to
  the left of the input and the end of nodes at the end.
  */
  parseSlice(n, t = {}) {
    let a = new $f(this, t, !0);
    return a.addAll(n, mt.none, t.from, t.to), Ye.maxOpen(a.finish());
  }
  /**
  @internal
  */
  matchTag(n, t, a) {
    for (let l = a ? this.tags.indexOf(a) + 1 : 0; l < this.tags.length; l++) {
      let r = this.tags[l];
      if (i$(n, r.tag) && (r.namespace === void 0 || n.namespaceURI == r.namespace) && (!r.context || t.matchesContext(r.context))) {
        if (r.getAttrs) {
          let o = r.getAttrs(n);
          if (o === !1)
            continue;
          r.attrs = o || void 0;
        }
        return r;
      }
    }
  }
  /**
  @internal
  */
  matchStyle(n, t, a, l) {
    for (let r = l ? this.styles.indexOf(l) + 1 : 0; r < this.styles.length; r++) {
      let o = this.styles[r], i = o.style;
      if (!(i.indexOf(n) != 0 || o.context && !a.matchesContext(o.context) || // Test that the style string either precisely matches the prop,
      // or has an '=' sign after the prop, followed by the given
      // value.
      i.length > n.length && (i.charCodeAt(n.length) != 61 || i.slice(n.length + 1) != t))) {
        if (o.getAttrs) {
          let s = o.getAttrs(t);
          if (s === !1)
            continue;
          o.attrs = s || void 0;
        }
        return o;
      }
    }
  }
  /**
  @internal
  */
  static schemaRules(n) {
    let t = [];
    function a(l) {
      let r = l.priority == null ? 50 : l.priority, o = 0;
      for (; o < t.length; o++) {
        let i = t[o];
        if ((i.priority == null ? 50 : i.priority) < r)
          break;
      }
      t.splice(o, 0, l);
    }
    for (let l in n.marks) {
      let r = n.marks[l].spec.parseDOM;
      r && r.forEach((o) => {
        a(o = If(o)), o.mark || o.ignore || o.clearMark || (o.mark = l);
      });
    }
    for (let l in n.nodes) {
      let r = n.nodes[l].spec.parseDOM;
      r && r.forEach((o) => {
        a(o = If(o)), o.node || o.ignore || o.mark || (o.node = l);
      });
    }
    return t;
  }
  /**
  Construct a DOM parser using the parsing rules listed in a
  schema's [node specs](https://prosemirror.net/docs/ref/#model.NodeSpec.parseDOM), reordered by
  [priority](https://prosemirror.net/docs/ref/#model.GenericParseRule.priority).
  */
  static fromSchema(n) {
    return n.cached.domParser || (n.cached.domParser = new Ia(n, Ia.schemaRules(n)));
  }
}
const Kg = {
  address: !0,
  article: !0,
  aside: !0,
  blockquote: !0,
  canvas: !0,
  dd: !0,
  div: !0,
  dl: !0,
  fieldset: !0,
  figcaption: !0,
  figure: !0,
  footer: !0,
  form: !0,
  h1: !0,
  h2: !0,
  h3: !0,
  h4: !0,
  h5: !0,
  h6: !0,
  header: !0,
  hgroup: !0,
  hr: !0,
  li: !0,
  noscript: !0,
  ol: !0,
  output: !0,
  p: !0,
  pre: !0,
  section: !0,
  table: !0,
  tfoot: !0,
  ul: !0
}, r$ = {
  head: !0,
  noscript: !0,
  object: !0,
  script: !0,
  style: !0,
  title: !0
}, Yg = { ol: !0, ul: !0 }, Fr = 1, zd = 2, xr = 4;
function Sf(e, n, t) {
  return n != null ? (n ? Fr : 0) | (n === "full" ? zd : 0) : e && e.whitespace == "pre" ? Fr | zd : t & ~xr;
}
class xo {
  constructor(n, t, a, l, r, o) {
    this.type = n, this.attrs = t, this.marks = a, this.solid = l, this.options = o, this.content = [], this.activeMarks = mt.none, this.match = r || (o & xr ? null : n.contentMatch);
  }
  findWrapping(n) {
    if (!this.match) {
      if (!this.type)
        return [];
      let t = this.type.contentMatch.fillBefore(Pe.from(n));
      if (t)
        this.match = this.type.contentMatch.matchFragment(t);
      else {
        let a = this.type.contentMatch, l;
        return (l = a.findWrapping(n.type)) ? (this.match = a, l) : null;
      }
    }
    return this.match.findWrapping(n.type);
  }
  finish(n) {
    if (!(this.options & Fr)) {
      let a = this.content[this.content.length - 1], l;
      if (a && a.isText && (l = /[ \t\r\n\u000c]+$/.exec(a.text))) {
        let r = a;
        a.text.length == l[0].length ? this.content.pop() : this.content[this.content.length - 1] = r.withText(r.text.slice(0, r.text.length - l[0].length));
      }
    }
    let t = Pe.from(this.content);
    return !n && this.match && (t = t.append(this.match.fillBefore(Pe.empty, !0))), this.type ? this.type.create(this.attrs, t, this.marks) : t;
  }
  inlineContext(n) {
    return this.type ? this.type.inlineContent : this.content.length ? this.content[0].isInline : n.parentNode && !Kg.hasOwnProperty(n.parentNode.nodeName.toLowerCase());
  }
}
class $f {
  constructor(n, t, a) {
    this.parser = n, this.options = t, this.isOpen = a, this.open = 0, this.localPreserveWS = !1;
    let l = t.topNode, r, o = Sf(null, t.preserveWhitespace, 0) | (a ? xr : 0);
    l ? r = new xo(l.type, l.attrs, mt.none, !0, t.topMatch || l.type.contentMatch, o) : a ? r = new xo(null, null, mt.none, !0, null, o) : r = new xo(n.schema.topNodeType, null, mt.none, !0, null, o), this.nodes = [r], this.find = t.findPositions, this.needsBlock = !1;
  }
  get top() {
    return this.nodes[this.open];
  }
  // Add a DOM node to the content. Text is inserted as text node,
  // otherwise, the node is passed to `addElement` or, if it has a
  // `style` attribute, `addElementWithStyles`.
  addDOM(n, t) {
    n.nodeType == 3 ? this.addTextNode(n, t) : n.nodeType == 1 && this.addElement(n, t);
  }
  addTextNode(n, t) {
    let a = n.nodeValue, l = this.top, r = l.options & zd ? "full" : this.localPreserveWS || (l.options & Fr) > 0, { schema: o } = this.parser;
    if (r === "full" || l.inlineContext(n) || /[^ \t\r\n\u000c]/.test(a)) {
      if (r)
        if (r === "full")
          a = a.replace(/\r\n?/g, `
`);
        else if (o.linebreakReplacement && /[\r\n]/.test(a) && this.top.findWrapping(o.linebreakReplacement.create())) {
          let i = a.split(/\r?\n|\r/);
          for (let s = 0; s < i.length; s++)
            s && this.insertNode(o.linebreakReplacement.create(), t, !0), i[s] && this.insertNode(o.text(i[s]), t, !/\S/.test(i[s]));
          a = "";
        } else
          a = a.replace(/\r?\n|\r/g, " ");
      else if (a = a.replace(/[ \t\r\n\u000c]+/g, " "), /^[ \t\r\n\u000c]/.test(a) && this.open == this.nodes.length - 1) {
        let i = l.content[l.content.length - 1], s = n.previousSibling;
        (!i || s && s.nodeName == "BR" || i.isText && /[ \t\r\n\u000c]$/.test(i.text)) && (a = a.slice(1));
      }
      a && this.insertNode(o.text(a), t, !/\S/.test(a)), this.findInText(n);
    } else
      this.findInside(n);
  }
  // Try to find a handler for the given tag and use that to parse. If
  // none is found, the element's content nodes are added directly.
  addElement(n, t, a) {
    let l = this.localPreserveWS, r = this.top;
    (n.tagName == "PRE" || /pre/.test(n.style && n.style.whiteSpace)) && (this.localPreserveWS = !0);
    let o = n.nodeName.toLowerCase(), i;
    Yg.hasOwnProperty(o) && this.parser.normalizeLists && o$(n);
    let s = this.options.ruleFromNode && this.options.ruleFromNode(n) || (i = this.parser.matchTag(n, this, a));
    e: if (s ? s.ignore : r$.hasOwnProperty(o))
      this.findInside(n), this.ignoreFallback(n, t);
    else if (!s || s.skip || s.closeParent) {
      s && s.closeParent ? this.open = Math.max(0, this.open - 1) : s && s.skip.nodeType && (n = s.skip);
      let d, u = this.needsBlock;
      if (Kg.hasOwnProperty(o))
        r.content.length && r.content[0].isInline && this.open && (this.open--, r = this.top), d = !0, r.type || (this.needsBlock = !0);
      else if (!n.firstChild) {
        this.leafFallback(n, t);
        break e;
      }
      let f = s && s.skip ? t : this.readStyles(n, t);
      f && this.addAll(n, f), d && this.sync(r), this.needsBlock = u;
    } else {
      let d = this.readStyles(n, t);
      d && this.addElementByRule(n, s, d, s.consuming === !1 ? i : void 0);
    }
    this.localPreserveWS = l;
  }
  // Called for leaf DOM nodes that would otherwise be ignored
  leafFallback(n, t) {
    n.nodeName == "BR" && this.top.type && this.top.type.inlineContent && this.addTextNode(n.ownerDocument.createTextNode(`
`), t);
  }
  // Called for ignored nodes
  ignoreFallback(n, t) {
    n.nodeName == "BR" && (!this.top.type || !this.top.type.inlineContent) && this.findPlace(this.parser.schema.text("-"), t, !0);
  }
  // Run any style parser associated with the node's styles. Either
  // return an updated array of marks, or null to indicate some of the
  // styles had a rule with `ignore` set.
  readStyles(n, t) {
    let a = n.style;
    if (a && a.length)
      for (let l = 0; l < this.parser.matchedStyles.length; l++) {
        let r = this.parser.matchedStyles[l], o = a.getPropertyValue(r);
        if (o)
          for (let i = void 0; ; ) {
            let s = this.parser.matchStyle(r, o, this, i);
            if (!s)
              break;
            if (s.ignore)
              return null;
            if (s.clearMark ? t = t.filter((d) => !s.clearMark(d)) : t = t.concat(this.parser.schema.marks[s.mark].create(s.attrs)), s.consuming === !1)
              i = s;
            else
              break;
          }
      }
    return t;
  }
  // Look up a handler for the given node. If none are found, return
  // false. Otherwise, apply it, use its return value to drive the way
  // the node's content is wrapped, and return true.
  addElementByRule(n, t, a, l) {
    let r, o;
    if (t.node)
      if (o = this.parser.schema.nodes[t.node], o.isLeaf)
        this.insertNode(o.create(t.attrs), a, n.nodeName == "BR") || this.leafFallback(n, a);
      else {
        let s = this.enter(o, t.attrs || null, a, t.preserveWhitespace);
        s && (r = !0, a = s);
      }
    else {
      let s = this.parser.schema.marks[t.mark];
      a = a.concat(s.create(t.attrs));
    }
    let i = this.top;
    if (o && o.isLeaf)
      this.findInside(n);
    else if (l)
      this.addElement(n, a, l);
    else if (t.getContent)
      this.findInside(n), t.getContent(n, this.parser.schema).forEach((s) => this.insertNode(s, a, !1));
    else {
      let s = n;
      typeof t.contentElement == "string" ? s = n.querySelector(t.contentElement) : typeof t.contentElement == "function" ? s = t.contentElement(n) : t.contentElement && (s = t.contentElement), this.findAround(n, s, !0), this.addAll(s, a), this.findAround(n, s, !1);
    }
    r && this.sync(i) && this.open--;
  }
  // Add all child nodes between `startIndex` and `endIndex` (or the
  // whole node, if not given). If `sync` is passed, use it to
  // synchronize after every block element.
  addAll(n, t, a, l) {
    let r = a || 0;
    for (let o = a ? n.childNodes[a] : n.firstChild, i = l == null ? null : n.childNodes[l]; o != i; o = o.nextSibling, ++r)
      this.findAtPoint(n, r), this.addDOM(o, t);
    this.findAtPoint(n, r);
  }
  // Try to find a way to fit the given node type into the current
  // context. May add intermediate wrappers and/or leave non-solid
  // nodes that we're in.
  findPlace(n, t, a) {
    let l, r;
    for (let o = this.open, i = 0; o >= 0; o--) {
      let s = this.nodes[o], d = s.findWrapping(n);
      if (d && (!l || l.length > d.length + i) && (l = d, r = s, !d.length))
        break;
      if (s.solid) {
        if (a)
          break;
        i += 2;
      }
    }
    if (!l)
      return null;
    this.sync(r);
    for (let o = 0; o < l.length; o++)
      t = this.enterInner(l[o], null, t, !1);
    return t;
  }
  // Try to insert the given node, adjusting the context when needed.
  insertNode(n, t, a) {
    if (n.isInline && this.needsBlock && !this.top.type) {
      let r = this.textblockFromContext();
      r && (t = this.enterInner(r, null, t));
    }
    let l = this.findPlace(n, t, a);
    if (l) {
      this.closeExtra();
      let r = this.top;
      r.match && (r.match = r.match.matchType(n.type));
      let o = mt.none;
      for (let i of l.concat(n.marks))
        (r.type ? r.type.allowsMarkType(i.type) : Tf(i.type, n.type)) && (o = i.addToSet(o));
      return r.content.push(n.mark(o)), !0;
    }
    return !1;
  }
  // Try to start a node of the given type, adjusting the context when
  // necessary.
  enter(n, t, a, l) {
    let r = this.findPlace(n.create(t), a, !1);
    return r && (r = this.enterInner(n, t, a, !0, l)), r;
  }
  // Open a node of the given type
  enterInner(n, t, a, l = !1, r) {
    this.closeExtra();
    let o = this.top;
    o.match = o.match && o.match.matchType(n);
    let i = Sf(n, r, o.options);
    o.options & xr && o.content.length == 0 && (i |= xr);
    let s = mt.none;
    return a = a.filter((d) => (o.type ? o.type.allowsMarkType(d.type) : Tf(d.type, n)) ? (s = d.addToSet(s), !1) : !0), this.nodes.push(new xo(n, t, s, l, null, i)), this.open++, a;
  }
  // Make sure all nodes above this.open are finished and added to
  // their parents
  closeExtra(n = !1) {
    let t = this.nodes.length - 1;
    if (t > this.open) {
      for (; t > this.open; t--)
        this.nodes[t - 1].content.push(this.nodes[t].finish(n));
      this.nodes.length = this.open + 1;
    }
  }
  finish() {
    return this.open = 0, this.closeExtra(this.isOpen), this.nodes[0].finish(!!(this.isOpen || this.options.topOpen));
  }
  sync(n) {
    for (let t = this.open; t >= 0; t--) {
      if (this.nodes[t] == n)
        return this.open = t, !0;
      this.localPreserveWS && (this.nodes[t].options |= Fr);
    }
    return !1;
  }
  get currentPos() {
    this.closeExtra();
    let n = 0;
    for (let t = this.open; t >= 0; t--) {
      let a = this.nodes[t].content;
      for (let l = a.length - 1; l >= 0; l--)
        n += a[l].nodeSize;
      t && n++;
    }
    return n;
  }
  findAtPoint(n, t) {
    if (this.find)
      for (let a = 0; a < this.find.length; a++)
        this.find[a].node == n && this.find[a].offset == t && (this.find[a].pos = this.currentPos);
  }
  findInside(n) {
    if (this.find)
      for (let t = 0; t < this.find.length; t++)
        this.find[t].pos == null && n.nodeType == 1 && n.contains(this.find[t].node) && (this.find[t].pos = this.currentPos);
  }
  findAround(n, t, a) {
    if (n != t && this.find)
      for (let l = 0; l < this.find.length; l++)
        this.find[l].pos == null && n.nodeType == 1 && n.contains(this.find[l].node) && t.compareDocumentPosition(this.find[l].node) & (a ? 2 : 4) && (this.find[l].pos = this.currentPos);
  }
  findInText(n) {
    if (this.find)
      for (let t = 0; t < this.find.length; t++)
        this.find[t].node == n && (this.find[t].pos = this.currentPos - (n.nodeValue.length - this.find[t].offset));
  }
  // Determines whether the given context string matches this context.
  matchesContext(n) {
    if (n.indexOf("|") > -1)
      return n.split(/\s*\|\s*/).some(this.matchesContext, this);
    let t = n.split("/"), a = this.options.context, l = !this.isOpen && (!a || a.parent.type == this.nodes[0].type), r = -(a ? a.depth + 1 : 0) + (l ? 0 : 1), o = (i, s) => {
      for (; i >= 0; i--) {
        let d = t[i];
        if (d == "") {
          if (i == t.length - 1 || i == 0)
            continue;
          for (; s >= r; s--)
            if (o(i - 1, s))
              return !0;
          return !1;
        } else {
          let u = s > 0 || s == 0 && l ? this.nodes[s].type : a && s >= r ? a.node(s - r).type : null;
          if (!u || u.name != d && !u.isInGroup(d))
            return !1;
          s--;
        }
      }
      return !0;
    };
    return o(t.length - 1, this.open);
  }
  textblockFromContext() {
    let n = this.options.context;
    if (n)
      for (let t = n.depth; t >= 0; t--) {
        let a = n.node(t).contentMatchAt(n.indexAfter(t)).defaultType;
        if (a && a.isTextblock && a.defaultAttrs)
          return a;
      }
    for (let t in this.parser.schema.nodes) {
      let a = this.parser.schema.nodes[t];
      if (a.isTextblock && a.defaultAttrs)
        return a;
    }
  }
}
function o$(e) {
  for (let n = e.firstChild, t = null; n; n = n.nextSibling) {
    let a = n.nodeType == 1 ? n.nodeName.toLowerCase() : null;
    a && Yg.hasOwnProperty(a) && t ? (t.appendChild(n), n = t) : a == "li" ? t = n : a && (t = null);
  }
}
function i$(e, n) {
  return (e.matches || e.msMatchesSelector || e.webkitMatchesSelector || e.mozMatchesSelector).call(e, n);
}
function If(e) {
  let n = {};
  for (let t in e)
    n[t] = e[t];
  return n;
}
function Tf(e, n) {
  let t = n.schema.nodes;
  for (let a in t) {
    let l = t[a];
    if (!l.allowsMarkType(e))
      continue;
    let r = [], o = (i) => {
      r.push(i);
      for (let s = 0; s < i.edgeCount; s++) {
        let { type: d, next: u } = i.edge(s);
        if (d == n || r.indexOf(u) < 0 && o(u))
          return !0;
      }
    };
    if (o(l.contentMatch))
      return !0;
  }
}
class bl {
  /**
  Create a serializer. `nodes` should map node names to functions
  that take a node and return a description of the corresponding
  DOM. `marks` does the same for mark names, but also gets an
  argument that tells it whether the mark's content is block or
  inline content (for typical use, it'll always be inline). A mark
  serializer may be `null` to indicate that marks of that type
  should not be serialized.
  */
  constructor(n, t) {
    this.nodes = n, this.marks = t;
  }
  /**
  Serialize the content of this fragment to a DOM fragment. When
  not in the browser, the `document` option, containing a DOM
  document, should be passed so that the serializer can create
  nodes.
  */
  serializeFragment(n, t = {}, a) {
    a || (a = yo(t).createDocumentFragment());
    let l = a, r = [];
    return n.forEach((o) => {
      if (r.length || o.marks.length) {
        let i = 0, s = 0;
        for (; i < r.length && s < o.marks.length; ) {
          let d = o.marks[s];
          if (!this.marks[d.type.name]) {
            s++;
            continue;
          }
          if (!d.eq(r[i][0]) || d.type.spec.spanning === !1)
            break;
          i++, s++;
        }
        for (; i < r.length; )
          l = r.pop()[1];
        for (; s < o.marks.length; ) {
          let d = o.marks[s++], u = this.serializeMark(d, o.isInline, t);
          u && (r.push([d, l]), l.appendChild(u.dom), l = u.contentDOM || u.dom);
        }
      }
      l.appendChild(this.serializeNodeInner(o, t));
    }), a;
  }
  /**
  @internal
  */
  serializeNodeInner(n, t) {
    if (n.isText)
      return yo(t).createTextNode(n.text);
    let { dom: a, contentDOM: l } = Wo(yo(t), this.nodes[n.type.name](n), null, n.attrs);
    if (l) {
      if (n.isLeaf)
        throw new RangeError("Content hole not allowed in a leaf node spec");
      this.serializeFragment(n.content, t, l);
    }
    return a;
  }
  /**
  Serialize this node to a DOM node. This can be useful when you
  need to serialize a part of a document, as opposed to the whole
  document. To serialize a whole document, use
  [`serializeFragment`](https://prosemirror.net/docs/ref/#model.DOMSerializer.serializeFragment) on
  its [content](https://prosemirror.net/docs/ref/#model.Node.content).
  */
  serializeNode(n, t = {}) {
    let a = this.serializeNodeInner(n, t);
    for (let l = n.marks.length - 1; l >= 0; l--) {
      let r = this.serializeMark(n.marks[l], n.isInline, t);
      r && ((r.contentDOM || r.dom).appendChild(a), a = r.dom);
    }
    return a;
  }
  /**
  @internal
  */
  serializeMark(n, t, a = {}) {
    let l = this.marks[n.type.name];
    return l && Wo(yo(a), l(n, t), null, n.attrs);
  }
  static renderSpec(n, t, a = null, l) {
    return typeof t == "string" ? { dom: n.createTextNode(t) } : Wo(n, t, a, l);
  }
  /**
  Build a serializer using the [`toDOM`](https://prosemirror.net/docs/ref/#model.NodeSpec.toDOM)
  properties in a schema's node and mark specs.
  */
  static fromSchema(n) {
    return n.cached.domSerializer || (n.cached.domSerializer = new bl(this.nodesFromSchema(n), this.marksFromSchema(n)));
  }
  /**
  Gather the serializers in a schema's node specs into an object.
  This can be useful as a base to build a custom serializer from.
  */
  static nodesFromSchema(n) {
    let t = Lf(n.nodes);
    return t.text || (t.text = (a) => a.text), t;
  }
  /**
  Gather the serializers in a schema's mark specs into an object.
  */
  static marksFromSchema(n) {
    return Lf(n.marks);
  }
}
function Lf(e) {
  let n = {};
  for (let t in e) {
    let a = e[t].spec.toDOM;
    a && (n[t] = a);
  }
  return n;
}
function yo(e) {
  return e.document || window.document;
}
const Ef = /* @__PURE__ */ new WeakMap();
function s$(e) {
  let n = Ef.get(e);
  return n === void 0 && Ef.set(e, n = d$(e)), n;
}
function d$(e) {
  let n = null;
  function t(a) {
    if (a && typeof a == "object")
      if (Array.isArray(a))
        if (typeof a[0] == "string")
          n || (n = []), n.push(a);
        else
          for (let l = 0; l < a.length; l++)
            t(a[l]);
      else
        for (let l in a)
          t(a[l]);
  }
  return t(e), n;
}
function Wo(e, n, t, a) {
  if (n.nodeType == 1)
    return { dom: n };
  if (n.dom && n.dom.nodeType == 1)
    return n;
  let l = n[0], r;
  if (typeof l != "string")
    throw new RangeError("Invalid array passed to renderSpec");
  if (a && (r = s$(a)) && r.indexOf(n) > -1)
    throw new RangeError("Using an array from an attribute object as a DOM spec. This may be an attempted cross site scripting attack.");
  let o = l.indexOf(" ");
  o > 0 && (t = l.slice(0, o), l = l.slice(o + 1));
  let i, s = t ? e.createElementNS(t, l) : e.createElement(l), d = n[1], u = 1;
  if (d && typeof d == "object" && d.nodeType == null && !Array.isArray(d)) {
    u = 2;
    for (let f in d)
      if (d[f] != null) {
        let b = f.indexOf(" ");
        b > 0 ? s.setAttributeNS(f.slice(0, b), f.slice(b + 1), d[f]) : f == "style" && s.style ? s.style.cssText = d[f] : s.setAttribute(f, d[f]);
      }
  }
  for (let f = u; f < n.length; f++) {
    let b = n[f];
    if (b === 0) {
      if (f < n.length - 1 || f > u)
        throw new RangeError("Content hole must be the only child of its parent node");
      return { dom: s, contentDOM: s };
    } else if (typeof b == "string")
      s.appendChild(e.createTextNode(b));
    else {
      let { dom: h, contentDOM: m } = Wo(e, b, t, a);
      if (s.appendChild(h), m) {
        if (i)
          throw new RangeError("Multiple content holes");
        i = m;
      }
    }
  }
  return { dom: s, contentDOM: i };
}
const Jg = 65535, Zg = Math.pow(2, 16);
function u$(e, n) {
  return e + n * Zg;
}
function Af(e) {
  return e & Jg;
}
function c$(e) {
  return (e - (e & Jg)) / Zg;
}
const Xg = 1, Qg = 2, qo = 4, _g = 8;
class Od {
  /**
  @internal
  */
  constructor(n, t, a) {
    this.pos = n, this.delInfo = t, this.recover = a;
  }
  /**
  Tells you whether the position was deleted, that is, whether the
  step removed the token on the side queried (via the `assoc`)
  argument from the document.
  */
  get deleted() {
    return (this.delInfo & _g) > 0;
  }
  /**
  Tells you whether the token before the mapped position was deleted.
  */
  get deletedBefore() {
    return (this.delInfo & (Xg | qo)) > 0;
  }
  /**
  True when the token after the mapped position was deleted.
  */
  get deletedAfter() {
    return (this.delInfo & (Qg | qo)) > 0;
  }
  /**
  Tells whether any of the steps mapped through deletes across the
  position (including both the token before and after the
  position).
  */
  get deletedAcross() {
    return (this.delInfo & qo) > 0;
  }
}
class hn {
  /**
  Create a position map. The modifications to the document are
  represented as an array of numbers, in which each group of three
  represents a modified chunk as `[start, oldSize, newSize]`.
  */
  constructor(n, t = !1) {
    if (this.ranges = n, this.inverted = t, !n.length && hn.empty)
      return hn.empty;
  }
  /**
  @internal
  */
  recover(n) {
    let t = 0, a = Af(n);
    if (!this.inverted)
      for (let l = 0; l < a; l++)
        t += this.ranges[l * 3 + 2] - this.ranges[l * 3 + 1];
    return this.ranges[a * 3] + t + c$(n);
  }
  mapResult(n, t = 1) {
    return this._map(n, t, !1);
  }
  map(n, t = 1) {
    return this._map(n, t, !0);
  }
  /**
  @internal
  */
  _map(n, t, a) {
    let l = 0, r = this.inverted ? 2 : 1, o = this.inverted ? 1 : 2;
    for (let i = 0; i < this.ranges.length; i += 3) {
      let s = this.ranges[i] - (this.inverted ? l : 0);
      if (s > n)
        break;
      let d = this.ranges[i + r], u = this.ranges[i + o], f = s + d;
      if (n <= f) {
        let b = d ? n == s ? -1 : n == f ? 1 : t : t, h = s + l + (b < 0 ? 0 : u);
        if (a)
          return h;
        let m = n == (t < 0 ? s : f) ? null : u$(i / 3, n - s), x = n == s ? Qg : n == f ? Xg : qo;
        return (t < 0 ? n != s : n != f) && (x |= _g), new Od(h, x, m);
      }
      l += u - d;
    }
    return a ? n + l : new Od(n + l, 0, null);
  }
  /**
  @internal
  */
  touches(n, t) {
    let a = 0, l = Af(t), r = this.inverted ? 2 : 1, o = this.inverted ? 1 : 2;
    for (let i = 0; i < this.ranges.length; i += 3) {
      let s = this.ranges[i] - (this.inverted ? a : 0);
      if (s > n)
        break;
      let d = this.ranges[i + r], u = s + d;
      if (n <= u && i == l * 3)
        return !0;
      a += this.ranges[i + o] - d;
    }
    return !1;
  }
  /**
  Calls the given function on each of the changed ranges included in
  this map.
  */
  forEach(n) {
    let t = this.inverted ? 2 : 1, a = this.inverted ? 1 : 2;
    for (let l = 0, r = 0; l < this.ranges.length; l += 3) {
      let o = this.ranges[l], i = o - (this.inverted ? r : 0), s = o + (this.inverted ? 0 : r), d = this.ranges[l + t], u = this.ranges[l + a];
      n(i, i + d, s, s + u), r += u - d;
    }
  }
  /**
  Create an inverted version of this map. The result can be used to
  map positions in the post-step document to the pre-step document.
  */
  invert() {
    return new hn(this.ranges, !this.inverted);
  }
  /**
  @internal
  */
  toString() {
    return (this.inverted ? "-" : "") + JSON.stringify(this.ranges);
  }
  /**
  Create a map that moves all positions by offset `n` (which may be
  negative). This can be useful when applying steps meant for a
  sub-document to a larger document, or vice-versa.
  */
  static offset(n) {
    return n == 0 ? hn.empty : new hn(n < 0 ? [0, -n, 0] : [0, 0, n]);
  }
}
hn.empty = new hn([]);
class Vr {
  /**
  Create a new mapping with the given position maps.
  */
  constructor(n, t, a = 0, l = n ? n.length : 0) {
    this.mirror = t, this.from = a, this.to = l, this._maps = n || [], this.ownData = !(n || t);
  }
  /**
  The step maps in this mapping.
  */
  get maps() {
    return this._maps;
  }
  /**
  Create a mapping that maps only through a part of this one.
  */
  slice(n = 0, t = this.maps.length) {
    return new Vr(this._maps, this.mirror, n, t);
  }
  /**
  Add a step map to the end of this mapping. If `mirrors` is
  given, it should be the index of the step map that is the mirror
  image of this one.
  */
  appendMap(n, t) {
    this.ownData || (this._maps = this._maps.slice(), this.mirror = this.mirror && this.mirror.slice(), this.ownData = !0), this.to = this._maps.push(n), t != null && this.setMirror(this._maps.length - 1, t);
  }
  /**
  Add all the step maps in a given mapping to this one (preserving
  mirroring information).
  */
  appendMapping(n) {
    for (let t = 0, a = this._maps.length; t < n._maps.length; t++) {
      let l = n.getMirror(t);
      this.appendMap(n._maps[t], l != null && l < t ? a + l : void 0);
    }
  }
  /**
  Finds the offset of the step map that mirrors the map at the
  given offset, in this mapping (as per the second argument to
  `appendMap`).
  */
  getMirror(n) {
    if (this.mirror) {
      for (let t = 0; t < this.mirror.length; t++)
        if (this.mirror[t] == n)
          return this.mirror[t + (t % 2 ? -1 : 1)];
    }
  }
  /**
  @internal
  */
  setMirror(n, t) {
    this.mirror || (this.mirror = []), this.mirror.push(n, t);
  }
  /**
  Append the inverse of the given mapping to this one.
  */
  appendMappingInverted(n) {
    for (let t = n.maps.length - 1, a = this._maps.length + n._maps.length; t >= 0; t--) {
      let l = n.getMirror(t);
      this.appendMap(n._maps[t].invert(), l != null && l > t ? a - l - 1 : void 0);
    }
  }
  /**
  Create an inverted version of this mapping.
  */
  invert() {
    let n = new Vr();
    return n.appendMappingInverted(this), n;
  }
  /**
  Map a position through this mapping.
  */
  map(n, t = 1) {
    if (this.mirror)
      return this._map(n, t, !0);
    for (let a = this.from; a < this.to; a++)
      n = this._maps[a].map(n, t);
    return n;
  }
  /**
  Map a position through this mapping, returning a mapping
  result.
  */
  mapResult(n, t = 1) {
    return this._map(n, t, !1);
  }
  /**
  @internal
  */
  _map(n, t, a) {
    let l = 0;
    for (let r = this.from; r < this.to; r++) {
      let o = this._maps[r], i = o.mapResult(n, t);
      if (i.recover != null) {
        let s = this.getMirror(r);
        if (s != null && s > r && s < this.to) {
          r = s, n = this._maps[s].recover(i.recover);
          continue;
        }
      }
      l |= i.delInfo, n = i.pos;
    }
    return a ? n : new Od(n, l, null);
  }
}
const Bs = /* @__PURE__ */ Object.create(null);
class _t {
  /**
  Get the step map that represents the changes made by this step,
  and which can be used to transform between positions in the old
  and the new document.
  */
  getMap() {
    return hn.empty;
  }
  /**
  Try to merge this step with another one, to be applied directly
  after it. Returns the merged step when possible, null if the
  steps can't be merged.
  */
  merge(n) {
    return null;
  }
  /**
  Deserialize a step from its JSON representation. Will call
  through to the step class' own implementation of this method.
  */
  static fromJSON(n, t) {
    if (!t || !t.stepType)
      throw new RangeError("Invalid input for Step.fromJSON");
    let a = Bs[t.stepType];
    if (!a)
      throw new RangeError(`No step type ${t.stepType} defined`);
    return a.fromJSON(n, t);
  }
  /**
  To be able to serialize steps to JSON, each step needs a string
  ID to attach to its JSON representation. Use this method to
  register an ID for your step classes. Try to pick something
  that's unlikely to clash with steps from other modules.
  */
  static jsonID(n, t) {
    if (n in Bs)
      throw new RangeError("Duplicate use of step JSON ID " + n);
    return Bs[n] = t, t.prototype.jsonID = n, t;
  }
}
class Mt {
  /**
  @internal
  */
  constructor(n, t) {
    this.doc = n, this.failed = t;
  }
  /**
  Create a successful step result.
  */
  static ok(n) {
    return new Mt(n, null);
  }
  /**
  Create a failed step result.
  */
  static fail(n) {
    return new Mt(null, n);
  }
  /**
  Call [`Node.replace`](https://prosemirror.net/docs/ref/#model.Node.replace) with the given
  arguments. Create a successful result if it succeeds, and a
  failed one if it throws a `ReplaceError`.
  */
  static fromReplace(n, t, a, l) {
    try {
      return Mt.ok(n.replace(t, a, l));
    } catch (r) {
      if (r instanceof ai)
        return Mt.fail(r.message);
      throw r;
    }
  }
}
function Uu(e, n, t) {
  let a = [];
  for (let l = 0; l < e.childCount; l++) {
    let r = e.child(l);
    r.content.size && (r = r.copy(Uu(r.content, n, r))), r.isInline && (r = n(r, t, l)), a.push(r);
  }
  return Pe.fromArray(a);
}
class ya extends _t {
  /**
  Create a mark step.
  */
  constructor(n, t, a) {
    super(), this.from = n, this.to = t, this.mark = a;
  }
  apply(n) {
    let t = n.slice(this.from, this.to), a = n.resolve(this.from), l = a.node(a.sharedDepth(this.to)), r = new Ye(Uu(t.content, (o, i) => !o.isAtom || !i.type.allowsMarkType(this.mark.type) ? o : o.mark(this.mark.addToSet(o.marks)), l), t.openStart, t.openEnd);
    return Mt.fromReplace(n, this.from, this.to, r);
  }
  invert() {
    return new On(this.from, this.to, this.mark);
  }
  map(n) {
    let t = n.mapResult(this.from, 1), a = n.mapResult(this.to, -1);
    return t.deleted && a.deleted || t.pos >= a.pos ? null : new ya(t.pos, a.pos, this.mark);
  }
  merge(n) {
    return n instanceof ya && n.mark.eq(this.mark) && this.from <= n.to && this.to >= n.from ? new ya(Math.min(this.from, n.from), Math.max(this.to, n.to), this.mark) : null;
  }
  toJSON() {
    return {
      stepType: "addMark",
      mark: this.mark.toJSON(),
      from: this.from,
      to: this.to
    };
  }
  /**
  @internal
  */
  static fromJSON(n, t) {
    if (typeof t.from != "number" || typeof t.to != "number")
      throw new RangeError("Invalid input for AddMarkStep.fromJSON");
    return new ya(t.from, t.to, n.markFromJSON(t.mark));
  }
}
_t.jsonID("addMark", ya);
class On extends _t {
  /**
  Create a mark-removing step.
  */
  constructor(n, t, a) {
    super(), this.from = n, this.to = t, this.mark = a;
  }
  apply(n) {
    let t = n.slice(this.from, this.to), a = new Ye(Uu(t.content, (l) => l.mark(this.mark.removeFromSet(l.marks)), n), t.openStart, t.openEnd);
    return Mt.fromReplace(n, this.from, this.to, a);
  }
  invert() {
    return new ya(this.from, this.to, this.mark);
  }
  map(n) {
    let t = n.mapResult(this.from, 1), a = n.mapResult(this.to, -1);
    return t.deleted && a.deleted || t.pos >= a.pos ? null : new On(t.pos, a.pos, this.mark);
  }
  merge(n) {
    return n instanceof On && n.mark.eq(this.mark) && this.from <= n.to && this.to >= n.from ? new On(Math.min(this.from, n.from), Math.max(this.to, n.to), this.mark) : null;
  }
  toJSON() {
    return {
      stepType: "removeMark",
      mark: this.mark.toJSON(),
      from: this.from,
      to: this.to
    };
  }
  /**
  @internal
  */
  static fromJSON(n, t) {
    if (typeof t.from != "number" || typeof t.to != "number")
      throw new RangeError("Invalid input for RemoveMarkStep.fromJSON");
    return new On(t.from, t.to, n.markFromJSON(t.mark));
  }
}
_t.jsonID("removeMark", On);
class ka extends _t {
  /**
  Create a node mark step.
  */
  constructor(n, t) {
    super(), this.pos = n, this.mark = t;
  }
  apply(n) {
    let t = n.nodeAt(this.pos);
    if (!t)
      return Mt.fail("No node at mark step's position");
    let a = t.type.create(t.attrs, null, this.mark.addToSet(t.marks));
    return Mt.fromReplace(n, this.pos, this.pos + 1, new Ye(Pe.from(a), 0, t.isLeaf ? 0 : 1));
  }
  invert(n) {
    let t = n.nodeAt(this.pos);
    if (t) {
      let a = this.mark.addToSet(t.marks);
      if (a.length == t.marks.length) {
        for (let l = 0; l < t.marks.length; l++)
          if (!t.marks[l].isInSet(a))
            return new ka(this.pos, t.marks[l]);
        return new ka(this.pos, this.mark);
      }
    }
    return new ul(this.pos, this.mark);
  }
  map(n) {
    let t = n.mapResult(this.pos, 1);
    return t.deletedAfter ? null : new ka(t.pos, this.mark);
  }
  toJSON() {
    return { stepType: "addNodeMark", pos: this.pos, mark: this.mark.toJSON() };
  }
  /**
  @internal
  */
  static fromJSON(n, t) {
    if (typeof t.pos != "number")
      throw new RangeError("Invalid input for AddNodeMarkStep.fromJSON");
    return new ka(t.pos, n.markFromJSON(t.mark));
  }
}
_t.jsonID("addNodeMark", ka);
class ul extends _t {
  /**
  Create a mark-removing step.
  */
  constructor(n, t) {
    super(), this.pos = n, this.mark = t;
  }
  apply(n) {
    let t = n.nodeAt(this.pos);
    if (!t)
      return Mt.fail("No node at mark step's position");
    let a = t.type.create(t.attrs, null, this.mark.removeFromSet(t.marks));
    return Mt.fromReplace(n, this.pos, this.pos + 1, new Ye(Pe.from(a), 0, t.isLeaf ? 0 : 1));
  }
  invert(n) {
    let t = n.nodeAt(this.pos);
    return !t || !this.mark.isInSet(t.marks) ? this : new ka(this.pos, this.mark);
  }
  map(n) {
    let t = n.mapResult(this.pos, 1);
    return t.deletedAfter ? null : new ul(t.pos, this.mark);
  }
  toJSON() {
    return { stepType: "removeNodeMark", pos: this.pos, mark: this.mark.toJSON() };
  }
  /**
  @internal
  */
  static fromJSON(n, t) {
    if (typeof t.pos != "number")
      throw new RangeError("Invalid input for RemoveNodeMarkStep.fromJSON");
    return new ul(t.pos, n.markFromJSON(t.mark));
  }
}
_t.jsonID("removeNodeMark", ul);
class Bt extends _t {
  /**
  The given `slice` should fit the 'gap' between `from` and
  `to`—the depths must line up, and the surrounding nodes must be
  able to be joined with the open sides of the slice. When
  `structure` is true, the step will fail if the content between
  from and to is not just a sequence of closing and then opening
  tokens (this is to guard against rebased replace steps
  overwriting something they weren't supposed to).
  */
  constructor(n, t, a, l = !1) {
    super(), this.from = n, this.to = t, this.slice = a, this.structure = l;
  }
  apply(n) {
    return this.structure && Pd(n, this.from, this.to) ? Mt.fail("Structure replace would overwrite content") : Mt.fromReplace(n, this.from, this.to, this.slice);
  }
  getMap() {
    return new hn([this.from, this.to - this.from, this.slice.size]);
  }
  invert(n) {
    return new Bt(this.from, this.from + this.slice.size, n.slice(this.from, this.to));
  }
  map(n) {
    let t = n.mapResult(this.to, -1), a = this.from == this.to && Bt.MAP_BIAS < 0 ? t : n.mapResult(this.from, 1);
    return a.deletedAcross && t.deletedAcross ? null : new Bt(a.pos, Math.max(a.pos, t.pos), this.slice, this.structure);
  }
  merge(n) {
    if (!(n instanceof Bt) || n.structure || this.structure)
      return null;
    if (this.from + this.slice.size == n.from && !this.slice.openEnd && !n.slice.openStart) {
      let t = this.slice.size + n.slice.size == 0 ? Ye.empty : new Ye(this.slice.content.append(n.slice.content), this.slice.openStart, n.slice.openEnd);
      return new Bt(this.from, this.to + (n.to - n.from), t, this.structure);
    } else if (n.to == this.from && !this.slice.openStart && !n.slice.openEnd) {
      let t = this.slice.size + n.slice.size == 0 ? Ye.empty : new Ye(n.slice.content.append(this.slice.content), n.slice.openStart, this.slice.openEnd);
      return new Bt(n.from, this.to, t, this.structure);
    } else
      return null;
  }
  toJSON() {
    let n = { stepType: "replace", from: this.from, to: this.to };
    return this.slice.size && (n.slice = this.slice.toJSON()), this.structure && (n.structure = !0), n;
  }
  /**
  @internal
  */
  static fromJSON(n, t) {
    if (typeof t.from != "number" || typeof t.to != "number")
      throw new RangeError("Invalid input for ReplaceStep.fromJSON");
    return new Bt(t.from, t.to, Ye.fromJSON(n, t.slice), !!t.structure);
  }
}
Bt.MAP_BIAS = 1;
_t.jsonID("replace", Bt);
class Vt extends _t {
  /**
  Create a replace-around step with the given range and gap.
  `insert` should be the point in the slice into which the content
  of the gap should be moved. `structure` has the same meaning as
  it has in the [`ReplaceStep`](https://prosemirror.net/docs/ref/#transform.ReplaceStep) class.
  */
  constructor(n, t, a, l, r, o, i = !1) {
    super(), this.from = n, this.to = t, this.gapFrom = a, this.gapTo = l, this.slice = r, this.insert = o, this.structure = i;
  }
  apply(n) {
    if (this.structure && (Pd(n, this.from, this.gapFrom) || Pd(n, this.gapTo, this.to)))
      return Mt.fail("Structure gap-replace would overwrite content");
    let t = n.slice(this.gapFrom, this.gapTo);
    if (t.openStart || t.openEnd)
      return Mt.fail("Gap is not a flat range");
    let a = this.slice.insertAt(this.insert, t.content);
    return a ? Mt.fromReplace(n, this.from, this.to, a) : Mt.fail("Content does not fit in gap");
  }
  getMap() {
    return new hn([
      this.from,
      this.gapFrom - this.from,
      this.insert,
      this.gapTo,
      this.to - this.gapTo,
      this.slice.size - this.insert
    ]);
  }
  invert(n) {
    let t = this.gapTo - this.gapFrom;
    return new Vt(this.from, this.from + this.slice.size + t, this.from + this.insert, this.from + this.insert + t, n.slice(this.from, this.to).removeBetween(this.gapFrom - this.from, this.gapTo - this.from), this.gapFrom - this.from, this.structure);
  }
  map(n) {
    let t = n.mapResult(this.from, 1), a = n.mapResult(this.to, -1), l = this.from == this.gapFrom ? t.pos : n.map(this.gapFrom, -1), r = this.to == this.gapTo ? a.pos : n.map(this.gapTo, 1);
    return t.deletedAcross && a.deletedAcross || l < t.pos || r > a.pos ? null : new Vt(t.pos, a.pos, l, r, this.slice, this.insert, this.structure);
  }
  toJSON() {
    let n = {
      stepType: "replaceAround",
      from: this.from,
      to: this.to,
      gapFrom: this.gapFrom,
      gapTo: this.gapTo,
      insert: this.insert
    };
    return this.slice.size && (n.slice = this.slice.toJSON()), this.structure && (n.structure = !0), n;
  }
  /**
  @internal
  */
  static fromJSON(n, t) {
    if (typeof t.from != "number" || typeof t.to != "number" || typeof t.gapFrom != "number" || typeof t.gapTo != "number" || typeof t.insert != "number")
      throw new RangeError("Invalid input for ReplaceAroundStep.fromJSON");
    return new Vt(t.from, t.to, t.gapFrom, t.gapTo, Ye.fromJSON(n, t.slice), t.insert, !!t.structure);
  }
}
_t.jsonID("replaceAround", Vt);
function Pd(e, n, t) {
  let a = e.resolve(n), l = t - n, r = a.depth;
  for (; l > 0 && r > 0 && a.indexAfter(r) == a.node(r).childCount; )
    r--, l--;
  if (l > 0) {
    let o = a.node(r).maybeChild(a.indexAfter(r));
    for (; l > 0; ) {
      if (!o || o.isLeaf)
        return !0;
      o = o.firstChild, l--;
    }
  }
  return !1;
}
function f$(e, n, t, a) {
  let l = [], r = [], o, i;
  e.doc.nodesBetween(n, t, (s, d, u) => {
    if (!s.isInline)
      return;
    let f = s.marks;
    if (!a.isInSet(f) && u.type.allowsMarkType(a.type)) {
      let b = Math.max(d, n), h = Math.min(d + s.nodeSize, t), m = a.addToSet(f);
      for (let x = 0; x < f.length; x++)
        f[x].isInSet(m) || (o && o.to == b && o.mark.eq(f[x]) ? o.to = h : l.push(o = new On(b, h, f[x])));
      i && i.to == b ? i.to = h : r.push(i = new ya(b, h, a));
    }
  }), l.forEach((s) => e.step(s)), r.forEach((s) => e.step(s));
}
function h$(e, n, t, a) {
  let l = [], r = 0;
  e.doc.nodesBetween(n, t, (o, i) => {
    if (!o.isInline)
      return;
    r++;
    let s = null;
    if (a instanceof Xi) {
      let d = o.marks, u;
      for (; u = a.isInSet(d); )
        (s || (s = [])).push(u), d = u.removeFromSet(d);
    } else a ? a.isInSet(o.marks) && (s = [a]) : s = o.marks;
    if (s && s.length) {
      let d = Math.min(i + o.nodeSize, t);
      for (let u = 0; u < s.length; u++) {
        let f = s[u], b;
        for (let h = 0; h < l.length; h++) {
          let m = l[h];
          m.step == r - 1 && f.eq(l[h].style) && (b = m);
        }
        b ? (b.to = d, b.step = r) : l.push({ style: f, from: Math.max(i, n), to: d, step: r });
      }
    }
  }), l.forEach((o) => e.step(new On(o.from, o.to, o.style)));
}
function Gu(e, n, t, a = t.contentMatch, l = !0) {
  let r = e.doc.nodeAt(n), o = [], i = n + 1;
  for (let s = 0; s < r.childCount; s++) {
    let d = r.child(s), u = i + d.nodeSize, f = a.matchType(d.type);
    if (!f)
      o.push(new Bt(i, u, Ye.empty));
    else {
      a = f;
      for (let b = 0; b < d.marks.length; b++)
        t.allowsMarkType(d.marks[b].type) || e.step(new On(i, u, d.marks[b]));
      if (l && d.isText && t.whitespace != "pre") {
        let b, h = /\r?\n|\r/g, m;
        for (; b = h.exec(d.text); )
          m || (m = new Ye(Pe.from(t.schema.text(" ", t.allowedMarks(d.marks))), 0, 0)), o.push(new Bt(i + b.index, i + b.index + b[0].length, m));
      }
    }
    i = u;
  }
  if (!a.validEnd) {
    let s = a.fillBefore(Pe.empty, !0);
    e.replace(i, i, new Ye(s, 0, 0));
  }
  for (let s = o.length - 1; s >= 0; s--)
    e.step(o[s]);
}
function b$(e, n, t) {
  return (n == 0 || e.canReplace(n, e.childCount)) && (t == e.childCount || e.canReplace(0, t));
}
function Jl(e) {
  let t = e.parent.content.cutByIndex(e.startIndex, e.endIndex);
  for (let a = e.depth, l = 0, r = 0; ; --a) {
    let o = e.$from.node(a), i = e.$from.index(a) + l, s = e.$to.indexAfter(a) - r;
    if (a < e.depth && o.canReplace(i, s, t))
      return a;
    if (a == 0 || o.type.spec.isolating || !b$(o, i, s))
      break;
    i && (l = 1), s < o.childCount && (r = 1);
  }
  return null;
}
function g$(e, n, t) {
  let { $from: a, $to: l, depth: r } = n, o = a.before(r + 1), i = l.after(r + 1), s = o, d = i, u = Pe.empty, f = 0;
  for (let m = r, x = !1; m > t; m--)
    x || a.index(m) > 0 ? (x = !0, u = Pe.from(a.node(m).copy(u)), f++) : s--;
  let b = Pe.empty, h = 0;
  for (let m = r, x = !1; m > t; m--)
    x || l.after(m + 1) < l.end(m) ? (x = !0, b = Pe.from(l.node(m).copy(b)), h++) : d++;
  e.step(new Vt(s, d, o, i, new Ye(u.append(b), f, h), u.size - f, !0));
}
function Ku(e, n, t = null, a = e) {
  let l = p$(e, n), r = l && m$(a, n);
  return r ? l.map(Rf).concat({ type: n, attrs: t }).concat(r.map(Rf)) : null;
}
function Rf(e) {
  return { type: e, attrs: null };
}
function p$(e, n) {
  let { parent: t, startIndex: a, endIndex: l } = e, r = t.contentMatchAt(a).findWrapping(n);
  if (!r)
    return null;
  let o = r.length ? r[0] : n;
  return t.canReplaceWith(a, l, o) ? r : null;
}
function m$(e, n) {
  let { parent: t, startIndex: a, endIndex: l } = e, r = t.child(a), o = n.contentMatch.findWrapping(r.type);
  if (!o)
    return null;
  let s = (o.length ? o[o.length - 1] : n).contentMatch;
  for (let d = a; s && d < l; d++)
    s = s.matchType(t.child(d).type);
  return !s || !s.validEnd ? null : o;
}
function v$(e, n, t) {
  let a = Pe.empty;
  for (let o = t.length - 1; o >= 0; o--) {
    if (a.size) {
      let i = t[o].type.contentMatch.matchFragment(a);
      if (!i || !i.validEnd)
        throw new RangeError("Wrapper type given to Transform.wrap does not form valid content of its parent wrapper");
    }
    a = Pe.from(t[o].type.create(t[o].attrs, a));
  }
  let l = n.start, r = n.end;
  e.step(new Vt(l, r, l, r, new Ye(a, 0, 0), t.length, !0));
}
function x$(e, n, t, a, l) {
  if (!a.isTextblock)
    throw new RangeError("Type given to setBlockType should be a textblock");
  let r = e.steps.length;
  e.doc.nodesBetween(n, t, (o, i) => {
    let s = typeof l == "function" ? l(o) : l;
    if (o.isTextblock && !o.hasMarkup(a, s) && y$(e.doc, e.mapping.slice(r).map(i), a)) {
      let d = null;
      if (a.schema.linebreakReplacement) {
        let h = a.whitespace == "pre", m = !!a.contentMatch.matchType(a.schema.linebreakReplacement);
        h && !m ? d = !1 : !h && m && (d = !0);
      }
      d === !1 && tp(e, o, i, r), Gu(e, e.mapping.slice(r).map(i, 1), a, void 0, d === null);
      let u = e.mapping.slice(r), f = u.map(i, 1), b = u.map(i + o.nodeSize, 1);
      return e.step(new Vt(f, b, f + 1, b - 1, new Ye(Pe.from(a.create(s, null, o.marks)), 0, 0), 1, !0)), d === !0 && ep(e, o, i, r), !1;
    }
  });
}
function ep(e, n, t, a) {
  n.forEach((l, r) => {
    if (l.isText) {
      let o, i = /\r?\n|\r/g;
      for (; o = i.exec(l.text); ) {
        let s = e.mapping.slice(a).map(t + 1 + r + o.index);
        e.replaceWith(s, s + 1, n.type.schema.linebreakReplacement.create());
      }
    }
  });
}
function tp(e, n, t, a) {
  n.forEach((l, r) => {
    if (l.type == l.type.schema.linebreakReplacement) {
      let o = e.mapping.slice(a).map(t + 1 + r);
      e.replaceWith(o, o + 1, n.type.schema.text(`
`));
    }
  });
}
function y$(e, n, t) {
  let a = e.resolve(n), l = a.index();
  return a.parent.canReplaceWith(l, l + 1, t);
}
function k$(e, n, t, a, l) {
  let r = e.doc.nodeAt(n);
  if (!r)
    throw new RangeError("No node at given position");
  t || (t = r.type);
  let o = t.create(a, null, l || r.marks);
  if (r.isLeaf)
    return e.replaceWith(n, n + r.nodeSize, o);
  if (!t.validContent(r.content))
    throw new RangeError("Invalid content for node type " + t.name);
  e.step(new Vt(n, n + r.nodeSize, n + 1, n + r.nodeSize - 1, new Ye(Pe.from(o), 0, 0), 1, !0));
}
function sa(e, n, t = 1, a) {
  let l = e.resolve(n), r = l.depth - t, o = a && a[a.length - 1] || l.parent;
  if (r < 0 || l.parent.type.spec.isolating || !l.parent.canReplace(l.index(), l.parent.childCount) || !o.type.validContent(l.parent.content.cutByIndex(l.index(), l.parent.childCount)))
    return !1;
  for (let d = l.depth - 1, u = t - 2; d > r; d--, u--) {
    let f = l.node(d), b = l.index(d);
    if (f.type.spec.isolating)
      return !1;
    let h = f.content.cutByIndex(b, f.childCount), m = a && a[u + 1];
    m && (h = h.replaceChild(0, m.type.create(m.attrs)));
    let x = a && a[u] || f;
    if (!f.canReplace(b + 1, f.childCount) || !x.type.validContent(h))
      return !1;
  }
  let i = l.indexAfter(r), s = a && a[0];
  return l.node(r).canReplaceWith(i, i, s ? s.type : l.node(r + 1).type);
}
function w$(e, n, t = 1, a) {
  let l = e.doc.resolve(n), r = Pe.empty, o = Pe.empty;
  for (let i = l.depth, s = l.depth - t, d = t - 1; i > s; i--, d--) {
    r = Pe.from(l.node(i).copy(r));
    let u = a && a[d];
    o = Pe.from(u ? u.type.create(u.attrs, o) : l.node(i).copy(o));
  }
  e.step(new Bt(n, n, new Ye(r.append(o), t, t), !0));
}
function Ha(e, n) {
  let t = e.resolve(n), a = t.index();
  return np(t.nodeBefore, t.nodeAfter) && t.parent.canReplace(a, a + 1);
}
function C$(e, n) {
  n.content.size || e.type.compatibleContent(n.type);
  let t = e.contentMatchAt(e.childCount), { linebreakReplacement: a } = e.type.schema;
  for (let l = 0; l < n.childCount; l++) {
    let r = n.child(l), o = r.type == a ? e.type.schema.nodes.text : r.type;
    if (t = t.matchType(o), !t || !e.type.allowsMarks(r.marks))
      return !1;
  }
  return t.validEnd;
}
function np(e, n) {
  return !!(e && n && !e.isLeaf && C$(e, n));
}
function Qi(e, n, t = -1) {
  let a = e.resolve(n);
  for (let l = a.depth; ; l--) {
    let r, o, i = a.index(l);
    if (l == a.depth ? (r = a.nodeBefore, o = a.nodeAfter) : t > 0 ? (r = a.node(l + 1), i++, o = a.node(l).maybeChild(i)) : (r = a.node(l).maybeChild(i - 1), o = a.node(l + 1)), r && !r.isTextblock && np(r, o) && a.node(l).canReplace(i, i + 1))
      return n;
    if (l == 0)
      break;
    n = t < 0 ? a.before(l) : a.after(l);
  }
}
function S$(e, n, t) {
  let a = null, { linebreakReplacement: l } = e.doc.type.schema, r = e.doc.resolve(n - t), o = r.node().type;
  if (l && o.inlineContent) {
    let u = o.whitespace == "pre", f = !!o.contentMatch.matchType(l);
    u && !f ? a = !1 : !u && f && (a = !0);
  }
  let i = e.steps.length;
  if (a === !1) {
    let u = e.doc.resolve(n + t);
    tp(e, u.node(), u.before(), i);
  }
  o.inlineContent && Gu(e, n + t - 1, o, r.node().contentMatchAt(r.index()), a == null);
  let s = e.mapping.slice(i), d = s.map(n - t);
  if (e.step(new Bt(d, s.map(n + t, -1), Ye.empty, !0)), a === !0) {
    let u = e.doc.resolve(d);
    ep(e, u.node(), u.before(), e.steps.length);
  }
  return e;
}
function $$(e, n, t) {
  let a = e.resolve(n);
  if (a.parent.canReplaceWith(a.index(), a.index(), t))
    return n;
  if (a.parentOffset == 0)
    for (let l = a.depth - 1; l >= 0; l--) {
      let r = a.index(l);
      if (a.node(l).canReplaceWith(r, r, t))
        return a.before(l + 1);
      if (r > 0)
        return null;
    }
  if (a.parentOffset == a.parent.content.size)
    for (let l = a.depth - 1; l >= 0; l--) {
      let r = a.indexAfter(l);
      if (a.node(l).canReplaceWith(r, r, t))
        return a.after(l + 1);
      if (r < a.node(l).childCount)
        return null;
    }
  return null;
}
function ap(e, n, t) {
  let a = e.resolve(n);
  if (!t.content.size)
    return n;
  let l = t.content;
  for (let r = 0; r < t.openStart; r++)
    l = l.firstChild.content;
  for (let r = 1; r <= (t.openStart == 0 && t.size ? 2 : 1); r++)
    for (let o = a.depth; o >= 0; o--) {
      let i = o == a.depth ? 0 : a.pos <= (a.start(o + 1) + a.end(o + 1)) / 2 ? -1 : 1, s = a.index(o) + (i > 0 ? 1 : 0), d = a.node(o), u = !1;
      if (r == 1)
        u = d.canReplace(s, s, l);
      else {
        let f = d.contentMatchAt(s).findWrapping(l.firstChild.type);
        u = f && d.canReplaceWith(s, s, f[0]);
      }
      if (u)
        return i == 0 ? a.pos : i < 0 ? a.before(o + 1) : a.after(o + 1);
    }
  return null;
}
function _i(e, n, t = n, a = Ye.empty) {
  if (n == t && !a.size)
    return null;
  let l = e.resolve(n), r = e.resolve(t);
  return lp(l, r, a) ? new Bt(n, t, a) : new I$(l, r, a).fit();
}
function lp(e, n, t) {
  return !t.openStart && !t.openEnd && e.start() == n.start() && e.parent.canReplace(e.index(), n.index(), t.content);
}
class I$ {
  constructor(n, t, a) {
    this.$from = n, this.$to = t, this.unplaced = a, this.frontier = [], this.placed = Pe.empty;
    for (let l = 0; l <= n.depth; l++) {
      let r = n.node(l);
      this.frontier.push({
        type: r.type,
        match: r.contentMatchAt(n.indexAfter(l))
      });
    }
    for (let l = n.depth; l > 0; l--)
      this.placed = Pe.from(n.node(l).copy(this.placed));
  }
  get depth() {
    return this.frontier.length - 1;
  }
  fit() {
    for (; this.unplaced.size; ) {
      let d = this.findFittable();
      d ? this.placeNodes(d) : this.openMore() || this.dropNode();
    }
    let n = this.mustMoveInline(), t = this.placed.size - this.depth - this.$from.depth, a = this.$from, l = this.close(n < 0 ? this.$to : a.doc.resolve(n));
    if (!l)
      return null;
    let r = this.placed, o = a.depth, i = l.depth;
    for (; o && i && r.childCount == 1; )
      r = r.firstChild.content, o--, i--;
    let s = new Ye(r, o, i);
    return n > -1 ? new Vt(a.pos, n, this.$to.pos, this.$to.end(), s, t) : s.size || a.pos != this.$to.pos ? new Bt(a.pos, l.pos, s) : null;
  }
  // Find a position on the start spine of `this.unplaced` that has
  // content that can be moved somewhere on the frontier. Returns two
  // depths, one for the slice and one for the frontier.
  findFittable() {
    let n = this.unplaced.openStart;
    for (let t = this.unplaced.content, a = 0, l = this.unplaced.openEnd; a < n; a++) {
      let r = t.firstChild;
      if (t.childCount > 1 && (l = 0), r.type.spec.isolating && l <= a) {
        n = a;
        break;
      }
      t = r.content;
    }
    for (let t = 1; t <= 2; t++)
      for (let a = t == 1 ? n : this.unplaced.openStart; a >= 0; a--) {
        let l, r = null;
        a ? (r = Ms(this.unplaced.content, a - 1).firstChild, l = r.content) : l = this.unplaced.content;
        let o = l.firstChild;
        for (let i = this.depth; i >= 0; i--) {
          let { type: s, match: d } = this.frontier[i], u, f = null;
          if (t == 1 && (o ? d.matchType(o.type) || (f = d.fillBefore(Pe.from(o), !1)) : r && s.compatibleContent(r.type)))
            return { sliceDepth: a, frontierDepth: i, parent: r, inject: f };
          if (t == 2 && o && (u = d.findWrapping(o.type)))
            return { sliceDepth: a, frontierDepth: i, parent: r, wrap: u };
          if (r && d.matchType(r.type))
            break;
        }
      }
  }
  openMore() {
    let { content: n, openStart: t, openEnd: a } = this.unplaced, l = Ms(n, t);
    return !l.childCount || l.firstChild.isLeaf ? !1 : (this.unplaced = new Ye(n, t + 1, Math.max(a, l.size + t >= n.size - a ? t + 1 : 0)), !0);
  }
  dropNode() {
    let { content: n, openStart: t, openEnd: a } = this.unplaced, l = Ms(n, t);
    if (l.childCount <= 1 && t > 0) {
      let r = n.size - t <= t + l.size;
      this.unplaced = new Ye(dr(n, t - 1, 1), t - 1, r ? t - 1 : a);
    } else
      this.unplaced = new Ye(dr(n, t, 1), t, a);
  }
  // Move content from the unplaced slice at `sliceDepth` to the
  // frontier node at `frontierDepth`. Close that frontier node when
  // applicable.
  placeNodes({ sliceDepth: n, frontierDepth: t, parent: a, inject: l, wrap: r }) {
    for (; this.depth > t; )
      this.closeFrontierNode();
    if (r)
      for (let x = 0; x < r.length; x++)
        this.openFrontierNode(r[x]);
    let o = this.unplaced, i = a ? a.content : o.content, s = o.openStart - n, d = 0, u = [], { match: f, type: b } = this.frontier[t];
    if (l) {
      for (let x = 0; x < l.childCount; x++)
        u.push(l.child(x));
      f = f.matchFragment(l);
    }
    let h = i.size + n - (o.content.size - o.openEnd);
    for (; d < i.childCount; ) {
      let x = i.child(d), y = f.matchType(x.type);
      if (!y)
        break;
      d++, (d > 1 || s == 0 || x.content.size) && (f = y, u.push(rp(x.mark(b.allowedMarks(x.marks)), d == 1 ? s : 0, d == i.childCount ? h : -1)));
    }
    let m = d == i.childCount;
    m || (h = -1), this.placed = ur(this.placed, t, Pe.from(u)), this.frontier[t].match = f, m && h < 0 && a && a.type == this.frontier[this.depth].type && this.frontier.length > 1 && this.closeFrontierNode();
    for (let x = 0, y = i; x < h; x++) {
      let w = y.lastChild;
      this.frontier.push({ type: w.type, match: w.contentMatchAt(w.childCount) }), y = w.content;
    }
    this.unplaced = m ? n == 0 ? Ye.empty : new Ye(dr(o.content, n - 1, 1), n - 1, h < 0 ? o.openEnd : n - 1) : new Ye(dr(o.content, n, d), o.openStart, o.openEnd);
  }
  mustMoveInline() {
    if (!this.$to.parent.isTextblock)
      return -1;
    let n = this.frontier[this.depth], t;
    if (!n.type.isTextblock || !Ds(this.$to, this.$to.depth, n.type, n.match, !1) || this.$to.depth == this.depth && (t = this.findCloseLevel(this.$to)) && t.depth == this.depth)
      return -1;
    let { depth: a } = this.$to, l = this.$to.after(a);
    for (; a > 1 && l == this.$to.end(--a); )
      ++l;
    return l;
  }
  findCloseLevel(n) {
    e: for (let t = Math.min(this.depth, n.depth); t >= 0; t--) {
      let { match: a, type: l } = this.frontier[t], r = t < n.depth && n.end(t + 1) == n.pos + (n.depth - (t + 1)), o = Ds(n, t, l, a, r);
      if (o) {
        for (let i = t - 1; i >= 0; i--) {
          let { match: s, type: d } = this.frontier[i], u = Ds(n, i, d, s, !0);
          if (!u || u.childCount)
            continue e;
        }
        return { depth: t, fit: o, move: r ? n.doc.resolve(n.after(t + 1)) : n };
      }
    }
  }
  close(n) {
    let t = this.findCloseLevel(n);
    if (!t)
      return null;
    for (; this.depth > t.depth; )
      this.closeFrontierNode();
    t.fit.childCount && (this.placed = ur(this.placed, t.depth, t.fit)), n = t.move;
    for (let a = t.depth + 1; a <= n.depth; a++) {
      let l = n.node(a), r = l.type.contentMatch.fillBefore(l.content, !0, n.index(a));
      this.openFrontierNode(l.type, l.attrs, r);
    }
    return n;
  }
  openFrontierNode(n, t = null, a) {
    let l = this.frontier[this.depth];
    l.match = l.match.matchType(n), this.placed = ur(this.placed, this.depth, Pe.from(n.create(t, a))), this.frontier.push({ type: n, match: n.contentMatch });
  }
  closeFrontierNode() {
    let t = this.frontier.pop().match.fillBefore(Pe.empty, !0);
    t.childCount && (this.placed = ur(this.placed, this.frontier.length, t));
  }
}
function dr(e, n, t) {
  return n == 0 ? e.cutByIndex(t, e.childCount) : e.replaceChild(0, e.firstChild.copy(dr(e.firstChild.content, n - 1, t)));
}
function ur(e, n, t) {
  return n == 0 ? e.append(t) : e.replaceChild(e.childCount - 1, e.lastChild.copy(ur(e.lastChild.content, n - 1, t)));
}
function Ms(e, n) {
  for (let t = 0; t < n; t++)
    e = e.firstChild.content;
  return e;
}
function rp(e, n, t) {
  if (n <= 0)
    return e;
  let a = e.content;
  return n > 1 && (a = a.replaceChild(0, rp(a.firstChild, n - 1, a.childCount == 1 ? t - 1 : 0))), n > 0 && (a = e.type.contentMatch.fillBefore(a).append(a), t <= 0 && (a = a.append(e.type.contentMatch.matchFragment(a).fillBefore(Pe.empty, !0)))), e.copy(a);
}
function Ds(e, n, t, a, l) {
  let r = e.node(n), o = l ? e.indexAfter(n) : e.index(n);
  if (o == r.childCount && !t.compatibleContent(r.type))
    return null;
  let i = a.fillBefore(r.content, !0, o);
  return i && !T$(t, r.content, o) ? i : null;
}
function T$(e, n, t) {
  for (let a = t; a < n.childCount; a++)
    if (!e.allowsMarks(n.child(a).marks))
      return !0;
  return !1;
}
function L$(e) {
  return e.spec.defining || e.spec.definingForContent;
}
function E$(e, n, t, a) {
  if (!a.size)
    return e.deleteRange(n, t);
  let l = e.doc.resolve(n), r = e.doc.resolve(t);
  if (lp(l, r, a))
    return e.step(new Bt(n, t, a));
  let o = ip(l, r);
  o[o.length - 1] == 0 && o.pop();
  let i = -(l.depth + 1);
  o.unshift(i);
  for (let b = l.depth, h = l.pos - 1; b > 0; b--, h--) {
    let m = l.node(b).type.spec;
    if (m.defining || m.definingAsContext || m.isolating)
      break;
    o.indexOf(b) > -1 ? i = b : l.before(b) == h && o.splice(1, 0, -b);
  }
  let s = o.indexOf(i), d = [], u = a.openStart;
  for (let b = a.content, h = 0; ; h++) {
    let m = b.firstChild;
    if (d.push(m), h == a.openStart)
      break;
    b = m.content;
  }
  for (let b = u - 1; b >= 0; b--) {
    let h = d[b], m = L$(h.type);
    if (m && !h.sameMarkup(l.node(Math.abs(i) - 1)))
      u = b;
    else if (m || !h.type.isTextblock)
      break;
  }
  for (let b = a.openStart; b >= 0; b--) {
    let h = (b + u + 1) % (a.openStart + 1), m = d[h];
    if (m)
      for (let x = 0; x < o.length; x++) {
        let y = o[(x + s) % o.length], w = !0;
        y < 0 && (w = !1, y = -y);
        let S = l.node(y - 1), $ = l.index(y - 1);
        if (S.canReplaceWith($, $, m.type, m.marks))
          return e.replace(l.before(y), w ? r.after(y) : t, new Ye(op(a.content, 0, a.openStart, h), h, a.openEnd));
      }
  }
  let f = e.steps.length;
  for (let b = o.length - 1; b >= 0 && (e.replace(n, t, a), !(e.steps.length > f)); b--) {
    let h = o[b];
    h < 0 || (n = l.before(h), t = r.after(h));
  }
}
function op(e, n, t, a, l) {
  if (n < t) {
    let r = e.firstChild;
    e = e.replaceChild(0, r.copy(op(r.content, n + 1, t, a, r)));
  }
  if (n > a) {
    let r = l.contentMatchAt(0), o = r.fillBefore(e).append(e);
    e = o.append(r.matchFragment(o).fillBefore(Pe.empty, !0));
  }
  return e;
}
function A$(e, n, t, a) {
  if (!a.isInline && n == t && e.doc.resolve(n).parent.content.size) {
    let l = $$(e.doc, n, a.type);
    l != null && (n = t = l);
  }
  e.replaceRange(n, t, new Ye(Pe.from(a), 0, 0));
}
function R$(e, n, t) {
  let a = e.doc.resolve(n), l = e.doc.resolve(t);
  if (a.parent.isTextblock && l.parent.isTextblock && a.start() != l.start() && a.parentOffset == 0 && l.parentOffset == 0) {
    let o = a.sharedDepth(t), i = !1;
    for (let s = a.depth; s > o; s--)
      a.node(s).type.spec.isolating && (i = !0);
    for (let s = l.depth; s > o; s--)
      l.node(s).type.spec.isolating && (i = !0);
    if (!i) {
      for (let s = a.depth; s > 0 && n == a.start(s); s--)
        n = a.before(s);
      for (let s = l.depth; s > 0 && t == l.start(s); s--)
        t = l.before(s);
      a = e.doc.resolve(n), l = e.doc.resolve(t);
    }
  }
  let r = ip(a, l);
  for (let o = 0; o < r.length; o++) {
    let i = r[o], s = o == r.length - 1;
    if (s && i == 0 || a.node(i).type.contentMatch.validEnd)
      return e.delete(a.start(i), l.end(i));
    if (i > 0 && (s || a.node(i - 1).canReplace(a.index(i - 1), l.indexAfter(i - 1))))
      return e.delete(a.before(i), l.after(i));
  }
  for (let o = 1; o <= a.depth && o <= l.depth; o++)
    if (n - a.start(o) == a.depth - o && t > a.end(o) && l.end(o) - t != l.depth - o && a.start(o - 1) == l.start(o - 1) && a.node(o - 1).canReplace(a.index(o - 1), l.index(o - 1)))
      return e.delete(a.before(o), t);
  e.delete(n, t);
}
function ip(e, n) {
  let t = [], a = Math.min(e.depth, n.depth);
  for (let l = a; l >= 0; l--) {
    let r = e.start(l);
    if (r < e.pos - (e.depth - l) || n.end(l) > n.pos + (n.depth - l) || e.node(l).type.spec.isolating || n.node(l).type.spec.isolating)
      break;
    (r == n.start(l) || l == e.depth && l == n.depth && e.parent.inlineContent && n.parent.inlineContent && l && n.start(l - 1) == r - 1) && t.push(l);
  }
  return t;
}
class Ll extends _t {
  /**
  Construct an attribute step.
  */
  constructor(n, t, a) {
    super(), this.pos = n, this.attr = t, this.value = a;
  }
  apply(n) {
    let t = n.nodeAt(this.pos);
    if (!t)
      return Mt.fail("No node at attribute step's position");
    let a = /* @__PURE__ */ Object.create(null);
    for (let r in t.attrs)
      a[r] = t.attrs[r];
    a[this.attr] = this.value;
    let l = t.type.create(a, null, t.marks);
    return Mt.fromReplace(n, this.pos, this.pos + 1, new Ye(Pe.from(l), 0, t.isLeaf ? 0 : 1));
  }
  getMap() {
    return hn.empty;
  }
  invert(n) {
    return new Ll(this.pos, this.attr, n.nodeAt(this.pos).attrs[this.attr]);
  }
  map(n) {
    let t = n.mapResult(this.pos, 1);
    return t.deletedAfter ? null : new Ll(t.pos, this.attr, this.value);
  }
  toJSON() {
    return { stepType: "attr", pos: this.pos, attr: this.attr, value: this.value };
  }
  static fromJSON(n, t) {
    if (typeof t.pos != "number" || typeof t.attr != "string")
      throw new RangeError("Invalid input for AttrStep.fromJSON");
    return new Ll(t.pos, t.attr, t.value);
  }
}
_t.jsonID("attr", Ll);
class Nr extends _t {
  /**
  Construct an attribute step.
  */
  constructor(n, t) {
    super(), this.attr = n, this.value = t;
  }
  apply(n) {
    let t = /* @__PURE__ */ Object.create(null);
    for (let l in n.attrs)
      t[l] = n.attrs[l];
    t[this.attr] = this.value;
    let a = n.type.create(t, n.content, n.marks);
    return Mt.ok(a);
  }
  getMap() {
    return hn.empty;
  }
  invert(n) {
    return new Nr(this.attr, n.attrs[this.attr]);
  }
  map(n) {
    return this;
  }
  toJSON() {
    return { stepType: "docAttr", attr: this.attr, value: this.value };
  }
  static fromJSON(n, t) {
    if (typeof t.attr != "string")
      throw new RangeError("Invalid input for DocAttrStep.fromJSON");
    return new Nr(t.attr, t.value);
  }
}
_t.jsonID("docAttr", Nr);
let Vl = class extends Error {
};
Vl = function e(n) {
  let t = Error.call(this, n);
  return t.__proto__ = e.prototype, t;
};
Vl.prototype = Object.create(Error.prototype);
Vl.prototype.constructor = Vl;
Vl.prototype.name = "TransformError";
class sp {
  /**
  Create a transform that starts with the given document.
  */
  constructor(n) {
    this.doc = n, this.steps = [], this.docs = [], this.mapping = new Vr();
  }
  /**
  The starting document.
  */
  get before() {
    return this.docs.length ? this.docs[0] : this.doc;
  }
  /**
  Apply a new step in this transform, saving the result. Throws an
  error when the step fails.
  */
  step(n) {
    let t = this.maybeStep(n);
    if (t.failed)
      throw new Vl(t.failed);
    return this;
  }
  /**
  Try to apply a step in this transformation, ignoring it if it
  fails. Returns the step result.
  */
  maybeStep(n) {
    let t = n.apply(this.doc);
    return t.failed || this.addStep(n, t.doc), t;
  }
  /**
  True when the document has been changed (when there are any
  steps).
  */
  get docChanged() {
    return this.steps.length > 0;
  }
  /**
  Return a single range, in post-transform document positions,
  that covers all content changed by this transform. Returns null
  if no replacements are made. Note that this will ignore changes
  that add/remove marks without replacing the underlying content.
  */
  changedRange() {
    let n = 1e9, t = -1e9;
    for (let a = 0; a < this.mapping.maps.length; a++) {
      let l = this.mapping.maps[a];
      a && (n = l.map(n, 1), t = l.map(t, -1)), l.forEach((r, o, i, s) => {
        n = Math.min(n, i), t = Math.max(t, s);
      });
    }
    return n == 1e9 ? null : { from: n, to: t };
  }
  /**
  @internal
  */
  addStep(n, t) {
    this.docs.push(this.doc), this.steps.push(n), this.mapping.appendMap(n.getMap()), this.doc = t;
  }
  /**
  Replace the part of the document between `from` and `to` with the
  given `slice`.
  */
  replace(n, t = n, a = Ye.empty) {
    let l = _i(this.doc, n, t, a);
    return l && this.step(l), this;
  }
  /**
  Replace the given range with the given content, which may be a
  fragment, node, or array of nodes.
  */
  replaceWith(n, t, a) {
    return this.replace(n, t, new Ye(Pe.from(a), 0, 0));
  }
  /**
  Delete the content between the given positions.
  */
  delete(n, t) {
    return this.replace(n, t, Ye.empty);
  }
  /**
  Insert the given content at the given position.
  */
  insert(n, t) {
    return this.replaceWith(n, n, t);
  }
  /**
  Replace a range of the document with a given slice, using
  `from`, `to`, and the slice's
  [`openStart`](https://prosemirror.net/docs/ref/#model.Slice.openStart) property as hints, rather
  than fixed start and end points. This method may grow the
  replaced area or close open nodes in the slice in order to get a
  fit that is more in line with WYSIWYG expectations, by dropping
  fully covered parent nodes of the replaced region when they are
  marked [non-defining as
  context](https://prosemirror.net/docs/ref/#model.NodeSpec.definingAsContext), or including an
  open parent node from the slice that _is_ marked as [defining
  its content](https://prosemirror.net/docs/ref/#model.NodeSpec.definingForContent).
  
  This is the method, for example, to handle paste. The similar
  [`replace`](https://prosemirror.net/docs/ref/#transform.Transform.replace) method is a more
  primitive tool which will _not_ move the start and end of its given
  range, and is useful in situations where you need more precise
  control over what happens.
  */
  replaceRange(n, t, a) {
    return E$(this, n, t, a), this;
  }
  /**
  Replace the given range with a node, but use `from` and `to` as
  hints, rather than precise positions. When from and to are the same
  and are at the start or end of a parent node in which the given
  node doesn't fit, this method may _move_ them out towards a parent
  that does allow the given node to be placed. When the given range
  completely covers a parent node, this method may completely replace
  that parent node.
  */
  replaceRangeWith(n, t, a) {
    return A$(this, n, t, a), this;
  }
  /**
  Delete the given range, expanding it to cover fully covered
  parent nodes until a valid replace is found.
  */
  deleteRange(n, t) {
    return R$(this, n, t), this;
  }
  /**
  Split the content in the given range off from its parent, if there
  is sibling content before or after it, and move it up the tree to
  the depth specified by `target`. You'll probably want to use
  [`liftTarget`](https://prosemirror.net/docs/ref/#transform.liftTarget) to compute `target`, to make
  sure the lift is valid.
  */
  lift(n, t) {
    return g$(this, n, t), this;
  }
  /**
  Join the blocks around the given position. If depth is 2, their
  last and first siblings are also joined, and so on.
  */
  join(n, t = 1) {
    return S$(this, n, t), this;
  }
  /**
  Wrap the given [range](https://prosemirror.net/docs/ref/#model.NodeRange) in the given set of wrappers.
  The wrappers are assumed to be valid in this position, and should
  probably be computed with [`findWrapping`](https://prosemirror.net/docs/ref/#transform.findWrapping).
  */
  wrap(n, t) {
    return v$(this, n, t), this;
  }
  /**
  Set the type of all textblocks (partly) between `from` and `to` to
  the given node type with the given attributes.
  */
  setBlockType(n, t = n, a, l = null) {
    return x$(this, n, t, a, l), this;
  }
  /**
  Change the type, attributes, and/or marks of the node at `pos`.
  When `type` isn't given, the existing node type is preserved,
  */
  setNodeMarkup(n, t, a = null, l) {
    return k$(this, n, t, a, l), this;
  }
  /**
  Set a single attribute on a given node to a new value.
  The `pos` addresses the document content. Use `setDocAttribute`
  to set attributes on the document itself.
  */
  setNodeAttribute(n, t, a) {
    return this.step(new Ll(n, t, a)), this;
  }
  /**
  Set a single attribute on the document to a new value.
  */
  setDocAttribute(n, t) {
    return this.step(new Nr(n, t)), this;
  }
  /**
  Add a mark to the node at position `pos`.
  */
  addNodeMark(n, t) {
    return this.step(new ka(n, t)), this;
  }
  /**
  Remove a mark (or all marks of the given type) from the node at
  position `pos`.
  */
  removeNodeMark(n, t) {
    let a = this.doc.nodeAt(n);
    if (!a)
      throw new RangeError("No node at position " + n);
    if (t instanceof mt)
      t.isInSet(a.marks) && this.step(new ul(n, t));
    else {
      let l = a.marks, r, o = [];
      for (; r = t.isInSet(l); )
        o.push(new ul(n, r)), l = r.removeFromSet(l);
      for (let i = o.length - 1; i >= 0; i--)
        this.step(o[i]);
    }
    return this;
  }
  /**
  Split the node at the given position, and optionally, if `depth` is
  greater than one, any number of nodes above that. By default, the
  parts split off will inherit the node type of the original node.
  This can be changed by passing an array of types and attributes to
  use after the split (with the outermost nodes coming first).
  */
  split(n, t = 1, a) {
    return w$(this, n, t, a), this;
  }
  /**
  Add the given mark to the inline content between `from` and `to`.
  */
  addMark(n, t, a) {
    return f$(this, n, t, a), this;
  }
  /**
  Remove marks from inline nodes between `from` and `to`. When
  `mark` is a single mark, remove precisely that mark. When it is
  a mark type, remove all marks of that type. When it is null,
  remove all marks of any type.
  */
  removeMark(n, t, a) {
    return h$(this, n, t, a), this;
  }
  /**
  Removes all marks and nodes from the content of the node at
  `pos` that don't match the given new parent node type. Accepts
  an optional starting [content match](https://prosemirror.net/docs/ref/#model.ContentMatch) as
  third argument.
  */
  clearIncompatible(n, t, a) {
    return Gu(this, n, t, a), this;
  }
}
const zs = /* @__PURE__ */ Object.create(null);
class rt {
  /**
  Initialize a selection with the head and anchor and ranges. If no
  ranges are given, constructs a single range across `$anchor` and
  `$head`.
  */
  constructor(n, t, a) {
    this.$anchor = n, this.$head = t, this.ranges = a || [new B$(n.min(t), n.max(t))];
  }
  /**
  The selection's anchor, as an unresolved position.
  */
  get anchor() {
    return this.$anchor.pos;
  }
  /**
  The selection's head.
  */
  get head() {
    return this.$head.pos;
  }
  /**
  The lower bound of the selection's main range.
  */
  get from() {
    return this.$from.pos;
  }
  /**
  The upper bound of the selection's main range.
  */
  get to() {
    return this.$to.pos;
  }
  /**
  The resolved lower  bound of the selection's main range.
  */
  get $from() {
    return this.ranges[0].$from;
  }
  /**
  The resolved upper bound of the selection's main range.
  */
  get $to() {
    return this.ranges[0].$to;
  }
  /**
  Indicates whether the selection contains any content.
  */
  get empty() {
    let n = this.ranges;
    for (let t = 0; t < n.length; t++)
      if (n[t].$from.pos != n[t].$to.pos)
        return !1;
    return !0;
  }
  /**
  Get the content of this selection as a slice.
  */
  content() {
    return this.$from.doc.slice(this.from, this.to, !0);
  }
  /**
  Replace the selection with a slice or, if no slice is given,
  delete the selection. Will append to the given transaction.
  */
  replace(n, t = Ye.empty) {
    let a = t.content.lastChild, l = null;
    for (let i = 0; i < t.openEnd; i++)
      l = a, a = a.lastChild;
    let r = n.steps.length, o = this.ranges;
    for (let i = 0; i < o.length; i++) {
      let { $from: s, $to: d } = o[i], u = n.mapping.slice(r);
      n.replaceRange(u.map(s.pos), u.map(d.pos), i ? Ye.empty : t), i == 0 && Df(n, r, (a ? a.isInline : l && l.isTextblock) ? -1 : 1);
    }
  }
  /**
  Replace the selection with the given node, appending the changes
  to the given transaction.
  */
  replaceWith(n, t) {
    let a = n.steps.length, l = this.ranges;
    for (let r = 0; r < l.length; r++) {
      let { $from: o, $to: i } = l[r], s = n.mapping.slice(a), d = s.map(o.pos), u = s.map(i.pos);
      r ? n.deleteRange(d, u) : (n.replaceRangeWith(d, u, t), Df(n, a, t.isInline ? -1 : 1));
    }
  }
  /**
  Find a valid cursor or leaf node selection starting at the given
  position and searching back if `dir` is negative, and forward if
  positive. When `textOnly` is true, only consider cursor
  selections. Will return null when no valid selection position is
  found.
  */
  static findFrom(n, t, a = !1) {
    let l = n.parent.inlineContent ? new nt(n) : xl(n.node(0), n.parent, n.pos, n.index(), t, a);
    if (l)
      return l;
    for (let r = n.depth - 1; r >= 0; r--) {
      let o = t < 0 ? xl(n.node(0), n.node(r), n.before(r + 1), n.index(r), t, a) : xl(n.node(0), n.node(r), n.after(r + 1), n.index(r) + 1, t, a);
      if (o)
        return o;
    }
    return null;
  }
  /**
  Find a valid cursor or leaf node selection near the given
  position. Searches forward first by default, but if `bias` is
  negative, it will search backwards first.
  */
  static near(n, t = 1) {
    return this.findFrom(n, t) || this.findFrom(n, -t) || new bn(n.node(0));
  }
  /**
  Find the cursor or leaf node selection closest to the start of
  the given document. Will return an
  [`AllSelection`](https://prosemirror.net/docs/ref/#state.AllSelection) if no valid position
  exists.
  */
  static atStart(n) {
    return xl(n, n, 0, 0, 1) || new bn(n);
  }
  /**
  Find the cursor or leaf node selection closest to the end of the
  given document.
  */
  static atEnd(n) {
    return xl(n, n, n.content.size, n.childCount, -1) || new bn(n);
  }
  /**
  Deserialize the JSON representation of a selection. Must be
  implemented for custom classes (as a static class method).
  */
  static fromJSON(n, t) {
    if (!t || !t.type)
      throw new RangeError("Invalid input for Selection.fromJSON");
    let a = zs[t.type];
    if (!a)
      throw new RangeError(`No selection type ${t.type} defined`);
    return a.fromJSON(n, t);
  }
  /**
  To be able to deserialize selections from JSON, custom selection
  classes must register themselves with an ID string, so that they
  can be disambiguated. Try to pick something that's unlikely to
  clash with classes from other modules.
  */
  static jsonID(n, t) {
    if (n in zs)
      throw new RangeError("Duplicate use of selection JSON ID " + n);
    return zs[n] = t, t.prototype.jsonID = n, t;
  }
  /**
  Get a [bookmark](https://prosemirror.net/docs/ref/#state.SelectionBookmark) for this selection,
  which is a value that can be mapped without having access to a
  current document, and later resolved to a real selection for a
  given document again. (This is used mostly by the history to
  track and restore old selections.) The default implementation of
  this method just converts the selection to a text selection and
  returns the bookmark for that.
  */
  getBookmark() {
    return nt.between(this.$anchor, this.$head).getBookmark();
  }
}
rt.prototype.visible = !0;
class B$ {
  /**
  Create a range.
  */
  constructor(n, t) {
    this.$from = n, this.$to = t;
  }
}
let Bf = !1;
function Mf(e) {
  !Bf && !e.parent.inlineContent && (Bf = !0, console.warn("TextSelection endpoint not pointing into a node with inline content (" + e.parent.type.name + ")"));
}
class nt extends rt {
  /**
  Construct a text selection between the given points.
  */
  constructor(n, t = n) {
    Mf(n), Mf(t), super(n, t);
  }
  /**
  Returns a resolved position if this is a cursor selection (an
  empty text selection), and null otherwise.
  */
  get $cursor() {
    return this.$anchor.pos == this.$head.pos ? this.$head : null;
  }
  map(n, t) {
    let a = n.resolve(t.map(this.head));
    if (!a.parent.inlineContent)
      return rt.near(a);
    let l = n.resolve(t.map(this.anchor));
    return new nt(l.parent.inlineContent ? l : a, a);
  }
  replace(n, t = Ye.empty) {
    if (super.replace(n, t), t == Ye.empty) {
      let a = this.$from.marksAcross(this.$to);
      a && n.ensureMarks(a);
    }
  }
  eq(n) {
    return n instanceof nt && n.anchor == this.anchor && n.head == this.head;
  }
  getBookmark() {
    return new es(this.anchor, this.head);
  }
  toJSON() {
    return { type: "text", anchor: this.anchor, head: this.head };
  }
  /**
  @internal
  */
  static fromJSON(n, t) {
    if (typeof t.anchor != "number" || typeof t.head != "number")
      throw new RangeError("Invalid input for TextSelection.fromJSON");
    return new nt(n.resolve(t.anchor), n.resolve(t.head));
  }
  /**
  Create a text selection from non-resolved positions.
  */
  static create(n, t, a = t) {
    let l = n.resolve(t);
    return new this(l, a == t ? l : n.resolve(a));
  }
  /**
  Return a text selection that spans the given positions or, if
  they aren't text positions, find a text selection near them.
  `bias` determines whether the method searches forward (default)
  or backwards (negative number) first. Will fall back to calling
  [`Selection.near`](https://prosemirror.net/docs/ref/#state.Selection^near) when the document
  doesn't contain a valid text position.
  */
  static between(n, t, a) {
    let l = n.pos - t.pos;
    if ((!a || l) && (a = l >= 0 ? 1 : -1), !t.parent.inlineContent) {
      let r = rt.findFrom(t, a, !0) || rt.findFrom(t, -a, !0);
      if (r)
        t = r.$head;
      else
        return rt.near(t, a);
    }
    return n.parent.inlineContent || (l == 0 ? n = t : (n = (rt.findFrom(n, -a, !0) || rt.findFrom(n, a, !0)).$anchor, n.pos < t.pos != l < 0 && (n = t))), new nt(n, t);
  }
}
rt.jsonID("text", nt);
class es {
  constructor(n, t) {
    this.anchor = n, this.head = t;
  }
  map(n) {
    return new es(n.map(this.anchor), n.map(this.head));
  }
  resolve(n) {
    return nt.between(n.resolve(this.anchor), n.resolve(this.head));
  }
}
class Xe extends rt {
  /**
  Create a node selection. Does not verify the validity of its
  argument.
  */
  constructor(n) {
    let t = n.nodeAfter, a = n.node(0).resolve(n.pos + t.nodeSize);
    super(n, a), this.node = t;
  }
  map(n, t) {
    let { deleted: a, pos: l } = t.mapResult(this.anchor), r = n.resolve(l);
    return a ? rt.near(r) : new Xe(r);
  }
  content() {
    return new Ye(Pe.from(this.node), 0, 0);
  }
  eq(n) {
    return n instanceof Xe && n.anchor == this.anchor;
  }
  toJSON() {
    return { type: "node", anchor: this.anchor };
  }
  getBookmark() {
    return new Yu(this.anchor);
  }
  /**
  @internal
  */
  static fromJSON(n, t) {
    if (typeof t.anchor != "number")
      throw new RangeError("Invalid input for NodeSelection.fromJSON");
    return new Xe(n.resolve(t.anchor));
  }
  /**
  Create a node selection from non-resolved positions.
  */
  static create(n, t) {
    return new Xe(n.resolve(t));
  }
  /**
  Determines whether the given node may be selected as a node
  selection.
  */
  static isSelectable(n) {
    return !n.isText && n.type.spec.selectable !== !1;
  }
}
Xe.prototype.visible = !1;
rt.jsonID("node", Xe);
class Yu {
  constructor(n) {
    this.anchor = n;
  }
  map(n) {
    let { deleted: t, pos: a } = n.mapResult(this.anchor);
    return t ? new es(a, a) : new Yu(a);
  }
  resolve(n) {
    let t = n.resolve(this.anchor), a = t.nodeAfter;
    return a && Xe.isSelectable(a) ? new Xe(t) : rt.near(t);
  }
}
class bn extends rt {
  /**
  Create an all-selection over the given document.
  */
  constructor(n) {
    super(n.resolve(0), n.resolve(n.content.size));
  }
  replace(n, t = Ye.empty) {
    if (t == Ye.empty) {
      n.delete(0, n.doc.content.size);
      let a = rt.atStart(n.doc);
      a.eq(n.selection) || n.setSelection(a);
    } else
      super.replace(n, t);
  }
  toJSON() {
    return { type: "all" };
  }
  /**
  @internal
  */
  static fromJSON(n) {
    return new bn(n);
  }
  map(n) {
    return new bn(n);
  }
  eq(n) {
    return n instanceof bn;
  }
  getBookmark() {
    return M$;
  }
}
rt.jsonID("all", bn);
const M$ = {
  map() {
    return this;
  },
  resolve(e) {
    return new bn(e);
  }
};
function xl(e, n, t, a, l, r = !1) {
  if (n.inlineContent)
    return nt.create(e, t);
  for (let o = a - (l > 0 ? 0 : 1); l > 0 ? o < n.childCount : o >= 0; o += l) {
    let i = n.child(o);
    if (i.isAtom) {
      if (!r && Xe.isSelectable(i))
        return Xe.create(e, t - (l < 0 ? i.nodeSize : 0));
    } else {
      let s = xl(e, i, t + l, l < 0 ? i.childCount : 0, l, r);
      if (s)
        return s;
    }
    t += i.nodeSize * l;
  }
  return null;
}
function Df(e, n, t) {
  let a = e.steps.length - 1;
  if (a < n)
    return;
  let l = e.steps[a];
  if (!(l instanceof Bt || l instanceof Vt))
    return;
  let r = e.mapping.maps[a], o;
  r.forEach((i, s, d, u) => {
    o == null && (o = u);
  }), e.setSelection(rt.near(e.doc.resolve(o), t));
}
const zf = 1, ko = 2, Of = 4;
class D$ extends sp {
  /**
  @internal
  */
  constructor(n) {
    super(n.doc), this.curSelectionFor = 0, this.updated = 0, this.meta = /* @__PURE__ */ Object.create(null), this.time = Date.now(), this.curSelection = n.selection, this.storedMarks = n.storedMarks;
  }
  /**
  The transaction's current selection. This defaults to the editor
  selection [mapped](https://prosemirror.net/docs/ref/#state.Selection.map) through the steps in the
  transaction, but can be overwritten with
  [`setSelection`](https://prosemirror.net/docs/ref/#state.Transaction.setSelection).
  */
  get selection() {
    return this.curSelectionFor < this.steps.length && (this.curSelection = this.curSelection.map(this.doc, this.mapping.slice(this.curSelectionFor)), this.curSelectionFor = this.steps.length), this.curSelection;
  }
  /**
  Update the transaction's current selection. Will determine the
  selection that the editor gets when the transaction is applied.
  */
  setSelection(n) {
    if (n.$from.doc != this.doc)
      throw new RangeError("Selection passed to setSelection must point at the current document");
    return this.curSelection = n, this.curSelectionFor = this.steps.length, this.updated = (this.updated | zf) & ~ko, this.storedMarks = null, this;
  }
  /**
  Whether the selection was explicitly updated by this transaction.
  */
  get selectionSet() {
    return (this.updated & zf) > 0;
  }
  /**
  Set the current stored marks.
  */
  setStoredMarks(n) {
    return this.storedMarks = n, this.updated |= ko, this;
  }
  /**
  Make sure the current stored marks or, if that is null, the marks
  at the selection, match the given set of marks. Does nothing if
  this is already the case.
  */
  ensureMarks(n) {
    return mt.sameSet(this.storedMarks || this.selection.$from.marks(), n) || this.setStoredMarks(n), this;
  }
  /**
  Add a mark to the set of stored marks.
  */
  addStoredMark(n) {
    return this.ensureMarks(n.addToSet(this.storedMarks || this.selection.$head.marks()));
  }
  /**
  Remove a mark or mark type from the set of stored marks.
  */
  removeStoredMark(n) {
    return this.ensureMarks(n.removeFromSet(this.storedMarks || this.selection.$head.marks()));
  }
  /**
  Whether the stored marks were explicitly set for this transaction.
  */
  get storedMarksSet() {
    return (this.updated & ko) > 0;
  }
  /**
  @internal
  */
  addStep(n, t) {
    super.addStep(n, t), this.updated = this.updated & ~ko, this.storedMarks = null;
  }
  /**
  Update the timestamp for the transaction.
  */
  setTime(n) {
    return this.time = n, this;
  }
  /**
  Replace the current selection with the given slice.
  */
  replaceSelection(n) {
    return this.selection.replace(this, n), this;
  }
  /**
  Replace the selection with the given node. When `inheritMarks` is
  true and the content is inline, it inherits the marks from the
  place where it is inserted.
  */
  replaceSelectionWith(n, t = !0) {
    let a = this.selection;
    return t && (n = n.mark(this.storedMarks || (a.empty ? a.$from.marks() : a.$from.marksAcross(a.$to) || mt.none))), a.replaceWith(this, n), this;
  }
  /**
  Delete the selection.
  */
  deleteSelection() {
    return this.selection.replace(this), this;
  }
  /**
  Replace the given range, or the selection if no range is given,
  with a text node containing the given string.
  */
  insertText(n, t, a) {
    let l = this.doc.type.schema;
    if (t == null)
      return n ? this.replaceSelectionWith(l.text(n), !0) : this.deleteSelection();
    {
      if (a == null && (a = t), !n)
        return this.deleteRange(t, a);
      let r = this.storedMarks;
      if (!r) {
        let o = this.doc.resolve(t);
        r = a == t ? o.marks() : o.marksAcross(this.doc.resolve(a));
      }
      return this.replaceRangeWith(t, a, l.text(n, r)), !this.selection.empty && this.selection.to == t + n.length && this.setSelection(rt.near(this.selection.$to)), this;
    }
  }
  /**
  Store a metadata property in this transaction, keyed either by
  name or by plugin.
  */
  setMeta(n, t) {
    return this.meta[typeof n == "string" ? n : n.key] = t, this;
  }
  /**
  Retrieve a metadata property for a given name or plugin.
  */
  getMeta(n) {
    return this.meta[typeof n == "string" ? n : n.key];
  }
  /**
  Returns true if this transaction doesn't contain any metadata,
  and can thus safely be extended.
  */
  get isGeneric() {
    for (let n in this.meta)
      return !1;
    return !0;
  }
  /**
  Indicate that the editor should scroll the selection into view
  when updated to the state produced by this transaction.
  */
  scrollIntoView() {
    return this.updated |= Of, this;
  }
  /**
  True when this transaction has had `scrollIntoView` called on it.
  */
  get scrolledIntoView() {
    return (this.updated & Of) > 0;
  }
}
function Pf(e, n) {
  return !n || !e ? e : e.bind(n);
}
class cr {
  constructor(n, t, a) {
    this.name = n, this.init = Pf(t.init, a), this.apply = Pf(t.apply, a);
  }
}
const z$ = [
  new cr("doc", {
    init(e) {
      return e.doc || e.schema.topNodeType.createAndFill();
    },
    apply(e) {
      return e.doc;
    }
  }),
  new cr("selection", {
    init(e, n) {
      return e.selection || rt.atStart(n.doc);
    },
    apply(e) {
      return e.selection;
    }
  }),
  new cr("storedMarks", {
    init(e) {
      return e.storedMarks || null;
    },
    apply(e, n, t, a) {
      return a.selection.$cursor ? e.storedMarks : null;
    }
  }),
  new cr("scrollToSelection", {
    init() {
      return 0;
    },
    apply(e, n) {
      return e.scrolledIntoView ? n + 1 : n;
    }
  })
];
class Os {
  constructor(n, t) {
    this.schema = n, this.plugins = [], this.pluginsByKey = /* @__PURE__ */ Object.create(null), this.fields = z$.slice(), t && t.forEach((a) => {
      if (this.pluginsByKey[a.key])
        throw new RangeError("Adding different instances of a keyed plugin (" + a.key + ")");
      this.plugins.push(a), this.pluginsByKey[a.key] = a, a.spec.state && this.fields.push(new cr(a.key, a.spec.state, a));
    });
  }
}
class Cl {
  /**
  @internal
  */
  constructor(n) {
    this.config = n;
  }
  /**
  The schema of the state's document.
  */
  get schema() {
    return this.config.schema;
  }
  /**
  The plugins that are active in this state.
  */
  get plugins() {
    return this.config.plugins;
  }
  /**
  Apply the given transaction to produce a new state.
  */
  apply(n) {
    return this.applyTransaction(n).state;
  }
  /**
  @internal
  */
  filterTransaction(n, t = -1) {
    for (let a = 0; a < this.config.plugins.length; a++)
      if (a != t) {
        let l = this.config.plugins[a];
        if (l.spec.filterTransaction && !l.spec.filterTransaction.call(l, n, this))
          return !1;
      }
    return !0;
  }
  /**
  Verbose variant of [`apply`](https://prosemirror.net/docs/ref/#state.EditorState.apply) that
  returns the precise transactions that were applied (which might
  be influenced by the [transaction
  hooks](https://prosemirror.net/docs/ref/#state.PluginSpec.filterTransaction) of
  plugins) along with the new state.
  */
  applyTransaction(n) {
    if (!this.filterTransaction(n))
      return { state: this, transactions: [] };
    let t = [n], a = this.applyInner(n), l = null;
    for (; ; ) {
      let r = !1;
      for (let o = 0; o < this.config.plugins.length; o++) {
        let i = this.config.plugins[o];
        if (i.spec.appendTransaction) {
          let s = l ? l[o].n : 0, d = l ? l[o].state : this, u = s < t.length && i.spec.appendTransaction.call(i, s ? t.slice(s) : t, d, a);
          if (u && a.filterTransaction(u, o)) {
            if (u.setMeta("appendedTransaction", n), !l) {
              l = [];
              for (let f = 0; f < this.config.plugins.length; f++)
                l.push(f < o ? { state: a, n: t.length } : { state: this, n: 0 });
            }
            t.push(u), a = a.applyInner(u), r = !0;
          }
          l && (l[o] = { state: a, n: t.length });
        }
      }
      if (!r)
        return { state: a, transactions: t };
    }
  }
  /**
  @internal
  */
  applyInner(n) {
    if (!n.before.eq(this.doc))
      throw new RangeError("Applying a mismatched transaction");
    let t = new Cl(this.config), a = this.config.fields;
    for (let l = 0; l < a.length; l++) {
      let r = a[l];
      t[r.name] = r.apply(n, this[r.name], this, t);
    }
    return t;
  }
  /**
  Accessor that constructs and returns a new [transaction](https://prosemirror.net/docs/ref/#state.Transaction) from this state.
  */
  get tr() {
    return new D$(this);
  }
  /**
  Create a new state.
  */
  static create(n) {
    let t = new Os(n.doc ? n.doc.type.schema : n.schema, n.plugins), a = new Cl(t);
    for (let l = 0; l < t.fields.length; l++)
      a[t.fields[l].name] = t.fields[l].init(n, a);
    return a;
  }
  /**
  Create a new state based on this one, but with an adjusted set
  of active plugins. State fields that exist in both sets of
  plugins are kept unchanged. Those that no longer exist are
  dropped, and those that are new are initialized using their
  [`init`](https://prosemirror.net/docs/ref/#state.StateField.init) method, passing in the new
  configuration object..
  */
  reconfigure(n) {
    let t = new Os(this.schema, n.plugins), a = t.fields, l = new Cl(t);
    for (let r = 0; r < a.length; r++) {
      let o = a[r].name;
      l[o] = this.hasOwnProperty(o) ? this[o] : a[r].init(n, l);
    }
    return l;
  }
  /**
  Serialize this state to JSON. If you want to serialize the state
  of plugins, pass an object mapping property names to use in the
  resulting JSON object to plugin objects. The argument may also be
  a string or number, in which case it is ignored, to support the
  way `JSON.stringify` calls `toString` methods.
  */
  toJSON(n) {
    let t = { doc: this.doc.toJSON(), selection: this.selection.toJSON() };
    if (this.storedMarks && (t.storedMarks = this.storedMarks.map((a) => a.toJSON())), n && typeof n == "object")
      for (let a in n) {
        if (a == "doc" || a == "selection")
          throw new RangeError("The JSON fields `doc` and `selection` are reserved");
        let l = n[a], r = l.spec.state;
        r && r.toJSON && (t[a] = r.toJSON.call(l, this[l.key]));
      }
    return t;
  }
  /**
  Deserialize a JSON representation of a state. `config` should
  have at least a `schema` field, and should contain array of
  plugins to initialize the state with. `pluginFields` can be used
  to deserialize the state of plugins, by associating plugin
  instances with the property names they use in the JSON object.
  */
  static fromJSON(n, t, a) {
    if (!t)
      throw new RangeError("Invalid input for EditorState.fromJSON");
    if (!n.schema)
      throw new RangeError("Required config field 'schema' missing");
    let l = new Os(n.schema, n.plugins), r = new Cl(l);
    return l.fields.forEach((o) => {
      if (o.name == "doc")
        r.doc = $a.fromJSON(n.schema, t.doc);
      else if (o.name == "selection")
        r.selection = rt.fromJSON(r.doc, t.selection);
      else if (o.name == "storedMarks")
        t.storedMarks && (r.storedMarks = t.storedMarks.map(n.schema.markFromJSON));
      else {
        if (a)
          for (let i in a) {
            let s = a[i], d = s.spec.state;
            if (s.key == o.name && d && d.fromJSON && Object.prototype.hasOwnProperty.call(t, i)) {
              r[o.name] = d.fromJSON.call(s, n, t[i], r);
              return;
            }
          }
        r[o.name] = o.init(n, r);
      }
    }), r;
  }
}
function dp(e, n, t) {
  for (let a in e) {
    let l = e[a];
    l instanceof Function ? l = l.bind(n) : a == "handleDOMEvents" && (l = dp(l, n, {})), t[a] = l;
  }
  return t;
}
class Tt {
  /**
  Create a plugin.
  */
  constructor(n) {
    this.spec = n, this.props = {}, n.props && dp(n.props, this, this.props), this.key = n.key ? n.key.key : up("plugin");
  }
  /**
  Extract the plugin's state field from an editor state.
  */
  getState(n) {
    return n[this.key];
  }
}
const Ps = /* @__PURE__ */ Object.create(null);
function up(e) {
  return e in Ps ? e + "$" + ++Ps[e] : (Ps[e] = 0, e + "$");
}
class Ot {
  /**
  Create a plugin key.
  */
  constructor(n = "key") {
    this.key = up(n);
  }
  /**
  Get the active plugin with this key, if any, from an editor
  state.
  */
  get(n) {
    return n.config.pluginsByKey[this.key];
  }
  /**
  Get the plugin's state from an editor state.
  */
  getState(n) {
    return n[this.key];
  }
}
const cp = (e, n) => e.selection.empty ? !1 : (n && n(e.tr.deleteSelection().scrollIntoView()), !0);
function fp(e, n) {
  let { $cursor: t } = e.selection;
  return !t || (n ? !n.endOfTextblock("backward", e) : t.parentOffset > 0) ? null : t;
}
const hp = (e, n, t) => {
  let a = fp(e, t);
  if (!a)
    return !1;
  let l = Ju(a);
  if (!l) {
    let o = a.blockRange(), i = o && Jl(o);
    return i == null ? !1 : (n && n(e.tr.lift(o, i).scrollIntoView()), !0);
  }
  let r = l.nodeBefore;
  if (wp(e, l, n, -1))
    return !0;
  if (a.parent.content.size == 0 && (Nl(r, "end") || Xe.isSelectable(r)))
    for (let o = a.depth; ; o--) {
      let i = _i(e.doc, a.before(o), a.after(o), Ye.empty);
      if (i && i.slice.size < i.to - i.from) {
        if (n) {
          let s = e.tr.step(i);
          s.setSelection(Nl(r, "end") ? rt.findFrom(s.doc.resolve(s.mapping.map(l.pos, -1)), -1) : Xe.create(s.doc, l.pos - r.nodeSize)), n(s.scrollIntoView());
        }
        return !0;
      }
      if (o == 1 || a.node(o - 1).childCount > 1)
        break;
    }
  return r.isAtom && l.depth == a.depth - 1 ? (n && n(e.tr.delete(l.pos - r.nodeSize, l.pos).scrollIntoView()), !0) : !1;
}, O$ = (e, n, t) => {
  let a = fp(e, t);
  if (!a)
    return !1;
  let l = Ju(a);
  return l ? bp(e, l, n) : !1;
}, P$ = (e, n, t) => {
  let a = pp(e, t);
  if (!a)
    return !1;
  let l = Zu(a);
  return l ? bp(e, l, n) : !1;
};
function bp(e, n, t) {
  let a = n.nodeBefore, l = a, r = n.pos - 1;
  for (; !l.isTextblock; r--) {
    if (l.type.spec.isolating)
      return !1;
    let u = l.lastChild;
    if (!u)
      return !1;
    l = u;
  }
  let o = n.nodeAfter, i = o, s = n.pos + 1;
  for (; !i.isTextblock; s++) {
    if (i.type.spec.isolating)
      return !1;
    let u = i.firstChild;
    if (!u)
      return !1;
    i = u;
  }
  let d = _i(e.doc, r, s, Ye.empty);
  if (!d || d.from != r || d instanceof Bt && d.slice.size >= s - r)
    return !1;
  if (t) {
    let u = e.tr.step(d);
    u.setSelection(nt.create(u.doc, r)), t(u.scrollIntoView());
  }
  return !0;
}
function Nl(e, n, t = !1) {
  for (let a = e; a; a = n == "start" ? a.firstChild : a.lastChild) {
    if (a.isTextblock)
      return !0;
    if (t && a.childCount != 1)
      return !1;
  }
  return !1;
}
const gp = (e, n, t) => {
  let { $head: a, empty: l } = e.selection, r = a;
  if (!l)
    return !1;
  if (a.parent.isTextblock) {
    if (t ? !t.endOfTextblock("backward", e) : a.parentOffset > 0)
      return !1;
    r = Ju(a);
  }
  let o = r && r.nodeBefore;
  return !o || !Xe.isSelectable(o) ? !1 : (n && n(e.tr.setSelection(Xe.create(e.doc, r.pos - o.nodeSize)).scrollIntoView()), !0);
};
function Ju(e) {
  if (!e.parent.type.spec.isolating)
    for (let n = e.depth - 1; n >= 0; n--) {
      if (e.index(n) > 0)
        return e.doc.resolve(e.before(n + 1));
      if (e.node(n).type.spec.isolating)
        break;
    }
  return null;
}
function pp(e, n) {
  let { $cursor: t } = e.selection;
  return !t || (n ? !n.endOfTextblock("forward", e) : t.parentOffset < t.parent.content.size) ? null : t;
}
const mp = (e, n, t) => {
  let a = pp(e, t);
  if (!a)
    return !1;
  let l = Zu(a);
  if (!l)
    return !1;
  let r = l.nodeAfter;
  if (wp(e, l, n, 1))
    return !0;
  if (a.parent.content.size == 0 && (Nl(r, "start") || Xe.isSelectable(r))) {
    let o = _i(e.doc, a.before(), a.after(), Ye.empty);
    if (o && o.slice.size < o.to - o.from) {
      if (n) {
        let i = e.tr.step(o);
        i.setSelection(Nl(r, "start") ? rt.findFrom(i.doc.resolve(i.mapping.map(l.pos)), 1) : Xe.create(i.doc, i.mapping.map(l.pos))), n(i.scrollIntoView());
      }
      return !0;
    }
  }
  return r.isAtom && l.depth == a.depth - 1 ? (n && n(e.tr.delete(l.pos, l.pos + r.nodeSize).scrollIntoView()), !0) : !1;
}, vp = (e, n, t) => {
  let { $head: a, empty: l } = e.selection, r = a;
  if (!l)
    return !1;
  if (a.parent.isTextblock) {
    if (t ? !t.endOfTextblock("forward", e) : a.parentOffset < a.parent.content.size)
      return !1;
    r = Zu(a);
  }
  let o = r && r.nodeAfter;
  return !o || !Xe.isSelectable(o) ? !1 : (n && n(e.tr.setSelection(Xe.create(e.doc, r.pos)).scrollIntoView()), !0);
};
function Zu(e) {
  if (!e.parent.type.spec.isolating)
    for (let n = e.depth - 1; n >= 0; n--) {
      let t = e.node(n);
      if (e.index(n) + 1 < t.childCount)
        return e.doc.resolve(e.after(n + 1));
      if (t.type.spec.isolating)
        break;
    }
  return null;
}
const F$ = (e, n) => {
  let t = e.selection, a = t instanceof Xe, l;
  if (a) {
    if (t.node.isTextblock || !Ha(e.doc, t.from))
      return !1;
    l = t.from;
  } else if (l = Qi(e.doc, t.from, -1), l == null)
    return !1;
  if (n) {
    let r = e.tr.join(l);
    a && r.setSelection(Xe.create(r.doc, l - e.doc.resolve(l).nodeBefore.nodeSize)), n(r.scrollIntoView());
  }
  return !0;
}, V$ = (e, n) => {
  let t = e.selection, a;
  if (t instanceof Xe) {
    if (t.node.isTextblock || !Ha(e.doc, t.to))
      return !1;
    a = t.to;
  } else if (a = Qi(e.doc, t.to, 1), a == null)
    return !1;
  return n && n(e.tr.join(a).scrollIntoView()), !0;
}, N$ = (e, n) => {
  let { $from: t, $to: a } = e.selection, l = t.blockRange(a), r = l && Jl(l);
  return r == null ? !1 : (n && n(e.tr.lift(l, r).scrollIntoView()), !0);
}, xp = (e, n) => {
  let { $head: t, $anchor: a } = e.selection;
  return !t.parent.type.spec.code || !t.sameParent(a) ? !1 : (n && n(e.tr.insertText(`
`).scrollIntoView()), !0);
};
function Xu(e) {
  for (let n = 0; n < e.edgeCount; n++) {
    let { type: t } = e.edge(n);
    if (t.isTextblock && !t.hasRequiredAttrs())
      return t;
  }
  return null;
}
const H$ = (e, n) => {
  let { $head: t, $anchor: a } = e.selection;
  if (!t.parent.type.spec.code || !t.sameParent(a))
    return !1;
  let l = t.node(-1), r = t.indexAfter(-1), o = Xu(l.contentMatchAt(r));
  if (!o || !l.canReplaceWith(r, r, o))
    return !1;
  if (n) {
    let i = t.after(), s = e.tr.replaceWith(i, i, o.createAndFill());
    s.setSelection(rt.near(s.doc.resolve(i), 1)), n(s.scrollIntoView());
  }
  return !0;
}, yp = (e, n) => {
  let t = e.selection, { $from: a, $to: l } = t;
  if (t instanceof bn || a.parent.inlineContent || l.parent.inlineContent)
    return !1;
  let r = Xu(l.parent.contentMatchAt(l.indexAfter()));
  if (!r || !r.isTextblock)
    return !1;
  if (n) {
    let o = (!a.parentOffset && l.index() < l.parent.childCount ? a : l).pos, i = e.tr.insert(o, r.createAndFill());
    i.setSelection(nt.create(i.doc, o + 1)), n(i.scrollIntoView());
  }
  return !0;
}, kp = (e, n) => {
  let { $cursor: t } = e.selection;
  if (!t || t.parent.content.size)
    return !1;
  if (t.depth > 1 && t.after() != t.end(-1)) {
    let r = t.before();
    if (sa(e.doc, r))
      return n && n(e.tr.split(r).scrollIntoView()), !0;
  }
  let a = t.blockRange(), l = a && Jl(a);
  return l == null ? !1 : (n && n(e.tr.lift(a, l).scrollIntoView()), !0);
};
function j$(e) {
  return (n, t) => {
    let { $from: a, $to: l } = n.selection;
    if (n.selection instanceof Xe && n.selection.node.isBlock)
      return !a.parentOffset || !sa(n.doc, a.pos) ? !1 : (t && t(n.tr.split(a.pos).scrollIntoView()), !0);
    if (!a.depth)
      return !1;
    let r = [], o, i, s = !1, d = !1;
    for (let h = a.depth; ; h--)
      if (a.node(h).isBlock) {
        s = a.end(h) == a.pos + (a.depth - h), d = a.start(h) == a.pos - (a.depth - h), i = Xu(a.node(h - 1).contentMatchAt(a.indexAfter(h - 1))), r.unshift(s && i ? { type: i } : null), o = h;
        break;
      } else {
        if (h == 1)
          return !1;
        r.unshift(null);
      }
    let u = n.tr;
    (n.selection instanceof nt || n.selection instanceof bn) && u.deleteSelection();
    let f = u.mapping.map(a.pos), b = sa(u.doc, f, r.length, r);
    if (b || (r[0] = i ? { type: i } : null, b = sa(u.doc, f, r.length, r)), !b)
      return !1;
    if (u.split(f, r.length, r), !s && d && a.node(o).type != i) {
      let h = u.mapping.map(a.before(o)), m = u.doc.resolve(h);
      i && a.node(o - 1).canReplaceWith(m.index(), m.index() + 1, i) && u.setNodeMarkup(u.mapping.map(a.before(o)), i);
    }
    return t && t(u.scrollIntoView()), !0;
  };
}
const W$ = j$(), q$ = (e, n) => {
  let { $from: t, to: a } = e.selection, l, r = t.sharedDepth(a);
  return r == 0 ? !1 : (l = t.before(r), n && n(e.tr.setSelection(Xe.create(e.doc, l))), !0);
};
function U$(e, n, t) {
  let a = n.nodeBefore, l = n.nodeAfter, r = n.index();
  return !a || !l || !a.type.compatibleContent(l.type) ? !1 : !a.content.size && n.parent.canReplace(r - 1, r) ? (t && t(e.tr.delete(n.pos - a.nodeSize, n.pos).scrollIntoView()), !0) : !n.parent.canReplace(r, r + 1) || !(l.isTextblock || Ha(e.doc, n.pos)) ? !1 : (t && t(e.tr.join(n.pos).scrollIntoView()), !0);
}
function wp(e, n, t, a) {
  let l = n.nodeBefore, r = n.nodeAfter, o, i, s = l.type.spec.isolating || r.type.spec.isolating;
  if (!s && U$(e, n, t))
    return !0;
  let d = !s && n.parent.canReplace(n.index(), n.index() + 1);
  if (d && (o = (i = l.contentMatchAt(l.childCount)).findWrapping(r.type)) && i.matchType(o[0] || r.type).validEnd) {
    if (t) {
      let h = n.pos + r.nodeSize, m = Pe.empty;
      for (let w = o.length - 1; w >= 0; w--)
        m = Pe.from(o[w].create(null, m));
      m = Pe.from(l.copy(m));
      let x = e.tr.step(new Vt(n.pos - 1, h, n.pos, h, new Ye(m, 1, 0), o.length, !0)), y = x.doc.resolve(h + 2 * o.length);
      y.nodeAfter && y.nodeAfter.type == l.type && Ha(x.doc, y.pos) && x.join(y.pos), t(x.scrollIntoView());
    }
    return !0;
  }
  let u = r.type.spec.isolating || a > 0 && s ? null : rt.findFrom(n, 1), f = u && u.$from.blockRange(u.$to), b = f && Jl(f);
  if (b != null && b >= n.depth)
    return t && t(e.tr.lift(f, b).scrollIntoView()), !0;
  if (d && Nl(r, "start", !0) && Nl(l, "end")) {
    let h = l, m = [];
    for (; m.push(h), !h.isTextblock; )
      h = h.lastChild;
    let x = r, y = 1;
    for (; !x.isTextblock; x = x.firstChild)
      y++;
    if (h.canReplace(h.childCount, h.childCount, x.content)) {
      if (t) {
        let w = Pe.empty;
        for (let $ = m.length - 1; $ >= 0; $--)
          w = Pe.from(m[$].copy(w));
        let S = e.tr.step(new Vt(n.pos - m.length, n.pos + r.nodeSize, n.pos + y, n.pos + r.nodeSize - y, new Ye(w, m.length, 0), 0, !0));
        t(S.scrollIntoView());
      }
      return !0;
    }
  }
  return !1;
}
function Cp(e) {
  return function(n, t) {
    let a = n.selection, l = e < 0 ? a.$from : a.$to, r = l.depth;
    for (; l.node(r).isInline; ) {
      if (!r)
        return !1;
      r--;
    }
    return l.node(r).isTextblock ? (t && t(n.tr.setSelection(nt.create(n.doc, e < 0 ? l.start(r) : l.end(r)))), !0) : !1;
  };
}
const G$ = Cp(-1), K$ = Cp(1);
function Y$(e, n = null) {
  return function(t, a) {
    let { $from: l, $to: r } = t.selection, o = l.blockRange(r), i = o && Ku(o, e, n);
    return i ? (a && a(t.tr.wrap(o, i).scrollIntoView()), !0) : !1;
  };
}
function Ff(e, n = null) {
  return function(t, a) {
    let l = !1;
    for (let r = 0; r < t.selection.ranges.length && !l; r++) {
      let { $from: { pos: o }, $to: { pos: i } } = t.selection.ranges[r];
      t.doc.nodesBetween(o, i, (s, d) => {
        if (l)
          return !1;
        if (!(!s.isTextblock || s.hasMarkup(e, n)))
          if (s.type == e)
            l = !0;
          else {
            let u = t.doc.resolve(d), f = u.index();
            l = u.parent.canReplaceWith(f, f + 1, e);
          }
      });
    }
    if (!l)
      return !1;
    if (a) {
      let r = t.tr;
      for (let o = 0; o < t.selection.ranges.length; o++) {
        let { $from: { pos: i }, $to: { pos: s } } = t.selection.ranges[o];
        r.setBlockType(i, s, e, n);
      }
      a(r.scrollIntoView());
    }
    return !0;
  };
}
function Qu(...e) {
  return function(n, t, a) {
    for (let l = 0; l < e.length; l++)
      if (e[l](n, t, a))
        return !0;
    return !1;
  };
}
Qu(cp, hp, gp);
Qu(cp, mp, vp);
Qu(xp, yp, kp, W$);
typeof navigator < "u" ? /Mac|iP(hone|[oa]d)/.test(navigator.platform) : typeof os < "u" && os.platform && os.platform() == "darwin";
function J$(e, n = null) {
  return function(t, a) {
    let { $from: l, $to: r } = t.selection, o = l.blockRange(r);
    if (!o)
      return !1;
    let i = a ? t.tr : null;
    return Z$(i, o, e, n) ? (a && a(i.scrollIntoView()), !0) : !1;
  };
}
function Z$(e, n, t, a = null) {
  let l = !1, r = n, o = n.$from.doc;
  if (n.depth >= 2 && n.$from.node(n.depth - 1).type.compatibleContent(t) && n.startIndex == 0) {
    if (n.$from.index(n.depth - 1) == 0)
      return !1;
    let s = o.resolve(n.start - 2);
    r = new ri(s, s, n.depth), n.endIndex < n.parent.childCount && (n = new ri(n.$from, o.resolve(n.$to.end(n.depth)), n.depth)), l = !0;
  }
  let i = Ku(r, t, a, n);
  return i ? (e && X$(e, n, i, l, t), !0) : !1;
}
function X$(e, n, t, a, l) {
  let r = Pe.empty;
  for (let u = t.length - 1; u >= 0; u--)
    r = Pe.from(t[u].type.create(t[u].attrs, r));
  e.step(new Vt(n.start - (a ? 2 : 0), n.end, n.start, n.end, new Ye(r, 0, 0), t.length, !0));
  let o = 0;
  for (let u = 0; u < t.length; u++)
    t[u].type == l && (o = u + 1);
  let i = t.length - o, s = n.start + t.length - (a ? 2 : 0), d = n.parent;
  for (let u = n.startIndex, f = n.endIndex, b = !0; u < f; u++, b = !1)
    !b && sa(e.doc, s, i) && (e.split(s, i), s += 2 * i), s += d.child(u).nodeSize;
  return e;
}
function Q$(e) {
  return function(n, t) {
    let { $from: a, $to: l } = n.selection, r = a.blockRange(l, (o) => o.childCount > 0 && o.firstChild.type == e);
    return r ? t ? a.node(r.depth - 1).type == e ? _$(n, t, e, r) : eI(n, t, r) : !0 : !1;
  };
}
function _$(e, n, t, a) {
  let l = e.tr, r = a.end, o = a.$to.end(a.depth);
  r < o && (l.step(new Vt(r - 1, o, r, o, new Ye(Pe.from(t.create(null, a.parent.copy())), 1, 0), 1, !0)), a = new ri(l.doc.resolve(a.$from.pos), l.doc.resolve(o), a.depth));
  const i = Jl(a);
  if (i == null)
    return !1;
  l.lift(a, i);
  let s = l.doc.resolve(l.mapping.map(r, -1) - 1);
  return Ha(l.doc, s.pos) && s.nodeBefore.type == s.nodeAfter.type && l.join(s.pos), n(l.scrollIntoView()), !0;
}
function eI(e, n, t) {
  let a = e.tr, l = t.parent;
  for (let h = t.end, m = t.endIndex - 1, x = t.startIndex; m > x; m--)
    h -= l.child(m).nodeSize, a.delete(h - 1, h + 1);
  let r = a.doc.resolve(t.start), o = r.nodeAfter;
  if (a.mapping.map(t.end) != t.start + r.nodeAfter.nodeSize)
    return !1;
  let i = t.startIndex == 0, s = t.endIndex == l.childCount, d = r.node(-1), u = r.index(-1);
  if (!d.canReplace(u + (i ? 0 : 1), u + 1, o.content.append(s ? Pe.empty : Pe.from(l))))
    return !1;
  let f = r.pos, b = f + o.nodeSize;
  return a.step(new Vt(f - (i ? 1 : 0), b + (s ? 1 : 0), f + 1, b - 1, new Ye((i ? Pe.empty : Pe.from(l.copy(Pe.empty))).append(s ? Pe.empty : Pe.from(l.copy(Pe.empty))), i ? 0 : 1, s ? 0 : 1), i ? 0 : 1)), n(a.scrollIntoView()), !0;
}
function tI(e) {
  return function(n, t) {
    let { $from: a, $to: l } = n.selection, r = a.blockRange(l, (d) => d.childCount > 0 && d.firstChild.type == e);
    if (!r)
      return !1;
    let o = r.startIndex;
    if (o == 0)
      return !1;
    let i = r.parent, s = i.child(o - 1);
    if (s.type != e)
      return !1;
    if (t) {
      let d = s.lastChild && s.lastChild.type == i.type, u = Pe.from(d ? e.create() : null), f = new Ye(Pe.from(e.create(null, Pe.from(i.type.create(null, u)))), d ? 3 : 1, 0), b = r.start, h = r.end;
      t(n.tr.step(new Vt(b - (d ? 3 : 1), h, b, h, f, 1, !0)).scrollIntoView());
    }
    return !0;
  };
}
const Wt = function(e) {
  for (var n = 0; ; n++)
    if (e = e.previousSibling, !e)
      return n;
}, Hl = function(e) {
  let n = e.assignedSlot || e.parentNode;
  return n && n.nodeType == 11 ? n.host : n;
};
let Fd = null;
const la = function(e, n, t) {
  let a = Fd || (Fd = document.createRange());
  return a.setEnd(e, t ?? e.nodeValue.length), a.setStart(e, n || 0), a;
}, nI = function() {
  Fd = null;
}, cl = function(e, n, t, a) {
  return t && (Vf(e, n, t, a, -1) || Vf(e, n, t, a, 1));
}, aI = /^(img|br|input|textarea|hr)$/i;
function Vf(e, n, t, a, l) {
  for (var r; ; ) {
    if (e == t && n == a)
      return !0;
    if (n == (l < 0 ? 0 : yn(e))) {
      let o = e.parentNode;
      if (!o || o.nodeType != 1 || ao(e) || aI.test(e.nodeName) || e.contentEditable == "false")
        return !1;
      n = Wt(e) + (l < 0 ? 0 : 1), e = o;
    } else if (e.nodeType == 1) {
      let o = e.childNodes[n + (l < 0 ? -1 : 0)];
      if (o.nodeType == 1 && o.contentEditable == "false")
        if (!((r = o.pmViewDesc) === null || r === void 0) && r.ignoreForSelection)
          n += l;
        else
          return !1;
      else
        e = o, n = l < 0 ? yn(e) : 0;
    } else
      return !1;
  }
}
function yn(e) {
  return e.nodeType == 3 ? e.nodeValue.length : e.childNodes.length;
}
function lI(e, n) {
  for (; ; ) {
    if (e.nodeType == 3 && n)
      return e;
    if (e.nodeType == 1 && n > 0) {
      if (e.contentEditable == "false")
        return null;
      e = e.childNodes[n - 1], n = yn(e);
    } else if (e.parentNode && !ao(e))
      n = Wt(e), e = e.parentNode;
    else
      return null;
  }
}
function rI(e, n) {
  for (; ; ) {
    if (e.nodeType == 3 && n < e.nodeValue.length)
      return e;
    if (e.nodeType == 1 && n < e.childNodes.length) {
      if (e.contentEditable == "false")
        return null;
      e = e.childNodes[n], n = 0;
    } else if (e.parentNode && !ao(e))
      n = Wt(e) + 1, e = e.parentNode;
    else
      return null;
  }
}
function oI(e, n, t) {
  for (let a = n == 0, l = n == yn(e); a || l; ) {
    if (e == t)
      return !0;
    let r = Wt(e);
    if (e = e.parentNode, !e)
      return !1;
    a = a && r == 0, l = l && r == yn(e);
  }
}
function ao(e) {
  let n;
  for (let t = e; t && !(n = t.pmViewDesc); t = t.parentNode)
    ;
  return n && n.node && n.node.isBlock && (n.dom == e || n.contentDOM == e);
}
const ts = function(e) {
  return e.focusNode && cl(e.focusNode, e.focusOffset, e.anchorNode, e.anchorOffset);
};
function Ka(e, n) {
  let t = document.createEvent("Event");
  return t.initEvent("keydown", !0, !0), t.keyCode = e, t.key = t.code = n, t;
}
function iI(e) {
  let n = e.activeElement;
  for (; n && n.shadowRoot; )
    n = n.shadowRoot.activeElement;
  return n;
}
function sI(e, n, t) {
  if (e.caretPositionFromPoint)
    try {
      let a = e.caretPositionFromPoint(n, t);
      if (a)
        return { node: a.offsetNode, offset: Math.min(yn(a.offsetNode), a.offset) };
    } catch {
    }
  if (e.caretRangeFromPoint) {
    let a = e.caretRangeFromPoint(n, t);
    if (a)
      return { node: a.startContainer, offset: Math.min(yn(a.startContainer), a.startOffset) };
  }
}
const Xn = typeof navigator < "u" ? navigator : null, Nf = typeof document < "u" ? document : null, ja = Xn && Xn.userAgent || "", Vd = /Edge\/(\d+)/.exec(ja), Sp = /MSIE \d/.exec(ja), Nd = /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(ja), un = !!(Sp || Nd || Vd), Ta = Sp ? document.documentMode : Nd ? +Nd[1] : Vd ? +Vd[1] : 0, In = !un && /gecko\/(\d+)/i.test(ja);
In && +(/Firefox\/(\d+)/.exec(ja) || [0, 0])[1];
const Hd = !un && /Chrome\/(\d+)/.exec(ja), Ut = !!Hd, $p = Hd ? +Hd[1] : 0, Qt = !un && !!Xn && /Apple Computer/.test(Xn.vendor), jl = Qt && (/Mobile\/\w+/.test(ja) || !!Xn && Xn.maxTouchPoints > 2), xn = jl || (Xn ? /Mac/.test(Xn.platform) : !1), Ip = Xn ? /Win/.test(Xn.platform) : !1, ia = /Android \d/.test(ja), lo = !!Nf && "webkitFontSmoothing" in Nf.documentElement.style, dI = lo ? +(/\bAppleWebKit\/(\d+)/.exec(navigator.userAgent) || [0, 0])[1] : 0;
function uI(e) {
  let n = e.defaultView && e.defaultView.visualViewport;
  return n ? {
    left: 0,
    right: n.width,
    top: 0,
    bottom: n.height
  } : {
    left: 0,
    right: e.documentElement.clientWidth,
    top: 0,
    bottom: e.documentElement.clientHeight
  };
}
function ea(e, n) {
  return typeof e == "number" ? e : e[n];
}
function cI(e) {
  let n = e.getBoundingClientRect(), t = n.width / e.offsetWidth || 1, a = n.height / e.offsetHeight || 1;
  return {
    left: n.left,
    right: n.left + e.clientWidth * t,
    top: n.top,
    bottom: n.top + e.clientHeight * a
  };
}
function Hf(e, n, t) {
  let a = e.someProp("scrollThreshold") || 0, l = e.someProp("scrollMargin") || 5, r = e.dom.ownerDocument;
  for (let o = t || e.dom; o; ) {
    if (o.nodeType != 1) {
      o = Hl(o);
      continue;
    }
    let i = o, s = i == r.body, d = s ? uI(r) : cI(i), u = 0, f = 0;
    if (n.top < d.top + ea(a, "top") ? f = -(d.top - n.top + ea(l, "top")) : n.bottom > d.bottom - ea(a, "bottom") && (f = n.bottom - n.top > d.bottom - d.top ? n.top + ea(l, "top") - d.top : n.bottom - d.bottom + ea(l, "bottom")), n.left < d.left + ea(a, "left") ? u = -(d.left - n.left + ea(l, "left")) : n.right > d.right - ea(a, "right") && (u = n.right - d.right + ea(l, "right")), u || f)
      if (s)
        r.defaultView.scrollBy(u, f);
      else {
        let h = i.scrollLeft, m = i.scrollTop;
        f && (i.scrollTop += f), u && (i.scrollLeft += u);
        let x = i.scrollLeft - h, y = i.scrollTop - m;
        n = { left: n.left - x, top: n.top - y, right: n.right - x, bottom: n.bottom - y };
      }
    let b = s ? "fixed" : getComputedStyle(o).position;
    if (/^(fixed|sticky)$/.test(b))
      break;
    o = b == "absolute" ? o.offsetParent : Hl(o);
  }
}
function fI(e) {
  let n = e.dom.getBoundingClientRect(), t = Math.max(0, n.top), a, l;
  for (let r = (n.left + n.right) / 2, o = t + 1; o < Math.min(innerHeight, n.bottom); o += 5) {
    let i = e.root.elementFromPoint(r, o);
    if (!i || i == e.dom || !e.dom.contains(i))
      continue;
    let s = i.getBoundingClientRect();
    if (s.top >= t - 20) {
      a = i, l = s.top;
      break;
    }
  }
  return { refDOM: a, refTop: l, stack: Tp(e.dom) };
}
function Tp(e) {
  let n = [], t = e.ownerDocument;
  for (let a = e; a && (n.push({ dom: a, top: a.scrollTop, left: a.scrollLeft }), e != t); a = Hl(a))
    ;
  return n;
}
function hI({ refDOM: e, refTop: n, stack: t }) {
  let a = e ? e.getBoundingClientRect().top : 0;
  Lp(t, a == 0 ? 0 : a - n);
}
function Lp(e, n) {
  for (let t = 0; t < e.length; t++) {
    let { dom: a, top: l, left: r } = e[t];
    a.scrollTop != l + n && (a.scrollTop = l + n), a.scrollLeft != r && (a.scrollLeft = r);
  }
}
let gl = null;
function bI(e) {
  if (e.setActive)
    return e.setActive();
  if (gl)
    return e.focus(gl);
  let n = Tp(e);
  e.focus(gl == null ? {
    get preventScroll() {
      return gl = { preventScroll: !0 }, !0;
    }
  } : void 0), gl || (gl = !1, Lp(n, 0));
}
function Ep(e, n) {
  let t, a = 2e8, l, r = 0, o = n.top, i = n.top, s, d;
  for (let u = e.firstChild, f = 0; u; u = u.nextSibling, f++) {
    let b;
    if (u.nodeType == 1)
      b = u.getClientRects();
    else if (u.nodeType == 3)
      b = la(u).getClientRects();
    else
      continue;
    for (let h = 0; h < b.length; h++) {
      let m = b[h];
      if (m.top <= o && m.bottom >= i) {
        o = Math.max(m.bottom, o), i = Math.min(m.top, i);
        let x = m.left > n.left ? m.left - n.left : m.right < n.left ? n.left - m.right : 0;
        if (x < a) {
          t = u, a = x, l = x && t.nodeType == 3 ? {
            left: m.right < n.left ? m.right : m.left,
            top: n.top
          } : n, u.nodeType == 1 && x && (r = f + (n.left >= (m.left + m.right) / 2 ? 1 : 0));
          continue;
        }
      } else m.top > n.top && !s && m.left <= n.left && m.right >= n.left && (s = u, d = { left: Math.max(m.left, Math.min(m.right, n.left)), top: m.top });
      !t && (n.left >= m.right && n.top >= m.top || n.left >= m.left && n.top >= m.bottom) && (r = f + 1);
    }
  }
  return !t && s && (t = s, l = d, a = 0), t && t.nodeType == 3 ? gI(t, l) : !t || a && t.nodeType == 1 ? { node: e, offset: r } : Ep(t, l);
}
function gI(e, n) {
  let t = e.nodeValue.length, a = document.createRange(), l;
  for (let r = 0; r < t; r++) {
    a.setEnd(e, r + 1), a.setStart(e, r);
    let o = ba(a, 1);
    if (o.top != o.bottom && _u(n, o)) {
      l = { node: e, offset: r + (n.left >= (o.left + o.right) / 2 ? 1 : 0) };
      break;
    }
  }
  return a.detach(), l || { node: e, offset: 0 };
}
function _u(e, n) {
  return e.left >= n.left - 1 && e.left <= n.right + 1 && e.top >= n.top - 1 && e.top <= n.bottom + 1;
}
function pI(e, n) {
  let t = e.parentNode;
  return t && /^li$/i.test(t.nodeName) && n.left < e.getBoundingClientRect().left ? t : e;
}
function mI(e, n, t) {
  let { node: a, offset: l } = Ep(n, t), r = -1;
  if (a.nodeType == 1 && !a.firstChild) {
    let o = a.getBoundingClientRect();
    r = o.left != o.right && t.left > (o.left + o.right) / 2 ? 1 : -1;
  }
  return e.docView.posFromDOM(a, l, r);
}
function vI(e, n, t, a) {
  let l = -1;
  for (let r = n, o = !1; r != e.dom; ) {
    let i = e.docView.nearestDesc(r, !0), s;
    if (!i)
      return null;
    if (i.dom.nodeType == 1 && (i.node.isBlock && i.parent || !i.contentDOM) && // Ignore elements with zero-size bounding rectangles
    ((s = i.dom.getBoundingClientRect()).width || s.height) && (i.node.isBlock && i.parent && !/^T(R|BODY|HEAD|FOOT)$/.test(i.dom.nodeName) && (!o && s.left > a.left || s.top > a.top ? l = i.posBefore : (!o && s.right < a.left || s.bottom < a.top) && (l = i.posAfter), o = !0), !i.contentDOM && l < 0 && !i.node.isText))
      return (i.node.isBlock ? a.top < (s.top + s.bottom) / 2 : a.left < (s.left + s.right) / 2) ? i.posBefore : i.posAfter;
    r = i.dom.parentNode;
  }
  return l > -1 ? l : e.docView.posFromDOM(n, t, -1);
}
function Ap(e, n, t) {
  let a = e.childNodes.length;
  if (a && t.top < t.bottom)
    for (let l = Math.max(0, Math.min(a - 1, Math.floor(a * (n.top - t.top) / (t.bottom - t.top)) - 2)), r = l; ; ) {
      let o = e.childNodes[r];
      if (o.nodeType == 1) {
        let i = o.getClientRects();
        for (let s = 0; s < i.length; s++) {
          let d = i[s];
          if (_u(n, d))
            return Ap(o, n, d);
        }
      }
      if ((r = (r + 1) % a) == l)
        break;
    }
  return e;
}
function xI(e, n) {
  let t = e.dom.ownerDocument, a, l = 0, r = sI(t, n.left, n.top);
  r && ({ node: a, offset: l } = r);
  let o = (e.root.elementFromPoint ? e.root : t).elementFromPoint(n.left, n.top), i;
  if (!o || !e.dom.contains(o.nodeType != 1 ? o.parentNode : o)) {
    let d = e.dom.getBoundingClientRect();
    if (!_u(n, d) || (o = Ap(e.dom, n, d), !o))
      return null;
  }
  if (Qt)
    for (let d = o; a && d; d = Hl(d))
      d.draggable && (a = void 0);
  if (o = pI(o, n), a) {
    if (In && a.nodeType == 1 && (l = Math.min(l, a.childNodes.length), l < a.childNodes.length)) {
      let u = a.childNodes[l], f;
      u.nodeName == "IMG" && (f = u.getBoundingClientRect()).right <= n.left && f.bottom > n.top && l++;
    }
    let d;
    lo && l && a.nodeType == 1 && (d = a.childNodes[l - 1]).nodeType == 1 && d.contentEditable == "false" && d.getBoundingClientRect().top >= n.top && l--, a == e.dom && l == a.childNodes.length - 1 && a.lastChild.nodeType == 1 && n.top > a.lastChild.getBoundingClientRect().bottom ? i = e.state.doc.content.size : (l == 0 || a.nodeType != 1 || a.childNodes[l - 1].nodeName != "BR") && (i = vI(e, a, l, n));
  }
  i == null && (i = mI(e, o, n));
  let s = e.docView.nearestDesc(o, !0);
  return { pos: i, inside: s ? s.posAtStart - s.border : -1 };
}
function jf(e) {
  return e.top < e.bottom || e.left < e.right;
}
function ba(e, n) {
  let t = e.getClientRects();
  if (t.length) {
    let a = t[n < 0 ? 0 : t.length - 1];
    if (jf(a))
      return a;
  }
  return Array.prototype.find.call(t, jf) || e.getBoundingClientRect();
}
const yI = /[\u0590-\u05f4\u0600-\u06ff\u0700-\u08ac]/;
function Rp(e, n, t) {
  let { node: a, offset: l, atom: r } = e.docView.domFromPos(n, t < 0 ? -1 : 1), o = lo || In;
  if (a.nodeType == 3)
    if (o && (yI.test(a.nodeValue) || (t < 0 ? !l : l == a.nodeValue.length))) {
      let s = ba(la(a, l, l), t);
      if (In && l && /\s/.test(a.nodeValue[l - 1]) && l < a.nodeValue.length) {
        let d = ba(la(a, l - 1, l - 1), -1);
        if (d.top == s.top) {
          let u = ba(la(a, l, l + 1), -1);
          if (u.top != s.top)
            return er(u, u.left < d.left);
        }
      }
      return s;
    } else {
      let s = l, d = l, u = t < 0 ? 1 : -1;
      return t < 0 && !l ? (d++, u = -1) : t >= 0 && l == a.nodeValue.length ? (s--, u = 1) : t < 0 ? s-- : d++, er(ba(la(a, s, d), u), u < 0);
    }
  if (!e.state.doc.resolve(n - (r || 0)).parent.inlineContent) {
    if (r == null && l && (t < 0 || l == yn(a))) {
      let s = a.childNodes[l - 1];
      if (s.nodeType == 1)
        return Fs(s.getBoundingClientRect(), !1);
    }
    if (r == null && l < yn(a)) {
      let s = a.childNodes[l];
      if (s.nodeType == 1)
        return Fs(s.getBoundingClientRect(), !0);
    }
    return Fs(a.getBoundingClientRect(), t >= 0);
  }
  if (r == null && l && (t < 0 || l == yn(a))) {
    let s = a.childNodes[l - 1], d = s.nodeType == 3 ? la(s, yn(s) - (o ? 0 : 1)) : s.nodeType == 1 && (s.nodeName != "BR" || !s.nextSibling) ? s : null;
    if (d)
      return er(ba(d, 1), !1);
  }
  if (r == null && l < yn(a)) {
    let s = a.childNodes[l];
    for (; s.pmViewDesc && s.pmViewDesc.ignoreForCoords; )
      s = s.nextSibling;
    let d = s ? s.nodeType == 3 ? la(s, 0, o ? 0 : 1) : s.nodeType == 1 ? s : null : null;
    if (d)
      return er(ba(d, -1), !0);
  }
  return er(ba(a.nodeType == 3 ? la(a) : a, -t), t >= 0);
}
function er(e, n) {
  if (e.width == 0)
    return e;
  let t = n ? e.left : e.right;
  return { top: e.top, bottom: e.bottom, left: t, right: t };
}
function Fs(e, n) {
  if (e.height == 0)
    return e;
  let t = n ? e.top : e.bottom;
  return { top: t, bottom: t, left: e.left, right: e.right };
}
function Bp(e, n, t) {
  let a = e.state, l = e.root.activeElement;
  a != n && e.updateState(n), l != e.dom && e.focus();
  try {
    return t();
  } finally {
    a != n && e.updateState(a), l != e.dom && l && l.focus();
  }
}
function kI(e, n, t) {
  let a = n.selection, l = t == "up" ? a.$from : a.$to;
  return Bp(e, n, () => {
    let { node: r } = e.docView.domFromPos(l.pos, t == "up" ? -1 : 1);
    for (; ; ) {
      let i = e.docView.nearestDesc(r, !0);
      if (!i)
        break;
      if (i.node.isBlock) {
        r = i.contentDOM || i.dom;
        break;
      }
      r = i.dom.parentNode;
    }
    let o = Rp(e, l.pos, 1);
    for (let i = r.firstChild; i; i = i.nextSibling) {
      let s;
      if (i.nodeType == 1)
        s = i.getClientRects();
      else if (i.nodeType == 3)
        s = la(i, 0, i.nodeValue.length).getClientRects();
      else
        continue;
      for (let d = 0; d < s.length; d++) {
        let u = s[d];
        if (u.bottom > u.top + 1 && (t == "up" ? o.top - u.top > (u.bottom - o.top) * 2 : u.bottom - o.bottom > (o.bottom - u.top) * 2))
          return !1;
      }
    }
    return !0;
  });
}
const wI = /[\u0590-\u08ac]/;
function CI(e, n, t) {
  let { $head: a } = n.selection;
  if (!a.parent.isTextblock)
    return !1;
  let l = a.parentOffset, r = !l, o = l == a.parent.content.size, i = e.domSelection();
  return i ? !wI.test(a.parent.textContent) || !i.modify ? t == "left" || t == "backward" ? r : o : Bp(e, n, () => {
    let { focusNode: s, focusOffset: d, anchorNode: u, anchorOffset: f } = e.domSelectionRange(), b = i.caretBidiLevel;
    i.modify("move", t, "character");
    let h = a.depth ? e.docView.domAfterPos(a.before()) : e.dom, { focusNode: m, focusOffset: x } = e.domSelectionRange(), y = m && !h.contains(m.nodeType == 1 ? m : m.parentNode) || s == m && d == x;
    try {
      i.collapse(u, f), s && (s != u || d != f) && i.extend && i.extend(s, d);
    } catch {
    }
    return b != null && (i.caretBidiLevel = b), y;
  }) : a.pos == a.start() || a.pos == a.end();
}
let Wf = null, qf = null, Uf = !1;
function SI(e, n, t) {
  return Wf == n && qf == t ? Uf : (Wf = n, qf = t, Uf = t == "up" || t == "down" ? kI(e, n, t) : CI(e, n, t));
}
const Tn = 0, Gf = 1, Ya = 2, Qn = 3;
class ro {
  constructor(n, t, a, l) {
    this.parent = n, this.children = t, this.dom = a, this.contentDOM = l, this.dirty = Tn, a.pmViewDesc = this;
  }
  // Used to check whether a given description corresponds to a
  // widget/mark/node.
  matchesWidget(n) {
    return !1;
  }
  matchesMark(n) {
    return !1;
  }
  matchesNode(n, t, a) {
    return !1;
  }
  matchesHack(n) {
    return !1;
  }
  // When parsing in-editor content (in domchange.js), we allow
  // descriptions to determine the parse rules that should be used to
  // parse them.
  parseRule() {
    return null;
  }
  // Used by the editor's event handler to ignore events that come
  // from certain descs.
  stopEvent(n) {
    return !1;
  }
  // The size of the content represented by this desc.
  get size() {
    let n = 0;
    for (let t = 0; t < this.children.length; t++)
      n += this.children[t].size;
    return n;
  }
  // For block nodes, this represents the space taken up by their
  // start/end tokens.
  get border() {
    return 0;
  }
  destroy() {
    this.parent = void 0, this.dom.pmViewDesc == this && (this.dom.pmViewDesc = void 0);
    for (let n = 0; n < this.children.length; n++)
      this.children[n].destroy();
  }
  posBeforeChild(n) {
    for (let t = 0, a = this.posAtStart; ; t++) {
      let l = this.children[t];
      if (l == n)
        return a;
      a += l.size;
    }
  }
  get posBefore() {
    return this.parent.posBeforeChild(this);
  }
  get posAtStart() {
    return this.parent ? this.parent.posBeforeChild(this) + this.border : 0;
  }
  get posAfter() {
    return this.posBefore + this.size;
  }
  get posAtEnd() {
    return this.posAtStart + this.size - 2 * this.border;
  }
  localPosFromDOM(n, t, a) {
    if (this.contentDOM && this.contentDOM.contains(n.nodeType == 1 ? n : n.parentNode))
      if (a < 0) {
        let r, o;
        if (n == this.contentDOM)
          r = n.childNodes[t - 1];
        else {
          for (; n.parentNode != this.contentDOM; )
            n = n.parentNode;
          r = n.previousSibling;
        }
        for (; r && !((o = r.pmViewDesc) && o.parent == this); )
          r = r.previousSibling;
        return r ? this.posBeforeChild(o) + o.size : this.posAtStart;
      } else {
        let r, o;
        if (n == this.contentDOM)
          r = n.childNodes[t];
        else {
          for (; n.parentNode != this.contentDOM; )
            n = n.parentNode;
          r = n.nextSibling;
        }
        for (; r && !((o = r.pmViewDesc) && o.parent == this); )
          r = r.nextSibling;
        return r ? this.posBeforeChild(o) : this.posAtEnd;
      }
    let l;
    if (n == this.dom && this.contentDOM)
      l = t > Wt(this.contentDOM);
    else if (this.contentDOM && this.contentDOM != this.dom && this.dom.contains(this.contentDOM))
      l = n.compareDocumentPosition(this.contentDOM) & 2;
    else if (this.dom.firstChild) {
      if (t == 0)
        for (let r = n; ; r = r.parentNode) {
          if (r == this.dom) {
            l = !1;
            break;
          }
          if (r.previousSibling)
            break;
        }
      if (l == null && t == n.childNodes.length)
        for (let r = n; ; r = r.parentNode) {
          if (r == this.dom) {
            l = !0;
            break;
          }
          if (r.nextSibling)
            break;
        }
    }
    return l ?? a > 0 ? this.posAtEnd : this.posAtStart;
  }
  nearestDesc(n, t = !1) {
    for (let a = !0, l = n; l; l = l.parentNode) {
      let r = this.getDesc(l), o;
      if (r && (!t || r.node))
        if (a && (o = r.nodeDOM) && !(o.nodeType == 1 ? o.contains(n.nodeType == 1 ? n : n.parentNode) : o == n))
          a = !1;
        else
          return r;
    }
  }
  getDesc(n) {
    let t = n.pmViewDesc;
    for (let a = t; a; a = a.parent)
      if (a == this)
        return t;
  }
  posFromDOM(n, t, a) {
    for (let l = n; l; l = l.parentNode) {
      let r = this.getDesc(l);
      if (r)
        return r.localPosFromDOM(n, t, a);
    }
    return -1;
  }
  // Find the desc for the node after the given pos, if any. (When a
  // parent node overrode rendering, there might not be one.)
  descAt(n) {
    for (let t = 0, a = 0; t < this.children.length; t++) {
      let l = this.children[t], r = a + l.size;
      if (a == n && r != a) {
        for (; !l.border && l.children.length; )
          for (let o = 0; o < l.children.length; o++) {
            let i = l.children[o];
            if (i.size) {
              l = i;
              break;
            }
          }
        return l;
      }
      if (n < r)
        return l.descAt(n - a - l.border);
      a = r;
    }
  }
  domFromPos(n, t) {
    if (!this.contentDOM)
      return { node: this.dom, offset: 0, atom: n + 1 };
    let a = 0, l = 0;
    for (let r = 0; a < this.children.length; a++) {
      let o = this.children[a], i = r + o.size;
      if (i > n || o instanceof Dp) {
        l = n - r;
        break;
      }
      r = i;
    }
    if (l)
      return this.children[a].domFromPos(l - this.children[a].border, t);
    for (let r; a && !(r = this.children[a - 1]).size && r instanceof Mp && r.side >= 0; a--)
      ;
    if (t <= 0) {
      let r, o = !0;
      for (; r = a ? this.children[a - 1] : null, !(!r || r.dom.parentNode == this.contentDOM); a--, o = !1)
        ;
      return r && t && o && !r.border && !r.domAtom ? r.domFromPos(r.size, t) : { node: this.contentDOM, offset: r ? Wt(r.dom) + 1 : 0 };
    } else {
      let r, o = !0;
      for (; r = a < this.children.length ? this.children[a] : null, !(!r || r.dom.parentNode == this.contentDOM); a++, o = !1)
        ;
      return r && o && !r.border && !r.domAtom ? r.domFromPos(0, t) : { node: this.contentDOM, offset: r ? Wt(r.dom) : this.contentDOM.childNodes.length };
    }
  }
  // Used to find a DOM range in a single parent for a given changed
  // range.
  parseRange(n, t, a = 0) {
    if (this.children.length == 0)
      return { node: this.contentDOM, from: n, to: t, fromOffset: 0, toOffset: this.contentDOM.childNodes.length };
    let l = -1, r = -1;
    for (let o = a, i = 0; ; i++) {
      let s = this.children[i], d = o + s.size;
      if (l == -1 && n <= d) {
        let u = o + s.border;
        if (n >= u && t <= d - s.border && s.node && s.contentDOM && this.contentDOM.contains(s.contentDOM))
          return s.parseRange(n, t, u);
        n = o;
        for (let f = i; f > 0; f--) {
          let b = this.children[f - 1];
          if (b.size && b.dom.parentNode == this.contentDOM && !b.emptyChildAt(1)) {
            l = Wt(b.dom) + 1;
            break;
          }
          n -= b.size;
        }
        l == -1 && (l = 0);
      }
      if (l > -1 && (d > t || i == this.children.length - 1)) {
        t = d;
        for (let u = i + 1; u < this.children.length; u++) {
          let f = this.children[u];
          if (f.size && f.dom.parentNode == this.contentDOM && !f.emptyChildAt(-1)) {
            r = Wt(f.dom);
            break;
          }
          t += f.size;
        }
        r == -1 && (r = this.contentDOM.childNodes.length);
        break;
      }
      o = d;
    }
    return { node: this.contentDOM, from: n, to: t, fromOffset: l, toOffset: r };
  }
  emptyChildAt(n) {
    if (this.border || !this.contentDOM || !this.children.length)
      return !1;
    let t = this.children[n < 0 ? 0 : this.children.length - 1];
    return t.size == 0 || t.emptyChildAt(n);
  }
  domAfterPos(n) {
    let { node: t, offset: a } = this.domFromPos(n, 0);
    if (t.nodeType != 1 || a == t.childNodes.length)
      throw new RangeError("No node after pos " + n);
    return t.childNodes[a];
  }
  // View descs are responsible for setting any selection that falls
  // entirely inside of them, so that custom implementations can do
  // custom things with the selection. Note that this falls apart when
  // a selection starts in such a node and ends in another, in which
  // case we just use whatever domFromPos produces as a best effort.
  setSelection(n, t, a, l = !1) {
    let r = Math.min(n, t), o = Math.max(n, t);
    for (let h = 0, m = 0; h < this.children.length; h++) {
      let x = this.children[h], y = m + x.size;
      if (r > m && o < y)
        return x.setSelection(n - m - x.border, t - m - x.border, a, l);
      m = y;
    }
    let i = this.domFromPos(n, n ? -1 : 1), s = t == n ? i : this.domFromPos(t, t ? -1 : 1), d = a.root.getSelection(), u = a.domSelectionRange(), f = !1;
    if ((In || Qt) && n == t) {
      let { node: h, offset: m } = i;
      if (h.nodeType == 3) {
        if (f = !!(m && h.nodeValue[m - 1] == `
`), f && m == h.nodeValue.length)
          for (let x = h, y; x; x = x.parentNode) {
            if (y = x.nextSibling) {
              y.nodeName == "BR" && (i = s = { node: y.parentNode, offset: Wt(y) + 1 });
              break;
            }
            let w = x.pmViewDesc;
            if (w && w.node && w.node.isBlock)
              break;
          }
      } else {
        let x = h.childNodes[m - 1];
        f = x && (x.nodeName == "BR" || x.contentEditable == "false");
      }
    }
    if (In && u.focusNode && u.focusNode != s.node && u.focusNode.nodeType == 1) {
      let h = u.focusNode.childNodes[u.focusOffset];
      h && h.contentEditable == "false" && (l = !0);
    }
    if (!(l || f && Qt) && cl(i.node, i.offset, u.anchorNode, u.anchorOffset) && cl(s.node, s.offset, u.focusNode, u.focusOffset))
      return;
    let b = !1;
    if ((d.extend || n == t) && !(f && In)) {
      d.collapse(i.node, i.offset);
      try {
        n != t && d.extend(s.node, s.offset), b = !0;
      } catch {
      }
    }
    if (!b) {
      if (n > t) {
        let m = i;
        i = s, s = m;
      }
      let h = document.createRange();
      h.setEnd(s.node, s.offset), h.setStart(i.node, i.offset), d.removeAllRanges(), d.addRange(h);
    }
  }
  ignoreMutation(n) {
    return !this.contentDOM && n.type != "selection";
  }
  get contentLost() {
    return this.contentDOM && this.contentDOM != this.dom && !this.dom.contains(this.contentDOM);
  }
  // Remove a subtree of the element tree that has been touched
  // by a DOM change, so that the next update will redraw it.
  markDirty(n, t) {
    for (let a = 0, l = 0; l < this.children.length; l++) {
      let r = this.children[l], o = a + r.size;
      if (a == o ? n <= o && t >= a : n < o && t > a) {
        let i = a + r.border, s = o - r.border;
        if (n >= i && t <= s) {
          this.dirty = n == a || t == o ? Ya : Gf, n == i && t == s && (r.contentLost || r.dom.parentNode != this.contentDOM) ? r.dirty = Qn : r.markDirty(n - i, t - i);
          return;
        } else
          r.dirty = r.dom == r.contentDOM && r.dom.parentNode == this.contentDOM && !r.children.length ? Ya : Qn;
      }
      a = o;
    }
    this.dirty = Ya;
  }
  markParentsDirty() {
    let n = 1;
    for (let t = this.parent; t; t = t.parent, n++) {
      let a = n == 1 ? Ya : Gf;
      t.dirty < a && (t.dirty = a);
    }
  }
  get domAtom() {
    return !1;
  }
  get ignoreForCoords() {
    return !1;
  }
  get ignoreForSelection() {
    return !1;
  }
  isText(n) {
    return !1;
  }
}
class Mp extends ro {
  constructor(n, t, a, l) {
    let r, o = t.type.toDOM;
    if (typeof o == "function" && (o = o(a, () => {
      if (!r)
        return l;
      if (r.parent)
        return r.parent.posBeforeChild(r);
    })), !t.type.spec.raw) {
      if (o.nodeType != 1) {
        let i = document.createElement("span");
        i.appendChild(o), o = i;
      }
      o.contentEditable = "false", o.classList.add("ProseMirror-widget");
    }
    super(n, [], o, null), this.widget = t, this.widget = t, r = this;
  }
  matchesWidget(n) {
    return this.dirty == Tn && n.type.eq(this.widget.type);
  }
  parseRule() {
    return { ignore: !0 };
  }
  stopEvent(n) {
    let t = this.widget.spec.stopEvent;
    return t ? t(n) : !1;
  }
  ignoreMutation(n) {
    return n.type != "selection" || this.widget.spec.ignoreSelection;
  }
  destroy() {
    this.widget.type.destroy(this.dom), super.destroy();
  }
  get domAtom() {
    return !0;
  }
  get ignoreForSelection() {
    return !!this.widget.type.spec.relaxedSide;
  }
  get side() {
    return this.widget.type.side;
  }
}
class $I extends ro {
  constructor(n, t, a, l) {
    super(n, [], t, null), this.textDOM = a, this.text = l;
  }
  get size() {
    return this.text.length;
  }
  localPosFromDOM(n, t) {
    return n != this.textDOM ? this.posAtStart + (t ? this.size : 0) : this.posAtStart + t;
  }
  domFromPos(n) {
    return { node: this.textDOM, offset: n };
  }
  ignoreMutation(n) {
    return n.type === "characterData" && n.target.nodeValue == n.oldValue;
  }
}
class fl extends ro {
  constructor(n, t, a, l, r) {
    super(n, [], a, l), this.mark = t, this.spec = r;
  }
  static create(n, t, a, l) {
    let r = l.nodeViews[t.type.name], o = r && r(t, l, a);
    return (!o || !o.dom) && (o = bl.renderSpec(document, t.type.spec.toDOM(t, a), null, t.attrs)), new fl(n, t, o.dom, o.contentDOM || o.dom, o);
  }
  parseRule() {
    return this.dirty & Qn || this.mark.type.spec.reparseInView ? null : { mark: this.mark.type.name, attrs: this.mark.attrs, contentElement: this.contentDOM };
  }
  matchesMark(n) {
    return this.dirty != Qn && this.mark.eq(n);
  }
  markDirty(n, t) {
    if (super.markDirty(n, t), this.dirty != Tn) {
      let a = this.parent;
      for (; !a.node; )
        a = a.parent;
      a.dirty < this.dirty && (a.dirty = this.dirty), this.dirty = Tn;
    }
  }
  slice(n, t, a) {
    let l = fl.create(this.parent, this.mark, !0, a), r = this.children, o = this.size;
    t < o && (r = Wd(r, t, o, a)), n > 0 && (r = Wd(r, 0, n, a));
    for (let i = 0; i < r.length; i++)
      r[i].parent = l;
    return l.children = r, l;
  }
  ignoreMutation(n) {
    return this.spec.ignoreMutation ? this.spec.ignoreMutation(n) : super.ignoreMutation(n);
  }
  destroy() {
    this.spec.destroy && this.spec.destroy(), super.destroy();
  }
}
class La extends ro {
  constructor(n, t, a, l, r, o, i, s, d) {
    super(n, [], r, o), this.node = t, this.outerDeco = a, this.innerDeco = l, this.nodeDOM = i;
  }
  // By default, a node is rendered using the `toDOM` method from the
  // node type spec. But client code can use the `nodeViews` spec to
  // supply a custom node view, which can influence various aspects of
  // the way the node works.
  //
  // (Using subclassing for this was intentionally decided against,
  // since it'd require exposing a whole slew of finicky
  // implementation details to the user code that they probably will
  // never need.)
  static create(n, t, a, l, r, o) {
    let i = r.nodeViews[t.type.name], s, d = i && i(t, r, () => {
      if (!s)
        return o;
      if (s.parent)
        return s.parent.posBeforeChild(s);
    }, a, l), u = d && d.dom, f = d && d.contentDOM;
    if (t.isText) {
      if (!u)
        u = document.createTextNode(t.text);
      else if (u.nodeType != 3)
        throw new RangeError("Text must be rendered as a DOM text node");
    } else u || ({ dom: u, contentDOM: f } = bl.renderSpec(document, t.type.spec.toDOM(t), null, t.attrs));
    !f && !t.isText && u.nodeName != "BR" && (u.hasAttribute("contenteditable") || (u.contentEditable = "false"), t.type.spec.draggable && (u.draggable = !0));
    let b = u;
    return u = Pp(u, a, t), d ? s = new II(n, t, a, l, u, f || null, b, d, r, o + 1) : t.isText ? new ns(n, t, a, l, u, b, r) : new La(n, t, a, l, u, f || null, b, r, o + 1);
  }
  parseRule() {
    if (this.node.type.spec.reparseInView)
      return null;
    let n = { node: this.node.type.name, attrs: this.node.attrs };
    if (this.node.type.whitespace == "pre" && (n.preserveWhitespace = "full"), !this.contentDOM)
      n.getContent = () => this.node.content;
    else if (!this.contentLost)
      n.contentElement = this.contentDOM;
    else {
      for (let t = this.children.length - 1; t >= 0; t--) {
        let a = this.children[t];
        if (this.dom.contains(a.dom.parentNode)) {
          n.contentElement = a.dom.parentNode;
          break;
        }
      }
      n.contentElement || (n.getContent = () => Pe.empty);
    }
    return n;
  }
  matchesNode(n, t, a) {
    return this.dirty == Tn && n.eq(this.node) && ii(t, this.outerDeco) && a.eq(this.innerDeco);
  }
  get size() {
    return this.node.nodeSize;
  }
  get border() {
    return this.node.isLeaf ? 0 : 1;
  }
  // Syncs `this.children` to match `this.node.content` and the local
  // decorations, possibly introducing nesting for marks. Then, in a
  // separate step, syncs the DOM inside `this.contentDOM` to
  // `this.children`.
  updateChildren(n, t) {
    let a = this.node.inlineContent, l = t, r = n.composing ? this.localCompositionInfo(n, t) : null, o = r && r.pos > -1 ? r : null, i = r && r.pos < 0, s = new LI(this, o && o.node, n);
    RI(this.node, this.innerDeco, (d, u, f) => {
      d.spec.marks ? s.syncToMarks(d.spec.marks, a, n, u) : d.type.side >= 0 && !f && s.syncToMarks(u == this.node.childCount ? mt.none : this.node.child(u).marks, a, n, u), s.placeWidget(d, n, l);
    }, (d, u, f, b) => {
      s.syncToMarks(d.marks, a, n, b);
      let h;
      s.findNodeMatch(d, u, f, b) || i && n.state.selection.from > l && n.state.selection.to < l + d.nodeSize && (h = s.findIndexWithChild(r.node)) > -1 && s.updateNodeAt(d, u, f, h, n) || s.updateNextNode(d, u, f, n, b, l) || s.addNode(d, u, f, n, l), l += d.nodeSize;
    }), s.syncToMarks([], a, n, 0), this.node.isTextblock && s.addTextblockHacks(), s.destroyRest(), (s.changed || this.dirty == Ya) && (o && this.protectLocalComposition(n, o), zp(this.contentDOM, this.children, n), jl && BI(this.dom));
  }
  localCompositionInfo(n, t) {
    let { from: a, to: l } = n.state.selection;
    if (!(n.state.selection instanceof nt) || a < t || l > t + this.node.content.size)
      return null;
    let r = n.input.compositionNode;
    if (!r || !this.dom.contains(r.parentNode))
      return null;
    if (this.node.inlineContent) {
      let o = r.nodeValue, i = MI(this.node.content, o, a - t, l - t);
      return i < 0 ? null : { node: r, pos: i, text: o };
    } else
      return { node: r, pos: -1, text: "" };
  }
  protectLocalComposition(n, { node: t, pos: a, text: l }) {
    if (this.getDesc(t))
      return;
    let r = t;
    for (; r.parentNode != this.contentDOM; r = r.parentNode) {
      for (; r.previousSibling; )
        r.parentNode.removeChild(r.previousSibling);
      for (; r.nextSibling; )
        r.parentNode.removeChild(r.nextSibling);
      r.pmViewDesc && (r.pmViewDesc = void 0);
    }
    let o = new $I(this, r, t, l);
    n.input.compositionNodes.push(o), this.children = Wd(this.children, a, a + l.length, n, o);
  }
  // If this desc must be updated to match the given node decoration,
  // do so and return true.
  update(n, t, a, l) {
    return this.dirty == Qn || !n.sameMarkup(this.node) ? !1 : (this.updateInner(n, t, a, l), !0);
  }
  updateInner(n, t, a, l) {
    this.updateOuterDeco(t), this.node = n, this.innerDeco = a, this.contentDOM && this.updateChildren(l, this.posAtStart), this.dirty = Tn;
  }
  updateOuterDeco(n) {
    if (ii(n, this.outerDeco))
      return;
    let t = this.nodeDOM.nodeType != 1, a = this.dom;
    this.dom = Op(this.dom, this.nodeDOM, jd(this.outerDeco, this.node, t), jd(n, this.node, t)), this.dom != a && (a.pmViewDesc = void 0, this.dom.pmViewDesc = this), this.outerDeco = n;
  }
  // Mark this node as being the selected node.
  selectNode() {
    this.nodeDOM.nodeType == 1 && (this.nodeDOM.classList.add("ProseMirror-selectednode"), (this.contentDOM || !this.node.type.spec.draggable) && (this.nodeDOM.draggable = !0));
  }
  // Remove selected node marking from this node.
  deselectNode() {
    this.nodeDOM.nodeType == 1 && (this.nodeDOM.classList.remove("ProseMirror-selectednode"), (this.contentDOM || !this.node.type.spec.draggable) && this.nodeDOM.removeAttribute("draggable"));
  }
  get domAtom() {
    return this.node.isAtom;
  }
}
function Kf(e, n, t, a, l) {
  Pp(a, n, e);
  let r = new La(void 0, e, n, t, a, a, a, l, 0);
  return r.contentDOM && r.updateChildren(l, 0), r;
}
class ns extends La {
  constructor(n, t, a, l, r, o, i) {
    super(n, t, a, l, r, null, o, i, 0);
  }
  parseRule() {
    let n = this.nodeDOM.parentNode;
    for (; n && n != this.dom && !n.pmIsDeco; )
      n = n.parentNode;
    return { skip: n || !0 };
  }
  update(n, t, a, l) {
    return this.dirty == Qn || this.dirty != Tn && !this.inParent() || !n.sameMarkup(this.node) ? !1 : (this.updateOuterDeco(t), (this.dirty != Tn || n.text != this.node.text) && n.text != this.nodeDOM.nodeValue && (this.nodeDOM.nodeValue = n.text, l.trackWrites == this.nodeDOM && (l.trackWrites = null)), this.node = n, this.dirty = Tn, !0);
  }
  inParent() {
    let n = this.parent.contentDOM;
    for (let t = this.nodeDOM; t; t = t.parentNode)
      if (t == n)
        return !0;
    return !1;
  }
  domFromPos(n) {
    return { node: this.nodeDOM, offset: n };
  }
  localPosFromDOM(n, t, a) {
    return n == this.nodeDOM ? this.posAtStart + Math.min(t, this.node.text.length) : super.localPosFromDOM(n, t, a);
  }
  ignoreMutation(n) {
    return n.type != "characterData" && n.type != "selection";
  }
  slice(n, t, a) {
    let l = this.node.cut(n, t), r = document.createTextNode(l.text);
    return new ns(this.parent, l, this.outerDeco, this.innerDeco, r, r, a);
  }
  markDirty(n, t) {
    super.markDirty(n, t), this.dom != this.nodeDOM && (n == 0 || t == this.nodeDOM.nodeValue.length) && (this.dirty = Qn);
  }
  get domAtom() {
    return !1;
  }
  isText(n) {
    return this.node.text == n;
  }
}
class Dp extends ro {
  parseRule() {
    return { ignore: !0 };
  }
  matchesHack(n) {
    return this.dirty == Tn && this.dom.nodeName == n;
  }
  get domAtom() {
    return !0;
  }
  get ignoreForCoords() {
    return this.dom.nodeName == "IMG";
  }
}
class II extends La {
  constructor(n, t, a, l, r, o, i, s, d, u) {
    super(n, t, a, l, r, o, i, d, u), this.spec = s;
  }
  // A custom `update` method gets to decide whether the update goes
  // through. If it does, and there's a `contentDOM` node, our logic
  // updates the children.
  update(n, t, a, l) {
    if (this.dirty == Qn)
      return !1;
    if (this.spec.update && (this.node.type == n.type || this.spec.multiType)) {
      let r = this.spec.update(n, t, a);
      return r && this.updateInner(n, t, a, l), r;
    } else return !this.contentDOM && !n.isLeaf ? !1 : super.update(n, t, a, l);
  }
  selectNode() {
    this.spec.selectNode ? this.spec.selectNode() : super.selectNode();
  }
  deselectNode() {
    this.spec.deselectNode ? this.spec.deselectNode() : super.deselectNode();
  }
  setSelection(n, t, a, l) {
    this.spec.setSelection ? this.spec.setSelection(n, t, a.root) : super.setSelection(n, t, a, l);
  }
  destroy() {
    this.spec.destroy && this.spec.destroy(), super.destroy();
  }
  stopEvent(n) {
    return this.spec.stopEvent ? this.spec.stopEvent(n) : !1;
  }
  ignoreMutation(n) {
    return this.spec.ignoreMutation ? this.spec.ignoreMutation(n) : super.ignoreMutation(n);
  }
}
function zp(e, n, t) {
  let a = e.firstChild, l = !1;
  for (let r = 0; r < n.length; r++) {
    let o = n[r], i = o.dom;
    if (i.parentNode == e) {
      for (; i != a; )
        a = Yf(a), l = !0;
      a = a.nextSibling;
    } else
      l = !0, e.insertBefore(i, a);
    if (o instanceof fl) {
      let s = a ? a.previousSibling : e.lastChild;
      zp(o.contentDOM, o.children, t), a = s ? s.nextSibling : e.firstChild;
    }
  }
  for (; a; )
    a = Yf(a), l = !0;
  l && t.trackWrites == e && (t.trackWrites = null);
}
const yr = function(e) {
  e && (this.nodeName = e);
};
yr.prototype = /* @__PURE__ */ Object.create(null);
const Ja = [new yr()];
function jd(e, n, t) {
  if (e.length == 0)
    return Ja;
  let a = t ? Ja[0] : new yr(), l = [a];
  for (let r = 0; r < e.length; r++) {
    let o = e[r].type.attrs;
    if (o) {
      o.nodeName && l.push(a = new yr(o.nodeName));
      for (let i in o) {
        let s = o[i];
        s != null && (t && l.length == 1 && l.push(a = new yr(n.isInline ? "span" : "div")), i == "class" ? a.class = (a.class ? a.class + " " : "") + s : i == "style" ? a.style = (a.style ? a.style + ";" : "") + s : i != "nodeName" && (a[i] = s));
      }
    }
  }
  return l;
}
function Op(e, n, t, a) {
  if (t == Ja && a == Ja)
    return n;
  let l = n;
  for (let r = 0; r < a.length; r++) {
    let o = a[r], i = t[r];
    if (r) {
      let s;
      i && i.nodeName == o.nodeName && l != e && (s = l.parentNode) && s.nodeName.toLowerCase() == o.nodeName || (s = document.createElement(o.nodeName), s.pmIsDeco = !0, s.appendChild(l), i = Ja[0]), l = s;
    }
    TI(l, i || Ja[0], o);
  }
  return l;
}
function TI(e, n, t) {
  for (let a in n)
    a != "class" && a != "style" && a != "nodeName" && !(a in t) && e.removeAttribute(a);
  for (let a in t)
    a != "class" && a != "style" && a != "nodeName" && t[a] != n[a] && e.setAttribute(a, t[a]);
  if (n.class != t.class) {
    let a = n.class ? n.class.split(" ").filter(Boolean) : [], l = t.class ? t.class.split(" ").filter(Boolean) : [];
    for (let r = 0; r < a.length; r++)
      l.indexOf(a[r]) == -1 && e.classList.remove(a[r]);
    for (let r = 0; r < l.length; r++)
      a.indexOf(l[r]) == -1 && e.classList.add(l[r]);
    e.classList.length == 0 && e.removeAttribute("class");
  }
  if (n.style != t.style) {
    if (n.style) {
      let a = /\s*([\w\-\xa1-\uffff]+)\s*:(?:"(?:\\.|[^"])*"|'(?:\\.|[^'])*'|\(.*?\)|[^;])*/g, l;
      for (; l = a.exec(n.style); )
        e.style.removeProperty(l[1]);
    }
    t.style && (e.style.cssText += t.style);
  }
}
function Pp(e, n, t) {
  return Op(e, e, Ja, jd(n, t, e.nodeType != 1));
}
function ii(e, n) {
  if (e.length != n.length)
    return !1;
  for (let t = 0; t < e.length; t++)
    if (!e[t].type.eq(n[t].type))
      return !1;
  return !0;
}
function Yf(e) {
  let n = e.nextSibling;
  return e.parentNode.removeChild(e), n;
}
class LI {
  constructor(n, t, a) {
    this.lock = t, this.view = a, this.index = 0, this.stack = [], this.changed = !1, this.top = n, this.preMatch = EI(n.node.content, n);
  }
  // Destroy and remove the children between the given indices in
  // `this.top`.
  destroyBetween(n, t) {
    if (n != t) {
      for (let a = n; a < t; a++)
        this.top.children[a].destroy();
      this.top.children.splice(n, t - n), this.changed = !0;
    }
  }
  // Destroy all remaining children in `this.top`.
  destroyRest() {
    this.destroyBetween(this.index, this.top.children.length);
  }
  // Sync the current stack of mark descs with the given array of
  // marks, reusing existing mark descs when possible.
  syncToMarks(n, t, a, l) {
    let r = 0, o = this.stack.length >> 1, i = Math.min(o, n.length);
    for (; r < i && (r == o - 1 ? this.top : this.stack[r + 1 << 1]).matchesMark(n[r]) && n[r].type.spec.spanning !== !1; )
      r++;
    for (; r < o; )
      this.destroyRest(), this.top.dirty = Tn, this.index = this.stack.pop(), this.top = this.stack.pop(), o--;
    for (; o < n.length; ) {
      this.stack.push(this.top, this.index + 1);
      let s = -1, d = this.top.children.length;
      l < this.preMatch.index && (d = Math.min(this.index + 3, d));
      for (let u = this.index; u < d; u++) {
        let f = this.top.children[u];
        if (f.matchesMark(n[o]) && !this.isLocked(f.dom)) {
          s = u;
          break;
        }
      }
      if (s > -1)
        s > this.index && (this.changed = !0, this.destroyBetween(this.index, s)), this.top = this.top.children[this.index];
      else {
        let u = fl.create(this.top, n[o], t, a);
        this.top.children.splice(this.index, 0, u), this.top = u, this.changed = !0;
      }
      this.index = 0, o++;
    }
  }
  // Try to find a node desc matching the given data. Skip over it and
  // return true when successful.
  findNodeMatch(n, t, a, l) {
    let r = -1, o;
    if (l >= this.preMatch.index && (o = this.preMatch.matches[l - this.preMatch.index]).parent == this.top && o.matchesNode(n, t, a))
      r = this.top.children.indexOf(o, this.index);
    else
      for (let i = this.index, s = Math.min(this.top.children.length, i + 5); i < s; i++) {
        let d = this.top.children[i];
        if (d.matchesNode(n, t, a) && !this.preMatch.matched.has(d)) {
          r = i;
          break;
        }
      }
    return r < 0 ? !1 : (this.destroyBetween(this.index, r), this.index++, !0);
  }
  updateNodeAt(n, t, a, l, r) {
    let o = this.top.children[l];
    return o.dirty == Qn && o.dom == o.contentDOM && (o.dirty = Ya), o.update(n, t, a, r) ? (this.destroyBetween(this.index, l), this.index++, !0) : !1;
  }
  findIndexWithChild(n) {
    for (; ; ) {
      let t = n.parentNode;
      if (!t)
        return -1;
      if (t == this.top.contentDOM) {
        let a = n.pmViewDesc;
        if (a) {
          for (let l = this.index; l < this.top.children.length; l++)
            if (this.top.children[l] == a)
              return l;
        }
        return -1;
      }
      n = t;
    }
  }
  // Try to update the next node, if any, to the given data. Checks
  // pre-matches to avoid overwriting nodes that could still be used.
  updateNextNode(n, t, a, l, r, o) {
    for (let i = this.index; i < this.top.children.length; i++) {
      let s = this.top.children[i];
      if (s instanceof La) {
        let d = this.preMatch.matched.get(s);
        if (d != null && d != r)
          return !1;
        let u = s.dom, f, b = this.isLocked(u) && !(n.isText && s.node && s.node.isText && s.nodeDOM.nodeValue == n.text && s.dirty != Qn && ii(t, s.outerDeco));
        if (!b && s.update(n, t, a, l))
          return this.destroyBetween(this.index, i), s.dom != u && (this.changed = !0), this.index++, !0;
        if (!b && (f = this.recreateWrapper(s, n, t, a, l, o)))
          return this.destroyBetween(this.index, i), this.top.children[this.index] = f, f.contentDOM && (f.dirty = Ya, f.updateChildren(l, o + 1), f.dirty = Tn), this.changed = !0, this.index++, !0;
        break;
      }
    }
    return !1;
  }
  // When a node with content is replaced by a different node with
  // identical content, move over its children.
  recreateWrapper(n, t, a, l, r, o) {
    if (n.dirty || t.isAtom || !n.children.length || !n.node.content.eq(t.content) || !ii(a, n.outerDeco) || !l.eq(n.innerDeco))
      return null;
    let i = La.create(this.top, t, a, l, r, o);
    if (i.contentDOM) {
      i.children = n.children, n.children = [];
      for (let s of i.children)
        s.parent = i;
    }
    return n.destroy(), i;
  }
  // Insert the node as a newly created node desc.
  addNode(n, t, a, l, r) {
    let o = La.create(this.top, n, t, a, l, r);
    o.contentDOM && o.updateChildren(l, r + 1), this.top.children.splice(this.index++, 0, o), this.changed = !0;
  }
  placeWidget(n, t, a) {
    let l = this.index < this.top.children.length ? this.top.children[this.index] : null;
    if (l && l.matchesWidget(n) && (n == l.widget || !l.widget.type.toDOM.parentNode))
      this.index++;
    else {
      let r = new Mp(this.top, n, t, a);
      this.top.children.splice(this.index++, 0, r), this.changed = !0;
    }
  }
  // Make sure a textblock looks and behaves correctly in
  // contentEditable.
  addTextblockHacks() {
    let n = this.top.children[this.index - 1], t = this.top;
    for (; n instanceof fl; )
      t = n, n = t.children[t.children.length - 1];
    (!n || // Empty textblock
    !(n instanceof ns) || /\n$/.test(n.node.text) || this.view.requiresGeckoHackNode && /\s$/.test(n.node.text)) && ((Qt || Ut) && n && n.dom.contentEditable == "false" && this.addHackNode("IMG", t), this.addHackNode("BR", this.top));
  }
  addHackNode(n, t) {
    if (t == this.top && this.index < t.children.length && t.children[this.index].matchesHack(n))
      this.index++;
    else {
      let a = document.createElement(n);
      n == "IMG" && (a.className = "ProseMirror-separator", a.alt = ""), n == "BR" && (a.className = "ProseMirror-trailingBreak");
      let l = new Dp(this.top, [], a, null);
      t != this.top ? t.children.push(l) : t.children.splice(this.index++, 0, l), this.changed = !0;
    }
  }
  isLocked(n) {
    return this.lock && (n == this.lock || n.nodeType == 1 && n.contains(this.lock.parentNode));
  }
}
function EI(e, n) {
  let t = n, a = t.children.length, l = e.childCount, r = /* @__PURE__ */ new Map(), o = [];
  e: for (; l > 0; ) {
    let i;
    for (; ; )
      if (a) {
        let d = t.children[a - 1];
        if (d instanceof fl)
          t = d, a = d.children.length;
        else {
          i = d, a--;
          break;
        }
      } else {
        if (t == n)
          break e;
        a = t.parent.children.indexOf(t), t = t.parent;
      }
    let s = i.node;
    if (s) {
      if (s != e.child(l - 1))
        break;
      --l, r.set(i, l), o.push(i);
    }
  }
  return { index: l, matched: r, matches: o.reverse() };
}
function AI(e, n) {
  return e.type.side - n.type.side;
}
function RI(e, n, t, a) {
  let l = n.locals(e), r = 0;
  if (l.length == 0) {
    for (let d = 0; d < e.childCount; d++) {
      let u = e.child(d);
      a(u, l, n.forChild(r, u), d), r += u.nodeSize;
    }
    return;
  }
  let o = 0, i = [], s = null;
  for (let d = 0; ; ) {
    let u, f;
    for (; o < l.length && l[o].to == r; ) {
      let y = l[o++];
      y.widget && (u ? (f || (f = [u])).push(y) : u = y);
    }
    if (u)
      if (f) {
        f.sort(AI);
        for (let y = 0; y < f.length; y++)
          t(f[y], d, !!s);
      } else
        t(u, d, !!s);
    let b, h;
    if (s)
      h = -1, b = s, s = null;
    else if (d < e.childCount)
      h = d, b = e.child(d++);
    else
      break;
    for (let y = 0; y < i.length; y++)
      i[y].to <= r && i.splice(y--, 1);
    for (; o < l.length && l[o].from <= r && l[o].to > r; )
      i.push(l[o++]);
    let m = r + b.nodeSize;
    if (b.isText) {
      let y = m;
      o < l.length && l[o].from < y && (y = l[o].from);
      for (let w = 0; w < i.length; w++)
        i[w].to < y && (y = i[w].to);
      y < m && (s = b.cut(y - r), b = b.cut(0, y - r), m = y, h = -1);
    } else
      for (; o < l.length && l[o].to < m; )
        o++;
    let x = b.isInline && !b.isLeaf ? i.filter((y) => !y.inline) : i.slice();
    a(b, x, n.forChild(r, b), h), r = m;
  }
}
function BI(e) {
  if (e.nodeName == "UL" || e.nodeName == "OL") {
    let n = e.style.cssText;
    e.style.cssText = n + "; list-style: square !important", window.getComputedStyle(e).listStyle, e.style.cssText = n;
  }
}
function MI(e, n, t, a) {
  for (let l = 0, r = 0; l < e.childCount && r <= a; ) {
    let o = e.child(l++), i = r;
    if (r += o.nodeSize, !o.isText)
      continue;
    let s = o.text;
    for (; l < e.childCount; ) {
      let d = e.child(l++);
      if (r += d.nodeSize, !d.isText)
        break;
      s += d.text;
    }
    if (r >= t) {
      if (r >= a && s.slice(a - n.length - i, a - i) == n)
        return a - n.length;
      let d = i < a ? s.lastIndexOf(n, a - i - 1) : -1;
      if (d >= 0 && d + n.length + i >= t)
        return i + d;
      if (t == a && s.length >= a + n.length - i && s.slice(a - i, a - i + n.length) == n)
        return a;
    }
  }
  return -1;
}
function Wd(e, n, t, a, l) {
  let r = [];
  for (let o = 0, i = 0; o < e.length; o++) {
    let s = e[o], d = i, u = i += s.size;
    d >= t || u <= n ? r.push(s) : (d < n && r.push(s.slice(0, n - d, a)), l && (r.push(l), l = void 0), u > t && r.push(s.slice(t - d, s.size, a)));
  }
  return r;
}
function ec(e, n = null) {
  let t = e.domSelectionRange(), a = e.state.doc;
  if (!t.focusNode)
    return null;
  let l = e.docView.nearestDesc(t.focusNode), r = l && l.size == 0, o = e.docView.posFromDOM(t.focusNode, t.focusOffset, 1);
  if (o < 0)
    return null;
  let i = a.resolve(o), s, d;
  if (ts(t)) {
    for (s = o; l && !l.node; )
      l = l.parent;
    let f = l.node;
    if (l && f.isAtom && Xe.isSelectable(f) && l.parent && !(f.isInline && oI(t.focusNode, t.focusOffset, l.dom))) {
      let b = l.posBefore;
      d = new Xe(o == b ? i : a.resolve(b));
    }
  } else {
    if (t instanceof e.dom.ownerDocument.defaultView.Selection && t.rangeCount > 1) {
      let f = o, b = o;
      for (let h = 0; h < t.rangeCount; h++) {
        let m = t.getRangeAt(h);
        f = Math.min(f, e.docView.posFromDOM(m.startContainer, m.startOffset, 1)), b = Math.max(b, e.docView.posFromDOM(m.endContainer, m.endOffset, -1));
      }
      if (f < 0)
        return null;
      [s, o] = b == e.state.selection.anchor ? [b, f] : [f, b], i = a.resolve(o);
    } else
      s = e.docView.posFromDOM(t.anchorNode, t.anchorOffset, 1);
    if (s < 0)
      return null;
  }
  let u = a.resolve(s);
  if (!d) {
    let f = n == "pointer" || e.state.selection.head < i.pos && !r ? 1 : -1;
    d = tc(e, u, i, f);
  }
  return d;
}
function Fp(e) {
  return e.editable ? e.hasFocus() : Np(e) && document.activeElement && document.activeElement.contains(e.dom);
}
function da(e, n = !1) {
  let t = e.state.selection;
  if (Vp(e, t), !!Fp(e)) {
    if (!n && e.input.mouseDown && e.input.mouseDown.allowDefault && Ut) {
      let a = e.domSelectionRange(), l = e.domObserver.currentSelection;
      if (a.anchorNode && l.anchorNode && cl(a.anchorNode, a.anchorOffset, l.anchorNode, l.anchorOffset)) {
        e.input.mouseDown.delayedSelectionSync = !0, e.domObserver.setCurSelection();
        return;
      }
    }
    if (e.domObserver.disconnectSelection(), e.cursorWrapper)
      zI(e);
    else {
      let { anchor: a, head: l } = t, r, o;
      Jf && !(t instanceof nt) && (t.$from.parent.inlineContent || (r = Zf(e, t.from)), !t.empty && !t.$from.parent.inlineContent && (o = Zf(e, t.to))), e.docView.setSelection(a, l, e, n), Jf && (r && Xf(r), o && Xf(o)), t.visible ? e.dom.classList.remove("ProseMirror-hideselection") : (e.dom.classList.add("ProseMirror-hideselection"), "onselectionchange" in document && DI(e));
    }
    e.domObserver.setCurSelection(), e.domObserver.connectSelection();
  }
}
const Jf = Qt || Ut && $p < 63;
function Zf(e, n) {
  let { node: t, offset: a } = e.docView.domFromPos(n, 0), l = a < t.childNodes.length ? t.childNodes[a] : null, r = a ? t.childNodes[a - 1] : null;
  if (Qt && l && l.contentEditable == "false")
    return Vs(l);
  if ((!l || l.contentEditable == "false") && (!r || r.contentEditable == "false")) {
    if (l)
      return Vs(l);
    if (r)
      return Vs(r);
  }
}
function Vs(e) {
  return e.contentEditable = "true", Qt && e.draggable && (e.draggable = !1, e.wasDraggable = !0), e;
}
function Xf(e) {
  e.contentEditable = "false", e.wasDraggable && (e.draggable = !0, e.wasDraggable = null);
}
function DI(e) {
  let n = e.dom.ownerDocument;
  n.removeEventListener("selectionchange", e.input.hideSelectionGuard);
  let t = e.domSelectionRange(), a = t.anchorNode, l = t.anchorOffset;
  n.addEventListener("selectionchange", e.input.hideSelectionGuard = () => {
    (t.anchorNode != a || t.anchorOffset != l) && (n.removeEventListener("selectionchange", e.input.hideSelectionGuard), setTimeout(() => {
      (!Fp(e) || e.state.selection.visible) && e.dom.classList.remove("ProseMirror-hideselection");
    }, 20));
  });
}
function zI(e) {
  let n = e.domSelection();
  if (!n)
    return;
  let t = e.cursorWrapper.dom, a = t.nodeName == "IMG";
  a ? n.collapse(t.parentNode, Wt(t) + 1) : n.collapse(t, 0), !a && !e.state.selection.visible && un && Ta <= 11 && (t.disabled = !0, t.disabled = !1);
}
function Vp(e, n) {
  if (n instanceof Xe) {
    let t = e.docView.descAt(n.from);
    t != e.lastSelectedViewDesc && (Qf(e), t && t.selectNode(), e.lastSelectedViewDesc = t);
  } else
    Qf(e);
}
function Qf(e) {
  e.lastSelectedViewDesc && (e.lastSelectedViewDesc.parent && e.lastSelectedViewDesc.deselectNode(), e.lastSelectedViewDesc = void 0);
}
function tc(e, n, t, a) {
  return e.someProp("createSelectionBetween", (l) => l(e, n, t)) || nt.between(n, t, a);
}
function _f(e) {
  return e.editable && !e.hasFocus() ? !1 : Np(e);
}
function Np(e) {
  let n = e.domSelectionRange();
  if (!n.anchorNode)
    return !1;
  try {
    return e.dom.contains(n.anchorNode.nodeType == 3 ? n.anchorNode.parentNode : n.anchorNode) && (e.editable || e.dom.contains(n.focusNode.nodeType == 3 ? n.focusNode.parentNode : n.focusNode));
  } catch {
    return !1;
  }
}
function OI(e) {
  let n = e.docView.domFromPos(e.state.selection.anchor, 0), t = e.domSelectionRange();
  return cl(n.node, n.offset, t.anchorNode, t.anchorOffset);
}
function qd(e, n) {
  let { $anchor: t, $head: a } = e.selection, l = n > 0 ? t.max(a) : t.min(a), r = l.parent.inlineContent ? l.depth ? e.doc.resolve(n > 0 ? l.after() : l.before()) : null : l;
  return r && rt.findFrom(r, n);
}
function ga(e, n) {
  return e.dispatch(e.state.tr.setSelection(n).scrollIntoView()), !0;
}
function eh(e, n, t) {
  let a = e.state.selection;
  if (a instanceof nt)
    if (t.indexOf("s") > -1) {
      let { $head: l } = a, r = l.textOffset ? null : n < 0 ? l.nodeBefore : l.nodeAfter;
      if (!r || r.isText || !r.isLeaf)
        return !1;
      let o = e.state.doc.resolve(l.pos + r.nodeSize * (n < 0 ? -1 : 1));
      return ga(e, new nt(a.$anchor, o));
    } else if (a.empty) {
      if (e.endOfTextblock(n > 0 ? "forward" : "backward")) {
        let l = qd(e.state, n);
        return l && l instanceof Xe ? ga(e, l) : !1;
      } else if (!(xn && t.indexOf("m") > -1)) {
        let l = a.$head, r = l.textOffset ? null : n < 0 ? l.nodeBefore : l.nodeAfter, o;
        if (!r || r.isText)
          return !1;
        let i = n < 0 ? l.pos - r.nodeSize : l.pos;
        return r.isAtom || (o = e.docView.descAt(i)) && !o.contentDOM ? Xe.isSelectable(r) ? ga(e, new Xe(n < 0 ? e.state.doc.resolve(l.pos - r.nodeSize) : l)) : lo ? ga(e, new nt(e.state.doc.resolve(n < 0 ? i : i + r.nodeSize))) : !1 : !1;
      }
    } else return !1;
  else {
    if (a instanceof Xe && a.node.isInline)
      return ga(e, new nt(n > 0 ? a.$to : a.$from));
    {
      let l = qd(e.state, n);
      return l ? ga(e, l) : !1;
    }
  }
}
function si(e) {
  return e.nodeType == 3 ? e.nodeValue.length : e.childNodes.length;
}
function kr(e, n) {
  let t = e.pmViewDesc;
  return t && t.size == 0 && (n < 0 || e.nextSibling || e.nodeName != "BR");
}
function pl(e, n) {
  return n < 0 ? PI(e) : FI(e);
}
function PI(e) {
  let n = e.domSelectionRange(), t = n.focusNode, a = n.focusOffset;
  if (!t)
    return;
  let l, r, o = !1;
  for (In && t.nodeType == 1 && a < si(t) && kr(t.childNodes[a], -1) && (o = !0); ; )
    if (a > 0) {
      if (t.nodeType != 1)
        break;
      {
        let i = t.childNodes[a - 1];
        if (kr(i, -1))
          l = t, r = --a;
        else if (i.nodeType == 3)
          t = i, a = t.nodeValue.length;
        else
          break;
      }
    } else {
      if (Hp(t))
        break;
      {
        let i = t.previousSibling;
        for (; i && kr(i, -1); )
          l = t.parentNode, r = Wt(i), i = i.previousSibling;
        if (i)
          t = i, a = si(t);
        else {
          if (t = t.parentNode, t == e.dom)
            break;
          a = 0;
        }
      }
    }
  o ? Ud(e, t, a) : l && Ud(e, l, r);
}
function FI(e) {
  let n = e.domSelectionRange(), t = n.focusNode, a = n.focusOffset;
  if (!t)
    return;
  let l = si(t), r, o;
  for (; ; )
    if (a < l) {
      if (t.nodeType != 1)
        break;
      let i = t.childNodes[a];
      if (kr(i, 1))
        r = t, o = ++a;
      else
        break;
    } else {
      if (Hp(t))
        break;
      {
        let i = t.nextSibling;
        for (; i && kr(i, 1); )
          r = i.parentNode, o = Wt(i) + 1, i = i.nextSibling;
        if (i)
          t = i, a = 0, l = si(t);
        else {
          if (t = t.parentNode, t == e.dom)
            break;
          a = l = 0;
        }
      }
    }
  r && Ud(e, r, o);
}
function Hp(e) {
  let n = e.pmViewDesc;
  return n && n.node && n.node.isBlock;
}
function VI(e, n) {
  for (; e && n == e.childNodes.length && !ao(e); )
    n = Wt(e) + 1, e = e.parentNode;
  for (; e && n < e.childNodes.length; ) {
    let t = e.childNodes[n];
    if (t.nodeType == 3)
      return t;
    if (t.nodeType == 1 && t.contentEditable == "false")
      break;
    e = t, n = 0;
  }
}
function NI(e, n) {
  for (; e && !n && !ao(e); )
    n = Wt(e), e = e.parentNode;
  for (; e && n; ) {
    let t = e.childNodes[n - 1];
    if (t.nodeType == 3)
      return t;
    if (t.nodeType == 1 && t.contentEditable == "false")
      break;
    e = t, n = e.childNodes.length;
  }
}
function Ud(e, n, t) {
  if (n.nodeType != 3) {
    let r, o;
    (o = VI(n, t)) ? (n = o, t = 0) : (r = NI(n, t)) && (n = r, t = r.nodeValue.length);
  }
  let a = e.domSelection();
  if (!a)
    return;
  if (ts(a)) {
    let r = document.createRange();
    r.setEnd(n, t), r.setStart(n, t), a.removeAllRanges(), a.addRange(r);
  } else a.extend && a.extend(n, t);
  e.domObserver.setCurSelection();
  let { state: l } = e;
  setTimeout(() => {
    e.state == l && da(e);
  }, 50);
}
function th(e, n) {
  let t = e.state.doc.resolve(n);
  if (!(Ut || Ip) && t.parent.inlineContent) {
    let l = e.coordsAtPos(n);
    if (n > t.start()) {
      let r = e.coordsAtPos(n - 1), o = (r.top + r.bottom) / 2;
      if (o > l.top && o < l.bottom && Math.abs(r.left - l.left) > 1)
        return r.left < l.left ? "ltr" : "rtl";
    }
    if (n < t.end()) {
      let r = e.coordsAtPos(n + 1), o = (r.top + r.bottom) / 2;
      if (o > l.top && o < l.bottom && Math.abs(r.left - l.left) > 1)
        return r.left > l.left ? "ltr" : "rtl";
    }
  }
  return getComputedStyle(e.dom).direction == "rtl" ? "rtl" : "ltr";
}
function nh(e, n, t) {
  let a = e.state.selection;
  if (a instanceof nt && !a.empty || t.indexOf("s") > -1 || xn && t.indexOf("m") > -1)
    return !1;
  let { $from: l, $to: r } = a;
  if (!l.parent.inlineContent || e.endOfTextblock(n < 0 ? "up" : "down")) {
    let o = qd(e.state, n);
    if (o && o instanceof Xe)
      return ga(e, o);
  }
  if (!l.parent.inlineContent) {
    let o = n < 0 ? l : r, i = a instanceof bn ? rt.near(o, n) : rt.findFrom(o, n);
    return i ? ga(e, i) : !1;
  }
  return !1;
}
function ah(e, n) {
  if (!(e.state.selection instanceof nt))
    return !0;
  let { $head: t, $anchor: a, empty: l } = e.state.selection;
  if (!t.sameParent(a))
    return !0;
  if (!l)
    return !1;
  if (e.endOfTextblock(n > 0 ? "forward" : "backward"))
    return !0;
  let r = !t.textOffset && (n < 0 ? t.nodeBefore : t.nodeAfter);
  if (r && !r.isText) {
    let o = e.state.tr;
    return n < 0 ? o.delete(t.pos - r.nodeSize, t.pos) : o.delete(t.pos, t.pos + r.nodeSize), e.dispatch(o), !0;
  }
  return !1;
}
function lh(e, n, t) {
  e.domObserver.stop(), n.contentEditable = t, e.domObserver.start();
}
function HI(e) {
  if (!Qt || e.state.selection.$head.parentOffset > 0)
    return !1;
  let { focusNode: n, focusOffset: t } = e.domSelectionRange();
  if (n && n.nodeType == 1 && t == 0 && n.firstChild && n.firstChild.contentEditable == "false") {
    let a = n.firstChild;
    lh(e, a, "true"), setTimeout(() => lh(e, a, "false"), 20);
  }
  return !1;
}
function jI(e) {
  let n = "";
  return e.ctrlKey && (n += "c"), e.metaKey && (n += "m"), e.altKey && (n += "a"), e.shiftKey && (n += "s"), n;
}
function WI(e, n) {
  let t = n.keyCode, a = jI(n);
  if (t == 8 || xn && t == 72 && a == "c")
    return ah(e, -1) || pl(e, -1);
  if (t == 46 && !n.shiftKey || xn && t == 68 && a == "c")
    return ah(e, 1) || pl(e, 1);
  if (t == 13 || t == 27)
    return !0;
  if (t == 37 || xn && t == 66 && a == "c") {
    let l = t == 37 ? th(e, e.state.selection.from) == "ltr" ? -1 : 1 : -1;
    return eh(e, l, a) || pl(e, l);
  } else if (t == 39 || xn && t == 70 && a == "c") {
    let l = t == 39 ? th(e, e.state.selection.from) == "ltr" ? 1 : -1 : 1;
    return eh(e, l, a) || pl(e, l);
  } else {
    if (t == 38 || xn && t == 80 && a == "c")
      return nh(e, -1, a) || pl(e, -1);
    if (t == 40 || xn && t == 78 && a == "c")
      return HI(e) || nh(e, 1, a) || pl(e, 1);
    if (a == (xn ? "m" : "c") && (t == 66 || t == 73 || t == 89 || t == 90))
      return !0;
  }
  return !1;
}
function nc(e, n) {
  e.someProp("transformCopied", (h) => {
    n = h(n, e);
  });
  let t = [], { content: a, openStart: l, openEnd: r } = n;
  for (; l > 1 && r > 1 && a.childCount == 1 && a.firstChild.childCount == 1; ) {
    l--, r--;
    let h = a.firstChild;
    t.push(h.type.name, h.attrs != h.type.defaultAttrs ? h.attrs : null), a = h.content;
  }
  let o = e.someProp("clipboardSerializer") || bl.fromSchema(e.state.schema), i = Kp(), s = i.createElement("div");
  s.appendChild(o.serializeFragment(a, { document: i }));
  let d = s.firstChild, u, f = 0;
  for (; d && d.nodeType == 1 && (u = Gp[d.nodeName.toLowerCase()]); ) {
    for (let h = u.length - 1; h >= 0; h--) {
      let m = i.createElement(u[h]);
      for (; s.firstChild; )
        m.appendChild(s.firstChild);
      s.appendChild(m), f++;
    }
    d = s.firstChild;
  }
  d && d.nodeType == 1 && d.setAttribute("data-pm-slice", `${l} ${r}${f ? ` -${f}` : ""} ${JSON.stringify(t)}`);
  let b = e.someProp("clipboardTextSerializer", (h) => h(n, e)) || n.content.textBetween(0, n.content.size, `

`);
  return { dom: s, text: b, slice: n };
}
function jp(e, n, t, a, l) {
  let r = l.parent.type.spec.code, o, i;
  if (!t && !n)
    return null;
  let s = !!n && (a || r || !t);
  if (s) {
    if (e.someProp("transformPastedText", (b) => {
      n = b(n, r || a, e);
    }), r)
      return i = new Ye(Pe.from(e.state.schema.text(n.replace(/\r\n?/g, `
`))), 0, 0), e.someProp("transformPasted", (b) => {
        i = b(i, e, !0);
      }), i;
    let f = e.someProp("clipboardTextParser", (b) => b(n, l, a, e));
    if (f)
      i = f;
    else {
      let b = l.marks(), { schema: h } = e.state, m = bl.fromSchema(h);
      o = document.createElement("div"), n.split(/(?:\r\n?|\n)+/).forEach((x) => {
        let y = o.appendChild(document.createElement("p"));
        x && y.appendChild(m.serializeNode(h.text(x, b)));
      });
    }
  } else
    e.someProp("transformPastedHTML", (f) => {
      t = f(t, e);
    }), o = KI(t), lo && YI(o);
  let d = o && o.querySelector("[data-pm-slice]"), u = d && /^(\d+) (\d+)(?: -(\d+))? (.*)/.exec(d.getAttribute("data-pm-slice") || "");
  if (u && u[3])
    for (let f = +u[3]; f > 0; f--) {
      let b = o.firstChild;
      for (; b && b.nodeType != 1; )
        b = b.nextSibling;
      if (!b)
        break;
      o = b;
    }
  if (i || (i = (e.someProp("clipboardParser") || e.someProp("domParser") || Ia.fromSchema(e.state.schema)).parseSlice(o, {
    preserveWhitespace: !!(s || u),
    context: l,
    ruleFromNode(b) {
      return b.nodeName == "BR" && !b.nextSibling && b.parentNode && !qI.test(b.parentNode.nodeName) ? { ignore: !0 } : null;
    }
  })), u)
    i = JI(rh(i, +u[1], +u[2]), u[4]);
  else if (i = Ye.maxOpen(UI(i.content, l), !0), i.openStart || i.openEnd) {
    let f = 0, b = 0;
    for (let h = i.content.firstChild; f < i.openStart && !h.type.spec.isolating; f++, h = h.firstChild)
      ;
    for (let h = i.content.lastChild; b < i.openEnd && !h.type.spec.isolating; b++, h = h.lastChild)
      ;
    i = rh(i, f, b);
  }
  return e.someProp("transformPasted", (f) => {
    i = f(i, e, s);
  }), i;
}
const qI = /^(a|abbr|acronym|b|cite|code|del|em|i|ins|kbd|label|output|q|ruby|s|samp|span|strong|sub|sup|time|u|tt|var)$/i;
function UI(e, n) {
  if (e.childCount < 2)
    return e;
  for (let t = n.depth; t >= 0; t--) {
    let l = n.node(t).contentMatchAt(n.index(t)), r, o = [];
    if (e.forEach((i) => {
      if (!o)
        return;
      let s = l.findWrapping(i.type), d;
      if (!s)
        return o = null;
      if (d = o.length && r.length && qp(s, r, i, o[o.length - 1], 0))
        o[o.length - 1] = d;
      else {
        o.length && (o[o.length - 1] = Up(o[o.length - 1], r.length));
        let u = Wp(i, s);
        o.push(u), l = l.matchType(u.type), r = s;
      }
    }), o)
      return Pe.from(o);
  }
  return e;
}
function Wp(e, n, t = 0) {
  for (let a = n.length - 1; a >= t; a--)
    e = n[a].create(null, Pe.from(e));
  return e;
}
function qp(e, n, t, a, l) {
  if (l < e.length && l < n.length && e[l] == n[l]) {
    let r = qp(e, n, t, a.lastChild, l + 1);
    if (r)
      return a.copy(a.content.replaceChild(a.childCount - 1, r));
    if (a.contentMatchAt(a.childCount).matchType(l == e.length - 1 ? t.type : e[l + 1]))
      return a.copy(a.content.append(Pe.from(Wp(t, e, l + 1))));
  }
}
function Up(e, n) {
  if (n == 0)
    return e;
  let t = e.content.replaceChild(e.childCount - 1, Up(e.lastChild, n - 1)), a = e.contentMatchAt(e.childCount).fillBefore(Pe.empty, !0);
  return e.copy(t.append(a));
}
function Gd(e, n, t, a, l, r) {
  let o = n < 0 ? e.firstChild : e.lastChild, i = o.content;
  return e.childCount > 1 && (r = 0), l < a - 1 && (i = Gd(i, n, t, a, l + 1, r)), l >= t && (i = n < 0 ? o.contentMatchAt(0).fillBefore(i, r <= l).append(i) : i.append(o.contentMatchAt(o.childCount).fillBefore(Pe.empty, !0))), e.replaceChild(n < 0 ? 0 : e.childCount - 1, o.copy(i));
}
function rh(e, n, t) {
  return n < e.openStart && (e = new Ye(Gd(e.content, -1, n, e.openStart, 0, e.openEnd), n, e.openEnd)), t < e.openEnd && (e = new Ye(Gd(e.content, 1, t, e.openEnd, 0, 0), e.openStart, t)), e;
}
const Gp = {
  thead: ["table"],
  tbody: ["table"],
  tfoot: ["table"],
  caption: ["table"],
  colgroup: ["table"],
  col: ["table", "colgroup"],
  tr: ["table", "tbody"],
  td: ["table", "tbody", "tr"],
  th: ["table", "tbody", "tr"]
};
let oh = null;
function Kp() {
  return oh || (oh = document.implementation.createHTMLDocument("title"));
}
let Ns = null;
function GI(e) {
  let n = window.trustedTypes;
  return n ? (Ns || (Ns = n.defaultPolicy || n.createPolicy("ProseMirrorClipboard", { createHTML: (t) => t })), Ns.createHTML(e)) : e;
}
function KI(e) {
  let n = /^(\s*<meta [^>]*>)*/.exec(e);
  n && (e = e.slice(n[0].length));
  let t = Kp().createElement("div"), a = /<([a-z][^>\s]+)/i.exec(e), l;
  if ((l = a && Gp[a[1].toLowerCase()]) && (e = l.map((r) => "<" + r + ">").join("") + e + l.map((r) => "</" + r + ">").reverse().join("")), t.innerHTML = GI(e), l)
    for (let r = 0; r < l.length; r++)
      t = t.querySelector(l[r]) || t;
  return t;
}
function YI(e) {
  let n = e.querySelectorAll(Ut ? "span:not([class]):not([style])" : "span.Apple-converted-space");
  for (let t = 0; t < n.length; t++) {
    let a = n[t];
    a.childNodes.length == 1 && a.textContent == " " && a.parentNode && a.parentNode.replaceChild(e.ownerDocument.createTextNode(" "), a);
  }
}
function JI(e, n) {
  if (!e.size)
    return e;
  let t = e.content.firstChild.type.schema, a;
  try {
    a = JSON.parse(n);
  } catch {
    return e;
  }
  let { content: l, openStart: r, openEnd: o } = e;
  for (let i = a.length - 2; i >= 0; i -= 2) {
    let s = t.nodes[a[i]];
    if (!s || s.hasRequiredAttrs())
      break;
    l = Pe.from(s.create(a[i + 1], l)), r++, o++;
  }
  return new Ye(l, r, o);
}
const ln = {}, rn = {}, ZI = { touchstart: !0, touchmove: !0 };
class XI {
  constructor() {
    this.shiftKey = !1, this.mouseDown = null, this.lastKeyCode = null, this.lastKeyCodeTime = 0, this.lastClick = { time: 0, x: 0, y: 0, type: "", button: 0 }, this.lastSelectionOrigin = null, this.lastSelectionTime = 0, this.lastIOSEnter = 0, this.lastIOSEnterFallbackTimeout = -1, this.lastFocus = 0, this.lastTouch = 0, this.lastChromeDelete = 0, this.composing = !1, this.compositionNode = null, this.composingTimeout = -1, this.compositionNodes = [], this.compositionEndedAt = -2e8, this.compositionID = 1, this.badSafariComposition = !1, this.compositionPendingChanges = 0, this.domChangeCount = 0, this.eventHandlers = /* @__PURE__ */ Object.create(null), this.hideSelectionGuard = null;
  }
}
function QI(e) {
  for (let n in ln) {
    let t = ln[n];
    e.dom.addEventListener(n, e.input.eventHandlers[n] = (a) => {
      eT(e, a) && !ac(e, a) && (e.editable || !(a.type in rn)) && t(e, a);
    }, ZI[n] ? { passive: !0 } : void 0);
  }
  Qt && e.dom.addEventListener("input", () => null), Kd(e);
}
function wa(e, n) {
  e.input.lastSelectionOrigin = n, e.input.lastSelectionTime = Date.now();
}
function _I(e) {
  e.domObserver.stop();
  for (let n in e.input.eventHandlers)
    e.dom.removeEventListener(n, e.input.eventHandlers[n]);
  clearTimeout(e.input.composingTimeout), clearTimeout(e.input.lastIOSEnterFallbackTimeout);
}
function Kd(e) {
  e.someProp("handleDOMEvents", (n) => {
    for (let t in n)
      e.input.eventHandlers[t] || e.dom.addEventListener(t, e.input.eventHandlers[t] = (a) => ac(e, a));
  });
}
function ac(e, n) {
  return e.someProp("handleDOMEvents", (t) => {
    let a = t[n.type];
    return a ? a(e, n) || n.defaultPrevented : !1;
  });
}
function eT(e, n) {
  if (!n.bubbles)
    return !0;
  if (n.defaultPrevented)
    return !1;
  for (let t = n.target; t != e.dom; t = t.parentNode)
    if (!t || t.nodeType == 11 || t.pmViewDesc && t.pmViewDesc.stopEvent(n))
      return !1;
  return !0;
}
function tT(e, n) {
  !ac(e, n) && ln[n.type] && (e.editable || !(n.type in rn)) && ln[n.type](e, n);
}
rn.keydown = (e, n) => {
  let t = n;
  if (e.input.shiftKey = t.keyCode == 16 || t.shiftKey, !Jp(e, t) && (e.input.lastKeyCode = t.keyCode, e.input.lastKeyCodeTime = Date.now(), !(ia && Ut && t.keyCode == 13)))
    if (t.keyCode != 229 && e.domObserver.forceFlush(), jl && t.keyCode == 13 && !t.ctrlKey && !t.altKey && !t.metaKey) {
      let a = Date.now();
      e.input.lastIOSEnter = a, e.input.lastIOSEnterFallbackTimeout = setTimeout(() => {
        e.input.lastIOSEnter == a && (e.someProp("handleKeyDown", (l) => l(e, Ka(13, "Enter"))), e.input.lastIOSEnter = 0);
      }, 200);
    } else e.someProp("handleKeyDown", (a) => a(e, t)) || WI(e, t) ? t.preventDefault() : wa(e, "key");
};
rn.keyup = (e, n) => {
  n.keyCode == 16 && (e.input.shiftKey = !1);
};
rn.keypress = (e, n) => {
  let t = n;
  if (Jp(e, t) || !t.charCode || t.ctrlKey && !t.altKey || xn && t.metaKey)
    return;
  if (e.someProp("handleKeyPress", (l) => l(e, t))) {
    t.preventDefault();
    return;
  }
  let a = e.state.selection;
  if (!(a instanceof nt) || !a.$from.sameParent(a.$to)) {
    let l = String.fromCharCode(t.charCode), r = () => e.state.tr.insertText(l).scrollIntoView();
    !/[\r\n]/.test(l) && !e.someProp("handleTextInput", (o) => o(e, a.$from.pos, a.$to.pos, l, r)) && e.dispatch(r()), t.preventDefault();
  }
};
function as(e) {
  return { left: e.clientX, top: e.clientY };
}
function nT(e, n) {
  let t = n.x - e.clientX, a = n.y - e.clientY;
  return t * t + a * a < 100;
}
function lc(e, n, t, a, l) {
  if (a == -1)
    return !1;
  let r = e.state.doc.resolve(a);
  for (let o = r.depth + 1; o > 0; o--)
    if (e.someProp(n, (i) => o > r.depth ? i(e, t, r.nodeAfter, r.before(o), l, !0) : i(e, t, r.node(o), r.before(o), l, !1)))
      return !0;
  return !1;
}
function El(e, n, t) {
  if (e.focused || e.focus(), e.state.selection.eq(n))
    return;
  let a = e.state.tr.setSelection(n);
  a.setMeta("pointer", !0), e.dispatch(a);
}
function aT(e, n) {
  if (n == -1)
    return !1;
  let t = e.state.doc.resolve(n), a = t.nodeAfter;
  return a && a.isAtom && Xe.isSelectable(a) ? (El(e, new Xe(t)), !0) : !1;
}
function lT(e, n) {
  if (n == -1)
    return !1;
  let t = e.state.selection, a, l;
  t instanceof Xe && (a = t.node);
  let r = e.state.doc.resolve(n);
  for (let o = r.depth + 1; o > 0; o--) {
    let i = o > r.depth ? r.nodeAfter : r.node(o);
    if (Xe.isSelectable(i)) {
      a && t.$from.depth > 0 && o >= t.$from.depth && r.before(t.$from.depth + 1) == t.$from.pos ? l = r.before(t.$from.depth) : l = r.before(o);
      break;
    }
  }
  return l != null ? (El(e, Xe.create(e.state.doc, l)), !0) : !1;
}
function rT(e, n, t, a, l) {
  return lc(e, "handleClickOn", n, t, a) || e.someProp("handleClick", (r) => r(e, n, a)) || (l ? lT(e, t) : aT(e, t));
}
function oT(e, n, t, a) {
  return lc(e, "handleDoubleClickOn", n, t, a) || e.someProp("handleDoubleClick", (l) => l(e, n, a));
}
function iT(e, n, t, a) {
  return lc(e, "handleTripleClickOn", n, t, a) || e.someProp("handleTripleClick", (l) => l(e, n, a)) || sT(e, t, a);
}
function sT(e, n, t) {
  if (t.button != 0)
    return !1;
  let a = e.state.doc;
  if (n == -1)
    return a.inlineContent ? (El(e, nt.create(a, 0, a.content.size)), !0) : !1;
  let l = a.resolve(n);
  for (let r = l.depth + 1; r > 0; r--) {
    let o = r > l.depth ? l.nodeAfter : l.node(r), i = l.before(r);
    if (o.inlineContent)
      El(e, nt.create(a, i + 1, i + 1 + o.content.size));
    else if (Xe.isSelectable(o))
      El(e, Xe.create(a, i));
    else
      continue;
    return !0;
  }
}
function rc(e) {
  return di(e);
}
const Yp = xn ? "metaKey" : "ctrlKey";
ln.mousedown = (e, n) => {
  let t = n;
  e.input.shiftKey = t.shiftKey;
  let a = rc(e), l = Date.now(), r = "singleClick";
  l - e.input.lastClick.time < 500 && nT(t, e.input.lastClick) && !t[Yp] && e.input.lastClick.button == t.button && (e.input.lastClick.type == "singleClick" ? r = "doubleClick" : e.input.lastClick.type == "doubleClick" && (r = "tripleClick")), e.input.lastClick = { time: l, x: t.clientX, y: t.clientY, type: r, button: t.button };
  let o = e.posAtCoords(as(t));
  o && (r == "singleClick" ? (e.input.mouseDown && e.input.mouseDown.done(), e.input.mouseDown = new dT(e, o, t, !!a)) : (r == "doubleClick" ? oT : iT)(e, o.pos, o.inside, t) ? t.preventDefault() : wa(e, "pointer"));
};
class dT {
  constructor(n, t, a, l) {
    this.view = n, this.pos = t, this.event = a, this.flushed = l, this.delayedSelectionSync = !1, this.mightDrag = null, this.startDoc = n.state.doc, this.selectNode = !!a[Yp], this.allowDefault = a.shiftKey;
    let r, o;
    if (t.inside > -1)
      r = n.state.doc.nodeAt(t.inside), o = t.inside;
    else {
      let u = n.state.doc.resolve(t.pos);
      r = u.parent, o = u.depth ? u.before() : 0;
    }
    const i = l ? null : a.target, s = i ? n.docView.nearestDesc(i, !0) : null;
    this.target = s && s.nodeDOM.nodeType == 1 ? s.nodeDOM : null;
    let { selection: d } = n.state;
    a.button == 0 && (r.type.spec.draggable && r.type.spec.selectable !== !1 || d instanceof Xe && d.from <= o && d.to > o) && (this.mightDrag = {
      node: r,
      pos: o,
      addAttr: !!(this.target && !this.target.draggable),
      setUneditable: !!(this.target && In && !this.target.hasAttribute("contentEditable"))
    }), this.target && this.mightDrag && (this.mightDrag.addAttr || this.mightDrag.setUneditable) && (this.view.domObserver.stop(), this.mightDrag.addAttr && (this.target.draggable = !0), this.mightDrag.setUneditable && setTimeout(() => {
      this.view.input.mouseDown == this && this.target.setAttribute("contentEditable", "false");
    }, 20), this.view.domObserver.start()), n.root.addEventListener("mouseup", this.up = this.up.bind(this)), n.root.addEventListener("mousemove", this.move = this.move.bind(this)), wa(n, "pointer");
  }
  done() {
    this.view.root.removeEventListener("mouseup", this.up), this.view.root.removeEventListener("mousemove", this.move), this.mightDrag && this.target && (this.view.domObserver.stop(), this.mightDrag.addAttr && this.target.removeAttribute("draggable"), this.mightDrag.setUneditable && this.target.removeAttribute("contentEditable"), this.view.domObserver.start()), this.delayedSelectionSync && setTimeout(() => da(this.view)), this.view.input.mouseDown = null;
  }
  up(n) {
    if (this.done(), !this.view.dom.contains(n.target))
      return;
    let t = this.pos;
    this.view.state.doc != this.startDoc && (t = this.view.posAtCoords(as(n))), this.updateAllowDefault(n), this.allowDefault || !t ? wa(this.view, "pointer") : rT(this.view, t.pos, t.inside, n, this.selectNode) ? n.preventDefault() : n.button == 0 && (this.flushed || // Safari ignores clicks on draggable elements
    Qt && this.mightDrag && !this.mightDrag.node.isAtom || // Chrome will sometimes treat a node selection as a
    // cursor, but still report that the node is selected
    // when asked through getSelection. You'll then get a
    // situation where clicking at the point where that
    // (hidden) cursor is doesn't change the selection, and
    // thus doesn't get a reaction from ProseMirror. This
    // works around that.
    Ut && !this.view.state.selection.visible && Math.min(Math.abs(t.pos - this.view.state.selection.from), Math.abs(t.pos - this.view.state.selection.to)) <= 2) ? (El(this.view, rt.near(this.view.state.doc.resolve(t.pos))), n.preventDefault()) : wa(this.view, "pointer");
  }
  move(n) {
    this.updateAllowDefault(n), wa(this.view, "pointer"), n.buttons == 0 && this.done();
  }
  updateAllowDefault(n) {
    !this.allowDefault && (Math.abs(this.event.x - n.clientX) > 4 || Math.abs(this.event.y - n.clientY) > 4) && (this.allowDefault = !0);
  }
}
ln.touchstart = (e) => {
  e.input.lastTouch = Date.now(), rc(e), wa(e, "pointer");
};
ln.touchmove = (e) => {
  e.input.lastTouch = Date.now(), wa(e, "pointer");
};
ln.contextmenu = (e) => rc(e);
function Jp(e, n) {
  return e.composing ? !0 : Qt && Math.abs(n.timeStamp - e.input.compositionEndedAt) < 500 ? (e.input.compositionEndedAt = -2e8, !0) : !1;
}
const uT = ia ? 5e3 : -1;
rn.compositionstart = rn.compositionupdate = (e) => {
  if (!e.composing) {
    e.domObserver.flush();
    let { state: n } = e, t = n.selection.$to;
    if (n.selection instanceof nt && (n.storedMarks || !t.textOffset && t.parentOffset && t.nodeBefore.marks.some((a) => a.type.spec.inclusive === !1) || Ut && Ip && cT(e)))
      e.markCursor = e.state.storedMarks || t.marks(), di(e, !0), e.markCursor = null;
    else if (di(e, !n.selection.empty), In && n.selection.empty && t.parentOffset && !t.textOffset && t.nodeBefore.marks.length) {
      let a = e.domSelectionRange();
      for (let l = a.focusNode, r = a.focusOffset; l && l.nodeType == 1 && r != 0; ) {
        let o = r < 0 ? l.lastChild : l.childNodes[r - 1];
        if (!o)
          break;
        if (o.nodeType == 3) {
          let i = e.domSelection();
          i && i.collapse(o, o.nodeValue.length);
          break;
        } else
          l = o, r = -1;
      }
    }
    e.input.composing = !0;
  }
  Zp(e, uT);
};
function cT(e) {
  let { focusNode: n, focusOffset: t } = e.domSelectionRange();
  if (!n || n.nodeType != 1 || t >= n.childNodes.length)
    return !1;
  let a = n.childNodes[t];
  return a.nodeType == 1 && a.contentEditable == "false";
}
rn.compositionend = (e, n) => {
  e.composing && (e.input.composing = !1, e.input.compositionEndedAt = n.timeStamp, e.input.compositionPendingChanges = e.domObserver.pendingRecords().length ? e.input.compositionID : 0, e.input.compositionNode = null, e.input.badSafariComposition ? e.domObserver.forceFlush() : e.input.compositionPendingChanges && Promise.resolve().then(() => e.domObserver.flush()), e.input.compositionID++, Zp(e, 20));
};
function Zp(e, n) {
  clearTimeout(e.input.composingTimeout), n > -1 && (e.input.composingTimeout = setTimeout(() => di(e), n));
}
function Xp(e) {
  for (e.composing && (e.input.composing = !1, e.input.compositionEndedAt = hT()); e.input.compositionNodes.length > 0; )
    e.input.compositionNodes.pop().markParentsDirty();
}
function fT(e) {
  let n = e.domSelectionRange();
  if (!n.focusNode)
    return null;
  let t = lI(n.focusNode, n.focusOffset), a = rI(n.focusNode, n.focusOffset);
  if (t && a && t != a) {
    let l = a.pmViewDesc, r = e.domObserver.lastChangedTextNode;
    if (t == r || a == r)
      return r;
    if (!l || !l.isText(a.nodeValue))
      return a;
    if (e.input.compositionNode == a) {
      let o = t.pmViewDesc;
      if (!(!o || !o.isText(t.nodeValue)))
        return a;
    }
  }
  return t || a;
}
function hT() {
  let e = document.createEvent("Event");
  return e.initEvent("event", !0, !0), e.timeStamp;
}
function di(e, n = !1) {
  if (!(ia && e.domObserver.flushingSoon >= 0)) {
    if (e.domObserver.forceFlush(), Xp(e), n || e.docView && e.docView.dirty) {
      let t = ec(e), a = e.state.selection;
      return t && !t.eq(a) ? e.dispatch(e.state.tr.setSelection(t)) : (e.markCursor || n) && !a.$from.node(a.$from.sharedDepth(a.to)).inlineContent ? e.dispatch(e.state.tr.deleteSelection()) : e.updateState(e.state), !0;
    }
    return !1;
  }
}
function bT(e, n) {
  if (!e.dom.parentNode)
    return;
  let t = e.dom.parentNode.appendChild(document.createElement("div"));
  t.appendChild(n), t.style.cssText = "position: fixed; left: -10000px; top: 10px";
  let a = getSelection(), l = document.createRange();
  l.selectNodeContents(n), e.dom.blur(), a.removeAllRanges(), a.addRange(l), setTimeout(() => {
    t.parentNode && t.parentNode.removeChild(t), e.focus();
  }, 50);
}
const Hr = un && Ta < 15 || jl && dI < 604;
ln.copy = rn.cut = (e, n) => {
  let t = n, a = e.state.selection, l = t.type == "cut";
  if (a.empty)
    return;
  let r = Hr ? null : t.clipboardData, o = a.content(), { dom: i, text: s } = nc(e, o);
  r ? (t.preventDefault(), r.clearData(), r.setData("text/html", i.innerHTML), r.setData("text/plain", s)) : bT(e, i), l && e.dispatch(e.state.tr.deleteSelection().scrollIntoView().setMeta("uiEvent", "cut"));
};
function gT(e) {
  return e.openStart == 0 && e.openEnd == 0 && e.content.childCount == 1 ? e.content.firstChild : null;
}
function pT(e, n) {
  if (!e.dom.parentNode)
    return;
  let t = e.input.shiftKey || e.state.selection.$from.parent.type.spec.code, a = e.dom.parentNode.appendChild(document.createElement(t ? "textarea" : "div"));
  t || (a.contentEditable = "true"), a.style.cssText = "position: fixed; left: -10000px; top: 10px", a.focus();
  let l = e.input.shiftKey && e.input.lastKeyCode != 45;
  setTimeout(() => {
    e.focus(), a.parentNode && a.parentNode.removeChild(a), t ? jr(e, a.value, null, l, n) : jr(e, a.textContent, a.innerHTML, l, n);
  }, 50);
}
function jr(e, n, t, a, l) {
  let r = jp(e, n, t, a, e.state.selection.$from);
  if (e.someProp("handlePaste", (s) => s(e, l, r || Ye.empty)))
    return !0;
  if (!r)
    return !1;
  let o = gT(r), i = o ? e.state.tr.replaceSelectionWith(o, a) : e.state.tr.replaceSelection(r);
  return e.dispatch(i.scrollIntoView().setMeta("paste", !0).setMeta("uiEvent", "paste")), !0;
}
function Qp(e) {
  let n = e.getData("text/plain") || e.getData("Text");
  if (n)
    return n;
  let t = e.getData("text/uri-list");
  return t ? t.replace(/\r?\n/g, " ") : "";
}
rn.paste = (e, n) => {
  let t = n;
  if (e.composing && !ia)
    return;
  let a = Hr ? null : t.clipboardData, l = e.input.shiftKey && e.input.lastKeyCode != 45;
  a && jr(e, Qp(a), a.getData("text/html"), l, t) ? t.preventDefault() : pT(e, t);
};
class _p {
  constructor(n, t, a) {
    this.slice = n, this.move = t, this.node = a;
  }
}
const mT = xn ? "altKey" : "ctrlKey";
function em(e, n) {
  let t;
  return e.someProp("dragCopies", (a) => {
    t = t || a(n);
  }), t != null ? !t : !n[mT];
}
ln.dragstart = (e, n) => {
  let t = n, a = e.input.mouseDown;
  if (a && a.done(), !t.dataTransfer)
    return;
  let l = e.state.selection, r = l.empty ? null : e.posAtCoords(as(t)), o;
  if (!(r && r.pos >= l.from && r.pos <= (l instanceof Xe ? l.to - 1 : l.to))) {
    if (a && a.mightDrag)
      o = Xe.create(e.state.doc, a.mightDrag.pos);
    else if (t.target && t.target.nodeType == 1) {
      let f = e.docView.nearestDesc(t.target, !0);
      f && f.node.type.spec.draggable && f != e.docView && (o = Xe.create(e.state.doc, f.posBefore));
    }
  }
  let i = (o || e.state.selection).content(), { dom: s, text: d, slice: u } = nc(e, i);
  (!t.dataTransfer.files.length || !Ut || $p > 120) && t.dataTransfer.clearData(), t.dataTransfer.setData(Hr ? "Text" : "text/html", s.innerHTML), t.dataTransfer.effectAllowed = "copyMove", Hr || t.dataTransfer.setData("text/plain", d), e.dragging = new _p(u, em(e, t), o);
};
ln.dragend = (e) => {
  let n = e.dragging;
  window.setTimeout(() => {
    e.dragging == n && (e.dragging = null);
  }, 50);
};
rn.dragover = rn.dragenter = (e, n) => n.preventDefault();
rn.drop = (e, n) => {
  try {
    vT(e, n, e.dragging);
  } finally {
    e.dragging = null;
  }
};
function vT(e, n, t) {
  if (!n.dataTransfer)
    return;
  let a = e.posAtCoords(as(n));
  if (!a)
    return;
  let l = e.state.doc.resolve(a.pos), r = t && t.slice;
  r ? e.someProp("transformPasted", (h) => {
    r = h(r, e, !1);
  }) : r = jp(e, Qp(n.dataTransfer), Hr ? null : n.dataTransfer.getData("text/html"), !1, l);
  let o = !!(t && em(e, n));
  if (e.someProp("handleDrop", (h) => h(e, n, r || Ye.empty, o))) {
    n.preventDefault();
    return;
  }
  if (!r)
    return;
  n.preventDefault();
  let i = r ? ap(e.state.doc, l.pos, r) : l.pos;
  i == null && (i = l.pos);
  let s = e.state.tr;
  if (o) {
    let { node: h } = t;
    h ? h.replace(s) : s.deleteSelection();
  }
  let d = s.mapping.map(i), u = r.openStart == 0 && r.openEnd == 0 && r.content.childCount == 1, f = s.doc;
  if (u ? s.replaceRangeWith(d, d, r.content.firstChild) : s.replaceRange(d, d, r), s.doc.eq(f))
    return;
  let b = s.doc.resolve(d);
  if (u && Xe.isSelectable(r.content.firstChild) && b.nodeAfter && b.nodeAfter.sameMarkup(r.content.firstChild))
    s.setSelection(new Xe(b));
  else {
    let h = s.mapping.map(i);
    s.mapping.maps[s.mapping.maps.length - 1].forEach((m, x, y, w) => h = w), s.setSelection(tc(e, b, s.doc.resolve(h)));
  }
  e.focus(), e.dispatch(s.setMeta("uiEvent", "drop"));
}
ln.focus = (e) => {
  e.input.lastFocus = Date.now(), e.focused || (e.domObserver.stop(), e.dom.classList.add("ProseMirror-focused"), e.domObserver.start(), e.focused = !0, setTimeout(() => {
    e.docView && e.hasFocus() && !e.domObserver.currentSelection.eq(e.domSelectionRange()) && da(e);
  }, 20));
};
ln.blur = (e, n) => {
  let t = n;
  e.focused && (e.domObserver.stop(), e.dom.classList.remove("ProseMirror-focused"), e.domObserver.start(), t.relatedTarget && e.dom.contains(t.relatedTarget) && e.domObserver.currentSelection.clear(), e.focused = !1);
};
ln.beforeinput = (e, n) => {
  if (Ut && ia && n.inputType == "deleteContentBackward") {
    e.domObserver.flushSoon();
    let { domChangeCount: a } = e.input;
    setTimeout(() => {
      if (e.input.domChangeCount != a || (e.dom.blur(), e.focus(), e.someProp("handleKeyDown", (r) => r(e, Ka(8, "Backspace")))))
        return;
      let { $cursor: l } = e.state.selection;
      l && l.pos > 0 && e.dispatch(e.state.tr.delete(l.pos - 1, l.pos).scrollIntoView());
    }, 50);
  }
};
for (let e in rn)
  ln[e] = rn[e];
function Wr(e, n) {
  if (e == n)
    return !0;
  for (let t in e)
    if (e[t] !== n[t])
      return !1;
  for (let t in n)
    if (!(t in e))
      return !1;
  return !0;
}
class ui {
  constructor(n, t) {
    this.toDOM = n, this.spec = t || nl, this.side = this.spec.side || 0;
  }
  map(n, t, a, l) {
    let { pos: r, deleted: o } = n.mapResult(t.from + l, this.side < 0 ? -1 : 1);
    return o ? null : new an(r - a, r - a, this);
  }
  valid() {
    return !0;
  }
  eq(n) {
    return this == n || n instanceof ui && (this.spec.key && this.spec.key == n.spec.key || this.toDOM == n.toDOM && Wr(this.spec, n.spec));
  }
  destroy(n) {
    this.spec.destroy && this.spec.destroy(n);
  }
}
class Ea {
  constructor(n, t) {
    this.attrs = n, this.spec = t || nl;
  }
  map(n, t, a, l) {
    let r = n.map(t.from + l, this.spec.inclusiveStart ? -1 : 1) - a, o = n.map(t.to + l, this.spec.inclusiveEnd ? 1 : -1) - a;
    return r >= o ? null : new an(r, o, this);
  }
  valid(n, t) {
    return t.from < t.to;
  }
  eq(n) {
    return this == n || n instanceof Ea && Wr(this.attrs, n.attrs) && Wr(this.spec, n.spec);
  }
  static is(n) {
    return n.type instanceof Ea;
  }
  destroy() {
  }
}
class oc {
  constructor(n, t) {
    this.attrs = n, this.spec = t || nl;
  }
  map(n, t, a, l) {
    let r = n.mapResult(t.from + l, 1);
    if (r.deleted)
      return null;
    let o = n.mapResult(t.to + l, -1);
    return o.deleted || o.pos <= r.pos ? null : new an(r.pos - a, o.pos - a, this);
  }
  valid(n, t) {
    let { index: a, offset: l } = n.content.findIndex(t.from), r;
    return l == t.from && !(r = n.child(a)).isText && l + r.nodeSize == t.to;
  }
  eq(n) {
    return this == n || n instanceof oc && Wr(this.attrs, n.attrs) && Wr(this.spec, n.spec);
  }
  destroy() {
  }
}
class an {
  /**
  @internal
  */
  constructor(n, t, a) {
    this.from = n, this.to = t, this.type = a;
  }
  /**
  @internal
  */
  copy(n, t) {
    return new an(n, t, this.type);
  }
  /**
  @internal
  */
  eq(n, t = 0) {
    return this.type.eq(n.type) && this.from + t == n.from && this.to + t == n.to;
  }
  /**
  @internal
  */
  map(n, t, a) {
    return this.type.map(n, this, t, a);
  }
  /**
  Creates a widget decoration, which is a DOM node that's shown in
  the document at the given position. It is recommended that you
  delay rendering the widget by passing a function that will be
  called when the widget is actually drawn in a view, but you can
  also directly pass a DOM node. `getPos` can be used to find the
  widget's current document position.
  */
  static widget(n, t, a) {
    return new an(n, n, new ui(t, a));
  }
  /**
  Creates an inline decoration, which adds the given attributes to
  each inline node between `from` and `to`.
  */
  static inline(n, t, a, l) {
    return new an(n, t, new Ea(a, l));
  }
  /**
  Creates a node decoration. `from` and `to` should point precisely
  before and after a node in the document. That node, and only that
  node, will receive the given attributes.
  */
  static node(n, t, a, l) {
    return new an(n, t, new oc(a, l));
  }
  /**
  The spec provided when creating this decoration. Can be useful
  if you've stored extra information in that object.
  */
  get spec() {
    return this.type.spec;
  }
  /**
  @internal
  */
  get inline() {
    return this.type instanceof Ea;
  }
  /**
  @internal
  */
  get widget() {
    return this.type instanceof ui;
  }
}
const yl = [], nl = {};
class $t {
  /**
  @internal
  */
  constructor(n, t) {
    this.local = n.length ? n : yl, this.children = t.length ? t : yl;
  }
  /**
  Create a set of decorations, using the structure of the given
  document. This will consume (modify) the `decorations` array, so
  you must make a copy if you want need to preserve that.
  */
  static create(n, t) {
    return t.length ? ci(t, n, 0, nl) : Zt;
  }
  /**
  Find all decorations in this set which touch the given range
  (including decorations that start or end directly at the
  boundaries) and match the given predicate on their spec. When
  `start` and `end` are omitted, all decorations in the set are
  considered. When `predicate` isn't given, all decorations are
  assumed to match.
  */
  find(n, t, a) {
    let l = [];
    return this.findInner(n ?? 0, t ?? 1e9, l, 0, a), l;
  }
  findInner(n, t, a, l, r) {
    for (let o = 0; o < this.local.length; o++) {
      let i = this.local[o];
      i.from <= t && i.to >= n && (!r || r(i.spec)) && a.push(i.copy(i.from + l, i.to + l));
    }
    for (let o = 0; o < this.children.length; o += 3)
      if (this.children[o] < t && this.children[o + 1] > n) {
        let i = this.children[o] + 1;
        this.children[o + 2].findInner(n - i, t - i, a, l + i, r);
      }
  }
  /**
  Map the set of decorations in response to a change in the
  document.
  */
  map(n, t, a) {
    return this == Zt || n.maps.length == 0 ? this : this.mapInner(n, t, 0, 0, a || nl);
  }
  /**
  @internal
  */
  mapInner(n, t, a, l, r) {
    let o;
    for (let i = 0; i < this.local.length; i++) {
      let s = this.local[i].map(n, a, l);
      s && s.type.valid(t, s) ? (o || (o = [])).push(s) : r.onRemove && r.onRemove(this.local[i].spec);
    }
    return this.children.length ? xT(this.children, o || [], n, t, a, l, r) : o ? new $t(o.sort(al), yl) : Zt;
  }
  /**
  Add the given array of decorations to the ones in the set,
  producing a new set. Consumes the `decorations` array. Needs
  access to the current document to create the appropriate tree
  structure.
  */
  add(n, t) {
    return t.length ? this == Zt ? $t.create(n, t) : this.addInner(n, t, 0) : this;
  }
  addInner(n, t, a) {
    let l, r = 0;
    n.forEach((i, s) => {
      let d = s + a, u;
      if (u = nm(t, i, d)) {
        for (l || (l = this.children.slice()); r < l.length && l[r] < s; )
          r += 3;
        l[r] == s ? l[r + 2] = l[r + 2].addInner(i, u, d + 1) : l.splice(r, 0, s, s + i.nodeSize, ci(u, i, d + 1, nl)), r += 3;
      }
    });
    let o = tm(r ? am(t) : t, -a);
    for (let i = 0; i < o.length; i++)
      o[i].type.valid(n, o[i]) || o.splice(i--, 1);
    return new $t(o.length ? this.local.concat(o).sort(al) : this.local, l || this.children);
  }
  /**
  Create a new set that contains the decorations in this set, minus
  the ones in the given array.
  */
  remove(n) {
    return n.length == 0 || this == Zt ? this : this.removeInner(n, 0);
  }
  removeInner(n, t) {
    let a = this.children, l = this.local;
    for (let r = 0; r < a.length; r += 3) {
      let o, i = a[r] + t, s = a[r + 1] + t;
      for (let u = 0, f; u < n.length; u++)
        (f = n[u]) && f.from > i && f.to < s && (n[u] = null, (o || (o = [])).push(f));
      if (!o)
        continue;
      a == this.children && (a = this.children.slice());
      let d = a[r + 2].removeInner(o, i + 1);
      d != Zt ? a[r + 2] = d : (a.splice(r, 3), r -= 3);
    }
    if (l.length) {
      for (let r = 0, o; r < n.length; r++)
        if (o = n[r])
          for (let i = 0; i < l.length; i++)
            l[i].eq(o, t) && (l == this.local && (l = this.local.slice()), l.splice(i--, 1));
    }
    return a == this.children && l == this.local ? this : l.length || a.length ? new $t(l, a) : Zt;
  }
  forChild(n, t) {
    if (this == Zt)
      return this;
    if (t.isLeaf)
      return $t.empty;
    let a, l;
    for (let i = 0; i < this.children.length; i += 3)
      if (this.children[i] >= n) {
        this.children[i] == n && (a = this.children[i + 2]);
        break;
      }
    let r = n + 1, o = r + t.content.size;
    for (let i = 0; i < this.local.length; i++) {
      let s = this.local[i];
      if (s.from < o && s.to > r && s.type instanceof Ea) {
        let d = Math.max(r, s.from) - r, u = Math.min(o, s.to) - r;
        d < u && (l || (l = [])).push(s.copy(d, u));
      }
    }
    if (l) {
      let i = new $t(l.sort(al), yl);
      return a ? new xa([i, a]) : i;
    }
    return a || Zt;
  }
  /**
  @internal
  */
  eq(n) {
    if (this == n)
      return !0;
    if (!(n instanceof $t) || this.local.length != n.local.length || this.children.length != n.children.length)
      return !1;
    for (let t = 0; t < this.local.length; t++)
      if (!this.local[t].eq(n.local[t]))
        return !1;
    for (let t = 0; t < this.children.length; t += 3)
      if (this.children[t] != n.children[t] || this.children[t + 1] != n.children[t + 1] || !this.children[t + 2].eq(n.children[t + 2]))
        return !1;
    return !0;
  }
  /**
  @internal
  */
  locals(n) {
    return ic(this.localsInner(n));
  }
  /**
  @internal
  */
  localsInner(n) {
    if (this == Zt)
      return yl;
    if (n.inlineContent || !this.local.some(Ea.is))
      return this.local;
    let t = [];
    for (let a = 0; a < this.local.length; a++)
      this.local[a].type instanceof Ea || t.push(this.local[a]);
    return t;
  }
  forEachSet(n) {
    n(this);
  }
}
$t.empty = new $t([], []);
$t.removeOverlap = ic;
const Zt = $t.empty;
class xa {
  constructor(n) {
    this.members = n;
  }
  map(n, t) {
    const a = this.members.map((l) => l.map(n, t, nl));
    return xa.from(a);
  }
  forChild(n, t) {
    if (t.isLeaf)
      return $t.empty;
    let a = [];
    for (let l = 0; l < this.members.length; l++) {
      let r = this.members[l].forChild(n, t);
      r != Zt && (r instanceof xa ? a = a.concat(r.members) : a.push(r));
    }
    return xa.from(a);
  }
  eq(n) {
    if (!(n instanceof xa) || n.members.length != this.members.length)
      return !1;
    for (let t = 0; t < this.members.length; t++)
      if (!this.members[t].eq(n.members[t]))
        return !1;
    return !0;
  }
  locals(n) {
    let t, a = !0;
    for (let l = 0; l < this.members.length; l++) {
      let r = this.members[l].localsInner(n);
      if (r.length)
        if (!t)
          t = r;
        else {
          a && (t = t.slice(), a = !1);
          for (let o = 0; o < r.length; o++)
            t.push(r[o]);
        }
    }
    return t ? ic(a ? t : t.sort(al)) : yl;
  }
  // Create a group for the given array of decoration sets, or return
  // a single set when possible.
  static from(n) {
    switch (n.length) {
      case 0:
        return Zt;
      case 1:
        return n[0];
      default:
        return new xa(n.every((t) => t instanceof $t) ? n : n.reduce((t, a) => t.concat(a instanceof $t ? a : a.members), []));
    }
  }
  forEachSet(n) {
    for (let t = 0; t < this.members.length; t++)
      this.members[t].forEachSet(n);
  }
}
function xT(e, n, t, a, l, r, o) {
  let i = e.slice();
  for (let d = 0, u = r; d < t.maps.length; d++) {
    let f = 0;
    t.maps[d].forEach((b, h, m, x) => {
      let y = x - m - (h - b);
      for (let w = 0; w < i.length; w += 3) {
        let S = i[w + 1];
        if (S < 0 || b > S + u - f)
          continue;
        let $ = i[w] + u - f;
        h >= $ ? i[w + 1] = b <= $ ? -2 : -1 : b >= u && y && (i[w] += y, i[w + 1] += y);
      }
      f += y;
    }), u = t.maps[d].map(u, -1);
  }
  let s = !1;
  for (let d = 0; d < i.length; d += 3)
    if (i[d + 1] < 0) {
      if (i[d + 1] == -2) {
        s = !0, i[d + 1] = -1;
        continue;
      }
      let u = t.map(e[d] + r), f = u - l;
      if (f < 0 || f >= a.content.size) {
        s = !0;
        continue;
      }
      let b = t.map(e[d + 1] + r, -1), h = b - l, { index: m, offset: x } = a.content.findIndex(f), y = a.maybeChild(m);
      if (y && x == f && x + y.nodeSize == h) {
        let w = i[d + 2].mapInner(t, y, u + 1, e[d] + r + 1, o);
        w != Zt ? (i[d] = f, i[d + 1] = h, i[d + 2] = w) : (i[d + 1] = -2, s = !0);
      } else
        s = !0;
    }
  if (s) {
    let d = yT(i, e, n, t, l, r, o), u = ci(d, a, 0, o);
    n = u.local;
    for (let f = 0; f < i.length; f += 3)
      i[f + 1] < 0 && (i.splice(f, 3), f -= 3);
    for (let f = 0, b = 0; f < u.children.length; f += 3) {
      let h = u.children[f];
      for (; b < i.length && i[b] < h; )
        b += 3;
      i.splice(b, 0, u.children[f], u.children[f + 1], u.children[f + 2]);
    }
  }
  return new $t(n.sort(al), i);
}
function tm(e, n) {
  if (!n || !e.length)
    return e;
  let t = [];
  for (let a = 0; a < e.length; a++) {
    let l = e[a];
    t.push(new an(l.from + n, l.to + n, l.type));
  }
  return t;
}
function yT(e, n, t, a, l, r, o) {
  function i(s, d) {
    for (let u = 0; u < s.local.length; u++) {
      let f = s.local[u].map(a, l, d);
      f ? t.push(f) : o.onRemove && o.onRemove(s.local[u].spec);
    }
    for (let u = 0; u < s.children.length; u += 3)
      i(s.children[u + 2], s.children[u] + d + 1);
  }
  for (let s = 0; s < e.length; s += 3)
    e[s + 1] == -1 && i(e[s + 2], n[s] + r + 1);
  return t;
}
function nm(e, n, t) {
  if (n.isLeaf)
    return null;
  let a = t + n.nodeSize, l = null;
  for (let r = 0, o; r < e.length; r++)
    (o = e[r]) && o.from > t && o.to < a && ((l || (l = [])).push(o), e[r] = null);
  return l;
}
function am(e) {
  let n = [];
  for (let t = 0; t < e.length; t++)
    e[t] != null && n.push(e[t]);
  return n;
}
function ci(e, n, t, a) {
  let l = [], r = !1;
  n.forEach((i, s) => {
    let d = nm(e, i, s + t);
    if (d) {
      r = !0;
      let u = ci(d, i, t + s + 1, a);
      u != Zt && l.push(s, s + i.nodeSize, u);
    }
  });
  let o = tm(r ? am(e) : e, -t).sort(al);
  for (let i = 0; i < o.length; i++)
    o[i].type.valid(n, o[i]) || (a.onRemove && a.onRemove(o[i].spec), o.splice(i--, 1));
  return o.length || l.length ? new $t(o, l) : Zt;
}
function al(e, n) {
  return e.from - n.from || e.to - n.to;
}
function ic(e) {
  let n = e;
  for (let t = 0; t < n.length - 1; t++) {
    let a = n[t];
    if (a.from != a.to)
      for (let l = t + 1; l < n.length; l++) {
        let r = n[l];
        if (r.from == a.from) {
          r.to != a.to && (n == e && (n = e.slice()), n[l] = r.copy(r.from, a.to), ih(n, l + 1, r.copy(a.to, r.to)));
          continue;
        } else {
          r.from < a.to && (n == e && (n = e.slice()), n[t] = a.copy(a.from, r.from), ih(n, l, a.copy(r.from, a.to)));
          break;
        }
      }
  }
  return n;
}
function ih(e, n, t) {
  for (; n < e.length && al(t, e[n]) > 0; )
    n++;
  e.splice(n, 0, t);
}
function Hs(e) {
  let n = [];
  return e.someProp("decorations", (t) => {
    let a = t(e.state);
    a && a != Zt && n.push(a);
  }), e.cursorWrapper && n.push($t.create(e.state.doc, [e.cursorWrapper.deco])), xa.from(n);
}
const kT = {
  childList: !0,
  characterData: !0,
  characterDataOldValue: !0,
  attributes: !0,
  attributeOldValue: !0,
  subtree: !0
}, wT = un && Ta <= 11;
class CT {
  constructor() {
    this.anchorNode = null, this.anchorOffset = 0, this.focusNode = null, this.focusOffset = 0;
  }
  set(n) {
    this.anchorNode = n.anchorNode, this.anchorOffset = n.anchorOffset, this.focusNode = n.focusNode, this.focusOffset = n.focusOffset;
  }
  clear() {
    this.anchorNode = this.focusNode = null;
  }
  eq(n) {
    return n.anchorNode == this.anchorNode && n.anchorOffset == this.anchorOffset && n.focusNode == this.focusNode && n.focusOffset == this.focusOffset;
  }
}
class ST {
  constructor(n, t) {
    this.view = n, this.handleDOMChange = t, this.queue = [], this.flushingSoon = -1, this.observer = null, this.currentSelection = new CT(), this.onCharData = null, this.suppressingSelectionUpdates = !1, this.lastChangedTextNode = null, this.observer = window.MutationObserver && new window.MutationObserver((a) => {
      for (let l = 0; l < a.length; l++)
        this.queue.push(a[l]);
      un && Ta <= 11 && a.some((l) => l.type == "childList" && l.removedNodes.length || l.type == "characterData" && l.oldValue.length > l.target.nodeValue.length) ? this.flushSoon() : Qt && n.composing && a.some((l) => l.type == "childList" && l.target.nodeName == "TR") ? (n.input.badSafariComposition = !0, this.flushSoon()) : this.flush();
    }), wT && (this.onCharData = (a) => {
      this.queue.push({ target: a.target, type: "characterData", oldValue: a.prevValue }), this.flushSoon();
    }), this.onSelectionChange = this.onSelectionChange.bind(this);
  }
  flushSoon() {
    this.flushingSoon < 0 && (this.flushingSoon = window.setTimeout(() => {
      this.flushingSoon = -1, this.flush();
    }, 20));
  }
  forceFlush() {
    this.flushingSoon > -1 && (window.clearTimeout(this.flushingSoon), this.flushingSoon = -1, this.flush());
  }
  start() {
    this.observer && (this.observer.takeRecords(), this.observer.observe(this.view.dom, kT)), this.onCharData && this.view.dom.addEventListener("DOMCharacterDataModified", this.onCharData), this.connectSelection();
  }
  stop() {
    if (this.observer) {
      let n = this.observer.takeRecords();
      if (n.length) {
        for (let t = 0; t < n.length; t++)
          this.queue.push(n[t]);
        window.setTimeout(() => this.flush(), 20);
      }
      this.observer.disconnect();
    }
    this.onCharData && this.view.dom.removeEventListener("DOMCharacterDataModified", this.onCharData), this.disconnectSelection();
  }
  connectSelection() {
    this.view.dom.ownerDocument.addEventListener("selectionchange", this.onSelectionChange);
  }
  disconnectSelection() {
    this.view.dom.ownerDocument.removeEventListener("selectionchange", this.onSelectionChange);
  }
  suppressSelectionUpdates() {
    this.suppressingSelectionUpdates = !0, setTimeout(() => this.suppressingSelectionUpdates = !1, 50);
  }
  onSelectionChange() {
    if (_f(this.view)) {
      if (this.suppressingSelectionUpdates)
        return da(this.view);
      if (un && Ta <= 11 && !this.view.state.selection.empty) {
        let n = this.view.domSelectionRange();
        if (n.focusNode && cl(n.focusNode, n.focusOffset, n.anchorNode, n.anchorOffset))
          return this.flushSoon();
      }
      this.flush();
    }
  }
  setCurSelection() {
    this.currentSelection.set(this.view.domSelectionRange());
  }
  ignoreSelectionChange(n) {
    if (!n.focusNode)
      return !0;
    let t = /* @__PURE__ */ new Set(), a;
    for (let r = n.focusNode; r; r = Hl(r))
      t.add(r);
    for (let r = n.anchorNode; r; r = Hl(r))
      if (t.has(r)) {
        a = r;
        break;
      }
    let l = a && this.view.docView.nearestDesc(a);
    if (l && l.ignoreMutation({
      type: "selection",
      target: a.nodeType == 3 ? a.parentNode : a
    }))
      return this.setCurSelection(), !0;
  }
  pendingRecords() {
    if (this.observer)
      for (let n of this.observer.takeRecords())
        this.queue.push(n);
    return this.queue;
  }
  flush() {
    let { view: n } = this;
    if (!n.docView || this.flushingSoon > -1)
      return;
    let t = this.pendingRecords();
    t.length && (this.queue = []);
    let a = n.domSelectionRange(), l = !this.suppressingSelectionUpdates && !this.currentSelection.eq(a) && _f(n) && !this.ignoreSelectionChange(a), r = -1, o = -1, i = !1, s = [];
    if (n.editable)
      for (let u = 0; u < t.length; u++) {
        let f = this.registerMutation(t[u], s);
        f && (r = r < 0 ? f.from : Math.min(f.from, r), o = o < 0 ? f.to : Math.max(f.to, o), f.typeOver && (i = !0));
      }
    if (s.some((u) => u.nodeName == "BR") && (n.input.lastKeyCode == 8 || n.input.lastKeyCode == 46)) {
      for (let u of s)
        if (u.nodeName == "BR" && u.parentNode) {
          let f = u.nextSibling;
          for (; f && f.nodeType == 1; ) {
            if (f.contentEditable == "false") {
              u.parentNode.removeChild(u);
              break;
            }
            f = f.firstChild;
          }
        }
    } else if (In && s.length) {
      let u = s.filter((f) => f.nodeName == "BR");
      if (u.length == 2) {
        let [f, b] = u;
        f.parentNode && f.parentNode.parentNode == b.parentNode ? b.remove() : f.remove();
      } else {
        let { focusNode: f } = this.currentSelection;
        for (let b of u) {
          let h = b.parentNode;
          h && h.nodeName == "LI" && (!f || TT(n, f) != h) && b.remove();
        }
      }
    }
    let d = null;
    r < 0 && l && n.input.lastFocus > Date.now() - 200 && Math.max(n.input.lastTouch, n.input.lastClick.time) < Date.now() - 300 && ts(a) && (d = ec(n)) && d.eq(rt.near(n.state.doc.resolve(0), 1)) ? (n.input.lastFocus = 0, da(n), this.currentSelection.set(a), n.scrollToSelection()) : (r > -1 || l) && (r > -1 && (n.docView.markDirty(r, o), $T(n)), n.input.badSafariComposition && (n.input.badSafariComposition = !1, LT(n, s)), this.handleDOMChange(r, o, i, s), n.docView && n.docView.dirty ? n.updateState(n.state) : this.currentSelection.eq(a) || da(n), this.currentSelection.set(a));
  }
  registerMutation(n, t) {
    if (t.indexOf(n.target) > -1)
      return null;
    let a = this.view.docView.nearestDesc(n.target);
    if (n.type == "attributes" && (a == this.view.docView || n.attributeName == "contenteditable" || // Firefox sometimes fires spurious events for null/empty styles
    n.attributeName == "style" && !n.oldValue && !n.target.getAttribute("style")) || !a || a.ignoreMutation(n))
      return null;
    if (n.type == "childList") {
      for (let u = 0; u < n.addedNodes.length; u++) {
        let f = n.addedNodes[u];
        t.push(f), f.nodeType == 3 && (this.lastChangedTextNode = f);
      }
      if (a.contentDOM && a.contentDOM != a.dom && !a.contentDOM.contains(n.target))
        return { from: a.posBefore, to: a.posAfter };
      let l = n.previousSibling, r = n.nextSibling;
      if (un && Ta <= 11 && n.addedNodes.length)
        for (let u = 0; u < n.addedNodes.length; u++) {
          let { previousSibling: f, nextSibling: b } = n.addedNodes[u];
          (!f || Array.prototype.indexOf.call(n.addedNodes, f) < 0) && (l = f), (!b || Array.prototype.indexOf.call(n.addedNodes, b) < 0) && (r = b);
        }
      let o = l && l.parentNode == n.target ? Wt(l) + 1 : 0, i = a.localPosFromDOM(n.target, o, -1), s = r && r.parentNode == n.target ? Wt(r) : n.target.childNodes.length, d = a.localPosFromDOM(n.target, s, 1);
      return { from: i, to: d };
    } else return n.type == "attributes" ? { from: a.posAtStart - a.border, to: a.posAtEnd + a.border } : (this.lastChangedTextNode = n.target, {
      from: a.posAtStart,
      to: a.posAtEnd,
      // An event was generated for a text change that didn't change
      // any text. Mark the dom change to fall back to assuming the
      // selection was typed over with an identical value if it can't
      // find another change.
      typeOver: n.target.nodeValue == n.oldValue
    });
  }
}
let sh = /* @__PURE__ */ new WeakMap(), dh = !1;
function $T(e) {
  if (!sh.has(e) && (sh.set(e, null), ["normal", "nowrap", "pre-line"].indexOf(getComputedStyle(e.dom).whiteSpace) !== -1)) {
    if (e.requiresGeckoHackNode = In, dh)
      return;
    console.warn("ProseMirror expects the CSS white-space property to be set, preferably to 'pre-wrap'. It is recommended to load style/prosemirror.css from the prosemirror-view package."), dh = !0;
  }
}
function uh(e, n) {
  let t = n.startContainer, a = n.startOffset, l = n.endContainer, r = n.endOffset, o = e.domAtPos(e.state.selection.anchor);
  return cl(o.node, o.offset, l, r) && ([t, a, l, r] = [l, r, t, a]), { anchorNode: t, anchorOffset: a, focusNode: l, focusOffset: r };
}
function IT(e, n) {
  if (n.getComposedRanges) {
    let l = n.getComposedRanges(e.root)[0];
    if (l)
      return uh(e, l);
  }
  let t;
  function a(l) {
    l.preventDefault(), l.stopImmediatePropagation(), t = l.getTargetRanges()[0];
  }
  return e.dom.addEventListener("beforeinput", a, !0), document.execCommand("indent"), e.dom.removeEventListener("beforeinput", a, !0), t ? uh(e, t) : null;
}
function TT(e, n) {
  for (let t = n.parentNode; t && t != e.dom; t = t.parentNode) {
    let a = e.docView.nearestDesc(t, !0);
    if (a && a.node.isBlock)
      return t;
  }
  return null;
}
function LT(e, n) {
  var t;
  let { focusNode: a, focusOffset: l } = e.domSelectionRange();
  for (let r of n)
    if (((t = r.parentNode) === null || t === void 0 ? void 0 : t.nodeName) == "TR") {
      let o = r.nextSibling;
      for (; o && o.nodeName != "TD" && o.nodeName != "TH"; )
        o = o.nextSibling;
      if (o) {
        let i = o;
        for (; ; ) {
          let s = i.firstChild;
          if (!s || s.nodeType != 1 || s.contentEditable == "false" || /^(BR|IMG)$/.test(s.nodeName))
            break;
          i = s;
        }
        i.insertBefore(r, i.firstChild), a == r && e.domSelection().collapse(r, l);
      } else
        r.parentNode.removeChild(r);
    }
}
function ET(e, n, t) {
  let { node: a, fromOffset: l, toOffset: r, from: o, to: i } = e.docView.parseRange(n, t), s = e.domSelectionRange(), d, u = s.anchorNode;
  if (u && e.dom.contains(u.nodeType == 1 ? u : u.parentNode) && (d = [{ node: u, offset: s.anchorOffset }], ts(s) || d.push({ node: s.focusNode, offset: s.focusOffset })), Ut && e.input.lastKeyCode === 8)
    for (let y = r; y > l; y--) {
      let w = a.childNodes[y - 1], S = w.pmViewDesc;
      if (w.nodeName == "BR" && !S) {
        r = y;
        break;
      }
      if (!S || S.size)
        break;
    }
  let f = e.state.doc, b = e.someProp("domParser") || Ia.fromSchema(e.state.schema), h = f.resolve(o), m = null, x = b.parse(a, {
    topNode: h.parent,
    topMatch: h.parent.contentMatchAt(h.index()),
    topOpen: !0,
    from: l,
    to: r,
    preserveWhitespace: h.parent.type.whitespace == "pre" ? "full" : !0,
    findPositions: d,
    ruleFromNode: AT,
    context: h
  });
  if (d && d[0].pos != null) {
    let y = d[0].pos, w = d[1] && d[1].pos;
    w == null && (w = y), m = { anchor: y + o, head: w + o };
  }
  return { doc: x, sel: m, from: o, to: i };
}
function AT(e) {
  let n = e.pmViewDesc;
  if (n)
    return n.parseRule();
  if (e.nodeName == "BR" && e.parentNode) {
    if (Qt && /^(ul|ol)$/i.test(e.parentNode.nodeName)) {
      let t = document.createElement("div");
      return t.appendChild(document.createElement("li")), { skip: t };
    } else if (e.parentNode.lastChild == e || Qt && /^(tr|table)$/i.test(e.parentNode.nodeName))
      return { ignore: !0 };
  } else if (e.nodeName == "IMG" && e.getAttribute("mark-placeholder"))
    return { ignore: !0 };
  return null;
}
const RT = /^(a|abbr|acronym|b|bd[io]|big|br|button|cite|code|data(list)?|del|dfn|em|i|img|ins|kbd|label|map|mark|meter|output|q|ruby|s|samp|small|span|strong|su[bp]|time|u|tt|var)$/i;
function BT(e, n, t, a, l) {
  let r = e.input.compositionPendingChanges || (e.composing ? e.input.compositionID : 0);
  if (e.input.compositionPendingChanges = 0, n < 0) {
    let R = e.input.lastSelectionTime > Date.now() - 50 ? e.input.lastSelectionOrigin : null, z = ec(e, R);
    if (z && !e.state.selection.eq(z)) {
      if (Ut && ia && e.input.lastKeyCode === 13 && Date.now() - 100 < e.input.lastKeyCodeTime && e.someProp("handleKeyDown", (V) => V(e, Ka(13, "Enter"))))
        return;
      let D = e.state.tr.setSelection(z);
      R == "pointer" ? D.setMeta("pointer", !0) : R == "key" && D.scrollIntoView(), r && D.setMeta("composition", r), e.dispatch(D);
    }
    return;
  }
  let o = e.state.doc.resolve(n), i = o.sharedDepth(t);
  n = o.before(i + 1), t = e.state.doc.resolve(t).after(i + 1);
  let s = e.state.selection, d = ET(e, n, t), u = e.state.doc, f = u.slice(d.from, d.to), b, h;
  e.input.lastKeyCode === 8 && Date.now() - 100 < e.input.lastKeyCodeTime ? (b = e.state.selection.to, h = "end") : (b = e.state.selection.from, h = "start"), e.input.lastKeyCode = null;
  let m = zT(f.content, d.doc.content, d.from, b, h);
  if (m && e.input.domChangeCount++, (jl && e.input.lastIOSEnter > Date.now() - 225 || ia) && l.some((R) => R.nodeType == 1 && !RT.test(R.nodeName)) && (!m || m.endA >= m.endB) && e.someProp("handleKeyDown", (R) => R(e, Ka(13, "Enter")))) {
    e.input.lastIOSEnter = 0;
    return;
  }
  if (!m)
    if (a && s instanceof nt && !s.empty && s.$head.sameParent(s.$anchor) && !e.composing && !(d.sel && d.sel.anchor != d.sel.head))
      m = { start: s.from, endA: s.to, endB: s.to };
    else {
      if (d.sel) {
        let R = ch(e, e.state.doc, d.sel);
        if (R && !R.eq(e.state.selection)) {
          let z = e.state.tr.setSelection(R);
          r && z.setMeta("composition", r), e.dispatch(z);
        }
      }
      return;
    }
  e.state.selection.from < e.state.selection.to && m.start == m.endB && e.state.selection instanceof nt && (m.start > e.state.selection.from && m.start <= e.state.selection.from + 2 && e.state.selection.from >= d.from ? m.start = e.state.selection.from : m.endA < e.state.selection.to && m.endA >= e.state.selection.to - 2 && e.state.selection.to <= d.to && (m.endB += e.state.selection.to - m.endA, m.endA = e.state.selection.to)), un && Ta <= 11 && m.endB == m.start + 1 && m.endA == m.start && m.start > d.from && d.doc.textBetween(m.start - d.from - 1, m.start - d.from + 1) == "  " && (m.start--, m.endA--, m.endB--);
  let x = d.doc.resolveNoCache(m.start - d.from), y = d.doc.resolveNoCache(m.endB - d.from), w = u.resolve(m.start), S = x.sameParent(y) && x.parent.inlineContent && w.end() >= m.endA;
  if ((jl && e.input.lastIOSEnter > Date.now() - 225 && (!S || l.some((R) => R.nodeName == "DIV" || R.nodeName == "P")) || !S && x.pos < d.doc.content.size && (!x.sameParent(y) || !x.parent.inlineContent) && x.pos < y.pos && !/\S/.test(d.doc.textBetween(x.pos, y.pos, "", ""))) && e.someProp("handleKeyDown", (R) => R(e, Ka(13, "Enter")))) {
    e.input.lastIOSEnter = 0;
    return;
  }
  if (e.state.selection.anchor > m.start && DT(u, m.start, m.endA, x, y) && e.someProp("handleKeyDown", (R) => R(e, Ka(8, "Backspace")))) {
    ia && Ut && e.domObserver.suppressSelectionUpdates();
    return;
  }
  Ut && m.endB == m.start && (e.input.lastChromeDelete = Date.now()), ia && !S && x.start() != y.start() && y.parentOffset == 0 && x.depth == y.depth && d.sel && d.sel.anchor == d.sel.head && d.sel.head == m.endA && (m.endB -= 2, y = d.doc.resolveNoCache(m.endB - d.from), setTimeout(() => {
    e.someProp("handleKeyDown", function(R) {
      return R(e, Ka(13, "Enter"));
    });
  }, 20));
  let $ = m.start, T = m.endA, L = (R) => {
    let z = R || e.state.tr.replace($, T, d.doc.slice(m.start - d.from, m.endB - d.from));
    if (d.sel) {
      let D = ch(e, z.doc, d.sel);
      D && !(Ut && e.composing && D.empty && (m.start != m.endB || e.input.lastChromeDelete < Date.now() - 100) && (D.head == $ || D.head == z.mapping.map(T) - 1) || un && D.empty && D.head == $) && z.setSelection(D);
    }
    return r && z.setMeta("composition", r), z.scrollIntoView();
  }, A;
  if (S)
    if (x.pos == y.pos) {
      un && Ta <= 11 && x.parentOffset == 0 && (e.domObserver.suppressSelectionUpdates(), setTimeout(() => da(e), 20));
      let R = L(e.state.tr.delete($, T)), z = u.resolve(m.start).marksAcross(u.resolve(m.endA));
      z && R.ensureMarks(z), e.dispatch(R);
    } else if (
      // Adding or removing a mark
      m.endA == m.endB && (A = MT(x.parent.content.cut(x.parentOffset, y.parentOffset), w.parent.content.cut(w.parentOffset, m.endA - w.start())))
    ) {
      let R = L(e.state.tr);
      A.type == "add" ? R.addMark($, T, A.mark) : R.removeMark($, T, A.mark), e.dispatch(R);
    } else if (x.parent.child(x.index()).isText && x.index() == y.index() - (y.textOffset ? 0 : 1)) {
      let R = x.parent.textBetween(x.parentOffset, y.parentOffset), z = () => L(e.state.tr.insertText(R, $, T));
      e.someProp("handleTextInput", (D) => D(e, $, T, R, z)) || e.dispatch(z());
    } else
      e.dispatch(L());
  else
    e.dispatch(L());
}
function ch(e, n, t) {
  return Math.max(t.anchor, t.head) > n.content.size ? null : tc(e, n.resolve(t.anchor), n.resolve(t.head));
}
function MT(e, n) {
  let t = e.firstChild.marks, a = n.firstChild.marks, l = t, r = a, o, i, s;
  for (let u = 0; u < a.length; u++)
    l = a[u].removeFromSet(l);
  for (let u = 0; u < t.length; u++)
    r = t[u].removeFromSet(r);
  if (l.length == 1 && r.length == 0)
    i = l[0], o = "add", s = (u) => u.mark(i.addToSet(u.marks));
  else if (l.length == 0 && r.length == 1)
    i = r[0], o = "remove", s = (u) => u.mark(i.removeFromSet(u.marks));
  else
    return null;
  let d = [];
  for (let u = 0; u < n.childCount; u++)
    d.push(s(n.child(u)));
  if (Pe.from(d).eq(e))
    return { mark: i, type: o };
}
function DT(e, n, t, a, l) {
  if (
    // The content must have shrunk
    t - n <= l.pos - a.pos || // newEnd must point directly at or after the end of the block that newStart points into
    js(a, !0, !1) < l.pos
  )
    return !1;
  let r = e.resolve(n);
  if (!a.parent.isTextblock) {
    let i = r.nodeAfter;
    return i != null && t == n + i.nodeSize;
  }
  if (r.parentOffset < r.parent.content.size || !r.parent.isTextblock)
    return !1;
  let o = e.resolve(js(r, !0, !0));
  return !o.parent.isTextblock || o.pos > t || js(o, !0, !1) < t ? !1 : a.parent.content.cut(a.parentOffset).eq(o.parent.content);
}
function js(e, n, t) {
  let a = e.depth, l = n ? e.end() : e.pos;
  for (; a > 0 && (n || e.indexAfter(a) == e.node(a).childCount); )
    a--, l++, n = !1;
  if (t) {
    let r = e.node(a).maybeChild(e.indexAfter(a));
    for (; r && !r.isLeaf; )
      r = r.firstChild, l++;
  }
  return l;
}
function zT(e, n, t, a, l) {
  let r = e.findDiffStart(n, t);
  if (r == null)
    return null;
  let { a: o, b: i } = e.findDiffEnd(n, t + e.size, t + n.size);
  if (l == "end") {
    let s = Math.max(0, r - Math.min(o, i));
    a -= o + s - r;
  }
  if (o < r && e.size < n.size) {
    let s = a <= r && a >= o ? r - a : 0;
    r -= s, r && r < n.size && fh(n.textBetween(r - 1, r + 1)) && (r += s ? 1 : -1), i = r + (i - o), o = r;
  } else if (i < r) {
    let s = a <= r && a >= i ? r - a : 0;
    r -= s, r && r < e.size && fh(e.textBetween(r - 1, r + 1)) && (r += s ? 1 : -1), o = r + (o - i), i = r;
  }
  return { start: r, endA: o, endB: i };
}
function fh(e) {
  if (e.length != 2)
    return !1;
  let n = e.charCodeAt(0), t = e.charCodeAt(1);
  return n >= 56320 && n <= 57343 && t >= 55296 && t <= 56319;
}
class lm {
  /**
  Create a view. `place` may be a DOM node that the editor should
  be appended to, a function that will place it into the document,
  or an object whose `mount` property holds the node to use as the
  document container. If it is `null`, the editor will not be
  added to the document.
  */
  constructor(n, t) {
    this._root = null, this.focused = !1, this.trackWrites = null, this.mounted = !1, this.markCursor = null, this.cursorWrapper = null, this.lastSelectedViewDesc = void 0, this.input = new XI(), this.prevDirectPlugins = [], this.pluginViews = [], this.requiresGeckoHackNode = !1, this.dragging = null, this._props = t, this.state = t.state, this.directPlugins = t.plugins || [], this.directPlugins.forEach(mh), this.dispatch = this.dispatch.bind(this), this.dom = n && n.mount || document.createElement("div"), n && (n.appendChild ? n.appendChild(this.dom) : typeof n == "function" ? n(this.dom) : n.mount && (this.mounted = !0)), this.editable = gh(this), bh(this), this.nodeViews = ph(this), this.docView = Kf(this.state.doc, hh(this), Hs(this), this.dom, this), this.domObserver = new ST(this, (a, l, r, o) => BT(this, a, l, r, o)), this.domObserver.start(), QI(this), this.updatePluginViews();
  }
  /**
  Holds `true` when a
  [composition](https://w3c.github.io/uievents/#events-compositionevents)
  is active.
  */
  get composing() {
    return this.input.composing;
  }
  /**
  The view's current [props](https://prosemirror.net/docs/ref/#view.EditorProps).
  */
  get props() {
    if (this._props.state != this.state) {
      let n = this._props;
      this._props = {};
      for (let t in n)
        this._props[t] = n[t];
      this._props.state = this.state;
    }
    return this._props;
  }
  /**
  Update the view's props. Will immediately cause an update to
  the DOM.
  */
  update(n) {
    n.handleDOMEvents != this._props.handleDOMEvents && Kd(this);
    let t = this._props;
    this._props = n, n.plugins && (n.plugins.forEach(mh), this.directPlugins = n.plugins), this.updateStateInner(n.state, t);
  }
  /**
  Update the view by updating existing props object with the object
  given as argument. Equivalent to `view.update(Object.assign({},
  view.props, props))`.
  */
  setProps(n) {
    let t = {};
    for (let a in this._props)
      t[a] = this._props[a];
    t.state = this.state;
    for (let a in n)
      t[a] = n[a];
    this.update(t);
  }
  /**
  Update the editor's `state` prop, without touching any of the
  other props.
  */
  updateState(n) {
    this.updateStateInner(n, this._props);
  }
  updateStateInner(n, t) {
    var a;
    let l = this.state, r = !1, o = !1;
    n.storedMarks && this.composing && (Xp(this), o = !0), this.state = n;
    let i = l.plugins != n.plugins || this._props.plugins != t.plugins;
    if (i || this._props.plugins != t.plugins || this._props.nodeViews != t.nodeViews) {
      let h = ph(this);
      PT(h, this.nodeViews) && (this.nodeViews = h, r = !0);
    }
    (i || t.handleDOMEvents != this._props.handleDOMEvents) && Kd(this), this.editable = gh(this), bh(this);
    let s = Hs(this), d = hh(this), u = l.plugins != n.plugins && !l.doc.eq(n.doc) ? "reset" : n.scrollToSelection > l.scrollToSelection ? "to selection" : "preserve", f = r || !this.docView.matchesNode(n.doc, d, s);
    (f || !n.selection.eq(l.selection)) && (o = !0);
    let b = u == "preserve" && o && this.dom.style.overflowAnchor == null && fI(this);
    if (o) {
      this.domObserver.stop();
      let h = f && (un || Ut) && !this.composing && !l.selection.empty && !n.selection.empty && OT(l.selection, n.selection);
      if (f) {
        let m = Ut ? this.trackWrites = this.domSelectionRange().focusNode : null;
        this.composing && (this.input.compositionNode = fT(this)), (r || !this.docView.update(n.doc, d, s, this)) && (this.docView.updateOuterDeco(d), this.docView.destroy(), this.docView = Kf(n.doc, d, s, this.dom, this)), m && (!this.trackWrites || !this.dom.contains(this.trackWrites)) && (h = !0);
      }
      h || !(this.input.mouseDown && this.domObserver.currentSelection.eq(this.domSelectionRange()) && OI(this)) ? da(this, h) : (Vp(this, n.selection), this.domObserver.setCurSelection()), this.domObserver.start();
    }
    this.updatePluginViews(l), !((a = this.dragging) === null || a === void 0) && a.node && !l.doc.eq(n.doc) && this.updateDraggedNode(this.dragging, l), u == "reset" ? this.dom.scrollTop = 0 : u == "to selection" ? this.scrollToSelection() : b && hI(b);
  }
  /**
  @internal
  */
  scrollToSelection() {
    let n = this.domSelectionRange().focusNode;
    if (!(!n || !this.dom.contains(n.nodeType == 1 ? n : n.parentNode))) {
      if (!this.someProp("handleScrollToSelection", (t) => t(this))) if (this.state.selection instanceof Xe) {
        let t = this.docView.domAfterPos(this.state.selection.from);
        t.nodeType == 1 && Hf(this, t.getBoundingClientRect(), n);
      } else
        Hf(this, this.coordsAtPos(this.state.selection.head, 1), n);
    }
  }
  destroyPluginViews() {
    let n;
    for (; n = this.pluginViews.pop(); )
      n.destroy && n.destroy();
  }
  updatePluginViews(n) {
    if (!n || n.plugins != this.state.plugins || this.directPlugins != this.prevDirectPlugins) {
      this.prevDirectPlugins = this.directPlugins, this.destroyPluginViews();
      for (let t = 0; t < this.directPlugins.length; t++) {
        let a = this.directPlugins[t];
        a.spec.view && this.pluginViews.push(a.spec.view(this));
      }
      for (let t = 0; t < this.state.plugins.length; t++) {
        let a = this.state.plugins[t];
        a.spec.view && this.pluginViews.push(a.spec.view(this));
      }
    } else
      for (let t = 0; t < this.pluginViews.length; t++) {
        let a = this.pluginViews[t];
        a.update && a.update(this, n);
      }
  }
  updateDraggedNode(n, t) {
    let a = n.node, l = -1;
    if (a.from < this.state.doc.content.size && this.state.doc.nodeAt(a.from) == a.node)
      l = a.from;
    else {
      let r = a.from + (this.state.doc.content.size - t.doc.content.size);
      (r > 0 && r < this.state.doc.content.size && this.state.doc.nodeAt(r)) == a.node && (l = r);
    }
    this.dragging = new _p(n.slice, n.move, l < 0 ? void 0 : Xe.create(this.state.doc, l));
  }
  someProp(n, t) {
    let a = this._props && this._props[n], l;
    if (a != null && (l = t ? t(a) : a))
      return l;
    for (let o = 0; o < this.directPlugins.length; o++) {
      let i = this.directPlugins[o].props[n];
      if (i != null && (l = t ? t(i) : i))
        return l;
    }
    let r = this.state.plugins;
    if (r)
      for (let o = 0; o < r.length; o++) {
        let i = r[o].props[n];
        if (i != null && (l = t ? t(i) : i))
          return l;
      }
  }
  /**
  Query whether the view has focus.
  */
  hasFocus() {
    if (un) {
      let n = this.root.activeElement;
      if (n == this.dom)
        return !0;
      if (!n || !this.dom.contains(n))
        return !1;
      for (; n && this.dom != n && this.dom.contains(n); ) {
        if (n.contentEditable == "false")
          return !1;
        n = n.parentElement;
      }
      return !0;
    }
    return this.root.activeElement == this.dom;
  }
  /**
  Focus the editor.
  */
  focus() {
    this.domObserver.stop(), this.editable && bI(this.dom), da(this), this.domObserver.start();
  }
  /**
  Get the document root in which the editor exists. This will
  usually be the top-level `document`, but might be a [shadow
  DOM](https://developer.mozilla.org/en-US/docs/Web/Web_Components/Shadow_DOM)
  root if the editor is inside one.
  */
  get root() {
    let n = this._root;
    if (n == null) {
      for (let t = this.dom.parentNode; t; t = t.parentNode)
        if (t.nodeType == 9 || t.nodeType == 11 && t.host)
          return t.getSelection || (Object.getPrototypeOf(t).getSelection = () => t.ownerDocument.getSelection()), this._root = t;
    }
    return n || document;
  }
  /**
  When an existing editor view is moved to a new document or
  shadow tree, call this to make it recompute its root.
  */
  updateRoot() {
    this._root = null;
  }
  /**
  Given a pair of viewport coordinates, return the document
  position that corresponds to them. May return null if the given
  coordinates aren't inside of the editor. When an object is
  returned, its `pos` property is the position nearest to the
  coordinates, and its `inside` property holds the position of the
  inner node that the position falls inside of, or -1 if it is at
  the top level, not in any node.
  */
  posAtCoords(n) {
    return xI(this, n);
  }
  /**
  Returns the viewport rectangle at a given document position.
  `left` and `right` will be the same number, as this returns a
  flat cursor-ish rectangle. If the position is between two things
  that aren't directly adjacent, `side` determines which element
  is used. When < 0, the element before the position is used,
  otherwise the element after.
  */
  coordsAtPos(n, t = 1) {
    return Rp(this, n, t);
  }
  /**
  Find the DOM position that corresponds to the given document
  position. When `side` is negative, find the position as close as
  possible to the content before the position. When positive,
  prefer positions close to the content after the position. When
  zero, prefer as shallow a position as possible.
  
  Note that you should **not** mutate the editor's internal DOM,
  only inspect it (and even that is usually not necessary).
  */
  domAtPos(n, t = 0) {
    return this.docView.domFromPos(n, t);
  }
  /**
  Find the DOM node that represents the document node after the
  given position. May return `null` when the position doesn't point
  in front of a node or if the node is inside an opaque node view.
  
  This is intended to be able to call things like
  `getBoundingClientRect` on that DOM node. Do **not** mutate the
  editor DOM directly, or add styling this way, since that will be
  immediately overriden by the editor as it redraws the node.
  */
  nodeDOM(n) {
    let t = this.docView.descAt(n);
    return t ? t.nodeDOM : null;
  }
  /**
  Find the document position that corresponds to a given DOM
  position. (Whenever possible, it is preferable to inspect the
  document structure directly, rather than poking around in the
  DOM, but sometimes—for example when interpreting an event
  target—you don't have a choice.)
  
  The `bias` parameter can be used to influence which side of a DOM
  node to use when the position is inside a leaf node.
  */
  posAtDOM(n, t, a = -1) {
    let l = this.docView.posFromDOM(n, t, a);
    if (l == null)
      throw new RangeError("DOM position not inside the editor");
    return l;
  }
  /**
  Find out whether the selection is at the end of a textblock when
  moving in a given direction. When, for example, given `"left"`,
  it will return true if moving left from the current cursor
  position would leave that position's parent textblock. Will apply
  to the view's current state by default, but it is possible to
  pass a different state.
  */
  endOfTextblock(n, t) {
    return SI(this, t || this.state, n);
  }
  /**
  Run the editor's paste logic with the given HTML string. The
  `event`, if given, will be passed to the
  [`handlePaste`](https://prosemirror.net/docs/ref/#view.EditorProps.handlePaste) hook.
  */
  pasteHTML(n, t) {
    return jr(this, "", n, !1, t || new ClipboardEvent("paste"));
  }
  /**
  Run the editor's paste logic with the given plain-text input.
  */
  pasteText(n, t) {
    return jr(this, n, null, !0, t || new ClipboardEvent("paste"));
  }
  /**
  Serialize the given slice as it would be if it was copied from
  this editor. Returns a DOM element that contains a
  representation of the slice as its children, a textual
  representation, and the transformed slice (which can be
  different from the given input due to hooks like
  [`transformCopied`](https://prosemirror.net/docs/ref/#view.EditorProps.transformCopied)).
  */
  serializeForClipboard(n) {
    return nc(this, n);
  }
  /**
  Removes the editor from the DOM and destroys all [node
  views](https://prosemirror.net/docs/ref/#view.NodeView).
  */
  destroy() {
    this.docView && (_I(this), this.destroyPluginViews(), this.mounted ? (this.docView.update(this.state.doc, [], Hs(this), this), this.dom.textContent = "") : this.dom.parentNode && this.dom.parentNode.removeChild(this.dom), this.docView.destroy(), this.docView = null, nI());
  }
  /**
  This is true when the view has been
  [destroyed](https://prosemirror.net/docs/ref/#view.EditorView.destroy) (and thus should not be
  used anymore).
  */
  get isDestroyed() {
    return this.docView == null;
  }
  /**
  Used for testing.
  */
  dispatchEvent(n) {
    return tT(this, n);
  }
  /**
  @internal
  */
  domSelectionRange() {
    let n = this.domSelection();
    return n ? Qt && this.root.nodeType === 11 && iI(this.dom.ownerDocument) == this.dom && IT(this, n) || n : { focusNode: null, focusOffset: 0, anchorNode: null, anchorOffset: 0 };
  }
  /**
  @internal
  */
  domSelection() {
    return this.root.getSelection();
  }
}
lm.prototype.dispatch = function(e) {
  let n = this._props.dispatchTransaction;
  n ? n.call(this, e) : this.updateState(this.state.apply(e));
};
function hh(e) {
  let n = /* @__PURE__ */ Object.create(null);
  return n.class = "ProseMirror", n.contenteditable = String(e.editable), e.someProp("attributes", (t) => {
    if (typeof t == "function" && (t = t(e.state)), t)
      for (let a in t)
        a == "class" ? n.class += " " + t[a] : a == "style" ? n.style = (n.style ? n.style + ";" : "") + t[a] : !n[a] && a != "contenteditable" && a != "nodeName" && (n[a] = String(t[a]));
  }), n.translate || (n.translate = "no"), [an.node(0, e.state.doc.content.size, n)];
}
function bh(e) {
  if (e.markCursor) {
    let n = document.createElement("img");
    n.className = "ProseMirror-separator", n.setAttribute("mark-placeholder", "true"), n.setAttribute("alt", ""), e.cursorWrapper = { dom: n, deco: an.widget(e.state.selection.from, n, { raw: !0, marks: e.markCursor }) };
  } else
    e.cursorWrapper = null;
}
function gh(e) {
  return !e.someProp("editable", (n) => n(e.state) === !1);
}
function OT(e, n) {
  let t = Math.min(e.$anchor.sharedDepth(e.head), n.$anchor.sharedDepth(n.head));
  return e.$anchor.start(t) != n.$anchor.start(t);
}
function ph(e) {
  let n = /* @__PURE__ */ Object.create(null);
  function t(a) {
    for (let l in a)
      Object.prototype.hasOwnProperty.call(n, l) || (n[l] = a[l]);
  }
  return e.someProp("nodeViews", t), e.someProp("markViews", t), n;
}
function PT(e, n) {
  let t = 0, a = 0;
  for (let l in e) {
    if (e[l] != n[l])
      return !0;
    t++;
  }
  for (let l in n)
    a++;
  return t != a;
}
function mh(e) {
  if (e.spec.state || e.spec.filterTransaction || e.spec.appendTransaction)
    throw new RangeError("Plugins passed directly to the view must not have a state component");
}
var Ba = {
  8: "Backspace",
  9: "Tab",
  10: "Enter",
  12: "NumLock",
  13: "Enter",
  16: "Shift",
  17: "Control",
  18: "Alt",
  20: "CapsLock",
  27: "Escape",
  32: " ",
  33: "PageUp",
  34: "PageDown",
  35: "End",
  36: "Home",
  37: "ArrowLeft",
  38: "ArrowUp",
  39: "ArrowRight",
  40: "ArrowDown",
  44: "PrintScreen",
  45: "Insert",
  46: "Delete",
  59: ";",
  61: "=",
  91: "Meta",
  92: "Meta",
  106: "*",
  107: "+",
  108: ",",
  109: "-",
  110: ".",
  111: "/",
  144: "NumLock",
  145: "ScrollLock",
  160: "Shift",
  161: "Shift",
  162: "Control",
  163: "Control",
  164: "Alt",
  165: "Alt",
  173: "-",
  186: ";",
  187: "=",
  188: ",",
  189: "-",
  190: ".",
  191: "/",
  192: "`",
  219: "[",
  220: "\\",
  221: "]",
  222: "'"
}, fi = {
  48: ")",
  49: "!",
  50: "@",
  51: "#",
  52: "$",
  53: "%",
  54: "^",
  55: "&",
  56: "*",
  57: "(",
  59: ":",
  61: "+",
  173: "_",
  186: ":",
  187: "+",
  188: "<",
  189: "_",
  190: ">",
  191: "?",
  192: "~",
  219: "{",
  220: "|",
  221: "}",
  222: '"'
}, FT = typeof navigator < "u" && /Mac/.test(navigator.platform), VT = typeof navigator < "u" && /MSIE \d|Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(navigator.userAgent);
for (var qt = 0; qt < 10; qt++) Ba[48 + qt] = Ba[96 + qt] = String(qt);
for (var qt = 1; qt <= 24; qt++) Ba[qt + 111] = "F" + qt;
for (var qt = 65; qt <= 90; qt++)
  Ba[qt] = String.fromCharCode(qt + 32), fi[qt] = String.fromCharCode(qt);
for (var Ws in Ba) fi.hasOwnProperty(Ws) || (fi[Ws] = Ba[Ws]);
function NT(e) {
  var n = FT && e.metaKey && e.shiftKey && !e.ctrlKey && !e.altKey || VT && e.shiftKey && e.key && e.key.length == 1 || e.key == "Unidentified", t = !n && e.key || (e.shiftKey ? fi : Ba)[e.keyCode] || e.key || "Unidentified";
  return t == "Esc" && (t = "Escape"), t == "Del" && (t = "Delete"), t == "Left" && (t = "ArrowLeft"), t == "Up" && (t = "ArrowUp"), t == "Right" && (t = "ArrowRight"), t == "Down" && (t = "ArrowDown"), t;
}
const HT = typeof navigator < "u" && /Mac|iP(hone|[oa]d)/.test(navigator.platform), jT = typeof navigator < "u" && /Win/.test(navigator.platform);
function WT(e) {
  let n = e.split(/-(?!$)/), t = n[n.length - 1];
  t == "Space" && (t = " ");
  let a, l, r, o;
  for (let i = 0; i < n.length - 1; i++) {
    let s = n[i];
    if (/^(cmd|meta|m)$/i.test(s))
      o = !0;
    else if (/^a(lt)?$/i.test(s))
      a = !0;
    else if (/^(c|ctrl|control)$/i.test(s))
      l = !0;
    else if (/^s(hift)?$/i.test(s))
      r = !0;
    else if (/^mod$/i.test(s))
      HT ? o = !0 : l = !0;
    else
      throw new Error("Unrecognized modifier name: " + s);
  }
  return a && (t = "Alt-" + t), l && (t = "Ctrl-" + t), o && (t = "Meta-" + t), r && (t = "Shift-" + t), t;
}
function qT(e) {
  let n = /* @__PURE__ */ Object.create(null);
  for (let t in e)
    n[WT(t)] = e[t];
  return n;
}
function qs(e, n, t = !0) {
  return n.altKey && (e = "Alt-" + e), n.ctrlKey && (e = "Ctrl-" + e), n.metaKey && (e = "Meta-" + e), t && n.shiftKey && (e = "Shift-" + e), e;
}
function UT(e) {
  return new Tt({ props: { handleKeyDown: rm(e) } });
}
function rm(e) {
  let n = qT(e);
  return function(t, a) {
    let l = NT(a), r, o = n[qs(l, a)];
    if (o && o(t.state, t.dispatch, t))
      return !0;
    if (l.length == 1 && l != " ") {
      if (a.shiftKey) {
        let i = n[qs(l, a, !1)];
        if (i && i(t.state, t.dispatch, t))
          return !0;
      }
      if ((a.altKey || a.metaKey || a.ctrlKey) && // Ctrl-Alt may be used for AltGr on Windows
      !(jT && a.ctrlKey && a.altKey) && (r = Ba[a.keyCode]) && r != l) {
        let i = n[qs(r, a)];
        if (i && i(t.state, t.dispatch, t))
          return !0;
      }
    }
    return !1;
  };
}
var GT = Object.defineProperty, sc = (e, n) => {
  for (var t in n)
    GT(e, t, { get: n[t], enumerable: !0 });
};
function ls(e) {
  const { state: n, transaction: t } = e;
  let { selection: a } = t, { doc: l } = t, { storedMarks: r } = t;
  return {
    ...n,
    apply: n.apply.bind(n),
    applyTransaction: n.applyTransaction.bind(n),
    plugins: n.plugins,
    schema: n.schema,
    reconfigure: n.reconfigure.bind(n),
    toJSON: n.toJSON.bind(n),
    get storedMarks() {
      return r;
    },
    get selection() {
      return a;
    },
    get doc() {
      return l;
    },
    get tr() {
      return a = t.selection, l = t.doc, r = t.storedMarks, t;
    }
  };
}
var rs = class {
  constructor(e) {
    this.editor = e.editor, this.rawCommands = this.editor.extensionManager.commands, this.customState = e.state;
  }
  get hasCustomState() {
    return !!this.customState;
  }
  get state() {
    return this.customState || this.editor.state;
  }
  get commands() {
    const { rawCommands: e, editor: n, state: t } = this, { view: a } = n, { tr: l } = t, r = this.buildProps(l);
    return Object.fromEntries(
      Object.entries(e).map(([o, i]) => [o, (...d) => {
        const u = i(...d)(r);
        return !l.getMeta("preventDispatch") && !this.hasCustomState && a.dispatch(l), u;
      }])
    );
  }
  get chain() {
    return () => this.createChain();
  }
  get can() {
    return () => this.createCan();
  }
  createChain(e, n = !0) {
    const { rawCommands: t, editor: a, state: l } = this, { view: r } = a, o = [], i = !!e, s = e || l.tr, d = () => (!i && n && !s.getMeta("preventDispatch") && !this.hasCustomState && r.dispatch(s), o.every((f) => f === !0)), u = {
      ...Object.fromEntries(
        Object.entries(t).map(([f, b]) => [f, (...m) => {
          const x = this.buildProps(s, n), y = b(...m)(x);
          return o.push(y), u;
        }])
      ),
      run: d
    };
    return u;
  }
  createCan(e) {
    const { rawCommands: n, state: t } = this, a = !1, l = e || t.tr, r = this.buildProps(l, a);
    return {
      ...Object.fromEntries(
        Object.entries(n).map(([i, s]) => [i, (...d) => s(...d)({ ...r, dispatch: void 0 })])
      ),
      chain: () => this.createChain(l, a)
    };
  }
  buildProps(e, n = !0) {
    const { rawCommands: t, editor: a, state: l } = this, { view: r } = a, o = {
      tr: e,
      editor: a,
      view: r,
      state: ls({
        state: l,
        transaction: e
      }),
      dispatch: n ? () => {
      } : void 0,
      chain: () => this.createChain(e, n),
      can: () => this.createCan(e),
      get commands() {
        return Object.fromEntries(
          Object.entries(t).map(([i, s]) => [i, (...d) => s(...d)(o)])
        );
      }
    };
    return o;
  }
}, om = {};
sc(om, {
  blur: () => KT,
  clearContent: () => YT,
  clearNodes: () => JT,
  command: () => ZT,
  createParagraphNear: () => XT,
  cut: () => QT,
  deleteCurrentNode: () => _T,
  deleteNode: () => eL,
  deleteRange: () => tL,
  deleteSelection: () => lL,
  enter: () => rL,
  exitCode: () => oL,
  extendMarkRange: () => iL,
  first: () => sL,
  focus: () => uL,
  forEach: () => cL,
  insertContent: () => fL,
  insertContentAt: () => gL,
  joinBackward: () => vL,
  joinDown: () => mL,
  joinForward: () => xL,
  joinItemBackward: () => yL,
  joinItemForward: () => kL,
  joinTextblockBackward: () => wL,
  joinTextblockForward: () => CL,
  joinUp: () => pL,
  keyboardShortcut: () => $L,
  lift: () => IL,
  liftEmptyBlock: () => TL,
  liftListItem: () => LL,
  newlineInCode: () => EL,
  resetAttributes: () => AL,
  scrollIntoView: () => RL,
  selectAll: () => BL,
  selectNodeBackward: () => ML,
  selectNodeForward: () => DL,
  selectParentNode: () => zL,
  selectTextblockEnd: () => OL,
  selectTextblockStart: () => PL,
  setContent: () => FL,
  setMark: () => rE,
  setMeta: () => oE,
  setNode: () => iE,
  setNodeSelection: () => sE,
  setTextDirection: () => dE,
  setTextSelection: () => uE,
  sinkListItem: () => cE,
  splitBlock: () => fE,
  splitListItem: () => hE,
  toggleList: () => gE,
  toggleMark: () => pE,
  toggleNode: () => mE,
  toggleWrap: () => vE,
  undoInputRule: () => xE,
  unsetAllMarks: () => yE,
  unsetMark: () => kE,
  unsetTextDirection: () => wE,
  updateAttributes: () => CE,
  wrapIn: () => SE,
  wrapInList: () => $E
});
var KT = () => ({ editor: e, view: n }) => (requestAnimationFrame(() => {
  var t;
  e.isDestroyed || (n.dom.blur(), (t = window == null ? void 0 : window.getSelection()) == null || t.removeAllRanges());
}), !0), YT = (e = !0) => ({ commands: n }) => n.setContent("", { emitUpdate: e }), JT = () => ({ state: e, tr: n, dispatch: t }) => {
  const { selection: a } = n, { ranges: l } = a;
  return t && l.forEach(({ $from: r, $to: o }) => {
    e.doc.nodesBetween(r.pos, o.pos, (i, s) => {
      if (i.type.isText)
        return;
      const { doc: d, mapping: u } = n, f = d.resolve(u.map(s)), b = d.resolve(u.map(s + i.nodeSize)), h = f.blockRange(b);
      if (!h)
        return;
      const m = Jl(h);
      if (i.type.isTextblock) {
        const { defaultType: x } = f.parent.contentMatchAt(f.index());
        n.setNodeMarkup(h.start, x);
      }
      (m || m === 0) && n.lift(h, m);
    });
  }), !0;
}, ZT = (e) => (n) => e(n), XT = () => ({ state: e, dispatch: n }) => yp(e, n), QT = (e, n) => ({ editor: t, tr: a }) => {
  const { state: l } = t, r = l.doc.slice(e.from, e.to);
  a.deleteRange(e.from, e.to);
  const o = a.mapping.map(n);
  return a.insert(o, r.content), a.setSelection(new nt(a.doc.resolve(Math.max(o - 1, 0)))), !0;
}, _T = () => ({ tr: e, dispatch: n }) => {
  const { selection: t } = e, a = t.$anchor.node();
  if (a.content.size > 0)
    return !1;
  const l = e.selection.$anchor;
  for (let r = l.depth; r > 0; r -= 1)
    if (l.node(r).type === a.type) {
      if (n) {
        const i = l.before(r), s = l.after(r);
        e.delete(i, s).scrollIntoView();
      }
      return !0;
    }
  return !1;
};
function Dt(e, n) {
  if (typeof e == "string") {
    if (!n.nodes[e])
      throw Error(`There is no node type named '${e}'. Maybe you forgot to add the extension?`);
    return n.nodes[e];
  }
  return e;
}
var eL = (e) => ({ tr: n, state: t, dispatch: a }) => {
  const l = Dt(e, t.schema), r = n.selection.$anchor;
  for (let o = r.depth; o > 0; o -= 1)
    if (r.node(o).type === l) {
      if (a) {
        const s = r.before(o), d = r.after(o);
        n.delete(s, d).scrollIntoView();
      }
      return !0;
    }
  return !1;
}, tL = (e) => ({ tr: n, dispatch: t }) => {
  const { from: a, to: l } = e;
  return t && n.delete(a, l), !0;
}, nL = (e) => e.content ? /^text(\*|\+)/.test(e.content) : !1, vh = (e, n, t) => {
  if (!e.parent.isInline || t === "left" && e.pos > e.start() || t === "right" && e.pos < e.end())
    return e.pos;
  const a = n.nodes[e.parent.type.name].spec;
  return nL(a) ? t === "left" ? e.start() - 1 : e.end() + 1 : e.pos;
}, aL = (e, n, t) => {
  const a = vh(e, t, "left"), l = vh(n, t, "right");
  return { from: a, to: l };
}, lL = () => ({ state: e, dispatch: n }) => {
  const { $from: t, $to: a } = e.selection;
  if (e.selection.empty)
    return !1;
  const { from: l, to: r } = aL(t, a, e.schema);
  return n && (e.tr.deleteRange(l, r).scrollIntoView(), n(e.tr)), !0;
}, rL = () => ({ commands: e }) => e.keyboardShortcut("Enter"), oL = () => ({ state: e, dispatch: n }) => H$(e, n);
function dc(e) {
  return Object.prototype.toString.call(e) === "[object RegExp]";
}
function hi(e, n, t = { strict: !0 }) {
  const a = Object.keys(n);
  return a.length ? a.every((l) => t.strict ? n[l] === e[l] : dc(n[l]) ? n[l].test(e[l]) : n[l] === e[l]) : !0;
}
function im(e, n, t = {}) {
  return e.find((a) => a.type === n && hi(
    // Only check equality for the attributes that are provided
    Object.fromEntries(Object.keys(t).map((l) => [l, a.attrs[l]])),
    t
  ));
}
function xh(e, n, t = {}) {
  return !!im(e, n, t);
}
function uc(e, n, t) {
  if (!e || !n)
    return;
  let a = e.parent.childAfter(e.parentOffset);
  if ((!a.node || !a.node.marks.some((d) => d.type === n)) && (a = e.parent.childBefore(e.parentOffset)), !a.node || !a.node.marks.some((d) => d.type === n))
    return;
  if (!t) {
    const d = a.node.marks.find((u) => u.type === n);
    d && (t = d.attrs);
  }
  if (!im([...a.node.marks], n, t))
    return;
  let r = a.index, o = e.start() + a.offset, i = r + 1, s = o + a.node.nodeSize;
  for (; r > 0 && xh([...e.parent.child(r - 1).marks], n, t); )
    r -= 1, o -= e.parent.child(r).nodeSize;
  for (; i < e.parent.childCount && xh([...e.parent.child(i).marks], n, t); )
    s += e.parent.child(i).nodeSize, i += 1;
  return {
    from: o,
    to: s
  };
}
function ca(e, n) {
  if (typeof e == "string") {
    if (!n.marks[e])
      throw Error(`There is no mark type named '${e}'. Maybe you forgot to add the extension?`);
    return n.marks[e];
  }
  return e;
}
var iL = (e, n) => ({ tr: t, state: a, dispatch: l }) => {
  const r = ca(e, a.schema), { doc: o, selection: i } = t, { $from: s, from: d, to: u } = i;
  if (l) {
    const f = uc(s, r, n);
    if (f && f.from <= d && f.to >= u) {
      const b = nt.create(o, f.from, f.to);
      t.setSelection(b);
    }
  }
  return !0;
}, sL = (e) => (n) => {
  const t = typeof e == "function" ? e(n) : e;
  for (let a = 0; a < t.length; a += 1)
    if (t[a](n))
      return !0;
  return !1;
};
function sm(e) {
  return e instanceof nt;
}
function Za(e = 0, n = 0, t = 0) {
  return Math.min(Math.max(e, n), t);
}
function dm(e, n = null) {
  if (!n)
    return null;
  const t = rt.atStart(e), a = rt.atEnd(e);
  if (n === "start" || n === !0)
    return t;
  if (n === "end")
    return a;
  const l = t.from, r = a.to;
  return n === "all" ? nt.create(e, Za(0, l, r), Za(e.content.size, l, r)) : nt.create(e, Za(n, l, r), Za(n, l, r));
}
function yh() {
  return navigator.platform === "Android" || /android/i.test(navigator.userAgent);
}
function bi() {
  return ["iPad Simulator", "iPhone Simulator", "iPod Simulator", "iPad", "iPhone", "iPod"].includes(navigator.platform) || // iPad on iOS 13 detection
  navigator.userAgent.includes("Mac") && "ontouchend" in document;
}
function dL() {
  return typeof navigator < "u" ? /^((?!chrome|android).)*safari/i.test(navigator.userAgent) : !1;
}
var uL = (e = null, n = {}) => ({ editor: t, view: a, tr: l, dispatch: r }) => {
  n = {
    scrollIntoView: !0,
    ...n
  };
  const o = () => {
    (bi() || yh()) && a.dom.focus(), dL() && !bi() && !yh() && a.dom.focus({ preventScroll: !0 }), requestAnimationFrame(() => {
      t.isDestroyed || (a.focus(), n != null && n.scrollIntoView && t.commands.scrollIntoView());
    });
  };
  try {
    if (a.hasFocus() && e === null || e === !1)
      return !0;
  } catch {
    return !1;
  }
  if (r && e === null && !sm(t.state.selection))
    return o(), !0;
  const i = dm(l.doc, e) || t.state.selection, s = t.state.selection.eq(i);
  return r && (s || l.setSelection(i), s && l.storedMarks && l.setStoredMarks(l.storedMarks), o()), !0;
}, cL = (e, n) => (t) => e.every((a, l) => n(a, { ...t, index: l })), fL = (e, n) => ({ tr: t, commands: a }) => a.insertContentAt({ from: t.selection.from, to: t.selection.to }, e, n), um = (e) => {
  const n = e.childNodes;
  for (let t = n.length - 1; t >= 0; t -= 1) {
    const a = n[t];
    a.nodeType === 3 && a.nodeValue && /^(\n\s\s|\n)$/.test(a.nodeValue) ? e.removeChild(a) : a.nodeType === 1 && um(a);
  }
  return e;
};
function wo(e) {
  if (typeof window > "u")
    throw new Error("[tiptap error]: there is no window object available, so this function cannot be used");
  const n = `<body>${e}</body>`, t = new window.DOMParser().parseFromString(n, "text/html").body;
  return um(t);
}
function qr(e, n, t) {
  if (e instanceof $a || e instanceof Pe)
    return e;
  t = {
    slice: !0,
    parseOptions: {},
    ...t
  };
  const a = typeof e == "object" && e !== null, l = typeof e == "string";
  if (a)
    try {
      if (Array.isArray(e) && e.length > 0)
        return Pe.fromArray(e.map((i) => n.nodeFromJSON(i)));
      const o = n.nodeFromJSON(e);
      return t.errorOnInvalidContent && o.check(), o;
    } catch (r) {
      if (t.errorOnInvalidContent)
        throw new Error("[tiptap error]: Invalid JSON content", { cause: r });
      return console.warn("[tiptap warn]: Invalid content.", "Passed value:", e, "Error:", r), qr("", n, t);
    }
  if (l) {
    if (t.errorOnInvalidContent) {
      let o = !1, i = "";
      const s = new Gg({
        topNode: n.spec.topNode,
        marks: n.spec.marks,
        // Prosemirror's schemas are executed such that: the last to execute, matches last
        // This means that we can add a catch-all node at the end of the schema to catch any content that we don't know how to handle
        nodes: n.spec.nodes.append({
          __tiptap__private__unknown__catch__all__node: {
            content: "inline*",
            group: "block",
            parseDOM: [
              {
                tag: "*",
                getAttrs: (d) => (o = !0, i = typeof d == "string" ? d : d.outerHTML, null)
              }
            ]
          }
        })
      });
      if (t.slice ? Ia.fromSchema(s).parseSlice(wo(e), t.parseOptions) : Ia.fromSchema(s).parse(wo(e), t.parseOptions), t.errorOnInvalidContent && o)
        throw new Error("[tiptap error]: Invalid HTML content", {
          cause: new Error(`Invalid element found: ${i}`)
        });
    }
    const r = Ia.fromSchema(n);
    return t.slice ? r.parseSlice(wo(e), t.parseOptions).content : r.parse(wo(e), t.parseOptions);
  }
  return qr("", n, t);
}
function hL(e, n, t) {
  const a = e.steps.length - 1;
  if (a < n)
    return;
  const l = e.steps[a];
  if (!(l instanceof Bt || l instanceof Vt))
    return;
  const r = e.mapping.maps[a];
  let o = 0;
  r.forEach((i, s, d, u) => {
    o === 0 && (o = u);
  }), e.setSelection(rt.near(e.doc.resolve(o), t));
}
var bL = (e) => !("type" in e), gL = (e, n, t) => ({ tr: a, dispatch: l, editor: r }) => {
  var o;
  if (l) {
    t = {
      parseOptions: r.options.parseOptions,
      updateSelection: !0,
      applyInputRules: !1,
      applyPasteRules: !1,
      ...t
    };
    let i;
    const s = (y) => {
      r.emit("contentError", {
        editor: r,
        error: y,
        disableCollaboration: () => {
          "collaboration" in r.storage && typeof r.storage.collaboration == "object" && r.storage.collaboration && (r.storage.collaboration.isDisabled = !0);
        }
      });
    }, d = {
      preserveWhitespace: "full",
      ...t.parseOptions
    };
    if (!t.errorOnInvalidContent && !r.options.enableContentCheck && r.options.emitContentError)
      try {
        qr(n, r.schema, {
          parseOptions: d,
          errorOnInvalidContent: !0
        });
      } catch (y) {
        s(y);
      }
    try {
      i = qr(n, r.schema, {
        parseOptions: d,
        errorOnInvalidContent: (o = t.errorOnInvalidContent) != null ? o : r.options.enableContentCheck
      });
    } catch (y) {
      return s(y), !1;
    }
    let { from: u, to: f } = typeof e == "number" ? { from: e, to: e } : { from: e.from, to: e.to }, b = !0, h = !0;
    if ((bL(i) ? i : [i]).forEach((y) => {
      y.check(), b = b ? y.isText && y.marks.length === 0 : !1, h = h ? y.isBlock : !1;
    }), u === f && h) {
      const { parent: y } = a.doc.resolve(u);
      y.isTextblock && !y.type.spec.code && !y.childCount && (u -= 1, f += 1);
    }
    let x;
    if (b) {
      if (Array.isArray(n))
        x = n.map((y) => y.text || "").join("");
      else if (n instanceof Pe) {
        let y = "";
        n.forEach((w) => {
          w.text && (y += w.text);
        }), x = y;
      } else typeof n == "object" && n && n.text ? x = n.text : x = n;
      a.insertText(x, u, f);
    } else {
      x = i;
      const y = a.doc.resolve(u), w = y.node(), S = y.parentOffset === 0, $ = w.isText || w.isTextblock, T = w.content.size > 0;
      S && $ && T && h && (u = Math.max(0, u - 1)), a.replaceWith(u, f, x);
    }
    t.updateSelection && hL(a, a.steps.length - 1, -1), t.applyInputRules && a.setMeta("applyInputRules", { from: u, text: x }), t.applyPasteRules && a.setMeta("applyPasteRules", { from: u, text: x });
  }
  return !0;
}, pL = () => ({ state: e, dispatch: n }) => F$(e, n), mL = () => ({ state: e, dispatch: n }) => V$(e, n), vL = () => ({ state: e, dispatch: n }) => hp(e, n), xL = () => ({ state: e, dispatch: n }) => mp(e, n), yL = () => ({ state: e, dispatch: n, tr: t }) => {
  try {
    const a = Qi(e.doc, e.selection.$from.pos, -1);
    return a == null ? !1 : (t.join(a, 2), n && n(t), !0);
  } catch {
    return !1;
  }
}, kL = () => ({ state: e, dispatch: n, tr: t }) => {
  try {
    const a = Qi(e.doc, e.selection.$from.pos, 1);
    return a == null ? !1 : (t.join(a, 2), n && n(t), !0);
  } catch {
    return !1;
  }
}, wL = () => ({ state: e, dispatch: n }) => O$(e, n), CL = () => ({ state: e, dispatch: n }) => P$(e, n);
function cm() {
  return typeof navigator < "u" ? /Mac/.test(navigator.platform) : !1;
}
function SL(e) {
  const n = e.split(/-(?!$)/);
  let t = n[n.length - 1];
  t === "Space" && (t = " ");
  let a, l, r, o;
  for (let i = 0; i < n.length - 1; i += 1) {
    const s = n[i];
    if (/^(cmd|meta|m)$/i.test(s))
      o = !0;
    else if (/^a(lt)?$/i.test(s))
      a = !0;
    else if (/^(c|ctrl|control)$/i.test(s))
      l = !0;
    else if (/^s(hift)?$/i.test(s))
      r = !0;
    else if (/^mod$/i.test(s))
      bi() || cm() ? o = !0 : l = !0;
    else
      throw new Error(`Unrecognized modifier name: ${s}`);
  }
  return a && (t = `Alt-${t}`), l && (t = `Ctrl-${t}`), o && (t = `Meta-${t}`), r && (t = `Shift-${t}`), t;
}
var $L = (e) => ({ editor: n, view: t, tr: a, dispatch: l }) => {
  const r = SL(e).split(/-(?!$)/), o = r.find((d) => !["Alt", "Ctrl", "Meta", "Shift"].includes(d)), i = new KeyboardEvent("keydown", {
    key: o === "Space" ? " " : o,
    altKey: r.includes("Alt"),
    ctrlKey: r.includes("Ctrl"),
    metaKey: r.includes("Meta"),
    shiftKey: r.includes("Shift"),
    bubbles: !0,
    cancelable: !0
  }), s = n.captureTransaction(() => {
    t.someProp("handleKeyDown", (d) => d(t, i));
  });
  return s == null || s.steps.forEach((d) => {
    const u = d.map(a.mapping);
    u && l && a.maybeStep(u);
  }), !0;
};
function Ma(e, n, t = {}) {
  const { from: a, to: l, empty: r } = e.selection, o = n ? Dt(n, e.schema) : null, i = [];
  e.doc.nodesBetween(a, l, (f, b) => {
    if (f.isText)
      return;
    const h = Math.max(a, b), m = Math.min(l, b + f.nodeSize);
    i.push({
      node: f,
      from: h,
      to: m
    });
  });
  const s = l - a, d = i.filter((f) => o ? o.name === f.node.type.name : !0).filter((f) => hi(f.node.attrs, t, { strict: !1 }));
  return r ? !!d.length : d.reduce((f, b) => f + b.to - b.from, 0) >= s;
}
var IL = (e, n = {}) => ({ state: t, dispatch: a }) => {
  const l = Dt(e, t.schema);
  return Ma(t, l, n) ? N$(t, a) : !1;
}, TL = () => ({ state: e, dispatch: n }) => kp(e, n), LL = (e) => ({ state: n, dispatch: t }) => {
  const a = Dt(e, n.schema);
  return Q$(a)(n, t);
}, EL = () => ({ state: e, dispatch: n }) => xp(e, n);
function is(e, n) {
  return n.nodes[e] ? "node" : n.marks[e] ? "mark" : null;
}
function kh(e, n) {
  const t = typeof n == "string" ? [n] : n;
  return Object.keys(e).reduce((a, l) => (t.includes(l) || (a[l] = e[l]), a), {});
}
var AL = (e, n) => ({ tr: t, state: a, dispatch: l }) => {
  let r = null, o = null;
  const i = is(
    typeof e == "string" ? e : e.name,
    a.schema
  );
  if (!i)
    return !1;
  i === "node" && (r = Dt(e, a.schema)), i === "mark" && (o = ca(e, a.schema));
  let s = !1;
  return t.selection.ranges.forEach((d) => {
    a.doc.nodesBetween(d.$from.pos, d.$to.pos, (u, f) => {
      r && r === u.type && (s = !0, l && t.setNodeMarkup(f, void 0, kh(u.attrs, n))), o && u.marks.length && u.marks.forEach((b) => {
        o === b.type && (s = !0, l && t.addMark(f, f + u.nodeSize, o.create(kh(b.attrs, n))));
      });
    });
  }), s;
}, RL = () => ({ tr: e, dispatch: n }) => (n && e.scrollIntoView(), !0), BL = () => ({ tr: e, dispatch: n }) => {
  if (n) {
    const t = new bn(e.doc);
    e.setSelection(t);
  }
  return !0;
}, ML = () => ({ state: e, dispatch: n }) => gp(e, n), DL = () => ({ state: e, dispatch: n }) => vp(e, n), zL = () => ({ state: e, dispatch: n }) => q$(e, n), OL = () => ({ state: e, dispatch: n }) => K$(e, n), PL = () => ({ state: e, dispatch: n }) => G$(e, n);
function Yd(e, n, t = {}, a = {}) {
  return qr(e, n, {
    slice: !1,
    parseOptions: t,
    errorOnInvalidContent: a.errorOnInvalidContent
  });
}
var FL = (e, { errorOnInvalidContent: n, emitUpdate: t = !0, parseOptions: a = {} } = {}) => ({ editor: l, tr: r, dispatch: o, commands: i }) => {
  const { doc: s } = r;
  if (a.preserveWhitespace !== "full") {
    const d = Yd(e, l.schema, a, {
      errorOnInvalidContent: n ?? l.options.enableContentCheck
    });
    return o && r.replaceWith(0, s.content.size, d).setMeta("preventUpdate", !t), !0;
  }
  return o && r.setMeta("preventUpdate", !t), i.insertContentAt({ from: 0, to: s.content.size }, e, {
    parseOptions: a,
    errorOnInvalidContent: n ?? l.options.enableContentCheck
  });
};
function fm(e, n) {
  const t = ca(n, e.schema), { from: a, to: l, empty: r } = e.selection, o = [];
  r ? (e.storedMarks && o.push(...e.storedMarks), o.push(...e.selection.$head.marks())) : e.doc.nodesBetween(a, l, (s) => {
    o.push(...s.marks);
  });
  const i = o.find((s) => s.type.name === t.name);
  return i ? { ...i.attrs } : {};
}
function hm(e, n) {
  const t = new sp(e);
  return n.forEach((a) => {
    a.steps.forEach((l) => {
      t.step(l);
    });
  }), t;
}
function VL(e) {
  for (let n = 0; n < e.edgeCount; n += 1) {
    const { type: t } = e.edge(n);
    if (t.isTextblock && !t.hasRequiredAttrs())
      return t;
  }
  return null;
}
function NL(e, n, t) {
  const a = [];
  return e.nodesBetween(n.from, n.to, (l, r) => {
    t(l) && a.push({
      node: l,
      pos: r
    });
  }), a;
}
function HL(e, n) {
  for (let t = e.depth; t > 0; t -= 1) {
    const a = e.node(t);
    if (n(a))
      return {
        pos: t > 0 ? e.before(t) : 0,
        start: e.start(t),
        depth: t,
        node: a
      };
  }
}
function ss(e) {
  return (n) => HL(n.$from, e);
}
function Ze(e, n, t) {
  return e.config[n] === void 0 && e.parent ? Ze(e.parent, n, t) : typeof e.config[n] == "function" ? e.config[n].bind({
    ...t,
    parent: e.parent ? Ze(e.parent, n, t) : null
  }) : e.config[n];
}
function cc(e) {
  return e.map((n) => {
    const t = {
      name: n.name,
      options: n.options,
      storage: n.storage
    }, a = Ze(n, "addExtensions", t);
    return a ? [n, ...cc(a())] : n;
  }).flat(10);
}
function fc(e, n) {
  const t = bl.fromSchema(n).serializeFragment(e), l = document.implementation.createHTMLDocument().createElement("div");
  return l.appendChild(t), l.innerHTML;
}
function bm(e) {
  return typeof e == "function";
}
function ht(e, n = void 0, ...t) {
  return bm(e) ? n ? e.bind(n)(...t) : e(...t) : e;
}
function jL(e = {}) {
  return Object.keys(e).length === 0 && e.constructor === Object;
}
function Wl(e) {
  const n = e.filter((l) => l.type === "extension"), t = e.filter((l) => l.type === "node"), a = e.filter((l) => l.type === "mark");
  return {
    baseExtensions: n,
    nodeExtensions: t,
    markExtensions: a
  };
}
function gm(e) {
  const n = [], { nodeExtensions: t, markExtensions: a } = Wl(e), l = [...t, ...a], r = {
    default: null,
    validate: void 0,
    rendered: !0,
    renderHTML: null,
    parseHTML: null,
    keepOnSplit: !0,
    isRequired: !1
  }, o = t.filter((d) => d.name !== "text").map((d) => d.name), i = a.map((d) => d.name), s = [...o, ...i];
  return e.forEach((d) => {
    const u = {
      name: d.name,
      options: d.options,
      storage: d.storage,
      extensions: l
    }, f = Ze(
      d,
      "addGlobalAttributes",
      u
    );
    if (!f)
      return;
    f().forEach((h) => {
      let m;
      Array.isArray(h.types) ? m = h.types : h.types === "*" ? m = s : h.types === "nodes" ? m = o : h.types === "marks" ? m = i : m = [], m.forEach((x) => {
        Object.entries(h.attributes).forEach(([y, w]) => {
          n.push({
            type: x,
            name: y,
            attribute: {
              ...r,
              ...w
            }
          });
        });
      });
    });
  }), l.forEach((d) => {
    const u = {
      name: d.name,
      options: d.options,
      storage: d.storage
    }, f = Ze(
      d,
      "addAttributes",
      u
    );
    if (!f)
      return;
    const b = f();
    Object.entries(b).forEach(([h, m]) => {
      const x = {
        ...r,
        ...m
      };
      typeof (x == null ? void 0 : x.default) == "function" && (x.default = x.default()), x != null && x.isRequired && (x == null ? void 0 : x.default) === void 0 && delete x.default, n.push({
        type: d.name,
        name: h,
        attribute: x
      });
    });
  }), n;
}
function WL(e) {
  const n = [];
  let t = "", a = !1, l = !1, r = 0;
  const o = e.length;
  for (let i = 0; i < o; i += 1) {
    const s = e[i];
    if (s === "'" && !l) {
      a = !a, t += s;
      continue;
    }
    if (s === '"' && !a) {
      l = !l, t += s;
      continue;
    }
    if (!a && !l) {
      if (s === "(") {
        r += 1, t += s;
        continue;
      }
      if (s === ")" && r > 0) {
        r -= 1, t += s;
        continue;
      }
      if (s === ";" && r === 0) {
        n.push(t), t = "";
        continue;
      }
    }
    t += s;
  }
  return t && n.push(t), n;
}
function wh(e) {
  const n = [], t = WL(e || ""), a = t.length;
  for (let l = 0; l < a; l += 1) {
    const r = t[l], o = r.indexOf(":");
    if (o === -1)
      continue;
    const i = r.slice(0, o).trim(), s = r.slice(o + 1).trim();
    i && s && n.push([i, s]);
  }
  return n;
}
function It(...e) {
  return e.filter((n) => !!n).reduce((n, t) => {
    const a = { ...n };
    return Object.entries(t).forEach(([l, r]) => {
      if (!a[l]) {
        a[l] = r;
        return;
      }
      if (l === "class") {
        const i = r ? String(r).split(" ") : [], s = a[l] ? a[l].split(" ") : [], d = i.filter((u) => !s.includes(u));
        a[l] = [...s, ...d].join(" ");
      } else if (l === "style") {
        const i = new Map([...wh(a[l]), ...wh(r)]);
        a[l] = Array.from(i.entries()).map(([s, d]) => `${s}: ${d}`).join("; ");
      } else
        a[l] = r;
    }), a;
  }, {});
}
function Ur(e, n) {
  return n.filter((t) => t.type === e.type.name).filter((t) => t.attribute.rendered).map((t) => t.attribute.renderHTML ? t.attribute.renderHTML(e.attrs) || {} : {
    [t.name]: e.attrs[t.name]
  }).reduce((t, a) => It(t, a), {});
}
function qL(e) {
  return typeof e != "string" ? e : e.match(/^[+-]?(?:\d*\.)?\d+$/) ? Number(e) : e === "true" ? !0 : e === "false" ? !1 : e;
}
function Ch(e, n) {
  return "style" in e ? e : {
    ...e,
    getAttrs: (t) => {
      const a = e.getAttrs ? e.getAttrs(t) : e.attrs;
      if (a === !1)
        return !1;
      const l = n.reduce((r, o) => {
        const i = o.attribute.parseHTML ? o.attribute.parseHTML(t) : qL(t.getAttribute(o.name));
        return i == null ? r : {
          ...r,
          [o.name]: i
        };
      }, {});
      return { ...a, ...l };
    }
  };
}
function Sh(e) {
  return Object.fromEntries(
    // @ts-ignore
    Object.entries(e).filter(([n, t]) => n === "attrs" && jL(t) ? !1 : t != null)
  );
}
function $h(e) {
  var n, t;
  const a = {};
  return !((n = e == null ? void 0 : e.attribute) != null && n.isRequired) && "default" in ((e == null ? void 0 : e.attribute) || {}) && (a.default = e.attribute.default), ((t = e == null ? void 0 : e.attribute) == null ? void 0 : t.validate) !== void 0 && (a.validate = e.attribute.validate), [e.name, a];
}
function UL(e, n) {
  var t;
  const a = gm(e), { nodeExtensions: l, markExtensions: r } = Wl(e), o = (t = l.find((d) => Ze(d, "topNode"))) == null ? void 0 : t.name, i = Object.fromEntries(
    l.map((d) => {
      const u = a.filter((w) => w.type === d.name), f = {
        name: d.name,
        options: d.options,
        storage: d.storage,
        editor: n
      }, b = e.reduce((w, S) => {
        const $ = Ze(S, "extendNodeSchema", f);
        return {
          ...w,
          ...$ ? $(d) : {}
        };
      }, {}), h = Sh({
        ...b,
        content: ht(Ze(d, "content", f)),
        marks: ht(Ze(d, "marks", f)),
        group: ht(Ze(d, "group", f)),
        inline: ht(Ze(d, "inline", f)),
        atom: ht(Ze(d, "atom", f)),
        selectable: ht(Ze(d, "selectable", f)),
        draggable: ht(Ze(d, "draggable", f)),
        code: ht(Ze(d, "code", f)),
        whitespace: ht(Ze(d, "whitespace", f)),
        linebreakReplacement: ht(
          Ze(d, "linebreakReplacement", f)
        ),
        defining: ht(Ze(d, "defining", f)),
        isolating: ht(Ze(d, "isolating", f)),
        attrs: Object.fromEntries(u.map($h))
      }), m = ht(Ze(d, "parseHTML", f));
      m && (h.parseDOM = m.map(
        (w) => Ch(w, u)
      ));
      const x = Ze(d, "renderHTML", f);
      x && (h.toDOM = (w) => x({
        node: w,
        HTMLAttributes: Ur(w, u)
      }));
      const y = Ze(d, "renderText", f);
      return y && (h.toText = y), [d.name, h];
    })
  ), s = Object.fromEntries(
    r.map((d) => {
      const u = a.filter((y) => y.type === d.name), f = {
        name: d.name,
        options: d.options,
        storage: d.storage,
        editor: n
      }, b = e.reduce((y, w) => {
        const S = Ze(w, "extendMarkSchema", f);
        return {
          ...y,
          ...S ? S(d) : {}
        };
      }, {}), h = Sh({
        ...b,
        inclusive: ht(Ze(d, "inclusive", f)),
        excludes: ht(Ze(d, "excludes", f)),
        group: ht(Ze(d, "group", f)),
        spanning: ht(Ze(d, "spanning", f)),
        code: ht(Ze(d, "code", f)),
        attrs: Object.fromEntries(u.map($h))
      }), m = ht(Ze(d, "parseHTML", f));
      m && (h.parseDOM = m.map(
        (y) => Ch(y, u)
      ));
      const x = Ze(d, "renderHTML", f);
      return x && (h.toDOM = (y) => x({
        mark: y,
        HTMLAttributes: Ur(y, u)
      })), [d.name, h];
    })
  );
  return new Gg({
    topNode: o,
    nodes: i,
    marks: s
  });
}
function GL(e) {
  const n = e.filter((t, a) => e.indexOf(t) !== a);
  return Array.from(new Set(n));
}
function wr(e) {
  return e.sort((t, a) => {
    const l = Ze(t, "priority") || 100, r = Ze(a, "priority") || 100;
    return l > r ? -1 : l < r ? 1 : 0;
  });
}
function pm(e) {
  const n = wr(cc(e)), t = GL(n.map((a) => a.name));
  return t.length && console.warn(
    `[tiptap warn]: Duplicate extension names found: [${t.map((a) => `'${a}'`).join(", ")}]. This can lead to issues.`
  ), n;
}
function mm(e, n, t) {
  const { from: a, to: l } = n, { blockSeparator: r = `

`, textSerializers: o = {} } = t || {};
  let i = "";
  return e.nodesBetween(a, l, (s, d, u, f) => {
    var b;
    s.isBlock && d > a && (i += r);
    const h = o == null ? void 0 : o[s.type.name];
    if (h)
      return u && (i += h({
        node: s,
        pos: d,
        parent: u,
        index: f,
        range: n
      })), !1;
    s.isText && (i += (b = s == null ? void 0 : s.text) == null ? void 0 : b.slice(Math.max(a, d) - d, l - d));
  }), i;
}
function KL(e, n) {
  const t = {
    from: 0,
    to: e.content.size
  };
  return mm(e, t, n);
}
function vm(e) {
  return Object.fromEntries(
    Object.entries(e.nodes).filter(([, n]) => n.spec.toText).map(([n, t]) => [n, t.spec.toText])
  );
}
function YL(e, n) {
  const t = Dt(n, e.schema), { from: a, to: l } = e.selection, r = [];
  e.doc.nodesBetween(a, l, (i) => {
    r.push(i);
  });
  const o = r.reverse().find((i) => i.type.name === t.name);
  return o ? { ...o.attrs } : {};
}
function xm(e, n) {
  const t = is(
    typeof n == "string" ? n : n.name,
    e.schema
  );
  return t === "node" ? YL(e, n) : t === "mark" ? fm(e, n) : {};
}
function JL(e, n = JSON.stringify) {
  const t = {};
  return e.filter((a) => {
    const l = n(a);
    return Object.prototype.hasOwnProperty.call(t, l) ? !1 : t[l] = !0;
  });
}
function ZL(e) {
  const n = JL(e);
  return n.length === 1 ? n : n.filter((t, a) => !n.filter((r, o) => o !== a).some((r) => t.oldRange.from >= r.oldRange.from && t.oldRange.to <= r.oldRange.to && t.newRange.from >= r.newRange.from && t.newRange.to <= r.newRange.to));
}
function ym(e) {
  const { mapping: n, steps: t } = e, a = [];
  return n.maps.forEach((l, r) => {
    const o = [];
    if (l.ranges.length)
      l.forEach((i, s) => {
        o.push({ from: i, to: s });
      });
    else {
      const { from: i, to: s } = t[r];
      if (i === void 0 || s === void 0)
        return;
      o.push({ from: i, to: s });
    }
    o.forEach(({ from: i, to: s }) => {
      const d = n.slice(r).map(i, -1), u = n.slice(r).map(s), f = n.invert().map(d, -1), b = n.invert().map(u);
      a.push({
        oldRange: {
          from: f,
          to: b
        },
        newRange: {
          from: d,
          to: u
        }
      });
    });
  }), ZL(a);
}
function hc(e, n, t) {
  const a = [];
  return e === n ? t.resolve(e).marks().forEach((l) => {
    const r = t.resolve(e), o = uc(r, l.type);
    o && a.push({
      mark: l,
      ...o
    });
  }) : t.nodesBetween(e, n, (l, r) => {
    !l || (l == null ? void 0 : l.nodeSize) === void 0 || a.push(
      ...l.marks.map((o) => ({
        from: r,
        to: r + l.nodeSize,
        mark: o
      }))
    );
  }), a;
}
var XL = (e, n, t, a = 20) => {
  const l = e.doc.resolve(t);
  let r = a, o = null;
  for (; r > 0 && o === null; ) {
    const i = l.node(r);
    (i == null ? void 0 : i.type.name) === n ? o = i : r -= 1;
  }
  return [o, r];
};
function tr(e, n) {
  return n.nodes[e] || n.marks[e] || null;
}
function Uo(e, n, t) {
  return Object.fromEntries(
    Object.entries(t).filter(([a]) => {
      const l = e.find((r) => r.type === n && r.name === a);
      return l ? l.attribute.keepOnSplit : !1;
    })
  );
}
var QL = (e, n = 500) => {
  let t = "";
  const a = e.parentOffset;
  return e.parent.nodesBetween(Math.max(0, a - n), a, (l, r, o, i) => {
    var s, d;
    const u = ((d = (s = l.type.spec).toText) == null ? void 0 : d.call(s, {
      node: l,
      pos: r,
      parent: o,
      index: i
    })) || l.textContent || "%leaf%";
    t += l.isAtom && !l.isText ? u : u.slice(0, Math.max(0, a - r));
  }), t;
};
function Jd(e, n, t = {}) {
  const { empty: a, ranges: l } = e.selection, r = n ? ca(n, e.schema) : null;
  if (a)
    return !!(e.storedMarks || e.selection.$from.marks()).filter((f) => r ? r.name === f.type.name : !0).find((f) => hi(f.attrs, t, { strict: !1 }));
  let o = 0;
  const i = [];
  if (l.forEach(({ $from: f, $to: b }) => {
    const h = f.pos, m = b.pos;
    e.doc.nodesBetween(h, m, (x, y) => {
      if (r && x.inlineContent && !x.type.allowsMarkType(r))
        return !1;
      if (!x.isText && !x.marks.length)
        return;
      const w = Math.max(h, y), S = Math.min(m, y + x.nodeSize), $ = S - w;
      o += $, i.push(
        ...x.marks.map((T) => ({
          mark: T,
          from: w,
          to: S
        }))
      );
    });
  }), o === 0)
    return !1;
  const s = i.filter((f) => r ? r.name === f.mark.type.name : !0).filter((f) => hi(f.mark.attrs, t, { strict: !1 })).reduce((f, b) => f + b.to - b.from, 0), d = i.filter((f) => r ? f.mark.type !== r && f.mark.type.excludes(r) : !0).reduce((f, b) => f + b.to - b.from, 0);
  return (s > 0 ? s + d : s) >= o;
}
function _L(e, n, t = {}) {
  if (!n)
    return Ma(e, null, t) || Jd(e, null, t);
  const a = is(n, e.schema);
  return a === "node" ? Ma(e, n, t) : a === "mark" ? Jd(e, n, t) : !1;
}
var eE = (e, n) => {
  const { $from: t, $to: a, $anchor: l } = e.selection;
  if (n) {
    const r = ss((i) => i.type.name === n)(e.selection);
    if (!r)
      return !1;
    const o = e.doc.resolve(r.pos + 1);
    return l.pos + 1 === o.end();
  }
  return !(a.parentOffset < a.parent.nodeSize - 2 || t.pos !== a.pos);
}, tE = (e) => {
  const { $from: n, $to: t } = e.selection;
  return !(n.parentOffset > 0 || n.pos !== t.pos);
};
function Ih(e, n) {
  return Array.isArray(n) ? n.some((t) => (typeof t == "string" ? t : t.name) === e.name) : n;
}
function Us(e, n) {
  const { nodeExtensions: t } = Wl(n), a = t.find((o) => o.name === e);
  if (!a)
    return !1;
  const l = {
    name: a.name,
    options: a.options,
    storage: a.storage
  }, r = ht(Ze(a, "group", l));
  return typeof r != "string" ? !1 : r.split(" ").includes("list");
}
function Gr(e, {
  checkChildren: n = !0,
  ignoreWhitespace: t = !1
} = {}) {
  var a;
  if (t) {
    if (e.type.name === "hardBreak")
      return !0;
    if (e.isText)
      return !/\S/.test((a = e.text) != null ? a : "");
  }
  if (e.isText)
    return !e.text;
  if (e.isAtom || e.isLeaf)
    return !1;
  if (e.content.childCount === 0)
    return !0;
  if (n) {
    let l = !0;
    return e.content.forEach((r) => {
      l !== !1 && (Gr(r, { ignoreWhitespace: t, checkChildren: n }) || (l = !1));
    }), l;
  }
  return !1;
}
function km(e) {
  return e instanceof Xe;
}
var wm = class Cm {
  constructor(n) {
    this.position = n;
  }
  /**
   * Creates a MappablePosition from a JSON object.
   */
  static fromJSON(n) {
    return new Cm(n.position);
  }
  /**
   * Converts the MappablePosition to a JSON object.
   */
  toJSON() {
    return {
      position: this.position
    };
  }
};
function nE(e, n) {
  const t = n.mapping.mapResult(e.position);
  return {
    position: new wm(t.pos),
    mapResult: t
  };
}
function aE(e) {
  return new wm(e);
}
function lE(e, n, t) {
  var a;
  const { selection: l } = n;
  let r = null;
  if (sm(l) && (r = l.$cursor), r) {
    const i = (a = e.storedMarks) != null ? a : r.marks();
    return r.parent.type.allowsMarkType(t) && (!!t.isInSet(i) || !i.some((d) => d.type.excludes(t)));
  }
  const { ranges: o } = l;
  return o.some(({ $from: i, $to: s }) => {
    let d = i.depth === 0 ? e.doc.inlineContent && e.doc.type.allowsMarkType(t) : !1;
    return e.doc.nodesBetween(i.pos, s.pos, (u, f, b) => {
      if (d)
        return !1;
      if (u.isInline) {
        const h = !b || b.type.allowsMarkType(t), m = !!t.isInSet(u.marks) || !u.marks.some((x) => x.type.excludes(t));
        d = h && m;
      }
      return !d;
    }), d;
  });
}
var rE = (e, n = {}) => ({ tr: t, state: a, dispatch: l }) => {
  const { selection: r } = t, { empty: o, ranges: i } = r, s = ca(e, a.schema);
  if (l)
    if (o) {
      const d = fm(a, s);
      t.addStoredMark(
        s.create({
          ...d,
          ...n
        })
      );
    } else
      i.forEach((d) => {
        const u = d.$from.pos, f = d.$to.pos;
        a.doc.nodesBetween(u, f, (b, h) => {
          const m = Math.max(h, u), x = Math.min(h + b.nodeSize, f);
          b.marks.find((w) => w.type === s) ? b.marks.forEach((w) => {
            s === w.type && t.addMark(
              m,
              x,
              s.create({
                ...w.attrs,
                ...n
              })
            );
          }) : t.addMark(m, x, s.create(n));
        });
      });
  return lE(a, t, s);
}, oE = (e, n) => ({ tr: t }) => (t.setMeta(e, n), !0), iE = (e, n = {}) => ({ state: t, dispatch: a, chain: l }) => {
  const r = Dt(e, t.schema);
  let o;
  return t.selection.$anchor.sameParent(t.selection.$head) && (o = t.selection.$anchor.parent.attrs), r.isTextblock ? l().command(({ commands: i }) => Ff(r, { ...o, ...n })(t) ? !0 : i.clearNodes()).command(({ state: i }) => Ff(r, { ...o, ...n })(i, a)).run() : (console.warn('[tiptap warn]: Currently "setNode()" only supports text block nodes.'), !1);
}, sE = (e) => ({ tr: n, dispatch: t }) => {
  if (t) {
    const { doc: a } = n, l = Za(e, 0, a.content.size), r = Xe.create(a, l);
    n.setSelection(r);
  }
  return !0;
}, dE = (e, n) => ({ tr: t, state: a, dispatch: l }) => {
  const { selection: r } = a;
  let o, i;
  return typeof n == "number" ? (o = n, i = n) : n && "from" in n && "to" in n ? (o = n.from, i = n.to) : (o = r.from, i = r.to), l && t.doc.nodesBetween(o, i, (s, d) => {
    s.isText || t.setNodeMarkup(d, void 0, {
      ...s.attrs,
      dir: e
    });
  }), !0;
}, uE = (e) => ({ tr: n, dispatch: t }) => {
  if (t) {
    const { doc: a } = n, { from: l, to: r } = typeof e == "number" ? { from: e, to: e } : e, o = nt.atStart(a).from, i = nt.atEnd(a).to, s = Za(l, o, i), d = Za(r, o, i), u = nt.create(a, s, d);
    n.setSelection(u);
  }
  return !0;
}, cE = (e) => ({ state: n, dispatch: t }) => {
  const a = Dt(e, n.schema);
  return tI(a)(n, t);
};
function Th(e, n) {
  const t = e.storedMarks || e.selection.$to.parentOffset && e.selection.$from.marks();
  if (t) {
    const a = t.filter((l) => n == null ? void 0 : n.includes(l.type.name));
    e.tr.ensureMarks(a);
  }
}
var fE = ({ keepMarks: e = !0 } = {}) => ({ tr: n, state: t, dispatch: a, editor: l }) => {
  const { selection: r, doc: o } = n, { $from: i, $to: s } = r, d = l.extensionManager.attributes, u = Uo(d, i.node().type.name, i.node().attrs);
  if (r instanceof Xe && r.node.isBlock)
    return !i.parentOffset || !sa(o, i.pos) ? !1 : (a && (e && Th(t, l.extensionManager.splittableMarks), n.split(i.pos).scrollIntoView()), !0);
  if (!i.parent.isBlock)
    return !1;
  const f = s.parentOffset === s.parent.content.size, b = i.depth === 0 ? void 0 : VL(i.node(-1).contentMatchAt(i.indexAfter(-1)));
  let h = f && b ? [
    {
      type: b,
      attrs: u
    }
  ] : void 0, m = sa(n.doc, n.mapping.map(i.pos), 1, h);
  if (!h && !m && sa(n.doc, n.mapping.map(i.pos), 1, b ? [{ type: b }] : void 0) && (m = !0, h = b ? [
    {
      type: b,
      attrs: u
    }
  ] : void 0), a) {
    if (m && (r instanceof nt && n.deleteSelection(), n.split(n.mapping.map(i.pos), 1, h), b && !f && !i.parentOffset && i.parent.type !== b)) {
      const x = n.mapping.map(i.before()), y = n.doc.resolve(x);
      i.node(-1).canReplaceWith(y.index(), y.index() + 1, b) && n.setNodeMarkup(n.mapping.map(i.before()), b);
    }
    e && Th(t, l.extensionManager.splittableMarks), n.scrollIntoView();
  }
  return m;
}, hE = (e, n = {}) => ({ tr: t, state: a, dispatch: l, editor: r }) => {
  var o;
  const i = Dt(e, a.schema), { $from: s, $to: d } = a.selection, u = a.selection.node;
  if (u && u.isBlock || s.depth < 2 || !s.sameParent(d))
    return !1;
  const f = s.node(-1);
  if (f.type !== i)
    return !1;
  const b = r.extensionManager.attributes;
  if (s.parent.content.size === 0 && s.node(-1).childCount === s.indexAfter(-1)) {
    if (s.depth === 2 || s.node(-3).type !== i || s.index(-2) !== s.node(-2).childCount - 1)
      return !1;
    if (l) {
      let w = Pe.empty;
      const S = s.index(-1) ? 1 : s.index(-2) ? 2 : 3;
      for (let z = s.depth - S; z >= s.depth - 3; z -= 1)
        w = Pe.from(s.node(z).copy(w));
      const $ = (
        // eslint-disable-next-line no-nested-ternary
        s.indexAfter(-1) < s.node(-2).childCount ? 1 : s.indexAfter(-2) < s.node(-3).childCount ? 2 : 3
      ), T = {
        ...Uo(b, s.node().type.name, s.node().attrs),
        ...n
      }, L = ((o = i.contentMatch.defaultType) == null ? void 0 : o.createAndFill(T)) || void 0;
      w = w.append(Pe.from(i.createAndFill(null, L) || void 0));
      const A = s.before(s.depth - (S - 1));
      t.replace(A, s.after(-$), new Ye(w, 4 - S, 0));
      let R = -1;
      t.doc.nodesBetween(A, t.doc.content.size, (z, D) => {
        if (R > -1)
          return !1;
        z.isTextblock && z.content.size === 0 && (R = D + 1);
      }), R > -1 && t.setSelection(nt.near(t.doc.resolve(R))), t.scrollIntoView();
    }
    return !0;
  }
  const h = d.pos === s.end() ? f.contentMatchAt(0).defaultType : null, m = {
    ...Uo(b, f.type.name, f.attrs),
    ...n
  }, x = {
    ...Uo(b, s.node().type.name, s.node().attrs),
    ...n
  };
  t.delete(s.pos, d.pos);
  const y = h ? [
    { type: i, attrs: m },
    { type: h, attrs: x }
  ] : [{ type: i, attrs: m }];
  if (!sa(t.doc, s.pos, 2))
    return !1;
  if (l) {
    const { selection: w, storedMarks: S } = a, { splittableMarks: $ } = r.extensionManager, T = S || w.$to.parentOffset && w.$from.marks();
    if (t.split(s.pos, 2, y).scrollIntoView(), !T || !l)
      return !0;
    const L = T.filter((A) => $.includes(A.type.name));
    t.ensureMarks(L);
  }
  return !0;
}, Gs = (e, n) => {
  const t = ss((o) => o.type === n)(e.selection);
  if (!t)
    return !0;
  const a = e.doc.resolve(Math.max(0, t.pos - 1)).before(t.depth);
  if (a === void 0)
    return !0;
  const l = e.doc.nodeAt(a);
  return t.node.type === (l == null ? void 0 : l.type) && Ha(e.doc, t.pos) && e.join(t.pos), !0;
}, Ks = (e, n) => {
  const t = ss((o) => o.type === n)(e.selection);
  if (!t)
    return !0;
  const a = e.doc.resolve(t.start).after(t.depth);
  if (a === void 0)
    return !0;
  const l = e.doc.nodeAt(a);
  return t.node.type === (l == null ? void 0 : l.type) && Ha(e.doc, a) && e.join(a), !0;
};
function bE(e) {
  const n = e.doc, t = n.firstChild;
  if (!t)
    return null;
  const a = n.resolve(1), l = n.resolve(t.nodeSize - 1);
  return nt.between(a, l);
}
var gE = (e, n, t, a = {}) => ({ editor: l, tr: r, state: o, dispatch: i, chain: s, commands: d, can: u }) => {
  const { extensions: f, splittableMarks: b } = l.extensionManager, h = Dt(e, o.schema), m = Dt(n, o.schema), { selection: x, storedMarks: y } = o, { $from: w, $to: S } = x, $ = w.blockRange(S), T = y || x.$to.parentOffset && x.$from.marks();
  if (!$)
    return !1;
  const L = ss((j) => Us(j.type.name, f))(x), A = x.from === 0 && x.to === o.doc.content.size, R = o.doc.content.content, z = R.length === 1 ? R[0] : null, D = A && z && Us(z.type.name, f) ? {
    node: z,
    pos: 0
  } : null, V = L ?? D, Y = !!L && $.depth >= 1 && $.depth - L.depth <= 1, _ = !!D;
  if ((Y || _) && V) {
    if (V.node.type === h)
      return A && _ ? s().command(({ tr: j, dispatch: M }) => {
        const W = bE(j);
        return W ? (j.setSelection(W), M && M(j), !0) : !1;
      }).liftListItem(m).run() : d.liftListItem(m);
    if (Us(V.node.type.name, f) && h.validContent(V.node.content))
      return s().command(() => (r.setNodeMarkup(V.pos, h), !0)).command(() => Gs(r, h)).command(() => Ks(r, h)).run();
  }
  return !t || !T || !i ? s().command(() => u().wrapInList(h, a) ? !0 : d.clearNodes()).wrapInList(h, a).command(() => Gs(r, h)).command(() => Ks(r, h)).run() : s().command(() => {
    const j = u().wrapInList(h, a), M = T.filter((W) => b.includes(W.type.name));
    return r.ensureMarks(M), j ? !0 : d.clearNodes();
  }).wrapInList(h, a).command(() => Gs(r, h)).command(() => Ks(r, h)).run();
}, pE = (e, n = {}, t = {}) => ({ state: a, commands: l }) => {
  const { extendEmptyMarkRange: r = !1 } = t, o = ca(e, a.schema);
  return Jd(a, o, n) ? l.unsetMark(o, { extendEmptyMarkRange: r }) : l.setMark(o, n);
}, mE = (e, n, t = {}) => ({ state: a, commands: l }) => {
  const r = Dt(e, a.schema), o = Dt(n, a.schema), i = Ma(a, r, t);
  let s;
  return a.selection.$anchor.sameParent(a.selection.$head) && (s = a.selection.$anchor.parent.attrs), i ? l.setNode(o, s) : l.setNode(r, { ...s, ...t });
}, vE = (e, n = {}) => ({ state: t, commands: a }) => {
  const l = Dt(e, t.schema);
  return Ma(t, l, n) ? a.lift(l) : a.wrapIn(l, n);
}, xE = () => ({ state: e, dispatch: n }) => {
  const t = e.plugins;
  for (let a = 0; a < t.length; a += 1) {
    const l = t[a];
    let r;
    if (l.spec.isInputRules && (r = l.getState(e))) {
      if (n) {
        const o = e.tr, i = r.transform;
        for (let s = i.steps.length - 1; s >= 0; s -= 1)
          o.step(i.steps[s].invert(i.docs[s]));
        if (r.text) {
          const s = o.doc.resolve(r.from).marks();
          o.replaceWith(r.from, r.to, e.schema.text(r.text, s));
        } else
          o.delete(r.from, r.to);
      }
      return !0;
    }
  }
  return !1;
}, yE = () => ({ tr: e, dispatch: n }) => {
  const { selection: t } = e, { empty: a, ranges: l } = t;
  return a || n && l.forEach((r) => {
    e.removeMark(r.$from.pos, r.$to.pos);
  }), !0;
}, kE = (e, n = {}) => ({ tr: t, state: a, dispatch: l }) => {
  var r;
  const { extendEmptyMarkRange: o = !1 } = n, { selection: i } = t, s = ca(e, a.schema), { $from: d, empty: u, ranges: f } = i;
  if (!l)
    return !0;
  if (u && o) {
    let { from: b, to: h } = i;
    const m = (r = d.marks().find((y) => y.type === s)) == null ? void 0 : r.attrs, x = uc(d, s, m);
    x && (b = x.from, h = x.to), t.removeMark(b, h, s);
  } else
    f.forEach((b) => {
      t.removeMark(b.$from.pos, b.$to.pos, s);
    });
  return t.removeStoredMark(s), !0;
}, wE = (e) => ({ tr: n, state: t, dispatch: a }) => {
  const { selection: l } = t;
  let r, o;
  return typeof e == "number" ? (r = e, o = e) : e && "from" in e && "to" in e ? (r = e.from, o = e.to) : (r = l.from, o = l.to), a && n.doc.nodesBetween(r, o, (i, s) => {
    if (i.isText)
      return;
    const d = { ...i.attrs };
    delete d.dir, n.setNodeMarkup(s, void 0, d);
  }), !0;
}, CE = (e, n = {}) => ({ tr: t, state: a, dispatch: l }) => {
  let r = null, o = null;
  const i = is(
    typeof e == "string" ? e : e.name,
    a.schema
  );
  if (!i)
    return !1;
  i === "node" && (r = Dt(e, a.schema)), i === "mark" && (o = ca(e, a.schema));
  let s = !1;
  return t.selection.ranges.forEach((d) => {
    const u = d.$from.pos, f = d.$to.pos;
    let b, h, m, x;
    t.selection.empty ? a.doc.nodesBetween(u, f, (y, w) => {
      r && r === y.type && (s = !0, m = Math.max(w, u), x = Math.min(w + y.nodeSize, f), b = w, h = y);
    }) : a.doc.nodesBetween(u, f, (y, w) => {
      w < u && r && r === y.type && (s = !0, m = Math.max(w, u), x = Math.min(w + y.nodeSize, f), b = w, h = y), w >= u && w <= f && (r && r === y.type && (s = !0, l && t.setNodeMarkup(w, void 0, {
        ...y.attrs,
        ...n
      })), o && y.marks.length && y.marks.forEach((S) => {
        if (o === S.type && (s = !0, l)) {
          const $ = Math.max(w, u), T = Math.min(w + y.nodeSize, f);
          t.addMark(
            $,
            T,
            o.create({
              ...S.attrs,
              ...n
            })
          );
        }
      }));
    }), h && (b !== void 0 && l && t.setNodeMarkup(b, void 0, {
      ...h.attrs,
      ...n
    }), o && h.marks.length && h.marks.forEach((y) => {
      o === y.type && l && t.addMark(
        m,
        x,
        o.create({
          ...y.attrs,
          ...n
        })
      );
    }));
  }), s;
}, SE = (e, n = {}) => ({ state: t, dispatch: a }) => {
  const l = Dt(e, t.schema);
  return Y$(l, n)(t, a);
}, $E = (e, n = {}) => ({ state: t, dispatch: a }) => {
  const l = Dt(e, t.schema);
  return J$(l, n)(t, a);
}, IE = class {
  constructor() {
    this.callbacks = {};
  }
  on(e, n) {
    return this.callbacks[e] || (this.callbacks[e] = []), this.callbacks[e].push(n), this;
  }
  emit(e, ...n) {
    const t = this.callbacks[e];
    return t && t.forEach((a) => a.apply(this, n)), this;
  }
  off(e, n) {
    const t = this.callbacks[e];
    return t && (n ? this.callbacks[e] = t.filter((a) => a !== n) : delete this.callbacks[e]), this;
  }
  once(e, n) {
    const t = (...a) => {
      this.off(e, t), n.apply(this, a);
    };
    return this.on(e, t);
  }
  removeAllListeners() {
    this.callbacks = {};
  }
}, ds = class {
  constructor(e) {
    var n;
    this.find = e.find, this.handler = e.handler, this.undoable = (n = e.undoable) != null ? n : !0;
  }
}, TE = (e, n) => {
  if (dc(n))
    return n.exec(e);
  const t = n(e);
  if (!t)
    return null;
  const a = [t.text];
  return a.index = t.index, a.input = e, a.data = t.data, t.replaceWith && (t.text.includes(t.replaceWith) || console.warn('[tiptap warn]: "inputRuleMatch.replaceWith" must be part of "inputRuleMatch.text".'), a.push(t.replaceWith)), a;
};
function Co(e) {
  var n;
  const { editor: t, from: a, to: l, text: r, rules: o, plugin: i } = e, { view: s } = t;
  if (s.composing)
    return !1;
  const d = s.state.doc.resolve(a);
  if (
    // check for code node
    d.parent.type.spec.code || (n = d.nodeBefore || d.nodeAfter) != null && n.marks.find((b) => b.type.spec.code)
  )
    return !1;
  let u = !1;
  const f = QL(d) + r;
  return o.forEach((b) => {
    if (u)
      return;
    const h = TE(f, b.find);
    if (!h)
      return;
    const m = s.state.tr, x = ls({
      state: s.state,
      transaction: m
    }), y = {
      from: a - (h[0].length - r.length),
      to: l
    }, { commands: w, chain: S, can: $ } = new rs({
      editor: t,
      state: x
    });
    b.handler({
      state: x,
      range: y,
      match: h,
      commands: w,
      chain: S,
      can: $
    }) === null || !m.steps.length || (b.undoable && m.setMeta(i, {
      transform: m,
      from: a,
      to: l,
      text: r
    }), s.dispatch(m), u = !0);
  }), u;
}
function LE(e) {
  const { editor: n, rules: t } = e, a = new Tt({
    state: {
      init() {
        return null;
      },
      apply(l, r, o) {
        const i = l.getMeta(a);
        if (i)
          return i;
        const s = l.getMeta("applyInputRules");
        return !!s && setTimeout(() => {
          let { text: u } = s;
          typeof u == "string" ? u = u : u = fc(Pe.from(u), o.schema);
          const { from: f } = s, b = f + u.length;
          Co({
            editor: n,
            from: f,
            to: b,
            text: u,
            rules: t,
            plugin: a
          });
        }), l.selectionSet || l.docChanged ? null : r;
      }
    },
    props: {
      handleTextInput(l, r, o, i) {
        return Co({
          editor: n,
          from: r,
          to: o,
          text: i,
          rules: t,
          plugin: a
        });
      },
      handleDOMEvents: {
        compositionend: (l) => (setTimeout(() => {
          const { $cursor: r } = l.state.selection;
          r && Co({
            editor: n,
            from: r.pos,
            to: r.pos,
            text: "",
            rules: t,
            plugin: a
          });
        }), !1)
      },
      // add support for input rules to trigger on enter
      // this is useful for example for code blocks
      handleKeyDown(l, r) {
        if (r.key !== "Enter")
          return !1;
        const { $cursor: o } = l.state.selection;
        return o ? Co({
          editor: n,
          from: o.pos,
          to: o.pos,
          text: `
`,
          rules: t,
          plugin: a
        }) : !1;
      }
    },
    // @ts-ignore
    isInputRules: !0
  });
  return a;
}
function EE(e) {
  return Object.prototype.toString.call(e).slice(8, -1);
}
function So(e) {
  return EE(e) !== "Object" ? !1 : e.constructor === Object && Object.getPrototypeOf(e) === Object.prototype;
}
function Sm(e, n) {
  const t = { ...e };
  return So(e) && So(n) && Object.keys(n).forEach((a) => {
    So(n[a]) && So(e[a]) ? t[a] = Sm(e[a], n[a]) : t[a] = n[a];
  }), t;
}
var bc = class {
  constructor(e = {}) {
    this.type = "extendable", this.parent = null, this.child = null, this.name = "", this.config = {
      name: this.name
    }, this.config = {
      ...this.config,
      ...e
    }, this.name = this.config.name;
  }
  get options() {
    return {
      ...ht(
        Ze(this, "addOptions", {
          name: this.name
        })
      ) || {}
    };
  }
  get storage() {
    return {
      ...ht(
        Ze(this, "addStorage", {
          name: this.name,
          options: this.options
        })
      ) || {}
    };
  }
  configure(e = {}) {
    const n = this.extend({
      ...this.config,
      addOptions: () => Sm(this.options, e)
    });
    return n.name = this.name, n.parent = this.parent, this.child = null, n;
  }
  extend(e = {}) {
    const n = new this.constructor({ ...this.config, ...e });
    return n.parent = this, this.child = n, n.name = "name" in e ? e.name : n.parent.name, n;
  }
}, fa = class $m extends bc {
  constructor() {
    super(...arguments), this.type = "mark";
  }
  /**
   * Create a new Mark instance
   * @param config - Mark configuration object or a function that returns a configuration object
   */
  static create(n = {}) {
    const t = typeof n == "function" ? n() : n;
    return new $m(t);
  }
  static handleExit({ editor: n, mark: t }) {
    const { tr: a } = n.state, l = n.state.selection.$from;
    if (l.pos === l.end()) {
      const o = l.marks();
      if (!!!o.find((d) => (d == null ? void 0 : d.type.name) === t.name))
        return !1;
      const s = o.find((d) => (d == null ? void 0 : d.type.name) === t.name);
      return s && a.removeStoredMark(s), a.insertText(" ", l.pos), n.view.dispatch(a), !0;
    }
    return !1;
  }
  configure(n) {
    return super.configure(n);
  }
  extend(n) {
    const t = typeof n == "function" ? n() : n;
    return super.extend(t);
  }
};
function AE(e) {
  return typeof e == "number";
}
var RE = class {
  constructor(e) {
    this.find = e.find, this.handler = e.handler;
  }
}, BE = (e, n, t) => {
  if (dc(n))
    return [...e.matchAll(n)];
  const a = n(e, t);
  return a ? a.map((l) => {
    const r = [l.text];
    return r.index = l.index, r.input = e, r.data = l.data, l.replaceWith && (l.text.includes(l.replaceWith) || console.warn('[tiptap warn]: "pasteRuleMatch.replaceWith" must be part of "pasteRuleMatch.text".'), r.push(l.replaceWith)), r;
  }) : [];
};
function ME(e) {
  const { editor: n, state: t, from: a, to: l, rule: r, pasteEvent: o, dropEvent: i } = e, { commands: s, chain: d, can: u } = new rs({
    editor: n,
    state: t
  }), f = [];
  return t.doc.nodesBetween(a, l, (h, m) => {
    var x, y, w, S, $;
    if ((y = (x = h.type) == null ? void 0 : x.spec) != null && y.code || !(h.isText || h.isTextblock || h.isInline))
      return;
    const T = ($ = (S = (w = h.content) == null ? void 0 : w.size) != null ? S : h.nodeSize) != null ? $ : 0, L = Math.max(a, m), A = Math.min(l, m + T);
    if (L >= A)
      return;
    const R = h.isText ? h.text || "" : h.textBetween(L - m, A - m, void 0, "￼");
    BE(R, r.find, o).forEach((D) => {
      if (D.index === void 0)
        return;
      const V = L + D.index + 1, Y = V + D[0].length, _ = {
        from: t.tr.mapping.map(V),
        to: t.tr.mapping.map(Y)
      }, j = r.handler({
        state: t,
        range: _,
        match: D,
        commands: s,
        chain: d,
        can: u,
        pasteEvent: o,
        dropEvent: i
      });
      f.push(j);
    });
  }), f.every((h) => h !== null);
}
var $o = null, DE = (e) => {
  var n;
  const t = new ClipboardEvent("paste", {
    clipboardData: new DataTransfer()
  });
  return (n = t.clipboardData) == null || n.setData("text/html", e), t;
};
function zE(e) {
  const { editor: n, rules: t } = e;
  let a = null, l = !1, r = !1, o = typeof ClipboardEvent < "u" ? new ClipboardEvent("paste") : null, i;
  try {
    i = typeof DragEvent < "u" ? new DragEvent("drop") : null;
  } catch {
    i = null;
  }
  const s = ({
    state: u,
    from: f,
    to: b,
    rule: h,
    pasteEvt: m
  }) => {
    const x = u.tr, y = ls({
      state: u,
      transaction: x
    });
    if (!(!ME({
      editor: n,
      state: y,
      from: Math.max(f - 1, 0),
      to: b.b - 1,
      rule: h,
      pasteEvent: m,
      dropEvent: i
    }) || !x.steps.length)) {
      try {
        i = typeof DragEvent < "u" ? new DragEvent("drop") : null;
      } catch {
        i = null;
      }
      return o = typeof ClipboardEvent < "u" ? new ClipboardEvent("paste") : null, x;
    }
  };
  return t.map((u) => new Tt({
    // we register a global drag handler to track the current drag source element
    view(f) {
      const b = (m) => {
        var x;
        a = (x = f.dom.parentElement) != null && x.contains(m.target) ? f.dom.parentElement : null, a && ($o = n);
      }, h = () => {
        $o && ($o = null);
      };
      return window.addEventListener("dragstart", b), window.addEventListener("dragend", h), {
        destroy() {
          window.removeEventListener("dragstart", b), window.removeEventListener("dragend", h);
        }
      };
    },
    props: {
      handleDOMEvents: {
        drop: (f, b) => {
          if (r = a === f.dom.parentElement, i = b, !r) {
            const h = $o;
            h != null && h.isEditable && setTimeout(() => {
              const m = h.state.selection;
              m && h.commands.deleteRange({ from: m.from, to: m.to });
            }, 10);
          }
          return !1;
        },
        paste: (f, b) => {
          var h;
          const m = (h = b.clipboardData) == null ? void 0 : h.getData("text/html");
          return o = b, l = !!(m != null && m.includes("data-pm-slice")), !1;
        }
      }
    },
    appendTransaction: (f, b, h) => {
      const m = f[0], x = m.getMeta("uiEvent") === "paste" && !l, y = m.getMeta("uiEvent") === "drop" && !r, w = m.getMeta("applyPasteRules"), S = !!w;
      if (!x && !y && !S)
        return;
      if (S) {
        let { text: L } = w;
        typeof L == "string" ? L = L : L = fc(Pe.from(L), h.schema);
        const { from: A } = w, R = A + L.length, z = DE(L);
        return s({
          rule: u,
          state: h,
          from: A,
          to: { b: R },
          pasteEvt: z
        });
      }
      const $ = b.doc.content.findDiffStart(h.doc.content), T = b.doc.content.findDiffEnd(h.doc.content);
      if (!(!AE($) || !T || $ === T.b))
        return s({
          rule: u,
          state: h,
          from: $,
          to: T,
          pasteEvt: o
        });
    }
  }));
}
var us = class {
  constructor(e, n) {
    this.splittableMarks = [], this.editor = n, this.baseExtensions = e, this.extensions = pm(e), this.schema = UL(this.extensions, n), this.setupExtensions();
  }
  /**
   * Get all commands from the extensions.
   * @returns An object with all commands where the key is the command name and the value is the command function
   */
  get commands() {
    return this.extensions.reduce((e, n) => {
      const t = {
        name: n.name,
        options: n.options,
        storage: this.editor.extensionStorage[n.name],
        editor: this.editor,
        type: tr(n.name, this.schema)
      }, a = Ze(n, "addCommands", t);
      return a ? {
        ...e,
        ...a()
      } : e;
    }, {});
  }
  /**
   * Get all registered Prosemirror plugins from the extensions.
   * @returns An array of Prosemirror plugins
   */
  get plugins() {
    const { editor: e } = this;
    return wr([...this.extensions].reverse()).flatMap((a) => {
      const l = {
        name: a.name,
        options: a.options,
        storage: this.editor.extensionStorage[a.name],
        editor: e,
        type: tr(a.name, this.schema)
      }, r = [], o = Ze(
        a,
        "addKeyboardShortcuts",
        l
      );
      let i = {};
      if (a.type === "mark" && Ze(a, "exitable", l) && (i.ArrowRight = () => fa.handleExit({ editor: e, mark: a })), o) {
        const b = Object.fromEntries(
          Object.entries(o()).map(([h, m]) => [h, () => m({ editor: e })])
        );
        i = { ...i, ...b };
      }
      const s = UT(i);
      r.push(s);
      const d = Ze(a, "addInputRules", l);
      if (Ih(a, e.options.enableInputRules) && d) {
        const b = d();
        if (b && b.length) {
          const h = LE({
            editor: e,
            rules: b
          }), m = Array.isArray(h) ? h : [h];
          r.push(...m);
        }
      }
      const u = Ze(a, "addPasteRules", l);
      if (Ih(a, e.options.enablePasteRules) && u) {
        const b = u();
        if (b && b.length) {
          const h = zE({ editor: e, rules: b });
          r.push(...h);
        }
      }
      const f = Ze(
        a,
        "addProseMirrorPlugins",
        l
      );
      if (f) {
        const b = f();
        r.push(...b);
      }
      return r;
    });
  }
  /**
   * Get all attributes from the extensions.
   * @returns An array of attributes
   */
  get attributes() {
    return gm(this.extensions);
  }
  /**
   * Get all node views from the extensions.
   * @returns An object with all node views where the key is the node name and the value is the node view function
   */
  get nodeViews() {
    const { editor: e } = this, { nodeExtensions: n } = Wl(this.extensions);
    return Object.fromEntries(
      n.filter((t) => !!Ze(t, "addNodeView")).map((t) => {
        const a = this.attributes.filter((s) => s.type === t.name), l = {
          name: t.name,
          options: t.options,
          storage: this.editor.extensionStorage[t.name],
          editor: e,
          type: Dt(t.name, this.schema)
        }, r = Ze(t, "addNodeView", l);
        if (!r)
          return [];
        const o = r();
        if (!o)
          return [];
        const i = (s, d, u, f, b) => {
          const h = Ur(s, a);
          return o({
            // pass-through
            node: s,
            view: d,
            getPos: u,
            decorations: f,
            innerDecorations: b,
            // tiptap-specific
            editor: e,
            extension: t,
            HTMLAttributes: h
          });
        };
        return [t.name, i];
      })
    );
  }
  /**
   * Get the composed dispatchTransaction function from all extensions.
   * @param baseDispatch The base dispatch function (e.g. from the editor or user props)
   * @returns A composed dispatch function
   */
  dispatchTransaction(e) {
    const { editor: n } = this;
    return wr([...this.extensions].reverse()).reduceRight((a, l) => {
      const r = {
        name: l.name,
        options: l.options,
        storage: this.editor.extensionStorage[l.name],
        editor: n,
        type: tr(l.name, this.schema)
      }, o = Ze(
        l,
        "dispatchTransaction",
        r
      );
      return o ? (i) => {
        o.call(r, { transaction: i, next: a });
      } : a;
    }, e);
  }
  /**
   * Get the composed transformPastedHTML function from all extensions.
   * @param baseTransform The base transform function (e.g. from the editor props)
   * @returns A composed transform function that chains all extension transforms
   */
  transformPastedHTML(e) {
    const { editor: n } = this;
    return wr([...this.extensions]).reduce(
      (a, l) => {
        const r = {
          name: l.name,
          options: l.options,
          storage: this.editor.extensionStorage[l.name],
          editor: n,
          type: tr(l.name, this.schema)
        }, o = Ze(
          l,
          "transformPastedHTML",
          r
        );
        return o ? (i, s) => {
          const d = a(i, s);
          return o.call(r, d);
        } : a;
      },
      e || ((a) => a)
    );
  }
  get markViews() {
    const { editor: e } = this, { markExtensions: n } = Wl(this.extensions);
    return Object.fromEntries(
      n.filter((t) => !!Ze(t, "addMarkView")).map((t) => {
        const a = this.attributes.filter((i) => i.type === t.name), l = {
          name: t.name,
          options: t.options,
          storage: this.editor.extensionStorage[t.name],
          editor: e,
          type: ca(t.name, this.schema)
        }, r = Ze(t, "addMarkView", l);
        if (!r)
          return [];
        const o = (i, s, d) => {
          const u = Ur(i, a);
          return r()({
            // pass-through
            mark: i,
            view: s,
            inline: d,
            // tiptap-specific
            editor: e,
            extension: t,
            HTMLAttributes: u,
            updateAttributes: (f) => {
              ZE(i, e, f);
            }
          });
        };
        return [t.name, o];
      })
    );
  }
  /**
   * Destroy the extension manager and clean up all extension references
   * to prevent memory leaks through parent/child extension chains.
   *
   * Walks each extension's full parent chain and nulls every forward
   * `parent.child → current` link where the parent still points to the
   * current node. This breaks the retention path from module-scope
   * singleton roots through deep extend() chains.
   *
   * Only ancestor `.child` links matching the current chain are cleared.
   * The `.parent` pointer on ancestors is never touched — extensions
   * may be shared across live editors, so their own backward references
   * and non-matching forward links must remain intact.
   */
  destroy() {
    this.extensions.forEach((e) => {
      let n = e;
      for (; n.parent; ) {
        const t = n.parent;
        t.child === n && (t.child = null), n = t;
      }
    }), this.extensions = [], this.baseExtensions = [], this.schema = null, this.editor = null;
  }
  /**
   * Go through all extensions, create extension storages & setup marks
   * & bind editor event listener.
   */
  setupExtensions() {
    const e = this.extensions;
    this.editor.extensionStorage = Object.fromEntries(
      e.map((n) => [n.name, n.storage])
    ), e.forEach((n) => {
      var t;
      const a = {
        name: n.name,
        options: n.options,
        storage: this.editor.extensionStorage[n.name],
        editor: this.editor,
        type: tr(n.name, this.schema)
      };
      n.type === "mark" && ((t = ht(Ze(n, "keepOnSplit", a))) == null || t) && this.splittableMarks.push(n.name);
      const l = Ze(n, "onBeforeCreate", a), r = Ze(n, "onCreate", a), o = Ze(n, "onUpdate", a), i = Ze(
        n,
        "onSelectionUpdate",
        a
      ), s = Ze(n, "onTransaction", a), d = Ze(n, "onFocus", a), u = Ze(n, "onBlur", a), f = Ze(n, "onDestroy", a);
      l && this.editor.on("beforeCreate", l), r && this.editor.on("create", r), o && this.editor.on("update", o), i && this.editor.on("selectionUpdate", i), s && this.editor.on("transaction", s), d && this.editor.on("focus", d), u && this.editor.on("blur", u), f && this.editor.on("destroy", f);
    });
  }
};
us.resolve = pm;
us.sort = wr;
us.flatten = cc;
var OE = {};
sc(OE, {
  ClipboardTextSerializer: () => Tm,
  Commands: () => Lm,
  Delete: () => Em,
  Drop: () => Am,
  Editable: () => Rm,
  FocusEvents: () => Mm,
  Keymap: () => Dm,
  Paste: () => zm,
  Tabindex: () => Om,
  TextDirection: () => Pm,
  focusEventsPluginKey: () => Bm
});
var pt = class Im extends bc {
  constructor() {
    super(...arguments), this.type = "extension";
  }
  /**
   * Create a new Extension instance
   * @param config - Extension configuration object or a function that returns a configuration object
   */
  static create(n = {}) {
    const t = typeof n == "function" ? n() : n;
    return new Im(t);
  }
  configure(n) {
    return super.configure(n);
  }
  extend(n) {
    const t = typeof n == "function" ? n() : n;
    return super.extend(t);
  }
}, Tm = pt.create({
  name: "clipboardTextSerializer",
  addOptions() {
    return {
      blockSeparator: void 0
    };
  },
  addProseMirrorPlugins() {
    return [
      new Tt({
        key: new Ot("clipboardTextSerializer"),
        props: {
          clipboardTextSerializer: () => {
            const { editor: e } = this, { state: n, schema: t } = e, { doc: a, selection: l } = n, { ranges: r } = l, o = Math.min(...r.map((u) => u.$from.pos)), i = Math.max(...r.map((u) => u.$to.pos)), s = vm(t);
            return mm(a, { from: o, to: i }, {
              ...this.options.blockSeparator !== void 0 ? { blockSeparator: this.options.blockSeparator } : {},
              textSerializers: s
            });
          }
        }
      })
    ];
  }
}), Lm = pt.create({
  name: "commands",
  addCommands() {
    return {
      ...om
    };
  }
}), Em = pt.create({
  name: "delete",
  onUpdate({ transaction: e, appendedTransactions: n }) {
    var t, a, l;
    const r = () => {
      var o, i, s, d;
      if ((d = (s = (i = (o = this.editor.options.coreExtensionOptions) == null ? void 0 : o.delete) == null ? void 0 : i.filterTransaction) == null ? void 0 : s.call(i, e)) != null ? d : e.getMeta("y-sync$"))
        return;
      const u = hm(e.before, [e, ...n]);
      ym(u).forEach((h) => {
        u.mapping.mapResult(h.oldRange.from).deletedAfter && u.mapping.mapResult(h.oldRange.to).deletedBefore && u.before.nodesBetween(h.oldRange.from, h.oldRange.to, (m, x) => {
          const y = x + m.nodeSize - 2, w = h.oldRange.from <= x && y <= h.oldRange.to;
          this.editor.emit("delete", {
            type: "node",
            node: m,
            from: x,
            to: y,
            newFrom: u.mapping.map(x),
            newTo: u.mapping.map(y),
            deletedRange: h.oldRange,
            newRange: h.newRange,
            partial: !w,
            editor: this.editor,
            transaction: e,
            combinedTransform: u
          });
        });
      });
      const b = u.mapping;
      u.steps.forEach((h, m) => {
        var x, y;
        if (h instanceof On) {
          const w = b.slice(m).map(h.from, -1), S = b.slice(m).map(h.to), $ = b.invert().map(w, -1), T = b.invert().map(S), L = w > 0 ? (x = u.doc.nodeAt(w - 1)) == null ? void 0 : x.marks.some((R) => R.eq(h.mark)) : !1, A = (y = u.doc.nodeAt(S)) == null ? void 0 : y.marks.some((R) => R.eq(h.mark));
          this.editor.emit("delete", {
            type: "mark",
            mark: h.mark,
            from: h.from,
            to: h.to,
            deletedRange: {
              from: $,
              to: T
            },
            newRange: {
              from: w,
              to: S
            },
            partial: !!(A || L),
            editor: this.editor,
            transaction: e,
            combinedTransform: u
          });
        }
      });
    };
    (l = (a = (t = this.editor.options.coreExtensionOptions) == null ? void 0 : t.delete) == null ? void 0 : a.async) == null || l ? setTimeout(r, 0) : r();
  }
}), Am = pt.create({
  name: "drop",
  addProseMirrorPlugins() {
    return [
      new Tt({
        key: new Ot("tiptapDrop"),
        props: {
          handleDrop: (e, n, t, a) => {
            this.editor.emit("drop", {
              editor: this.editor,
              event: n,
              slice: t,
              moved: a
            });
          }
        }
      })
    ];
  }
}), Rm = pt.create({
  name: "editable",
  addProseMirrorPlugins() {
    return [
      new Tt({
        key: new Ot("editable"),
        props: {
          editable: () => this.editor.options.editable
        }
      })
    ];
  }
}), Bm = new Ot("focusEvents"), Mm = pt.create({
  name: "focusEvents",
  addProseMirrorPlugins() {
    const { editor: e } = this;
    return [
      new Tt({
        key: Bm,
        props: {
          handleDOMEvents: {
            focus: (n, t) => {
              e.isFocused = !0;
              const a = e.state.tr.setMeta("focus", { event: t }).setMeta("addToHistory", !1);
              return n.dispatch(a), !1;
            },
            blur: (n, t) => {
              e.isFocused = !1;
              const a = e.state.tr.setMeta("blur", { event: t }).setMeta("addToHistory", !1);
              return n.dispatch(a), !1;
            }
          }
        }
      })
    ];
  }
}), Dm = pt.create({
  name: "keymap",
  addKeyboardShortcuts() {
    const e = () => this.editor.commands.first(({ commands: o }) => [
      () => o.undoInputRule(),
      // maybe convert first text block node to default node
      () => o.command(({ tr: i }) => {
        const { selection: s, doc: d } = i, { empty: u, $anchor: f } = s, { pos: b, parent: h } = f, m = f.parent.isTextblock && b > 0 ? i.doc.resolve(b - 1) : f, x = m.parent.type.spec.isolating, y = f.pos - f.parentOffset, w = x && m.parent.childCount === 1 ? y === f.pos : rt.atStart(d).from === b;
        return !u || !h.type.isTextblock || h.textContent.length || !w || w && f.parent.type.name === "paragraph" ? !1 : o.clearNodes();
      }),
      () => o.deleteSelection(),
      () => o.joinBackward(),
      () => o.selectNodeBackward()
    ]), n = () => this.editor.commands.first(({ commands: o }) => [
      () => o.deleteSelection(),
      () => o.deleteCurrentNode(),
      () => o.joinForward(),
      () => o.selectNodeForward()
    ]), a = {
      Enter: () => this.editor.commands.first(({ commands: o }) => [
        () => o.newlineInCode(),
        () => o.createParagraphNear(),
        () => o.liftEmptyBlock(),
        () => o.splitBlock()
      ]),
      "Mod-Enter": () => this.editor.commands.exitCode(),
      Backspace: e,
      "Mod-Backspace": e,
      "Shift-Backspace": e,
      Delete: n,
      "Mod-Delete": n,
      "Mod-a": () => this.editor.commands.selectAll()
    }, l = {
      ...a
    }, r = {
      ...a,
      "Ctrl-h": e,
      "Alt-Backspace": e,
      "Ctrl-d": n,
      "Ctrl-Alt-Backspace": n,
      "Alt-Delete": n,
      "Alt-d": n,
      "Ctrl-a": () => this.editor.commands.selectTextblockStart(),
      "Ctrl-e": () => this.editor.commands.selectTextblockEnd()
    };
    return bi() || cm() ? r : l;
  },
  addProseMirrorPlugins() {
    return [
      // With this plugin we check if the whole document was selected and deleted.
      // In this case we will additionally call `clearNodes()` to convert e.g. a heading
      // to a paragraph if necessary.
      // This is an alternative to ProseMirror's `AllSelection`, which doesn’t work well
      // with many other commands.
      new Tt({
        key: new Ot("clearDocument"),
        appendTransaction: (e, n, t) => {
          if (e.some((x) => x.getMeta("composition")))
            return;
          const a = e.some((x) => x.docChanged) && !n.doc.eq(t.doc), l = e.some((x) => x.getMeta("preventClearDocument"));
          if (!a || l)
            return;
          const { empty: r, from: o, to: i } = n.selection, s = rt.atStart(n.doc).from, d = rt.atEnd(n.doc).to;
          if (r || !(o === s && i === d) || !Gr(t.doc))
            return;
          const b = t.tr, h = ls({
            state: t,
            transaction: b
          }), { commands: m } = new rs({
            editor: this.editor,
            state: h
          });
          if (m.clearNodes(), !!b.steps.length)
            return b;
        }
      })
    ];
  }
}), zm = pt.create({
  name: "paste",
  addProseMirrorPlugins() {
    return [
      new Tt({
        key: new Ot("tiptapPaste"),
        props: {
          handlePaste: (e, n, t) => {
            this.editor.emit("paste", {
              editor: this.editor,
              event: n,
              slice: t
            });
          }
        }
      })
    ];
  }
}), Om = pt.create({
  name: "tabindex",
  addOptions() {
    return {
      value: void 0
    };
  },
  addProseMirrorPlugins() {
    return [
      new Tt({
        key: new Ot("tabindex"),
        props: {
          attributes: () => {
            var e;
            return !this.editor.isEditable && this.options.value === void 0 ? {} : { tabindex: (e = this.options.value) != null ? e : "0" };
          }
        }
      })
    ];
  }
}), Pm = pt.create({
  name: "textDirection",
  addOptions() {
    return {
      direction: void 0
    };
  },
  addGlobalAttributes() {
    if (!this.options.direction)
      return [];
    const { nodeExtensions: e } = Wl(this.extensions);
    return [
      {
        types: e.filter((n) => n.name !== "text").map((n) => n.name),
        attributes: {
          dir: {
            default: this.options.direction,
            parseHTML: (n) => {
              const t = n.getAttribute("dir");
              return t && (t === "ltr" || t === "rtl" || t === "auto") ? t : this.options.direction;
            },
            renderHTML: (n) => n.dir ? {
              dir: n.dir
            } : {}
          }
        }
      }
    ];
  },
  addProseMirrorPlugins() {
    return [
      new Tt({
        key: new Ot("textDirection"),
        props: {
          attributes: () => {
            const e = this.options.direction;
            return e ? {
              dir: e
            } : {};
          }
        }
      })
    ];
  }
}), PE = class fr {
  constructor(n, t, a = !1, l = null) {
    this.currentNode = null, this.actualDepth = null, this.isBlock = a, this.resolvedPos = n, this.editor = t, this.currentNode = l;
  }
  get name() {
    return this.node.type.name;
  }
  get node() {
    return this.currentNode || this.resolvedPos.node();
  }
  get element() {
    return this.editor.view.domAtPos(this.pos).node;
  }
  get depth() {
    var n;
    return (n = this.actualDepth) != null ? n : this.resolvedPos.depth;
  }
  get pos() {
    return this.resolvedPos.pos;
  }
  get content() {
    return this.node.content;
  }
  set content(n) {
    let t = this.from, a = this.to;
    if (this.isBlock) {
      if (this.content.size === 0) {
        console.error(`You can’t set content on a block node. Tried to set content on ${this.name} at ${this.pos}`);
        return;
      }
      t = this.from + 1, a = this.to - 1;
    }
    this.editor.commands.insertContentAt({ from: t, to: a }, n);
  }
  get attributes() {
    return this.node.attrs;
  }
  get textContent() {
    return this.node.textContent;
  }
  get size() {
    return this.node.nodeSize;
  }
  get from() {
    return this.isBlock ? this.pos : this.resolvedPos.start(this.resolvedPos.depth);
  }
  get range() {
    return {
      from: this.from,
      to: this.to
    };
  }
  get to() {
    return this.isBlock ? this.pos + this.size : this.resolvedPos.end(this.resolvedPos.depth) + (this.node.isText ? 0 : 1);
  }
  get parent() {
    if (this.depth === 0)
      return null;
    const n = this.resolvedPos.start(this.resolvedPos.depth - 1), t = this.resolvedPos.doc.resolve(n);
    return new fr(t, this.editor);
  }
  get before() {
    let n = this.resolvedPos.doc.resolve(this.from - (this.isBlock ? 1 : 2));
    return n.depth !== this.depth && (n = this.resolvedPos.doc.resolve(this.from - 3)), new fr(n, this.editor);
  }
  get after() {
    let n = this.resolvedPos.doc.resolve(this.to + (this.isBlock ? 2 : 1));
    return n.depth !== this.depth && (n = this.resolvedPos.doc.resolve(this.to + 3)), new fr(n, this.editor);
  }
  get children() {
    const n = [];
    return this.node.content.forEach((t, a) => {
      const l = t.isBlock && !t.isTextblock, r = t.isAtom && !t.isText, o = t.isInline, i = this.pos + a + (r ? 0 : 1);
      if (i < 0 || i > this.resolvedPos.doc.nodeSize - 2)
        return;
      const s = this.resolvedPos.doc.resolve(i);
      if (!l && !o && s.depth <= this.depth)
        return;
      const d = new fr(s, this.editor, l, l || o ? t : null);
      l && (d.actualDepth = this.depth + 1), n.push(d);
    }), n;
  }
  get firstChild() {
    return this.children[0] || null;
  }
  get lastChild() {
    const n = this.children;
    return n[n.length - 1] || null;
  }
  closest(n, t = {}) {
    let a = null, l = this.parent;
    for (; l && !a; ) {
      if (l.node.type.name === n)
        if (Object.keys(t).length > 0) {
          const r = l.node.attrs, o = Object.keys(t);
          for (let i = 0; i < o.length; i += 1) {
            const s = o[i];
            if (r[s] !== t[s])
              break;
          }
        } else
          a = l;
      l = l.parent;
    }
    return a;
  }
  querySelector(n, t = {}) {
    return this.querySelectorAll(n, t, !0)[0] || null;
  }
  querySelectorAll(n, t = {}, a = !1) {
    let l = [];
    if (!this.children || this.children.length === 0)
      return l;
    const r = Object.keys(t);
    return this.children.forEach((o) => {
      a && l.length > 0 || (o.node.type.name === n && r.every((s) => t[s] === o.node.attrs[s]) && l.push(o), !(a && l.length > 0) && (l = l.concat(o.querySelectorAll(n, t, a))));
    }), l;
  }
  setAttribute(n) {
    const { tr: t } = this.editor.state;
    t.setNodeMarkup(this.from, void 0, {
      ...this.node.attrs,
      ...n
    }), this.editor.view.dispatch(t);
  }
}, FE = `.ProseMirror {
  position: relative;
}

.ProseMirror {
  word-wrap: break-word;
  white-space: pre-wrap;
  white-space: break-spaces;
  -webkit-font-variant-ligatures: none;
  font-variant-ligatures: none;
  font-feature-settings: "liga" 0; /* the above doesn't seem to work in Edge */
}

.ProseMirror [contenteditable="false"] {
  white-space: normal;
}

.ProseMirror [contenteditable="false"] [contenteditable="true"] {
  white-space: pre-wrap;
}

.ProseMirror pre {
  white-space: pre-wrap;
}

img.ProseMirror-separator {
  display: inline !important;
  border: none !important;
  margin: 0 !important;
  width: 0 !important;
  height: 0 !important;
}

.ProseMirror-gapcursor {
  display: none;
  pointer-events: none;
  position: absolute;
  margin: 0;
}

.ProseMirror-gapcursor:after {
  content: "";
  display: block;
  position: absolute;
  top: -2px;
  width: 20px;
  border-top: 1px solid black;
  animation: ProseMirror-cursor-blink 1.1s steps(2, start) infinite;
}

@keyframes ProseMirror-cursor-blink {
  to {
    visibility: hidden;
  }
}

.ProseMirror-hideselection *::selection {
  background: transparent;
}

.ProseMirror-hideselection *::-moz-selection {
  background: transparent;
}

.ProseMirror-hideselection * {
  caret-color: transparent;
}

.ProseMirror-focused .ProseMirror-gapcursor {
  display: block;
}`;
function VE(e, n, t) {
  const a = document.querySelector("style[data-tiptap-style]");
  if (a !== null)
    return a;
  const l = document.createElement("style");
  return n && l.setAttribute("nonce", n), l.setAttribute("data-tiptap-style", ""), l.innerHTML = e, document.getElementsByTagName("head")[0].appendChild(l), l;
}
var NE = class extends IE {
  constructor(n = {}) {
    super(), this.css = null, this.className = "tiptap", this.editorView = null, this.isFocused = !1, this.destroyed = !1, this.isInitialized = !1, this.extensionStorage = {}, this.instanceId = Math.random().toString(36).slice(2, 9), this.options = {
      element: typeof document < "u" ? document.createElement("div") : null,
      content: "",
      injectCSS: !0,
      injectNonce: void 0,
      extensions: [],
      autofocus: !1,
      editable: !0,
      textDirection: void 0,
      editorProps: {},
      parseOptions: {},
      coreExtensionOptions: {},
      enableInputRules: !0,
      enablePasteRules: !0,
      enableCoreExtensions: !0,
      enableContentCheck: !1,
      emitContentError: !1,
      onBeforeCreate: () => null,
      onCreate: () => null,
      onMount: () => null,
      onUnmount: () => null,
      onUpdate: () => null,
      onSelectionUpdate: () => null,
      onTransaction: () => null,
      onFocus: () => null,
      onBlur: () => null,
      onDestroy: () => null,
      onContentError: ({ error: l }) => {
        throw l;
      },
      onPaste: () => null,
      onDrop: () => null,
      onDelete: () => null,
      enableExtensionDispatchTransaction: !0
    }, this.isCapturingTransaction = !1, this.capturedTransaction = null, this.utils = {
      getUpdatedPosition: nE,
      createMappablePosition: aE
    }, this.setOptions(n), this.createExtensionManager(), this.createCommandManager(), this.createSchema(), this.on("beforeCreate", this.options.onBeforeCreate), this.emit("beforeCreate", { editor: this }), this.on("mount", this.options.onMount), this.on("unmount", this.options.onUnmount), this.on("contentError", this.options.onContentError), this.on("create", this.options.onCreate), this.on("update", this.options.onUpdate), this.on("selectionUpdate", this.options.onSelectionUpdate), this.on("transaction", this.options.onTransaction), this.on("focus", this.options.onFocus), this.on("blur", this.options.onBlur), this.on("destroy", this.options.onDestroy), this.on("drop", ({ event: l, slice: r, moved: o }) => this.options.onDrop(l, r, o)), this.on("paste", ({ event: l, slice: r }) => this.options.onPaste(l, r)), this.on("delete", this.options.onDelete);
    const t = this.createDoc(), a = dm(t, this.options.autofocus);
    this.editorState = Cl.create({
      doc: t,
      schema: this.schema,
      selection: a || void 0
    }), this.options.element && this.mount(this.options.element);
  }
  /**
   * Attach the editor to the DOM, creating a new editor view.
   */
  mount(n) {
    if (typeof document > "u")
      throw new Error(
        "[tiptap error]: The editor cannot be mounted because there is no 'document' defined in this environment."
      );
    this.createView(n), this.emit("mount", { editor: this }), this.css && !document.head.contains(this.css) && document.head.appendChild(this.css), window.setTimeout(() => {
      this.isDestroyed || (this.options.autofocus !== !1 && this.options.autofocus !== null && this.commands.focus(this.options.autofocus), this.emit("create", { editor: this }), this.isInitialized = !0);
    }, 0);
  }
  /**
   * Remove the editor from the DOM, but still allow remounting at a different point in time
   */
  unmount() {
    if (this.editorView) {
      const n = this.editorView.dom;
      n != null && n.editor && delete n.editor, this.editorView.destroy();
    }
    if (this.editorView = null, this.isInitialized = !1, this.css && !document.querySelectorAll(`.${this.className}`).length)
      try {
        typeof this.css.remove == "function" ? this.css.remove() : this.css.parentNode && this.css.parentNode.removeChild(this.css);
      } catch (n) {
        console.warn("Failed to remove CSS element:", n);
      }
    this.css = null, this.emit("unmount", { editor: this });
  }
  /**
   * Returns the editor storage.
   */
  get storage() {
    return this.extensionStorage;
  }
  /**
   * An object of all registered commands.
   */
  get commands() {
    return this.commandManager.commands;
  }
  /**
   * Create a command chain to call multiple commands at once.
   */
  chain() {
    return this.commandManager.chain();
  }
  /**
   * Check if a command or a command chain can be executed. Without executing it.
   */
  can() {
    return this.commandManager.can();
  }
  /**
   * Inject CSS styles.
   */
  injectCSS() {
    this.options.injectCSS && typeof document < "u" && (this.css = VE(FE, this.options.injectNonce));
  }
  /**
   * Update editor options.
   *
   * @param options A list of options
   */
  setOptions(n = {}) {
    this.options = {
      ...this.options,
      ...n
    }, !(!this.editorView || !this.state || this.isDestroyed) && (this.options.editorProps && this.view.setProps(this.options.editorProps), this.view.updateState(this.state));
  }
  /**
   * Update editable state of the editor.
   */
  setEditable(n, t = !0) {
    this.setOptions({ editable: n }), t && this.emit("update", { editor: this, transaction: this.state.tr, appendedTransactions: [] });
  }
  /**
   * Returns whether the editor is editable.
   */
  get isEditable() {
    return this.options.editable && this.view && this.view.editable;
  }
  /**
   * Returns the editor view.
   */
  get view() {
    return this.editorView ? this.editorView : new Proxy(
      {
        state: this.editorState,
        updateState: (n) => {
          this.editorState = n;
        },
        dispatch: (n) => {
          this.dispatchTransaction(n);
        },
        // Stub some commonly accessed properties to prevent errors
        composing: !1,
        dragging: null,
        editable: !0,
        isDestroyed: !1
      },
      {
        get: (n, t) => {
          if (this.editorView)
            return this.editorView[t];
          if (t === "state")
            return this.editorState;
          if (t in n)
            return Reflect.get(n, t);
          throw new Error(
            `[tiptap error]: The editor view is not available. Cannot access view['${t}']. The editor may not be mounted yet.`
          );
        }
      }
    );
  }
  /**
   * Returns the editor state.
   */
  get state() {
    return this.editorView && (this.editorState = this.view.state), this.editorState;
  }
  /**
   * Register a ProseMirror plugin.
   *
   * @param plugin A ProseMirror plugin
   * @param handlePlugins Control how to merge the plugin into the existing plugins.
   * @returns The new editor state
   */
  registerPlugin(n, t) {
    const a = bm(t) ? t(n, [...this.state.plugins]) : [...this.state.plugins, n], l = this.state.reconfigure({ plugins: a });
    return this.view.updateState(l), l;
  }
  /**
   * Unregister a ProseMirror plugin.
   *
   * @param nameOrPluginKeyToRemove The plugins name
   * @returns The new editor state or undefined if the editor is destroyed
   */
  unregisterPlugin(n) {
    if (this.isDestroyed)
      return;
    const t = this.state.plugins;
    let a = t;
    if ([].concat(n).forEach((r) => {
      const o = typeof r == "string" ? `${r}$` : r.key;
      a = a.filter((i) => !i.key.startsWith(o));
    }), t.length === a.length)
      return;
    const l = this.state.reconfigure({
      plugins: a
    });
    return this.view.updateState(l), l;
  }
  /**
   * Creates an extension manager.
   */
  createExtensionManager() {
    var n, t, a, l;
    const o = [...this.options.enableCoreExtensions ? [
      Rm,
      Tm.configure({
        blockSeparator: (t = (n = this.options.coreExtensionOptions) == null ? void 0 : n.clipboardTextSerializer) == null ? void 0 : t.blockSeparator
      }),
      Lm,
      Mm,
      Dm,
      Om.configure({
        value: (l = (a = this.options.coreExtensionOptions) == null ? void 0 : a.tabindex) == null ? void 0 : l.value
      }),
      Am,
      zm,
      Em,
      Pm.configure({
        direction: this.options.textDirection
      })
    ].filter((i) => typeof this.options.enableCoreExtensions == "object" ? this.options.enableCoreExtensions[i.name] !== !1 : !0) : [], ...this.options.extensions].filter((i) => ["extension", "node", "mark"].includes(i == null ? void 0 : i.type));
    this.extensionManager = new us(o, this);
  }
  /**
   * Creates an command manager.
   */
  createCommandManager() {
    this.commandManager = new rs({
      editor: this
    });
  }
  /**
   * Creates a ProseMirror schema.
   */
  createSchema() {
    this.schema = this.extensionManager.schema;
  }
  /**
   * Creates the initial document.
   */
  createDoc() {
    let n;
    try {
      n = Yd(this.options.content, this.schema, this.options.parseOptions, {
        errorOnInvalidContent: this.options.enableContentCheck
      });
    } catch (t) {
      if (!(t instanceof Error) || !["[tiptap error]: Invalid JSON content", "[tiptap error]: Invalid HTML content"].includes(t.message))
        throw t;
      this.emit("contentError", {
        editor: this,
        error: t,
        disableCollaboration: () => {
          "collaboration" in this.storage && typeof this.storage.collaboration == "object" && this.storage.collaboration && (this.storage.collaboration.isDisabled = !0), this.options.extensions = this.options.extensions.filter((a) => a.name !== "collaboration"), this.createExtensionManager();
        }
      }), n = Yd(this.options.content, this.schema, this.options.parseOptions, {
        errorOnInvalidContent: !1
      });
    }
    return n;
  }
  /**
   * Creates a ProseMirror view.
   */
  createView(n) {
    const { editorProps: t, enableExtensionDispatchTransaction: a } = this.options, l = t.dispatchTransaction || this.dispatchTransaction.bind(this), r = a ? this.extensionManager.dispatchTransaction(l) : l, o = t.transformPastedHTML, i = this.extensionManager.transformPastedHTML(o);
    this.editorView = new lm(n, {
      ...t,
      attributes: {
        // add `role="textbox"` to the editor element
        role: "textbox",
        ...t == null ? void 0 : t.attributes
      },
      dispatchTransaction: r,
      transformPastedHTML: i,
      state: this.editorState,
      markViews: this.extensionManager.markViews,
      nodeViews: this.extensionManager.nodeViews
    });
    const s = this.state.reconfigure({
      plugins: this.extensionManager.plugins
    });
    this.view.updateState(s), this.prependClass(), this.injectCSS();
    const d = this.view.dom;
    d.editor = this;
  }
  /**
   * Creates all node and mark views.
   */
  createNodeViews() {
    this.view.isDestroyed || this.view.setProps({
      markViews: this.extensionManager.markViews,
      nodeViews: this.extensionManager.nodeViews
    });
  }
  /**
   * Prepend class name to element.
   */
  prependClass() {
    this.view.dom.className = `${this.className} ${this.view.dom.className}`;
  }
  captureTransaction(n) {
    this.isCapturingTransaction = !0, n(), this.isCapturingTransaction = !1;
    const t = this.capturedTransaction;
    return this.capturedTransaction = null, t;
  }
  /**
   * The callback over which to send transactions (state updates) produced by the view.
   *
   * @param transaction An editor state transaction
   */
  dispatchTransaction(n) {
    if (this.view.isDestroyed)
      return;
    if (this.isCapturingTransaction) {
      if (!this.capturedTransaction) {
        this.capturedTransaction = n;
        return;
      }
      n.steps.forEach((u) => {
        var f;
        return (f = this.capturedTransaction) == null ? void 0 : f.step(u);
      });
      return;
    }
    const { state: t, transactions: a } = this.state.applyTransaction(n), l = !this.state.selection.eq(t.selection), r = a.includes(n), o = this.state;
    if (this.emit("beforeTransaction", {
      editor: this,
      transaction: n,
      nextState: t
    }), !r)
      return;
    this.view.updateState(t), this.emit("transaction", {
      editor: this,
      transaction: n,
      appendedTransactions: a.slice(1)
    }), l && this.emit("selectionUpdate", {
      editor: this,
      transaction: n
    });
    const i = a.findLast((u) => u.getMeta("focus") || u.getMeta("blur")), s = i == null ? void 0 : i.getMeta("focus"), d = i == null ? void 0 : i.getMeta("blur");
    s && this.emit("focus", {
      editor: this,
      event: s.event,
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      transaction: i
    }), d && this.emit("blur", {
      editor: this,
      event: d.event,
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      transaction: i
    }), !(n.getMeta("preventUpdate") || !a.some((u) => u.docChanged) || o.doc.eq(t.doc)) && this.emit("update", {
      editor: this,
      transaction: n,
      appendedTransactions: a.slice(1)
    });
  }
  /**
   * Get attributes of the currently selected node or mark.
   */
  getAttributes(n) {
    return xm(this.state, n);
  }
  isActive(n, t) {
    const a = typeof n == "string" ? n : null, l = typeof n == "string" ? t : n;
    return _L(this.state, a, l);
  }
  /**
   * Get the document as JSON.
   */
  getJSON() {
    return this.state.doc.toJSON();
  }
  /**
   * Get the document as HTML.
   */
  getHTML() {
    return fc(this.state.doc.content, this.schema);
  }
  /**
   * Get the document as text.
   */
  getText(n) {
    const { blockSeparator: t = `

`, textSerializers: a = {} } = n || {};
    return KL(this.state.doc, {
      blockSeparator: t,
      textSerializers: {
        ...vm(this.schema),
        ...a
      }
    });
  }
  /**
   * Check if there is no content.
   */
  get isEmpty() {
    return Gr(this.state.doc);
  }
  /**
   * Destroy the editor.
   */
  destroy() {
    this.destroyed || (this.destroyed = !0, this.emit("destroy"), this.unmount(), this.removeAllListeners(), this.extensionManager.destroy(), this.extensionManager = null, this.schema = null, this.commandManager = null, this.extensionStorage = {});
  }
  /**
   * Check if the editor is already destroyed.
   */
  get isDestroyed() {
    var n, t;
    return (t = (n = this.editorView) == null ? void 0 : n.isDestroyed) != null ? t : !0;
  }
  $node(n, t) {
    var a;
    return ((a = this.$doc) == null ? void 0 : a.querySelector(n, t)) || null;
  }
  $nodes(n, t) {
    var a;
    return ((a = this.$doc) == null ? void 0 : a.querySelectorAll(n, t)) || null;
  }
  $pos(n) {
    const t = this.state.doc.resolve(n), a = n > 0 && t.nodeAfter && !t.nodeAfter.isText ? t.nodeAfter : null;
    return new PE(t, this, !1, a);
  }
  get $doc() {
    return this.$pos(0);
  }
};
function hl(e) {
  return new ds({
    find: e.find,
    handler: ({ state: n, range: t, match: a }) => {
      const l = ht(e.getAttributes, void 0, a);
      if (l === !1 || l === null)
        return null;
      const { tr: r } = n, o = a[a.length - 1], i = a[0];
      if (o) {
        const s = i.search(/\S/), d = t.from + i.indexOf(o), u = d + o.length;
        if (hc(t.from, t.to, n.doc).filter((h) => h.mark.type.excluded.find((x) => x === e.type && x !== h.mark.type)).filter((h) => h.to > d).length)
          return null;
        u < t.to && r.delete(u, t.to), d > t.from && r.delete(t.from + s, d);
        const b = t.from + s + o.length;
        r.addMark(t.from + s, b, e.type.create(l || {})), r.removeStoredMark(e.type);
      }
    },
    undoable: e.undoable
  });
}
function Fm(e) {
  return new ds({
    find: e.find,
    handler: ({ state: n, range: t, match: a }) => {
      const l = ht(e.getAttributes, void 0, a) || {}, { tr: r } = n, o = t.from;
      let i = t.to;
      const s = e.type.create(l);
      if (a[1]) {
        const d = a[0].lastIndexOf(a[1]);
        let u = o + d;
        u > i ? u = i : i = u + a[1].length;
        const f = a[0][a[0].length - 1];
        r.insertText(f, o + a[0].length - 1), r.replaceWith(u, i, s);
      } else if (a[0]) {
        const d = e.type.isInline ? o : o - 1;
        r.insert(d, e.type.create(l)).delete(r.mapping.map(o), r.mapping.map(i));
      }
      r.scrollIntoView();
    },
    undoable: e.undoable
  });
}
function Zd(e) {
  return new ds({
    find: e.find,
    handler: ({ state: n, range: t, match: a }) => {
      const l = n.doc.resolve(t.from), r = ht(e.getAttributes, void 0, a) || {};
      if (!l.node(-1).canReplaceWith(l.index(-1), l.indexAfter(-1), e.type))
        return null;
      n.tr.delete(t.from, t.to).setBlockType(t.from, t.from, e.type, r);
    },
    undoable: e.undoable
  });
}
function ql(e) {
  return new ds({
    find: e.find,
    handler: ({ state: n, range: t, match: a, chain: l }) => {
      const r = ht(e.getAttributes, void 0, a) || {}, o = n.tr.delete(t.from, t.to), s = o.doc.resolve(t.from).blockRange(), d = s && Ku(s, e.type, r);
      if (!d)
        return null;
      if (o.wrap(s, d), e.keepMarks && e.editor) {
        const { selection: f, storedMarks: b } = n, { splittableMarks: h } = e.editor.extensionManager, m = b || f.$to.parentOffset && f.$from.marks();
        if (m) {
          const x = m.filter((y) => h.includes(y.type.name));
          o.ensureMarks(x);
        }
      }
      if (e.keepAttributes) {
        const f = e.type.name === "bulletList" || e.type.name === "orderedList" ? "listItem" : "taskList";
        l().updateAttributes(f, r).run();
      }
      const u = o.doc.resolve(t.from - 1).nodeBefore;
      u && u.type === e.type && Ha(o.doc, t.from - 1) && (!e.joinPredicate || e.joinPredicate(a, u)) && o.join(t.from - 1);
    },
    undoable: e.undoable
  });
}
var HE = (e) => "touches" in e, jE = class {
  /**
   * Creates a new ResizableNodeView instance.
   *
   * The constructor sets up the resize handles, applies initial sizing from
   * node attributes, and configures all resize behavior options.
   *
   * @param options - Configuration options for the resizable node view
   */
  constructor(e) {
    this.directions = ["bottom-left", "bottom-right", "top-left", "top-right"], this.minSize = {
      height: 8,
      width: 8
    }, this.preserveAspectRatio = !1, this.classNames = {
      container: "",
      wrapper: "",
      handle: "",
      resizing: ""
    }, this.initialWidth = 0, this.initialHeight = 0, this.aspectRatio = 1, this.isResizing = !1, this.activeHandle = null, this.startX = 0, this.startY = 0, this.startWidth = 0, this.startHeight = 0, this.isShiftKeyPressed = !1, this.lastEditableState = void 0, this.handleMap = /* @__PURE__ */ new Map(), this.handleMouseMove = (i) => {
      if (!this.isResizing || !this.activeHandle)
        return;
      const s = i.clientX - this.startX, d = i.clientY - this.startY;
      this.handleResize(s, d);
    }, this.handleTouchMove = (i) => {
      if (!this.isResizing || !this.activeHandle)
        return;
      const s = i.touches[0];
      if (!s)
        return;
      const d = s.clientX - this.startX, u = s.clientY - this.startY;
      this.handleResize(d, u);
    }, this.handleMouseUp = () => {
      if (!this.isResizing)
        return;
      const i = this.element.offsetWidth, s = this.element.offsetHeight;
      this.onCommit(i, s), this.isResizing = !1, this.activeHandle = null, this.container.dataset.resizeState = "false", this.classNames.resizing && this.container.classList.remove(this.classNames.resizing), document.removeEventListener("mousemove", this.handleMouseMove), document.removeEventListener("mouseup", this.handleMouseUp), document.removeEventListener("keydown", this.handleKeyDown), document.removeEventListener("keyup", this.handleKeyUp);
    }, this.handleKeyDown = (i) => {
      i.key === "Shift" && (this.isShiftKeyPressed = !0);
    }, this.handleKeyUp = (i) => {
      i.key === "Shift" && (this.isShiftKeyPressed = !1);
    };
    var n, t, a, l, r, o;
    this.node = e.node, this.editor = e.editor, this.element = e.element, this.contentElement = e.contentElement, this.getPos = e.getPos, this.onResize = e.onResize, this.onCommit = e.onCommit, this.onUpdate = e.onUpdate, (n = e.options) != null && n.min && (this.minSize = {
      ...this.minSize,
      ...e.options.min
    }), (t = e.options) != null && t.max && (this.maxSize = e.options.max), (a = e == null ? void 0 : e.options) != null && a.directions && (this.directions = e.options.directions), (l = e.options) != null && l.preserveAspectRatio && (this.preserveAspectRatio = e.options.preserveAspectRatio), (r = e.options) != null && r.className && (this.classNames = {
      container: e.options.className.container || "",
      wrapper: e.options.className.wrapper || "",
      handle: e.options.className.handle || "",
      resizing: e.options.className.resizing || ""
    }), (o = e.options) != null && o.createCustomHandle && (this.createCustomHandle = e.options.createCustomHandle), this.wrapper = this.createWrapper(), this.container = this.createContainer(), this.applyInitialSize(), this.attachHandles(), this.editor.on("update", this.handleEditorUpdate.bind(this));
  }
  /**
   * Returns the top-level DOM node that should be placed in the editor.
   *
   * This is required by the ProseMirror NodeView interface. The container
   * includes the wrapper, handles, and the actual content element.
   *
   * @returns The container element to be inserted into the editor
   */
  get dom() {
    return this.container;
  }
  get contentDOM() {
    var e;
    return (e = this.contentElement) != null ? e : null;
  }
  handleEditorUpdate() {
    const e = this.editor.isEditable;
    e !== this.lastEditableState && (this.lastEditableState = e, e ? e && this.handleMap.size === 0 && this.attachHandles() : this.removeHandles());
  }
  /**
   * Called when the node's content or attributes change.
   *
   * Updates the internal node reference. If a custom `onUpdate` callback
   * was provided, it will be called to handle additional update logic.
   *
   * @param node - The new/updated node
   * @param decorations - Node decorations
   * @param innerDecorations - Inner decorations
   * @returns `false` if the node type has changed (requires full rebuild), otherwise the result of `onUpdate` or `true`
   */
  update(e, n, t) {
    return e.type !== this.node.type ? !1 : (this.node = e, this.onUpdate ? this.onUpdate(e, n, t) : !0);
  }
  /**
   * Cleanup method called when the node view is being removed.
   *
   * Removes all event listeners to prevent memory leaks. This is required
   * by the ProseMirror NodeView interface. If a resize is active when
   * destroy is called, it will be properly cancelled.
   */
  destroy() {
    this.isResizing && (this.container.dataset.resizeState = "false", this.classNames.resizing && this.container.classList.remove(this.classNames.resizing), document.removeEventListener("mousemove", this.handleMouseMove), document.removeEventListener("mouseup", this.handleMouseUp), document.removeEventListener("keydown", this.handleKeyDown), document.removeEventListener("keyup", this.handleKeyUp), this.isResizing = !1, this.activeHandle = null), this.editor.off("update", this.handleEditorUpdate.bind(this)), this.container.remove();
  }
  /**
   * Creates the outer container element.
   *
   * The container is the top-level element returned by the NodeView and
   * wraps the entire resizable node. It's set up with flexbox to handle
   * alignment and includes data attributes for styling and identification.
   *
   * @returns The container element
   */
  createContainer() {
    const e = document.createElement("div");
    return e.dataset.resizeContainer = "", e.dataset.node = this.node.type.name, e.style.display = this.node.type.isInline ? "inline-flex" : "flex", this.classNames.container && (e.className = this.classNames.container), e.appendChild(this.wrapper), e;
  }
  /**
   * Creates the wrapper element that contains the content and handles.
   *
   * The wrapper uses relative positioning so that resize handles can be
   * positioned absolutely within it. This is the direct parent of the
   * content element being made resizable.
   *
   * @returns The wrapper element
   */
  createWrapper() {
    const e = document.createElement("div");
    return e.style.position = "relative", e.style.display = "block", e.dataset.resizeWrapper = "", this.classNames.wrapper && (e.className = this.classNames.wrapper), e.appendChild(this.element), e;
  }
  /**
   * Creates a resize handle element for a specific direction.
   *
   * Each handle is absolutely positioned and includes a data attribute
   * identifying its direction for styling purposes.
   *
   * @param direction - The resize direction for this handle
   * @returns The handle element
   */
  createHandle(e) {
    const n = document.createElement("div");
    return n.dataset.resizeHandle = e, n.style.position = "absolute", this.classNames.handle && (n.className = this.classNames.handle), n;
  }
  /**
   * Positions a handle element according to its direction.
   *
   * Corner handles (e.g., 'top-left') are positioned at the intersection
   * of two edges. Edge handles (e.g., 'top') span the full width or height.
   *
   * @param handle - The handle element to position
   * @param direction - The direction determining the position
   */
  positionHandle(e, n) {
    const t = n.includes("top"), a = n.includes("bottom"), l = n.includes("left"), r = n.includes("right");
    t && (e.style.top = "0"), a && (e.style.bottom = "0"), l && (e.style.left = "0"), r && (e.style.right = "0"), (n === "top" || n === "bottom") && (e.style.left = "0", e.style.right = "0"), (n === "left" || n === "right") && (e.style.top = "0", e.style.bottom = "0");
  }
  /**
   * Creates and attaches all resize handles to the wrapper.
   *
   * Iterates through the configured directions, creates a handle for each,
   * positions it, attaches the mousedown listener, and appends it to the DOM.
   */
  attachHandles() {
    this.directions.forEach((e) => {
      let n;
      this.createCustomHandle ? n = this.createCustomHandle(e) : n = this.createHandle(e), n instanceof HTMLElement || (console.warn(
        `[ResizableNodeView] createCustomHandle("${e}") did not return an HTMLElement. Falling back to default handle.`
      ), n = this.createHandle(e)), this.createCustomHandle || this.positionHandle(n, e), n.addEventListener("mousedown", (t) => this.handleResizeStart(t, e)), n.addEventListener("touchstart", (t) => this.handleResizeStart(t, e)), this.handleMap.set(e, n), this.wrapper.appendChild(n);
    });
  }
  /**
   * Removes all resize handles from the wrapper.
   *
   * Cleans up the handle map and removes each handle element from the DOM.
   */
  removeHandles() {
    this.handleMap.forEach((e) => e.remove()), this.handleMap.clear();
  }
  /**
   * Applies initial sizing from node attributes to the element.
   *
   * If width/height attributes exist on the node, they're applied to the element.
   * Otherwise, the element's natural/current dimensions are measured. The aspect
   * ratio is calculated for later use in aspect-ratio-preserving resizes.
   */
  applyInitialSize() {
    const e = this.node.attrs.width, n = this.node.attrs.height;
    e ? (this.element.style.width = `${e}px`, this.initialWidth = e) : this.initialWidth = this.element.offsetWidth, n ? (this.element.style.height = `${n}px`, this.initialHeight = n) : this.initialHeight = this.element.offsetHeight, this.initialWidth > 0 && this.initialHeight > 0 && (this.aspectRatio = this.initialWidth / this.initialHeight);
  }
  /**
   * Initiates a resize operation when a handle is clicked.
   *
   * Captures the starting mouse position and element dimensions, sets up
   * the resize state, adds the resizing class and state attribute, and
   * attaches document-level listeners for mouse movement and keyboard input.
   *
   * @param event - The mouse down event
   * @param direction - The direction of the handle being dragged
   */
  handleResizeStart(e, n) {
    e.preventDefault(), e.stopPropagation(), this.isResizing = !0, this.activeHandle = n, HE(e) ? (this.startX = e.touches[0].clientX, this.startY = e.touches[0].clientY) : (this.startX = e.clientX, this.startY = e.clientY), this.startWidth = this.element.offsetWidth, this.startHeight = this.element.offsetHeight, this.startWidth > 0 && this.startHeight > 0 && (this.aspectRatio = this.startWidth / this.startHeight), this.getPos(), this.container.dataset.resizeState = "true", this.classNames.resizing && this.container.classList.add(this.classNames.resizing), document.addEventListener("mousemove", this.handleMouseMove), document.addEventListener("touchmove", this.handleTouchMove), document.addEventListener("mouseup", this.handleMouseUp), document.addEventListener("keydown", this.handleKeyDown), document.addEventListener("keyup", this.handleKeyUp);
  }
  handleResize(e, n) {
    if (!this.activeHandle)
      return;
    const t = this.preserveAspectRatio || this.isShiftKeyPressed, { width: a, height: l } = this.calculateNewDimensions(this.activeHandle, e, n), r = this.applyConstraints(a, l, t);
    this.element.style.width = `${r.width}px`, this.element.style.height = `${r.height}px`, this.onResize && this.onResize(r.width, r.height);
  }
  /**
   * Calculates new dimensions based on mouse delta and resize direction.
   *
   * Takes the starting dimensions and applies the mouse movement delta
   * according to the handle direction. For corner handles, both dimensions
   * are affected. For edge handles, only one dimension changes. If aspect
   * ratio should be preserved, delegates to applyAspectRatio.
   *
   * @param direction - The active resize handle direction
   * @param deltaX - Horizontal mouse movement since resize start
   * @param deltaY - Vertical mouse movement since resize start
   * @returns The calculated width and height
   */
  calculateNewDimensions(e, n, t) {
    let a = this.startWidth, l = this.startHeight;
    const r = e.includes("right"), o = e.includes("left"), i = e.includes("bottom"), s = e.includes("top");
    return r ? a = this.startWidth + n : o && (a = this.startWidth - n), i ? l = this.startHeight + t : s && (l = this.startHeight - t), (e === "right" || e === "left") && (a = this.startWidth + (r ? n : -n)), (e === "top" || e === "bottom") && (l = this.startHeight + (i ? t : -t)), this.preserveAspectRatio || this.isShiftKeyPressed ? this.applyAspectRatio(a, l, e) : { width: a, height: l };
  }
  /**
   * Applies min/max constraints to dimensions.
   *
   * When aspect ratio is NOT preserved, constraints are applied independently
   * to width and height. When aspect ratio IS preserved, constraints are
   * applied while maintaining the aspect ratio—if one dimension hits a limit,
   * the other is recalculated proportionally.
   *
   * This ensures that aspect ratio is never broken when constrained.
   *
   * @param width - The unconstrained width
   * @param height - The unconstrained height
   * @param preserveAspectRatio - Whether to maintain aspect ratio while constraining
   * @returns The constrained dimensions
   */
  applyConstraints(e, n, t) {
    var a, l, r, o;
    if (!t) {
      let d = Math.max(this.minSize.width, e), u = Math.max(this.minSize.height, n);
      return (a = this.maxSize) != null && a.width && (d = Math.min(this.maxSize.width, d)), (l = this.maxSize) != null && l.height && (u = Math.min(this.maxSize.height, u)), { width: d, height: u };
    }
    let i = e, s = n;
    return i < this.minSize.width && (i = this.minSize.width, s = i / this.aspectRatio), s < this.minSize.height && (s = this.minSize.height, i = s * this.aspectRatio), (r = this.maxSize) != null && r.width && i > this.maxSize.width && (i = this.maxSize.width, s = i / this.aspectRatio), (o = this.maxSize) != null && o.height && s > this.maxSize.height && (s = this.maxSize.height, i = s * this.aspectRatio), { width: i, height: s };
  }
  /**
   * Adjusts dimensions to maintain the original aspect ratio.
   *
   * For horizontal handles (left/right), uses width as the primary dimension
   * and calculates height from it. For vertical handles (top/bottom), uses
   * height as primary and calculates width. For corner handles, uses width
   * as the primary dimension.
   *
   * @param width - The new width
   * @param height - The new height
   * @param direction - The active resize direction
   * @returns Dimensions adjusted to preserve aspect ratio
   */
  applyAspectRatio(e, n, t) {
    const a = t === "left" || t === "right", l = t === "top" || t === "bottom";
    return a ? {
      width: e,
      height: e / this.aspectRatio
    } : l ? {
      width: n * this.aspectRatio,
      height: n
    } : {
      width: e,
      height: e / this.aspectRatio
    };
  }
};
function WE(e, n) {
  const { selection: t } = e, { $from: a } = t;
  if (t instanceof Xe) {
    const r = a.index();
    return a.parent.canReplaceWith(r, r + 1, n);
  }
  let l = a.depth;
  for (; l >= 0; ) {
    const r = a.index(l);
    if (a.node(l).contentMatchAt(r).matchType(n))
      return !0;
    l -= 1;
  }
  return !1;
}
function Zl(e, n) {
  const t = e.getAttribute("style");
  if (!t)
    return null;
  const a = t.split(";").map((r) => r.trim()).filter(Boolean), l = n.toLowerCase();
  for (let r = a.length - 1; r >= 0; r -= 1) {
    const o = a[r], i = o.indexOf(":");
    if (i === -1)
      continue;
    if (o.slice(0, i).trim().toLowerCase() === l)
      return o.slice(i + 1).trim();
  }
  return null;
}
var qE = {};
sc(qE, {
  createAtomBlockMarkdownSpec: () => UE,
  createBlockMarkdownSpec: () => GE,
  createInlineMarkdownSpec: () => JE,
  parseAttributes: () => gc,
  parseIndentedBlocks: () => Xd,
  renderNestedMarkdownContent: () => mc,
  serializeAttributes: () => pc
});
function gc(e) {
  if (!(e != null && e.trim()))
    return {};
  const n = {}, t = [], a = e.replace(/["']([^"']*)["']/g, (d) => (t.push(d), `__QUOTED_${t.length - 1}__`)), l = a.match(/(?:^|\s)\.([a-zA-Z][\w-]*)/g);
  if (l) {
    const d = l.map((u) => u.trim().slice(1));
    n.class = d.join(" ");
  }
  const r = a.match(/(?:^|\s)#([a-zA-Z][\w-]*)/);
  r && (n.id = r[1]);
  const o = /([a-zA-Z][\w-]*)\s*=\s*(__QUOTED_\d+__)/g;
  Array.from(a.matchAll(o)).forEach(([, d, u]) => {
    var f;
    const b = parseInt(((f = u.match(/__QUOTED_(\d+)__/)) == null ? void 0 : f[1]) || "0", 10), h = t[b];
    h && (n[d] = h.slice(1, -1));
  });
  const s = a.replace(/(?:^|\s)\.([a-zA-Z][\w-]*)/g, "").replace(/(?:^|\s)#([a-zA-Z][\w-]*)/g, "").replace(/([a-zA-Z][\w-]*)\s*=\s*__QUOTED_\d+__/g, "").trim();
  return s && s.split(/\s+/).filter(Boolean).forEach((u) => {
    u.match(/^[a-zA-Z][\w-]*$/) && (n[u] = !0);
  }), n;
}
function pc(e) {
  if (!e || Object.keys(e).length === 0)
    return "";
  const n = [];
  return e.class && String(e.class).split(/\s+/).filter(Boolean).forEach((a) => n.push(`.${a}`)), e.id && n.push(`#${e.id}`), Object.entries(e).forEach(([t, a]) => {
    t === "class" || t === "id" || (a === !0 ? n.push(t) : a !== !1 && a != null && n.push(`${t}="${String(a)}"`));
  }), n.join(" ");
}
function UE(e) {
  const {
    nodeName: n,
    name: t,
    parseAttributes: a = gc,
    serializeAttributes: l = pc,
    defaultAttributes: r = {},
    requiredAttributes: o = [],
    allowedAttributes: i
  } = e, s = t || n, d = (u) => {
    if (!i)
      return u;
    const f = {};
    return i.forEach((b) => {
      b in u && (f[b] = u[b]);
    }), f;
  };
  return {
    parseMarkdown: (u, f) => {
      const b = { ...r, ...u.attributes };
      return f.createNode(n, b, []);
    },
    markdownTokenizer: {
      name: n,
      level: "block",
      start(u) {
        var f;
        const b = new RegExp(`^:::${s}(?:\\s|$)`, "m"), h = (f = u.match(b)) == null ? void 0 : f.index;
        return h !== void 0 ? h : -1;
      },
      tokenize(u, f, b) {
        const h = new RegExp(`^:::${s}(?:\\s+\\{([^}]*)\\})?\\s*:::(?:\\n|$)`), m = u.match(h);
        if (!m)
          return;
        const x = m[1] || "", y = a(x);
        if (!o.find((S) => !(S in y)))
          return {
            type: n,
            raw: m[0],
            attributes: y
          };
      }
    },
    renderMarkdown: (u) => {
      const f = d(u.attrs || {}), b = l(f), h = b ? ` {${b}}` : "";
      return `:::${s}${h} :::`;
    }
  };
}
function GE(e) {
  const {
    nodeName: n,
    name: t,
    getContent: a,
    parseAttributes: l = gc,
    serializeAttributes: r = pc,
    defaultAttributes: o = {},
    content: i = "block",
    allowedAttributes: s
  } = e, d = t || n, u = (f) => {
    if (!s)
      return f;
    const b = {};
    return s.forEach((h) => {
      h in f && (b[h] = f[h]);
    }), b;
  };
  return {
    parseMarkdown: (f, b) => {
      let h;
      if (a) {
        const x = a(f);
        h = typeof x == "string" ? [{ type: "text", text: x }] : x;
      } else i === "block" ? h = b.parseChildren(f.tokens || []) : h = b.parseInline(f.tokens || []);
      const m = { ...o, ...f.attributes };
      return b.createNode(n, m, h);
    },
    markdownTokenizer: {
      name: n,
      level: "block",
      start(f) {
        var b;
        const h = new RegExp(`^:::${d}`, "m"), m = (b = f.match(h)) == null ? void 0 : b.index;
        return m !== void 0 ? m : -1;
      },
      tokenize(f, b, h) {
        var m;
        const x = new RegExp(`^:::${d}(?:\\s+\\{([^}]*)\\})?\\s*\\n`), y = f.match(x);
        if (!y)
          return;
        const [w, S = ""] = y, $ = l(S);
        let T = 1;
        const L = w.length;
        let A = "";
        const R = /^:::([\w-]*)(\s.*)?/gm, z = f.slice(L);
        for (R.lastIndex = 0; ; ) {
          const D = R.exec(z);
          if (D === null)
            break;
          const V = D.index, Y = D[1];
          if (!((m = D[2]) != null && m.endsWith(":::"))) {
            if (Y)
              T += 1;
            else if (T -= 1, T === 0) {
              const _ = z.slice(0, V);
              A = _.trim();
              const j = f.slice(0, L + V + D[0].length);
              let M = [];
              if (A)
                if (i === "block")
                  for (M = h.blockTokens(_), M.forEach((W) => {
                    W.text && (!W.tokens || W.tokens.length === 0) && (W.tokens = h.inlineTokens(W.text));
                  }); M.length > 0; ) {
                    const W = M[M.length - 1];
                    if (W.type === "paragraph" && (!W.text || W.text.trim() === ""))
                      M.pop();
                    else
                      break;
                  }
                else
                  M = h.inlineTokens(A);
              return {
                type: n,
                raw: j,
                attributes: $,
                content: A,
                tokens: M
              };
            }
          }
        }
      }
    },
    renderMarkdown: (f, b) => {
      const h = u(f.attrs || {}), m = r(h), x = m ? ` {${m}}` : "", y = b.renderChildren(f.content || [], `

`);
      return `:::${d}${x}

${y}

:::`;
    }
  };
}
function KE(e) {
  if (!e.trim())
    return {};
  const n = {}, t = /(\w+)=(?:"([^"]*)"|'([^']*)')/g;
  let a = t.exec(e);
  for (; a !== null; ) {
    const [, l, r, o] = a;
    n[l] = r || o, a = t.exec(e);
  }
  return n;
}
function YE(e) {
  return Object.entries(e).filter(([, n]) => n != null).map(([n, t]) => `${n}="${t}"`).join(" ");
}
function JE(e) {
  const {
    nodeName: n,
    name: t,
    getContent: a,
    parseAttributes: l = KE,
    serializeAttributes: r = YE,
    defaultAttributes: o = {},
    selfClosing: i = !1,
    allowedAttributes: s
  } = e, d = t || n, u = (b) => {
    if (!s)
      return b;
    const h = {};
    return s.forEach((m) => {
      const x = typeof m == "string" ? m : m.name, y = typeof m == "string" ? void 0 : m.skipIfDefault;
      if (x in b) {
        const w = b[x];
        if (y !== void 0 && w === y)
          return;
        h[x] = w;
      }
    }), h;
  }, f = d.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  return {
    parseMarkdown: (b, h) => {
      const m = { ...o, ...b.attributes };
      if (i)
        return h.createNode(n, m);
      const x = a ? a(b) : b.content || "";
      return x ? h.createNode(n, m, [h.createTextNode(x)]) : h.createNode(n, m, []);
    },
    markdownTokenizer: {
      name: n,
      level: "inline",
      start(b) {
        const h = i ? new RegExp(`\\[${f}\\s*[^\\]]*\\]`) : new RegExp(`\\[${f}\\s*[^\\]]*\\][\\s\\S]*?\\[\\/${f}\\]`), m = b.match(h), x = m == null ? void 0 : m.index;
        return x !== void 0 ? x : -1;
      },
      tokenize(b, h, m) {
        const x = i ? new RegExp(`^\\[${f}\\s*([^\\]]*)\\]`) : new RegExp(`^\\[${f}\\s*([^\\]]*)\\]([\\s\\S]*?)\\[\\/${f}\\]`), y = b.match(x);
        if (!y)
          return;
        let w = "", S = "";
        if (i) {
          const [, T] = y;
          S = T;
        } else {
          const [, T, L] = y;
          S = T, w = L || "";
        }
        const $ = l(S.trim());
        return {
          type: n,
          raw: y[0],
          content: w.trim(),
          attributes: $
        };
      }
    },
    renderMarkdown: (b) => {
      let h = "";
      a ? h = a(b) : b.content && b.content.length > 0 && (h = b.content.filter((w) => w.type === "text").map((w) => w.text).join(""));
      const m = u(b.attrs || {}), x = r(m), y = x ? ` ${x}` : "";
      return i ? `[${d}${y}]` : `[${d}${y}]${h}[/${d}]`;
    }
  };
}
function Xd(e, n, t) {
  var a, l, r, o;
  const i = e.split(`
`), s = [];
  let d = "", u = 0;
  const f = n.baseIndentSize || 2;
  for (; u < i.length; ) {
    const b = i[u], h = b.match(n.itemPattern);
    if (!h) {
      if (s.length > 0)
        break;
      if (b.trim() === "") {
        u += 1, d = `${d}${b}
`;
        continue;
      } else
        return;
    }
    const m = n.extractItemData(h), { indentLevel: x, mainContent: y } = m;
    d = `${d}${b}
`;
    const w = [y];
    for (u += 1; u < i.length; ) {
      const L = i[u];
      if (L.trim() === "") {
        const R = i.slice(u + 1).findIndex((V) => V.trim() !== "");
        if (R === -1)
          break;
        if ((((l = (a = i[u + 1 + R].match(/^(\s*)/)) == null ? void 0 : a[1]) == null ? void 0 : l.length) || 0) > x) {
          w.push(L), d = `${d}${L}
`, u += 1;
          continue;
        } else
          break;
      }
      if ((((o = (r = L.match(/^(\s*)/)) == null ? void 0 : r[1]) == null ? void 0 : o.length) || 0) > x)
        w.push(L), d = `${d}${L}
`, u += 1;
      else
        break;
    }
    let S;
    const $ = w.slice(1);
    if ($.length > 0) {
      const L = $.map((A) => A.slice(x + f)).join(`
`);
      L.trim() && (n.customNestedParser ? S = n.customNestedParser(L) : S = t.blockTokens(L));
    }
    const T = n.createToken(m, S);
    s.push(T);
  }
  if (s.length !== 0)
    return {
      items: s,
      raw: d
    };
}
function mc(e, n, t, a) {
  if (!e || !Array.isArray(e.content))
    return "";
  const l = typeof t == "function" ? t(a) : t, [r, ...o] = e.content, i = n.renderChildren([r]);
  let s = `${l}${i}`;
  return o && o.length > 0 && o.forEach((d, u) => {
    var f, b;
    const h = (b = (f = n.renderChild) == null ? void 0 : f.call(n, d, u + 1)) != null ? b : n.renderChildren([d]);
    if (h != null) {
      const m = h.split(`
`).map((x) => x ? n.indent(x) : n.indent("")).join(`
`);
      s += d.type === "paragraph" ? `

${m}` : `
${m}`;
    }
  }), s;
}
function ZE(e, n, t = {}) {
  const { state: a } = n, { doc: l, tr: r } = a, o = e;
  l.descendants((i, s) => {
    const d = r.mapping.map(s), u = r.mapping.map(s) + i.nodeSize;
    let f = null;
    if (i.marks.forEach((h) => {
      if (h !== o)
        return !1;
      f = h;
    }), !f)
      return;
    let b = !1;
    if (Object.keys(t).forEach((h) => {
      t[h] !== f.attrs[h] && (b = !0);
    }), b) {
      const h = e.type.create({
        ...e.attrs,
        ...t
      });
      r.removeMark(d, u, e.type), r.addMark(d, u, h);
    }
  }), r.docChanged && n.view.dispatch(r);
}
var cn = class Vm extends bc {
  constructor() {
    super(...arguments), this.type = "node";
  }
  /**
   * Create a new Node instance
   * @param config - Node configuration object or a function that returns a configuration object
   */
  static create(n = {}) {
    const t = typeof n == "function" ? n() : n;
    return new Vm(t);
  }
  configure(n) {
    return super.configure(n);
  }
  extend(n) {
    const t = typeof n == "function" ? n() : n;
    return super.extend(t);
  }
};
function Da(e) {
  return new RE({
    find: e.find,
    handler: ({ state: n, range: t, match: a, pasteEvent: l }) => {
      const r = ht(e.getAttributes, void 0, a, l);
      if (r === !1 || r === null)
        return null;
      const { tr: o } = n, i = a[a.length - 1], s = a[0];
      let d = t.to;
      if (i) {
        const u = s.search(/\S/), f = t.from + s.indexOf(i), b = f + i.length;
        if (hc(t.from, t.to, n.doc).filter((x) => x.mark.type.excluded.find((w) => w === e.type && w !== x.mark.type)).filter((x) => x.to > f).length)
          return null;
        b < t.to && o.delete(b, t.to), f > t.from && o.delete(t.from + u, f), d = t.from + u + i.length, o.addMark(t.from + u, d, e.type.create(r || {})), a.index !== void 0 && a.input !== void 0 && a.index + a[0].length >= a.input.length || o.removeStoredMark(e.type);
      }
    }
  });
}
function Lh(e) {
  return sx((n, t) => ({
    get() {
      return n(), e;
    },
    set(a) {
      e = a, requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          t();
        });
      });
    }
  }));
}
var XE = class extends NE {
  constructor(e = {}) {
    return super(e), this.contentComponent = null, this.appContext = null, this.reactiveState = Lh(this.view.state), this.reactiveExtensionStorage = Lh(this.extensionStorage), this.on("beforeTransaction", ({ nextState: n }) => {
      this.reactiveState.value = n, this.reactiveExtensionStorage.value = this.extensionStorage;
    }), ix(this);
  }
  get state() {
    return this.reactiveState ? this.reactiveState.value : this.view.state;
  }
  get storage() {
    return this.reactiveExtensionStorage ? this.reactiveExtensionStorage.value : super.storage;
  }
  /**
   * Register a ProseMirror plugin.
   */
  registerPlugin(e, n) {
    const t = super.registerPlugin(e, n);
    return this.reactiveState && (this.reactiveState.value = t), t;
  }
  /**
   * Unregister a ProseMirror plugin.
   */
  unregisterPlugin(e) {
    const n = super.unregisterPlugin(e);
    return this.reactiveState && n && (this.reactiveState.value = n), n;
  }
}, QE = ye({
  name: "EditorContent",
  props: {
    editor: {
      default: null,
      type: Object
    }
  },
  setup(e) {
    const n = E(), t = wu();
    return Db(() => {
      const a = e.editor;
      a && a.options.element && n.value && qe(() => {
        var l;
        if (!n.value || !((l = a.view.dom) != null && l.parentNode))
          return;
        const r = I(n.value);
        n.value.append(...a.view.dom.parentNode.childNodes), a.contentComponent = t.ctx._, t && (a.appContext = {
          ...t.appContext,
          // Vue internally uses prototype chain to forward/shadow injects across the entire component chain
          // so don't use object spread operator or 'Object.assign' and just set `provides` as is on editor's appContext
          // @ts-expect-error forward instance's 'provides' into appContext
          provides: t.provides
        }), a.setOptions({
          element: r
        }), a.createNodeViews();
      });
    }), gt(() => {
      const a = e.editor;
      a && (a.contentComponent = null, a.appContext = null);
    }), { rootEl: n };
  },
  render() {
    return Gn("div", {
      ref: (e) => {
        this.rootEl = e;
      }
    });
  }
});
ye({
  name: "NodeViewContent",
  props: {
    as: {
      type: String,
      default: "div"
    }
  },
  render() {
    return Gn(this.as, {
      style: {
        whiteSpace: "pre-wrap"
      },
      "data-node-view-content": ""
    });
  }
});
ye({
  name: "NodeViewWrapper",
  props: {
    as: {
      type: String,
      default: "div"
    }
  },
  inject: ["onDragStart", "decorationClasses"],
  render() {
    var e, n;
    return Gn(
      this.as,
      {
        // @ts-ignore
        class: this.decorationClasses,
        style: {
          whiteSpace: "normal"
        },
        "data-node-view-wrapper": "",
        // @ts-ignore (https://github.com/vuejs/vue-next/issues/3031)
        onDragstart: this.onDragStart
      },
      (n = (e = this.$slots).default) == null ? void 0 : n.call(e)
    );
  }
});
var _E = (e = {}) => {
  const n = Qr();
  return ot(() => {
    n.value = new XE(e);
  }), gt(() => {
    var t;
    (t = n.value) == null || t.destroy();
  }), n;
};
ye({
  name: "MarkViewContent",
  props: {
    as: {
      type: String,
      default: "span"
    }
  },
  render() {
    return Gn(this.as, {
      style: {
        whiteSpace: "inherit"
      },
      "data-mark-view-content": ""
    });
  }
});
var gi = (e, n) => {
  if (e === "slot")
    return 0;
  if (e instanceof Function)
    return e(n);
  const { children: t, ...a } = n ?? {};
  if (e === "svg")
    throw new Error("SVG elements are not supported in the JSX syntax, use the array syntax instead");
  return [e, a, t];
}, eA = /^\s*>\s$/, tA = cn.create({
  name: "blockquote",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  content: "block+",
  group: "block",
  defining: !0,
  parseHTML() {
    return [{ tag: "blockquote" }];
  },
  renderHTML({ HTMLAttributes: e }) {
    return /* @__PURE__ */ gi("blockquote", { ...It(this.options.HTMLAttributes, e), children: /* @__PURE__ */ gi("slot", {}) });
  },
  parseMarkdown: (e, n) => {
    var t;
    const a = (t = n.parseBlockChildren) != null ? t : n.parseChildren;
    return n.createNode("blockquote", void 0, a(e.tokens || []));
  },
  renderMarkdown: (e, n) => {
    if (!e.content)
      return "";
    const t = ">", a = [];
    return e.content.forEach((l, r) => {
      var o, i;
      const u = ((i = (o = n.renderChild) == null ? void 0 : o.call(n, l, r)) != null ? i : n.renderChildren([l])).split(`
`).map((f) => f.trim() === "" ? t : `${t} ${f}`);
      a.push(u.join(`
`));
    }), a.join(`
${t}
`);
  },
  addCommands() {
    return {
      setBlockquote: () => ({ commands: e }) => e.wrapIn(this.name),
      toggleBlockquote: () => ({ commands: e }) => e.toggleWrap(this.name),
      unsetBlockquote: () => ({ commands: e }) => e.lift(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-b": () => this.editor.commands.toggleBlockquote()
    };
  },
  addInputRules() {
    return [
      ql({
        find: eA,
        type: this.type
      })
    ];
  }
}), nA = /(?:^|\s)(\*\*(?!\s+\*\*)((?:[^*]+))\*\*(?!\s+\*\*))$/, aA = /(?:^|\s)(\*\*(?!\s+\*\*)((?:[^*]+))\*\*(?!\s+\*\*))/g, lA = /(?:^|\s)(__(?!\s+__)((?:[^_]+))__(?!\s+__))$/, rA = /(?:^|\s)(__(?!\s+__)((?:[^_]+))__(?!\s+__))/g, oA = fa.create({
  name: "bold",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  parseHTML() {
    return [
      {
        tag: "strong"
      },
      {
        tag: "b",
        getAttrs: (e) => e.style.fontWeight !== "normal" && null
      },
      {
        style: "font-weight=400",
        clearMark: (e) => e.type.name === this.name
      },
      {
        style: "font-weight",
        getAttrs: (e) => /^(bold(er)?|[5-9]\d{2,})$/.test(e) && null
      }
    ];
  },
  renderHTML({ HTMLAttributes: e }) {
    return /* @__PURE__ */ gi("strong", { ...It(this.options.HTMLAttributes, e), children: /* @__PURE__ */ gi("slot", {}) });
  },
  markdownTokenName: "strong",
  parseMarkdown: (e, n) => n.applyMark("bold", n.parseInline(e.tokens || [])),
  markdownOptions: {
    htmlReopen: {
      open: "<strong>",
      close: "</strong>"
    }
  },
  renderMarkdown: (e, n) => `**${n.renderChildren(e)}**`,
  addCommands() {
    return {
      setBold: () => ({ commands: e }) => e.setMark(this.name),
      toggleBold: () => ({ commands: e }) => e.toggleMark(this.name),
      unsetBold: () => ({ commands: e }) => e.unsetMark(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-b": () => this.editor.commands.toggleBold(),
      "Mod-B": () => this.editor.commands.toggleBold()
    };
  },
  addInputRules() {
    return [
      hl({
        find: nA,
        type: this.type
      }),
      hl({
        find: lA,
        type: this.type
      })
    ];
  },
  addPasteRules() {
    return [
      Da({
        find: aA,
        type: this.type
      }),
      Da({
        find: rA,
        type: this.type
      })
    ];
  }
}), iA = /(^|[^`])`([^`]+)`(?!`)$/, sA = /(^|[^`])`([^`]+)`(?!`)/g, dA = fa.create({
  name: "code",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  excludes: "_",
  code: !0,
  exitable: !0,
  parseHTML() {
    return [{ tag: "code" }];
  },
  renderHTML({ HTMLAttributes: e }) {
    return ["code", It(this.options.HTMLAttributes, e), 0];
  },
  markdownTokenName: "codespan",
  parseMarkdown: (e, n) => n.applyMark("code", [{ type: "text", text: e.text || "" }]),
  renderMarkdown: (e, n) => e.content ? `\`${n.renderChildren(e.content)}\`` : "",
  addCommands() {
    return {
      setCode: () => ({ commands: e }) => e.setMark(this.name),
      toggleCode: () => ({ commands: e }) => e.toggleMark(this.name),
      unsetCode: () => ({ commands: e }) => e.unsetMark(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-e": () => this.editor.commands.toggleCode()
    };
  },
  addInputRules() {
    return [
      hl({
        find: iA,
        type: this.type
      })
    ];
  },
  addPasteRules() {
    return [
      Da({
        find: sA,
        type: this.type
      })
    ];
  }
}), Ys = 4, uA = /^```([a-z]+)?[\s\n]$/, cA = /^~~~([a-z]+)?[\s\n]$/, fA = cn.create({
  name: "codeBlock",
  addOptions() {
    return {
      languageClassPrefix: "language-",
      exitOnTripleEnter: !0,
      exitOnArrowDown: !0,
      defaultLanguage: null,
      enableTabIndentation: !1,
      tabSize: Ys,
      HTMLAttributes: {}
    };
  },
  content: "text*",
  marks: "",
  group: "block",
  code: !0,
  defining: !0,
  addAttributes() {
    return {
      language: {
        default: this.options.defaultLanguage,
        parseHTML: (e) => {
          var n;
          const { languageClassPrefix: t } = this.options;
          if (!t)
            return null;
          const r = [...((n = e.firstElementChild) == null ? void 0 : n.classList) || []].filter((o) => o.startsWith(t)).map((o) => o.replace(t, ""))[0];
          return r || null;
        },
        rendered: !1
      }
    };
  },
  parseHTML() {
    return [
      {
        tag: "pre",
        preserveWhitespace: "full"
      }
    ];
  },
  renderHTML({ node: e, HTMLAttributes: n }) {
    return [
      "pre",
      It(this.options.HTMLAttributes, n),
      [
        "code",
        {
          class: e.attrs.language ? this.options.languageClassPrefix + e.attrs.language : null
        },
        0
      ]
    ];
  },
  markdownTokenName: "code",
  parseMarkdown: (e, n) => {
    var t, a;
    return ((t = e.raw) == null ? void 0 : t.startsWith("```")) === !1 && ((a = e.raw) == null ? void 0 : a.startsWith("~~~")) === !1 && e.codeBlockStyle !== "indented" ? [] : n.createNode(
      "codeBlock",
      { language: e.lang || null },
      e.text ? [n.createTextNode(e.text)] : []
    );
  },
  renderMarkdown: (e, n) => {
    var t;
    let a = "";
    const l = ((t = e.attrs) == null ? void 0 : t.language) || "";
    return e.content ? a = [`\`\`\`${l}`, n.renderChildren(e.content), "```"].join(`
`) : a = `\`\`\`${l}

\`\`\``, a;
  },
  addCommands() {
    return {
      setCodeBlock: (e) => ({ commands: n }) => n.setNode(this.name, e),
      toggleCodeBlock: (e) => ({ commands: n }) => n.toggleNode(this.name, "paragraph", e)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Alt-c": () => this.editor.commands.toggleCodeBlock(),
      // remove code block when at start of document or code block is empty
      Backspace: () => {
        const { empty: e, $anchor: n } = this.editor.state.selection, t = n.pos === 1;
        return !e || n.parent.type.name !== this.name ? !1 : t || !n.parent.textContent.length ? this.editor.commands.clearNodes() : !1;
      },
      // handle tab indentation
      Tab: ({ editor: e }) => {
        var n;
        if (!this.options.enableTabIndentation)
          return !1;
        const t = (n = this.options.tabSize) != null ? n : Ys, { state: a } = e, { selection: l } = a, { $from: r, empty: o } = l;
        if (r.parent.type !== this.type)
          return !1;
        const i = " ".repeat(t);
        return o ? e.commands.insertContent(i) : e.commands.command(({ tr: s }) => {
          const { from: d, to: u } = l, h = a.doc.textBetween(d, u, `
`, `
`).split(`
`).map((m) => i + m).join(`
`);
          return s.replaceWith(d, u, a.schema.text(h)), !0;
        });
      },
      // handle shift+tab reverse indentation
      "Shift-Tab": ({ editor: e }) => {
        var n;
        if (!this.options.enableTabIndentation)
          return !1;
        const t = (n = this.options.tabSize) != null ? n : Ys, { state: a } = e, { selection: l } = a, { $from: r, empty: o } = l;
        return r.parent.type !== this.type ? !1 : o ? e.commands.command(({ tr: i }) => {
          var s;
          const { pos: d } = r, u = r.start(), f = r.end(), h = a.doc.textBetween(u, f, `
`, `
`).split(`
`);
          let m = 0, x = 0;
          const y = d - u;
          for (let A = 0; A < h.length; A += 1) {
            if (x + h[A].length >= y) {
              m = A;
              break;
            }
            x += h[A].length + 1;
          }
          const S = ((s = h[m].match(/^ */)) == null ? void 0 : s[0]) || "", $ = Math.min(S.length, t);
          if ($ === 0)
            return !0;
          let T = u;
          for (let A = 0; A < m; A += 1)
            T += h[A].length + 1;
          return i.delete(T, T + $), d - T <= $ && i.setSelection(nt.create(i.doc, T)), !0;
        }) : e.commands.command(({ tr: i }) => {
          const { from: s, to: d } = l, b = a.doc.textBetween(s, d, `
`, `
`).split(`
`).map((h) => {
            var m;
            const x = ((m = h.match(/^ */)) == null ? void 0 : m[0]) || "", y = Math.min(x.length, t);
            return h.slice(y);
          }).join(`
`);
          return i.replaceWith(s, d, a.schema.text(b)), !0;
        });
      },
      // exit node on triple enter
      Enter: ({ editor: e }) => {
        if (!this.options.exitOnTripleEnter)
          return !1;
        const { state: n } = e, { selection: t } = n, { $from: a, empty: l } = t;
        if (!l || a.parent.type !== this.type)
          return !1;
        const r = a.parentOffset === a.parent.nodeSize - 2, o = a.parent.textContent.endsWith(`

`);
        return !r || !o ? !1 : e.chain().command(({ tr: i }) => (i.delete(a.pos - 2, a.pos), !0)).exitCode().run();
      },
      // exit node on arrow down
      ArrowDown: ({ editor: e }) => {
        if (!this.options.exitOnArrowDown)
          return !1;
        const { state: n } = e, { selection: t, doc: a } = n, { $from: l, empty: r } = t;
        if (!r || l.parent.type !== this.type || !(l.parentOffset === l.parent.nodeSize - 2))
          return !1;
        const i = l.after();
        return i === void 0 ? !1 : a.nodeAt(i) ? e.commands.command(({ tr: d }) => (d.setSelection(rt.near(a.resolve(i))), !0)) : e.commands.exitCode();
      }
    };
  },
  addInputRules() {
    return [
      Zd({
        find: uA,
        type: this.type,
        getAttributes: (e) => ({
          language: e[1]
        })
      }),
      Zd({
        find: cA,
        type: this.type,
        getAttributes: (e) => ({
          language: e[1]
        })
      })
    ];
  },
  addProseMirrorPlugins() {
    return [
      // this plugin creates a code block for pasted content from VS Code
      // we can also detect the copied code language
      new Tt({
        key: new Ot("codeBlockVSCodeHandler"),
        props: {
          handlePaste: (e, n) => {
            if (!n.clipboardData || this.editor.isActive(this.type.name))
              return !1;
            const t = n.clipboardData.getData("text/plain"), a = n.clipboardData.getData("vscode-editor-data"), l = a ? JSON.parse(a) : void 0, r = l == null ? void 0 : l.mode;
            if (!t || !r)
              return !1;
            const { tr: o, schema: i } = e.state, s = i.text(t.replace(/\r\n?/g, `
`));
            return o.replaceSelectionWith(this.type.create({ language: r }, s)), o.selection.$from.parent.type !== this.type && o.setSelection(nt.near(o.doc.resolve(Math.max(0, o.selection.from - 2)))), o.setMeta("paste", !0), e.dispatch(o), !0;
          }
        }
      })
    ];
  }
}), hA = cn.create({
  name: "doc",
  topNode: !0,
  content: "block+",
  renderMarkdown: (e, n) => e.content ? n.renderChildren(e.content, `

`) : ""
}), bA = cn.create({
  name: "hardBreak",
  markdownTokenName: "br",
  addOptions() {
    return {
      keepMarks: !0,
      HTMLAttributes: {}
    };
  },
  inline: !0,
  group: "inline",
  selectable: !1,
  linebreakReplacement: !0,
  parseHTML() {
    return [{ tag: "br" }];
  },
  renderHTML({ HTMLAttributes: e }) {
    return ["br", It(this.options.HTMLAttributes, e)];
  },
  renderText() {
    return `
`;
  },
  renderMarkdown: () => `  
`,
  parseMarkdown: () => ({
    type: "hardBreak"
  }),
  addCommands() {
    return {
      setHardBreak: () => ({ commands: e, chain: n, state: t, editor: a }) => e.first([
        () => e.exitCode(),
        () => e.command(() => {
          const { selection: l, storedMarks: r } = t;
          if (l.$from.parent.type.spec.isolating)
            return !1;
          const { keepMarks: o } = this.options, { splittableMarks: i } = a.extensionManager, s = r || l.$to.parentOffset && l.$from.marks();
          return n().insertContent({ type: this.name }).command(({ tr: d, dispatch: u }) => {
            if (u && s && o) {
              const f = s.filter((b) => i.includes(b.type.name));
              d.ensureMarks(f);
            }
            return !0;
          }).run();
        })
      ])
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Enter": () => this.editor.commands.setHardBreak(),
      "Shift-Enter": () => this.editor.commands.setHardBreak()
    };
  }
}), gA = cn.create({
  name: "heading",
  addOptions() {
    return {
      levels: [1, 2, 3, 4, 5, 6],
      HTMLAttributes: {}
    };
  },
  content: "inline*",
  group: "block",
  defining: !0,
  addAttributes() {
    return {
      level: {
        default: 1,
        rendered: !1
      }
    };
  },
  parseHTML() {
    return this.options.levels.map((e) => ({
      tag: `h${e}`,
      attrs: { level: e }
    }));
  },
  renderHTML({ node: e, HTMLAttributes: n }) {
    return [`h${this.options.levels.includes(e.attrs.level) ? e.attrs.level : this.options.levels[0]}`, It(this.options.HTMLAttributes, n), 0];
  },
  parseMarkdown: (e, n) => n.createNode("heading", { level: e.depth || 1 }, n.parseInline(e.tokens || [])),
  renderMarkdown: (e, n) => {
    var t;
    const a = (t = e.attrs) != null && t.level ? parseInt(e.attrs.level, 10) : 1, l = "#".repeat(a);
    return e.content ? `${l} ${n.renderChildren(e.content)}` : "";
  },
  addCommands() {
    return {
      setHeading: (e) => ({ commands: n }) => this.options.levels.includes(e.level) ? n.setNode(this.name, e) : !1,
      toggleHeading: (e) => ({ commands: n }) => this.options.levels.includes(e.level) ? n.toggleNode(this.name, "paragraph", e) : !1
    };
  },
  addKeyboardShortcuts() {
    return this.options.levels.reduce(
      (e, n) => ({
        ...e,
        [`Mod-Alt-${n}`]: () => this.editor.commands.toggleHeading({ level: n })
      }),
      {}
    );
  },
  addInputRules() {
    return this.options.levels.map((e) => Zd({
      find: new RegExp(`^(#{${Math.min(...this.options.levels)},${e}})\\s$`),
      type: this.type,
      getAttributes: {
        level: e
      }
    }));
  }
}), pA = cn.create({
  name: "horizontalRule",
  addOptions() {
    return {
      HTMLAttributes: {},
      nextNodeType: "paragraph"
    };
  },
  group: "block",
  parseHTML() {
    return [{ tag: "hr" }];
  },
  renderHTML({ HTMLAttributes: e }) {
    return ["hr", It(this.options.HTMLAttributes, e)];
  },
  markdownTokenName: "hr",
  parseMarkdown: (e, n) => n.createNode("horizontalRule"),
  renderMarkdown: () => "---",
  addCommands() {
    return {
      setHorizontalRule: () => ({ chain: e, state: n }) => {
        if (!WE(n, n.schema.nodes[this.name]))
          return !1;
        const { selection: t } = n, { $to: a } = t, l = e();
        return km(t) ? l.insertContentAt(a.pos, {
          type: this.name
        }) : l.insertContent({ type: this.name }), l.command(({ state: r, tr: o, dispatch: i }) => {
          if (i) {
            const { $to: s } = o.selection, d = s.end();
            if (s.nodeAfter)
              s.nodeAfter.isTextblock ? o.setSelection(nt.create(o.doc, s.pos + 1)) : s.nodeAfter.isBlock ? o.setSelection(Xe.create(o.doc, s.pos)) : o.setSelection(nt.create(o.doc, s.pos));
            else {
              const u = r.schema.nodes[this.options.nextNodeType] || s.parent.type.contentMatch.defaultType, f = u == null ? void 0 : u.create();
              f && (o.insert(d, f), o.setSelection(nt.create(o.doc, d + 1)));
            }
            o.scrollIntoView();
          }
          return !0;
        }).run();
      }
    };
  },
  addInputRules() {
    return [
      Fm({
        find: /^(?:---|—-|___\s|\*\*\*\s)$/,
        type: this.type
      })
    ];
  }
}), mA = /(?:^|\s)(\*(?!\s+\*)((?:[^*]+))\*(?!\s+\*))$/, vA = /(?:^|\s)(\*(?!\s+\*)((?:[^*]+))\*(?!\s+\*))/g, xA = /(?:^|\s)(_(?!\s+_)((?:[^_]+))_(?!\s+_))$/, yA = /(?:^|\s)(_(?!\s+_)((?:[^_]+))_(?!\s+_))/g, kA = fa.create({
  name: "italic",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  parseHTML() {
    return [
      {
        tag: "em"
      },
      {
        tag: "i",
        getAttrs: (e) => e.style.fontStyle !== "normal" && null
      },
      {
        style: "font-style=normal",
        clearMark: (e) => e.type.name === this.name
      },
      {
        style: "font-style=italic"
      }
    ];
  },
  renderHTML({ HTMLAttributes: e }) {
    return ["em", It(this.options.HTMLAttributes, e), 0];
  },
  addCommands() {
    return {
      setItalic: () => ({ commands: e }) => e.setMark(this.name),
      toggleItalic: () => ({ commands: e }) => e.toggleMark(this.name),
      unsetItalic: () => ({ commands: e }) => e.unsetMark(this.name)
    };
  },
  markdownTokenName: "em",
  parseMarkdown: (e, n) => n.applyMark("italic", n.parseInline(e.tokens || [])),
  markdownOptions: {
    htmlReopen: {
      open: "<em>",
      close: "</em>"
    }
  },
  renderMarkdown: (e, n) => `*${n.renderChildren(e)}*`,
  addKeyboardShortcuts() {
    return {
      "Mod-i": () => this.editor.commands.toggleItalic(),
      "Mod-I": () => this.editor.commands.toggleItalic()
    };
  },
  addInputRules() {
    return [
      hl({
        find: mA,
        type: this.type
      }),
      hl({
        find: xA,
        type: this.type
      })
    ];
  },
  addPasteRules() {
    return [
      Da({
        find: vA,
        type: this.type
      }),
      Da({
        find: yA,
        type: this.type
      })
    ];
  }
});
const wA = "aaa1rp3bb0ott3vie4c1le2ogado5udhabi7c0ademy5centure6ountant0s9o1tor4d0s1ult4e0g1ro2tna4f0l1rica5g0akhan5ency5i0g1rbus3force5tel5kdn3l0ibaba4pay4lfinanz6state5y2sace3tom5m0azon4ericanexpress7family11x2fam3ica3sterdam8nalytics7droid5quan4z2o0l2partments8p0le4q0uarelle8r0ab1mco4chi3my2pa2t0e3s0da2ia2sociates9t0hleta5torney7u0ction5di0ble3o3spost5thor3o0s4w0s2x0a2z0ure5ba0by2idu3namex4d1k2r0celona5laycard4s5efoot5gains6seball5ketball8uhaus5yern5b0c1t1va3cg1n2d1e0ats2uty4er2rlin4st0buy5t2f1g1h0arti5i0ble3d1ke2ng0o3o1z2j1lack0friday9ockbuster8g1omberg7ue3m0s1w2n0pparibas9o0ats3ehringer8fa2m1nd2o0k0ing5sch2tik2on4t1utique6x2r0adesco6idgestone9oadway5ker3ther5ussels7s1t1uild0ers6siness6y1zz3v1w1y1z0h3ca0b1fe2l0l1vinklein9m0era3p2non3petown5ital0one8r0avan4ds2e0er0s4s2sa1e1h1ino4t0ering5holic7ba1n1re3c1d1enter4o1rn3f0a1d2g1h0anel2nel4rity4se2t2eap3intai5ristmas6ome4urch5i0priani6rcle4sco3tadel4i0c2y3k1l0aims4eaning6ick2nic1que6othing5ud3ub0med6m1n1o0ach3des3ffee4llege4ogne5m0mbank4unity6pany2re3uter5sec4ndos3struction8ulting7tact3ractors9oking4l1p2rsica5untry4pon0s4rses6pa2r0edit0card4union9icket5own3s1uise0s6u0isinella9v1w1x1y0mru3ou3z2dad1nce3ta1e1ing3sun4y2clk3ds2e0al0er2s3gree4livery5l1oitte5ta3mocrat6ntal2ist5si0gn4v2hl2iamonds6et2gital5rect0ory7scount3ver5h2y2j1k1m1np2o0cs1tor4g1mains5t1wnload7rive4tv2ubai3pont4rban5vag2r2z2earth3t2c0o2deka3u0cation8e1g1mail3erck5nergy4gineer0ing9terprises10pson4quipment8r0icsson6ni3s0q1tate5t1u0rovision8s2vents5xchange6pert3osed4ress5traspace10fage2il1rwinds6th3mily4n0s2rm0ers5shion4t3edex3edback6rrari3ero6i0delity5o2lm2nal1nce1ial7re0stone6mdale6sh0ing5t0ness6j1k1lickr3ghts4r2orist4wers5y2m1o0o0d1tball6rd1ex2sale4um3undation8x2r0ee1senius7l1ogans4ntier7tr2ujitsu5n0d2rniture7tbol5yi3ga0l0lery3o1up4me0s3p1rden4y2b0iz3d0n2e0a1nt0ing5orge5f1g0ee3h1i0ft0s3ves2ing5l0ass3e1obal2o4m0ail3bh2o1x2n1odaddy5ld0point6f2odyear5g0le4p1t1v2p1q1r0ainger5phics5tis4een3ipe3ocery4up4s1t1u0cci3ge2ide2tars5ru3w1y2hair2mburg5ngout5us3bo2dfc0bank7ealth0care8lp1sinki6re1mes5iphop4samitsu7tachi5v2k0t2m1n1ockey4ldings5iday5medepot5goods5s0ense7nda3rse3spital5t0ing5t0els3mail5use3w2r1sbc3t1u0ghes5yatt3undai7ibm2cbc2e1u2d1e0ee3fm2kano4l1m0amat4db2mo0bilien9n0c1dustries8finiti5o2g1k1stitute6urance4e4t0ernational10uit4vestments10o1piranga7q1r0ish4s0maili5t0anbul7t0au2v3jaguar4va3cb2e0ep2tzt3welry6io2ll2m0p2nj2o0bs1urg4t1y2p0morgan6rs3uegos4niper7kaufen5ddi3e0rryhotels6properties14fh2g1h1i0a1ds2m1ndle4tchen5wi3m1n1oeln3matsu5sher5p0mg2n2r0d1ed3uokgroup8w1y0oto4z2la0caixa5mborghini8er3nd0rover6xess5salle5t0ino3robe5w0yer5b1c1ds2ease3clerc5frak4gal2o2xus4gbt3i0dl2fe0insurance9style7ghting6ke2lly3mited4o2ncoln4k2ve1ing5k1lc1p2oan0s3cker3us3l1ndon4tte1o3ve3pl0financial11r1s1t0d0a3u0ndbeck6xe1ury5v1y2ma0drid4if1son4keup4n0agement7go3p1rket0ing3s4riott5shalls7ttel5ba2c0kinsey7d1e0d0ia3et2lbourne7me1orial6n0u2rck0msd7g1h1iami3crosoft7l1ni1t2t0subishi9k1l0b1s2m0a2n1o0bi0le4da2e1i1m1nash3ey2ster5rmon3tgage6scow4to0rcycles9v0ie4p1q1r1s0d2t0n1r2u0seum3ic4v1w1x1y1z2na0b1goya4me2vy3ba2c1e0c1t0bank4flix4work5ustar5w0s2xt0direct7us4f0l2g0o2hk2i0co2ke1on3nja3ssan1y5l1o0kia3rton4w0ruz3tv4p1r0a1w2tt2u1yc2z2obi1server7ffice5kinawa6layan0group9lo3m0ega4ne1g1l0ine5oo2pen3racle3nge4g0anic5igins6saka4tsuka4t2vh3pa0ge2nasonic7ris2s1tners4s1y3y2ccw3e0t2f0izer5g1h0armacy6d1ilips5one2to0graphy6s4ysio5ics1tet2ures6d1n0g1k2oneer5zza4k1l0ace2y0station9umbing5s3m1n0c2ohl2ker3litie5rn2st3r0axi3ess3ime3o0d0uctions8f1gressive8mo2perties3y5tection8u0dential9s1t1ub2w0c2y2qa1pon3uebec3st5racing4dio4e0ad1lestate6tor2y4cipes5d0umbrella9hab3ise0n3t2liance6n0t0als5pair3ort3ublican8st0aurant8view0s5xroth6ich0ardli6oh3l1o1p2o0cks3deo3gers4om3s0vp3u0gby3hr2n2w0e2yukyu6sa0arland6fe0ty4kura4le1on3msclub4ung5ndvik0coromant12ofi4p1rl2s1ve2xo3b0i1s2c0b1haeffler7midt4olarships8ol3ule3warz5ience5ot3d1e0arch3t2cure1ity6ek2lect4ner3rvices6ven3w1x0y3fr2g1h0angrila6rp3ell3ia1ksha5oes2p0ping5uji3w3i0lk2na1gles5te3j1k0i0n2y0pe4l0ing4m0art3ile4n0cf3o0ccer3ial4ftbank4ware6hu2lar2utions7ng1y2y2pa0ce3ort2t3r0l2s1t0ada2ples4r1tebank4farm7c0group6ockholm6rage3e3ream4udio2y3yle4u0cks3pplies3y2ort5rf1gery5zuki5v1watch4iss4x1y0dney4stems6z2tab1ipei4lk2obao4rget4tamotors6r2too4x0i3c0i2d0k2eam2ch0nology8l1masek5nnis4va3f1g1h0d1eater2re6iaa2ckets5enda4ps2res2ol4j0maxx4x2k0maxx5l1m0all4n1o0day3kyo3ols3p1ray3shiba5tal3urs3wn2yota3s3r0ade1ing4ining5vel0ers0insurance16ust3v2t1ube2i1nes3shu4v0s2w1z2ua1bank3s2g1k1nicom3versity8o2ol2ps2s1y1z2va0cations7na1guard7c1e0gas3ntures6risign5mögensberater2ung14sicherung10t2g1i0ajes4deo3g1king4llas4n1p1rgin4sa1ion4va1o3laanderen9n1odka3lvo3te1ing3o2yage5u2wales2mart4ter4ng0gou5tch0es6eather0channel12bcam3er2site5d0ding5ibo2r3f1hoswho6ien2ki2lliamhill9n0dows4e1ners6me2oodside6rk0s2ld3w2s1tc1f3xbox3erox4ihuan4n2xx2yz3yachts4hoo3maxun5ndex5e1odobashi7ga2kohama6u0tube6t1un3za0ppos4ra3ero3ip2m1one3uerich6w2", CA = "ελ1υ2бг1ел3дети4ею2католик6ом3мкд2он1сква6онлайн5рг3рус2ф2сайт3рб3укр3қаз3հայ3ישראל5קום3ابوظبي5رامكو5لاردن4بحرين5جزائر5سعودية6عليان5مغرب5مارات5یران5بارت2زار4يتك3ھارت5تونس4سودان3رية5شبكة4عراق2ب2مان4فلسطين6قطر3كاثوليك6وم3مصر2ليسيا5وريتانيا7قع4همراه5پاکستان7ڀارت4कॉम3नेट3भारत0म्3ोत5संगठन5বাংলা5ভারত2ৰত4ਭਾਰਤ4ભારત4ଭାରତ4இந்தியா6லங்கை6சிங்கப்பூர்11భారత్5ಭಾರತ4ഭാരതം5ලංකා4คอม3ไทย3ລາວ3გე2みんな3アマゾン4クラウド4グーグル4コム2ストア3セール3ファッション6ポイント4世界2中信1国1國1文网3亚马逊3企业2佛山2信息2健康2八卦2公司1益2台湾1灣2商城1店1标2嘉里0大酒店5在线2大拿2天主教3娱乐2家電2广东2微博2慈善2我爱你3手机2招聘2政务1府2新加坡2闻2时尚2書籍2机构2淡马锡3游戏2澳門2点看2移动2组织机构4网址1店1站1络2联通2谷歌2购物2通販2集团2電訊盈科4飞利浦3食品2餐厅2香格里拉3港2닷넷1컴2삼성2한국2", Qd = "numeric", _d = "ascii", eu = "alpha", Cr = "asciinumeric", hr = "alphanumeric", tu = "domain", Nm = "emoji", SA = "scheme", $A = "slashscheme", Js = "whitespace";
function IA(e, n) {
  return e in n || (n[e] = []), n[e];
}
function Xa(e, n, t) {
  n[Qd] && (n[Cr] = !0, n[hr] = !0), n[_d] && (n[Cr] = !0, n[eu] = !0), n[Cr] && (n[hr] = !0), n[eu] && (n[hr] = !0), n[hr] && (n[tu] = !0), n[Nm] && (n[tu] = !0);
  for (const a in n) {
    const l = IA(a, t);
    l.indexOf(e) < 0 && l.push(e);
  }
}
function TA(e, n) {
  const t = {};
  for (const a in n)
    n[a].indexOf(e) >= 0 && (t[a] = !0);
  return t;
}
function on(e = null) {
  this.j = {}, this.jr = [], this.jd = null, this.t = e;
}
on.groups = {};
on.prototype = {
  accepts() {
    return !!this.t;
  },
  /**
   * Follow an existing transition from the given input to the next state.
   * Does not mutate.
   * @param {string} input character or token type to transition on
   * @returns {?State<T>} the next state, if any
   */
  go(e) {
    const n = this, t = n.j[e];
    if (t)
      return t;
    for (let a = 0; a < n.jr.length; a++) {
      const l = n.jr[a][0], r = n.jr[a][1];
      if (r && l.test(e))
        return r;
    }
    return n.jd;
  },
  /**
   * Whether the state has a transition for the given input. Set the second
   * argument to true to only look for an exact match (and not a default or
   * regular-expression-based transition)
   * @param {string} input
   * @param {boolean} exactOnly
   */
  has(e, n = !1) {
    return n ? e in this.j : !!this.go(e);
  },
  /**
   * Short for "transition all"; create a transition from the array of items
   * in the given list to the same final resulting state.
   * @param {string | string[]} inputs Group of inputs to transition on
   * @param {Transition<T> | State<T>} [next] Transition options
   * @param {Flags} [flags] Collections flags to add token to
   * @param {Collections<T>} [groups] Master list of token groups
   */
  ta(e, n, t, a) {
    for (let l = 0; l < e.length; l++)
      this.tt(e[l], n, t, a);
  },
  /**
   * Short for "take regexp transition"; defines a transition for this state
   * when it encounters a token which matches the given regular expression
   * @param {RegExp} regexp Regular expression transition (populate first)
   * @param {T | State<T>} [next] Transition options
   * @param {Flags} [flags] Collections flags to add token to
   * @param {Collections<T>} [groups] Master list of token groups
   * @returns {State<T>} taken after the given input
   */
  tr(e, n, t, a) {
    a = a || on.groups;
    let l;
    return n && n.j ? l = n : (l = new on(n), t && a && Xa(n, t, a)), this.jr.push([e, l]), l;
  },
  /**
   * Short for "take transitions", will take as many sequential transitions as
   * the length of the given input and returns the
   * resulting final state.
   * @param {string | string[]} input
   * @param {T | State<T>} [next] Transition options
   * @param {Flags} [flags] Collections flags to add token to
   * @param {Collections<T>} [groups] Master list of token groups
   * @returns {State<T>} taken after the given input
   */
  ts(e, n, t, a) {
    let l = this;
    const r = e.length;
    if (!r)
      return l;
    for (let o = 0; o < r - 1; o++)
      l = l.tt(e[o]);
    return l.tt(e[r - 1], n, t, a);
  },
  /**
   * Short for "take transition", this is a method for building/working with
   * state machines.
   *
   * If a state already exists for the given input, returns it.
   *
   * If a token is specified, that state will emit that token when reached by
   * the linkify engine.
   *
   * If no state exists, it will be initialized with some default transitions
   * that resemble existing default transitions.
   *
   * If a state is given for the second argument, that state will be
   * transitioned to on the given input regardless of what that input
   * previously did.
   *
   * Specify a token group flags to define groups that this token belongs to.
   * The token will be added to corresponding entires in the given groups
   * object.
   *
   * @param {string} input character, token type to transition on
   * @param {T | State<T>} [next] Transition options
   * @param {Flags} [flags] Collections flags to add token to
   * @param {Collections<T>} [groups] Master list of groups
   * @returns {State<T>} taken after the given input
   */
  tt(e, n, t, a) {
    a = a || on.groups;
    const l = this;
    if (n && n.j)
      return l.j[e] = n, n;
    const r = n;
    let o, i = l.go(e);
    if (i ? (o = new on(), Object.assign(o.j, i.j), o.jr.push.apply(o.jr, i.jr), o.jd = i.jd, o.t = i.t) : o = new on(), r) {
      if (a)
        if (o.t && typeof o.t == "string") {
          const s = Object.assign(TA(o.t, a), t);
          Xa(r, s, a);
        } else t && Xa(r, t, a);
      o.t = r;
    }
    return l.j[e] = o, o;
  }
};
const st = (e, n, t, a, l) => e.ta(n, t, a, l), Lt = (e, n, t, a, l) => e.tr(n, t, a, l), Eh = (e, n, t, a, l) => e.ts(n, t, a, l), Fe = (e, n, t, a, l) => e.tt(n, t, a, l), aa = "WORD", nu = "UWORD", Hm = "ASCIINUMERICAL", jm = "ALPHANUMERICAL", Kr = "LOCALHOST", au = "TLD", lu = "UTLD", Go = "SCHEME", kl = "SLASH_SCHEME", vc = "NUM", ru = "WS", xc = "NL", Sr = "OPENBRACE", $r = "CLOSEBRACE", pi = "OPENBRACKET", mi = "CLOSEBRACKET", vi = "OPENPAREN", xi = "CLOSEPAREN", yi = "OPENANGLEBRACKET", ki = "CLOSEANGLEBRACKET", wi = "FULLWIDTHLEFTPAREN", Ci = "FULLWIDTHRIGHTPAREN", Si = "LEFTCORNERBRACKET", $i = "RIGHTCORNERBRACKET", Ii = "LEFTWHITECORNERBRACKET", Ti = "RIGHTWHITECORNERBRACKET", Li = "FULLWIDTHLESSTHAN", Ei = "FULLWIDTHGREATERTHAN", Ai = "AMPERSAND", Ri = "APOSTROPHE", Bi = "ASTERISK", pa = "AT", Mi = "BACKSLASH", Di = "BACKTICK", zi = "CARET", Qa = "COLON", yc = "COMMA", Oi = "DOLLAR", Nn = "DOT", Pi = "EQUALS", kc = "EXCLAMATION", vn = "HYPHEN", Ir = "PERCENT", Fi = "PIPE", Vi = "PLUS", Ni = "POUND", Tr = "QUERY", wc = "QUOTE", Wm = "FULLWIDTHMIDDLEDOT", Cc = "SEMI", Hn = "SLASH", Lr = "TILDE", Hi = "UNDERSCORE", qm = "EMOJI", ji = "SYM";
var Um = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  ALPHANUMERICAL: jm,
  AMPERSAND: Ai,
  APOSTROPHE: Ri,
  ASCIINUMERICAL: Hm,
  ASTERISK: Bi,
  AT: pa,
  BACKSLASH: Mi,
  BACKTICK: Di,
  CARET: zi,
  CLOSEANGLEBRACKET: ki,
  CLOSEBRACE: $r,
  CLOSEBRACKET: mi,
  CLOSEPAREN: xi,
  COLON: Qa,
  COMMA: yc,
  DOLLAR: Oi,
  DOT: Nn,
  EMOJI: qm,
  EQUALS: Pi,
  EXCLAMATION: kc,
  FULLWIDTHGREATERTHAN: Ei,
  FULLWIDTHLEFTPAREN: wi,
  FULLWIDTHLESSTHAN: Li,
  FULLWIDTHMIDDLEDOT: Wm,
  FULLWIDTHRIGHTPAREN: Ci,
  HYPHEN: vn,
  LEFTCORNERBRACKET: Si,
  LEFTWHITECORNERBRACKET: Ii,
  LOCALHOST: Kr,
  NL: xc,
  NUM: vc,
  OPENANGLEBRACKET: yi,
  OPENBRACE: Sr,
  OPENBRACKET: pi,
  OPENPAREN: vi,
  PERCENT: Ir,
  PIPE: Fi,
  PLUS: Vi,
  POUND: Ni,
  QUERY: Tr,
  QUOTE: wc,
  RIGHTCORNERBRACKET: $i,
  RIGHTWHITECORNERBRACKET: Ti,
  SCHEME: Go,
  SEMI: Cc,
  SLASH: Hn,
  SLASH_SCHEME: kl,
  SYM: ji,
  TILDE: Lr,
  TLD: au,
  UNDERSCORE: Hi,
  UTLD: lu,
  UWORD: nu,
  WORD: aa,
  WS: ru
});
const ta = /[a-z]/, nr = new RegExp("\\p{L}", "u"), Zs = new RegExp("\\p{Emoji}", "u"), na = /\d/, Xs = /\s/, Ah = "\r", Qs = `
`, LA = "️", EA = "‍", _s = "￼";
let Io = null, To = null;
function AA(e = []) {
  const n = {};
  on.groups = n;
  const t = new on();
  Io == null && (Io = Rh(wA)), To == null && (To = Rh(CA)), Fe(t, "'", Ri), Fe(t, "{", Sr), Fe(t, "}", $r), Fe(t, "[", pi), Fe(t, "]", mi), Fe(t, "(", vi), Fe(t, ")", xi), Fe(t, "<", yi), Fe(t, ">", ki), Fe(t, "（", wi), Fe(t, "）", Ci), Fe(t, "「", Si), Fe(t, "」", $i), Fe(t, "『", Ii), Fe(t, "』", Ti), Fe(t, "＜", Li), Fe(t, "＞", Ei), Fe(t, "&", Ai), Fe(t, "*", Bi), Fe(t, "@", pa), Fe(t, "`", Di), Fe(t, "^", zi), Fe(t, ":", Qa), Fe(t, ",", yc), Fe(t, "$", Oi), Fe(t, ".", Nn), Fe(t, "=", Pi), Fe(t, "!", kc), Fe(t, "-", vn), Fe(t, "%", Ir), Fe(t, "|", Fi), Fe(t, "+", Vi), Fe(t, "#", Ni), Fe(t, "?", Tr), Fe(t, '"', wc), Fe(t, "/", Hn), Fe(t, ";", Cc), Fe(t, "~", Lr), Fe(t, "_", Hi), Fe(t, "\\", Mi), Fe(t, "・", Wm);
  const a = Lt(t, na, vc, {
    [Qd]: !0
  });
  Lt(a, na, a);
  const l = Lt(a, ta, Hm, {
    [Cr]: !0
  }), r = Lt(a, nr, jm, {
    [hr]: !0
  }), o = Lt(t, ta, aa, {
    [_d]: !0
  });
  Lt(o, na, l), Lt(o, ta, o), Lt(l, na, l), Lt(l, ta, l);
  const i = Lt(t, nr, nu, {
    [eu]: !0
  });
  Lt(i, ta), Lt(i, na, r), Lt(i, nr, i), Lt(r, na, r), Lt(r, ta), Lt(r, nr, r);
  const s = Fe(t, Qs, xc, {
    [Js]: !0
  }), d = Fe(t, Ah, ru, {
    [Js]: !0
  }), u = Lt(t, Xs, ru, {
    [Js]: !0
  });
  Fe(t, _s, u), Fe(d, Qs, s), Fe(d, _s, u), Lt(d, Xs, u), Fe(u, Ah), Fe(u, Qs), Lt(u, Xs, u), Fe(u, _s, u);
  const f = Lt(t, Zs, qm, {
    [Nm]: !0
  });
  Fe(f, "#"), Lt(f, Zs, f), Fe(f, LA, f);
  const b = Fe(f, EA);
  Fe(b, "#"), Lt(b, Zs, f);
  const h = [[ta, o], [na, l]], m = [[ta, null], [nr, i], [na, r]];
  for (let x = 0; x < Io.length; x++)
    ha(t, Io[x], au, aa, h);
  for (let x = 0; x < To.length; x++)
    ha(t, To[x], lu, nu, m);
  Xa(au, {
    tld: !0,
    ascii: !0
  }, n), Xa(lu, {
    utld: !0,
    alpha: !0
  }, n), ha(t, "file", Go, aa, h), ha(t, "mailto", Go, aa, h), ha(t, "http", kl, aa, h), ha(t, "https", kl, aa, h), ha(t, "ftp", kl, aa, h), ha(t, "ftps", kl, aa, h), Xa(Go, {
    scheme: !0,
    ascii: !0
  }, n), Xa(kl, {
    slashscheme: !0,
    ascii: !0
  }, n), e = e.sort((x, y) => x[0] > y[0] ? 1 : -1);
  for (let x = 0; x < e.length; x++) {
    const y = e[x][0], S = e[x][1] ? {
      [SA]: !0
    } : {
      [$A]: !0
    };
    y.indexOf("-") >= 0 ? S[tu] = !0 : ta.test(y) ? na.test(y) ? S[Cr] = !0 : S[_d] = !0 : S[Qd] = !0, Eh(t, y, y, S);
  }
  return Eh(t, "localhost", Kr, {
    ascii: !0
  }), t.jd = new on(ji), {
    start: t,
    tokens: Object.assign({
      groups: n
    }, Um)
  };
}
function Gm(e, n) {
  const t = RA(n.replace(/[A-Z]/g, (i) => i.toLowerCase())), a = t.length, l = [];
  let r = 0, o = 0;
  for (; o < a; ) {
    let i = e, s = null, d = 0, u = null, f = -1, b = -1;
    for (; o < a && (s = i.go(t[o])); )
      i = s, i.accepts() ? (f = 0, b = 0, u = i) : f >= 0 && (f += t[o].length, b++), d += t[o].length, r += t[o].length, o++;
    r -= f, o -= b, d -= f, l.push({
      t: u.t,
      // token type/name
      v: n.slice(r - d, r),
      // string value
      s: r - d,
      // start index
      e: r
      // end index (excluding)
    });
  }
  return l;
}
function RA(e) {
  const n = [], t = e.length;
  let a = 0;
  for (; a < t; ) {
    let l = e.charCodeAt(a), r, o = l < 55296 || l > 56319 || a + 1 === t || (r = e.charCodeAt(a + 1)) < 56320 || r > 57343 ? e[a] : e.slice(a, a + 2);
    n.push(o), a += o.length;
  }
  return n;
}
function ha(e, n, t, a, l) {
  let r;
  const o = n.length;
  for (let i = 0; i < o - 1; i++) {
    const s = n[i];
    e.j[s] ? r = e.j[s] : (r = new on(a), r.jr = l.slice(), e.j[s] = r), e = r;
  }
  return r = new on(t), r.jr = l.slice(), e.j[n[o - 1]] = r, r;
}
function Rh(e) {
  const n = [], t = [];
  let a = 0, l = "0123456789";
  for (; a < e.length; ) {
    let r = 0;
    for (; l.indexOf(e[a + r]) >= 0; )
      r++;
    if (r > 0) {
      n.push(t.join(""));
      for (let o = parseInt(e.substring(a, a + r), 10); o > 0; o--)
        t.pop();
      a += r;
    } else
      t.push(e[a]), a++;
  }
  return n;
}
const Yr = {
  defaultProtocol: "http",
  events: null,
  format: Bh,
  formatHref: Bh,
  nl2br: !1,
  tagName: "a",
  target: null,
  rel: null,
  validate: !0,
  truncate: 1 / 0,
  className: null,
  attributes: null,
  ignoreTags: [],
  render: null
};
function Sc(e, n = null) {
  let t = Object.assign({}, Yr);
  e && (t = Object.assign(t, e instanceof Sc ? e.o : e));
  const a = t.ignoreTags, l = [];
  for (let r = 0; r < a.length; r++)
    l.push(a[r].toUpperCase());
  this.o = t, n && (this.defaultRender = n), this.ignoreTags = l;
}
Sc.prototype = {
  o: Yr,
  /**
   * @type string[]
   */
  ignoreTags: [],
  /**
   * @param {IntermediateRepresentation} ir
   * @returns {any}
   */
  defaultRender(e) {
    return e;
  },
  /**
   * Returns true or false based on whether a token should be displayed as a
   * link based on the user options.
   * @param {MultiToken} token
   * @returns {boolean}
   */
  check(e) {
    return this.get("validate", e.toString(), e);
  },
  // Private methods
  /**
   * Resolve an option's value based on the value of the option and the given
   * params. If operator and token are specified and the target option is
   * callable, automatically calls the function with the given argument.
   * @template {keyof Opts} K
   * @param {K} key Name of option to use
   * @param {string} [operator] will be passed to the target option if it's a
   * function. If not specified, RAW function value gets returned
   * @param {MultiToken} [token] The token from linkify.tokenize
   * @returns {Opts[K] | any}
   */
  get(e, n, t) {
    const a = n != null;
    let l = this.o[e];
    return l && (typeof l == "object" ? (l = t.t in l ? l[t.t] : Yr[e], typeof l == "function" && a && (l = l(n, t))) : typeof l == "function" && a && (l = l(n, t.t, t)), l);
  },
  /**
   * @template {keyof Opts} L
   * @param {L} key Name of options object to use
   * @param {string} [operator]
   * @param {MultiToken} [token]
   * @returns {Opts[L] | any}
   */
  getObj(e, n, t) {
    let a = this.o[e];
    return typeof a == "function" && n != null && (a = a(n, t.t, t)), a;
  },
  /**
   * Convert the given token to a rendered element that may be added to the
   * calling-interface's DOM
   * @param {MultiToken} token Token to render to an HTML element
   * @returns {any} Render result; e.g., HTML string, DOM element, React
   *   Component, etc.
   */
  render(e) {
    const n = e.render(this);
    return (this.get("render", null, e) || this.defaultRender)(n, e.t, e);
  }
};
function Bh(e) {
  return e;
}
function Km(e, n) {
  this.t = "token", this.v = e, this.tk = n;
}
Km.prototype = {
  isLink: !1,
  /**
   * Return the string this token represents.
   * @return {string}
   */
  toString() {
    return this.v;
  },
  /**
   * What should the value for this token be in the `href` HTML attribute?
   * Returns the `.toString` value by default.
   * @param {string} [scheme]
   * @return {string}
   */
  toHref(e) {
    return this.toString();
  },
  /**
   * @param {Options} options Formatting options
   * @returns {string}
   */
  toFormattedString(e) {
    const n = this.toString(), t = e.get("truncate", n, this), a = e.get("format", n, this);
    return t && a.length > t ? a.substring(0, t) + "…" : a;
  },
  /**
   *
   * @param {Options} options
   * @returns {string}
   */
  toFormattedHref(e) {
    return e.get("formatHref", this.toHref(e.get("defaultProtocol")), this);
  },
  /**
   * The start index of this token in the original input string
   * @returns {number}
   */
  startIndex() {
    return this.tk[0].s;
  },
  /**
   * The end index of this token in the original input string (up to this
   * index but not including it)
   * @returns {number}
   */
  endIndex() {
    return this.tk[this.tk.length - 1].e;
  },
  /**
  	Returns an object  of relevant values for this token, which includes keys
  	* type - Kind of token ('url', 'email', etc.)
  	* value - Original text
  	* href - The value that should be added to the anchor tag's href
  		attribute
  		@method toObject
  	@param {string} [protocol] `'http'` by default
  */
  toObject(e = Yr.defaultProtocol) {
    return {
      type: this.t,
      value: this.toString(),
      isLink: this.isLink,
      href: this.toHref(e),
      start: this.startIndex(),
      end: this.endIndex()
    };
  },
  /**
   *
   * @param {Options} options Formatting option
   */
  toFormattedObject(e) {
    return {
      type: this.t,
      value: this.toFormattedString(e),
      isLink: this.isLink,
      href: this.toFormattedHref(e),
      start: this.startIndex(),
      end: this.endIndex()
    };
  },
  /**
   * Whether this token should be rendered as a link according to the given options
   * @param {Options} options
   * @returns {boolean}
   */
  validate(e) {
    return e.get("validate", this.toString(), this);
  },
  /**
   * Return an object that represents how this link should be rendered.
   * @param {Options} options Formattinng options
   */
  render(e) {
    const n = this, t = this.toHref(e.get("defaultProtocol")), a = e.get("formatHref", t, this), l = e.get("tagName", t, n), r = this.toFormattedString(e), o = {}, i = e.get("className", t, n), s = e.get("target", t, n), d = e.get("rel", t, n), u = e.getObj("attributes", t, n), f = e.getObj("events", t, n);
    return o.href = a, i && (o.class = i), s && (o.target = s), d && (o.rel = d), u && Object.assign(o, u), {
      tagName: l,
      attributes: o,
      content: r,
      eventListeners: f
    };
  }
};
function cs(e, n) {
  class t extends Km {
    constructor(l, r) {
      super(l, r), this.t = e;
    }
  }
  for (const a in n)
    t.prototype[a] = n[a];
  return t.t = e, t;
}
const BA = cs("email", {
  isLink: !0,
  toHref() {
    return "mailto:" + this.toString();
  }
}), Mh = cs("text"), MA = cs("nl"), Lo = cs("url", {
  isLink: !0,
  /**
  	Lowercases relevant parts of the domain and adds the protocol if
  	required. Note that this will not escape unsafe HTML characters in the
  	URL.
  		@param {string} [scheme] default scheme (e.g., 'https')
  	@return {string} the full href
  */
  toHref(e = Yr.defaultProtocol) {
    return this.hasProtocol() ? this.v : `${e}://${this.v}`;
  },
  /**
   * Check whether this URL token has a protocol
   * @return {boolean}
   */
  hasProtocol() {
    const e = this.tk;
    return e.length >= 2 && e[0].t !== Kr && e[1].t === Qa;
  }
}), mn = (e) => new on(e);
function DA({
  groups: e
}) {
  const n = e.domain.concat([Ai, Bi, pa, Mi, Di, zi, Oi, Pi, vn, vc, Ir, Fi, Vi, Ni, Hn, ji, Lr, Hi]), t = [Ri, Qa, yc, Nn, kc, Ir, Tr, wc, Cc, yi, ki, Sr, $r, mi, pi, vi, xi, wi, Ci, Si, $i, Ii, Ti, Li, Ei], a = [Ai, Ri, Bi, Mi, Di, zi, Oi, Pi, vn, Sr, $r, Ir, Fi, Vi, Ni, Tr, Hn, ji, Lr, Hi], l = mn(), r = Fe(l, Lr);
  st(r, a, r), st(r, e.domain, r);
  const o = mn(), i = mn(), s = mn();
  st(l, e.domain, o), st(l, e.scheme, i), st(l, e.slashscheme, s), st(o, a, r), st(o, e.domain, o);
  const d = Fe(o, pa);
  Fe(r, pa, d), Fe(i, pa, d), Fe(s, pa, d);
  const u = Fe(r, Nn);
  st(u, a, r), st(u, e.domain, r);
  const f = mn();
  st(d, e.domain, f), st(f, e.domain, f);
  const b = Fe(f, Nn);
  st(b, e.domain, f);
  const h = mn(BA);
  st(b, e.tld, h), st(b, e.utld, h), Fe(d, Kr, h);
  const m = Fe(f, vn);
  Fe(m, vn, m), st(m, e.domain, f), st(h, e.domain, f), Fe(h, Nn, b), Fe(h, vn, m);
  const x = Fe(o, vn), y = Fe(o, Nn);
  Fe(x, vn, x), st(x, e.domain, o), st(y, a, r), st(y, e.domain, o);
  const w = mn(Lo);
  st(y, e.tld, w), st(y, e.utld, w), st(w, e.domain, o), st(w, a, r), Fe(w, Nn, y), Fe(w, vn, x), Fe(w, pa, d);
  const S = Fe(w, Qa), $ = mn(Lo);
  st(S, e.numeric, $);
  const T = mn(Lo), L = mn();
  st(T, n, T), st(T, t, L), st(L, n, T), st(L, t, L), Fe(w, Hn, T), Fe($, Hn, T);
  const A = Fe(i, Qa), R = Fe(s, Qa), z = Fe(R, Hn), D = Fe(z, Hn);
  st(i, e.domain, o), Fe(i, Nn, y), Fe(i, vn, x), st(s, e.domain, o), Fe(s, Nn, y), Fe(s, vn, x), st(A, e.domain, T), Fe(A, Hn, T), Fe(A, Tr, T), st(D, e.domain, T), st(D, n, T), Fe(D, Hn, T);
  const V = [
    [Sr, $r],
    // {}
    [pi, mi],
    // []
    [vi, xi],
    // ()
    [yi, ki],
    // <>
    [wi, Ci],
    // （）
    [Si, $i],
    // 「」
    [Ii, Ti],
    // 『』
    [Li, Ei]
    // ＜＞
  ];
  for (let Y = 0; Y < V.length; Y++) {
    const [_, j] = V[Y], M = Fe(T, _);
    Fe(L, _, M);
    const W = mn(Lo);
    st(M, n, W);
    const G = mn();
    st(M, t, G), Fe(M, j, T), st(W, n, W), st(W, t, G), st(G, n, W), st(G, t, G), Fe(W, j, T), Fe(G, j, T);
  }
  return Fe(l, Kr, w), Fe(l, xc, MA), {
    start: l,
    tokens: Um
  };
}
function zA(e, n, t) {
  let a = t.length, l = 0, r = [], o = [];
  for (; l < a; ) {
    let i = e, s = null, d = null, u = 0, f = null, b = -1;
    for (; l < a && !(s = i.go(t[l].t)); )
      o.push(t[l++]);
    for (; l < a && (d = s || i.go(t[l].t)); )
      s = null, i = d, i.accepts() ? (b = 0, f = i) : b >= 0 && b++, l++, u++;
    if (b < 0)
      l -= u, l < a && (o.push(t[l]), l++);
    else {
      o.length > 0 && (r.push(ed(Mh, n, o)), o = []), l -= b, u -= b;
      const h = f.t, m = t.slice(l - u, l);
      r.push(ed(h, n, m));
    }
  }
  return o.length > 0 && r.push(ed(Mh, n, o)), r;
}
function ed(e, n, t) {
  const a = t[0].s, l = t[t.length - 1].e, r = n.slice(a, l);
  return new e(r, t);
}
const OA = typeof console < "u" && console && console.warn || (() => {
}), PA = "until manual call of linkify.init(). Register all schemes and plugins before invoking linkify the first time.", yt = {
  scanner: null,
  parser: null,
  tokenQueue: [],
  pluginQueue: [],
  customSchemes: [],
  initialized: !1
};
function FA() {
  return on.groups = {}, yt.scanner = null, yt.parser = null, yt.tokenQueue = [], yt.pluginQueue = [], yt.customSchemes = [], yt.initialized = !1, yt;
}
function Dh(e, n = !1) {
  if (yt.initialized && OA(`linkifyjs: already initialized - will not register custom scheme "${e}" ${PA}`), !/^[0-9a-z]+(-[0-9a-z]+)*$/.test(e))
    throw new Error(`linkifyjs: incorrect scheme format.
1. Must only contain digits, lowercase ASCII letters or "-"
2. Cannot start or end with "-"
3. "-" cannot repeat`);
  yt.customSchemes.push([e, n]);
}
function VA() {
  yt.scanner = AA(yt.customSchemes);
  for (let e = 0; e < yt.tokenQueue.length; e++)
    yt.tokenQueue[e][1]({
      scanner: yt.scanner
    });
  yt.parser = DA(yt.scanner.tokens);
  for (let e = 0; e < yt.pluginQueue.length; e++)
    yt.pluginQueue[e][1]({
      scanner: yt.scanner,
      parser: yt.parser
    });
  return yt.initialized = !0, yt;
}
function $c(e) {
  return yt.initialized || VA(), zA(yt.parser.start, e, Gm(yt.scanner.start, e));
}
$c.scan = Gm;
function Ym(e, n = null, t = null) {
  if (n && typeof n == "object") {
    if (t)
      throw Error(`linkifyjs: Invalid link type ${n}; must be a string`);
    t = n, n = null;
  }
  const a = new Sc(t), l = $c(e), r = [];
  for (let o = 0; o < l.length; o++) {
    const i = l[o];
    i.isLink && (!n || i.t === n) && a.check(i) && r.push(i.toFormattedObject(a));
  }
  return r;
}
var Ic = "[\0-   ᠎ -\u2029 　]", NA = new RegExp(Ic), HA = new RegExp(`${Ic}$`), jA = new RegExp(Ic, "g");
function WA(e) {
  return e.length === 1 ? e[0].isLink : e.length === 3 && e[1].isLink ? ["()", "[]"].includes(e[0].value + e[2].value) : !1;
}
function qA(e) {
  return new Tt({
    key: new Ot("autolink"),
    appendTransaction: (n, t, a) => {
      const l = n.some((d) => d.docChanged) && !t.doc.eq(a.doc), r = n.some((d) => d.getMeta("preventAutolink"));
      if (!l || r)
        return;
      const { tr: o } = a, i = hm(t.doc, [...n]);
      if (ym(i).forEach(({ newRange: d }) => {
        const u = NL(a.doc, d, (h) => h.isTextblock);
        let f, b;
        if (u.length > 1)
          f = u[0], b = a.doc.textBetween(
            f.pos,
            f.pos + f.node.nodeSize,
            void 0,
            " "
          );
        else if (u.length) {
          const h = a.doc.textBetween(d.from, d.to, " ", " ");
          if (!HA.test(h))
            return;
          f = u[0], b = a.doc.textBetween(f.pos, d.to, void 0, " ");
        }
        if (f && b) {
          const h = b.split(NA).filter(Boolean);
          if (h.length <= 0)
            return !1;
          const m = h[h.length - 1], x = f.pos + b.lastIndexOf(m);
          if (!m)
            return !1;
          const y = $c(m).map((w) => w.toObject(e.defaultProtocol));
          if (!WA(y))
            return !1;
          y.filter((w) => w.isLink).map((w) => ({
            ...w,
            from: x + w.start + 1,
            to: x + w.end + 1
          })).filter((w) => a.schema.marks.code ? !a.doc.rangeHasMark(w.from, w.to, a.schema.marks.code) : !0).filter((w) => e.validate(w.value)).filter((w) => e.shouldAutoLink(w.value)).forEach((w) => {
            hc(w.from, w.to, a.doc).some((S) => S.mark.type === e.type) || o.addMark(
              w.from,
              w.to,
              e.type.create({
                href: w.href
              })
            );
          });
        }
      }), !!o.steps.length)
        return o;
    }
  });
}
function UA(e) {
  return new Tt({
    key: new Ot("handleClickLink"),
    props: {
      handleClick: (n, t, a) => {
        var l, r;
        if (a.button !== 0 || !n.editable)
          return !1;
        let o = null;
        if (a.target instanceof HTMLAnchorElement)
          o = a.target;
        else {
          const s = a.target;
          if (!s)
            return !1;
          const d = e.editor.view.dom;
          o = s.closest("a"), o && !d.contains(o) && (o = null);
        }
        if (!o)
          return !1;
        let i = !1;
        if (e.enableClickSelection && (i = e.editor.commands.extendMarkRange(e.type.name)), e.openOnClick) {
          const s = xm(n.state, e.type.name), d = (l = o.href) != null ? l : s.href, u = (r = o.target) != null ? r : s.target;
          d && (window.open(d, u), i = !0);
        }
        return i;
      }
    }
  });
}
function GA(e) {
  return new Tt({
    key: new Ot("handlePasteLink"),
    props: {
      handlePaste: (n, t, a) => {
        const { shouldAutoLink: l } = e, { state: r } = n, { selection: o } = r, { empty: i } = o;
        if (i)
          return !1;
        let s = "";
        a.content.forEach((u) => {
          s += u.textContent;
        });
        const d = Ym(s, { defaultProtocol: e.defaultProtocol }).find(
          (u) => u.isLink && u.value === s
        );
        return !s || !d || l !== void 0 && !l(d.value) ? !1 : e.editor.commands.setMark(e.type, {
          href: d.href
        });
      }
    }
  });
}
function qa(e, n) {
  const t = ["http", "https", "ftp", "ftps", "mailto", "tel", "callto", "sms", "cid", "xmpp"];
  return n && n.forEach((a) => {
    const l = typeof a == "string" ? a : a.scheme;
    l && t.push(l);
  }), !e || e.replace(jA, "").match(
    new RegExp(
      // eslint-disable-next-line no-useless-escape
      `^(?:(?:${t.join("|")}):|[^a-z]|[a-z0-9+.-]+(?:[^a-z+.-:]|$))`,
      "i"
    )
  );
}
var KA = fa.create({
  name: "link",
  priority: 1e3,
  keepOnSplit: !1,
  exitable: !0,
  onCreate() {
    this.options.validate && !this.options.shouldAutoLink && (this.options.shouldAutoLink = this.options.validate, console.warn("The `validate` option is deprecated. Rename to the `shouldAutoLink` option instead.")), this.options.protocols.forEach((e) => {
      if (typeof e == "string") {
        Dh(e);
        return;
      }
      Dh(e.scheme, e.optionalSlashes);
    });
  },
  onDestroy() {
    FA();
  },
  inclusive() {
    return this.options.autolink;
  },
  addOptions() {
    return {
      openOnClick: !0,
      enableClickSelection: !1,
      linkOnPaste: !0,
      autolink: !0,
      protocols: [],
      defaultProtocol: "http",
      HTMLAttributes: {
        target: "_blank",
        rel: "noopener noreferrer nofollow",
        class: null
      },
      isAllowedUri: (e, n) => !!qa(e, n.protocols),
      validate: (e) => !!e,
      shouldAutoLink: (e) => {
        const n = /^[a-z][a-z0-9+.-]*:\/\//i.test(e), t = /^[a-z][a-z0-9+.-]*:/i.test(e);
        if (n || t && !e.includes("@"))
          return !0;
        const l = (e.includes("@") ? e.split("@").pop() : e).split(/[/?#:]/)[0];
        return !(/^\d{1,3}(\.\d{1,3}){3}$/.test(l) || !/\./.test(l));
      }
    };
  },
  addAttributes() {
    return {
      href: {
        default: null,
        parseHTML(e) {
          return e.getAttribute("href");
        }
      },
      target: {
        default: this.options.HTMLAttributes.target
      },
      rel: {
        default: this.options.HTMLAttributes.rel
      },
      class: {
        default: this.options.HTMLAttributes.class
      },
      title: {
        default: null
      }
    };
  },
  parseHTML() {
    return [
      {
        tag: "a[href]",
        getAttrs: (e) => {
          const n = e.getAttribute("href");
          return !n || !this.options.isAllowedUri(n, {
            defaultValidate: (t) => !!qa(t, this.options.protocols),
            protocols: this.options.protocols,
            defaultProtocol: this.options.defaultProtocol
          }) ? !1 : null;
        }
      }
    ];
  },
  renderHTML({ HTMLAttributes: e }) {
    return this.options.isAllowedUri(e.href, {
      defaultValidate: (n) => !!qa(n, this.options.protocols),
      protocols: this.options.protocols,
      defaultProtocol: this.options.defaultProtocol
    }) ? ["a", It(this.options.HTMLAttributes, e), 0] : ["a", It(this.options.HTMLAttributes, { ...e, href: "" }), 0];
  },
  markdownTokenName: "link",
  parseMarkdown: (e, n) => n.applyMark("link", n.parseInline(e.tokens || []), {
    href: e.href,
    title: e.title || null
  }),
  renderMarkdown: (e, n) => {
    var t, a, l, r;
    const o = (a = (t = e.attrs) == null ? void 0 : t.href) != null ? a : "", i = (r = (l = e.attrs) == null ? void 0 : l.title) != null ? r : "", s = n.renderChildren(e);
    return i ? `[${s}](${o} "${i}")` : `[${s}](${o})`;
  },
  addCommands() {
    return {
      setLink: (e) => ({ chain: n }) => {
        const { href: t } = e;
        return this.options.isAllowedUri(t, {
          defaultValidate: (a) => !!qa(a, this.options.protocols),
          protocols: this.options.protocols,
          defaultProtocol: this.options.defaultProtocol
        }) ? n().setMark(this.name, e).setMeta("preventAutolink", !0).run() : !1;
      },
      toggleLink: (e) => ({ chain: n }) => {
        const { href: t } = e || {};
        return t && !this.options.isAllowedUri(t, {
          defaultValidate: (a) => !!qa(a, this.options.protocols),
          protocols: this.options.protocols,
          defaultProtocol: this.options.defaultProtocol
        }) ? !1 : n().toggleMark(this.name, e, { extendEmptyMarkRange: !0 }).setMeta("preventAutolink", !0).run();
      },
      unsetLink: () => ({ chain: e }) => e().unsetMark(this.name, { extendEmptyMarkRange: !0 }).setMeta("preventAutolink", !0).run()
    };
  },
  addPasteRules() {
    return [
      Da({
        find: (e) => {
          const n = [];
          if (e) {
            const { protocols: t, defaultProtocol: a } = this.options, l = Ym(e).filter(
              (r) => r.isLink && this.options.isAllowedUri(r.value, {
                defaultValidate: (o) => !!qa(o, t),
                protocols: t,
                defaultProtocol: a
              })
            );
            l.length && l.forEach((r) => {
              this.options.shouldAutoLink(r.value) && n.push({
                text: r.value,
                data: {
                  href: r.href
                },
                index: r.start
              });
            });
          }
          return n;
        },
        type: this.type,
        getAttributes: (e) => {
          var n;
          return {
            href: (n = e.data) == null ? void 0 : n.href
          };
        }
      })
    ];
  },
  addProseMirrorPlugins() {
    const e = [], { protocols: n, defaultProtocol: t } = this.options;
    return this.options.autolink && e.push(
      qA({
        type: this.type,
        defaultProtocol: this.options.defaultProtocol,
        validate: (a) => this.options.isAllowedUri(a, {
          defaultValidate: (l) => !!qa(l, n),
          protocols: n,
          defaultProtocol: t
        }),
        shouldAutoLink: this.options.shouldAutoLink
      })
    ), e.push(
      UA({
        type: this.type,
        editor: this.editor,
        openOnClick: this.options.openOnClick === "whenNotEditable" ? !0 : this.options.openOnClick,
        enableClickSelection: this.options.enableClickSelection
      })
    ), this.options.linkOnPaste && e.push(
      GA({
        editor: this.editor,
        defaultProtocol: this.options.defaultProtocol,
        type: this.type,
        shouldAutoLink: this.options.shouldAutoLink
      })
    ), e;
  }
}), YA = Object.defineProperty, JA = (e, n) => {
  for (var t in n)
    YA(e, t, { get: n[t], enumerable: !0 });
}, ZA = "listItem", zh = "textStyle", Oh = /^\s*([-+*])\s$/, Jm = cn.create({
  name: "bulletList",
  addOptions() {
    return {
      itemTypeName: "listItem",
      HTMLAttributes: {},
      keepMarks: !1,
      keepAttributes: !1
    };
  },
  group: "block list",
  content() {
    return `${this.options.itemTypeName}+`;
  },
  parseHTML() {
    return [{ tag: "ul" }];
  },
  renderHTML({ HTMLAttributes: e }) {
    return ["ul", It(this.options.HTMLAttributes, e), 0];
  },
  markdownTokenName: "list",
  parseMarkdown: (e, n) => e.type !== "list" || e.ordered ? [] : {
    type: "bulletList",
    content: e.items ? n.parseChildren(e.items) : []
  },
  renderMarkdown: (e, n) => e.content ? n.renderChildren(e.content, `
`) : "",
  markdownOptions: {
    indentsContent: !0
  },
  addCommands() {
    return {
      toggleBulletList: () => ({ commands: e, chain: n }) => this.options.keepAttributes ? n().toggleList(this.name, this.options.itemTypeName, this.options.keepMarks).updateAttributes(ZA, this.editor.getAttributes(zh)).run() : e.toggleList(this.name, this.options.itemTypeName, this.options.keepMarks)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-8": () => this.editor.commands.toggleBulletList()
    };
  },
  addInputRules() {
    let e = ql({
      find: Oh,
      type: this.type
    });
    return (this.options.keepMarks || this.options.keepAttributes) && (e = ql({
      find: Oh,
      type: this.type,
      keepMarks: this.options.keepMarks,
      keepAttributes: this.options.keepAttributes,
      getAttributes: () => this.editor.getAttributes(zh),
      editor: this.editor
    })), [e];
  }
});
function XA(e) {
  var n, t;
  const a = (n = e.tokens) == null ? void 0 : n[0];
  return !!(e.text && ((t = e.tokens) == null ? void 0 : t.length) === 1 && (a == null ? void 0 : a.type) === "list" && a.ordered && a.raw === e.text);
}
function QA(e, n) {
  return n.tokenizeInline ? n.parseInline(n.tokenizeInline(e)) : n.parseInline([
    {
      type: "text",
      raw: e,
      text: e
    }
  ]);
}
var Zm = cn.create({
  name: "listItem",
  addOptions() {
    return {
      HTMLAttributes: {},
      bulletListTypeName: "bulletList",
      orderedListTypeName: "orderedList"
    };
  },
  content: "paragraph block*",
  defining: !0,
  parseHTML() {
    return [
      {
        tag: "li"
      }
    ];
  },
  renderHTML({ HTMLAttributes: e }) {
    return ["li", It(this.options.HTMLAttributes, e), 0];
  },
  markdownTokenName: "list_item",
  parseMarkdown: (e, n) => {
    var t;
    if (e.type !== "list_item")
      return [];
    const a = (t = n.parseBlockChildren) != null ? t : n.parseChildren;
    let l = [];
    if (e.tokens && e.tokens.length > 0) {
      if (XA(e))
        return {
          type: "listItem",
          content: [
            {
              type: "paragraph",
              content: QA(e.text || "", n)
            }
          ]
        };
      if (e.tokens.some((o) => o.type === "paragraph"))
        l = a(e.tokens);
      else {
        const o = e.tokens[0];
        if (o && o.type === "text" && o.tokens && o.tokens.length > 0) {
          if (l = [
            {
              type: "paragraph",
              content: n.parseInline(o.tokens)
            }
          ], e.tokens.length > 1) {
            const s = e.tokens.slice(1), d = a(s);
            l.push(...d);
          }
        } else
          l = a(e.tokens);
      }
    }
    return l.length === 0 && (l = [
      {
        type: "paragraph",
        content: []
      }
    ]), {
      type: "listItem",
      content: l
    };
  },
  renderMarkdown: (e, n, t) => mc(
    e,
    n,
    (a) => {
      var l, r;
      return a.parentType === "bulletList" ? "- " : a.parentType === "orderedList" ? `${(((r = (l = a.meta) == null ? void 0 : l.parentAttrs) == null ? void 0 : r.start) || 1) + a.index}. ` : "- ";
    },
    t
  ),
  addKeyboardShortcuts() {
    return {
      Enter: () => this.editor.commands.splitListItem(this.name),
      Tab: () => this.editor.commands.sinkListItem(this.name),
      "Shift-Tab": () => this.editor.commands.liftListItem(this.name)
    };
  }
}), _A = {};
JA(_A, {
  findListItemPos: () => oo,
  getNextListDepth: () => Tc,
  handleBackspace: () => ou,
  handleDelete: () => iu,
  hasListBefore: () => Xm,
  hasListItemAfter: () => e5,
  hasListItemBefore: () => Qm,
  listItemHasSubList: () => _m,
  nextListIsDeeper: () => ev,
  nextListIsHigher: () => tv
});
var oo = (e, n) => {
  const { $from: t } = n.selection, a = Dt(e, n.schema);
  let l = null, r = t.depth, o = t.pos, i = null;
  for (; r > 0 && i === null; )
    l = t.node(r), l.type === a ? i = r : (r -= 1, o -= 1);
  return i === null ? null : { $pos: n.doc.resolve(o), depth: i };
}, Tc = (e, n) => {
  const t = oo(e, n);
  if (!t)
    return !1;
  const [, a] = XL(n, e, t.$pos.pos + 4);
  return a;
}, Xm = (e, n, t) => {
  const { $anchor: a } = e.selection, l = Math.max(0, a.pos - 2), r = e.doc.resolve(l).node();
  return !(!r || !t.includes(r.type.name));
}, Qm = (e, n) => {
  var t;
  const { $anchor: a } = n.selection, l = n.doc.resolve(a.pos - 2);
  return !(l.index() === 0 || ((t = l.nodeBefore) == null ? void 0 : t.type.name) !== e);
}, _m = (e, n, t) => {
  if (!t)
    return !1;
  const a = Dt(e, n.schema);
  let l = !1;
  return t.descendants((r) => {
    r.type === a && (l = !0);
  }), l;
}, ou = (e, n, t) => {
  if (e.commands.undoInputRule())
    return !0;
  if (e.state.selection.from !== e.state.selection.to)
    return !1;
  if (!Ma(e.state, n) && Xm(e.state, n, t)) {
    const { $anchor: i } = e.state.selection, s = e.state.doc.resolve(i.before() - 1), d = [];
    s.node().descendants((b, h) => {
      b.type.name === n && d.push({ node: b, pos: h });
    });
    const u = d.at(-1);
    if (!u)
      return !1;
    const f = e.state.doc.resolve(s.start() + u.pos + 1);
    return e.chain().cut({ from: i.start() - 1, to: i.end() + 1 }, f.end()).joinForward().run();
  }
  if (!Ma(e.state, n) || !tE(e.state))
    return !1;
  const a = oo(n, e.state);
  if (!a)
    return !1;
  const r = e.state.doc.resolve(a.$pos.pos - 2).node(a.depth), o = _m(n, e.state, r);
  return Qm(n, e.state) && !o ? e.commands.joinItemBackward() : e.chain().liftListItem(n).run();
}, ev = (e, n) => {
  const t = Tc(e, n), a = oo(e, n);
  return !a || !t ? !1 : t > a.depth;
}, tv = (e, n) => {
  const t = Tc(e, n), a = oo(e, n);
  return !a || !t ? !1 : t < a.depth;
}, iu = (e, n) => {
  if (!Ma(e.state, n) || !eE(e.state, n))
    return !1;
  const { selection: t } = e.state, { $from: a, $to: l } = t;
  return !t.empty && a.sameParent(l) ? !1 : ev(n, e.state) ? e.chain().focus(e.state.selection.from + 4).lift(n).joinBackward().run() : tv(n, e.state) ? e.chain().joinForward().joinBackward().run() : e.commands.joinItemForward();
}, e5 = (e, n) => {
  var t;
  const { $anchor: a } = n.selection, l = n.doc.resolve(a.pos - a.parentOffset - 2);
  return !(l.index() === l.parent.childCount - 1 || ((t = l.nodeAfter) == null ? void 0 : t.type.name) !== e);
}, nv = pt.create({
  name: "listKeymap",
  addOptions() {
    return {
      listTypes: [
        {
          itemName: "listItem",
          wrapperNames: ["bulletList", "orderedList"]
        },
        {
          itemName: "taskItem",
          wrapperNames: ["taskList"]
        }
      ]
    };
  },
  addKeyboardShortcuts() {
    return {
      Delete: ({ editor: e }) => {
        let n = !1;
        return this.options.listTypes.forEach(({ itemName: t }) => {
          e.state.schema.nodes[t] !== void 0 && iu(e, t) && (n = !0);
        }), n;
      },
      "Mod-Delete": ({ editor: e }) => {
        let n = !1;
        return this.options.listTypes.forEach(({ itemName: t }) => {
          e.state.schema.nodes[t] !== void 0 && iu(e, t) && (n = !0);
        }), n;
      },
      Backspace: ({ editor: e }) => {
        let n = !1;
        return this.options.listTypes.forEach(({ itemName: t, wrapperNames: a }) => {
          e.state.schema.nodes[t] !== void 0 && ou(e, t, a) && (n = !0);
        }), n;
      },
      "Mod-Backspace": ({ editor: e }) => {
        let n = !1;
        return this.options.listTypes.forEach(({ itemName: t, wrapperNames: a }) => {
          e.state.schema.nodes[t] !== void 0 && ou(e, t, a) && (n = !0);
        }), n;
      }
    };
  }
}), Ph = /^(\s*)(\d+)\.\s+(.*)$/, t5 = /^\s/;
function n5(e) {
  const n = e.trimStart();
  return /^[-+*]\s+/.test(n) || /^\d+\.\s+/.test(n) || /^>\s?/.test(n) || /^```/.test(n) || /^~~~/.test(n);
}
function a5(e) {
  const n = [], t = [];
  let a = !1;
  return e.forEach((l) => {
    if (a) {
      t.push(l);
      return;
    }
    if (l.trim() === "") {
      a = !0, t.push(l);
      return;
    }
    if (n.length > 0 && n5(l)) {
      a = !0, t.push(l);
      return;
    }
    n.push(l);
  }), {
    paragraphLines: n,
    blockLines: t
  };
}
function l5(e) {
  const n = [];
  let t = 0, a = 0;
  for (; t < e.length; ) {
    const l = e[t], r = l.match(Ph);
    if (!r)
      break;
    const [, o, i, s] = r, d = o.length, u = [s];
    let f = t + 1;
    const b = [l];
    let h = !1;
    for (; f < e.length; ) {
      const m = e[f];
      if (m.match(Ph))
        break;
      if (m.trim() === "")
        b.push(m), u.push(""), h = !0, f += 1;
      else if (m.match(t5))
        b.push(m), u.push(m.slice(d + 2)), f += 1;
      else {
        if (h)
          break;
        b.push(m), u.push(m), f += 1;
      }
    }
    n.push({
      indent: d,
      number: parseInt(i, 10),
      content: u.join(`
`).trim(),
      contentLines: u,
      raw: b.join(`
`)
    }), a = f, t = f;
  }
  return [n, a];
}
function av(e, n, t) {
  const a = [];
  let l = 0;
  for (; l < e.length; ) {
    const r = e[l];
    if (r.indent === n) {
      const { paragraphLines: o, blockLines: i } = a5(r.contentLines), s = o.join(`
`).trim(), d = [];
      s && d.push({
        type: "paragraph",
        raw: s,
        tokens: t.inlineTokens(s)
      });
      const u = i.join(`
`).trim();
      if (u) {
        const h = t.blockTokens(u);
        d.push(...h);
      }
      let f = l + 1;
      const b = [];
      for (; f < e.length && e[f].indent > n; )
        b.push(e[f]), f += 1;
      if (b.length > 0) {
        const h = Math.min(...b.map((x) => x.indent)), m = av(b, h, t);
        d.push({
          type: "list",
          ordered: !0,
          start: b[0].number,
          items: m,
          raw: b.map((x) => x.raw).join(`
`)
        });
      }
      a.push({
        type: "list_item",
        raw: r.raw,
        tokens: d
      }), l = f;
    } else
      l += 1;
  }
  return a;
}
function r5(e, n) {
  return e.map((t) => {
    if (t.type !== "list_item")
      return n.parseChildren([t])[0];
    const a = [];
    return t.tokens && t.tokens.length > 0 && t.tokens.forEach((l) => {
      if (l.type === "paragraph" || l.type === "list" || l.type === "blockquote" || l.type === "code")
        a.push(...n.parseChildren([l]));
      else if (l.type === "text" && l.tokens) {
        const r = n.parseChildren([l]);
        a.push({
          type: "paragraph",
          content: r
        });
      } else {
        const r = n.parseChildren([l]);
        r.length > 0 && a.push(...r);
      }
    }), {
      type: "listItem",
      content: a
    };
  });
}
var o5 = "listItem", Fh = "textStyle", Vh = /^(\d+)\.\s$/, lv = cn.create({
  name: "orderedList",
  addOptions() {
    return {
      itemTypeName: "listItem",
      HTMLAttributes: {},
      keepMarks: !1,
      keepAttributes: !1
    };
  },
  group: "block list",
  content() {
    return `${this.options.itemTypeName}+`;
  },
  addAttributes() {
    return {
      start: {
        default: 1,
        parseHTML: (e) => e.hasAttribute("start") ? parseInt(e.getAttribute("start") || "", 10) : 1
      },
      type: {
        default: null,
        parseHTML: (e) => e.getAttribute("type")
      }
    };
  },
  parseHTML() {
    return [
      {
        tag: "ol"
      }
    ];
  },
  renderHTML({ HTMLAttributes: e }) {
    const { start: n, ...t } = e;
    return n === 1 ? ["ol", It(this.options.HTMLAttributes, t), 0] : ["ol", It(this.options.HTMLAttributes, e), 0];
  },
  markdownTokenName: "list",
  parseMarkdown: (e, n) => {
    if (e.type !== "list" || !e.ordered)
      return [];
    const t = e.start || 1, a = e.items ? r5(e.items, n) : [];
    return t !== 1 ? {
      type: "orderedList",
      attrs: { start: t },
      content: a
    } : {
      type: "orderedList",
      content: a
    };
  },
  renderMarkdown: (e, n) => e.content ? n.renderChildren(e.content, `
`) : "",
  markdownTokenizer: {
    name: "orderedList",
    level: "block",
    start: (e) => {
      const n = e.match(/^(\s*)(\d+)\.\s+/), t = n == null ? void 0 : n.index;
      return t !== void 0 ? t : -1;
    },
    tokenize: (e, n, t) => {
      var a;
      const l = e.split(`
`), [r, o] = l5(l);
      if (r.length === 0)
        return;
      const i = av(r, 0, t);
      return i.length === 0 ? void 0 : {
        type: "list",
        ordered: !0,
        start: ((a = r[0]) == null ? void 0 : a.number) || 1,
        items: i,
        raw: l.slice(0, o).join(`
`)
      };
    }
  },
  markdownOptions: {
    indentsContent: !0
  },
  addCommands() {
    return {
      toggleOrderedList: () => ({ commands: e, chain: n }) => this.options.keepAttributes ? n().toggleList(this.name, this.options.itemTypeName, this.options.keepMarks).updateAttributes(o5, this.editor.getAttributes(Fh)).run() : e.toggleList(this.name, this.options.itemTypeName, this.options.keepMarks)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-7": () => this.editor.commands.toggleOrderedList()
    };
  },
  addInputRules() {
    let e = ql({
      find: Vh,
      type: this.type,
      getAttributes: (n) => ({ start: +n[1] }),
      joinPredicate: (n, t) => t.childCount + t.attrs.start === +n[1]
    });
    return (this.options.keepMarks || this.options.keepAttributes) && (e = ql({
      find: Vh,
      type: this.type,
      keepMarks: this.options.keepMarks,
      keepAttributes: this.options.keepAttributes,
      getAttributes: (n) => ({ start: +n[1], ...this.editor.getAttributes(Fh) }),
      joinPredicate: (n, t) => t.childCount + t.attrs.start === +n[1],
      editor: this.editor
    })), [e];
  }
}), i5 = /^\s*(\[([( |x])?\])\s$/, s5 = cn.create({
  name: "taskItem",
  addOptions() {
    return {
      nested: !1,
      HTMLAttributes: {},
      taskListTypeName: "taskList",
      a11y: void 0
    };
  },
  content() {
    return this.options.nested ? "paragraph block*" : "paragraph+";
  },
  defining: !0,
  addAttributes() {
    return {
      checked: {
        default: !1,
        keepOnSplit: !1,
        parseHTML: (e) => {
          const n = e.getAttribute("data-checked");
          return n === "" || n === "true";
        },
        renderHTML: (e) => ({
          "data-checked": e.checked
        })
      }
    };
  },
  parseHTML() {
    return [
      {
        tag: `li[data-type="${this.name}"]`,
        priority: 51
      }
    ];
  },
  renderHTML({ node: e, HTMLAttributes: n }) {
    return [
      "li",
      It(this.options.HTMLAttributes, n, {
        "data-type": this.name
      }),
      [
        "label",
        [
          "input",
          {
            type: "checkbox",
            checked: e.attrs.checked ? "checked" : null
          }
        ],
        ["span"]
      ],
      ["div", 0]
    ];
  },
  parseMarkdown: (e, n) => {
    const t = [];
    if (e.tokens && e.tokens.length > 0 ? t.push(n.createNode("paragraph", {}, n.parseInline(e.tokens))) : e.text ? t.push(n.createNode("paragraph", {}, [n.createNode("text", { text: e.text })])) : t.push(n.createNode("paragraph", {}, [])), e.nestedTokens && e.nestedTokens.length > 0) {
      const a = n.parseChildren(e.nestedTokens);
      t.push(...a);
    }
    return n.createNode("taskItem", { checked: e.checked || !1 }, t);
  },
  renderMarkdown: (e, n) => {
    var t;
    const l = `- [${(t = e.attrs) != null && t.checked ? "x" : " "}] `;
    return mc(e, n, l);
  },
  addKeyboardShortcuts() {
    const e = {
      Enter: () => this.editor.commands.splitListItem(this.name),
      "Shift-Tab": () => this.editor.commands.liftListItem(this.name)
    };
    return this.options.nested ? {
      ...e,
      Tab: () => this.editor.commands.sinkListItem(this.name)
    } : e;
  },
  addNodeView() {
    return ({ node: e, HTMLAttributes: n, getPos: t, editor: a }) => {
      const l = document.createElement("li"), r = document.createElement("label"), o = document.createElement("span"), i = document.createElement("input"), s = document.createElement("div"), d = (f) => {
        var b, h;
        i.ariaLabel = ((h = (b = this.options.a11y) == null ? void 0 : b.checkboxLabel) == null ? void 0 : h.call(b, f, i.checked)) || `Task item checkbox for ${f.textContent || "empty task item"}`;
      };
      d(e), r.contentEditable = "false", i.type = "checkbox", i.addEventListener("mousedown", (f) => f.preventDefault()), i.addEventListener("change", (f) => {
        if (!a.isEditable && !this.options.onReadOnlyChecked) {
          i.checked = !i.checked;
          return;
        }
        const { checked: b } = f.target;
        a.isEditable && typeof t == "function" && a.chain().focus(void 0, { scrollIntoView: !1 }).command(({ tr: h }) => {
          const m = t();
          if (typeof m != "number")
            return !1;
          const x = h.doc.nodeAt(m);
          return h.setNodeMarkup(m, void 0, {
            ...x == null ? void 0 : x.attrs,
            checked: b
          }), !0;
        }).run(), !a.isEditable && this.options.onReadOnlyChecked && (this.options.onReadOnlyChecked(e, b) || (i.checked = !i.checked));
      }), Object.entries(this.options.HTMLAttributes).forEach(([f, b]) => {
        l.setAttribute(f, b);
      }), l.dataset.checked = e.attrs.checked, i.checked = e.attrs.checked, r.append(i, o), l.append(r, s), Object.entries(n).forEach(([f, b]) => {
        l.setAttribute(f, b);
      });
      let u = new Set(Object.keys(n));
      return {
        dom: l,
        contentDOM: s,
        update: (f) => {
          if (f.type !== this.type)
            return !1;
          l.dataset.checked = f.attrs.checked, i.checked = f.attrs.checked, d(f);
          const b = a.extensionManager.attributes, h = Ur(f, b), m = new Set(Object.keys(h)), x = this.options.HTMLAttributes;
          return u.forEach((y) => {
            m.has(y) || (y in x ? l.setAttribute(y, x[y]) : l.removeAttribute(y));
          }), Object.entries(h).forEach(([y, w]) => {
            w == null ? y in x ? l.setAttribute(y, x[y]) : l.removeAttribute(y) : l.setAttribute(y, w);
          }), u = m, !0;
        }
      };
    };
  },
  addInputRules() {
    return [
      ql({
        find: i5,
        type: this.type,
        getAttributes: (e) => ({
          checked: e[e.length - 1] === "x"
        })
      })
    ];
  }
}), d5 = cn.create({
  name: "taskList",
  addOptions() {
    return {
      itemTypeName: "taskItem",
      HTMLAttributes: {}
    };
  },
  group: "block list",
  content() {
    return `${this.options.itemTypeName}+`;
  },
  parseHTML() {
    return [
      {
        tag: `ul[data-type="${this.name}"]`,
        priority: 51
      }
    ];
  },
  renderHTML({ HTMLAttributes: e }) {
    return ["ul", It(this.options.HTMLAttributes, e, { "data-type": this.name }), 0];
  },
  parseMarkdown: (e, n) => n.createNode("taskList", {}, n.parseChildren(e.items || [])),
  renderMarkdown: (e, n) => e.content ? n.renderChildren(e.content, `
`) : "",
  markdownTokenizer: {
    name: "taskList",
    level: "block",
    start(e) {
      var n;
      const t = (n = e.match(/^\s*[-+*]\s+\[([ xX])\]\s+/)) == null ? void 0 : n.index;
      return t !== void 0 ? t : -1;
    },
    tokenize(e, n, t) {
      const a = (r) => {
        const o = Xd(
          r,
          {
            itemPattern: /^(\s*)([-+*])\s+\[([ xX])\]\s+(.*)$/,
            extractItemData: (i) => ({
              indentLevel: i[1].length,
              mainContent: i[4],
              checked: i[3].toLowerCase() === "x"
            }),
            createToken: (i, s) => ({
              type: "taskItem",
              raw: "",
              mainContent: i.mainContent,
              indentLevel: i.indentLevel,
              checked: i.checked,
              text: i.mainContent,
              tokens: t.inlineTokens(i.mainContent),
              nestedTokens: s
            }),
            // Allow recursive nesting
            customNestedParser: a
          },
          t
        );
        return o ? [
          {
            type: "taskList",
            raw: o.raw,
            items: o.items
          }
        ] : t.blockTokens(r);
      }, l = Xd(
        e,
        {
          itemPattern: /^(\s*)([-+*])\s+\[([ xX])\]\s+(.*)$/,
          extractItemData: (r) => ({
            indentLevel: r[1].length,
            mainContent: r[4],
            checked: r[3].toLowerCase() === "x"
          }),
          createToken: (r, o) => ({
            type: "taskItem",
            raw: "",
            mainContent: r.mainContent,
            indentLevel: r.indentLevel,
            checked: r.checked,
            text: r.mainContent,
            tokens: t.inlineTokens(r.mainContent),
            nestedTokens: o
          }),
          // Use the recursive parser for nested content
          customNestedParser: a
        },
        t
      );
      if (l)
        return {
          type: "taskList",
          raw: l.raw,
          items: l.items
        };
    }
  },
  markdownOptions: {
    indentsContent: !0
  },
  addCommands() {
    return {
      toggleTaskList: () => ({ commands: e }) => e.toggleList(this.name, this.options.itemTypeName)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-9": () => this.editor.commands.toggleTaskList()
    };
  }
});
pt.create({
  name: "listKit",
  addExtensions() {
    const e = [];
    return this.options.bulletList !== !1 && e.push(Jm.configure(this.options.bulletList)), this.options.listItem !== !1 && e.push(Zm.configure(this.options.listItem)), this.options.listKeymap !== !1 && e.push(nv.configure(this.options.listKeymap)), this.options.orderedList !== !1 && e.push(lv.configure(this.options.orderedList)), this.options.taskItem !== !1 && e.push(s5.configure(this.options.taskItem)), this.options.taskList !== !1 && e.push(d5.configure(this.options.taskList)), e;
  }
});
var Eo = "&nbsp;", td = " ", u5 = cn.create({
  name: "paragraph",
  priority: 1e3,
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  group: "block",
  content: "inline*",
  parseHTML() {
    return [{ tag: "p" }];
  },
  renderHTML({ HTMLAttributes: e }) {
    return ["p", It(this.options.HTMLAttributes, e), 0];
  },
  parseMarkdown: (e, n) => {
    const t = e.tokens || [];
    if (t.length === 1 && t[0].type === "image")
      return n.parseChildren([t[0]]);
    const a = n.parseInline(t);
    return t.length === 1 && t[0].type === "text" && (t[0].raw === Eo || t[0].text === Eo || t[0].raw === td || t[0].text === td) && a.length === 1 && a[0].type === "text" && (a[0].text === Eo || a[0].text === td) ? n.createNode("paragraph", void 0, []) : n.createNode("paragraph", void 0, a);
  },
  renderMarkdown: (e, n, t) => {
    var a, l;
    if (!e)
      return "";
    const r = Array.isArray(e.content) ? e.content : [];
    if (r.length === 0) {
      const o = Array.isArray((a = t == null ? void 0 : t.previousNode) == null ? void 0 : a.content) ? t.previousNode.content : [];
      return ((l = t == null ? void 0 : t.previousNode) == null ? void 0 : l.type) === "paragraph" && o.length === 0 ? Eo : "";
    }
    return n.renderChildren(r);
  },
  addCommands() {
    return {
      setParagraph: () => ({ commands: e }) => e.setNode(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Alt-0": () => this.editor.commands.setParagraph()
    };
  }
}), c5 = /(?:^|\s)(~~(?!\s+~~)((?:[^~]+))~~(?!\s+~~))$/, f5 = /(?:^|\s)(~~(?!\s+~~)((?:[^~]+))~~(?!\s+~~))/g, h5 = fa.create({
  name: "strike",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  parseHTML() {
    return [
      {
        tag: "s"
      },
      {
        tag: "del"
      },
      {
        tag: "strike"
      },
      {
        style: "text-decoration",
        consuming: !1,
        getAttrs: (e) => e.includes("line-through") ? {} : !1
      }
    ];
  },
  renderHTML({ HTMLAttributes: e }) {
    return ["s", It(this.options.HTMLAttributes, e), 0];
  },
  markdownTokenName: "del",
  parseMarkdown: (e, n) => n.applyMark("strike", n.parseInline(e.tokens || [])),
  renderMarkdown: (e, n) => `~~${n.renderChildren(e)}~~`,
  addCommands() {
    return {
      setStrike: () => ({ commands: e }) => e.setMark(this.name),
      toggleStrike: () => ({ commands: e }) => e.toggleMark(this.name),
      unsetStrike: () => ({ commands: e }) => e.unsetMark(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-s": () => this.editor.commands.toggleStrike()
    };
  },
  addInputRules() {
    return [
      hl({
        find: c5,
        type: this.type
      })
    ];
  },
  addPasteRules() {
    return [
      Da({
        find: f5,
        type: this.type
      })
    ];
  }
}), b5 = cn.create({
  name: "text",
  group: "inline",
  parseMarkdown: (e) => ({
    type: "text",
    text: e.text || ""
  }),
  renderMarkdown: (e) => e.text || ""
}), g5 = fa.create({
  name: "underline",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  parseHTML() {
    return [
      {
        tag: "u"
      },
      {
        style: "text-decoration",
        consuming: !1,
        getAttrs: (e) => e.includes("underline") ? {} : !1
      }
    ];
  },
  renderHTML({ HTMLAttributes: e }) {
    return ["u", It(this.options.HTMLAttributes, e), 0];
  },
  parseMarkdown(e, n) {
    return n.applyMark(this.name || "underline", n.parseInline(e.tokens || []));
  },
  renderMarkdown(e, n) {
    return `++${n.renderChildren(e)}++`;
  },
  markdownTokenizer: {
    name: "underline",
    level: "inline",
    start(e) {
      return e.indexOf("++");
    },
    tokenize(e, n, t) {
      const l = /^(\+\+)([\s\S]+?)(\+\+)/.exec(e);
      if (!l)
        return;
      const r = l[2].trim();
      return {
        type: "underline",
        raw: l[0],
        text: r,
        tokens: t.inlineTokens(r)
      };
    }
  },
  addCommands() {
    return {
      setUnderline: () => ({ commands: e }) => e.setMark(this.name),
      toggleUnderline: () => ({ commands: e }) => e.toggleMark(this.name),
      unsetUnderline: () => ({ commands: e }) => e.unsetMark(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-u": () => this.editor.commands.toggleUnderline(),
      "Mod-U": () => this.editor.commands.toggleUnderline()
    };
  }
});
function p5(e = {}) {
  return new Tt({
    view(n) {
      return new m5(n, e);
    }
  });
}
class m5 {
  constructor(n, t) {
    var a;
    this.editorView = n, this.cursorPos = null, this.element = null, this.timeout = -1, this.width = (a = t.width) !== null && a !== void 0 ? a : 1, this.color = t.color === !1 ? void 0 : t.color || "black", this.class = t.class, this.handlers = ["dragover", "dragend", "drop", "dragleave"].map((l) => {
      let r = (o) => {
        this[l](o);
      };
      return n.dom.addEventListener(l, r), { name: l, handler: r };
    });
  }
  destroy() {
    this.handlers.forEach(({ name: n, handler: t }) => this.editorView.dom.removeEventListener(n, t));
  }
  update(n, t) {
    this.cursorPos != null && t.doc != n.state.doc && (this.cursorPos > n.state.doc.content.size ? this.setCursor(null) : this.updateOverlay());
  }
  setCursor(n) {
    n != this.cursorPos && (this.cursorPos = n, n == null ? (this.element.parentNode.removeChild(this.element), this.element = null) : this.updateOverlay());
  }
  updateOverlay() {
    let n = this.editorView.state.doc.resolve(this.cursorPos), t = !n.parent.inlineContent, a, l = this.editorView.dom, r = l.getBoundingClientRect(), o = r.width / l.offsetWidth, i = r.height / l.offsetHeight;
    if (t) {
      let f = n.nodeBefore, b = n.nodeAfter;
      if (f || b) {
        let h = this.editorView.nodeDOM(this.cursorPos - (f ? f.nodeSize : 0));
        if (h) {
          let m = h.getBoundingClientRect(), x = f ? m.bottom : m.top;
          f && b && (x = (x + this.editorView.nodeDOM(this.cursorPos).getBoundingClientRect().top) / 2);
          let y = this.width / 2 * i;
          a = { left: m.left, right: m.right, top: x - y, bottom: x + y };
        }
      }
    }
    if (!a) {
      let f = this.editorView.coordsAtPos(this.cursorPos), b = this.width / 2 * o;
      a = { left: f.left - b, right: f.left + b, top: f.top, bottom: f.bottom };
    }
    let s = this.editorView.dom.offsetParent;
    this.element || (this.element = s.appendChild(document.createElement("div")), this.class && (this.element.className = this.class), this.element.style.cssText = "position: absolute; z-index: 50; pointer-events: none;", this.color && (this.element.style.backgroundColor = this.color)), this.element.classList.toggle("prosemirror-dropcursor-block", t), this.element.classList.toggle("prosemirror-dropcursor-inline", !t);
    let d, u;
    if (!s || s == document.body && getComputedStyle(s).position == "static")
      d = -pageXOffset, u = -pageYOffset;
    else {
      let f = s.getBoundingClientRect(), b = f.width / s.offsetWidth, h = f.height / s.offsetHeight;
      d = f.left - s.scrollLeft * b, u = f.top - s.scrollTop * h;
    }
    this.element.style.left = (a.left - d) / o + "px", this.element.style.top = (a.top - u) / i + "px", this.element.style.width = (a.right - a.left) / o + "px", this.element.style.height = (a.bottom - a.top) / i + "px";
  }
  scheduleRemoval(n) {
    clearTimeout(this.timeout), this.timeout = setTimeout(() => this.setCursor(null), n);
  }
  dragover(n) {
    if (!this.editorView.editable)
      return;
    let t = this.editorView.posAtCoords({ left: n.clientX, top: n.clientY }), a = t && t.inside >= 0 && this.editorView.state.doc.nodeAt(t.inside), l = a && a.type.spec.disableDropCursor, r = typeof l == "function" ? l(this.editorView, t, n) : l;
    if (t && !r) {
      let o = t.pos;
      if (this.editorView.dragging && this.editorView.dragging.slice) {
        let i = ap(this.editorView.state.doc, o, this.editorView.dragging.slice);
        i != null && (o = i);
      }
      this.setCursor(o), this.scheduleRemoval(5e3);
    }
  }
  dragend() {
    this.scheduleRemoval(20);
  }
  drop() {
    this.scheduleRemoval(20);
  }
  dragleave(n) {
    this.editorView.dom.contains(n.relatedTarget) || this.setCursor(null);
  }
}
class Et extends rt {
  /**
  Create a gap cursor.
  */
  constructor(n) {
    super(n, n);
  }
  map(n, t) {
    let a = n.resolve(t.map(this.head));
    return Et.valid(a) ? new Et(a) : rt.near(a);
  }
  content() {
    return Ye.empty;
  }
  eq(n) {
    return n instanceof Et && n.head == this.head;
  }
  toJSON() {
    return { type: "gapcursor", pos: this.head };
  }
  /**
  @internal
  */
  static fromJSON(n, t) {
    if (typeof t.pos != "number")
      throw new RangeError("Invalid input for GapCursor.fromJSON");
    return new Et(n.resolve(t.pos));
  }
  /**
  @internal
  */
  getBookmark() {
    return new Lc(this.anchor);
  }
  /**
  @internal
  */
  static valid(n) {
    let t = n.parent;
    if (t.inlineContent || !v5(n) || !x5(n))
      return !1;
    let a = t.type.spec.allowGapCursor;
    if (a != null)
      return a;
    let l = t.contentMatchAt(n.index()).defaultType;
    return l && l.isTextblock;
  }
  /**
  @internal
  */
  static findGapCursorFrom(n, t, a = !1) {
    e: for (; ; ) {
      if (!a && Et.valid(n))
        return n;
      let l = n.pos, r = null;
      for (let o = n.depth; ; o--) {
        let i = n.node(o);
        if (t > 0 ? n.indexAfter(o) < i.childCount : n.index(o) > 0) {
          r = i.child(t > 0 ? n.indexAfter(o) : n.index(o) - 1);
          break;
        } else if (o == 0)
          return null;
        l += t;
        let s = n.doc.resolve(l);
        if (Et.valid(s))
          return s;
      }
      for (; ; ) {
        let o = t > 0 ? r.firstChild : r.lastChild;
        if (!o) {
          if (r.isAtom && !r.isText && !Xe.isSelectable(r)) {
            n = n.doc.resolve(l + r.nodeSize * t), a = !1;
            continue e;
          }
          break;
        }
        r = o, l += t;
        let i = n.doc.resolve(l);
        if (Et.valid(i))
          return i;
      }
      return null;
    }
  }
}
Et.prototype.visible = !1;
Et.findFrom = Et.findGapCursorFrom;
rt.jsonID("gapcursor", Et);
class Lc {
  constructor(n) {
    this.pos = n;
  }
  map(n) {
    return new Lc(n.map(this.pos));
  }
  resolve(n) {
    let t = n.resolve(this.pos);
    return Et.valid(t) ? new Et(t) : rt.near(t);
  }
}
function rv(e) {
  return e.isAtom || e.spec.isolating || e.spec.createGapCursor;
}
function v5(e) {
  for (let n = e.depth; n >= 0; n--) {
    let t = e.index(n), a = e.node(n);
    if (t == 0) {
      if (a.type.spec.isolating)
        return !0;
      continue;
    }
    for (let l = a.child(t - 1); ; l = l.lastChild) {
      if (l.childCount == 0 && !l.inlineContent || rv(l.type))
        return !0;
      if (l.inlineContent)
        return !1;
    }
  }
  return !0;
}
function x5(e) {
  for (let n = e.depth; n >= 0; n--) {
    let t = e.indexAfter(n), a = e.node(n);
    if (t == a.childCount) {
      if (a.type.spec.isolating)
        return !0;
      continue;
    }
    for (let l = a.child(t); ; l = l.firstChild) {
      if (l.childCount == 0 && !l.inlineContent || rv(l.type))
        return !0;
      if (l.inlineContent)
        return !1;
    }
  }
  return !0;
}
function y5() {
  return new Tt({
    props: {
      decorations: S5,
      createSelectionBetween(e, n, t) {
        return n.pos == t.pos && Et.valid(t) ? new Et(t) : null;
      },
      handleClick: w5,
      handleKeyDown: k5,
      handleDOMEvents: { beforeinput: C5 }
    }
  });
}
const k5 = rm({
  ArrowLeft: Ao("horiz", -1),
  ArrowRight: Ao("horiz", 1),
  ArrowUp: Ao("vert", -1),
  ArrowDown: Ao("vert", 1)
});
function Ao(e, n) {
  const t = e == "vert" ? n > 0 ? "down" : "up" : n > 0 ? "right" : "left";
  return function(a, l, r) {
    let o = a.selection, i = n > 0 ? o.$to : o.$from, s = o.empty;
    if (o instanceof nt) {
      if (!r.endOfTextblock(t) || i.depth == 0)
        return !1;
      s = !1, i = a.doc.resolve(n > 0 ? i.after() : i.before());
    }
    let d = Et.findGapCursorFrom(i, n, s);
    return d ? (l && l(a.tr.setSelection(new Et(d))), !0) : !1;
  };
}
function w5(e, n, t) {
  if (!e || !e.editable)
    return !1;
  let a = e.state.doc.resolve(n);
  if (!Et.valid(a))
    return !1;
  let l = e.posAtCoords({ left: t.clientX, top: t.clientY });
  return l && l.inside > -1 && Xe.isSelectable(e.state.doc.nodeAt(l.inside)) ? !1 : (e.dispatch(e.state.tr.setSelection(new Et(a))), !0);
}
function C5(e, n) {
  if (n.inputType != "insertCompositionText" || !(e.state.selection instanceof Et))
    return !1;
  let { $from: t } = e.state.selection, a = t.parent.contentMatchAt(t.index()).findWrapping(e.state.schema.nodes.text);
  if (!a)
    return !1;
  let l = Pe.empty;
  for (let o = a.length - 1; o >= 0; o--)
    l = Pe.from(a[o].createAndFill(null, l));
  let r = e.state.tr.replace(t.pos, t.pos, new Ye(l, 0, 0));
  return r.setSelection(nt.near(r.doc.resolve(t.pos + 1))), e.dispatch(r), !1;
}
function S5(e) {
  if (!(e.selection instanceof Et))
    return null;
  let n = document.createElement("div");
  return n.className = "ProseMirror-gapcursor", $t.create(e.doc, [an.widget(e.selection.head, n, { key: "gapcursor" })]);
}
var Wi = 200, Nt = function() {
};
Nt.prototype.append = function(n) {
  return n.length ? (n = Nt.from(n), !this.length && n || n.length < Wi && this.leafAppend(n) || this.length < Wi && n.leafPrepend(this) || this.appendInner(n)) : this;
};
Nt.prototype.prepend = function(n) {
  return n.length ? Nt.from(n).append(this) : this;
};
Nt.prototype.appendInner = function(n) {
  return new $5(this, n);
};
Nt.prototype.slice = function(n, t) {
  return n === void 0 && (n = 0), t === void 0 && (t = this.length), n >= t ? Nt.empty : this.sliceInner(Math.max(0, n), Math.min(this.length, t));
};
Nt.prototype.get = function(n) {
  if (!(n < 0 || n >= this.length))
    return this.getInner(n);
};
Nt.prototype.forEach = function(n, t, a) {
  t === void 0 && (t = 0), a === void 0 && (a = this.length), t <= a ? this.forEachInner(n, t, a, 0) : this.forEachInvertedInner(n, t, a, 0);
};
Nt.prototype.map = function(n, t, a) {
  t === void 0 && (t = 0), a === void 0 && (a = this.length);
  var l = [];
  return this.forEach(function(r, o) {
    return l.push(n(r, o));
  }, t, a), l;
};
Nt.from = function(n) {
  return n instanceof Nt ? n : n && n.length ? new ov(n) : Nt.empty;
};
var ov = /* @__PURE__ */ function(e) {
  function n(a) {
    e.call(this), this.values = a;
  }
  e && (n.__proto__ = e), n.prototype = Object.create(e && e.prototype), n.prototype.constructor = n;
  var t = { length: { configurable: !0 }, depth: { configurable: !0 } };
  return n.prototype.flatten = function() {
    return this.values;
  }, n.prototype.sliceInner = function(l, r) {
    return l == 0 && r == this.length ? this : new n(this.values.slice(l, r));
  }, n.prototype.getInner = function(l) {
    return this.values[l];
  }, n.prototype.forEachInner = function(l, r, o, i) {
    for (var s = r; s < o; s++)
      if (l(this.values[s], i + s) === !1)
        return !1;
  }, n.prototype.forEachInvertedInner = function(l, r, o, i) {
    for (var s = r - 1; s >= o; s--)
      if (l(this.values[s], i + s) === !1)
        return !1;
  }, n.prototype.leafAppend = function(l) {
    if (this.length + l.length <= Wi)
      return new n(this.values.concat(l.flatten()));
  }, n.prototype.leafPrepend = function(l) {
    if (this.length + l.length <= Wi)
      return new n(l.flatten().concat(this.values));
  }, t.length.get = function() {
    return this.values.length;
  }, t.depth.get = function() {
    return 0;
  }, Object.defineProperties(n.prototype, t), n;
}(Nt);
Nt.empty = new ov([]);
var $5 = /* @__PURE__ */ function(e) {
  function n(t, a) {
    e.call(this), this.left = t, this.right = a, this.length = t.length + a.length, this.depth = Math.max(t.depth, a.depth) + 1;
  }
  return e && (n.__proto__ = e), n.prototype = Object.create(e && e.prototype), n.prototype.constructor = n, n.prototype.flatten = function() {
    return this.left.flatten().concat(this.right.flatten());
  }, n.prototype.getInner = function(a) {
    return a < this.left.length ? this.left.get(a) : this.right.get(a - this.left.length);
  }, n.prototype.forEachInner = function(a, l, r, o) {
    var i = this.left.length;
    if (l < i && this.left.forEachInner(a, l, Math.min(r, i), o) === !1 || r > i && this.right.forEachInner(a, Math.max(l - i, 0), Math.min(this.length, r) - i, o + i) === !1)
      return !1;
  }, n.prototype.forEachInvertedInner = function(a, l, r, o) {
    var i = this.left.length;
    if (l > i && this.right.forEachInvertedInner(a, l - i, Math.max(r, i) - i, o + i) === !1 || r < i && this.left.forEachInvertedInner(a, Math.min(l, i), r, o) === !1)
      return !1;
  }, n.prototype.sliceInner = function(a, l) {
    if (a == 0 && l == this.length)
      return this;
    var r = this.left.length;
    return l <= r ? this.left.slice(a, l) : a >= r ? this.right.slice(a - r, l - r) : this.left.slice(a, r).append(this.right.slice(0, l - r));
  }, n.prototype.leafAppend = function(a) {
    var l = this.right.leafAppend(a);
    if (l)
      return new n(this.left, l);
  }, n.prototype.leafPrepend = function(a) {
    var l = this.left.leafPrepend(a);
    if (l)
      return new n(l, this.right);
  }, n.prototype.appendInner = function(a) {
    return this.left.depth >= Math.max(this.right.depth, a.depth) + 1 ? new n(this.left, new n(this.right, a)) : new n(this, a);
  }, n;
}(Nt);
const I5 = 500;
class zn {
  constructor(n, t) {
    this.items = n, this.eventCount = t;
  }
  // Pop the latest event off the branch's history and apply it
  // to a document transform.
  popEvent(n, t) {
    if (this.eventCount == 0)
      return null;
    let a = this.items.length;
    for (; ; a--)
      if (this.items.get(a - 1).selection) {
        --a;
        break;
      }
    let l, r;
    t && (l = this.remapping(a, this.items.length), r = l.maps.length);
    let o = n.tr, i, s, d = [], u = [];
    return this.items.forEach((f, b) => {
      if (!f.step) {
        l || (l = this.remapping(a, b + 1), r = l.maps.length), r--, u.push(f);
        return;
      }
      if (l) {
        u.push(new jn(f.map));
        let h = f.step.map(l.slice(r)), m;
        h && o.maybeStep(h).doc && (m = o.mapping.maps[o.mapping.maps.length - 1], d.push(new jn(m, void 0, void 0, d.length + u.length))), r--, m && l.appendMap(m, r);
      } else
        o.maybeStep(f.step);
      if (f.selection)
        return i = l ? f.selection.map(l.slice(r)) : f.selection, s = new zn(this.items.slice(0, a).append(u.reverse().concat(d)), this.eventCount - 1), !1;
    }, this.items.length, 0), { remaining: s, transform: o, selection: i };
  }
  // Create a new branch with the given transform added.
  addTransform(n, t, a, l) {
    let r = [], o = this.eventCount, i = this.items, s = !l && i.length ? i.get(i.length - 1) : null;
    for (let u = 0; u < n.steps.length; u++) {
      let f = n.steps[u].invert(n.docs[u]), b = new jn(n.mapping.maps[u], f, t), h;
      (h = s && s.merge(b)) && (b = h, u ? r.pop() : i = i.slice(0, i.length - 1)), r.push(b), t && (o++, t = void 0), l || (s = b);
    }
    let d = o - a.depth;
    return d > L5 && (i = T5(i, d), o -= d), new zn(i.append(r), o);
  }
  remapping(n, t) {
    let a = new Vr();
    return this.items.forEach((l, r) => {
      let o = l.mirrorOffset != null && r - l.mirrorOffset >= n ? a.maps.length - l.mirrorOffset : void 0;
      a.appendMap(l.map, o);
    }, n, t), a;
  }
  addMaps(n) {
    return this.eventCount == 0 ? this : new zn(this.items.append(n.map((t) => new jn(t))), this.eventCount);
  }
  // When the collab module receives remote changes, the history has
  // to know about those, so that it can adjust the steps that were
  // rebased on top of the remote changes, and include the position
  // maps for the remote changes in its array of items.
  rebased(n, t) {
    if (!this.eventCount)
      return this;
    let a = [], l = Math.max(0, this.items.length - t), r = n.mapping, o = n.steps.length, i = this.eventCount;
    this.items.forEach((b) => {
      b.selection && i--;
    }, l);
    let s = t;
    this.items.forEach((b) => {
      let h = r.getMirror(--s);
      if (h == null)
        return;
      o = Math.min(o, h);
      let m = r.maps[h];
      if (b.step) {
        let x = n.steps[h].invert(n.docs[h]), y = b.selection && b.selection.map(r.slice(s + 1, h));
        y && i++, a.push(new jn(m, x, y));
      } else
        a.push(new jn(m));
    }, l);
    let d = [];
    for (let b = t; b < o; b++)
      d.push(new jn(r.maps[b]));
    let u = this.items.slice(0, l).append(d).append(a), f = new zn(u, i);
    return f.emptyItemCount() > I5 && (f = f.compress(this.items.length - a.length)), f;
  }
  emptyItemCount() {
    let n = 0;
    return this.items.forEach((t) => {
      t.step || n++;
    }), n;
  }
  // Compressing a branch means rewriting it to push the air (map-only
  // items) out. During collaboration, these naturally accumulate
  // because each remote change adds one. The `upto` argument is used
  // to ensure that only the items below a given level are compressed,
  // because `rebased` relies on a clean, untouched set of items in
  // order to associate old items with rebased steps.
  compress(n = this.items.length) {
    let t = this.remapping(0, n), a = t.maps.length, l = [], r = 0;
    return this.items.forEach((o, i) => {
      if (i >= n)
        l.push(o), o.selection && r++;
      else if (o.step) {
        let s = o.step.map(t.slice(a)), d = s && s.getMap();
        if (a--, d && t.appendMap(d, a), s) {
          let u = o.selection && o.selection.map(t.slice(a));
          u && r++;
          let f = new jn(d.invert(), s, u), b, h = l.length - 1;
          (b = l.length && l[h].merge(f)) ? l[h] = b : l.push(f);
        }
      } else o.map && a--;
    }, this.items.length, 0), new zn(Nt.from(l.reverse()), r);
  }
}
zn.empty = new zn(Nt.empty, 0);
function T5(e, n) {
  let t;
  return e.forEach((a, l) => {
    if (a.selection && n-- == 0)
      return t = l, !1;
  }), e.slice(t);
}
class jn {
  constructor(n, t, a, l) {
    this.map = n, this.step = t, this.selection = a, this.mirrorOffset = l;
  }
  merge(n) {
    if (this.step && n.step && !n.selection) {
      let t = n.step.merge(this.step);
      if (t)
        return new jn(t.getMap().invert(), t, this.selection);
    }
  }
}
class ma {
  constructor(n, t, a, l, r) {
    this.done = n, this.undone = t, this.prevRanges = a, this.prevTime = l, this.prevComposition = r;
  }
}
const L5 = 20;
function E5(e, n, t, a) {
  let l = t.getMeta(ll), r;
  if (l)
    return l.historyState;
  t.getMeta(B5) && (e = new ma(e.done, e.undone, null, 0, -1));
  let o = t.getMeta("appendedTransaction");
  if (t.steps.length == 0)
    return e;
  if (o && o.getMeta(ll))
    return o.getMeta(ll).redo ? new ma(e.done.addTransform(t, void 0, a, Ko(n)), e.undone, Nh(t.mapping.maps), e.prevTime, e.prevComposition) : new ma(e.done, e.undone.addTransform(t, void 0, a, Ko(n)), null, e.prevTime, e.prevComposition);
  if (t.getMeta("addToHistory") !== !1 && !(o && o.getMeta("addToHistory") === !1)) {
    let i = t.getMeta("composition"), s = e.prevTime == 0 || !o && e.prevComposition != i && (e.prevTime < (t.time || 0) - a.newGroupDelay || !A5(t, e.prevRanges)), d = o ? nd(e.prevRanges, t.mapping) : Nh(t.mapping.maps);
    return new ma(e.done.addTransform(t, s ? n.selection.getBookmark() : void 0, a, Ko(n)), zn.empty, d, t.time, i ?? e.prevComposition);
  } else return (r = t.getMeta("rebased")) ? new ma(e.done.rebased(t, r), e.undone.rebased(t, r), nd(e.prevRanges, t.mapping), e.prevTime, e.prevComposition) : new ma(e.done.addMaps(t.mapping.maps), e.undone.addMaps(t.mapping.maps), nd(e.prevRanges, t.mapping), e.prevTime, e.prevComposition);
}
function A5(e, n) {
  if (!n)
    return !1;
  if (!e.docChanged)
    return !0;
  let t = !1;
  return e.mapping.maps[0].forEach((a, l) => {
    for (let r = 0; r < n.length; r += 2)
      a <= n[r + 1] && l >= n[r] && (t = !0);
  }), t;
}
function Nh(e) {
  let n = [];
  for (let t = e.length - 1; t >= 0 && n.length == 0; t--)
    e[t].forEach((a, l, r, o) => n.push(r, o));
  return n;
}
function nd(e, n) {
  if (!e)
    return null;
  let t = [];
  for (let a = 0; a < e.length; a += 2) {
    let l = n.map(e[a], 1), r = n.map(e[a + 1], -1);
    l <= r && t.push(l, r);
  }
  return t;
}
function R5(e, n, t) {
  let a = Ko(n), l = ll.get(n).spec.config, r = (t ? e.undone : e.done).popEvent(n, a);
  if (!r)
    return null;
  let o = r.selection.resolve(r.transform.doc), i = (t ? e.done : e.undone).addTransform(r.transform, n.selection.getBookmark(), l, a), s = new ma(t ? i : r.remaining, t ? r.remaining : i, null, 0, -1);
  return r.transform.setSelection(o).setMeta(ll, { redo: t, historyState: s });
}
let ad = !1, Hh = null;
function Ko(e) {
  let n = e.plugins;
  if (Hh != n) {
    ad = !1, Hh = n;
    for (let t = 0; t < n.length; t++)
      if (n[t].spec.historyPreserveItems) {
        ad = !0;
        break;
      }
  }
  return ad;
}
const ll = new Ot("history"), B5 = new Ot("closeHistory");
function M5(e = {}) {
  return e = {
    depth: e.depth || 100,
    newGroupDelay: e.newGroupDelay || 500
  }, new Tt({
    key: ll,
    state: {
      init() {
        return new ma(zn.empty, zn.empty, null, 0, -1);
      },
      apply(n, t, a) {
        return E5(t, a, n, e);
      }
    },
    config: e,
    props: {
      handleDOMEvents: {
        beforeinput(n, t) {
          let a = t.inputType, l = a == "historyUndo" ? sv : a == "historyRedo" ? dv : null;
          return !l || !n.editable ? !1 : (t.preventDefault(), l(n.state, n.dispatch));
        }
      }
    }
  });
}
function iv(e, n) {
  return (t, a) => {
    let l = ll.getState(t);
    if (!l || (e ? l.undone : l.done).eventCount == 0)
      return !1;
    if (a) {
      let r = R5(l, t, e);
      r && a(n ? r.scrollIntoView() : r);
    }
    return !0;
  };
}
const sv = iv(!1, !0), dv = iv(!0, !0);
pt.create({
  name: "characterCount",
  addOptions() {
    return {
      limit: null,
      autoTrim: !0,
      mode: "textSize",
      textCounter: (e) => e.length,
      wordCounter: (e) => e.split(" ").filter((n) => n !== "").length
    };
  },
  addStorage() {
    return {
      characters: () => 0,
      words: () => 0
    };
  },
  onBeforeCreate() {
    this.storage.characters = (e) => {
      const n = (e == null ? void 0 : e.node) || this.editor.state.doc;
      if (((e == null ? void 0 : e.mode) || this.options.mode) === "textSize") {
        const a = n.textBetween(0, n.content.size, void 0, " ");
        return this.options.textCounter(a);
      }
      return n.nodeSize;
    }, this.storage.words = (e) => {
      const n = (e == null ? void 0 : e.node) || this.editor.state.doc, t = n.textBetween(0, n.content.size, " ", " ");
      return this.options.wordCounter(t);
    };
  },
  addProseMirrorPlugins() {
    let e = !1;
    return [
      new Tt({
        key: new Ot("characterCount"),
        appendTransaction: (n, t, a) => {
          if (e)
            return;
          const l = this.options.limit, r = this.options.autoTrim;
          if (l == null || l === 0 || r === !1) {
            e = !0;
            return;
          }
          const o = this.storage.characters({ node: a.doc });
          if (o > l) {
            const i = o - l, s = 0, d = i;
            console.warn(
              `[CharacterCount] Initial content exceeded limit of ${l} characters. Content was automatically trimmed.`
            );
            const u = a.tr.deleteRange(s, d);
            return e = !0, u;
          }
          e = !0;
        },
        filterTransaction: (n, t) => {
          const a = this.options.limit;
          if (!n.docChanged || a === 0 || a === null || a === void 0)
            return !0;
          const l = this.storage.characters({ node: t.doc }), r = this.storage.characters({ node: n.doc });
          if (r <= a || l > a && r > a && r <= l)
            return !0;
          if (l > a && r > a && r > l || !n.getMeta("paste"))
            return !1;
          const i = n.selection.$head.pos, s = r - a, d = i - s, u = i;
          return n.deleteRange(d, u), !(this.storage.characters({ node: n.doc }) > a);
        }
      })
    ];
  }
});
var D5 = pt.create({
  name: "dropCursor",
  addOptions() {
    return {
      color: "currentColor",
      width: 1,
      class: void 0
    };
  },
  addProseMirrorPlugins() {
    return [p5(this.options)];
  }
});
pt.create({
  name: "focus",
  addOptions() {
    return {
      className: "has-focus",
      mode: "all"
    };
  },
  addProseMirrorPlugins() {
    return [
      new Tt({
        key: new Ot("focus"),
        props: {
          decorations: ({ doc: e, selection: n }) => {
            const { isEditable: t, isFocused: a } = this.editor, { anchor: l } = n, r = [];
            if (!t || !a)
              return $t.create(e, []);
            let o = 0;
            this.options.mode === "deepest" && e.descendants((s, d) => {
              if (s.isText)
                return;
              if (!(l >= d && l <= d + s.nodeSize - 1))
                return !1;
              o += 1;
            });
            let i = 0;
            return e.descendants((s, d) => {
              if (s.isText || !(l >= d && l <= d + s.nodeSize - 1))
                return !1;
              if (i += 1, this.options.mode === "deepest" && o - i > 0 || this.options.mode === "shallowest" && i > 1)
                return this.options.mode === "deepest";
              r.push(
                an.node(d, d + s.nodeSize, {
                  class: this.options.className
                })
              );
            }), $t.create(e, r);
          }
        }
      })
    ];
  }
});
var z5 = pt.create({
  name: "gapCursor",
  addProseMirrorPlugins() {
    return [y5()];
  },
  extendNodeSchema(e) {
    var n;
    const t = {
      name: e.name,
      options: e.options,
      storage: e.storage
    };
    return {
      allowGapCursor: (n = ht(Ze(e, "allowGapCursor", t))) != null ? n : null
    };
  }
});
function jh(e) {
  const {
    editor: n,
    placeholder: t,
    dataAttribute: a,
    pos: l,
    node: r,
    isEmptyDoc: o,
    hasAnchor: i,
    classes: { emptyNode: s, emptyEditor: d }
  } = e, u = [s];
  return o && u.push(d), an.node(l, l + r.nodeSize, {
    class: u.join(" "),
    [a]: typeof t == "function" ? t({
      editor: n,
      node: r,
      pos: l,
      hasAnchor: i
    }) : t
  });
}
function O5(e) {
  const n = getComputedStyle(e), t = `${n.overflow} ${n.overflowY} ${n.overflowX}`;
  return /auto|scroll|overlay/.test(t);
}
function P5(e) {
  let n = e;
  for (; n; ) {
    if (O5(n))
      return n;
    const t = n.parentElement;
    if (!t) {
      const a = n.getRootNode();
      if (a instanceof ShadowRoot) {
        n = a.host;
        continue;
      }
      return window;
    }
    n = t;
  }
  return window;
}
function F5(e) {
  return e === window ? { top: 0, bottom: window.innerHeight } : e.getBoundingClientRect();
}
function V5({
  doc: e,
  view: n,
  scrollContainer: t
}) {
  const a = n.dom.getBoundingClientRect(), l = t ? F5(t) : { top: 0, bottom: window.innerHeight }, r = Math.max(a.top, l.top), o = Math.min(a.bottom, l.bottom);
  if (r >= o)
    return { top: 0, bottom: e.content.size };
  const s = getComputedStyle(n.dom).direction === "rtl" ? Math.max(a.right - 2, a.left + 2) : a.left + 2, d = n.posAtCoords({ left: s, top: r + 2 }), u = n.posAtCoords({ left: s, top: o - 2 });
  return {
    top: d ? d.pos : 0,
    bottom: u ? u.pos : e.content.size
  };
}
function N5(e, n) {
  let t = null;
  return { call: (...r) => {
    t || (e(...r), t = setTimeout(() => {
      t = null;
    }, n));
  }, cancel: () => {
    t && (clearTimeout(t), t = null);
  } };
}
var Wh = "placeholder";
function H5(e) {
  return e.replace(/\s+/g, "-").replace(/[^a-zA-Z0-9-]/g, "").replace(/^[0-9-]+/, "").replace(/^-+/, "").toLowerCase();
}
var ar = new Ot("tiptap__placeholder");
pt.create({
  name: "placeholder",
  addOptions() {
    return {
      emptyEditorClass: "is-editor-empty",
      emptyNodeClass: "is-empty",
      dataAttribute: Wh,
      placeholder: "Write something …",
      showOnlyWhenEditable: !0,
      showOnlyCurrent: !0,
      includeChildren: !1
    };
  },
  addProseMirrorPlugins() {
    const e = this.options.dataAttribute ? `data-${H5(this.options.dataAttribute)}` : `data-${Wh}`;
    return [
      new Tt({
        state: {
          init() {
            return {
              // null means "no viewport info yet" — decoration callback falls
              // back to full document scan until the scroll handler fires.
              topPos: null,
              bottomPos: null
            };
          },
          apply(n, t) {
            const a = n.getMeta(ar);
            return a != null && a.positions ? {
              topPos: a.positions.top,
              bottomPos: a.positions.bottom
            } : n.docChanged ? {
              topPos: t.topPos !== null ? n.mapping.map(t.topPos) : null,
              bottomPos: t.bottomPos !== null ? n.mapping.map(t.bottomPos) : null
            } : t;
          }
        },
        key: ar,
        view(n) {
          const t = P5(n.dom), a = () => {
            const i = V5({
              view: n,
              doc: n.state.doc,
              scrollContainer: t
            }), s = ar.getState(n.state);
            if (s.topPos === i.top && s.bottomPos === i.bottom)
              return;
            const d = n.state.tr.setMeta(ar, { positions: i }).setMeta("tiptap__viewportUpdate", !0);
            n.dispatch(d);
          }, { call: l, cancel: r } = N5(a, 250), o = t;
          return o.addEventListener("scroll", l, { passive: !0 }), a(), {
            update(i, s) {
              n.state.doc.content.size !== s.doc.content.size && a();
            },
            destroy: () => {
              r(), o.removeEventListener("scroll", l);
            }
          };
        },
        props: {
          decorations: ({ doc: n, selection: t }) => {
            var a, l;
            if (!(this.editor.isEditable || !this.options.showOnlyWhenEditable))
              return null;
            const { anchor: o } = t, i = [], s = this.editor.isEmpty;
            if (this.options.showOnlyCurrent && !this.options.includeChildren) {
              const u = n.resolve(o);
              if (u.depth > 0) {
                const f = u.node(1), b = u.before(1);
                if (f.type.isTextblock && Gr(f)) {
                  const h = o >= b && o <= b + f.nodeSize, m = jh({
                    node: f,
                    dataAttribute: e,
                    hasAnchor: h,
                    placeholder: this.options.placeholder,
                    classes: {
                      emptyEditor: this.options.emptyEditorClass,
                      emptyNode: this.options.emptyNodeClass
                    },
                    editor: this.editor,
                    isEmptyDoc: s,
                    pos: u.before(1)
                  });
                  i.push(m);
                }
              }
            } else {
              const u = ar.getState(this.editor.state), f = (a = u.topPos) != null ? a : 0, b = (l = u.bottomPos) != null ? l : n.content.size;
              n.nodesBetween(f, b, (h, m) => {
                const x = o >= m && o <= m + h.nodeSize, y = !h.isLeaf && Gr(h);
                if (!h.type.isTextblock)
                  return this.options.includeChildren;
                if ((x || !this.options.showOnlyCurrent) && y) {
                  const w = jh({
                    classes: { emptyEditor: this.options.emptyEditorClass, emptyNode: this.options.emptyNodeClass },
                    editor: this.editor,
                    isEmptyDoc: s,
                    dataAttribute: e,
                    hasAnchor: x,
                    placeholder: this.options.placeholder,
                    node: h,
                    pos: m
                  });
                  i.push(w);
                }
                return this.options.includeChildren;
              });
            }
            return $t.create(n, i);
          }
        }
      })
    ];
  }
});
pt.create({
  name: "selection",
  addOptions() {
    return {
      className: "selection"
    };
  },
  addProseMirrorPlugins() {
    const { editor: e, options: n } = this;
    return [
      new Tt({
        key: new Ot("selection"),
        props: {
          decorations(t) {
            return t.selection.empty || e.isFocused || !e.isEditable || km(t.selection) || e.view.dragging ? null : $t.create(t.doc, [
              an.inline(t.selection.from, t.selection.to, {
                class: n.className
              })
            ]);
          }
        }
      })
    ];
  }
});
var j5 = "skipTrailingNode";
function qh({ types: e, node: n }) {
  return n && Array.isArray(e) && e.includes(n.type) || (n == null ? void 0 : n.type) === e;
}
var W5 = pt.create({
  name: "trailingNode",
  addOptions() {
    return {
      node: void 0,
      notAfter: []
    };
  },
  addProseMirrorPlugins() {
    var e;
    const n = new Ot(this.name), t = this.options.node || ((e = this.editor.schema.topNodeType.contentMatch.defaultType) == null ? void 0 : e.name) || "paragraph", a = Object.entries(this.editor.schema.nodes).map(([, l]) => l).filter((l) => (this.options.notAfter || []).concat(t).includes(l.name));
    return [
      new Tt({
        key: n,
        appendTransaction: (l, r, o) => {
          const { doc: i, tr: s, schema: d } = o, u = n.getState(o), f = i.content.size, b = d.nodes[t];
          if (!l.some((h) => h.getMeta(j5)) && u)
            return s.insert(f, b.create());
        },
        state: {
          init: (l, r) => {
            const o = r.tr.doc.lastChild;
            return !qh({ node: o, types: a });
          },
          apply: (l, r) => {
            if (!l.docChanged || l.getMeta("__uniqueIDTransaction"))
              return r;
            const o = l.doc.lastChild;
            return !qh({ node: o, types: a });
          }
        }
      })
    ];
  }
}), q5 = pt.create({
  name: "undoRedo",
  addOptions() {
    return {
      depth: 100,
      newGroupDelay: 500
    };
  },
  addCommands() {
    return {
      undo: () => ({ state: e, dispatch: n }) => sv(e, n),
      redo: () => ({ state: e, dispatch: n }) => dv(e, n)
    };
  },
  addProseMirrorPlugins() {
    return [M5(this.options)];
  },
  addKeyboardShortcuts() {
    return {
      "Mod-z": () => this.editor.commands.undo(),
      "Shift-Mod-z": () => this.editor.commands.redo(),
      "Mod-y": () => this.editor.commands.redo(),
      // Russian keyboard layouts
      "Mod-я": () => this.editor.commands.undo(),
      "Shift-Mod-я": () => this.editor.commands.redo()
    };
  }
}), U5 = pt.create({
  name: "starterKit",
  addExtensions() {
    var e, n, t, a;
    const l = [];
    return this.options.bold !== !1 && l.push(oA.configure(this.options.bold)), this.options.blockquote !== !1 && l.push(tA.configure(this.options.blockquote)), this.options.bulletList !== !1 && l.push(Jm.configure(this.options.bulletList)), this.options.code !== !1 && l.push(dA.configure(this.options.code)), this.options.codeBlock !== !1 && l.push(fA.configure(this.options.codeBlock)), this.options.document !== !1 && l.push(hA.configure(this.options.document)), this.options.dropcursor !== !1 && l.push(D5.configure(this.options.dropcursor)), this.options.gapcursor !== !1 && l.push(z5.configure(this.options.gapcursor)), this.options.hardBreak !== !1 && l.push(bA.configure(this.options.hardBreak)), this.options.heading !== !1 && l.push(gA.configure(this.options.heading)), this.options.undoRedo !== !1 && l.push(q5.configure(this.options.undoRedo)), this.options.horizontalRule !== !1 && l.push(pA.configure(this.options.horizontalRule)), this.options.italic !== !1 && l.push(kA.configure(this.options.italic)), this.options.listItem !== !1 && l.push(Zm.configure(this.options.listItem)), this.options.listKeymap !== !1 && l.push(nv.configure((e = this.options) == null ? void 0 : e.listKeymap)), this.options.link !== !1 && l.push(KA.configure((n = this.options) == null ? void 0 : n.link)), this.options.orderedList !== !1 && l.push(lv.configure(this.options.orderedList)), this.options.paragraph !== !1 && l.push(u5.configure(this.options.paragraph)), this.options.strike !== !1 && l.push(h5.configure(this.options.strike)), this.options.text !== !1 && l.push(b5.configure(this.options.text)), this.options.underline !== !1 && l.push(g5.configure((t = this.options) == null ? void 0 : t.underline)), this.options.trailingNode !== !1 && l.push(W5.configure((a = this.options) == null ? void 0 : a.trailingNode)), l;
  }
}), G5 = U5, K5 = pt.create({
  name: "textAlign",
  addOptions() {
    return {
      types: [],
      alignments: ["left", "center", "right", "justify"],
      defaultAlignment: null
    };
  },
  addGlobalAttributes() {
    return [
      {
        types: this.options.types,
        attributes: {
          textAlign: {
            default: this.options.defaultAlignment,
            parseHTML: (e) => {
              const n = e.style.textAlign;
              return this.options.alignments.includes(n) ? n : this.options.defaultAlignment;
            },
            renderHTML: (e) => e.textAlign ? { style: `text-align: ${e.textAlign}` } : {}
          }
        }
      }
    ];
  },
  addCommands() {
    return {
      setTextAlign: (e) => ({ commands: n }) => this.options.alignments.includes(e) ? this.options.types.map((t) => n.updateAttributes(t, { textAlign: e })).some((t) => t) : !1,
      unsetTextAlign: () => ({ commands: e }) => this.options.types.map((n) => e.resetAttributes(n, "textAlign")).some((n) => n),
      toggleTextAlign: (e) => ({ editor: n, commands: t }) => this.options.alignments.includes(e) ? n.isActive({ textAlign: e }) ? t.unsetTextAlign() : t.setTextAlign(e) : !1
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-l": () => this.editor.commands.setTextAlign("left"),
      "Mod-Shift-e": () => this.editor.commands.setTextAlign("center"),
      "Mod-Shift-r": () => this.editor.commands.setTextAlign("right"),
      "Mod-Shift-j": () => this.editor.commands.setTextAlign("justify")
    };
  }
}), Y5 = K5, J5 = 20, uv = (e, n = 0) => {
  const t = [];
  return !e.children.length || n > J5 || Array.from(e.children).forEach((a) => {
    a.tagName === "SPAN" ? t.push(a) : a.children.length && t.push(...uv(a, n + 1));
  }), t;
}, Z5 = (e) => {
  if (!e.children.length)
    return;
  const n = uv(e);
  n && n.forEach((t) => {
    var a, l;
    const r = t.getAttribute("style"), o = (l = (a = t.parentElement) == null ? void 0 : a.closest("span")) == null ? void 0 : l.getAttribute("style");
    t.setAttribute("style", `${o};${r}`);
  });
}, cv = fa.create({
  name: "textStyle",
  priority: 101,
  addOptions() {
    return {
      HTMLAttributes: {},
      mergeNestedSpanStyles: !0
    };
  },
  parseHTML() {
    return [
      {
        tag: "span",
        consuming: !1,
        getAttrs: (e) => e.hasAttribute("style") ? (this.options.mergeNestedSpanStyles && Z5(e), {}) : !1
      }
    ];
  },
  renderHTML({ HTMLAttributes: e }) {
    return ["span", It(this.options.HTMLAttributes, e), 0];
  },
  addCommands() {
    return {
      toggleTextStyle: (e) => ({ commands: n }) => n.toggleMark(this.name, e),
      removeEmptyTextStyle: () => ({ tr: e }) => {
        const { selection: n } = e;
        return e.doc.nodesBetween(n.from, n.to, (t, a) => {
          if (t.isTextblock)
            return !0;
          t.marks.filter((l) => l.type === this.type).some((l) => Object.values(l.attrs).some((r) => !!r)) || e.removeMark(a, a + t.nodeSize, this.type);
        }), !0;
      }
    };
  }
}), X5 = pt.create({
  name: "backgroundColor",
  addOptions() {
    return {
      types: ["textStyle"]
    };
  },
  addGlobalAttributes() {
    return [
      {
        types: this.options.types,
        attributes: {
          backgroundColor: {
            default: null,
            parseHTML: (e) => {
              var n;
              const t = (n = Zl(e, "background-color")) != null ? n : e.style.backgroundColor;
              return t == null ? void 0 : t.replace(/['"]+/g, "");
            },
            renderHTML: (e) => e.backgroundColor ? {
              style: `background-color: ${e.backgroundColor}`
            } : {}
          }
        }
      }
    ];
  },
  addCommands() {
    return {
      setBackgroundColor: (e) => ({ chain: n }) => n().setMark("textStyle", { backgroundColor: e }).run(),
      unsetBackgroundColor: () => ({ chain: e }) => e().setMark("textStyle", { backgroundColor: null }).removeEmptyTextStyle().run()
    };
  }
}), fv = pt.create({
  name: "color",
  addOptions() {
    return {
      types: ["textStyle"]
    };
  },
  addGlobalAttributes() {
    return [
      {
        types: this.options.types,
        attributes: {
          color: {
            default: null,
            parseHTML: (e) => {
              var n;
              const t = (n = Zl(e, "color")) != null ? n : e.style.color;
              return t == null ? void 0 : t.replace(/['"]+/g, "");
            },
            renderHTML: (e) => e.color ? {
              style: `color: ${e.color}`
            } : {}
          }
        }
      }
    ];
  },
  addCommands() {
    return {
      setColor: (e) => ({ chain: n }) => n().setMark("textStyle", { color: e }).run(),
      unsetColor: () => ({ chain: e }) => e().setMark("textStyle", { color: null }).removeEmptyTextStyle().run()
    };
  }
}), Q5 = pt.create({
  name: "fontFamily",
  addOptions() {
    return {
      types: ["textStyle"]
    };
  },
  addGlobalAttributes() {
    return [
      {
        types: this.options.types,
        attributes: {
          fontFamily: {
            default: null,
            // Prefer the raw inline `style` attribute so unquoted or
            // single-quoted multi-word names are preserved instead of being
            // canonicalized by `element.style.fontFamily`, which forces double
            // quotes that then get HTML-encoded to `&quot;` on serialization.
            parseHTML: (e) => {
              var n;
              return (n = Zl(e, "font-family")) != null ? n : e.style.fontFamily;
            },
            renderHTML: (e) => e.fontFamily ? {
              style: `font-family: ${e.fontFamily}`
            } : {}
          }
        }
      }
    ];
  },
  addCommands() {
    return {
      setFontFamily: (e) => ({ chain: n }) => n().setMark("textStyle", { fontFamily: e }).run(),
      unsetFontFamily: () => ({ chain: e }) => e().setMark("textStyle", { fontFamily: null }).removeEmptyTextStyle().run()
    };
  }
}), hv = pt.create({
  name: "fontSize",
  addOptions() {
    return {
      types: ["textStyle"]
    };
  },
  addGlobalAttributes() {
    return [
      {
        types: this.options.types,
        attributes: {
          fontSize: {
            default: null,
            // Prefer the raw inline `style` attribute so the original format
            // is preserved instead of the canonicalized value returned by
            // `element.style.fontSize`.
            parseHTML: (e) => {
              var n;
              return (n = Zl(e, "font-size")) != null ? n : e.style.fontSize;
            },
            renderHTML: (e) => e.fontSize ? {
              style: `font-size: ${e.fontSize}`
            } : {}
          }
        }
      }
    ];
  },
  addCommands() {
    return {
      setFontSize: (e) => ({ chain: n }) => n().setMark("textStyle", { fontSize: e }).run(),
      unsetFontSize: () => ({ chain: e }) => e().setMark("textStyle", { fontSize: null }).removeEmptyTextStyle().run()
    };
  }
}), bv = pt.create({
  name: "lineHeight",
  addOptions() {
    return {
      types: ["textStyle"]
    };
  },
  addGlobalAttributes() {
    return [
      {
        types: this.options.types,
        attributes: {
          lineHeight: {
            default: null,
            // Prefer the raw inline `style` attribute so the original format
            // is preserved instead of the canonicalized value returned by
            // `element.style.lineHeight`.
            parseHTML: (e) => {
              var n;
              return (n = Zl(e, "line-height")) != null ? n : e.style.lineHeight;
            },
            renderHTML: (e) => e.lineHeight ? {
              style: `line-height: ${e.lineHeight}`
            } : {}
          }
        }
      }
    ];
  },
  addCommands() {
    return {
      setLineHeight: (e) => ({ chain: n }) => n().setMark("textStyle", { lineHeight: e }).run(),
      unsetLineHeight: () => ({ chain: e }) => e().setMark("textStyle", { lineHeight: null }).removeEmptyTextStyle().run()
    };
  }
});
pt.create({
  name: "textStyleKit",
  addExtensions() {
    const e = [];
    return this.options.backgroundColor !== !1 && e.push(X5.configure(this.options.backgroundColor)), this.options.color !== !1 && e.push(fv.configure(this.options.color)), this.options.fontFamily !== !1 && e.push(Q5.configure(this.options.fontFamily)), this.options.fontSize !== !1 && e.push(hv.configure(this.options.fontSize)), this.options.lineHeight !== !1 && e.push(bv.configure(this.options.lineHeight)), this.options.textStyle !== !1 && e.push(cv.configure(this.options.textStyle)), e;
  }
});
var _5 = /(?:^|\s)(==(?!\s+==)((?:[^=]+))==(?!\s+==))$/, eR = /(?:^|\s)(==(?!\s+==)((?:[^=]+))==(?!\s+==))/g, tR = fa.create({
  name: "highlight",
  addOptions() {
    return {
      multicolor: !1,
      HTMLAttributes: {}
    };
  },
  addAttributes() {
    return this.options.multicolor ? {
      color: {
        default: null,
        // Prefer `data-color` (set by our own `renderHTML`) for lossless
        // round-trips. Otherwise parse the raw inline `style` attribute so
        // the original color format (e.g. `#rrggbb`) is preserved instead of
        // the canonicalized `rgb(...)` value from `element.style.backgroundColor`.
        parseHTML: (e) => e.getAttribute("data-color") || Zl(e, "background-color") || e.style.backgroundColor,
        renderHTML: (e) => e.color ? {
          "data-color": e.color,
          style: `background-color: ${e.color}; color: inherit`
        } : {}
      }
    } : {};
  },
  parseHTML() {
    return [
      {
        tag: "mark"
      }
    ];
  },
  renderHTML({ HTMLAttributes: e }) {
    return ["mark", It(this.options.HTMLAttributes, e), 0];
  },
  renderMarkdown: (e, n) => `==${n.renderChildren(e)}==`,
  parseMarkdown: (e, n) => n.applyMark("highlight", n.parseInline(e.tokens || [])),
  markdownTokenizer: {
    name: "highlight",
    level: "inline",
    start: (e) => e.indexOf("=="),
    tokenize(e, n, t) {
      const l = /^(==)([^=]+)(==)/.exec(e);
      if (l) {
        const r = l[2].trim(), o = t.inlineTokens(r);
        return {
          type: "highlight",
          raw: l[0],
          text: r,
          tokens: o
        };
      }
    }
  },
  addCommands() {
    return {
      setHighlight: (e) => ({ commands: n }) => n.setMark(this.name, e),
      toggleHighlight: (e) => ({ commands: n }) => n.toggleMark(this.name, e),
      unsetHighlight: () => ({ commands: e }) => e.unsetMark(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-h": () => this.editor.commands.toggleHighlight()
    };
  },
  addInputRules() {
    return [
      hl({
        find: _5,
        type: this.type
      })
    ];
  },
  addPasteRules() {
    return [
      Da({
        find: eR,
        type: this.type
      })
    ];
  }
}), nR = tR, aR = /(?:^|\s)(!\[(.+|:?)]\((\S+)(?:(?:\s+)["'](\S+)["'])?\))$/, lR = cn.create({
  name: "image",
  addOptions() {
    return {
      inline: !1,
      allowBase64: !1,
      HTMLAttributes: {},
      resize: !1
    };
  },
  inline() {
    return this.options.inline;
  },
  group() {
    return this.options.inline ? "inline" : "block";
  },
  draggable: !0,
  addAttributes() {
    return {
      src: {
        default: null
      },
      alt: {
        default: null
      },
      title: {
        default: null
      },
      width: {
        default: null
      },
      height: {
        default: null
      }
    };
  },
  parseHTML() {
    return [
      {
        tag: this.options.allowBase64 ? "img[src]" : 'img[src]:not([src^="data:"])'
      }
    ];
  },
  renderHTML({ HTMLAttributes: e }) {
    return ["img", It(this.options.HTMLAttributes, e)];
  },
  parseMarkdown: (e, n) => n.createNode("image", {
    src: e.href,
    title: e.title,
    alt: e.text
  }),
  renderMarkdown: (e) => {
    var n, t, a, l, r, o;
    const i = (t = (n = e.attrs) == null ? void 0 : n.src) != null ? t : "", s = (l = (a = e.attrs) == null ? void 0 : a.alt) != null ? l : "", d = (o = (r = e.attrs) == null ? void 0 : r.title) != null ? o : "";
    return d ? `![${s}](${i} "${d}")` : `![${s}](${i})`;
  },
  addNodeView() {
    if (!this.options.resize || !this.options.resize.enabled || typeof document > "u")
      return null;
    const { directions: e, minWidth: n, minHeight: t, alwaysPreserveAspectRatio: a } = this.options.resize;
    return ({ node: l, getPos: r, HTMLAttributes: o, editor: i }) => {
      const s = document.createElement("img");
      Object.entries(o).forEach(([f, b]) => {
        if (b != null)
          switch (f) {
            case "width":
            case "height":
              break;
            default:
              s.setAttribute(f, b);
              break;
          }
      }), s.src = o.src;
      const d = new jE({
        element: s,
        editor: i,
        node: l,
        getPos: r,
        onResize: (f, b) => {
          s.style.width = `${f}px`, s.style.height = `${b}px`;
        },
        onCommit: (f, b) => {
          const h = r();
          h !== void 0 && this.editor.chain().setNodeSelection(h).updateAttributes(this.name, {
            width: f,
            height: b
          }).run();
        },
        onUpdate: (f, b, h) => f.type === l.type,
        options: {
          directions: e,
          min: {
            width: n,
            height: t
          },
          preserveAspectRatio: a === !0
        }
      }), u = d.dom;
      return u.style.visibility = "hidden", u.style.pointerEvents = "none", s.onload = () => {
        u.style.visibility = "", u.style.pointerEvents = "";
      }, d;
    };
  },
  addCommands() {
    return {
      setImage: (e) => ({ commands: n }) => n.insertContent({
        type: this.name,
        attrs: e
      })
    };
  },
  addInputRules() {
    return [
      Fm({
        find: aR,
        type: this.type,
        getAttributes: (e) => {
          const [, , n, t, a] = e;
          return { src: t, alt: n, title: a };
        }
      })
    ];
  }
}), rR = lR;
const oR = {
  "data-testid": "modal-pre-header",
  class: "flex items-center justify-end h-9"
}, iR = { class: "flex-1 min-w-0" }, sR = /* @__PURE__ */ ye({
  inheritAttrs: !1,
  __name: "Modal",
  props: {
    modelValue: { type: Boolean, default: !1 },
    size: { default: "md" },
    showCloseButton: { type: Boolean, default: !0 },
    headerPosition: { default: "left" },
    footerPosition: { default: "right" },
    dismissable: { type: Boolean, default: !0 },
    closeOnEscape: { type: Boolean, default: !0 },
    showFooter: { type: Boolean, default: !0 },
    showHeader: { type: Boolean, default: !0 },
    showHeaderBorder: { type: Boolean, default: !1 },
    showFooterBorder: { type: Boolean, default: !1 },
    contentClass: {},
    headerClass: {},
    overlayClass: {},
    borderGradient: {}
  },
  emits: ["update:modelValue", "close"],
  setup(e, { emit: n }) {
    const t = Fn();
    nn(Hu, null);
    const a = e, l = n, r = () => {
      l("update:modelValue", !1), l("close");
    }, o = () => {
      a.dismissable && r();
    }, i = Symbol("opal-modal"), s = () => Zn(i), d = () => An(i), u = (T) => {
      T.key !== "Escape" || !a.closeOnEscape || !a.modelValue || Va(i) && (T.defaultPrevented || (T.preventDefault(), r()));
    };
    Ie(
      () => a.modelValue,
      (T) => {
        T ? (s(), document.body.style.overflow = "hidden") : (d(), document.body.style.overflow = "");
      }
    ), ot(() => {
      document.addEventListener("keydown", u), a.modelValue && (s(), document.body.style.overflow = "hidden");
    }), kt(() => {
      document.removeEventListener("keydown", u), d(), document.body.style.overflow = "";
    });
    const f = {
      xs: "max-w-[384px]",
      sm: "max-w-[500px]",
      md: "max-w-[704px]",
      lg: "max-w-[996px]",
      xl: "max-w-[1340px]",
      "2xl": "max-w-full"
    }, b = {
      left: "justify-start text-left",
      center: "justify-center text-center"
    }, h = {
      left: "justify-start",
      right: "justify-end",
      center: "justify-center",
      split: "justify-between"
    }, m = p(() => f[a.size]), x = p(() => b[a.headerPosition]), y = p(() => h[a.footerPosition]), w = p(() => a.size === "2xl"), S = p(
      () => a.borderGradient ? { "--Border-gradient": a.borderGradient } : void 0
    ), $ = E(null);
    return Gi({
      active: qn(a, "modelValue"),
      container: $,
      containFocus: !0
    }), (T, L) => (c(), K(Bn, { to: "body" }, [
      te(wt, { name: "modal-fade" }, {
        default: ve(() => [
          e.modelValue ? (c(), g("div", {
            key: 0,
            "data-testid": "modal-backdrop",
            class: C([
              "fixed inset-0 z-50 flex overflow-y-auto overflow-x-hidden",
              w.value ? "p-0" : "p-4",
              e.overlayClass
            ]),
            onClick: Ue(o, ["self"])
          }, [
            v("div", {
              class: "fixed inset-0 bg-black/50 dark:bg-black/70",
              onClick: o
            }),
            v("div", Oe(I(t), {
              "data-testid": "modal-container",
              role: "dialog",
              "aria-modal": "true",
              class: ["relative z-10 w-full m-auto", m.value, w.value ? "h-full" : ""],
              onClick: L[0] || (L[0] = Ue(() => {
              }, ["stop"]))
            }), [
              v("div", {
                ref_key: "panelRef",
                ref: $,
                class: C([
                  "relative flex flex-col bg-white dark:bg-(--colors-background-black-default) modal-container",
                  w.value ? "rounded-none h-full border border-(--colors-border-base-soft) dark:border-(--colors-border-base) shadow-xl" : (
                    // DS rule: constant 30px vertical margin — beyond that the content
                    // scrolls internally and the footer stays pinned.
                    "rounded-[var(--border-border-radius-rounded-base,24px)] p-2 shadow-(--shadow-xl) max-h-[calc(100dvh-60px)]"
                  ),
                  e.contentClass
                ]),
                style: Ne(S.value)
              }, [
                v("div", oR, [
                  e.showCloseButton ? (c(), g("button", {
                    key: 0,
                    "data-testid": "modal-close-button",
                    type: "button",
                    class: "inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-transparent text-(--colors-text-body-subtle) hover:bg-(--colors-background-hover) hover:text-(--colors-text-heading) dark:hover:bg-gray-600 dark:hover:text-white transition-colors duration-200",
                    onClick: r
                  }, [...L[1] || (L[1] = [
                    v("i", { class: "ri-close-line text-lg" }, null, -1),
                    v("span", { class: "sr-only" }, "Close modal", -1)
                  ])])) : k("", !0)
                ]),
                e.showHeader ? (c(), g("div", {
                  key: 0,
                  "data-testid": "modal-header",
                  class: C([
                    [
                      "flex items-center gap-5 pt-0 pb-6 px-6",
                      e.showHeaderBorder && "border-b border-(--colors-border-base-soft) dark:border-(--colors-border-base)"
                    ],
                    x.value,
                    e.headerClass
                  ])
                }, [
                  v("div", iR, [
                    $e(T.$slots, "header", {}, void 0, !0)
                  ])
                ], 2)) : k("", !0),
                v("div", {
                  "data-testid": "modal-content",
                  class: C([
                    "flex-1 flex flex-col gap-5 pt-0 px-6 overflow-y-auto",
                    e.showFooter ? "pb-0" : "pb-6"
                  ])
                }, [
                  $e(T.$slots, "default", {}, void 0, !0)
                ], 2),
                e.showFooter ? (c(), g("div", {
                  key: 1,
                  "data-testid": "modal-footer",
                  class: C([
                    [
                      "flex items-center gap-5 pt-6 pb-6 px-6",
                      e.showFooterBorder && "border-t border-(--colors-border-base-soft) dark:border-(--colors-border-base)"
                    ],
                    y.value
                  ])
                }, [
                  $e(T.$slots, "footer", {}, void 0, !0)
                ], 2)) : k("", !0)
              ], 6)
            ], 16)
          ], 2)) : k("", !0)
        ]),
        _: 3
      })
    ]));
  }
}), za = /* @__PURE__ */ lt(sR, [["__scopeId", "data-v-8e70280f"]]), dR = ["data-type"], uR = ["aria-label"], cR = { class: "flex items-center gap-1 flex-wrap" }, fR = ["disabled", "aria-label", "title"], hR = ["disabled", "aria-label", "title"], bR = ["disabled", "aria-label", "title"], gR = ["disabled", "aria-label", "title"], pR = ["disabled", "aria-label", "title"], mR = ["title"], vR = ["aria-label", "disabled"], xR = ["title"], yR = ["aria-label", "disabled"], kR = ["disabled", "aria-expanded", "aria-label", "title"], wR = ["aria-label"], CR = ["disabled", "aria-label", "title"], SR = ["disabled", "aria-label", "title"], $R = ["disabled", "aria-label", "title"], IR = { class: "flex items-center gap-2 flex-wrap" }, TR = ["disabled", "aria-expanded", "aria-label"], LR = { class: "leading-(--line-height-l)" }, ER = ["aria-label"], AR = ["disabled", "aria-label", "title"], RR = ["disabled", "aria-label", "title"], BR = ["disabled", "aria-label", "title"], MR = ["disabled", "aria-label", "title"], DR = ["disabled", "aria-label", "title"], zR = ["disabled", "aria-expanded", "aria-label", "title"], OR = ["aria-label"], PR = { class: "min-h-0 flex-1 overflow-y-auto" }, FR = {
  key: 0,
  "aria-hidden": "true",
  "data-testid": "rich-text-editor-placeholder",
  class: "pointer-events-none absolute top-[calc(--spacing(3)-1px)] left-[calc(--spacing(3)-1px)] text-(length:--size-m) leading-(--line-height-l) text-(--text-text-body-subtle)"
}, VR = {
  key: 0,
  class: "flex items-start gap-4",
  "data-testid": "rich-text-editor-footer"
}, NR = "w-full flex flex-col items-start gap-0.5 text-left text-(length:--size-m) font-inter", HR = /* @__PURE__ */ ye({
  __name: "RichTextEditor",
  props: {
    type: { default: "Default" },
    modelValue: { default: "" },
    label: { default: void 0 },
    ariaLabel: { default: void 0 },
    required: { type: Boolean, default: !1 },
    requiredIndicator: { default: "*" },
    labelTooltip: { default: void 0 },
    placeholder: { default: void 0 },
    helpText: { default: void 0 },
    error: { default: void 0 },
    disabled: { type: Boolean, default: !1 },
    fullWidth: { type: Boolean, default: !0 },
    width: { default: void 0 },
    minHeight: { default: "184px" },
    resizable: { type: Boolean, default: !1 },
    id: { default: void 0 },
    labels: { default: void 0 },
    actions: { default: () => [] }
  },
  emits: ["update:modelValue", "focus", "blur", "send", "action"],
  setup(e, { emit: n }) {
    const t = `absolute top-[calc(100%+4px)] z-20 min-w-50 w-max ${_o}`, a = {
      toolbar: "Rich text formatting",
      bold: "Bold",
      clearFormatting: "Clear formatting",
      italic: "Italic",
      underline: "Underline",
      strikethrough: "Strikethrough",
      textColor: "Text color",
      highlight: "Highlight",
      alignLeft: "Align left",
      alignCenter: "Align center",
      alignRight: "Align right",
      textFormat: "Text format",
      paragraph: "Paragraph",
      heading1: "Heading 1",
      heading2: "Heading 2",
      heading3: "Heading 3",
      insertLink: "Insert link",
      insertImage: "Insert image",
      bulletList: "Bullet list",
      orderedList: "Ordered list",
      blockquote: "Blockquote",
      linkDialogTitle: "Insert link",
      linkUrlLabel: "URL",
      linkUrlPlaceholder: "https://example.com",
      linkInsert: "Insert",
      linkRemove: "Remove link",
      imageDialogTitle: "Insert image",
      imageUrlLabel: "Image URL",
      imageUrlPlaceholder: "https://example.com/image.png",
      imageInsert: "Insert",
      cancel: "Cancel",
      invalidUrl: "Enter a valid http(s) URL.",
      send: "Send message",
      fontSize: "Font size",
      lineHeight: "Line height",
      defaultStyle: "Default"
    }, l = e, r = p(() => ({ ...a, ...l.labels })), o = n, i = Ve(), s = p(() => l.id || i), d = p(() => l.label ? `${s.value}-label` : void 0), u = p(() => `${s.value}-error`), f = p(() => `${s.value}-help`), b = p(() => !!l.error), h = p(() => {
      const ce = [];
      return b.value && ce.push(u.value), l.helpText && ce.push(f.value), ce.length ? ce.join(" ") : void 0;
    }), m = p(() => d.value ? { "aria-labelledby": d.value } : l.ariaLabel ? { "aria-label": l.ariaLabel } : {}), x = p(
      () => h.value ? { "aria-describedby": h.value } : {}
    ), y = p(() => ({
      id: s.value,
      role: "textbox",
      "aria-multiline": "true",
      "aria-disabled": l.disabled ? "true" : "false",
      "aria-required": l.required ? "true" : "false",
      ...m.value,
      "aria-invalid": b.value ? "true" : "false",
      ...x.value,
      class: "prose prose-sm max-w-none focus:outline-none text-(--text-text-black-default) dark:text-(--colors-text-white-default) min-h-full"
    })), w = ["paragraph", "heading"], S = _E({
      content: l.modelValue,
      editable: !l.disabled,
      extensions: [
        G5.configure({
          // StarterKit v3 already bundles Underline, Link, lists.
          link: {
            openOnClick: !1,
            autolink: !0,
            defaultProtocol: "https"
          }
        }),
        Y5.configure({ types: ["heading", "paragraph"] }),
        cv,
        hv,
        bv.configure({ types: w }),
        fv,
        nR.configure({ multicolor: !0 }),
        rR.configure({ inline: !1 })
      ],
      editorProps: { attributes: y.value },
      onUpdate({ editor: ce }) {
        o("update:modelValue", ce.getHTML());
      },
      onFocus() {
        $.value = !0, o("focus");
      },
      onBlur() {
        $.value = !1, o("blur");
      }
    }), $ = E(!1), T = E(null), L = E(null);
    Ie(
      () => l.modelValue,
      (ce) => {
        var Se, We;
        const pe = (Se = S.value) == null ? void 0 : Se.getHTML();
        ce !== void 0 && ce !== pe && ((We = S.value) == null || We.commands.setContent(ce || "", { emitUpdate: !1 }));
      }
    ), Ie(
      () => l.disabled,
      (ce) => {
        var pe;
        (pe = S.value) == null || pe.setEditable(!ce);
      }
    ), Ie(y, (ce) => {
      var pe;
      (pe = S.value) == null || pe.setOptions({ editorProps: { attributes: ce } });
    }), gt(() => {
      var ce;
      (ce = S.value) == null || ce.destroy();
    });
    const A = p(() => [
      { value: "paragraph", label: r.value.paragraph, shortcut: "⌘⌥0" },
      { value: "h1", label: r.value.heading1, shortcut: "⌘⌥1" },
      { value: "h2", label: r.value.heading2, shortcut: "⌘⌥2" },
      { value: "h3", label: r.value.heading3, shortcut: "⌘⌥3" }
    ]), R = ["12px", "14px", "16px", "18px", "20px", "24px"], z = ["1", "1.25", "1.5", "2"], D = p(() => [
      { value: "", label: r.value.defaultStyle },
      ...R.map((ce) => ({ value: ce, label: ce.replace("px", " px") }))
    ]), V = p(() => [
      { value: "", label: r.value.defaultStyle },
      ...z.map((ce) => ({ value: ce, label: ce }))
    ]), Y = (ce) => {
      var Se;
      const pe = (Se = S.value) == null ? void 0 : Se.chain().focus();
      if (pe) {
        if (ce === "paragraph")
          pe.setParagraph().run();
        else {
          const We = Number(ce.replace("h", ""));
          pe.toggleHeading({ level: We }).run();
        }
        M.value = null;
      }
    }, _ = (ce) => {
      var Se;
      const pe = (Se = S.value) == null ? void 0 : Se.chain().focus();
      ce ? pe == null || pe.setFontSize(ce).run() : pe == null || pe.unsetFontSize().run(), M.value = null;
    }, j = (ce) => {
      var pe;
      (pe = S.value) == null || pe.chain().focus().command(
        ({ commands: Se }) => w.map((We) => Se.updateAttributes(We, { lineHeight: ce || null })).some(Boolean)
      ).run(), M.value = null;
    }, M = E(null), W = E(null), G = E(null), B = E(null), F = { format: W, fontSize: G, lineHeight: B }, X = (ce) => {
      l.disabled || (M.value = M.value === ce ? null : ce);
    }, H = E(null), q = E(!1), N = async () => {
      var We;
      q.value = !1;
      const ce = M.value;
      if (!ce) return;
      await qe();
      const pe = (We = F[ce].value) == null ? void 0 : We.querySelector('[role="menu"]'), Se = H.value;
      !pe || !Se || M.value !== ce || (q.value = pe.getBoundingClientRect().right > Se.getBoundingClientRect().right);
    };
    Ie(M, N);
    const J = (ce) => Array.from(ce.querySelectorAll('[role="menuitemradio"]'));
    Ie(M, async (ce) => {
      var We, St;
      if (!ce) return;
      await qe();
      const pe = (We = F[ce].value) == null ? void 0 : We.querySelector('[role="menu"]');
      if (!pe) return;
      const Se = J(pe);
      (St = Se.find((Wa) => Wa.getAttribute("aria-checked") === "true") ?? Se[0]) == null || St.focus();
    });
    const be = (ce) => {
      if (ce.key === "Tab") {
        M.value = null;
        return;
      }
      const pe = J(ce.currentTarget), Se = pe.indexOf(document.activeElement), We = {
        ArrowDown: (Se + 1) % pe.length,
        ArrowUp: (Se - 1 + pe.length) % pe.length,
        Home: 0,
        End: pe.length - 1
      }[ce.key];
      We === void 0 || !pe.length || (ce.preventDefault(), pe[We].focus());
    }, ke = (ce) => {
      var pe, Se;
      return (Se = (pe = F[ce].value) == null ? void 0 : pe.querySelector('[aria-haspopup="menu"]')) == null ? void 0 : Se.focus();
    }, ee = () => {
      M.value && N();
    }, oe = (ce) => {
      if (!M.value) return;
      const pe = F[M.value].value;
      pe && !pe.contains(ce.target) && (M.value = null);
    }, ge = (ce) => {
      if (M.value && ce.key === "Escape") {
        ce.stopPropagation(), ce.preventDefault();
        const pe = M.value;
        M.value = null, ke(pe);
      }
    };
    ot(() => {
      document.addEventListener("mousedown", oe), document.addEventListener("keydown", ge), window.addEventListener("resize", ee);
    }), gt(() => {
      document.removeEventListener("mousedown", oe), document.removeEventListener("keydown", ge), window.removeEventListener("resize", ee);
    });
    const re = (ce) => {
      var Se;
      const pe = ce.target.value;
      (Se = S.value) == null || Se.chain().focus().setColor(pe).run();
    }, ue = (ce) => {
      var Se;
      const pe = ce.target.value;
      (Se = S.value) == null || Se.chain().focus().toggleHighlight({ color: pe }).run();
    }, O = E(!1), U = E(""), Q = E(!1), ae = E(!1), Z = E(""), ie = E(!1), fe = `rich-text-editor-link-title-${Ve()}`, de = `rich-text-editor-image-title-${Ve()}`;
    function ne(ce) {
      try {
        const pe = new URL(ce);
        return pe.protocol === "http:" || pe.protocol === "https:";
      } catch {
        return !1;
      }
    }
    const le = (ce) => {
      var pe;
      return (pe = ce == null ? void 0 : ce.currentTarget) == null ? void 0 : pe.focus();
    }, Le = (ce) => {
      var Se;
      if (l.disabled) return;
      le(ce);
      const pe = (Se = S.value) == null ? void 0 : Se.getAttributes("link").href;
      U.value = pe ?? "", Q.value = !1, O.value = !0;
    }, Te = () => {
      var ce;
      (ce = S.value) == null || ce.chain().extendMarkRange("link").unsetLink().run(), O.value = !1;
    }, xe = () => {
      var pe;
      const ce = U.value.trim();
      if (ce === "") {
        Te();
        return;
      }
      if (!ne(ce)) {
        Q.value = !0;
        return;
      }
      (pe = S.value) == null || pe.chain().extendMarkRange("link").setLink({ href: ce, target: "_blank", rel: "noopener noreferrer" }).run(), O.value = !1;
    }, we = () => {
      O.value = !1;
    }, he = (ce) => {
      l.disabled || (le(ce), Z.value = "", ie.value = !1, ae.value = !0);
    }, De = () => {
      var pe;
      const ce = Z.value.trim();
      if (!ne(ce)) {
        ie.value = !0;
        return;
      }
      (pe = S.value) == null || pe.chain().setImage({ src: ce }).run(), ae.value = !1;
    }, Ee = () => {
      ae.value = !1;
    }, je = (ce, pe) => {
      ce.key === "Enter" && (ce.preventDefault(), pe());
    }, Ge = () => {
      var ce;
      (ce = S.value) == null || ce.chain().focus().clearNodes().unsetAllMarks().run();
    }, Qe = (ce, pe) => S.value ? typeof ce == "string" ? S.value.isActive(ce, {}) : S.value.isActive(ce) : !1, Ce = p(() => S.value ? S.value.isActive("heading", { level: 1 }) ? "h1" : S.value.isActive("heading", { level: 2 }) ? "h2" : S.value.isActive("heading", { level: 3 }) ? "h3" : "paragraph" : "paragraph"), me = p(
      () => {
        var ce;
        return ((ce = S.value) == null ? void 0 : ce.getAttributes("textStyle").fontSize) ?? "";
      }
    ), Ae = p(() => w.map((pe) => {
      var Se;
      return (Se = S.value) == null ? void 0 : Se.getAttributes(pe).lineHeight;
    }).find(Boolean) ?? ""), Ke = p(
      () => {
        var ce;
        return ((ce = A.value.find((pe) => pe.value === Ce.value)) == null ? void 0 : ce.label) ?? r.value.paragraph;
      }
    ), Je = p(() => l.type === "Buttons inside"), _e = p(() => l.type === "Buttons outside"), At = p(() => !!S.value && !S.value.isEmpty), Be = p(() => {
      var Se;
      const ce = (Se = S.value) == null ? void 0 : Se.state.doc, pe = (ce == null ? void 0 : ce.childCount) === 1 ? ce.firstChild : null;
      return !!l.placeholder && (pe == null ? void 0 : pe.type.name) === "paragraph" && pe.content.size === 0;
    }), ze = p(
      () => l.disabled ? "border-(--border-border-disabled-subtle) dark:border-(--colors-border-disabled-subtle)" : "border-(--border-border-base-medium) dark:border-(--border-border-base)"
    ), He = p(
      () => l.disabled ? `bg-(--background-background-disabled-opacity) dark:bg-(--colors-background-disabled) ${ze.value}` : `bg-(--background-background-white) dark:bg-(--background-background-black-default) ${ze.value}`
    ), it = p(() => l.type === "Default"), Ct = p(() => {
      const ce = "flex flex-col rounded-(--border-border-radius-rounded-l) shadow-(--blur-shadow-xs)";
      if (it.value) return `${ce} gap-0.5`;
      const pe = `${ce} dark:shadow-(--blur-shadow-m-dark)`;
      return Je.value ? `${pe} border border-solid ${ze.value}` : pe;
    }), Yt = p(
      () => it.value ? "flex flex-col rounded-(--border-border-radius-rounded-l) dark:shadow-(--blur-shadow-m-dark)" : "flex flex-col"
    ), Dn = p(() => `flex flex-col gap-2 border-solid rounded-t-(--border-border-radius-rounded-l) px-[calc(--spacing(3)-1px)] pt-[calc(--spacing(3)-1px)] ${Je.value ? "-mx-px -mt-px border-x border-t pb-3" : "border pb-[calc(--spacing(3)-1px)]"} ${He.value}`), gs = p(() => {
      const ce = Je.value ? "-mx-px" : "rounded-b-(--border-border-radius-rounded-l)", pe = l.resizable && !l.disabled ? "resize-y" : "", Se = `relative flex flex-col overflow-hidden border border-solid p-[calc(--spacing(3)-1px)] ${ce} ${pe}`, We = Je.value ? "" : "border-t-transparent dark:border-t-transparent", St = "shadow-[0_0_2px_2px_var(--background-background-hover)]", Wa = "shadow-(--blur-shadow-xs) dark:shadow-(--blur-shadow-m-dark)";
      return l.disabled ? `${Se} ${We} ${He.value} cursor-not-allowed` : b.value ? `${Se} ${$.value ? St : Wa} bg-(--background-background-white) dark:bg-(--background-background-black-default) border-(--border-border-error-strong) dark:border-(--border-border-error)` : $.value ? `${Se} ${St} bg-(--background-background-selected) dark:bg-(--background-background-black-default) border-(--border-border-accent)` : `${Se} ${We} ${At.value ? "" : Wa} ${He.value}`;
    }), ps = p(
      () => `-mx-px -mb-px flex items-center gap-4 border-x border-b border-solid rounded-b-(--border-border-radius-rounded-l) px-[calc(--spacing(3)-1px)] pt-3 pb-[calc(--spacing(3)-1px)] ${He.value}`
    ), so = () => {
      var ce;
      return o("send", ((ce = S.value) == null ? void 0 : ce.getHTML()) ?? l.modelValue);
    }, uo = (ce) => o("action", ce), co = p(() => l.fullWidth ? {} : l.width ? { width: l.width } : {}), fo = (ce) => {
      var pe, Se;
      l.disabled || (pe = ce.target) != null && pe.closest("[data-field-label-tooltip]") || (Se = S.value) == null || Se.commands.focus();
    };
    return (ce, pe) => (c(), g("div", {
      class: C(NR),
      style: Ne(co.value),
      "data-type": e.type
    }, [
      e.label ? (c(), K(xt, {
        key: 0,
        id: d.value,
        ref_key: "labelRef",
        ref: T,
        text: e.label,
        required: e.required,
        "required-indicator": e.requiredIndicator,
        tooltip: e.labelTooltip,
        focused: $.value,
        "test-id": "rich-text-editor-label",
        class: C(!e.disabled && "cursor-pointer"),
        onClick: fo
      }, null, 8, ["id", "text", "required", "required-indicator", "tooltip", "focused", "class"])) : k("", !0),
      v("div", {
        class: C(["self-stretch flex flex-col", _e.value && "gap-4"])
      }, [
        v("div", {
          ref_key: "fieldRef",
          ref: H,
          class: C(Ct.value),
          "data-testid": "rich-text-editor-field"
        }, [
          v("div", {
            class: C(Yt.value),
            "data-testid": "rich-text-editor-box"
          }, [
            v("div", {
              class: C(Dn.value),
              role: "toolbar",
              "aria-label": r.value.toolbar,
              "data-testid": "rich-text-editor-toolbar"
            }, [
              v("div", cR, [
                v("button", {
                  type: "button",
                  class: C(["toolbar-btn", { "is-active": Qe("bold") }]),
                  disabled: e.disabled,
                  "aria-label": r.value.bold,
                  title: r.value.bold,
                  onClick: pe[0] || (pe[0] = (Se) => {
                    var We;
                    return (We = I(S)) == null ? void 0 : We.chain().focus().toggleBold().run();
                  })
                }, [...pe[20] || (pe[20] = [
                  v("i", {
                    class: "ri-bold",
                    "aria-hidden": "true"
                  }, null, -1)
                ])], 10, fR),
                v("button", {
                  type: "button",
                  class: "toolbar-btn",
                  disabled: e.disabled,
                  "aria-label": r.value.clearFormatting,
                  title: r.value.clearFormatting,
                  onClick: Ge
                }, [...pe[21] || (pe[21] = [
                  v("i", {
                    class: "ri-format-clear",
                    "aria-hidden": "true"
                  }, null, -1)
                ])], 8, hR),
                v("button", {
                  type: "button",
                  class: C(["toolbar-btn", { "is-active": Qe("italic") }]),
                  disabled: e.disabled,
                  "aria-label": r.value.italic,
                  title: r.value.italic,
                  onClick: pe[1] || (pe[1] = (Se) => {
                    var We;
                    return (We = I(S)) == null ? void 0 : We.chain().focus().toggleItalic().run();
                  })
                }, [...pe[22] || (pe[22] = [
                  v("i", {
                    class: "ri-italic",
                    "aria-hidden": "true"
                  }, null, -1)
                ])], 10, bR),
                v("button", {
                  type: "button",
                  class: C(["toolbar-btn", { "is-active": Qe("underline") }]),
                  disabled: e.disabled,
                  "aria-label": r.value.underline,
                  title: r.value.underline,
                  onClick: pe[2] || (pe[2] = (Se) => {
                    var We;
                    return (We = I(S)) == null ? void 0 : We.chain().focus().toggleUnderline().run();
                  })
                }, [...pe[23] || (pe[23] = [
                  v("i", {
                    class: "ri-underline",
                    "aria-hidden": "true"
                  }, null, -1)
                ])], 10, gR),
                v("button", {
                  type: "button",
                  class: C(["toolbar-btn", { "is-active": Qe("strike") }]),
                  disabled: e.disabled,
                  "aria-label": r.value.strikethrough,
                  title: r.value.strikethrough,
                  onClick: pe[3] || (pe[3] = (Se) => {
                    var We;
                    return (We = I(S)) == null ? void 0 : We.chain().focus().toggleStrike().run();
                  })
                }, [...pe[24] || (pe[24] = [
                  v("i", {
                    class: "ri-strikethrough",
                    "aria-hidden": "true"
                  }, null, -1)
                ])], 10, pR),
                v("label", {
                  class: C(["toolbar-btn relative cursor-pointer", { "opacity-50 cursor-not-allowed": e.disabled }]),
                  title: r.value.textColor
                }, [
                  pe[25] || (pe[25] = v("i", {
                    class: "ri-font-color",
                    "aria-hidden": "true"
                  }, null, -1)),
                  v("input", {
                    type: "color",
                    "aria-label": r.value.textColor,
                    class: "absolute inset-0 opacity-0 cursor-pointer",
                    disabled: e.disabled,
                    onInput: re
                  }, null, 40, vR)
                ], 10, mR),
                v("label", {
                  class: C(["toolbar-btn relative cursor-pointer", {
                    "is-active": Qe("highlight"),
                    "opacity-50 cursor-not-allowed": e.disabled
                  }]),
                  title: r.value.highlight
                }, [
                  pe[26] || (pe[26] = v("i", {
                    class: "ri-mark-pen-line",
                    "aria-hidden": "true"
                  }, null, -1)),
                  v("input", {
                    type: "color",
                    "aria-label": r.value.highlight,
                    class: "absolute inset-0 opacity-0 cursor-pointer",
                    disabled: e.disabled,
                    onInput: ue
                  }, null, 40, yR)
                ], 10, xR),
                v("div", {
                  ref_key: "fontSizeWrapperRef",
                  ref: G,
                  class: "relative"
                }, [
                  v("button", {
                    type: "button",
                    class: C(["toolbar-btn", { "is-active": M.value === "fontSize" }]),
                    disabled: e.disabled,
                    "aria-expanded": M.value === "fontSize",
                    "aria-haspopup": "menu",
                    "aria-label": r.value.fontSize,
                    title: r.value.fontSize,
                    onClick: pe[4] || (pe[4] = (Se) => X("fontSize"))
                  }, [...pe[27] || (pe[27] = [
                    v("i", {
                      class: "ri-font-size",
                      "aria-hidden": "true"
                    }, null, -1)
                  ])], 10, kR),
                  M.value === "fontSize" ? (c(), g("div", {
                    key: 0,
                    role: "menu",
                    "aria-label": r.value.fontSize,
                    class: C([t, q.value ? "right-0 left-auto" : "left-0"]),
                    onKeydown: be
                  }, [
                    (c(!0), g(se, null, Me(D.value, (Se) => (c(), K(Gt, {
                      key: Se.value,
                      as: "button",
                      type: "default",
                      role: "menuitemradio",
                      tabindex: "-1",
                      label: Se.label,
                      selected: me.value === Se.value,
                      "aria-checked": me.value === Se.value,
                      onClick: (We) => _(Se.value)
                    }, null, 8, ["label", "selected", "aria-checked", "onClick"]))), 128))
                  ], 42, wR)) : k("", !0)
                ], 512),
                pe[31] || (pe[31] = v("span", {
                  class: "mx-1 inline-block w-px h-4 bg-(--colors-background-gray)",
                  "aria-hidden": "true"
                }, null, -1)),
                v("button", {
                  type: "button",
                  class: C(["toolbar-btn", { "is-active": Qe({ textAlign: "left" }) }]),
                  disabled: e.disabled,
                  "aria-label": r.value.alignLeft,
                  title: r.value.alignLeft,
                  onClick: pe[5] || (pe[5] = (Se) => {
                    var We;
                    return (We = I(S)) == null ? void 0 : We.chain().focus().setTextAlign("left").run();
                  })
                }, [...pe[28] || (pe[28] = [
                  v("i", {
                    class: "ri-align-left",
                    "aria-hidden": "true"
                  }, null, -1)
                ])], 10, CR),
                v("button", {
                  type: "button",
                  class: C(["toolbar-btn", { "is-active": Qe({ textAlign: "center" }) }]),
                  disabled: e.disabled,
                  "aria-label": r.value.alignCenter,
                  title: r.value.alignCenter,
                  onClick: pe[6] || (pe[6] = (Se) => {
                    var We;
                    return (We = I(S)) == null ? void 0 : We.chain().focus().setTextAlign("center").run();
                  })
                }, [...pe[29] || (pe[29] = [
                  v("i", {
                    class: "ri-align-center",
                    "aria-hidden": "true"
                  }, null, -1)
                ])], 10, SR),
                v("button", {
                  type: "button",
                  class: C(["toolbar-btn", { "is-active": Qe({ textAlign: "right" }) }]),
                  disabled: e.disabled,
                  "aria-label": r.value.alignRight,
                  title: r.value.alignRight,
                  onClick: pe[7] || (pe[7] = (Se) => {
                    var We;
                    return (We = I(S)) == null ? void 0 : We.chain().focus().setTextAlign("right").run();
                  })
                }, [...pe[30] || (pe[30] = [
                  v("i", {
                    class: "ri-align-right",
                    "aria-hidden": "true"
                  }, null, -1)
                ])], 10, $R)
              ]),
              v("div", IR, [
                v("div", {
                  ref_key: "formatWrapperRef",
                  ref: W,
                  class: "relative"
                }, [
                  v("button", {
                    type: "button",
                    class: C(["format-btn", { "is-open": M.value === "format" }]),
                    disabled: e.disabled,
                    "aria-expanded": M.value === "format",
                    "aria-haspopup": "menu",
                    "aria-label": r.value.textFormat,
                    onClick: pe[8] || (pe[8] = (Se) => X("format"))
                  }, [
                    v("span", LR, P(Ke.value), 1),
                    pe[32] || (pe[32] = v("i", {
                      class: "ri-arrow-down-s-line text-(length:--size-m)",
                      "aria-hidden": "true"
                    }, null, -1))
                  ], 10, TR),
                  M.value === "format" ? (c(), g("div", {
                    key: 0,
                    role: "menu",
                    "aria-label": r.value.textFormat,
                    class: C([t, q.value ? "right-0 left-auto" : "left-0"]),
                    onKeydown: be
                  }, [
                    (c(!0), g(se, null, Me(A.value, (Se) => (c(), K(Gt, {
                      key: Se.value,
                      as: "button",
                      type: "secondary-text",
                      role: "menuitemradio",
                      tabindex: "-1",
                      label: Se.label,
                      "secondary-label": Se.shortcut,
                      "aria-label": Se.label,
                      selected: Ce.value === Se.value,
                      "aria-checked": Ce.value === Se.value,
                      onClick: (We) => Y(Se.value)
                    }, null, 8, ["label", "secondary-label", "aria-label", "selected", "aria-checked", "onClick"]))), 128))
                  ], 42, ER)) : k("", !0)
                ], 512),
                v("button", {
                  type: "button",
                  class: C(["toolbar-btn", { "is-active": Qe("link") }]),
                  disabled: e.disabled,
                  "aria-label": r.value.insertLink,
                  title: r.value.insertLink,
                  onClick: Le
                }, [...pe[33] || (pe[33] = [
                  v("i", {
                    class: "ri-link",
                    "aria-hidden": "true"
                  }, null, -1)
                ])], 10, AR),
                v("button", {
                  type: "button",
                  class: "toolbar-btn",
                  disabled: e.disabled,
                  "aria-label": r.value.insertImage,
                  title: r.value.insertImage,
                  onClick: he
                }, [...pe[34] || (pe[34] = [
                  v("i", {
                    class: "ri-image-line",
                    "aria-hidden": "true"
                  }, null, -1)
                ])], 8, RR),
                v("button", {
                  type: "button",
                  class: C(["toolbar-btn", { "is-active": Qe("bulletList") }]),
                  disabled: e.disabled,
                  "aria-label": r.value.bulletList,
                  title: r.value.bulletList,
                  onClick: pe[9] || (pe[9] = (Se) => {
                    var We;
                    return (We = I(S)) == null ? void 0 : We.chain().focus().toggleBulletList().run();
                  })
                }, [...pe[35] || (pe[35] = [
                  v("i", {
                    class: "ri-list-unordered",
                    "aria-hidden": "true"
                  }, null, -1)
                ])], 10, BR),
                v("button", {
                  type: "button",
                  class: C(["toolbar-btn", { "is-active": Qe("orderedList") }]),
                  disabled: e.disabled,
                  "aria-label": r.value.orderedList,
                  title: r.value.orderedList,
                  onClick: pe[10] || (pe[10] = (Se) => {
                    var We;
                    return (We = I(S)) == null ? void 0 : We.chain().focus().toggleOrderedList().run();
                  })
                }, [...pe[36] || (pe[36] = [
                  v("i", {
                    class: "ri-list-ordered",
                    "aria-hidden": "true"
                  }, null, -1)
                ])], 10, MR),
                v("button", {
                  type: "button",
                  class: C(["toolbar-btn", { "is-active": Qe("blockquote") }]),
                  disabled: e.disabled,
                  "aria-label": r.value.blockquote,
                  title: r.value.blockquote,
                  onClick: pe[11] || (pe[11] = (Se) => {
                    var We;
                    return (We = I(S)) == null ? void 0 : We.chain().focus().toggleBlockquote().run();
                  })
                }, [...pe[37] || (pe[37] = [
                  v("i", {
                    class: "ri-double-quotes-l",
                    "aria-hidden": "true"
                  }, null, -1)
                ])], 10, DR),
                v("div", {
                  ref_key: "lineHeightWrapperRef",
                  ref: B,
                  class: "relative"
                }, [
                  v("button", {
                    type: "button",
                    class: C(["toolbar-btn", { "is-active": M.value === "lineHeight" }]),
                    disabled: e.disabled,
                    "aria-expanded": M.value === "lineHeight",
                    "aria-haspopup": "menu",
                    "aria-label": r.value.lineHeight,
                    title: r.value.lineHeight,
                    onClick: pe[12] || (pe[12] = (Se) => X("lineHeight"))
                  }, [...pe[38] || (pe[38] = [
                    v("i", {
                      class: "ri-line-height",
                      "aria-hidden": "true"
                    }, null, -1)
                  ])], 10, zR),
                  M.value === "lineHeight" ? (c(), g("div", {
                    key: 0,
                    role: "menu",
                    "aria-label": r.value.lineHeight,
                    class: C([t, q.value ? "right-0 left-auto" : "left-0"]),
                    onKeydown: be
                  }, [
                    (c(!0), g(se, null, Me(V.value, (Se) => (c(), K(Gt, {
                      key: Se.value,
                      as: "button",
                      type: "default",
                      role: "menuitemradio",
                      tabindex: "-1",
                      label: Se.label,
                      selected: Ae.value === Se.value,
                      "aria-checked": Ae.value === Se.value,
                      onClick: (We) => j(Se.value)
                    }, null, 8, ["label", "selected", "aria-checked", "onClick"]))), 128))
                  ], 42, OR)) : k("", !0)
                ], 512)
              ])
            ], 10, uR),
            v("div", {
              class: C(gs.value),
              style: Ne({ minHeight: e.minHeight }),
              "data-testid": "rich-text-editor-content"
            }, [
              v("div", PR, [
                I(S) ? (c(), K(I(QE), {
                  key: 0,
                  editor: I(S),
                  "data-testid": "rich-text-editor",
                  class: "text-(length:--size-m) leading-(--line-height-l)",
                  onKeydown: pe[13] || (pe[13] = (Se) => {
                    var We, St;
                    (We = T.value) == null || We.handleFieldKeydown(Se), (St = L.value) == null || St.handleFieldKeydown(Se);
                  })
                }, null, 8, ["editor"])) : k("", !0)
              ]),
              Be.value ? (c(), g("span", FR, P(e.placeholder), 1)) : k("", !0),
              e.resizable && !e.disabled ? (c(), K(Ag, {
                key: 1,
                class: "absolute right-[calc(--spacing(2)-1px)] bottom-[calc(--spacing(2)-1px)]"
              })) : k("", !0)
            ], 6)
          ], 2),
          it.value ? (c(), K(vt, {
            key: 0,
            ref_key: "helperRef",
            ref: L,
            focused: $.value,
            hint: e.helpText,
            error: e.error,
            "hint-id": f.value,
            "error-id": u.value,
            "test-id-prefix": "rich-text-editor"
          }, null, 8, ["focused", "hint", "error", "hint-id", "error-id"])) : k("", !0),
          Je.value ? (c(), g("div", {
            key: 1,
            class: C(ps.value),
            "data-testid": "rich-text-editor-footer"
          }, [
            te(ti, {
              class: "shrink-0",
              labels: { send: r.value.send },
              actions: e.actions,
              disabled: e.disabled,
              onSend: so,
              onAction: uo
            }, null, 8, ["labels", "actions", "disabled"]),
            te(vt, {
              ref_key: "helperRef",
              ref: L,
              class: "min-w-0 flex-1",
              focused: $.value,
              hint: e.helpText,
              error: e.error,
              "hint-id": f.value,
              "error-id": u.value,
              "test-id-prefix": "rich-text-editor"
            }, null, 8, ["focused", "hint", "error", "hint-id", "error-id"])
          ], 2)) : k("", !0)
        ], 2),
        _e.value ? (c(), g("div", VR, [
          te(ti, {
            class: "shrink-0",
            labels: { send: r.value.send },
            actions: e.actions,
            disabled: e.disabled,
            onSend: so,
            onAction: uo
          }, null, 8, ["labels", "actions", "disabled"]),
          te(vt, {
            ref_key: "helperRef",
            ref: L,
            class: "min-w-0 flex-1",
            focused: $.value,
            hint: e.helpText,
            error: e.error,
            "hint-id": f.value,
            "error-id": u.value,
            "test-id-prefix": "rich-text-editor"
          }, null, 8, ["focused", "hint", "error", "hint-id", "error-id"])
        ])) : k("", !0)
      ], 2),
      te(za, {
        modelValue: O.value,
        "onUpdate:modelValue": pe[16] || (pe[16] = (Se) => O.value = Se),
        size: "sm",
        "aria-labelledby": fe
      }, {
        header: ve(() => [
          v("h2", {
            id: fe,
            class: "text-(length:--size-l) leading-(--line-height-xxl) font-(--weight-bold) text-(--text-text-black-default) dark:text-(--text-text-white-default)"
          }, P(r.value.linkDialogTitle), 1)
        ]),
        footer: ve(() => [
          te(Re, {
            class: "mr-auto",
            variant: "tertiary",
            label: r.value.linkRemove,
            onClick: Te
          }, null, 8, ["label"]),
          te(Re, {
            variant: "secondary",
            label: r.value.cancel,
            onClick: we
          }, null, 8, ["label"]),
          te(Re, {
            variant: "primary",
            label: r.value.linkInsert,
            onClick: xe
          }, null, 8, ["label"])
        ]),
        default: ve(() => [
          te(zt, {
            "model-value": U.value,
            type: "url",
            label: r.value.linkUrlLabel,
            placeholder: r.value.linkUrlPlaceholder,
            error: Q.value ? r.value.invalidUrl : void 0,
            "full-width": "",
            "onUpdate:modelValue": pe[14] || (pe[14] = (Se) => {
              U.value = Se, Q.value = !1;
            }),
            onKeydown: pe[15] || (pe[15] = (Se) => je(Se, xe))
          }, null, 8, ["model-value", "label", "placeholder", "error"])
        ]),
        _: 1
      }, 8, ["modelValue"]),
      te(za, {
        modelValue: ae.value,
        "onUpdate:modelValue": pe[19] || (pe[19] = (Se) => ae.value = Se),
        size: "xs",
        "aria-labelledby": de
      }, {
        header: ve(() => [
          v("h2", {
            id: de,
            class: "text-(length:--size-l) leading-(--line-height-xxl) font-(--weight-bold) text-(--text-text-black-default) dark:text-(--text-text-white-default)"
          }, P(r.value.imageDialogTitle), 1)
        ]),
        footer: ve(() => [
          te(Re, {
            variant: "secondary",
            label: r.value.cancel,
            onClick: Ee
          }, null, 8, ["label"]),
          te(Re, {
            variant: "primary",
            label: r.value.imageInsert,
            onClick: De
          }, null, 8, ["label"])
        ]),
        default: ve(() => [
          te(zt, {
            "model-value": Z.value,
            type: "url",
            label: r.value.imageUrlLabel,
            placeholder: r.value.imageUrlPlaceholder,
            error: ie.value ? r.value.invalidUrl : void 0,
            "full-width": "",
            "onUpdate:modelValue": pe[17] || (pe[17] = (Se) => {
              Z.value = Se, ie.value = !1;
            }),
            onKeydown: pe[18] || (pe[18] = (Se) => je(Se, De))
          }, null, 8, ["model-value", "label", "placeholder", "error"])
        ]),
        _: 1
      }, 8, ["modelValue"])
    ], 12, dR));
  }
}), UW = /* @__PURE__ */ lt(HR, [["__scopeId", "data-v-3885850c"]]), jR = /* @__PURE__ */ ye({
  __name: "EmailInput",
  props: {
    modelValue: { default: "" },
    placeholder: { default: void 0 },
    label: { default: void 0 },
    required: { type: Boolean, default: !1 },
    requiredIndicator: { default: "*" },
    success: { type: Boolean, default: !1 },
    labelTooltip: { default: void 0 },
    labels: { default: () => ({ clear: "Clear input" }) },
    disabled: { type: Boolean, default: !1 },
    readonly: { type: Boolean, default: !1 },
    size: { default: "md" },
    name: { default: void 0 },
    id: { default: void 0 },
    fullWidth: { type: Boolean, default: !1 },
    width: { default: void 0 },
    iconLeft: { default: void 0 },
    hint: { default: void 0 },
    labelInline: { type: Boolean, default: !1 },
    autocomplete: { default: "off" },
    error: { default: void 0 },
    validator: { type: Function, default: void 0 },
    validateOnBlur: { type: Boolean, default: !0 },
    validateOnInput: { type: Boolean, default: !1 },
    invalidEmailMessage: { default: "Please enter a valid email address" },
    requiredMessage: { default: "Email is required" }
  },
  emits: ["update:modelValue", "input", "focus", "blur", "validation-change"],
  setup(e, { expose: n, emit: t }) {
    const a = Ht(), l = e, r = t, o = E(void 0), i = E(!1), s = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/, d = (w) => {
      if (l.validator)
        return l.validator(w) ?? void 0;
      if (l.required && !w.trim())
        return l.requiredMessage;
      if (w.trim() && !s.test(w))
        return l.invalidEmailMessage;
    }, u = () => {
      const w = d(l.modelValue ?? "");
      o.value = w, r("validation-change", !w, w);
    }, f = p(() => {
      if (l.error) return l.error;
      if (i.value) return o.value;
    }), b = (w) => {
      const S = w.target;
      r("update:modelValue", S.value), r("input", w), l.validateOnInput && u();
    }, h = (w) => {
      r("focus", w);
    }, m = (w) => {
      i.value = !0, r("blur", w), l.validateOnBlur && u();
    };
    return Ie(
      () => l.modelValue,
      () => {
        i.value && (l.validateOnBlur || l.validateOnInput) && u();
      }
    ), Ie(
      () => l.error,
      (w) => {
        w && (o.value = void 0);
      }
    ), n({
      validate: () => (i.value = !0, u(), !o.value),
      resetValidation: () => {
        i.value = !1, o.value = void 0;
      }
    }), (w, S) => (c(), K(zt, {
      id: e.id,
      "model-value": e.modelValue,
      placeholder: e.placeholder,
      label: e.label,
      required: e.required,
      "required-indicator": e.requiredIndicator,
      success: e.success,
      "label-tooltip": e.labelTooltip,
      labels: e.labels,
      disabled: e.disabled,
      readonly: e.readonly,
      size: e.size,
      name: e.name,
      "full-width": e.fullWidth,
      width: e.width,
      "icon-left": e.iconLeft,
      hint: e.hint,
      "label-inline": e.labelInline,
      error: f.value,
      type: "email",
      inputmode: "email",
      autocomplete: e.autocomplete,
      "data-testid": "email-input",
      "onUpdate:modelValue": S[0] || (S[0] = ($) => r("update:modelValue", $)),
      onInput: b,
      onFocus: h,
      onBlur: m
    }, _n({ _: 2 }, [
      I(a)("actions") ? {
        name: "actions",
        fn: ve(() => [
          $e(w.$slots, "actions")
        ]),
        key: "0"
      } : void 0
    ]), 1032, ["id", "model-value", "placeholder", "label", "required", "required-indicator", "success", "label-tooltip", "labels", "disabled", "readonly", "size", "name", "full-width", "width", "icon-left", "hint", "label-inline", "error", "autocomplete"]));
  }
}), WR = ["disabled", "aria-pressed", "aria-controls", "aria-label"], GW = /* @__PURE__ */ ye({
  __name: "PasswordInput",
  props: {
    modelValue: { default: "" },
    placeholder: { default: void 0 },
    label: { default: void 0 },
    labelTooltip: { default: void 0 },
    required: { type: Boolean, default: !1 },
    requiredIndicator: { default: "*" },
    ariaLabel: { default: void 0 },
    hint: { default: void 0 },
    error: { default: void 0 },
    success: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    readonly: { type: Boolean, default: !1 },
    size: { default: "md" },
    name: { default: void 0 },
    id: { default: void 0 },
    fullWidth: { type: Boolean, default: !1 },
    width: { default: void 0 },
    labelInline: { type: Boolean, default: !1 },
    autocomplete: { default: "current-password" },
    maxlength: { default: void 0 },
    minlength: { default: void 0 },
    labels: { default: () => ({}) },
    remember: { type: Boolean, default: !1 },
    rememberLabel: { default: void 0 },
    forgotLabel: { default: void 0 },
    forgotHref: { default: void 0 }
  },
  emits: ["update:modelValue", "update:remember", "forgot", "focus", "blur"],
  setup(e, { emit: n }) {
    const t = e, a = n, l = Ve(), r = p(() => t.id ?? l), o = E(!1), i = p(() => t.labels.show ?? "Show password"), s = p(() => !!t.rememberLabel || !!t.forgotLabel), d = p(() => t.disabled ? "cursor-not-allowed" : "cursor-pointer");
    function u() {
      t.forgotHref || a("forgot");
    }
    return nn(
      gg,
      () => s.value ? Gn("div", { class: "flex w-full items-center justify-between gap-1", "data-testid": "password-input-row" }, [
        t.rememberLabel ? Gn(Cn, {
          modelValue: t.remember,
          label: t.rememberLabel,
          disabled: t.disabled,
          "onUpdate:modelValue": (f) => a("update:remember", f)
        }) : null,
        t.forgotLabel ? Gn(
          $n,
          {
            class: "ml-auto shrink-0",
            "data-testid": "password-input-forgot",
            as: t.forgotHref ? "a" : "button",
            href: t.forgotHref,
            disabled: t.disabled,
            onClick: u
          },
          () => t.forgotLabel
        ) : null
      ]) : null
    ), (f, b) => (c(), K(zt, {
      id: r.value,
      "model-value": e.modelValue,
      type: o.value ? "text" : "password",
      "icon-left": "ri-lock-2-line",
      placeholder: e.placeholder,
      label: e.label,
      "label-tooltip": e.labelTooltip,
      required: e.required,
      "required-indicator": e.requiredIndicator,
      "aria-label": e.ariaLabel,
      hint: e.hint,
      error: e.error,
      success: e.success,
      disabled: e.disabled,
      readonly: e.readonly,
      size: e.size,
      name: e.name,
      "full-width": e.fullWidth,
      width: e.width,
      "label-inline": e.labelInline,
      autocomplete: e.autocomplete,
      maxlength: e.maxlength,
      minlength: e.minlength,
      "onUpdate:modelValue": b[1] || (b[1] = (h) => a("update:modelValue", h)),
      onFocus: b[2] || (b[2] = (h) => a("focus", h)),
      onBlur: b[3] || (b[3] = (h) => a("blur", h))
    }, {
      iconRight: ve(({ iconColorClass: h, iconBoxClass: m }) => [
        v("button", {
          type: "button",
          "data-testid": "password-input-toggle",
          class: C([
            m,
            h,
            d.value,
            "rounded-(--border-border-radius-rounded-xs) focus-visible:shadow-(--shadow-focus-l) focus-visible:outline-2 focus-visible:outline-transparent"
          ]),
          disabled: e.disabled,
          "aria-pressed": o.value,
          "aria-controls": r.value,
          "aria-label": i.value,
          onClick: b[0] || (b[0] = (x) => o.value = !o.value)
        }, [
          v("i", {
            class: C(o.value ? "ri-eye-off-line" : "ri-eye-line"),
            "aria-hidden": "true"
          }, null, 2)
        ], 10, WR)
      ]),
      _: 1
    }, 8, ["id", "model-value", "type", "placeholder", "label", "label-tooltip", "required", "required-indicator", "aria-label", "hint", "error", "success", "disabled", "readonly", "size", "name", "full-width", "width", "label-inline", "autocomplete", "maxlength", "minlength"]));
  }
});
function gv(e) {
  if (!e || !/^[dmy/\-. ]+$/.test(e) || !/[dmy]/.test(e)) return null;
  for (const n of e.match(/([dmy])\1*/g) ?? [])
    if (n.length < 2) return null;
  return e.replace(/[dmy]/g, "0");
}
function su(e) {
  const n = new Set([...e].filter((l) => /\D/.test(l)));
  if (n.size !== 1) return null;
  const [t] = [...n], a = e.split(t).map((l) => l.length).filter((l) => l > 0);
  return a.length === 0 ? null : { groupSizes: a, separator: t };
}
function qR(e) {
  if (!e) return null;
  const n = e.match(/[Xx]+/g);
  if (!n) return null;
  const t = e.split(/[Xx]+/);
  if (t[0] !== "" || t[t.length - 1] !== "") return null;
  const a = t.slice(1, -1);
  if (a.length === 0) return null;
  const [l] = a;
  return l === "" || a.some((r) => r !== l) ? null : { groupSizes: n.map((r) => r.length), separator: l };
}
function Jr(e, n) {
  if (!e) return "";
  const t = [];
  let a = 0;
  for (const l of n.groupSizes) {
    if (a >= e.length) break;
    t.push(e.slice(a, a + l)), a += l;
  }
  return a < e.length && t.push(e.slice(a)), t.join(n.separator);
}
function UR(e, n) {
  if (n <= 0) return 0;
  let t = 0;
  for (let a = 0; a < e.length; a++)
    if (/\d/.test(e[a]) && (t += 1, t === n))
      return a + 1;
  return e.length;
}
function pv(e, n, t) {
  const a = e.value, l = e.selectionStart ?? a.length, r = n(a.slice(0, l)).length, o = n(a), i = t(o);
  e.value = i;
  const s = UR(i, r);
  try {
    e.setSelectionRange(s, s);
  } catch {
  }
  return i;
}
function Uh(e, n, t) {
  return pv(
    e,
    n,
    (a) => t ? Jr(a, t) : a
  );
}
function mv(e, n, t) {
  if (e.key !== "Backspace" && e.key !== "Delete" || e.ctrlKey || e.altKey || e.metaKey) return !1;
  const a = n.selectionStart, l = n.selectionEnd;
  if (a === null || l === null || a !== l) return !1;
  const r = n.value, o = (d) => d !== void 0 && /\d/.test(d);
  let i, s;
  if (e.key === "Backspace") {
    if (a === 0 || o(r[a - 1])) return !1;
    let d = a - 1;
    for (; d >= 0 && !o(r[d]); ) d -= 1;
    if (d < 0) return !1;
    i = d, s = d;
  } else {
    if (a >= r.length || o(r[a])) return !1;
    let d = a;
    for (; d < r.length && !o(r[d]); ) d += 1;
    if (d >= r.length) return !1;
    i = d, s = a;
  }
  n.value = r.slice(0, i) + r.slice(i + 1);
  try {
    n.setSelectionRange(s, s);
  } catch {
  }
  return e.preventDefault(), t(n), !0;
}
const Un = {
  FR: { placeholder: "6 12 34 56 78", min: 9, max: 9, name: "France", hasTrunkZero: !0 },
  GB: {
    placeholder: "7911 123456",
    min: 9,
    max: 10,
    name: "United Kingdom",
    hasTrunkZero: !0
  },
  CA: {
    placeholder: "123-456-7890",
    min: 10,
    max: 10,
    name: "Canada",
    hasTrunkZero: !1,
    displaySeparator: " "
  },
  US: {
    placeholder: "123-456-7890",
    min: 10,
    max: 10,
    name: "United States",
    hasTrunkZero: !1,
    displaySeparator: " "
  },
  NL: { placeholder: "6 12345678", min: 9, max: 9, name: "Netherlands", hasTrunkZero: !0 },
  DE: { placeholder: "176 12345678", min: 10, max: 11, name: "Germany", hasTrunkZero: !0 },
  // min: 8 covers landline numbers behind a 2-digit area code (Brussels "02 XXX XX XX" = 8
  // significant digits); mobiles and other landlines are 9 (the placeholder's own length).
  BE: { placeholder: "470 12 34 56", min: 8, max: 9, name: "Belgium", hasTrunkZero: !0 },
  CH: { placeholder: "78 123 45 67", min: 9, max: 9, name: "Switzerland", hasTrunkZero: !0 },
  // The leading "0" is a significant digit of the Italian landline numbering plan (mandatory,
  // not a trunk prefix) — hasTrunkZero: false so it is never split out, stripped, or parenthesised
  // anywhere (input, display, validation count). min/max count the "0" itself, so hasTrunkZero:
  // false means nothing strips it before counting. min: 9 covers a shorter landline behind a
  // 2-digit area code ("02 1234 567" = 9 digits); max: 10 matches the placeholder (mobiles and
  // longer landlines).
  IT: { placeholder: "06 1234 5678", min: 9, max: 10, name: "Italy", hasTrunkZero: !1 },
  ES: { placeholder: "612 34 56 78", min: 9, max: 9, name: "Spain", hasTrunkZero: !1 },
  PT: { placeholder: "912 345 678", min: 9, max: 9, name: "Portugal", hasTrunkZero: !1 },
  GR: { placeholder: "691 234 5678", min: 10, max: 10, name: "Greece", hasTrunkZero: !1 },
  DK: { placeholder: "20 12 34 56", min: 8, max: 8, name: "Denmark", hasTrunkZero: !1 },
  NO: { placeholder: "406 12 345", min: 8, max: 8, name: "Norway", hasTrunkZero: !1 }
}, Sl = {
  placeholder: "123 456 789",
  min: 6,
  max: Number.POSITIVE_INFINITY,
  name: "",
  hasTrunkZero: !1
}, Gh = "FR", vv = {
  FR: "+33",
  GB: "+44",
  CA: "+1",
  US: "+1",
  NL: "+31",
  DE: "+49",
  BE: "+32",
  CH: "+41",
  IT: "+39",
  ES: "+34",
  PT: "+351",
  GR: "+30",
  DK: "+45",
  NO: "+47"
}, Ec = Object.entries(vv).sort((e, n) => n[1].length - e[1].length), GR = Object.entries(
  Un
).reduce((e, [n, t]) => {
  const a = vv[n];
  return a in e || (e[a] = t), e;
}, {});
function Kh(e) {
  const n = e.replace(/^0+/, "");
  return n.length > 0 ? n : e;
}
function Yh(e, n) {
  const t = Un[n] ?? Sl, a = su(t.placeholder);
  if (!a) return e;
  const l = t.displaySeparator ?? a.separator;
  return Jr(e, { groupSizes: a.groupSizes, separator: l });
}
function lr(e, n, t) {
  if (!e) return "";
  if (!t) {
    const i = su(n);
    return i ? Jr(e, i) : e;
  }
  if (/^0*$/.test(e)) return e;
  const a = e.startsWith("0"), l = a ? "0" : "", r = a ? e.slice(1) : e, o = su(n);
  return l + (o ? Jr(r, o) : r);
}
function Ac(e, n) {
  return /^0*$/.test(e) ? "" : n && e.startsWith("0") ? e.slice(1) : e;
}
function KW(e) {
  const n = (e ?? "").trim();
  if (!n.startsWith("+")) return e;
  const t = Ec.find(([, i]) => n.startsWith(i));
  if (!t) return e;
  const [a, l] = t;
  if (!Un[a].hasTrunkZero) return e;
  const o = n.slice(l.length).replace(/\D/g, "");
  return !o || o.startsWith("0") ? e : `${l}0${o}`;
}
function YW(e) {
  const n = (e ?? "").trim();
  if (!n.startsWith("+")) return e;
  const t = Ec.find(([, s]) => n.startsWith(s));
  if (!t) return e;
  const [a, l] = t, r = Un[a], o = n.slice(l.length).replace(/\D/g, ""), i = r.hasTrunkZero ? Ac(o, !0) : o;
  return i ? `${l}${i}` : e;
}
function KR(e) {
  const n = (e ?? "").trim();
  if (!n) return e;
  if (n.startsWith("+")) {
    const i = Ec.find(([, x]) => n.startsWith(x));
    if (!i) return e;
    const [s, d] = i, u = Un[s], f = n.slice(d.length).replace(/\D/g, ""), b = u.hasTrunkZero ? Kh(f) : f;
    if (!b) return e;
    const h = Yh(b, s), m = u.hasTrunkZero ? "(0)" : "";
    return `${d} ${m}${h}`;
  }
  const t = Kh(n.replace(/\D/g, ""));
  if (!t) return e;
  const { min: a, max: l } = Un[Gh];
  if (t.length < a || t.length > l) return e;
  const r = Yh(t, Gh);
  return `${n.replace(/\D/g, "").startsWith("0") ? "0" : ""}${r}`;
}
const YR = ["id"], JR = { class: "relative min-w-0 flex-1" }, ZR = { class: "inline-flex items-center gap-1.5" }, XR = { class: "inline-flex size-4 shrink-0 items-center justify-center" }, QR = ["title"], _R = ["id", "autocomplete", "disabled", "readonly", "aria-labelledby", "aria-invalid", "aria-describedby", "placeholder"], eB = ["aria-label"], tB = {
  key: 0,
  class: "shrink-0"
}, nB = /* @__PURE__ */ ye({
  __name: "PhoneInput",
  props: {
    modelValue: { default: "" },
    label: { default: void 0 },
    required: { type: Boolean, default: !1 },
    requiredIndicator: { default: "*" },
    labelTooltip: { default: void 0 },
    disabled: { type: Boolean, default: !1 },
    error: { default: void 0 },
    hint: { default: void 0 },
    disableInternalValidation: { type: Boolean, default: !1 },
    showCountrySelector: { type: Boolean, default: !0 },
    showVerificationButton: { type: Boolean, default: !1 },
    verificationOptions: { default: () => [
      { id: "sms", label: "Send SMS" },
      { id: "call", label: "Call" }
    ] },
    countries: { default: () => [
      { code: "FR", name: "France", dialCode: "+33" },
      { code: "GB", name: "United Kingdom", dialCode: "+44" },
      { code: "CA", name: "Canada", dialCode: "+1" },
      { code: "NL", name: "Netherlands", dialCode: "+31" },
      { code: "DE", name: "Germany", dialCode: "+49" },
      { code: "BE", name: "Belgium", dialCode: "+32" },
      { code: "CH", name: "Switzerland", dialCode: "+41" },
      { code: "IT", name: "Italy", dialCode: "+39" },
      { code: "ES", name: "Spain", dialCode: "+34" },
      { code: "PT", name: "Portugal", dialCode: "+351" },
      { code: "GR", name: "Greece", dialCode: "+30" },
      { code: "DK", name: "Denmark", dialCode: "+45" },
      { code: "NO", name: "Norway", dialCode: "+47" }
    ] },
    countryListLabel: { default: "Country" },
    locale: { default: void 0 },
    fullWidth: { type: Boolean, default: !1 },
    size: { default: "md" },
    autocomplete: { default: "tel" },
    maskInput: { type: Boolean, default: !0 },
    formatHintLabel: { default: void 0 },
    readonly: { type: Boolean, default: !1 },
    labelInline: { type: Boolean, default: !1 },
    buttons: { default: () => [] },
    buttonLayout: { default: "attached" },
    buttonSize: { default: void 0 },
    innerButton: { default: void 0 },
    removeButton: { default: void 0 }
  },
  emits: ["update:modelValue", "focus", "blur", "validation-change", "verification-click", "country-change", "button-click"],
  setup(e, { emit: n }) {
    const t = e, a = Ht(), l = p(() => a("actions")), r = n, o = E(!1), i = E(!1), s = E(""), d = E(t.countries[0]), u = E(t.verificationOptions[0]), f = E(!1), b = E(void 0), h = E(null), m = E(null), x = p(() => {
      var Be;
      return ((Be = h.value) == null ? void 0 : Be.$el) ?? null;
    }), y = E(null), w = p(
      () => {
        var Be;
        return ((Be = m.value) == null ? void 0 : Be.$el) ?? null;
      }
    ), S = E(null), $ = Fu(), T = p(() => {
      if (!t.locale) return null;
      try {
        return new Intl.DisplayNames([t.locale], { type: "region", fallback: "none" });
      } catch {
        return null;
      }
    }), L = (Be) => {
      var ze;
      return ((ze = T.value) == null ? void 0 : ze.of(Be.code)) ?? Be.name;
    }, A = (Be) => {
      var ze;
      return Be.placeholder || ((ze = Un[Be.code]) == null ? void 0 : ze.placeholder) || Sl.placeholder;
    }, R = (Be) => {
      const ze = Be.replace(/\s/g, "");
      return [...t.countries].sort((it, Ct) => Ct.dialCode.length - it.dialCode.length).find((it) => ze.startsWith(it.dialCode));
    }, z = () => {
      if (!t.modelValue) {
        s.value = "";
        return;
      }
      const Be = R(t.modelValue);
      if (Be) {
        d.value = Be;
        const ze = t.modelValue.slice(Be.dialCode.length);
        s.value = t.maskInput && t.showCountrySelector ? lr(
          ze.replace(/\D/g, ""),
          A(Be),
          (Un[Be.code] ?? Sl).hasTrunkZero
        ) : ze;
        return;
      }
      s.value = t.modelValue.replace(/^\+/, "");
    };
    z();
    const D = p(() => {
      const Be = s.value.replace(/\D/g, "");
      return !Be || !/[1-9]/.test(Be) ? "" : t.showCountrySelector ? `${d.value.dialCode}${Be}` : `+${Be}`;
    }), V = p(() => Un[d.value.code] || Sl), Y = p(() => t.showCountrySelector ? A(d.value) : "+33612345678"), _ = p(() => {
      if (t.error) return t.error;
      if (!t.disableInternalValidation && f.value)
        return b.value;
    }), j = () => {
      const Be = s.value.replace(/\D/g, "");
      if (t.required && !Be)
        return "Phone number is required";
      if (!Be)
        return;
      const ze = Ac(Be, V.value.hasTrunkZero), { min: He, max: it } = V.value;
      if (ze.length < He || ze.length > it)
        return `Phone number must be ${He === it ? `${He}` : `${He}–${it}`} digits for ${d.value.name}`;
    }, M = () => {
      const Be = j();
      b.value = Be, r("validation-change", !Be, Be);
    }, W = () => {
      b.value = void 0;
    }, G = (Be) => pv(
      Be,
      (ze) => ze.replace(/\D/g, ""),
      (ze) => lr(ze, Y.value, V.value.hasTrunkZero)
    ), B = (Be) => {
      const ze = Be.target;
      if (W(), t.maskInput && t.showCountrySelector) {
        s.value = G(ze);
        return;
      }
      const He = ze.value.replace(/[^\d\s\-()]/g, "");
      s.value = He, ze.value = He;
    }, F = (Be) => {
      var it, Ct;
      if ((it = De.value) == null || it.handleFieldKeydown(Be), (Ct = Ee.value) == null || Ct.handleFieldKeydown(Be), t.readonly || t.disabled || !(t.maskInput && t.showCountrySelector)) return;
      const ze = Be.target;
      mv(Be, ze, (Yt) => G(Yt)) && (W(), s.value = ze.value);
    }, X = (Be) => {
      if (he.value = !1, f.value = !0, t.showCountrySelector) {
        const ze = s.value.replace(/\D/g, "");
        s.value = t.maskInput ? lr(
          ze,
          Y.value,
          V.value.hasTrunkZero
        ) : ze;
      }
      M(), r("blur", Be);
    }, H = (Be) => {
      he.value = !0, r("focus", Be);
    }, q = (Be) => {
      var Yt;
      if (!t.showCountrySelector) return;
      const ze = (((Yt = Be.clipboardData) == null ? void 0 : Yt.getData("text")) ?? "").trim();
      if (!ze.startsWith("+")) return;
      const He = R(ze);
      if (!He) return;
      Be.preventDefault(), W(), d.value = He;
      const it = Un[He.code] ?? Sl, Ct = ze.replace(/\D/g, "").slice(He.dialCode.replace(/\D/g, "").length);
      s.value = t.maskInput ? lr(Ct, A(He), it.hasTrunkZero) : Ct;
    }, N = (Be) => {
      d.value = Be, U("country"), t.maskInput && t.showCountrySelector && s.value && (s.value = lr(
        s.value.replace(/\D/g, ""),
        Y.value,
        V.value.hasTrunkZero
      )), f.value && M();
    }, J = (Be, ze) => {
      ze.stopPropagation(), N(Be);
    }, be = (Be) => Be === "country" ? o : i, ke = (Be) => Be === "country" ? x.value : w.value, ee = (Be) => Be === "country" ? y.value : S.value, oe = (Be) => {
      var ze;
      return Array.from(((ze = ee(Be)) == null ? void 0 : ze.querySelectorAll("[data-popup-row]")) ?? []);
    }, ge = (Be) => Be.findIndex((ze) => ze.getAttribute("aria-selected") === "true" || ze.getAttribute("aria-checked") === "true"), re = (Be, ze) => {
      const He = Be[(ze + Be.length) % Be.length];
      He == null || He.focus({ preventScroll: !0 }), He == null || He.scrollIntoView({ block: "nearest" });
    }, ue = (Be, ze) => {
      const He = ge(Be);
      re(Be, He !== -1 ? He : ze === "first" ? 0 : Be.length - 1);
    }, O = async (Be, ze = "first") => {
      be(Be).value = !0, await qe(), ue(oe(Be), ze);
    }, U = (Be) => {
      var ze, He;
      (ze = ee(Be)) != null && ze.contains(document.activeElement) && ((He = ke(Be)) == null || He.focus()), be(Be).value = !1;
    }, Q = (Be, ze) => {
      t.disabled || (ze.stopPropagation(), be(Be).value ? U(Be) : ze.detail === 0 ? O(Be) : be(Be).value = !0);
    }, ae = (Be, ze) => {
      const He = Aa($.query.value), it = /^(.)\1+$/u.test(He) ? He[0] : He, Ct = it.length === 1 ? ze + 1 : Math.max(ze, 0);
      for (let Yt = 0; Yt < t.countries.length; Yt++) {
        const Dn = (Ct + Yt) % t.countries.length;
        if (Aa(L(t.countries[Dn])).startsWith(it)) {
          re(Be, Dn);
          return;
        }
      }
    }, Z = (Be, ze) => {
      var Ct;
      if (!be(Be).value) {
        (ze.key === "ArrowDown" || ze.key === "ArrowUp") && (ze.preventDefault(), O(Be, ze.key === "ArrowDown" ? "first" : "last"));
        return;
      }
      const He = oe(Be), it = He.indexOf(document.activeElement);
      if (Be === "country" && !(ze.key === " " && !$.query.value) && $.handleKey(ze)) {
        ze.preventDefault(), ze.stopPropagation(), ae(He, it);
        return;
      }
      switch (ze.key) {
        case "ArrowDown":
        case "ArrowUp":
          ze.preventDefault(), it === -1 ? ue(He, ze.key === "ArrowDown" ? "first" : "last") : re(He, it + (ze.key === "ArrowDown" ? 1 : -1));
          break;
        case "Home":
        case "End":
          ze.preventDefault(), re(He, ze.key === "Home" ? 0 : He.length - 1);
          break;
        case "Enter":
        case " ":
          if (it === -1) return;
          ze.preventDefault(), ze.stopPropagation(), He[it].click();
          break;
        case "Escape":
          ze.preventDefault(), ze.stopPropagation(), U(Be), (Ct = ke(Be)) == null || Ct.focus();
          break;
        case "Tab":
          U(Be);
          break;
      }
    }, ie = (Be) => Q("country", Be), fe = (Be) => Q("verification", Be), de = (Be, ze) => {
      ze.stopPropagation(), u.value = Be, U("verification"), r("verification-click", Be.id);
    }, ne = (Be) => {
      const ze = Be.target, He = !x.value || !x.value.contains(ze), it = !y.value || !y.value.contains(ze);
      He && it && (o.value = !1);
      const Ct = !w.value || !w.value.contains(ze), Yt = !S.value || !S.value.contains(ze);
      Ct && Yt && (i.value = !1);
    };
    Ie([s, d], () => {
      if (r("update:modelValue", D.value), t.showCountrySelector) {
        const Be = s.value.replace(/\D/g, "");
        r("country-change", d.value, Be);
      }
    }), Ie(
      () => t.modelValue,
      (Be) => {
        Be !== D.value && (W(), z());
      }
    ), Ie([o, i], ([Be, ze]) => {
      Be || ze ? document.addEventListener("click", ne) : document.removeEventListener("click", ne), Be || $.reset();
    }), ot(() => {
      t.maskInput && t.showCountrySelector && t.modelValue && t.countries.some((Be) => t.modelValue.startsWith(Be.dialCode)) && D.value !== t.modelValue && r("update:modelValue", D.value);
    }), kt(() => {
      document.removeEventListener("click", ne);
    });
    const le = p(
      () => Kl(t.labelInline, !!t.label, !!t.removeButton)
    ), Le = p(() => t.removeButton && Nu(t.removeButton)), Te = p(() => !!t.innerButton || t.showVerificationButton), xe = p(
      () => t.size === "md" ? "pl-[calc(--spacing(2)-1px)] pr-[calc(--spacing(2)-1px)]" : ""
    ), we = Ve(), he = E(!1), De = E(null), Ee = E(null), je = p(() => `${we}-phone`), Ge = p(() => t.label ? `${we}-label` : void 0), Qe = p(() => `${we}-error`), Ce = p(() => `${we}-hint`), me = p(() => `${we}-format-hint`), Ae = `${we}-countries`, Ke = `${we}-verification`, Je = `${we}-verification-menu`, _e = p(() => t.formatHintLabel ? `${t.formatHintLabel} ${Y.value}` : t.showCountrySelector ? Y.value : ""), At = p(() => {
      const Be = [];
      return _e.value && Be.push(me.value), t.hint && Be.push(Ce.value), _.value && Be.push(Qe.value), Be.length > 0 ? Be.join(" ") : void 0;
    });
    return (Be, ze) => (c(), g("div", {
      class: C(["relative w-full pb-0.5", le.value.root])
    }, [
      e.label ? (c(), K(xt, {
        key: 0,
        id: Ge.value,
        ref_key: "labelRef",
        ref: De,
        text: e.label,
        "input-id": je.value,
        required: e.required,
        "required-indicator": e.requiredIndicator,
        tooltip: e.labelTooltip,
        focused: he.value,
        inline: e.labelInline,
        class: C(le.value.label),
        "test-id": "phone-input-label"
      }, null, 8, ["id", "text", "input-id", "required", "required-indicator", "tooltip", "focused", "inline", "class"])) : k("", !0),
      _e.value ? (c(), g("span", {
        key: 1,
        id: me.value,
        class: "sr-only"
      }, P(_e.value), 9, YR)) : k("", !0),
      v("div", {
        class: C(["flex w-full items-end gap-3", le.value.field])
      }, [
        v("div", JR, [
          te(to, {
            buttons: e.buttons,
            layout: e.buttonLayout,
            size: e.size,
            disabled: e.disabled,
            "button-size": e.buttonSize,
            onButtonClick: ze[4] || (ze[4] = (He) => r("button-click", He))
          }, _n({
            default: ve(({ fieldClass: He }) => [
              te(Rn, {
                class: C(["w-full", He]),
                size: e.size,
                "inner-button": Te.value,
                disabled: e.disabled,
                readonly: e.readonly,
                error: !!_.value,
                "has-value": !!s.value
              }, {
                default: ve(({ leftIconBoxClass: it, iconColorClass: Ct, textClass: Yt }) => [
                  v("i", {
                    class: C(["ri-phone-fill", it, Ct]),
                    "aria-hidden": "true"
                  }, null, 2),
                  Gl(v("input", {
                    id: je.value,
                    "onUpdate:modelValue": ze[1] || (ze[1] = (Dn) => s.value = Dn),
                    type: "tel",
                    inputmode: "tel",
                    autocomplete: e.autocomplete,
                    disabled: e.disabled,
                    readonly: e.readonly,
                    "aria-labelledby": Ge.value,
                    "aria-invalid": !!_.value,
                    "aria-describedby": At.value,
                    class: C([
                      "relative min-w-0 flex-1 text-ellipsis border-0 bg-transparent p-0 outline-none focus:border-0 focus:outline-none focus:ring-0 placeholder:text-(--text-text-body-subtle) dark:placeholder:text-(--colors-text-white-secondary)",
                      Yt,
                      e.readonly ? "cursor-default" : ""
                    ]),
                    placeholder: Y.value,
                    onInput: B,
                    onKeydown: F,
                    onPaste: q,
                    onBlur: X,
                    onFocus: H
                  }, null, 42, _R), [
                    [zb, s.value]
                  ]),
                  e.innerButton ? (c(), K(Re, Oe({ key: 0 }, I(Yn)(e.innerButton, e.disabled), {
                    size: "xs",
                    onClick: ze[2] || (ze[2] = (Dn) => r("button-click", e.innerButton.id))
                  }), null, 16)) : k("", !0),
                  e.showVerificationButton ? (c(), K(Re, {
                    key: 1,
                    id: Ke,
                    ref_key: "verificationButtonRef",
                    ref: m,
                    variant: "tertiary",
                    size: "xs",
                    class: C(e.size === "md" ? "-mr-0.5" : ""),
                    label: u.value.label,
                    disabled: e.disabled || e.readonly,
                    "aria-haspopup": "menu",
                    "aria-expanded": i.value,
                    "aria-controls": i.value ? Je : void 0,
                    "dropdown-icon": "",
                    onClick: fe,
                    onKeydown: ze[3] || (ze[3] = (Dn) => Z("verification", Dn))
                  }, null, 8, ["class", "label", "disabled", "aria-expanded", "aria-controls"])) : k("", !0)
                ]),
                _: 1
              }, 8, ["class", "size", "inner-button", "disabled", "readonly", "error", "has-value"])
            ]),
            _: 2
          }, [
            e.showCountrySelector ? {
              name: "leading",
              fn: ve(({ partClass: He, buttonSize: it }) => [
                te(Re, {
                  ref_key: "countryButtonRef",
                  ref: h,
                  variant: "secondary",
                  size: it,
                  class: C([He, xe.value]),
                  disabled: e.disabled || e.readonly,
                  "aria-haspopup": "listbox",
                  "aria-expanded": o.value,
                  "aria-controls": o.value ? Ae : void 0,
                  "dropdown-icon": "",
                  onClick: ie,
                  onKeydown: ze[0] || (ze[0] = (Ct) => Z("country", Ct))
                }, {
                  default: ve(() => [
                    v("span", ZR, [
                      v("span", XR, [
                        v("span", {
                          class: C(["fi fis size-[13.33px] rounded-full", `fi-${d.value.code.toLowerCase()}`]),
                          title: L(d.value)
                        }, null, 10, QR)
                      ]),
                      v("span", null, P(d.value.dialCode), 1)
                    ])
                  ]),
                  _: 1
                }, 8, ["size", "class", "disabled", "aria-expanded", "aria-controls"])
              ]),
              key: "0"
            } : void 0
          ]), 1032, ["buttons", "layout", "size", "disabled", "button-size"]),
          e.showCountrySelector && o.value ? (c(), g("div", {
            key: 0,
            ref_key: "countryDropdownMenuRef",
            ref: y,
            class: C(["absolute left-0 top-full z-50 mt-1 w-56 max-h-[min(400px,calc(100vh-24px))] overflow-y-auto", I(_o)]),
            onKeydown: ze[5] || (ze[5] = (He) => Z("country", He))
          }, [
            v("ul", {
              id: Ae,
              class: "flex min-w-0 flex-col gap-1.5",
              role: "listbox",
              "aria-label": e.countryListLabel
            }, [
              (c(!0), g(se, null, Me(e.countries, (He) => (c(), K(Gt, {
                key: He.code,
                as: "li",
                type: "flag",
                role: "option",
                tabindex: "-1",
                "data-popup-row": "",
                "aria-selected": He.code === d.value.code,
                label: L(He),
                flag: He.code,
                selected: He.code === d.value.code,
                "data-testid": `phone-country-${He.code}`,
                onClick: (it) => J(He, it)
              }, null, 8, ["aria-selected", "label", "flag", "selected", "data-testid", "onClick"]))), 128))
            ], 8, eB)
          ], 34)) : k("", !0),
          e.showVerificationButton && i.value ? (c(), g("div", {
            key: 1,
            ref_key: "verificationDropdownMenuRef",
            ref: S,
            class: C(["absolute right-0 top-full z-50 mt-1 min-w-36 w-max", I(_o)]),
            onKeydown: ze[6] || (ze[6] = (He) => Z("verification", He))
          }, [
            v("ul", {
              id: Je,
              class: "flex min-w-0 flex-col gap-1.5",
              role: "menu",
              "aria-labelledby": Ke
            }, [
              (c(!0), g(se, null, Me(e.verificationOptions, (He) => (c(), K(Gt, {
                key: He.id,
                as: "li",
                type: "default",
                role: "menuitemradio",
                tabindex: "-1",
                "data-popup-row": "",
                "aria-checked": He.id === u.value.id,
                label: He.label,
                selected: He.id === u.value.id,
                onClick: (it) => de(He, it)
              }, null, 8, ["aria-checked", "label", "selected", "onClick"]))), 128))
            ])
          ], 34)) : k("", !0)
        ]),
        l.value ? (c(), g("div", tB, [
          $e(Be.$slots, "actions", {}, void 0, !0)
        ])) : k("", !0),
        Le.value && le.value.removeInFieldRow ? (c(), K(Re, Oe({ key: 1 }, I(Yn)(Le.value, e.disabled), {
          size: I(Ra)(e.size, "attached"),
          onClick: ze[7] || (ze[7] = (He) => r("button-click", Le.value.id))
        }), null, 16, ["size"])) : k("", !0)
      ], 2),
      le.value.reservesHelper || e.hint || _.value ? (c(), K(vt, {
        key: 2,
        ref_key: "helperRef",
        ref: Ee,
        class: C(le.value.helper),
        focused: he.value,
        hint: e.hint,
        error: _.value,
        "hint-id": Ce.value,
        "error-id": Qe.value,
        "test-id-prefix": "phone-input"
      }, null, 8, ["class", "focused", "hint", "error", "hint-id", "error-id"])) : k("", !0),
      Le.value && !le.value.removeInFieldRow ? (c(), K(Re, Oe({ key: 3 }, I(Yn)(Le.value, e.disabled), {
        class: le.value.remove,
        size: I(Ra)(e.size, "attached"),
        onClick: ze[8] || (ze[8] = (He) => r("button-click", Le.value.id))
      }), null, 16, ["class", "size"])) : k("", !0)
    ], 2));
  }
}), aB = /* @__PURE__ */ lt(nB, [["__scopeId", "data-v-da8fce2b"]]), lB = ["href", "aria-label"], rB = { key: 1 }, JW = /* @__PURE__ */ ye({
  __name: "PhoneDisplay",
  props: {
    value: {},
    link: { type: Boolean, default: !0 },
    ariaLabel: { default: void 0 }
  },
  setup(e) {
    const n = e, t = p(() => KR(n.value)), a = p(() => `tel:${n.value.replace(/[^\d+]/g, "")}`);
    return (l, r) => e.link ? (c(), g("a", {
      key: 0,
      href: a.value,
      "aria-label": e.ariaLabel
    }, P(t.value), 9, lB)) : (c(), g("span", rB, P(t.value), 1));
  }
}), oB = ["id"], ZW = /* @__PURE__ */ ye({
  __name: "MaskedInput",
  props: {
    modelValue: { default: "" },
    mask: {},
    label: { default: void 0 },
    placeholder: { default: void 0 },
    hint: { default: void 0 },
    error: { default: void 0 },
    required: { type: Boolean, default: !1 },
    requiredIndicator: { default: "*" },
    disabled: { type: Boolean, default: !1 },
    success: { type: Boolean, default: !1 },
    labelTooltip: { default: void 0 },
    labels: { default: () => ({ clear: "Clear input" }) },
    readonly: { type: Boolean, default: !1 },
    size: { default: "md" },
    name: { default: void 0 },
    id: { default: void 0 },
    fullWidth: { type: Boolean, default: !1 },
    width: { default: void 0 },
    iconLeft: { default: void 0 },
    labelInline: { type: Boolean, default: !1 },
    autocomplete: { default: "off" },
    formatHintLabel: { default: void 0 },
    showEditIcon: { type: Boolean, default: !0 }
  },
  emits: ["update:modelValue", "input", "focus", "blur", "clear"],
  setup(e, { emit: n }) {
    const t = e, a = n, l = Ht(), r = p(() => qR(t.mask)), o = (S) => S.replace(/\D/g, ""), i = p(() => {
      const S = o(t.modelValue ?? "");
      return r.value ? Jr(S, r.value) : S;
    }), s = Ve(), d = p(() => t.id || `${s}-masked`), u = p(() => `${d.value}-format-hint`), f = p(
      () => t.formatHintLabel ? `${t.formatHintLabel} ${t.mask}` : t.mask
    ), b = p(() => {
      const S = [u.value];
      return t.hint && S.push(`${d.value}-hint`), t.error && S.push(`${d.value}-error`), S.join(" ");
    }), h = (S) => {
      const $ = S.target, T = Uh($, o, r.value);
      a("update:modelValue", T), a("input", S);
    }, m = (S) => {
      if (t.readonly || t.disabled) return;
      const $ = S.target;
      mv(
        S,
        $,
        (L) => Uh(L, o, r.value)
      ) && a("update:modelValue", $.value);
    }, x = (S) => a("focus", S), y = (S) => a("blur", S), w = () => {
      a("update:modelValue", ""), a("clear");
    };
    return (S, $) => (c(), g("div", null, [
      v("span", {
        id: u.value,
        class: "sr-only"
      }, P(f.value), 9, oB),
      te(zt, {
        id: d.value,
        "model-value": i.value,
        placeholder: e.placeholder,
        label: e.label,
        hint: e.hint,
        error: e.error,
        required: e.required,
        "required-indicator": e.requiredIndicator,
        disabled: e.disabled,
        success: e.success,
        "label-tooltip": e.labelTooltip,
        labels: e.labels,
        readonly: e.readonly,
        size: e.size,
        name: e.name,
        "full-width": e.fullWidth,
        width: e.width,
        "icon-left": e.iconLeft,
        "show-edit-icon": e.showEditIcon,
        "label-inline": e.labelInline,
        autocomplete: e.autocomplete,
        "aria-describedby": b.value,
        type: "text",
        inputmode: "numeric",
        "data-testid": "masked-input",
        onInput: h,
        onKeydown: m,
        onFocus: x,
        onBlur: y,
        onClear: w
      }, _n({ _: 2 }, [
        I(l)("actions") ? {
          name: "actions",
          fn: ve(() => [
            $e(S.$slots, "actions")
          ]),
          key: "0"
        } : void 0
      ]), 1032, ["id", "model-value", "placeholder", "label", "hint", "error", "required", "required-indicator", "disabled", "success", "label-tooltip", "labels", "readonly", "size", "name", "full-width", "width", "icon-left", "show-edit-icon", "label-inline", "autocomplete", "aria-describedby"])
    ]));
  }
}), iB = ["disabled", "aria-disabled", "aria-label", "data-testid"], sB = {
  key: 2,
  role: "status",
  class: "sr-only"
}, dB = 2e3, ld = /* @__PURE__ */ ye({
  __name: "ListItemActionButton",
  props: {
    action: {},
    appearance: {},
    variant: {},
    muted: { type: Boolean },
    rowHover: { type: Boolean },
    keepFocusable: { type: Boolean }
  },
  setup(e, { expose: n }) {
    const t = e, a = p(() => t.action.disabled ? t.action.disabledReason : void 0), l = p(() => !!t.action.disabled), r = p(() => l.value && !a.value && !t.keepFocusable), o = p(() => l.value && !r.value), i = p(() => t.muted || l.value ? "text-(--icons-icon-base)" : t.rowHover ? "text-(--icons-icon-base-strong) group-hover/row:text-(--icons-icon-hover)" : "text-(--icons-icon-base-strong)"), s = E(null), d = E(null), u = E(!1);
    let f, b = !1;
    const h = p(() => "copiedLabel" in t.action ? t.action.copiedLabel : void 0);
    async function m(w) {
      l.value || (clearTimeout(f), u.value = !1, await t.action.onClick(w), await qe(), !(!h.value || b) && (u.value = !0, f = setTimeout(() => u.value = !1, dB)));
    }
    gt(() => {
      b = !0, clearTimeout(f);
    });
    const x = p(() => (u.value ? h.value : a.value) ?? "");
    function y() {
      var S;
      const w = d.value ?? ((S = s.value) == null ? void 0 : S.$el) ?? null;
      return !w || r.value ? !1 : (w.focus(), !0);
    }
    return n({ focus: y }), (w, S) => (c(), K(ft, {
      text: x.value,
      disabled: !x.value,
      open: u.value ? !0 : void 0,
      as: "span",
      class: "shrink-0"
    }, {
      default: ve(() => [
        e.appearance === "inline-icon" ? (c(), g("button", {
          key: 0,
          ref_key: "inlineRef",
          ref: d,
          type: "button",
          class: C(["inline-flex size-6 -mx-1 shrink-0 items-center justify-center rounded-(--border-border-radius-rounded-xs) focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-(--border-border-accent)", l.value ? "cursor-default" : "cursor-pointer"]),
          disabled: r.value,
          "aria-disabled": o.value ? "true" : void 0,
          "aria-label": e.action.label,
          "data-testid": e.action.testId ?? "list-item-copy-action",
          onClick: m
        }, [
          v("i", {
            class: C(["ri-file-copy-line inline-flex size-(--icon-size-sm) items-center justify-center text-(length:--icon-size-sm) leading-(--icon-size-sm)", i.value]),
            "aria-hidden": "true"
          }, null, 2)
        ], 10, iB)) : (c(), K(Re, Oe({
          key: 1,
          ref_key: "buttonRef",
          ref: s,
          variant: e.variant,
          size: "xs",
          "icon-only": e.appearance === "icon",
          "icon-left": "icon" in e.action ? e.action.icon : void 0,
          label: e.appearance === "label" ? e.action.label : void 0,
          "aria-label": e.appearance === "icon" ? e.action.label : void 0,
          disabled: r.value,
          "aria-disabled": o.value
        }, e.action.testId ? { "data-testid": e.action.testId } : {}, {
          onClick: e.action.onClick
        }), null, 16, ["variant", "icon-only", "icon-left", "label", "aria-label", "disabled", "aria-disabled", "onClick"])),
        e.appearance === "inline-icon" ? (c(), g("span", sB, P(u.value ? h.value : ""), 1)) : k("", !0)
      ]),
      _: 1
    }, 8, ["text", "disabled", "open"]));
  }
}), uB = ["id"], cB = {
  key: 0,
  class: "flex shrink-0",
  "data-testid": "list-item-leading"
}, fB = {
  key: 1,
  class: "flex shrink-0",
  "data-testid": "list-item-leading"
}, hB = {
  key: 0,
  class: "flex",
  "data-testid": "list-item-top-badge"
}, bB = ["id"], gB = ["id"], pB = ["id"], mB = {
  key: 3,
  class: "flex min-w-0 items-end justify-between gap-1.5",
  "data-testid": "list-item-amount-row"
}, vB = { class: "flex min-w-0 items-end gap-1.5" }, xB = ["id"], yB = ["id"], kB = ["id"], wB = ["id"], CB = ["id"], SB = {
  key: 6,
  class: "flex flex-wrap gap-1",
  "data-testid": "list-item-label-badge"
}, $B = ["id"], IB = ["id"], TB = {
  key: 5,
  class: "flex shrink-0",
  "data-testid": "list-item-right-icon"
}, LB = {
  key: 6,
  class: "ml-0.5 flex shrink-0 items-center gap-1.5",
  "data-testid": "list-item-icons"
}, EB = ["id", "src", "alt"], AB = ["id", "role", "aria-label", "aria-hidden"], RB = {
  key: 0,
  class: "flex items-center gap-1.5",
  "data-testid": "list-item-trend"
}, BB = { class: "flex items-center" }, MB = ["id"], DB = ["id"], Jh = "text-(length:--size-l) leading-(--line-height-xxl) font-(--weight-medium)", Zh = "text-(length:--size-sm) leading-(--line-height-l) font-(--weight-regular)", Xh = "@max-[24rem]/item:flex-col-reverse", Qh = "pt-3.5 pr-3.5", zB = 2, OB = "ri-arrow-right-line", PB = "cursor-pointer text-left disabled:cursor-default aria-disabled:cursor-default focus-visible:outline-hidden after:absolute after:inset-0 after:content-[''] after:rounded-(--border-border-radius-rounded-xs) focus-visible:after:ring-2 focus-visible:after:ring-(--border-border-accent) focus-visible:after:outline-2 focus-visible:after:outline-transparent", FB = /* @__PURE__ */ ye({
  __name: "ListItem",
  props: {
    type: {},
    label: {},
    disabled: { type: Boolean, default: !1 },
    ariaDisabled: { type: Boolean, default: !1 },
    interactive: { type: Boolean, default: !1 },
    icon: { default: void 0 },
    value: { default: void 0 },
    rightIcon: { default: void 0 },
    icons: { default: void 0 },
    avatar: { default: void 0 },
    iconShape: { default: void 0 },
    helperText: { default: void 0 },
    extraText: { default: void 0 },
    labelBadge: { default: void 0 },
    badge: { default: void 0 },
    status: { default: void 0 },
    copyAction: { default: void 0 },
    primaryAction: { default: void 0 },
    secondaryAction: { default: void 0 },
    trend: { default: void 0 },
    progress: { default: void 0 },
    max: { default: void 0 },
    amount: { default: void 0 },
    total: { default: void 0 },
    sideText: { default: void 0 },
    percentText: { default: void 0 },
    valueTone: { default: void 0 },
    meta: { default: void 0 },
    author: { default: void 0 },
    badges: { default: void 0 },
    selected: { type: Boolean, default: void 0 }
  },
  emits: ["click"],
  setup(e, { expose: n, emit: t }) {
    var ae;
    const a = e, l = t, r = {
      root: "items-center justify-between gap-1.5",
      main: "flex-1",
      height: "min-h-6",
      labelText: Jh,
      extra: Zh,
      column: "gap-px",
      labelGap: "gap-1.5",
      surface: "",
      surfaceHover: "",
      surfaceActive: "",
      surfaceMuted: "",
      recolour: !0,
      hoverRecolour: !0,
      caption: "text-(--text-text-body)",
      gap: "gap-1.5",
      align: "items-center",
      value: "text-(--text-text-black-default)",
      valueText: "text-(length:--size-m) leading-(--line-height-l) font-(--weight-medium)",
      valueBox: "shrink-0",
      end: "inline",
      shape: "circle",
      trailingGap: "gap-4",
      trailingStack: Xh,
      label: "text-(--text-text-body)",
      helper: "text-(--text-text-body)",
      labelRow: "items-center",
      leading: "",
      badgePlacement: "trailing",
      secondaryVariant: "secondary",
      mutedBadges: !0,
      mutedIconShape: !0
    }, o = {
      root: "items-center justify-between gap-0.5",
      main: "flex-1",
      height: "",
      gap: "gap-2",
      labelText: Jh,
      extra: Zh,
      column: "gap-px",
      labelGap: "gap-1.5",
      surface: "",
      surfaceHover: "",
      surfaceActive: "",
      surfaceMuted: "",
      recolour: !0,
      hoverRecolour: !0,
      caption: "text-(--text-text-body)",
      value: "",
      valueText: "",
      valueBox: "",
      end: "inline",
      shape: "circle",
      trailingGap: "gap-4",
      trailingStack: Xh,
      mutedBadges: !0,
      mutedIconShape: !0
    }, i = {
      ...o,
      root: "items-center justify-between gap-1.5",
      height: "",
      label: "text-(--text-text-body)",
      helper: "text-(--text-text-body)",
      value: "text-(--text-text-body)",
      valueText: "text-(length:--size-l) leading-(--line-height-xxl) font-(--weight-medium)",
      // Figma puts the value in the root, 6 px after `Left content`; here it sits in the main zone,
      // whose gap is the 8 px of `Left content`.
      valueBox: "shrink-0 -ml-0.5",
      align: "items-center",
      labelRow: "items-center",
      leading: "",
      badgePlacement: "trailing",
      secondaryVariant: "secondary",
      // Figma Disabled object rows keep the Icon Shape colours.
      mutedIconShape: !1
    }, s = `${Qh} pl-3.5 pb-[calc(--spacing(3.5)-1px)]`, d = `${s} border-b border-(--border-border-disabled-subtle) bg-(--background-background-disabled-opacity)`, u = `${s} border-b border-(--border-border-disabled) bg-(--background-background-disabled-opacity)`, f = {
      ...i,
      root: "items-center justify-between gap-2",
      gap: "gap-2",
      labelText: "text-(length:--size-m) leading-(--line-height-l) font-(--weight-semi-bold)",
      label: "text-(--text-text-black-default)",
      column: "gap-1",
      labelGap: "gap-0",
      hoverRecolour: !1,
      surface: `${s} border-b border-(--border-border-base-soft) bg-(--background-background-white)`,
      surfaceHover: "hover:pl-[calc(--spacing(3.5)-2px)] hover:pb-3.5 hover:border-b-0 hover:border-l-2 hover:border-l-(--border-border-hover) hover:bg-(--background-background-hover)",
      surfaceActive: `${Qh} pl-[calc(--spacing(3.5)-2px)] pb-3.5 border-l-2 border-(--border-border-hover) bg-(--background-background-hover)`,
      surfaceMuted: d,
      mutedIconShape: !0
    }, b = {
      avatar: !0,
      helperText: !0,
      extraText: !0,
      labelBadge: !0,
      badge: !0,
      secondaryAction: !0
    }, h = {
      default: { ...r, props: { icon: !0 } },
      "with-number": { ...r, props: { icon: !0, value: !0 } },
      "with-badge": { ...r, props: { icon: !0, badge: !0 } },
      "with-right-icon": { ...r, props: { icon: !0, rightIcon: !0 } },
      "with-icons": { ...r, root: "items-center justify-start gap-2", main: "flex-initial", props: { icon: !0, icons: !0 } },
      "image-number": { ...i, props: { avatar: !0, helperText: !0, value: !0 } },
      "icon-number": {
        ...i,
        root: "items-start justify-start gap-2",
        main: "flex-initial",
        valueBox: "shrink-0 self-start",
        props: { iconShape: !0, helperText: !0, value: !0 }
      },
      // Figma Disabled 12773:10692, 15346:13357, 12773:13407 keep the Badge theme.
      "icon-number-badge": {
        ...i,
        badgePlacement: "above",
        mutedBadges: !1,
        props: { iconShape: !0, helperText: !0, badge: !0 }
      },
      "icon-badge": { ...i, mutedBadges: !1, props: { iconShape: !0, helperText: !0, badge: !0 } },
      "badge-name": { ...i, badgePlacement: "above", mutedBadges: !1, props: { badge: !0, helperText: !0 } },
      "image-buttons": {
        ...i,
        trailingGap: "gap-1.5",
        // Two buttons: on screen in their Tab order.
        trailingStack: "@max-[24rem]/item:flex-col",
        secondaryVariant: "ghost",
        props: { avatar: !0, helperText: !0, primaryAction: !0, secondaryAction: !0 }
      },
      transaction: {
        ...i,
        label: "text-(--text-text-black-default)",
        helper: "text-(--text-text-black-default)",
        valueText: "text-(length:--size-m) leading-(--line-height-l) font-(--weight-medium)",
        value: "text-(--text-text-black-default)",
        end: "column",
        shape: "square",
        props: { iconShape: !0, helperText: !0, value: !0, status: !0 }
      },
      // Figma 19619:3015: only the label and extra text recolour (hover and disabled).
      "data-list": {
        ...i,
        root: "items-center justify-between gap-1.5 pb-1.5",
        height: "",
        gap: "gap-1.5",
        labelText: "text-(length:--size-xxl) leading-(--line-height-xxl) font-(--weight-bold)",
        label: "text-(--text-text-heading)",
        extra: "text-(length:--size-l) leading-(--line-height-xxl) font-(--weight-regular)",
        helper: "text-(--text-text-black-default)",
        column: "gap-0.5",
        trailingGap: "gap-1.5",
        props: { extraText: !0, trend: !0 }
      },
      // Figma 19563:13185: hover and disabled change the fill only.
      progress: {
        ...i,
        root: "flex-col items-stretch gap-1.5 p-1 pt-0 rounded-(--border-border-radius-rounded-xs)",
        main: "w-full",
        gap: "gap-0",
        labelText: "text-(length:--size-l) leading-(--line-height-xxl) font-(--weight-regular)",
        labelGap: "gap-4",
        labelRow: "items-end",
        column: "gap-0",
        surfaceHover: "hover:bg-(--background-background-hover)",
        surfaceMuted: "bg-(--background-background-disabled-opacity)",
        recolour: !1,
        hoverRecolour: !1,
        props: {
          progress: !0,
          max: !0,
          amount: !0,
          total: !0,
          sideText: !0,
          percentText: !0,
          valueTone: !0
        }
      },
      "tab-document": {
        ...f,
        shape: "square",
        props: { iconShape: !0, meta: !0, author: !0, selected: !0 }
      },
      // The Figma raw binds a stronger disabled border on these two than on tab-document.
      "tab-badge": { ...f, badgePlacement: "below", surfaceMuted: u, props: { badge: !0, selected: !0 } },
      "tab-history": {
        ...f,
        surfaceMuted: u,
        props: { meta: !0, author: !0, badges: !0, selected: !0 }
      },
      "avatar-text-badge": {
        ...o,
        props: { ...b, copyAction: !0 },
        label: "text-(--text-text-body)",
        helper: "text-(--text-text-body)",
        align: "items-center",
        labelRow: "items-center",
        leading: "",
        badgePlacement: "trailing",
        secondaryVariant: "secondary"
      },
      "avatar-text-two-badges": {
        ...o,
        props: b,
        label: "text-(--text-text-heading)",
        helper: "text-(--text-text-black-default)",
        align: "items-start",
        labelRow: "items-start",
        leading: "py-1",
        badgePlacement: "label-row",
        secondaryVariant: "secondary"
      },
      "contact-item-badge": {
        ...o,
        props: b,
        label: "text-(--text-text-heading)",
        helper: "text-(--text-text-black-default)",
        align: "items-center",
        labelRow: "items-start",
        leading: "",
        badgePlacement: "trailing",
        secondaryVariant: "secondary"
      }
    }, m = p(() => h[a.type] ?? h.default), x = p(() => a.disabled || a.ariaDisabled), y = [
      "icon",
      "value",
      "rightIcon",
      "icons",
      "avatar",
      "iconShape",
      "helperText",
      "extraText",
      "labelBadge",
      "badge",
      "status",
      "copyAction",
      "primaryAction",
      "secondaryAction",
      "trend",
      "progress",
      "max",
      "amount",
      "total",
      "sideText",
      "percentText",
      "valueTone",
      "meta",
      "author",
      "badges",
      "selected"
    ];
    function w(Z) {
      return !!m.value.props[Z];
    }
    const S = p(() => {
      const Z = w("copyAction") ? a.copyAction : void 0;
      return Z && x.value ? { ...Z, disabled: !0, disabledReason: void 0 } : Z;
    }), $ = p(() => {
      var fe;
      const Z = (de) => w(de) ? a[de] : void 0, ie = m.value.badgePlacement;
      return {
        icon: Z("icon"),
        value: Z("value"),
        rightIcon: w("rightIcon") ? a.rightIcon ?? OB : void 0,
        icons: Z("icons"),
        avatar: Z("avatar"),
        iconShape: Z("iconShape"),
        status: Z("status"),
        helperText: Z("helperText"),
        extraText: Z("extraText"),
        labelBadge: Z("labelBadge"),
        belowBadges: [
          w("labelBadge") ? a.labelBadge : void 0,
          ie === "below" ? a.badge : void 0,
          ...w("badges") ? (a.badges ?? []).slice(0, zB) : []
        ].filter((de) => !!de),
        meta: w("meta") && ((fe = a.meta) != null && fe.length) ? a.meta.join(" · ") : void 0,
        author: Z("author"),
        selected: w("selected") && a.interactive && !!a.selected,
        rowBadge: ie === "label-row" ? Z("badge") : void 0,
        topBadge: ie === "above" ? Z("badge") : void 0,
        trailingBadge: ie === "trailing" ? Z("badge") : void 0,
        copyAction: S.value,
        primaryAction: Z("primaryAction"),
        secondaryAction: Z("secondaryAction"),
        trend: Z("trend"),
        progress: Z("progress"),
        max: Z("max"),
        amount: Z("amount"),
        total: Z("total"),
        sideText: Z("sideText"),
        percentText: Z("percentText")
      };
    }), T = {
      neutral: "text-(--text-text-body)",
      success: "text-(--text-text-success)",
      warning: "text-(--text-text-warning)",
      destructive: "text-(--text-text-error-strong)",
      info: "text-(--text-text-info)"
    }, L = p(() => T[a.valueTone ?? "neutral"]), A = Ve(), R = Ve(), z = (Z) => `${R}-${Z}`, D = p(() => {
      var fe;
      const Z = $.value;
      return [
        Z.topBadge && z("top-badge"),
        Z.sideText && z("side"),
        Z.rowBadge && z("row-badge"),
        Z.helperText && z("helper"),
        Z.extraText && z("extra"),
        Z.amount && z("amount"),
        Z.amount && Z.total && z("total"),
        Z.amount && Z.percentText && z("percent"),
        Z.meta && z("meta"),
        Z.author && z("author"),
        ...Z.belowBadges.map((de, ne) => z(`below-badge-${ne}`)),
        Z.value && z("value"),
        Z.value && Z.status && m.value.end === "column" && z("status"),
        ...(Z.icons ?? []).flatMap((de, ne) => de.label ? [z(`icon-${ne}`)] : []),
        Z.trend && z("trend-value"),
        ((fe = Z.trend) == null ? void 0 : fe.caption) && z("trend-caption"),
        Z.trailingBadge && z("trailing-badge")
      ].filter((de) => !!de).join(" ") || void 0;
    }), V = p(() => x.value ? m.value.surfaceMuted : $.value.selected ? m.value.surfaceActive : a.interactive ? [m.value.surface, m.value.surfaceHover] : m.value.surface), Y = p(() => x.value ? "text-(--text-text-disabled-strong)" : m.value.caption), _ = p(
      () => !!($.value.trailingBadge || $.value.primaryAction || $.value.secondaryAction || $.value.trend)
    ), j = p(() => {
      if (x.value && m.value.recolour) return "text-(--text-text-disabled-strong)";
      const Z = m.value.label;
      return a.interactive && m.value.hoverRecolour ? `${Z} group-hover/row:text-(--text-text-hover)` : Z;
    }), M = p(() => {
      if (x.value && m.value.recolour) return "text-(--text-text-disabled-strong)";
      const Z = m.value.helper;
      return a.interactive && m.value.hoverRecolour ? `${Z} group-hover/row:text-(--text-text-hover)` : Z;
    }), W = p(() => {
      if (x.value) return "text-(--icons-icon-disabled-strong)";
      const Z = "text-(--icons-icon-dark-default)";
      return a.interactive ? `${Z} group-hover/row:text-(--icons-icon-hover)` : Z;
    }), G = p(() => {
      if (x.value) return `${m.value.valueText} text-(--text-text-disabled-strong)`;
      const Z = `${m.value.valueText} ${m.value.value}`;
      return a.interactive ? `${Z} group-hover/row:text-(--text-text-hover)` : Z;
    }), B = p(() => x.value ? "grayscale opacity-60" : "");
    function F(Z) {
      return x.value && m.value.mutedBadges ? "disabled" : Z.theme;
    }
    const X = p(() => a.interactive && !x.value ? "group-hover/row:text-(--text-text-hover)" : "");
    function H(Z) {
      x.value || l("click", Z);
    }
    const q = p(
      () => a.interactive ? {
        type: "button",
        disabled: a.disabled,
        "aria-disabled": a.ariaDisabled && !a.disabled ? "true" : void 0,
        "aria-current": $.value.selected ? "true" : void 0,
        "aria-labelledby": A,
        "aria-describedby": D.value,
        "data-row-button": "",
        "data-testid": "list-item-row-button"
      } : {}
    ), N = E(null), J = E(null), be = E(null);
    function ke(Z) {
      const ie = { primary: N, secondary: J, copy: be }[Z].value;
      return (ie == null ? void 0 : ie.focus()) ?? !1;
    }
    n({ focusAction: ke });
    const ee = E(null), oe = E(!1), ge = E(!1), re = p(() => ge.value ? !1 : oe.value ? !0 : void 0);
    function ue(Z) {
      try {
        oe.value = Z.target.matches(":focus-visible");
      } catch {
        oe.value = !0;
      }
    }
    function O() {
      oe.value = !1, ge.value = !1;
    }
    Ie(
      () => [a.disabled, a.interactive],
      ([Z, ie]) => {
        (Z || !ie) && O();
      }
    );
    function U(Z) {
      var ie;
      Z.key !== "Escape" || ge.value || !oe.value || !((ie = ee.value) != null && ie.isTruncated) || (Z.stopPropagation(), Z.preventDefault(), ge.value = !0);
    }
    const Q = typeof process < "u" && ((ae = process.env) == null ? void 0 : ae.NODE_ENV) !== "production";
    return Ie(
      () => [a.type, a.interactive, a.selected, ...y.map((Z) => a[Z] !== void 0)].join(),
      () => {
        if (!Q) return;
        if (!(a.type in h)) {
          console.warn(`[OPAL ListItem] unknown type "${a.type}": rendered as "default".`);
          return;
        }
        const Z = y.filter((ie) => a[ie] !== void 0 && !w(ie));
        Z.length && console.warn(`[OPAL ListItem] type "${a.type}" takes no ${Z.map((ie) => `\`${ie}\``).join(", ")}: ignored.`), a.selected && !a.interactive && console.warn("[OPAL ListItem] `selected` needs `interactive`: ignored.");
      },
      { immediate: !0 }
    ), (Z, ie) => {
      var fe;
      return c(), g("li", {
        class: C(["@container/item flex w-full min-w-0", [m.value.root, m.value.height, V.value, e.interactive ? "group/row relative" : ""]]),
        "data-testid": "list-item"
      }, [
        e.interactive || $.value.progress !== void 0 ? (c(), g("span", {
          key: 0,
          id: I(A),
          hidden: ""
        }, P(e.label), 9, uB)) : k("", !0),
        v("div", {
          class: C(["flex min-w-0", [m.value.main, m.value.gap, m.value.align]]),
          "data-testid": "list-item-main"
        }, [
          $.value.icon ? (c(), g("div", cB, [
            v("i", {
              class: C(["inline-flex size-(--icon-size-sm) items-center justify-center text-(length:--icon-size-sm) leading-(--icon-size-sm)", [$.value.icon, W.value]]),
              "aria-hidden": "true"
            }, null, 2)
          ])) : k("", !0),
          $.value.iconShape ? (c(), g("div", fB, [
            te(Xt, {
              icon: $.value.iconShape.icon,
              color: x.value && m.value.mutedIconShape ? "disabled" : $.value.iconShape.color ?? "default",
              type: m.value.shape,
              variant: "outlined",
              size: "md",
              as: "span"
            }, null, 8, ["icon", "color", "type"])
          ])) : k("", !0),
          $.value.avatar ? (c(), g("div", {
            key: 2,
            class: C(["flex shrink-0", m.value.leading]),
            "data-testid": "list-item-leading"
          }, [
            te(Kt, {
              name: $.value.avatar.name,
              img: $.value.avatar.img,
              entity: $.value.avatar.entity,
              size: "md",
              as: "span",
              presentational: ""
            }, null, 8, ["name", "img", "entity"])
          ], 2)) : k("", !0),
          v("div", {
            class: C(["flex flex-1 min-w-0 flex-col", m.value.column])
          }, [
            $.value.topBadge ? (c(), g("div", hB, [
              te(ct, {
                id: z("top-badge"),
                label: $.value.topBadge.label,
                theme: F($.value.topBadge),
                "left-icon": $.value.topBadge.leftIcon,
                "show-left-icon": !!$.value.topBadge.leftIcon,
                size: "sm"
              }, null, 8, ["id", "label", "theme", "left-icon", "show-left-icon"])
            ])) : k("", !0),
            v("div", {
              class: C(["flex min-w-0", [m.value.labelGap, m.value.labelRow]]),
              "data-testid": "list-item-label-row"
            }, [
              (c(), K(dt(e.interactive ? "button" : "span"), Oe({
                class: ["flex min-w-0", [$.value.copyAction ? "" : "flex-1", e.interactive ? PB : ""]]
              }, q.value, Rl(e.interactive ? { click: H, focus: ue, blur: O, keydown: U } : {})), {
                default: ve(() => [
                  te(bt, {
                    ref_key: "labelRef",
                    ref: ee,
                    as: "span",
                    class: C(e.interactive ? "relative z-1" : ""),
                    text: e.label,
                    focusable: !e.interactive,
                    open: e.interactive ? re.value : void 0,
                    "text-class": `${m.value.labelText} @max-[24rem]/item:whitespace-normal @max-[24rem]/item:wrap-break-word ${j.value}`,
                    "data-testid": "list-item-label"
                  }, null, 8, ["class", "text", "focusable", "open", "text-class"])
                ]),
                _: 1
              }, 16, ["class"])),
              $.value.sideText ? (c(), g("div", {
                key: 0,
                id: z("side"),
                class: "block min-w-0 max-w-1/2 shrink-0 wrap-break-word text-right text-(length:--size-sm) leading-(--line-height-l) font-(--weight-regular) text-(--text-text-body)",
                "data-testid": "list-item-side-text"
              }, P($.value.sideText), 9, bB)) : k("", !0),
              $.value.copyAction ? (c(), K(ld, {
                key: 1,
                ref_key: "copyRef",
                ref: be,
                class: C(e.interactive ? "relative z-1" : ""),
                action: $.value.copyAction,
                appearance: "inline-icon",
                muted: x.value,
                "row-hover": e.interactive,
                "keep-focusable": e.ariaDisabled && !e.disabled
              }, null, 8, ["class", "action", "muted", "row-hover", "keep-focusable"])) : k("", !0),
              $.value.rowBadge ? (c(), K(ct, {
                key: 2,
                id: z("row-badge"),
                class: "shrink-0",
                label: $.value.rowBadge.label,
                theme: F($.value.rowBadge),
                "left-icon": $.value.rowBadge.leftIcon,
                "show-left-icon": !!$.value.rowBadge.leftIcon,
                size: "sm",
                "data-testid": "list-item-badge"
              }, null, 8, ["id", "label", "theme", "left-icon", "show-left-icon"])) : k("", !0)
            ], 2),
            $.value.helperText ? (c(), g("span", {
              key: 1,
              id: z("helper"),
              class: C(["block min-w-0 wrap-break-word text-(length:--size-m) leading-(--line-height-l) font-(--weight-regular)", M.value]),
              "data-testid": "list-item-helper"
            }, P($.value.helperText), 11, gB)) : k("", !0),
            $.value.extraText ? (c(), g("span", {
              key: 2,
              id: z("extra"),
              class: C(["block min-w-0 wrap-break-word", [m.value.extra, M.value]]),
              "data-testid": "list-item-extra"
            }, P($.value.extraText), 11, pB)) : k("", !0),
            $.value.amount ? (c(), g("div", mB, [
              v("div", vB, [
                v("span", {
                  id: z("amount"),
                  class: "text-(length:--size-xl) leading-(--line-height-xl) font-(--weight-semi-bold) text-(--text-text-heading)",
                  "data-testid": "list-item-amount"
                }, P($.value.amount), 9, xB),
                $.value.total ? (c(), g("span", {
                  key: 0,
                  id: z("total"),
                  class: "text-(length:--size-m) leading-(--line-height-l) font-(--weight-regular) text-(--text-text-body)",
                  "data-testid": "list-item-total"
                }, P($.value.total), 9, yB)) : k("", !0)
              ]),
              $.value.percentText ? (c(), g("span", {
                key: 0,
                id: z("percent"),
                class: C(["shrink-0 text-right text-(length:--size-sm) leading-(--line-height-l) font-(--weight-medium)", L.value]),
                "data-testid": "list-item-percent"
              }, P($.value.percentText), 11, kB)) : k("", !0)
            ])) : k("", !0),
            $.value.meta ? (c(), g("span", {
              key: 4,
              id: z("meta"),
              class: C(["block min-w-0 wrap-break-word text-(length:--size-sm) leading-(--line-height-s) font-(--weight-regular)", Y.value]),
              "data-testid": "list-item-meta"
            }, P($.value.meta), 11, wB)) : k("", !0),
            $.value.author ? (c(), g("span", {
              key: 5,
              id: z("author"),
              class: C(["block min-w-0 wrap-break-word text-(length:--size-xs) leading-(--line-height-xs) font-(--weight-regular)", Y.value]),
              "data-testid": "list-item-author"
            }, P($.value.author), 11, CB)) : k("", !0),
            $.value.belowBadges.length ? (c(), g("div", SB, [
              (c(!0), g(se, null, Me($.value.belowBadges, (de, ne) => (c(), K(ct, {
                id: z(`below-badge-${ne}`),
                key: ne,
                label: de.label,
                theme: F(de),
                "left-icon": de.leftIcon,
                "show-left-icon": !!de.leftIcon,
                size: "sm"
              }, null, 8, ["id", "label", "theme", "left-icon", "show-left-icon"]))), 128))
            ])) : k("", !0)
          ], 2),
          $.value.value && m.value.end === "column" ? (c(), g("div", {
            key: 3,
            class: C(["flex shrink-0 flex-col items-end", m.value.valueBox]),
            "data-testid": "list-item-end"
          }, [
            v("span", {
              id: z("value"),
              class: C(G.value),
              "data-testid": "list-item-value"
            }, P($.value.value), 11, $B),
            $.value.status ? (c(), K(ct, {
              key: 0,
              id: z("status"),
              label: $.value.status.label,
              theme: F($.value.status),
              type: "with-dot",
              size: "sm",
              class: C(X.value),
              "data-testid": "list-item-status"
            }, null, 8, ["id", "label", "theme", "class"])) : k("", !0)
          ], 2)) : $.value.value ? (c(), g("span", {
            key: 4,
            id: z("value"),
            class: C([m.value.valueBox, G.value]),
            "data-testid": "list-item-value"
          }, P($.value.value), 11, IB)) : k("", !0),
          $.value.rightIcon ? (c(), g("div", TB, [
            v("i", {
              class: C(["inline-flex size-(--icon-size-sm) items-center justify-center text-(length:--icon-size-sm) leading-(--icon-size-sm)", [$.value.rightIcon, W.value]]),
              "aria-hidden": "true"
            }, null, 2)
          ])) : k("", !0),
          (fe = $.value.icons) != null && fe.length ? (c(), g("div", LB, [
            (c(!0), g(se, null, Me($.value.icons, (de, ne) => (c(), g(se, { key: ne }, [
              de.src ? (c(), g("img", {
                key: 0,
                id: de.label ? z(`icon-${ne}`) : void 0,
                class: C(["size-4.5 shrink-0 object-contain", B.value]),
                src: de.src,
                alt: de.label,
                "data-testid": "list-item-icons-entry"
              }, null, 10, EB)) : (c(), g("i", {
                key: 1,
                id: de.label ? z(`icon-${ne}`) : void 0,
                class: C(["inline-flex size-4.5 items-center justify-center text-[18px] leading-[18px]", [de.icon, W.value]]),
                role: de.label ? "img" : void 0,
                "aria-label": de.label,
                "aria-hidden": de.label ? void 0 : "true",
                "data-testid": "list-item-icons-entry"
              }, null, 10, AB))
            ], 64))), 128))
          ])) : k("", !0)
        ], 2),
        $.value.progress !== void 0 ? (c(), K(Vu, {
          key: 1,
          value: $.value.progress,
          max: $.value.max,
          size: "lg",
          "aria-labelledby": I(A),
          "aria-valuetext": $.value.percentText,
          "data-testid": "list-item-progress"
        }, null, 8, ["value", "max", "aria-labelledby", "aria-valuetext"])) : k("", !0),
        _.value ? (c(), g("div", {
          key: 2,
          class: C(["flex shrink-0 items-center @max-[24rem]/item:items-end @max-[24rem]/item:gap-2", [m.value.trailingGap, m.value.trailingStack]]),
          "data-testid": "list-item-trailing"
        }, [
          $.value.trend ? (c(), g("div", RB, [
            v("span", BB, [
              ie[0] || (ie[0] = v("i", {
                class: "ri-arrow-right-up-line inline-flex size-(--icon-size-sm) items-center justify-center text-(length:--icon-size-sm) leading-(--icon-size-sm) text-(--icons-icon-success)",
                "aria-hidden": "true"
              }, null, -1)),
              v("span", {
                id: z("trend-value"),
                class: "text-(length:--size-m) leading-(--line-height-l) font-(--weight-medium) text-(--text-text-success)",
                "data-testid": "list-item-trend-value"
              }, P($.value.trend.value), 9, MB)
            ]),
            $.value.trend.caption ? (c(), g("span", {
              key: 0,
              id: z("trend-caption"),
              class: "text-(length:--size-m) leading-(--line-height-l) font-(--weight-regular) text-(--text-text-body)",
              "data-testid": "list-item-trend-caption"
            }, P($.value.trend.caption), 9, DB)) : k("", !0)
          ])) : k("", !0),
          $.value.trailingBadge ? (c(), K(ct, {
            key: 1,
            id: z("trailing-badge"),
            label: $.value.trailingBadge.label,
            theme: F($.value.trailingBadge),
            "left-icon": $.value.trailingBadge.leftIcon,
            "show-left-icon": !!$.value.trailingBadge.leftIcon,
            size: "sm",
            "data-testid": "list-item-badge"
          }, null, 8, ["id", "label", "theme", "left-icon", "show-left-icon"])) : k("", !0),
          $.value.primaryAction ? (c(), K(ld, {
            key: 2,
            ref_key: "primaryRef",
            ref: N,
            class: C(e.interactive ? "relative z-1" : ""),
            action: $.value.primaryAction,
            appearance: "label",
            variant: "secondary"
          }, null, 8, ["class", "action"])) : k("", !0),
          $.value.secondaryAction ? (c(), K(ld, {
            key: 3,
            ref_key: "secondaryRef",
            ref: J,
            class: C(e.interactive ? "relative z-1" : ""),
            action: $.value.secondaryAction,
            appearance: "icon",
            variant: m.value.secondaryVariant
          }, null, 8, ["class", "action", "variant"])) : k("", !0)
        ], 2)) : k("", !0)
      ], 2);
    };
  }
}), VB = /* @__PURE__ */ ye({
  __name: "ListItemGroup",
  props: {
    divider: { type: Boolean, default: !1 },
    dividerColor: { default: "var(--border-border-base-soft)" }
  },
  setup(e) {
    const n = e, t = p(() => n.divider ? { "--list-item-group-divider": n.dividerColor } : void 0);
    return (a, l) => (c(), g("ul", {
      role: "list",
      class: C(["m-0 flex w-full min-w-0 list-none flex-col p-0", e.divider ? "gap-3 [&>li+li]:border-t [&>li+li]:border-solid [&>li+li]:border-(--list-item-group-divider) [&>li+li]:pt-3" : "gap-4"]),
      style: Ne(t.value),
      "data-testid": "list-item-group"
    }, [
      $e(a.$slots, "default")
    ], 6));
  }
});
function xv(e) {
  return p(() => {
    const n = e(), t = n.border !== !1, a = [
      `flex items-center rounded-(--border-border-radius-rounded-l) border border-solid w-full transition-[color,background-color,border-color,box-shadow] duration-200 ${n.padding}`,
      n.gap
    ];
    return n.minHeight && a.push(n.minHeight), n.alwaysClasses && a.push(n.alwaysClasses), n.disabled ? (a.push("bg-(--background-background-disabled-opacity) cursor-default"), a.push(t ? "border-(--border-border-disabled)" : "border-transparent"), a) : (n.selected ? a.push("bg-(--background-background-accent) border-(--border-border-accent)") : (a.push("bg-(--background-background-white) hover:bg-(--background-background-hover)"), a.push(
      t ? "border-(--border-border-base-medium) hover:border-(--border-border-hover)" : "border-transparent"
    )), n.restingClasses && a.push(n.restingClasses), n.grabbed && a.push("ring-2 ring-(--border-border-accent)"), a);
  });
}
const NB = {
  key: 0,
  class: "min-w-0 flex-1"
}, HB = ["aria-label"], jB = /* @__PURE__ */ ye({
  __name: "EditableTitle",
  props: {
    modelValue: {},
    editable: { type: Boolean, default: !0 },
    showPen: { type: Boolean, default: !0 },
    size: { default: "md" },
    placeholder: { default: void 0 },
    maxlength: { default: void 0 },
    error: { default: void 0 },
    editLabel: {},
    saveLabel: {},
    penVariant: { default: "secondary" },
    inputWidth: { default: void 0 },
    maxWidth: { default: void 0 },
    warnPattern: { default: void 0 },
    warnLabel: { default: void 0 },
    autoEdit: { type: Boolean, default: !1 }
  },
  emits: ["save", "cancel", "edit-start", "edit-end"],
  setup(e, { emit: n }) {
    const t = e, a = n, l = {
      sm: {
        text: "text-(length:--size-m) leading-(--line-height-l) font-(--weight-semi-bold) text-(--text-text-heading) dark:text-(--colors-text-white-default)",
        gap: "gap-1.5",
        pen: "xs"
      },
      md: {
        text: "text-(length:--size-4xl) leading-(--line-height-4xl) font-(--weight-bold) text-(--text-text-black-default) dark:text-(--colors-text-white-default)",
        gap: "gap-3",
        pen: "xs"
      },
      lg: {
        text: "text-(length:--size-5xl) leading-(--line-height-5xl) font-(--weight-bold) text-(--text-text-black-default) dark:text-(--colors-text-white-default)",
        gap: "gap-3",
        pen: "lg"
      }
    }, r = p(() => l[t.size]), o = E(!1), i = E(""), s = E(null), d = E(null), u = p(
      () => t.maxWidth && !o.value ? { maxWidth: t.maxWidth } : void 0
    ), f = p(() => !!t.warnPattern && t.warnPattern.test(i.value));
    function b() {
      var T;
      const S = (T = s.value) == null ? void 0 : T.$el, $ = S == null ? void 0 : S.querySelector("input");
      $ == null || $.focus(), $ == null || $.select();
    }
    async function h() {
      t.editable && (i.value = t.modelValue, o.value = !0, await qe(), b());
    }
    async function m() {
      var S, $;
      o.value = !1, await qe(), ($ = (S = d.value) == null ? void 0 : S.$el) == null || $.focus();
    }
    function x() {
      m(), a("cancel");
    }
    function y() {
      const S = i.value.trim();
      if (S.length === 0 || S === t.modelValue) {
        x();
        return;
      }
      a("save", S), m();
    }
    function w(S) {
      S.key === "Enter" ? (S.preventDefault(), y()) : S.key === "Escape" && (S.preventDefault(), x());
    }
    return Ie(
      () => t.error,
      async (S) => {
        S && !o.value && (o.value = !0, await qe(), b());
      }
    ), Ie(o, (S) => {
      a(S ? "edit-start" : "edit-end");
    }), Ie(
      () => t.autoEdit,
      (S) => {
        S && t.editable && !o.value && h();
      },
      { immediate: !0 }
    ), (S, $) => (c(), g("div", {
      class: C(["inline-flex min-w-0 items-center", o.value ? "gap-3" : r.value.gap]),
      style: Ne(u.value),
      "data-testid": "editable-title"
    }, [
      o.value ? (c(), g(se, { key: 1 }, [
        te(zt, {
          ref_key: "inputRef",
          ref: s,
          modelValue: i.value,
          "onUpdate:modelValue": $[0] || ($[0] = (T) => i.value = T),
          size: "md",
          placeholder: e.placeholder,
          maxlength: e.maxlength,
          "aria-label": e.editLabel,
          "full-width": !e.inputWidth,
          width: e.inputWidth,
          "data-testid": "editable-title-input",
          onKeydown: w
        }, _n({ _: 2 }, [
          f.value ? {
            name: "iconRight",
            fn: ve(() => [
              te(ft, {
                text: e.warnLabel ?? "",
                disabled: !e.warnLabel,
                position: "bottom"
              }, {
                default: ve(() => [
                  v("i", {
                    class: "ri-alert-fill inline-flex size-4 shrink-0 items-center justify-center text-(length:--size-l) text-(--icons-icon-warning)",
                    role: "img",
                    "aria-label": e.warnLabel,
                    "data-testid": "editable-title-warning"
                  }, null, 8, HB)
                ]),
                _: 1
              }, 8, ["text", "disabled"])
            ]),
            key: "0"
          } : void 0
        ]), 1032, ["modelValue", "placeholder", "maxlength", "aria-label", "full-width", "width"]),
        te(Re, {
          variant: "secondary",
          size: "sm",
          "icon-only": "",
          "icon-left": "ri-save-3-fill",
          "aria-label": e.saveLabel,
          "data-testid": "editable-title-save",
          onMousedown: $[1] || ($[1] = Ue(() => {
          }, ["prevent"])),
          onClick: y
        }, null, 8, ["aria-label"])
      ], 64)) : (c(), g(se, { key: 0 }, [
        e.maxWidth ? (c(), g("div", NB, [
          te(bt, {
            text: e.modelValue,
            position: "bottom",
            "text-class": r.value.text,
            "data-testid": "editable-title-text"
          }, null, 8, ["text", "text-class"])
        ])) : (c(), g("span", {
          key: 1,
          class: C([r.value.text, "truncate"]),
          "data-testid": "editable-title-text"
        }, P(e.modelValue), 3)),
        e.editable && e.showPen ? (c(), K(Re, {
          key: 2,
          ref_key: "penRef",
          ref: d,
          variant: e.penVariant,
          size: r.value.pen,
          "icon-only": "",
          "icon-left": "ri-pencil-line",
          "aria-label": e.editLabel,
          "data-testid": "editable-title-edit",
          onClick: h
        }, null, 8, ["variant", "size", "aria-label"])) : k("", !0)
      ], 64))
    ], 6));
  }
}), WB = /* @__PURE__ */ lt(jB, [["__scopeId", "data-v-d12b23de"]]), qB = { class: "flex flex-1 min-w-0 items-center gap-2" }, UB = { class: "flex-1 min-w-0 flex flex-col gap-0" }, GB = { class: "flex grow shrink basis-48 min-w-0 items-center gap-2" }, KB = { class: "flex flex-1 min-w-0 flex-col gap-0" }, YB = {
  key: 0,
  class: "w-full min-w-0 truncate text-(length:--size-sm) leading-(--line-height-s) text-(--text-text-body)",
  "data-testid": "list-item-subtitle"
}, JB = {
  key: 0,
  class: "ml-auto flex min-w-0 flex-wrap items-center justify-end gap-x-6 gap-y-3",
  "data-testid": "list-item-trailing"
}, ZB = {
  key: 0,
  class: "flex flex-wrap items-center justify-end gap-x-6 gap-y-3",
  "data-testid": "list-item-trailing-actions"
}, XB = {
  key: 0,
  class: "flex items-center gap-6",
  "data-testid": "list-item-stats"
}, QB = { class: "flex min-w-0 grow shrink basis-32 flex-col" }, _B = {
  key: 0,
  class: "flex min-w-0 flex-wrap items-center gap-x-4 gap-y-3",
  "data-testid": "list-item-stats"
}, eM = {
  key: 1,
  class: "flex min-h-12.5 w-[153px] max-w-full shrink-0 flex-col justify-center gap-1.5",
  "data-testid": "list-item-progress"
}, tM = ["id"], nM = ["id"], aM = {
  key: 2,
  class: "flex shrink-0 items-center gap-4",
  "data-testid": "list-item-trailing-actions"
}, lM = { class: "flex grow shrink basis-48 min-w-0 items-center gap-2" }, rM = ["aria-label", "aria-pressed", "disabled"], oM = { class: "flex flex-1 min-w-0 flex-col gap-0" }, iM = {
  key: 1,
  class: "w-full min-w-0 truncate text-(length:--size-m) leading-(--line-height-l) font-(--weight-semi-bold) text-(--text-text-heading)",
  "data-testid": "list-item-title"
}, sM = {
  key: 0,
  class: "w-full min-w-0 truncate text-(length:--size-sm) leading-(--line-height-s) text-(--text-text-body)",
  "data-testid": "list-item-subtitle"
}, dM = {
  key: 0,
  class: "ml-auto flex max-w-full shrink-0 flex-wrap items-center justify-end gap-3.5",
  "data-testid": "list-item-trailing"
}, uM = ["aria-label", "aria-pressed", "disabled"], cM = /* @__PURE__ */ ye({
  inheritAttrs: !1,
  __name: "ListItemCard",
  props: {
    type: { default: "default" },
    label: {},
    subtitle: { default: void 0 },
    disabled: { type: Boolean, default: !1 },
    reorderable: { type: Boolean, default: void 0 },
    dragHandleLabel: { default: void 0 },
    grabbed: { type: Boolean, default: !1 },
    editable: { type: Boolean, default: !1 },
    showEdit: { type: Boolean, default: !1 },
    editLabel: { default: void 0 },
    saveLabel: { default: void 0 },
    maxlength: { default: void 0 },
    editError: { default: void 0 },
    autoEdit: { type: Boolean, default: !1 },
    editInputWidth: { default: void 0 },
    selected: { type: Boolean, default: !1 },
    progress: { default: void 0 },
    max: { default: 100 },
    progressLabel: { default: void 0 }
  },
  emits: ["rename", "grab", "grab-cancel", "select"],
  setup(e, { emit: n }) {
    const t = ["draggable-edit", "draggable-collapsed"], a = ["card-item", "draggable-edit"], l = e, r = n, o = Ht();
    let i = {};
    dx(() => {
      i = {};
    });
    const s = (z) => i[z] ?? (i[z] = o(z)), d = E(!1), u = p(() => t.includes(l.type)), f = p(
      () => l.type === "draggable-collapsed" ? {
        role: "button",
        tabindex: l.disabled ? void 0 : 0,
        "aria-pressed": l.selected || void 0,
        // The row IS the button here, so it carries the disabled state (other types' roots have a
        // role that supports none). Only set when disabled, so a forwarded attr is not clobbered.
        ...l.disabled ? { "aria-disabled": "true" } : {}
      } : {}
    ), b = p(() => !u.value || l.reorderable === !1 ? !1 : l.reorderable === !0 ? !0 : !l.disabled), h = {
      default: { padding: "p-[calc(--spacing(3.5)-1px)]", gap: "gap-3.5", shadow: !0 },
      "card-item": { padding: "p-[calc(--spacing(3.5)-1px)]", gap: "gap-6", minHeight: "min-h-[74px]", shadow: !1 },
      "draggable-edit": { padding: "p-[calc(--spacing(3.5)-1px)]", gap: "gap-3.5", minHeight: "min-h-[74px]", shadow: !0 },
      "draggable-collapsed": { padding: "p-[calc(--spacing(3.5)-1px)]", gap: "gap-2", minHeight: "min-h-14", shadow: !0 },
      progression: {
        padding: "pt-[calc(--spacing(4.5)-1px)] pr-[calc(--spacing(5)-1px)] pb-[calc(--spacing(4.5)-1px)] pl-[calc(--spacing(6)-1px)]",
        gap: "gap-4",
        shadow: !0
      }
    }, m = xv(() => {
      const z = h[l.type];
      return {
        padding: z.padding,
        gap: z.gap,
        minHeight: z.minHeight,
        // The draggable Figma variants drop the DS card shadow on hover and when disabled.
        restingClasses: z.shadow ? l.type === "progression" ? "shadow-(--blur-shadow-s)" : "shadow-(--blur-shadow-s) hover:shadow-none" : void 0,
        // The trailing zone wraps under the text only when it no longer fits beside a 12rem text
        // block (`basis-48` below; Figma has no narrow card), 12px below it. The drag rows of a
        // drawer (`default`) and the palette (`draggable-collapsed`) stay on one line.
        alwaysClasses: a.includes(l.type) ? "flex-wrap gap-y-3" : l.type === "progression" ? "flex-wrap justify-between gap-y-3" : void 0,
        disabled: l.disabled,
        // selected wins over the resting border (collapsed palette pick); grabbed is the
        // keyboard-grabbed accent ring (Rule n°4 feedback) — both are no-ops outside their own type.
        selected: l.selected,
        grabbed: l.grabbed
      };
    }), x = Ve(), y = Ve(), w = p(() => {
      var z;
      return ((z = l.progressLabel) == null ? void 0 : z.trim()) || void 0;
    }), S = p(
      () => l.disabled ? "text-(--text-text-disabled-strong)" : "text-(--text-text-body)"
    );
    function $() {
      b.value && r("grab");
    }
    function T() {
      r("grab-cancel");
    }
    function L(z) {
      r("rename", z);
    }
    function A() {
      l.disabled || l.type !== "draggable-collapsed" || r("select");
    }
    function R(z) {
      l.type !== "draggable-collapsed" || l.disabled || (z.key === "Enter" || z.key === " ") && (z.preventDefault(), r("select"));
    }
    return (z, D) => (c(), g("div", Oe({ ...z.$attrs, ...f.value }, {
      class: I(m),
      onClick: A,
      onKeydown: R
    }), [
      e.type === "default" ? (c(), g(se, { key: 0 }, [
        v("div", qB, [
          s("icon") || s("leading") ? (c(), g("div", {
            key: 0,
            class: C(["shrink-0 flex items-center", { "opacity-40": e.disabled }])
          }, [
            $e(z.$slots, "leading", {}, () => [
              $e(z.$slots, "icon")
            ])
          ], 2)) : k("", !0),
          v("div", UB, [
            v("p", {
              class: C(["text-(length:--size-m) leading-(--line-height-l) font-(--weight-semi-bold) w-full truncate", S.value])
            }, P(e.label), 3),
            e.subtitle ? (c(), g("p", {
              key: 0,
              class: C(["text-(length:--size-m) leading-(--line-height-l) font-(--weight-medium) w-full", S.value])
            }, P(e.subtitle), 3)) : k("", !0)
          ])
        ]),
        $e(z.$slots, "badge"),
        $e(z.$slots, "actions")
      ], 64)) : e.type === "card-item" ? (c(), g(se, { key: 1 }, [
        v("div", GB, [
          $e(z.$slots, "leading"),
          v("div", KB, [
            te(bt, {
              text: e.label,
              "text-class": "text-(length:--size-m) leading-(--line-height-l) font-(--weight-semi-bold) text-(--text-text-heading)",
              "data-testid": "list-item-title"
            }, null, 8, ["text"]),
            $e(z.$slots, "subtitle", {}, () => [
              e.subtitle ? (c(), g("p", YB, P(e.subtitle), 1)) : k("", !0)
            ])
          ])
        ]),
        s("badge") || s("stats") || s("actions") ? (c(), g("div", JB, [
          $e(z.$slots, "badge"),
          s("stats") || s("actions") ? (c(), g("div", ZB, [
            s("stats") ? (c(), g("div", XB, [
              $e(z.$slots, "stats")
            ])) : k("", !0),
            $e(z.$slots, "actions")
          ])) : k("", !0)
        ])) : k("", !0)
      ], 64)) : e.type === "progression" ? (c(), g(se, { key: 2 }, [
        v("div", QB, [
          te(bt, {
            text: e.label,
            "text-class": "text-(length:--size-l) leading-(--line-height-xxl) font-(--weight-bold) text-(--text-text-heading)",
            "data-testid": "list-item-title"
          }, null, 8, ["text"])
        ]),
        s("stats") ? (c(), g("div", _B, [
          $e(z.$slots, "stats")
        ])) : k("", !0),
        e.progress !== void 0 ? (c(), g("div", eM, [
          w.value ? (c(), g("span", {
            key: 0,
            id: I(x),
            class: "min-w-0 wrap-break-word text-(length:--size-xs) leading-(--line-height-s) font-(--weight-regular) text-(--text-text-black-default)",
            "data-testid": "list-item-progress-label"
          }, P(w.value), 9, tM)) : k("", !0),
          te(Vu, Oe({
            value: e.progress,
            max: e.max
          }, w.value ? { "aria-labelledby": `${I(y)} ${I(x)}` } : { ariaLabel: e.label }), null, 16, ["value", "max"]),
          w.value ? (c(), g("span", {
            key: 1,
            id: I(y),
            hidden: ""
          }, P(e.label), 9, nM)) : k("", !0)
        ])) : k("", !0),
        s("actions") ? (c(), g("div", aM, [
          $e(z.$slots, "actions")
        ])) : k("", !0)
      ], 64)) : e.type === "draggable-edit" ? (c(), g(se, { key: 3 }, [
        v("div", lM, [
          v("button", {
            type: "button",
            class: C(["ri-draggable shrink-0 rounded-(--border-border-radius-rounded-xs) p-0 text-(length:--icon-size-lg) leading-none focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-(--border-border-accent)", [
              b.value ? "cursor-grab text-(--icons-icon-dark-default)" : "opacity-40 cursor-default",
              e.grabbed ? "text-(--text-text-accent)" : ""
            ]]),
            "aria-label": e.dragHandleLabel,
            "aria-roledescription": "draggable",
            "aria-pressed": e.grabbed || void 0,
            disabled: e.disabled || !b.value,
            "data-testid": "list-item-drag-handle",
            onClick: $,
            onKeydown: ut(T, ["esc"])
          }, null, 42, rM),
          $e(z.$slots, "leading"),
          v("div", oM, [
            e.editable ? (c(), K(WB, {
              key: 0,
              "model-value": e.label,
              editable: !e.disabled,
              "show-pen": e.showEdit && !e.disabled,
              size: "sm",
              "pen-variant": "tertiary",
              maxlength: e.maxlength,
              error: e.editError,
              "auto-edit": e.autoEdit,
              "input-width": e.editInputWidth,
              "edit-label": e.editLabel ?? "",
              "save-label": e.saveLabel ?? "",
              class: "w-full min-w-0 min-h-8",
              onSave: L,
              onEditStart: D[0] || (D[0] = (V) => d.value = !0),
              onEditEnd: D[1] || (D[1] = (V) => d.value = !1)
            }, null, 8, ["model-value", "editable", "show-pen", "maxlength", "error", "auto-edit", "input-width", "edit-label", "save-label"])) : (c(), g("p", iM, P(e.label), 1)),
            $e(z.$slots, "subtitle", {}, () => [
              e.subtitle ? (c(), g("p", sM, P(e.subtitle), 1)) : k("", !0)
            ])
          ])
        ]),
        !d.value && (s("badge") || s("actions")) ? (c(), g("div", dM, [
          $e(z.$slots, "badge"),
          $e(z.$slots, "actions")
        ])) : k("", !0)
      ], 64)) : (c(), g(se, { key: 4 }, [
        v("button", {
          type: "button",
          class: C(["ri-draggable shrink-0 rounded-(--border-border-radius-rounded-xs) p-0 text-(length:--icon-size-lg) leading-none focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-(--border-border-accent)", [
            b.value ? "cursor-grab text-(--icons-icon-dark-default)" : "opacity-40 cursor-default",
            e.grabbed ? "text-(--text-text-accent)" : ""
          ]]),
          "aria-label": e.dragHandleLabel,
          "aria-roledescription": "draggable",
          "aria-pressed": e.grabbed || void 0,
          disabled: e.disabled || !b.value,
          "data-testid": "list-item-drag-handle",
          onClick: Ue($, ["stop"]),
          onKeydown: ut(T, ["esc"])
        }, null, 42, uM),
        $e(z.$slots, "leading"),
        v("span", {
          class: C(["flex-1 min-w-0 truncate text-(length:--size-m) leading-(--line-height-l) font-(--weight-medium)", e.disabled ? "text-(--text-text-disabled-strong)" : e.selected ? "text-(--text-text-accent)" : "text-(--text-text-body)"]),
          "data-testid": "list-item-label"
        }, P(e.label), 3),
        $e(z.$slots, "badge"),
        $e(z.$slots, "actions")
      ], 64))
    ], 16));
  }
}), fM = /* @__PURE__ */ ye({
  inheritAttrs: !1,
  __name: "DraggableListItem",
  props: {
    reorderable: { type: Boolean, default: void 0 },
    type: {},
    label: {},
    subtitle: { default: void 0 },
    disabled: { type: Boolean, default: !1 },
    dragHandleLabel: {},
    grabbed: { type: Boolean },
    editable: { type: Boolean },
    showEdit: { type: Boolean },
    editLabel: {},
    saveLabel: {},
    maxlength: {},
    editError: {},
    autoEdit: { type: Boolean },
    editInputWidth: {},
    selected: { type: Boolean },
    progress: {},
    max: {},
    progressLabel: {}
  },
  setup(e) {
    const n = e, t = Ht(), a = p(() => n.reorderable === !1 ? !1 : n.reorderable === !0 ? !0 : !n.disabled);
    return (l, r) => (c(), K(cM, Oe(l.$attrs, {
      label: n.label,
      subtitle: n.subtitle,
      disabled: n.disabled,
      draggable: a.value ? "true" : "false"
    }), _n({
      icon: ve(() => [
        v("i", {
          class: C(["ri-draggable text-(length:--icon-size-lg) leading-none select-none text-(--icons-icon-dark-default)", a.value ? "cursor-grab" : "opacity-40"]),
          "aria-hidden": "true"
        }, null, 2)
      ]),
      _: 2
    }, [
      I(t)("badge") ? {
        name: "badge",
        fn: ve(() => [
          v("div", null, [
            $e(l.$slots, "badge")
          ])
        ]),
        key: "0"
      } : void 0,
      I(t)("actions") ? {
        name: "actions",
        fn: ve(() => [
          $e(l.$slots, "actions")
        ]),
        key: "1"
      } : void 0
    ]), 1040, ["label", "subtitle", "disabled", "draggable"]));
  }
}), hM = ["aria-level"], bM = {
  class: "text-(length:--size-sm) leading-(--line-height-l) font-(--weight-medium) text-(--text-text-body-subtle)",
  "data-testid": "date-group-header-label"
}, XW = /* @__PURE__ */ ye({
  __name: "DateGroupHeader",
  props: {
    label: {},
    count: {},
    ariaLevel: { default: 3 },
    fullWidth: { type: Boolean, default: !1 }
  },
  setup(e) {
    return (n, t) => (c(), g("div", {
      class: C([
        "flex items-center gap-2.5 rounded-md bg-(--background-background-white-tertiary) px-4 py-1",
        e.fullWidth ? "w-full" : "w-fit"
      ]),
      role: "heading",
      "aria-level": e.ariaLevel
    }, [
      v("span", bM, P(e.label), 1),
      te(ct, {
        theme: "gradient-light",
        size: "sm",
        "badge-style": "circle",
        "text-only": "",
        value: e.count,
        "data-testid": "date-group-header-count"
      }, null, 8, ["value"])
    ], 10, hM));
  }
}), gM = ["role", "aria-label", "aria-hidden"], pM = /* @__PURE__ */ ye({
  __name: "AvatarGroup",
  props: {
    avatars: {},
    size: { default: "md" },
    max: { default: 4 },
    ariaLabel: { default: void 0 },
    ringClass: { default: "ring-(--border-border-white-full)" }
  },
  setup(e) {
    const n = e, t = p(() => n.avatars.slice(0, n.max)), a = p(() => Math.max(n.avatars.length - n.max, 0)), l = p(() => (n.ariaLabel ?? "").trim().length > 0), r = {
      sm: { item: "-ml-2 first:ml-0 ring-1", bubble: "h-6 w-6 text-(length:--size-2xs)" },
      md: { item: "-ml-3.5 first:ml-0 ring-2", bubble: "h-9 w-9 text-(length:--size-sm)" },
      lg: { item: "-ml-4 first:ml-0 ring-2", bubble: "h-11 w-11 text-(length:--size-m)" }
    };
    return (o, i) => (c(), g("div", {
      class: "flex items-center",
      role: l.value ? "img" : void 0,
      "aria-label": l.value ? e.ariaLabel : void 0,
      "aria-hidden": l.value ? void 0 : "true",
      "data-testid": "avatar-group"
    }, [
      (c(!0), g(se, null, Me(t.value, (s, d) => (c(), K(Kt, {
        key: d,
        name: s.name,
        img: s.img,
        size: e.size,
        "avatar-style": "circle",
        presentational: !0,
        class: C([e.ringClass, r[e.size].item]),
        "data-testid": "avatar-group-avatar",
        "aria-hidden": "true"
      }, null, 8, ["name", "img", "size", "class"]))), 128)),
      a.value > 0 ? (c(), g("span", {
        key: 0,
        class: C(["flex shrink-0 items-center justify-center rounded-full bg-(--colors-indigo-100) font-(--weight-medium) text-(--icons-icon-dark-default)", [e.ringClass, r[e.size].item, r[e.size].bubble]]),
        "data-testid": "avatar-group-overflow",
        "aria-hidden": "true"
      }, "+" + P(a.value), 3)) : k("", !0)
    ], 8, gM));
  }
}), mM = { class: "flex grow shrink basis-64 min-w-0 flex-wrap items-center gap-5" }, vM = {
  class: "flex grow shrink basis-64 min-w-0 flex-col gap-1",
  "data-testid": "list-item-interaction-content"
}, xM = {
  class: "flex items-center gap-2",
  "data-testid": "list-item-interaction-header"
}, yM = {
  key: 0,
  class: "text-(length:--size-m) leading-(--line-height-l) font-(--weight-regular) text-(--text-text-body)",
  "data-testid": "list-item-interaction-date-time"
}, kM = {
  class: "flex min-w-0 flex-col gap-1.5",
  "data-testid": "list-item-interaction-body"
}, wM = {
  key: 0,
  class: "w-full min-w-0 wrap-break-word text-(length:--size-sm) leading-(--line-height-l) font-(--weight-medium) text-(--text-text-body)",
  "data-testid": "list-item-subtitle"
}, CM = {
  key: 1,
  class: "flex flex-col gap-1 rounded-(--border-border-radius-rounded-sm) border border-(--border-border-base-soft) bg-(--background-background-white-secondary-soft) px-4 py-3 text-(length:--size-sm) leading-(--line-height-l) text-(--text-text-body)",
  "data-testid": "list-item-call-summary"
}, SM = {
  key: 0,
  class: "flex items-center gap-1.5"
}, $M = {
  class: "font-(--weight-medium)",
  "data-testid": "list-item-call-duration"
}, IM = {
  key: 1,
  class: "wrap-break-word font-(--weight-regular)",
  "data-testid": "list-item-call-summary-text"
}, TM = {
  key: 2,
  class: "text-(length:--size-sm) leading-(--line-height-l) text-(--text-text-body)",
  "data-testid": "list-item-interaction-meta"
}, LM = {
  key: 3,
  class: "flex items-center gap-1",
  "data-testid": "list-item-person"
}, EM = {
  class: "text-(length:--size-sm) leading-(--line-height-l) font-(--weight-medium) text-(--text-text-body)",
  "data-testid": "list-item-person-name"
}, AM = {
  class: "text-(length:--size-sm) leading-(--line-height-l) font-(--weight-medium) text-(--text-text-body)",
  "data-testid": "list-item-attachment-label"
}, RM = {
  key: 0,
  class: "ml-auto flex max-w-full shrink-0 flex-wrap items-center justify-end gap-3",
  "data-testid": "list-item-trailing-actions"
}, QW = /* @__PURE__ */ ye({
  inheritAttrs: !1,
  __name: "InteractionListItem",
  props: {
    label: {},
    subtitle: { default: void 0 },
    cancelled: { type: Boolean, default: !1 },
    kind: { default: void 0 },
    typeLabel: { default: "" },
    date: { default: void 0 },
    time: { default: void 0 },
    dotTheme: { default: "green" },
    people: { default: void 0 },
    peopleLabel: { default: void 0 },
    attachmentLabel: { default: void 0 },
    durationLabel: { default: void 0 },
    summary: { default: void 0 },
    summaryBadgeLabel: { default: void 0 }
  },
  setup(e) {
    const n = {
      call: "ri-phone-fill",
      email: "ri-mail-line",
      "face-to-face": "ri-user-line",
      event: "ri-group-2-line",
      meeting: "ri-calendar-2-line"
    }, t = e, a = Ht(), l = {
      green: "green",
      active: "active",
      red: "red",
      disabled: "neutral",
      orange: "orange",
      dark: "dark"
    }, r = p(() => l[t.dotTheme]), o = p(
      () => t.cancelled ? "text-(--text-text-disabled-strong) line-through" : "text-(--text-text-heading)"
    ), i = p(() => [t.date, t.time].filter(Boolean).join(" · ")), s = p(() => t.kind ? n[t.kind] : void 0);
    return Ie(
      () => {
        var d;
        return [((d = t.people) == null ? void 0 : d.length) ?? 0, t.peopleLabel];
      },
      ([d, u]) => {
        d > 0 && !(u != null && u.trim()) && console.warn(
          "[InteractionListItem] `people` is set without `peopleLabel` — the avatar group has no accessible name for assistive tech (WCAG 1.1.1). Pass a pre-formatted `peopleLabel`."
        );
      },
      { immediate: !0 }
    ), (d, u) => {
      var f;
      return c(), g("div", Oe({
        class: "flex w-full min-w-64 flex-wrap items-start gap-4",
        "data-testid": "list-item-interaction-row"
      }, d.$attrs), [
        s.value ? (c(), K(Xt, {
          key: 0,
          size: "md",
          type: "square",
          variant: "outlined",
          color: e.cancelled ? "disabled" : "default",
          icon: s.value,
          class: "shrink-0"
        }, null, 8, ["color", "icon"])) : k("", !0),
        v("div", mM, [
          v("div", vM, [
            v("div", xM, [
              te(ct, {
                type: "with-dot",
                theme: r.value,
                label: e.typeLabel,
                size: "lg",
                "data-testid": "list-item-interaction-type-label"
              }, null, 8, ["theme", "label"]),
              $e(d.$slots, "header-badges"),
              i.value ? (c(), g("span", yM, P(i.value), 1)) : k("", !0)
            ]),
            v("div", kM, [
              v("p", {
                class: C(["w-full min-w-0 wrap-break-word text-(length:--size-l) leading-(--line-height-l) font-(--weight-bold)", o.value]),
                "data-testid": "list-item-title"
              }, P(e.label), 3),
              e.subtitle ? (c(), g("p", wM, P(e.subtitle), 1)) : k("", !0),
              e.durationLabel || e.summary || e.summaryBadgeLabel ? (c(), g("div", CM, [
                e.durationLabel || e.summaryBadgeLabel ? (c(), g("div", SM, [
                  e.durationLabel ? (c(), g(se, { key: 0 }, [
                    u[0] || (u[0] = v("i", {
                      class: "ri-timer-line shrink-0 leading-none",
                      "aria-hidden": "true"
                    }, null, -1)),
                    v("span", $M, P(e.durationLabel), 1)
                  ], 64)) : k("", !0),
                  e.summaryBadgeLabel ? (c(), K(ct, {
                    key: 1,
                    label: e.summaryBadgeLabel,
                    theme: "purple",
                    size: "sm",
                    "show-left-icon": !1,
                    "show-close-icon": !1,
                    "data-testid": "list-item-call-summary-badge"
                  }, null, 8, ["label"])) : k("", !0)
                ])) : k("", !0),
                e.summary ? (c(), g("p", IM, P(e.summary), 1)) : k("", !0)
              ])) : k("", !0),
              I(a)("interaction-meta") ? (c(), g("div", TM, [
                $e(d.$slots, "interaction-meta")
              ])) : k("", !0),
              (f = e.people) != null && f.length ? (c(), g("div", LM, [
                te(pM, {
                  avatars: e.people,
                  "ring-class": "ring-(--background-background-white)",
                  size: "sm"
                }, null, 8, ["avatars"]),
                v("span", EM, P(e.peopleLabel), 1),
                e.attachmentLabel ? (c(), g(se, { key: 0 }, [
                  u[1] || (u[1] = v("span", {
                    class: "text-(length:--size-m) font-(--weight-medium) text-(--text-text-body)",
                    "aria-hidden": "true"
                  }, "·", -1)),
                  u[2] || (u[2] = v("i", {
                    class: "ri-attachment-2 shrink-0 text-(length:--size-sm) leading-none text-(--text-text-body)",
                    "aria-hidden": "true"
                  }, null, -1)),
                  v("span", AM, P(e.attachmentLabel), 1)
                ], 64)) : k("", !0)
              ])) : k("", !0)
            ])
          ]),
          I(a)("cta") || I(a)("actions") ? (c(), g("div", RM, [
            $e(d.$slots, "cta"),
            $e(d.$slots, "actions")
          ])) : k("", !0)
        ])
      ], 16);
    };
  }
}), BM = {
  class: "flex flex-1 min-w-0 flex-col gap-2 py-3.5 pl-6 @[calc(44rem-25px)]/meeting:flex-row @[calc(44rem-25px)]/meeting:items-center @[calc(44rem-25px)]/meeting:gap-0 @[calc(44rem-25px)]/meeting:py-0 @[calc(44rem-25px)]/meeting:pl-0",
  "data-testid": "list-item-content-row"
}, MM = {
  class: "flex min-w-0 flex-wrap items-center gap-x-3 gap-y-2 @[calc(44rem-25px)]/meeting:contents",
  "data-testid": "list-item-time-meta"
}, DM = { class: "flex items-center self-stretch shrink-0" }, zM = {
  key: 0,
  class: "flex items-center self-stretch shrink-0 overflow-hidden @[calc(44rem-25px)]/meeting:px-5 @[calc(44rem-25px)]/meeting:w-[185px]",
  "data-testid": "list-item-meta-badge"
}, OM = { class: "flex flex-1 min-w-0 flex-col gap-0.5 @[calc(44rem-25px)]/meeting:basis-64 @[calc(44rem-25px)]/meeting:px-6 @[calc(44rem-25px)]/meeting:py-3.5" }, PM = { class: "flex w-full min-w-0 items-start gap-1.5" }, FM = ["aria-label"], VM = { class: "flex flex-wrap items-center gap-x-2 gap-y-1 @[calc(44rem-25px)]/meeting:flex-col @[calc(44rem-25px)]/meeting:items-start @[calc(44rem-25px)]/meeting:gap-1 @[calc(50rem-25px)]/meeting:flex-row @[calc(50rem-25px)]/meeting:items-center @[calc(50rem-25px)]/meeting:gap-x-2" }, NM = {
  key: 1,
  class: "flex items-center gap-1.5",
  "data-testid": "list-item-person"
}, HM = {
  key: 0,
  class: "flex min-w-min flex-wrap items-center justify-end gap-x-4 gap-y-3 @[calc(44rem-25px)]/meeting:flex-col @[calc(44rem-25px)]/meeting:items-end @[calc(44rem-25px)]/meeting:gap-3 @[calc(50rem-25px)]/meeting:flex-row @[calc(50rem-25px)]/meeting:items-center @[calc(50rem-25px)]/meeting:gap-x-4",
  "data-testid": "list-item-trailing-actions"
}, jM = { class: "flex flex-1 min-w-0 flex-col gap-3 py-4" }, WM = { class: "flex flex-col gap-0.5 min-w-0" }, qM = { class: "flex items-center justify-between gap-2" }, UM = { class: "flex w-full min-w-0 items-start gap-1.5" }, GM = ["aria-label"], KM = {
  key: 1,
  class: "flex items-center gap-1.5",
  "data-testid": "list-item-person"
}, YM = {
  key: 1,
  class: "flex items-start gap-3",
  "data-testid": "list-item-cta"
}, _W = /* @__PURE__ */ ye({
  inheritAttrs: !1,
  __name: "MeetingListItem",
  props: {
    layout: {},
    label: {},
    subtitle: { default: void 0 },
    disabled: { type: Boolean, default: !1 },
    border: { type: Boolean, default: !0 },
    time: { default: void 0 },
    statusTheme: { default: "green" },
    statusLabel: { default: "" },
    struckThrough: { type: Boolean, default: !1 },
    metaBadge: { default: void 0 },
    personName: { default: void 0 },
    personAvatarUrl: { default: void 0 },
    date: { default: void 0 },
    urgencyLabel: { default: void 0 },
    titleIcon: { default: void 0 }
  },
  setup(e) {
    const n = e, t = Ht(), a = {
      long: { padding: "pl-0 pr-[calc(--spacing(6)-1px)] py-0", gap: "gap-6", minHeight: "min-h-[100px]" },
      short: { padding: "pl-0 pr-[calc(--spacing(4)-1px)] py-0", gap: "gap-4" }
    }, l = xv(() => {
      const f = a[n.layout];
      return {
        padding: f.padding,
        gap: f.gap,
        minHeight: f.minHeight,
        disabled: n.disabled,
        border: n.border,
        // Only Long queries its own width; Short keeps its content-based width.
        alwaysClasses: `overflow-hidden min-w-64 ${n.layout === "long" ? "@container/meeting" : ""}`,
        restingClasses: "shadow-(--blur-shadow-s)"
      };
    }), r = p(
      () => n.disabled ? "text-(--text-text-disabled-strong)" : "text-(--text-text-heading)"
    ), o = {
      green: "green",
      active: "active",
      red: "red",
      disabled: "neutral",
      orange: "orange"
    }, i = {
      green: "bg-(--components-badge-background-badge-green-strong-bg)",
      active: "bg-(--components-badge-background-badge-indigo-strong-bg)",
      red: "bg-(--components-badge-background-badge-error-strong-bg)",
      disabled: "bg-(--components-badge-background-badge-neutral-strong-bg)",
      orange: "bg-(--components-badge-background-badge-orange-strong-bg)"
    }, s = p(() => o[n.statusTheme]), d = p(() => i[n.statusTheme]), u = p(() => [n.date, n.time].filter(Boolean).join(" · "));
    return (f, b) => (c(), g("div", Oe(f.$attrs, { class: I(l) }), [
      e.layout === "long" ? (c(), g(se, { key: 0 }, [
        v("div", {
          class: C(["w-[5px] self-stretch shrink-0", d.value]),
          "aria-hidden": "true",
          "data-testid": "list-item-accent-bar"
        }, null, 2),
        v("div", BM, [
          v("div", MM, [
            v("div", DM, [
              v("p", {
                class: C(["whitespace-nowrap text-(length:--size-l) leading-(--line-height-xxl) font-(--weight-bold)", r.value]),
                "data-testid": "list-item-time"
              }, P(e.time), 3)
            ]),
            e.metaBadge ? (c(), g("div", zM, [
              te(ct, {
                label: e.metaBadge.label,
                theme: e.metaBadge.theme ?? "cyan",
                size: "sm",
                truncate: "",
                "show-left-icon": !1,
                "show-close-icon": !1
              }, null, 8, ["label", "theme"])
            ])) : k("", !0)
          ]),
          v("div", OM, [
            te(ct, {
              type: "with-dot",
              theme: s.value,
              label: e.statusLabel,
              size: "sm",
              class: "self-start",
              "data-testid": "list-item-status-badge"
            }, null, 8, ["theme", "label"]),
            v("div", PM, [
              e.titleIcon ? (c(), g("i", {
                key: 0,
                class: C([[e.titleIcon.icon, r.value], "shrink-0 text-(length:--size-l) leading-(--line-height-xxl)"]),
                role: "img",
                "aria-label": e.titleIcon.label,
                "data-testid": "list-item-title-icon"
              }, null, 10, FM)) : k("", !0),
              te(bt, {
                text: e.label,
                lines: 2,
                "text-class": ["text-(length:--size-l) leading-(--line-height-xxl) font-(--weight-bold)", r.value, e.struckThrough ? "line-through" : ""].join(" "),
                "data-testid": "list-item-title"
              }, null, 8, ["text", "text-class"])
            ]),
            v("div", VM, [
              e.subtitle ? (c(), g("p", {
                key: 0,
                class: C(["min-w-0 text-(length:--size-m) leading-(--line-height-l)", r.value]),
                "data-testid": "list-item-subtitle"
              }, P(e.subtitle), 3)) : k("", !0),
              e.personName ? (c(), g("div", NM, [
                te(Kt, {
                  name: e.personName,
                  img: e.personAvatarUrl,
                  size: "sm",
                  presentational: !0,
                  class: C({ "opacity-70": e.disabled })
                }, null, 8, ["name", "img", "class"]),
                v("span", {
                  class: C(["text-(length:--size-sm) leading-(--line-height-l) font-(--weight-medium)", r.value])
                }, P(e.personName), 3)
              ])) : k("", !0)
            ])
          ]),
          I(t)("cta") || I(t)("actions") ? (c(), g("div", HM, [
            $e(f.$slots, "cta"),
            $e(f.$slots, "actions")
          ])) : k("", !0)
        ])
      ], 64)) : (c(), g(se, { key: 1 }, [
        v("div", {
          class: C(["w-[5px] self-stretch shrink-0", d.value]),
          "aria-hidden": "true",
          "data-testid": "list-item-accent-bar"
        }, null, 2),
        v("div", jM, [
          v("div", WM, [
            v("div", qM, [
              v("p", {
                class: C(["whitespace-nowrap text-(length:--size-m) leading-(--line-height-l) font-(--weight-semi-bold)", r.value]),
                "data-testid": "list-item-date-time"
              }, P(u.value), 3),
              te(ct, {
                type: "with-dot",
                theme: s.value,
                label: e.statusLabel,
                size: "sm",
                "data-testid": "list-item-status-badge"
              }, null, 8, ["theme", "label"])
            ]),
            v("div", UM, [
              e.titleIcon ? (c(), g("i", {
                key: 0,
                class: C([[e.titleIcon.icon, r.value], "shrink-0 text-(length:--size-l) leading-(--line-height-xxl)"]),
                role: "img",
                "aria-label": e.titleIcon.label,
                "data-testid": "list-item-title-icon"
              }, null, 10, GM)) : k("", !0),
              v("p", {
                class: C(["w-full min-w-0 break-words text-(length:--size-l) leading-(--line-height-xxl) font-(--weight-bold)", [r.value, e.struckThrough ? "line-through" : ""]]),
                "data-testid": "list-item-title"
              }, P(e.label), 3)
            ]),
            e.subtitle ? (c(), g("p", {
              key: 0,
              class: C(["w-full min-w-0 break-words text-(length:--size-m) leading-(--line-height-l)", r.value]),
              "data-testid": "list-item-subtitle"
            }, P(e.subtitle), 3)) : k("", !0),
            e.personName ? (c(), g("div", KM, [
              te(Kt, {
                name: e.personName,
                img: e.personAvatarUrl,
                size: "sm",
                presentational: !0,
                class: C({ "opacity-70": e.disabled })
              }, null, 8, ["name", "img", "class"]),
              v("span", {
                class: C(["text-(length:--size-sm) leading-(--line-height-l) font-(--weight-medium)", r.value])
              }, P(e.personName), 3)
            ])) : k("", !0)
          ]),
          e.urgencyLabel ? (c(), K(ct, {
            key: 0,
            theme: "red",
            size: "xs",
            label: e.urgencyLabel,
            "show-close-icon": !1,
            "data-testid": "list-item-urgency-badge",
            "left-icon": "ri-alert-line"
          }, null, 8, ["label"])) : k("", !0),
          I(t)("cta") ? (c(), g("div", YM, [
            $e(f.$slots, "cta")
          ])) : k("", !0)
        ])
      ], 64))
    ], 16));
  }
}), JM = {
  class: "flex min-w-0 flex-col gap-3",
  "data-testid": "list-item-accordion"
}, ZM = { class: "border-b border-solid border-(--border-border-base-soft) pb-3" }, XM = ["aria-expanded", "aria-controls"], QM = { class: "flex min-w-0 flex-1 items-center gap-1.5" }, _M = { class: "flex shrink-0 items-center gap-1.5" }, eD = {
  class: "flex size-8 items-center justify-center",
  "aria-hidden": "true"
}, tD = ["id", "hidden"], eq = /* @__PURE__ */ ye({
  __name: "ListItemAccordion",
  props: /* @__PURE__ */ wd({
    title: {},
    icon: { default: void 0 },
    count: { default: void 0 }
  }, {
    open: { type: Boolean, default: !1 },
    openModifiers: {}
  }),
  emits: ["update:open"],
  setup(e) {
    const n = Ob(e, "open"), t = Ve(), a = E(null), l = E(!1), r = E(!1), o = p(() => r.value ? !1 : l.value ? !0 : void 0);
    function i(u) {
      try {
        l.value = u.target.matches(":focus-visible");
      } catch {
        l.value = !0;
      }
    }
    function s() {
      l.value = !1, r.value = !1;
    }
    function d(u) {
      var f;
      u.key !== "Escape" || r.value || !l.value || !((f = a.value) != null && f.isTruncated) || (u.stopPropagation(), u.preventDefault(), r.value = !0);
    }
    return (u, f) => (c(), g("div", JM, [
      v("div", ZM, [
        v("button", {
          type: "button",
          class: "flex h-8 w-full min-w-0 cursor-pointer items-center justify-between gap-1.5 rounded-(--border-border-radius-rounded-xs) border-0 bg-transparent p-0 text-left focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-(--border-border-accent)",
          "aria-expanded": n.value,
          "aria-controls": I(t),
          "data-testid": "list-item-accordion-header",
          onClick: f[0] || (f[0] = (b) => n.value = !n.value),
          onFocus: i,
          onBlur: s,
          onKeydown: d
        }, [
          v("span", QM, [
            e.icon ? (c(), g("i", {
              key: 0,
              class: C([e.icon, "shrink-0 text-(length:--icon-size-sm) text-(--icons-icon-dark-default)"]),
              "aria-hidden": "true",
              "data-testid": "list-item-accordion-icon"
            }, null, 2)) : k("", !0),
            te(bt, {
              ref_key: "titleRef",
              ref: a,
              as: "span",
              class: "min-w-0",
              text: e.title,
              focusable: !1,
              open: o.value,
              "text-class": "text-(length:--size-m) leading-(--line-height-l) font-(--weight-semi-bold) text-(--text-text-heading)",
              "data-testid": "list-item-accordion-title"
            }, null, 8, ["text", "open"])
          ]),
          v("span", _M, [
            e.count !== void 0 ? (c(), K(ct, {
              key: 0,
              label: String(e.count),
              theme: "gradient-light",
              size: "lg",
              "badge-style": "circle",
              "text-only": "",
              "data-testid": "list-item-accordion-count"
            }, null, 8, ["label"])) : k("", !0),
            v("span", eD, [
              v("i", {
                class: C([n.value ? "ri-arrow-up-s-line" : "ri-arrow-down-s-line", "text-(length:--icon-size-sm) text-(--icons-icon-dark-default)"]),
                "data-testid": "list-item-accordion-chevron"
              }, null, 2)
            ])
          ])
        ], 40, XM)
      ]),
      v("ul", {
        id: I(t),
        role: "list",
        class: "m-0 list-none flex-col gap-3 p-0 [&:not([hidden])]:flex",
        hidden: !n.value,
        "data-testid": "list-item-accordion-body"
      }, [
        $e(u.$slots, "default")
      ], 8, tD)
    ]));
  }
}), nD = {
  class: "m-0 min-w-0 list-none border-b border-solid border-(--border-border-base-soft) pb-3",
  "data-testid": "list-item-accordion-row"
}, aD = { class: "flex min-w-0 flex-1 items-center gap-1.5" }, tq = /* @__PURE__ */ ye({
  __name: "ListItemAccordionRow",
  props: {
    label: {},
    value: { default: void 0 },
    variant: { default: "default" },
    icon: { default: void 0 }
  },
  setup(e) {
    const n = e, t = {
      default: {
        row: "min-h-5 pl-6",
        label: "text-(length:--size-m) leading-(--line-height-l) font-(--weight-regular) text-(--text-text-body)",
        value: "text-(length:--size-m) leading-(--line-height-l) font-(--weight-medium) text-(--text-text-black-default)",
        icon: ""
      },
      header: {
        row: "min-h-5",
        label: "text-(length:--size-m) leading-(--line-height-l) font-(--weight-semi-bold) text-(--text-text-body)",
        value: "text-(length:--size-m) leading-(--line-height-l) font-(--weight-medium) text-(--text-text-black-default)",
        icon: "size-(--icon-size-sm) text-(length:--icon-size-sm) leading-(--icon-size-sm)"
      },
      title: {
        row: "min-h-6",
        label: "text-(length:--size-xl) leading-(--line-height-xl) font-(--weight-semi-bold) text-(--text-text-body)",
        value: "text-(length:--size-l) leading-(--line-height-xxl) font-(--weight-bold) text-(--text-text-black-default)",
        icon: "size-(--icon-size-md) text-(length:--icon-size-md) leading-(--icon-size-md)"
      }
    };
    return (a, l) => (c(), g("li", nD, [
      v("div", {
        class: C(["flex min-w-0 items-center justify-between gap-1.5", t[n.variant].row])
      }, [
        v("div", aD, [
          e.icon && e.variant !== "default" ? (c(), g("i", {
            key: 0,
            class: C([e.icon, t[n.variant].icon, "inline-flex shrink-0 items-center justify-center text-(--icons-icon-dark-default)"]),
            "aria-hidden": "true",
            "data-testid": "list-item-accordion-row-icon"
          }, null, 2)) : k("", !0),
          te(bt, {
            class: "min-w-0",
            text: e.label,
            "text-class": t[n.variant].label,
            "data-testid": "list-item-accordion-row-label"
          }, null, 8, ["text", "text-class"])
        ]),
        e.value !== void 0 ? (c(), g("span", {
          key: 0,
          class: C(["shrink-0", t[n.variant].value]),
          "data-testid": "list-item-accordion-row-value"
        }, P(e.value), 3)) : k("", !0)
      ], 2)
    ]));
  }
}), lD = FB, rD = { class: "flex w-full min-w-0 items-start gap-2" }, oD = {
  "data-testid": "alert-icon-column",
  class: "flex items-start py-1 shrink-0"
}, iD = {
  "data-testid": "alert-text-column",
  class: "flex min-w-0 flex-1 flex-col"
}, sD = { class: "flex min-w-0 items-center gap-2" }, dD = { class: "flex min-w-0 flex-1 flex-col gap-2" }, uD = {
  key: 0,
  "data-testid": "alert-heading",
  class: "wrap-break-word text-(length:--size-l) leading-(--line-height-xxl) font-(--weight-medium)"
}, cD = {
  key: 1,
  "data-testid": "alert-message",
  class: "wrap-break-word text-(length:--size-sm) leading-(--line-height-l) font-(--weight-regular)"
}, fD = { class: "accordion-content-inner" }, hD = { class: "min-w-0 pt-2" }, bD = /* @__PURE__ */ ye({
  __name: "AlertDuplicatesList",
  props: {
    duplicates: {},
    heading: {},
    message: {},
    icon: {},
    iconTint: {},
    listBorderClass: {},
    listDividerVar: {},
    open: { type: Boolean },
    defaultOpen: { type: Boolean },
    labels: {}
  },
  emits: ["update:open", "remove"],
  setup(e, { emit: n }) {
    const t = e, a = n, { isOpen: l, toggle: r, triggerProps: o, panelProps: i, panelClasses: s, onTransitionEnd: d } = Vb({
      open: () => t.open,
      defaultOpen: () => t.defaultOpen,
      onOpenChange: (S) => a("update:open", S)
    }), u = E(null), f = E(null), b = /* @__PURE__ */ new Map();
    function h(S, $) {
      $ ? b.set(S, $) : b.delete(S);
    }
    const m = p(() => t.labels.toggleButton ?? (t.heading || t.message || "Show duplicates"));
    function x(S) {
      var T, L;
      const $ = S.helperText ? `${S.label}, ${S.helperText}` : S.label;
      return ((L = (T = t.labels).removeDuplicate) == null ? void 0 : L.call(T, S)) ?? `Remove ${$}`;
    }
    Ie(l, (S) => {
      var $, T;
      !S && (($ = f.value) != null && $.contains(document.activeElement)) && ((T = u.value) == null || T.$el.focus());
    });
    let y = null;
    function w(S, $) {
      y = { id: S.id, index: $ }, a("remove", S);
    }
    return Ie(
      () => t.duplicates.map((S) => S.id),
      async (S, $) => {
        var D;
        const T = y;
        if (!T) return;
        const L = !S.includes(T.id);
        if (!L && S.length >= $.length || (y = null, !L)) return;
        await qe();
        const A = document.activeElement;
        if (A && A !== document.body && A.isConnected) return;
        const R = S[Math.min(T.index, S.length - 1)], z = R !== void 0 ? b.get(R) : void 0;
        z != null && z.focusAction("secondary") || (D = u.value) == null || D.$el.focus();
      }
    ), (S, $) => (c(), g("div", rD, [
      v("div", oD, [
        v("i", {
          class: C([[e.icon, e.iconTint], "inline-flex items-center justify-center size-(--icon-size-sm) text-(length:--size-l)"]),
          "aria-hidden": "true"
        }, null, 2)
      ]),
      v("div", iD, [
        v("div", sD, [
          v("div", dD, [
            e.heading ? (c(), g("p", uD, P(e.heading), 1)) : k("", !0),
            e.message ? (c(), g("p", cD, P(e.message), 1)) : k("", !0)
          ]),
          te(I(Re), Oe({
            ref_key: "toggleRef",
            ref: u
          }, I(o), {
            "data-testid": "alert-duplicates-toggle",
            variant: "tertiary",
            size: "md",
            "icon-only": "",
            "icon-left": I(l) ? "ri-arrow-up-s-line" : "ri-arrow-down-s-line",
            "aria-label": m.value,
            class: "shrink-0",
            onClick: I(r)
          }), null, 16, ["icon-left", "aria-label", "onClick"])
        ]),
        v("div", Oe({
          ref_key: "panelRef",
          ref: f
        }, I(i), {
          class: I(s),
          "data-testid": "alert-duplicates-panel",
          onTransitionend: $[0] || ($[0] = //@ts-ignore
          (...T) => I(d) && I(d)(...T))
        }), [
          v("div", fD, [
            v("div", hD, [
              v("div", {
                "data-testid": "alert-duplicates-list",
                class: C(["min-w-0 border-y-(length:--border-border-width-border) border-solid py-3", e.listBorderClass])
              }, [
                te(I(VB), {
                  divider: "",
                  "divider-color": `var(${e.listDividerVar})`
                }, {
                  default: ve(() => [
                    (c(!0), g(se, null, Me(e.duplicates, (T, L) => (c(), K(I(lD), {
                      key: T.id,
                      ref_for: !0,
                      ref: (A) => h(T.id, A),
                      type: "avatar-text-badge",
                      label: T.label,
                      "helper-text": T.helperText,
                      "label-badge": T.badge ? { label: T.badge, theme: "orange" } : void 0,
                      "secondary-action": {
                        label: x(T),
                        icon: "ri-delete-bin-line",
                        testId: "alert-duplicate-remove",
                        onClick: () => w(T, L)
                      }
                    }, null, 8, ["label", "helper-text", "label-badge", "secondary-action"]))), 128))
                  ]),
                  _: 1
                }, 8, ["divider-color"])
              ], 2)
            ])
          ])
        ], 16)
      ])
    ]));
  }
}), gD = { class: "flex w-full min-w-0 items-start gap-2" }, pD = {
  "data-testid": "alert-icon-column",
  class: "flex items-start py-1 shrink-0"
}, mD = {
  "data-testid": "alert-text-column",
  class: "flex min-w-0 flex-1 flex-col gap-2"
}, vD = {
  "data-testid": "alert-heading",
  class: "wrap-break-word text-(length:--size-l) leading-(--line-height-xxl) font-(--weight-medium)"
}, xD = {
  key: 0,
  "data-testid": "alert-message",
  class: "wrap-break-word text-(length:--size-m) leading-(--line-height-l) font-(--weight-regular)"
}, yD = {
  key: 1,
  "data-testid": "alert-error-links",
  class: "flex flex-col gap-1"
}, kD = /* @__PURE__ */ ye({
  __name: "AlertErrorSummary",
  props: {
    errors: {},
    message: {},
    showLinks: { type: Boolean },
    icon: {},
    iconTint: {},
    labels: {}
  },
  setup(e) {
    const n = e, t = p(() => {
      var r, o;
      const l = n.errors.length;
      return ((o = (r = n.labels).errorSummaryHeading) == null ? void 0 : o.call(r, l)) ?? (l === 1 ? "1 error" : `${l} errors`);
    });
    function a(l, r) {
      const o = document.getElementById(r);
      o && (l.preventDefault(), o.scrollIntoView({ block: "center" }), o.focus({ preventScroll: !0 }));
    }
    return (l, r) => (c(), g("div", gD, [
      v("div", pD, [
        v("i", {
          class: C([[e.icon, e.iconTint], "inline-flex items-center justify-center size-(--icon-size-sm) text-(length:--size-l)"]),
          "aria-hidden": "true"
        }, null, 2)
      ]),
      v("div", mD, [
        v("h2", vD, P(t.value), 1),
        e.message ? (c(), g("p", xD, P(e.message), 1)) : k("", !0),
        e.showLinks ? (c(), g("ul", yD, [
          (c(!0), g(se, null, Me(e.errors, (o) => (c(), g("li", {
            key: o.fieldId
          }, [
            te(I($n), {
              as: "a",
              href: `#${o.fieldId}`,
              onClick: (i) => a(i, o.fieldId)
            }, {
              default: ve(() => [
                at(P(o.message), 1)
              ]),
              _: 2
            }, 1032, ["href", "onClick"])
          ]))), 128))
        ])) : k("", !0)
      ])
    ]));
  }
}), wD = {
  "data-testid": "alert-pill-link",
  class: "flex min-w-0 flex-1 items-center gap-0.5"
}, CD = {
  key: 4,
  "data-testid": "alert-inline-row",
  class: "flex w-full items-start gap-2"
}, SD = { class: "flex-1 flex flex-col gap-3" }, $D = {
  "data-testid": "alert-text-group",
  class: "flex flex-col gap-1"
}, ID = {
  key: 5,
  "data-testid": "alert-compact-row",
  class: "flex w-full items-start gap-2"
}, TD = { class: "flex-1 flex flex-col gap-2" }, LD = { class: "flex flex-col gap-1" }, ED = {
  key: 1,
  class: "flex items-center gap-1"
}, AD = {
  key: 0,
  "data-testid": "alert-actions",
  class: "flex items-center gap-4"
}, RD = {
  key: 1,
  "data-testid": "alert-actions",
  class: "flex items-center gap-4"
}, BD = {
  key: 2,
  "data-testid": "alert-right-column",
  class: "flex flex-col items-end justify-center gap-2 shrink-0"
}, _h = "text-(length:--size-l) leading-(--line-height-xxl) font-(--weight-medium)", MD = "text-(length:--size-m) leading-(--line-height-l) font-(--weight-medium)", eb = "text-(length:--size-xs) leading-(--line-height-xs) font-(--weight-regular)", Ul = /* @__PURE__ */ ye({
  __name: "Alert",
  props: /* @__PURE__ */ wd({
    color: { default: "success" },
    surface: { default: "card" },
    layout: { default: "inline" },
    heading: { default: void 0 },
    message: { default: "" },
    closable: { type: Boolean, default: !1 },
    percentage: { default: void 0 },
    buttons: { default: () => [] },
    buttonsPosition: { default: "bottom" },
    compact: { type: Boolean, default: !1 },
    href: { default: void 0 },
    optionalIcon: { default: void 0 },
    checkbox: { default: void 0 },
    duplicates: { default: void 0 },
    open: { type: Boolean, default: void 0 },
    defaultOpen: { type: Boolean, default: !1 },
    errors: { default: void 0 },
    labels: { default: () => ({}) }
  }, {
    checked: { type: Boolean, default: !1 },
    checkedModifiers: {}
  }),
  emits: /* @__PURE__ */ wd(["close", "navigate", "update:open", "remove"], ["update:checked"]),
  setup(e, { expose: n, emit: t }) {
    const a = e, l = t, r = Ob(e, "checked"), o = E(!1), i = {
      success: {
        bg: "bg-(--background-background-success)",
        borderClass: "border-(--border-border-success)",
        borderTopClass: "border-(--border-border-success)",
        pillHoverBorderClass: "hover:border-(--background-background-success)",
        icon: "ri-checkbox-circle-line",
        iconTint: "text-(--icons-icon-success)",
        badgeTheme: "green",
        listBorderClass: "border-(--border-border-success-sublte)",
        listDividerVar: "--border-border-success-sublte"
      },
      danger: {
        bg: "bg-(--background-background-error)",
        borderClass: "border-(--border-border-error-subtle)",
        borderTopClass: "border-(--border-border-error-strong)",
        pillHoverBorderClass: "hover:border-(--background-background-error)",
        icon: "ri-alert-line",
        iconTint: "text-(--icons-icon-error)",
        badgeTheme: "red",
        listBorderClass: "border-(--border-border-error-strong)",
        listDividerVar: "--border-border-error-strong"
      },
      warning: {
        bg: "bg-(--background-background-warning)",
        borderClass: "border-(--border-border-warning-subtle)",
        borderTopClass: "border-(--border-border-warning)",
        pillHoverBorderClass: "hover:border-(--background-background-warning)",
        icon: "ri-alert-line",
        iconTint: "text-(--icons-icon-warning)",
        badgeTheme: "orange",
        listBorderClass: "border-(--border-border-warning)",
        listDividerVar: "--border-border-warning"
      },
      info: {
        bg: "bg-(--background-background-info)",
        borderClass: "border-(--border-border-info-subtle)",
        borderTopClass: "border-(--border-border-info-subtle)",
        pillHoverBorderClass: "hover:border-(--background-background-info)",
        icon: "ri-information-line",
        iconTint: "text-(--icons-icon-info)",
        badgeTheme: "indigo",
        listBorderClass: "border-(--border-border-info-strong)",
        listDividerVar: "--border-border-info-strong"
      },
      default: {
        bg: "bg-(--background-background-white)",
        borderClass: "border-(--border-border-base-medium)",
        borderTopClass: "border-(--border-border-base-medium)",
        pillHoverBorderClass: "hover:border-(--background-background-white)",
        icon: "ri-information-line",
        iconTint: "text-(--icons-icon-dark-default)",
        badgeTheme: "neutral",
        listBorderClass: "border-(--border-border-base)",
        listDividerVar: "--border-border-base"
      },
      ia: {
        bg: "bg-(--background-background-ia)",
        borderClass: "border-(--border-border-ia)",
        borderTopClass: "border-(--colors-border-ia-strong)",
        pillHoverBorderClass: "hover:border-(--background-background-ia)",
        icon: "ri-magic-line",
        iconTint: "text-(--icons-icon-ia)",
        badgeTheme: "purple",
        listBorderClass: "border-(--border-border-ia)",
        listDividerVar: "--border-border-ia"
      }
    }, s = p(() => {
      var B;
      return i[(B = a.errors) != null && B.length ? "danger" : a.color];
    }), d = p(() => s.value.badgeTheme), u = p(
      () => a.color === "danger" ? { role: "alert", ariaLive: "assertive", ariaAtomic: "true" } : { role: "status", ariaLive: "polite", ariaAtomic: void 0 }
    ), f = p(() => a.surface === "pill"), b = p(() => {
      var B;
      return (((B = a.errors) == null ? void 0 : B.length) ?? 0) > 10;
    }), h = p(() => f.value ? a.href ? "a" : "button" : "div"), m = p(() => {
      var B;
      return f.value ? a.href ? { href: a.href } : { type: "button" } : a.duplicates ? {} : (B = a.errors) != null && B.length ? { tabindex: -1, role: "group" } : {
        role: u.value.role,
        "aria-live": u.value.ariaLive,
        "aria-atomic": u.value.ariaAtomic
      };
    }), x = p(() => a.surface === "pill" ? "rounded-(--border-border-radius-rounded-full) border-(length:--border-border-width-border) border-solid flex-row items-center gap-2 py-[calc(--spacing(1)-1px)] pr-[calc(--spacing(2)-1px)] pl-[calc(--spacing(1)-1px)] w-full" : a.surface === "borderTop" ? "rounded-none border-t-(length:--border-border-width-border-lg) border-solid flex-col items-start gap-4 px-4 pb-4 pt-[calc(--spacing(4)-4px)] w-full" : "rounded-(--border-border-radius-rounded-l) border-(length:--border-border-width-border) border-solid flex-col items-start gap-4 p-[calc(--spacing(4)-1px)] w-full"), y = p(() => [
      b.value ? "sticky top-0 z-10 max-h-[40vh] overflow-y-auto" : "relative",
      "box-border flex min-w-64 text-left font-inter transition-all duration-300",
      s.value.bg,
      a.surface === "borderTop" ? s.value.borderTopClass : s.value.borderClass,
      "text-(--text-text-heading)",
      x.value,
      f.value ? ["cursor-pointer", "transition-colors", s.value.pillHoverBorderClass] : ""
    ]), w = p(() => a.percentage !== void 0 || a.layout === "stacked" && a.buttonsPosition === "bottom" ? "text-(length:--size-sm) leading-(--line-height-l) font-(--weight-regular)" : "text-(length:--size-m) leading-(--line-height-l) font-(--weight-regular)"), S = p(() => !!a.heading && a.surface !== "borderTop"), $ = p(
      () => a.surface === "borderTop" ? "text-(length:--size-m) leading-(--line-height-l) font-(--weight-regular)" : _h
    ), T = p(
      () => a.closable && a.percentage === void 0 && !f.value && !a.compact
    ), L = p(
      () => a.buttonsPosition === "right" && (T.value || a.buttons.length > 0)
    ), A = p(
      () => a.buttonsPosition === "right" && (!a.message || a.buttons.length > 0 && a.buttons.every((B) => B.variant === "tertiary"))
    ), R = p(
      () => !!a.checkbox && !f.value && !a.compact && !a.heading && !a.message
    ), z = p(() => a.percentage !== void 0), D = p(() => {
      var B;
      return ((B = a.labels) == null ? void 0 : B.closeButton) ?? "Dismiss alert";
    });
    function V() {
      o.value = !0, l("close");
    }
    function Y() {
      l("navigate");
    }
    function _(B) {
      var F;
      (F = B.onClick) == null || F.call(B);
    }
    function j(B) {
      return {
        as: B.href ? "a" : "button",
        href: B.href,
        ariaLabel: B.ariaLabel,
        iconLeft: B.iconPosition !== "right" ? B.icon : void 0,
        iconRight: B.iconPosition === "right" ? B.icon : void 0,
        size: "s",
        onClick: () => _(B)
      };
    }
    function M(B) {
      return {
        label: B.label,
        variant: B.variant ?? (a.buttonsPosition === "right" ? "primary" : "secondary"),
        as: B.href ? "a" : "button",
        href: B.href,
        // Passed as a literal HTML attribute key, not a declared Button prop —
        // Button.vue never declares `ariaLabel`, so this lands in Button's
        // $attrs and Vue's default attrs inheritance forwards it straight to
        // the root <button>/<a> element, overriding nothing else. Declaring a
        // real `ariaLabel` prop on Button.vue would close the automatic $attrs
        // fallthrough for that attribute name for every consumer in the
        // monorepo (many icon-only Button call sites rely on a raw, undeclared
        // :aria-label falling through) — see Refs: #OP-5881 fix commit.
        "aria-label": B.ariaLabel,
        iconLeft: B.iconPosition !== "right" ? B.icon : void 0,
        iconRight: B.iconPosition === "right" ? B.icon : void 0,
        size: "xs",
        loading: B.loading,
        onClick: () => _(B)
      };
    }
    const W = E(null);
    n({
      /** Moves focus to the Alert; only the error summary (`errors`) can take it. */
      focus: () => {
        var B;
        return (B = W.value) == null ? void 0 : B.focus();
      }
    });
    function G() {
      f.value && !a.href && Y();
    }
    return (B, F) => o.value ? k("", !0) : (c(), K(dt(h.value), Oe({
      key: 0,
      ref_key: "rootRef",
      ref: W
    }, m.value, { class: y.value }, Rl(f.value ? { click: G } : {})), {
      default: ve(() => {
        var X;
        return [
          R.value && !B.$slots.body ? (c(), K(Cn, {
            key: 0,
            modelValue: r.value,
            "onUpdate:modelValue": F[0] || (F[0] = (H) => r.value = H),
            label: e.checkbox.label,
            "label-wrap": ""
          }, null, 8, ["modelValue", "label"])) : f.value ? (c(), g(se, { key: 1 }, [
            te(I(ct), {
              "data-testid": "alert-badge",
              label: e.heading,
              theme: d.value,
              size: "sm",
              "show-left-icon": !1,
              "show-close-icon": !1,
              class: "h-5! min-h-5! min-w-0! max-w-1/2 rounded-(--border-border-radius-rounded-full)! px-2! py-0! [&>span>span]:min-w-0 [&>span>span]:truncate"
            }, null, 8, ["label", "theme"]),
            v("span", wD, [
              e.message ? (c(), g("span", {
                key: 0,
                "data-testid": "alert-message",
                class: C([w.value, "min-w-0 truncate"])
              }, P(e.message), 3)) : k("", !0),
              F[5] || (F[5] = v("i", {
                class: "ri-arrow-right-line inline-flex items-center justify-center size-(--icon-size-sm) text-(length:--size-l) shrink-0",
                "aria-hidden": "true"
              }, null, -1))
            ])
          ], 64)) : e.duplicates ? (c(), K(bD, {
            key: 2,
            duplicates: e.duplicates,
            heading: e.heading,
            message: e.message,
            icon: s.value.icon,
            "icon-tint": s.value.iconTint,
            "list-border-class": s.value.listBorderClass,
            "list-divider-var": s.value.listDividerVar,
            open: e.open,
            "default-open": e.defaultOpen,
            labels: e.labels,
            "onUpdate:open": F[1] || (F[1] = (H) => l("update:open", H)),
            onRemove: F[2] || (F[2] = (H) => l("remove", H))
          }, null, 8, ["duplicates", "heading", "message", "icon", "icon-tint", "list-border-class", "list-divider-var", "open", "default-open", "labels"])) : (X = e.errors) != null && X.length ? (c(), K(kD, {
            key: 3,
            errors: e.errors,
            message: e.message,
            "show-links": b.value,
            icon: s.value.icon,
            "icon-tint": s.value.iconTint,
            labels: e.labels
          }, null, 8, ["errors", "message", "show-links", "icon", "icon-tint", "labels"])) : e.layout === "inline" ? (c(), g("div", CD, [
            v("div", {
              "data-testid": "alert-icon-column",
              class: C(["flex items-center shrink-0", S.value ? "py-1" : "py-0.5"])
            }, [
              v("i", {
                class: C([[s.value.icon, s.value.iconTint], "inline-flex items-center justify-center size-(--icon-size-sm) text-(length:--size-l)"]),
                "aria-hidden": "true"
              }, null, 2)
            ], 2),
            v("div", SD, [
              v("div", $D, [
                e.heading ? (c(), g("p", {
                  key: 0,
                  "data-testid": "alert-heading",
                  class: C($.value)
                }, P(e.heading), 3)) : k("", !0),
                e.message ? (c(), g("p", {
                  key: 1,
                  "data-testid": "alert-message",
                  class: C(w.value)
                }, P(e.message), 3)) : k("", !0)
              ]),
              e.checkbox ? (c(), K(Cn, {
                key: 0,
                modelValue: r.value,
                "onUpdate:modelValue": F[3] || (F[3] = (H) => r.value = H),
                label: e.checkbox.label,
                "label-wrap": ""
              }, null, 8, ["modelValue", "label"])) : k("", !0)
            ]),
            T.value ? (c(), K(I(Re), {
              key: 0,
              variant: "text",
              "icon-only": "",
              "icon-left": "ri-close-line",
              size: "xs",
              "aria-label": D.value,
              class: C(["-mx-2 shrink-0", S.value ? "-my-1" : "-my-1.5"]),
              onClick: V
            }, null, 8, ["aria-label", "class"])) : k("", !0)
          ])) : e.compact ? (c(), g("div", ID, [
            z.value ? (c(), K(I(ct), {
              key: 0,
              "data-testid": "alert-percentage",
              label: `${e.percentage}%`,
              theme: d.value,
              size: "sm",
              "show-left-icon": !1,
              "show-close-icon": !1,
              class: "min-w-10 rounded-(--border-border-radius-rounded-xs)!"
            }, null, 8, ["label", "theme"])) : k("", !0),
            v("div", TD, [
              v("div", LD, [
                e.heading ? (c(), g("p", {
                  key: 0,
                  "data-testid": "alert-heading",
                  class: C(MD)
                }, P(e.heading), 1)) : k("", !0),
                e.optionalIcon ? (c(), g("div", ED, [
                  $e(B.$slots, "body", {}, () => [
                    e.message ? (c(), g("p", {
                      key: 0,
                      "data-testid": "alert-message",
                      class: C(eb)
                    }, P(e.message), 1)) : k("", !0)
                  ]),
                  te(I(Xt), {
                    icon: e.optionalIcon,
                    color: "yellow",
                    size: "xs",
                    type: "square",
                    variant: "outlined"
                  }, null, 8, ["icon"])
                ])) : $e(B.$slots, "body", { key: 2 }, () => [
                  e.message ? (c(), g("p", {
                    key: 0,
                    "data-testid": "alert-message",
                    class: C(eb)
                  }, P(e.message), 1)) : k("", !0)
                ])
              ]),
              e.buttons.length ? (c(), g("div", AD, [
                (c(!0), g(se, null, Me(e.buttons, (H, q) => (c(), g(se, { key: q }, [
                  H.component === "link" ? (c(), K(I($n), Oe({
                    key: 0,
                    ref_for: !0
                  }, j(H)), {
                    default: ve(() => [
                      at(P(H.label), 1)
                    ]),
                    _: 2
                  }, 1040)) : (c(), K(I(Re), Oe({
                    key: 1,
                    ref_for: !0
                  }, M(H)), null, 16))
                ], 64))), 128))
              ])) : k("", !0)
            ])
          ])) : (c(), g("div", {
            key: 6,
            "data-testid": "alert-main-row",
            class: C(["flex w-full", [
              A.value ? "items-center" : "items-start",
              z.value ? "gap-1 ps-5" : "gap-2 ps-6",
              { "flex-wrap": L.value }
            ]])
          }, [
            v("div", {
              class: C(["relative flex min-h-6 min-w-0", L.value ? "grow basis-40" : "flex-1"])
            }, [
              v("div", {
                "data-testid": "alert-icon-column",
                class: C(["absolute top-0 flex items-start py-1", z.value ? "-start-5" : "-start-6"])
              }, [
                v("i", {
                  class: C([[s.value.icon, s.value.iconTint], "inline-flex items-center justify-center size-(--icon-size-sm) text-(length:--size-l)"]),
                  "aria-hidden": "true"
                }, null, 2)
              ], 2),
              v("div", {
                "data-testid": "alert-text-column",
                class: C(["flex min-w-0 flex-1 flex-col", e.checkbox ? "gap-3" : "gap-2"])
              }, [
                v("div", {
                  "data-testid": "alert-text-group",
                  class: C(e.checkbox ? "flex flex-col gap-1" : "contents")
                }, [
                  e.heading ? (c(), g("p", {
                    key: 0,
                    "data-testid": "alert-heading",
                    class: C(_h)
                  }, P(e.heading), 1)) : k("", !0),
                  $e(B.$slots, "body", {}, () => [
                    e.message ? (c(), g("p", {
                      key: 0,
                      "data-testid": "alert-message",
                      class: C(w.value)
                    }, P(e.message), 3)) : k("", !0)
                  ])
                ], 2),
                e.checkbox ? (c(), K(Cn, {
                  key: 0,
                  modelValue: r.value,
                  "onUpdate:modelValue": F[4] || (F[4] = (H) => r.value = H),
                  label: e.checkbox.label,
                  "label-wrap": ""
                }, null, 8, ["modelValue", "label"])) : k("", !0),
                e.buttons.length && e.buttonsPosition === "bottom" ? (c(), g("div", RD, [
                  (c(!0), g(se, null, Me(e.buttons, (H, q) => (c(), g(se, { key: q }, [
                    H.component === "link" ? (c(), K(I($n), Oe({
                      key: 0,
                      ref_for: !0
                    }, j(H)), {
                      default: ve(() => [
                        at(P(H.label), 1)
                      ]),
                      _: 2
                    }, 1040)) : (c(), K(I(Re), Oe({
                      key: 1,
                      ref_for: !0
                    }, M(H)), null, 16))
                  ], 64))), 128))
                ])) : k("", !0)
              ], 2)
            ], 2),
            z.value ? (c(), K(I(ct), {
              key: 0,
              "data-testid": "alert-percentage",
              label: `${e.percentage}%`,
              theme: d.value,
              size: "sm",
              "show-left-icon": !1,
              "show-close-icon": !1,
              class: "shrink-0 min-w-10 rounded-(--border-border-radius-rounded-xs)!"
            }, null, 8, ["label", "theme"])) : k("", !0),
            T.value && e.buttonsPosition !== "right" ? (c(), K(I(Re), {
              key: 1,
              variant: "text",
              "icon-only": "",
              "icon-left": "ri-close-line",
              size: "xs",
              "aria-label": D.value,
              class: "-mx-2 -my-1 shrink-0",
              onClick: V
            }, null, 8, ["aria-label"])) : k("", !0),
            L.value ? (c(), g("div", BD, [
              T.value ? (c(), K(I(Re), {
                key: 0,
                variant: "text",
                "icon-only": "",
                "icon-left": "ri-close-line",
                size: "xs",
                "aria-label": D.value,
                class: "-m-2",
                onClick: V
              }, null, 8, ["aria-label"])) : k("", !0),
              (c(!0), g(se, null, Me(e.buttons, (H, q) => (c(), g(se, { key: q }, [
                H.component === "link" ? (c(), K(I($n), Oe({
                  key: 0,
                  ref_for: !0
                }, j(H)), {
                  default: ve(() => [
                    at(P(H.label), 1)
                  ]),
                  _: 2
                }, 1040)) : (c(), K(I(Re), Oe({
                  key: 1,
                  ref_for: !0
                }, M(H)), null, 16))
              ], 64))), 128))
            ])) : k("", !0)
          ], 2))
        ];
      }),
      _: 3
    }, 16, ["class"]));
  }
}), DD = '<svg viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path d="M7.82843 10.9999H20V12.9999H7.82843L13.1924 18.3638L11.7782 19.778L4 11.9999L11.7782 4.22168L13.1924 5.63589L7.82843 10.9999Z"/></svg>', tb = '<svg viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path d="M16.1716 10.9999L10.8076 5.63589L12.2218 4.22168L20 11.9999L12.2218 19.778L10.8076 18.3638L16.1716 12.9999H4V10.9999H16.1716Z"/></svg>', zD = '<svg viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path d="M17 6H22V8H20V21C20 21.5523 19.5523 22 19 22H5C4.44772 22 4 21.5523 4 21V8H2V6H7V3C7 2.44772 7.44772 2 8 2H16C16.5523 2 17 2.44772 17 3V6ZM18 8H6V20H18V8ZM9 11H11V17H9V11ZM13 11H15V17H13V11ZM9 4V6H15V4H9Z"/></svg>', OD = ["src", "alt"], PD = ["aria-label", "disabled", "aria-describedby"], FD = { class: "text-lg font-semibold text-(--colors-text-heading) dark:text-(--colors-text-white-default)" }, VD = { class: "flex flex-col gap-4" }, ND = { class: "flex items-start gap-4" }, HD = {
  "data-testid": "image-upload-preview",
  class: "shrink-0"
}, jD = ["src", "alt"], WD = { class: "flex-1 min-w-0" }, qD = { key: 0 }, nb = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='200' height='200' viewBox='0 0 200 200'%3E%3Crect width='200' height='200' fill='%23c0c0c0'/%3E%3Crect x='30' y='30' width='140' height='140' rx='4' fill='%23e0e0e0'/%3E%3Ccircle cx='80' cy='82' r='14' fill='%23b0b0b0'/%3E%3Cpath d='M50 140 l30-40 l20 25 l15-18 l35 45 H50z' fill='%23b0b0b0'/%3E%3C/svg%3E", nq = /* @__PURE__ */ ye({
  __name: "ImageUploadInput",
  props: {
    imageUrl: { default: void 0 },
    imageAlt: { default: "Profile picture" },
    avatarSize: { default: 64 },
    label: { default: void 0 },
    labelInline: { type: Boolean, default: !1 },
    required: { type: Boolean, default: !1 },
    requiredIndicator: { default: "*" },
    labelTooltip: { default: void 0 },
    hint: { default: void 0 },
    error: { default: void 0 },
    errorLive: { type: Boolean, default: !0 },
    accept: { default: "image/*" },
    maxFileSize: { default: 30 * 1024 * 1024 },
    maxFileSizeText: { default: "SVG, PNG, JPG or GIF (MAX. 800x400px)." },
    fileTypeErrorText: { default: void 0 },
    fileSizeErrorText: { default: void 0 },
    fileInputLabel: { default: void 0 },
    browseButtonText: { default: "Choose files" },
    placeholder: { default: "No file chosen" },
    removeButtonLabel: { default: "Remove current picture" },
    alertHeading: { default: "Important" },
    alertMessage: { default: "In order for new users to access their accounts, they must receive approval from an administrator to verify their eligibility." },
    alertVariant: { default: "info" },
    showAlert: { type: Boolean, default: !0 },
    cancelButtonLabel: { default: "Cancel" },
    uploadButtonLabel: { default: "Upload new picture" },
    modalTitle: { default: "Upload profile picture" },
    modalSize: { default: "sm" },
    disabled: { type: Boolean, default: !1 },
    editButtonLabel: { default: "Edit profile picture" }
  },
  emits: ["upload", "remove", "cancel"],
  setup(e, { emit: n }) {
    const t = (Y, _) => {
      const j = Y.replace('fill="currentColor"', `fill="${_}"`).replace("<svg", '<svg width="16" height="16"');
      return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(j)}`;
    }, a = {
      arrowLeftDark: t(DD, "#242424"),
      arrowRightDark: t(tb, "#242424"),
      arrowRightLight: t(tb, "#f2f0f0"),
      deleteDark: t(zD, "#242424")
    }, l = e, r = n, o = E(!1), i = E(!1), s = E(null), d = Ve(), u = `${d}-hint`, f = `${d}-error`, b = p(() => {
      const Y = [];
      return l.hint && Y.push(u), l.error && Y.push(f), Y.length > 0 ? Y.join(" ") : void 0;
    }), h = E(null), m = E(void 0), x = E(null), y = p(() => ({
      width: `${l.avatarSize}px`,
      height: `${l.avatarSize}px`
    })), w = p(() => {
      const Y = "flex text-left text-sm font-inter";
      return l.labelInline ? `${Y} flex-row items-center gap-4` : `${Y} flex-col items-start gap-2`;
    }), S = () => {
      l.disabled || (h.value = null, m.value = l.imageUrl, x.value = null, o.value = !0);
    }, $ = () => {
      o.value = !1, h.value = null, m.value = void 0;
    }, T = () => {
      r("cancel"), $();
    }, L = (Y) => {
      !Y || Array.isArray(Y) || (x.value = null, h.value = Y, m.value = URL.createObjectURL(Y));
    }, A = (Y) => {
      x.value = Y, h.value = null;
    }, R = () => {
      h.value = null, m.value = void 0, r("remove");
    }, z = () => {
      h.value && (r("upload", h.value), $());
    }, D = p(() => !!h.value), V = p(() => !!m.value);
    return Ie(o, (Y) => {
      !Y && m.value && m.value !== l.imageUrl && URL.revokeObjectURL(m.value);
    }), (Y, _) => (c(), g("div", {
      "data-testid": "image-upload-input",
      class: C(w.value)
    }, [
      e.label ? (c(), K(xt, {
        key: 0,
        text: e.label,
        required: e.required,
        "required-indicator": e.requiredIndicator,
        tooltip: e.labelTooltip,
        inline: e.labelInline,
        "test-id": "image-upload-label"
      }, null, 8, ["text", "required", "required-indicator", "tooltip", "inline"])) : k("", !0),
      v("div", {
        class: C(["flex min-w-0 flex-col items-start gap-0.5", e.labelInline ? "flex-1" : "self-stretch"])
      }, [
        v("div", {
          class: "relative inline-block",
          style: Ne(y.value)
        }, [
          v("div", {
            "data-testid": "image-upload-trigger",
            class: C(["w-full h-full rounded-(--border-border-radius-rounded-l) overflow-hidden border border-(--colors-border-base-soft) dark:border-(--colors-border-base)", e.disabled ? "opacity-50" : ""])
          }, [
            v("img", {
              src: e.imageUrl || nb,
              alt: e.imageAlt,
              class: "w-full h-full object-cover"
            }, null, 8, OD)
          ], 2),
          v("button", {
            "data-testid": "image-upload-edit-button",
            type: "button",
            "aria-label": e.editButtonLabel,
            class: C(["absolute -top-2 -right-2 flex items-center justify-center w-8 h-8 rounded-full bg-(--background-background-white) dark:bg-(--colors-background-black-default) border border-(--colors-border-base-soft) dark:border-(--colors-border-base) shadow-sm transition-colors duration-200 hover:bg-(--colors-background-hover) dark:hover:bg-[rgba(255,255,255,0.1)]", e.disabled ? "cursor-not-allowed opacity-50" : "cursor-pointer"]),
            disabled: e.disabled,
            "aria-describedby": b.value,
            onClick: S,
            onFocus: _[0] || (_[0] = (j) => i.value = !0),
            onBlur: _[1] || (_[1] = (j) => i.value = !1),
            onKeydown: _[2] || (_[2] = (j) => {
              var M;
              return (M = s.value) == null ? void 0 : M.handleFieldKeydown(j);
            })
          }, [..._[4] || (_[4] = [
            v("i", {
              class: "ri-pencil-line text-(length:--size-m) text-(--colors-text-heading) dark:text-(--colors-text-white-default)",
              "aria-hidden": "true"
            }, null, -1)
          ])], 42, PD)
        ], 4),
        e.hint || e.error ? (c(), K(vt, {
          key: 0,
          ref_key: "helperRef",
          ref: s,
          focused: i.value,
          hint: e.hint,
          error: e.error,
          "hint-id": u,
          "error-id": f,
          "error-live": e.errorLive,
          "test-id-prefix": "image-upload"
        }, null, 8, ["focused", "hint", "error", "error-live"])) : k("", !0)
      ], 2),
      te(I(za), {
        modelValue: o.value,
        "onUpdate:modelValue": _[3] || (_[3] = (j) => o.value = j),
        size: e.modalSize,
        "header-position": "left",
        "footer-position": "right"
      }, {
        header: ve(() => [
          v("h3", FD, P(e.modalTitle), 1)
        ]),
        footer: ve(() => [
          te(I(Re), {
            "data-testid": "image-upload-cancel-button",
            variant: "secondary",
            label: e.cancelButtonLabel,
            "icon-left": a.arrowLeftDark,
            onClick: T
          }, null, 8, ["label", "icon-left"]),
          te(I(Re), {
            "data-testid": "image-upload-submit-button",
            variant: "primary",
            label: e.uploadButtonLabel,
            "icon-right": a.arrowRightLight,
            disabled: !D.value,
            onClick: z
          }, null, 8, ["label", "icon-right", "disabled"])
        ]),
        default: ve(() => [
          v("div", VD, [
            v("div", ND, [
              v("div", HD, [
                v("img", {
                  src: m.value || nb,
                  alt: e.imageAlt,
                  class: "w-16 h-16 rounded-xl object-cover border border-(--colors-border-base-soft) dark:border-(--colors-border-base)"
                }, null, 8, jD)
              ]),
              v("div", WD, [
                te(I(CS), {
                  variant: "basic",
                  accept: e.accept,
                  "max-file-size": e.maxFileSize,
                  "max-file-size-text": e.maxFileSizeText,
                  "file-type-error-text": e.fileTypeErrorText,
                  "file-size-error-text": e.fileSizeErrorText,
                  label: e.fileInputLabel,
                  "browse-button-text": e.browseButtonText,
                  placeholder: e.placeholder,
                  "model-value": h.value,
                  error: x.value ?? void 0,
                  "onUpdate:modelValue": L,
                  onError: A
                }, null, 8, ["accept", "max-file-size", "max-file-size-text", "file-type-error-text", "file-size-error-text", "label", "browse-button-text", "placeholder", "model-value", "error"])
              ])
            ]),
            V.value ? (c(), g("div", qD, [
              te(I(Re), {
                "data-testid": "image-upload-remove-button",
                variant: "secondary",
                label: e.removeButtonLabel,
                "icon-left": a.deleteDark,
                size: "sm",
                onClick: R
              }, null, 8, ["label", "icon-left"])
            ])) : k("", !0),
            e.showAlert ? (c(), K(I(Ul), {
              key: 1,
              heading: e.alertHeading,
              message: e.alertMessage,
              color: e.alertVariant === "error" ? "danger" : e.alertVariant,
              closable: !1
            }, null, 8, ["heading", "message", "color"])) : k("", !0)
          ])
        ]),
        _: 1
      }, 8, ["modelValue", "size"])
    ], 2));
  }
}), UD = ["id", "aria-label", "data-testid"], GD = {
  key: 0,
  class: "flex w-full items-center gap-3"
}, yv = /* @__PURE__ */ ye({
  __name: "DatepickerPanel",
  props: {
    open: { type: Boolean, default: !1 },
    anchorEl: {},
    dialogLabel: {},
    testId: {},
    widthClass: {},
    id: { default: void 0 },
    keepAnchorFocusable: { type: Boolean, default: !1 },
    additionalAnchorEls: { default: () => [] },
    placement: { default: "bottom-start" }
  },
  emits: ["update:open", "close"],
  setup(e, { expose: n, emit: t }) {
    const a = e, l = t, r = E(null);
    let o = null;
    function i(m) {
      return m.startsWith("bottom") ? m.replace("bottom", "top") : m.replace("top", "bottom");
    }
    function s() {
      r.value && (o == null || o.destroy(), o = Fa(a.anchorEl, r.value, {
        strategy: "fixed",
        placement: a.placement,
        modifiers: [
          { name: "offset", options: { offset: [0, 4] } },
          { name: "flip", options: { fallbackPlacements: [i(a.placement)] } },
          { name: "preventOverflow", options: { padding: 8 } }
        ]
      }));
    }
    function d() {
      o == null || o.destroy(), o = null;
    }
    function u() {
      o == null || o.update();
    }
    function f() {
      l("update:open", !1), l("close");
    }
    Gi({
      active: qn(a, "open"),
      container: r,
      containFocus: !0,
      restoreFocusTo: () => a.anchorEl,
      // See keepAnchorFocusable's doc above: without this, a consumer whose anchor IS its own
      // typing surface can never place a caret in it while the panel is open — containFocus treats
      // the click as focus escaping the trap and yanks it straight back to the panel's first
      // focusable cell.
      allowOutsideElements: a.keepAnchorFocusable ? () => [a.anchorEl, ...a.additionalAnchorEls] : void 0
    }), Ji(r, f, {
      isActive: () => a.open,
      ignoreElements: () => [a.anchorEl, ...a.additionalAnchorEls]
    });
    const b = Symbol("datepicker-panel");
    function h(m) {
      m.key !== "Escape" || !a.open || Va(b) && (m.defaultPrevented || (m.stopPropagation(), m.preventDefault(), f()));
    }
    return Ie(
      () => a.open,
      async (m) => {
        m ? (Zn(b), await qe(), s()) : (An(b), d());
      },
      { immediate: !0 }
    ), Ie(
      () => a.anchorEl,
      () => {
        a.open && s();
      }
    ), ot(() => {
      document.addEventListener("keydown", h);
    }), gt(() => {
      document.removeEventListener("keydown", h), An(b), d();
    }), n({ updatePosition: u }), (m, x) => (c(), K(Bn, { to: "body" }, [
      e.open ? (c(), g("div", {
        key: 0,
        id: e.id,
        ref_key: "panelRef",
        ref: r,
        role: "dialog",
        "aria-modal": "true",
        "aria-label": e.dialogLabel,
        "data-focus-trap-allow-outside": "",
        "data-testid": e.testId,
        class: C([
          "z-[350] flex flex-col items-center gap-4 rounded-(--border-border-radius-rounded-l) border border-solid border-(--border-border-base-soft) bg-(--background-background-white) p-5 shadow-(--blur-shadow-m) dark:bg-(--colors-background-black-default) dark:shadow-(--blur-shadow-m-dark)",
          e.widthClass
        ])
      }, [
        $e(m.$slots, "default"),
        m.$slots.actions ? (c(), g("div", GD, [
          $e(m.$slots, "actions")
        ])) : k("", !0)
      ], 10, UD)) : k("", !0)
    ]));
  }
}), KD = ["aria-disabled", "data-state", "aria-current"], Ua = "relative inline-flex items-center justify-center font-inter focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-(--border-border-accent) focus-visible:ring-offset-1", YD = "flex size-9 items-center justify-center rounded-(--border-border-radius-rounded-full) border border-solid datepicker-cell--gradient-white", ml = "text-(length:--size-sm) leading-(--line-height-l)", JD = /* @__PURE__ */ ye({
  __name: "DatepickerCell",
  props: {
    type: { default: "Day" },
    state: { default: "Initial" },
    text: { default: "" },
    muted: { type: Boolean, default: !1 }
  },
  emits: ["click"],
  setup(e, { emit: n }) {
    const t = e, a = n, l = p(() => t.state === "Disabled");
    function r(u) {
      l.value || a("click", u);
    }
    const o = p(
      () => t.type === "Day" && (t.state === "Active start" || t.state === "Active end")
    ), i = p(() => {
      switch (t.type) {
        case "Month":
          return "h-9 min-w-[78px] flex-1";
        case "Year":
        case "Wheel":
          return "h-9 min-w-[57px] flex-1";
        default:
          return "size-9 shrink-0";
      }
    }), s = p(() => {
      switch (t.state) {
        case "Hover":
          return `${Ua} bg-(--background-background-accent) rounded-(--border-border-radius-rounded-base)`;
        case "Active":
          return `${Ua} datepicker-cell--gradient-white border border-solid rounded-(--border-border-radius-rounded-full)`;
        case "Active start":
          return `${Ua} bg-(--background-background-accent) rounded-l-(--border-border-radius-rounded-base)`;
        case "Active between":
          return `${Ua} bg-(--background-background-accent)`;
        case "Active end":
          return `${Ua} bg-(--background-background-accent) rounded-r-(--border-border-radius-rounded-base)`;
        case "Today":
          return `${Ua} datepicker-cell--gradient-black border border-solid rounded-(--border-border-radius-rounded-full)`;
        default:
          return `${Ua} rounded-(--border-border-radius-rounded-base)`;
      }
    }), d = p(() => {
      switch (t.state) {
        case "Active":
        case "Active start":
        case "Active end":
          return `${ml} font-(--weight-semi-bold) text-(--text-text-accent)`;
        case "Today":
          return `${ml} font-(--weight-semi-bold) text-(--text-text-white-default)`;
        case "Disabled":
          return `${ml} font-(--weight-medium) text-(--text-text-disabled-light)`;
        case "Hover":
        case "Active between":
          return `${ml} font-(--weight-medium) text-(--text-text-black-default)`;
        default:
          return t.muted ? `${ml} font-(--weight-medium) text-(--text-text-disabled-strong) dark:text-(--text-text-disabled-light)` : `${ml} font-(--weight-medium) text-(--text-text-black-default) dark:text-(--colors-text-white-default)`;
      }
    });
    return (u, f) => (c(), g("button", {
      type: "button",
      "aria-disabled": l.value ? "true" : void 0,
      class: C([s.value, i.value, l.value ? "cursor-not-allowed" : "cursor-pointer"]),
      "data-state": e.state,
      "aria-current": e.state === "Today" ? "date" : void 0,
      "data-testid": "datepicker-cell",
      onClick: r
    }, [
      o.value ? (c(), g("span", {
        key: 0,
        class: C(YD),
        "data-testid": "datepicker-cell-inner"
      }, [
        v("span", {
          class: C(d.value)
        }, P(e.text), 3)
      ])) : (c(), g("span", {
        key: 1,
        class: C(d.value)
      }, P(e.text), 3))
    ], 10, KD));
  }
}), Er = /* @__PURE__ */ lt(JD, [["__scopeId", "data-v-c4eaa4a3"]]);
function rd(e, n) {
  const t = E(0);
  function a() {
    const s = e.value.findIndex((d) => d.value === n.value);
    t.value = s >= 0 ? s : Math.max(e.value.findIndex((d) => !d.disabled), 0);
  }
  a();
  function l(s) {
    const d = e.value[s];
    !d || d.disabled || (t.value = s, n.value = d.value);
  }
  function r(s) {
    if (s < 0 || s >= e.value.length) return;
    t.value = s;
    const d = e.value[s];
    d.disabled || (n.value = d.value);
  }
  function o(s) {
    r(t.value + s);
  }
  function i(s) {
    const d = e.value;
    r(s === "start" ? 0 : d.length - 1);
  }
  return { focusedIndex: t, selectIndex: l, moveFocus: o, moveToEdge: i, syncFocusToSelected: a };
}
const ZD = { class: "w-full text-center text-(length:--size-m) font-(--weight-semi-bold) leading-(--line-height-l) text-(--text-text-black-default) dark:text-(--colors-text-white-default)" }, XD = { class: "flex w-full flex-wrap content-start items-start justify-between" }, QD = ["aria-label"], _D = ["aria-label"], e3 = ["aria-label"], t3 = 120, n3 = 10, a3 = 200, l3 = 200, r3 = /* @__PURE__ */ ye({
  __name: "DatepickerDobPicker",
  props: {
    open: { type: Boolean, default: !1 },
    modelValue: { default: void 0 },
    anchorEl: {},
    minDate: { default: void 0 },
    maxDate: { default: void 0 },
    defaultDate: { default: void 0 },
    id: { default: void 0 },
    autoFocusOnOpen: { type: Boolean, default: !0 },
    title: {},
    yearColumnLabel: {},
    monthColumnLabel: {},
    dayColumnLabel: {},
    monthLabels: {},
    monthShortLabels: {},
    clearLabel: {}
  },
  emits: ["update:open", "update:modelValue", "clear", "close"],
  setup(e, { expose: n, emit: t }) {
    const a = e, l = t;
    function r(O) {
      return String(O).padStart(2, "0");
    }
    function o(O, U, Q) {
      return `${O}-${r(U + 1)}-${r(Q)}`;
    }
    function i(O, U) {
      return new Date(O, U + 1, 0).getDate();
    }
    function s() {
      const O = a.modelValue || a.defaultDate, U = O ? /* @__PURE__ */ new Date(`${O}T00:00:00`) : /* @__PURE__ */ new Date();
      return { year: U.getFullYear(), month: U.getMonth(), day: U.getDate() };
    }
    const d = s(), u = E(d.year), f = E(d.month), b = E(d.day);
    function h(O) {
      const U = (/* @__PURE__ */ new Date()).getFullYear();
      return Math.min(Math.max(O, U - a3), U + l3);
    }
    const m = p(() => a.minDate ? h(Number(a.minDate.slice(0, 4))) : void 0), x = p(() => a.maxDate ? h(Number(a.maxDate.slice(0, 4))) : void 0), y = p(() => {
      const O = (/* @__PURE__ */ new Date()).getFullYear(), U = [O - t3, O + n3];
      return m.value !== void 0 && U.push(m.value), x.value !== void 0 && U.push(x.value), U.push(h(u.value)), {
        min: Math.min(...U),
        max: Math.max(...U)
      };
    });
    function w(O) {
      const { minDate: U, maxDate: Q } = a;
      return !!(U && O < U.slice(0, O.length) || Q && O > Q.slice(0, O.length));
    }
    const S = p(() => {
      const { min: O, max: U } = y.value, Q = [];
      for (let ae = O; ae <= U; ae++) {
        const Z = String(ae);
        w(Z) || Q.push({ value: ae, label: Z, disabled: !1 });
      }
      return Q;
    }), $ = p(() => {
      const O = [];
      return a.monthShortLabels.forEach((U, Q) => {
        const ae = `${u.value}-${r(Q + 1)}`;
        w(ae) || O.push({ value: Q, label: U, disabled: !1 });
      }), O;
    }), T = p(() => {
      const O = i(u.value, f.value), U = [];
      for (let Q = 0; Q < O; Q++) {
        const ae = Q + 1, Z = o(u.value, f.value, ae);
        w(Z) || U.push({ value: ae, label: String(ae), disabled: !1 });
      }
      return U;
    }), L = rd(S, u), A = rd($, f), R = rd(T, b);
    function z() {
      l("update:modelValue", o(u.value, f.value, b.value));
    }
    function D(O) {
      u.value = h(u.value), x.value !== void 0 && u.value > x.value && (u.value = x.value), m.value !== void 0 && u.value < m.value && (u.value = m.value);
      const U = i(u.value, f.value);
      if (b.value > U && (b.value = U), a.maxDate) {
        const [Z, ie, fe] = a.maxDate.split("-").map(Number);
        u.value === Z && f.value > ie - 1 && (f.value = ie - 1, b.value = Math.min(b.value, i(u.value, f.value))), u.value === Z && f.value === ie - 1 && b.value > fe && (b.value = fe);
      }
      if (a.minDate) {
        const [Z, ie, fe] = a.minDate.split("-").map(Number);
        u.value === Z && f.value < ie - 1 && (f.value = ie - 1, b.value = Math.min(b.value, i(u.value, f.value))), u.value === Z && f.value === ie - 1 && b.value < fe && (b.value = fe);
      }
      const Q = O ?? be, ae = ["year", "month", "day"].filter((Z) => Z !== Q);
      ae.forEach((Z) => J.value.add(Z)), O !== void 0 && (be = O), L.syncFocusToSelected(), A.syncFocusToSelected(), R.syncFocusToSelected(), qe(() => {
        ae.forEach((Z) => J.value.delete(Z)), O !== void 0 && (be = void 0);
      });
    }
    Ie([u, f], () => D());
    function V(O) {
      L.selectIndex(O), D("year"), z();
    }
    function Y(O) {
      A.selectIndex(O), D("month"), z();
    }
    function _(O) {
      R.selectIndex(O), z();
    }
    const j = { year: L, month: A, day: R }, M = {
      year: u,
      month: f,
      day: b
    }, W = ["year", "month", "day"];
    function G(O, U) {
      const Q = W.indexOf(O) + U;
      if (Q < 0 || Q >= W.length) return;
      const ae = W[Q], Z = N[ae].value, ie = Z == null ? void 0 : Z.querySelectorAll('[role="option"]')[j[ae].focusedIndex.value];
      ie == null || ie.focus({ preventScroll: !0 }), ie == null || ie.scrollIntoView({ block: "center", behavior: "smooth" });
    }
    function B() {
      l("update:open", !1), l("close");
    }
    function F(O, U) {
      if (O.key === "ArrowLeft" || O.key === "ArrowRight") {
        O.preventDefault(), G(U, O.key === "ArrowLeft" ? -1 : 1);
        return;
      }
      if (O.key === "Enter" || O.key === " ") {
        O.preventDefault(), B();
        return;
      }
      const Q = j[U], ae = M[U], Z = ae.value;
      switch (O.key) {
        case "ArrowDown":
          O.preventDefault(), Q.moveFocus(1);
          break;
        case "ArrowUp":
          O.preventDefault(), Q.moveFocus(-1);
          break;
        case "Home":
          O.preventDefault(), Q.moveToEdge("start");
          break;
        case "End":
          O.preventDefault(), Q.moveToEdge("end");
          break;
        default:
          return;
      }
      ae.value !== Z && (U !== "day" && D(U), z());
    }
    const X = E(null), H = E(null), q = E(null), N = { year: X, month: H, day: q }, J = E(/* @__PURE__ */ new Set());
    let be;
    function ke(O) {
      const U = N[O].value, Q = U == null ? void 0 : U.querySelectorAll('[role="option"]')[j[O].focusedIndex.value];
      J.value.has(O) || Q == null || Q.focus({ preventScroll: !0 }), Q == null || Q.scrollIntoView({ block: "center", behavior: "smooth" });
    }
    Ie(L.focusedIndex, () => ke("year"), { flush: "post" }), Ie(A.focusedIndex, () => ke("month"), { flush: "post" }), Ie(R.focusedIndex, () => ke("day"), { flush: "post" });
    function ee(O, U) {
      return O.value === U ? "Active" : "Initial";
    }
    function oe() {
      l("clear");
    }
    async function ge() {
      const O = s();
      u.value = O.year, f.value = O.month, b.value = O.day, D(), J.value.add("year"), J.value.add("month"), J.value.add("day"), L.syncFocusToSelected(), A.syncFocusToSelected(), R.syncFocusToSelected(), await qe(), J.value.delete("year"), J.value.delete("month"), J.value.delete("day");
      const U = ["year", "month", "day"].map(
        (Q) => {
          var ae;
          return (ae = N[Q].value) == null ? void 0 : ae.querySelectorAll('[role="option"]')[j[Q].focusedIndex.value];
        }
      );
      return U.forEach((Q) => Q == null ? void 0 : Q.scrollIntoView({ block: "center" })), U[0];
    }
    async function re() {
      const O = await ge();
      O == null || O.focus({ preventScroll: !0 });
    }
    Ie(
      () => a.open,
      (O) => {
        O && (a.autoFocusOnOpen ? re() : ge());
      },
      // DatePickerInput's openDobPicker() sets
      // dobMounted/isDobOpen true in the SAME synchronous call, so this component can mount with
      // `open` ALREADY true on first open — without `immediate`, this watcher would never fire for
      // that case (a plain watch only fires on a subsequent CHANGE), and the explicit year-column
      // focus above would never run on the very first open at all.
      { immediate: !0 }
    );
    function ue() {
      re();
    }
    return n({ focusYearColumn: ue }), Ie(
      () => a.modelValue,
      (O) => {
        if (!a.open || O === o(u.value, f.value, b.value)) return;
        const U = s();
        u.value = U.year, f.value = U.month, b.value = U.day, D();
      }
    ), (O, U) => (c(), K(yv, {
      id: e.id,
      open: e.open,
      "anchor-el": e.anchorEl,
      "keep-anchor-focusable": "",
      "dialog-label": e.title,
      "test-id": "datepicker-dob-picker",
      "width-class": "w-[224px]",
      "onUpdate:open": U[3] || (U[3] = (Q) => l("update:open", Q)),
      onClose: U[4] || (U[4] = (Q) => l("close"))
    }, {
      actions: ve(() => [
        te(Re, {
          variant: "secondary",
          size: "sm",
          class: "flex-1",
          "full-width": "",
          label: e.clearLabel,
          "data-testid": "datepicker-dob-picker-clear",
          onClick: oe
        }, null, 8, ["label"])
      ]),
      default: ve(() => [
        v("p", ZD, P(e.title), 1),
        v("div", XD, [
          v("div", {
            ref_key: "yearListRef",
            ref: X,
            role: "listbox",
            "aria-label": e.yearColumnLabel,
            class: "dob-wheel-column h-[108px] w-[57px] shrink-0 snap-y snap-mandatory overflow-y-auto scroll-smooth py-9",
            onKeydown: U[0] || (U[0] = (Q) => F(Q, "year"))
          }, [
            (c(!0), g(se, null, Me(S.value, (Q, ae) => (c(), K(Er, {
              key: Q.value,
              type: "Wheel",
              state: ee(Q, u.value),
              text: Q.label,
              role: "option",
              class: "snap-center",
              "aria-selected": Q.value === u.value ? "true" : void 0,
              tabindex: ae === I(L).focusedIndex.value ? 0 : -1,
              "aria-label": Q.label,
              onClick: (Z) => V(ae)
            }, null, 8, ["state", "text", "aria-selected", "tabindex", "aria-label", "onClick"]))), 128))
          ], 40, QD),
          v("div", {
            ref_key: "monthListRef",
            ref: H,
            role: "listbox",
            "aria-label": e.monthColumnLabel,
            class: "dob-wheel-column h-[108px] w-[57px] shrink-0 snap-y snap-mandatory overflow-y-auto scroll-smooth py-9",
            onKeydown: U[1] || (U[1] = (Q) => F(Q, "month"))
          }, [
            (c(!0), g(se, null, Me($.value, (Q, ae) => (c(), K(Er, {
              key: Q.value,
              type: "Wheel",
              state: ee(Q, f.value),
              text: Q.label,
              role: "option",
              class: "snap-center",
              "aria-selected": Q.value === f.value ? "true" : void 0,
              tabindex: ae === I(A).focusedIndex.value ? 0 : -1,
              "aria-label": e.monthLabels[Q.value],
              onClick: (Z) => Y(ae)
            }, null, 8, ["state", "text", "aria-selected", "tabindex", "aria-label", "onClick"]))), 128))
          ], 40, _D),
          v("div", {
            ref_key: "dayListRef",
            ref: q,
            role: "listbox",
            "aria-label": e.dayColumnLabel,
            class: "dob-wheel-column h-[108px] w-[57px] shrink-0 snap-y snap-mandatory overflow-y-auto scroll-smooth py-9",
            onKeydown: U[2] || (U[2] = (Q) => F(Q, "day"))
          }, [
            (c(!0), g(se, null, Me(T.value, (Q, ae) => (c(), K(Er, {
              key: Q.value,
              type: "Wheel",
              state: ee(Q, b.value),
              text: Q.label,
              role: "option",
              class: "snap-center",
              "aria-selected": Q.value === b.value ? "true" : void 0,
              tabindex: ae === I(R).focusedIndex.value ? 0 : -1,
              "aria-label": Q.label,
              onClick: (Z) => _(ae)
            }, null, 8, ["state", "text", "aria-selected", "tabindex", "aria-label", "onClick"]))), 128))
          ], 40, e3)
        ])
      ]),
      _: 1
    }, 8, ["id", "open", "anchor-el", "dialog-label"]));
  }
}), o3 = /* @__PURE__ */ lt(r3, [["__scopeId", "data-v-f30f2f82"]]), i3 = { class: "flex w-full items-center justify-between" }, s3 = ["disabled"], d3 = /* @__PURE__ */ ye({
  __name: "DatepickerControls",
  props: {
    label: {},
    previousLabel: {},
    nextLabel: {},
    labelDisabled: { type: Boolean, default: !1 },
    previousDisabled: { type: Boolean, default: !1 },
    nextDisabled: { type: Boolean, default: !1 }
  },
  emits: ["prev", "next", "drill-up"],
  setup(e, { emit: n }) {
    const t = n;
    return (a, l) => (c(), g("div", i3, [
      te(Re, {
        variant: "ghost",
        size: "xs",
        "icon-only": "",
        "icon-left": "ri-arrow-left-line",
        "aria-label": e.previousLabel,
        disabled: e.previousDisabled,
        "data-testid": "datepicker-controls-prev",
        onClick: l[0] || (l[0] = (r) => t("prev"))
      }, null, 8, ["aria-label", "disabled"]),
      v("button", {
        type: "button",
        "aria-live": "polite",
        disabled: e.labelDisabled,
        class: "font-(--weight-semi-bold) text-(length:--size-m) leading-(--line-height-l) text-(--text-text-heading) dark:text-(--colors-text-white-default) focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-(--border-border-accent) focus-visible:ring-offset-1 rounded-(--border-border-radius-rounded-sm) cursor-pointer disabled:cursor-not-allowed disabled:opacity-60",
        "data-testid": "datepicker-controls-label",
        onClick: l[1] || (l[1] = (r) => t("drill-up"))
      }, P(e.label), 9, s3),
      te(Re, {
        variant: "ghost",
        size: "xs",
        "icon-only": "",
        "icon-right": "ri-arrow-right-line",
        "aria-label": e.nextLabel,
        disabled: e.nextDisabled,
        "data-testid": "datepicker-controls-next",
        onClick: l[2] || (l[2] = (r) => t("next"))
      }, null, 8, ["aria-label", "disabled"])
    ]));
  }
});
function du(e) {
  return String(e).padStart(2, "0");
}
function ab(e, n, t) {
  const a = e * 12 + n + t;
  return { year: Math.floor(a / 12), month: (a % 12 + 12) % 12 };
}
function Rc(e, n, t) {
  return `${e}-${du(n + 1)}-${du(t)}`;
}
function uu(e, n) {
  return `${e}-${du(n + 1)}`;
}
function kn(e, n) {
  return e < n ? -1 : e > n ? 1 : 0;
}
function Yo() {
  const e = /* @__PURE__ */ new Date();
  return Rc(e.getFullYear(), e.getMonth(), e.getDate());
}
function Bc(e, n, t) {
  const { selectedIso: a, selectedEndIso: l, todayIso: r, minIso: o, maxIso: i } = n, s = r.substring(0, e.length), d = a !== void 0 ? a.substring(0, e.length) : void 0, u = l !== void 0 ? l.substring(0, e.length) : void 0;
  if (o !== void 0 && kn(e, o) < 0 || i !== void 0 && kn(e, i) > 0) return "Disabled";
  if (d !== void 0 && u !== void 0) {
    if (e === d) return "Active start";
    if (e === u) return "Active end";
    if (kn(e, d) > 0 && kn(e, u) < 0) return "Active between";
  } else {
    if (d !== void 0 && e === d)
      return "Active";
    if (u !== void 0 && e === u)
      return "Active";
  }
  return e === s ? "Today" : t;
}
function u3(e, n, t) {
  const l = (new Date(e, n, 1).getDay() + 6) % 7, r = new Date(e, n, 1 - l), o = [];
  for (let i = 0; i < 42; i++) {
    const s = new Date(r);
    s.setDate(r.getDate() + i);
    const d = Rc(s.getFullYear(), s.getMonth(), s.getDate()), u = s.getMonth() === n && s.getFullYear() === e, f = Bc(d, t, "Initial");
    o.push({ iso: d, label: String(s.getDate()), state: f, inMonth: u });
  }
  return o;
}
function c3(e, n, t) {
  return n.map((a, l) => {
    const r = uu(e, l);
    return { iso: r, label: a, state: Bc(r, t, "Initial"), inMonth: !0 };
  });
}
function f3(e, n) {
  return Array.from({ length: 12 }, (t, a) => {
    const l = e + a, r = String(l);
    return { iso: r, label: r, state: Bc(r, n, "Initial"), inMonth: !0 };
  });
}
const h3 = {
  key: 0,
  class: "flex w-[252px] flex-col"
}, b3 = {
  role: "row",
  "data-testid": "datepicker-weekday-header-row",
  class: "mb-1.5 flex items-center"
}, Mc = /* @__PURE__ */ ye({
  __name: "DatepickerDropdownMenu",
  props: {
    open: { type: Boolean, default: !1 },
    modelValue: { default: void 0 },
    startDate: { default: void 0 },
    endDate: { default: void 0 },
    seedField: { default: "start" },
    anchorEl: {},
    additionalAnchorEls: { default: () => [] },
    minDate: { default: void 0 },
    maxDate: { default: void 0 },
    todayButtonMode: { default: "highlight" },
    mode: { default: "day" },
    showTodayButton: { type: Boolean, default: !0 },
    showClearButton: { type: Boolean, default: !0 },
    weekdayLabels: {},
    monthLabels: {},
    monthShortLabels: {},
    clearLabel: {},
    todayLabel: {},
    previousLabel: {},
    nextLabel: {},
    unavailableLabel: {},
    rangeStartLabel: { default: "start of selected range" },
    rangeEndLabel: { default: "end of selected range" },
    rangeBetweenLabel: { default: "in selected range" },
    dialogLabel: {},
    id: { default: void 0 },
    placement: { default: "bottom-start" },
    keepAnchorFocusable: { type: Boolean, default: !1 },
    autoFocusOnOpen: { type: Boolean, default: !0 }
  },
  emits: ["update:open", "update:modelValue", "select", "range-select", "clear", "close"],
  setup(e, { expose: n, emit: t }) {
    const a = e, l = t, r = p(() => a.startDate !== void 0 || a.endDate !== void 0), o = E(/* @__PURE__ */ new Date()), i = p(() => {
      const ae = o.value;
      return `${ae.getFullYear()}-${String(ae.getMonth() + 1).padStart(2, "0")}-${String(ae.getDate()).padStart(2, "0")}`;
    });
    function s(ae) {
      const Z = ae ?? a.seedField, ie = Z === "end" ? a.endDate : a.startDate, fe = Z === "end" ? a.startDate : a.endDate, de = r.value ? ie || fe : a.modelValue;
      if (de) {
        const [ne, le, Le] = de.split("-").map(Number);
        return { year: ne, month: le - 1, day: Le };
      }
      return { year: o.value.getFullYear(), month: o.value.getMonth(), day: o.value.getDate() };
    }
    const d = s(), u = E(d.year), f = E(d.month), b = E(d.day), h = E(a.mode), m = E(o.value.getFullYear() - o.value.getFullYear() % 12), x = p(
      () => u3(u.value, f.value, {
        todayIso: i.value,
        // "" (not yet picked) is normalized to undefined here — cellState's own selectedEndIso
        // contract treats any DEFINED value, empty string included, as a real endpoint, which would
        // otherwise render the lone startDate cell "Active start" instead of plain "Active" before an
        // end date is chosen.
        selectedIso: r.value ? a.startDate || void 0 : a.modelValue,
        selectedEndIso: r.value && a.endDate || void 0,
        minIso: a.minDate,
        maxIso: a.maxDate
      })
    ), y = p(
      () => {
        var ae, Z;
        return c3(u.value, a.monthShortLabels, {
          todayIso: i.value,
          selectedIso: r.value ? a.startDate || void 0 : a.modelValue,
          selectedEndIso: r.value && a.endDate || void 0,
          minIso: (ae = a.minDate) == null ? void 0 : ae.slice(0, 7),
          maxIso: (Z = a.maxDate) == null ? void 0 : Z.slice(0, 7)
        });
      }
    ), w = p(
      () => {
        var ae, Z;
        return f3(m.value, {
          todayIso: i.value,
          selectedIso: r.value ? a.startDate || void 0 : a.modelValue,
          selectedEndIso: r.value && a.endDate || void 0,
          minIso: (ae = a.minDate) == null ? void 0 : ae.slice(0, 4),
          maxIso: (Z = a.maxDate) == null ? void 0 : Z.slice(0, 4)
        });
      }
    ), S = p(() => h.value === "month" ? y.value : h.value === "year" ? w.value : x.value), $ = p(() => {
      const ae = [];
      for (let Z = 0; Z < 6; Z++)
        ae.push(
          x.value.slice(Z * 7, Z * 7 + 7).map((ie, fe) => ({ cell: ie, index: Z * 7 + fe }))
        );
      return ae;
    }), T = p(() => h.value === "day" ? 7 : h.value === "month" ? 3 : 4), L = p(() => {
      const ae = T.value, Z = S.value, ie = [];
      for (let fe = 0; fe < Z.length; fe += ae)
        ie.push(Z.slice(fe, fe + ae).map((de, ne) => ({ cell: de, index: fe + ne })));
      return ie;
    }), A = E(null);
    function R(ae) {
      return ae.state === "Initial" && A.value === ae.iso ? "Hover" : ae.state;
    }
    const z = /* @__PURE__ */ new Set([
      "Active",
      "Active start",
      "Active between",
      "Active end"
    ]);
    function D(ae) {
      const [Z, ie] = ae.iso.split("-").map(Number), fe = `${a.monthLabels[ie - 1]} ${ae.label}, ${Z}`;
      return ae.state === "Disabled" ? `${fe}, ${a.unavailableLabel}` : ae.state === "Active start" ? `${fe}, ${a.rangeStartLabel}` : ae.state === "Active end" ? `${fe}, ${a.rangeEndLabel}` : ae.state === "Active between" ? `${fe}, ${a.rangeBetweenLabel}` : fe;
    }
    function V(ae) {
      const Z = Number(ae.iso.split("-")[1]), ie = a.monthLabels[Z - 1];
      return ae.state === "Disabled" ? `${ie}, ${a.unavailableLabel}` : ie;
    }
    const Y = p(() => h.value === "month" ? String(u.value) : h.value === "year" ? `${m.value}-${m.value + 11}` : `${a.monthLabels[f.value]} ${u.value}`), _ = p(() => a.mode !== "day" || h.value === "year"), j = p(() => {
      var Z;
      if (h.value === "day") {
        if (a.minDate === void 0) return !1;
        const ie = (Z = x.value[0]) == null ? void 0 : Z.iso;
        return ie !== void 0 && kn(ie, a.minDate) <= 0;
      }
      if (a.minDate === void 0) return !1;
      const ae = Number(a.minDate.slice(0, 4));
      return h.value === "month" ? u.value <= ae : m.value <= ae;
    }), M = p(() => {
      var Z;
      if (h.value === "day") {
        if (a.maxDate === void 0) return !1;
        const ie = (Z = x.value[41]) == null ? void 0 : Z.iso;
        return ie !== void 0 && kn(ie, a.maxDate) >= 0;
      }
      if (a.maxDate === void 0) return !1;
      const ae = Number(a.maxDate.slice(0, 4));
      return h.value === "month" ? u.value >= ae : m.value + 11 >= ae;
    }), W = p(() => {
      var de, ne;
      const ae = a.mode === "month" ? 7 : a.mode === "year" ? 4 : 10, Z = i.value.slice(0, ae), ie = (de = a.minDate) == null ? void 0 : de.slice(0, ae), fe = (ne = a.maxDate) == null ? void 0 : ne.slice(0, ae);
      return ie !== void 0 && kn(Z, ie) < 0 || fe !== void 0 && kn(Z, fe) > 0;
    });
    async function G() {
      await qe(), re(ke.value);
    }
    function B() {
      var ae;
      return ((ae = document.activeElement) == null ? void 0 : ae.getAttribute("data-testid")) === "datepicker-cell";
    }
    async function F() {
      if (j.value) return;
      const ae = B();
      if (h.value === "day") {
        const { year: Z, month: ie } = ab(u.value, f.value, -1);
        u.value = Z, f.value = ie;
      } else h.value === "month" ? u.value -= 1 : m.value -= 12;
      ae && await G();
    }
    async function X() {
      if (M.value) return;
      const ae = B();
      if (h.value === "day") {
        const { year: Z, month: ie } = ab(u.value, f.value, 1);
        u.value = Z, f.value = ie;
      } else h.value === "month" ? u.value += 1 : m.value += 12;
      ae && await G();
    }
    async function H() {
      const ae = B();
      if (h.value === "day")
        h.value = "month";
      else if (h.value === "month")
        m.value = u.value - u.value % 12, h.value = "year";
      else
        return;
      ae && await G();
    }
    function q() {
      l("clear");
    }
    async function N() {
      if (!W.value) {
        if (a.mode === "month") {
          if (u.value = o.value.getFullYear(), a.todayButtonMode === "select") {
            J(uu(o.value.getFullYear(), o.value.getMonth()));
            return;
          }
          await qe(), re(y.value.findIndex((ae) => ae.iso === i.value.slice(0, 7)));
          return;
        }
        if (a.mode === "year") {
          if (m.value = o.value.getFullYear() - o.value.getFullYear() % 12, a.todayButtonMode === "select") {
            J(String(o.value.getFullYear()));
            return;
          }
          await qe(), re(w.value.findIndex((ae) => ae.iso === i.value.slice(0, 4)));
          return;
        }
        if (h.value = "day", u.value = o.value.getFullYear(), f.value = o.value.getMonth(), a.todayButtonMode === "select") {
          if (r.value) {
            l("range-select", i.value);
            return;
          }
          l("update:modelValue", i.value), l("select", i.value), O();
          return;
        }
        await qe(), re(x.value.findIndex((ae) => ae.iso === i.value));
      }
    }
    function J(ae) {
      l("update:modelValue", ae), l("select", ae), O();
    }
    async function be(ae) {
      if (ae.state !== "Disabled") {
        if (h.value === "year") {
          if (a.mode === "year") {
            J(ae.iso);
            return;
          }
          u.value = Number(ae.iso), h.value = "month", await G();
          return;
        }
        if (h.value === "month") {
          if (a.mode === "month") {
            J(ae.iso);
            return;
          }
          f.value = Number(ae.iso.slice(5)) - 1, h.value = "day", await G();
          return;
        }
        if (r.value) {
          l("range-select", ae.iso);
          return;
        }
        J(ae.iso);
      }
    }
    const ke = E(0);
    function ee() {
      const ae = S.value;
      let Z;
      if (h.value === "day") {
        const fe = new Date(u.value, f.value + 1, 0).getDate();
        Z = Rc(u.value, f.value, Math.min(b.value, fe));
      } else h.value === "month" ? Z = uu(u.value, f.value) : Z = String(u.value);
      const ie = ae.findIndex((fe) => fe.iso === Z);
      ke.value = ie >= 0 ? ie : Math.max(ae.findIndex((fe) => fe.state !== "Disabled"), 0);
    }
    ee(), Ie([u, f, h, m], ee);
    const oe = E(null), ge = E(null);
    function re(ae) {
      var Z, ie;
      if (ke.value = ae, h.value === "day") {
        const fe = x.value[ae];
        fe && (b.value = Number(fe.iso.slice(8, 10)));
      }
      (ie = (Z = oe.value) == null ? void 0 : Z.querySelectorAll('[data-testid="datepicker-cell"]')[ae]) == null || ie.focus({ preventScroll: !0 });
    }
    function ue(ae) {
      const Z = S.value, ie = Z.length, fe = ke.value, de = T.value, ne = fe - fe % de;
      switch (ae.key) {
        case "ArrowRight":
          ae.preventDefault(), fe < ie - 1 && re(fe + 1);
          break;
        case "ArrowLeft":
          ae.preventDefault(), fe > 0 && re(fe - 1);
          break;
        case "ArrowDown":
          ae.preventDefault(), fe + de < ie && re(fe + de);
          break;
        case "ArrowUp":
          ae.preventDefault(), fe - de >= 0 && re(fe - de);
          break;
        case "Home":
          ae.preventDefault(), re(ne);
          break;
        case "End":
          ae.preventDefault(), re(Math.min(ne + de - 1, ie - 1));
          break;
        case "PageUp":
          h.value === "day" && (ae.preventDefault(), F());
          break;
        case "PageDown":
          h.value === "day" && (ae.preventDefault(), X());
          break;
        case "Enter":
        case " ":
          ae.preventDefault(), be(Z[fe]);
          break;
      }
    }
    function O() {
      l("update:open", !1), l("close");
    }
    function U(ae) {
      o.value = /* @__PURE__ */ new Date(), h.value = a.mode;
      const Z = s(ae);
      u.value = Z.year, f.value = Z.month, b.value = Z.day, m.value = Z.year - Z.year % 12, ee();
    }
    Ie(
      () => a.open,
      (ae) => {
        ae ? (U(), a.autoFocusOnOpen && qe(() => re(ke.value))) : A.value = null;
      },
      { immediate: !0 }
    ), Ie(h, async () => {
      var ae;
      await qe(), (ae = ge.value) == null || ae.updatePosition();
    });
    async function Q(ae) {
      U(ae), await qe(), re(ke.value);
    }
    return n({ focusGrid: Q, reseedVisibleGrid: U }), (ae, Z) => (c(), K(yv, {
      id: e.id,
      ref_key: "panelComponent",
      ref: ge,
      open: e.open,
      "anchor-el": e.anchorEl,
      "additional-anchor-els": e.additionalAnchorEls,
      "dialog-label": e.dialogLabel,
      "test-id": "datepicker-dropdown-menu",
      "width-class": "w-[292px]",
      placement: e.placement,
      "keep-anchor-focusable": e.keepAnchorFocusable,
      "onUpdate:open": Z[2] || (Z[2] = (ie) => l("update:open", ie)),
      onClose: Z[3] || (Z[3] = (ie) => l("close"))
    }, _n({
      default: ve(() => [
        v("div", {
          ref_key: "contentRef",
          ref: oe,
          class: "contents"
        }, [
          te(d3, {
            label: Y.value,
            "previous-label": e.previousLabel,
            "next-label": e.nextLabel,
            "label-disabled": _.value,
            "previous-disabled": j.value,
            "next-disabled": M.value,
            onPrev: F,
            onNext: X,
            onDrillUp: H
          }, null, 8, ["label", "previous-label", "next-label", "label-disabled", "previous-disabled", "next-disabled"]),
          h.value === "day" ? (c(), g("div", h3, [
            v("div", {
              role: "grid",
              class: "flex flex-col gap-0.5",
              onKeydown: ue
            }, [
              v("div", b3, [
                (c(!0), g(se, null, Me(e.weekdayLabels, (ie, fe) => (c(), g("span", {
                  key: fe,
                  role: "columnheader",
                  "data-testid": "datepicker-weekday-header",
                  class: "w-9 flex-1 text-center text-(length:--size-sm) font-(--weight-medium) text-(--text-text-body-subtle) dark:text-(--colors-text-white-secondary)"
                }, P(ie), 1))), 128))
              ]),
              (c(!0), g(se, null, Me($.value, (ie, fe) => (c(), g("div", {
                key: fe,
                role: "row",
                "data-testid": "datepicker-day-row",
                class: "flex items-center"
              }, [
                (c(!0), g(se, null, Me(ie, ({ cell: de, index: ne }) => (c(), K(Er, {
                  key: de.iso,
                  type: "Day",
                  state: R(de),
                  text: de.label,
                  muted: !de.inMonth,
                  role: "gridcell",
                  tabindex: ne === ke.value ? 0 : -1,
                  "aria-selected": I(z).has(de.state) ? "true" : void 0,
                  "aria-label": D(de),
                  onClick: (le) => be(de),
                  onMouseover: (le) => A.value = de.iso,
                  onMouseout: Z[0] || (Z[0] = (le) => A.value = null)
                }, null, 8, ["state", "text", "muted", "tabindex", "aria-selected", "aria-label", "onClick", "onMouseover"]))), 128))
              ]))), 128))
            ], 32)
          ])) : (c(), g("div", {
            key: 1,
            role: "grid",
            class: "flex w-[252px] flex-col gap-1.5",
            onKeydown: ue
          }, [
            (c(!0), g(se, null, Me(L.value, (ie, fe) => (c(), g("div", {
              key: fe,
              role: "row",
              "data-testid": "datepicker-grid-row",
              class: "flex gap-1.5"
            }, [
              (c(!0), g(se, null, Me(ie, ({ cell: de, index: ne }) => (c(), K(Er, {
                key: de.iso,
                type: h.value === "month" ? "Month" : "Year",
                state: R(de),
                text: de.label,
                role: "gridcell",
                tabindex: ne === ke.value ? 0 : -1,
                "aria-selected": I(z).has(de.state) ? "true" : void 0,
                "aria-label": h.value === "month" ? V(de) : de.state === "Disabled" ? `${de.label}, ${e.unavailableLabel}` : de.label,
                onClick: (le) => be(de),
                onMouseover: (le) => A.value = de.iso,
                onMouseout: Z[1] || (Z[1] = (le) => A.value = null)
              }, null, 8, ["type", "state", "text", "tabindex", "aria-selected", "aria-label", "onClick", "onMouseover"]))), 128))
            ]))), 128))
          ], 32))
        ], 512)
      ]),
      _: 2
    }, [
      e.showClearButton || e.showTodayButton ? {
        name: "actions",
        fn: ve(() => [
          e.showClearButton ? (c(), K(Re, {
            key: 0,
            variant: "secondary",
            size: "sm",
            class: "flex-1",
            "full-width": "",
            label: e.clearLabel,
            "data-testid": "datepicker-dropdown-menu-clear",
            onClick: q
          }, null, 8, ["label"])) : k("", !0),
          e.showTodayButton ? (c(), K(Re, {
            key: 1,
            variant: "primary",
            size: "sm",
            class: "flex-1",
            "full-width": "",
            label: e.todayLabel,
            disabled: W.value,
            "data-testid": "datepicker-dropdown-menu-today",
            onClick: N
          }, null, 8, ["label", "disabled"])) : k("", !0)
        ]),
        key: "0"
      } : void 0
    ]), 1032, ["id", "open", "anchor-el", "additional-anchor-els", "dialog-label", "placement", "keep-anchor-focusable"]));
  }
}), g3 = {
  en: "mm/yyyy",
  fr: "mm/yyyy",
  nl: "mm-yyyy"
};
function p3(e) {
  return e ?? "";
}
function m3(e) {
  return /^\d{4}$/.test(e) ? e : void 0;
}
function kv(e) {
  return e.replace(/[my]/g, "");
}
function v3(e, n) {
  if (!e) return "";
  const [t, a] = e.split("-");
  return `${a}${kv(n)}${t}`;
}
function x3(e, n) {
  const t = kv(n), [a, l] = e.split(t);
  if (!a || !l || !/^\d{2}$/.test(a) || !/^\d{4}$/.test(l)) return;
  const r = Number(a);
  if (!(r < 1 || r > 12))
    return `${l}-${a}`;
}
function fn(e, n) {
  if (!e) return "";
  const [t, a, l] = e.split("-");
  return !t || !a || !l ? "" : n.replace(/y+/, t).replace(/m+/, a).replace(/d+/, l);
}
function y3(e) {
  const n = e.match(/([dmy])\1*|[^dmy]+/g) ?? [], t = [];
  let a = "^";
  for (const r of n)
    /^[dmy]+$/.test(r) ? (t.push({ field: r[0], length: r.length }), a += r.length > 1 ? `(\\d{${r.length}})` : "(\\d{1,2})") : a += r.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  a += "$";
  const l = t.map((r) => r.field);
  if (l.filter((r) => r === "d").length === 1 && l.filter((r) => r === "m").length === 1 && l.filter((r) => r === "y").length === 1)
    return { tokens: t, regex: new RegExp(a) };
}
function Pt(e, n) {
  const t = y3(n);
  if (!t) return;
  const a = t.regex.exec(e);
  if (!a) return;
  let l, r, o;
  if (t.tokens.forEach((s, d) => {
    const u = Number(a[d + 1]);
    s.field === "d" ? l = u : s.field === "m" ? r = u : o = u;
  }), l === void 0 || r === void 0 || o === void 0 || r < 1 || r > 12) return;
  const i = new Date(o, r, 0).getDate();
  if (!(l < 1 || l > i))
    return `${String(o).padStart(4, "0")}-${String(r).padStart(2, "0")}-${String(l).padStart(2, "0")}`;
}
function cu(e) {
  const { inputRef: n, format: t, maskEnabled: a, disabled: l, readonly: r, onAccept: o, resolveRevertValue: i, resolveResyncValue: s } = e;
  let d = null, u = null, f = 0, b = !1;
  const h = E(!1), m = E(!1), x = E(!1), y = E(e.initialDisplayValue), w = p(() => a.value ? gv(t.value) : null), S = () => {
    if (!u || !n.value || w.value === null) return;
    $();
    const M = y.value || n.value.value;
    d = u(n.value, { mask: w.value, lazy: !0 }), d.value = M ?? "", x.value = !0, d.on("accept", () => {
      if (!d) return;
      const W = b;
      if (b = !1, r.value || l.value) {
        const B = i();
        d.value = B, y.value = B;
        return;
      }
      const G = d.value;
      y.value = G, !W && o(G);
    });
  }, $ = () => {
    d == null || d.destroy(), d = null, x.value = !1;
  };
  ot(async () => {
    if (n.value && w.value !== null) {
      const M = ++f;
      if (u = (await import("./index-CZ98n4Cf.js")).default, !n.value || M !== f) return;
      S();
    }
  }), kt(() => {
    $();
  }), Ie(w, async (M) => {
    const W = ++f;
    $(), M !== null && (u || (u = (await import("./index-CZ98n4Cf.js")).default), W === f && S());
  });
  const T = () => {
    l.value || (m.value = !0);
  }, L = () => {
    m.value = !1;
  }, A = () => {
    l.value || (h.value = !0);
  }, R = (M) => {
    y.value = M, d && (b = !0, d.value = M, b = !1);
  }, z = () => {
    h.value = !1, R(s());
  }, D = (M) => {
    if (d) return;
    const W = M.target.value;
    y.value = W, o(W);
  }, V = (M) => {
    d ? d.value = M : (y.value = M, o(M));
  };
  let Y = !1;
  return {
    displayValue: y,
    isFocused: h,
    isHovered: m,
    datePattern: w,
    isMaskAttached: x,
    handleMouseEnter: T,
    handleMouseLeave: L,
    handleFocus: A,
    handleBlur: z,
    handleInput: D,
    setValue: V,
    syncDisplayValue: R,
    armMouseDown: (M) => {
      Y = M;
    },
    consumeClick: () => {
      const M = Y;
      return Y = !1, M;
    }
  };
}
const wv = {
  weekdayLabels: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
  monthLabels: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ],
  monthShortLabels: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
  clearLabel: "Clear",
  todayLabel: "Today",
  previousLabel: "Previous month",
  nextLabel: "Next month",
  unavailableLabel: "Unavailable",
  dialogLabel: "Choose date",
  rangeStartLabel: "start of selected range",
  rangeEndLabel: "end of selected range",
  rangeBetweenLabel: "in selected range",
  rangeDialogLabel: "Choose date range",
  clearStartLabel: "Clear start date",
  clearEndLabel: "Clear end date"
}, Cv = {
  fr: {
    weekdayLabels: ["lun.", "mar.", "mer.", "jeu.", "ven.", "sam.", "dim."],
    monthLabels: [
      "janvier",
      "février",
      "mars",
      "avril",
      "mai",
      "juin",
      "juillet",
      "août",
      "septembre",
      "octobre",
      "novembre",
      "décembre"
    ],
    monthShortLabels: [
      "janv.",
      "févr.",
      "mars",
      "avril",
      "mai",
      "juin",
      "juil.",
      "août",
      "sept.",
      "oct.",
      "nov.",
      "déc."
    ],
    clearLabel: "Effacer",
    todayLabel: "Aujourd'hui",
    previousLabel: "Mois précédent",
    nextLabel: "Mois suivant",
    unavailableLabel: "Indisponible",
    dialogLabel: "Choisir une date",
    rangeStartLabel: "début de la période sélectionnée",
    rangeEndLabel: "fin de la période sélectionnée",
    rangeBetweenLabel: "dans la période sélectionnée",
    rangeDialogLabel: "Choisir une période",
    clearStartLabel: "Effacer la date de début",
    clearEndLabel: "Effacer la date de fin"
  },
  nl: {
    weekdayLabels: ["ma", "di", "wo", "do", "vr", "za", "zo"],
    monthLabels: [
      "januari",
      "februari",
      "maart",
      "april",
      "mei",
      "juni",
      "juli",
      "augustus",
      "september",
      "oktober",
      "november",
      "december"
    ],
    monthShortLabels: ["jan", "feb", "mrt", "apr", "mei", "jun", "jul", "aug", "sep", "okt", "nov", "dec"],
    clearLabel: "Wissen",
    todayLabel: "Vandaag",
    previousLabel: "Vorige maand",
    nextLabel: "Volgende maand",
    unavailableLabel: "Niet beschikbaar",
    dialogLabel: "Kies een datum",
    rangeStartLabel: "begin van de geselecteerde periode",
    rangeEndLabel: "einde van de geselecteerde periode",
    rangeBetweenLabel: "in de geselecteerde periode",
    rangeDialogLabel: "Kies een periode",
    clearStartLabel: "Startdatum wissen",
    clearEndLabel: "Einddatum wissen"
  }
}, k3 = ["id", "name", "inputmode", "value", "placeholder", "disabled", "readonly", "autocomplete", "aria-labelledby", "aria-label", "aria-disabled", "aria-invalid", "aria-describedby", "aria-required", "aria-expanded", "aria-controls", "data-testid"], fu = /* @__PURE__ */ ye({
  __name: "DatePickerInput",
  props: {
    modelValue: { default: "" },
    label: { default: void 0 },
    ariaLabel: { default: void 0 },
    required: { type: Boolean, default: !1 },
    requiredIndicator: { default: "*" },
    labelTooltip: { default: void 0 },
    placeholder: { default: void 0 },
    format: { default: void 0 },
    minDate: { default: void 0 },
    maxDate: { default: void 0 },
    autohide: { type: Boolean, default: !0 },
    buttons: { type: Boolean, default: !0 },
    orientation: { default: "auto" },
    weekStart: { default: 1 },
    language: { default: "en" },
    title: { default: void 0 },
    disabled: { type: Boolean, default: !1 },
    size: { default: "md" },
    fullWidth: { type: Boolean, default: !1 },
    width: { default: "384px" },
    error: { default: void 0 },
    errorLive: { type: Boolean, default: !0 },
    hint: { default: void 0 },
    showHint: { type: Boolean, default: !0 },
    labelInline: { type: Boolean, default: !1 },
    id: { default: void 0 },
    name: { default: void 0 },
    autocomplete: { default: void 0 },
    testId: { default: void 0 },
    maskInput: { type: Boolean, default: !0 },
    readonly: { type: Boolean, default: !1 },
    type: { default: "default" },
    dobLabels: { default: void 0 },
    dobDefaultDate: { default: void 0 },
    labels: { default: void 0 }
  },
  emits: ["update:modelValue", "changeDate", "show", "hide"],
  setup(e, { emit: n }) {
    var xe;
    const t = e, a = n, l = E(null), r = E(null), o = E(null), i = p(() => t.modelValue !== void 0 && t.modelValue !== null && t.modelValue.trim() !== ""), s = p(() => !!t.error), d = Ve(), u = p(() => t.id || d), f = p(() => t.label ? `${u.value}-label` : void 0), b = p(() => `${u.value}-error`), h = p(() => `${u.value}-hint`), m = p(() => t.language.slice(0, 2).toLowerCase()), x = {
      en: "mm/dd/yyyy",
      fr: "dd/mm/yyyy",
      nl: "dd-mm-yyyy"
    }, y = p(() => t.format !== void 0 ? t.format : x[m.value] ?? "dd/mm/yyyy"), w = p(
      () => t.labels ?? Cv[m.value] ?? wv
    ), S = p(
      () => t.minDate ? Pt(t.minDate, y.value) ?? t.minDate : void 0
    ), $ = p(
      () => t.maxDate ? Pt(t.maxDate, y.value) ?? t.maxDate : void 0
    ), T = {
      fr: { d: "j", y: "a" },
      // jour / année
      nl: { y: "j" }
      // jaar
    }, L = p(() => {
      const we = T[m.value];
      return we ? y.value.replace(/d+|m+|y+/g, (he) => {
        const De = we[he[0]];
        return De ? De.repeat(he.length) : he;
      }) : y.value;
    }), A = p(() => {
      var he;
      const we = (he = t.hint) == null ? void 0 : he.trim();
      return we && we.length > 0 ? we : s.value ? void 0 : L.value;
    }), R = p(() => {
      var he;
      const we = (he = t.placeholder) == null ? void 0 : he.trim();
      return we && we.length > 0 ? we : L.value;
    }), z = p(() => {
      const we = [];
      return t.showHint && A.value && we.push(h.value), s.value && we.push(b.value), we.length > 0 ? we.join(" ") : void 0;
    }), D = p(() => s.value ? "true" : void 0), V = p(() => {
      const we = "relative rounded-xl border-solid box-border flex items-center text-left font-inter";
      if (t.disabled)
        return `${we} border-[1px] shadow-[0px_1px_0.5px_0.05px_rgba(29,_41,_61,_0.02)] dark:shadow-[0px_0px_4px_rgba(255,255,255,0.1)] bg-gainsboro-200 dark:bg-(--colors-background-disabled) border-border-disabled-subtle dark:border-(--colors-border-disabled-subtle) text-text-disabled dark:text-(--colors-text-disabled)`;
      if (t.readonly) {
        const Ee = F.isFocused.value ? "shadow-[0px_0px_2px_var(--border-border-accent)] border-(--border-border-accent)" : "shadow-[0px_1px_0.5px_0.05px_rgba(29,_41,_61,_0.02)] dark:shadow-[0px_0px_4px_rgba(255,255,255,0.1)] border-(--border-border-base-soft) dark:border-(--border-border-base)";
        return `${we} border-[1px] ${Ee} bg-(--colors-background-white-secondary-soft) dark:bg-(--colors-background-disabled) text-(--text-text-black-default) dark:text-(--text-text-white-default) cursor-default`;
      }
      if (s.value)
        return `${we} border-[1px] shadow-[0px_1px_0.5px_0.05px_rgba(29,_41,_61,_0.02)] dark:shadow-[0px_0px_4px_rgba(255,255,255,0.1)] bg-(--background-background-white) dark:bg-(--background-background-black-default) border-(--border-border-error-strong) dark:border-(--border-border-error) text-(--text-text-black-default) dark:text-(--text-text-white-default)`;
      if (F.isFocused.value)
        return `${we} border-[1px] shadow-[0px_0px_2px_var(--border-border-accent)] bg-(--background-background-selected) dark:bg-[rgba(255,255,255,0.05)] border-(--border-border-accent) text-(--text-text-black-default) dark:text-(--text-text-white-default)`;
      if (F.isHovered.value)
        return `${we} border-[1px] bg-(--background-background-white) dark:bg-(--background-background-black-default) border-(--border-border-accent) text-(--text-text-black-default) dark:text-(--text-text-white-default)`;
      const he = i.value ? "text-(--text-text-black-default)" : "text-(--text-text-body-subtle)";
      return `${we} border-[1px] shadow-[0px_1px_0.5px_0.05px_rgba(29,_41,_61,_0.02)] dark:shadow-[0px_0px_4px_rgba(255,255,255,0.1)] bg-(--background-background-white) dark:bg-(--background-background-black-default) border-(--border-border-base-medium) dark:border-(--border-border-base) ${he} dark:text-(--text-text-white-default)`;
    }), _ = {
      sm: {
        container: "h-[32px] px-2 py-1.5 gap-2",
        text: "text-sm leading-5"
      },
      md: {
        container: "h-[36px] px-3 py-2 gap-2",
        text: "text-sm leading-5"
      },
      lg: {
        container: "h-[48px] px-3.5 py-3 gap-2",
        text: "text-base leading-6"
      },
      xl: {
        container: "h-[52px] px-4 py-3.5 gap-2",
        text: "text-base leading-6"
      }
    }[t.size], j = p(() => t.fullWidth ? "w-full" : ""), M = p(() => t.fullWidth ? {} : { width: t.width }), W = p(() => {
      const we = "relative flex pb-0.5 text-left text-sm text-text-black-default dark:text-(--colors-text-white-default) font-inter";
      return t.labelInline ? `${we} flex-row items-center gap-2${t.fullWidth ? " w-full" : ""}` : `${we} flex-col items-start gap-0.5${t.fullWidth ? " w-full" : ""}`;
    }), G = p(() => t.fullWidth || t.labelInline ? {} : { width: t.width });
    function B(we) {
      if (we === "") {
        t.modelValue && a("update:modelValue", "");
        return;
      }
      const he = Pt(we, y.value);
      he !== void 0 && he !== t.modelValue && a("update:modelValue", he);
    }
    const F = cu({
      inputRef: l,
      format: y,
      maskEnabled: p(() => t.maskInput),
      disabled: qn(t, "disabled"),
      readonly: qn(t, "readonly"),
      initialDisplayValue: t.type === "dob" ? fn(t.modelValue, y.value) : t.modelValue,
      onAccept: (we) => {
        if (t.type === "dob") {
          B(we);
          return;
        }
        (!F.isMaskAttached.value || we === "" || Pt(we, y.value) !== void 0) && we !== t.modelValue && a("update:modelValue", we);
      },
      resolveRevertValue: () => t.type === "dob" ? fn(t.modelValue, y.value) : t.modelValue ?? "",
      resolveResyncValue: () => t.type === "dob" ? fn(t.modelValue, y.value) : t.modelValue
    });
    Ie(
      () => t.modelValue,
      (we) => {
        if (F.isFocused.value) return;
        const he = t.type === "dob" ? fn(we, y.value) : we;
        F.syncDisplayValue(he);
      }
    ), Ie([y, m], ([we], [he]) => {
      if (t.type === "dob" && !F.isFocused.value && F.syncDisplayValue(fn(t.modelValue, we)), t.type === "default" && !F.isFocused.value && we !== he) {
        const De = Pt(F.displayValue.value, he);
        De !== void 0 && F.syncDisplayValue(fn(De, we));
      }
    });
    const X = E(!1), H = E(!1), q = p(() => `${u.value}-dob-dialog`), N = E(null), J = typeof process < "u" && ((xe = process.env) == null ? void 0 : xe.NODE_ENV) !== "production";
    function be() {
      if (!(t.type !== "dob" || t.disabled || t.readonly) && !X.value) {
        if (!t.dobLabels) {
          J && console.error(
            '[OPAL DatePickerInput] type="dob" requires the `dobLabels` prop (see DatepickerDobLabels) — the wheel picker was not opened.'
          );
          return;
        }
        X.value = !0, H.value = !0, a("show");
      }
    }
    function ke(we) {
      F.setValue(fn(we, y.value)), a("changeDate", we);
    }
    function ee() {
      F.setValue(""), a("changeDate", "");
    }
    function oe() {
      var we;
      X.value = !1, a("hide"), (we = l.value) == null || we.focus();
    }
    const ge = E(!1), re = E(!1), ue = p(() => `${u.value}-default-dialog`), O = E(null), U = E(!0), Q = p(
      () => Pt(F.displayValue.value, y.value) ?? ""
    ), ae = p(() => {
      const we = t.orientation.includes("right") ? "end" : "start";
      return `${t.orientation.includes("top") ? "top" : "bottom"}-${we}`;
    });
    function Z() {
      t.type !== "default" || t.disabled || t.readonly || ge.value || (ge.value = !0, re.value = !0, a("show"));
    }
    function ie(we) {
      const he = fn(we, y.value);
      F.setValue(he), a("changeDate", he);
    }
    function fe() {
      F.setValue(""), a("changeDate", "");
    }
    function de() {
      var we;
      ge.value = !1, a("hide"), (we = l.value) == null || we.focus();
    }
    function ne() {
      t.type === "dob" ? be() : Z();
    }
    function le() {
      F.armMouseDown(t.type === "dob" ? X.value : ge.value);
    }
    function Le() {
      var we;
      t.disabled || t.readonly || F.consumeClick() || (U.value = !1, ne(), (we = l.value) == null || we.focus());
    }
    function Te(we) {
      var he, De, Ee, je;
      if (!X.value && !ge.value && ((he = r.value) == null || he.handleFieldKeydown(we), (De = o.value) == null || De.handleFieldKeydown(we)), !(t.disabled || t.readonly)) {
        if (we.key === "Enter") {
          X.value ? oe() : ge.value && de();
          const Ge = Yo(), Qe = (S.value === void 0 || kn(Ge, S.value) >= 0) && ($.value === void 0 || kn(Ge, $.value) <= 0);
          (F.displayValue.value ?? "").trim() === "" && Qe && (t.type === "dob" ? ke(Ge) : ie(Ge));
          return;
        }
        if (we.key === "ArrowDown") {
          if (we.preventDefault(), X.value) {
            (Ee = N.value) == null || Ee.focusYearColumn();
            return;
          }
          if (ge.value) {
            (je = O.value) == null || je.focusGrid();
            return;
          }
          U.value = !0, ne();
        }
      }
    }
    return (we, he) => (c(), g("div", {
      class: C(W.value),
      style: Ne(G.value),
      "data-testid": "date-picker-wrapper"
    }, [
      e.label ? (c(), K(xt, {
        key: 0,
        id: f.value,
        ref_key: "labelRef",
        ref: r,
        text: e.label,
        "input-id": u.value,
        required: e.required,
        "required-indicator": e.requiredIndicator,
        tooltip: e.labelTooltip,
        focused: I(F).isFocused.value,
        inline: e.labelInline,
        class: C(e.labelInline ? "" : "order-1"),
        "test-id": "date-picker-label"
      }, null, 8, ["id", "text", "input-id", "required", "required-indicator", "tooltip", "focused", "inline", "class"])) : k("", !0),
      v("div", {
        class: C(e.labelInline ? "flex flex-col gap-0.5" : "contents")
      }, [
        te(vt, {
          ref_key: "helperRef",
          ref: o,
          focused: I(F).isFocused.value,
          class: "order-3",
          hint: e.showHint ? A.value : void 0,
          error: e.error,
          "hint-id": h.value,
          "error-id": b.value,
          "error-live": e.errorLive,
          "test-id-prefix": "date-picker"
        }, null, 8, ["focused", "hint", "error", "hint-id", "error-id", "error-live"]),
        v("div", {
          class: C([V.value, I(_).container, j.value, "order-2"]),
          style: Ne(M.value),
          "data-testid": "date-picker-container",
          onMouseenter: he[3] || (he[3] = //@ts-ignore
          (...De) => I(F).handleMouseEnter && I(F).handleMouseEnter(...De)),
          onMouseleave: he[4] || (he[4] = //@ts-ignore
          (...De) => I(F).handleMouseLeave && I(F).handleMouseLeave(...De)),
          onMousedown: le,
          onClick: Le
        }, [
          v("i", {
            "aria-hidden": "true",
            "data-testid": "date-picker-calendar-icon",
            class: C([
              "ri-calendar-line",
              I(_).text,
              e.disabled ? "text-text-disabled dark:text-(--text-text-disabled-light)" : "text-(--icons-icon-dark-default) dark:text-(--icons-icon-white-default)"
            ])
          }, null, 2),
          v("input", {
            id: u.value,
            ref_key: "inputRef",
            ref: l,
            name: e.name,
            type: "text",
            inputmode: I(F).datePattern.value ? "numeric" : void 0,
            value: I(F).displayValue.value,
            placeholder: R.value,
            disabled: e.disabled,
            readonly: e.readonly,
            autocomplete: e.autocomplete ?? "off",
            "aria-labelledby": f.value,
            "aria-label": e.label ? void 0 : e.ariaLabel,
            "aria-disabled": e.disabled ? "true" : void 0,
            "aria-invalid": D.value,
            "aria-describedby": z.value,
            "aria-required": e.required ? "true" : void 0,
            role: "combobox",
            "aria-haspopup": "dialog",
            "aria-expanded": e.type === "dob" ? X.value : ge.value,
            "aria-controls": e.type === "dob" ? H.value ? q.value : void 0 : re.value ? ue.value : void 0,
            "data-testid": e.testId ?? "date-picker-input",
            class: C([
              "flex-1 min-w-0 relative bg-transparent border-0 outline-none focus:outline-none focus:ring-0 focus:border-0 forced-colors:focus-visible:outline forced-colors:focus-visible:outline-2 forced-colors:focus-visible:outline-offset-2 placeholder:text-text-body-subtle dark:placeholder:text-(--colors-text-white-secondary) pl-0",
              !e.disabled && !e.readonly && "cursor-text",
              I(_).text
            ]),
            onFocus: he[0] || (he[0] = //@ts-ignore
            (...De) => I(F).handleFocus && I(F).handleFocus(...De)),
            onBlur: he[1] || (he[1] = //@ts-ignore
            (...De) => I(F).handleBlur && I(F).handleBlur(...De)),
            onInput: he[2] || (he[2] = //@ts-ignore
            (...De) => I(F).handleInput && I(F).handleInput(...De)),
            onKeydown: Te
          }, null, 42, k3)
        ], 38)
      ], 2),
      e.type === "dob" && l.value && H.value ? (c(), K(o3, Oe({ key: 1 }, e.dobLabels, {
        id: q.value,
        ref_key: "dobPickerRef",
        ref: N,
        open: X.value,
        "model-value": e.modelValue,
        "anchor-el": l.value,
        "auto-focus-on-open": U.value,
        "min-date": S.value,
        "max-date": $.value,
        "default-date": e.dobDefaultDate,
        "onUpdate:open": he[5] || (he[5] = (De) => X.value = De),
        "onUpdate:modelValue": ke,
        onClear: ee,
        onClose: oe
      }), null, 16, ["id", "open", "model-value", "anchor-el", "auto-focus-on-open", "min-date", "max-date", "default-date"])) : k("", !0),
      e.type === "default" && l.value && re.value ? (c(), K(Mc, {
        key: 2,
        id: ue.value,
        ref_key: "defaultDropdownMenuRef",
        ref: O,
        open: ge.value,
        "model-value": Q.value,
        "anchor-el": l.value,
        "keep-anchor-focusable": "",
        "auto-focus-on-open": U.value,
        "min-date": S.value,
        "max-date": $.value,
        "today-button-mode": "select",
        "show-today-button": e.buttons,
        "show-clear-button": e.buttons,
        placement: ae.value,
        "weekday-labels": w.value.weekdayLabels,
        "month-labels": w.value.monthLabels,
        "month-short-labels": w.value.monthShortLabels,
        "clear-label": w.value.clearLabel,
        "today-label": w.value.todayLabel,
        "previous-label": w.value.previousLabel,
        "next-label": w.value.nextLabel,
        "unavailable-label": w.value.unavailableLabel,
        "dialog-label": w.value.dialogLabel,
        "onUpdate:open": he[6] || (he[6] = (De) => ge.value = De),
        "onUpdate:modelValue": ie,
        onClear: fe,
        onClose: de
      }, null, 8, ["id", "open", "model-value", "anchor-el", "auto-focus-on-open", "min-date", "max-date", "show-today-button", "show-clear-button", "placement", "weekday-labels", "month-labels", "month-short-labels", "clear-label", "today-label", "previous-label", "next-label", "unavailable-label", "dialog-label"])) : k("", !0)
    ], 6));
  }
}), w3 = { class: "relative flex flex-col items-start gap-0.5 text-left text-(length:--size-m) font-inter" }, C3 = ["id", "inputmode", "value", "disabled", "aria-labelledby", "aria-required", "aria-invalid", "aria-describedby", "aria-expanded", "data-testid"], aq = /* @__PURE__ */ ye({
  __name: "YearMonthPickerInput",
  props: {
    type: {},
    modelValue: { default: "" },
    label: { default: void 0 },
    required: { type: Boolean, default: !1 },
    requiredIndicator: { default: "*" },
    labelTooltip: { default: void 0 },
    hint: { default: void 0 },
    error: { default: void 0 },
    errorLive: { type: Boolean, default: !0 },
    minDate: { default: void 0 },
    maxDate: { default: void 0 },
    language: { default: "en" },
    disabled: { type: Boolean, default: !1 },
    showTodayButton: { type: Boolean, default: !1 },
    todayButtonMode: { default: "highlight" },
    weekdayLabels: {},
    monthLabels: {},
    monthShortLabels: {},
    clearLabel: {},
    todayLabel: {},
    previousLabel: {},
    nextLabel: {},
    unavailableLabel: {},
    dialogLabel: {},
    testId: { default: void 0 }
  },
  emits: ["update:modelValue", "select"],
  setup(e, { emit: n }) {
    const t = e, a = n, l = p(() => t.language.slice(0, 2).toLowerCase()), r = p(() => g3[l.value] ?? "mm/yyyy"), o = p(() => t.type === "year" ? "yyyy" : r.value), i = p(() => gv(o.value));
    function s(N) {
      return t.type === "year" ? p3(N) : v3(N, r.value);
    }
    function d(N) {
      return t.type === "year" ? m3(N) : x3(N, r.value);
    }
    const u = E(null), f = E(null), b = E(!1), h = E(!1), m = E(null), x = E(null), y = E(s(t.modelValue));
    let w = null, S = null, $ = 0;
    function T() {
      w == null || w.destroy(), w = null;
    }
    function L() {
      !S || !u.value || i.value === null || (T(), w = S(u.value, { mask: i.value, lazy: !0 }), w.value = y.value, w.on("accept", () => {
        if (!w) return;
        const N = w.value;
        if (y.value = N, N === "") {
          t.modelValue !== "" && a("update:modelValue", "");
          return;
        }
        const J = d(N);
        J !== void 0 && J !== t.modelValue && a("update:modelValue", J);
      }));
    }
    ot(async () => {
      if (!u.value || i.value === null) return;
      const N = ++$;
      S = (await import("./index-CZ98n4Cf.js")).default, !(!u.value || N !== $) && L();
    }), kt(() => {
      T();
    }), Ie(
      () => t.modelValue,
      (N) => {
        if (h.value) return;
        const J = s(N);
        y.value = J, w && (w.value = J);
      }
    ), Ie([i], async () => {
      const N = ++$;
      T(), i.value !== null && (S || (S = (await import("./index-CZ98n4Cf.js")).default), N === $ && L());
    });
    function A() {
      t.disabled || (h.value = !0);
    }
    function R() {
      h.value = !1;
      const N = s(t.modelValue);
      y.value = N, w && (w.value = N);
    }
    function z(N) {
      if (w) return;
      const J = N.target.value;
      y.value = J;
      const be = d(J);
      be !== void 0 && a("update:modelValue", be);
    }
    function D() {
      t.disabled || (b.value = !0);
    }
    function V(N) {
      var J, be;
      b.value || ((J = m.value) == null || J.handleFieldKeydown(N), (be = x.value) == null || be.handleFieldKeydown(N)), !(N.key !== "Enter" && N.key !== " " && N.key !== "ArrowDown") && (N.preventDefault(), D());
    }
    function Y(N) {
      a("select", N);
    }
    function _() {
      var N;
      (N = u.value) == null || N.focus();
    }
    const M = Ve(), W = p(() => t.label ? `${M}-label` : void 0), G = `${M}-dialog`, B = `${M}-hint`, F = `${M}-error`, X = p(() => {
      const N = [];
      return t.hint && N.push(B), t.error && N.push(F), N.length > 0 ? N.join(" ") : void 0;
    }), H = p(() => t.disabled ? "border-border-disabled-subtle bg-gainsboro-200 dark:border-(--colors-border-disabled-subtle) dark:bg-(--colors-background-disabled)" : t.error ? "border-(--border-border-error-strong) bg-(--background-background-white) dark:border-(--border-border-error) dark:bg-(--background-background-black-default)" : "border-(--border-border-base-medium) bg-(--background-background-white) dark:border-(--border-border-base) dark:bg-(--background-background-black-default)"), q = p(
      () => t.disabled ? "text-text-disabled dark:text-(--text-text-disabled-light)" : "text-(--icons-icon-dark-default) dark:text-(--icons-icon-white-default)"
    );
    return (N, J) => (c(), g("div", w3, [
      e.label ? (c(), K(xt, {
        key: 0,
        id: W.value,
        ref_key: "labelRef",
        ref: m,
        text: e.label,
        "input-id": I(M),
        required: e.required,
        "required-indicator": e.requiredIndicator,
        tooltip: e.labelTooltip,
        focused: h.value,
        "test-id": "year-month-picker-label"
      }, null, 8, ["id", "text", "input-id", "required", "required-indicator", "tooltip", "focused"])) : k("", !0),
      v("div", {
        ref_key: "triggerRef",
        ref: f,
        class: C([
          "relative flex h-[36px] items-center gap-2 rounded-xl border-[1px] border-solid px-3 py-2",
          H.value
        ])
      }, [
        v("i", {
          "aria-hidden": "true",
          class: C(["ri-calendar-line text-sm", q.value])
        }, null, 2),
        v("input", {
          id: I(M),
          ref_key: "inputRef",
          ref: u,
          type: "text",
          inputmode: i.value ? "numeric" : void 0,
          value: y.value,
          disabled: e.disabled,
          "aria-labelledby": W.value,
          "aria-required": e.required ? "true" : void 0,
          "aria-invalid": e.error ? "true" : void 0,
          "aria-describedby": X.value,
          "aria-haspopup": "dialog",
          "aria-expanded": b.value,
          "aria-controls": G,
          "data-testid": e.testId ?? "year-month-picker-input",
          class: "min-w-0 flex-1 border-0 bg-transparent text-(length:--size-m) leading-(--line-height-l) outline-none placeholder:text-text-body-subtle focus:outline-none focus:ring-0",
          onFocus: A,
          onBlur: R,
          onInput: z,
          onClick: D,
          onKeydown: V
        }, null, 40, C3)
      ], 2),
      te(vt, {
        ref_key: "helperRef",
        ref: x,
        class: "self-stretch",
        focused: h.value,
        hint: e.hint,
        error: e.error,
        "hint-id": B,
        "error-id": F,
        "error-live": e.errorLive,
        "test-id-prefix": "year-month-picker"
      }, null, 8, ["focused", "hint", "error", "error-live"]),
      f.value ? (c(), K(Mc, {
        key: 1,
        id: G,
        open: b.value,
        "onUpdate:open": J[0] || (J[0] = (be) => b.value = be),
        "model-value": e.modelValue,
        "anchor-el": f.value,
        mode: e.type,
        "min-date": e.minDate,
        "max-date": e.maxDate,
        "show-today-button": e.showTodayButton,
        "today-button-mode": e.todayButtonMode,
        "weekday-labels": e.weekdayLabels,
        "month-labels": e.monthLabels,
        "month-short-labels": e.monthShortLabels,
        "clear-label": e.clearLabel,
        "today-label": e.todayLabel,
        "previous-label": e.previousLabel,
        "next-label": e.nextLabel,
        "unavailable-label": e.unavailableLabel,
        "dialog-label": e.dialogLabel,
        "onUpdate:modelValue": J[1] || (J[1] = (be) => a("update:modelValue", be)),
        onSelect: Y,
        onClear: J[2] || (J[2] = (be) => a("update:modelValue", "")),
        onClose: _
      }, null, 8, ["open", "model-value", "anchor-el", "mode", "min-date", "max-date", "show-today-button", "today-button-mode", "weekday-labels", "month-labels", "month-short-labels", "clear-label", "today-label", "previous-label", "next-label", "unavailable-label", "dialog-label"])) : k("", !0)
    ]));
  }
}), S3 = {
  class: "flex flex-col gap-0.5 pb-0.5",
  "data-testid": "date-range-wrapper"
}, $3 = ["id", "value", "placeholder", "disabled", "readonly", "inputmode", "aria-expanded", "aria-controls", "aria-labelledby", "aria-label", "aria-required", "aria-invalid", "aria-describedby"], I3 = ["aria-label"], T3 = ["id", "value", "placeholder", "disabled", "readonly", "inputmode", "aria-expanded", "aria-controls", "aria-labelledby", "aria-label", "aria-required", "aria-invalid", "aria-describedby"], L3 = ["aria-label"], E3 = /* @__PURE__ */ ye({
  __name: "DateRangePickerInput",
  props: {
    startDate: { default: "" },
    endDate: { default: "" },
    startLabel: { default: "From" },
    endLabel: { default: "To" },
    startPlaceholder: { default: "Select date start" },
    endPlaceholder: { default: "Select date end" },
    required: { type: Boolean, default: !1 },
    requiredIndicator: { default: "*" },
    labelTooltip: { default: void 0 },
    format: { default: void 0 },
    minDate: { default: void 0 },
    maxDate: { default: void 0 },
    buttons: { type: Boolean, default: !0 },
    weekStart: { default: 1 },
    language: { default: "en" },
    disabled: { type: Boolean, default: !1 },
    size: { default: "md" },
    fullWidth: { type: Boolean, default: !1 },
    error: { default: void 0 },
    hint: { default: void 0 },
    readonly: { type: Boolean, default: !0 },
    labels: { default: void 0 }
  },
  emits: ["update:startDate", "update:endDate", "changeDate"],
  setup(e, { emit: n }) {
    const t = e, a = n, l = E(null), r = E(null), o = Ve(), i = p(() => t.language.slice(0, 2).toLowerCase()), s = {
      en: "mm/dd/yyyy",
      fr: "dd/mm/yyyy",
      nl: "dd-mm-yyyy"
    }, d = p(() => t.format !== void 0 ? t.format : s[i.value] ?? "mm/dd/yyyy"), u = p(
      () => t.labels ?? Cv[i.value] ?? wv
    ), f = p(() => !!t.error), b = Ve(), h = p(() => `${b}-start-input`), m = p(() => `${b}-end-input`), x = p(() => t.startLabel ? `${b}-start-label` : void 0), y = p(() => t.endLabel ? `${b}-end-label` : void 0), w = p(() => `${b}-hint`), S = E(null), $ = E(null), T = E(null), L = p(() => `${b}-error`), A = p(() => {
      const xe = [];
      return t.hint && xe.push(w.value), f.value && xe.push(L.value), xe.length > 0 ? xe.join(" ") : void 0;
    }), R = E(!1), z = E(null), D = E(null), V = E("start"), Y = E("start"), _ = E(!1), j = E(!0), M = cu({
      inputRef: l,
      format: d,
      maskEnabled: p(() => !t.readonly),
      disabled: qn(t, "disabled"),
      readonly: qn(t, "readonly"),
      initialDisplayValue: t.startDate,
      onAccept: (xe) => {
        if (xe === "") {
          t.startDate !== "" && (a("update:startDate", ""), a("changeDate", { startDate: "", endDate: W.displayValue.value }));
          return;
        }
        Pt(xe, d.value) !== void 0 && xe !== t.startDate && (a("update:startDate", xe), a("changeDate", { startDate: xe, endDate: W.displayValue.value }));
      },
      resolveRevertValue: () => t.startDate,
      resolveResyncValue: () => t.startDate
    }), W = cu({
      inputRef: r,
      format: d,
      maskEnabled: p(() => !t.readonly),
      disabled: qn(t, "disabled"),
      readonly: qn(t, "readonly"),
      initialDisplayValue: t.endDate,
      onAccept: (xe) => {
        if (xe === "") {
          t.endDate !== "" && (a("update:endDate", ""), a("changeDate", { startDate: M.displayValue.value, endDate: "" }));
          return;
        }
        Pt(xe, d.value) !== void 0 && xe !== t.endDate && (a("update:endDate", xe), a("changeDate", { startDate: M.displayValue.value, endDate: xe }));
      },
      resolveRevertValue: () => t.endDate,
      resolveResyncValue: () => t.endDate
    });
    Ie(
      () => t.startDate,
      (xe) => {
        M.isFocused.value || M.syncDisplayValue(xe);
      }
    ), Ie(
      () => t.endDate,
      (xe) => {
        W.isFocused.value || W.syncDisplayValue(xe);
      }
    ), Ie([d], ([xe], [we]) => {
      if (xe !== we) {
        if (!M.isFocused.value) {
          const he = Pt(M.displayValue.value, we);
          he !== void 0 && M.syncDisplayValue(fn(he, xe));
        }
        if (!W.isFocused.value) {
          const he = Pt(W.displayValue.value, we);
          he !== void 0 && W.syncDisplayValue(fn(he, xe));
        }
      }
    });
    const G = (xe, we, he) => {
      const De = "relative rounded-xl border-solid box-border flex items-center text-left font-inter";
      return t.disabled ? `${De} border-[1px] shadow-[0px_1px_0.5px_0.05px_rgba(29,_41,_61,_0.02)] dark:shadow-[0px_0px_4px_rgba(255,255,255,0.1)] bg-gainsboro-200 dark:bg-(--colors-background-disabled) border-border-disabled-subtle dark:border-(--colors-border-disabled-subtle) text-text-disabled dark:text-(--colors-text-disabled)` : f.value ? `${De} border-[1px] shadow-[0px_1px_0.5px_0.05px_rgba(29,_41,_61,_0.02)] dark:shadow-[0px_0px_4px_rgba(255,255,255,0.1)] bg-(--background-background-white) dark:bg-(--background-background-black-default) border-(--border-border-error-strong) dark:border-(--border-border-error) text-(--text-text-black-default) dark:text-(--text-text-white-default)` : xe || we ? `${De} border-[1px] shadow-[0px_0px_2px_var(--border-border-accent)] bg-(--background-background-selected) dark:bg-[rgba(255,255,255,0.05)] border-(--border-border-accent) text-(--text-text-black-default) dark:text-(--text-text-white-default)` : `${De} border-[1px] shadow-[0px_1px_0.5px_0.05px_rgba(29,_41,_61,_0.02)] dark:shadow-[0px_0px_4px_rgba(255,255,255,0.1)] bg-(--background-background-white) dark:bg-(--background-background-black-default) border-(--border-border-base-medium) dark:border-(--border-border-base) ${he ? "text-(--text-text-black-default)" : "text-(--text-text-body-subtle)"} dark:text-(--text-text-white-default)`;
    }, B = p(
      () => G(M.isFocused.value, M.isHovered.value, !!t.startDate)
    ), F = p(
      () => G(W.isFocused.value, W.isHovered.value, !!t.endDate)
    ), H = {
      sm: { container: "h-[32px] px-2 py-1.5 gap-2", text: "text-sm leading-5", icon: "h-4 w-4" },
      md: { container: "h-[36px] px-3 py-2 gap-2", text: "text-sm leading-5", icon: "h-4 w-4" },
      lg: { container: "h-[48px] px-3.5 py-3 gap-2", text: "text-base leading-6", icon: "h-5 w-5" },
      xl: { container: "h-[52px] px-4 py-3.5 gap-2", text: "text-base leading-6", icon: "h-5 w-5" }
    }[t.size], q = p(
      () => t.fullWidth ? "flex flex-col items-start gap-0.5 flex-1 min-w-0" : "flex flex-col items-start gap-0.5"
    ), N = p(() => t.fullWidth ? "w-full" : "w-[180px]"), J = p(
      () => t.fullWidth ? "flex flex-row gap-4 w-full" : "flex flex-row gap-4"
    ), be = p(() => Pt(t.startDate, d.value) ?? ""), ke = p(() => Pt(t.endDate, d.value) ?? ""), ee = p(
      () => t.minDate ? Pt(t.minDate, d.value) ?? t.minDate : void 0
    ), oe = p(
      () => t.maxDate ? Pt(t.maxDate, d.value) ?? t.maxDate : void 0
    );
    function ge() {
      const xe = Yo();
      return (ee.value === void 0 || kn(xe, ee.value) >= 0) && (oe.value === void 0 || kn(xe, oe.value) <= 0);
    }
    function re(xe) {
      var De;
      z.value = xe;
      const we = xe === r.value ? "end" : "start";
      Y.value = we;
      const he = we === "end" ? t.endDate !== "" : t.startDate !== "";
      _.value = he, V.value = _.value ? we : t.startDate === "" ? "start" : "end", R.value = !0, (De = D.value) == null || De.reseedVisibleGrid(we);
    }
    function ue() {
      M.armMouseDown(R.value && z.value === l.value);
    }
    function O() {
      var xe;
      t.disabled || M.consumeClick() || (j.value = !1, re(l.value), (xe = l.value) == null || xe.focus());
    }
    function U(xe) {
      var he;
      if (t.disabled) return;
      xe.preventDefault();
      const we = R.value;
      j.value = !0, re(l.value), we && ((he = D.value) == null || he.focusGrid("start"));
    }
    function Q(xe) {
      var he, De;
      if (R.value || ((he = S.value) == null || he.handleFieldKeydown(xe), (De = T.value) == null || De.handleFieldKeydown(xe)), xe.key === "ArrowDown") {
        U(xe);
        return;
      }
      if (xe.key !== "Enter" || t.disabled || t.readonly) return;
      R.value && (R.value = !1), M.displayValue.value.trim() === "" && ge() && M.setValue(fn(Yo(), d.value));
    }
    function ae() {
      W.armMouseDown(R.value && z.value === r.value);
    }
    function Z() {
      var xe;
      t.disabled || W.consumeClick() || (j.value = !1, re(r.value), (xe = r.value) == null || xe.focus());
    }
    function ie(xe) {
      var he;
      if (t.disabled) return;
      xe.preventDefault();
      const we = R.value;
      j.value = !0, re(r.value), we && ((he = D.value) == null || he.focusGrid("end"));
    }
    function fe(xe) {
      var he, De;
      if (R.value || ((he = $.value) == null || he.handleFieldKeydown(xe), (De = T.value) == null || De.handleFieldKeydown(xe)), xe.key === "ArrowDown") {
        ie(xe);
        return;
      }
      if (xe.key !== "Enter" || t.disabled || t.readonly) return;
      R.value && (R.value = !1), W.displayValue.value.trim() === "" && ge() && W.setValue(fn(Yo(), d.value));
    }
    function de(xe) {
      const we = fn(xe, d.value);
      if (_.value) {
        if (V.value === "start") {
          M.setValue(we);
          const De = Pt(t.endDate, d.value);
          De !== void 0 && xe > De && W.setValue("");
        } else {
          W.setValue(we);
          const De = Pt(t.startDate, d.value);
          De !== void 0 && xe < De && M.setValue("");
        }
        R.value = !1;
        return;
      }
      if (V.value === "start") {
        M.setValue(we);
        const De = Pt(t.endDate, d.value);
        De !== void 0 && xe > De && W.setValue(""), V.value = "end";
        return;
      }
      const he = Pt(t.startDate, d.value);
      if (he !== void 0 && xe < he) {
        M.setValue(we), W.setValue(""), V.value = "end";
        return;
      }
      W.setValue(we), R.value = !1;
    }
    function ne() {
      R.value = !1;
    }
    function le() {
      M.setValue(""), W.setValue(""), V.value = "start", _.value = !1;
    }
    function Le() {
      M.consumeClick(), M.setValue("");
    }
    function Te() {
      W.consumeClick(), W.setValue("");
    }
    return (xe, we) => (c(), g("div", S3, [
      v("div", {
        class: C(J.value),
        "data-testid": "date-range-row"
      }, [
        v("div", {
          class: C(q.value)
        }, [
          e.startLabel ? (c(), K(xt, {
            key: 0,
            id: x.value,
            ref_key: "startLabelRef",
            ref: S,
            text: e.startLabel,
            "input-id": h.value,
            required: e.required,
            "required-indicator": e.requiredIndicator,
            tooltip: e.labelTooltip,
            focused: I(M).isFocused.value,
            "test-id": "date-range-start-label"
          }, null, 8, ["id", "text", "input-id", "required", "required-indicator", "tooltip", "focused"])) : k("", !0),
          v("div", {
            class: C([B.value, I(H).container, N.value]),
            "data-testid": "date-range-start-container",
            onMouseenter: we[3] || (we[3] = //@ts-ignore
            (...he) => I(M).handleMouseEnter && I(M).handleMouseEnter(...he)),
            onMouseleave: we[4] || (we[4] = //@ts-ignore
            (...he) => I(M).handleMouseLeave && I(M).handleMouseLeave(...he)),
            onMousedown: ue,
            onClick: O
          }, [
            v("i", {
              class: C([
                "ri-calendar-line",
                I(H).icon,
                e.disabled ? "text-text-disabled dark:text-(--text-text-disabled-light)" : "text-(--icons-icon-dark-default) dark:text-(--icons-icon-white-default)"
              ])
            }, null, 2),
            v("input", {
              id: h.value,
              ref_key: "startInputRef",
              ref: l,
              name: "start",
              type: "text",
              value: I(M).displayValue.value,
              placeholder: e.startPlaceholder,
              disabled: e.disabled,
              readonly: e.readonly,
              autocomplete: "off",
              inputmode: I(M).datePattern.value ? "numeric" : void 0,
              role: "combobox",
              "aria-haspopup": "dialog",
              "aria-expanded": R.value && z.value === l.value,
              "aria-controls": R.value && z.value === l.value ? I(o) : void 0,
              "aria-labelledby": x.value,
              "aria-label": x.value ? void 0 : e.startPlaceholder,
              "aria-required": e.required ? "true" : void 0,
              "aria-invalid": f.value ? "true" : void 0,
              "aria-describedby": A.value,
              "data-testid": "date-range-start-input",
              class: C([
                // forced-colors:focus-visible: mirrors DatePickerInput.vue's own gap fix — the
                // designed focus indicator lives on the CONTAINER (startInputClasses, CSS-var
                // border + box-shadow), and Windows High Contrast Mode suppresses both, so a real
                // outline is re-added here, painted by the UA in the system Highlight color.
                "flex-1 relative bg-transparent border-0 outline-none focus:outline-none focus:ring-0 focus:border-0 forced-colors:focus-visible:outline forced-colors:focus-visible:outline-2 forced-colors:focus-visible:outline-offset-2 placeholder:text-text-body-subtle dark:placeholder:text-(--colors-text-white-secondary) min-w-0",
                !e.disabled && !e.readonly ? "cursor-text" : "cursor-pointer",
                I(H).text
              ]),
              onFocus: we[0] || (we[0] = //@ts-ignore
              (...he) => I(M).handleFocus && I(M).handleFocus(...he)),
              onBlur: we[1] || (we[1] = //@ts-ignore
              (...he) => I(M).handleBlur && I(M).handleBlur(...he)),
              onInput: we[2] || (we[2] = //@ts-ignore
              (...he) => I(M).handleInput && I(M).handleInput(...he)),
              onKeydown: Q
            }, null, 42, $3),
            e.disabled ? k("", !0) : (c(), g("button", {
              key: 0,
              type: "button",
              "data-testid": "date-range-start-clear",
              class: C([
                "shrink-0 flex items-center justify-center text-(--icons-icon-dark-default) dark:text-(--icons-icon-white-default) bg-transparent border-0 p-0 transition-opacity",
                e.startDate ? "opacity-100 hover:opacity-70 cursor-pointer" : "hidden"
              ]),
              "aria-label": u.value.clearStartLabel,
              onClick: Ue(Le, ["stop"])
            }, [
              v("i", {
                class: C(["ri-close-line", I(H).icon])
              }, null, 2)
            ], 10, I3))
          ], 34)
        ], 2),
        v("div", {
          class: C(q.value)
        }, [
          e.endLabel ? (c(), K(xt, {
            key: 0,
            id: y.value,
            ref_key: "endLabelRef",
            ref: $,
            text: e.endLabel,
            "input-id": m.value,
            required: e.required,
            "required-indicator": e.requiredIndicator,
            focused: I(W).isFocused.value,
            "test-id": "date-range-end-label"
          }, null, 8, ["id", "text", "input-id", "required", "required-indicator", "focused"])) : k("", !0),
          v("div", {
            class: C([F.value, I(H).container, N.value]),
            "data-testid": "date-range-end-container",
            onMouseenter: we[8] || (we[8] = //@ts-ignore
            (...he) => I(W).handleMouseEnter && I(W).handleMouseEnter(...he)),
            onMouseleave: we[9] || (we[9] = //@ts-ignore
            (...he) => I(W).handleMouseLeave && I(W).handleMouseLeave(...he)),
            onMousedown: ae,
            onClick: Z
          }, [
            v("i", {
              class: C([
                "ri-calendar-line",
                I(H).icon,
                e.disabled ? "text-text-disabled dark:text-(--text-text-disabled-light)" : "text-(--icons-icon-dark-default) dark:text-(--icons-icon-white-default)"
              ])
            }, null, 2),
            v("input", {
              id: m.value,
              ref_key: "endInputRef",
              ref: r,
              name: "end",
              type: "text",
              value: I(W).displayValue.value,
              placeholder: e.endPlaceholder,
              disabled: e.disabled,
              readonly: e.readonly,
              autocomplete: "off",
              inputmode: I(W).datePattern.value ? "numeric" : void 0,
              role: "combobox",
              "aria-haspopup": "dialog",
              "aria-expanded": R.value && z.value === r.value,
              "aria-controls": R.value && z.value === r.value ? I(o) : void 0,
              "aria-labelledby": y.value,
              "aria-label": y.value ? void 0 : e.endPlaceholder,
              "aria-required": e.required ? "true" : void 0,
              "aria-invalid": f.value ? "true" : void 0,
              "aria-describedby": A.value,
              "data-testid": "date-range-end-input",
              class: C([
                // See the Start input's own class comment above — same forced-colors rationale.
                "flex-1 relative bg-transparent border-0 outline-none focus:outline-none focus:ring-0 focus:border-0 forced-colors:focus-visible:outline forced-colors:focus-visible:outline-2 forced-colors:focus-visible:outline-offset-2 placeholder:text-text-body-subtle dark:placeholder:text-(--colors-text-white-secondary) min-w-0",
                !e.disabled && !e.readonly ? "cursor-text" : "cursor-pointer",
                I(H).text
              ]),
              onFocus: we[5] || (we[5] = //@ts-ignore
              (...he) => I(W).handleFocus && I(W).handleFocus(...he)),
              onBlur: we[6] || (we[6] = //@ts-ignore
              (...he) => I(W).handleBlur && I(W).handleBlur(...he)),
              onInput: we[7] || (we[7] = //@ts-ignore
              (...he) => I(W).handleInput && I(W).handleInput(...he)),
              onKeydown: fe
            }, null, 42, T3),
            e.disabled ? k("", !0) : (c(), g("button", {
              key: 0,
              type: "button",
              "data-testid": "date-range-end-clear",
              class: C([
                "shrink-0 flex items-center justify-center text-(--icons-icon-dark-default) dark:text-(--icons-icon-white-default) bg-transparent border-0 p-0 transition-opacity",
                e.endDate ? "opacity-100 hover:opacity-70 cursor-pointer" : "hidden"
              ]),
              "aria-label": u.value.clearEndLabel,
              onClick: Ue(Te, ["stop"])
            }, [
              v("i", {
                class: C(["ri-close-line", I(H).icon])
              }, null, 2)
            ], 10, L3))
          ], 34)
        ], 2)
      ], 2),
      te(vt, {
        ref_key: "helperRef",
        ref: T,
        focused: I(M).isFocused.value || I(W).isFocused.value,
        hint: e.hint,
        error: e.error,
        "hint-id": w.value,
        "error-id": L.value,
        "test-id-prefix": "date-range"
      }, null, 8, ["focused", "hint", "error", "hint-id", "error-id"]),
      z.value ? (c(), K(Mc, {
        key: 0,
        id: I(o),
        ref_key: "dropdownMenuRef",
        ref: D,
        open: R.value,
        "anchor-el": z.value,
        "additional-anchor-els": [l.value, r.value],
        "keep-anchor-focusable": "",
        "auto-focus-on-open": j.value,
        "start-date": be.value,
        "end-date": ke.value,
        "seed-field": Y.value,
        "min-date": ee.value,
        "max-date": oe.value,
        "today-button-mode": "select",
        "show-today-button": e.buttons,
        "show-clear-button": e.buttons,
        "weekday-labels": u.value.weekdayLabels,
        "month-labels": u.value.monthLabels,
        "month-short-labels": u.value.monthShortLabels,
        "clear-label": u.value.clearLabel,
        "today-label": u.value.todayLabel,
        "previous-label": u.value.previousLabel,
        "next-label": u.value.nextLabel,
        "unavailable-label": u.value.unavailableLabel,
        "range-start-label": u.value.rangeStartLabel,
        "range-end-label": u.value.rangeEndLabel,
        "range-between-label": u.value.rangeBetweenLabel,
        "dialog-label": u.value.rangeDialogLabel,
        "onUpdate:open": we[10] || (we[10] = (he) => R.value = he),
        onRangeSelect: de,
        onClear: le,
        onClose: ne
      }, null, 8, ["id", "open", "anchor-el", "additional-anchor-els", "auto-focus-on-open", "start-date", "end-date", "seed-field", "min-date", "max-date", "show-today-button", "show-clear-button", "weekday-labels", "month-labels", "month-short-labels", "clear-label", "today-label", "previous-label", "next-label", "unavailable-label", "range-start-label", "range-end-label", "range-between-label", "dialog-label"])) : k("", !0)
    ]));
  }
}), A3 = { class: "flex w-full items-end gap-3" }, R3 = ["id", "value", "name", "title", "placeholder", "disabled", "readonly", "required", "autocomplete", "aria-labelledby", "aria-invalid", "aria-describedby", "aria-required", "aria-disabled"], B3 = ["aria-label", "onKeydown"], M3 = /* @__PURE__ */ ye({
  __name: "UrlInput",
  props: {
    modelValue: { default: "" },
    prefix: { default: void 0 },
    iconLeft: { default: void 0 },
    placeholder: { default: void 0 },
    label: { default: void 0 },
    required: { type: Boolean, default: !1 },
    labelTooltip: { default: void 0 },
    requiredIndicator: { default: "*" },
    disabled: { type: Boolean, default: !1 },
    readonly: { type: Boolean, default: !1 },
    size: { default: "md" },
    name: { default: void 0 },
    id: { default: void 0 },
    fullWidth: { type: Boolean, default: !1 },
    width: { default: void 0 },
    hint: { default: void 0 },
    labelInline: { type: Boolean, default: !1 },
    autocomplete: { default: "off" },
    error: { default: void 0 },
    validator: { type: Function, default: void 0 },
    validateOnBlur: { type: Boolean, default: !0 },
    validateOnInput: { type: Boolean, default: !1 },
    invalidUrlMessage: { default: "Please enter a valid URL" },
    requiredMessage: { default: "URL is required" },
    buttonLabels: { default: () => ({
      label: "",
      labelWhenCopied: ""
    }) },
    resolvedUrl: { default: void 0 },
    labels: { default: () => ({ clear: "Clear input" }) }
  },
  emits: ["update:modelValue", "input", "focus", "blur", "clear", "validation-change"],
  setup(e, { expose: n, emit: t }) {
    const a = e, l = t, r = E(!1), o = E(null), i = E(null), s = E(!1), d = E(!1), u = E(void 0), f = (N) => {
      if (a.validator)
        return a.validator(N) ?? void 0;
      if (a.required && !N.trim())
        return a.requiredMessage;
      if (N.trim())
        try {
          const J = !a.prefix && /^https?:\/\/|^ftps?:\/\//i.test(N), ke = new URL(J ? N : (a.prefix || "https://") + N).hostname.split("."), ee = ke[ke.length - 1];
          if (ke.length < 2 || ee.length < 2)
            return a.invalidUrlMessage;
        } catch {
          return a.invalidUrlMessage;
        }
    }, b = () => {
      const N = f(a.modelValue ?? "");
      u.value = N, l("validation-change", !N, N);
    }, h = p(() => {
      if (a.error) return a.error;
      if (d.value && s.value) return u.value;
    }), m = p(() => !!(a.modelValue ?? "").trim()), x = p(
      () => d.value && s.value && !h.value && m.value
    ), y = (N) => N && !r.value && !a.disabled && !a.readonly, w = p(
      () => r.value && m.value && !a.disabled && !a.readonly
    ), S = p(() => {
      var N;
      return !!((N = a.buttonLabels) != null && N.label);
    }), $ = p(() => a.fullWidth || a.width === void 0), T = (N) => {
      const J = N.target;
      d.value = !0, l("update:modelValue", J.value), l("input", N), a.validateOnInput && b();
    }, L = (N) => {
      r.value = !0, l("focus", N);
    }, A = (N) => {
      r.value = !1, s.value = !0, l("blur", N), a.validateOnBlur && b();
    }, R = (N) => {
      var J, be;
      (J = o.value) == null || J.handleFieldKeydown(N), (be = i.value) == null || be.handleFieldKeydown(N);
    }, z = () => {
      l("update:modelValue", ""), l("clear");
    }, D = E("idle"), V = p(() => {
      if (a.resolvedUrl !== void 0) return a.resolvedUrl;
      const N = a.modelValue ?? "";
      return N.trim() ? !a.prefix && /^https?:\/\/|^ftps?:\/\//i.test(N) ? N : (a.prefix ?? "") + N : "";
    });
    async function Y() {
      if (V.value)
        try {
          await navigator.clipboard.writeText(V.value), D.value = "copied", setTimeout(() => {
            D.value = "idle";
          }, 2e3);
        } catch (N) {
          console.error("Copy failed", N);
        }
    }
    const _ = p(() => a.buttonLabels ? D.value === "copied" ? a.buttonLabels.labelWhenCopied : a.buttonLabels.label : ""), j = p(
      () => D.value === "copied" ? "ri-check-line" : "ri-file-copy-2-line"
    );
    Ie(
      () => a.modelValue,
      () => {
        s.value && (a.validateOnBlur || a.validateOnInput) && b();
      }
    ), Ie(
      () => a.error,
      (N) => {
        N && (u.value = void 0);
      }
    ), n({ validate: () => (s.value = !0, b(), !u.value), resetValidation: () => {
      s.value = !1, u.value = void 0;
    } });
    const G = Ve(), B = p(() => a.id ?? `${G}-url`), F = p(() => a.label ? `${G}-label` : void 0), X = p(() => `${G}-error`), H = p(() => `${G}-hint`), q = p(() => {
      const N = [];
      return a.hint && N.push(H.value), h.value && N.push(X.value), N.join(" ") || void 0;
    });
    return (N, J) => (c(), g("div", {
      class: C([
        "relative flex min-w-0 pb-0.5 text-left font-inter",
        e.labelInline ? "flex-row items-center gap-2" : "flex-col items-start gap-0.5",
        $.value ? "w-full" : ""
      ]),
      style: Ne($.value ? void 0 : { width: e.width })
    }, [
      e.label ? (c(), K(xt, {
        key: 0,
        id: F.value,
        ref_key: "labelRef",
        ref: o,
        text: e.label,
        "input-id": B.value,
        required: e.required,
        "required-indicator": e.requiredIndicator,
        tooltip: e.labelTooltip,
        focused: r.value,
        inline: e.labelInline,
        "test-id": "url-input-label"
      }, null, 8, ["id", "text", "input-id", "required", "required-indicator", "tooltip", "focused", "inline"])) : k("", !0),
      v("div", {
        class: C(["flex min-w-0 flex-col gap-0.5", $.value || e.labelInline ? "w-full flex-1" : "w-full"])
      }, [
        v("div", A3, [
          te(Rn, {
            class: "min-w-0 flex-1",
            flush: !!e.prefix,
            "inner-button": S.value,
            size: e.size,
            disabled: e.disabled,
            readonly: e.readonly,
            error: !!h.value,
            success: x.value,
            "has-value": m.value,
            "data-testid": "url-input-shell"
          }, {
            default: ve(({ hovered: be, iconBoxClass: ke, leftIconBoxClass: ee, iconColorClass: oe, borderColorClass: ge, addonTextClass: re, textClass: ue }) => [
              e.iconLeft && !e.prefix ? (c(), g("i", {
                key: 0,
                class: C([e.iconLeft, ee, oe])
              }, null, 2)) : k("", !0),
              e.prefix ? (c(), g("span", {
                key: 1,
                "data-testid": "url-input-prefix",
                class: C([
                  "flex shrink-0 select-none items-center gap-2 self-stretch border-r",
                  I(Sa)[e.size].addon,
                  "text-(length:--size-m) leading-(--line-height-l)",
                  ge,
                  re
                ])
              }, [
                e.iconLeft ? (c(), g("i", {
                  key: 0,
                  class: C([e.iconLeft, ee, oe])
                }, null, 2)) : k("", !0),
                at(" " + P(e.prefix), 1)
              ], 2)) : k("", !0),
              v("div", {
                class: C([
                  e.prefix ? ["flex h-full min-w-0 flex-1 items-center gap-2", I(Sa)[e.size].input] : "contents",
                  e.prefix && !S.value ? I(Sa)[e.size].inputEnd : ""
                ])
              }, [
                v("input", {
                  id: B.value,
                  value: e.modelValue,
                  name: e.name,
                  title: V.value || void 0,
                  placeholder: e.placeholder,
                  disabled: e.disabled,
                  readonly: e.readonly,
                  required: e.required,
                  type: "url",
                  inputmode: "url",
                  autocomplete: e.autocomplete,
                  "aria-labelledby": F.value,
                  "aria-invalid": !!h.value,
                  "aria-describedby": q.value,
                  "aria-required": e.required || void 0,
                  "aria-disabled": e.disabled || void 0,
                  "data-testid": "url-input",
                  class: C([
                    "relative min-w-0 flex-1 text-ellipsis border-0 bg-transparent p-0 outline-none focus:border-0 focus:outline-none focus:ring-0 placeholder:text-(--text-text-body-subtle) dark:placeholder:text-(--colors-text-white-secondary)",
                    ue,
                    e.readonly ? "cursor-default" : ""
                  ]),
                  onInput: T,
                  onFocus: L,
                  onBlur: A,
                  onKeydown: R
                }, null, 42, R3),
                y(be) ? (c(), g("i", {
                  key: 0,
                  class: C(["ri-pencil-line text-(--icons-icon-accent)", ke])
                }, null, 2)) : w.value ? (c(), g("i", {
                  key: 1,
                  class: C([
                    "ri-close-fill cursor-pointer text-(--icons-icon-dark-default) dark:text-(--icons-icon-white-default)",
                    ke
                  ]),
                  role: "button",
                  tabindex: "-1",
                  "aria-label": e.labels.clear,
                  onMousedown: J[0] || (J[0] = Ue(() => {
                  }, ["prevent"])),
                  onClick: Ue(z, ["stop"]),
                  onKeydown: [
                    ut(z, ["enter"]),
                    ut(Ue(z, ["prevent"]), ["space"])
                  ]
                }, null, 42, B3)) : k("", !0),
                S.value ? (c(), K(Re, {
                  key: 2,
                  variant: "secondary",
                  size: "xs",
                  "icon-left": j.value,
                  label: _.value,
                  "aria-label": _.value,
                  disabled: e.disabled || !e.modelValue,
                  onClick: Y
                }, null, 8, ["icon-left", "label", "aria-label", "disabled"])) : k("", !0)
              ], 2)
            ]),
            _: 1
          }, 8, ["flush", "inner-button", "size", "disabled", "readonly", "error", "success", "has-value"]),
          $e(N.$slots, "actions", {}, void 0, !0)
        ]),
        te(vt, {
          ref_key: "helperRef",
          ref: i,
          focused: r.value,
          hint: e.hint,
          error: h.value,
          "hint-id": H.value,
          "error-id": X.value,
          "test-id-prefix": "url-input"
        }, null, 8, ["focused", "hint", "error", "hint-id", "error-id"])
      ], 2)
    ], 6));
  }
}), lq = /* @__PURE__ */ lt(M3, [["__scopeId", "data-v-3d78c675"]]), Dc = {
  name: "sameWidth",
  enabled: !0,
  phase: "beforeWrite",
  requires: ["computeStyles"],
  fn: ({ state: e }) => {
    e.styles.popper.width = `${e.rects.reference.width}px`;
  }
}, D3 = {
  indigo: "indigo",
  amber: "orange",
  green: "green",
  red: "red"
}, Sv = (e) => e.badge ? {
  label: e.badge,
  theme: e.badgeTheme ?? D3[e.badgeVariant ?? "indigo"],
  icon: e.badgeIcon,
  brandIcon: e.badgeBrandIcon
} : void 0, z3 = ["aria-expanded", "aria-activedescendant", "aria-required", "aria-invalid", "aria-disabled", "aria-describedby", "disabled", "placeholder"], O3 = ["aria-label"], P3 = { class: "flex items-start justify-between gap-2" }, F3 = {
  role: "status",
  "aria-live": "polite",
  class: "sr-only",
  "data-testid": "autocomplete-status"
}, V3 = {
  key: 0,
  class: "flex justify-center py-4"
}, N3 = {
  key: 1,
  "data-testid": "autocomplete-empty",
  class: "flex px-2.5 py-2 text-(length:--size-m) leading-(--line-height-l) font-(--weight-semi-bold) text-(--text-text-black-default) dark:text-(--colors-text-white-default)"
}, H3 = {
  key: 2,
  "data-testid": "autocomplete-results-heading",
  class: "flex shrink-0 px-2.5 pt-2 text-(length:--size-m) leading-(--line-height-l) font-(--weight-semi-bold) text-(--text-text-black-default) dark:text-(--colors-text-white-default)"
}, j3 = ["aria-labelledby", "aria-label"], W3 = /* @__PURE__ */ ye({
  inheritAttrs: !1,
  __name: "AutoComplete",
  props: {
    modelValue: { default: void 0 },
    label: { default: void 0 },
    required: { type: Boolean },
    requiredIndicator: { default: "*" },
    placeholder: { default: void 0 },
    iconLeft: { default: "ri-map-pin-2-line" },
    iconRight: { default: "ri-search-line" },
    options: { default: void 0 },
    loading: { type: Boolean },
    emptyLabel: { default: void 0 },
    resultsLabel: { default: void 0 },
    error: { default: void 0 },
    hint: { default: void 0 },
    disabled: { type: Boolean },
    fullWidth: { type: Boolean, default: !0 },
    showAddMoreDetails: { type: Boolean },
    addMoreDetailsLabel: { default: void 0 },
    labelTooltip: { default: void 0 },
    debounce: { default: 300 },
    minSearchLength: { default: 1 },
    maxVisibleOptions: { default: 5 },
    keepInputOnEdit: { type: Boolean },
    clearable: { type: Boolean, default: !0 },
    clearLabel: { default: "Clear" },
    resultsCountLabel: { type: [String, Function], default: "{count} results" },
    seeAllLabel: { type: [String, Function], default: void 0 },
    createLabel: { type: [String, Function], default: void 0 },
    createIcon: { default: "ri-add-line" }
  },
  emits: ["update:modelValue", "search", "select", "clear", "addMoreDetails", "blur", "see-all", "create"],
  setup(e, { expose: n, emit: t }) {
    var xe, we;
    const a = e, l = t, r = Ve(), o = `autocomplete-input-${r}`, i = `autocomplete-listbox-${r}`, s = `autocomplete-error-${r}`, d = `autocomplete-hint-${r}`, u = `autocomplete-label-${r}`, f = p(() => {
      const he = [];
      return a.hint && he.push(d), a.error && he.push(s), he.length > 0 ? he.join(" ") : void 0;
    }), b = E(
      a.modelValue ? ((we = (xe = a.options) == null ? void 0 : xe.find((he) => he.value === a.modelValue)) == null ? void 0 : we.label) ?? a.modelValue : ""
    ), h = E(!1), m = E(!1), x = E(!1), y = E(null), w = E(null), S = E(!1), $ = E(-1), T = E(), L = E(), A = E(), R = E(null), z = E(!1), D = E(!1);
    let V = null, Y = null, _ = !1, j = !1, M = !1;
    const W = p(
      () => h.value && !m.value && b.value.length >= (a.minSearchLength ?? 1) && !a.disabled
    ), G = p(() => (a.options ?? []).slice(0, a.maxVisibleOptions)), B = (he) => he.image !== void 0 ? { name: he.label, img: he.image ?? void 0, logo: he.logo } : void 0, F = p(() => {
      if (!W.value || a.loading || D.value) return "";
      const he = G.value.length;
      return he === 0 ? a.emptyLabel ?? "No results" : Du(a.resultsCountLabel, he);
    }), X = (he) => typeof he == "function" ? he(b.value) : he, H = p(() => X(a.seeAllLabel)), q = p(() => X(a.createLabel)), N = p(() => !!(H.value || q.value)), J = p(() => !!a.modelValue), be = p(
      () => a.clearable && !!b.value && !a.disabled && (S.value || h.value)
    ), ke = p(() => a.disabled ? "text-text-disabled dark:text-(--text-text-disabled-light)" : h.value ? "text-(--border-border-accent)" : J.value ? "text-(--text-text-black-default) dark:text-(--text-text-white-default)" : "text-(--text-text-body-subtle)"), ee = p(() => a.disabled ? "text-text-disabled dark:text-(--text-text-disabled-light)" : S.value && !h.value ? "text-(--border-border-accent)" : J.value ? "text-(--text-text-black-default) dark:text-(--text-text-white-default)" : "text-(--text-text-body-subtle)"), oe = p(() => {
      const he = "relative rounded-(--border-border-radius-rounded-l) border-solid box-border flex items-center gap-2 px-3 h-9 font-inter";
      return a.disabled ? `${he} border-[1px] bg-gainsboro-200 dark:bg-(--colors-background-disabled) border-border-disabled-subtle dark:border-(--colors-border-disabled-subtle) text-text-disabled dark:text-(--colors-text-disabled)` : a.error ? `${he} border-[1px] shadow-[0px_1px_0.5px_0.05px_rgba(29,_41,_61,_0.02)] bg-(--background-background-white) dark:bg-(--background-background-black-default) border-(--border-border-error-strong) dark:border-(--border-border-error)` : h.value ? `${he} border-[1px] shadow-[0px_0px_2px_var(--border-border-accent)] bg-(--background-background-selected) dark:bg-[rgba(255,255,255,0.05)] border-(--border-border-accent)` : S.value ? `${he} border-[1px] bg-(--background-background-white) dark:bg-(--background-background-black-default) border-(--border-border-accent)` : `${he} border-[1px] shadow-[0px_1px_0.5px_0.05px_rgba(29,_41,_61,_0.02)] bg-(--background-background-white) dark:bg-(--background-background-black-default) border-(--border-border-base-medium) dark:border-(--border-border-base)`;
    });
    Ie(W, async (he) => {
      he ? (await qe(), V = Fa(T.value, A.value, {
        placement: "bottom-start",
        onFirstUpdate: () => {
          z.value = !0;
        },
        modifiers: [
          { name: "offset", options: { offset: [0, 4] } },
          { name: "flip", options: { fallbackPlacements: ["top-start"] } },
          { name: "preventOverflow", options: { padding: 8 } },
          Dc
        ]
      })) : (V == null || V.destroy(), V = null, z.value = !1);
    }), Ie(z, async (he) => {
      he && (await qe(), await (V == null ? void 0 : V.update()));
    }), Ie(
      [() => a.options, () => a.loading],
      async () => {
        var he;
        if (!h.value && a.modelValue) {
          const De = (he = a.options) == null ? void 0 : he.find((Ee) => Ee.value === a.modelValue);
          De && (b.value = De.label);
        }
        $.value = -1, await qe(), await (V == null ? void 0 : V.update());
      }
    ), Ie(W, (he) => {
      he || ($.value = -1);
    }), Ie(
      () => a.modelValue,
      (he) => {
        var Ee;
        if (!he) {
          _ || (b.value = ""), _ = !1;
          return;
        }
        const De = (Ee = a.options) == null ? void 0 : Ee.find((je) => je.value === he);
        b.value = De ? De.label : he;
      },
      { immediate: !0 }
    ), gt(() => {
      V == null || V.destroy(), V = null, Y && clearTimeout(Y);
    });
    const ge = (he) => {
      if (j) {
        j = !1;
        return;
      }
      h.value = !0, m.value = !1, he.target.select();
    }, re = () => {
      a.disabled || (h.value = !0, m.value = !1);
    }, ue = (he) => {
      var De;
      if (M || (De = A.value) != null && De.contains(he.relatedTarget)) {
        M = !1;
        return;
      }
      h.value = !1, l("blur");
    }, O = () => {
      m.value = !1, a.modelValue && (a.keepInputOnEdit && (_ = !0), l("update:modelValue", "")), D.value = !0, Y && clearTimeout(Y), Y = setTimeout(() => {
        D.value = !1, l("search", b.value);
      }, a.debounce ?? 300);
    }, U = (he) => {
      he.disabled || (b.value = he.label, l("update:modelValue", he.value), l("select", he), ae());
    }, Q = () => {
      b.value = "", l("update:modelValue", ""), l("clear");
    }, ae = () => {
      m.value = !0;
    }, Z = () => {
      ae(), L.value && document.activeElement !== L.value && (j = !0, L.value.focus());
    }, ie = () => {
      var he, De;
      return Array.from(
        ((De = (he = R.value) == null ? void 0 : he.$el) == null ? void 0 : De.querySelectorAll("button, a[href]")) ?? []
      );
    };
    function fe(he) {
      const De = b.value;
      Z(), l(he === "see-all" ? "see-all" : "create", De);
    }
    function de(he) {
      var Ee, je;
      const De = ie();
      he.key === "Escape" ? (he.preventDefault(), he.stopPropagation(), Z()) : he.key === "Tab" && he.shiftKey && he.target === De[0] ? (he.preventDefault(), (Ee = L.value) == null || Ee.focus()) : he.key === "Tab" && !he.shiftKey && he.target === De[De.length - 1] && (j = !0, (je = L.value) == null || je.focus(), ae());
    }
    function ne(he) {
      var Ee;
      const De = he.relatedTarget;
      De === L.value || (Ee = A.value) != null && Ee.contains(De) || (h.value = !1, l("blur"));
    }
    function le(he, De) {
      he.disabled || ($.value = De, x.value = !1);
    }
    const Le = async () => {
      var he;
      await qe(), (he = document.getElementById(`${i}-option-${$.value}`)) == null || he.scrollIntoView({ block: "nearest" });
    }, Te = (he) => {
      var je, Ge;
      if (!W.value) {
        if (m.value && (he.key === "ArrowDown" || he.key === "ArrowUp")) {
          he.preventDefault(), m.value = !1;
          return;
        }
        (je = y.value) == null || je.handleFieldKeydown(he), (Ge = w.value) == null || Ge.handleFieldKeydown(he);
        return;
      }
      if (he.key === "Escape") {
        he.stopPropagation(), he.preventDefault(), ae();
        return;
      }
      const De = G.value.length;
      if (!De && he.key !== "Tab") return;
      const Ee = $.value < De ? $.value : -1;
      switch (he.key) {
        case "ArrowDown": {
          he.preventDefault(), $.value = (Ee + 1) % De, x.value = !0, Le();
          break;
        }
        case "ArrowUp": {
          he.preventDefault(), $.value = Ee === -1 ? De - 1 : Ee - 1, x.value = !0, Le();
          break;
        }
        case "Enter": {
          he.preventDefault(), $.value >= 0 && G.value[$.value] && U(G.value[$.value]);
          break;
        }
        case "Tab": {
          if (!he.shiftKey && $.value >= 0 && G.value[$.value])
            U(G.value[$.value]);
          else if (!he.shiftKey && ie()[0]) {
            he.preventDefault(), M = !0, ie()[0].focus();
            break;
          }
          ae();
          break;
        }
      }
    };
    return n({ focus: () => {
      var he;
      return (he = L.value) == null ? void 0 : he.focus();
    } }), (he, De) => (c(), g(se, null, [
      v("div", {
        class: C(["font-inter text-(length:--size-m) leading-(--line-height-l) flex flex-col gap-0.5 pb-0.5", e.fullWidth ? "w-full" : ""])
      }, [
        e.label ? (c(), K(xt, {
          key: 0,
          id: u,
          ref_key: "labelRef",
          ref: y,
          text: e.label,
          "input-id": o,
          required: e.required,
          "required-indicator": e.requiredIndicator,
          tooltip: e.labelTooltip,
          focused: h.value,
          "test-id": "autocomplete-label"
        }, null, 8, ["text", "required", "required-indicator", "tooltip", "focused"])) : k("", !0),
        v("div", {
          ref_key: "inputRef",
          ref: T,
          class: C(oe.value),
          onMouseenter: De[2] || (De[2] = (Ee) => S.value = !0),
          onMouseleave: De[3] || (De[3] = (Ee) => S.value = !1)
        }, [
          e.iconLeft ? (c(), g("i", {
            key: 0,
            class: C([e.iconLeft, "shrink-0 text-(length:--icon-size-sm) leading-(--line-height-xxl) transition-colors", ke.value])
          }, null, 2)) : k("", !0),
          Gl(v("input", Oe(he.$attrs, {
            id: o,
            ref_key: "nativeInputRef",
            ref: L,
            "onUpdate:modelValue": De[0] || (De[0] = (Ee) => b.value = Ee),
            role: "combobox",
            "aria-expanded": W.value,
            "aria-autocomplete": "list",
            "aria-controls": i,
            "aria-activedescendant": $.value >= 0 ? `${i}-option-${$.value}` : void 0,
            "aria-haspopup": "listbox",
            "aria-required": e.required || void 0,
            "aria-invalid": !!e.error || void 0,
            "aria-disabled": e.disabled ? "true" : void 0,
            "aria-describedby": f.value,
            autocomplete: "off",
            disabled: e.disabled,
            placeholder: e.placeholder,
            class: ["flex-1 min-w-0 truncate bg-transparent outline-none text-(length:--size-m) leading-(--line-height-l) placeholder:text-(--text-text-body-subtle)", e.disabled ? "text-text-disabled dark:text-(--text-text-disabled-light)" : "text-(--text-text-black-default) dark:text-(--text-text-white-default)"],
            onInput: O,
            onFocus: ge,
            onClick: re,
            onBlur: ue,
            onKeydown: Te
          }), null, 16, z3), [
            [ux, b.value]
          ]),
          be.value ? (c(), g("button", {
            key: 1,
            type: "button",
            "aria-label": e.clearLabel,
            "data-testid": "autocomplete-clear",
            class: C(["-m-1 inline-flex size-6 shrink-0 cursor-pointer items-center justify-center rounded-full transition-colors focus-visible:outline-hidden focus-visible:shadow-(--shadow-focus-l)", ee.value]),
            onMousedown: De[1] || (De[1] = Ue(() => {
            }, ["prevent"])),
            onClick: Q
          }, [...De[8] || (De[8] = [
            v("i", {
              class: "ri-close-line text-(length:--icon-size-sm) leading-(--line-height-xxl)",
              "aria-hidden": "true"
            }, null, -1)
          ])], 42, O3)) : e.iconRight ? (c(), g("i", {
            key: 2,
            class: C([e.iconRight, "shrink-0 text-(length:--icon-size-sm) leading-(--line-height-xxl) transition-colors", ee.value])
          }, null, 2)) : k("", !0)
        ], 34),
        v("div", P3, [
          te(vt, {
            ref_key: "helperRef",
            ref: w,
            focused: h.value,
            class: "flex-1",
            hint: e.hint,
            error: e.error,
            "hint-id": d,
            "error-id": s,
            "test-id-prefix": "autocomplete"
          }, null, 8, ["focused", "hint", "error"]),
          te(wt, {
            "enter-active-class": "transition duration-150 ease-in-out motion-reduce:transition-none",
            "enter-from-class": "opacity-0 -translate-y-1 motion-reduce:translate-y-0",
            "enter-to-class": "opacity-100 translate-y-0"
          }, {
            default: ve(() => [
              e.showAddMoreDetails ? (c(), K(I($n), {
                key: 0,
                "data-testid": "autocomplete-add-more-details",
                "icon-right": "ri-pencil-line",
                class: "shrink-0 ml-2",
                disabled: e.disabled,
                onClick: De[4] || (De[4] = (Ee) => l("addMoreDetails"))
              }, {
                default: ve(() => [
                  at(P(e.addMoreDetailsLabel ?? "Add more details"), 1)
                ]),
                _: 1
              }, 8, ["disabled"])) : k("", !0)
            ]),
            _: 1
          })
        ]),
        v("span", F3, P(F.value), 1)
      ], 2),
      (c(), K(Bn, { to: "body" }, [
        W.value ? (c(), g("div", {
          key: 0,
          ref_key: "panelRef",
          ref: A,
          class: "fixed z-[200]",
          "data-focus-trap-allow-outside": "",
          onMousedown: De[7] || (De[7] = Ue(() => {
          }, ["prevent"])),
          onFocusout: ne
        }, [
          te(wt, {
            "enter-active-class": "transition duration-100 ease-out",
            "enter-from-class": "transform scale-95 opacity-0",
            "enter-to-class": "transform scale-100 opacity-100",
            "leave-active-class": "transition duration-75 ease-out",
            "leave-from-class": "transform scale-100 opacity-100",
            "leave-to-class": "transform scale-95 opacity-0"
          }, {
            default: ve(() => [
              z.value ? (c(), g("div", {
                key: 0,
                "data-testid": "autocomplete-panel",
                class: C([
                  "flex w-full flex-col overflow-hidden",
                  // Without a footer the border is medium and there is no blur, so only the footer panel is the shared surface.
                  N.value ? I(Na) : "rounded-(--border-border-radius-rounded-l) border border-solid border-(--border-border-base-medium) bg-(--background-background-white) shadow-(--blur-shadow-m) dark:border-(--colors-border-base) dark:bg-(--colors-background-black-default) dark:shadow-(--blur-shadow-m-dark)"
                ])
              }, [
                v("div", {
                  "data-testid": "autocomplete-list",
                  class: C([
                    "flex min-h-0 flex-col",
                    N.value ? "p-1" : "gap-1.5 p-[calc(--spacing(2)-1px)]"
                  ])
                }, [
                  e.loading ? (c(), g("div", V3, [...De[9] || (De[9] = [
                    v("i", {
                      class: "ri-loader-4-line animate-spin text-(--text-text-body-subtle)",
                      "aria-hidden": "true"
                    }, null, -1)
                  ])])) : !G.value.length && !D.value ? (c(), g("div", N3, P(e.emptyLabel ?? "No results"), 1)) : e.resultsLabel ? (c(), g("div", H3, P(e.resultsLabel), 1)) : k("", !0),
                  v("ul", {
                    id: i,
                    role: "listbox",
                    "aria-labelledby": e.label ? u : void 0,
                    "aria-label": e.label ? void 0 : e.resultsLabel,
                    class: C([
                      "flex flex-col",
                      !N.value && "gap-1.5",
                      (e.loading || !G.value.length) && "hidden"
                    ])
                  }, [
                    (c(!0), g(se, null, Me(G.value, (Ee, je) => (c(), K(Gt, {
                      id: `${i}-option-${je}`,
                      key: Ee.value,
                      as: "li",
                      type: "autocomplete",
                      role: "option",
                      "aria-selected": je === $.value,
                      label: Ee.label,
                      highlight: b.value,
                      icon: Ee.icon,
                      avatar: B(Ee),
                      "secondary-label": Ee.description,
                      badge: I(Sv)(Ee),
                      description: Ee.disabled ? Ee.disabledReason : void 0,
                      "aria-disabled": !!Ee.disabled,
                      highlighted: je === $.value,
                      "keyboard-active": x.value && je === $.value,
                      "data-testid": `autocomplete-option-${Ee.value}`,
                      onClick: (Ge) => U(Ee),
                      onMouseenter: (Ge) => le(Ee, je)
                    }, null, 8, ["id", "aria-selected", "label", "highlight", "icon", "avatar", "secondary-label", "badge", "description", "aria-disabled", "highlighted", "keyboard-active", "data-testid", "onClick", "onMouseenter"]))), 128))
                  ], 10, j3)
                ], 2),
                N.value ? (c(), K(il, {
                  key: 0,
                  ref_key: "footerRef",
                  ref: R,
                  type: "see-all-create",
                  "see-all-label": H.value,
                  "create-label": q.value,
                  "create-icon": e.createIcon,
                  class: "shrink-0",
                  onKeydown: de,
                  onSeeAll: De[5] || (De[5] = (Ee) => fe("see-all")),
                  onCreate: De[6] || (De[6] = (Ee) => fe("create"))
                }, null, 8, ["see-all-label", "create-label", "create-icon"])) : k("", !0)
              ], 2)) : k("", !0)
            ]),
            _: 1
          })
        ], 544)) : k("", !0)
      ]))
    ], 64));
  }
}), q3 = { class: "flex w-full flex-col" }, U3 = { class: "@container flex flex-col" }, G3 = {
  "data-testid": "address-input-zip-city",
  class: "grid grid-cols-1 gap-x-4 @sm:grid-cols-2"
}, K3 = { class: "text-(length:--size-m) leading-(--line-height-l) font-(--weight-regular) text-(--text-text-black-default) dark:text-(--text-text-white-default)" }, Y3 = "ri-map-pin-2-line", lb = "ri-search-line", rq = /* @__PURE__ */ ye({
  inheritAttrs: !1,
  __name: "AddressInput",
  props: {
    modelValue: { default: "" },
    details: { default: void 0 },
    label: { default: void 0 },
    required: { type: Boolean, default: !1 },
    placeholder: { default: void 0 },
    ariaLabel: { default: void 0 },
    labelTooltip: { default: void 0 },
    options: { default: () => [] },
    loading: { type: Boolean, default: !1 },
    hint: { default: void 0 },
    error: { default: void 0 },
    disabled: { type: Boolean, default: !1 },
    countries: { default: () => [] },
    formatAddress: { type: Function, default: void 0 },
    labels: { default: () => ({}) }
  },
  emits: ["update:modelValue", "update:details", "search", "select", "clear", "blur", "addMoreDetails"],
  setup(e, { emit: n }) {
    const t = e, a = n, l = { line1: "", line2: "", line3: "", zip: "", city: "", country: "" }, r = p(() => ({
      addMoreDetails: t.labels.addMoreDetails ?? "Add more details",
      modalTitle: t.labels.modalTitle ?? "Edit address",
      line1: t.labels.line1 ?? "Address line 1",
      line2: t.labels.line2 ?? "Address line 2 (optional)",
      line3: t.labels.line3 ?? "Address line 3 (optional)",
      linePlaceholder: t.labels.linePlaceholder ?? "Enter a new address line",
      zip: t.labels.zip ?? "Zip code",
      city: t.labels.city ?? "City",
      country: t.labels.country ?? "Country",
      save: t.labels.save ?? "Save",
      cancel: t.labels.cancel ?? "Cancel"
    })), o = E(t.modelValue);
    Ie(
      () => t.modelValue,
      (Y) => {
        o.value = Y;
      }
    );
    const i = E({ ...l, ...t.details });
    Ie(
      () => t.details,
      (Y) => {
        i.value = { ...l, ...Y };
      },
      { deep: !0 }
    );
    const s = p(() => !!o.value), d = E(null);
    function u() {
      t.details || (i.value = { ...l });
    }
    function f(Y) {
      u(), a("select", Y);
    }
    function b() {
      i.value = { ...l }, a("clear");
    }
    function h(Y) {
      o.value = Y, a("update:modelValue", Y);
    }
    function m(Y) {
      u(), h(Y);
    }
    function x(Y) {
      var _, j;
      t.disabled || (_ = Y.target) != null && _.closest(`.${lb}`) && ((j = d.value) == null || j.focus());
    }
    const y = p(() => [
      "[&_.ri-search-line]:cursor-pointer",
      // AutoComplete sizes its icons `text-base`, a 24 px line box; Figma's icons are 16 px squares.
      "[&_.ri-map-pin-2-line]:text-(length:--icon-size-sm) [&_.ri-map-pin-2-line]:leading-(--icon-size-sm)",
      "[&_.ri-search-line]:text-(length:--icon-size-sm) [&_.ri-search-line]:leading-(--icon-size-sm)",
      s.value && !t.disabled ? "[&_input]:text-(--text-text-link) [&_input]:font-(--weight-medium)" : ""
    ]), w = E(!1), S = rl({ ...l }), $ = `address-input-title-${Ve()}`, T = `address-input-description-${Ve()}`;
    function L(Y) {
      var M;
      const _ = ((M = t.countries.find((W) => W.value === Y.country)) == null ? void 0 : M.label) ?? Y.country, j = [Y.zip, Y.city].filter((W) => W.trim()).join(" ");
      return [Y.line1, Y.line2, Y.line3, j, _].filter((W) => W.trim());
    }
    const A = (Y) => t.formatAddress ? t.formatAddress(Y) : L(Y).join(", "), R = p(() => L(S));
    function z() {
      Object.assign(S, i.value), w.value = !0, a("addMoreDetails");
    }
    function D() {
      const Y = { ...S }, _ = A(Y);
      w.value = !1, _ && (i.value = Y, a("update:details", Y), h(_));
    }
    function V() {
      w.value = !1;
    }
    return (Y, _) => (c(), g("div", q3, [
      v("div", {
        "data-testid": "address-input-field",
        class: C(y.value),
        onClick: x
      }, [
        te(W3, Oe({
          ref_key: "autoCompleteRef",
          ref: d
        }, Y.$attrs, {
          "model-value": o.value,
          label: e.label,
          required: e.required,
          placeholder: e.placeholder,
          "aria-label": e.label ? void 0 : e.ariaLabel,
          "label-tooltip": e.labelTooltip,
          options: e.options,
          loading: e.loading,
          hint: e.hint,
          error: e.error,
          disabled: e.disabled,
          "icon-left": Y3,
          "icon-right": lb,
          "keep-input-on-edit": "",
          "show-add-more-details": s.value,
          "add-more-details-label": r.value.addMoreDetails,
          onAddMoreDetails: z,
          "onUpdate:modelValue": m,
          onSearch: _[0] || (_[0] = (j) => a("search", j)),
          onSelect: f,
          onClear: b,
          onBlur: _[1] || (_[1] = (j) => a("blur"))
        }), null, 16, ["model-value", "label", "required", "placeholder", "aria-label", "label-tooltip", "options", "loading", "hint", "error", "disabled", "show-add-more-details", "add-more-details-label"])
      ], 2),
      te(za, {
        modelValue: w.value,
        "onUpdate:modelValue": _[8] || (_[8] = (j) => w.value = j),
        size: "sm",
        "aria-labelledby": $,
        "aria-describedby": R.value.length ? T : void 0
      }, {
        header: ve(() => [
          v("h2", {
            id: $,
            class: "text-(length:--size-l) leading-(--line-height-xxl) font-(--weight-bold) text-(--text-text-black-default) dark:text-(--text-text-white-default)"
          }, P(r.value.modalTitle), 1)
        ]),
        footer: ve(() => [
          te(Re, {
            "data-testid": "address-input-cancel",
            variant: "secondary",
            label: r.value.cancel,
            onClick: V
          }, null, 8, ["label"]),
          te(Re, {
            "data-testid": "address-input-save",
            variant: "primary",
            label: r.value.save,
            onClick: D
          }, null, 8, ["label"])
        ]),
        default: ve(() => [
          v("div", U3, [
            te(zt, {
              modelValue: S.line1,
              "onUpdate:modelValue": _[2] || (_[2] = (j) => S.line1 = j),
              "data-testid": "address-input-line1",
              label: r.value.line1,
              "full-width": ""
            }, null, 8, ["modelValue", "label"]),
            te(zt, {
              modelValue: S.line2,
              "onUpdate:modelValue": _[3] || (_[3] = (j) => S.line2 = j),
              "data-testid": "address-input-line2",
              label: r.value.line2,
              placeholder: r.value.linePlaceholder,
              "full-width": ""
            }, null, 8, ["modelValue", "label", "placeholder"]),
            te(zt, {
              modelValue: S.line3,
              "onUpdate:modelValue": _[4] || (_[4] = (j) => S.line3 = j),
              "data-testid": "address-input-line3",
              label: r.value.line3,
              placeholder: r.value.linePlaceholder,
              "full-width": ""
            }, null, 8, ["modelValue", "label", "placeholder"]),
            v("div", G3, [
              te(zt, {
                modelValue: S.zip,
                "onUpdate:modelValue": _[5] || (_[5] = (j) => S.zip = j),
                "data-testid": "address-input-zip",
                label: r.value.zip,
                "full-width": ""
              }, null, 8, ["modelValue", "label"]),
              te(zt, {
                modelValue: S.city,
                "onUpdate:modelValue": _[6] || (_[6] = (j) => S.city = j),
                "data-testid": "address-input-city",
                label: r.value.city,
                "full-width": ""
              }, null, 8, ["modelValue", "label"])
            ]),
            te(Tl, {
              modelValue: S.country,
              "onUpdate:modelValue": _[7] || (_[7] = (j) => S.country = j),
              "data-testid": "address-input-country",
              label: r.value.country,
              options: e.countries,
              "full-width": ""
            }, null, 8, ["modelValue", "label", "options"]),
            R.value.length ? (c(), K(Ul, {
              key: 0,
              id: T,
              "data-testid": "address-input-description",
              color: "default",
              layout: "stacked",
              "aria-live": "off"
            }, {
              body: ve(() => [
                v("p", K3, [
                  (c(!0), g(se, null, Me(R.value, (j, M) => (c(), g("span", {
                    key: M,
                    class: "block"
                  }, P(j), 1))), 128))
                ])
              ]),
              _: 1
            })) : k("", !0)
          ])
        ]),
        _: 1
      }, 8, ["modelValue", "aria-describedby"])
    ]));
  }
}), J3 = { class: "flex w-full flex-col" }, Z3 = { class: "box-border flex w-full flex-col gap-1.5 p-[calc(--spacing(2)-1px)]" }, X3 = ["id"], Q3 = {
  key: 1,
  class: "flex justify-center py-2"
}, _3 = {
  key: 2,
  class: "px-2 py-2 text-(length:--size-m) leading-(--line-height-l) text-(--text-text-body-subtle) dark:text-(--colors-text-white-secondary)",
  "data-testid": "relation-input-empty"
}, ez = ["id", "aria-labelledby", "aria-label", "aria-owns", "aria-busy"], tz = ["id", "aria-selected", "onClick", "onMouseenter"], nz = { class: "flex min-w-0 flex-1 flex-col gap-px" }, az = {
  class: "truncate text-(length:--size-sm) leading-(--line-height-l) font-(--weight-medium) text-(--text-text-heading) dark:text-(--colors-text-white-default)",
  "data-testid": "relation-input-option-name"
}, lz = {
  key: 0,
  class: "bg-transparent text-(--text-text-accent)"
}, rz = {
  key: 0,
  class: "truncate text-(length:--size-sm) leading-(--line-height-l) font-(--weight-regular) text-(--text-text-body) dark:text-(--colors-text-white-secondary)"
}, oz = /* @__PURE__ */ ye({
  __name: "RelationListbox",
  props: {
    listboxId: {},
    items: {},
    activeIndex: {},
    query: {},
    heading: {},
    name: {},
    loading: { type: Boolean },
    loadingLabel: {},
    emptyText: {}
  },
  emits: ["choose", "hover"],
  setup(e, { emit: n }) {
    const t = e, a = n, l = p(() => `${t.listboxId}-heading`), r = p(
      () => t.items.map((f, b) => ({ item: f, index: b })).filter(
        (f) => f.item.kind === "record"
      )
    ), o = p(
      () => t.items.map((f, b) => ({ item: f, index: b })).filter(
        (f) => f.item.kind !== "record"
      )
    ), i = p(() => o.value.find((f) => f.item.kind === "viewAll")), s = p(() => o.value.find((f) => f.item.kind === "create")), d = p(() => o.value.map((f) => f.item.id).join(" ") || void 0), u = (f) => f.role ?? f.email;
    return (f, b) => {
      var h, m;
      return c(), g("div", J3, [
        v("div", Z3, [
          e.heading ? (c(), g("div", {
            key: 0,
            id: l.value,
            class: "flex h-4 w-full items-end px-2 text-(length:--size-sm) leading-(--line-height-l) font-(--weight-semi-bold) text-(--text-text-body-subtle) dark:text-(--colors-text-white-secondary)"
          }, P(e.heading), 9, X3)) : k("", !0),
          e.loading ? (c(), g("div", Q3, [
            te(Ru, {
              size: "sm",
              label: e.loadingLabel
            }, null, 8, ["label"])
          ])) : e.emptyText ? (c(), g("div", _3, P(e.emptyText), 1)) : k("", !0),
          v("div", {
            id: e.listboxId,
            role: "listbox",
            "aria-labelledby": e.heading ? l.value : void 0,
            "aria-label": e.heading ? void 0 : e.name,
            "aria-owns": d.value,
            "aria-busy": e.loading || void 0,
            class: C(["flex flex-col gap-1.5", d.value ? "empty:sr-only" : "empty:hidden"]),
            "data-testid": "relation-input-listbox"
          }, [
            (c(!0), g(se, null, Me(r.value, ({ item: x, index: y }) => (c(), g("div", {
              id: x.id,
              key: x.id,
              role: "option",
              "aria-selected": y === e.activeIndex,
              "data-testid": "relation-input-option",
              class: C([
                "flex h-[46px] cursor-pointer items-center gap-1.5 rounded-(--border-border-radius-rounded-sm) p-2",
                y === e.activeIndex ? "bg-(--background-background-hover) dark:bg-white/8" : "hover:bg-(--background-background-hover) dark:hover:bg-white/8"
              ]),
              onClick: (w) => a("choose", x),
              onMouseenter: (w) => a("hover", y)
            }, [
              te(Kt, {
                name: x.record.label,
                img: x.record.avatarSrc,
                size: "sm",
                presentational: ""
              }, null, 8, ["name", "img"]),
              v("span", nz, [
                v("span", az, [
                  (c(!0), g(se, null, Me([I(og)(x.record.label, e.query)], (w, S) => (c(), g(se, { key: S }, [
                    at(P(w.before), 1),
                    w.match ? (c(), g("mark", lz, P(w.match), 1)) : k("", !0),
                    at(P(w.after), 1)
                  ], 64))), 128))
                ]),
                u(x.record) ? (c(), g("span", rz, P(u(x.record)), 1)) : k("", !0)
              ]),
              x.record.badge ? (c(), K(ct, {
                key: 0,
                label: x.record.badge.label,
                theme: x.record.badge.color,
                size: "sm",
                "show-left-icon": !1,
                class: "shrink-0",
                "data-testid": "relation-input-option-badge"
              }, null, 8, ["label", "theme"])) : k("", !0)
            ], 42, tz))), 128))
          ], 10, ez)
        ]),
        o.value.length ? (c(), K(il, {
          key: 0,
          type: "see-all-create",
          "see-all-label": (h = i.value) == null ? void 0 : h.item.label,
          "see-all-option": i.value && {
            id: i.value.item.id,
            active: i.value.index === e.activeIndex,
            testId: "relation-input-view-all"
          },
          "create-label": (m = s.value) == null ? void 0 : m.item.label,
          "create-option": s.value && {
            id: s.value.item.id,
            active: s.value.index === e.activeIndex,
            testId: "relation-input-create"
          },
          onSeeAll: b[0] || (b[0] = (x) => i.value && a("choose", i.value.item)),
          onCreate: b[1] || (b[1] = (x) => s.value && a("choose", s.value.item)),
          onOptionHover: b[2] || (b[2] = (x) => a("hover", (x === "see-all" ? i.value : s.value).index))
        }, null, 8, ["see-all-label", "see-all-option", "create-label", "create-option"])) : k("", !0)
      ]);
    };
  }
}), vl = Qr(null), iz = ["id", "role", "aria-labelledby"], sz = { class: "opal-popover-inner" }, dz = { class: "opal-popover-header flex h-8 items-center justify-between ps-3 text-(length:--size-m) leading-(--line-height-l) font-(--weight-medium)" }, uz = {
  key: 0,
  class: "opal-popover-record mb-1 flex min-w-0 flex-col"
}, cz = {
  key: 0,
  class: "flex items-start justify-between gap-2"
}, fz = {
  key: 0,
  class: "opal-popover-avatar"
}, hz = {
  key: 1,
  class: "opal-popover-action ml-auto shrink-0"
}, bz = {
  key: 2,
  class: "opal-popover-badges mt-px flex flex-wrap gap-1.5"
}, gz = { class: "opal-popover-content" }, pz = /* @__PURE__ */ ye({
  inheritAttrs: !1,
  __name: "Popover",
  props: {
    header: {},
    position: { default: "bottom" },
    delay: { default: 400 },
    closeDelay: { default: 100 },
    disabled: { type: Boolean, default: !1 },
    open: { type: Boolean, default: void 0 },
    interactive: { type: Boolean, default: !1 },
    closable: { type: Boolean, default: !1 },
    closeLabel: { default: "Close" },
    minWidth: { default: void 0 },
    maxWidth: { default: "255px" }
  },
  emits: ["update:open"],
  setup(e, { emit: n }) {
    var De;
    const t = wu(), a = e, l = n, r = Ht(), o = () => ["avatar", "title", "badges", "action"].some(r), i = Ve(), s = `${i}-header`, d = `${i}-body`, u = E(a.position), f = () => u.value === "bottom" ? "var(--background-background-white-secondary)" : "var(--colors-white-50-opacity-bold)", b = E(null), h = E(null), m = E(!1), x = E(!1), y = Symbol("popover"), w = p(() => a.open !== void 0), S = p(() => w.value ? a.open === !0 : m.value), $ = p(() => a.interactive || a.closable), T = typeof process < "u" && ((De = process.env) == null ? void 0 : De.NODE_ENV) !== "production", L = p(
      () => $.value ? {
        "aria-haspopup": "dialog",
        "aria-expanded": S.value,
        "aria-controls": S.value ? i : void 0
      } : { "aria-describedby": S.value ? d : void 0 }
    );
    let A = null, R = null, z = null, D = null, V = !1, Y = null, _ = !1;
    const j = (Ee) => Ee === "top" || Ee === "bottom", M = {
      name: "syncSide",
      enabled: !0,
      phase: "afterWrite",
      fn: ({ state: Ee, instance: je }) => {
        const Ge = u.value;
        u.value = Ee.placement.split("-")[0], j(Ge) !== j(u.value) && qe(() => je.update());
      }
    }, W = () => {
      Y == null || Y.disconnect(), Y = null, A == null || A.destroy(), A = null;
    };
    Ie(
      S,
      async (Ee) => {
        if (!Ee) {
          _ = !1, F();
          return;
        }
        if (u.value = a.position, await qe(), !S.value || !b.value || !h.value) return;
        W();
        const je = Fa(b.value, h.value, {
          placement: a.position,
          modifiers: [
            // Arrow height: the caret tip touches the trigger.
            { name: "offset", options: { offset: [0, 10] } },
            { name: "arrow", options: { element: ".opal-popover-arrow", padding: 12 } },
            {
              name: "flip",
              // altAxis off: near the top or bottom edge a side bubble is shifted, not flipped.
              options: { fallbackPlacements: Jb[a.position], altAxis: !1 }
            },
            { name: "preventOverflow", options: { padding: Zb } },
            M
          ],
          // The first pass measures the caret before the side's CSS (10×40 on left/right) applies.
          onFirstUpdate: () => void je.update()
        });
        A = je, typeof ResizeObserver < "u" && (Y = new ResizeObserver(() => void je.update()), Y.observe(h.value));
      },
      { immediate: !0 }
    );
    const G = () => {
      R && (clearTimeout(R), R = null);
    }, B = () => {
      z && (clearTimeout(z), z = null);
    };
    function F() {
      vl.value === y && (vl.value = null), x.value = !1, document.removeEventListener("pointerdown", H, !0);
    }
    const X = () => {
      if (w.value) {
        l("update:open", !1);
        return;
      }
      F(), m.value = !1;
    };
    function H(Ee) {
      ke(b.value, Ee.target) || ke(h.value, Ee.target) || X();
    }
    const q = () => {
      !a.closable || a.disabled || w.value || x.value || (G(), B(), vl.value = y, x.value = !0, m.value = !0, document.addEventListener("pointerdown", H, !0));
    };
    Ie(vl, (Ee) => {
      x.value && Ee !== y && X();
    });
    const N = () => !a.disabled && !w.value && !(vl.value && vl.value !== y), J = () => {
      N() && (B(), !R && (R = setTimeout(() => {
        m.value = !0, R = null;
      }, a.delay)));
    }, be = () => {
      w.value || (G(), B(), z = setTimeout(X, a.closeDelay));
    }, ke = (Ee, je) => !!Ee && je instanceof Node && Ee.contains(je), ee = () => {
      x.value || ke(h.value, document.activeElement) || ke(b.value, document.activeElement) || be();
    }, oe = () => (D != null && D.isConnected ? D : null) ?? (b.value ? va(b.value)[0] ?? null : null), ge = (Ee) => {
      Ee.target instanceof HTMLElement && (D = Ee.target), V || J();
    }, re = () => {
      _ = !0, B();
    }, ue = () => {
      _ = !1, ee();
    }, O = (Ee) => Ee.relatedTarget === null && (document.activeElement === Ee.target || _), U = () => x.value ? X() : be(), Q = (Ee) => {
      O(Ee) || ke(h.value, Ee.relatedTarget) || U();
    }, ae = (Ee) => {
      O(Ee) || ke(h.value, Ee.relatedTarget) || ke(b.value, Ee.relatedTarget) || U();
    }, Z = (Ee) => void qe(
      () => (
        // Two frames: the first can already be pending and fire in the same task as the re-render.
        requestAnimationFrame(
          () => requestAnimationFrame(() => {
            V = !0;
            try {
              Ee == null || Ee.focus();
            } finally {
              V = !1;
            }
          })
        )
      )
    ), ie = () => {
      const Ee = oe();
      X(), w.value || Z(Ee);
    }, fe = (Ee) => {
      var Ce;
      if (!S.value) return;
      Ee.stopPropagation(), Ee.preventDefault();
      const je = document.activeElement, Ge = ke(h.value, je) || x.value && (!je || je === document.body), Qe = oe();
      X(), T && w.value && !((Ce = t == null ? void 0 : t.vnode.props) != null && Ce["onUpdate:open"]) && console.warn(
        "[OPAL Popover] Escape was consumed and emitted as `update:open(false)`, but no `update:open` listener is bound: nothing can close this controlled popover. Listen for the emit (`v-model:open`), or Escape does nothing."
      ), !(!Ge || w.value) && Z(Qe);
    }, de = Symbol("popover"), ne = (Ee) => {
      Ee.key !== "Escape" || Ee.defaultPrevented || Va(de) && fe(Ee);
    }, le = () => {
      document.removeEventListener("keydown", ne), An(de);
    }, Le = p(() => S.value && !w.value);
    Ie(Le, (Ee) => {
      Ee ? (Zn(de), document.addEventListener("keydown", ne)) : le();
    });
    const Te = (Ee) => {
      if (Ee.key === "Escape") {
        fe(Ee);
        return;
      }
      if ((Ee.key === "Enter" || Ee.key === " ") && !Ee.repeat && Ee.target instanceof Element && Ee.target.matches("[aria-haspopup='dialog']") && a.interactive && !a.closable && !S.value && N()) {
        Ee.key === " " && Ee.preventDefault(), G(), B(), m.value = !0;
        return;
      }
      if (Ee.key !== "Tab" || Ee.shiftKey || !$.value || !S.value || !h.value)
        return;
      const je = va(h.value)[0];
      je && (xe(Ee), je.focus());
    }, xe = (Ee) => {
      Ee.preventDefault(), Ee.stopPropagation();
    }, we = () => {
      const Ee = oe();
      if (!Ee) return;
      const je = x0(document.body).filter((Qe) => {
        if (ke(h.value, Qe)) return !1;
        const Ce = Qe.closest("[role='dialog'], [role='alertdialog']");
        return !Ce || Ce.contains(Ee);
      }), Ge = je.indexOf(Ee);
      return Ge < 0 ? void 0 : je[Ge + 1];
    }, he = (Ee) => {
      var Qe;
      if (Ee.key === "Escape") {
        fe(Ee);
        return;
      }
      if (Ee.key !== "Tab" || !$.value || !h.value) return;
      const je = va(h.value), Ge = document.activeElement;
      if (Ee.shiftKey && Ge === je[0])
        xe(Ee), (Qe = oe()) == null || Qe.focus();
      else if (!Ee.shiftKey && Ge === je[je.length - 1]) {
        const Ce = we();
        if (!Ce) return;
        xe(Ee), Ce.focus(), w.value || X();
      }
    };
    return gt(() => {
      G(), B(), F(), le(), W();
    }), (Ee, je) => (c(), g(se, null, [
      v("div", Oe({
        ref_key: "triggerRef",
        ref: b,
        class: "inline-flex"
      }, Ee.$attrs, {
        onMouseenter: J,
        onMouseleave: ee,
        onFocusin: ge,
        onFocusout: Q,
        onKeydown: Te,
        onClick: q
      }), [
        $e(Ee.$slots, "trigger", { triggerProps: L.value }, void 0, !0)
      ], 16),
      (c(), K(Bn, { to: "body" }, [
        te(wt, {
          name: "opal-popover",
          onAfterLeave: W
        }, {
          default: ve(() => [
            S.value ? (c(), g("div", {
              key: 0,
              id: I(i),
              ref_key: "bubbleRef",
              ref: h,
              role: $.value ? "dialog" : "tooltip",
              "aria-labelledby": $.value ? s : void 0,
              class: C(["opal-popover absolute z-9999", `opal-popover--${u.value}`]),
              style: Ne({ minWidth: a.minWidth, maxWidth: a.maxWidth }),
              "data-focus-trap-allow-outside": "",
              onMouseenter: re,
              onMouseleave: ue,
              onFocusin: q,
              onFocusout: ae,
              onKeydown: he
            }, [
              v("div", sz, [
                v("div", dz, [
                  v("span", {
                    id: s,
                    class: "min-w-0"
                  }, P(a.header), 1),
                  a.closable ? (c(), K(Re, {
                    key: 0,
                    variant: "ghost",
                    size: "xs",
                    "icon-only": "",
                    "icon-left": "ri-close-line",
                    "aria-label": a.closeLabel,
                    class: "opal-popover-close shrink-0",
                    onClick: ie
                  }, null, 8, ["aria-label"])) : k("", !0)
                ]),
                v("div", {
                  id: d,
                  class: "opal-popover-body p-3 text-(length:--size-m) leading-(--line-height-l) font-(--weight-regular)"
                }, [
                  o() ? (c(), g("div", uz, [
                    I(r)("avatar") || I(r)("action") ? (c(), g("div", cz, [
                      I(r)("avatar") ? (c(), g("div", fz, [
                        $e(Ee.$slots, "avatar", {}, void 0, !0)
                      ])) : k("", !0),
                      I(r)("action") ? (c(), g("div", hz, [
                        $e(Ee.$slots, "action", {}, void 0, !0)
                      ])) : k("", !0)
                    ])) : k("", !0),
                    I(r)("title") ? (c(), g("div", {
                      key: 1,
                      class: C(["opal-popover-title min-w-0 font-(--weight-semi-bold)", { "mt-0.5": I(r)("avatar") || I(r)("action") }])
                    }, [
                      $e(Ee.$slots, "title", {}, void 0, !0)
                    ], 2)) : k("", !0),
                    I(r)("badges") ? (c(), g("div", bz, [
                      $e(Ee.$slots, "badges", {}, void 0, !0)
                    ])) : k("", !0)
                  ])) : k("", !0),
                  v("div", gz, [
                    $e(Ee.$slots, "default", {}, void 0, !0)
                  ])
                ])
              ]),
              v("div", {
                class: "opal-popover-arrow",
                "aria-hidden": "true",
                style: Ne({ "--arrow-bg": f() })
              }, [...je[0] || (je[0] = [
                v("svg", {
                  viewBox: "0 0 40 10",
                  width: "40",
                  height: "10",
                  "aria-hidden": "true",
                  focusable: "false"
                }, [
                  v("path", {
                    class: "opal-popover-arrow-fill",
                    d: "M 0 0 L 6.59 0 Q 10.59 0 13.33 2.91 L 17.26 7.09 Q 20 10 22.74 7.09 L 26.67 2.91 Q 29.41 0 33.41 0 L 40 0 Z"
                  }),
                  v("path", {
                    class: "opal-popover-arrow-outline",
                    d: "M 6.59 0 Q 10.59 0 13.33 2.91 L 17.26 7.09 Q 20 10 22.74 7.09 L 26.67 2.91 Q 29.41 0 33.41 0"
                  })
                ], -1)
              ])], 4)
            ], 46, iz)) : k("", !0)
          ]),
          _: 3
        })
      ]))
    ], 64));
  }
}), $v = /* @__PURE__ */ lt(pz, [["__scopeId", "data-v-0eb73eba"]]), mz = {
  key: 0,
  class: "block truncate"
}, vz = {
  key: 1,
  class: "block truncate text-(--text-text-body)"
}, xz = /* @__PURE__ */ ye({
  __name: "RelationPopover",
  props: {
    record: {},
    linkId: {},
    header: {},
    viewRecordLabel: {},
    disabled: { type: Boolean },
    linkClass: {}
  },
  setup(e) {
    return (n, t) => (c(), K($v, {
      header: e.header,
      position: "top",
      interactive: "",
      delay: 0,
      "min-width": "260px",
      "max-width": "none",
      disabled: e.disabled,
      class: "min-w-0 max-w-full"
    }, _n({
      trigger: ve(({ triggerProps: a }) => [
        (c(), K(dt(e.record.href ? "a" : "span"), Oe({ id: e.linkId }, a, {
          href: e.record.href,
          tabindex: e.record.href ? void 0 : 0,
          role: e.record.href ? void 0 : "button",
          "data-testid": "relation-input-link",
          class: ["min-w-0 truncate rounded-(--border-border-radius-rounded-xs) font-(--weight-medium) hover:underline focus-visible:underline focus-visible:shadow-(--shadow-focus-l) focus-visible:outline-hidden", e.linkClass]
        }), {
          default: ve(() => [
            at(P(e.record.label), 1)
          ]),
          _: 1
        }, 16, ["id", "href", "tabindex", "role", "class"]))
      ]),
      avatar: ve(() => [
        te(Kt, {
          name: e.record.label,
          img: e.record.avatarSrc,
          size: "md"
        }, null, 8, ["name", "img"])
      ]),
      title: ve(() => [
        te(bt, {
          text: e.record.label
        }, null, 8, ["text"])
      ]),
      default: ve(() => [
        e.record.email ? (c(), g("span", mz, P(e.record.email), 1)) : k("", !0),
        e.record.role ? (c(), g("span", vz, P(e.record.role), 1)) : k("", !0)
      ]),
      _: 2
    }, [
      e.record.href ? {
        name: "action",
        fn: ve(() => [
          te(Re, {
            as: "a",
            href: e.record.href,
            variant: "primary",
            size: "xs",
            label: e.viewRecordLabel
          }, null, 8, ["href", "label"])
        ]),
        key: "0"
      } : void 0
    ]), 1032, ["header", "disabled"]));
  }
}), yz = ["id", "value", "aria-expanded", "aria-controls", "aria-activedescendant", "aria-required", "aria-invalid", "aria-label", "aria-describedby", "placeholder"], kz = ["aria-label"], wz = ["id", "value", "readonly", "disabled", "placeholder", "aria-label", "aria-describedby"], Cz = {
  class: "sr-only",
  role: "status",
  "data-testid": "relation-input-status"
}, oq = /* @__PURE__ */ ye({
  inheritAttrs: !1,
  __name: "RelationInput",
  props: {
    modelValue: { default: null },
    recentRecords: { default: () => [] },
    results: { default: () => [] },
    loading: { type: Boolean, default: !1 },
    resultsCount: { default: void 0 },
    label: { default: void 0 },
    labelTooltip: { default: void 0 },
    ariaLabel: { default: void 0 },
    required: { type: Boolean, default: !1 },
    placeholder: { default: void 0 },
    hint: { default: void 0 },
    error: { default: void 0 },
    readonly: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    size: { default: "md" },
    id: { default: void 0 },
    labels: { default: () => ({}) }
  },
  emits: ["update:modelValue", "select", "search", "clear", "restore", "view-all", "create"],
  setup(e, { expose: n, emit: t }) {
    const a = e, l = t, r = p(() => ({
      recent: a.labels.recent ?? "Recently viewed",
      viewAll: a.labels.viewAll ?? "View all results",
      linkRemoved: a.labels.linkRemoved ?? "Link removed",
      restore: a.labels.restore ?? "Restore",
      clear: a.labels.clear ?? "Remove link",
      viewRecord: a.labels.viewRecord ?? "View record",
      noResults: a.labels.noResults ?? "No results",
      recordDetails: a.labels.recordDetails ?? "Record details",
      resultCount: a.labels.resultCount ?? ((Z) => `${Z} results`),
      loading: a.labels.loading ?? "Loading"
    })), o = Ve(), i = p(() => a.id ?? `relation-input-${o}`), s = `relation-input-listbox-${o}`, d = `relation-input-hint-${o}`, u = `relation-input-error-${o}`, f = E(null), b = E(null), h = E(null), m = E(null), x = E(null), y = E(""), w = E(!1), S = E(!1), $ = E(!1), T = E(-1), L = E(null), A = p(() => !a.readonly && !a.disabled), R = p(() => y.value.trim() !== ""), z = p(() => !!a.modelValue), D = p(() => z.value && !R.value), V = `relation-input-link-${o}`, Y = p(() => {
      const Z = [D.value && A.value && V, a.hint && d, a.error && u].filter(Boolean);
      return Z.length ? Z.join(" ") : void 0;
    }), _ = p(() => a.resultsCount ?? a.results.length), j = p(() => {
      const Z = a.labels.create;
      if (Z)
        return typeof Z == "function" ? Z(y.value.trim()) : Z;
    }), M = p(() => {
      const Z = R.value ? a.results : a.recentRecords, ie = a.loading ? [] : Z.map((fe, de) => ({ kind: "record", id: `${s}-option-${de}`, record: fe }));
      return R.value && (!a.loading && _.value > 0 && ie.push({ kind: "viewAll", id: `${s}-view-all`, label: `${r.value.viewAll} (${_.value})` }), j.value && ie.push({ kind: "create", id: `${s}-create`, label: j.value })), ie;
    }), W = p(
      () => R.value && !a.loading && a.results.length === 0 ? r.value.noResults : void 0
    ), G = p(
      () => w.value && A.value && (R.value || a.loading || a.recentRecords.length > 0)
    ), B = p(() => !G.value || !R.value || a.loading ? "" : a.results.length ? r.value.resultCount(_.value) : r.value.noResults), F = p(() => {
      var Z;
      return (Z = M.value[T.value]) == null ? void 0 : Z.id;
    });
    Ie(M, () => {
      T.value = -1;
    }), Ie(
      () => a.modelValue,
      (Z) => {
        Z && (L.value = null);
      }
    );
    let X = null;
    Ie(G, async (Z) => {
      var fe;
      if (X == null || X.destroy(), X = null, !Z) return;
      await qe();
      const ie = (fe = b.value) == null ? void 0 : fe.$el;
      !ie || !h.value || (X = Fa(ie, h.value, {
        placement: "bottom-start",
        strategy: "fixed",
        modifiers: [
          { name: "offset", options: { offset: [0, 4] } },
          { name: "flip", options: { fallbackPlacements: ["top-start"] } },
          { name: "preventOverflow", options: { padding: 8 } },
          Dc
        ]
      }));
    }), Ie(M, async () => {
      await qe(), await (X == null ? void 0 : X.update());
    }), gt(() => X == null ? void 0 : X.destroy());
    function H() {
      A.value && (L.value = null, w.value = !0);
    }
    function q() {
      w.value = !1, T.value = -1;
    }
    function N(Z) {
      L.value = null, y.value = "", q(), l("update:modelValue", Z), l("select", Z);
    }
    function J(Z) {
      if (Z.kind === "record") {
        N(Z.record);
        return;
      }
      const ie = y.value.trim();
      q(), Z.kind === "viewAll" ? l("view-all", ie) : l("create", ie);
    }
    function be() {
      var ie;
      const Z = a.modelValue;
      Z && (L.value = Z, y.value = "", q(), l("update:modelValue", null), l("clear", Z), (ie = f.value) == null || ie.focus());
    }
    function ke() {
      var ie;
      const Z = L.value;
      Z && (L.value = null, l("update:modelValue", Z), l("restore", Z), (ie = f.value) == null || ie.focus());
    }
    function ee(Z) {
      y.value = Z.target.value, L.value = null, H(), l("search", y.value);
    }
    function oe(Z) {
      var fe;
      if (!A.value) return;
      const ie = Z.target;
      ie != null && ie.closest("a, button") || (ie !== f.value && (Z.preventDefault(), (fe = f.value) == null || fe.focus()), H());
    }
    function ge() {
      S.value = !1, q(), y.value = "";
    }
    function re(Z) {
      const ie = M.value.length;
      ie && (T.value = T.value === -1 ? Z === 1 ? 0 : ie - 1 : (T.value + Z + ie) % ie, qe(() => {
        var fe, de;
        return (de = (fe = document.getElementById(F.value ?? "")) == null ? void 0 : fe.scrollIntoView) == null ? void 0 : de.call(fe, { block: "nearest" });
      }));
    }
    function ue(Z) {
      var fe, de;
      const ie = G.value;
      switch (Z.key) {
        case "ArrowDown":
        case "ArrowUp": {
          Z.preventDefault();
          const ne = Z.key === "ArrowDown" ? 1 : -1;
          if (!ie) {
            if (H(), Z.altKey) return;
            qe(() => re(ne));
            return;
          }
          Z.altKey || re(ne);
          return;
        }
        case "Enter": {
          if (!ie) {
            R.value || (Z.preventDefault(), H());
            return;
          }
          Z.preventDefault();
          const ne = M.value[T.value];
          ne && J(ne);
          return;
        }
        case " ": {
          !ie && !R.value && (Z.preventDefault(), H());
          return;
        }
        case "Escape": {
          if (ie) {
            Z.preventDefault(), Z.stopPropagation(), q();
            return;
          }
          if (R.value || L.value) {
            Z.preventDefault(), Z.stopPropagation(), y.value = "", L.value = null;
            return;
          }
          (fe = m.value) == null || fe.handleFieldKeydown(Z), (de = x.value) == null || de.handleFieldKeydown(Z);
          return;
        }
        case "Tab": {
          const ne = M.value[T.value];
          ie && (ne == null ? void 0 : ne.kind) === "record" && N(ne.record);
          return;
        }
      }
    }
    function O(Z) {
      const ie = Z.currentTarget;
      $.value = ie.contains(Z.relatedTarget);
    }
    const U = (Z) => Z || S.value || G.value ? "text-(--icons-icon-accent)" : "text-(--icons-icon-dark-default) dark:text-(--icons-icon-white-default)", Q = (Z) => A.value && z.value && (Z || $.value || G.value), ae = p(
      () => a.disabled ? "text-(--text-text-link)/44" : "text-(--text-text-link) dark:text-(--colors-text-link)"
    );
    return n({ focus: () => {
      var Z;
      return (Z = f.value) == null ? void 0 : Z.focus();
    } }), (Z, ie) => (c(), g(se, null, [
      v("div", Oe(Z.$attrs, {
        class: "flex w-full flex-col gap-px font-inter",
        "data-testid": "relation-input",
        onFocusin: ie[2] || (ie[2] = (fe) => $.value = !0),
        onFocusout: O
      }), [
        e.label ? (c(), K(xt, {
          key: 0,
          ref_key: "labelRef",
          ref: m,
          text: e.label,
          "input-id": i.value,
          required: e.required,
          tooltip: e.labelTooltip,
          focused: S.value,
          "test-id": "relation-input-label"
        }, null, 8, ["text", "input-id", "required", "tooltip", "focused"])) : k("", !0),
        te(Rn, {
          ref_key: "shellRef",
          ref: b,
          size: e.size,
          disabled: e.disabled,
          readonly: e.readonly,
          error: !!e.error,
          focused: G.value,
          "has-value": z.value,
          class: C(A.value ? "cursor-text" : ""),
          "data-testid": "relation-input-field",
          onMousedown: oe
        }, {
          default: ve(({ hovered: fe, iconBoxClass: de, textClass: ne }) => {
            var le;
            return [
              A.value ? (c(), g(se, { key: 0 }, [
                D.value && e.modelValue ? (c(), K(xz, {
                  key: 0,
                  record: e.modelValue,
                  header: r.value.recordDetails,
                  "view-record-label": r.value.viewRecord,
                  "link-id": V,
                  disabled: G.value,
                  "link-class": [ne, ae.value]
                }, null, 8, ["record", "header", "view-record-label", "disabled", "link-class"])) : k("", !0),
                v("input", {
                  id: i.value,
                  ref_key: "inputRef",
                  ref: f,
                  value: y.value,
                  type: "text",
                  role: "combobox",
                  "aria-autocomplete": "list",
                  "aria-haspopup": "listbox",
                  "aria-expanded": G.value,
                  "aria-controls": G.value ? s : void 0,
                  "aria-activedescendant": G.value ? F.value : void 0,
                  "aria-required": e.required || void 0,
                  "aria-invalid": !!e.error || void 0,
                  "aria-label": e.label ? void 0 : e.ariaLabel,
                  "aria-describedby": Y.value,
                  autocomplete: "off",
                  placeholder: z.value ? void 0 : e.placeholder,
                  "data-testid": "relation-input-input",
                  class: C(["min-w-0 flex-1 truncate border-0 bg-transparent p-0 font-(--weight-medium) text-(--text-text-black-default) outline-none placeholder:text-(--text-text-disabled-strong) dark:text-(--text-text-white-default) dark:placeholder:text-(--colors-text-white-secondary)", ne]),
                  onInput: ee,
                  onFocus: ie[0] || (ie[0] = (Le) => S.value = !0),
                  onBlur: ge,
                  onKeydown: ue
                }, null, 42, yz),
                Q(fe) ? (c(), g("button", {
                  key: 1,
                  type: "button",
                  "aria-label": r.value.clear,
                  "data-testid": "relation-input-clear",
                  class: C(["cursor-pointer rounded-(--border-border-radius-rounded-xs) text-(--icons-icon-dark-default) focus-visible:outline-hidden focus-visible:shadow-(--shadow-focus-l) dark:text-(--icons-icon-white-default)", de]),
                  onMousedown: ie[1] || (ie[1] = Ue(() => {
                  }, ["prevent"])),
                  onClick: be
                }, [...ie[5] || (ie[5] = [
                  v("i", {
                    class: "ri-close-line",
                    "aria-hidden": "true"
                  }, null, -1)
                ])], 42, kz)) : (c(), g("i", {
                  key: 2,
                  class: C(["ri-search-line", [de, U(fe)]]),
                  "aria-hidden": "true",
                  "data-testid": "relation-input-search-icon"
                }, null, 2))
              ], 64)) : (c(), g("input", {
                key: 1,
                id: i.value,
                value: ((le = e.modelValue) == null ? void 0 : le.label) ?? "",
                type: "text",
                readonly: e.readonly,
                disabled: e.disabled,
                placeholder: e.placeholder,
                "aria-label": e.label ? void 0 : e.ariaLabel,
                "aria-describedby": Y.value,
                "data-testid": "relation-input-input",
                class: C(["min-w-0 flex-1 truncate border-0 bg-transparent p-0 font-(--weight-medium) outline-none placeholder:text-(--text-text-disabled-strong)", [ne, ae.value, e.readonly ? "cursor-default" : "cursor-not-allowed"]])
              }, null, 10, wz))
            ];
          }),
          _: 1
        }, 8, ["size", "disabled", "readonly", "error", "focused", "has-value", "class"]),
        L.value && A.value ? (c(), K(Ul, {
          key: 1,
          class: "mt-1",
          color: "info",
          layout: "stacked",
          "buttons-position": "right",
          message: r.value.linkRemoved,
          buttons: [{ label: r.value.restore, variant: "tertiary", icon: "ri-arrow-left-line", onClick: ke }],
          "data-testid": "relation-input-removed"
        }, null, 8, ["message", "buttons"])) : k("", !0),
        te(vt, {
          ref_key: "helperRef",
          ref: x,
          focused: S.value,
          hint: e.hint,
          error: e.error,
          "hint-id": d,
          "error-id": u,
          "test-id-prefix": "relation-input"
        }, null, 8, ["focused", "hint", "error"]),
        v("span", Cz, P(B.value), 1)
      ], 16),
      (c(), K(Bn, { to: "body" }, [
        G.value ? (c(), g("div", {
          key: 0,
          ref_key: "panelRef",
          ref: h,
          class: C(["fixed z-[200] overflow-y-auto", [I(Na), I(zu)]]),
          "data-focus-trap-allow-outside": "",
          onMousedown: ie[4] || (ie[4] = Ue(() => {
          }, ["prevent"]))
        }, [
          te(oz, {
            "listbox-id": s,
            items: M.value,
            "active-index": T.value,
            query: y.value,
            heading: R.value ? void 0 : r.value.recent,
            name: e.label ?? r.value.recent,
            loading: e.loading,
            "loading-label": r.value.loading,
            "empty-text": W.value,
            onChoose: J,
            onHover: ie[3] || (ie[3] = (fe) => T.value = fe)
          }, null, 8, ["items", "active-index", "query", "heading", "name", "loading", "loading-label", "empty-text"])
        ], 34)) : k("", !0)
      ]))
    ], 64));
  }
}), Sz = {
  key: 0,
  class: "sr-only"
}, $z = {
  key: 1,
  class: "flex flex-wrap gap-1.5",
  "data-testid": "avatar-label-badges"
}, iq = /* @__PURE__ */ ye({
  __name: "AvatarLabel",
  props: {
    name: {},
    helperText: { default: void 0 },
    type: { default: "heading-helper" },
    size: { default: "md" },
    disabled: { type: Boolean, default: !1 },
    img: { default: void 0 },
    entity: { default: "contact" },
    avatarStyle: { default: "circle" },
    status: { default: void 0 },
    statusLabel: { default: void 0 },
    badges: { default: () => [] },
    maxBadges: { default: 3 },
    truncationFocusable: { type: Boolean, default: !0 }
  },
  setup(e) {
    const n = e, t = {
      "heading-helper": {
        sm: {
          avatar: "sm",
          gap: "gap-1.5",
          name: "text-(length:--size-sm) leading-(--line-height-l) font-(--weight-medium)",
          helper: "text-(length:--size-sm) leading-(--line-height-l) font-(--weight-regular)"
        },
        md: {
          avatar: "md",
          gap: "gap-2",
          name: "text-(length:--size-l) leading-(--line-height-xxl) font-(--weight-medium)",
          helper: "text-(length:--size-m) leading-(--line-height-l) font-(--weight-regular)"
        },
        lg: {
          avatar: "lg",
          gap: "gap-2.5",
          name: "text-(length:--size-l) leading-(--line-height-xxl) font-(--weight-medium)",
          helper: "text-(length:--size-l) leading-(--line-height-xxl) font-(--weight-regular)"
        },
        xl: {
          avatar: "xl",
          gap: "gap-2.5",
          name: "text-(length:--size-5xl) leading-(--line-height-5xl) font-(--weight-bold)",
          helper: "text-(length:--size-xl) leading-(--line-height-xxl) font-(--weight-regular)"
        }
      },
      text: {
        sm: { avatar: "xs", gap: "gap-1.5", name: "text-(length:--size-sm) leading-(--line-height-l) font-(--weight-medium)" },
        md: { avatar: "sm", gap: "gap-1.5", name: "text-(length:--size-l) leading-(--line-height-xxl) font-(--weight-medium)" },
        lg: { avatar: "lg", gap: "gap-2", name: "text-(length:--size-xl) leading-(--line-height-xl) font-(--weight-semi-bold)" },
        xl: { avatar: "xl", gap: "gap-2", name: "text-(length:--size-5xl) leading-(--line-height-5xl) font-(--weight-bold)" }
      }
    }, a = p(() => t[n.type][n.size]), l = p(() => {
      var b;
      return n.type === "heading-helper" && !!((b = n.helperText) != null && b.trim());
    }), r = p(() => n.type === "heading-helper" ? "xs" : "sm"), o = p(
      () => _b(n.badges, n.maxBadges).map((b) => ({
        ...b,
        theme: n.disabled ? "disabled" : b.theme ?? "neutral"
      }))
    ), i = p(() => n.type === "heading-helper" && o.value.length > 0), s = p(() => i.value ? "items-start" : "items-center"), d = p(
      () => i.value ? n.size === "xl" ? "mt-0.5" : "mt-1" : void 0
    ), u = p(
      () => n.disabled ? "text-(--text-text-disabled-strong)" : "text-(--text-text-heading)"
    ), f = p(
      () => n.disabled ? "text-(--text-text-disabled-strong)" : "text-(--text-text-body)"
    );
    return (b, h) => (c(), g("div", {
      class: C(["flex min-w-0", [a.value.gap, s.value]]),
      "data-testid": "avatar-label"
    }, [
      te(Kt, {
        name: e.name,
        img: e.img,
        size: a.value.avatar,
        entity: e.entity,
        "avatar-style": e.avatarStyle,
        status: e.status,
        "status-label": e.statusLabel,
        presentational: "",
        class: C([{ "opacity-70": e.disabled }, d.value])
      }, null, 8, ["name", "img", "size", "entity", "avatar-style", "status", "status-label", "class"]),
      v("div", {
        class: C(["flex min-w-0 flex-1 flex-col", e.type === "text" ? "gap-1" : "gap-px"])
      }, [
        v("div", {
          class: C(["flex min-w-0", [a.value.name, u.value]]),
          "data-testid": "avatar-label-name"
        }, [
          te(bt, {
            text: e.name,
            focusable: e.truncationFocusable
          }, {
            default: ve(() => {
              var m;
              return [
                e.status && ((m = e.statusLabel) != null && m.trim()) ? (c(), g("span", Sz, ", " + P(e.statusLabel.trim()), 1)) : k("", !0)
              ];
            }),
            _: 1
          }, 8, ["text", "focusable"])
        ], 2),
        l.value ? (c(), g("div", {
          key: 0,
          class: C(["flex min-w-0", [a.value.helper, f.value]]),
          "data-testid": "avatar-label-helper"
        }, [
          te(bt, {
            text: e.helperText,
            focusable: e.truncationFocusable
          }, null, 8, ["text", "focusable"])
        ], 2)) : k("", !0),
        o.value.length ? (c(), g("div", $z, [
          (c(!0), g(se, null, Me(o.value, (m, x) => (c(), K(ct, {
            key: x,
            label: m.label,
            theme: m.theme,
            size: r.value,
            truncate: m.truncate ?? !1,
            "truncation-focusable": e.truncationFocusable,
            "show-close-icon": !1
          }, null, 8, ["label", "theme", "size", "truncate", "truncation-focusable"]))), 128))
        ])) : k("", !0)
      ], 2)
    ], 2));
  }
}), Iz = { class: "flex flex-col gap-0.5" }, Tz = ["id"], Lz = ["id"], Ez = { class: "modal-scrollbar border border-(--border-border-base-medium) dark:border-(--colors-border-base) rounded-xl p-1 overflow-y-auto max-h-135" }, Az = {
  key: 0,
  class: "flex justify-center py-8"
}, Rz = {
  key: 1,
  class: "flex flex-col items-center gap-2 py-8 text-center"
}, Bz = { class: "text-sm text-(--text-text-black-default) dark:text-(--text-text-white-default)" }, Mz = {
  key: 2,
  class: "flex flex-col items-center gap-2 py-8 text-center"
}, Dz = { class: "text-sm text-(--text-text-body-subtle)" }, zz = ["aria-label"], Oz = ["aria-selected", "onClick"], Pz = { class: "flex items-center gap-1.5 min-w-0 flex-1" }, Fz = { class: "flex flex-col min-w-0" }, Vz = { class: "text-xs leading-5 font-medium text-(--text-text-black-default) dark:text-(--text-text-white-default)" }, Nz = {
  key: 0,
  class: "text-xs leading-5 text-(--text-text-body) dark:text-(--text-text-white-default)"
}, sq = /* @__PURE__ */ ye({
  __name: "AutoCompleteAllResultsModal",
  props: {
    modelValue: { type: Boolean },
    options: {},
    title: {},
    subtitle: { default: void 0 },
    loading: { type: Boolean, default: !1 },
    error: { type: Boolean, default: !1 },
    loadErrorLabel: { default: void 0 },
    emptyLabel: { default: void 0 },
    closeLabel: { default: void 0 },
    selectLabel: { default: void 0 }
  },
  emits: ["update:modelValue", "confirm"],
  setup(e, { emit: n }) {
    const t = e, a = n, l = Ve(), r = Ve(), o = E(null);
    Ie(
      () => t.modelValue,
      (u) => {
        u && (o.value = null);
      }
    );
    function i(u) {
      var f;
      return ((f = u.meta) == null ? void 0 : f.uniqueKey) ?? u.value;
    }
    function s(u) {
      const f = Sv(u);
      return { label: f == null ? void 0 : f.label, theme: f == null ? void 0 : f.theme, leftIcon: f == null ? void 0 : f.icon, brandIcon: f == null ? void 0 : f.brandIcon };
    }
    function d() {
      o.value && (a("confirm", o.value), a("update:modelValue", !1));
    }
    return (u, f) => (c(), K(I(za), {
      "model-value": e.modelValue,
      size: "lg",
      "show-close-button": !0,
      "footer-position": "split",
      "overlay-class": "!z-[300]",
      "content-class": "!max-h-[748px] p-2",
      "header-class": "pt-0!",
      "show-footer-border": !1,
      "show-header-border": !1,
      "aria-labelledby": I(l),
      "aria-describedby": e.subtitle ? I(r) : void 0,
      "onUpdate:modelValue": f[1] || (f[1] = (b) => u.$emit("update:modelValue", b))
    }, {
      header: ve(() => [
        v("div", Iz, [
          v("span", {
            id: I(l),
            class: "text-xl font-bold text-(--text-text-black-default) dark:text-(--text-text-white-default)"
          }, P(e.title), 9, Tz),
          e.subtitle ? (c(), g("span", {
            key: 0,
            id: I(r),
            class: "text-base font-normal text-(--text-text-black-default) dark:text-(--text-text-white-default)"
          }, P(e.subtitle), 9, Lz)) : k("", !0)
        ])
      ]),
      footer: ve(() => [
        te(I(Re), {
          variant: "secondary",
          label: e.closeLabel ?? "Close",
          onClick: f[0] || (f[0] = (b) => u.$emit("update:modelValue", !1))
        }, null, 8, ["label"]),
        te(I(Re), {
          variant: "primary",
          "icon-left": "ri-check-line",
          label: e.selectLabel ?? "Select",
          disabled: !o.value,
          onClick: d
        }, null, 8, ["label", "disabled"])
      ]),
      default: ve(() => [
        v("div", Ez, [
          e.loading ? (c(), g("div", Az, [...f[2] || (f[2] = [
            v("i", { class: "ri-loader-4-line animate-spin text-2xl text-(--text-text-body-subtle)" }, null, -1)
          ])])) : e.error ? (c(), g("div", Rz, [
            f[3] || (f[3] = v("i", { class: "ri-error-warning-line text-2xl text-red-500" }, null, -1)),
            v("span", Bz, P(e.loadErrorLabel ?? "Unable to load results."), 1)
          ])) : e.options.length ? (c(), g("div", {
            key: 3,
            role: "listbox",
            "aria-label": e.title,
            class: "flex flex-col gap-0.5"
          }, [
            (c(!0), g(se, null, Me(e.options, (b) => (c(), g("button", {
              key: i(b),
              type: "button",
              role: "option",
              "aria-selected": !!o.value && i(o.value) === i(b),
              class: C([
                "flex items-center justify-between h-11.5 w-full p-2 rounded-lg cursor-pointer transition-colors text-left",
                "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-(--border-border-accent)",
                o.value && i(o.value) === i(b) ? "bg-(--colors-background-accent) dark:bg-indigo-950/20" : "bg-transparent hover:bg-(--colors-background-hover) dark:hover:bg-(--colors-background-hover)"
              ]),
              onClick: (h) => o.value = b
            }, [
              v("span", Pz, [
                b.image !== void 0 ? (c(), K(I(Kt), {
                  key: 0,
                  as: "span",
                  img: b.image ?? void 0,
                  name: b.label,
                  size: "sm",
                  presentational: !0,
                  class: "border border-(--border-border-base-soft)"
                }, null, 8, ["img", "name"])) : k("", !0),
                v("span", Fz, [
                  v("span", Vz, P(b.label), 1),
                  b.description ? (c(), g("span", Nz, P(b.description), 1)) : k("", !0)
                ])
              ]),
              b.badge ? (c(), K(Bu, Oe({
                key: 0,
                ref_for: !0
              }, s(b), {
                size: "sm",
                class: "shrink-0 ml-2",
                "data-testid": "autocomplete-all-results-badge"
              }), null, 16)) : k("", !0)
            ], 10, Oz))), 128))
          ], 8, zz)) : (c(), g("div", Mz, [
            v("span", Dz, P(e.emptyLabel ?? "No results to display."), 1)
          ]))
        ])
      ]),
      _: 1
    }, 8, ["model-value", "aria-labelledby", "aria-describedby"]));
  }
}), Hz = ["id", "name", "value", "placeholder", "disabled", "required", "aria-expanded", "aria-controls", "aria-labelledby", "aria-label", "aria-disabled", "aria-invalid", "aria-describedby", "aria-activedescendant"], jz = ["id", "aria-label"], Wz = {
  key: 0,
  class: "px-3 py-2 text-sm text-gray-400 dark:text-(--colors-text-white-secondary)"
}, qz = ["id", "data-index", "aria-selected", "aria-disabled", "onMousedown", "onMouseenter"], Uz = /* @__PURE__ */ ye({
  __name: "TimePickerInput",
  props: {
    modelValue: { default: void 0 },
    label: { default: void 0 },
    placeholder: { default: "HH:mm" },
    required: { type: Boolean, default: !1 },
    requiredIndicator: { default: "*" },
    labelTooltip: { default: void 0 },
    disabled: { type: Boolean, default: !1 },
    error: { default: void 0 },
    showError: { type: Boolean, default: void 0 },
    hint: { default: void 0 },
    size: { default: "md" },
    fullWidth: { type: Boolean, default: !1 },
    width: { default: "384px" },
    minuteStep: { default: 15 },
    minTime: { default: void 0 },
    maxTime: { default: void 0 },
    gridStartTime: { default: void 0 },
    gridEndTime: { default: void 0 },
    name: { default: void 0 },
    id: { default: void 0 },
    groupPosition: { default: void 0 },
    ariaDescribedby: { default: void 0 },
    ariaLabel: { default: void 0 }
  },
  emits: ["update:modelValue", "change", "focus", "blur"],
  setup(e, { emit: n }) {
    const t = e, a = n, l = E(!1), r = E(!1), o = E(null), i = E(null), s = E(""), d = E(-1), u = E(null), f = E(null), b = E(null);
    let h = null;
    const m = () => {
      !f.value || !u.value || (h == null || h.destroy(), h = Fa(f.value, u.value, {
        strategy: "fixed",
        placement: "bottom-start",
        modifiers: [
          { name: "offset", options: { offset: [0, 4] } },
          { name: "flip", options: { fallbackPlacements: ["top-start"] } },
          { name: "preventOverflow", options: { padding: 8 } },
          Dc
        ]
      }));
    }, x = () => {
      h == null || h.destroy(), h = null;
    }, y = Ve(), w = p(() => t.id || y), S = p(() => t.label ? `${w.value}-label` : void 0), $ = p(() => `${w.value}-error`), T = p(() => `${w.value}-hint`), L = p(() => `${w.value}-listbox`), A = p(() => !!t.error), R = p(
      () => t.showError !== void 0 ? t.showError : A.value
    ), z = p(() => {
      if (t.ariaDescribedby) return t.ariaDescribedby;
      const U = [];
      return t.hint && U.push(T.value), A.value && R.value && U.push($.value), U.length > 0 ? U.join(" ") : void 0;
    }), D = p(() => {
      const U = [], Q = t.minuteStep, ae = t.gridStartTime ? Y(t.gridStartTime) : 0, Z = t.gridEndTime ? Y(t.gridEndTime) : 24 * 60 - 1;
      for (let ie = ae; ie <= Z; ie += Q) {
        const fe = Math.floor(ie / 60).toString().padStart(2, "0"), de = (ie % 60).toString().padStart(2, "0");
        U.push(`${fe}:${de}`);
      }
      return U;
    }), V = p(() => {
      if (!s.value) return D.value;
      const U = s.value.replace(/[^0-9:]/g, "");
      return D.value.filter((Q) => Q.includes(U));
    });
    function Y(U) {
      const [Q, ae] = U.split(":").map(Number);
      return Q * 60 + ae;
    }
    function _(U) {
      if (!t.minTime && !t.maxTime) return !1;
      const Q = Y(U), ae = t.minTime ? Y(t.minTime) : 0, Z = t.maxTime ? Y(t.maxTime) : 24 * 60 - 1;
      return Q < ae || Q > Z;
    }
    function j(U) {
      const Q = U.findIndex((ae) => !_(ae));
      return Q >= 0 ? Q : 0;
    }
    function M(U, Q, ae) {
      let Z = U;
      for (let ie = 0; ie < ae.length; ie++) {
        if (Z += Q, Z < 0 || Z >= ae.length) return U;
        if (!_(ae[Z])) return Z;
      }
      return U;
    }
    const G = {
      sm: {
        container: "h-[36px] px-2.5 gap-2",
        text: "text-sm leading-5",
        icon: "h-4 w-4"
      },
      md: {
        container: "h-[36px] px-3 py-2 gap-2",
        text: "text-sm leading-5",
        icon: "h-4 w-4"
      },
      lg: {
        container: "h-[48px] px-3.5 gap-2",
        text: "text-base leading-6",
        icon: "h-5 w-5"
      }
    }[t.size], B = p(() => t.groupPosition === "start" ? "rounded-r-none! border-r-0!" : t.groupPosition === "end" ? "rounded-l-none!" : ""), F = p(() => {
      const U = "relative rounded-xl border-solid box-border flex items-center text-left font-inter";
      if (t.disabled)
        return `${U} border-[1px] shadow-[0px_1px_0.5px_0.05px_rgba(29,_41,_61,_0.02)] dark:shadow-[0px_0px_4px_rgba(255,255,255,0.1)] bg-gainsboro-200 dark:bg-(--colors-background-disabled) border-border-disabled-subtle dark:border-(--colors-border-disabled-subtle) text-text-disabled dark:text-(--colors-text-disabled)`;
      if (A.value)
        return `${U} border-[1px] shadow-[0px_1px_0.5px_0.05px_rgba(29,_41,_61,_0.02)] dark:shadow-[0px_0px_4px_rgba(255,255,255,0.1)] bg-white dark:bg-(--colors-background-black-default) border-(--border-border-error-strong) dark:border-(--border-border-error) text-text-black-default dark:text-(--colors-text-white-default)`;
      if (r.value)
        return `${U} border-[1px] shadow-[0px_0px_2px_var(--border-border-accent)] bg-(--background-background-selected) dark:bg-[rgba(255,255,255,0.05)] border-(--border-border-accent) text-text-black-default dark:text-(--colors-text-white-default)`;
      const ae = t.modelValue !== void 0 && t.modelValue !== "" ? "text-text-black-default" : "text-text-body-subtle";
      return `${U} border-[1px] shadow-[0px_1px_0.5px_0.05px_rgba(29,_41,_61,_0.02)] dark:shadow-[0px_0px_4px_rgba(255,255,255,0.1)] bg-(--background-background-white) dark:bg-(--colors-background-black-default) border-(--border-border-base-medium) hover:border-(--border-border-accent) dark:border-(--colors-border-base) transition-colors ${ae} dark:text-(--colors-text-white-default)`;
    }), X = p(() => t.fullWidth ? "w-full" : ""), H = p(() => t.fullWidth ? {} : { width: t.width }), q = p(() => `relative flex items-start pb-0.5 text-left text-sm text-text-black-default dark:text-(--colors-text-white-default) font-inter flex-col gap-0.5 ${t.fullWidth ? "w-full" : ""}`), N = p(() => t.fullWidth ? {} : { width: t.width }), J = () => {
      if (t.disabled) return;
      l.value = !0, s.value = "";
      const U = D.value.indexOf(t.modelValue || "");
      U >= 0 ? d.value = U : t.modelValue ? d.value = -1 : d.value = j(D.value), ue();
    }, be = () => {
      l.value = !1, s.value = "", d.value = -1;
    }, ke = (U) => {
      var Q;
      _(U) || (a("update:modelValue", U), a("change", U), be(), (Q = f.value) == null || Q.focus());
    }, ee = (U) => {
      t.disabled || (r.value = !0, a("focus", U));
    }, oe = (U) => {
      setTimeout(() => {
        var Q;
        (Q = b.value) != null && Q.contains(document.activeElement) || (r.value = !1, be(), a("blur", U));
      }, 150);
    }, ge = (U) => {
      const Q = U.target;
      s.value = Q.value, l.value || J(), d.value = 0;
    }, re = (U) => {
      var ae, Z;
      l.value || ((ae = o.value) == null || ae.handleFieldKeydown(U), (Z = i.value) == null || Z.handleFieldKeydown(U));
      const Q = V.value;
      switch (U.key) {
        case "ArrowDown":
          U.preventDefault(), l.value ? (d.value = M(d.value, 1, Q), ue()) : J();
          break;
        case "ArrowUp":
          U.preventDefault(), l.value && (d.value = M(d.value, -1, Q), ue());
          break;
        case "Enter":
          U.preventDefault(), l.value && d.value >= 0 && d.value < Q.length ? ke(Q[d.value]) : l.value || J();
          break;
        case "Escape":
          l.value && (U.stopPropagation(), U.preventDefault(), be());
          break;
        case "Tab":
          be();
          break;
      }
    }, ue = () => {
      requestAnimationFrame(() => {
        var Q;
        const U = (Q = u.value) == null ? void 0 : Q.querySelector(`[data-index="${d.value}"]`);
        U == null || U.scrollIntoView({ block: "nearest" });
      });
    }, O = (U) => {
      b.value && !b.value.contains(U.target) && (be(), r.value = !1);
    };
    return ot(() => {
      document.addEventListener("mousedown", O);
    }), kt(() => {
      document.removeEventListener("mousedown", O), x();
    }), Ie(l, async (U) => {
      U ? (await qe(), m()) : x();
    }), Ie(s, () => {
      d.value = 0;
    }), (U, Q) => (c(), g("div", {
      ref_key: "containerRef",
      ref: b,
      class: C(q.value),
      style: Ne(N.value)
    }, [
      e.label ? (c(), K(xt, {
        key: 0,
        id: S.value,
        ref_key: "labelRef",
        ref: o,
        text: e.label,
        "input-id": w.value,
        required: e.required,
        "required-indicator": e.requiredIndicator,
        tooltip: e.labelTooltip,
        focused: r.value,
        "test-id": "time-picker-label"
      }, null, 8, ["id", "text", "input-id", "required", "required-indicator", "tooltip", "focused"])) : k("", !0),
      v("div", {
        class: C(["relative", X.value]),
        style: Ne(H.value)
      }, [
        v("div", {
          class: C([F.value, I(G).container, X.value, B.value]),
          style: Ne(H.value),
          onClick: J
        }, [
          v("i", {
            class: C(["ri-time-line flex-shrink-0", [
              I(G).icon,
              e.disabled ? "text-text-disabled dark:text-(--colors-text-disabled)" : r.value ? "text-[#7c86ff]" : "text-gray-400 dark:text-(--colors-text-white-secondary)"
            ]])
          }, null, 2),
          v("input", {
            id: w.value,
            ref_key: "inputRef",
            ref: f,
            type: "text",
            name: e.name,
            value: l.value ? s.value : e.modelValue || "",
            placeholder: e.placeholder,
            disabled: e.disabled,
            required: e.required,
            autocomplete: "off",
            "data-testid": "time-picker-input",
            role: "combobox",
            "aria-expanded": l.value,
            "aria-controls": L.value,
            "aria-labelledby": S.value,
            "aria-label": e.ariaLabel,
            "aria-disabled": e.disabled ? "true" : "false",
            "aria-invalid": A.value ? "true" : void 0,
            "aria-describedby": z.value,
            "aria-activedescendant": l.value && d.value >= 0 ? `${w.value}-option-${d.value}` : void 0,
            class: C([
              "flex-1 min-w-0 bg-transparent border-0 outline-none focus:outline-none focus:ring-0 focus:border-0 w-full",
              I(G).text,
              !e.disabled && "cursor-text"
            ]),
            onFocus: ee,
            onBlur: oe,
            onInput: ge,
            onKeydown: re
          }, null, 42, Hz)
        ], 6),
        Gl(v("div", {
          id: L.value,
          ref_key: "dropdownRef",
          ref: u,
          role: "listbox",
          "aria-label": e.label || e.ariaLabel || "Time selection",
          class: "fixed z-50 max-h-[200px] overflow-auto rounded-xl border border-solid border-lightgray dark:border-(--colors-border-base) bg-white-50-opacity-bold dark:bg-(--colors-background-black-default) shadow-(--blur-shadow-m) [backdrop-filter:blur(4px)] dark:shadow-(--blur-shadow-m-dark)",
          "data-testid": "time-picker-dropdown"
        }, [
          V.value.length === 0 ? (c(), g("div", Wz, " Aucun horaire disponible ")) : k("", !0),
          (c(!0), g(se, null, Me(V.value, (ae, Z) => (c(), g("div", {
            id: `${w.value}-option-${Z}`,
            key: ae,
            "data-index": Z,
            role: "option",
            "aria-selected": ae === e.modelValue,
            "aria-disabled": _(ae) ? "true" : void 0,
            class: C(["px-3 py-2 text-sm transition-colors", [
              _(ae) ? "cursor-not-allowed text-text-disabled dark:text-(--colors-text-disabled)" : "cursor-pointer",
              !_(ae) && ae === e.modelValue ? "bg-[#7c86ff]/10 text-[#7c86ff] font-medium" : "",
              !_(ae) && ae !== e.modelValue && Z === d.value ? "bg-gray-100 dark:bg-[rgba(255,255,255,0.08)] text-text-black-default dark:text-(--colors-text-white-default)" : "",
              !_(ae) && ae !== e.modelValue && Z !== d.value ? "text-text-black-default dark:text-(--colors-text-white-default) hover:bg-gray-50 dark:hover:bg-[rgba(255,255,255,0.05)]" : ""
            ]]),
            onMousedown: Ue((ie) => ke(ae), ["prevent"]),
            onMouseenter: (ie) => !_(ae) && (d.value = Z)
          }, P(ae), 43, qz))), 128))
        ], 8, jz), [
          [Cu, l.value]
        ])
      ], 6),
      te(vt, {
        ref_key: "helperRef",
        ref: i,
        focused: r.value,
        hint: e.hint,
        error: R.value ? e.error : void 0,
        "hint-id": T.value,
        "error-id": $.value,
        "test-id-prefix": "time-picker"
      }, null, 8, ["focused", "hint", "error", "hint-id", "error-id"])
    ], 6));
  }
}), dq = /* @__PURE__ */ lt(Uz, [["__scopeId", "data-v-60bc77d5"]]), Gz = {
  "data-testid": "number-range-input",
  class: "flex flex-col gap-4 w-full"
}, Kz = {
  key: 0,
  "data-testid": "number-range-slider",
  class: "relative w-full h-5"
}, Yz = ["min", "max", "step", "value", "disabled", "aria-label"], Jz = ["min", "max", "step", "value", "disabled", "aria-label"], Zz = { class: "flex flex-1 min-w-0 flex-col gap-px" }, Xz = ["id", "value", "min", "max", "step", "placeholder", "disabled", "aria-label"], Qz = { class: "shrink-0 py-2 font-(--weight-medium) text-(length:--size-m) leading-(--line-height-l) text-(--text-text-black-default) dark:text-(--colors-text-white-default)" }, _z = { class: "flex flex-1 min-w-0 flex-col gap-px" }, e4 = ["id", "value", "min", "max", "step", "placeholder", "disabled", "aria-label"], t4 = {
  key: 1,
  "data-testid": "number-range-hint",
  class: "text-(length:--size-xs) leading-(--line-height-s) text-(--text-text-body-subtle) dark:text-(--colors-text-body-subtle) m-0"
}, n4 = /* @__PURE__ */ ye({
  __name: "NumberRangeInput",
  props: {
    minValue: { default: null },
    maxValue: { default: null },
    min: { default: 0 },
    max: { default: 100 },
    step: { default: 1 },
    minPlaceholder: { default: "0" },
    maxPlaceholder: { default: "" },
    separatorLabel: { default: "to" },
    showSlider: { type: Boolean, default: !0 },
    disabled: { type: Boolean, default: !1 },
    minAriaLabel: { default: "Minimum value" },
    maxAriaLabel: { default: "Maximum value" },
    minLabel: { default: void 0 },
    maxLabel: { default: void 0 },
    clampInputToBounds: { type: Boolean, default: !0 },
    dataMin: { default: null },
    dataMax: { default: null },
    hintLabel: { default: "" }
  },
  emits: ["update:minValue", "update:maxValue"],
  setup(e, { emit: n }) {
    const t = e, a = Ve(), l = Ve(), r = n, o = (L) => Math.max(t.min, Math.min(L, t.max)), i = E(o(t.minValue ?? t.min)), s = E(o(t.maxValue ?? t.max));
    Ie(
      () => t.minValue,
      (L) => {
        i.value = o(L ?? t.min);
      }
    ), Ie(
      () => t.maxValue,
      (L) => {
        s.value = o(L ?? t.max);
      }
    );
    const d = p(() => t.max - t.min || 1), u = p(() => (i.value - t.min) / d.value * 100), f = p(() => (s.value - t.min) / d.value * 100), b = p(() => ({
      left: `${u.value}%`,
      width: `${f.value - u.value}%`
    })), h = p(() => u.value > 50), m = p(
      () => t.dataMin != null && t.dataMax != null && t.dataMax > t.dataMin
    ), x = p(
      () => t.dataMin != null ? Math.max(0, Math.min(100, (t.dataMin - t.min) / d.value * 100)) : 0
    ), y = p(
      () => t.dataMax != null ? Math.max(0, Math.min(100, (t.dataMax - t.min) / d.value * 100)) : 100
    );
    function w(L) {
      const A = L.target, R = Number(A.value), z = Math.min(R, s.value - t.step);
      i.value = z, R !== z && (A.value = String(z)), r("update:minValue", z);
    }
    function S(L) {
      const A = L.target, R = Number(A.value), z = Math.max(R, i.value + t.step);
      s.value = z, R !== z && (A.value = String(z)), r("update:maxValue", z);
    }
    function $(L) {
      const A = L.target, R = A.value;
      if (R === "") {
        r("update:minValue", null);
        return;
      }
      const z = Number(R);
      if (Number.isFinite(z))
        if (i.value = o(z), t.clampInputToBounds) {
          const D = o(z);
          z !== D && (A.value = String(D)), r("update:minValue", D);
        } else
          r("update:minValue", z);
    }
    function T(L) {
      const A = L.target, R = A.value;
      if (R === "") {
        r("update:maxValue", null);
        return;
      }
      const z = Number(R);
      if (Number.isFinite(z))
        if (s.value = o(z), t.clampInputToBounds) {
          const D = o(z);
          z !== D && (A.value = String(D)), r("update:maxValue", D);
        } else
          r("update:maxValue", z);
    }
    return (L, A) => (c(), g("div", Gz, [
      e.showSlider ? (c(), g("div", Kz, [
        A[0] || (A[0] = v("div", { class: "absolute top-1/2 -translate-y-1/2 w-full h-2 rounded-(--border-border-radius-rounded-base) bg-(--background-background-gray)" }, null, -1)),
        m.value ? (c(), g(se, { key: 0 }, [
          v("div", {
            "data-testid": "number-range-data-marker-min",
            class: "absolute top-1/2 -translate-y-1/2 h-3 w-px bg-(--border-border-base-soft) dark:bg-(--colors-border-base-soft) opacity-80 pointer-events-none",
            style: Ne({ left: `${x.value}%` }),
            "aria-hidden": "true"
          }, null, 4),
          v("div", {
            "data-testid": "number-range-data-marker-max",
            class: "absolute top-1/2 -translate-y-1/2 h-3 w-px bg-(--border-border-base-soft) dark:bg-(--colors-border-base-soft) opacity-80 pointer-events-none",
            style: Ne({ left: `${y.value}%` }),
            "aria-hidden": "true"
          }, null, 4)
        ], 64)) : k("", !0),
        v("div", {
          class: "absolute top-1/2 -translate-y-1/2 h-2 rounded-(--border-border-radius-rounded-base)",
          style: Ne({ ...b.value, background: "linear-gradient(36deg, #716FF2 11%, #52DBF5 87%)" })
        }, null, 4),
        v("input", {
          type: "range",
          min: e.min,
          max: e.max,
          step: e.step,
          value: i.value,
          disabled: e.disabled,
          "aria-label": e.minAriaLabel,
          class: C(["range-thumb absolute top-0 left-0 w-full h-5 appearance-none bg-transparent pointer-events-none", h.value ? "z-30" : "z-20"]),
          onInput: w
        }, null, 42, Yz),
        v("input", {
          type: "range",
          min: e.min,
          max: e.max,
          step: e.step,
          value: s.value,
          disabled: e.disabled,
          "aria-label": e.maxAriaLabel,
          class: C(["range-thumb absolute top-0 left-0 w-full h-5 appearance-none bg-transparent pointer-events-none", h.value ? "z-20" : "z-30"]),
          onInput: S
        }, null, 42, Jz)
      ])) : k("", !0),
      v("div", {
        class: C(["flex gap-6 w-full", e.minLabel || e.maxLabel ? "items-end" : "items-center"])
      }, [
        v("div", Zz, [
          e.minLabel ? (c(), K(xt, {
            key: 0,
            text: e.minLabel,
            "input-id": I(a),
            "test-id": "number-range-min-label"
          }, null, 8, ["text", "input-id"])) : k("", !0),
          v("input", {
            id: I(a),
            type: "number",
            "data-testid": "number-range-min",
            value: e.minValue ?? "",
            min: e.clampInputToBounds ? e.min : void 0,
            max: e.clampInputToBounds ? e.max : void 0,
            step: e.step,
            placeholder: e.minPlaceholder,
            disabled: e.disabled,
            "aria-label": e.minLabel ? void 0 : e.minAriaLabel,
            class: "w-full bg-(--background-background-white) border border-solid border-(--border-border-base-soft) rounded-(--border-border-radius-rounded-l) px-3 py-2 text-(length:--size-m) font-inter leading-(--line-height-l) text-(--text-text-black-default) placeholder:text-(--text-text-body-subtle) outline-none focus:border-royalblue transition-colors disabled:opacity-50",
            onChange: $
          }, null, 40, Xz)
        ]),
        v("span", Qz, P(e.separatorLabel), 1),
        v("div", _z, [
          e.maxLabel ? (c(), K(xt, {
            key: 0,
            text: e.maxLabel,
            "input-id": I(l),
            "test-id": "number-range-max-label"
          }, null, 8, ["text", "input-id"])) : k("", !0),
          v("input", {
            id: I(l),
            type: "number",
            "data-testid": "number-range-max",
            value: e.maxValue ?? "",
            min: e.clampInputToBounds ? e.min : void 0,
            max: e.clampInputToBounds ? e.max : void 0,
            step: e.step,
            placeholder: e.maxPlaceholder,
            disabled: e.disabled,
            "aria-label": e.maxLabel ? void 0 : e.maxAriaLabel,
            class: "w-full bg-(--background-background-white) border border-solid border-(--border-border-base-soft) rounded-(--border-border-radius-rounded-l) px-3 py-2 text-(length:--size-m) font-inter leading-(--line-height-l) text-(--text-text-black-default) placeholder:text-(--text-text-body-subtle) outline-none focus:border-royalblue transition-colors disabled:opacity-50",
            onChange: T
          }, null, 40, e4)
        ])
      ], 2),
      e.hintLabel ? (c(), g("p", t4, P(e.hintLabel), 1)) : k("", !0)
    ]));
  }
}), Iv = /* @__PURE__ */ lt(n4, [["__scopeId", "data-v-61d0ad59"]]), a4 = { class: "inline-flex min-w-0 items-center gap-1" }, l4 = { class: "inline-flex min-w-0 items-center gap-0.5" }, r4 = ["for"], o4 = {
  key: 0,
  "aria-hidden": "true",
  class: "text-(length:--size-m) leading-(--line-height-l) font-(--weight-medium) text-(--icons-icon-dark-default) dark:text-(--icons-icon-white-default)"
}, od = /* @__PURE__ */ ye({
  __name: "ToggleLabel",
  props: {
    forId: {},
    text: {},
    required: { type: Boolean, default: !1 },
    labelTooltip: { default: void 0 },
    unavailable: { type: Boolean, default: !1 }
  },
  setup(e) {
    return (n, t) => (c(), g("span", a4, [
      v("span", l4, [
        v("label", {
          for: e.forId,
          class: C(["min-w-0 text-(length:--size-m) leading-(--line-height-l) font-(--weight-medium) text-(--colors-text-heading) dark:text-(--colors-text-white-default)", e.unavailable ? "cursor-not-allowed" : "cursor-pointer"])
        }, P(e.text), 11, r4),
        e.required ? (c(), g("span", o4, "*")) : k("", !0)
      ]),
      e.labelTooltip ? (c(), K(ft, {
        key: 0,
        text: e.labelTooltip,
        as: "span",
        "labels-trigger": "",
        role: "img",
        tabindex: "0",
        "aria-label": e.labelTooltip,
        class: "shrink-0 rounded-(--border-border-radius-rounded-full) focus-visible:shadow-(--shadow-focus-l) focus-visible:outline-2 focus-visible:outline-transparent"
      }, {
        default: ve(() => [...t[0] || (t[0] = [
          v("i", {
            class: "ri-question-line text-(length:--icon-size-xs) leading-none text-(--icons-icon-dark-default) dark:text-(--icons-icon-white-default)",
            "aria-hidden": "true"
          }, null, -1)
        ])]),
        _: 1
      }, 8, ["text", "aria-label"])) : k("", !0)
    ]));
  }
}), Tv = Symbol("ToggleGroup"), i4 = { class: "flex min-w-0 flex-[1_1_11rem] flex-col gap-2" }, s4 = { class: "flex h-8 w-22.5 shrink-0 items-center" }, d4 = ["for"], u4 = ["id"], c4 = ["data-testid"], f4 = ["id", "name", "checked", "disabled", "aria-disabled", "onChange"], h4 = {
  key: 0,
  class: "whitespace-nowrap text-(length:--size-m) leading-(--line-height-l) font-(--weight-medium) text-(--colors-text-heading) dark:text-(--colors-text-white-default)"
}, b4 = { class: "sr-only" }, g4 = { class: "flex min-w-0 items-start justify-between gap-2" }, p4 = ["id"], m4 = ["id"], v4 = { class: "flex min-w-0 flex-[1_1_11rem] items-center gap-2.5" }, x4 = { class: "flex min-w-0 flex-1 flex-col gap-0.5" }, y4 = ["id"], k4 = "label, a, button, input, select, textarea, summary, [role=button], [role=link], [tabindex]", id = "text-(length:--size-m) leading-(--line-height-l) font-(--weight-regular) text-(--colors-text-body) dark:text-(--colors-text-white-secondary)", rr = "min-w-0 rounded-(--border-border-radius-rounded-l) border border-(--colors-border-base-soft) bg-(--colors-background-white) shadow-(--blur-shadow-xs) dark:border-(--colors-border-base) dark:bg-(--colors-background-black-default)", uq = /* @__PURE__ */ ye({
  __name: "ToggleInput",
  props: {
    modelValue: { type: Boolean, default: !1 },
    label: {},
    description: { default: void 0 },
    type: { default: void 0 },
    icon: { default: void 0 },
    required: { type: Boolean, default: !1 },
    labelTooltip: { default: void 0 },
    leftLabel: { default: void 0 },
    rightLabel: { default: void 0 },
    leftIcon: { default: void 0 },
    rightIcon: { default: void 0 },
    disabled: { type: Boolean, default: !1 },
    ariaDisabled: { type: Boolean, default: !1 },
    id: { default: void 0 },
    ariaDescribedby: { default: void 0 }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: n }) {
    const t = e, a = n, l = Ft(Tv, void 0), r = p(() => t.type ?? (l == null ? void 0 : l.value) ?? "advanced"), o = p(() => r.value === "left-right-label" || r.value === "left-right-icons"), i = p(() => r.value !== "default" && !o.value), s = p(() => t.disabled || t.ariaDisabled), d = Ve(), u = p(() => t.id ?? d), f = p(() => `${u.value}-description`), b = p(() => {
      const D = !!t.description && !o.value, V = [t.ariaDescribedby, D ? f.value : void 0].filter(Boolean);
      return V.length > 0 ? V.join(" ") : void 0;
    }), h = p(() => ({
      id: u.value,
      modelValue: t.modelValue,
      disabled: t.disabled,
      ariaDisabled: t.ariaDisabled,
      "aria-describedby": b.value,
      "onUpdate:modelValue": (D) => a("update:modelValue", D)
    })), m = xs("toggleSwitch");
    function x(D) {
      var W;
      const V = D.currentTarget, Y = D.target;
      if (D.detail > 1) {
        const G = Y == null ? void 0 : Y.closest("label");
        G && V.contains(G) && D.preventDefault();
        return;
      }
      if (!i.value) return;
      const _ = (W = m.value) == null ? void 0 : W.$el;
      if (!_ || !Y || _.contains(Y) || _.disabled) return;
      const j = Y.closest(k4);
      if (j && V.contains(j)) return;
      const M = window.getSelection();
      M && !M.isCollapsed && V.contains(M.anchorNode) || (D.stopPropagation(), _.click());
    }
    const y = xs("leftRadio"), w = xs("rightRadio"), S = p(() => [
      { key: "left", right: !1, text: t.leftLabel, icon: t.leftIcon },
      { key: "right", right: !0, text: t.rightLabel, icon: t.rightIcon }
    ]);
    function $(D) {
      t.ariaDisabled && D.preventDefault();
    }
    function T(D, V = !1) {
      var Y, _;
      s.value || t.modelValue === D || (a("update:modelValue", D), V && ((_ = (Y = (D ? w : y).value) == null ? void 0 : Y[0]) == null || _.focus()));
    }
    async function L(D) {
      var Y;
      T(D), await qe();
      const V = (Y = (t.modelValue ? w : y).value) == null ? void 0 : Y[0];
      V && !V.checked && (V.checked = !0);
    }
    const A = p(() => {
      const D = s.value ? "" : " cursor-pointer";
      switch (r.value) {
        case "default":
          return "flex min-w-0 items-start gap-2";
        case "simple":
          return `${rr} flex items-start gap-2.5 p-4${D}`;
        case "logo":
          return `${rr} flex flex-wrap items-start justify-between gap-x-16 gap-y-3 p-4${D}`;
        case "title-toggle":
          return `${rr} flex flex-col gap-2 p-4${D}`;
        case "toggle-text":
          return `${rr} flex items-center gap-2.5 px-4 py-3${D}`;
        case "left-right-label":
        case "left-right-icons":
          return "group inline-flex items-center gap-3";
        default:
          return `${rr} flex flex-wrap items-center justify-between gap-x-16 gap-y-3 px-4 py-3${D}`;
      }
    }), R = p(() => s.value ? "relative flex cursor-not-allowed" : "relative flex cursor-pointer"), z = p(
      () => o.value ? { role: "radiogroup", "aria-label": t.label, "aria-describedby": t.ariaDescribedby } : {}
    );
    return (D, V) => (c(), g("div", Oe({ class: A.value }, z.value, { onClick: x }), [
      r.value === "logo" ? (c(), g(se, { key: 0 }, [
        v("div", i4, [
          v("div", s4, [
            $e(D.$slots, "logo")
          ]),
          v("label", {
            for: u.value,
            class: "sr-only"
          }, P(e.label), 9, d4),
          e.description ? (c(), g("p", {
            key: 0,
            id: f.value,
            class: "text-(length:--size-l) leading-(--line-height-xxl) font-(--weight-regular) text-(--colors-text-body) dark:text-(--colors-text-white-secondary)"
          }, P(e.description), 9, u4)) : k("", !0)
        ]),
        te(Ga, Oe({
          ref_key: "toggleSwitch",
          ref: m
        }, h.value), null, 16)
      ], 64)) : o.value ? (c(!0), g(se, { key: 1 }, Me(S.value, (Y) => (c(), g(se, {
        key: Y.key
      }, [
        Y.right ? (c(), K(Ga, {
          key: 0,
          type: "default",
          presentational: "",
          "aria-hidden": "true",
          "data-testid": "toggle-input-switch",
          class: C(["group-has-focus-visible:shadow-(--shadow-focus-l) group-has-focus-visible:outline-2 group-has-focus-visible:outline-transparent", s.value ? "cursor-not-allowed" : "cursor-pointer"]),
          "model-value": e.modelValue,
          disabled: e.disabled,
          "aria-disabled": e.ariaDisabled,
          onClick: V[0] || (V[0] = (_) => T(!e.modelValue, !0))
        }, null, 8, ["class", "model-value", "disabled", "aria-disabled"])) : k("", !0),
        v("label", {
          class: C(R.value),
          "data-testid": `toggle-input-${Y.key}`
        }, [
          v("input", {
            id: `${u.value}-${Y.key}`,
            ref_for: !0,
            ref: Y.right ? "rightRadio" : "leftRadio",
            type: "radio",
            class: "absolute inset-0 m-0 size-full cursor-[inherit] appearance-none opacity-0",
            name: u.value,
            checked: e.modelValue === Y.right,
            disabled: e.disabled,
            "aria-disabled": e.ariaDisabled ? "true" : void 0,
            onClick: $,
            onChange: (_) => L(Y.right)
          }, null, 40, f4),
          r.value === "left-right-label" ? (c(), g("span", h4, P(Y.text), 1)) : (c(), g(se, { key: 1 }, [
            v("i", {
              "aria-hidden": "true",
              class: C([Y.icon, "block text-(length:--icon-size-md) leading-none text-(--icons-icon-dark-default) dark:text-(--icons-icon-white-default)"])
            }, null, 2),
            v("span", b4, P(Y.text), 1)
          ], 64))
        ], 10, c4)
      ], 64))), 128)) : r.value === "title-toggle" ? (c(), g(se, { key: 2 }, [
        v("div", g4, [
          te(od, {
            "for-id": u.value,
            text: e.label,
            required: e.required,
            "label-tooltip": e.labelTooltip,
            unavailable: s.value
          }, null, 8, ["for-id", "text", "required", "label-tooltip", "unavailable"]),
          te(Ga, Oe({
            ref_key: "toggleSwitch",
            ref: m
          }, h.value), null, 16)
        ]),
        e.description ? (c(), g("p", {
          key: 0,
          id: f.value,
          class: C(id)
        }, P(e.description), 9, p4)) : k("", !0)
      ], 64)) : r.value === "default" || r.value === "simple" || r.value === "toggle-text" ? (c(), g(se, { key: 3 }, [
        te(Ga, Oe({
          ref_key: "toggleSwitch",
          ref: m
        }, h.value), null, 16),
        v("div", {
          class: C(["flex min-w-0 flex-col", r.value === "default" ? "gap-0.5" : r.value === "simple" ? "flex-1 gap-1" : "flex-1 gap-0.5"])
        }, [
          te(od, {
            "for-id": u.value,
            text: e.label,
            required: e.required,
            "label-tooltip": e.labelTooltip,
            unavailable: s.value
          }, null, 8, ["for-id", "text", "required", "label-tooltip", "unavailable"]),
          e.description ? (c(), g("p", {
            key: 0,
            id: f.value,
            class: C(id)
          }, P(e.description), 9, m4)) : k("", !0)
        ], 2)
      ], 64)) : (c(), g(se, { key: 4 }, [
        v("div", v4, [
          e.icon ? (c(), K(Xt, {
            key: 0,
            icon: e.icon,
            color: "white",
            size: "md",
            type: "square"
          }, null, 8, ["icon"])) : k("", !0),
          v("div", x4, [
            te(od, {
              "for-id": u.value,
              text: e.label,
              required: e.required,
              "label-tooltip": e.labelTooltip,
              unavailable: s.value
            }, null, 8, ["for-id", "text", "required", "label-tooltip", "unavailable"]),
            e.description ? (c(), g("p", {
              key: 0,
              id: f.value,
              class: C(id)
            }, P(e.description), 9, y4)) : k("", !0)
          ])
        ]),
        te(Ga, Oe({
          ref_key: "toggleSwitch",
          ref: m
        }, h.value), null, 16)
      ], 64))
    ], 16));
  }
}), w4 = ["aria-label"], cq = /* @__PURE__ */ ye({
  __name: "ToggleGroup",
  props: {
    type: { default: "default" },
    ariaLabel: { default: void 0 }
  },
  setup(e) {
    const n = e, t = {
      default: "simple",
      integration: "logo",
      settings: "advanced"
    };
    return nn(
      Tv,
      p(() => t[n.type])
    ), (a, l) => (c(), g("div", {
      role: "group",
      "aria-label": e.ariaLabel,
      class: "flex min-w-0 flex-col gap-4"
    }, [
      $e(a.$slots, "default")
    ], 8, w4));
  }
}), C4 = ["value", "placeholder", "aria-label", "title", "disabled"], S4 = ["aria-label"], $4 = /* @__PURE__ */ ye({
  __name: "CollapsibleSearch",
  props: {
    modelValue: {},
    placeholder: { default: "Search..." },
    labels: { default: void 0 },
    maxWidth: { default: "175px" },
    disabled: { type: Boolean, default: !1 },
    autoFocus: { type: Boolean, default: !0 },
    debounce: { default: 0 }
  },
  emits: ["update:modelValue", "expand", "collapse", "clear", "pending"],
  setup(e, { expose: n, emit: t }) {
    const a = e, l = t, r = { closeSearch: "Clear search" }, o = p(() => ({ ...r, ...a.labels })), i = E(a.modelValue.length > 0), s = E(null), d = E(null), u = E(a.modelValue);
    let f;
    function b() {
      f !== void 0 && (clearTimeout(f), f = void 0, l("pending", !1));
    }
    function h(L) {
      b(), L !== a.modelValue && l("update:modelValue", L);
    }
    Ie(
      () => a.modelValue,
      (L) => {
        L.length > 0 && (i.value = !0), L !== u.value && (b(), u.value = L);
      }
    ), gt(b);
    function m() {
      a.disabled || (i.value = !0, l("expand"), a.autoFocus && qe(() => {
        var L;
        return (L = s.value) == null ? void 0 : L.focus();
      }));
    }
    function x() {
      u.value.length > 0 || (i.value = !1, l("collapse"));
    }
    function y() {
      b(), u.value = "", l("update:modelValue", ""), l("clear"), i.value = !1, qe(() => {
        var L, A;
        return (A = (L = d.value) == null ? void 0 : L.$el) == null ? void 0 : A.focus();
      });
    }
    function w(L) {
      L.preventDefault(), L.stopPropagation(), y();
    }
    function S(L) {
      if (u.value = L.target.value, a.debounce <= 0 || u.value === "") {
        h(u.value);
        return;
      }
      if (u.value === a.modelValue) {
        b();
        return;
      }
      f === void 0 ? l("pending", !0) : clearTimeout(f), f = setTimeout(() => h(u.value), a.debounce);
    }
    function $() {
      f !== void 0 && h(u.value);
    }
    function T(L) {
      b(), u.value = L;
    }
    return n({ discardPending: T }), (L, A) => i.value ? (c(), K(wt, {
      key: 1,
      "enter-active-class": "transition-all duration-200 ease-out",
      "enter-from-class": "opacity-0 w-0!",
      "enter-to-class": "opacity-100",
      "leave-active-class": "transition-all duration-150 ease-in",
      "leave-from-class": "opacity-100",
      "leave-to-class": "opacity-0 w-0!"
    }, {
      default: ve(() => [
        v("div", {
          class: "flex h-8 items-center gap-2 p-2 rounded-(--border-border-radius-rounded-l) overflow-hidden group w-(--cs-w)",
          style: Ne({ "--cs-w": e.maxWidth })
        }, [
          v("i", {
            class: C(["ri-search-line text-(length:--icon-size-sm) leading-(--icon-size-sm) shrink-0 transition-colors text-(--icons-icon-dark-default) dark:text-(--icons-icon-white-default)", u.value ? "group-focus-within:text-(--icons-icon-accent)" : ""]),
            "aria-hidden": "true"
          }, null, 2),
          v("input", {
            ref_key: "inputRef",
            ref: s,
            type: "text",
            "data-testid": "collapsible-search-input",
            value: u.value,
            placeholder: e.placeholder,
            "aria-label": o.value.input ?? e.placeholder,
            title: u.value || void 0,
            disabled: e.disabled,
            class: "flex-1 min-w-0 bg-transparent border-0 outline-none focus:outline-none focus:ring-0 p-0 text-(length:--size-sm) leading-(--line-height-l) text-(--text-text-black-default) dark:text-(--colors-text-white-default) placeholder:text-(--text-text-body-subtle) dark:placeholder:text-(--colors-text-white-secondary) text-ellipsis overflow-hidden",
            onInput: S,
            onBlur: x,
            onKeydown: [
              ut(w, ["escape"]),
              ut($, ["enter"])
            ]
          }, null, 40, C4),
          v("button", {
            type: "button",
            class: "shrink-0 inline-flex items-center justify-center text-(--icons-icon-dark-default) dark:text-(--icons-icon-white-default) cursor-pointer rounded-(--border-border-radius-rounded-xs) focus-visible:shadow-(--shadow-focus-l) focus-visible:outline-2 focus-visible:outline-transparent",
            "aria-label": o.value.closeSearch,
            "data-testid": "collapsible-search-clear",
            onClick: y
          }, [...A[0] || (A[0] = [
            v("i", {
              class: "ri-close-circle-line text-(length:--icon-size-sm) leading-(--icon-size-sm)",
              "aria-hidden": "true"
            }, null, -1)
          ])], 8, S4)
        ], 4)
      ]),
      _: 1
    })) : (c(), K(Re, {
      key: 0,
      ref_key: "toggleRef",
      ref: d,
      variant: "tertiary",
      "icon-left": "ri-search-line",
      "icon-only": "",
      size: "xs",
      class: "[&_i]:text-(length:--icon-size-sm) [&_i]:leading-(--icon-size-sm)",
      "aria-label": e.placeholder,
      disabled: e.disabled,
      "data-testid": "collapsible-search-toggle",
      onClick: m
    }, null, 8, ["aria-label", "disabled"]));
  }
}), I4 = ["id", "value", "placeholder", "aria-labelledby", "aria-label", "aria-invalid", "aria-required", "aria-describedby", "disabled", "readonly"], T4 = /* @__PURE__ */ ye({
  __name: "TagInput",
  props: {
    modelValue: {},
    placeholder: { default: void 0 },
    ariaLabel: { default: void 0 },
    label: { default: void 0 },
    required: { type: Boolean, default: !1 },
    labelTooltip: { default: void 0 },
    hint: { default: void 0 },
    removeLabel: { default: void 0 },
    truncate: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    readonly: { type: Boolean, default: !1 },
    error: { default: void 0 },
    success: { type: Boolean, default: !1 },
    size: { default: "md" },
    fullWidth: { type: Boolean, default: !1 },
    width: { default: void 0 }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: n }) {
    const t = e, a = n, l = E(""), r = Ve(), o = p(() => `${r}-error`), i = `${r}-hint`, s = p(() => t.label ? `${r}-label` : void 0), d = p(() => {
      const N = [];
      return t.hint && N.push(i), t.error && N.push(o.value), N.length > 0 ? N.join(" ") : void 0;
    }), u = E(!1), f = E(null), b = E(null), h = E(null), m = E(null), x = p(() => t.disabled || t.readonly), y = p(() => t.modelValue.length > 0 || l.value !== ""), w = p(() => t.fullWidth || t.width === void 0), S = p(() => t.size === "lg" || t.size === "xl" ? "lg" : "sm"), $ = p(() => t.disabled ? "disabled" : "white"), T = p(() => t.disabled ? void 0 : "border-(--border-border-base-medium)!");
    function L(N) {
      N.currentTarget.contains(N.relatedTarget) || (u.value = !1);
    }
    const A = p(() => !u.value && t.modelValue.length > 0), R = E(Number.POSITIVE_INFINITY), z = p(
      () => A.value ? Math.max(0, t.modelValue.length - R.value) : 0
    ), D = p(() => t.modelValue.slice(t.modelValue.length - z.value)), V = (N) => {
      var ke, ee;
      if (t.disabled) return;
      const J = N.currentTarget, be = (ke = N.target) == null ? void 0 : ke.closest('button, a, [role="button"], input, [tabindex]');
      be && be !== J && J.contains(be) || (N.preventDefault(), (ee = h.value) == null || ee.focus());
    }, Y = (N) => A.value && N >= R.value;
    function _() {
      var ue, O;
      const N = (ue = m.value) == null ? void 0 : ue.$el;
      if (!N || !A.value) return;
      const J = getComputedStyle(N), be = parseFloat(J.columnGap) || 0, ke = N.clientWidth - (parseFloat(J.paddingLeft) || 0) - (parseFloat(J.paddingRight) || 0), ee = Array.from(N.querySelectorAll(":scope > [data-tag-chip]")).map(
        (U) => U.getBoundingClientRect().width
      );
      if (ee.reduce((U, Q, ae) => U + Q + (ae > 0 ? be : 0), 0) <= ke) {
        R.value = ee.length;
        return;
      }
      let ge = ((O = N.querySelector(":scope > [data-tag-overflow]")) == null ? void 0 : O.getBoundingClientRect().width) ?? 0, re = 0;
      for (const U of ee) {
        if (ge + be + U > ke) break;
        ge += be + U, re++;
      }
      R.value = re;
    }
    let j = null, M = 0;
    const W = () => {
      cancelAnimationFrame(M), M = requestAnimationFrame(_);
    };
    function G() {
      var J;
      const N = (J = m.value) == null ? void 0 : J.$el;
      !j || !N || (j.disconnect(), j.observe(N), N.querySelectorAll(":scope > [data-tag-chip], :scope > [data-tag-overflow]").forEach((be) => j.observe(be)));
    }
    ot(() => {
      typeof ResizeObserver < "u" && (j = new ResizeObserver(W)), G(), _();
    }), qi(() => {
      G(), _();
    }), gt(() => {
      j == null || j.disconnect(), j = null, cancelAnimationFrame(M);
    });
    function B(N) {
      l.value = "";
      const J = N.split(",").map((ke) => ke.trim()).filter((ke) => ke.length > 0), be = [...t.modelValue];
      for (const ke of J)
        be.includes(ke) || be.push(ke);
      be.length !== t.modelValue.length && a("update:modelValue", be);
    }
    function F(N) {
      const J = N.target.value;
      if (J.endsWith(",")) {
        B(J.slice(0, -1));
        return;
      }
      l.value = J;
    }
    function X(N) {
      N.preventDefault(), !t.readonly && B(l.value);
    }
    function H() {
      t.readonly || l.value === "" && t.modelValue.length > 0 && a("update:modelValue", t.modelValue.slice(0, -1));
    }
    function q(N) {
      var J;
      a("update:modelValue", t.modelValue.filter((be, ke) => ke !== N)), (J = h.value) == null || J.focus();
    }
    return (N, J) => (c(), g("div", {
      class: C(["flex min-w-0 flex-col gap-0.5", w.value ? "w-full" : ""]),
      style: Ne(w.value ? void 0 : { width: e.width })
    }, [
      e.label ? (c(), K(xt, {
        key: 0,
        id: s.value,
        ref_key: "labelRef",
        ref: f,
        text: e.label,
        "input-id": I(r),
        required: e.required,
        tooltip: e.labelTooltip,
        focused: u.value,
        "test-id": "tag-input-label"
      }, null, 8, ["id", "text", "input-id", "required", "tooltip", "focused"])) : k("", !0),
      te(Rn, {
        ref_key: "shellRef",
        ref: m,
        role: "group",
        "aria-labelledby": s.value,
        "aria-label": e.label ? void 0 : e.ariaLabel,
        "aria-describedby": d.value,
        class: C(["w-full", A.value ? "flex-nowrap! overflow-hidden" : ""]),
        tags: "",
        size: e.size,
        disabled: e.disabled,
        readonly: e.readonly,
        error: !!e.error,
        success: e.success,
        "has-value": y.value,
        "focus-scope": "any",
        onFocusin: J[2] || (J[2] = (be) => u.value = !0),
        onFocusout: L,
        onMousedown: V
      }, {
        default: ve(({ textClass: be }) => [
          (c(!0), g(se, null, Me(e.modelValue, (ke, ee) => (c(), g("span", {
            key: `${ke}-${ee}`,
            "data-tag-chip": "",
            class: C(["inline-flex", { "shrink-0": A.value, "order-2 invisible": Y(ee) }])
          }, [
            te(ct, {
              label: ke,
              size: S.value,
              theme: $.value,
              truncate: e.truncate,
              class: C(T.value),
              "show-close-icon": "",
              "close-icon-inactive": x.value,
              "remove-label": `${e.removeLabel ?? ""} ${ke}`.trim(),
              onClose: (oe) => q(ee)
            }, null, 8, ["label", "size", "theme", "truncate", "class", "close-icon-inactive", "remove-label", "onClose"])
          ], 2))), 128)),
          z.value > 0 ? (c(), g("span", {
            key: 0,
            "data-tag-overflow": "",
            class: "order-1 inline-flex shrink-0 cursor-pointer",
            onClick: J[0] || (J[0] = (ke) => {
              var ee;
              return (ee = h.value) == null ? void 0 : ee.focus();
            })
          }, [
            te(ct, {
              label: `+${z.value}`,
              size: S.value,
              theme: $.value,
              class: C(T.value),
              "tooltip-text": D.value.join(", ")
            }, null, 8, ["label", "size", "theme", "class", "tooltip-text"])
          ])) : k("", !0),
          v("input", {
            id: I(r),
            ref_key: "inputRef",
            ref: h,
            value: l.value,
            type: "text",
            class: C([
              "flex-1 border-0 bg-transparent p-0 outline-none focus:border-0 focus:outline-none focus:ring-0 placeholder:text-(--text-text-body-subtle) dark:placeholder:text-(--colors-text-white-secondary)",
              be,
              A.value ? "order-1 min-w-0" : "min-w-20",
              e.readonly ? "cursor-default" : ""
            ]),
            placeholder: e.modelValue.length > 0 ? void 0 : e.placeholder,
            "aria-labelledby": s.value,
            "aria-label": e.label ? void 0 : e.ariaLabel,
            "aria-invalid": e.error ? "true" : void 0,
            "aria-required": e.required ? "true" : void 0,
            "aria-describedby": d.value,
            disabled: e.disabled,
            readonly: e.readonly,
            onKeydown: [
              J[1] || (J[1] = (ke) => {
                var ee, oe;
                (ee = f.value) == null || ee.handleFieldKeydown(ke), (oe = b.value) == null || oe.handleFieldKeydown(ke);
              }),
              ut(X, ["enter"]),
              ut(H, ["delete"])
            ],
            onInput: F
          }, null, 42, I4)
        ]),
        _: 1
      }, 8, ["aria-labelledby", "aria-label", "aria-describedby", "class", "size", "disabled", "readonly", "error", "success", "has-value"]),
      te(vt, {
        ref_key: "helperRef",
        ref: b,
        focused: u.value,
        hint: e.hint,
        error: e.error,
        "hint-id": i,
        "error-id": o.value,
        "test-id-prefix": "tag-input"
      }, null, 8, ["focused", "hint", "error", "error-id"])
    ], 6));
  }
}), L4 = { class: "inline-flex max-w-full min-w-0 flex-col gap-1" }, E4 = ["aria-labelledby", "aria-label"], A4 = {
  key: 0,
  "data-otp-separator": "",
  "aria-hidden": "true",
  class: "h-0 w-3 shrink-0 border-t-(length:--border-border-width-border-base) border-(--border-border-black-default) dark:border-(--border-border-white-default)"
}, R4 = ["id", "value", "inputmode", "autocomplete", "aria-label", "aria-invalid", "aria-required", "aria-describedby", "disabled", "readonly", "onInput", "onPaste", "onKeydown"], fq = /* @__PURE__ */ ye({
  __name: "OtpInput",
  props: {
    modelValue: {},
    length: { default: 6 },
    size: { default: "md" },
    type: { default: "default" },
    numeric: { type: Boolean, default: !0 },
    label: { default: void 0 },
    ariaLabel: { default: void 0 },
    required: { type: Boolean, default: !1 },
    requiredIndicator: { default: "*" },
    labelTooltip: { default: void 0 },
    hint: { default: void 0 },
    error: { default: void 0 },
    success: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    readonly: { type: Boolean, default: !1 },
    labels: { default: void 0 }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: n }) {
    const t = e, a = n, l = { cell: "Digit {index} of {length}" }, r = p(() => ({ ...l, ...t.labels })), o = (H) => r.value.cell.replace("{index}", String(H + 1)).replace("{length}", String(t.length)), i = Ve(), s = (H) => `${i}-cell-${H}`, d = p(() => t.label ? `${i}-label` : void 0), u = `${i}-hint`, f = `${i}-error`, b = p(() => {
      const H = [];
      return t.hint && H.push(u), t.error && H.push(f), H.length > 0 ? H.join(" ") : void 0;
    }), h = (H) => Array.from({ length: t.length }, (q, N) => H[N] ?? ""), m = E(h(t.modelValue));
    Ie(
      () => [t.modelValue, t.length],
      ([H]) => {
        (H !== m.value.join("") || m.value.length !== t.length) && (m.value = h(H));
      }
    );
    const x = E([]), y = E(!1), w = E(null), S = E(null), $ = (H) => {
      const q = Array.from(H.replace(/\s/g, ""));
      return t.numeric ? q.filter((N) => /\d/.test(N)) : q;
    };
    function T() {
      a("update:modelValue", m.value.join(""));
    }
    function L(H) {
      const q = x.value[Math.max(0, Math.min(H, t.length - 1))];
      q == null || q.focus(), q == null || q.select();
    }
    function A(H, q) {
      const N = q.length >= t.length ? 0 : H, J = q.slice(0, t.length - N);
      J.forEach((be, ke) => {
        m.value[N + ke] = be;
      }), T(), L(N + J.length);
    }
    function R(H, q) {
      const N = q.target, J = q, be = J.inputType === "insertText" && J.data ? J.data : N.value, ke = $(be);
      if (ke.length > 1) {
        N.value = m.value[H], A(H, ke);
        return;
      }
      if (ke.length === 0) {
        N.value === "" ? (m.value[H] = "", T()) : N.value = m.value[H];
        return;
      }
      m.value[H] = ke[0], N.value = ke[0], T(), H < t.length - 1 && L(H + 1);
    }
    function z(H, q) {
      var J;
      if (q.preventDefault(), t.readonly || t.disabled) return;
      const N = $(((J = q.clipboardData) == null ? void 0 : J.getData("text")) ?? "");
      N.length > 0 && A(H, N);
    }
    function D(H, q) {
      var N, J;
      switch ((N = w.value) == null || N.handleFieldKeydown(q), (J = S.value) == null || J.handleFieldKeydown(q), q.key) {
        case "ArrowLeft":
          q.preventDefault(), L(H - 1);
          return;
        case "ArrowRight":
          q.preventDefault(), L(H + 1);
          return;
        case "Home":
          q.preventDefault(), L(0);
          return;
        case "End":
          q.preventDefault(), L(t.length - 1);
          return;
        case "Backspace":
          if (q.preventDefault(), t.readonly) return;
          m.value[H] ? (m.value[H] = "", T()) : H > 0 && (m.value[H - 1] = "", T(), L(H - 1));
          return;
        case "Delete":
          if (q.preventDefault(), t.readonly || !m.value[H]) return;
          m.value[H] = "", T();
          return;
      }
    }
    function V(H) {
      var q, N;
      y.value = !0, (N = (q = H.target).select) == null || N.call(q);
    }
    function Y(H) {
      H.currentTarget.contains(H.relatedTarget) || (y.value = !1);
    }
    const _ = 3, j = p(() => t.type === "separator" || t.type === "separator-spaced"), M = p(() => t.type === "spaced" || t.type === "separator-spaced"), W = p(() => {
      const H = j.value ? _ : t.length, q = [];
      for (let N = 0; N < t.length; N += H)
        q.push(Array.from({ length: Math.min(H, t.length - N) }, (J, be) => N + be));
      return q;
    }), G = {
      sm: "size-9 text-(length:--size-l) leading-(--line-height-xxl)",
      md: "size-10 text-(length:--size-l) leading-(--line-height-xxl)",
      lg: "size-12 text-(length:--size-4xl) leading-(--line-height-4xl)",
      xl: "size-13 text-(length:--size-4xl) leading-(--line-height-4xl)"
    }, B = "focus:shadow-[0_0_2px_2px_var(--background-background-hover)]", F = p(() => {
      if (t.disabled)
        return "bg-(--background-background-disabled-subtle) dark:bg-(--colors-background-disabled) border-(--border-border-disabled) dark:border-(--colors-border-disabled-subtle) text-(--text-text-disabled-light) dark:text-(--colors-text-disabled) cursor-not-allowed";
      if (t.readonly)
        return `bg-(--background-background-white-secondary-soft) dark:bg-(--colors-background-disabled) border-(--border-border-base-medium) dark:border-(--border-border-base) focus:border-(--border-border-accent) ${B} text-(--text-text-black-default) dark:text-(--text-text-white-default) cursor-default`;
      const H = "bg-(--background-background-white) dark:bg-(--background-background-black-default) text-(--text-text-black-default) dark:text-(--text-text-white-default)";
      return t.error ? `${H} border-(--border-border-error-strong) dark:border-(--border-border-error) ${B}` : t.success ? `${H} border-(--border-border-success-strong) ${B}` : `${H} border-(--border-border-base-medium) dark:border-(--border-border-base) focus:border-(--border-border-accent) ${B}`;
    });
    function X(H, q) {
      const N = M.value ? "rounded-(--border-border-radius-rounded-l)" : [
        q === 0 ? "rounded-l-(--border-border-radius-rounded-l)" : "-ml-px",
        q === H.length - 1 ? "rounded-r-(--border-border-radius-rounded-l)" : ""
      ].join(" ");
      return [
        "relative box-border border border-solid p-0 text-center font-inter font-(--weight-bold) outline-none focus:z-10 focus:outline-none focus:ring-0",
        G[t.size],
        N,
        F.value
      ];
    }
    return (H, q) => (c(), g("div", L4, [
      e.label ? (c(), K(xt, {
        key: 0,
        id: d.value,
        ref_key: "labelRef",
        ref: w,
        text: e.label,
        "input-id": s(0),
        required: e.required,
        "required-indicator": e.requiredIndicator,
        tooltip: e.labelTooltip,
        focused: y.value,
        "test-id": "otp-input-label"
      }, null, 8, ["id", "text", "input-id", "required", "required-indicator", "tooltip", "focused"])) : k("", !0),
      v("div", {
        role: "group",
        "data-otp-cells": "",
        "aria-labelledby": d.value,
        "aria-label": e.label ? void 0 : e.ariaLabel,
        class: C(["flex items-center", j.value || M.value ? "gap-2" : ""]),
        onFocusin: V,
        onFocusout: Y
      }, [
        (c(!0), g(se, null, Me(W.value, (N, J) => (c(), g(se, { key: J }, [
          J > 0 && j.value ? (c(), g("span", A4)) : k("", !0),
          v("div", {
            class: C(["flex items-center", M.value ? "gap-2" : ""])
          }, [
            (c(!0), g(se, null, Me(N, (be, ke) => (c(), g("input", {
              id: s(be),
              key: be,
              ref_for: !0,
              ref: (ee) => {
                ee && (x.value[be] = ee);
              },
              value: m.value[be],
              type: "text",
              inputmode: e.numeric ? "numeric" : "text",
              autocomplete: be === 0 ? "one-time-code" : "off",
              "aria-label": o(be),
              "aria-invalid": e.error ? "true" : void 0,
              "aria-required": e.required ? "true" : void 0,
              "aria-describedby": b.value,
              disabled: e.disabled,
              readonly: e.readonly,
              class: C(X(N, ke)),
              onInput: (ee) => R(be, ee),
              onPaste: (ee) => z(be, ee),
              onKeydown: (ee) => D(be, ee)
            }, null, 42, R4))), 128))
          ], 2)
        ], 64))), 128))
      ], 42, E4),
      te(vt, {
        ref_key: "helperRef",
        ref: S,
        focused: y.value,
        hint: e.hint,
        error: e.error,
        "hint-id": u,
        "error-id": f,
        "test-id-prefix": "otp-input"
      }, null, 8, ["focused", "hint", "error"])
    ]));
  }
}), B4 = ["data-status", "aria-label", "disabled"], hq = /* @__PURE__ */ ye({
  __name: "LookupInput",
  props: {
    placeholder: {},
    modelValue: {},
    iconLeft: {},
    size: {},
    disabled: { type: Boolean },
    success: { type: Boolean },
    type: {},
    name: {},
    id: {},
    fullWidth: { type: Boolean },
    width: {},
    label: {},
    labelTooltip: {},
    required: { type: Boolean },
    requiredIndicator: {},
    labelInline: { type: Boolean },
    ariaLabel: {},
    inputmode: {},
    autocomplete: {},
    pattern: {},
    maxlength: {},
    minlength: {},
    min: {},
    max: {},
    error: {},
    hint: {},
    ariaDescribedby: {},
    readonly: { type: Boolean },
    readonlyChrome: { type: Boolean, default: !0 },
    valueVariant: {},
    showEditIcon: { type: Boolean, default: !0 },
    variant: {},
    buttons: {},
    buttonLayout: {},
    buttonSize: {},
    innerButton: {},
    prefix: {},
    removeButton: {},
    status: { default: null },
    statusTitle: { default: void 0 },
    statusText: { default: void 0 },
    open: { type: Boolean, default: void 0 },
    labels: { default: () => ({}) }
  },
  emits: ["update:open", "update:modelValue"],
  setup(e, { emit: n }) {
    const t = e, a = n, l = {
      recognized: { icon: "ri-check-fill", color: "text-(--icons-icon-success)" },
      unrecognized: { icon: "ri-alert-line", color: "text-(--icons-icon-warning)" }
    }, r = p(() => t.statusTitle ? t.statusTitle : t.status === "unrecognized" ? t.labels.unrecognized ?? "Not recognized" : t.labels.recognized ?? "Recognized"), o = /* @__PURE__ */ new Set(["status", "statusTitle", "statusText", "open", "labels"]), i = p(
      () => Object.fromEntries(Object.entries(t).filter(([d]) => !o.has(d)))
    ), s = p(() => t.labels.clear ? { clear: t.labels.clear } : void 0);
    return (d, u) => (c(), K(zt, Oe(i.value, {
      labels: s.value,
      "onUpdate:modelValue": u[1] || (u[1] = (f) => a("update:modelValue", f))
    }), _n({ _: 2 }, [
      e.status ? {
        name: "iconRight",
        fn: ve(({ iconBoxClass: f }) => [
          te($v, {
            header: r.value,
            position: "top",
            delay: 0,
            open: e.open,
            disabled: !e.statusText || e.disabled,
            "onUpdate:open": u[0] || (u[0] = (b) => a("update:open", b))
          }, {
            trigger: ve(({ triggerProps: b }) => [
              v("button", Oe({ type: "button" }, b, {
                "data-testid": "lookup-input-status",
                "data-status": e.status,
                "aria-label": r.value,
                disabled: e.disabled,
                class: [
                  f,
                  l[e.status].color,
                  "rounded-(--border-border-radius-rounded-xs) focus-visible:shadow-(--shadow-focus-l) focus-visible:outline-2 focus-visible:outline-transparent"
                ]
              }), [
                v("i", {
                  class: C(l[e.status].icon),
                  "aria-hidden": "true"
                }, null, 2)
              ], 16, B4)
            ]),
            default: ve(() => [
              at(" " + P(e.statusText), 1)
            ]),
            _: 2
          }, 1032, ["header", "open", "disabled"])
        ]),
        key: "0"
      } : void 0
    ]), 1040, ["labels"]));
  }
}), M4 = ["disabled", "aria-current"], D4 = "inline-flex h-9 min-w-9 shrink-0 items-center justify-center whitespace-nowrap rounded-full border border-solid px-[calc(--spacing(2.5)-1px)] text-(length:--size-m) leading-(--line-height-m) font-(--weight-semi-bold) focus-visible:outline-hidden focus-visible:shadow-(--shadow-focus-l)", z4 = "cursor-pointer border-(--border-border-white-default) bg-(--background-background-white) text-(--text-text-black-default) hover:border-(--border-border-hover) hover:bg-(--background-background-hover) dark:border-(--colors-border-base) dark:bg-(--colors-background-black-default) dark:text-(--colors-text-white-default) dark:hover:border-(--border-border-hover) dark:hover:bg-(--background-background-hover) dark:hover:text-(--text-text-black-default)", O4 = "cursor-default border-(--border-border-black-default) bg-(--background-background-black-default) text-(--icons-icon-white-default) dark:border-(--background-background-white) dark:bg-(--background-background-white) dark:text-(--text-text-black-default)", P4 = "cursor-not-allowed border-(--border-border-disabled) bg-(--components-button-button-disabled) text-(--icons-icon-disabled-strong)", F4 = /* @__PURE__ */ ye({
  __name: "PageNumber",
  props: {
    page: {},
    active: { type: Boolean },
    disabled: { type: Boolean }
  },
  emits: ["select"],
  setup(e, { emit: n }) {
    const t = n;
    return (a, l) => (c(), g("button", {
      type: "button",
      disabled: e.disabled,
      "aria-current": e.active ? "page" : void 0,
      class: C([D4, e.disabled ? P4 : e.active ? O4 : z4]),
      onClick: l[0] || (l[0] = (r) => t("select", e.page))
    }, P(e.page), 11, M4));
  }
});
function Lv(e, n, t, a) {
  Ie(
    n,
    () => {
      const l = document.activeElement;
      if (!e.value || !(l instanceof HTMLButtonElement) || !l.disabled) return;
      const r = e.value.querySelector(`[data-testid="${t}"]`), o = e.value.querySelector(`[data-testid="${a}"]`), i = l === o ? r : l === r ? o : null;
      i && !i.disabled && i.focus();
    },
    { flush: "post" }
  );
}
const V4 = ["aria-label"], N4 = {
  key: 0,
  class: "@4xl/pager:col-start-1 flex min-w-0 flex-wrap items-center gap-3"
}, H4 = {
  key: 0,
  class: "flex items-center gap-3"
}, j4 = ["id", "for"], W4 = ["id", "aria-labelledby", "disabled", "aria-expanded", "aria-controls"], q4 = { class: "min-w-0 flex-1 truncate" }, U4 = ["id", "aria-labelledby"], G4 = ["aria-selected", "tabindex", "onClick", "onKeydown", "onKeyup"], K4 = {
  key: 1,
  "data-testid": "pager-items-count",
  class: "text-(length:--size-l) leading-(--line-height-xxl) font-(--weight-medium) text-(--text-text-black-default) dark:text-(--text-text-white-default)"
}, Y4 = { class: "flex min-w-0 flex-wrap items-center justify-center gap-1.5" }, J4 = {
  key: 0,
  "data-testid": "pager-ellipsis",
  class: "flex size-9 shrink-0 select-none items-center justify-center text-(length:--size-l) leading-(--line-height-xxl) font-(--weight-bold) text-(--text-text-black-default) dark:text-(--text-text-white-default)",
  "aria-hidden": "true"
}, Z4 = {
  key: 2,
  class: "@4xl/pager:col-start-3 ml-auto flex min-w-0 flex-wrap items-center justify-end gap-3"
}, X4 = { class: "flex min-w-0 items-center gap-2" }, Q4 = ["for"], _4 = ["id", "max", "disabled", "aria-invalid", "aria-describedby"], eO = ["id"], tO = 1500, nO = /* @__PURE__ */ ye({
  __name: "Pager",
  props: {
    currentPage: { default: 1 },
    totalPages: { default: 1 },
    totalItems: { default: 0 },
    itemsPerPage: { default: 10 },
    previousLabel: { default: "Previous" },
    nextLabel: { default: "Next" },
    disabled: { type: Boolean, default: !1 },
    rowsPerPageOptions: { default: () => [10, 30, 50] },
    rowsPerPageLabel: { default: "Rows per page" },
    showRowsPerPage: { type: Boolean, default: !0 },
    showItemsCount: { type: Boolean, default: !1 },
    itemsCountSeparator: { default: "of" },
    itemsCountFormat: { type: Function, default: void 0 },
    maxVisiblePages: { default: 5 },
    alwaysShowPages: { type: Boolean, default: !1 },
    pageAlign: { default: "center" },
    showGoToPage: { type: Boolean, default: !1 },
    goToPageLabel: { default: "Go to page" },
    goLabel: { default: "Go" },
    goToPageErrorLabel: { default: void 0 },
    navLabel: { default: void 0 }
  },
  emits: ["page-change", "items-per-page-change"],
  setup(e, { emit: n }) {
    const t = e, a = n, l = p(() => {
      const O = t.totalPages, U = t.currentPage, Q = Math.max(5, t.maxVisiblePages);
      if (O <= Q)
        return Array.from({ length: O }, (ie, fe) => fe + 1);
      const ae = Math.floor((Q - 5) / 2);
      if (U <= ae + 2)
        return [...Array.from({ length: Q - 2 }, (fe, de) => de + 1), "ellipsis-end", O];
      if (U >= O - ae - 1) {
        const ie = O - Q + 3;
        return [1, "ellipsis-start", ...Array.from({ length: Q - 2 }, (de, ne) => ie + ne)];
      }
      return [1, "ellipsis-start", ...Array.from({ length: ae * 2 + 1 }, (ie, fe) => U - ae + fe), "ellipsis-end", O];
    }), r = p(() => t.currentPage > 1 && !t.disabled), o = p(() => t.currentPage < t.totalPages && !t.disabled), i = p(() => {
      if (t.totalItems === 0) return `0 ${t.itemsCountSeparator} 0`;
      const O = (t.currentPage - 1) * t.itemsPerPage + 1, U = Math.min(t.currentPage * t.itemsPerPage, t.totalItems);
      return t.itemsCountFormat ? t.itemsCountFormat(O, U, t.totalItems) : `${O}-${U} ${t.itemsCountSeparator} ${t.totalItems}`;
    }), s = p(
      () => t.rowsPerPageOptions.map((O) => ({
        value: String(O),
        label: String(O)
      }))
    ), d = (O) => {
      t.disabled || O < 1 || O > t.totalPages || O !== t.currentPage && a("page-change", O);
    }, u = () => {
      r.value && d(t.currentPage - 1);
    }, f = () => {
      o.value && d(t.currentPage + 1);
    }, b = (O) => {
      a("items-per-page-change", Number(O));
    }, h = Ve(), m = Ve(), x = Mn(), y = (O) => {
      const U = x[O];
      return U && U({}).length;
    }, w = Ve(), S = E(""), $ = E(!1), T = E(0);
    let L = null;
    function A() {
      L && clearTimeout(L), L = null;
    }
    const R = p(() => t.disabled || t.totalPages === 0), z = () => {
      A(), $.value = !1;
    };
    Ie(
      [
        () => t.currentPage,
        () => t.totalPages,
        () => t.itemsPerPage,
        R,
        () => t.goToPageErrorLabel
      ],
      () => {
        L && (S.value = ""), A(), $.value = !1;
      }
    );
    const D = () => {
      A();
      const O = parseInt(S.value, 10);
      if (isNaN(O) || O < 1 || O > t.totalPages) {
        $.value = !0, T.value += 1, t.goToPageErrorLabel || (L = setTimeout(() => {
          S.value = "", $.value = !1, L = null;
        }, tO));
        return;
      }
      $.value = !1, d(O), S.value = "";
    };
    gt(() => {
      document.removeEventListener("click", ee), H(), A();
    });
    const V = E(!1), Y = E(null), _ = E(null), j = E(null);
    let M = !1;
    const W = E([]), G = E(0);
    function B(O) {
      var Q;
      const U = s.value.length;
      G.value = (O + U) % U, (Q = W.value[G.value]) == null || Q.focus();
    }
    async function F() {
      const O = s.value.findIndex((U) => U.value === String(t.itemsPerPage));
      G.value = Math.max(O, 0), V.value = !0, await qe(), B(G.value);
    }
    function X() {
      var O;
      V.value = !1, (O = _.value) == null || O.focus();
    }
    function H() {
      M = !1, document.removeEventListener("mouseup", H, !0);
    }
    function q() {
      M = !0, document.addEventListener("mouseup", H, !0);
    }
    function N() {
      H(), !t.disabled && (V.value ? X() : F());
    }
    function J(O) {
      X(), b(O);
    }
    function be(O, U) {
      const Q = {
        ArrowDown: U + 1,
        ArrowUp: U - 1,
        Home: 0,
        End: s.value.length - 1
      };
      O.key in Q && (O.preventDefault(), B(Q[O.key]));
    }
    function ke(O) {
      var Q;
      if (!V.value || M) return;
      const U = O.relatedTarget;
      U && ((Q = j.value) != null && Q.contains(U)) || (V.value = !1);
    }
    function ee(O) {
      V.value && Y.value && !Y.value.contains(O.target) && (V.value = !1);
    }
    function oe(O) {
      O.key !== "Escape" || !V.value || (O.stopPropagation(), O.preventDefault(), X());
    }
    Ie(V, (O) => {
      O ? document.addEventListener("click", ee) : document.removeEventListener("click", ee);
    });
    const ge = p(() => t.alwaysShowPages || t.totalPages > 1), re = () => !!y("info") || t.showRowsPerPage || t.showItemsCount, ue = E(null);
    return Lv(ue, () => t.currentPage, "pager-previous", "pager-next"), (O, U) => (c(), g("div", {
      ref_key: "rootRef",
      ref: ue,
      class: "@container/pager"
    }, [
      re() || ge.value || e.showGoToPage ? (c(), g("nav", {
        key: 0,
        class: "flex flex-wrap items-center justify-between gap-x-6 gap-y-3 text-(length:--size-m) leading-(--line-height-l) @4xl/pager:grid @4xl/pager:grid-cols-[1fr_auto_1fr] @4xl/pager:gap-x-0 @4xl/pager:gap-y-0",
        "aria-label": e.navLabel,
        "data-testid": "pager-nav"
      }, [
        re() ? (c(), g("div", N4, [
          y("info") ? $e(O.$slots, "info", { key: 0 }) : k("", !0),
          e.showRowsPerPage || e.showItemsCount ? (c(), g(se, { key: 1 }, [
            e.showRowsPerPage ? (c(), g("div", H4, [
              v("label", {
                id: `${I(h)}-label`,
                for: I(h),
                class: "whitespace-nowrap text-(length:--size-sm) leading-(--line-height-l) font-(--weight-medium) text-(--text-text-body) dark:text-(--text-text-white-secondary)"
              }, P(e.rowsPerPageLabel), 9, j4),
              v("div", {
                ref_key: "rowsMenuRef",
                ref: Y,
                class: "relative",
                onKeydown: oe,
                onFocusout: ke
              }, [
                te(Rn, {
                  size: "sm",
                  flush: "",
                  "has-value": "",
                  disabled: e.disabled,
                  "focus-scope": "any",
                  class: "min-w-16 shrink-0"
                }, {
                  default: ve(({ iconBoxClass: Q, iconColorClass: ae, textClass: Z }) => [
                    v("button", {
                      id: I(h),
                      ref_key: "rowsTriggerRef",
                      ref: _,
                      type: "button",
                      "aria-labelledby": `${I(h)}-label ${I(h)}`,
                      disabled: e.disabled,
                      "aria-haspopup": "listbox",
                      "aria-expanded": V.value,
                      "aria-controls": `${I(h)}-listbox`,
                      class: C([
                        "flex h-full w-full min-w-0 items-center gap-2 px-[calc(--spacing(2)-1px)] text-left focus-visible:outline-hidden focus-visible:-outline-offset-2 disabled:cursor-not-allowed",
                        Z
                      ]),
                      "data-testid": "pager-rows-trigger",
                      onMousedown: q,
                      onClick: N
                    }, [
                      v("span", q4, P(e.itemsPerPage), 1),
                      v("i", {
                        class: C(["ri-arrow-down-s-line", Q, ae]),
                        "aria-hidden": "true"
                      }, null, 2)
                    ], 42, W4)
                  ]),
                  _: 1
                }, 8, ["disabled"]),
                V.value ? (c(), g("ul", {
                  key: 0,
                  id: `${I(h)}-listbox`,
                  ref_key: "rowsListboxRef",
                  ref: j,
                  role: "listbox",
                  "aria-labelledby": `${I(h)}-label`,
                  class: C([I(_o), "absolute bottom-full left-0 z-30 mb-px min-w-full"]),
                  "data-testid": "pager-rows-menu"
                }, [
                  (c(!0), g(se, null, Me(s.value, (Q, ae) => (c(), g("li", {
                    key: Q.value,
                    ref_for: !0,
                    ref_key: "rowsOptionRefs",
                    ref: W,
                    role: "option",
                    "aria-selected": String(e.itemsPerPage) === Q.value,
                    tabindex: ae === G.value ? 0 : -1,
                    class: C([I(My), String(e.itemsPerPage) === Q.value ? I(Dy) : ""]),
                    onClick: (Z) => J(Q.value),
                    onKeydown: [
                      ut(Ue((Z) => J(Q.value), ["prevent"]), ["enter"]),
                      U[0] || (U[0] = ut(Ue(() => {
                      }, ["prevent"]), ["space"])),
                      (Z) => be(Z, ae)
                    ],
                    onKeyup: ut(Ue((Z) => J(Q.value), ["prevent"]), ["space"])
                  }, P(Q.label), 43, G4))), 128))
                ], 10, U4)) : k("", !0)
              ], 544)
            ])) : k("", !0),
            e.showItemsCount ? (c(), g("div", K4, P(i.value), 1)) : k("", !0)
          ], 64)) : k("", !0)
        ])) : k("", !0),
        ge.value ? (c(), g("div", {
          key: 1,
          class: C([
            "flex min-w-0 max-w-full items-center gap-x-4",
            e.pageAlign === "end" ? [
              "justify-end",
              // CONSTRAINT: never alone in a `1fr` side track: long page numbers would wrap there.
              e.showGoToPage ? "@4xl/pager:col-start-2" : re() ? "@4xl/pager:col-start-2 @4xl/pager:col-span-2" : "@4xl/pager:col-span-full @4xl/pager:justify-end"
            ] : "@4xl/pager:col-start-2 justify-center",
            // Alone at the start of the wrapping row, justify-between would push the centred pages to the left.
            e.pageAlign === "center" && !re() ? "mx-auto @4xl/pager:mx-0" : "",
            e.pageAlign === "end" && !re() ? "ml-auto @4xl/pager:ml-0" : ""
          ])
        }, [
          te(I(Re), {
            variant: "secondary",
            size: "sm",
            "icon-only": "",
            "icon-left": "ri-arrow-left-s-line",
            disabled: !r.value,
            "aria-label": e.previousLabel,
            "data-testid": "pager-previous",
            class: "shrink-0",
            onClick: u
          }, null, 8, ["disabled", "aria-label"]),
          v("div", Y4, [
            (c(!0), g(se, null, Me(l.value, (Q) => (c(), g(se, { key: Q }, [
              String(Q).startsWith("ellipsis") ? (c(), g("span", J4, " ... ")) : (c(), K(F4, {
                key: 1,
                page: Q,
                active: Q === e.currentPage,
                disabled: e.disabled,
                "data-testid": "pager-page",
                onSelect: d
              }, null, 8, ["page", "active", "disabled"]))
            ], 64))), 128))
          ]),
          te(I(Re), {
            variant: "secondary",
            size: "sm",
            "icon-only": "",
            "icon-right": "ri-arrow-right-s-line",
            disabled: !o.value,
            "aria-label": e.nextLabel,
            "data-testid": "pager-next",
            class: "shrink-0",
            onClick: f
          }, null, 8, ["disabled", "aria-label"])
        ], 2)) : k("", !0),
        e.showGoToPage ? (c(), g("div", Z4, [
          v("div", X4, [
            v("label", {
              for: I(m),
              class: "whitespace-nowrap text-(length:--size-sm) leading-(--line-height-l) font-(--weight-medium) text-(--text-text-body) dark:text-(--text-text-white-secondary)"
            }, P(e.goToPageLabel), 9, Q4),
            te(Rn, {
              size: "sm",
              disabled: R.value,
              error: $.value,
              "has-value": S.value !== "",
              class: "w-16 shrink-0"
            }, {
              default: ve(({ textClass: Q }) => [
                Gl(v("input", {
                  id: I(m),
                  "onUpdate:modelValue": U[1] || (U[1] = (ae) => S.value = ae),
                  type: "number",
                  min: "1",
                  max: e.totalPages,
                  disabled: R.value,
                  "aria-invalid": $.value || void 0,
                  "aria-describedby": $.value && e.goToPageErrorLabel ? I(w) : void 0,
                  "data-testid": "pager-go-to-page",
                  class: C([
                    "min-w-0 flex-1 border-0 bg-transparent p-0 outline-none focus:ring-0 disabled:cursor-not-allowed [appearance:textfield] [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none",
                    Q
                  ]),
                  onInput: z,
                  onKeydown: ut(D, ["enter"])
                }, null, 42, _4), [
                  [zb, S.value]
                ])
              ]),
              _: 1
            }, 8, ["disabled", "error", "has-value"])
          ]),
          te(I(Re), {
            variant: "primary",
            size: "xs",
            label: e.goLabel,
            disabled: R.value,
            "data-testid": "pager-go-button",
            onClick: D
          }, null, 8, ["label", "disabled"])
        ])) : k("", !0),
        e.showGoToPage && e.goToPageErrorLabel && $.value ? (c(), g("p", {
          id: I(w),
          key: T.value,
          role: "alert",
          "data-testid": "pager-go-to-page-error",
          class: "basis-full text-right text-balance text-(length:--size-sm) leading-(--line-height-l) text-(--text-text-error-strong) dark:text-(--border-border-error-subtle) @4xl/pager:col-start-3 @4xl/pager:row-start-2 @4xl/pager:pt-1"
        }, P(e.goToPageErrorLabel), 9, eO)) : k("", !0)
      ], 8, V4)) : k("", !0)
    ], 512));
  }
}), Ev = "enabled:z-10 hover:enabled:z-20 focus-visible:z-20", Av = `${Ev} rounded-r-none -mr-px`, Rv = `${Ev} rounded-l-none`, aO = ["aria-label"], lO = {
  key: 0,
  "data-testid": "compact-pager-helper",
  class: "text-center text-(length:--size-l) leading-(--line-height-xxl) font-(--weight-medium) text-(--text-text-black-default) dark:text-(--text-text-white-default)"
}, rO = { class: "inline-flex shadow-(--blur-shadow-xs)" }, oO = ["id"], iO = { class: "inline-flex" }, sO = { "aria-hidden": "true" }, dO = { class: "sr-only" }, Ro = "whitespace-nowrap text-(length:--size-sm) leading-(--line-height-l) font-(--weight-medium) text-(--text-text-black-default)", sd = "border border-solid border-(--border-border-secondary-button) bg-(--components-button-secondary-button-secondary)", bq = /* @__PURE__ */ ye({
  __name: "CompactPager",
  props: {
    type: { default: "arrows" },
    currentPage: { default: 1 },
    totalPages: { default: 1 },
    disabled: { type: Boolean, default: !1 },
    previousLabel: { default: "Previous" },
    nextLabel: { default: "Next" },
    pageStatusFormat: { type: Function, default: void 0 },
    navLabel: { default: void 0 },
    helperText: { default: void 0 },
    totalPagesFormat: { type: Function, default: void 0 },
    pageSelectLabel: { default: "Page" }
  },
  emits: ["page-change"],
  setup(e, { emit: n }) {
    const t = e, a = n, l = p(() => !t.disabled && t.currentPage > 1), r = p(() => !t.disabled && t.currentPage < t.totalPages), o = p(
      () => t.pageStatusFormat ? t.pageStatusFormat(t.currentPage, t.totalPages) : `${t.currentPage} of ${t.totalPages}`
    ), i = p(
      () => t.totalPagesFormat ? t.totalPagesFormat(t.totalPages) : `of ${t.totalPages} pages`
    ), s = Ve(), d = ($) => String($).padStart(2, "0"), u = p(
      () => Array.from({ length: Math.max(t.totalPages, 0) }, ($, T) => {
        const L = T + 1;
        return {
          label: d(L),
          active: L === t.currentPage,
          testId: `compact-pager-page-${L}`,
          onClick: () => {
            t.disabled || L > t.totalPages || L === t.currentPage || a("page-change", L);
          }
        };
      })
    );
    function f() {
      l.value && a("page-change", t.currentPage - 1);
    }
    function b() {
      r.value && a("page-change", t.currentPage + 1);
    }
    const h = {
      "arrow-buttons": { variant: "secondary", size: "xs", content: "icon", fused: !0 },
      arrows: { variant: "secondary", size: "xs", content: "icon", fused: !0 },
      "arrows-text": { variant: "text", size: "xs", content: "icon", fused: !1 },
      "arrows-number": { variant: "secondary", size: "sm", content: "icon", fused: !1 },
      "two-buttons": { variant: "secondary", size: "xs", content: "icon-label", fused: !1 },
      "buttons-helper": { variant: "secondary", size: "xs", content: "label", fused: !0 },
      "dropdown-buttons": { variant: "secondary", size: "xs", content: "icon", fused: !0 }
    };
    function m($) {
      const T = h[t.type], L = $ === "previous", A = L ? t.previousLabel : t.nextLabel, R = T.content === "label" ? void 0 : `ri-arrow-${L ? "left" : "right"}-s-line`;
      return {
        variant: T.variant,
        size: T.size,
        iconOnly: T.content === "icon",
        iconLeft: L ? R : void 0,
        iconRight: L ? void 0 : R,
        label: T.content === "icon" ? void 0 : A,
        ariaLabel: T.content === "icon" ? A : void 0,
        disabled: L ? !l.value : !r.value,
        "data-testid": `compact-pager-${$}`,
        class: T.fused ? L ? Av : Rv : void 0,
        onClick: L ? f : b
      };
    }
    const x = p(() => m("previous")), y = p(() => m("next")), w = E(null);
    Lv(w, () => t.currentPage, "compact-pager-previous", "compact-pager-next");
    const S = {
      "arrow-buttons": "shadow-(--blur-shadow-xs)",
      arrows: "shadow-(--blur-shadow-xs)",
      "arrows-text": "",
      "arrows-number": "gap-1 shadow-(--blur-shadow-xs)",
      "two-buttons": "gap-3 shadow-(--blur-shadow-xs)",
      "buttons-helper": "flex-col gap-4",
      "dropdown-buttons": "gap-3 shadow-(--blur-shadow-xs)"
    };
    return ($, T) => (c(), g("nav", {
      ref_key: "rootRef",
      ref: w,
      "aria-label": e.navLabel,
      "data-testid": "compact-pager",
      class: C(["inline-flex items-center", S[e.type]])
    }, [
      e.type === "two-buttons" || e.type === "arrow-buttons" ? (c(), g(se, { key: 0 }, [
        te(I(Re), en(tn(x.value)), null, 16),
        te(I(Re), en(tn(y.value)), null, 16)
      ], 64)) : e.type === "arrows" ? (c(), g(se, { key: 1 }, [
        te(I(Re), en(tn(x.value)), null, 16),
        v("span", {
          "data-testid": "compact-pager-status",
          class: C([
            "relative z-5 -mr-px self-stretch inline-flex items-center px-[calc(--spacing(3)-1px)] py-[calc(--spacing(1.5)-1px)]",
            sd,
            Ro
          ])
        }, P(o.value), 3),
        te(I(Re), en(tn(y.value)), null, 16)
      ], 64)) : e.type === "arrows-text" ? (c(), g(se, { key: 2 }, [
        te(I(Re), en(tn(x.value)), null, 16),
        v("span", {
          "data-testid": "compact-pager-status",
          class: C(["px-3 py-1.5", Ro, "dark:text-(--text-text-white-default)"])
        }, P(o.value), 3),
        te(I(Re), en(tn(y.value)), null, 16)
      ], 64)) : e.type === "buttons-helper" ? (c(), g(se, { key: 3 }, [
        e.helperText ? (c(), g("span", lO, P(e.helperText), 1)) : k("", !0),
        v("div", rO, [
          te(I(Re), en(tn(x.value)), null, 16),
          te(I(Re), en(tn(y.value)), null, 16)
        ])
      ], 64)) : e.type === "dropdown-buttons" ? (c(), g(se, { key: 4 }, [
        te(Sn, { items: u.value }, {
          trigger: ve(({ triggerProps: L }) => [
            te(I(Re), Oe({
              variant: "secondary",
              size: "xs",
              label: d(e.currentPage),
              "dropdown-icon": "",
              "aria-label": `${e.pageSelectLabel} ${d(e.currentPage)}`,
              "aria-describedby": I(s),
              disabled: e.disabled,
              "data-testid": "compact-pager-page-select"
            }, L), null, 16, ["label", "aria-label", "aria-describedby", "disabled"])
          ]),
          _: 1
        }, 8, ["items"]),
        v("span", {
          id: I(s),
          "data-testid": "compact-pager-status",
          class: C([
            "inline-flex items-center rounded-(--border-border-radius-rounded-base) px-[calc(--spacing(3)-1px)] py-[calc(--spacing(1.5)-1px)]",
            sd,
            Ro
          ])
        }, P(i.value), 11, oO),
        v("div", iO, [
          te(I(Re), en(tn(x.value)), null, 16),
          te(I(Re), en(tn(y.value)), null, 16)
        ])
      ], 64)) : e.type === "arrows-number" ? (c(), g(se, { key: 5 }, [
        te(I(Re), en(tn(x.value)), null, 16),
        v("span", {
          "data-testid": "compact-pager-status",
          class: C(["inline-flex size-9 shrink-0 items-center justify-center rounded-full", sd, Ro])
        }, [
          v("span", sO, P(e.currentPage), 1),
          v("span", dO, P(o.value), 1)
        ], 2),
        te(I(Re), en(tn(y.value)), null, 16)
      ], 64)) : k("", !0)
    ], 10, aO));
  }
});
function gq(e, n) {
  return {
    result: e.data.map(n),
    currentPage: e.pagination.page,
    pageSize: e.pagination.perPage,
    totalItems: e.pagination.totalItems,
    totalPages: e.pagination.totalPages
  };
}
const Xl = Symbol("tableQuery"), fs = Symbol("tableViews"), uO = Symbol(
  "tableColumnSettings"
), Bv = Symbol("tablePermissions"), Mv = Symbol("tableLabels"), Dv = Symbol("tableViewPanel");
function zv(e, n) {
  return `${e}-tab-${n}`;
}
const Ov = {
  filterButton: "Filter",
  eraseAll: "Erase all",
  hideFilters: (e) => `Hide filters (${e})`,
  showFilters: (e) => `Show filters (${e})`,
  saveView: "Save",
  shareView: "Share",
  closeSearch: "Close search",
  removeFilter: (e) => `Remove ${e} filter`,
  renameView: "Rename view",
  setAsDefault: "Set as default",
  deleteView: "Delete view",
  manageViews: "Manage views",
  viewSettingsLabel: "View settings",
  viewModeTable: "Table",
  viewModeBoard: "Board",
  viewModeCalendar: "Calendar",
  viewModeGantt: "Gantt",
  viewTabsLabel: "Pre-filtered lists",
  viewTabsOverflowLabel: "lists"
};
function io() {
  return Ft(
    Mv,
    p(() => Ov)
  );
}
const cO = ["aria-label"], fO = ["id", "aria-controls", "aria-selected", "tabindex", "data-testid", "data-active", "onClick"], hO = {
  "data-tab-label": "",
  class: "truncate min-w-0"
}, bO = {
  key: 0,
  "data-tab-count": "",
  "data-testid": "table-view-tab-count",
  class: "shrink-0 whitespace-pre"
}, rb = "ri-arrow-down-s-line", gO = "ri-information-line", pO = 6, mO = 233, dd = 1, vO = /* @__PURE__ */ ye({
  __name: "TableViewTabs",
  props: {
    tabDropdowns: { default: () => [] },
    overflowLabel: { default: void 0 }
  },
  emits: ["tab-requested", "tab-reordered"],
  setup(e, { emit: n }) {
    const t = e, a = n, l = Ft(Xl), r = Ft(fs), o = E(null), i = E(null), s = E(null), d = E(/* @__PURE__ */ new Map()), u = E([]), f = /* @__PURE__ */ new Map(), b = (re) => {
      var ue;
      return ((ue = f.get(re)) == null ? void 0 : ue.width) ?? 0;
    };
    let h = 0;
    const m = p(() => (r == null ? void 0 : r.presetViews.value) ?? []), x = io(), y = Ft(Dv, null);
    function w(re) {
      return re.count === void 0 ? re.label : `${re.label} (${re.count})`;
    }
    const S = E([]);
    function $() {
      const re = m.value.filter((ue) => {
        var U;
        const O = (U = d.value.get(ue.id)) == null ? void 0 : U.querySelector("[data-tab-label]");
        return !!O && O.scrollWidth > O.offsetWidth;
      }).map((ue) => ue.id);
      re.join("\0") !== S.value.join("\0") && (S.value = re);
    }
    const T = p(
      () => m.value.map((re) => re.id).filter((re) => !u.value.includes(re))
    ), L = p(() => z.value ? R.value : T.value[0] ?? null);
    function A(re) {
      var Q;
      const ue = T.value, O = ue.findIndex((ae) => d.value.get(ae) === document.activeElement);
      if (O < 0 || ue.length === 0) return;
      let U;
      switch (re.key) {
        case "ArrowRight":
          U = (O + 1) % ue.length;
          break;
        case "ArrowLeft":
          U = (O - 1 + ue.length) % ue.length;
          break;
        case "Home":
          U = 0;
          break;
        case "End":
          U = ue.length - 1;
          break;
        default:
          return;
      }
      re.preventDefault(), (Q = d.value.get(ue[U])) == null || Q.focus();
    }
    const R = p(() => (l == null ? void 0 : l.state.activeViewId) ?? null), z = p(() => !!R.value && m.value.some((re) => re.id === R.value)), D = p(() => t.tabDropdowns), V = p(
      () => {
        var re;
        return ((re = D.value.find((ue) => ue.overflowLabel)) == null ? void 0 : re.overflowLabel) ?? t.overflowLabel ?? x.value.viewTabsOverflowLabel;
      }
    ), Y = p(
      () => {
        var re;
        return (re = D.value.find((ue) => ue.overflowInfoTooltip)) == null ? void 0 : re.overflowInfoTooltip;
      }
    ), _ = E(
      t.tabDropdowns.reduce((re, ue, O) => {
        var U, Q;
        return (Q = (U = ue.groupButtons) == null ? void 0 : U[0]) != null && Q.value && (re[O] = ue.groupButtons[0].value), re;
      }, {})
    ), j = (re, ue) => {
      _.value[re] = ue;
    }, M = E({}), W = (re, ue) => {
      M.value[re] = ue;
    }, G = E({}), B = (re, ue) => {
      const O = G.value[re] ?? [];
      O.indexOf(ue) >= 0 ? G.value[re] = O.filter((Q) => Q !== ue) : G.value[re] = [...O, ue];
    }, F = p(
      () => D.value.map(
        (re, ue) => {
          if (!re.showHeader) return { left: void 0, right: void 0 };
          const O = re.controlledSelection ? re.items.filter((Q) => Q.switchChecked).length : (G.value[ue] ?? []).length, U = re.selectedCountSuffix ?? "selected";
          return {
            left: { text: re.label },
            right: { text: `${O}/${re.items.length} ${U}` }
          };
        }
      )
    ), X = p(
      () => D.value.map(
        (re, ue) => re.items.map((O) => re.controlledSelection ? {
          id: O.id,
          label: O.label,
          group: O.group,
          hasSwitch: !0,
          switchChecked: O.switchChecked === !0,
          disabled: O.disabled === !0,
          onClick: O.onClick,
          moreActions: O.moreActions
        } : {
          id: O.id,
          label: O.label,
          group: O.group,
          hasSwitch: !0,
          switchChecked: (G.value[ue] ?? []).includes(O.id),
          onClick: () => B(ue, O.id),
          moreActions: O.moreActions
        })
      )
    ), H = p(
      () => D.value.map(
        (re, ue) => (re.footerButtons ?? []).map((O) => re.controlledSelection ? {
          label: O.label,
          variant: O.variant,
          keepOpen: O.keepOpen,
          disabled: O.disabled,
          onClick: () => {
            var U;
            return (U = O.onClick) == null ? void 0 : U.call(O, []);
          }
        } : {
          label: O.label,
          variant: O.variant,
          keepOpen: O.keepOpen,
          onClick: () => {
            var ae;
            const U = G.value[ue] ?? [], Q = re.items.filter((Z) => U.includes(Z.id));
            a("tab-requested", ue, Q), (ae = O.onClick) == null || ae.call(O, Q), G.value = { ...G.value, [ue]: [] };
          }
        })
      )
    ), q = p(
      () => m.value.filter((re) => u.value.includes(re.id)).map((re) => ({
        label: w(re),
        onClick: () => l == null ? void 0 : l.setView(re.id)
      }))
    );
    let N = 0;
    function J() {
      return typeof window > "u" ? 0.72 : window.innerWidth >= 1920 ? 0.8 : 0.72;
    }
    function be(re) {
      return re.reduce((ue, O) => ue + b(O), 0) + dd * Math.max(0, re.length - 1);
    }
    function ke(re) {
      var fe, de;
      const ue = re.getBoundingClientRect().width, O = ((fe = re.querySelector("[data-tab-label]")) == null ? void 0 : fe.scrollWidth) ?? 0;
      if (ue === 0 && O === 0) return 0;
      const U = getComputedStyle(re), ae = ["paddingLeft", "paddingRight", "borderLeftWidth", "borderRightWidth"].reduce((ne, le) => ne + (parseFloat(U[le]) || 0), 0), Z = ((de = re.querySelector("[data-tab-count]")) == null ? void 0 : de.getBoundingClientRect().width) ?? 0, ie = Math.ceil(ae + O + Z);
      return Math.min(mO, Math.max(ue, ie));
    }
    function ee() {
      var Ee, je;
      if (N >= pO) return;
      const re = o.value, ue = i.value;
      if (!re || !ue) {
        u.value = [];
        return;
      }
      const O = re.getBoundingClientRect().width;
      if (O <= 0) return;
      let U = !1;
      for (const Ge of m.value) {
        if (((Ee = f.get(Ge.id)) == null ? void 0 : Ee.label) === w(Ge)) continue;
        const Qe = d.value.get(Ge.id);
        if (Qe) {
          const Ce = ke(Qe);
          Ce > 0 ? f.set(Ge.id, { label: w(Ge), width: Ce }) : U = !0;
        } else
          U = !0;
      }
      if (U) {
        u.value = [], N++, qe(ee);
        return;
      }
      $();
      const Q = ((je = s.value) == null ? void 0 : je.$el) ?? null;
      let ae = 0, Z = 0;
      for (let Ge = 0; Ge < re.children.length; Ge++) {
        const Qe = re.children[Ge];
        Qe !== ue && (Q && (Qe === Q || Qe.contains(Q)) || (ae += Qe.getBoundingClientRect().width, Z++));
      }
      const ie = (typeof window < "u" ? window.innerWidth : O) * J(), fe = Math.min(O, ie), de = Math.floor(fe - ae - dd * Z), ne = m.value.map((Ge) => Ge.id);
      if (be(ne) <= de - 1) {
        const Ge = JSON.stringify(u.value);
        u.value = [], JSON.stringify([]) !== Ge ? (N++, qe(ee)) : N = 0;
        return;
      }
      if (Q) {
        const Ge = Q.getBoundingClientRect().width;
        Ge > 0 && (h = Ge);
      }
      const le = Math.floor(
        fe - ae - h - dd * (Z + 1)
      ), Le = (Ge) => be(Ge) <= le - 1, Te = [], xe = [];
      for (const Ge of ne) (Le([...xe, Ge]) ? xe : Te).push(Ge);
      const we = R.value;
      if (we && Te.includes(we)) {
        for (; xe.length > 0 && !Le([...xe, we]); ) Te.push(xe.pop());
        Te.splice(Te.indexOf(we), 1), xe.push(we);
      }
      xe.length === 0 && Te.length > 0 && xe.push(Te.shift());
      const he = JSON.stringify(u.value), De = JSON.stringify(Te);
      u.value = Te, he !== De ? (N++, qe(ee)) : N = 0;
    }
    function oe() {
      N = 0, qe(() => {
        requestAnimationFrame(() => {
          requestAnimationFrame(ee);
        });
      });
    }
    let ge = null;
    return ot(() => {
      var re;
      oe(), ge = new ResizeObserver(() => {
        h = 0, oe();
      }), o.value && ge.observe(o.value), (re = document.fonts) == null || re.ready.then(() => {
        f.clear(), h = 0, oe();
      });
    }), kt(() => ge == null ? void 0 : ge.disconnect()), Ie(
      m,
      (re) => {
        const ue = new Set(re.map((O) => O.id));
        for (const [O] of f)
          ue.has(O) || f.delete(O);
        h = 0, oe();
      },
      // CONSTRAINT: deep, so a counter mutated in place on the same view object still re-measures.
      { deep: !0 }
    ), Ie(R, () => {
      oe();
    }), Ie([V, Y], () => {
      oe();
    }), (re, ue) => (c(), g("div", {
      ref_key: "outerRef",
      ref: o,
      class: "flex items-stretch gap-px min-w-0 flex-1"
    }, [
      v("div", {
        ref_key: "containerRef",
        ref: i,
        "data-testid": "tab-container",
        role: "tablist",
        "aria-label": I(x).viewTabsLabel,
        class: "flex items-stretch gap-px min-w-0 overflow-hidden",
        onKeydown: A
      }, [
        (c(!0), g(se, null, Me(m.value, (O) => (c(), K(I(ft), {
          key: O.id,
          role: "presentation",
          class: C(["min-w-0", { "hidden!": u.value.includes(O.id) }]),
          text: w(O),
          disabled: !S.value.includes(O.id),
          "labels-trigger": ""
        }, {
          default: ve(() => {
            var U;
            return [
              Gl(v("button", {
                id: I(y) ? I(zv)(I(y).id, O.id) : void 0,
                ref_for: !0,
                ref: (Q) => {
                  Q && d.value.set(O.id, Q);
                },
                type: "button",
                role: "tab",
                "aria-controls": (U = I(y)) != null && U.isTabpanel.value ? I(y).id : void 0,
                "aria-selected": R.value === O.id ? "true" : "false",
                tabindex: L.value === O.id ? 0 : -1,
                "data-testid": `table-view-tab-${O.id}`,
                "data-active": R.value === O.id ? "true" : "false",
                class: C([
                  "min-w-0 px-3 flex items-center text-xs leading-5 font-medium transition-colors duration-200 rounded-tl-(--border-border-radius-rounded-sm) rounded-tr-(--border-border-radius-rounded-sm) max-w-[233px] overflow-hidden focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-royalblue",
                  R.value === O.id ? "tab-active tab-active--has-left -mb-px text-gray-900 dark:text-white" : "border-t border-r border-l border-(--border-border-tab) bg-(--colors-background-white-tertiary) text-(--colors-text-black-default) hover:bg-whitesmoke dark:bg-white/5 dark:text-(--colors-text-white-secondary) dark:hover:bg-white/10"
                ]),
                onClick: (Q) => {
                  var ae;
                  return (ae = I(l)) == null ? void 0 : ae.setView(O.id);
                }
              }, [
                v("span", hO, P(O.label), 1),
                O.count !== void 0 ? (c(), g("span", bO, " (" + P(O.count) + ")", 1)) : k("", !0)
              ], 10, fO), [
                [Cu, !u.value.includes(O.id)]
              ])
            ];
          }),
          _: 2
        }, 1032, ["class", "text", "disabled"]))), 128))
      ], 40, cO),
      q.value.length > 0 ? (c(), K(I(Sn), {
        key: 0,
        ref_key: "overflowDropdownRef",
        ref: s,
        class: "shrink-0",
        label: `+${q.value.length} ${V.value}`,
        items: q.value,
        "trigger-icon-info": Y.value ? gO : void 0,
        "trigger-icon-info-tooltip": Y.value,
        "trigger-icon": rb,
        "menu-align": "left",
        "menu-width": "220px",
        tab: !0
      }, null, 8, ["label", "items", "trigger-icon-info", "trigger-icon-info-tooltip"])) : k("", !0),
      (c(!0), g(se, null, Me(D.value, (O, U) => (c(), g("div", {
        key: U,
        class: "flex items-center gap-1 shrink-0"
      }, [
        te(I(qu), {
          class: "shrink-0",
          label: O.label,
          "trigger-icon-left": O.iconLeft,
          "trigger-icon": rb,
          tab: !0,
          "header-label-left": F.value[U].left,
          "header-label-right": F.value[U].right,
          "show-search": O.showSearch,
          "search-query": M.value[U] ?? "",
          "search-placeholder": O.searchPlaceholder,
          "search-clear-label": O.searchClearLabel,
          "group-buttons": O.groupButtons,
          "active-group-button": _.value[U],
          items: X.value[U],
          "footer-buttons": H.value[U],
          reorderable: O.reorderable === !0,
          "freeze-on-open": !0,
          "menu-align": "left",
          size: O.size ?? "m",
          "max-list-height": "280px",
          "reserve-list-height": O.reserveListHeight !== !1,
          "empty-label": O.emptyLabel,
          "onUpdate:searchQuery": (Q) => W(U, Q),
          "onUpdate:activeGroupButton": (Q) => j(U, Q),
          onReorder: (Q) => a("tab-reordered", U, Q)
        }, null, 8, ["label", "trigger-icon-left", "header-label-left", "header-label-right", "show-search", "search-query", "search-placeholder", "search-clear-label", "group-buttons", "active-group-button", "items", "footer-buttons", "reorderable", "size", "reserve-list-height", "empty-label", "onUpdate:searchQuery", "onUpdate:activeGroupButton", "onReorder"])
      ]))), 128))
    ], 512));
  }
}), xO = /* @__PURE__ */ lt(vO, [["__scopeId", "data-v-b1c338bb"]]), hs = 300;
function pq(e = {}) {
  const { initialViewMode: n, filterLabels: t, filterItems: a, filterFieldConfigs: l, ...r } = e, o = E(n ?? "table"), i = E(!1), s = E(0), d = rl({
    search: "",
    filters: {},
    sort: null,
    activeViewId: null,
    page: 1,
    pageSize: 10,
    ...r
  }), u = p(() => Object.keys(d.filters).length > 0), f = p(() => Object.keys(d.filters).length), b = p(() => {
    const D = Rt(t), V = Rt(a), Y = Rt(l);
    return Object.entries(d.filters).map(([_, j]) => {
      const M = {
        key: _,
        label: (D == null ? void 0 : D[_]) ?? _,
        valueLabel: yO(j, V == null ? void 0 : V[_]),
        value: j
      };
      V != null && V[_] && (M.items = V[_]);
      const W = Y == null ? void 0 : Y[_];
      return W && (W.placeholder && (M.placeholder = W.placeholder), W.rangeConfig && (M.rangeConfig = W.rangeConfig), W.dateRangeConfig && (M.dateRangeConfig = W.dateRangeConfig)), M;
    });
  });
  function h(D, V) {
    d.filters[D] = V, d.page = 1;
  }
  function m(D) {
    delete d.filters[D], d.page = 1;
  }
  function x() {
    d.filters = {}, d.page = 1;
  }
  function y(D) {
    d.search = D, d.page = 1, s.value++;
  }
  function w(D) {
    i.value = D;
  }
  function S(D, V) {
    d.sort = { column: D, direction: V };
  }
  function $() {
    d.sort = null;
  }
  function T(D) {
    d.page = D;
  }
  function L(D) {
    d.pageSize = D, d.page = 1;
  }
  function A(D) {
    d.activeViewId = D, d.page = 1;
  }
  function R(D) {
    o.value = D;
  }
  function z(D) {
    Object.assign(d, D);
  }
  return {
    state: d,
    viewMode: o,
    searchPending: i,
    searchRevision: s,
    hasActiveFilters: u,
    activeFilterCount: f,
    activeFilterPills: b,
    setFilter: h,
    removeFilter: m,
    clearAllFilters: x,
    setSearch: y,
    setSearchPending: w,
    setSort: S,
    clearSort: $,
    setPage: T,
    setPageSize: L,
    setView: A,
    setViewMode: R,
    patch: z
  };
}
function yO(e, n) {
  switch (e.type) {
    case "equals":
      return String(e.value);
    case "in": {
      const t = (a) => {
        var l;
        return ((l = n == null ? void 0 : n.find((r) => r.id === a)) == null ? void 0 : l.label) ?? a;
      };
      return e.values.length === 1 ? t(e.values[0]) : `${t(e.values[0])} (${e.values.length})`;
    }
    case "range":
      return e.min != null && e.max != null ? `${e.min} – ${e.max}` : e.min != null ? `≥ ${e.min}` : e.max != null ? `≤ ${e.max}` : "";
    case "dateRange":
      return e.from && e.to ? `${e.from} – ${e.to}` : e.from ? `≥ ${e.from}` : e.to ? `≤ ${e.to}` : "";
    case "boolean":
      return e.value ? "Yes" : "No";
  }
}
const kO = /* @__PURE__ */ ye({
  __name: "TableSearch",
  props: {
    placeholder: { default: "Search..." },
    debounce: { default: hs }
  },
  setup(e) {
    const n = Ft(Xl), t = io(), a = E(null);
    Ie(
      () => n == null ? void 0 : n.searchRevision.value,
      () => {
        var r;
        return (r = a.value) == null ? void 0 : r.discardPending((n == null ? void 0 : n.state.search) ?? "");
      }
    );
    function l(r) {
      n == null || n.setSearch(r);
    }
    return (r, o) => {
      var i;
      return c(), K($4, {
        ref_key: "searchRef",
        ref: a,
        "model-value": ((i = I(n)) == null ? void 0 : i.state.search) ?? "",
        placeholder: e.placeholder,
        labels: { closeSearch: I(t).closeSearch },
        debounce: e.debounce,
        "onUpdate:modelValue": l,
        onPending: o[0] || (o[0] = (s) => {
          var d;
          return (d = I(n)) == null ? void 0 : d.setSearchPending(s);
        })
      }, null, 8, ["model-value", "placeholder", "labels", "debounce"]);
    };
  }
}), wO = {
  key: 0,
  class: "inline-flex items-center px-3 py-2 text-(length:--size-m) leading-[20px] font-medium text-(--colors-text-black-default) dark:text-(--colors-text-white-default)",
  "data-testid": "table-view-selector-static"
}, CO = /* @__PURE__ */ ye({
  __name: "TableViewSelector",
  emits: ["rename-view", "delete-view", "set-default"],
  setup(e, { emit: n }) {
    const t = n, a = Ft(Xl), l = Ft(fs), r = io(), o = p(
      () => l == null ? void 0 : l.views.value.find((d) => d.id === (a == null ? void 0 : a.state.activeViewId))
    ), i = p(() => !!(o.value && !o.value.isPreset)), s = p(() => i.value ? [
      { label: r.value.renameView, onClick: () => t("rename-view", o.value.id) },
      {
        label: r.value.setAsDefault,
        hasDividerAfter: !0,
        onClick: () => {
          l == null || l.setDefault(o.value.id), t("set-default", o.value.id);
        }
      },
      { label: r.value.deleteView, onClick: () => t("delete-view", o.value.id) }
    ] : []);
    return (d, u) => i.value ? (c(), K(I(Sn), {
      key: 1,
      label: I(r).viewModeTable,
      items: s.value,
      "menu-align": "right",
      "menu-width": "180px",
      ghost: !0
    }, null, 8, ["label", "items"])) : (c(), g("div", wO, P(I(r).viewModeTable), 1));
  }
}), SO = { class: "@container/topbar relative flex flex-wrap items-stretch border-gainsboro dark:border-(--colors-border-base)" }, $O = {
  key: 1,
  class: "flex-1"
}, Pv = /* @__PURE__ */ ye({
  __name: "TableTopbar",
  props: {
    searchPlaceholder: { default: "Search..." },
    showSearch: { type: Boolean, default: !0 },
    searchDebounce: { default: hs },
    showViewSelector: { type: Boolean, default: !1 },
    tabDropdowns: { default: () => [] }
  },
  emits: ["rename-view", "delete-view", "set-default", "tab-requested", "tab-reordered"],
  setup(e, { emit: n }) {
    const t = n, a = Ft(fs), l = p(() => ((a == null ? void 0 : a.presetViews.value.length) ?? 0) > 0);
    return (r, o) => (c(), g("div", SO, [
      v("div", {
        class: C(["h-9 items-stretch w-full @2xl/topbar:w-[73%] min-w-0", l.value ? "flex" : "hidden @2xl/topbar:flex"]),
        "data-testid": "table-topbar-tabs"
      }, [
        l.value ? (c(), K(xO, {
          key: 0,
          "tab-dropdowns": e.tabDropdowns,
          onTabRequested: o[0] || (o[0] = (i, s) => t("tab-requested", i, s)),
          onTabReordered: o[1] || (o[1] = (i, s) => t("tab-reordered", i, s))
        }, null, 8, ["tab-dropdowns"])) : (c(), g("div", $O))
      ], 2),
      v("div", {
        class: C(["order-first flex h-9 items-center justify-end gap-1 w-full @2xl/topbar:order-none @2xl/topbar:w-[27%] px-4 py-1", l.value ? "border-gainsboro dark:border-(--colors-border-base)" : ""]),
        "data-testid": "table-topbar-search"
      }, [
        e.showSearch ? (c(), K(kO, {
          key: 0,
          placeholder: e.searchPlaceholder,
          debounce: e.searchDebounce
        }, null, 8, ["placeholder", "debounce"])) : k("", !0),
        e.showViewSelector ? (c(), K(CO, {
          key: 1,
          onRenameView: o[2] || (o[2] = (i) => t("rename-view", i)),
          onDeleteView: o[3] || (o[3] = (i) => t("delete-view", i)),
          onSetDefault: o[4] || (o[4] = (i) => t("set-default", i))
        })) : k("", !0)
      ], 2)
    ]));
  }
}), IO = "data:image/svg+xml,%3csvg%20viewBox='0%200%2024%2024'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M14%2014V20L10%2022V14L4%205V3H20V5L14%2014ZM6.4037%205L12%2013.3944L17.5963%205H6.4037Z'/%3e%3c/svg%3e", TO = "data:image/svg+xml,%3csvg%20viewBox='0%200%2024%2024'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M17.8827%2019.2968C16.1814%2020.3755%2014.1638%2021.0002%2012.0003%2021.0002C6.60812%2021.0002%202.12215%2017.1204%201.18164%2012.0002C1.61832%209.62282%202.81932%207.5129%204.52047%205.93457L1.39366%202.80777L2.80788%201.39355L22.6069%2021.1925L21.1927%2022.6068L17.8827%2019.2968ZM5.9356%207.3497C4.60673%208.56015%203.6378%2010.1672%203.22278%2012.0002C4.14022%2016.0521%207.7646%2019.0002%2012.0003%2019.0002C13.5997%2019.0002%2015.112%2018.5798%2016.4243%2017.8384L14.396%2015.8101C13.7023%2016.2472%2012.8808%2016.5002%2012.0003%2016.5002C9.51498%2016.5002%207.50026%2014.4854%207.50026%2012.0002C7.50026%2011.1196%207.75317%2010.2981%208.19031%209.60442L5.9356%207.3497ZM12.9139%2014.328L9.67246%2011.0866C9.5613%2011.3696%209.50026%2011.6777%209.50026%2012.0002C9.50026%2013.3809%2010.6196%2014.5002%2012.0003%2014.5002C12.3227%2014.5002%2012.6309%2014.4391%2012.9139%2014.328ZM20.8068%2016.5925L19.376%2015.1617C20.0319%2014.2268%2020.5154%2013.1586%2020.7777%2012.0002C19.8603%207.94818%2016.2359%205.00016%2012.0003%205.00016C11.1544%205.00016%2010.3329%205.11773%209.55249%205.33818L7.97446%203.76015C9.22127%203.26959%2010.5793%203.00016%2012.0003%203.00016C17.3924%203.00016%2021.8784%206.87992%2022.8189%2012.0002C22.5067%2013.6998%2021.8038%2015.2628%2020.8068%2016.5925ZM11.7229%207.50857C11.8146%207.50299%2011.9071%207.50016%2012.0003%207.50016C14.4855%207.50016%2016.5003%209.51488%2016.5003%2012.0002C16.5003%2012.0933%2016.4974%2012.1858%2016.4919%2012.2775L11.7229%207.50857Z'/%3e%3c/svg%3e", LO = "data:image/svg+xml,%3csvg%20viewBox='0%200%2024%2024'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M12.0003%203C17.3924%203%2021.8784%206.87976%2022.8189%2012C21.8784%2017.1202%2017.3924%2021%2012.0003%2021C6.60812%2021%202.12215%2017.1202%201.18164%2012C2.12215%206.87976%206.60812%203%2012.0003%203ZM12.0003%2019C16.2359%2019%2019.8603%2016.052%2020.7777%2012C19.8603%207.94803%2016.2359%205%2012.0003%205C7.7646%205%204.14022%207.94803%203.22278%2012C4.14022%2016.052%207.7646%2019%2012.0003%2019ZM12.0003%2016.5C9.51498%2016.5%207.50026%2014.4853%207.50026%2012C7.50026%209.51472%209.51498%207.5%2012.0003%207.5C14.4855%207.5%2016.5003%209.51472%2016.5003%2012C16.5003%2014.4853%2014.4855%2016.5%2012.0003%2016.5ZM12.0003%2014.5C13.381%2014.5%2014.5003%2013.3807%2014.5003%2012C14.5003%2010.6193%2013.381%209.5%2012.0003%209.5C10.6196%209.5%209.50026%2010.6193%209.50026%2012C9.50026%2013.3807%2010.6196%2014.5%2012.0003%2014.5Z'/%3e%3c/svg%3e", EO = "data:image/svg+xml,%3csvg%20viewBox='0%200%2024%2024'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M4%203H18L20.7071%205.70711C20.8946%205.89464%2021%206.149%2021%206.41421V20C21%2020.5523%2020.5523%2021%2020%2021H4C3.44772%2021%203%2020.5523%203%2020V4C3%203.44772%203.44772%203%204%203ZM7%204V9H16V4H7ZM6%2012V19H18V12H6ZM13%205H15V8H13V5Z'/%3e%3c/svg%3e", Al = "data:image/svg+xml,%3csvg%20viewBox='0%200%2024%2024'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M11.9999%2013.1714L16.9497%208.22168L18.3639%209.63589L11.9999%2015.9999L5.63599%209.63589L7.0502%208.22168L11.9999%2013.1714Z'/%3e%3c/svg%3e", Jo = "data:image/svg+xml,%3csvg%20viewBox='0%200%2024%2024'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M11.9999%2010.8284L7.0502%2015.7782L5.63599%2014.364L11.9999%208L18.3639%2014.364L16.9497%2015.7782L11.9999%2010.8284Z'/%3e%3c/svg%3e", Fv = /* @__PURE__ */ ye({
  __name: "TableControls",
  props: {
    isFilterPanelOpen: { type: Boolean, default: !1 },
    isFilterBarVisible: { type: Boolean, default: !0 },
    showFilter: { type: Boolean, default: !0 },
    bordered: { type: Boolean, default: !0 }
  },
  emits: ["toggle-filter-panel", "toggle-filter-bar", "save-view", "share-view"],
  setup(e, { emit: n }) {
    const t = n, a = Ft(Xl), l = Ft(Bv), r = io(), o = p(() => (a == null ? void 0 : a.hasActiveFilters.value) ?? !1), i = p(() => (a == null ? void 0 : a.activeFilterCount.value) ?? 0);
    function s() {
      a == null || a.clearAllFilters();
    }
    return (d, u) => {
      var f, b;
      return c(), g("div", {
        class: C([
          "flex flex-wrap items-center gap-3 p-3 bg-white dark:bg-(--colors-background-black-default) rounded-tr-[12px]",
          e.bordered && "border-b border-x border-(--colors-border-base-soft) dark:border-(--colors-border-base)"
        ])
      }, [
        e.showFilter ? (c(), g(se, { key: 0 }, [
          d.$slots.filter ? $e(d.$slots, "filter", { key: 0 }) : (c(), K(I(Re), {
            key: 1,
            variant: "tertiary",
            "icon-left": I(IO),
            "icon-right": I(Al),
            size: "sm",
            active: e.isFilterPanelOpen,
            onClick: u[0] || (u[0] = (h) => t("toggle-filter-panel"))
          }, {
            default: ve(() => [
              at(P(I(r).filterButton), 1)
            ]),
            _: 1
          }, 8, ["icon-left", "icon-right", "active"]))
        ], 64)) : k("", !0),
        o.value ? (c(), g("button", {
          key: 1,
          type: "button",
          class: "shrink-0 text-sm font-medium text-blue-600 underline cursor-pointer hover:text-blue-800 dark:text-blue-400 dark:hover:text-blue-300 transition-colors",
          onClick: s
        }, P(I(r).eraseAll), 1)) : k("", !0),
        o.value ? (c(), K(I(Re), {
          key: 2,
          variant: "tertiary",
          "icon-left": e.isFilterBarVisible ? I(TO) : I(LO),
          "icon-right": e.isFilterBarVisible ? I(Jo) : I(Al),
          size: "sm",
          "aria-expanded": e.isFilterBarVisible,
          "data-testid": "table-controls-filter-bar-toggle",
          onClick: u[1] || (u[1] = (h) => t("toggle-filter-bar"))
        }, {
          default: ve(() => [
            at(P(e.isFilterBarVisible ? I(r).hideFilters(i.value) : I(r).showFilters(i.value)), 1)
          ]),
          _: 1
        }, 8, ["icon-left", "icon-right", "aria-expanded"])) : k("", !0),
        $e(d.$slots, "controls-info"),
        u[4] || (u[4] = v("div", { class: "flex-1" }, null, -1)),
        $e(d.$slots, "controls-actions"),
        ((f = I(l)) == null ? void 0 : f.canSaveView) !== !1 ? (c(), K(I(Re), {
          key: 3,
          variant: "secondary",
          label: I(r).saveView,
          "icon-left": I(EO),
          "icon-right": I(Al),
          size: "sm",
          disabled: !o.value,
          onClick: u[2] || (u[2] = (h) => t("save-view"))
        }, null, 8, ["label", "icon-left", "icon-right", "disabled"])) : k("", !0),
        ((b = I(l)) == null ? void 0 : b.canShareView) !== !1 ? (c(), K(I(Re), {
          key: 4,
          variant: "secondary",
          label: I(r).shareView,
          size: "sm",
          onClick: u[3] || (u[3] = (h) => t("share-view"))
        }, null, 8, ["label"])) : k("", !0)
      ], 2);
    };
  }
}), AO = { class: "pill-gradient relative inline-flex shrink-0 items-stretch rounded-full" }, RO = { class: "flex items-stretch rounded-full bg-white dark:bg-(--colors-background-black-default)" }, BO = { class: "whitespace-nowrap text-sm font-medium text-slategray dark:text-(--colors-text-white-secondary)" }, MO = ["title"], DO = {
  key: 1,
  class: "ml-0.5 whitespace-nowrap text-sm font-medium text-(--colors-text-black-default) dark:text-(--colors-text-white-default)"
}, zO = ["aria-label"], OO = /* @__PURE__ */ ye({
  __name: "FilterPill",
  props: {
    pill: {}
  },
  emits: ["remove", "edit"],
  setup(e, { emit: n }) {
    const t = e, a = n, l = io(), r = p(
      () => t.pill.value.type === "in" ? t.pill.value.values.length : null
    ), o = p(() => r.value !== null && r.value > 1);
    function i() {
      a("edit", t.pill.key);
    }
    return (s, d) => (c(), g("div", AO, [
      v("div", RO, [
        v("button", {
          type: "button",
          class: "inline-flex cursor-pointer items-center gap-1 py-1 pl-3 pr-1.5 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-royalblue focus-visible:ring-offset-1 rounded-l-full",
          onClick: Ue(i, ["stop"])
        }, [
          v("span", BO, P(e.pill.label), 1),
          o.value ? (c(), g("span", DO, " (" + P(r.value) + ") ", 1)) : (c(), g(se, { key: 0 }, [
            d[1] || (d[1] = v("span", { class: "text-sm text-slategray dark:text-(--colors-text-white-secondary)" }, " : ", -1)),
            v("span", {
              class: "max-w-50 truncate text-sm font-medium text-(--colors-text-black-default) dark:text-(--colors-text-white-default)",
              title: e.pill.valueLabel
            }, P(e.pill.valueLabel), 9, MO)
          ], 64)),
          d[2] || (d[2] = v("svg", {
            viewBox: "0 0 24 24",
            fill: "none",
            stroke: "currentColor",
            "stroke-width": "2.5",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            class: "ml-0.5 h-3 w-3 shrink-0 text-slategray dark:text-(--colors-text-white-secondary)"
          }, [
            v("path", { d: "M6 9l6 6 6-6" })
          ], -1))
        ]),
        d[4] || (d[4] = v("div", { class: "my-1.5 w-px bg-gainsboro dark:bg-(--colors-border-base)" }, null, -1)),
        v("button", {
          type: "button",
          class: "inline-flex w-7 cursor-pointer items-center justify-center rounded-r-full transition-colors duration-150 hover:bg-gray-100 dark:hover:bg-white/10 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-royalblue focus-visible:ring-offset-1",
          "aria-label": I(l).removeFilter(e.pill.label),
          onClick: d[0] || (d[0] = Ue((u) => a("remove", e.pill.key), ["stop"]))
        }, [...d[3] || (d[3] = [
          v("svg", {
            viewBox: "0 0 24 24",
            fill: "none",
            stroke: "currentColor",
            "stroke-width": "2.5",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            class: "h-2.5 w-2.5 text-slategray dark:text-(--colors-text-white-secondary)"
          }, [
            v("path", { d: "M18 6 6 18M6 6l12 12" })
          ], -1)
        ])], 8, zO)
      ])
    ]));
  }
}), PO = /* @__PURE__ */ lt(OO, [["__scopeId", "data-v-6790cffd"]]), FO = { class: "flex items-center gap-2 flex-1 flex-wrap" }, Vv = /* @__PURE__ */ ye({
  __name: "TableFilterBar",
  props: {
    bordered: { type: Boolean, default: !0 }
  },
  emits: ["edit-filter"],
  setup(e, { emit: n }) {
    const t = n, a = Ft(Xl), l = p(() => (a == null ? void 0 : a.activeFilterPills.value) ?? []);
    function r(o) {
      a == null || a.removeFilter(o);
    }
    return (o, i) => (c(), K(wt, {
      "enter-active-class": "transition-[max-height] duration-200 ease-out overflow-hidden",
      "enter-from-class": "max-h-0",
      "enter-to-class": "max-h-60",
      "leave-active-class": "transition-[max-height] duration-150 ease-in overflow-hidden",
      "leave-from-class": "max-h-60",
      "leave-to-class": "max-h-0"
    }, {
      default: ve(() => [
        l.value.length > 0 ? (c(), g("div", {
          key: 0,
          class: C([
            "flex items-start gap-2 px-4 py-2 bg-white dark:bg-(--colors-background-black-default)",
            e.bordered && "border-b border-gainsboro dark:border-(--colors-border-base)"
          ])
        }, [
          v("div", FO, [
            (c(!0), g(se, null, Me(l.value, (s) => (c(), K(PO, {
              key: s.key,
              pill: s,
              onRemove: r,
              onEdit: i[0] || (i[0] = (d) => t("edit-filter", d))
            }, null, 8, ["pill"]))), 128))
          ])
        ], 2)) : k("", !0)
      ]),
      _: 1
    }));
  }
}), VO = {
  "data-testid": "table-skeleton",
  "aria-hidden": "true",
  class: "w-full"
}, NO = {
  key: 0,
  class: "flex border-b border-(--colors-border-base-medium) dark:border-(--colors-border-base)"
}, HO = /* @__PURE__ */ ye({
  __name: "TableSkeleton",
  props: {
    columns: { default: 5 },
    rows: { default: 10 },
    showHeader: { type: Boolean, default: !0 }
  },
  setup(e) {
    const n = [85, 45, 30, 65, 40, 55, 35, 75];
    function t(a, l) {
      return `${n[(a + l) % n.length]}%`;
    }
    return (a, l) => (c(), g("div", VO, [
      e.showHeader ? (c(), g("div", NO, [
        (c(!0), g(se, null, Me(e.columns, (r) => (c(), g("div", {
          key: `skeleton-header-${r}`,
          class: "flex-1 h-11 px-5 flex items-center"
        }, [...l[0] || (l[0] = [
          v("div", { class: "skeleton h-2.5 w-full max-w-[140px] rounded-full" }, null, -1)
        ])]))), 128))
      ])) : k("", !0),
      (c(!0), g(se, null, Me(e.rows, (r) => (c(), g("div", {
        key: `skeleton-row-${r}`,
        class: "flex border-b border-(--colors-border-base-soft) dark:border-(--colors-border-base) last:border-b-0"
      }, [
        (c(!0), g(se, null, Me(e.columns, (o) => (c(), g("div", {
          key: `skeleton-cell-${r}-${o}`,
          class: "flex-1 h-14 px-5 flex items-center"
        }, [
          v("div", {
            class: "skeleton h-2.5 rounded-full",
            style: Ne({ width: t(r, o) })
          }, null, 4)
        ]))), 128))
      ]))), 128))
    ]));
  }
}), jO = { class: "flex items-center gap-1.5 justify-center" }, WO = ["src"], qO = ["src"], UO = { class: "self-stretch flex flex-col items-start gap-2" }, GO = {
  key: 0,
  class: "self-stretch flex flex-col items-start"
}, KO = ["onClick"], YO = ["src"], JO = {
  key: 1,
  class: "h-5 w-5 relative flex-shrink-0"
}, ZO = {
  key: 2,
  class: "relative leading-num-24 font-medium"
}, XO = ["src"], QO = ["onClick"], _O = { class: "flex-1 flex items-center py-num-0 pl-0.5 pr-num-0 shrink-0 relative z-10" }, eP = { class: "relative leading-num-24 font-medium" }, tP = ["onClick"], nP = ["src"], aP = {
  key: 1,
  class: "h-5 w-5 relative flex-shrink-0"
}, lP = {
  key: 2,
  class: "relative leading-num-24 font-medium z-10"
}, rP = {
  key: 0,
  class: "flex items-center gap-1.5 text-center text-[12px] text-colors-text-black-default relative z-10"
}, oP = { class: "relative leading-5 font-medium z-10" }, iP = "data:image/svg+xml,%3Csvg xmlns=%22http://www.w3.org/2000/svg%22 viewBox=%220 0 24 24%22 fill=%22none%22 stroke=%22%23242424%22 stroke-width=%222%22 stroke-linecap=%22round%22 stroke-linejoin=%22round%22%3E%3Cline x1=%2218%22 y1=%226%22 x2=%226%22 y2=%2218%22/%3E%3Cline x1=%226%22 y1=%226%22 x2=%2218%22 y2=%2218%22/%3E%3C/svg%3E", sP = "data:image/svg+xml,%3Csvg xmlns=%22http://www.w3.org/2000/svg%22 viewBox=%220 0 24 24%22 fill=%22none%22 stroke=%22%23242424%22 stroke-width=%222%22 stroke-linecap=%22round%22 stroke-linejoin=%22round%22%3E%3Cpolyline points=%229 18 15 12 9 6%22/%3E%3C/svg%3E", dP = "data:image/svg+xml,%3Csvg xmlns=%22http://www.w3.org/2000/svg%22 viewBox=%220 0 24 24%22 fill=%22none%22 stroke=%22%23242424%22 stroke-width=%222%22 stroke-linecap=%22round%22 stroke-linejoin=%22round%22%3E%3Cpolyline points=%226 9 12 15 18 9%22/%3E%3C/svg%3E", uP = "data:image/svg+xml,%3Csvg xmlns=%22http://www.w3.org/2000/svg%22 viewBox=%220 0 24 24%22 fill=%22none%22 stroke=%22%23242424%22 stroke-width=%222%22 stroke-linecap=%22round%22 stroke-linejoin=%22round%22%3E%3Cpolyline points=%2218 15 12 9 6 15%22/%3E%3C/svg%3E", cP = /* @__PURE__ */ ye({
  __name: "MainDrawer",
  props: {
    logoIcon: { default: "/logo-eudonet.svg" },
    logoText: { default: void 0 },
    closeIcon: { default: void 0 },
    items: { default: () => [
      {
        label: "Overview",
        children: []
      },
      {
        label: "Pages",
        children: []
      },
      {
        label: "Ecommerce",
        icon: void 0,
        children: [
          { label: "All products" },
          { label: "Billing", active: !0 },
          { label: "Invoice" },
          { label: "Transactions" }
        ]
      },
      {
        label: "Messages",
        badge: 4,
        children: []
      },
      {
        label: "Users",
        children: []
      },
      {
        label: "Support",
        children: []
      }
    ] },
    modelValue: { type: Boolean, default: !0 },
    width: { default: "100%" }
  },
  emits: ["update:modelValue", "close", "item-click"],
  setup(e, { emit: n }) {
    const t = e, a = n, l = E({
      Ecommerce: !0
    }), r = E(!1), o = p(() => t.items), i = (x) => {
      l.value[x] = !l.value[x];
    }, s = (x) => l.value[x] === !0, d = (x) => {
      x.children && x.children.length > 0 && !r.value && i(x.label), x.onClick && x.onClick(), a("item-click", x);
    }, u = () => {
      const x = !r.value;
      r.value = x, x && Object.keys(l.value).forEach((y) => {
        l.value[y] = !1;
      });
    }, f = p(() => r.value ? "/logo-eudonet-small.svg" : t.logoIcon || "/logo-eudonet.svg"), b = (x) => {
      const y = 'self-stretch flex items-center py-num-6 pl-8 pr-num-8 cursor-pointer border-solid border-[1px] border-transparent transition-[background,border-color] duration-300 relative before:content-[""] before:absolute before:inset-[-1px] before:rounded-[48px] before:[background:linear-gradient(90deg,_#716ff2,_#52DBF5)] before:transition-opacity before:duration-300 before:z-0 after:content-[""] after:absolute after:inset-0 after:rounded-[48px] after:bg-white after:transition-opacity after:duration-300 after:z-[1]';
      return x.active ? `${y} h-9 rounded-[48px] bg-white overflow-visible before:opacity-100 after:opacity-100` : `${y} rounded-num-12 hover:bg-aliceblue hover:border-[rgba(255,255,255,0.2)] hover:overflow-hidden before:opacity-0 after:opacity-0`;
    }, h = (x) => {
      const y = "self-stretch rounded-num-12 flex items-center justify-between py-num-6 px-num-8 gap-0 cursor-pointer border-solid border-[1px] border-transparent transition-[background,border-color] duration-300";
      return x.active ? `${y} relative before:content-[""] before:absolute before:inset-[-1px] before:rounded-[48px] before:[background:linear-gradient(90deg,_#716ff2,_#52DBF5)] before:transition-opacity before:duration-300 before:z-0 before:opacity-100 after:content-[""] after:absolute after:inset-0 after:rounded-[48px] after:bg-white after:transition-opacity after:duration-300 after:z-[1] after:opacity-100 bg-white overflow-visible` : `${y} hover:bg-aliceblue hover:border-[rgba(255,255,255,0.2)] hover:overflow-hidden`;
    }, m = () => 'h-[22px] w-[22px] rounded-[9999px] relative flex items-center justify-center overflow-visible before:opacity-100 after:opacity-100 before:content-[""] before:absolute before:inset-[-1px] before:rounded-[9999px] before:[background:linear-gradient(90deg,_#716ff2,_#52DBF5)] before:transition-opacity before:duration-300 before:z-0 after:content-[""] after:absolute after:inset-0 after:rounded-[9999px] after:bg-white after:transition-opacity after:duration-300 after:z-[1]';
    return (x, y) => e.modelValue ? (c(), g("div", {
      key: 0,
      role: "dialog",
      class: C(["drawer h-[1184px] relative bg-white flex flex-col items-start box-border gap-5 text-left text-num-16 text-colors-text-body font-inter transition-all duration-300", { "w-20 p-2 overflow-visible": r.value, "p-5 overflow-hidden": !r.value }]),
      style: Ne(r.value ? { width: "80px" } : { width: e.width })
    }, [
      v("div", {
        class: C([
          "self-stretch border-colors-border-black-default border-solid border-b-[1px] pt-num-0 px-num-0 relative",
          r.value ? "flex flex-col items-center gap-2 overflow-visible pb-2" : "flex items-center justify-between gap-5 pb-4"
        ])
      }, [
        v("div", jO, [
          f.value ? (c(), g("img", {
            key: 0,
            class: "h-[30px] w-auto relative",
            src: f.value,
            alt: "Eudonet"
          }, null, 8, WO)) : k("", !0),
          e.logoText && !r.value ? (c(), g("img", {
            key: 1,
            class: "h-[30px] w-[73.8px] relative",
            src: e.logoText,
            alt: "Eudonet"
          }, null, 8, qO)) : k("", !0)
        ]),
        r.value ? (c(), K(I(Re), {
          key: 1,
          variant: "tertiary",
          "icon-left": sP,
          "icon-only": "",
          size: "md",
          "aria-label": "Expand",
          class: "drawer-expand-button flex-shrink-0",
          onClick: u
        })) : (c(), K(I(Re), {
          key: 0,
          variant: "tertiary",
          "icon-left": e.closeIcon || iP,
          "icon-only": "",
          size: "md",
          "aria-label": "Close",
          class: "drawer-close-button flex-shrink-0",
          onClick: u
        }, null, 8, ["icon-left"]))
      ], 2),
      v("div", UO, [
        (c(!0), g(se, null, Me(o.value, (w, S) => (c(), g(se, { key: S }, [
          w.children && w.children.length > 0 ? (c(), g("div", GO, [
            v("button", {
              type: "button",
              class: C(["self-stretch rounded-num-12 flex items-center justify-between py-num-6 px-num-8 gap-0 cursor-pointer border-solid border-[1px] border-transparent hover:bg-aliceblue hover:border-[rgba(255,255,255,0.2)] hover:overflow-hidden transition-[background,border-color] duration-300", { "justify-center": r.value }]),
              onClick: ($) => d(w)
            }, [
              v("div", {
                class: C(["flex-1 flex items-center gap-1.5", { "justify-center": r.value }])
              }, [
                w.icon ? (c(), g("img", {
                  key: 0,
                  class: "h-5 w-5 relative flex-shrink-0",
                  src: w.icon,
                  alt: ""
                }, null, 8, YO)) : (c(), g("div", JO)),
                r.value ? k("", !0) : (c(), g("div", ZO, P(w.label), 1))
              ], 2),
              r.value ? k("", !0) : (c(), g("img", {
                key: 0,
                class: "h-4 w-4 relative transition-transform duration-200",
                src: s(w.label) ? uP : dP,
                alt: ""
              }, null, 8, XO))
            ], 10, KO),
            te(Mr, {
              name: "submenu",
              tag: "div",
              class: C([
                "self-stretch flex flex-col items-start gap-2 submenu-wrapper",
                { "submenu-open": s(w.label) }
              ])
            }, {
              default: ve(() => [
                (c(!0), g(se, null, Me(s(w.label) ? w.children : [], ($, T) => (c(), g("button", {
                  key: `${w.label}-${T}`,
                  type: "button",
                  class: C(b($)),
                  onClick: (L) => d($)
                }, [
                  v("div", _O, [
                    v("div", eP, P($.label), 1)
                  ])
                ], 10, QO))), 128))
              ]),
              _: 2
            }, 1032, ["class"])
          ])) : (c(), g("button", {
            key: 1,
            type: "button",
            class: C([h(w), { "justify-center": r.value }]),
            onClick: ($) => d(w)
          }, [
            v("div", {
              class: C(["flex-1 flex items-center gap-1.5 relative z-10", { "justify-center": r.value }])
            }, [
              w.icon ? (c(), g("img", {
                key: 0,
                class: "h-5 w-5 relative flex-shrink-0 z-10",
                src: w.icon,
                alt: ""
              }, null, 8, nP)) : (c(), g("div", aP)),
              r.value ? k("", !0) : (c(), g("div", lP, P(w.label), 1))
            ], 2),
            w.badge && !r.value ? (c(), g("div", rP, [
              v("div", {
                class: C(m())
              }, [
                v("div", oP, P(w.badge), 1)
              ], 2)
            ])) : k("", !0)
          ], 10, tP))
        ], 64))), 128))
      ])
    ], 6)) : k("", !0);
  }
}), mq = /* @__PURE__ */ lt(cP, [["__scopeId", "data-v-ce4179bf"]]), fP = ["aria-label", "aria-labelledby"], hP = {
  key: 0,
  "data-testid": "drawer-header",
  class: "flex shrink-0 items-start justify-between gap-6 mx-5 py-5 border-b border-(--colors-border-base-medium) dark:border-(--colors-border-base)"
}, bP = { class: "flex-1 min-w-0" }, gP = { class: "sr-only" }, pP = {
  key: 1,
  "data-testid": "drawer-subheader",
  class: "shrink-0 px-5 pt-5 pb-3"
}, mP = {
  "data-testid": "drawer-content",
  class: "flex-1 overflow-y-auto px-5 py-5"
}, vP = /* @__PURE__ */ ye({
  __name: "Drawer",
  props: {
    modelValue: { type: Boolean, default: !1 },
    title: { default: void 0 },
    position: { default: "right" },
    size: { default: "md" },
    showCloseButton: { type: Boolean, default: !0 },
    dismissable: { type: Boolean, default: !0 },
    closeOnEscape: { type: Boolean, default: !0 },
    showBackdrop: { type: Boolean, default: !0 },
    backdropClass: { default: void 0 },
    panelClass: { default: void 0 },
    ariaLabel: { default: void 0 },
    ariaLabelledby: { default: void 0 },
    ariaCloseLabel: { default: "Close drawer" },
    variant: { default: "default" }
  },
  emits: ["update:modelValue", "close"],
  setup(e, { emit: n }) {
    let t = 0;
    const a = e, l = Mn(), r = (A) => {
      const R = l[A];
      return !!(R && R({}).length);
    }, o = p(
      () => a.showCloseButton || !!a.title || r("header")
    ), i = p(() => r("footer")), s = n, d = `drawer-${++t}`, u = `${d}-title`, f = Symbol("opal-drawer"), b = () => {
      s("update:modelValue", !1), s("close");
    }, h = () => {
      a.dismissable && b();
    }, m = (A) => {
      A.key !== "Escape" || !a.closeOnEscape || !a.modelValue || Va(f) && (A.defaultPrevented || (A.preventDefault(), b()));
    };
    Ie(
      () => a.modelValue,
      (A) => {
        document.body.style.overflow = A ? "hidden" : "", A ? Zn(f) : An(f);
      }
    ), ot(() => {
      document.addEventListener("keydown", m), a.modelValue && (document.body.style.overflow = "hidden", Zn(f));
    }), kt(() => {
      document.removeEventListener("keydown", m), An(f), document.body.style.overflow = "";
    });
    const x = {
      sm: "w-64",
      md: "w-80",
      lg: "w-96",
      xl: "w-[512px]"
    }, y = p(() => x[a.size]), w = p(() => a.position === "left" ? "left-0" : "right-0"), S = p(
      () => a.variant === "column" ? a.position === "left" ? "border-r" : "border-l" : void 0
    ), $ = p(() => `drawer-slide-${a.position}`), T = p(
      () => a.ariaLabelledby ?? (a.title ? u : void 0)
    ), L = E(null);
    return Gi({
      active: qn(a, "modelValue"),
      container: L
    }), (A, R) => (c(), K(Bn, { to: "body" }, [
      te(wt, { name: "drawer-fade" }, {
        default: ve(() => [
          e.modelValue && e.showBackdrop ? (c(), g("div", {
            key: 0,
            "data-testid": "drawer-backdrop",
            "aria-hidden": "true",
            class: C(["fixed inset-0 z-40 bg-black/50 dark:bg-black/70", e.backdropClass]),
            onClick: h
          }, null, 2)) : k("", !0)
        ]),
        _: 1
      }),
      te(wt, { name: $.value }, {
        default: ve(() => [
          e.modelValue ? (c(), g("div", {
            key: 0,
            id: d,
            ref_key: "panelRef",
            ref: L,
            "data-testid": "drawer-panel",
            role: "dialog",
            "aria-modal": "true",
            "aria-label": e.ariaLabel,
            "aria-labelledby": T.value,
            class: C([
              "fixed inset-y-0 z-50 flex flex-col",
              "bg-white dark:bg-(--colors-background-black-default)",
              "border-(--colors-border-base-soft) dark:border-(--colors-border-base)",
              e.variant === "column" ? "shadow-[-1px_0px_4px_0px_#CECECE]" : "shadow-(--shadow-drawer)",
              y.value,
              w.value,
              S.value,
              e.panelClass
            ])
          }, [
            o.value ? (c(), g("div", hP, [
              v("div", bP, [
                $e(A.$slots, "header", {}, () => [
                  e.title ? (c(), g("h5", {
                    key: 0,
                    id: u,
                    class: "text-(length:--size-xl) leading-(--line-height-xl) font-(--weight-semi-bold) text-(--text-text-black-default) dark:text-(--colors-text-white-default) truncate"
                  }, P(e.title), 1)) : k("", !0)
                ], !0)
              ]),
              e.showCloseButton ? (c(), g("button", {
                key: 0,
                "data-testid": "drawer-close-button",
                type: "button",
                class: "inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-transparent text-sm text-(--colors-text-body-subtle) hover:bg-(--colors-background-hover) hover:text-(--colors-text-heading) dark:hover:bg-gray-600 dark:hover:text-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-(--border-border-accent) transition-colors duration-200",
                onClick: b
              }, [
                R[0] || (R[0] = v("i", { class: "ri-close-line text-lg" }, null, -1)),
                v("span", gP, P(e.ariaCloseLabel), 1)
              ])) : k("", !0)
            ])) : k("", !0),
            r("subheader") ? (c(), g("div", pP, [
              $e(A.$slots, "subheader", {}, void 0, !0)
            ])) : k("", !0),
            v("div", mP, [
              $e(A.$slots, "default", {}, void 0, !0)
            ]),
            i.value ? (c(), g("div", {
              key: 2,
              "data-testid": "drawer-footer",
              class: C([
                "flex shrink-0 items-center justify-end gap-4 py-5 border-t border-(--colors-border-base-medium) dark:border-(--colors-border-base)",
                e.variant === "column" ? "px-5" : "mx-5"
              ])
            }, [
              $e(A.$slots, "footer", {}, void 0, !0)
            ], 2)) : k("", !0)
          ], 10, fP)) : k("", !0)
        ]),
        _: 3
      }, 8, ["name"])
    ]));
  }
}), xP = /* @__PURE__ */ lt(vP, [["__scopeId", "data-v-33757c91"]]), Ar = 3, yP = {
  class: "sr-only",
  role: "status",
  "aria-live": "polite",
  "aria-atomic": "true",
  "data-testid": "faceted-reorder-live"
}, kP = { class: "flex items-start justify-between pt-5 px-5 pb-4 border-b border-(--colors-border-base-medium)" }, wP = { class: "flex flex-col gap-0.5" }, CP = { class: "text-lg font-semibold leading-[22px] text-(--colors-text-black-default) font-inter" }, SP = { class: "text-base font-normal leading-6 text-(--colors-text-black-default) font-inter" }, $P = { class: "sr-only" }, IP = { class: "flex flex-col gap-3 px-5 py-4" }, TP = { class: "shadow-(--blur-shadow-xs)" }, LP = ["aria-label"], EP = ["id", "aria-selected", "aria-controls", "tabindex"], AP = ["id", "aria-selected", "aria-controls", "tabindex"], RP = ["id", "aria-labelledby"], BP = { key: "visible" }, MP = ["aria-labelledby"], DP = ["id"], zP = { class: "flex flex-col gap-4" }, OP = { class: "shrink-0 w-4.5" }, PP = ["for"], FP = { class: "flex items-center gap-3 shrink-0" }, VP = ["aria-labelledby", "aria-label"], NP = ["id"], HP = { class: "flex flex-col gap-4" }, jP = { class: "shrink-0 w-4.5" }, WP = ["for"], qP = { class: "flex items-center gap-3 shrink-0" }, UP = ["disabled", "aria-label", "aria-pressed", "onClick"], GP = {
  key: 1,
  class: "flex items-center justify-center py-8 text-sm text-(--colors-text-body-subtle) font-inter"
}, KP = { key: "order" }, YP = {
  key: 0,
  class: "flex items-center gap-1.5 text-xs text-(--colors-text-body-subtle) mb-2 font-inter"
}, JP = ["aria-label"], ZP = ["aria-label"], XP = ["disabled", "aria-label", "aria-pressed", "onClick"], QP = {
  key: 1,
  class: "flex items-center justify-center py-8 text-sm text-(--colors-text-body-subtle) font-inter"
}, _P = { class: "flex items-center justify-between w-full" }, e8 = { class: "flex items-center gap-4" }, t8 = /* @__PURE__ */ ye({
  __name: "FacetedSearchDrawer",
  props: {
    modelValue: { type: Boolean },
    columns: {},
    defaultColumns: { default: () => [] },
    columnOrder: { default: () => [] },
    labels: { default: () => ({}) }
  },
  emits: ["update:modelValue", "save", "reset"],
  setup(e, { emit: n }) {
    const t = e, a = n, l = E(!1), r = {
      fige: "Pinned",
      "actif-indigo": "Active",
      "actif-orange": "Active",
      fixe: "Fixed"
    }, o = p(() => ({
      title: t.labels.title ?? "Customize columns",
      subtitle: t.labels.subtitle ?? ((le, Le) => `${le} of ${Le} selected`),
      searchPlaceholder: t.labels.searchPlaceholder ?? "Search a column",
      searchClearLabel: t.labels.searchClearLabel ?? "Clear search",
      visibleTab: t.labels.visibleTab ?? "Visible",
      orderTab: t.labels.orderTab ?? "Order",
      defaultColumnHeader: t.labels.defaultColumnHeader ?? "Default fixed column",
      pinnedBadge: t.labels.pinnedBadge ?? "Pinned",
      resetLabel: t.labels.resetLabel ?? "Reset columns",
      cancelLabel: t.labels.cancelLabel ?? "Cancel",
      saveLabel: t.labels.saveLabel ?? "Save",
      closeAriaLabel: t.labels.closeAriaLabel ?? "Close",
      emptySearchText: t.labels.emptySearchText ?? "No columns found",
      emptyOrderText: t.labels.emptyOrderText ?? "No visible columns",
      orderSearchHint: t.labels.orderSearchHint ?? "Showing filtered results. Drag to reorder within visible columns.",
      pinTooltip: t.labels.pinTooltip ?? "Locked column",
      pinAriaLabelPinned: t.labels.pinAriaLabelPinned ?? "Unfreeze column",
      pinAriaLabelUnpinned: t.labels.pinAriaLabelUnpinned ?? "Freeze column",
      pinLimitTooltip: t.labels.pinLimitTooltip ?? `You can freeze up to ${Ar} columns. Unfreeze a column to freeze another.`,
      badgeLabels: {
        ...r,
        ...t.labels.badgeLabels ?? {}
      },
      reorderMoved: t.labels.reorderMoved ?? ((le, Le, Te) => `${le} moved to position ${Le} of ${Te}`),
      reorderPickedUp: t.labels.reorderPickedUp ?? ((le) => `${le} picked up. Use arrow keys to move, space to drop, escape to cancel.`),
      reorderCancelled: t.labels.reorderCancelled ?? ((le) => `${le} reorder cancelled`),
      orderListLabel: t.labels.orderListLabel ?? "Column order"
    })), i = E(null), s = E([]), d = E(""), u = E("visible"), f = E(null), b = E(null), h = E(null), m = E(null);
    let x = null;
    const y = Ve();
    function w(le) {
      return `${y}-section-${le.replace(/\s+/g, "-").toLowerCase() || "ungrouped"}`;
    }
    function S(le) {
      return `${y}-column-${le.replace(/\s+/g, "-")}`;
    }
    const $ = E("");
    function T(le, Le, Te) {
      $.value = o.value.reorderMoved(le, Le, Te);
    }
    function L(le) {
      return le.map((Le) => ({
        ...Le,
        visible: Le.disabled || Le.alwaysVisible ? !0 : Le.visible
      }));
    }
    function A() {
      const le = L(t.columns);
      if (t.columnOrder.length > 0) {
        const Le = new Map(t.columnOrder.map((Te, xe) => [Te, xe]));
        le.sort((Te, xe) => (Le.get(Te.key) ?? 1 / 0) - (Le.get(xe.key) ?? 1 / 0));
      }
      s.value = ge(le);
    }
    Ie(
      () => t.modelValue,
      (le) => {
        le && (A(), d.value = "", u.value = "visible", m.value = null, x = null, l.value = !1);
      },
      { immediate: !0 }
    ), Ie(
      () => t.modelValue ? `${t.columnOrder.join("|")}::${t.columns.map((le) => le.key).join("|")}` : null,
      (le) => {
        le !== null && m.value === null && A();
      }
    );
    const R = {
      fige: "bg-white ring-1 ring-(--colors-border-base-soft) text-(--colors-text-black-default)",
      "actif-indigo": "bg-(--colors-indigo-100) text-(--colors-text-black-default)",
      "actif-orange": "bg-(--colors-warning-100) text-(--colors-text-black-default)",
      fixe: "bg-(--colors-indigo-100) text-(--colors-text-black-default)"
    };
    function z(le) {
      return R[le];
    }
    function D(le) {
      return le.badge ? o.value.badgeLabels[le.badge] : le.pinned || F(le) ? o.value.pinnedBadge : "";
    }
    const V = p(() => s.value.filter((le) => le.visible).length), Y = p(() => s.value.length), _ = p(
      () => o.value.subtitle(V.value, Y.value)
    ), j = p(() => {
      const le = d.value.toLowerCase().trim();
      return le ? s.value.filter((Le) => Le.label.toLowerCase().includes(le)) : s.value;
    }), M = p(
      () => j.value.filter((le) => le.alwaysVisible || le.disabled)
    ), W = p(
      () => j.value.filter((le) => !le.alwaysVisible && !le.disabled)
    ), G = p(() => {
      const le = [], Le = /* @__PURE__ */ new Map(), Te = [];
      for (const xe of W.value)
        xe.group ? (Le.has(xe.group) || Le.set(xe.group, []), Le.get(xe.group).push(xe)) : Te.push(xe);
      for (const [xe, we] of Le)
        le.push({ name: xe, items: we });
      return Te.length > 0 && le.push({ name: "", items: Te }), le;
    }), B = p(() => {
      const le = d.value.toLowerCase().trim(), Le = s.value.filter((Te) => Te.visible);
      return le ? Le.filter((Te) => Te.label.toLowerCase().includes(le)) : Le;
    });
    function F(le) {
      return !!(le.disabled || le.alwaysVisible);
    }
    const X = p(
      () => s.value.filter((le) => le.visible && (F(le) || le.pinned)).length
    ), H = p(() => X.value >= Ar);
    function q(le) {
      return !le.visible || F(le) ? !1 : le.pinned || !H.value;
    }
    function N(le) {
      return le.pinned ? o.value.pinAriaLabelPinned : o.value.pinAriaLabelUnpinned;
    }
    function J(le) {
      return le.visible && !le.pinned && H.value ? o.value.pinLimitTooltip : N(le);
    }
    function be(le) {
      return !F(le);
    }
    function ke(le) {
      return F(le) ? "locked" : le.pinned ? "pinned" : "regular";
    }
    function ee(le, Le) {
      return ke(le) === ke(Le);
    }
    function oe(le) {
      const Le = [], Te = [], xe = [];
      for (const we of le)
        F(we) ? Le.push(we) : we.pinned ? Te.push(we) : xe.push(we);
      return [...Le, ...Te, ...xe];
    }
    function ge(le = s.value) {
      const Le = [], Te = [];
      for (const xe of le)
        (xe.visible ? Le : Te).push(xe);
      return [...oe(Le), ...Te];
    }
    function re(le) {
      F(le) || (le.visible = !le.visible, le.visible || (le.pinned = !1));
    }
    function ue(le) {
      q(le) && (le.pinned = !le.pinned, s.value = ge());
    }
    function O() {
      a("update:modelValue", !1);
    }
    function U() {
      l.value && a("reset"), a(
        "save",
        s.value.map((le) => ({ ...le }))
      ), a("update:modelValue", !1);
    }
    function Q() {
      s.value = ge(L(t.defaultColumns)), l.value = !0;
    }
    function ae(le, Le) {
      f.value = le, Le.dataTransfer && (Le.dataTransfer.effectAllowed = "move");
    }
    function Z(le) {
      const Le = B.value[le], Te = f.value !== null ? B.value[f.value] : null;
      if (!Le || !be(Le)) {
        b.value = null;
        return;
      }
      if (Te && !ee(Te, Le)) {
        b.value = null;
        return;
      }
      b.value = le;
    }
    function ie(le) {
      if (f.value === null || f.value === le) {
        f.value = null, b.value = null;
        return;
      }
      const Le = B.value[f.value], Te = B.value[le];
      if (!Le || !Te || !be(Le) || !be(Te) || !ee(Le, Te)) {
        f.value = null, b.value = null;
        return;
      }
      const xe = Le.key, we = Te.key, he = [...s.value], De = he.findIndex((Ge) => Ge.key === xe), Ee = he.findIndex((Ge) => Ge.key === we), [je] = he.splice(De, 1);
      he.splice(Ee, 0, je), f.value = null, b.value = null, requestAnimationFrame(() => {
        s.value = ge(he);
        const Ge = s.value.findIndex((Ce) => Ce.key === xe) + 1, Qe = s.value.filter((Ce) => Ce.visible).length;
        T(Le.label, Ge, Qe);
      });
    }
    function fe() {
      f.value = null, b.value = null;
    }
    function de(le, Le) {
      const Te = B.value[le];
      if (!Te) return;
      if (Le.key === "Escape" && m.value !== null) {
        Le.preventDefault(), x && (s.value = x), m.value = null, x = null, $.value = o.value.reorderCancelled(Te.label);
        return;
      }
      if (Le.key === " " || Le.key === "Enter") {
        if (m.value === null) {
          if (!be(Te)) return;
          Le.preventDefault(), m.value = le, x = s.value.map((Je) => ({ ...Je })), $.value = o.value.reorderPickedUp(Te.label);
          return;
        }
        Le.preventDefault();
        const Ae = B.value[m.value], Ke = B.value.length;
        T((Ae == null ? void 0 : Ae.label) ?? Te.label, m.value + 1, Ke), m.value = null, x = null;
        return;
      }
      if (m.value === null || Le.key !== "ArrowUp" && Le.key !== "ArrowDown") return;
      const xe = m.value, we = B.value[xe];
      if (!we) return;
      let he = Le.key === "ArrowUp" ? xe - 1 : xe + 1;
      for (; he >= 0 && he < B.value.length && (!be(B.value[he]) || !ee(we, B.value[he])); )
        he += Le.key === "ArrowUp" ? -1 : 1;
      if (he < 0 || he >= B.value.length) return;
      Le.preventDefault();
      const De = B.value[xe].key, Ee = B.value[he].key, je = [...s.value], Ge = je.findIndex((Ae) => Ae.key === De), Qe = je.findIndex((Ae) => Ae.key === Ee), [Ce] = je.splice(Ge, 1);
      je.splice(Qe, 0, Ce), s.value = ge(je), m.value = he, h.value = he;
      const me = s.value.filter((Ae) => Ae.visible).length;
      T(Te.label, he + 1, me), requestAnimationFrame(() => {
        var Ke, Je;
        const Ae = (Ke = i.value) == null ? void 0 : Ke.querySelectorAll("[role='listitem']");
        (Je = Ae == null ? void 0 : Ae[he]) == null || Je.focus();
      });
    }
    function ne(le) {
      le.key !== "ArrowLeft" && le.key !== "ArrowRight" || (le.preventDefault(), u.value = u.value === "visible" ? "order" : "visible");
    }
    return (le, Le) => (c(), K(I(xP), {
      "model-value": e.modelValue,
      position: "right",
      size: "xl",
      variant: "column",
      "show-close-button": !1,
      dismissable: !0,
      "aria-label": o.value.title,
      "onUpdate:modelValue": Le[3] || (Le[3] = (Te) => a("update:modelValue", Te))
    }, {
      footer: ve(() => [
        v("div", _P, [
          te(I(Re), {
            label: o.value.resetLabel,
            variant: "tertiary",
            size: "sm",
            "icon-left": "ri-restart-line",
            onClick: Q
          }, null, 8, ["label"]),
          v("div", e8, [
            te(I(Re), {
              label: o.value.cancelLabel,
              variant: "secondary",
              size: "sm",
              onClick: O
            }, null, 8, ["label"]),
            te(I(Re), {
              label: o.value.saveLabel,
              variant: "primary",
              size: "sm",
              onClick: U
            }, null, 8, ["label"])
          ])
        ])
      ]),
      default: ve(() => [
        v("div", {
          ref_key: "drawerContainerRef",
          ref: i,
          class: "flex flex-col h-full -mx-5 -my-5 gap-1"
        }, [
          v("div", yP, P($.value), 1),
          v("div", kP, [
            v("div", wP, [
              v("h3", CP, P(o.value.title), 1),
              v("p", SP, P(_.value), 1)
            ]),
            v("button", {
              type: "button",
              class: "inline-flex size-9 shrink-0 items-center justify-center rounded-full bg-transparent text-sm text-(--colors-text-body-subtle) hover:bg-(--colors-background-hover) hover:text-(--colors-text-heading) transition-colors duration-200",
              onClick: O
            }, [
              Le[4] || (Le[4] = v("i", { class: "ri-close-line text-xl" }, null, -1)),
              v("span", $P, P(o.value.closeAriaLabel), 1)
            ])
          ]),
          v("div", IP, [
            v("div", TP, [
              te(I(Yi), {
                modelValue: d.value,
                "onUpdate:modelValue": Le[0] || (Le[0] = (Te) => d.value = Te),
                placeholder: o.value.searchPlaceholder,
                labels: { clear: o.value.searchClearLabel },
                size: "sm",
                "full-width": ""
              }, null, 8, ["modelValue", "placeholder", "labels"])
            ]),
            v("div", {
              class: "flex w-full bg-(--colors-white-50-opacity-light) border border-(--colors-border-base-medium) rounded-3xl p-px shadow-(--blur-shadow-xs)",
              role: "tablist",
              "aria-label": o.value.title,
              onKeydown: ne
            }, [
              v("button", {
                id: `${I(y)}-tab-visible`,
                type: "button",
                role: "tab",
                "aria-selected": u.value === "visible",
                "aria-controls": `${I(y)}-panel-body`,
                tabindex: u.value === "visible" ? 0 : -1,
                class: C([
                  "flex-1 px-3 py-2 text-sm font-medium font-inter rounded-3xl transition-colors duration-200 -mr-px focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-(--border-border-accent) focus-visible:ring-offset-1",
                  u.value === "visible" ? "bg-(--colors-background-black-default) border border-mediumslateblue text-(--colors-text-white-default)" : "bg-transparent border border-transparent text-(--colors-text-black-default) hover:bg-(--colors-background-hover)"
                ]),
                onClick: Le[1] || (Le[1] = (Te) => u.value = "visible")
              }, P(o.value.visibleTab), 11, EP),
              v("button", {
                id: `${I(y)}-tab-order`,
                type: "button",
                role: "tab",
                "aria-selected": u.value === "order",
                "aria-controls": `${I(y)}-panel-body`,
                tabindex: u.value === "order" ? 0 : -1,
                class: C([
                  "flex-1 px-3 py-2 text-sm font-medium font-inter rounded-3xl transition-colors duration-200 -mr-px focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-(--border-border-accent) focus-visible:ring-offset-1",
                  u.value === "order" ? "bg-(--colors-background-black-default) border border-mediumslateblue text-(--colors-text-white-default)" : "bg-transparent border border-transparent text-(--colors-text-black-default) hover:bg-(--colors-background-hover)"
                ]),
                onClick: Le[2] || (Le[2] = (Te) => u.value = "order")
              }, P(o.value.orderTab), 11, AP)
            ], 40, LP)
          ]),
          v("div", {
            id: `${I(y)}-panel-body`,
            class: "flex-1 overflow-y-auto px-5 pb-1",
            role: "tabpanel",
            "aria-labelledby": `${I(y)}-tab-${u.value}`
          }, [
            te(wt, {
              name: "faceted-tab-fade",
              mode: "out-in"
            }, {
              default: ve(() => [
                u.value === "visible" ? (c(), g("div", BP, [
                  M.value.length > 0 ? (c(), g("div", {
                    key: 0,
                    class: "mb-8",
                    role: "group",
                    "aria-labelledby": w("default-fixed")
                  }, [
                    v("div", {
                      id: w("default-fixed"),
                      class: "text-lg font-bold leading-6 text-(--colors-text-heading) mb-4 font-inter"
                    }, P(o.value.defaultColumnHeader), 9, DP),
                    v("div", zP, [
                      (c(!0), g(se, null, Me(M.value, (Te) => (c(), g("div", {
                        key: Te.key,
                        class: "flex items-center gap-2.5 p-px"
                      }, [
                        v("div", OP, [
                          te(I(Cn), {
                            id: S(Te.key),
                            "model-value": !0,
                            disabled: !0,
                            variant: "light"
                          }, null, 8, ["id"])
                        ]),
                        v("label", {
                          for: S(Te.key),
                          class: "flex-1 min-w-0 text-sm font-medium font-inter truncate cursor-not-allowed text-(--colors-text-body-subtle)"
                        }, P(Te.label), 9, PP),
                        v("div", FP, [
                          v("span", {
                            class: C(["inline-flex items-center px-1 py-0.5 rounded text-xs font-medium leading-5 font-inter", z(Te.badge ?? "fige")])
                          }, P(D(Te)), 3),
                          Le[5] || (Le[5] = v("i", {
                            class: "ri-pushpin-2-fill text-2xl leading-none text-(--colors-text-body-subtle)",
                            "aria-hidden": "true"
                          }, null, -1))
                        ])
                      ]))), 128))
                    ])
                  ], 8, MP)) : k("", !0),
                  (c(!0), g(se, null, Me(G.value, (Te) => (c(), g("div", {
                    key: Te.name,
                    class: "mb-8 last:mb-0",
                    role: "group",
                    "aria-labelledby": Te.name ? w(Te.name) : void 0,
                    "aria-label": Te.name ? void 0 : o.value.visibleTab
                  }, [
                    Te.name ? (c(), g("div", {
                      key: 0,
                      id: w(Te.name),
                      class: "text-lg font-bold leading-6 text-(--colors-text-heading) mb-4 font-inter"
                    }, P(Te.name), 9, NP)) : k("", !0),
                    v("div", HP, [
                      (c(!0), g(se, null, Me(Te.items, (xe) => (c(), g("div", {
                        key: xe.key,
                        class: "flex items-center gap-2.5 p-px"
                      }, [
                        v("div", jP, [
                          te(I(Cn), {
                            id: S(xe.key),
                            "model-value": xe.visible,
                            variant: "default",
                            "onUpdate:modelValue": (we) => re(xe)
                          }, null, 8, ["id", "model-value", "onUpdate:modelValue"])
                        ]),
                        v("label", {
                          for: S(xe.key),
                          class: "flex-1 min-w-0 text-sm font-medium font-inter truncate text-(--colors-text-heading) cursor-pointer"
                        }, P(xe.label), 9, WP),
                        v("div", qP, [
                          xe.pinned || xe.badge ? (c(), g("span", {
                            key: 0,
                            class: C(["inline-flex items-center px-1 py-0.5 rounded text-xs font-medium leading-5 font-inter", z(xe.badge ?? "fige")])
                          }, P(D(xe)), 3)) : k("", !0),
                          te(I(ft), {
                            text: J(xe),
                            position: "top",
                            tabindex: q(xe) ? void 0 : 0
                          }, {
                            default: ve(() => [
                              v("button", {
                                type: "button",
                                class: C([
                                  "inline-flex items-center justify-center size-6 rounded transition-colors duration-150 hover:bg-(--colors-background-hover) disabled:cursor-not-allowed disabled:hover:bg-transparent",
                                  xe.pinned ? "text-(--colors-text-black-default)" : "text-(--colors-text-body-subtle) hover:text-(--colors-text-black-default)"
                                ]),
                                disabled: !q(xe),
                                "aria-label": N(xe),
                                "aria-pressed": xe.pinned,
                                onClick: Ue((we) => ue(xe), ["stop"])
                              }, [
                                v("i", {
                                  class: C([xe.pinned ? "ri-pushpin-2-fill" : "ri-pushpin-2-line", "text-2xl leading-none"])
                                }, null, 2)
                              ], 10, UP)
                            ]),
                            _: 2
                          }, 1032, ["text", "tabindex"])
                        ])
                      ]))), 128))
                    ])
                  ], 8, VP))), 128)),
                  j.value.length === 0 ? (c(), g("div", GP, P(o.value.emptySearchText), 1)) : k("", !0)
                ])) : u.value === "order" ? (c(), g("div", KP, [
                  d.value.trim() && B.value.length > 0 ? (c(), g("div", YP, [
                    Le[6] || (Le[6] = v("i", { class: "ri-information-line text-sm shrink-0" }, null, -1)),
                    v("span", null, P(o.value.orderSearchHint), 1)
                  ])) : k("", !0),
                  v("div", {
                    class: "flex flex-col gap-3",
                    role: "list",
                    "aria-label": o.value.orderListLabel
                  }, [
                    (c(!0), g(se, null, Me(B.value, (Te, xe) => (c(), K(fM, {
                      key: Te.key,
                      label: Te.label,
                      disabled: Te.disabled || Te.alwaysVisible,
                      reorderable: be(Te),
                      class: C([
                        "transition-all duration-150 ease-out rounded-xl focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-(--border-border-accent) focus-visible:ring-offset-1",
                        b.value === xe && f.value !== xe ? "ring-2 ring-(--border-border-hover) rounded-xl" : "",
                        f.value === xe ? "opacity-40" : "",
                        m.value === xe ? "ring-2 ring-(--border-border-accent) rounded-xl" : ""
                      ]),
                      role: "listitem",
                      "aria-roledescription": be(Te) ? "sortable" : void 0,
                      "data-picked-up": m.value === xe ? "true" : void 0,
                      tabindex: "0",
                      onDragstart: (we) => ae(xe, we),
                      onDragover: Ue((we) => Z(xe), ["prevent"]),
                      onDragend: fe,
                      onDrop: Ue((we) => ie(xe), ["prevent"]),
                      onKeydown: (we) => de(xe, we)
                    }, {
                      badge: ve(() => [
                        Te.pinned || Te.badge ? (c(), g("span", {
                          key: 0,
                          class: C(["shrink-0 inline-flex items-center px-1 py-0.5 rounded text-xs font-medium leading-5 font-inter", z(Te.badge ?? "fige")])
                        }, P(D(Te)), 3)) : k("", !0)
                      ]),
                      actions: ve(() => [
                        Te.disabled || Te.alwaysVisible ? (c(), K(I(ft), {
                          key: 0,
                          text: o.value.pinTooltip,
                          position: "top"
                        }, {
                          default: ve(() => [
                            v("button", {
                              type: "button",
                              class: "shrink-0 size-6 flex items-center justify-center",
                              disabled: "",
                              "aria-label": o.value.pinTooltip
                            }, [...Le[7] || (Le[7] = [
                              v("i", { class: "ri-pushpin-2-fill text-2xl leading-none text-(--colors-text-body-subtle)" }, null, -1)
                            ])], 8, ZP)
                          ]),
                          _: 1
                        }, 8, ["text"])) : (c(), K(I(ft), {
                          key: 1,
                          text: J(Te),
                          position: "top",
                          tabindex: q(Te) ? void 0 : 0
                        }, {
                          default: ve(() => [
                            v("button", {
                              type: "button",
                              class: "shrink-0 size-6 flex items-center justify-center rounded transition-colors duration-150 hover:bg-(--colors-background-hover) disabled:cursor-not-allowed disabled:hover:bg-transparent",
                              disabled: !q(Te),
                              "aria-label": N(Te),
                              "aria-pressed": Te.pinned,
                              onClick: Ue((we) => ue(Te), ["stop"])
                            }, [
                              v("i", {
                                class: C([
                                  Te.pinned ? "ri-pushpin-2-fill text-(--colors-text-black-default)" : "ri-pushpin-2-line text-(--colors-text-body-subtle)",
                                  "text-2xl leading-none"
                                ])
                              }, null, 2)
                            ], 8, XP)
                          ]),
                          _: 2
                        }, 1032, ["text", "tabindex"]))
                      ]),
                      _: 2
                    }, 1032, ["label", "disabled", "reorderable", "class", "aria-roledescription", "data-picked-up", "onDragstart", "onDragover", "onDrop", "onKeydown"]))), 128))
                  ], 8, JP),
                  B.value.length === 0 ? (c(), g("div", QP, P(o.value.emptyOrderText), 1)) : k("", !0)
                ])) : k("", !0)
              ]),
              _: 1
            })
          ], 8, RP)
        ], 512)
      ]),
      _: 1
    }, 8, ["model-value", "aria-label"]));
  }
}), n8 = /* @__PURE__ */ lt(t8, [["__scopeId", "data-v-9797dcb1"]]);
function vq(e = {}) {
  const { defaultOpen: n = !1, onClose: t } = e, a = E(n);
  return { isOpen: a, open: () => {
    a.value = !0;
  }, close: () => {
    a.value = !1, t == null || t();
  }, toggle: () => {
    a.value = !a.value;
  } };
}
const a8 = ["aria-busy"], l8 = {
  key: 0,
  class: "border-b border-(--colors-border-base-soft) dark:border-(--colors-border-base)"
}, r8 = ["id", "role", "aria-labelledby", "aria-busy"], o8 = {
  key: 1,
  class: "border border-(--colors-border-base-soft) dark:border-(--colors-border-base) px-5 py-3 bg-white dark:bg-(--colors-background-black-default) rounded-b-xl"
}, i8 = {
  key: 0,
  "data-testid": "table-skeleton-footer",
  "aria-hidden": "true",
  class: "flex items-center justify-between h-7"
}, s8 = { class: "flex items-center gap-2.5" }, xq = /* @__PURE__ */ ye({
  __name: "TableShell",
  props: {
    query: {},
    views: { default: void 0 },
    permissions: { default: () => ({}) },
    labels: { default: void 0 },
    showTopbar: { type: Boolean, default: !0 },
    showControls: { type: Boolean, default: !0 },
    showFilter: { type: Boolean, default: !0 },
    searchPlaceholder: { default: "Search..." },
    showSearch: { type: Boolean, default: !0 },
    searchDebounce: { default: hs },
    markSearchStale: { type: Boolean, default: !0 },
    showViewSelector: { type: Boolean, default: !1 },
    tabDropdowns: { default: () => [] },
    columnSettings: { default: void 0 },
    loading: { type: Boolean, default: !1 },
    skeletonColumns: { default: void 0 },
    skeletonRows: { default: void 0 },
    bordered: { type: Boolean, default: !1 }
  },
  emits: ["rename-view", "delete-view", "set-default", "save-view", "share-view", "toggle-filter-panel", "toggle-filter-bar", "edit-filter", "tab-requested", "tab-reordered"],
  setup(e, { expose: n, emit: t }) {
    const a = Ht(), l = e, r = t;
    nn(Xl, l.query), l.views && nn(fs, l.views), l.columnSettings && nn(uO, l.columnSettings);
    const o = p(() => l.permissions ?? {});
    nn(Bv, o.value);
    const i = p(() => ({ ...Ov, ...l.labels }));
    nn(Mv, i);
    const s = Ve(), d = p(() => {
      var T;
      const S = l.query.state.activeViewId;
      return l.showTopbar && !!S && !!((T = l.views) != null && T.presetViews.value.some((L) => L.id === S)) ? zv(s, S) : null;
    });
    nn(Dv, { id: s, isTabpanel: p(() => d.value !== null) });
    const u = E(!1), f = E(!0);
    function b() {
      u.value = !u.value, r("toggle-filter-panel");
    }
    function h() {
      f.value = !f.value, r("toggle-filter-bar", f.value);
    }
    n({ toggleFilterPanel: b });
    const m = p(
      () => l.skeletonColumns ?? (l.columnSettings && l.columnSettings.settingsItems.value.filter((S) => S.visible).length || void 0) ?? 5
    ), x = p(() => l.skeletonRows ?? l.query.state.pageSize), y = p(
      () => l.markSearchStale && l.query.searchPending.value && !l.loading
    ), w = p(
      () => {
        var S, $;
        return l.showControls && (l.showFilter || ((S = l.permissions) == null ? void 0 : S.canSaveView) !== !1 || (($ = l.permissions) == null ? void 0 : $.canShareView) !== !1 || a("controls-info") || a("controls-actions") || a("filter"));
      }
    );
    return (S, $) => (c(), g(se, null, [
      v("div", {
        "data-table-shell-root": "",
        class: "w-full flex flex-col flex-1 min-h-0",
        "aria-busy": e.loading || void 0
      }, [
        e.showTopbar ? (c(), K(Pv, {
          key: 0,
          "search-placeholder": e.searchPlaceholder,
          "show-search": e.showSearch,
          "search-debounce": e.searchDebounce,
          "show-view-selector": e.showViewSelector,
          "tab-dropdowns": e.tabDropdowns,
          onRenameView: $[0] || ($[0] = (T) => r("rename-view", T)),
          onDeleteView: $[1] || ($[1] = (T) => r("delete-view", T)),
          onSetDefault: $[2] || ($[2] = (T) => r("set-default", T)),
          onTabRequested: $[3] || ($[3] = (T, L) => r("tab-requested", T, L)),
          onTabReordered: $[4] || ($[4] = (T, L) => r("tab-reordered", T, L))
        }, null, 8, ["search-placeholder", "show-search", "search-debounce", "show-view-selector", "tab-dropdowns"])) : k("", !0),
        v("div", {
          class: C([
            "flex flex-col flex-1 min-h-0 bg-white dark:bg-(--colors-background-black-default) shadow-[0px_1px_0.5px_0.05px_rgba(29,41,61,0.02)] dark:shadow-[0px_0px_4px_rgba(255,255,255,0.1)] overflow-hidden",
            e.showTopbar ? w.value ? "rounded-b-xl rounded-tr-xl" : "rounded-b-xl" : "rounded-xl",
            // -mt-px pulls this card up 1px over the tabs row above so its own top border sits
            // underneath the tabs' bottom edge instead of showing as a seam; pt-px compensates
            // so the card's own content doesn't shift up with it.
            e.bordered && "border border-(--colors-border-base-soft) dark:border-(--colors-border-base) -mt-px pt-px"
          ])
        }, [
          w.value ? (c(), K(Fv, {
            key: 0,
            "is-filter-panel-open": u.value,
            "is-filter-bar-visible": f.value,
            "show-filter": e.showFilter,
            bordered: !e.bordered,
            onToggleFilterPanel: b,
            onToggleFilterBar: h,
            onSaveView: $[5] || ($[5] = (T) => r("save-view")),
            onShareView: $[6] || ($[6] = (T) => r("share-view"))
          }, _n({ _: 2 }, [
            S.$slots.filter ? {
              name: "filter",
              fn: ve(() => [
                $e(S.$slots, "filter")
              ]),
              key: "0"
            } : void 0,
            S.$slots["controls-info"] ? {
              name: "controls-info",
              fn: ve(() => [
                $e(S.$slots, "controls-info")
              ]),
              key: "1"
            } : void 0,
            S.$slots["controls-actions"] ? {
              name: "controls-actions",
              fn: ve(() => [
                $e(S.$slots, "controls-actions")
              ]),
              key: "2"
            } : void 0
          ]), 1032, ["is-filter-panel-open", "is-filter-bar-visible", "show-filter", "bordered"])) : k("", !0),
          te(wt, {
            "enter-active-class": "transition-all duration-200 ease-out overflow-hidden",
            "enter-from-class": "max-h-0 opacity-0",
            "enter-to-class": "max-h-[600px] opacity-100",
            "leave-active-class": "transition-all duration-150 ease-in overflow-hidden",
            "leave-from-class": "max-h-[600px] opacity-100",
            "leave-to-class": "max-h-0 opacity-0"
          }, {
            default: ve(() => [
              u.value ? (c(), g("div", l8, [
                $e(S.$slots, "filter-panel", {
                  close: () => u.value = !1
                })
              ])) : k("", !0)
            ]),
            _: 3
          }),
          te(wt, {
            "enter-active-class": "transition-[max-height] duration-200 ease-out overflow-hidden",
            "enter-from-class": "max-h-0",
            "enter-to-class": "max-h-[100px]",
            "leave-active-class": "transition-[max-height] duration-150 ease-in overflow-hidden",
            "leave-from-class": "max-h-[100px]",
            "leave-to-class": "max-h-0"
          }, {
            default: ve(() => [
              f.value ? (c(), K(Vv, {
                key: 0,
                bordered: !e.bordered,
                onEditFilter: $[7] || ($[7] = (T) => r("edit-filter", T))
              }, null, 8, ["bordered"])) : k("", !0)
            ]),
            _: 1
          }),
          v("div", {
            id: I(s),
            role: d.value ? "tabpanel" : void 0,
            "aria-labelledby": d.value ?? void 0,
            class: C(["flex-1 overflow-x-hidden min-h-0 transition-opacity", y.value && "opacity-50"]),
            "aria-busy": y.value || void 0,
            "data-testid": "table-shell-body"
          }, [
            e.loading ? (c(), K(HO, {
              key: 0,
              columns: m.value,
              rows: x.value
            }, null, 8, ["columns", "rows"])) : $e(S.$slots, "table", { key: 1 })
          ], 10, r8),
          e.loading || I(a)("pagination") ? (c(), g("div", o8, [
            e.loading ? (c(), g("div", i8, [
              $[9] || ($[9] = v("div", { class: "flex items-center gap-3" }, [
                v("div", { class: "skeleton h-1.5 w-36 rounded-full" }),
                v("div", { class: "skeleton h-1.5 w-11 rounded-full" })
              ], -1)),
              v("div", s8, [
                (c(), g(se, null, Me(5, (T) => v("div", {
                  key: `skeleton-page-${T}`,
                  class: "skeleton size-7 rounded-md"
                })), 64))
              ])
            ])) : $e(S.$slots, "pagination", { key: 1 })
          ])) : k("", !0)
        ], 2)
      ], 8, a8),
      e.columnSettings ? (c(), K(I(n8), {
        key: 0,
        modelValue: e.columnSettings.drawerOpen.value,
        "onUpdate:modelValue": $[8] || ($[8] = (T) => e.columnSettings.drawerOpen.value = T),
        columns: e.columnSettings.settingsItems.value,
        "default-columns": e.columnSettings.defaultSettingsItems.value,
        "column-order": e.columnSettings.order.value,
        labels: e.columnSettings.labels.value,
        onSave: e.columnSettings.handleSave,
        onReset: e.columnSettings.handleReset
      }, null, 8, ["modelValue", "columns", "default-columns", "column-order", "labels", "onSave", "onReset"])) : k("", !0)
    ], 64));
  }
}), d8 = { class: "flex flex-col" }, u8 = {
  key: 0,
  class: "border-b border-gainsboro dark:border-(--colors-border-base)"
}, yq = /* @__PURE__ */ ye({
  __name: "TableHeader",
  props: {
    showTopbar: { type: Boolean, default: !0 },
    showControls: { type: Boolean, default: !0 },
    showFilter: { type: Boolean, default: !0 },
    searchPlaceholder: { default: "Search..." },
    showSearch: { type: Boolean, default: !0 },
    searchDebounce: { default: hs },
    showViewSelector: { type: Boolean, default: !1 },
    tabDropdowns: { default: () => [] }
  },
  emits: ["rename-view", "delete-view", "set-default", "save-view", "share-view", "toggle-filter-panel", "edit-filter", "tab-requested"],
  setup(e, { expose: n, emit: t }) {
    const a = t, l = E(!1), r = E(!0);
    function o() {
      l.value = !l.value, a("toggle-filter-panel");
    }
    function i() {
      r.value = !r.value;
    }
    return n({ toggleFilterPanel: o }), (s, d) => (c(), g("div", d8, [
      e.showTopbar ? (c(), K(Pv, {
        key: 0,
        "search-placeholder": e.searchPlaceholder,
        "show-search": e.showSearch,
        "search-debounce": e.searchDebounce,
        "show-view-selector": e.showViewSelector,
        "tab-dropdowns": e.tabDropdowns,
        onRenameView: d[0] || (d[0] = (u) => a("rename-view", u)),
        onDeleteView: d[1] || (d[1] = (u) => a("delete-view", u)),
        onSetDefault: d[2] || (d[2] = (u) => a("set-default", u)),
        onTabRequested: d[3] || (d[3] = (u, f) => a("tab-requested", u, f))
      }, null, 8, ["search-placeholder", "show-search", "search-debounce", "show-view-selector", "tab-dropdowns"])) : k("", !0),
      e.showControls ? (c(), K(Fv, {
        key: 1,
        "is-filter-panel-open": l.value,
        "is-filter-bar-visible": r.value,
        "show-filter": e.showFilter,
        onToggleFilterPanel: o,
        onToggleFilterBar: i,
        onSaveView: d[4] || (d[4] = (u) => a("save-view")),
        onShareView: d[5] || (d[5] = (u) => a("share-view"))
      }, _n({ _: 2 }, [
        s.$slots.filter ? {
          name: "filter",
          fn: ve(() => [
            $e(s.$slots, "filter")
          ]),
          key: "0"
        } : void 0,
        s.$slots["controls-info"] ? {
          name: "controls-info",
          fn: ve(() => [
            $e(s.$slots, "controls-info")
          ]),
          key: "1"
        } : void 0,
        s.$slots["controls-actions"] ? {
          name: "controls-actions",
          fn: ve(() => [
            $e(s.$slots, "controls-actions")
          ]),
          key: "2"
        } : void 0
      ]), 1032, ["is-filter-panel-open", "is-filter-bar-visible", "show-filter"])) : k("", !0),
      te(wt, {
        "enter-active-class": "transition-all duration-200 ease-out overflow-hidden",
        "enter-from-class": "max-h-0 opacity-0",
        "enter-to-class": "max-h-[600px] opacity-100",
        "leave-active-class": "transition-all duration-150 ease-in overflow-hidden",
        "leave-from-class": "max-h-[600px] opacity-100",
        "leave-to-class": "max-h-0 opacity-0"
      }, {
        default: ve(() => [
          l.value ? (c(), g("div", u8, [
            $e(s.$slots, "filter-panel", {
              close: () => l.value = !1
            })
          ])) : k("", !0)
        ]),
        _: 3
      }),
      te(wt, {
        "enter-active-class": "transition-[max-height] duration-200 ease-out overflow-hidden",
        "enter-from-class": "max-h-0",
        "enter-to-class": "max-h-[100px]",
        "leave-active-class": "transition-[max-height] duration-150 ease-in overflow-hidden",
        "leave-from-class": "max-h-[100px]",
        "leave-to-class": "max-h-0"
      }, {
        default: ve(() => [
          r.value ? (c(), K(Vv, {
            key: 0,
            onEditFilter: d[6] || (d[6] = (u) => a("edit-filter", u))
          })) : k("", !0)
        ]),
        _: 1
      })
    ]));
  }
});
function kq(e = {}) {
  const n = E(e.initialViews ?? []), t = p(() => n.value.filter((d) => d.isPreset)), a = p(() => n.value.filter((d) => !d.isPreset));
  function l(d) {
    n.value.push(d);
  }
  function r(d, u) {
    const f = n.value.findIndex((b) => b.id === d);
    f !== -1 && (n.value[f] = { ...n.value[f], ...u });
  }
  function o(d) {
    n.value = n.value.filter((u) => u.id !== d);
  }
  function i(d) {
    n.value.forEach((u) => {
      u.isDefault = u.id === d;
    });
  }
  function s(d) {
    const u = new Map(d.map((h, m) => [h, m])), f = n.value.filter((h) => h.isPreset).sort(
      (h, m) => (u.get(h.id) ?? Number.MAX_SAFE_INTEGER) - (u.get(m.id) ?? Number.MAX_SAFE_INTEGER)
    ), b = n.value.filter((h) => !h.isPreset);
    n.value = [...f, ...b];
  }
  return {
    views: n,
    presetViews: t,
    savedViews: a,
    addView: l,
    updateView: r,
    removeView: o,
    setDefault: i,
    reorderViews: s
  };
}
const ob = 10, c8 = 30, f8 = 900;
function wq() {
  function e() {
    return typeof window > "u" ? ob : window.innerHeight >= f8 ? c8 : ob;
  }
  const n = E(e());
  function t() {
    n.value = e();
  }
  return ot(() => {
    n.value = e(), window.addEventListener("resize", t, { passive: !0 });
  }), kt(() => {
    window.removeEventListener("resize", t);
  }), { pageSize: n };
}
function Cq(e) {
  const { defaultVisibility: n, defaultOrder: t = [] } = e, a = e.defaultPinning ?? {
    left: Rt(e.columns).filter((M) => M.pinned).map((M) => M.key),
    right: []
  }, l = p(
    () => new Set(
      Rt(e.columns).filter((M) => M.disabled || M.alwaysVisible).map((M) => M.key)
    )
  ), r = p(() => [...l.value]), o = (M) => l.value.has(M), i = rl(
    n ?? Object.fromEntries(Rt(e.columns).map((M) => [M.key, M.visible ?? !0]))
  ), s = Array.from(/* @__PURE__ */ new Set([...r.value, ...a.left])), d = E({
    left: s,
    right: [...a.right]
  }), u = E([...t]), f = E(!1), b = (M) => {
    var W;
    return ((W = d.value.left) == null ? void 0 : W.includes(M)) ?? !1;
  }, h = p(
    () => Rt(e.columns).filter((M) => (o(M.key) || (i[M.key] ?? !0)) && (o(M.key) || b(M.key))).length
  ), m = p(() => h.value >= Ar);
  function x(M) {
    return b(M) || !m.value;
  }
  const y = p(() => Rt(e.columns).map((M) => ({
    ...M,
    visible: i[M.key] ?? !0,
    pinned: b(M.key)
  }))), w = p(() => {
    const M = n ?? Object.fromEntries(Rt(e.columns).map((G) => [G.key, G.visible ?? !0])), W = new Set(a.left);
    return Rt(e.columns).map((G) => ({
      ...G,
      visible: M[G.key] ?? !0,
      pinned: W.has(G.key)
    }));
  }), S = p(() => Rt(e.labels) ?? {});
  function $() {
    f.value = !0;
  }
  function T() {
    f.value = !1;
  }
  function L(M) {
    for (const q of M)
      i[q.key] = o(q.key) ? !0 : q.visible;
    const W = [], G = [], B = [], F = [];
    for (const q of M)
      o(q.key) ? W.push(q.key) : q.visible ? q.pinned ? G.push(q.key) : B.push(q.key) : F.push(q.key);
    u.value = [...W, ...G, ...B, ...F, ...e.trailingColumns ?? []];
    const X = new Set(Rt(e.columns).map((q) => q.key)), H = (d.value.left ?? []).filter((q) => !X.has(q));
    d.value = {
      left: [...H, ...W, ...G],
      right: [...d.value.right ?? []]
    };
  }
  function A() {
    const M = n ?? Object.fromEntries(Rt(e.columns).map((G) => [G.key, G.visible ?? !0]));
    Object.keys(i).forEach((G) => {
      i[G] = o(G) ? !0 : M[G] ?? !0;
    }), u.value = [...t];
    const W = Array.from(/* @__PURE__ */ new Set([...r.value, ...a.left]));
    d.value = { left: W, right: [...a.right] };
  }
  function R() {
    return u.value.length > 0 ? [...u.value] : [...Rt(e.columns).map((M) => M.key), ...e.trailingColumns ?? []];
  }
  function z(M) {
    if (b(M) || !x(M)) return;
    const W = [...d.value.left ?? [], M];
    d.value = { ...d.value, left: W };
    const G = new Set(W), B = R().filter((X) => X !== M);
    let F = -1;
    for (let X = 0; X < B.length; X++)
      G.has(B[X]) && (F = X);
    B.splice(F + 1, 0, M), u.value = B;
  }
  function D(M) {
    o(M) || (d.value = {
      ...d.value,
      left: (d.value.left ?? []).filter((W) => W !== M)
    });
  }
  function V(M, W) {
    if (M.length !== W.length) return !1;
    for (let G = 0; G < M.length; G++) if (M[G] !== W[G]) return !1;
    return !0;
  }
  function Y(M) {
    const W = e.trailingColumns ?? [], G = new Set(W), B = M.filter((q) => !G.has(q)), F = [...B, ...W];
    V(F, u.value) || (u.value = F);
    const X = new Set(d.value.left ?? []), H = B.filter((q) => X.has(q));
    V(H, d.value.left ?? []) || (d.value = { ...d.value, left: H });
  }
  function _(M) {
    const W = new Set(Rt(e.columns).map((q) => q.key)), G = M.filter((q) => W.has(q));
    if (G.length <= Ar) return M;
    const B = G.filter((q) => o(q)), F = G.filter((q) => !o(q)), X = Math.max(0, Ar - B.length), H = /* @__PURE__ */ new Set([...B, ...F.slice(0, X)]);
    return M.filter((q) => !W.has(q) || H.has(q));
  }
  function j(M) {
    const W = _(M.left ?? []), G = M.right ?? [], B = d.value.left ?? [], F = d.value.right ?? [];
    V(W, B) && V(G, F) || (d.value = { left: [...W], right: [...G] });
  }
  return {
    // State
    visibility: i,
    pinning: d,
    order: u,
    drawerOpen: f,
    // Computed
    settingsItems: y,
    defaultSettingsItems: w,
    labels: S,
    isPinned: b,
    isFrozenLimitReached: m,
    canPinColumn: x,
    // Actions
    openDrawer: $,
    closeDrawer: T,
    handleSave: L,
    handleReset: A,
    pinColumn: z,
    unpinColumn: D,
    setOrder: Y,
    setPinning: j
  };
}
const h8 = {
  "data-testid": "filter-field-picker",
  class: "flex min-h-0 flex-col"
}, b8 = {
  role: "status",
  "aria-live": "polite",
  class: "sr-only",
  "data-testid": "filter-field-picker-status"
}, g8 = {
  class: "flex min-h-0 flex-col pb-2",
  "data-testid": "filter-field-picker-content"
}, p8 = ["aria-label"], m8 = ["data-empty-reason"], Nv = /* @__PURE__ */ ye({
  __name: "FilterFieldPicker",
  props: {
    fields: {},
    groups: { default: () => [] },
    activeGroup: { default: void 0 },
    strictGroups: { type: Boolean, default: !1 },
    searchQuery: { default: "" },
    searchPlaceholder: {},
    searchLabel: { default: void 0 },
    searchClearLabel: { default: "Clear search" },
    groupsLabel: { default: void 0 },
    groupAriaLabel: { default: void 0 },
    listLabel: {},
    selectedKey: { default: void 0 },
    selectable: { type: Boolean, default: !0 },
    noResultsLabel: { default: void 0 },
    resultsCountLabel: { type: [String, Function], default: "{count} results" },
    noFieldsLabel: { default: void 0 },
    emptyGroupLabel: { default: void 0 }
  },
  emits: ["select", "update:activeGroup", "update:searchQuery"],
  setup(e, { expose: n, emit: t }) {
    const a = e, l = t, r = E(null), o = E(null), i = p(() => {
      let R = a.fields;
      return a.groups.length && a.activeGroup && (R = R.filter((z) => z.group === a.activeGroup || !z.group && !a.strictGroups)), a.searchQuery.trim() && (R = R.filter((z) => Pu(z.label, a.searchQuery))), R;
    }), s = p(() => a.searchQuery.trim() ? a.noResultsLabel : a.fields.length ? a.emptyGroupLabel ?? a.noFieldsLabel : a.noFieldsLabel), d = p(() => a.searchQuery.trim() ? "no-results" : a.fields.length ? "empty-group" : "no-fields"), { focusedIndex: u, handleRovingKeydown: f, handleSearchFieldKeydown: b, clampFocusedIndex: h } = no(), m = p(() => i.value.findIndex((R) => R.key === a.selectedKey));
    Ie(
      [m, () => i.value.length],
      ([R, z]) => {
        R >= 0 ? u.value = R : h(z);
      },
      { immediate: !0 }
    );
    function x(R) {
      return !a.selectable || !!R.disabled;
    }
    function y(R) {
      x(R) || l("select", R.key);
    }
    function w(R, z) {
      return {
        role: "option",
        "aria-selected": R.key === a.selectedKey,
        tabindex: z === u.value ? 0 : -1,
        "data-listbox-index": z,
        onClick: () => y(R),
        onKeydown: ut(Ue(() => y(R), ["self", "prevent"]), ["enter", "space"]),
        onFocus: () => {
          u.value = z;
        }
      };
    }
    function S(R) {
      f(R, i.value.length, o.value);
    }
    function $(R) {
      if (!(R.target instanceof HTMLInputElement)) return;
      const z = m.value;
      b(R, i.value.length, o.value, z >= 0 ? { downIndex: z, upIndex: z } : {});
    }
    function T() {
      var R;
      return ((R = r.value) == null ? void 0 : R.focusSearch()) ?? !1;
    }
    function L(R = u.value) {
      var D;
      const z = (D = o.value) == null ? void 0 : D.querySelector(`[data-listbox-index="${R}"]`);
      return z ? (u.value = R, z.focus({ preventScroll: !0 }), z.scrollIntoView({ block: "nearest" }), !0) : !1;
    }
    function A(R) {
      const z = i.value.findIndex((D) => D.key === R);
      return z >= 0 && L(z);
    }
    return n({ focusSearch: T, focusOption: L, focusField: A }), (R, z) => (c(), g("div", h8, [
      te(sl, {
        ref_key: "headerRef",
        ref: r,
        class: "shrink-0",
        "show-search": "",
        "search-query": e.searchQuery,
        "search-placeholder": e.searchPlaceholder,
        "search-label": e.searchLabel ?? e.searchPlaceholder,
        "search-clear-label": e.searchClearLabel,
        "group-buttons": e.groups,
        "active-group": e.activeGroup,
        "group-label-left": e.groupsLabel,
        "group-aria-label": e.groupAriaLabel,
        onKeydown: $,
        "onUpdate:searchQuery": z[0] || (z[0] = (D) => l("update:searchQuery", D)),
        "onUpdate:activeGroup": z[1] || (z[1] = (D) => l("update:activeGroup", D))
      }, null, 8, ["search-query", "search-placeholder", "search-label", "search-clear-label", "group-buttons", "active-group", "group-label-left", "group-aria-label"]),
      v("span", b8, P(i.value.length ? I(Du)(e.resultsCountLabel, i.value.length) : s.value), 1),
      v("div", g8, [
        i.value.length ? (c(), g("div", {
          key: 0,
          ref_key: "listboxRef",
          ref: o,
          role: "listbox",
          "aria-label": e.listLabel,
          class: "flex min-h-0 flex-col overflow-y-auto px-2 py-1.5",
          "data-testid": "filter-field-picker-list",
          onKeydown: S
        }, [
          (c(!0), g(se, null, Me(i.value, (D, V) => (c(), K(Gt, Oe({
            key: D.key
          }, { ref_for: !0 }, w(D, V), {
            type: "two-icons",
            label: D.label,
            icon: D.icon,
            selected: D.key === e.selectedKey,
            "aria-disabled": x(D),
            description: D.disabled ? D.disabledReason : void 0,
            class: "shrink-0",
            "data-testid": `filter-field-picker-option-${D.key}`
          }), null, 16, ["label", "icon", "selected", "aria-disabled", "description", "data-testid"]))), 128))
        ], 40, p8)) : s.value ? (c(), g("div", {
          key: 1,
          "data-testid": "filter-field-picker-empty",
          "data-empty-reason": d.value,
          class: "flex flex-col items-center justify-center px-4 py-6 text-center text-(length:--size-m) leading-(--line-height-l) font-(--weight-regular) text-(--colors-text-body-subtle) dark:text-(--colors-text-white-secondary)"
        }, P(s.value), 9, m8)) : k("", !0)
      ])
    ]));
  }
}), v8 = ["id", "aria-label", "data-size"], x8 = {
  key: 0,
  "data-testid": "filter-step-list",
  class: "flex min-h-0 flex-col"
}, y8 = { class: "flex min-h-0 flex-col pb-2" }, k8 = ["aria-multiselectable", "aria-label"], w8 = {
  key: 0,
  "data-testid": "filter-select-all",
  class: "shrink-0 border-b border-(--border-border-base-soft) px-2 pt-2 pb-[calc(--spacing(2)-1px)] dark:border-(--colors-border-base)"
}, C8 = {
  key: 1,
  class: "min-h-0 overflow-y-auto"
}, S8 = {
  key: 1,
  "data-testid": "filter-step-list-empty",
  class: "px-4 py-6 text-center text-(length:--size-m) leading-(--line-height-l) font-(--weight-regular) text-(--colors-text-body-subtle) dark:text-(--colors-text-white-secondary)"
}, $8 = {
  key: 1,
  class: "flex min-h-0 flex-col"
}, I8 = { class: "flex min-h-0 flex-col overflow-y-auto pb-2" }, T8 = {
  key: 0,
  "data-testid": "filter-step-text",
  class: "flex flex-col gap-4 px-3 py-4"
}, L8 = { "data-testid": "filter-text-validate-error" }, E8 = ["aria-label"], A8 = {
  key: 0,
  class: "text-(length:--size-sm) leading-(--line-height-l) text-(--text-text-error-strong) dark:text-(--text-text-error)",
  role: "alert"
}, R8 = ["aria-label"], B8 = { class: "flex items-start gap-6" }, M8 = {
  key: 0,
  class: "text-(length:--size-sm) leading-(--line-height-l) text-(--text-text-error-strong) dark:text-(--text-text-error)",
  role: "alert"
}, Bo = 4, or = 16, D8 = 540, z8 = 240, Sq = /* @__PURE__ */ ye({
  __name: "TableFilterSelector",
  props: {
    fields: {},
    fieldGroups: { default: () => [] },
    fieldGroupsLabel: { default: "" },
    triggerLabel: { default: "Filter" },
    triggerIconLeft: { default: void 0 },
    activeCount: { default: 0 },
    step1SearchPlaceholder: { default: "Search a filter…" },
    searchClearLabel: { default: "Clear search" },
    step1FooterLabel: { default: "Rechercher par :" },
    advancedFiltersLabel: { default: "Filters avancées" },
    advancedFiltersIcon: { default: "ri-equalizer-line" },
    viewAdvancedLabel: { default: "" },
    createAdvancedLabel: { default: "" },
    advancedDisabled: { type: Boolean, default: !1 },
    advancedDisabledTooltip: { default: "" },
    backLabel: { default: "Back" },
    confirmLabel: { default: "Confirm" },
    closeOnConfirm: { type: Boolean, default: !0 },
    dateRangeErrorLabel: { default: 'The "From" date must be before or equal to the "To" date.' },
    noResultsLabel: { default: "No results for" },
    noFieldResultsLabel: { default: "No field matches your search" },
    resultsCountLabel: { type: [String, Function], default: "{count} results" },
    selectedCountLabel: { type: Function, default: (e, n) => `${e} of ${n} selected` },
    noFieldsLabel: { default: "" },
    activeFilters: { default: () => ({}) },
    fieldsSelectable: { type: Boolean, default: !0 }
  },
  emits: ["apply", "apply-filter", "remove-filter", "advanced-filters", "view-advanced-filters", "create-advanced-filter"],
  setup(e, { expose: n, emit: t }) {
    var co, fo;
    const a = e, l = t, r = E(null), o = p(() => {
      var ce;
      return ((ce = r.value) == null ? void 0 : ce.$el) ?? null;
    }), { isOpen: i, dropdownRef: s, toggleDropdown: d, openDropdown: u, closeDropdown: f } = Yl({
      onClose: uo,
      ignoreSelectors: [
        '[data-testid="datepicker-dropdown-menu"]',
        '[data-testid="datepicker-dob-picker"]',
        '[data-testid="filter-selector-menu"]'
      ]
    }), b = E({}), h = E(null), m = E(null), x = E(null);
    function y() {
      var jc, Wc;
      const ce = (jc = o.value) == null ? void 0 : jc.getBoundingClientRect();
      if (!ce) return;
      const pe = typeof window < "u" ? window.innerWidth : ce.right, Se = typeof window < "u" ? window.innerHeight : ce.bottom, We = ((Wc = m.value) == null ? void 0 : Wc.offsetWidth) ?? 0, ms = ce.left + ce.width / 2 > pe / 2 ? ce.right - We : ce.left, lx = Math.max(or, pe - or - We), vs = Se - ce.bottom - Bo - or, Nc = ce.top - Bo - or, Hc = vs < z8 && Nc > vs;
      b.value = {
        position: "fixed",
        ...Hc ? { bottom: `${Se - ce.top + Bo}px` } : { top: `${ce.bottom + Bo}px` },
        left: `${Math.max(or, Math.min(ms, lx))}px`,
        maxHeight: `${Math.min(D8, Math.max(Hc ? Nc : vs, 0))}px`,
        zIndex: "50"
      };
    }
    function w() {
      typeof window > "u" || (window.addEventListener("scroll", y, !0), window.addEventListener("resize", y));
    }
    function S() {
      typeof window > "u" || (window.removeEventListener("scroll", y, !0), window.removeEventListener("resize", y));
    }
    Ie(i, (ce) => {
      ce ? qe(() => {
        var pe;
        if (y(), w(), h.value) {
          ze(h.value), h.value = null;
          return;
        }
        (pe = x.value) != null && pe.focusSearch() || Ce();
      }) : S();
    }), gt(S);
    function $(ce) {
      !i.value && (ce.key === "ArrowDown" || ce.key === "ArrowUp") && (ce.preventDefault(), u());
    }
    function T(ce) {
      if (i.value) {
        ze(ce);
        return;
      }
      h.value = ce, setTimeout(d, 0);
    }
    n({ openDropdown: u, closeDropdown: f, openForField: T, triggerEl: o });
    function L(ce) {
      i.value && (ce.stopPropagation(), ce.preventDefault(), A.value === "value" ? it() : (f(), qe(() => {
        var pe;
        return (pe = o.value) == null ? void 0 : pe.focus();
      })));
    }
    const A = E("field"), R = E(""), z = E(((fo = (co = a.fieldGroups) == null ? void 0 : co[0]) == null ? void 0 : fo.value) ?? "");
    Ie(
      () => a.fieldGroups,
      (ce) => {
        ce != null && ce.length && (ce.some((pe) => pe.value === z.value) || (z.value = ce[0].value));
      },
      { immediate: !0 }
    );
    const D = E(null), V = E(null), Y = E(""), _ = E(/* @__PURE__ */ new Set()), j = E(""), M = E(null), W = E(null), G = E(""), B = E(""), F = p(
      () => D.value != null ? a.fields.find((ce) => ce.key === D.value) ?? null : null
    );
    function X(ce, pe) {
      if (!ce) return null;
      const Se = ce.split(/[/\\\-.]/), We = pe.toLowerCase().split(/[/\\\-.]/), St = {};
      return We.forEach((Wa, ms) => {
        St[Wa] = parseInt(Se[ms], 10);
      }), isNaN(St.yyyy) || isNaN(St.mm) || isNaN(St.dd) ? null : new Date(St.yyyy, (St.mm || 1) - 1, St.dd || 1);
    }
    const H = p(() => {
      var ce;
      return (ce = F.value) != null && ce.maxLength ? j.value.length <= F.value.maxLength : !0;
    }), q = p(() => {
      var Se, We;
      if (((Se = F.value) == null ? void 0 : Se.type) !== "text") return null;
      const ce = (We = F.value) == null ? void 0 : We.validate;
      if (!ce) return null;
      const pe = j.value.trim();
      return pe.length === 0 ? null : ce(pe);
    }), N = p(() => {
      const ce = F.value;
      if (!(!ce || ce.type !== "text")) {
        if (ce.maxLength && j.value.length > ce.maxLength)
          return ce.maxLengthErrorLabel ?? `Maximum ${ce.maxLength} characters`;
        if (q.value) return q.value;
      }
    }), J = Ve(), be = p(() => `${J}-text`), ke = p(() => `${J}-date-from`), ee = p(() => `${J}-date-to`), oe = p(() => M.value == null || W.value == null ? !0 : M.value <= W.value), ge = p(() => {
      var We;
      if (!G.value || !B.value) return !0;
      const ce = ((We = F.value) == null ? void 0 : We.dateFormat) ?? "dd/mm/yyyy", pe = X(G.value, ce), Se = X(B.value, ce);
      return !pe || !Se ? !0 : pe <= Se;
    }), re = p(() => {
      var ce;
      return ((ce = F.value) == null ? void 0 : ce.type) ?? "list";
    }), ue = p(
      () => A.value === "value" && F.value && re.value !== "list" ? "m" : "l"
    ), O = p(() => ({ width: Wu[ue.value] }));
    Ie(ue, () => {
      i.value && qe(y);
    });
    const U = p(
      () => a.fields.map((ce) => ({
        key: ce.key,
        label: ce.label,
        icon: ce.icon,
        group: ce.group,
        disabled: ce.disabled,
        disabledReason: ce.disabledReason
      }))
    ), Q = p(() => !!a.viewAdvancedLabel && !!a.createAdvancedLabel), ae = p(() => {
      const ce = a.step1FooterLabel;
      if (Q.value)
        return {
          type: "buttons-column",
          label: ce,
          buttons: [
            {
              label: a.createAdvancedLabel,
              variant: "primary",
              icon: "ri-add-line",
              ariaDisabled: a.advancedDisabled,
              testId: "create-advanced-filter-btn"
            },
            {
              label: a.viewAdvancedLabel,
              variant: "secondary",
              icon: a.advancedFiltersIcon,
              ariaDisabled: a.advancedDisabled,
              testId: "view-advanced-filters-btn"
            }
          ],
          description: a.advancedDisabled && a.advancedDisabledTooltip || void 0
        };
      if (!a.advancedFiltersLabel) return null;
      const pe = {
        label: a.advancedFiltersLabel,
        variant: "secondary",
        icon: a.advancedFiltersIcon,
        testId: "advanced-filters-btn"
      };
      return ce ? { type: "label-button", label: ce, buttons: [pe] } : { type: "button", buttons: [pe] };
    });
    function Z(ce) {
      Q.value ? ce === 0 ? so() : ps() : gs();
    }
    const ie = p(() => {
      if (!F.value || re.value !== "list") return [];
      const ce = F.value.items ?? [], pe = Y.value.trim().toLowerCase();
      return pe ? ce.filter((Se) => Se.label.toLowerCase().includes(pe)) : ce;
    }), fe = p(() => {
      var ce;
      return (((ce = F.value) == null ? void 0 : ce.items) ?? []).length;
    }), de = p(() => {
      var Se;
      const ce = ((Se = F.value) == null ? void 0 : Se.items) ?? [];
      return ce.some((We) => typeof We.count == "number") ? ce.reduce((We, St) => We + (typeof St.count == "number" ? St.count : 0), 0) : fe.value;
    }), ne = p(
      () => {
        var ce;
        return (((ce = F.value) == null ? void 0 : ce.items) ?? []).filter((pe) => _.value.has(pe.id)).length;
      }
    ), le = p(
      () => ne.value === fe.value && fe.value > 0
    ), Le = p(
      () => ne.value > 0 && ne.value < fe.value
    ), Te = E(null), {
      focusedIndex: xe,
      handleRovingKeydown: we,
      clampFocusedIndex: he,
      focusListboxOption: De,
      handleSearchFieldKeydown: Ee
    } = no(), je = p(
      () => {
        var ce, pe;
        return !((ce = F.value) != null && ce.single) && !Y.value && (((pe = F.value) == null ? void 0 : pe.items) ?? []).length > 0;
      }
    ), Ge = p(
      () => (je.value ? 1 : 0) + ie.value.length
    );
    Ie(
      () => Ge.value,
      (ce) => he(ce)
    ), Ie(A, (ce) => {
      if (ce === "field") {
        const pe = V.value;
        qe(() => {
          var Se, We;
          pe && ((Se = x.value) != null && Se.focusField(pe)) || (We = x.value) != null && We.focusOption(0) || Ce();
        });
      }
    });
    function Qe() {
      xe.value = 0, qe(() => {
        De(Te.value, 0), Ce();
      });
    }
    function Ce() {
      var pe, Se, We;
      if ((pe = m.value) != null && pe.contains(document.activeElement)) return;
      (We = ((Se = m.value) == null ? void 0 : Se.querySelector(
        'input:not([type="hidden"]):not([type="range"]), textarea, button'
      )) ?? m.value) == null || We.focus({ preventScroll: !0 });
    }
    function me(ce) {
      we(ce, Ge.value, Te.value);
    }
    function Ae(ce) {
      ce.target instanceof HTMLInputElement && Ee(ce, Ge.value, Te.value);
    }
    function Ke(ce, pe, Se) {
      return {
        role: "option",
        "aria-selected": pe,
        tabindex: xe.value === ce ? 0 : -1,
        "data-listbox-index": ce,
        onClick: Se,
        onKeydown: ut(Ue(Se, ["self", "prevent"]), ["enter", "space"]),
        onFocus: () => {
          xe.value = ce;
        }
      };
    }
    const Je = p(
      () => ne.value > 0 ? a.selectedCountLabel(ne.value, fe.value) : ""
    ), _e = p(
      () => re.value === "text" && (!H.value || !!q.value) || re.value === "dateRange" && !ge.value || re.value === "range" && !oe.value
    ), At = p(() => ({
      type: "buttons-inline",
      buttons: [
        { label: a.backLabel, variant: "secondary", icon: "ri-arrow-left-line", testId: "filter-back-btn" },
        { label: a.confirmLabel, variant: "primary", disabled: _e.value, testId: "filter-apply-btn" }
      ]
    }));
    function Be(ce) {
      ce === 0 ? it() : Dn();
    }
    function ze(ce) {
      var We, St;
      const pe = D.value === ce;
      D.value = ce, Y.value = "";
      const Se = (We = a.activeFilters) == null ? void 0 : We[ce];
      Se ? (Se.type === "in" ? _.value = new Set(Se.values) : _.value = /* @__PURE__ */ new Set(), j.value = Se.type === "equals" ? String(Se.value) : "", M.value = Se.type === "range" ? Se.min : null, W.value = Se.type === "range" ? Se.max : null, G.value = Se.type === "dateRange" ? Se.from ?? "" : "", B.value = Se.type === "dateRange" ? Se.to ?? "" : "") : (_.value = /* @__PURE__ */ new Set(), j.value = "", M.value = null, W.value = null, G.value = "", B.value = ""), A.value = "value", (!pe || !((St = m.value) != null && St.contains(document.activeElement))) && Qe();
    }
    function He(ce) {
      a.fieldsSelectable && ze(ce);
    }
    function it() {
      V.value = D.value, A.value = "field", D.value = null;
    }
    function Ct(ce) {
      var Se;
      if ((Se = F.value) != null && Se.single) {
        _.value = _.value.has(ce) ? /* @__PURE__ */ new Set() : /* @__PURE__ */ new Set([ce]);
        return;
      }
      const pe = new Set(_.value);
      pe.has(ce) ? pe.delete(ce) : pe.add(ce), _.value = pe;
    }
    function Yt() {
      var ce;
      le.value ? _.value = /* @__PURE__ */ new Set() : _.value = new Set((((ce = F.value) == null ? void 0 : ce.items) ?? []).map((pe) => pe.id));
    }
    function Dn() {
      const ce = D.value, pe = re.value;
      if (pe === "list")
        l("apply", ce, [..._.value]);
      else if (pe === "text") {
        if (q.value)
          return;
        j.value.trim() ? l("apply-filter", ce, { type: "equals", value: j.value.trim() }) : l("remove-filter", ce);
      } else pe === "range" ? M.value != null || W.value != null ? l("apply-filter", ce, { type: "range", min: M.value, max: W.value }) : l("remove-filter", ce) : pe === "dateRange" && (G.value || B.value ? l("apply-filter", ce, {
        type: "dateRange",
        from: G.value || null,
        to: B.value || null
      }) : l("remove-filter", ce));
      a.closeOnConfirm ? (f(), qe(() => {
        var Se;
        return (Se = o.value) == null ? void 0 : Se.focus();
      })) : it();
    }
    function gs() {
      l("advanced-filters"), f();
    }
    function ps() {
      a.advancedDisabled || (l("view-advanced-filters"), f());
    }
    function so() {
      a.advancedDisabled || (l("create-advanced-filter"), f());
    }
    function uo() {
      var ce, pe;
      V.value = null, A.value = "field", D.value = null, R.value = "", z.value = ((pe = (ce = a.fieldGroups) == null ? void 0 : ce[0]) == null ? void 0 : pe.value) ?? "", Y.value = "", _.value = /* @__PURE__ */ new Set(), j.value = "", M.value = null, W.value = null, G.value = "", B.value = "";
    }
    return (ce, pe) => (c(), g("div", {
      ref_key: "dropdownRef",
      ref: s,
      class: "relative inline-block text-left dark:text-(--colors-text-white-default)",
      onKeydown: ut(L, ["escape"])
    }, [
      te(I(Re), {
        ref_key: "triggerButtonRef",
        ref: r,
        "data-testid": "filter-selector-trigger",
        size: "xs",
        variant: "secondary",
        "icon-left": e.triggerIconLeft,
        "dropdown-icon": "",
        "aria-expanded": I(i),
        "aria-controls": I(i) ? I(J) : void 0,
        "aria-haspopup": "dialog",
        onClick: I(d),
        onKeydown: $
      }, {
        default: ve(() => [
          at(P(e.triggerLabel) + " ", 1),
          e.activeCount > 0 ? (c(), K(ct, {
            key: 0,
            "data-testid": "filter-active-badge",
            class: "ms-1.5",
            theme: "active",
            size: "sm",
            "badge-style": "circle",
            "text-only": "",
            value: e.activeCount
          }, null, 8, ["value"])) : k("", !0)
        ]),
        _: 1
      }, 8, ["icon-left", "aria-expanded", "aria-controls", "onClick"]),
      (c(), K(Bn, { to: "body" }, [
        te(wt, {
          "enter-active-class": "transition duration-100 ease-out motion-reduce:transition-none",
          "enter-from-class": "transform scale-95 opacity-0",
          "enter-to-class": "transform scale-100 opacity-100",
          "leave-active-class": "transition duration-75 ease-out motion-reduce:transition-none",
          "leave-from-class": "transform scale-100 opacity-100",
          "leave-to-class": "transform scale-95 opacity-0"
        }, {
          default: ve(() => [
            I(i) ? (c(), g("div", {
              key: 0,
              id: I(J),
              ref_key: "panelRef",
              ref: m,
              role: "dialog",
              "aria-label": e.triggerLabel,
              "data-testid": "filter-selector-menu",
              "data-size": ue.value,
              "data-focus-trap-allow-outside": "",
              tabindex: "-1",
              style: Ne([O.value, b.value]),
              class: C([
                "flex max-h-[540px] max-w-[calc(100vw-2rem)] flex-col overflow-hidden focus-visible:outline-none",
                I(Na)
              ]),
              onKeydown: ut(L, ["escape"])
            }, [
              A.value === "field" ? (c(), g(se, { key: 0 }, [
                te(Nv, {
                  ref_key: "pickerRef",
                  ref: x,
                  "active-group": z.value,
                  "onUpdate:activeGroup": pe[0] || (pe[0] = (Se) => z.value = Se),
                  "search-query": R.value,
                  "onUpdate:searchQuery": pe[1] || (pe[1] = (Se) => R.value = Se),
                  fields: U.value,
                  groups: e.fieldGroups,
                  "groups-label": e.fieldGroupsLabel || void 0,
                  "group-aria-label": e.triggerLabel,
                  "search-placeholder": e.step1SearchPlaceholder,
                  "search-clear-label": e.searchClearLabel,
                  "list-label": e.step1SearchPlaceholder,
                  selectable: e.fieldsSelectable,
                  "no-results-label": e.noFieldResultsLabel,
                  "results-count-label": e.resultsCountLabel,
                  "no-fields-label": e.noFieldsLabel || void 0,
                  onSelect: He
                }, null, 8, ["active-group", "search-query", "fields", "groups", "groups-label", "group-aria-label", "search-placeholder", "search-clear-label", "list-label", "selectable", "no-results-label", "results-count-label", "no-fields-label"]),
                ae.value ? (c(), K(il, Oe({ key: 0 }, ae.value, {
                  class: "shrink-0",
                  onButtonClick: Z
                }), null, 16)) : k("", !0)
              ], 64)) : k("", !0),
              A.value === "value" && F.value ? (c(), g(se, { key: 1 }, [
                re.value === "list" ? (c(), g("div", x8, [
                  te(sl, {
                    class: "shrink-0",
                    "label-left": F.value.label,
                    "label-right": Je.value || void 0,
                    "show-search": "",
                    "search-query": Y.value,
                    "search-placeholder": F.value.step2SearchPlaceholder ?? "Search…",
                    "search-label": F.value.step2SearchPlaceholder ?? "Search…",
                    "search-clear-label": e.searchClearLabel,
                    onKeydown: Ae,
                    "onUpdate:searchQuery": pe[2] || (pe[2] = (Se) => Y.value = Se)
                  }, null, 8, ["label-left", "label-right", "search-query", "search-placeholder", "search-label", "search-clear-label"]),
                  v("div", y8, [
                    Ge.value ? (c(), g("div", {
                      key: 0,
                      ref_key: "step2ListboxRef",
                      ref: Te,
                      role: "listbox",
                      "aria-multiselectable": !F.value.single,
                      "aria-label": F.value.label,
                      class: "flex min-h-0 flex-col",
                      onKeydown: me
                    }, [
                      je.value ? (c(), g("div", w8, [
                        te(Gt, Oe(Ke(0, le.value, Yt), {
                          type: "checkbox",
                          label: F.value.selectAllLabel ?? "Select all",
                          checked: le.value,
                          indeterminate: Le.value,
                          count: de.value > 0 ? `(${de.value})` : void 0
                        }), null, 16, ["label", "checked", "indeterminate", "count"])
                      ])) : k("", !0),
                      ie.value.length ? (c(), g("div", C8, [
                        v("div", {
                          class: C(["flex flex-col gap-0.5 px-2", je.value ? "pt-0.5 pb-0.5" : "py-1.5"])
                        }, [
                          (c(!0), g(se, null, Me(ie.value, (Se, We) => (c(), K(Gt, Oe({
                            key: Se.id
                          }, { ref_for: !0 }, Ke(je.value ? We + 1 : We, _.value.has(Se.id), () => Ct(Se.id)), {
                            class: "shrink-0",
                            type: "checkbox",
                            label: Se.label,
                            checked: _.value.has(Se.id),
                            count: Se.count !== void 0 ? `(${Se.count})` : void 0,
                            "data-testid": `filter-item-${Se.id}`
                          }), null, 16, ["label", "checked", "count", "data-testid"]))), 128))
                        ], 2)
                      ])) : k("", !0)
                    ], 40, k8)) : k("", !0),
                    !ie.value.length && Y.value ? (c(), g("div", S8, P(e.noResultsLabel) + ' "' + P(Y.value) + '". ', 1)) : k("", !0)
                  ])
                ])) : (c(), g("div", $8, [
                  te(sl, {
                    class: "shrink-0",
                    "label-left": F.value.label
                  }, null, 8, ["label-left"]),
                  v("div", I8, [
                    re.value === "text" ? (c(), g("div", T8, [
                      v("div", L8, [
                        te(I(zt), {
                          id: be.value,
                          modelValue: j.value,
                          "onUpdate:modelValue": pe[3] || (pe[3] = (Se) => j.value = Se),
                          "aria-label": F.value.label,
                          placeholder: F.value.placeholder ?? "",
                          error: N.value,
                          size: "md",
                          "full-width": ""
                        }, null, 8, ["id", "modelValue", "aria-label", "placeholder", "error"])
                      ])
                    ])) : re.value === "range" ? (c(), g("div", {
                      key: 1,
                      "data-testid": "filter-step-range",
                      role: "group",
                      "aria-label": F.value.label,
                      class: "flex flex-col gap-4 px-3 py-4"
                    }, [
                      te(I(Iv), {
                        "min-value": M.value,
                        "onUpdate:minValue": pe[4] || (pe[4] = (Se) => M.value = Se),
                        "max-value": W.value,
                        "onUpdate:maxValue": pe[5] || (pe[5] = (Se) => W.value = Se),
                        min: F.value.rangeMin ?? 0,
                        max: F.value.rangeMax ?? 1e4,
                        step: F.value.rangeStep ?? 1,
                        "separator-label": F.value.rangeSeparatorLabel ?? "to",
                        "min-label": F.value.rangeMinLabel ?? "Minimum",
                        "max-label": F.value.rangeMaxLabel ?? "Maximum",
                        "clamp-input-to-bounds": F.value.rangeClampInputToBounds ?? !0,
                        "data-min": F.value.rangeDataMin ?? null,
                        "data-max": F.value.rangeDataMax ?? null,
                        "hint-label": F.value.rangeHintLabel ?? ""
                      }, null, 8, ["min-value", "max-value", "min", "max", "step", "separator-label", "min-label", "max-label", "clamp-input-to-bounds", "data-min", "data-max", "hint-label"]),
                      oe.value ? k("", !0) : (c(), g("p", A8, P(F.value.rangeErrorLabel ?? "Min value must be less than or equal to max value"), 1))
                    ], 8, E8)) : re.value === "dateRange" ? (c(), g("div", {
                      key: 2,
                      "data-testid": "filter-step-date-range",
                      role: "group",
                      "aria-label": F.value.label,
                      class: "flex flex-col gap-4 px-3 py-4"
                    }, [
                      v("div", B8, [
                        te(I(fu), {
                          id: ke.value,
                          modelValue: G.value,
                          "onUpdate:modelValue": pe[6] || (pe[6] = (Se) => G.value = Se),
                          class: "min-w-0 flex-1",
                          label: F.value.dateFromLabel ?? "From",
                          placeholder: F.value.datePlaceholder ?? "dd/mm/yyyy",
                          format: F.value.dateFormat ?? "dd/mm/yyyy",
                          size: "md",
                          "full-width": ""
                        }, null, 8, ["id", "modelValue", "label", "placeholder", "format"]),
                        te(I(fu), {
                          id: ee.value,
                          modelValue: B.value,
                          "onUpdate:modelValue": pe[7] || (pe[7] = (Se) => B.value = Se),
                          class: "min-w-0 flex-1",
                          label: F.value.dateToLabel ?? "To",
                          placeholder: F.value.datePlaceholder ?? "dd/mm/yyyy",
                          format: F.value.dateFormat ?? "dd/mm/yyyy",
                          size: "md",
                          "full-width": ""
                        }, null, 8, ["id", "modelValue", "label", "placeholder", "format"])
                      ]),
                      ge.value ? k("", !0) : (c(), g("p", M8, P(e.dateRangeErrorLabel), 1))
                    ], 8, R8)) : k("", !0)
                  ])
                ])),
                te(il, Oe(At.value, {
                  class: "shrink-0",
                  onButtonClick: Be
                }), null, 16)
              ], 64)) : k("", !0)
            ], 46, v8)) : k("", !0)
          ]),
          _: 1
        })
      ]))
    ], 544));
  }
}), O8 = /* @__PURE__ */ ye({
  __name: "TablePanel",
  props: {
    roundTop: { type: Boolean, default: !0 }
  },
  setup(e) {
    return (n, t) => (c(), g("div", {
      class: C([
        "min-w-0 border border-(--border-border-base-soft) overflow-x-auto shadow-[0px_1px_0.5px_0.05px_rgba(29,41,61,0.02)]",
        e.roundTop ? "rounded-xl" : "rounded-b-xl"
      ])
    }, [
      $e(n.$slots, "default")
    ], 2));
  }
}), P8 = {
  key: 0,
  class: "border-b border-(--border-border-base-soft)"
}, F8 = {
  key: 1,
  "data-testid": "records-table-header",
  class: "flex items-center justify-between gap-4 px-3 py-3 border-b border-(--border-border-base-soft)"
}, V8 = { class: "flex items-center gap-2.5 min-w-0" }, N8 = {
  key: 0,
  class: "shrink-0 size-12 flex items-center justify-center bg-white border border-(--border-border-base-medium) rounded-lg"
}, H8 = { class: "flex flex-col gap-px min-w-0" }, j8 = {
  key: 0,
  class: "text-base font-medium leading-6 text-(--text-text-heading) truncate"
}, W8 = {
  key: 1,
  class: "text-base font-normal leading-6 text-(--text-text-body) truncate"
}, q8 = {
  key: 0,
  "data-testid": "records-table-actions",
  class: "flex items-center gap-2 shrink-0"
}, U8 = ["onClick"], G8 = { class: "flex items-center gap-1" }, K8 = {
  key: 0,
  class: "ri-expand-up-down-line text-xs"
}, Y8 = { key: 0 }, J8 = ["colspan"], ib = "sticky right-0 z-10 shadow-[inset_1px_0_0_var(--border-border-base-soft),-2px_0_4px_-2px_rgba(0,0,0,0.06)]", Z8 = "[transform:translateZ(0)]", $q = /* @__PURE__ */ ye({
  __name: "RecordsTable",
  props: {
    columns: {},
    data: {},
    emptyText: { default: "" },
    tableClass: {},
    title: {},
    subtitle: {},
    icon: {},
    minWidth: {},
    layout: { default: "fixed" }
  },
  setup(e) {
    const n = e, t = Ht(), a = E(null), l = E("asc"), r = (i) => {
      a.value === i ? l.value = l.value === "asc" ? "desc" : "asc" : (a.value = i, l.value = "asc");
    }, o = p(() => {
      if (!a.value) return n.data;
      const i = n.columns.find((s) => s.id === a.value);
      return i != null && i.sortable ? [...n.data].sort((s, d) => {
        const u = i.sortBy(s), f = i.sortBy(d), b = String(u).localeCompare(String(f), void 0, { numeric: !0 });
        return l.value === "asc" ? b : -b;
      }) : n.data;
    });
    return (i, s) => (c(), K(O8, null, {
      default: ve(() => [
        v("div", {
          style: Ne(e.minWidth ? { minWidth: `max(100%, ${e.minWidth}px)` } : void 0)
        }, [
          I(t)("header") ? (c(), g("div", P8, [
            $e(i.$slots, "header")
          ])) : e.title || e.subtitle || e.icon || I(t)("actions") ? (c(), g("div", F8, [
            v("div", V8, [
              e.icon ? (c(), g("div", N8, [
                v("i", {
                  class: C([e.icon, "text-[length:var(--size-5xl)] leading-none text-(--text-text-body)"]),
                  "aria-hidden": "true"
                }, null, 2)
              ])) : k("", !0),
              v("div", H8, [
                e.title ? (c(), g("span", j8, P(e.title), 1)) : k("", !0),
                e.subtitle ? (c(), g("span", W8, P(e.subtitle), 1)) : k("", !0)
              ])
            ]),
            I(t)("actions") ? (c(), g("div", q8, [
              $e(i.$slots, "actions")
            ])) : k("", !0)
          ])) : k("", !0),
          v("table", {
            class: C(["w-full", e.layout === "auto" ? "table-auto" : "table-fixed", e.tableClass])
          }, [
            v("thead", null, [
              v("tr", null, [
                (c(!0), g(se, null, Me(e.columns, (d) => (c(), g("th", {
                  key: d.id,
                  class: C([
                    "h-11 px-5 overflow-hidden text-left text-sm font-medium text-(--text-text-body) border-b border-(--border-border-base-medium) bg-white",
                    d.width,
                    d.sortable && "cursor-pointer select-none",
                    d.sticky && [ib, Z8]
                  ]),
                  onClick: (u) => d.sortable ? r(d.id) : void 0
                }, [
                  v("div", G8, [
                    at(P(d.header) + " ", 1),
                    d.sortable ? (c(), g("i", K8)) : k("", !0)
                  ])
                ], 10, U8))), 128))
              ])
            ]),
            v("tbody", null, [
              o.value.length ? k("", !0) : (c(), g("tr", Y8, [
                v("td", {
                  colspan: e.columns.length,
                  class: "h-14 px-5 text-sm text-center text-(--text-text-body)"
                }, P(e.emptyText), 9, J8)
              ])),
              (c(!0), g(se, null, Me(o.value, (d, u) => (c(), g("tr", {
                key: u,
                class: "border-b border-(--border-border-base-soft) last:border-b-0"
              }, [
                (c(!0), g(se, null, Me(e.columns, (f, b) => (c(), g("td", {
                  key: f.id,
                  class: C([
                    "h-14 px-5 overflow-hidden",
                    b === 0 && e.layout === "fixed" && "max-w-0",
                    f.sticky && ["bg-white", ib]
                  ])
                }, [
                  (c(), K(dt(() => f.cell(d))))
                ], 2))), 128))
              ]))), 128))
            ])
          ], 2)
        ], 4)
      ]),
      _: 3
    }));
  }
}), X8 = { class: "w-full relative shadow-[0px_1px_0.5px_0.05px_rgba(29,_41,_61,_0.02)] dark:shadow-[0px_0px_4px_rgba(255,255,255,0.1)] rounded-t-[0px] rounded-b-3xl bg-white dark:bg-[var(--colors-background-black-default)] border-gainsboro dark:border-[var(--colors-border-base)] border-solid border-[1px] box-border flex flex-col items-start text-left text-[14px] text-gray-200 dark:text-[var(--colors-text-white-default)] font-inter" }, Q8 = {
  key: 0,
  style: { width: "256px" }
}, _8 = { class: "flex items-center justify-end gap-3 flex-shrink-0" }, e6 = {
  key: 0,
  class: "skeleton h-9 w-32"
}, t6 = {
  key: 1,
  class: "skeleton h-9 w-20"
}, n6 = { class: "self-stretch overflow-x-auto" }, a6 = {
  class: "flex items-start",
  style: { width: "100%", "min-width": "max-content", "min-height": "324px" }
}, l6 = {
  key: 0,
  class: "flex flex-col items-start"
}, r6 = {
  key: 2,
  class: "flex-1 bg-white dark:bg-[var(--colors-background-black-default)] flex flex-col items-start min-w-0",
  style: { "min-width": "0" }
}, o6 = {
  key: 0,
  class: "self-stretch rounded-t-[0px] rounded-b-[12px] bg-white dark:bg-[var(--colors-background-black-default)] border-gainsboro dark:border-[var(--colors-border-base)] border-solid border-t-[1px] flex items-center justify-between p-[20px] gap-5"
}, i6 = ["data-testid"], s6 = { class: "flex items-center justify-end gap-3 text-gray-200 dark:text-[var(--colors-text-white-default)] flex-shrink-0" }, d6 = { class: "self-stretch overflow-x-auto" }, u6 = {
  class: "flex items-start",
  style: { width: "100%", "min-width": "max-content", "min-height": "324px" }
}, c6 = {
  key: 0,
  class: "flex flex-col items-start"
}, f6 = { class: "w-14 h-11 bg-whitesmoke-100 dark:bg-[rgba(255,255,255,0.05)] border-gainsboro dark:border-[var(--colors-border-base)] border-solid border-t-[1px] border-b-[1px] box-border flex flex-col items-center justify-center py-0 px-[20px]" }, h6 = { class: "flex items-center" }, b6 = ["onClick"], g6 = { class: "flex items-center gap-1 min-w-0" }, p6 = ["title"], m6 = ["src"], v6 = ["onMousedown"], x6 = { class: "flex-1 relative leading-[20px] overflow-hidden text-ellipsis whitespace-nowrap" }, y6 = { class: "self-stretch h-11 bg-whitesmoke-100 dark:bg-[rgba(255,255,255,0.05)] border-gainsboro dark:border-[var(--colors-border-base)] border-solid border-t-[1px] border-b-[1px] box-border flex flex-col items-start justify-center py-0 px-[20px] text-[14px] text-(--colors-text-body) dark:text-(--colors-text-white-default)" }, k6 = { class: "flex items-center gap-1" }, w6 = { class: "relative leading-[20px] font-medium" }, C6 = {
  key: 2,
  class: "flex-1 bg-white dark:bg-[var(--colors-background-black-default)] flex flex-col items-start min-w-0",
  style: { "min-width": "0" }
}, S6 = {
  key: 0,
  class: "self-stretch rounded-t-[0px] rounded-b-[12px] bg-white dark:bg-[var(--colors-background-black-default)] border-gainsboro dark:border-[var(--colors-border-base)] border-solid border-t-[1px] flex items-center justify-between p-[20px] gap-5"
}, $6 = { class: "relative leading-[20px] dark:text-[var(--colors-text-white-default)]" }, I6 = { class: "min-w-0 flex-1" }, T6 = /* @__PURE__ */ ye({
  __name: "Table",
  props: {
    columns: {},
    rows: {},
    showCheckbox: { type: Boolean, default: !0 },
    title: { default: "Transactions" },
    searchPlaceholder: { default: "Search for transaction" },
    searchClearLabel: { default: "Clear search" },
    showSearch: { type: Boolean, default: !0 },
    showFilters: { type: Boolean, default: !0 },
    showAddButton: { type: Boolean, default: !0 },
    addButtonLabel: { default: "Add transaction" },
    showActions: { type: Boolean, default: !0 },
    rowActions: { type: [Array, Function], default: () => [
      { label: "Actions", icon: void 0, onClick: () => {
      } },
      { label: "Delete", icon: void 0, onClick: () => {
      }, isDelete: !0 }
    ] },
    enablePagination: { type: Boolean, default: !0 },
    itemsPerPage: { default: 10 },
    totalItems: { default: 1e3 },
    currentPage: { default: 1 },
    searchIcon: { default: void 0 },
    filtersIcon: { default: void 0 },
    actionsIcon: { default: void 0 },
    addButtonIconLeft: { default: void 0 },
    filterItems: { default: () => [
      { label: "All", onClick: () => {
      } },
      { label: "Completed", onClick: () => {
      } },
      { label: "Pending", onClick: () => {
      } },
      { label: "Failed", onClick: () => {
      } }
    ] },
    filterSections: { default: () => [] },
    headerActionsItems: { default: () => [
      { label: "Export CSV", onClick: () => {
      } },
      { label: "Export Excel", onClick: () => {
      } },
      { label: "Print", onClick: () => {
      } }
    ] },
    filtersLabel: { default: "Filters" },
    actionsLabel: { default: "Actions" },
    actionsColumnLabel: { default: "Actions" },
    filterResetLabel: { default: "Reset" },
    filterApplyLabel: { default: "Apply" },
    filterMenuWidth: { default: "280px" },
    paginationText: { type: Function, default: (e, n, t) => `Showing ${e}-${n} of ${t}` },
    wrap: { type: Boolean, default: !1 },
    loading: { type: Boolean, default: !1 },
    serverSideSearch: { type: Boolean, default: !1 },
    serverSidePagination: { type: Boolean, default: !1 },
    searchDataTestId: { default: void 0 }
  },
  emits: ["search", "filter", "filter-apply", "filter-reset", "filter-change", "add", "action", "page-change", "selection-change"],
  setup(e, { emit: n }) {
    const t = e, a = n, l = p(() => [
      {
        label: t.filterResetLabel,
        variant: "secondary",
        onClick: () => a("filter-reset"),
        keepOpen: !0
      },
      {
        label: t.filterApplyLabel,
        variant: "primary",
        onClick: () => {
          var F;
          const B = {};
          (F = t.filterSections) == null || F.forEach((X) => {
            B[X.id] = X.checked ?? X.switchChecked ?? !1;
          }), a("filter-apply", B);
        }
      }
    ]), r = E(""), o = E(/* @__PURE__ */ new Set()), i = E(null), s = E("asc"), d = E(t.currentPage);
    Ie(
      () => t.currentPage,
      (B) => {
        t.serverSidePagination && B !== void 0 && (d.value = B);
      }
    );
    const u = E({}), f = E(!1), b = E(null), h = E(0), m = E(0), x = () => {
      const B = {};
      return t.columns.forEach((F) => {
        if (F.width) {
          const X = parseFloat(F.width);
          F.width.includes("px") ? B[F.key] = X : t.wrap || (B[F.key] = 200);
        } else t.wrap || (B[F.key] = 200);
      }), t.showActions && !t.wrap && (B.__actions__ = 150), B;
    };
    Object.keys(u.value).length === 0 && (u.value = x());
    const y = (B) => u.value[B] ? `${u.value[B]}px` : "200px", w = (B, F) => {
      if (f.value = !0, b.value = B, h.value = F.clientX, u.value[B])
        m.value = u.value[B];
      else {
        const H = F.target.closest(".bg-white.flex.flex-col");
        H ? m.value = H.offsetWidth : m.value = 200;
      }
      document.body.classList.add("resizing"), document.addEventListener("mousemove", S), document.addEventListener("mouseup", $), F.preventDefault(), F.stopPropagation();
    }, S = (B) => {
      if (!f.value || !b.value) return;
      const F = B.clientX - h.value, X = m.value + F;
      X >= 50 && X <= 1e3 && (u.value[b.value] = X);
    }, $ = () => {
      f.value = !1, b.value = null, document.body.classList.remove("resizing"), document.removeEventListener("mousemove", S), document.removeEventListener("mouseup", $);
    };
    Ie(
      () => t.columns,
      () => {
        if (t.wrap) {
          const B = x();
          Object.keys(B).forEach((F) => {
            u.value[F] === void 0 && B[F] !== void 0 && (u.value[F] = B[F]);
          });
        } else {
          const B = t.columns.every((X) => u.value[X.key] !== void 0), F = !t.showActions || u.value.__actions__ !== void 0;
          if (!B || !F) {
            const X = x();
            Object.keys(X).forEach((H) => {
              u.value[H] === void 0 && X[H] !== void 0 && (u.value[H] = X[H]);
            });
          }
        }
      },
      { deep: !0 }
    ), Ie(
      () => t.wrap,
      () => {
        u.value = x();
      }
    );
    const T = p(() => {
      let B = t.rows;
      if (r.value && t.showSearch && !t.serverSideSearch && (B = B.filter(
        (F) => JSON.stringify(F).toLowerCase().includes(r.value.toLowerCase())
      )), i.value && (B = [...B].sort((F, X) => {
        const H = F[i.value], q = X[i.value];
        return H == null && q == null ? 0 : H == null ? 1 : q == null ? -1 : H < q ? s.value === "asc" ? -1 : 1 : H > q ? s.value === "asc" ? 1 : -1 : 0;
      })), t.enablePagination && !t.serverSidePagination) {
        const F = (d.value - 1) * t.itemsPerPage, X = F + t.itemsPerPage;
        return B.slice(F, X);
      }
      return B;
    }), L = p(() => {
      if (!t.enablePagination) return 1;
      if (t.serverSidePagination) return Math.ceil((t.totalItems ?? 0) / t.itemsPerPage);
      if (t.serverSideSearch) return Math.ceil(t.rows.length / t.itemsPerPage);
      const B = t.rows.filter(
        (F) => !r.value || JSON.stringify(F).toLowerCase().includes(r.value.toLowerCase())
      );
      return Math.ceil(B.length / t.itemsPerPage);
    }), A = (B) => {
      d.value = 1, a("search", B);
    }, R = (B) => {
      B.sortable && (i.value === B.key ? s.value = s.value === "asc" ? "desc" : "asc" : (i.value = B.key, s.value = "asc"));
    }, z = (B) => {
      B ? T.value.forEach((F) => {
        o.value.add(F.id);
      }) : T.value.forEach((F) => {
        o.value.delete(F.id);
      }), a(
        "selection-change",
        Array.from(o.value).map((F) => t.rows.find((X) => X.id === F))
      );
    }, D = (B) => {
      o.value.has(B.id) ? o.value.delete(B.id) : o.value.add(B.id), a(
        "selection-change",
        Array.from(o.value).map((F) => t.rows.find((X) => X.id === F))
      );
    }, V = (B) => {
      d.value = B, a("page-change", B);
    }, Y = (B, F) => {
      B.onClick(F), a("action", B, F);
    }, _ = (B) => o.value.has(B.id), j = (B) => typeof t.rowActions == "function" ? t.rowActions(B) : t.rowActions || [], M = p(() => T.value.length === 0 ? !1 : T.value.every((B) => o.value.has(B.id))), W = (B, F) => F.render ? F.render(B[F.key], B) : B[F.key], G = (B) => {
      const F = [70, 85, 60, 90, 75, 80, 65, 95];
      return `${F[B % F.length]}%`;
    };
    return (B, F) => (c(), g("div", X8, [
      e.loading ? (c(), g(se, { key: 0 }, [
        v("div", {
          class: C(["self-stretch rounded-t-[12px] rounded-b-[0px] bg-white dark:bg-[var(--colors-background-black-default)] flex items-center p-[20px] gap-5", e.showSearch ? "justify-between" : "justify-end"])
        }, [
          e.showSearch ? (c(), g("div", Q8, [...F[4] || (F[4] = [
            v("div", { class: "skeleton h-10 w-full" }, null, -1)
          ])])) : k("", !0),
          v("div", _8, [
            e.showAddButton ? (c(), g("div", e6)) : k("", !0),
            e.showFilters ? (c(), g("div", t6)) : k("", !0),
            F[5] || (F[5] = v("div", { class: "skeleton h-9 w-20" }, null, -1))
          ])
        ], 2),
        v("div", n6, [
          v("div", a6, [
            e.showCheckbox ? (c(), g("div", l6, [
              F[7] || (F[7] = v("div", { class: "w-14 h-11 bg-whitesmoke-100 dark:bg-[rgba(255,255,255,0.05)] border-gainsboro dark:border-[var(--colors-border-base)] border-solid border-t-[1px] border-b-[1px] box-border flex flex-col items-center justify-center py-0 px-[20px]" }, [
                v("div", { class: "skeleton h-4 w-4" })
              ], -1)),
              (c(!0), g(se, null, Me(e.itemsPerPage, (X) => (c(), g("div", {
                key: `skeleton-checkbox-${X}`,
                class: "w-14 h-14 border-gainsboro dark:border-[var(--colors-border-base)] border-solid border-b-[1px] box-border flex items-center justify-center py-0 px-[20px]"
              }, [...F[6] || (F[6] = [
                v("div", { class: "skeleton h-4 w-4" }, null, -1)
              ])]))), 128))
            ])) : k("", !0),
            (c(!0), g(se, null, Me(e.columns, (X, H) => (c(), g("div", {
              key: `skeleton-col-${H}`,
              style: Ne(
                e.wrap ? u.value[X.key] ? { width: `${u.value[X.key]}px`, minWidth: "50px", flexShrink: 0 } : {
                  minWidth: "50px",
                  flex: X.width ? "0 0 auto" : "1 1 0%",
                  width: X.width || "auto"
                } : { width: y(X.key), minWidth: "50px", flexShrink: 0 }
              ),
              class: "bg-white dark:bg-[var(--colors-background-black-default)] flex flex-col items-start relative"
            }, [
              F[8] || (F[8] = v("div", { class: "self-stretch h-11 bg-whitesmoke-100 dark:bg-[rgba(255,255,255,0.05)] border-gainsboro dark:border-[var(--colors-border-base)] border-solid border-t-[1px] border-b-[1px] box-border flex flex-col items-start justify-center py-0 px-[20px]" }, [
                v("div", { class: "skeleton h-5 w-24" })
              ], -1)),
              (c(!0), g(se, null, Me(e.itemsPerPage, (q) => (c(), g("div", {
                key: `skeleton-row-${H}-${q}`,
                class: "self-stretch h-14 border-gainsboro dark:border-[var(--colors-border-base)] border-solid border-b-[1px] box-border overflow-hidden shrink-0 flex items-center py-0 px-[20px]"
              }, [
                v("div", {
                  class: "skeleton h-5",
                  style: Ne({ width: G(q - 1) })
                }, null, 4)
              ]))), 128))
            ], 4))), 128)),
            e.showActions && e.rowActions && e.rowActions.length > 0 ? (c(), g("div", {
              key: 1,
              class: "bg-white dark:bg-[var(--colors-background-black-default)] flex flex-col items-start relative",
              style: Ne(
                e.wrap ? u.value.__actions__ ? { width: `${u.value.__actions__}px`, minWidth: "50px", flexShrink: 0 } : { minWidth: "50px", flex: "0 0 auto", width: "auto" } : { width: y("__actions__"), minWidth: "50px", flexShrink: 0 }
              )
            }, [
              F[10] || (F[10] = v("div", { class: "self-stretch h-11 bg-whitesmoke-100 dark:bg-[rgba(255,255,255,0.05)] border-gainsboro dark:border-[var(--colors-border-base)] border-solid border-t-[1px] border-b-[1px] box-border flex flex-col items-start justify-center py-0 px-[20px]" }, [
                v("div", { class: "skeleton h-5 w-16" })
              ], -1)),
              (c(!0), g(se, null, Me(e.itemsPerPage, (X) => (c(), g("div", {
                key: `skeleton-actions-${X}`,
                class: "h-14 border-gainsboro dark:border-[var(--colors-border-base)] border-solid border-b-[1px] box-border flex items-center py-0 px-[20px] gap-2",
                style: { width: "100%" }
              }, [...F[9] || (F[9] = [
                v("div", { class: "skeleton h-8 w-20" }, null, -1)
              ])]))), 128))
            ], 4)) : k("", !0),
            e.wrap ? k("", !0) : (c(), g("div", r6, [
              F[11] || (F[11] = v("div", { class: "self-stretch h-11 bg-whitesmoke-100 dark:bg-[rgba(255,255,255,0.05)] border-gainsboro dark:border-[var(--colors-border-base)] border-solid border-t-[1px] border-b-[1px] box-border" }, null, -1)),
              (c(!0), g(se, null, Me(e.itemsPerPage, (X) => (c(), g("div", {
                key: `skeleton-spacer-${X}`,
                class: "self-stretch h-14 border-gainsboro dark:border-[var(--colors-border-base)] border-solid border-b-[1px] box-border"
              }))), 128))
            ]))
          ])
        ]),
        e.enablePagination ? (c(), g("div", o6, [...F[12] || (F[12] = [
          v("div", { class: "skeleton h-5 w-32" }, null, -1),
          v("div", { class: "skeleton h-9 w-48" }, null, -1)
        ])])) : k("", !0)
      ], 64)) : (c(), g(se, { key: 1 }, [
        v("div", {
          class: C(["self-stretch rounded-t-[12px] rounded-b-[0px] bg-white dark:bg-[var(--colors-background-black-default)] flex items-center p-[20px] gap-5 text-slategray dark:text-[var(--colors-text-white-default)]", e.showSearch ? "justify-between" : "justify-end"])
        }, [
          e.showSearch ? (c(), g("div", {
            key: 0,
            style: { width: "256px" },
            "data-testid": e.searchDataTestId
          }, [
            te(I(Yi), {
              modelValue: r.value,
              "onUpdate:modelValue": [
                F[0] || (F[0] = (X) => r.value = X),
                F[1] || (F[1] = (X) => A(X))
              ],
              placeholder: e.searchPlaceholder,
              labels: { clear: e.searchClearLabel },
              "icon-left": e.searchIcon,
              size: "md",
              width: "256px"
            }, null, 8, ["modelValue", "placeholder", "labels", "icon-left"])
          ], 8, i6)) : k("", !0),
          v("div", s6, [
            e.showAddButton ? (c(), K(I(Re), {
              key: 0,
              variant: "primary",
              label: e.addButtonLabel,
              "icon-left": e.addButtonIconLeft,
              size: "sm",
              class: "flex-shrink-0 whitespace-nowrap",
              onClick: F[2] || (F[2] = () => B.$emit("add"))
            }, null, 8, ["label", "icon-left"])) : k("", !0),
            e.showFilters && e.filterSections && e.filterSections.length > 0 ? (c(), K(I(qu), {
              key: 1,
              label: e.filtersLabel,
              "trigger-icon-left": e.filtersIcon,
              items: e.filterSections,
              "menu-width": e.filterMenuWidth,
              "menu-align": "right",
              "footer-buttons": l.value
            }, null, 8, ["label", "trigger-icon-left", "items", "menu-width", "footer-buttons"])) : e.showFilters && (!e.filterSections || e.filterSections.length === 0) ? (c(), K(I(Sn), {
              key: 2,
              label: e.filtersLabel,
              "trigger-icon-left": e.filtersIcon,
              items: e.filterItems,
              "menu-width": "180px",
              "menu-align": "right"
            }, null, 8, ["label", "trigger-icon-left", "items"])) : k("", !0),
            e.headerActionsItems && e.headerActionsItems.length > 0 ? (c(), K(I(Sn), {
              key: 3,
              label: e.actionsLabel,
              "trigger-icon": e.actionsIcon,
              items: e.headerActionsItems,
              "menu-width": "180px",
              "menu-align": "right"
            }, null, 8, ["label", "trigger-icon", "items"])) : k("", !0)
          ])
        ], 2),
        v("div", d6, [
          v("div", u6, [
            e.showCheckbox ? (c(), g("div", c6, [
              v("div", f6, [
                v("div", h6, [
                  te(I(Cn), {
                    "model-value": M.value,
                    "onUpdate:modelValue": z
                  }, null, 8, ["model-value"])
                ])
              ]),
              (c(!0), g(se, null, Me(T.value, (X) => (c(), g("div", {
                key: X.id,
                class: "w-14 h-14 border-gainsboro dark:border-[var(--colors-border-base)] border-solid border-b-[1px] box-border flex items-center justify-center py-0 px-[20px]"
              }, [
                te(I(Cn), {
                  "model-value": _(X),
                  "onUpdate:modelValue": () => D(X)
                }, null, 8, ["model-value", "onUpdate:modelValue"])
              ]))), 128))
            ])) : k("", !0),
            (c(!0), g(se, null, Me(e.columns, (X, H) => (c(), g("div", {
              key: H,
              style: Ne(
                e.wrap ? u.value[X.key] ? { width: `${u.value[X.key]}px`, minWidth: "50px", flexShrink: 0 } : {
                  minWidth: "50px",
                  flex: X.width ? "0 0 auto" : "1 1 0%",
                  width: X.width || "auto"
                } : { width: y(X.key), minWidth: "50px", flexShrink: 0 }
              ),
              class: C([
                "bg-white dark:bg-[var(--colors-background-black-default)] flex flex-col items-start relative",
                e.wrap && !X.width && !u.value[X.key] ? "min-w-0" : ""
              ])
            }, [
              v("div", {
                class: C(["self-stretch h-11 bg-whitesmoke-100 dark:bg-[rgba(255,255,255,0.05)] border-gainsboro dark:border-[var(--colors-border-base)] border-solid border-t-[1px] border-b-[1px] box-border flex flex-col items-start justify-center py-0 px-[20px] text-(--colors-text-body) dark:text-(--colors-text-white-default) cursor-pointer hover:bg-gray-50 dark:hover:bg-[rgba(255,255,255,0.05)] transition-colors duration-200", { "opacity-50": !X.sortable }]),
                onClick: (q) => R(X)
              }, [
                v("div", g6, [
                  v("div", {
                    class: "relative leading-[20px] font-medium overflow-hidden text-ellipsis whitespace-nowrap",
                    title: X.label
                  }, P(X.label), 9, p6),
                  X.sortable && i.value === X.key ? (c(), g("img", {
                    key: 0,
                    class: "h-3.5 w-3.5 relative table-sort-icon",
                    style: Ne({
                      transform: s.value === "asc" ? "rotate(0deg)" : "rotate(180deg)"
                    }),
                    src: i.value === X.key ? "data:image/svg+xml,%3Csvg xmlns=%22http://www.w3.org/2000/svg%22 viewBox=%220 0 24 24%22 fill=%22none%22 stroke=%22currentColor%22 stroke-width=%222%22%3E%3Cpath d=%22M19 9l-7 7-7-7%22/%3E%3C/svg%3E" : "",
                    alt: ""
                  }, null, 12, m6)) : k("", !0)
                ])
              ], 10, b6),
              v("div", {
                class: C(["absolute top-0 right-0 w-1 h-full cursor-col-resize z-0 hover:bg-blue-500 transition-colors", { "bg-blue-500": f.value && b.value === X.key }]),
                onMousedown: (q) => w(X.key, q)
              }, null, 42, v6),
              (c(!0), g(se, null, Me(T.value, (q) => (c(), g("div", {
                key: q.id,
                class: "self-stretch h-14 border-gainsboro dark:border-[var(--colors-border-base)] border-solid border-b-[1px] box-border overflow-hidden shrink-0 flex items-center py-0 px-[20px] text-text-body dark:text-[var(--colors-text-white-default)]"
              }, [
                v("div", x6, [
                  $e(B.$slots, `cell-${X.key}`, {
                    value: q[X.key],
                    row: q,
                    column: X
                  }, () => [
                    at(P(W(q, X)), 1)
                  ], !0)
                ])
              ]))), 128))
            ], 6))), 128)),
            e.showActions && e.rowActions && e.rowActions.length > 0 ? (c(), g("div", {
              key: 1,
              class: "bg-white dark:bg-[var(--colors-background-black-default)] flex flex-col items-start text-[12px] text-text-body dark:text-[var(--colors-text-white-default)] relative",
              style: Ne(
                e.wrap ? u.value.__actions__ ? { width: `${u.value.__actions__}px`, minWidth: "50px", flexShrink: 0 } : { minWidth: "50px", flex: "0 0 auto", width: "auto" } : { width: y("__actions__"), minWidth: "50px", flexShrink: 0 }
              )
            }, [
              v("div", y6, [
                v("div", k6, [
                  v("div", w6, P(e.actionsColumnLabel), 1)
                ])
              ]),
              v("div", {
                class: C(["absolute top-0 right-0 w-1 h-full cursor-col-resize z-0 hover:bg-blue-500 transition-colors", { "bg-blue-500": f.value && b.value === "__actions__" }]),
                onMousedown: F[3] || (F[3] = (X) => w("__actions__", X))
              }, null, 34),
              (c(!0), g(se, null, Me(T.value, (X) => (c(), g("div", {
                key: `actions-${X.id}`,
                class: "h-14 border-gainsboro dark:border-[var(--colors-border-base)] border-solid border-b-[1px] box-border flex items-center py-0 px-[20px] gap-2",
                style: { width: "100%" }
              }, [
                j(X).filter((H) => !H.isDelete).length > 0 ? (c(), K(I(Sn), {
                  key: 0,
                  label: e.actionsColumnLabel,
                  items: j(X).filter((H) => !H.isDelete).map((H) => ({
                    label: H.label,
                    icon: H.icon,
                    testId: H.testId,
                    onClick: () => Y(H, X)
                  })),
                  "menu-width": "150px"
                }, null, 8, ["label", "items"])) : k("", !0),
                (c(!0), g(se, null, Me(j(X).filter((H) => H.isDelete), (H) => (c(), K(I(Re), {
                  key: H.label,
                  variant: "error",
                  label: H.label,
                  "icon-left": H.icon,
                  size: "xs",
                  onClick: () => Y(H, X)
                }, null, 8, ["label", "icon-left", "onClick"]))), 128))
              ]))), 128))
            ], 4)) : k("", !0),
            e.wrap ? k("", !0) : (c(), g("div", C6, [
              F[13] || (F[13] = v("div", { class: "self-stretch h-11 bg-whitesmoke-100 dark:bg-[rgba(255,255,255,0.05)] border-gainsboro dark:border-[var(--colors-border-base)] border-solid border-t-[1px] border-b-[1px] box-border" }, null, -1)),
              (c(!0), g(se, null, Me(T.value, (X) => (c(), g("div", {
                key: `spacer-${X.id}`,
                class: "self-stretch h-14 border-gainsboro dark:border-[var(--colors-border-base)] border-solid border-b-[1px] box-border"
              }))), 128))
            ]))
          ])
        ]),
        e.enablePagination ? (c(), g("div", S6, [
          v("div", $6, P(e.paginationText(
            (d.value - 1) * e.itemsPerPage + 1,
            Math.min(d.value * e.itemsPerPage, e.totalItems),
            e.totalItems
          )), 1),
          v("div", I6, [
            te(I(nO), {
              "current-page": d.value,
              "total-pages": L.value,
              "total-items": e.totalItems,
              "items-per-page": e.itemsPerPage,
              "page-align": "end",
              "show-rows-per-page": !1,
              onPageChange: V
            }, null, 8, ["current-page", "total-pages", "total-items", "items-per-page"])
          ])
        ])) : k("", !0)
      ], 64))
    ]));
  }
}), Iq = /* @__PURE__ */ lt(T6, [["__scopeId", "data-v-2c369241"]]), L6 = "data:image/svg+xml,%3csvg%20viewBox='0%200%2024%2024'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M10.8284%2012.0007L15.7782%2016.9504L14.364%2018.3646L8%2012.0007L14.364%205.63672L15.7782%207.05093L10.8284%2012.0007Z'/%3e%3c/svg%3e", E6 = "data:image/svg+xml,%3csvg%20viewBox='0%200%2024%2024'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M13.1717%2012.0007L8.22192%207.05093L9.63614%205.63672L16.0001%2012.0007L9.63614%2018.3646L8.22192%2016.9504L13.1717%2012.0007Z'/%3e%3c/svg%3e", A6 = ["data-theme", "data-collapsed", "aria-label"], R6 = { class: "flex items-center sidebar-logo" }, B6 = ["src"], M6 = {
  key: 0,
  class: "h-7.5 border-border-base-medium border-solid border-l box-border flex items-center justify-center py-num-0 pl-3 pr-num-0"
}, D6 = { class: "relative leading-5.5 font-semibold dark:text-(--colors-text-white-secondary)" }, z6 = ["aria-label", "aria-expanded"], O6 = ["src"], P6 = {
  key: 0,
  class: "self-stretch shrink-0 flex flex-col items-center relative z-10 sidebar-scroll-indicator"
}, F6 = ["src"], V6 = {
  key: 0,
  class: "self-stretch border-border-base-soft border-solid border-b flex flex-col items-start pt-num-0 px-num-0 pb-4 shrink-0"
}, N6 = ["data-active", "aria-label", "aria-expanded", "aria-controls", "aria-current", "disabled"], H6 = ["src"], j6 = {
  key: 1,
  class: "h-5 w-5 relative shrink-0",
  "aria-hidden": "true"
}, W6 = {
  key: 2,
  class: "relative leading-num-24 font-medium dark:text-(--colors-text-white-secondary)"
}, q6 = {
  key: 0,
  class: "flex items-center gap-1.5 text-center text-[12px] text-text-black-default dark:text-(--colors-text-white-secondary) relative z-10"
}, U6 = { class: "relative leading-5 font-medium z-10 dark:text-(--colors-text-white-secondary)" }, G6 = ["src"], K6 = ["data-active", "aria-current", "aria-disabled", "disabled", "onClick"], Y6 = { class: "flex-1 flex items-center justify-start py-num-0 pl-num-2 pr-num-0 shrink-0 relative z-10 text-left min-w-0" }, J6 = { class: "relative leading-num-24 font-medium text-left dark:text-(--colors-text-white-secondary)" }, Z6 = { class: "self-stretch flex flex-col items-start gap-2 shrink-0 text-text-black-default dark:text-(--colors-text-white-secondary)" }, X6 = {
  key: 0,
  class: "self-stretch border-t border-border-base-soft my-1 sidebar-divider",
  "aria-hidden": "true"
}, Q6 = {
  key: 1,
  class: "self-stretch flex flex-col items-start"
}, _6 = ["data-active", "data-opened", "data-testid", "aria-label", "aria-expanded", "aria-controls", "aria-current", "aria-disabled", "disabled", "onClick"], eF = ["src"], tF = {
  key: 1,
  class: "h-5 w-5 relative shrink-0",
  "aria-hidden": "true"
}, nF = {
  key: 2,
  class: "relative leading-num-24 font-medium dark:text-(--colors-text-white-secondary) truncate"
}, aF = ["src"], lF = ["data-active", "data-testid", "aria-current", "aria-disabled", "disabled", "onClick"], rF = { class: "flex-1 flex items-center justify-start py-num-0 pl-num-2 pr-num-0 shrink-0 relative z-10 text-left min-w-0" }, oF = { class: "relative leading-num-24 font-medium text-left dark:text-(--colors-text-white-secondary) truncate" }, iF = ["data-active", "data-testid", "aria-label", "aria-current", "aria-disabled", "disabled", "onClick"], sF = ["src"], dF = {
  key: 1,
  class: "h-5 w-5 relative shrink-0",
  "aria-hidden": "true"
}, uF = {
  key: 2,
  class: "relative leading-num-24 font-medium z-10 dark:text-(--colors-text-white-secondary) truncate"
}, cF = {
  key: 0,
  class: "self-stretch shrink-0 flex flex-col items-center relative z-10 sidebar-scroll-indicator"
}, fF = ["src"], hF = { class: "self-stretch border-border-base-soft border-solid border-t shrink-0 pt-4 text-[12px] relative z-10" }, bF = { key: 0 }, gF = ["href"], pF = {
  key: 1,
  class: "relative leading-5 font-medium mb-1 sidebar-footer-a11y"
}, mF = { class: "relative leading-5 font-medium dark:text-(--colors-text-white-secondary)" }, vF = /* @__PURE__ */ ye({
  __name: "Sidebar",
  props: {
    companyIcon: { default: "/logo-eudonet-small.svg" },
    companyName: { default: "Eudonet" },
    items: { default: () => [] },
    modelValue: { type: Boolean, default: !0 },
    collapsed: { type: Boolean, default: void 0 },
    width: { default: "239px" },
    collapsedWidth: { default: "80px" },
    theme: { default: "light" },
    footerText: { default: "Powered by Eudonet" },
    ariaLabel: {},
    accessibilityText: { default: "" },
    accessibilityLink: { default: void 0 },
    backgroundColor: { default: void 0 },
    textColor: { default: void 0 },
    borderColor: { default: void 0 },
    accentColor: { default: void 0 },
    hoverBackgroundColor: { default: void 0 }
  },
  emits: ["update:modelValue", "update:collapsed", "item-click"],
  setup(e, { emit: n }) {
    const t = e, a = n, l = E(!1), r = E({}), o = () => {
      Object.keys(r.value).forEach((X) => {
        r.value[X] = !1;
      });
    };
    Ie(
      () => t.collapsed,
      (X, H) => {
        X !== void 0 && (l.value = X, X ? o() : H === !0 && !Object.values(r.value).some(Boolean) && y());
      },
      { immediate: !0 }
    );
    const i = () => {
      const X = !l.value;
      l.value = X, a("update:collapsed", X), X ? o() : y();
    }, s = E(
      typeof window < "u" ? window.matchMedia("(prefers-color-scheme: dark)").matches : !1
    );
    ot(() => {
      if (typeof window > "u") return;
      const X = window.matchMedia("(prefers-color-scheme: dark)"), H = (q) => {
        s.value = q.matches;
      };
      X.addEventListener("change", H), kt(() => X.removeEventListener("change", H));
    });
    const d = p(
      () => t.theme === "auto" ? s.value : t.theme === "dark"
    ), u = p(() => d.value ? "sidebar-dark" : "sidebar-light"), f = p(() => {
      const X = {};
      return t.backgroundColor && (X["--sidebar-bg"] = t.backgroundColor), t.textColor && (X["--sidebar-text"] = t.textColor), t.borderColor && (X["--sidebar-border"] = t.borderColor), t.accentColor && (X["--sidebar-accent"] = t.accentColor), t.hoverBackgroundColor && (X["--sidebar-hover-bg"] = t.hoverBackgroundColor), X.width = l.value ? t.collapsedWidth : t.width, X;
    }), b = (X) => X.key ?? X.label, h = p(() => t.items.find((X) => X.key === "bookmarks")), m = p(
      () => h.value ? b(h.value) : "bookmarks"
    ), x = p(() => t.items.filter((X) => X.key !== "bookmarks")), y = () => {
      t.items.forEach((X) => {
        var H;
        (H = X.children) != null && H.some((q) => q.active) && (r.value[b(X)] = !0);
      });
    };
    ot(() => {
      l.value || y();
    });
    const w = (X) => r.value[X] === !0, S = (X) => {
      const H = !r.value[X];
      H && Object.keys(r.value).forEach((q) => {
        q !== X && (r.value[q] = !1);
      }), r.value[X] = H;
    }, $ = E(null), T = E(!1), L = E(!1), A = () => {
      const X = $.value;
      X && (T.value = X.scrollTop > 4, L.value = X.scrollTop + X.clientHeight < X.scrollHeight - 4);
    }, R = () => {
      const X = $.value;
      X && X.scrollBy({ top: -100, behavior: "smooth" });
    }, z = () => {
      const X = $.value;
      X && X.scrollBy({ top: 100, behavior: "smooth" });
    };
    let D = null, V = null;
    ot(() => {
      setTimeout(() => {
        A();
        const X = $.value;
        X && (V = new ResizeObserver(() => A()), V.observe(X), D = new MutationObserver(() => A()), D.observe(X, { childList: !0, subtree: !0 }));
      }, 0);
    }), kt(() => {
      V == null || V.disconnect(), V = null, D == null || D.disconnect(), D = null;
    }), Ie(
      r,
      () => {
        qe(A), setTimeout(A, 100), setTimeout(A, 200), setTimeout(A, 350);
      },
      { deep: !0 }
    );
    const Y = (X) => {
      if (X.disabled) return;
      const H = X.children !== void 0 && X.children.length > 0;
      l.value ? (l.value = !1, a("update:collapsed", !1), H ? S(b(X)) : y()) : H && S(b(X)), X.onClick && X.onClick(), a("item-click", X);
    }, _ = (X) => {
      var H;
      return X.active === !0 || l.value && (((H = X.children) == null ? void 0 : H.some((q) => q.active)) ?? !1);
    }, j = Mn(), M = p(() => !!j.logo), W = p(
      () => l.value ? "/logo-eudonet-small.svg" : t.companyIcon
    ), G = (X) => {
      const H = "group self-stretch flex items-center justify-start py-num-6 pl-num-32 pr-num-8 cursor-pointer border-solid border border-transparent transition-[background,border-color] duration-300 relative text-left sidebar-child-item";
      return X.disabled ? `${H} opacity-50 cursor-not-allowed` : X.active ? `${H} rounded-[48px] overflow-visible sidebar-item-active` : `${H} rounded-num-12 sidebar-item-hover`;
    }, B = (X) => {
      const H = "group self-stretch rounded-num-12 flex items-center justify-between py-num-6 px-num-8 gap-0 cursor-pointer border-solid border border-transparent transition-[background,border-color] duration-300 sidebar-simple-item";
      return X.disabled ? `${H} opacity-50 cursor-not-allowed` : X.active ? `${H} relative overflow-visible sidebar-item-active` : `${H} sidebar-item-hover`;
    }, F = () => 'h-5.5 w-5.5 rounded-full relative flex items-center justify-center overflow-visible before:opacity-100 after:opacity-100 before:content-[""] before:absolute before:inset-[-1px] before:rounded-full before:[background:var(--sidebar-accent)] before:transition-opacity before:duration-300 before:z-0 after:content-[""] after:absolute after:inset-0 after:rounded-full after:transition-opacity after:duration-300 after:z-[1] sidebar-badge';
    return (X, H) => e.modelValue ? (c(), g("nav", {
      key: 0,
      class: C(["h-full relative shadow-[0px_4px_4px_rgba(0,0,0,0.25)] rounded-tl-none rounded-tr-3xl rounded-b-none box-border flex flex-col items-start text-left text-[18px] font-inter transition-all duration-300 sidebar-container", [u.value, { "sidebar-collapsed": l.value }, l.value ? "p-2" : "p-5"]]),
      "data-theme": d.value ? "dark" : "light",
      "data-collapsed": l.value ? "true" : "false",
      style: Ne(f.value),
      "aria-label": e.ariaLabel ?? "Main navigation"
    }, [
      v("div", {
        class: C([
          "self-stretch border-border-base-soft border-solid border-b pt-num-0 px-num-0 relative z-[2] shrink-0",
          l.value ? "flex flex-col items-center gap-2 overflow-visible pb-2" : "flex items-center justify-between gap-5 pb-5"
        ])
      }, [
        v("div", {
          class: C(["flex items-center gap-3", [{ "justify-center": l.value }, { "flex-1": !l.value }]])
        }, [
          v("div", R6, [
            M.value ? $e(X.$slots, "logo", {
              key: 0,
              collapsed: l.value
            }, void 0, !0) : W.value ? (c(), g("img", {
              key: 1,
              class: "h-7 w-7 relative",
              src: W.value,
              alt: "Company logo"
            }, null, 8, B6)) : k("", !0)
          ]),
          l.value ? k("", !0) : (c(), g("div", M6, [
            v("div", D6, P(e.companyName), 1)
          ]))
        ], 2),
        v("button", {
          type: "button",
          class: "sidebar-toggle-button shrink-0 h-6 w-6 rounded-full bg-white border border-gray-200 shadow-sm flex items-center justify-center cursor-pointer hover:border-gray-300 transition-colors duration-200",
          "aria-label": l.value ? "Expand sidebar" : "Collapse sidebar",
          "aria-expanded": !l.value,
          onClick: i
        }, [
          v("img", {
            src: l.value ? I(E6) : I(L6),
            class: "h-4 w-4 relative sidebar-toggle-icon",
            alt: "",
            "aria-hidden": "true"
          }, null, 8, O6)
        ], 8, z6)
      ], 2),
      te(wt, { name: "fade" }, {
        default: ve(() => [
          T.value ? (c(), g("div", P6, [
            v("button", {
              type: "button",
              class: "flex w-9 h-9 p-0 justify-center items-center shrink-0 rounded-full cursor-pointer bg-transparent border-none sidebar-scroll-btn",
              "aria-label": "Scroll up",
              onClick: R
            }, [
              v("img", {
                src: I(Jo),
                class: "h-4 w-4 sidebar-scroll-icon",
                alt: "",
                "aria-hidden": "true"
              }, null, 8, F6)
            ]),
            H[1] || (H[1] = v("div", { class: "flex h-px justify-center items-center shrink-0 self-stretch sidebar-scroll-divider" }, null, -1))
          ])) : k("", !0)
        ]),
        _: 1
      }),
      v("div", {
        ref_key: "scrollAreaRef",
        ref: $,
        class: "flex-1 min-h-0 overflow-y-auto self-stretch flex flex-col gap-4 py-4 text-num-16 dark:text-(--colors-text-white-secondary) sidebar-scroll-area relative z-[2]",
        onScroll: A
      }, [
        h.value ? (c(), g("div", V6, [
          te(ft, {
            text: h.value.label,
            position: "right",
            disabled: !l.value,
            class: "self-stretch flex-col"
          }, {
            default: ve(() => {
              var q;
              return [
                v("button", {
                  type: "button",
                  class: C(["group self-stretch rounded-num-12 flex items-center justify-between py-num-6 px-num-8 gap-0 cursor-pointer border-solid border border-transparent transition-[background,border-color] duration-300 sidebar-section-header", [
                    { "justify-center": l.value },
                    { "sidebar-item-active": _(h.value) },
                    { "opacity-50 cursor-not-allowed": h.value.disabled }
                  ]]),
                  "data-active": _(h.value) ? "true" : "false",
                  "aria-label": l.value ? h.value.label : void 0,
                  "aria-expanded": w(m.value),
                  "aria-controls": (q = h.value.children) != null && q.length ? "sidebar-submenu-bookmarks" : void 0,
                  "aria-current": h.value.active ? "page" : void 0,
                  disabled: h.value.disabled,
                  onClick: H[0] || (H[0] = (N) => Y(h.value))
                }, [
                  v("div", {
                    class: C(["flex-1 flex items-center gap-1.5", { "justify-center": l.value }])
                  }, [
                    h.value.icon ? (c(), g("img", {
                      key: 0,
                      class: "h-5 w-5 relative shrink-0",
                      src: h.value.icon,
                      alt: "",
                      "aria-hidden": "true"
                    }, null, 8, H6)) : (c(), g("div", j6)),
                    l.value ? k("", !0) : (c(), g("div", W6, P(h.value.label), 1))
                  ], 2),
                  l.value ? k("", !0) : (c(), g("div", q6, [
                    v("div", {
                      class: C(F())
                    }, [
                      v("div", U6, P(h.value.badge ?? 0), 1)
                    ], 2),
                    v("img", {
                      class: "h-4 w-4 relative z-10 transition-transform duration-200",
                      src: w(m.value) ? I(Jo) : I(Al),
                      alt: "",
                      "aria-hidden": "true"
                    }, null, 8, G6)
                  ]))
                ], 10, N6)
              ];
            }),
            _: 1
          }, 8, ["text", "disabled"]),
          h.value.children && h.value.children.length > 0 ? (c(), K(Mr, {
            key: 0,
            id: "sidebar-submenu-bookmarks",
            name: "submenu",
            tag: "div",
            role: "region",
            "aria-label": `${h.value.label} submenu`,
            class: C([
              "self-stretch flex flex-col items-start gap-2 submenu-wrapper",
              { "submenu-open": w(m.value) }
            ])
          }, {
            default: ve(() => [
              (c(!0), g(se, null, Me(w(m.value) ? h.value.children : [], (q) => (c(), g("button", {
                key: b(q),
                type: "button",
                class: C(G(q)),
                "data-active": q.active ? "true" : "false",
                "aria-current": q.active ? "page" : void 0,
                "aria-disabled": q.disabled ? "true" : void 0,
                disabled: q.disabled,
                onClick: (N) => Y(q)
              }, [
                v("div", Y6, [
                  v("div", J6, P(q.label), 1)
                ])
              ], 10, K6))), 128))
            ]),
            _: 1
          }, 8, ["aria-label", "class"])) : k("", !0)
        ])) : k("", !0),
        v("div", Z6, [
          (c(!0), g(se, null, Me(x.value, (q) => (c(), g(se, {
            key: b(q)
          }, [
            q.divider ? (c(), g("hr", X6)) : k("", !0),
            q.children !== void 0 ? (c(), g("div", Q6, [
              te(ft, {
                text: q.label,
                position: "right",
                disabled: !l.value,
                class: "self-stretch flex-col"
              }, {
                default: ve(() => {
                  var N;
                  return [
                    v("button", {
                      type: "button",
                      class: C(["group self-stretch rounded-num-12 flex items-center justify-between py-num-6 px-num-8 gap-0 cursor-pointer border-solid border border-transparent transition-[background,border-color] duration-300 sidebar-section-header", [
                        { "justify-center": l.value },
                        { "sidebar-item-active": _(q) },
                        {
                          "sidebar-item-opened": (w(b(q)) || ((N = q.children) == null ? void 0 : N.some((J) => J.active))) && !q.active
                        },
                        { "opacity-50 cursor-not-allowed": q.disabled }
                      ]]),
                      "data-active": _(q) ? "true" : "false",
                      "data-opened": w(b(q)) ? "true" : "false",
                      "data-testid": q.testId,
                      "aria-label": l.value ? q.label : void 0,
                      "aria-expanded": w(b(q)),
                      "aria-controls": `sidebar-submenu-${b(q)}`,
                      "aria-current": q.active ? "page" : void 0,
                      "aria-disabled": q.disabled ? "true" : void 0,
                      disabled: q.disabled,
                      onClick: (J) => Y(q)
                    }, [
                      v("div", {
                        class: C(["flex-1 flex items-center gap-1.5 min-w-0", { "justify-center": l.value }])
                      }, [
                        q.icon ? (c(), g("img", {
                          key: 0,
                          class: "h-5 w-5 relative shrink-0",
                          src: q.icon,
                          alt: "",
                          "aria-hidden": "true"
                        }, null, 8, eF)) : (c(), g("div", tF)),
                        l.value ? k("", !0) : (c(), g("div", nF, P(q.label), 1))
                      ], 2),
                      !l.value && q.children.length > 0 ? (c(), g("img", {
                        key: 0,
                        class: "h-4 w-4 relative transition-transform duration-200 shrink-0",
                        src: w(b(q)) ? I(Jo) : I(Al),
                        alt: "",
                        "aria-hidden": "true"
                      }, null, 8, aF)) : k("", !0)
                    ], 10, _6)
                  ];
                }),
                _: 2
              }, 1032, ["text", "disabled"]),
              te(Mr, {
                id: `sidebar-submenu-${b(q)}`,
                name: "submenu",
                tag: "div",
                role: "region",
                "aria-label": `${q.label} submenu`,
                class: C([
                  "self-stretch flex flex-col items-start gap-2 submenu-wrapper",
                  { "submenu-open": w(b(q)) }
                ])
              }, {
                default: ve(() => [
                  (c(!0), g(se, null, Me(w(b(q)) ? q.children : [], (N) => (c(), g("button", {
                    key: b(N),
                    type: "button",
                    class: C(G(N)),
                    "data-active": N.active ? "true" : "false",
                    "data-testid": N.testId,
                    "aria-current": N.active ? "page" : void 0,
                    "aria-disabled": N.disabled ? "true" : void 0,
                    disabled: N.disabled,
                    onClick: (J) => Y(N)
                  }, [
                    v("div", rF, [
                      v("div", oF, P(N.label), 1)
                    ])
                  ], 10, lF))), 128))
                ]),
                _: 2
              }, 1032, ["id", "aria-label", "class"])
            ])) : (c(), K(ft, {
              key: 2,
              text: q.label,
              position: "right",
              disabled: !l.value,
              class: "self-stretch flex-col"
            }, {
              default: ve(() => [
                v("button", {
                  type: "button",
                  class: C([B(q), { "justify-center": l.value }]),
                  "data-active": q.active ? "true" : "false",
                  "data-testid": q.testId,
                  "aria-label": l.value ? q.label : void 0,
                  "aria-current": q.active ? "page" : void 0,
                  "aria-disabled": q.disabled ? "true" : void 0,
                  disabled: q.disabled,
                  onClick: (N) => Y(q)
                }, [
                  v("div", {
                    class: C(["flex-1 flex items-center gap-1.5 relative z-10 min-w-0", { "justify-center": l.value }])
                  }, [
                    q.icon ? (c(), g("img", {
                      key: 0,
                      class: "h-5 w-5 relative z-10 shrink-0",
                      src: q.icon,
                      alt: "",
                      "aria-hidden": "true"
                    }, null, 8, sF)) : (c(), g("div", dF)),
                    l.value ? k("", !0) : (c(), g("div", uF, P(q.label), 1))
                  ], 2)
                ], 10, iF)
              ]),
              _: 2
            }, 1032, ["text", "disabled"]))
          ], 64))), 128))
        ])
      ], 544),
      te(wt, { name: "fade" }, {
        default: ve(() => [
          L.value ? (c(), g("div", cF, [
            H[2] || (H[2] = v("div", { class: "flex h-px justify-center items-center shrink-0 self-stretch sidebar-scroll-divider" }, null, -1)),
            v("button", {
              type: "button",
              class: "flex w-9 h-9 p-0 justify-center items-center shrink-0 rounded-full cursor-pointer bg-transparent border-none sidebar-scroll-btn",
              "aria-label": "Scroll down",
              onClick: z
            }, [
              v("img", {
                src: I(Al),
                class: "h-4 w-4 sidebar-scroll-icon",
                alt: "",
                "aria-hidden": "true"
              }, null, 8, fF)
            ])
          ])) : k("", !0)
        ]),
        _: 1
      }),
      v("div", hF, [
        l.value ? k("", !0) : (c(), g("div", bF, [
          $e(X.$slots, "footer", {}, () => [
            e.accessibilityText && e.accessibilityLink ? (c(), g("a", {
              key: 0,
              href: e.accessibilityLink,
              class: "block relative leading-5 font-medium mb-1 underline sidebar-footer-a11y-link"
            }, P(e.accessibilityText), 9, gF)) : e.accessibilityText ? (c(), g("div", pF, P(e.accessibilityText), 1)) : k("", !0),
            v("div", mF, P(e.footerText), 1)
          ], !0)
        ]))
      ])
    ], 14, A6)) : k("", !0);
  }
}), Tq = /* @__PURE__ */ lt(vF, [["__scopeId", "data-v-0fb03d0f"]]), xF = { class: "px-4 pt-5 pb-4" }, yF = { class: "text-lg font-semibold secondary-sidebar-title" }, kF = { class: "flex flex-col gap-8 px-4 pb-5" }, wF = { class: "text-xs font-medium uppercase tracking-wider secondary-sidebar-group-header" }, CF = {
  key: 0,
  class: "flex flex-col gap-1"
}, SF = ["aria-expanded", "aria-controls", "data-testid", "onClick"], $F = { class: "text-sm font-medium secondary-sidebar-item-text" }, IF = ["id"], TF = ["data-active", "aria-current", "data-testid", "onClick"], LF = { class: "text-sm font-medium secondary-sidebar-item-text" }, EF = ["data-active", "aria-current", "data-testid", "onClick"], AF = { class: "text-sm font-medium secondary-sidebar-item-text" }, RF = /* @__PURE__ */ ye({
  __name: "SecondarySidebar",
  props: {
    title: { default: "Settings" },
    groups: { default: () => [
      {
        label: "Profile management",
        items: [
          { label: "Profile" },
          { label: "Security information", active: !0 },
          { label: "Permissions" },
          { label: "Notification settings" }
        ]
      },
      {
        label: "Organisation management",
        items: [
          { label: "Global settings" },
          { label: "Users" },
          { label: "Security" },
          { label: "Configuration" },
          { label: "IA" },
          { label: "Billing & Plan" }
        ]
      },
      {
        label: "Module management",
        items: [{ label: "Global settings" }, { label: "Contact" }, { label: "Security" }]
      }
    ] },
    theme: { default: "light" },
    width: { default: "248px" },
    backgroundColor: { default: void 0 },
    textColor: { default: void 0 },
    borderColor: { default: void 0 },
    accentColor: { default: void 0 },
    hoverBackgroundColor: { default: void 0 },
    groupHeaderColor: { default: void 0 }
  },
  emits: ["item-click"],
  setup(e, { emit: n }) {
    const t = e, a = n, l = p(() => t.theme === "auto" ? typeof window < "u" ? window.matchMedia("(prefers-color-scheme: dark)").matches : !1 : t.theme === "dark"), r = p(() => l.value ? "secondary-sidebar-dark" : "secondary-sidebar-light"), o = p(() => {
      const $ = {};
      return t.backgroundColor && ($["--secondary-sidebar-bg"] = t.backgroundColor), t.textColor && ($["--secondary-sidebar-text"] = t.textColor), t.borderColor && ($["--secondary-sidebar-border"] = t.borderColor), t.accentColor && ($["--secondary-sidebar-accent"] = t.accentColor), t.hoverBackgroundColor && ($["--secondary-sidebar-hover-bg"] = t.hoverBackgroundColor), t.groupHeaderColor && ($["--secondary-sidebar-group-header"] = t.groupHeaderColor), $.width = t.width || "248px", $;
    }), i = Ve(), s = ($, T) => `${i}-category-${$}-${T}`, d = ($) => $.testId ?? $.label, u = ($, T) => T.key ?? `${$.label}/${d(T)}`, f = ($) => $.children !== void 0, b = ($) => {
      var T;
      return (T = $.children) == null ? void 0 : T.find((L) => L.active);
    }, h = E({}), m = ($, T) => h.value[u($, T)] ?? (b(T) !== void 0 || T.defaultExpanded === !0), x = ($, T) => {
      h.value = {
        ...h.value,
        [u($, T)]: !m($, T)
      };
    }, y = p(() => {
      const $ = {};
      for (const T of t.groups)
        for (const L of T.items) {
          const A = f(L) ? b(L) : void 0;
          A && ($[u(T, L)] = d(A));
        }
      return $;
    });
    Ie(y, ($, T) => {
      const L = Object.keys($).filter((R) => $[R] !== T[R]);
      if (L.length === 0) return;
      const A = { ...h.value };
      for (const R of L) delete A[R];
      h.value = A;
    });
    const w = ($, T) => {
      $.onClick && $.onClick(), a("item-click", $, T);
    }, S = ($) => {
      const T = "w-full text-left py-2 cursor-pointer transition-all duration-200 secondary-sidebar-item";
      return $.active ? `${T} secondary-sidebar-item-active` : `${T} secondary-sidebar-item-hover`;
    };
    return ($, T) => (c(), g("aside", {
      class: C(["h-full flex flex-col box-border overflow-y-auto overflow-x-hidden secondary-sidebar-container", r.value]),
      style: Ne(o.value)
    }, [
      v("div", xF, [
        v("h2", yF, P(e.title), 1)
      ]),
      v("div", kF, [
        (c(!0), g(se, null, Me(e.groups, (L, A) => (c(), g("div", {
          key: A,
          class: "flex flex-col gap-1"
        }, [
          v("div", wF, P(L.label), 1),
          (c(!0), g(se, null, Me(L.items, (R, z) => (c(), g(se, {
            key: `${A}-${z}`
          }, [
            f(R) ? (c(), g("div", CF, [
              v("button", {
                type: "button",
                class: "w-[calc(100%+24px)] -mx-3 px-3 flex items-center justify-between gap-2 text-left py-2 rounded-lg cursor-pointer transition-colors duration-200 secondary-sidebar-item hover:bg-(--secondary-sidebar-hover-bg)",
                "aria-expanded": m(L, R) ? "true" : "false",
                "aria-controls": s(A, z),
                "data-testid": R.testId,
                onClick: (D) => x(L, R)
              }, [
                v("span", $F, P(R.label), 1),
                v("i", {
                  class: C([
                    m(L, R) ? "ri-arrow-down-s-line" : "ri-arrow-right-s-line",
                    "text-base leading-none secondary-sidebar-item-text"
                  ]),
                  "aria-hidden": "true"
                }, null, 2)
              ], 8, SF),
              Gl(v("div", {
                id: s(A, z),
                class: "flex flex-col gap-1 pl-3"
              }, [
                (c(!0), g(se, null, Me(R.children, (D, V) => (c(), g("button", {
                  key: `${A}-${z}-${V}`,
                  type: "button",
                  class: C(S(D)),
                  "data-active": D.active ? "true" : "false",
                  "aria-current": D.active ? "page" : void 0,
                  "data-testid": D.testId,
                  onClick: (Y) => w(D, L)
                }, [
                  v("span", LF, P(D.label), 1)
                ], 10, TF))), 128))
              ], 8, IF), [
                [Cu, m(L, R)]
              ])
            ])) : (c(), g("button", {
              key: 1,
              type: "button",
              class: C(S(R)),
              "data-active": R.active ? "true" : "false",
              "aria-current": R.active ? "page" : void 0,
              "data-testid": R.testId,
              onClick: (D) => w(R, L)
            }, [
              v("span", AF, P(R.label), 1)
            ], 10, EF))
          ], 64))), 128))
        ]))), 128))
      ])
    ], 6));
  }
}), Lq = /* @__PURE__ */ lt(RF, [["__scopeId", "data-v-4e518031"]]), BF = { class: "flex items-center justify-between gap-5 self-stretch" }, MF = { class: "flex items-center gap-4" }, DF = { class: "shrink-0" }, zF = { class: "flex items-center" }, OF = { class: "flex items-center justify-end gap-2" }, PF = /* @__PURE__ */ ye({
  __name: "Navbar",
  props: {
    searchPlaceholder: { default: "Search by : company, contact, référence N°, event..." },
    searchClearLabel: { default: "Clear search" },
    searchIcon: { default: void 0 },
    filterIcon: { default: void 0 },
    actions: { default: () => [
      { icon: void 0, alt: "Action 1" },
      { icon: void 0, alt: "Action 2" },
      { icon: void 0, alt: "Action 3" },
      { icon: void 0, alt: "Action 4" }
    ] },
    avatar: { default: void 0 },
    searchWidth: { default: "487px" },
    searchSize: { default: "md" },
    searchValue: { default: "" },
    searchDisabled: { type: Boolean, default: !1 },
    avatarDropdownItems: { default: void 0 },
    avatarDropdownWidth: { default: "288px" },
    avatarDropdownAriaLabel: { default: void 0 },
    isScrolled: { type: Boolean, default: !1 }
  },
  emits: ["action-click", "update:searchValue", "search-click", "filter-click", "avatar-dropdown-item-click"],
  setup(e, { emit: n }) {
    const t = e, a = n, l = E(t.searchValue || "");
    Ie(
      () => t.searchValue,
      (o) => {
        l.value = o || "";
      }
    ), Ie(l, (o) => {
      a("update:searchValue", o);
    });
    const r = (o, i) => {
      o.onClick && o.onClick(), a("action-click", o, i);
    };
    return (o, i) => (c(), g("nav", {
      class: C(["border-border-base-soft text-text-secondary-disabled font-inter relative box-border flex w-full flex-col items-start justify-center border-b border-solid px-4 text-left text-sm transition-all duration-300", e.isScrolled ? "py-3" : "py-4"])
    }, [
      v("div", BF, [
        v("div", MF, [
          v("div", DF, [
            te(Yi, {
              modelValue: l.value,
              "onUpdate:modelValue": i[0] || (i[0] = (s) => l.value = s),
              placeholder: e.searchPlaceholder,
              labels: { clear: e.searchClearLabel },
              "icon-left": e.searchIcon,
              width: e.searchWidth,
              size: e.searchSize,
              disabled: e.searchDisabled,
              rounded: "full"
            }, null, 8, ["modelValue", "placeholder", "labels", "icon-left", "width", "size", "disabled"])
          ]),
          e.filterIcon ? (c(), K(I(Re), {
            key: 0,
            variant: "primary",
            "icon-left": e.filterIcon,
            "icon-only": "",
            size: "md",
            "aria-label": "Filter icon",
            class: "filter-button",
            onClick: i[1] || (i[1] = () => o.$emit("filter-click"))
          }, null, 8, ["icon-left"])) : k("", !0)
        ]),
        v("div", zF, [
          v("div", OF, [
            (c(!0), g(se, null, Me(e.actions, (s, d) => (c(), g(se, { key: d }, [
              s.icon ? (c(), K(I(Re), {
                key: 0,
                variant: "secondary",
                "icon-left": s.icon,
                "icon-only": "",
                size: "md",
                "aria-label": s.alt || "Action icon",
                onClick: (u) => r(s, d)
              }, null, 8, ["icon-left", "aria-label", "onClick"])) : k("", !0)
            ], 64))), 128)),
            e.avatar && !e.avatarDropdownItems ? (c(), K(Kt, {
              key: 0,
              name: e.avatar.name,
              img: e.avatar.img
            }, null, 8, ["name", "img"])) : k("", !0),
            e.avatar && e.avatarDropdownItems ? (c(), K(Sn, {
              key: 1,
              avatar: e.avatar,
              items: e.avatarDropdownItems,
              "menu-align": "right",
              "menu-width": e.avatarDropdownWidth,
              "aria-label": e.avatarDropdownAriaLabel
            }, null, 8, ["avatar", "items", "menu-width", "aria-label"])) : k("", !0)
          ])
        ])
      ])
    ], 2));
  }
}), Eq = /* @__PURE__ */ lt(PF, [["__scopeId", "data-v-5d495ad5"]]), FF = /* @__PURE__ */ ye({
  __name: "SpeedDial",
  props: {
    primaryIcon: {},
    primaryIconAlt: { default: "" },
    items: {},
    size: { default: "md" },
    orientation: { default: "vertical" },
    direction: { default: "top" },
    open: { type: Boolean, default: !1 }
  },
  emits: ["update:open", "item-click"],
  setup(e, { emit: n }) {
    const t = e, a = n, l = E(t.open);
    Ie(
      () => t.open,
      (h) => {
        l.value = h;
      }
    );
    const r = (h) => {
      l.value = h, a("update:open", h);
    }, o = () => {
      r(!l.value);
    }, i = (h, m) => {
      h.onClick && h.onClick(m), a("item-click", h, m);
    }, s = p(() => {
      const h = "relative w-full flex p-2.5 box-border gap-2";
      return t.orientation === "horizontal" ? t.direction === "left" ? `${h} flex-row items-center` : `${h} flex-row-reverse items-center` : t.direction === "top" ? `${h} flex-col-reverse items-end` : `${h} flex-col items-end`;
    }), d = p(() => ({
      position: "relative"
    })), u = p(() => {
      const h = "flex items-center";
      return t.orientation === "horizontal" ? `${h} flex-row` : `${h} flex-col`;
    }), f = p(() => (t.orientation === "horizontal", "gap-2")), b = p(() => t.direction);
    return (h, m) => (c(), g("div", {
      class: C([s.value, "speed-dial-container"])
    }, [
      te(Mr, {
        name: `speed-dial-${b.value}`,
        tag: "div",
        class: C([[u.value, f.value], "relative"]),
        style: Ne(d.value)
      }, {
        default: ve(() => [
          (c(!0), g(se, null, Me(l.value ? e.items : [], (x, y) => (c(), K(I(Re), {
            key: `speed-dial-item-${y}`,
            variant: "secondary",
            "icon-left": x.icon,
            "icon-only": "",
            "aria-label": x.iconAlt,
            size: e.size,
            style: Ne({
              "--index": y
            }),
            class: "relative",
            onClick: (w) => i(x, w)
          }, null, 8, ["icon-left", "aria-label", "size", "style", "onClick"]))), 128))
        ]),
        _: 1
      }, 8, ["name", "class", "style"]),
      te(I(Re), {
        variant: "primary",
        "icon-left": e.primaryIcon,
        "icon-only": "",
        "aria-label": e.primaryIconAlt,
        size: e.size,
        class: "relative z-20 speed-dial-primary-button",
        onClick: o
      }, null, 8, ["icon-left", "aria-label", "size"])
    ], 2));
  }
}), Aq = /* @__PURE__ */ lt(FF, [["__scopeId", "data-v-0eb94464"]]);
function VF(e) {
  return !!e.duration && e.status !== "error" && !e.link && !e.primaryAction && !e.secondaryAction;
}
function Hv(e) {
  return (e.layout ?? "default") === "default" && (e.status === "error" || e.status === "warning");
}
function NF(e) {
  const n = e.layout === "withHeader" && e.avatar ? `${e.avatar.name} ${e.message}` : e.message;
  return [e.title, n].filter(Boolean).join(". ");
}
const HF = 3, Vn = E([]), Rr = /* @__PURE__ */ new Map(), ir = /* @__PURE__ */ new Set();
let sb = !1;
function db(e) {
  const n = Rr.get(e);
  n != null && n.handle && clearTimeout(n.handle), Rr.delete(e);
}
function jF() {
  function e(i, s) {
    s.startedAt = Date.now(), s.handle = setTimeout(() => o(i), s.remaining);
  }
  function n(i) {
    if (!VF(i)) return;
    const s = /* @__PURE__ */ new Set();
    sb && s.add("window"), ir.has(i.id) && s.add("pointer");
    const d = { remaining: i.duration, startedAt: 0, pausedBy: s };
    Rr.set(i.id, d), s.size || e(i.id, d);
  }
  function t(i) {
    const s = (f) => (f.layout ?? "default") === "default", d = s(i) ? Vn.value.findIndex(
      (f) => s(f) && f.status === i.status && f.title === i.title && f.message === i.message
    ) : -1;
    if (d >= 0) {
      const f = { ariaClose: "Close", ...i, id: Vn.value[d].id };
      return db(f.id), Vn.value[d] = f, n(f), f.id;
    }
    const u = {
      id: crypto.randomUUID(),
      ariaClose: "Close",
      ...i
    };
    if (Vn.value.length >= HF) {
      const f = Vn.value.find(
        (b) => b.status !== "error" && !b.link && !b.primaryAction && !b.secondaryAction && !ir.has(b.id)
      );
      f && o(f.id);
    }
    return Vn.value.push(u), n(u), u.id;
  }
  function a(i, s = "pointer") {
    s === "pointer" && ir.add(i);
    const d = Rr.get(i);
    d && (d.pausedBy.add(s), d.handle && (clearTimeout(d.handle), d.handle = void 0, d.remaining = Math.max(0, d.remaining - (Date.now() - d.startedAt))));
  }
  function l(i, s = "pointer") {
    s === "pointer" && ir.delete(i);
    const d = Rr.get(i);
    d && (d.pausedBy.delete(s), !(d.handle || d.pausedBy.size) && e(i, d));
  }
  function r(i) {
    sb = i, Vn.value.forEach(
      (s) => i ? a(s.id, "window") : l(s.id, "window")
    );
  }
  function o(i) {
    db(i), ir.delete(i), Vn.value = Vn.value.filter((s) => s.id !== i);
  }
  return {
    toasts: Vn,
    showToast: t,
    removeToast: o,
    pauseToast: a,
    resumeToast: l,
    setWindowBlurred: r
  };
}
const ud = /* @__PURE__ */ ye({
  __name: "ToastActions",
  props: {
    primary: {},
    secondary: {}
  },
  emits: ["run"],
  setup(e, { emit: n }) {
    const t = e, a = n, l = p(() => {
      const r = [];
      return t.primary && r.push({ action: t.primary, variant: "primary" }), t.secondary && r.push({ action: t.secondary, variant: "secondary" }), r;
    });
    return (r, o) => l.value.length ? (c(), g("div", {
      key: 0,
      "data-testid": "toast-actions",
      class: C(["grid items-center gap-3", l.value.length > 1 ? "grid-cols-2" : "grid-cols-1"])
    }, [
      (c(!0), g(se, null, Me(l.value, ({ action: i, variant: s }) => (c(), K(I(Re), {
        key: s,
        variant: s,
        size: "xs",
        "full-width": "",
        label: i.label,
        "icon-left": i.icon,
        onClick: (d) => a("run", i.onClick)
      }, null, 8, ["variant", "label", "icon-left", "onClick"]))), 128))
    ], 2)) : k("", !0);
  }
}), WF = ["role", "aria-atomic"], qF = { class: "flex min-w-0 flex-1 flex-col gap-1" }, UF = { class: "flex flex-col gap-px" }, GF = {
  key: 0,
  "data-testid": "toast-name",
  class: "text-(length:--size-l) leading-(--line-height-l-tight) font-(--weight-semi-bold)"
}, KF = {
  "data-testid": "toast-message",
  class: "text-(length:--size-m) leading-(--line-height-l)"
}, YF = {
  key: 0,
  "data-testid": "toast-time",
  class: "text-(length:--size-sm) leading-(--line-height-xs)"
}, JF = {
  key: 1,
  "data-testid": "toast-content",
  class: "flex items-start gap-3"
}, ZF = { class: "flex min-w-0 flex-1 flex-col gap-3.5" }, XF = {
  key: 0,
  "data-testid": "toast-title",
  class: "text-(length:--size-l) font-(--weight-bold)"
}, QF = { "data-testid": "toast-message" }, _F = {
  key: 2,
  "data-testid": "toast-message-group",
  class: "flex min-w-0 flex-1 items-start gap-3"
}, eV = {
  "data-testid": "toast-icon",
  class: "inline-flex shrink-0 items-center justify-center",
  "aria-hidden": "true"
}, tV = { class: "flex min-w-0 flex-1 flex-col gap-1 text-(length:--size-m) leading-(--line-height-m)" }, nV = {
  key: 0,
  "data-testid": "toast-title",
  class: "text-(length:--size-l) leading-(--line-height-l) font-(--weight-bold)"
}, aV = /* @__PURE__ */ ye({
  __name: "ToastItem",
  props: {
    toast: {}
  },
  emits: ["close", "pause", "resume"],
  setup(e, { emit: n }) {
    const t = e, a = n;
    let l = !1, r = !1;
    function o(S, $) {
      const T = l || r;
      l = S, r = $;
      const L = l || r;
      L && !T && a("pause"), !L && T && a("resume");
    }
    function i(S) {
      S.currentTarget.contains(S.relatedTarget) || o(l, !1);
    }
    function s(S) {
      S.key === "Escape" && (S.stopPropagation(), S.preventDefault(), a("close"));
    }
    const d = p(() => t.toast.layout ?? "default"), u = p(() => Hv(t.toast) ? "alert" : void 0), f = {
      default: "items-center justify-between gap-3 p-4",
      withHeader: "flex-col gap-4 p-[calc(--spacing(4)-1px)]",
      iconShape: "flex-col p-[calc(--spacing(4)-1px)]"
    }, b = {
      success: {
        color: "text-(--icons-icon-success)",
        leading: "leading-(--line-height-l)",
        icon: "ri-checkbox-circle-fill"
      },
      info: {
        color: "text-(--icons-icon-info)",
        leading: "leading-(--line-height-l)",
        icon: "ri-information-fill"
      },
      warning: {
        color: "text-(--icons-icon-warning)",
        leading: "leading-(--line-height-m)",
        icon: "ri-alert-fill"
      },
      error: {
        color: "text-(--icons-icon-error)",
        leading: "leading-(--line-height-l)",
        icon: "ri-error-warning-fill"
      }
    }, h = p(() => b[t.toast.status]), m = p(
      () => d.value !== "withHeader" || !t.toast.primaryAction && !t.toast.secondaryAction
    ), x = p(() => m.value && d.value !== "default" ? "pe-6" : "");
    function y(S) {
      try {
        S == null || S();
      } finally {
        a("close");
      }
    }
    function w() {
      var S;
      (S = t.toast.link) != null && S.onClick && y(t.toast.link.onClick);
    }
    return (S, $) => (c(), g("div", {
      class: C(["relative flex w-full overflow-hidden rounded-(--border-border-radius-rounded-l) border border-(--border-border-base-medium) bg-(--background-background-black-default) text-(--text-text-white-default) shadow-(--blur-shadow-toast)", f[d.value]]),
      "data-testid": "toast",
      role: u.value,
      "aria-atomic": u.value ? "true" : void 0,
      onMouseenter: $[1] || ($[1] = (T) => o(!0, I(r))),
      onMouseleave: $[2] || ($[2] = (T) => o(!1, I(r))),
      onFocusin: $[3] || ($[3] = (T) => o(I(l), !0)),
      onFocusout: i,
      onKeydown: s
    }, [
      d.value === "withHeader" ? (c(), g(se, { key: 0 }, [
        e.toast.title ? (c(), g("div", {
          key: 0,
          "data-testid": "toast-header",
          class: C(["py-1 text-(length:--size-l) leading-(--line-height-l) font-(--weight-bold)", x.value])
        }, P(e.toast.title), 3)) : k("", !0),
        v("div", {
          "data-testid": "toast-avatar-row",
          class: C(["flex items-start gap-3", !e.toast.title && x.value])
        }, [
          e.toast.avatar ? (c(), K(I(Kt), {
            key: 0,
            img: e.toast.avatar.src,
            name: e.toast.avatar.name,
            presentational: ""
          }, null, 8, ["img", "name"])) : k("", !0),
          v("div", qF, [
            v("div", UF, [
              e.toast.avatar ? (c(), g("div", GF, P(e.toast.avatar.name), 1)) : k("", !0),
              v("div", KF, P(e.toast.message), 1)
            ]),
            e.toast.time ? (c(), g("div", YF, P(e.toast.time), 1)) : k("", !0)
          ])
        ], 2),
        te(ud, {
          primary: e.toast.primaryAction,
          secondary: e.toast.secondaryAction,
          onRun: y
        }, null, 8, ["primary", "secondary"])
      ], 64)) : d.value === "iconShape" ? (c(), g("div", JF, [
        e.toast.icon ? (c(), K(Xt, {
          key: 0,
          "data-testid": "toast-icon-shape",
          color: "white",
          variant: "outlined",
          size: "md",
          icon: e.toast.icon
        }, null, 8, ["icon"])) : k("", !0),
        v("div", ZF, [
          v("div", {
            class: C(["flex flex-col gap-2 text-(length:--size-m) leading-(--line-height-l)", x.value])
          }, [
            e.toast.title ? (c(), g("div", XF, P(e.toast.title), 1)) : k("", !0),
            v("div", QF, P(e.toast.message), 1)
          ], 2),
          te(ud, {
            primary: e.toast.primaryAction,
            secondary: e.toast.secondaryAction,
            onRun: y
          }, null, 8, ["primary", "secondary"])
        ])
      ])) : (c(), g("div", _F, [
        v("div", eV, [
          v("i", {
            class: C(["size-(--icon-size-md) text-(length:--icon-size-md) leading-(--icon-size-md)", [h.value.icon, h.value.color]])
          }, null, 2)
        ]),
        v("div", tV, [
          e.toast.title ? (c(), g("div", nV, P(e.toast.title), 1)) : k("", !0),
          v("div", {
            "data-testid": "toast-message",
            class: C(h.value.leading)
          }, P(e.toast.message), 3),
          e.toast.link ? (c(), K(I($n), {
            key: 1,
            "data-testid": "toast-link",
            class: "self-start text-(--text-text-link-on-dark)!",
            as: e.toast.link.href ? "a" : "button",
            href: e.toast.link.href,
            onClick: w
          }, {
            default: ve(() => [
              at(P(e.toast.link.label), 1)
            ]),
            _: 1
          }, 8, ["as", "href"])) : k("", !0),
          te(ud, {
            class: "mt-3.5",
            primary: e.toast.primaryAction,
            secondary: e.toast.secondaryAction,
            onRun: y
          }, null, 8, ["primary", "secondary"])
        ])
      ])),
      m.value ? (c(), g("div", {
        key: 3,
        "data-testid": "toast-close",
        class: C(d.value === "default" ? "flex shrink-0" : "absolute top-1 right-1")
      }, [
        te(I(Re), {
          class: "[&_i]:text-(--icons-icon-white-default)! hover:[&_i]:text-(--icons-icon-dark-default)! [&_i]:text-(length:--icon-size-sm) [&_i]:leading-(--icon-size-sm)",
          variant: "ghost",
          size: "xs",
          "icon-only": "",
          "icon-left": "ri-close-fill",
          "aria-label": t.toast.ariaClose,
          onClick: $[0] || ($[0] = (T) => a("close"))
        }, null, 8, ["aria-label"])
      ], 2)) : k("", !0)
    ], 42, WF));
  }
}), lV = {
  role: "status",
  "aria-live": "polite",
  "aria-atomic": "true",
  class: "sr-only",
  "data-testid": "toast-live-polite"
}, rV = 250, Rq = /* @__PURE__ */ ye({
  __name: "ToastContainer",
  setup(e) {
    const { toasts: n, removeToast: t, pauseToast: a, resumeToast: l, setWindowBlurred: r } = jF(), o = E();
    let i, s = !1, d = null;
    const u = E("");
    let f = new Map(n.value.map((S) => [S.id, S])), b = /* @__PURE__ */ new Set();
    function h(S) {
      var D, V, Y;
      const $ = S.map((_) => {
        var j;
        return (j = o.value) == null ? void 0 : j.querySelector(`[data-toast-id="${_}"]`);
      }), T = $.find((_) => _ == null ? void 0 : _.contains(document.activeElement));
      if (!T) return;
      const L = d;
      if (d = null, L != null && L.isConnected) return L.focus();
      if (!((D = document.activeElement) != null && D.matches(":focus-visible"))) return;
      const A = [...((V = o.value) == null ? void 0 : V.querySelectorAll("[data-toast-id]")) ?? []], R = A.indexOf(T), z = [...A.slice(R + 1), ...A.slice(0, R).reverse()].find(
        (_) => !$.includes(_)
      );
      (Y = z == null ? void 0 : z.querySelector("button")) == null || Y.focus();
    }
    Ie(
      () => [...n.value],
      async (S) => {
        const $ = new Map(S.map((L) => [L.id, L]));
        h([...f.keys()].filter((L) => !$.has(L)));
        const T = S.filter((L) => f.has(L.id) ? f.get(L.id) !== L : !Hv(L));
        if (f = $, !T.length) {
          b.size && ![...b].some((L) => $.has(L)) && (u.value = "", b = /* @__PURE__ */ new Set());
          return;
        }
        b = new Set(T.map((L) => L.id)), u.value = "", await qe(), u.value = T.map(NF).join(" ");
      }
    );
    function m() {
      const S = !document.hasFocus();
      S !== s && (s = S, r(S));
    }
    function x(S) {
      clearInterval(i), i = void 0, S && (m(), i = setInterval(m, rV));
    }
    Ie(() => n.value.length > 0, x, { flush: "sync" });
    function y(S) {
      var T;
      const $ = S.relatedTarget;
      $ instanceof HTMLElement && !((T = o.value) != null && T.contains($)) && (d = $);
    }
    function w(S) {
      var T;
      const $ = S.relatedTarget;
      ($ instanceof Node ? !((T = o.value) != null && T.contains($)) : document.hasFocus()) && (d = null);
    }
    return ot(() => {
      s = !document.hasFocus(), r(s), x(n.value.length > 0);
    }), gt(() => {
      x(!1), r(!1);
    }), (S, $) => (c(), g("div", {
      ref_key: "root",
      ref: o,
      class: "fixed right-4 z-[500] w-80 max-w-[calc(100vw-2rem)]",
      style: { top: "var(--toast-container-top, 1rem)" },
      onFocusin: y,
      onFocusout: w
    }, [
      v("div", lV, P(u.value), 1),
      te(Mr, {
        name: "toast",
        tag: "div",
        class: "flex max-h-[calc(100vh-var(--toast-container-top,1rem)-1rem+--spacing(5))] flex-col gap-3 overflow-x-hidden overflow-y-auto not-empty:-m-2.5 not-empty:p-2.5 *:shrink-0"
      }, {
        default: ve(() => [
          (c(!0), g(se, null, Me(I(n), (T) => (c(), K(aV, {
            key: T.id,
            toast: T,
            "data-toast-id": T.id,
            onClose: (L) => I(t)(T.id),
            onPause: (L) => I(a)(T.id, "pointer"),
            onResume: (L) => I(l)(T.id, "pointer")
          }, null, 8, ["toast", "data-toast-id", "onClose", "onPause", "onResume"]))), 128))
        ]),
        _: 1
      })
    ], 544));
  }
}), oV = '<svg viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path d="M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM11 15V17H13V15H11ZM11 7V13H13V7H11Z"/></svg>', iV = '<svg viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path d="M11.9997 10.5865L16.9495 5.63672L18.3637 7.05093L13.4139 12.0007L18.3637 16.9504L16.9495 18.3646L11.9997 13.4149L7.04996 18.3646L5.63574 16.9504L10.5855 12.0007L5.63574 7.05093L7.04996 5.63672L11.9997 10.5865Z"/></svg>', sV = { key: 0 }, dV = {
  key: 0,
  "data-testid": "form-error-summary-inline",
  class: "inline-flex items-center gap-2 px-3 py-1.5 rounded-(--border-border-radius-rounded-sm) bg-(--background-background-error) border border-solid border-(--border-border-error-subtle) text-(length:--size-m) leading-(--line-height-l) text-(--text-text-heading) font-(--weight-medium)"
}, uV = ["innerHTML"], cV = ["innerHTML"], fV = {
  key: 0,
  "data-testid": "form-error-summary-menu",
  class: "absolute left-0 top-[calc(100%+4px)] z-50 min-w-56 rounded-(--border-border-radius-rounded-l) border border-solid border-(--border-border-error-subtle) bg-white-50-opacity-bold p-3 shadow-(--blur-shadow-m) [backdrop-filter:blur(4px)] dark:border-(--border-border-base) dark:bg-(--background-background-black-default) dark:shadow-(--blur-shadow-m-dark)"
}, hV = {
  key: 0,
  "data-testid": "form-error-summary-list-heading",
  class: "mb-2 text-(length:--size-sm) leading-(--line-height-l) font-(--weight-semi-bold) text-(--text-text-body) dark:text-(--text-text-white-secondary)"
}, bV = { class: "flex flex-col gap-1" }, gV = ["onClick"], pV = ["innerHTML"], Bq = /* @__PURE__ */ ye({
  __name: "FormErrorSummary",
  props: {
    errors: {},
    mode: { default: "inline" },
    heading: { default: void 0 },
    triggerLabel: { default: void 0 },
    listHeading: { default: void 0 }
  },
  emits: ["navigateToField"],
  setup(e, { emit: n }) {
    const t = n, { isOpen: a, dropdownRef: l, toggleDropdown: r, closeDropdown: o } = Yl(), i = p(
      () => oV.replace("<svg", '<svg width="16" height="16" style="display: block;"')
    ), s = p(
      () => iV.replace("<svg", '<svg width="12" height="12" style="display: block;"')
    ), d = (u) => {
      o(), t("navigateToField", u);
    };
    return (u, f) => e.errors.length > 0 ? (c(), g("div", sV, [
      e.mode === "inline" ? (c(), g("div", dV, [
        v("span", {
          class: "h-4 w-4 flex-shrink-0 inline-flex items-center justify-center text-(--icons-icon-error)",
          innerHTML: i.value
        }, null, 8, uV),
        v("span", null, P(e.heading), 1)
      ])) : (c(), g("div", {
        key: 1,
        ref_key: "dropdownRef",
        ref: l,
        class: "relative inline-block"
      }, [
        v("button", {
          type: "button",
          "data-testid": "form-error-summary-trigger",
          class: "inline-flex items-center gap-1.5 rounded-(--border-border-radius-rounded-full) border border-solid border-(--border-border-error-subtle) bg-(--background-background-error) px-3 py-1.5 text-(length:--size-m) leading-(--line-height-l) font-(--weight-medium) text-(--text-text-heading) cursor-pointer transition-opacity hover:opacity-80",
          onClick: f[0] || (f[0] = //@ts-ignore
          (...b) => I(r) && I(r)(...b))
        }, [
          v("span", {
            class: "h-4 w-4 flex-shrink-0 inline-flex items-center justify-center text-(--icons-icon-error)",
            innerHTML: i.value
          }, null, 8, cV),
          v("span", null, P(e.triggerLabel), 1),
          (c(), g("svg", {
            class: "h-4 w-4 transition-transform duration-200",
            style: Ne({ transform: I(a) ? "rotate(180deg)" : "rotate(0deg)" }),
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [...f[1] || (f[1] = [
            v("path", {
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-width": "2",
              d: "M19 9l-7 7-7-7"
            }, null, -1)
          ])], 4))
        ]),
        te(wt, {
          "enter-active-class": "transition duration-100 ease-out",
          "enter-from-class": "transform scale-95 opacity-0",
          "enter-to-class": "transform scale-100 opacity-100",
          "leave-active-class": "transition duration-75 ease-out",
          "leave-from-class": "transform scale-100 opacity-100",
          "leave-to-class": "transform scale-95 opacity-0"
        }, {
          default: ve(() => [
            I(a) ? (c(), g("div", fV, [
              e.listHeading ? (c(), g("p", hV, P(e.listHeading), 1)) : k("", !0),
              v("ul", bV, [
                (c(!0), g(se, null, Me(e.errors, (b) => (c(), g("li", {
                  key: b.key
                }, [
                  v("button", {
                    type: "button",
                    "data-testid": "form-error-summary-item",
                    class: "inline-flex w-full items-center gap-1.5 rounded-(--border-border-radius-rounded-sm) px-2 py-1 text-(length:--size-m) leading-(--line-height-l) text-(--text-text-body) cursor-pointer transition-colors hover:bg-(--background-background-error) dark:text-(--text-text-white-secondary) dark:hover:bg-white/8",
                    onClick: (h) => d(b.key)
                  }, [
                    v("span", {
                      class: "h-3 w-3 flex-shrink-0 inline-flex items-center justify-center text-(--icons-icon-error)",
                      innerHTML: s.value
                    }, null, 8, pV),
                    v("span", null, P(b.label), 1)
                  ], 8, gV)
                ]))), 128))
              ])
            ])) : k("", !0)
          ]),
          _: 1
        })
      ], 512))
    ])) : k("", !0);
  }
}), mV = ["id"], Mq = /* @__PURE__ */ ye({
  __name: "DynamicFormField",
  props: {
    field: {},
    modelValue: {},
    error: {}
  },
  emits: ["update:modelValue", "country-change", "blur"],
  setup(e) {
    return (n, t) => (c(), g("div", {
      id: `field-${e.field.key}`
    }, [
      e.field.type === "email" ? (c(), K(jR, {
        key: 0,
        "model-value": e.modelValue,
        label: e.field.label,
        required: e.field.required,
        readonly: e.field.readonly,
        size: e.field.size,
        "full-width": !0,
        hint: e.field.hint,
        placeholder: e.field.placeholder ?? "",
        error: e.error,
        "onUpdate:modelValue": t[0] || (t[0] = (a) => n.$emit("update:modelValue", a)),
        onBlur: t[1] || (t[1] = (a) => n.$emit("blur"))
      }, null, 8, ["model-value", "label", "required", "readonly", "size", "hint", "placeholder", "error"])) : e.field.type === "text" ? (c(), K(zt, {
        key: 1,
        "model-value": e.modelValue,
        label: e.field.label,
        required: e.field.required,
        readonly: e.field.readonly,
        size: e.field.size,
        "full-width": !0,
        placeholder: e.field.placeholder ?? "",
        error: e.error,
        "onUpdate:modelValue": t[2] || (t[2] = (a) => n.$emit("update:modelValue", a)),
        onBlur: t[3] || (t[3] = (a) => n.$emit("blur"))
      }, null, 8, ["model-value", "label", "required", "readonly", "size", "placeholder", "error"])) : e.field.type === "phone" ? (c(), K(aB, {
        key: 2,
        "model-value": e.modelValue,
        label: e.field.label,
        readonly: e.field.readonly,
        "show-country-selector": e.field.showCountrySelector,
        countries: e.field.countries,
        "full-width": !0,
        size: e.field.size,
        error: e.error,
        "onUpdate:modelValue": t[4] || (t[4] = (a) => n.$emit("update:modelValue", a)),
        onBlur: t[5] || (t[5] = (a) => n.$emit("blur")),
        onCountryChange: t[6] || (t[6] = (a, l) => n.$emit("country-change", { dialCode: a.dialCode, nationalNumber: l }))
      }, null, 8, ["model-value", "label", "readonly", "show-country-selector", "countries", "size", "error"])) : e.field.type === "select" ? (c(), K(Tl, {
        key: 3,
        "model-value": e.modelValue,
        options: e.field.options || [],
        label: e.field.label,
        required: e.field.required,
        readonly: e.field.readonly,
        "full-width": !0,
        hint: e.field.hint,
        error: e.error,
        "onUpdate:modelValue": t[7] || (t[7] = (a) => n.$emit("update:modelValue", a)),
        onBlur: t[8] || (t[8] = (a) => n.$emit("blur"))
      }, null, 8, ["model-value", "options", "label", "required", "readonly", "hint", "error"])) : k("", !0)
    ], 8, mV));
  }
}), Dq = /* @__PURE__ */ ye({
  inheritAttrs: !1,
  __name: "FormSaveButton",
  props: {
    enabled: { type: Boolean },
    saving: { type: Boolean },
    saveLabel: {},
    savingLabel: {},
    disabledHint: {}
  },
  emits: ["save"],
  setup(e, { expose: n }) {
    const t = E(null);
    return n({ buttonElement: p(() => {
      var a;
      return ((a = t.value) == null ? void 0 : a.$el) ?? null;
    }) }), (a, l) => (c(), K(ft, {
      text: e.disabledHint ?? "",
      disabled: e.enabled || e.saving || !e.disabledHint
    }, {
      default: ve(() => [
        te(Re, Oe({
          ref_key: "buttonRef",
          ref: t
        }, a.$attrs, {
          variant: "primary",
          "icon-left": "ri-save-line",
          label: e.saveLabel,
          "aria-disabled": !e.enabled,
          loading: e.saving,
          "loading-label": e.savingLabel,
          onClick: l[0] || (l[0] = (r) => a.$emit("save"))
        }), null, 16, ["label", "aria-disabled", "loading", "loading-label"])
      ]),
      _: 1
    }, 8, ["text", "disabled"]));
  }
}), vV = { class: "flex flex-col items-center gap-2" }, xV = { class: "text-lg font-semibold text-(--colors-text-black-default)" }, yV = { class: "text-center text-base font-normal leading-6 text-(--colors-text-black-default)" }, kV = /* @__PURE__ */ ye({
  __name: "UnsavedChangesModal",
  props: {
    modelValue: { type: Boolean },
    title: {},
    message: {},
    stayLabel: {},
    leaveLabel: {},
    saveLabel: {},
    saveDisabled: { type: Boolean }
  },
  emits: ["update:modelValue", "stay", "leave", "discard", "save"],
  setup(e, { emit: n }) {
    const t = e, a = n, l = p({
      get: () => t.modelValue,
      set: (d) => a("update:modelValue", d)
    });
    function r() {
      a("update:modelValue", !1), a("stay");
    }
    function o() {
      a("update:modelValue", !1), a("leave");
    }
    function i() {
      a("update:modelValue", !1), a("discard");
    }
    function s() {
      t.saveDisabled || a("save");
    }
    return (d, u) => (c(), K(za, {
      modelValue: l.value,
      "onUpdate:modelValue": u[0] || (u[0] = (f) => l.value = f),
      size: "sm",
      dismissable: !1,
      "close-on-escape": !0,
      "header-position": "center",
      "footer-position": "right",
      "overlay-class": "!z-[400]",
      onClose: r
    }, {
      header: ve(() => [
        v("div", vV, [
          u[1] || (u[1] = v("div", {
            "data-testid": "unsaved-icon-shape",
            class: "flex items-center justify-center w-12 h-12 rounded-lg bg-(--colors-background-white) border border-(--border-border-base-soft)"
          }, [
            v("svg", {
              class: "h-7 w-7",
              viewBox: "0 0 24 24",
              fill: "none",
              xmlns: "http://www.w3.org/2000/svg",
              "aria-hidden": "true"
            }, [
              v("path", {
                d: "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM11 11V17H13V11H11ZM11 7V9H13V7H11Z",
                fill: "var(--colors-icon-info)"
              })
            ])
          ], -1)),
          v("h3", xV, P(e.title), 1)
        ])
      ]),
      footer: ve(() => [
        e.saveLabel ? (c(), g(se, { key: 0 }, [
          te(Re, {
            variant: "secondary",
            class: "whitespace-nowrap",
            label: e.leaveLabel,
            "data-testid": "unsaved-discard",
            onClick: i
          }, null, 8, ["label"]),
          te(Re, {
            variant: "primary",
            class: "whitespace-nowrap",
            label: e.saveLabel,
            disabled: e.saveDisabled,
            "data-testid": "unsaved-save",
            onClick: s
          }, null, 8, ["label", "disabled"])
        ], 64)) : (c(), g(se, { key: 1 }, [
          te(Re, {
            variant: "tertiary",
            class: "whitespace-nowrap",
            label: e.leaveLabel,
            "data-testid": "unsaved-leave",
            onClick: o
          }, null, 8, ["label"]),
          te(Re, {
            variant: "primary",
            class: "whitespace-nowrap",
            label: e.stayLabel,
            "data-testid": "unsaved-stay",
            onClick: r
          }, null, 8, ["label"])
        ], 64))
      ]),
      default: ve(() => [
        v("p", yV, P(e.message), 1)
      ]),
      _: 1
    }, 8, ["modelValue"]));
  }
}), wV = {
  class: "flex flex-col items-center gap-2 text-center",
  "data-testid": "confirm-delete-modal-body"
}, CV = { class: "flex items-center justify-center w-12 h-12 rounded-lg border border-gray-200 bg-white dark:border-gray-700 dark:bg-gray-800" }, SV = { class: "text-xl font-bold text-gray-900 dark:text-white leading-6" }, $V = { class: "text-base text-gray-700 dark:text-gray-300 leading-6" }, zq = /* @__PURE__ */ ye({
  __name: "ConfirmDeleteModal",
  props: {
    modelValue: { type: Boolean },
    title: {},
    subtitle: {},
    confirmLabel: {},
    cancelLabel: {},
    icon: { default: "ri-delete-bin-6-line" },
    confirmDisabled: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue", "confirm", "cancel"],
  setup(e, { emit: n }) {
    const t = e, a = n, l = p({
      get: () => t.modelValue,
      set: (i) => a("update:modelValue", i)
    });
    function r() {
      t.confirmDisabled || (a("update:modelValue", !1), a("confirm"));
    }
    function o() {
      a("update:modelValue", !1), a("cancel");
    }
    return (i, s) => (c(), K(za, {
      modelValue: l.value,
      "onUpdate:modelValue": s[0] || (s[0] = (d) => l.value = d),
      size: "xs",
      dismissable: !1,
      "close-on-escape": !0,
      "show-header": !1,
      "footer-position": "center",
      onClose: o
    }, {
      footer: ve(() => [
        te(Re, {
          variant: "secondary",
          size: "md",
          label: e.cancelLabel,
          "data-testid": "confirm-delete-modal-cancel",
          onClick: o
        }, null, 8, ["label"]),
        te(Re, {
          variant: "error",
          size: "md",
          label: e.confirmLabel,
          disabled: e.confirmDisabled,
          "icon-left": "ri-delete-bin-6-line",
          "data-testid": "confirm-delete-modal-confirm",
          onClick: r
        }, null, 8, ["label", "disabled"])
      ]),
      default: ve(() => [
        v("div", wV, [
          v("div", CV, [
            v("i", {
              class: C([e.icon, "text-2xl text-gray-700 dark:text-gray-200"]),
              "aria-hidden": "true",
              "data-testid": "confirm-delete-modal-icon"
            }, null, 2)
          ]),
          v("h2", SV, P(e.title), 1),
          v("p", $V, P(e.subtitle), 1)
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]));
  }
}), IV = /* @__PURE__ */ ye({
  __name: "DataTableContainer",
  props: {
    class: { type: [Boolean, null, String, Object, Array] },
    tableWidth: {}
  },
  setup(e) {
    const n = e;
    return (t, a) => (c(), g("table", {
      "data-slot": "table",
      class: C([
        "min-w-full table-fixed border-spacing-0 text-sm text-left text-text-black-default",
        n.class
      ]),
      style: Ne(e.tableWidth ? { width: e.tableWidth } : void 0)
    }, [
      $e(t.$slots, "default")
    ], 6));
  }
}), TV = /* @__PURE__ */ ye({
  __name: "DataTableBody",
  props: {
    class: { type: [Boolean, null, String, Object, Array] }
  },
  setup(e) {
    const n = e;
    return (t, a) => (c(), g("tbody", {
      "data-slot": "table-body",
      class: C(["", n.class])
    }, [
      $e(t.$slots, "default")
    ], 2));
  }
}), Oq = /* @__PURE__ */ ye({
  __name: "DataTableCaption",
  props: {
    class: { type: [Boolean, null, String, Object, Array] }
  },
  setup(e) {
    const n = e;
    return (t, a) => (c(), g("caption", {
      "data-slot": "table-caption",
      class: C(["text-muted-foreground mt-4 text-sm", n.class])
    }, [
      $e(t.$slots, "default")
    ], 2));
  }
}), hu = /* @__PURE__ */ ye({
  __name: "DataTableCell",
  props: {
    class: { type: [Boolean, null, String, Object, Array] },
    noTruncate: { type: Boolean, default: !1 }
  },
  setup(e) {
    const n = e, t = E(null);
    function a() {
      var r;
      const l = t.value;
      l && (l.scrollWidth > l.clientWidth ? l.title = ((r = l.textContent) == null ? void 0 : r.trim()) ?? "" : l.title = "");
    }
    return (l, r) => (c(), g("td", {
      "data-slot": "table-cell",
      class: C([
        "leading-5 font-medium text-sm p-3 h-12 align-middle [&:has([type=checkbox])]:pr-0 [&:has([type=checkbox])]:max-w-none",
        e.noTruncate ? "overflow-visible" : "overflow-hidden max-w-0",
        n.class
      ])
    }, [
      e.noTruncate ? $e(l.$slots, "default", { key: 1 }) : (c(), g("div", {
        key: 0,
        ref_key: "truncateRef",
        ref: t,
        class: "truncate",
        onMouseenter: a
      }, [
        $e(l.$slots, "default")
      ], 544))
    ], 2));
  }
});
typeof WorkerGlobalScope < "u" && globalThis instanceof WorkerGlobalScope;
function LV(e) {
  return Ho(e) ? rl(new Proxy({}, {
    get(n, t, a) {
      return I(Reflect.get(e.value, t, a));
    },
    set(n, t, a) {
      return Ho(e.value[t]) && !Ho(a) ? e.value[t].value = a : e.value[t] = a, !0;
    },
    deleteProperty(n, t) {
      return Reflect.deleteProperty(e.value, t);
    },
    has(n, t) {
      return Reflect.has(e.value, t);
    },
    ownKeys() {
      return Object.keys(e.value);
    },
    getOwnPropertyDescriptor() {
      return {
        enumerable: !0,
        configurable: !0
      };
    }
  })) : rl(e);
}
function EV(e) {
  return LV(p(e));
}
function AV(e, ...n) {
  const t = n.flat(), a = t[0];
  return EV(() => Object.fromEntries(typeof a == "function" ? Object.entries(qc(e)).filter(([l, r]) => !a(Rt(r), l)) : Object.entries(qc(e)).filter((l) => !t.includes(l[0]))));
}
const Zo = /* @__PURE__ */ ye({
  __name: "DataTableRow",
  props: {
    class: { type: [Boolean, null, String, Object, Array] }
  },
  setup(e) {
    const n = e;
    return (t, a) => (c(), g("tr", {
      "data-slot": "table-row",
      class: C([
        "bg-white dark:bg-(--colors-background-black-default) border-b border-border-base-soft dark:border-(--colors-border-base) hover:bg-(--background-background-hover) dark:hover:bg-(--color-dark-bg-tertiary)",
        n.class
      ])
    }, [
      $e(t.$slots, "default")
    ], 2));
  }
}), RV = { class: "flex items-center justify-center py-10" }, Pq = /* @__PURE__ */ ye({
  __name: "DataTableEmpty",
  props: {
    class: { type: [Boolean, null, String, Object, Array] },
    colspan: { default: 1 }
  },
  setup(e) {
    const n = e, t = AV(n, "class");
    return (a, l) => (c(), K(Zo, null, {
      default: ve(() => [
        te(hu, Oe({
          class: ["p-4 whitespace-nowrap align-middle text-sm text-foreground", n.class]
        }, I(t)), {
          default: ve(() => [
            v("div", RV, [
              $e(a.$slots, "default")
            ])
          ]),
          _: 3
        }, 16, ["class"])
      ]),
      _: 3
    }));
  }
}), Fq = /* @__PURE__ */ ye({
  __name: "DataTableFooter",
  props: {
    class: { type: [Boolean, null, String, Object, Array] }
  },
  setup(e) {
    const n = e;
    return (t, a) => (c(), g("tfoot", {
      "data-slot": "table-footer",
      class: C(["", n.class])
    }, [
      $e(t.$slots, "default")
    ], 2));
  }
}), BV = "data:image/svg+xml,%3csvg%20viewBox='0%200%2024%2024'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M8.5%207C9.32843%207%2010%206.32843%2010%205.5C10%204.67157%209.32843%204%208.5%204C7.67157%204%207%204.67157%207%205.5C7%206.32843%207.67157%207%208.5%207ZM8.5%2013.5C9.32843%2013.5%2010%2012.8284%2010%2012C10%2011.1716%209.32843%2010.5%208.5%2010.5C7.67157%2010.5%207%2011.1716%207%2012C7%2012.8284%207.67157%2013.5%208.5%2013.5ZM10%2018.5C10%2019.3284%209.32843%2020%208.5%2020C7.67157%2020%207%2019.3284%207%2018.5C7%2017.6716%207.67157%2017%208.5%2017C9.32843%2017%2010%2017.6716%2010%2018.5ZM15.5%207C16.3284%207%2017%206.32843%2017%205.5C17%204.67157%2016.3284%204%2015.5%204C14.6716%204%2014%204.67157%2014%205.5C14%206.32843%2014.6716%207%2015.5%207ZM17%2012C17%2012.8284%2016.3284%2013.5%2015.5%2013.5C14.6716%2013.5%2014%2012.8284%2014%2012C14%2011.1716%2014.6716%2010.5%2015.5%2010.5C16.3284%2010.5%2017%2011.1716%2017%2012ZM15.5%2020C16.3284%2020%2017%2019.3284%2017%2018.5C17%2017.6716%2016.3284%2017%2015.5%2017C14.6716%2017%2014%2017.6716%2014%2018.5C14%2019.3284%2014.6716%2020%2015.5%2020Z'/%3e%3c/svg%3e", MV = "data:image/svg+xml,%3csvg%20viewBox='0%200%2024%2024'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M18%203V5H17V11L19%2014V16H13V23H11V16H5V14L7%2011V5H6V3H18Z'/%3e%3c/svg%3e", DV = ["aria-sort"], zV = { class: "flex items-center gap-1 min-w-0" }, OV = ["src", "data-drag-handle", "draggable"], PV = {
  key: 1,
  class: "me-auto min-w-0"
}, FV = ["src"], VV = {
  key: 4,
  ref: "menuRef",
  class: "relative shrink-0"
}, NV = ["aria-label"], HV = /* @__PURE__ */ ye({
  __name: "DataTableHead",
  props: {
    class: { type: [Boolean, null, String, Object, Array] },
    isDraggable: { type: Boolean, default: !1 },
    isPinned: { type: Boolean, default: !1 },
    isLastPinned: { type: Boolean, default: !1 },
    isLocked: { type: Boolean, default: !1 },
    isPinIconVisible: { type: Boolean, default: !0 },
    headerMenuItems: { default: void 0 },
    isCustomHeader: { type: Boolean, default: !1 },
    isResizingActive: { type: Boolean, default: !1 },
    isResizable: { type: Boolean, default: !0 },
    menuAriaLabel: { default: "Column menu" },
    sortDirection: { default: void 0 }
  },
  emits: ["resize-start", "resize-auto", "drag-handle-start"],
  setup(e, { emit: n }) {
    const t = e, a = p(() => {
      if (t.sortDirection !== void 0)
        return t.sortDirection === "asc" ? "ascending" : t.sortDirection === "desc" ? "descending" : "none";
    }), l = p(() => t.sortDirection === "asc" ? "ri-arrow-up-s-line" : t.sortDirection === "desc" ? "ri-arrow-down-s-line" : "ri-expand-up-down-fill"), r = n;
    let o = 0;
    function i(f) {
      const b = Date.now();
      if (b - o < 300) {
        o = 0, r("resize-auto");
        return;
      }
      o = b, r("resize-start", f);
    }
    const s = p(() => {
      if (t.headerMenuItems)
        return t.headerMenuItems.map((f, b, h) => {
          const m = h[b + 1];
          return {
            label: f.label,
            icon: f.icon,
            onClick: f.onClick,
            disabled: f.disabled,
            hasDividerAfter: (m == null ? void 0 : m.dividerBefore) === !0
          };
        });
    }), d = E(null);
    function u() {
      var b;
      const f = d.value;
      f && (f.scrollWidth > f.clientWidth ? f.title = ((b = f.textContent) == null ? void 0 : b.trim()) ?? "" : f.title = "");
    }
    return (f, b) => (c(), g("th", {
      "data-slot": "table-head",
      scope: "col",
      "aria-sort": a.value,
      class: C([
        "relative h-10 px-3 min-w-32.5 text-left align-middle font-semibold whitespace-nowrap text-(--text-text-heading) dark:text-(--colors-text-white-default) [&:has([type=checkbox])]:min-w-auto [&:has([type=checkbox])]:w-10 [&:has([type=checkbox])]:pr-0 [&_button]:border-0 [&>div>div>button]:p-0",
        e.isPinned ? "bg-white dark:bg-(--colors-background-black-default) z-20" : "z-0",
        t.class
      ])
    }, [
      v("div", zV, [
        e.isDraggable || e.isLocked ? (c(), g("img", {
          key: 0,
          class: C([
            "size-3.5 shrink-0 dark:invert",
            e.isLocked ? "opacity-40 cursor-not-allowed" : "cursor-grab"
          ]),
          src: I(BV),
          alt: "",
          "data-drag-handle": e.isLocked ? "false" : "true",
          draggable: e.isLocked ? "false" : "true",
          onDragstart: b[0] || (b[0] = Ue((h) => !e.isLocked && r("drag-handle-start", h), ["stop"]))
        }, null, 42, OV)) : k("", !0),
        e.isCustomHeader ? (c(), g("div", PV, [
          $e(f.$slots, "default")
        ])) : (c(), g("div", {
          key: 2,
          ref_key: "headerTextRef",
          ref: d,
          class: "truncate me-auto min-w-0",
          onMouseenter: u
        }, [
          $e(f.$slots, "default")
        ], 544)),
        e.isPinned && e.isPinIconVisible ? (c(), g("img", {
          key: 3,
          class: C(["size-3.5 shrink-0 ms-auto dark:invert", e.isLocked ? "opacity-40" : ""]),
          src: I(MV),
          alt: ""
        }, null, 10, FV)) : k("", !0),
        e.headerMenuItems ? (c(), g("div", VV, [
          te(Sn, {
            "menu-align": "right",
            items: s.value
          }, {
            trigger: ve(({ triggerProps: h, isOpen: m }) => [
              v("button", Oe({
                type: "button",
                "data-testid": "dropdown-trigger",
                class: "inline-flex min-h-6 min-w-6 cursor-pointer items-center justify-center rounded-(--border-border-radius-rounded-full) bg-white transition-colors duration-300 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-royalblue focus-visible:ring-offset-2 dark:bg-(--colors-background-black-default)",
                "aria-label": e.menuAriaLabel
              }, h), [
                v("i", {
                  class: C([[l.value, { "rotate-180": m }], "inline-flex size-(--icon-size-sm) items-center justify-center text-(length:--icon-size-sm) leading-(--icon-size-sm) transition-transform duration-200 ease-in-out motion-reduce:transition-none"]),
                  "aria-hidden": "true"
                }, null, 2)
              ], 16, NV)
            ]),
            _: 1
          }, 8, ["items"])
        ], 512)) : k("", !0)
      ]),
      e.isResizable ? (c(), g("div", {
        key: 0,
        class: C(["absolute top-0 right-0 w-0.5 h-full cursor-col-resize z-10 bg-(--background-background-gray)/40 hover:bg-blue-400 hover:opacity-50 transition-colors", { "bg-blue-500 opacity-50": e.isResizingActive }]),
        onMousedown: b[1] || (b[1] = Ue((h) => i(h), ["stop", "prevent"])),
        onClick: b[2] || (b[2] = Ue(() => {
        }, ["stop", "prevent"]))
      }, null, 34)) : k("", !0)
    ], 10, DV));
  }
}), jV = /* @__PURE__ */ ye({
  __name: "DataTableHeader",
  props: {
    class: { type: [Boolean, null, String, Object, Array] },
    isSticky: { type: Boolean }
  },
  setup(e) {
    const n = e;
    return (t, a) => (c(), g("thead", {
      "data-slot": "table-header",
      class: C([
        "shadow-[0_1px_4px_0_rgba(0,0,0,0.1)] [&_tr:hover]:bg-transparent",
        n.isSticky && "sticky top-0 z-30 bg-white dark:bg-(--colors-background-black-default)",
        n.class
      ])
    }, [
      $e(t.$slots, "default")
    ], 2));
  }
});
/**
   * table-core
   *
   * Copyright (c) TanStack
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE.md file in the root directory of this source tree.
   *
   * @license MIT
   */
function Ca(e, n) {
  return typeof e == "function" ? e(n) : e;
}
function pn(e, n) {
  return (t) => {
    n.setState((a) => ({
      ...a,
      [e]: Ca(t, a[e])
    }));
  };
}
function bs(e) {
  return e instanceof Function;
}
function WV(e) {
  return Array.isArray(e) && e.every((n) => typeof n == "number");
}
function qV(e, n) {
  const t = [], a = (l) => {
    l.forEach((r) => {
      t.push(r);
      const o = n(r);
      o != null && o.length && a(o);
    });
  };
  return a(e), t;
}
function et(e, n, t) {
  let a = [], l;
  return (r) => {
    let o;
    t.key && t.debug && (o = Date.now());
    const i = e(r);
    if (!(i.length !== a.length || i.some((u, f) => a[f] !== u)))
      return l;
    a = i;
    let d;
    if (t.key && t.debug && (d = Date.now()), l = n(...i), t == null || t.onChange == null || t.onChange(l), t.key && t.debug && t != null && t.debug()) {
      const u = Math.round((Date.now() - o) * 100) / 100, f = Math.round((Date.now() - d) * 100) / 100, b = f / 16, h = (m, x) => {
        for (m = String(m); m.length < x; )
          m = " " + m;
        return m;
      };
      console.info(`%c⏱ ${h(f, 5)} /${h(u, 5)} ms`, `
            font-size: .6rem;
            font-weight: bold;
            color: hsl(${Math.max(0, Math.min(120 - 120 * b, 120))}deg 100% 31%);`, t == null ? void 0 : t.key);
    }
    return l;
  };
}
function tt(e, n, t, a) {
  return {
    debug: () => {
      var l;
      return (l = e == null ? void 0 : e.debugAll) != null ? l : e[n];
    },
    key: process.env.NODE_ENV === "development" && t,
    onChange: a
  };
}
function UV(e, n, t, a) {
  const l = () => {
    var o;
    return (o = r.getValue()) != null ? o : e.options.renderFallbackValue;
  }, r = {
    id: `${n.id}_${t.id}`,
    row: n,
    column: t,
    getValue: () => n.getValue(a),
    renderValue: l,
    getContext: et(() => [e, t, n, r], (o, i, s, d) => ({
      table: o,
      column: i,
      row: s,
      cell: d,
      getValue: d.getValue,
      renderValue: d.renderValue
    }), tt(e.options, "debugCells", "cell.getContext"))
  };
  return e._features.forEach((o) => {
    o.createCell == null || o.createCell(r, t, n, e);
  }, {}), r;
}
function GV(e, n, t, a) {
  var l, r;
  const i = {
    ...e._getDefaultColumnDef(),
    ...n
  }, s = i.accessorKey;
  let d = (l = (r = i.id) != null ? r : s ? typeof String.prototype.replaceAll == "function" ? s.replaceAll(".", "_") : s.replace(/\./g, "_") : void 0) != null ? l : typeof i.header == "string" ? i.header : void 0, u;
  if (i.accessorFn ? u = i.accessorFn : s && (s.includes(".") ? u = (b) => {
    let h = b;
    for (const x of s.split(".")) {
      var m;
      h = (m = h) == null ? void 0 : m[x], process.env.NODE_ENV !== "production" && h === void 0 && console.warn(`"${x}" in deeply nested key "${s}" returned undefined.`);
    }
    return h;
  } : u = (b) => b[i.accessorKey]), !d)
    throw process.env.NODE_ENV !== "production" ? new Error(i.accessorFn ? "Columns require an id when using an accessorFn" : "Columns require an id when using a non-string header") : new Error();
  let f = {
    id: `${String(d)}`,
    accessorFn: u,
    parent: a,
    depth: t,
    columnDef: i,
    columns: [],
    getFlatColumns: et(() => [!0], () => {
      var b;
      return [f, ...(b = f.columns) == null ? void 0 : b.flatMap((h) => h.getFlatColumns())];
    }, tt(e.options, "debugColumns", "column.getFlatColumns")),
    getLeafColumns: et(() => [e._getOrderColumnsFn()], (b) => {
      var h;
      if ((h = f.columns) != null && h.length) {
        let m = f.columns.flatMap((x) => x.getLeafColumns());
        return b(m);
      }
      return [f];
    }, tt(e.options, "debugColumns", "column.getLeafColumns"))
  };
  for (const b of e._features)
    b.createColumn == null || b.createColumn(f, e);
  return f;
}
const Jt = "debugHeaders";
function ub(e, n, t) {
  var a;
  let r = {
    id: (a = t.id) != null ? a : n.id,
    column: n,
    index: t.index,
    isPlaceholder: !!t.isPlaceholder,
    placeholderId: t.placeholderId,
    depth: t.depth,
    subHeaders: [],
    colSpan: 0,
    rowSpan: 0,
    headerGroup: null,
    getLeafHeaders: () => {
      const o = [], i = (s) => {
        s.subHeaders && s.subHeaders.length && s.subHeaders.map(i), o.push(s);
      };
      return i(r), o;
    },
    getContext: () => ({
      table: e,
      header: r,
      column: n
    })
  };
  return e._features.forEach((o) => {
    o.createHeader == null || o.createHeader(r, e);
  }), r;
}
const KV = {
  createTable: (e) => {
    e.getHeaderGroups = et(() => [e.getAllColumns(), e.getVisibleLeafColumns(), e.getState().columnPinning.left, e.getState().columnPinning.right], (n, t, a, l) => {
      var r, o;
      const i = (r = a == null ? void 0 : a.map((f) => t.find((b) => b.id === f)).filter(Boolean)) != null ? r : [], s = (o = l == null ? void 0 : l.map((f) => t.find((b) => b.id === f)).filter(Boolean)) != null ? o : [], d = t.filter((f) => !(a != null && a.includes(f.id)) && !(l != null && l.includes(f.id)));
      return Mo(n, [...i, ...d, ...s], e);
    }, tt(e.options, Jt, "getHeaderGroups")), e.getCenterHeaderGroups = et(() => [e.getAllColumns(), e.getVisibleLeafColumns(), e.getState().columnPinning.left, e.getState().columnPinning.right], (n, t, a, l) => (t = t.filter((r) => !(a != null && a.includes(r.id)) && !(l != null && l.includes(r.id))), Mo(n, t, e, "center")), tt(e.options, Jt, "getCenterHeaderGroups")), e.getLeftHeaderGroups = et(() => [e.getAllColumns(), e.getVisibleLeafColumns(), e.getState().columnPinning.left], (n, t, a) => {
      var l;
      const r = (l = a == null ? void 0 : a.map((o) => t.find((i) => i.id === o)).filter(Boolean)) != null ? l : [];
      return Mo(n, r, e, "left");
    }, tt(e.options, Jt, "getLeftHeaderGroups")), e.getRightHeaderGroups = et(() => [e.getAllColumns(), e.getVisibleLeafColumns(), e.getState().columnPinning.right], (n, t, a) => {
      var l;
      const r = (l = a == null ? void 0 : a.map((o) => t.find((i) => i.id === o)).filter(Boolean)) != null ? l : [];
      return Mo(n, r, e, "right");
    }, tt(e.options, Jt, "getRightHeaderGroups")), e.getFooterGroups = et(() => [e.getHeaderGroups()], (n) => [...n].reverse(), tt(e.options, Jt, "getFooterGroups")), e.getLeftFooterGroups = et(() => [e.getLeftHeaderGroups()], (n) => [...n].reverse(), tt(e.options, Jt, "getLeftFooterGroups")), e.getCenterFooterGroups = et(() => [e.getCenterHeaderGroups()], (n) => [...n].reverse(), tt(e.options, Jt, "getCenterFooterGroups")), e.getRightFooterGroups = et(() => [e.getRightHeaderGroups()], (n) => [...n].reverse(), tt(e.options, Jt, "getRightFooterGroups")), e.getFlatHeaders = et(() => [e.getHeaderGroups()], (n) => n.map((t) => t.headers).flat(), tt(e.options, Jt, "getFlatHeaders")), e.getLeftFlatHeaders = et(() => [e.getLeftHeaderGroups()], (n) => n.map((t) => t.headers).flat(), tt(e.options, Jt, "getLeftFlatHeaders")), e.getCenterFlatHeaders = et(() => [e.getCenterHeaderGroups()], (n) => n.map((t) => t.headers).flat(), tt(e.options, Jt, "getCenterFlatHeaders")), e.getRightFlatHeaders = et(() => [e.getRightHeaderGroups()], (n) => n.map((t) => t.headers).flat(), tt(e.options, Jt, "getRightFlatHeaders")), e.getCenterLeafHeaders = et(() => [e.getCenterFlatHeaders()], (n) => n.filter((t) => {
      var a;
      return !((a = t.subHeaders) != null && a.length);
    }), tt(e.options, Jt, "getCenterLeafHeaders")), e.getLeftLeafHeaders = et(() => [e.getLeftFlatHeaders()], (n) => n.filter((t) => {
      var a;
      return !((a = t.subHeaders) != null && a.length);
    }), tt(e.options, Jt, "getLeftLeafHeaders")), e.getRightLeafHeaders = et(() => [e.getRightFlatHeaders()], (n) => n.filter((t) => {
      var a;
      return !((a = t.subHeaders) != null && a.length);
    }), tt(e.options, Jt, "getRightLeafHeaders")), e.getLeafHeaders = et(() => [e.getLeftHeaderGroups(), e.getCenterHeaderGroups(), e.getRightHeaderGroups()], (n, t, a) => {
      var l, r, o, i, s, d;
      return [...(l = (r = n[0]) == null ? void 0 : r.headers) != null ? l : [], ...(o = (i = t[0]) == null ? void 0 : i.headers) != null ? o : [], ...(s = (d = a[0]) == null ? void 0 : d.headers) != null ? s : []].map((u) => u.getLeafHeaders()).flat();
    }, tt(e.options, Jt, "getLeafHeaders"));
  }
};
function Mo(e, n, t, a) {
  var l, r;
  let o = 0;
  const i = function(b, h) {
    h === void 0 && (h = 1), o = Math.max(o, h), b.filter((m) => m.getIsVisible()).forEach((m) => {
      var x;
      (x = m.columns) != null && x.length && i(m.columns, h + 1);
    }, 0);
  };
  i(e);
  let s = [];
  const d = (b, h) => {
    const m = {
      depth: h,
      id: [a, `${h}`].filter(Boolean).join("_"),
      headers: []
    }, x = [];
    b.forEach((y) => {
      const w = [...x].reverse()[0], S = y.column.depth === m.depth;
      let $, T = !1;
      if (S && y.column.parent ? $ = y.column.parent : ($ = y.column, T = !0), w && (w == null ? void 0 : w.column) === $)
        w.subHeaders.push(y);
      else {
        const L = ub(t, $, {
          id: [a, h, $.id, y == null ? void 0 : y.id].filter(Boolean).join("_"),
          isPlaceholder: T,
          placeholderId: T ? `${x.filter((A) => A.column === $).length}` : void 0,
          depth: h,
          index: x.length
        });
        L.subHeaders.push(y), x.push(L);
      }
      m.headers.push(y), y.headerGroup = m;
    }), s.push(m), h > 0 && d(x, h - 1);
  }, u = n.map((b, h) => ub(t, b, {
    depth: o,
    index: h
  }));
  d(u, o - 1), s.reverse();
  const f = (b) => b.filter((m) => m.column.getIsVisible()).map((m) => {
    let x = 0, y = 0, w = [0];
    m.subHeaders && m.subHeaders.length ? (w = [], f(m.subHeaders).forEach(($) => {
      let {
        colSpan: T,
        rowSpan: L
      } = $;
      x += T, w.push(L);
    })) : x = 1;
    const S = Math.min(...w);
    return y = y + S, m.colSpan = x, m.rowSpan = y, {
      colSpan: x,
      rowSpan: y
    };
  });
  return f((l = (r = s[0]) == null ? void 0 : r.headers) != null ? l : []), s;
}
const YV = (e, n, t, a, l, r, o) => {
  let i = {
    id: n,
    index: a,
    original: t,
    depth: l,
    parentId: o,
    _valuesCache: {},
    _uniqueValuesCache: {},
    getValue: (s) => {
      if (i._valuesCache.hasOwnProperty(s))
        return i._valuesCache[s];
      const d = e.getColumn(s);
      if (d != null && d.accessorFn)
        return i._valuesCache[s] = d.accessorFn(i.original, a), i._valuesCache[s];
    },
    getUniqueValues: (s) => {
      if (i._uniqueValuesCache.hasOwnProperty(s))
        return i._uniqueValuesCache[s];
      const d = e.getColumn(s);
      if (d != null && d.accessorFn)
        return d.columnDef.getUniqueValues ? (i._uniqueValuesCache[s] = d.columnDef.getUniqueValues(i.original, a), i._uniqueValuesCache[s]) : (i._uniqueValuesCache[s] = [i.getValue(s)], i._uniqueValuesCache[s]);
    },
    renderValue: (s) => {
      var d;
      return (d = i.getValue(s)) != null ? d : e.options.renderFallbackValue;
    },
    subRows: [],
    getLeafRows: () => qV(i.subRows, (s) => s.subRows),
    getParentRow: () => i.parentId ? e.getRow(i.parentId, !0) : void 0,
    getParentRows: () => {
      let s = [], d = i;
      for (; ; ) {
        const u = d.getParentRow();
        if (!u) break;
        s.push(u), d = u;
      }
      return s.reverse();
    },
    getAllCells: et(() => [e.getAllLeafColumns()], (s) => s.map((d) => UV(e, i, d, d.id)), tt(e.options, "debugRows", "getAllCells")),
    _getAllCellsByColumnId: et(() => [i.getAllCells()], (s) => s.reduce((d, u) => (d[u.column.id] = u, d), {}), tt(e.options, "debugRows", "getAllCellsByColumnId"))
  };
  for (let s = 0; s < e._features.length; s++) {
    const d = e._features[s];
    d == null || d.createRow == null || d.createRow(i, e);
  }
  return i;
}, JV = {
  createColumn: (e, n) => {
    e._getFacetedRowModel = n.options.getFacetedRowModel && n.options.getFacetedRowModel(n, e.id), e.getFacetedRowModel = () => e._getFacetedRowModel ? e._getFacetedRowModel() : n.getPreFilteredRowModel(), e._getFacetedUniqueValues = n.options.getFacetedUniqueValues && n.options.getFacetedUniqueValues(n, e.id), e.getFacetedUniqueValues = () => e._getFacetedUniqueValues ? e._getFacetedUniqueValues() : /* @__PURE__ */ new Map(), e._getFacetedMinMaxValues = n.options.getFacetedMinMaxValues && n.options.getFacetedMinMaxValues(n, e.id), e.getFacetedMinMaxValues = () => {
      if (e._getFacetedMinMaxValues)
        return e._getFacetedMinMaxValues();
    };
  }
}, jv = (e, n, t) => {
  var a, l;
  const r = t == null || (a = t.toString()) == null ? void 0 : a.toLowerCase();
  return !!(!((l = e.getValue(n)) == null || (l = l.toString()) == null || (l = l.toLowerCase()) == null) && l.includes(r));
};
jv.autoRemove = (e) => Pn(e);
const Wv = (e, n, t) => {
  var a;
  return !!(!((a = e.getValue(n)) == null || (a = a.toString()) == null) && a.includes(t));
};
Wv.autoRemove = (e) => Pn(e);
const qv = (e, n, t) => {
  var a;
  return ((a = e.getValue(n)) == null || (a = a.toString()) == null ? void 0 : a.toLowerCase()) === (t == null ? void 0 : t.toLowerCase());
};
qv.autoRemove = (e) => Pn(e);
const Uv = (e, n, t) => {
  var a;
  return (a = e.getValue(n)) == null ? void 0 : a.includes(t);
};
Uv.autoRemove = (e) => Pn(e);
const Gv = (e, n, t) => !t.some((a) => {
  var l;
  return !((l = e.getValue(n)) != null && l.includes(a));
});
Gv.autoRemove = (e) => Pn(e) || !(e != null && e.length);
const Kv = (e, n, t) => t.some((a) => {
  var l;
  return (l = e.getValue(n)) == null ? void 0 : l.includes(a);
});
Kv.autoRemove = (e) => Pn(e) || !(e != null && e.length);
const Yv = (e, n, t) => e.getValue(n) === t;
Yv.autoRemove = (e) => Pn(e);
const Jv = (e, n, t) => e.getValue(n) == t;
Jv.autoRemove = (e) => Pn(e);
const zc = (e, n, t) => {
  let [a, l] = t;
  const r = e.getValue(n);
  return r >= a && r <= l;
};
zc.resolveFilterValue = (e) => {
  let [n, t] = e, a = typeof n != "number" ? parseFloat(n) : n, l = typeof t != "number" ? parseFloat(t) : t, r = n === null || Number.isNaN(a) ? -1 / 0 : a, o = t === null || Number.isNaN(l) ? 1 / 0 : l;
  if (r > o) {
    const i = r;
    r = o, o = i;
  }
  return [r, o];
};
zc.autoRemove = (e) => Pn(e) || Pn(e[0]) && Pn(e[1]);
const ra = {
  includesString: jv,
  includesStringSensitive: Wv,
  equalsString: qv,
  arrIncludes: Uv,
  arrIncludesAll: Gv,
  arrIncludesSome: Kv,
  equals: Yv,
  weakEquals: Jv,
  inNumberRange: zc
};
function Pn(e) {
  return e == null || e === "";
}
const ZV = {
  getDefaultColumnDef: () => ({
    filterFn: "auto"
  }),
  getInitialState: (e) => ({
    columnFilters: [],
    ...e
  }),
  getDefaultOptions: (e) => ({
    onColumnFiltersChange: pn("columnFilters", e),
    filterFromLeafRows: !1,
    maxLeafRowFilterDepth: 100
  }),
  createColumn: (e, n) => {
    e.getAutoFilterFn = () => {
      const t = n.getCoreRowModel().flatRows[0], a = t == null ? void 0 : t.getValue(e.id);
      return typeof a == "string" ? ra.includesString : typeof a == "number" ? ra.inNumberRange : typeof a == "boolean" || a !== null && typeof a == "object" ? ra.equals : Array.isArray(a) ? ra.arrIncludes : ra.weakEquals;
    }, e.getFilterFn = () => {
      var t, a;
      return bs(e.columnDef.filterFn) ? e.columnDef.filterFn : e.columnDef.filterFn === "auto" ? e.getAutoFilterFn() : (
        // @ts-ignore
        (t = (a = n.options.filterFns) == null ? void 0 : a[e.columnDef.filterFn]) != null ? t : ra[e.columnDef.filterFn]
      );
    }, e.getCanFilter = () => {
      var t, a, l;
      return ((t = e.columnDef.enableColumnFilter) != null ? t : !0) && ((a = n.options.enableColumnFilters) != null ? a : !0) && ((l = n.options.enableFilters) != null ? l : !0) && !!e.accessorFn;
    }, e.getIsFiltered = () => e.getFilterIndex() > -1, e.getFilterValue = () => {
      var t;
      return (t = n.getState().columnFilters) == null || (t = t.find((a) => a.id === e.id)) == null ? void 0 : t.value;
    }, e.getFilterIndex = () => {
      var t, a;
      return (t = (a = n.getState().columnFilters) == null ? void 0 : a.findIndex((l) => l.id === e.id)) != null ? t : -1;
    }, e.setFilterValue = (t) => {
      n.setColumnFilters((a) => {
        const l = e.getFilterFn(), r = a == null ? void 0 : a.find((u) => u.id === e.id), o = Ca(t, r ? r.value : void 0);
        if (cb(l, o, e)) {
          var i;
          return (i = a == null ? void 0 : a.filter((u) => u.id !== e.id)) != null ? i : [];
        }
        const s = {
          id: e.id,
          value: o
        };
        if (r) {
          var d;
          return (d = a == null ? void 0 : a.map((u) => u.id === e.id ? s : u)) != null ? d : [];
        }
        return a != null && a.length ? [...a, s] : [s];
      });
    };
  },
  createRow: (e, n) => {
    e.columnFilters = {}, e.columnFiltersMeta = {};
  },
  createTable: (e) => {
    e.setColumnFilters = (n) => {
      const t = e.getAllLeafColumns(), a = (l) => {
        var r;
        return (r = Ca(n, l)) == null ? void 0 : r.filter((o) => {
          const i = t.find((s) => s.id === o.id);
          if (i) {
            const s = i.getFilterFn();
            if (cb(s, o.value, i))
              return !1;
          }
          return !0;
        });
      };
      e.options.onColumnFiltersChange == null || e.options.onColumnFiltersChange(a);
    }, e.resetColumnFilters = (n) => {
      var t, a;
      e.setColumnFilters(n ? [] : (t = (a = e.initialState) == null ? void 0 : a.columnFilters) != null ? t : []);
    }, e.getPreFilteredRowModel = () => e.getCoreRowModel(), e.getFilteredRowModel = () => (!e._getFilteredRowModel && e.options.getFilteredRowModel && (e._getFilteredRowModel = e.options.getFilteredRowModel(e)), e.options.manualFiltering || !e._getFilteredRowModel ? e.getPreFilteredRowModel() : e._getFilteredRowModel());
  }
};
function cb(e, n, t) {
  return (e && e.autoRemove ? e.autoRemove(n, t) : !1) || typeof n > "u" || typeof n == "string" && !n;
}
const XV = (e, n, t) => t.reduce((a, l) => {
  const r = l.getValue(e);
  return a + (typeof r == "number" ? r : 0);
}, 0), QV = (e, n, t) => {
  let a;
  return t.forEach((l) => {
    const r = l.getValue(e);
    r != null && (a > r || a === void 0 && r >= r) && (a = r);
  }), a;
}, _V = (e, n, t) => {
  let a;
  return t.forEach((l) => {
    const r = l.getValue(e);
    r != null && (a < r || a === void 0 && r >= r) && (a = r);
  }), a;
}, eN = (e, n, t) => {
  let a, l;
  return t.forEach((r) => {
    const o = r.getValue(e);
    o != null && (a === void 0 ? o >= o && (a = l = o) : (a > o && (a = o), l < o && (l = o)));
  }), [a, l];
}, tN = (e, n) => {
  let t = 0, a = 0;
  if (n.forEach((l) => {
    let r = l.getValue(e);
    r != null && (r = +r) >= r && (++t, a += r);
  }), t) return a / t;
}, nN = (e, n) => {
  if (!n.length)
    return;
  const t = n.map((r) => r.getValue(e));
  if (!WV(t))
    return;
  if (t.length === 1)
    return t[0];
  const a = Math.floor(t.length / 2), l = t.sort((r, o) => r - o);
  return t.length % 2 !== 0 ? l[a] : (l[a - 1] + l[a]) / 2;
}, aN = (e, n) => Array.from(new Set(n.map((t) => t.getValue(e))).values()), lN = (e, n) => new Set(n.map((t) => t.getValue(e))).size, rN = (e, n) => n.length, cd = {
  sum: XV,
  min: QV,
  max: _V,
  extent: eN,
  mean: tN,
  median: nN,
  unique: aN,
  uniqueCount: lN,
  count: rN
}, oN = {
  getDefaultColumnDef: () => ({
    aggregatedCell: (e) => {
      var n, t;
      return (n = (t = e.getValue()) == null || t.toString == null ? void 0 : t.toString()) != null ? n : null;
    },
    aggregationFn: "auto"
  }),
  getInitialState: (e) => ({
    grouping: [],
    ...e
  }),
  getDefaultOptions: (e) => ({
    onGroupingChange: pn("grouping", e),
    groupedColumnMode: "reorder"
  }),
  createColumn: (e, n) => {
    e.toggleGrouping = () => {
      n.setGrouping((t) => t != null && t.includes(e.id) ? t.filter((a) => a !== e.id) : [...t ?? [], e.id]);
    }, e.getCanGroup = () => {
      var t, a;
      return ((t = e.columnDef.enableGrouping) != null ? t : !0) && ((a = n.options.enableGrouping) != null ? a : !0) && (!!e.accessorFn || !!e.columnDef.getGroupingValue);
    }, e.getIsGrouped = () => {
      var t;
      return (t = n.getState().grouping) == null ? void 0 : t.includes(e.id);
    }, e.getGroupedIndex = () => {
      var t;
      return (t = n.getState().grouping) == null ? void 0 : t.indexOf(e.id);
    }, e.getToggleGroupingHandler = () => {
      const t = e.getCanGroup();
      return () => {
        t && e.toggleGrouping();
      };
    }, e.getAutoAggregationFn = () => {
      const t = n.getCoreRowModel().flatRows[0], a = t == null ? void 0 : t.getValue(e.id);
      if (typeof a == "number")
        return cd.sum;
      if (Object.prototype.toString.call(a) === "[object Date]")
        return cd.extent;
    }, e.getAggregationFn = () => {
      var t, a;
      if (!e)
        throw new Error();
      return bs(e.columnDef.aggregationFn) ? e.columnDef.aggregationFn : e.columnDef.aggregationFn === "auto" ? e.getAutoAggregationFn() : (t = (a = n.options.aggregationFns) == null ? void 0 : a[e.columnDef.aggregationFn]) != null ? t : cd[e.columnDef.aggregationFn];
    };
  },
  createTable: (e) => {
    e.setGrouping = (n) => e.options.onGroupingChange == null ? void 0 : e.options.onGroupingChange(n), e.resetGrouping = (n) => {
      var t, a;
      e.setGrouping(n ? [] : (t = (a = e.initialState) == null ? void 0 : a.grouping) != null ? t : []);
    }, e.getPreGroupedRowModel = () => e.getFilteredRowModel(), e.getGroupedRowModel = () => (!e._getGroupedRowModel && e.options.getGroupedRowModel && (e._getGroupedRowModel = e.options.getGroupedRowModel(e)), e.options.manualGrouping || !e._getGroupedRowModel ? e.getPreGroupedRowModel() : e._getGroupedRowModel());
  },
  createRow: (e, n) => {
    e.getIsGrouped = () => !!e.groupingColumnId, e.getGroupingValue = (t) => {
      if (e._groupingValuesCache.hasOwnProperty(t))
        return e._groupingValuesCache[t];
      const a = n.getColumn(t);
      return a != null && a.columnDef.getGroupingValue ? (e._groupingValuesCache[t] = a.columnDef.getGroupingValue(e.original), e._groupingValuesCache[t]) : e.getValue(t);
    }, e._groupingValuesCache = {};
  },
  createCell: (e, n, t, a) => {
    e.getIsGrouped = () => n.getIsGrouped() && n.id === t.groupingColumnId, e.getIsPlaceholder = () => !e.getIsGrouped() && n.getIsGrouped(), e.getIsAggregated = () => {
      var l;
      return !e.getIsGrouped() && !e.getIsPlaceholder() && !!((l = t.subRows) != null && l.length);
    };
  }
};
function iN(e, n, t) {
  if (!(n != null && n.length) || !t)
    return e;
  const a = e.filter((r) => !n.includes(r.id));
  return t === "remove" ? a : [...n.map((r) => e.find((o) => o.id === r)).filter(Boolean), ...a];
}
const sN = {
  getInitialState: (e) => ({
    columnOrder: [],
    ...e
  }),
  getDefaultOptions: (e) => ({
    onColumnOrderChange: pn("columnOrder", e)
  }),
  createColumn: (e, n) => {
    e.getIndex = et((t) => [Br(n, t)], (t) => t.findIndex((a) => a.id === e.id), tt(n.options, "debugColumns", "getIndex")), e.getIsFirstColumn = (t) => {
      var a;
      return ((a = Br(n, t)[0]) == null ? void 0 : a.id) === e.id;
    }, e.getIsLastColumn = (t) => {
      var a;
      const l = Br(n, t);
      return ((a = l[l.length - 1]) == null ? void 0 : a.id) === e.id;
    };
  },
  createTable: (e) => {
    e.setColumnOrder = (n) => e.options.onColumnOrderChange == null ? void 0 : e.options.onColumnOrderChange(n), e.resetColumnOrder = (n) => {
      var t;
      e.setColumnOrder(n ? [] : (t = e.initialState.columnOrder) != null ? t : []);
    }, e._getOrderColumnsFn = et(() => [e.getState().columnOrder, e.getState().grouping, e.options.groupedColumnMode], (n, t, a) => (l) => {
      let r = [];
      if (!(n != null && n.length))
        r = l;
      else {
        const o = [...n], i = [...l];
        for (; i.length && o.length; ) {
          const s = o.shift(), d = i.findIndex((u) => u.id === s);
          d > -1 && r.push(i.splice(d, 1)[0]);
        }
        r = [...r, ...i];
      }
      return iN(r, t, a);
    }, tt(e.options, "debugTable", "_getOrderColumnsFn"));
  }
}, fd = () => ({
  left: [],
  right: []
}), dN = {
  getInitialState: (e) => ({
    columnPinning: fd(),
    ...e
  }),
  getDefaultOptions: (e) => ({
    onColumnPinningChange: pn("columnPinning", e)
  }),
  createColumn: (e, n) => {
    e.pin = (t) => {
      const a = e.getLeafColumns().map((l) => l.id).filter(Boolean);
      n.setColumnPinning((l) => {
        var r, o;
        if (t === "right") {
          var i, s;
          return {
            left: ((i = l == null ? void 0 : l.left) != null ? i : []).filter((f) => !(a != null && a.includes(f))),
            right: [...((s = l == null ? void 0 : l.right) != null ? s : []).filter((f) => !(a != null && a.includes(f))), ...a]
          };
        }
        if (t === "left") {
          var d, u;
          return {
            left: [...((d = l == null ? void 0 : l.left) != null ? d : []).filter((f) => !(a != null && a.includes(f))), ...a],
            right: ((u = l == null ? void 0 : l.right) != null ? u : []).filter((f) => !(a != null && a.includes(f)))
          };
        }
        return {
          left: ((r = l == null ? void 0 : l.left) != null ? r : []).filter((f) => !(a != null && a.includes(f))),
          right: ((o = l == null ? void 0 : l.right) != null ? o : []).filter((f) => !(a != null && a.includes(f)))
        };
      });
    }, e.getCanPin = () => e.getLeafColumns().some((a) => {
      var l, r, o;
      return ((l = a.columnDef.enablePinning) != null ? l : !0) && ((r = (o = n.options.enableColumnPinning) != null ? o : n.options.enablePinning) != null ? r : !0);
    }), e.getIsPinned = () => {
      const t = e.getLeafColumns().map((i) => i.id), {
        left: a,
        right: l
      } = n.getState().columnPinning, r = t.some((i) => a == null ? void 0 : a.includes(i)), o = t.some((i) => l == null ? void 0 : l.includes(i));
      return r ? "left" : o ? "right" : !1;
    }, e.getPinnedIndex = () => {
      var t, a;
      const l = e.getIsPinned();
      return l ? (t = (a = n.getState().columnPinning) == null || (a = a[l]) == null ? void 0 : a.indexOf(e.id)) != null ? t : -1 : 0;
    };
  },
  createRow: (e, n) => {
    e.getCenterVisibleCells = et(() => [e._getAllVisibleCells(), n.getState().columnPinning.left, n.getState().columnPinning.right], (t, a, l) => {
      const r = [...a ?? [], ...l ?? []];
      return t.filter((o) => !r.includes(o.column.id));
    }, tt(n.options, "debugRows", "getCenterVisibleCells")), e.getLeftVisibleCells = et(() => [e._getAllVisibleCells(), n.getState().columnPinning.left], (t, a) => (a ?? []).map((r) => t.find((o) => o.column.id === r)).filter(Boolean).map((r) => ({
      ...r,
      position: "left"
    })), tt(n.options, "debugRows", "getLeftVisibleCells")), e.getRightVisibleCells = et(() => [e._getAllVisibleCells(), n.getState().columnPinning.right], (t, a) => (a ?? []).map((r) => t.find((o) => o.column.id === r)).filter(Boolean).map((r) => ({
      ...r,
      position: "right"
    })), tt(n.options, "debugRows", "getRightVisibleCells"));
  },
  createTable: (e) => {
    e.setColumnPinning = (n) => e.options.onColumnPinningChange == null ? void 0 : e.options.onColumnPinningChange(n), e.resetColumnPinning = (n) => {
      var t, a;
      return e.setColumnPinning(n ? fd() : (t = (a = e.initialState) == null ? void 0 : a.columnPinning) != null ? t : fd());
    }, e.getIsSomeColumnsPinned = (n) => {
      var t;
      const a = e.getState().columnPinning;
      if (!n) {
        var l, r;
        return !!((l = a.left) != null && l.length || (r = a.right) != null && r.length);
      }
      return !!((t = a[n]) != null && t.length);
    }, e.getLeftLeafColumns = et(() => [e.getAllLeafColumns(), e.getState().columnPinning.left], (n, t) => (t ?? []).map((a) => n.find((l) => l.id === a)).filter(Boolean), tt(e.options, "debugColumns", "getLeftLeafColumns")), e.getRightLeafColumns = et(() => [e.getAllLeafColumns(), e.getState().columnPinning.right], (n, t) => (t ?? []).map((a) => n.find((l) => l.id === a)).filter(Boolean), tt(e.options, "debugColumns", "getRightLeafColumns")), e.getCenterLeafColumns = et(() => [e.getAllLeafColumns(), e.getState().columnPinning.left, e.getState().columnPinning.right], (n, t, a) => {
      const l = [...t ?? [], ...a ?? []];
      return n.filter((r) => !l.includes(r.id));
    }, tt(e.options, "debugColumns", "getCenterLeafColumns"));
  }
};
function uN(e) {
  return e || (typeof document < "u" ? document : null);
}
const Do = {
  size: 150,
  minSize: 20,
  maxSize: Number.MAX_SAFE_INTEGER
}, hd = () => ({
  startOffset: null,
  startSize: null,
  deltaOffset: null,
  deltaPercentage: null,
  isResizingColumn: !1,
  columnSizingStart: []
}), cN = {
  getDefaultColumnDef: () => Do,
  getInitialState: (e) => ({
    columnSizing: {},
    columnSizingInfo: hd(),
    ...e
  }),
  getDefaultOptions: (e) => ({
    columnResizeMode: "onEnd",
    columnResizeDirection: "ltr",
    onColumnSizingChange: pn("columnSizing", e),
    onColumnSizingInfoChange: pn("columnSizingInfo", e)
  }),
  createColumn: (e, n) => {
    e.getSize = () => {
      var t, a, l;
      const r = n.getState().columnSizing[e.id];
      return Math.min(Math.max((t = e.columnDef.minSize) != null ? t : Do.minSize, (a = r ?? e.columnDef.size) != null ? a : Do.size), (l = e.columnDef.maxSize) != null ? l : Do.maxSize);
    }, e.getStart = et((t) => [t, Br(n, t), n.getState().columnSizing], (t, a) => a.slice(0, e.getIndex(t)).reduce((l, r) => l + r.getSize(), 0), tt(n.options, "debugColumns", "getStart")), e.getAfter = et((t) => [t, Br(n, t), n.getState().columnSizing], (t, a) => a.slice(e.getIndex(t) + 1).reduce((l, r) => l + r.getSize(), 0), tt(n.options, "debugColumns", "getAfter")), e.resetSize = () => {
      n.setColumnSizing((t) => {
        let {
          [e.id]: a,
          ...l
        } = t;
        return l;
      });
    }, e.getCanResize = () => {
      var t, a;
      return ((t = e.columnDef.enableResizing) != null ? t : !0) && ((a = n.options.enableColumnResizing) != null ? a : !0);
    }, e.getIsResizing = () => n.getState().columnSizingInfo.isResizingColumn === e.id;
  },
  createHeader: (e, n) => {
    e.getSize = () => {
      let t = 0;
      const a = (l) => {
        if (l.subHeaders.length)
          l.subHeaders.forEach(a);
        else {
          var r;
          t += (r = l.column.getSize()) != null ? r : 0;
        }
      };
      return a(e), t;
    }, e.getStart = () => {
      if (e.index > 0) {
        const t = e.headerGroup.headers[e.index - 1];
        return t.getStart() + t.getSize();
      }
      return 0;
    }, e.getResizeHandler = (t) => {
      const a = n.getColumn(e.column.id), l = a == null ? void 0 : a.getCanResize();
      return (r) => {
        if (!a || !l || (r.persist == null || r.persist(), bd(r) && r.touches && r.touches.length > 1))
          return;
        const o = e.getSize(), i = e ? e.getLeafHeaders().map((w) => [w.column.id, w.column.getSize()]) : [[a.id, a.getSize()]], s = bd(r) ? Math.round(r.touches[0].clientX) : r.clientX, d = {}, u = (w, S) => {
          typeof S == "number" && (n.setColumnSizingInfo(($) => {
            var T, L;
            const A = n.options.columnResizeDirection === "rtl" ? -1 : 1, R = (S - ((T = $ == null ? void 0 : $.startOffset) != null ? T : 0)) * A, z = Math.max(R / ((L = $ == null ? void 0 : $.startSize) != null ? L : 0), -0.999999);
            return $.columnSizingStart.forEach((D) => {
              let [V, Y] = D;
              d[V] = Math.round(Math.max(Y + Y * z, 0) * 100) / 100;
            }), {
              ...$,
              deltaOffset: R,
              deltaPercentage: z
            };
          }), (n.options.columnResizeMode === "onChange" || w === "end") && n.setColumnSizing(($) => ({
            ...$,
            ...d
          })));
        }, f = (w) => u("move", w), b = (w) => {
          u("end", w), n.setColumnSizingInfo((S) => ({
            ...S,
            isResizingColumn: !1,
            startOffset: null,
            startSize: null,
            deltaOffset: null,
            deltaPercentage: null,
            columnSizingStart: []
          }));
        }, h = uN(t), m = {
          moveHandler: (w) => f(w.clientX),
          upHandler: (w) => {
            h == null || h.removeEventListener("mousemove", m.moveHandler), h == null || h.removeEventListener("mouseup", m.upHandler), b(w.clientX);
          }
        }, x = {
          moveHandler: (w) => (w.cancelable && (w.preventDefault(), w.stopPropagation()), f(w.touches[0].clientX), !1),
          upHandler: (w) => {
            var S;
            h == null || h.removeEventListener("touchmove", x.moveHandler), h == null || h.removeEventListener("touchend", x.upHandler), w.cancelable && (w.preventDefault(), w.stopPropagation()), b((S = w.touches[0]) == null ? void 0 : S.clientX);
          }
        }, y = fN() ? {
          passive: !1
        } : !1;
        bd(r) ? (h == null || h.addEventListener("touchmove", x.moveHandler, y), h == null || h.addEventListener("touchend", x.upHandler, y)) : (h == null || h.addEventListener("mousemove", m.moveHandler, y), h == null || h.addEventListener("mouseup", m.upHandler, y)), n.setColumnSizingInfo((w) => ({
          ...w,
          startOffset: s,
          startSize: o,
          deltaOffset: 0,
          deltaPercentage: 0,
          columnSizingStart: i,
          isResizingColumn: a.id
        }));
      };
    };
  },
  createTable: (e) => {
    e.setColumnSizing = (n) => e.options.onColumnSizingChange == null ? void 0 : e.options.onColumnSizingChange(n), e.setColumnSizingInfo = (n) => e.options.onColumnSizingInfoChange == null ? void 0 : e.options.onColumnSizingInfoChange(n), e.resetColumnSizing = (n) => {
      var t;
      e.setColumnSizing(n ? {} : (t = e.initialState.columnSizing) != null ? t : {});
    }, e.resetHeaderSizeInfo = (n) => {
      var t;
      e.setColumnSizingInfo(n ? hd() : (t = e.initialState.columnSizingInfo) != null ? t : hd());
    }, e.getTotalSize = () => {
      var n, t;
      return (n = (t = e.getHeaderGroups()[0]) == null ? void 0 : t.headers.reduce((a, l) => a + l.getSize(), 0)) != null ? n : 0;
    }, e.getLeftTotalSize = () => {
      var n, t;
      return (n = (t = e.getLeftHeaderGroups()[0]) == null ? void 0 : t.headers.reduce((a, l) => a + l.getSize(), 0)) != null ? n : 0;
    }, e.getCenterTotalSize = () => {
      var n, t;
      return (n = (t = e.getCenterHeaderGroups()[0]) == null ? void 0 : t.headers.reduce((a, l) => a + l.getSize(), 0)) != null ? n : 0;
    }, e.getRightTotalSize = () => {
      var n, t;
      return (n = (t = e.getRightHeaderGroups()[0]) == null ? void 0 : t.headers.reduce((a, l) => a + l.getSize(), 0)) != null ? n : 0;
    };
  }
};
let zo = null;
function fN() {
  if (typeof zo == "boolean") return zo;
  let e = !1;
  try {
    const n = {
      get passive() {
        return e = !0, !1;
      }
    }, t = () => {
    };
    window.addEventListener("test", t, n), window.removeEventListener("test", t);
  } catch {
    e = !1;
  }
  return zo = e, zo;
}
function bd(e) {
  return e.type === "touchstart";
}
const hN = {
  getInitialState: (e) => ({
    columnVisibility: {},
    ...e
  }),
  getDefaultOptions: (e) => ({
    onColumnVisibilityChange: pn("columnVisibility", e)
  }),
  createColumn: (e, n) => {
    e.toggleVisibility = (t) => {
      e.getCanHide() && n.setColumnVisibility((a) => ({
        ...a,
        [e.id]: t ?? !e.getIsVisible()
      }));
    }, e.getIsVisible = () => {
      var t, a;
      const l = e.columns;
      return (t = l.length ? l.some((r) => r.getIsVisible()) : (a = n.getState().columnVisibility) == null ? void 0 : a[e.id]) != null ? t : !0;
    }, e.getCanHide = () => {
      var t, a;
      return ((t = e.columnDef.enableHiding) != null ? t : !0) && ((a = n.options.enableHiding) != null ? a : !0);
    }, e.getToggleVisibilityHandler = () => (t) => {
      e.toggleVisibility == null || e.toggleVisibility(t.target.checked);
    };
  },
  createRow: (e, n) => {
    e._getAllVisibleCells = et(() => [e.getAllCells(), n.getState().columnVisibility], (t) => t.filter((a) => a.column.getIsVisible()), tt(n.options, "debugRows", "_getAllVisibleCells")), e.getVisibleCells = et(() => [e.getLeftVisibleCells(), e.getCenterVisibleCells(), e.getRightVisibleCells()], (t, a, l) => [...t, ...a, ...l], tt(n.options, "debugRows", "getVisibleCells"));
  },
  createTable: (e) => {
    const n = (t, a) => et(() => [a(), a().filter((l) => l.getIsVisible()).map((l) => l.id).join("_")], (l) => l.filter((r) => r.getIsVisible == null ? void 0 : r.getIsVisible()), tt(e.options, "debugColumns", t));
    e.getVisibleFlatColumns = n("getVisibleFlatColumns", () => e.getAllFlatColumns()), e.getVisibleLeafColumns = n("getVisibleLeafColumns", () => e.getAllLeafColumns()), e.getLeftVisibleLeafColumns = n("getLeftVisibleLeafColumns", () => e.getLeftLeafColumns()), e.getRightVisibleLeafColumns = n("getRightVisibleLeafColumns", () => e.getRightLeafColumns()), e.getCenterVisibleLeafColumns = n("getCenterVisibleLeafColumns", () => e.getCenterLeafColumns()), e.setColumnVisibility = (t) => e.options.onColumnVisibilityChange == null ? void 0 : e.options.onColumnVisibilityChange(t), e.resetColumnVisibility = (t) => {
      var a;
      e.setColumnVisibility(t ? {} : (a = e.initialState.columnVisibility) != null ? a : {});
    }, e.toggleAllColumnsVisible = (t) => {
      var a;
      t = (a = t) != null ? a : !e.getIsAllColumnsVisible(), e.setColumnVisibility(e.getAllLeafColumns().reduce((l, r) => ({
        ...l,
        [r.id]: t || !(r.getCanHide != null && r.getCanHide())
      }), {}));
    }, e.getIsAllColumnsVisible = () => !e.getAllLeafColumns().some((t) => !(t.getIsVisible != null && t.getIsVisible())), e.getIsSomeColumnsVisible = () => e.getAllLeafColumns().some((t) => t.getIsVisible == null ? void 0 : t.getIsVisible()), e.getToggleAllColumnsVisibilityHandler = () => (t) => {
      var a;
      e.toggleAllColumnsVisible((a = t.target) == null ? void 0 : a.checked);
    };
  }
};
function Br(e, n) {
  return n ? n === "center" ? e.getCenterVisibleLeafColumns() : n === "left" ? e.getLeftVisibleLeafColumns() : e.getRightVisibleLeafColumns() : e.getVisibleLeafColumns();
}
const bN = {
  createTable: (e) => {
    e._getGlobalFacetedRowModel = e.options.getFacetedRowModel && e.options.getFacetedRowModel(e, "__global__"), e.getGlobalFacetedRowModel = () => e.options.manualFiltering || !e._getGlobalFacetedRowModel ? e.getPreFilteredRowModel() : e._getGlobalFacetedRowModel(), e._getGlobalFacetedUniqueValues = e.options.getFacetedUniqueValues && e.options.getFacetedUniqueValues(e, "__global__"), e.getGlobalFacetedUniqueValues = () => e._getGlobalFacetedUniqueValues ? e._getGlobalFacetedUniqueValues() : /* @__PURE__ */ new Map(), e._getGlobalFacetedMinMaxValues = e.options.getFacetedMinMaxValues && e.options.getFacetedMinMaxValues(e, "__global__"), e.getGlobalFacetedMinMaxValues = () => {
      if (e._getGlobalFacetedMinMaxValues)
        return e._getGlobalFacetedMinMaxValues();
    };
  }
}, gN = {
  getInitialState: (e) => ({
    globalFilter: void 0,
    ...e
  }),
  getDefaultOptions: (e) => ({
    onGlobalFilterChange: pn("globalFilter", e),
    globalFilterFn: "auto",
    getColumnCanGlobalFilter: (n) => {
      var t;
      const a = (t = e.getCoreRowModel().flatRows[0]) == null || (t = t._getAllCellsByColumnId()[n.id]) == null ? void 0 : t.getValue();
      return typeof a == "string" || typeof a == "number";
    }
  }),
  createColumn: (e, n) => {
    e.getCanGlobalFilter = () => {
      var t, a, l, r;
      return ((t = e.columnDef.enableGlobalFilter) != null ? t : !0) && ((a = n.options.enableGlobalFilter) != null ? a : !0) && ((l = n.options.enableFilters) != null ? l : !0) && ((r = n.options.getColumnCanGlobalFilter == null ? void 0 : n.options.getColumnCanGlobalFilter(e)) != null ? r : !0) && !!e.accessorFn;
    };
  },
  createTable: (e) => {
    e.getGlobalAutoFilterFn = () => ra.includesString, e.getGlobalFilterFn = () => {
      var n, t;
      const {
        globalFilterFn: a
      } = e.options;
      return bs(a) ? a : a === "auto" ? e.getGlobalAutoFilterFn() : (n = (t = e.options.filterFns) == null ? void 0 : t[a]) != null ? n : ra[a];
    }, e.setGlobalFilter = (n) => {
      e.options.onGlobalFilterChange == null || e.options.onGlobalFilterChange(n);
    }, e.resetGlobalFilter = (n) => {
      e.setGlobalFilter(n ? void 0 : e.initialState.globalFilter);
    };
  }
}, pN = {
  getInitialState: (e) => ({
    expanded: {},
    ...e
  }),
  getDefaultOptions: (e) => ({
    onExpandedChange: pn("expanded", e),
    paginateExpandedRows: !0
  }),
  createTable: (e) => {
    let n = !1, t = !1;
    e._autoResetExpanded = () => {
      var a, l;
      if (!n) {
        e._queue(() => {
          n = !0;
        });
        return;
      }
      if ((a = (l = e.options.autoResetAll) != null ? l : e.options.autoResetExpanded) != null ? a : !e.options.manualExpanding) {
        if (t) return;
        t = !0, e._queue(() => {
          e.resetExpanded(), t = !1;
        });
      }
    }, e.setExpanded = (a) => e.options.onExpandedChange == null ? void 0 : e.options.onExpandedChange(a), e.toggleAllRowsExpanded = (a) => {
      a ?? !e.getIsAllRowsExpanded() ? e.setExpanded(!0) : e.setExpanded({});
    }, e.resetExpanded = (a) => {
      var l, r;
      e.setExpanded(a ? {} : (l = (r = e.initialState) == null ? void 0 : r.expanded) != null ? l : {});
    }, e.getCanSomeRowsExpand = () => e.getPrePaginationRowModel().flatRows.some((a) => a.getCanExpand()), e.getToggleAllRowsExpandedHandler = () => (a) => {
      a.persist == null || a.persist(), e.toggleAllRowsExpanded();
    }, e.getIsSomeRowsExpanded = () => {
      const a = e.getState().expanded;
      return a === !0 || Object.values(a).some(Boolean);
    }, e.getIsAllRowsExpanded = () => {
      const a = e.getState().expanded;
      return typeof a == "boolean" ? a === !0 : !(!Object.keys(a).length || e.getRowModel().flatRows.some((l) => !l.getIsExpanded()));
    }, e.getExpandedDepth = () => {
      let a = 0;
      return (e.getState().expanded === !0 ? Object.keys(e.getRowModel().rowsById) : Object.keys(e.getState().expanded)).forEach((r) => {
        const o = r.split(".");
        a = Math.max(a, o.length);
      }), a;
    }, e.getPreExpandedRowModel = () => e.getSortedRowModel(), e.getExpandedRowModel = () => (!e._getExpandedRowModel && e.options.getExpandedRowModel && (e._getExpandedRowModel = e.options.getExpandedRowModel(e)), e.options.manualExpanding || !e._getExpandedRowModel ? e.getPreExpandedRowModel() : e._getExpandedRowModel());
  },
  createRow: (e, n) => {
    e.toggleExpanded = (t) => {
      n.setExpanded((a) => {
        var l;
        const r = a === !0 ? !0 : !!(a != null && a[e.id]);
        let o = {};
        if (a === !0 ? Object.keys(n.getRowModel().rowsById).forEach((i) => {
          o[i] = !0;
        }) : o = a, t = (l = t) != null ? l : !r, !r && t)
          return {
            ...o,
            [e.id]: !0
          };
        if (r && !t) {
          const {
            [e.id]: i,
            ...s
          } = o;
          return s;
        }
        return a;
      });
    }, e.getIsExpanded = () => {
      var t;
      const a = n.getState().expanded;
      return !!((t = n.options.getIsRowExpanded == null ? void 0 : n.options.getIsRowExpanded(e)) != null ? t : a === !0 || a != null && a[e.id]);
    }, e.getCanExpand = () => {
      var t, a, l;
      return (t = n.options.getRowCanExpand == null ? void 0 : n.options.getRowCanExpand(e)) != null ? t : ((a = n.options.enableExpanding) != null ? a : !0) && !!((l = e.subRows) != null && l.length);
    }, e.getIsAllParentsExpanded = () => {
      let t = !0, a = e;
      for (; t && a.parentId; )
        a = n.getRow(a.parentId, !0), t = a.getIsExpanded();
      return t;
    }, e.getToggleExpandedHandler = () => {
      const t = e.getCanExpand();
      return () => {
        t && e.toggleExpanded();
      };
    };
  }
}, bu = 0, gu = 10, gd = () => ({
  pageIndex: bu,
  pageSize: gu
}), mN = {
  getInitialState: (e) => ({
    ...e,
    pagination: {
      ...gd(),
      ...e == null ? void 0 : e.pagination
    }
  }),
  getDefaultOptions: (e) => ({
    onPaginationChange: pn("pagination", e)
  }),
  createTable: (e) => {
    let n = !1, t = !1;
    e._autoResetPageIndex = () => {
      var a, l;
      if (!n) {
        e._queue(() => {
          n = !0;
        });
        return;
      }
      if ((a = (l = e.options.autoResetAll) != null ? l : e.options.autoResetPageIndex) != null ? a : !e.options.manualPagination) {
        if (t) return;
        t = !0, e._queue(() => {
          e.resetPageIndex(), t = !1;
        });
      }
    }, e.setPagination = (a) => {
      const l = (r) => Ca(a, r);
      return e.options.onPaginationChange == null ? void 0 : e.options.onPaginationChange(l);
    }, e.resetPagination = (a) => {
      var l;
      e.setPagination(a ? gd() : (l = e.initialState.pagination) != null ? l : gd());
    }, e.setPageIndex = (a) => {
      e.setPagination((l) => {
        let r = Ca(a, l.pageIndex);
        const o = typeof e.options.pageCount > "u" || e.options.pageCount === -1 ? Number.MAX_SAFE_INTEGER : e.options.pageCount - 1;
        return r = Math.max(0, Math.min(r, o)), {
          ...l,
          pageIndex: r
        };
      });
    }, e.resetPageIndex = (a) => {
      var l, r;
      e.setPageIndex(a ? bu : (l = (r = e.initialState) == null || (r = r.pagination) == null ? void 0 : r.pageIndex) != null ? l : bu);
    }, e.resetPageSize = (a) => {
      var l, r;
      e.setPageSize(a ? gu : (l = (r = e.initialState) == null || (r = r.pagination) == null ? void 0 : r.pageSize) != null ? l : gu);
    }, e.setPageSize = (a) => {
      e.setPagination((l) => {
        const r = Math.max(1, Ca(a, l.pageSize)), o = l.pageSize * l.pageIndex, i = Math.floor(o / r);
        return {
          ...l,
          pageIndex: i,
          pageSize: r
        };
      });
    }, e.setPageCount = (a) => e.setPagination((l) => {
      var r;
      let o = Ca(a, (r = e.options.pageCount) != null ? r : -1);
      return typeof o == "number" && (o = Math.max(-1, o)), {
        ...l,
        pageCount: o
      };
    }), e.getPageOptions = et(() => [e.getPageCount()], (a) => {
      let l = [];
      return a && a > 0 && (l = [...new Array(a)].fill(null).map((r, o) => o)), l;
    }, tt(e.options, "debugTable", "getPageOptions")), e.getCanPreviousPage = () => e.getState().pagination.pageIndex > 0, e.getCanNextPage = () => {
      const {
        pageIndex: a
      } = e.getState().pagination, l = e.getPageCount();
      return l === -1 ? !0 : l === 0 ? !1 : a < l - 1;
    }, e.previousPage = () => e.setPageIndex((a) => a - 1), e.nextPage = () => e.setPageIndex((a) => a + 1), e.firstPage = () => e.setPageIndex(0), e.lastPage = () => e.setPageIndex(e.getPageCount() - 1), e.getPrePaginationRowModel = () => e.getExpandedRowModel(), e.getPaginationRowModel = () => (!e._getPaginationRowModel && e.options.getPaginationRowModel && (e._getPaginationRowModel = e.options.getPaginationRowModel(e)), e.options.manualPagination || !e._getPaginationRowModel ? e.getPrePaginationRowModel() : e._getPaginationRowModel()), e.getPageCount = () => {
      var a;
      return (a = e.options.pageCount) != null ? a : Math.ceil(e.getRowCount() / e.getState().pagination.pageSize);
    }, e.getRowCount = () => {
      var a;
      return (a = e.options.rowCount) != null ? a : e.getPrePaginationRowModel().rows.length;
    };
  }
}, pd = () => ({
  top: [],
  bottom: []
}), vN = {
  getInitialState: (e) => ({
    rowPinning: pd(),
    ...e
  }),
  getDefaultOptions: (e) => ({
    onRowPinningChange: pn("rowPinning", e)
  }),
  createRow: (e, n) => {
    e.pin = (t, a, l) => {
      const r = a ? e.getLeafRows().map((s) => {
        let {
          id: d
        } = s;
        return d;
      }) : [], o = l ? e.getParentRows().map((s) => {
        let {
          id: d
        } = s;
        return d;
      }) : [], i = /* @__PURE__ */ new Set([...o, e.id, ...r]);
      n.setRowPinning((s) => {
        var d, u;
        if (t === "bottom") {
          var f, b;
          return {
            top: ((f = s == null ? void 0 : s.top) != null ? f : []).filter((x) => !(i != null && i.has(x))),
            bottom: [...((b = s == null ? void 0 : s.bottom) != null ? b : []).filter((x) => !(i != null && i.has(x))), ...Array.from(i)]
          };
        }
        if (t === "top") {
          var h, m;
          return {
            top: [...((h = s == null ? void 0 : s.top) != null ? h : []).filter((x) => !(i != null && i.has(x))), ...Array.from(i)],
            bottom: ((m = s == null ? void 0 : s.bottom) != null ? m : []).filter((x) => !(i != null && i.has(x)))
          };
        }
        return {
          top: ((d = s == null ? void 0 : s.top) != null ? d : []).filter((x) => !(i != null && i.has(x))),
          bottom: ((u = s == null ? void 0 : s.bottom) != null ? u : []).filter((x) => !(i != null && i.has(x)))
        };
      });
    }, e.getCanPin = () => {
      var t;
      const {
        enableRowPinning: a,
        enablePinning: l
      } = n.options;
      return typeof a == "function" ? a(e) : (t = a ?? l) != null ? t : !0;
    }, e.getIsPinned = () => {
      const t = [e.id], {
        top: a,
        bottom: l
      } = n.getState().rowPinning, r = t.some((i) => a == null ? void 0 : a.includes(i)), o = t.some((i) => l == null ? void 0 : l.includes(i));
      return r ? "top" : o ? "bottom" : !1;
    }, e.getPinnedIndex = () => {
      var t, a;
      const l = e.getIsPinned();
      if (!l) return -1;
      const r = (t = l === "top" ? n.getTopRows() : n.getBottomRows()) == null ? void 0 : t.map((o) => {
        let {
          id: i
        } = o;
        return i;
      });
      return (a = r == null ? void 0 : r.indexOf(e.id)) != null ? a : -1;
    };
  },
  createTable: (e) => {
    e.setRowPinning = (n) => e.options.onRowPinningChange == null ? void 0 : e.options.onRowPinningChange(n), e.resetRowPinning = (n) => {
      var t, a;
      return e.setRowPinning(n ? pd() : (t = (a = e.initialState) == null ? void 0 : a.rowPinning) != null ? t : pd());
    }, e.getIsSomeRowsPinned = (n) => {
      var t;
      const a = e.getState().rowPinning;
      if (!n) {
        var l, r;
        return !!((l = a.top) != null && l.length || (r = a.bottom) != null && r.length);
      }
      return !!((t = a[n]) != null && t.length);
    }, e._getPinnedRows = (n, t, a) => {
      var l;
      return ((l = e.options.keepPinnedRows) == null || l ? (
        //get all rows that are pinned even if they would not be otherwise visible
        //account for expanded parent rows, but not pagination or filtering
        (t ?? []).map((o) => {
          const i = e.getRow(o, !0);
          return i.getIsAllParentsExpanded() ? i : null;
        })
      ) : (
        //else get only visible rows that are pinned
        (t ?? []).map((o) => n.find((i) => i.id === o))
      )).filter(Boolean).map((o) => ({
        ...o,
        position: a
      }));
    }, e.getTopRows = et(() => [e.getRowModel().rows, e.getState().rowPinning.top], (n, t) => e._getPinnedRows(n, t, "top"), tt(e.options, "debugRows", "getTopRows")), e.getBottomRows = et(() => [e.getRowModel().rows, e.getState().rowPinning.bottom], (n, t) => e._getPinnedRows(n, t, "bottom"), tt(e.options, "debugRows", "getBottomRows")), e.getCenterRows = et(() => [e.getRowModel().rows, e.getState().rowPinning.top, e.getState().rowPinning.bottom], (n, t, a) => {
      const l = /* @__PURE__ */ new Set([...t ?? [], ...a ?? []]);
      return n.filter((r) => !l.has(r.id));
    }, tt(e.options, "debugRows", "getCenterRows"));
  }
}, xN = {
  getInitialState: (e) => ({
    rowSelection: {},
    ...e
  }),
  getDefaultOptions: (e) => ({
    onRowSelectionChange: pn("rowSelection", e),
    enableRowSelection: !0,
    enableMultiRowSelection: !0,
    enableSubRowSelection: !0
    // enableGroupingRowSelection: false,
    // isAdditiveSelectEvent: (e: unknown) => !!e.metaKey,
    // isInclusiveSelectEvent: (e: unknown) => !!e.shiftKey,
  }),
  createTable: (e) => {
    e.setRowSelection = (n) => e.options.onRowSelectionChange == null ? void 0 : e.options.onRowSelectionChange(n), e.resetRowSelection = (n) => {
      var t;
      return e.setRowSelection(n ? {} : (t = e.initialState.rowSelection) != null ? t : {});
    }, e.toggleAllRowsSelected = (n) => {
      e.setRowSelection((t) => {
        n = typeof n < "u" ? n : !e.getIsAllRowsSelected();
        const a = {
          ...t
        }, l = e.getPreGroupedRowModel().flatRows;
        return n ? l.forEach((r) => {
          r.getCanSelect() && (a[r.id] = !0);
        }) : l.forEach((r) => {
          delete a[r.id];
        }), a;
      });
    }, e.toggleAllPageRowsSelected = (n) => e.setRowSelection((t) => {
      const a = typeof n < "u" ? n : !e.getIsAllPageRowsSelected(), l = {
        ...t
      };
      return e.getRowModel().rows.forEach((r) => {
        pu(l, r.id, a, !0, e);
      }), l;
    }), e.getPreSelectedRowModel = () => e.getCoreRowModel(), e.getSelectedRowModel = et(() => [e.getState().rowSelection, e.getCoreRowModel()], (n, t) => Object.keys(n).length ? md(e, t) : {
      rows: [],
      flatRows: [],
      rowsById: {}
    }, tt(e.options, "debugTable", "getSelectedRowModel")), e.getFilteredSelectedRowModel = et(() => [e.getState().rowSelection, e.getFilteredRowModel()], (n, t) => Object.keys(n).length ? md(e, t) : {
      rows: [],
      flatRows: [],
      rowsById: {}
    }, tt(e.options, "debugTable", "getFilteredSelectedRowModel")), e.getGroupedSelectedRowModel = et(() => [e.getState().rowSelection, e.getSortedRowModel()], (n, t) => Object.keys(n).length ? md(e, t) : {
      rows: [],
      flatRows: [],
      rowsById: {}
    }, tt(e.options, "debugTable", "getGroupedSelectedRowModel")), e.getIsAllRowsSelected = () => {
      const n = e.getFilteredRowModel().flatRows, {
        rowSelection: t
      } = e.getState();
      let a = !!(n.length && Object.keys(t).length);
      return a && n.some((l) => l.getCanSelect() && !t[l.id]) && (a = !1), a;
    }, e.getIsAllPageRowsSelected = () => {
      const n = e.getPaginationRowModel().flatRows.filter((l) => l.getCanSelect()), {
        rowSelection: t
      } = e.getState();
      let a = !!n.length;
      return a && n.some((l) => !t[l.id]) && (a = !1), a;
    }, e.getIsSomeRowsSelected = () => {
      var n;
      const t = Object.keys((n = e.getState().rowSelection) != null ? n : {}).length;
      return t > 0 && t < e.getFilteredRowModel().flatRows.length;
    }, e.getIsSomePageRowsSelected = () => {
      const n = e.getPaginationRowModel().flatRows;
      return e.getIsAllPageRowsSelected() ? !1 : n.filter((t) => t.getCanSelect()).some((t) => t.getIsSelected() || t.getIsSomeSelected());
    }, e.getToggleAllRowsSelectedHandler = () => (n) => {
      e.toggleAllRowsSelected(n.target.checked);
    }, e.getToggleAllPageRowsSelectedHandler = () => (n) => {
      e.toggleAllPageRowsSelected(n.target.checked);
    };
  },
  createRow: (e, n) => {
    e.toggleSelected = (t, a) => {
      const l = e.getIsSelected();
      n.setRowSelection((r) => {
        var o;
        if (t = typeof t < "u" ? t : !l, e.getCanSelect() && l === t)
          return r;
        const i = {
          ...r
        };
        return pu(i, e.id, t, (o = a == null ? void 0 : a.selectChildren) != null ? o : !0, n), i;
      });
    }, e.getIsSelected = () => {
      const {
        rowSelection: t
      } = n.getState();
      return Oc(e, t);
    }, e.getIsSomeSelected = () => {
      const {
        rowSelection: t
      } = n.getState();
      return mu(e, t) === "some";
    }, e.getIsAllSubRowsSelected = () => {
      const {
        rowSelection: t
      } = n.getState();
      return mu(e, t) === "all";
    }, e.getCanSelect = () => {
      var t;
      return typeof n.options.enableRowSelection == "function" ? n.options.enableRowSelection(e) : (t = n.options.enableRowSelection) != null ? t : !0;
    }, e.getCanSelectSubRows = () => {
      var t;
      return typeof n.options.enableSubRowSelection == "function" ? n.options.enableSubRowSelection(e) : (t = n.options.enableSubRowSelection) != null ? t : !0;
    }, e.getCanMultiSelect = () => {
      var t;
      return typeof n.options.enableMultiRowSelection == "function" ? n.options.enableMultiRowSelection(e) : (t = n.options.enableMultiRowSelection) != null ? t : !0;
    }, e.getToggleSelectedHandler = () => {
      const t = e.getCanSelect();
      return (a) => {
        var l;
        t && e.toggleSelected((l = a.target) == null ? void 0 : l.checked);
      };
    };
  }
}, pu = (e, n, t, a, l) => {
  var r;
  const o = l.getRow(n, !0);
  t ? (o.getCanMultiSelect() || Object.keys(e).forEach((i) => delete e[i]), o.getCanSelect() && (e[n] = !0)) : delete e[n], a && (r = o.subRows) != null && r.length && o.getCanSelectSubRows() && o.subRows.forEach((i) => pu(e, i.id, t, a, l));
};
function md(e, n) {
  const t = e.getState().rowSelection, a = [], l = {}, r = function(o, i) {
    return o.map((s) => {
      var d;
      const u = Oc(s, t);
      if (u && (a.push(s), l[s.id] = s), (d = s.subRows) != null && d.length && (s = {
        ...s,
        subRows: r(s.subRows)
      }), u)
        return s;
    }).filter(Boolean);
  };
  return {
    rows: r(n.rows),
    flatRows: a,
    rowsById: l
  };
}
function Oc(e, n) {
  var t;
  return (t = n[e.id]) != null ? t : !1;
}
function mu(e, n, t) {
  var a;
  if (!((a = e.subRows) != null && a.length)) return !1;
  let l = !0, r = !1;
  return e.subRows.forEach((o) => {
    if (!(r && !l) && (o.getCanSelect() && (Oc(o, n) ? r = !0 : l = !1), o.subRows && o.subRows.length)) {
      const i = mu(o, n);
      i === "all" ? r = !0 : (i === "some" && (r = !0), l = !1);
    }
  }), l ? "all" : r ? "some" : !1;
}
const vu = /([0-9]+)/gm, yN = (e, n, t) => Zv(Oa(e.getValue(t)).toLowerCase(), Oa(n.getValue(t)).toLowerCase()), kN = (e, n, t) => Zv(Oa(e.getValue(t)), Oa(n.getValue(t))), wN = (e, n, t) => Pc(Oa(e.getValue(t)).toLowerCase(), Oa(n.getValue(t)).toLowerCase()), CN = (e, n, t) => Pc(Oa(e.getValue(t)), Oa(n.getValue(t))), SN = (e, n, t) => {
  const a = e.getValue(t), l = n.getValue(t);
  return a > l ? 1 : a < l ? -1 : 0;
}, $N = (e, n, t) => Pc(e.getValue(t), n.getValue(t));
function Pc(e, n) {
  return e === n ? 0 : e > n ? 1 : -1;
}
function Oa(e) {
  return typeof e == "number" ? isNaN(e) || e === 1 / 0 || e === -1 / 0 ? "" : String(e) : typeof e == "string" ? e : "";
}
function Zv(e, n) {
  const t = e.split(vu).filter(Boolean), a = n.split(vu).filter(Boolean);
  for (; t.length && a.length; ) {
    const l = t.shift(), r = a.shift(), o = parseInt(l, 10), i = parseInt(r, 10), s = [o, i].sort();
    if (isNaN(s[0])) {
      if (l > r)
        return 1;
      if (r > l)
        return -1;
      continue;
    }
    if (isNaN(s[1]))
      return isNaN(o) ? -1 : 1;
    if (o > i)
      return 1;
    if (i > o)
      return -1;
  }
  return t.length - a.length;
}
const sr = {
  alphanumeric: yN,
  alphanumericCaseSensitive: kN,
  text: wN,
  textCaseSensitive: CN,
  datetime: SN,
  basic: $N
}, IN = {
  getInitialState: (e) => ({
    sorting: [],
    ...e
  }),
  getDefaultColumnDef: () => ({
    sortingFn: "auto",
    sortUndefined: 1
  }),
  getDefaultOptions: (e) => ({
    onSortingChange: pn("sorting", e),
    isMultiSortEvent: (n) => n.shiftKey
  }),
  createColumn: (e, n) => {
    e.getAutoSortingFn = () => {
      const t = n.getFilteredRowModel().flatRows.slice(10);
      let a = !1;
      for (const l of t) {
        const r = l == null ? void 0 : l.getValue(e.id);
        if (Object.prototype.toString.call(r) === "[object Date]")
          return sr.datetime;
        if (typeof r == "string" && (a = !0, r.split(vu).length > 1))
          return sr.alphanumeric;
      }
      return a ? sr.text : sr.basic;
    }, e.getAutoSortDir = () => {
      const t = n.getFilteredRowModel().flatRows[0];
      return typeof (t == null ? void 0 : t.getValue(e.id)) == "string" ? "asc" : "desc";
    }, e.getSortingFn = () => {
      var t, a;
      if (!e)
        throw new Error();
      return bs(e.columnDef.sortingFn) ? e.columnDef.sortingFn : e.columnDef.sortingFn === "auto" ? e.getAutoSortingFn() : (t = (a = n.options.sortingFns) == null ? void 0 : a[e.columnDef.sortingFn]) != null ? t : sr[e.columnDef.sortingFn];
    }, e.toggleSorting = (t, a) => {
      const l = e.getNextSortingOrder(), r = typeof t < "u" && t !== null;
      n.setSorting((o) => {
        const i = o == null ? void 0 : o.find((h) => h.id === e.id), s = o == null ? void 0 : o.findIndex((h) => h.id === e.id);
        let d = [], u, f = r ? t : l === "desc";
        if (o != null && o.length && e.getCanMultiSort() && a ? i ? u = "toggle" : u = "add" : o != null && o.length && s !== o.length - 1 ? u = "replace" : i ? u = "toggle" : u = "replace", u === "toggle" && (r || l || (u = "remove")), u === "add") {
          var b;
          d = [...o, {
            id: e.id,
            desc: f
          }], d.splice(0, d.length - ((b = n.options.maxMultiSortColCount) != null ? b : Number.MAX_SAFE_INTEGER));
        } else u === "toggle" ? d = o.map((h) => h.id === e.id ? {
          ...h,
          desc: f
        } : h) : u === "remove" ? d = o.filter((h) => h.id !== e.id) : d = [{
          id: e.id,
          desc: f
        }];
        return d;
      });
    }, e.getFirstSortDir = () => {
      var t, a;
      return ((t = (a = e.columnDef.sortDescFirst) != null ? a : n.options.sortDescFirst) != null ? t : e.getAutoSortDir() === "desc") ? "desc" : "asc";
    }, e.getNextSortingOrder = (t) => {
      var a, l;
      const r = e.getFirstSortDir(), o = e.getIsSorted();
      return o ? o !== r && ((a = n.options.enableSortingRemoval) == null || a) && // If enableSortRemove, enable in general
      (!(t && (l = n.options.enableMultiRemove) != null) || l) ? !1 : o === "desc" ? "asc" : "desc" : r;
    }, e.getCanSort = () => {
      var t, a;
      return ((t = e.columnDef.enableSorting) != null ? t : !0) && ((a = n.options.enableSorting) != null ? a : !0) && !!e.accessorFn;
    }, e.getCanMultiSort = () => {
      var t, a;
      return (t = (a = e.columnDef.enableMultiSort) != null ? a : n.options.enableMultiSort) != null ? t : !!e.accessorFn;
    }, e.getIsSorted = () => {
      var t;
      const a = (t = n.getState().sorting) == null ? void 0 : t.find((l) => l.id === e.id);
      return a ? a.desc ? "desc" : "asc" : !1;
    }, e.getSortIndex = () => {
      var t, a;
      return (t = (a = n.getState().sorting) == null ? void 0 : a.findIndex((l) => l.id === e.id)) != null ? t : -1;
    }, e.clearSorting = () => {
      n.setSorting((t) => t != null && t.length ? t.filter((a) => a.id !== e.id) : []);
    }, e.getToggleSortingHandler = () => {
      const t = e.getCanSort();
      return (a) => {
        t && (a.persist == null || a.persist(), e.toggleSorting == null || e.toggleSorting(void 0, e.getCanMultiSort() ? n.options.isMultiSortEvent == null ? void 0 : n.options.isMultiSortEvent(a) : !1));
      };
    };
  },
  createTable: (e) => {
    e.setSorting = (n) => e.options.onSortingChange == null ? void 0 : e.options.onSortingChange(n), e.resetSorting = (n) => {
      var t, a;
      e.setSorting(n ? [] : (t = (a = e.initialState) == null ? void 0 : a.sorting) != null ? t : []);
    }, e.getPreSortedRowModel = () => e.getGroupedRowModel(), e.getSortedRowModel = () => (!e._getSortedRowModel && e.options.getSortedRowModel && (e._getSortedRowModel = e.options.getSortedRowModel(e)), e.options.manualSorting || !e._getSortedRowModel ? e.getPreSortedRowModel() : e._getSortedRowModel());
  }
}, TN = [
  KV,
  hN,
  sN,
  dN,
  JV,
  ZV,
  bN,
  //depends on ColumnFaceting
  gN,
  //depends on ColumnFiltering
  IN,
  oN,
  //depends on RowSorting
  pN,
  mN,
  vN,
  xN,
  cN
];
function LN(e) {
  var n, t;
  process.env.NODE_ENV !== "production" && (e.debugAll || e.debugTable) && console.info("Creating Table Instance...");
  const a = [...TN, ...(n = e._features) != null ? n : []];
  let l = {
    _features: a
  };
  const r = l._features.reduce((b, h) => Object.assign(b, h.getDefaultOptions == null ? void 0 : h.getDefaultOptions(l)), {}), o = (b) => l.options.mergeOptions ? l.options.mergeOptions(r, b) : {
    ...r,
    ...b
  };
  let s = {
    ...{},
    ...(t = e.initialState) != null ? t : {}
  };
  l._features.forEach((b) => {
    var h;
    s = (h = b.getInitialState == null ? void 0 : b.getInitialState(s)) != null ? h : s;
  });
  const d = [];
  let u = !1;
  const f = {
    _features: a,
    options: {
      ...r,
      ...e
    },
    initialState: s,
    _queue: (b) => {
      d.push(b), u || (u = !0, Promise.resolve().then(() => {
        for (; d.length; )
          d.shift()();
        u = !1;
      }).catch((h) => setTimeout(() => {
        throw h;
      })));
    },
    reset: () => {
      l.setState(l.initialState);
    },
    setOptions: (b) => {
      const h = Ca(b, l.options);
      l.options = o(h);
    },
    getState: () => l.options.state,
    setState: (b) => {
      l.options.onStateChange == null || l.options.onStateChange(b);
    },
    _getRowId: (b, h, m) => {
      var x;
      return (x = l.options.getRowId == null ? void 0 : l.options.getRowId(b, h, m)) != null ? x : `${m ? [m.id, h].join(".") : h}`;
    },
    getCoreRowModel: () => (l._getCoreRowModel || (l._getCoreRowModel = l.options.getCoreRowModel(l)), l._getCoreRowModel()),
    // The final calls start at the bottom of the model,
    // expanded rows, which then work their way up
    getRowModel: () => l.getPaginationRowModel(),
    //in next version, we should just pass in the row model as the optional 2nd arg
    getRow: (b, h) => {
      let m = (h ? l.getPrePaginationRowModel() : l.getRowModel()).rowsById[b];
      if (!m && (m = l.getCoreRowModel().rowsById[b], !m))
        throw process.env.NODE_ENV !== "production" ? new Error(`getRow could not find row with ID: ${b}`) : new Error();
      return m;
    },
    _getDefaultColumnDef: et(() => [l.options.defaultColumn], (b) => {
      var h;
      return b = (h = b) != null ? h : {}, {
        header: (m) => {
          const x = m.header.column.columnDef;
          return x.accessorKey ? x.accessorKey : x.accessorFn ? x.id : null;
        },
        // footer: props => props.header.column.id,
        cell: (m) => {
          var x, y;
          return (x = (y = m.renderValue()) == null || y.toString == null ? void 0 : y.toString()) != null ? x : null;
        },
        ...l._features.reduce((m, x) => Object.assign(m, x.getDefaultColumnDef == null ? void 0 : x.getDefaultColumnDef()), {}),
        ...b
      };
    }, tt(e, "debugColumns", "_getDefaultColumnDef")),
    _getColumnDefs: () => l.options.columns,
    getAllColumns: et(() => [l._getColumnDefs()], (b) => {
      const h = function(m, x, y) {
        return y === void 0 && (y = 0), m.map((w) => {
          const S = GV(l, w, y, x), $ = w;
          return S.columns = $.columns ? h($.columns, S, y + 1) : [], S;
        });
      };
      return h(b);
    }, tt(e, "debugColumns", "getAllColumns")),
    getAllFlatColumns: et(() => [l.getAllColumns()], (b) => b.flatMap((h) => h.getFlatColumns()), tt(e, "debugColumns", "getAllFlatColumns")),
    _getAllFlatColumnsById: et(() => [l.getAllFlatColumns()], (b) => b.reduce((h, m) => (h[m.id] = m, h), {}), tt(e, "debugColumns", "getAllFlatColumnsById")),
    getAllLeafColumns: et(() => [l.getAllColumns(), l._getOrderColumnsFn()], (b, h) => {
      let m = b.flatMap((x) => x.getLeafColumns());
      return h(m);
    }, tt(e, "debugColumns", "getAllLeafColumns")),
    getColumn: (b) => {
      const h = l._getAllFlatColumnsById()[b];
      return process.env.NODE_ENV !== "production" && !h && console.error(`[Table] Column with id '${b}' does not exist.`), h;
    }
  };
  Object.assign(l, f);
  for (let b = 0; b < l._features.length; b++) {
    const h = l._features[b];
    h == null || h.createTable == null || h.createTable(l);
  }
  return l;
}
function EN() {
  return (e) => et(() => [e.options.data], (n) => {
    const t = {
      rows: [],
      flatRows: [],
      rowsById: {}
    }, a = function(l, r, o) {
      r === void 0 && (r = 0);
      const i = [];
      for (let d = 0; d < l.length; d++) {
        const u = YV(e, e._getRowId(l[d], d, o), l[d], d, r, void 0, o == null ? void 0 : o.id);
        if (t.flatRows.push(u), t.rowsById[u.id] = u, i.push(u), e.options.getSubRows) {
          var s;
          u.originalSubRows = e.options.getSubRows(l[d], d), (s = u.originalSubRows) != null && s.length && (u.subRows = a(u.originalSubRows, r + 1, u));
        }
      }
      return i;
    };
    return t.rows = a(n), t;
  }, tt(e.options, "debugTable", "getRowModel", () => e._autoResetPageIndex()));
}
/**
   * vue-table
   *
   * Copyright (c) TanStack
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE.md file in the root directory of this source tree.
   *
   * @license MIT
   */
function Oo() {
  return !0;
}
const AN = Symbol("merge-proxy"), RN = {
  get(e, n, t) {
    return n === AN ? t : e.get(n);
  },
  has(e, n) {
    return e.has(n);
  },
  set: Oo,
  deleteProperty: Oo,
  getOwnPropertyDescriptor(e, n) {
    return {
      configurable: !0,
      enumerable: !0,
      get() {
        return e.get(n);
      },
      set: Oo,
      deleteProperty: Oo
    };
  },
  ownKeys(e) {
    return e.keys();
  }
};
function vd(e) {
  return "value" in e ? e.value : e;
}
function br() {
  for (var e = arguments.length, n = new Array(e), t = 0; t < e; t++)
    n[t] = arguments[t];
  return new Proxy({
    get(a) {
      for (let l = n.length - 1; l >= 0; l--) {
        const r = vd(n[l])[a];
        if (r !== void 0) return r;
      }
    },
    has(a) {
      for (let l = n.length - 1; l >= 0; l--)
        if (a in vd(n[l])) return !0;
      return !1;
    },
    keys() {
      const a = [];
      for (let l = 0; l < n.length; l++) a.push(...Object.keys(vd(n[l])));
      return [...Array.from(new Set(a))];
    }
  }, RN);
}
const fb = ye({
  props: ["render", "props"],
  setup: (e) => () => typeof e.render == "function" || typeof e.render == "object" ? Gn(e.render, e.props) : e.render
});
function hb(e) {
  return br(e, {
    data: I(e.data)
  });
}
function BN(e) {
  const n = Ho(e.data), t = br({
    state: {},
    // Dummy state
    onStateChange: () => {
    },
    // noop
    renderFallbackValue: null,
    mergeOptions(r, o) {
      return n ? {
        ...r,
        ...o
      } : br(r, o);
    }
  }, n ? hb(e) : e), a = LN(t);
  if (n) {
    const r = Qr(e.data);
    Ie(r, () => {
      a.setState((o) => ({
        ...o,
        data: r.value
      }));
    }, {
      immediate: !0
    });
  }
  const l = E(a.initialState);
  return Db(() => {
    a.setOptions((r) => {
      var o;
      const i = new Proxy({}, {
        get: (s, d) => l.value[d]
      });
      return br(r, n ? hb(e) : e, {
        // merge the initialState and `options.state`
        // create a new proxy on each `setOptions` call
        // and get the value from state on each property access
        state: br(i, (o = e.state) != null ? o : {}),
        // Similarly, we'll maintain both our internal state and any user-provided
        // state.
        onStateChange: (s) => {
          s instanceof Function ? l.value = s(l.value) : l.value = s, e.onStateChange == null || e.onStateChange(s);
        }
      });
    });
  }), a;
}
const MN = "data:image/svg+xml,%3csvg%20viewBox='0%200%2024%2024'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M2.21232%2014.0601C1.91928%2012.6755%201.93115%2011.2743%202.21316%209.94038C3.32308%2010.0711%204.29187%209.7035%204.60865%208.93871C4.92544%208.17392%204.50032%207.22896%203.62307%206.53655C4.3669%205.3939%205.34931%204.39471%206.53554%203.62289C7.228%204.50059%208.17324%204.92601%208.93822%204.60914C9.7032%204.29227%2010.0708%203.32308%209.93979%202.21281C11.3243%201.91977%2012.7255%201.93164%2014.0595%202.21364C13.9288%203.32356%2014.2964%204.29235%2015.0612%204.60914C15.8259%204.92593%2016.7709%204.5008%2017.4633%203.62356C18.606%204.36739%2019.6052%205.3498%2020.377%206.53602C19.4993%207.22849%2019.0739%208.17373%2019.3907%208.93871C19.7076%209.70369%2020.6768%2010.0713%2021.7871%209.94028C22.0801%2011.3248%2022.0682%2012.726%2021.7862%2014.06C20.6763%2013.9293%2019.7075%2014.2969%2019.3907%2015.0616C19.0739%2015.8264%2019.4991%2016.7714%2020.3763%2017.4638C19.6325%2018.6064%2018.6501%2019.6056%2017.4638%2020.3775C16.7714%2019.4998%2015.8261%2019.0743%2015.0612%2019.3912C14.2962%2019.7081%2013.9286%2020.6773%2014.0596%2021.7875C12.675%2022.0806%2011.2738%2022.0687%209.93989%2021.7867C10.0706%2020.6768%209.70301%2019.708%208.93822%2019.3912C8.17343%2019.0744%207.22848%2019.4995%206.53606%2020.3768C5.39341%2019.633%204.39422%2018.6506%203.62241%2017.4643C4.5001%2016.7719%204.92552%2015.8266%204.60865%2015.0616C4.29179%2014.2967%203.32259%2013.9291%202.21232%2014.0601ZM3.99975%2012.2104C5.09956%2012.5148%206.00718%2013.2117%206.45641%2014.2963C6.90564%2015.3808%206.75667%2016.5154%206.19421%2017.5083C6.29077%2017.61%206.38998%2017.7092%206.49173%2017.8056C7.4846%2017.2432%208.61912%2017.0943%209.70359%2017.5435C10.7881%2017.9927%2011.485%2018.9002%2011.7894%2019.9999C11.9295%2020.0037%2012.0697%2020.0038%2012.2099%2020.0001C12.5143%2018.9003%2013.2112%2017.9927%2014.2958%2017.5435C15.3803%2017.0942%2016.5149%2017.2432%2017.5078%2017.8057C17.6096%2017.7091%2017.7087%2017.6099%2017.8051%2017.5081C17.2427%2016.5153%2017.0938%2015.3807%2017.543%2014.2963C17.9922%2013.2118%2018.8997%2012.5149%2019.9994%2012.2105C20.0032%2012.0704%2020.0033%2011.9301%2019.9996%2011.7899C18.8998%2011.4856%2017.9922%2010.7886%2017.543%209.70407C17.0937%208.61953%2017.2427%207.48494%2017.8052%206.49204C17.7086%206.39031%2017.6094%206.2912%2017.5076%206.19479C16.5148%206.75717%2015.3803%206.9061%2014.2958%206.4569C13.2113%206.0077%2012.5144%205.10016%2012.21%204.00044C12.0699%203.99666%2011.9297%203.99659%2011.7894%204.00024C11.4851%205.10005%2010.7881%206.00767%209.70359%206.4569C8.61904%206.90613%207.48446%206.75715%206.49155%206.1947C6.38982%206.29126%206.29071%206.39047%206.19431%206.49222C6.75668%207.48509%206.90561%208.61961%206.45641%209.70407C6.00721%2010.7885%205.09967%2011.4855%203.99995%2011.7899C3.99617%2011.93%203.9961%2012.0702%203.99975%2012.2104ZM11.9997%2015.0002C10.3428%2015.0002%208.99969%2013.657%208.99969%2012.0002C8.99969%2010.3433%2010.3428%209.00018%2011.9997%209.00018C13.6565%209.00018%2014.9997%2010.3433%2014.9997%2012.0002C14.9997%2013.657%2013.6565%2015.0002%2011.9997%2015.0002ZM11.9997%2013.0002C12.552%2013.0002%2012.9997%2012.5525%2012.9997%2012.0002C12.9997%2011.4479%2012.552%2011.0002%2011.9997%2011.0002C11.4474%2011.0002%2010.9997%2011.4479%2010.9997%2012.0002C10.9997%2012.5525%2011.4474%2013.0002%2011.9997%2013.0002Z'/%3e%3c/svg%3e";
function DN(e) {
  return e.map((n) => {
    const t = typeof n.header == "function" ? (l) => n.header({
      table: {
        getIsAllPageRowsSelected: () => l.table.getIsAllPageRowsSelected(),
        getIsSomePageRowsSelected: () => l.table.getIsSomePageRowsSelected(),
        toggleAllPageRowsSelected: (r) => l.table.toggleAllPageRowsSelected(r)
      }
    }) : n.header, a = {
      id: n.id,
      header: t,
      enableSorting: n.sortable,
      enableResizing: n.resizable,
      enablePinning: n.enablePinning ?? !1,
      meta: {
        enableColumnDragging: n.draggable,
        headerMenuItems: n.headerMenuItems,
        headerMenuAriaLabel: n.headerMenuAriaLabel,
        isCustomHeader: n.customHeader,
        noTruncate: n.noTruncate,
        // CONSTRAINT: no `??` here — `undefined` and `null` are two different headers downstream.
        sortDirection: n.sortDirection,
        locked: n.locked,
        showPinIcon: n.showPinIcon ?? !0
      }
    };
    return n.width !== void 0 && (a.size = n.width), n.minWidth !== void 0 && (a.minSize = n.minWidth), n.maxWidth !== void 0 && (a.maxSize = n.maxWidth), n.cell && (a.cell = (l) => n.cell({
      row: {
        original: l.row.original,
        getValue: (r) => l.row.getValue(r),
        id: l.row.id,
        getIsSelected: () => l.row.getIsSelected(),
        toggleSelected: (r) => l.row.toggleSelected(r)
      },
      getValue: () => l.getValue()
    })), n.key ? { ...a, accessorKey: n.key } : a;
  });
}
const zN = ["aria-label"], ON = { key: 0 }, PN = {
  key: 1,
  class: "sticky right-0 z-30 w-10 p-0 bg-white dark:bg-(--colors-background-black-default)"
}, FN = ["aria-label"], VN = ["src"], NN = { key: 0 }, HN = {
  key: 1,
  "aria-hidden": "true"
}, jN = 40, WN = /* @__PURE__ */ ye({
  __name: "DataTable",
  props: {
    columns: {},
    data: {},
    hasSettings: { type: Boolean },
    columnVisibility: {},
    columnOrder: {},
    stickyHeader: { type: Boolean },
    maxHeight: {},
    emptyText: {},
    settingsAriaLabel: {},
    regionLabel: {},
    columnPinning: {},
    columnSizing: {}
  },
  emits: ["settings-click", "pin-column", "update:columnOrder", "update:columnPinning", "update:columnSizing"],
  setup(e, { expose: n, emit: t }) {
    const a = e, l = t, r = E(a.columnOrder ?? []);
    Ie(
      () => a.columnOrder,
      (H) => {
        H && (r.value = H);
      }
    );
    const o = E({}), i = E(a.columnPinning ?? { left: [], right: [] }), s = E(null), d = E(null), u = E(0), f = p(() => a.hasSettings ? jN : 0), b = E({}), h = E({}), m = /* @__PURE__ */ new Set(), y = E({ ...{
      startOffset: null,
      startSize: null,
      deltaOffset: null,
      deltaPercentage: null,
      isResizingColumn: !1,
      columnSizingStart: []
    } }), w = E(!1), S = BN({
      get data() {
        return a.data;
      },
      get columns() {
        return DN(a.columns);
      },
      columnResizeMode: "onChange",
      enableRowSelection: !0,
      enableColumnPinning: !0,
      defaultColumn: {
        minSize: 130
      },
      state: {
        get columnOrder() {
          return r.value;
        },
        get columnVisibility() {
          return a.columnVisibility ?? {};
        },
        get columnSizing() {
          return b.value;
        },
        get columnSizingInfo() {
          return y.value;
        },
        get columnPinning() {
          return i.value;
        },
        get rowSelection() {
          return o.value;
        }
      },
      onColumnOrderChange: (H) => {
        const q = typeof H == "function" ? H(r.value) : H;
        r.value = q, l("update:columnOrder", q);
      },
      onColumnSizingChange: (H) => {
        b.value = typeof H == "function" ? H(b.value) : H;
      },
      onColumnSizingInfoChange: (H) => {
        y.value = typeof H == "function" ? H(y.value) : H;
      },
      onColumnPinningChange: (H) => {
        const q = typeof H == "function" ? H(i.value) : H, N = i.value, J = (q.left ?? []).length === (N.left ?? []).length && (q.left ?? []).every((ke, ee) => ke === (N.left ?? [])[ee]), be = (q.right ?? []).length === (N.right ?? []).length && (q.right ?? []).every((ke, ee) => ke === (N.right ?? [])[ee]);
        J && be || (i.value = q, l("update:columnPinning", q));
      },
      onRowSelectionChange: (H) => {
        o.value = typeof H == "function" ? H(o.value) : H;
      },
      getCoreRowModel: EN()
    }), $ = p(() => ({
      allSelected: S.getIsAllPageRowsSelected(),
      someSelected: S.getIsSomePageRowsSelected(),
      toggleAll: (H) => S.toggleAllPageRowsSelected(H),
      isSelected: (H) => {
        var q;
        return ((q = S.getRowModel().rows.find((N) => N.original === H)) == null ? void 0 : q.getIsSelected()) ?? !1;
      },
      toggleRow: (H, q) => {
        var N;
        return (N = S.getRowModel().rows.find((J) => J.original === H)) == null ? void 0 : N.toggleSelected(q);
      }
    }));
    function T(H, q = "left") {
      const N = S.getColumn(H);
      N && (N.pin(q), l("pin-column", H, q));
    }
    function L(H) {
      T(H, !1);
    }
    function A(H) {
      r.value = H;
    }
    Ie(
      () => a.columnPinning,
      (H) => {
        if (!H) return;
        const q = H.left ?? [], N = H.right ?? [], J = i.value, be = q.length === (J.left ?? []).length && q.every((ee, oe) => ee === (J.left ?? [])[oe]), ke = N.length === (J.right ?? []).length && N.every((ee, oe) => ee === (J.right ?? [])[oe]);
        be && ke || (i.value = { left: [...q], right: [...N] });
      },
      { deep: !0 }
    ), n({ selection: $, pinColumn: T, unpinColumn: L, setColumnOrder: A });
    function R() {
      var J, be;
      if (!d.value || Object.keys(b.value).length > 0) return;
      const H = Array.from(d.value.querySelectorAll("thead th")), q = ((J = S.getHeaderGroups()[0]) == null ? void 0 : J.headers) ?? [], N = {};
      if (q.forEach((ke, ee) => {
        const oe = H[ee];
        if (oe) {
          const ge = ke.column.columnDef.maxSize;
          N[ke.column.id] = ge !== void 0 ? Math.min(oe.offsetWidth, ge) : oe.offsetWidth;
        }
      }), Object.keys(N).length > 0) {
        const ke = d.value.clientWidth, ee = ke - f.value, ge = Object.values(N).reduce((re, ue) => re + ue, 0) - ee;
        if (ge !== 0) {
          const re = (be = [...q].reverse().find((ue) => ue.column.columnDef.maxSize === void 0)) == null ? void 0 : be.column.id;
          re !== void 0 && (N[re] = Math.max(130, N[re] - ge));
        }
        S.setColumnSizing(N), u.value = ke, h.value = { ...N }, w.value = !0, z();
      }
    }
    function z() {
      if (!w.value) return;
      const H = a.columnSizing ?? {}, q = Object.keys(H);
      if (q.length === 0) {
        m.size > 0 && (b.value = { ...h.value }, m.clear());
        return;
      }
      const N = new Set(S.getAllLeafColumns().map((ee) => ee.id)), J = {};
      for (const ee of q) {
        const oe = H[ee];
        N.has(ee) && typeof oe == "number" && oe > 0 && (J[ee] = oe);
      }
      const be = Object.keys(J);
      be.length === m.size && be.every((ee) => b.value[ee] === J[ee]) || (b.value = { ...h.value, ...J }, m.clear(), be.forEach((ee) => m.add(ee)));
    }
    function D() {
      const H = {};
      m.forEach((q) => {
        const N = b.value[q];
        typeof N == "number" && (H[q] = N);
      }), l("update:columnSizing", H);
    }
    Ie(
      () => y.value.isResizingColumn,
      (H, q) => {
        q && !H && (m.add(q), D());
      }
    ), Ie(() => a.columnSizing, z, { deep: !0 });
    function V(H) {
      var oe;
      if (!w.value) return;
      const q = H - u.value;
      if (q === 0) return;
      const J = (((oe = S.getHeaderGroups()[0]) == null ? void 0 : oe.headers) ?? []).filter(
        (ge) => ge.column.columnDef.maxSize === void 0 || ge.column.columnDef.maxSize >= Number.MAX_SAFE_INTEGER
      );
      if (J.length === 0) return;
      const be = { ...b.value }, ke = J.reduce(
        (ge, re) => ge + (be[re.column.id] ?? re.column.getSize()),
        0
      );
      let ee = q;
      J.forEach((ge, re) => {
        const ue = be[ge.column.id] ?? ge.column.getSize(), O = ge.column.columnDef.minSize ?? 130, U = re === J.length - 1 ? ee : Math.round(q * (ue / ke));
        be[ge.column.id] = Math.max(O, ue + U), ee -= U;
      }), b.value = be, u.value = H;
    }
    let Y = null;
    ot(() => {
      qe(() => {
        d.value && (Y = new ResizeObserver((H) => {
          var N, J;
          const q = ((N = H[0]) == null ? void 0 : N.contentRect.width) ?? ((J = d.value) == null ? void 0 : J.clientWidth) ?? 0;
          w.value ? V(Math.round(q)) : q > 0 && R();
        }), Y.observe(d.value), d.value.clientWidth > 0 && R());
      });
    }), kt(() => {
      Y == null || Y.disconnect(), Y = null;
    });
    const _ = p(() => {
      if (w.value)
        return `${S.getTotalSize() + f.value}px`;
    }), j = p(() => w.value ? S.getTotalSize() + f.value < u.value : !1);
    function M(H) {
      var N;
      const q = S.getColumn(H);
      ((N = q == null ? void 0 : q.columnDef.meta) == null ? void 0 : N.locked) !== !0 && (s.value = H);
    }
    function W(H) {
      var q;
      return ((q = H.columnDef.meta) == null ? void 0 : q.locked) === !0 ? "locked" : H.getIsPinned() === "left" ? "pinned" : "regular";
    }
    function G(H) {
      return (q) => {
        if (q.preventDefault(), !s.value) return;
        const N = S.getVisibleLeafColumns().map((O) => O.id), J = N.indexOf(s.value), be = N.indexOf(H);
        if (be === 0 || J === -1 || be === -1) return;
        const ke = S.getColumn(s.value), ee = S.getColumn(H);
        if (!ke || !ee) {
          s.value = null;
          return;
        }
        const oe = W(ke), ge = W(ee);
        if (oe === "locked" || ge === "locked" || oe !== ge) {
          s.value = null;
          return;
        }
        if (oe === "pinned" && ge === "pinned") {
          const O = [...S.getState().columnPinning.left ?? []], U = O.indexOf(s.value), Q = O.indexOf(H);
          if (U !== -1 && Q !== -1 && U !== Q) {
            const [ae] = O.splice(U, 1);
            O.splice(Q, 0, ae), S.setColumnPinning({
              left: O,
              right: S.getState().columnPinning.right ?? []
            });
          }
        }
        const re = [...N], [ue] = re.splice(J, 1);
        re.splice(be, 0, ue), S.setColumnOrder(re), s.value = null;
      };
    }
    function B(H) {
      const q = H.style.width, N = H.style.maxWidth;
      H.style.width = "max-content", H.style.maxWidth = "none";
      const J = H.scrollWidth;
      return H.style.width = q, H.style.maxWidth = N, J;
    }
    function F(H) {
      var Q, ae, Z;
      if (!d.value) return;
      const q = (Q = S.getHeaderGroups()[0]) == null ? void 0 : Q.headers.findIndex((ie) => ie.column.id === H);
      if (q === void 0 || q < 0) return;
      const J = Array.from(d.value.querySelectorAll("thead th"))[q], be = J == null ? void 0 : J.querySelector(".truncate, [data-slot]"), ke = be ? B(be) : (J == null ? void 0 : J.scrollWidth) ?? 0, ee = d.value.querySelectorAll("tbody tr");
      let oe = 0;
      ee.forEach((ie) => {
        const de = ie.querySelectorAll("td")[q];
        if (de) {
          const ne = de.querySelector(".truncate");
          oe = Math.max(oe, ne ? B(ne) : de.scrollWidth);
        }
      });
      const ge = (Z = (ae = S.getHeaderGroups()[0]) == null ? void 0 : ae.headers[q]) == null ? void 0 : Z.column, re = (ge == null ? void 0 : ge.columnDef.minSize) ?? 130, ue = (ge == null ? void 0 : ge.columnDef.maxSize) ?? 1e3, O = Math.min(
        ue,
        Math.max(re, Math.max(ke, oe) + 24)
      ), U = { ...b.value, [H]: O };
      S.setColumnSizing(U), m.add(H), D();
    }
    function X(H) {
      const q = H.getIsPinned();
      if (!q)
        return w.value ? { width: `${H.getSize()}px` } : void 0;
      const N = {
        position: "sticky",
        zIndex: "10"
      };
      return q === "left" && (N.left = `${H.getStart("left")}px`), w.value && (N.width = `${H.getSize()}px`), N;
    }
    return (H, q) => (c(), g("div", {
      class: C(["relative border-x border-(--colors-border-base-soft) dark:border-(--colors-border-base)", { "h-full flex flex-col": e.stickyHeader && !e.maxHeight }])
    }, [
      v("div", {
        ref_key: "containerRef",
        ref: d,
        role: "region",
        "aria-label": e.regionLabel ?? "Data table",
        "data-testid": "data-table-container",
        class: C(["relative overflow-x-auto text-(--text-text-heading)", { "overflow-y-auto flex-1 min-h-0": e.stickyHeader && !e.maxHeight }]),
        style: Ne({ scrollbarGutter: "stable", ...e.maxHeight ? { maxHeight: e.maxHeight, overflowY: "auto" } : {} })
      }, [
        te(I(IV), { "table-width": _.value }, {
          default: ve(() => [
            te(I(jV), {
              "is-sticky": e.stickyHeader || !!e.maxHeight
            }, {
              default: ve(() => [
                (c(!0), g(se, null, Me(I(S).getHeaderGroups(), (N) => (c(), K(I(Zo), {
                  key: N.id
                }, {
                  default: ve(() => [
                    (c(!0), g(se, null, Me(N.headers, (J) => {
                      var be, ke, ee, oe, ge, re, ue;
                      return c(), K(I(HV), {
                        key: J.id,
                        style: Ne(X(J.column)),
                        "is-pinned": J.column.getIsPinned() === "left",
                        "is-last-pinned": J.column.getIsLastColumn("left"),
                        "header-menu-items": (be = J.column.columnDef.meta) == null ? void 0 : be.headerMenuItems,
                        "menu-aria-label": (ke = J.column.columnDef.meta) == null ? void 0 : ke.headerMenuAriaLabel,
                        "is-custom-header": (ee = J.column.columnDef.meta) == null ? void 0 : ee.isCustomHeader,
                        "is-draggable": ((oe = J.column.columnDef.meta) == null ? void 0 : oe.enableColumnDragging) === !0,
                        "is-locked": ((ge = J.column.columnDef.meta) == null ? void 0 : ge.locked) === !0,
                        "is-pin-icon-visible": ((re = J.column.columnDef.meta) == null ? void 0 : re.showPinIcon) !== !1,
                        "sort-direction": (ue = J.column.columnDef.meta) == null ? void 0 : ue.sortDirection,
                        "is-resizable": J.column.getCanResize(),
                        "is-resizing-active": J.column.getIsResizing(),
                        class: "header-cell",
                        onDragHandleStart: (O) => M(J.column.id),
                        onDragover: q[0] || (q[0] = Ue(() => {
                        }, ["prevent"])),
                        onDrop: (O) => G(J.column.id)(O),
                        onResizeStart: (O) => J.getResizeHandler()(O),
                        onResizeAuto: (O) => F(J.column.id)
                      }, {
                        default: ve(() => [
                          J.isPlaceholder ? k("", !0) : (c(), K(I(fb), {
                            key: 0,
                            render: J.column.columnDef.header,
                            props: J.getContext()
                          }, null, 8, ["render", "props"]))
                        ]),
                        _: 2
                      }, 1032, ["style", "is-pinned", "is-last-pinned", "header-menu-items", "menu-aria-label", "is-custom-header", "is-draggable", "is-locked", "is-pin-icon-visible", "sort-direction", "is-resizable", "is-resizing-active", "onDragHandleStart", "onDrop", "onResizeStart", "onResizeAuto"]);
                    }), 128)),
                    j.value ? (c(), g("th", ON)) : k("", !0),
                    e.hasSettings ? (c(), g("th", PN, [
                      v("button", {
                        "data-testid": "data-settings",
                        "aria-label": e.settingsAriaLabel ?? "Column settings",
                        class: "data-settings-btn flex items-center justify-center w-10 h-10 p-0 cursor-pointer focus-visible:ring-2 focus-visible:ring-royalblue focus-visible:outline-none transition-colors",
                        onClick: q[1] || (q[1] = (J) => l("settings-click"))
                      }, [
                        v("img", {
                          class: "size-5",
                          src: I(MN),
                          alt: ""
                        }, null, 8, VN)
                      ], 8, FN)
                    ])) : k("", !0)
                  ]),
                  _: 2
                }, 1024))), 128))
              ]),
              _: 1
            }, 8, ["is-sticky"]),
            te(I(TV), null, {
              default: ve(() => {
                var N;
                return [
                  (N = I(S).getRowModel().rows) != null && N.length ? (c(!0), g(se, { key: 0 }, Me(I(S).getRowModel().rows, (J) => (c(), K(I(Zo), {
                    key: J.id,
                    "data-state": J.getIsSelected() ? "selected" : void 0
                  }, {
                    default: ve(() => [
                      (c(!0), g(se, null, Me(J.getVisibleCells(), (be) => {
                        var ke;
                        return c(), K(I(hu), {
                          key: be.id,
                          "no-truncate": (ke = be.column.columnDef.meta) == null ? void 0 : ke.noTruncate,
                          style: Ne(X(be.column)),
                          class: C([
                            be.column.getIsPinned() === "left" ? "sticky z-10 bg-white dark:bg-(--colors-background-black-default) pinned-cell" : "",
                            be.column.getIsLastColumn("left") ? "pinned-cell-last" : ""
                          ])
                        }, {
                          default: ve(() => [
                            te(I(fb), {
                              render: be.column.columnDef.cell ?? be.getValue,
                              props: be.getContext()
                            }, null, 8, ["render", "props"])
                          ]),
                          _: 2
                        }, 1032, ["no-truncate", "style", "class"]);
                      }), 128)),
                      j.value ? (c(), g("td", NN)) : k("", !0),
                      e.hasSettings ? (c(), g("td", HN)) : k("", !0)
                    ]),
                    _: 2
                  }, 1032, ["data-state"]))), 128)) : (c(), K(I(Zo), {
                    key: 1,
                    class: "border-b-0! hover:bg-white! dark:hover:bg-(--colors-background-black-default)!"
                  }, {
                    default: ve(() => [
                      te(I(hu), {
                        colspan: e.columns.length + 1,
                        class: "h-24 text-center"
                      }, {
                        default: ve(() => [
                          at(P(e.emptyText ?? "No results."), 1)
                        ]),
                        _: 1
                      }, 8, ["colspan"])
                    ]),
                    _: 1
                  }))
                ];
              }),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["table-width"])
      ], 14, zN)
    ], 2));
  }
}), Vq = /* @__PURE__ */ lt(WN, [["__scopeId", "data-v-9502b5a6"]]);
function Nq(e, n, t) {
  return (a) => {
    const r = (e() || "").replace(/\D/g, ""), o = n() || "", i = GR[o], s = Ac(r, (i == null ? void 0 : i.hasTrunkZero) ?? !1);
    if (!s) return;
    const d = (i == null ? void 0 : i.min) ?? 6, u = (i == null ? void 0 : i.max) ?? 1 / 0, f = (i == null ? void 0 : i.name) ?? o, b = (i == null ? void 0 : i.placeholder) ?? Sl.placeholder;
    if (s.length < d)
      return t({ count: d, country: f, example: b });
    if (s.length > u)
      return t({ count: u, country: f, example: b });
  };
}
function bb(e) {
  return e == null ? !0 : typeof e == "string" ? e.trim() === "" : !1;
}
function qN(e) {
  const n = typeof e == "string" ? { requiredMessage: e } : e, { requiredMessage: t, watchData: a } = n, l = typeof t == "function" ? t : () => t, r = E(/* @__PURE__ */ new Map()), o = p(() => Array.from(r.value.values())), i = p(() => r.value.size), s = p(() => r.value.size > 0);
  function d(x, y) {
    if (x.required && bb(y))
      return l();
    if (x.validate)
      return x.validate(y);
  }
  function u(x, y) {
    const w = /* @__PURE__ */ new Map();
    for (const S of x) {
      const $ = d(S, y[S.key]);
      $ && w.set(S.key, {
        key: S.key,
        label: S.label,
        message: $
      });
    }
    return r.value = w, w.size === 0;
  }
  function f(x, y) {
    const w = d(x, y);
    if (w) {
      const S = new Map(r.value);
      return S.set(x.key, { key: x.key, label: x.label, message: w }), r.value = S, !1;
    } else
      return h(x.key), !0;
  }
  function b(x) {
    var y;
    return (y = r.value.get(x)) == null ? void 0 : y.message;
  }
  function h(x) {
    if (r.value.has(x)) {
      const y = new Map(r.value);
      y.delete(x), r.value = y;
    }
  }
  function m() {
    r.value = /* @__PURE__ */ new Map();
  }
  return a && Ie(
    () => a,
    () => {
      if (s.value)
        for (const x of [...o.value]) {
          const y = a[x.key];
          bb(y) || h(x.key);
        }
    },
    { deep: !0 }
  ), {
    errors: r,
    errorList: o,
    errorCount: i,
    hasErrors: s,
    validateAll: u,
    validateField: d,
    validateAndSetField: f,
    getFieldError: b,
    clearFieldError: h,
    clearAllErrors: m
  };
}
function UN(e) {
  const n = E(!1);
  async function t() {
    var a, l;
    if (e.validate()) {
      n.value = !0;
      try {
        await e.save(), (a = e.onSuccess) == null || a.call(e);
      } catch (r) {
        (l = e.onError) == null || l.call(e, r);
      } finally {
        n.value = !1;
      }
    }
  }
  return { isSaving: n, handleSubmit: t };
}
function $l(e) {
  if (e === null || typeof e != "object")
    return e;
  if (Array.isArray(e))
    return e.map($l);
  const n = {};
  for (const t in e)
    Object.prototype.hasOwnProperty.call(e, t) && (n[t] = $l(e[t]));
  return n;
}
function xu(e, n) {
  if (e === n) return !0;
  if (e === null || n === null) return e === n;
  if (typeof e != typeof n) return !1;
  if (typeof e != "object") return e === n;
  if (Array.isArray(e) && Array.isArray(n))
    return e.length !== n.length ? !1 : e.every((l, r) => xu(l, n[r]));
  if (Array.isArray(e) || Array.isArray(n)) return !1;
  const t = Object.keys(e), a = Object.keys(n);
  return t.length !== a.length ? !1 : t.every(
    (l) => xu(e[l], n[l])
  );
}
function GN(e) {
  const { data: n, enableBeforeUnload: t = !0, beforeUnloadMessage: a } = e, l = E(null), r = E(!1), o = p(() => r.value ? !0 : l.value === null ? !1 : !xu(n, l.value));
  function i() {
    l.value = $l(n), r.value = !1;
  }
  function s() {
    l.value = $l(n), r.value = !1;
  }
  function d() {
    l.value !== null && Object.assign(n, $l(l.value)), r.value = !1;
  }
  function u() {
    return $l(l.value);
  }
  function f(h) {
    r.value = h;
  }
  function b(h) {
    if (o.value) {
      h.preventDefault();
      const m = a ? a() : "";
      return h.returnValue = m, m;
    }
  }
  return ot(() => {
    i(), t && window.addEventListener("beforeunload", b);
  }), kt(() => {
    t && window.removeEventListener("beforeunload", b);
  }), {
    isDirty: o,
    markAsSaved: s,
    resetToOriginal: d,
    getOriginalData: u,
    setDirty: f
  };
}
function Hq(e) {
  const n = GN({
    data: e.data,
    enableBeforeUnload: e.enableBeforeUnload,
    beforeUnloadMessage: e.beforeUnloadMessage
  }), t = qN({
    requiredMessage: e.requiredMessage,
    watchData: e.data
  }), a = UN({
    validate: () => t.validateAll(e.fields(), e.data),
    save: e.save,
    onSuccess: () => {
      var l;
      t.clearAllErrors(), n.markAsSaved(), (l = e.onSuccess) == null || l.call(e);
    },
    onError: e.onError
  });
  return {
    // Dirty state
    isDirty: n.isDirty,
    markAsSaved: n.markAsSaved,
    resetToOriginal: n.resetToOriginal,
    setDirty: n.setDirty,
    // Validation
    errorList: t.errorList,
    errorCount: t.errorCount,
    hasErrors: t.hasErrors,
    getFieldError: t.getFieldError,
    clearFieldError: t.clearFieldError,
    clearAllErrors: t.clearAllErrors,
    // Submit
    isSaving: a.isSaving,
    handleSubmit: a.handleSubmit
  };
}
function KN(e) {
  const n = E(!1);
  if (typeof window > "u") return n;
  const t = window.matchMedia(e), a = () => {
    n.value = t.matches;
  };
  return wu() && (ot(() => {
    a(), t.addEventListener("change", a);
  }), kt(() => {
    t.removeEventListener("change", a);
  })), n;
}
const YN = {
  key: 0,
  class: "p-3"
}, JN = { class: "flex flex-col-reverse md:flex-row items-center justify-between md:space-x-4" }, ZN = { class: "w-full lg:w-2/3 flex flex-col space-y-3 md:space-y-0 md:flex-row md:items-center" }, XN = {
  key: 0,
  class: "flex items-center space-x-4"
}, QN = {
  key: 1,
  class: "w-full md:w-auto flex flex-col md:flex-row mb-3 md:mb-0 items-stretch md:items-center justify-end md:space-x-3 shrink-0"
}, _N = {
  key: 0,
  class: "flex flex-wrap"
}, e9 = { class: "relative" }, t9 = { class: "flex-1 min-h-0 flex flex-col" }, n9 = {
  key: 1,
  class: "border-t border-gainsboro dark:border-(--colors-border-base) p-5"
}, jq = /* @__PURE__ */ ye({
  __name: "DataTableWrapper",
  props: {
    bordered: { type: Boolean }
  },
  setup(e) {
    const n = Ht();
    return (t, a) => (c(), g("div", {
      class: C([
        "relative bg-white rounded-xl flex-1 flex flex-col min-h-0",
        e.bordered ? "border border-(--border-border-base-soft) overflow-hidden shadow-[0px_1px_0.5px_0.05px_rgba(29,41,61,0.02)]" : "border-l border-border-base-soft has-[>div:nth-child(2)>[role=data-settings]]:rounded-tr-none"
      ])
    }, [
      a[0] || (a[0] = v("div", { class: "absolute bottom-0 left-1.5 right-0 h-px bg-linear-to-r from-(--background-background-gray) to-transparent" }, null, -1)),
      I(n)("filters") || I(n)("actions") ? (c(), g("div", YN, [
        v("div", JN, [
          v("div", ZN, [
            I(n)("filters") ? (c(), g("div", XN, [
              $e(t.$slots, "filters")
            ])) : k("", !0),
            I(n)("actions") ? (c(), g("div", QN, [
              $e(t.$slots, "actions")
            ])) : k("", !0)
          ]),
          I(n)("filter-items") ? (c(), g("div", _N, [
            $e(t.$slots, "filter-items")
          ])) : k("", !0)
        ])
      ])) : k("", !0),
      v("div", e9, [
        v("div", {
          class: C(["absolute top-0 right-0 h-0.5 bg-border-base-soft", I(n)("filters") ? "left-0" : "left-1.5"])
        }, null, 2)
      ]),
      v("div", t9, [
        $e(t.$slots, "table")
      ]),
      I(n)("pager") ? (c(), g("div", n9, [
        $e(t.$slots, "pager")
      ])) : k("", !0)
    ], 2));
  }
}), a9 = {
  key: 0,
  role: "menu",
  "data-testid": "card-actions-menu",
  class: "absolute right-0 top-10 z-50 min-w-160px rounded-xl border border-(--border-border-base-soft) bg-white py-1 shadow-[0_4px_16px_rgba(0,0,0,0.12)]"
}, l9 = ["onClick"], r9 = {
  key: 0,
  class: "skeleton w-full h-192px rounded-t-3xl"
}, o9 = {
  key: 1,
  class: "skeleton h-9 w-9 rounded-full shrink-0 m-6"
}, i9 = ["src", "alt"], s9 = { class: "h-9 w-9 rounded-full border border-(--border-border-base-soft) flex items-center justify-center bg-white" }, d9 = { class: "flex flex-col flex-1" }, u9 = {
  key: 0,
  class: "self-start bg-(--background-background-white-tertiary) text-xs font-medium px-1 py-0.5 rounded text-(--text-text-black-default)"
}, c9 = {
  key: 1,
  class: "text-2xl font-bold text-(--text-text-heading) dark:text-(--colors-text-white-default) m-0"
}, f9 = {
  key: 2,
  class: "text-base text-(--text-text-body) dark:text-(--colors-text-white-secondary) m-0"
}, Wq = /* @__PURE__ */ ye({
  __name: "Card",
  props: {
    layout: { default: "classic" },
    headerType: { default: "icon" },
    imageSrc: { default: void 0 },
    imageAlt: { default: "" },
    badge: { default: void 0 },
    title: { default: void 0 },
    description: { default: void 0 },
    primaryLabel: { default: void 0 },
    secondaryLabel: { default: void 0 },
    loading: { type: Boolean, default: !1 },
    actions: { default: void 0 }
  },
  emits: ["primary-click", "secondary-click"],
  setup(e, { emit: n }) {
    const t = n, {
      isOpen: a,
      dropdownRef: l,
      toggleDropdown: r,
      closeDropdown: o
    } = Yl(), i = (d) => {
      var u;
      (u = d.onClick) == null || u.call(d), o();
    }, s = (d) => {
      l.value = d;
    };
    return (d, u) => (c(), g("div", {
      "data-testid": "card",
      class: C([
        "relative overflow-hidden rounded-3xl border border-(--border-border-base-medium) bg-white dark:bg-(--colors-background-black-default) shadow-[0px_0px_4px_rgba(0,0,0,0.1)]",
        e.layout === "aligned" ? "flex flex-row items-center" : "flex flex-col"
      ])
    }, [
      !e.loading && e.actions && e.actions.length ? (c(), g("div", {
        key: 0,
        ref: s,
        class: "absolute top-3 right-3 z-10",
        "data-testid": "card-actions"
      }, [
        v("button", {
          type: "button",
          "data-testid": "card-actions-trigger",
          class: "h-8 w-8 rounded-full border border-(--border-border-base-soft) bg-white flex items-center justify-center cursor-pointer hover:bg-(--background-background-white-tertiary) transition-colors",
          onClick: u[0] || (u[0] = //@ts-ignore
          (...f) => I(r) && I(r)(...f))
        }, [...u[3] || (u[3] = [
          v("i", { class: "ri-more-line text-sm text-(--text-text-body)" }, null, -1)
        ])]),
        te(wt, {
          "enter-active-class": "transition duration-100 ease-out",
          "enter-from-class": "transform scale-95 opacity-0",
          "enter-to-class": "transform scale-100 opacity-100",
          "leave-active-class": "transition duration-75 ease-out",
          "leave-from-class": "transform scale-100 opacity-100",
          "leave-to-class": "transform scale-95 opacity-0"
        }, {
          default: ve(() => [
            I(a) ? (c(), g("div", a9, [
              (c(!0), g(se, null, Me(e.actions, (f) => (c(), g("button", {
                key: f.label,
                type: "button",
                role: "menuitem",
                "data-testid": "card-action-item",
                class: C([
                  "w-full text-left px-4 py-2 text-sm hover:bg-(--background-background-white-tertiary) transition-colors flex items-center gap-2",
                  f.class || "text-(--text-text-black-default)"
                ]),
                onClick: (b) => i(f)
              }, [
                f.icon ? (c(), g("i", {
                  key: 0,
                  class: C(f.icon)
                }, null, 2)) : k("", !0),
                at(" " + P(f.label), 1)
              ], 10, l9))), 128))
            ])) : k("", !0)
          ]),
          _: 1
        })
      ])) : k("", !0),
      e.loading ? (c(), g(se, { key: 1 }, [
        e.layout !== "aligned" ? (c(), g("div", r9)) : (c(), g("div", o9)),
        u[4] || (u[4] = Xr('<div class="flex flex-col gap-3 px-6 pb-6 pt-4 flex-1"><div class="skeleton h-5 w-16 rounded"></div><div class="skeleton h-8 w-3/4 rounded"></div><div class="skeleton h-4 w-full rounded"></div><div class="skeleton h-4 w-2/3 rounded"></div><div class="flex gap-2 pt-2"><div class="skeleton h-9 w-24 rounded-full"></div><div class="skeleton h-9 w-24 rounded-full"></div></div></div>', 1))
      ], 64)) : (c(), g(se, { key: 2 }, [
        $e(d.$slots, "header", {}, () => [
          e.headerType === "image" ? (c(), g("div", {
            key: 0,
            class: C(e.layout === "aligned" ? "p-6 shrink-0" : "p-6")
          }, [
            e.imageSrc ? (c(), g("img", {
              key: 0,
              src: e.imageSrc,
              alt: e.imageAlt,
              class: C(
                e.layout === "aligned" ? "h-48 w-48 object-cover rounded-xl" : "w-full h-48 object-cover rounded-xl"
              )
            }, null, 10, i9)) : k("", !0)
          ], 2)) : (c(), g("div", {
            key: 1,
            class: C(e.layout === "aligned" ? "pl-6 shrink-0" : "pt-6 pb-6 px-6")
          }, [
            v("div", s9, [
              $e(d.$slots, "icon")
            ])
          ], 2))
        ]),
        v("div", d9, [
          $e(d.$slots, "default", {}, () => [
            v("div", {
              class: C(["flex flex-col gap-3", e.layout === "aligned" ? "p-6" : "px-6 pb-6"])
            }, [
              e.badge ? (c(), g("span", u9, P(e.badge), 1)) : k("", !0),
              e.title ? (c(), g("p", c9, P(e.title), 1)) : k("", !0),
              e.description ? (c(), g("p", f9, P(e.description), 1)) : k("", !0)
            ], 2)
          ])
        ]),
        $e(d.$slots, "footer", {}, () => [
          e.primaryLabel || e.secondaryLabel ? (c(), g("div", {
            key: 0,
            class: C([
              e.layout === "aligned" ? "px-6 flex flex-col gap-4 items-start shrink-0" : "px-6 pb-6 flex items-center gap-4"
            ])
          }, [
            e.primaryLabel ? (c(), K(Re, {
              key: 0,
              variant: "primary",
              size: "xs",
              label: e.primaryLabel,
              onClick: u[1] || (u[1] = (f) => t("primary-click"))
            }, null, 8, ["label"])) : k("", !0),
            e.secondaryLabel ? (c(), K(Re, {
              key: 1,
              variant: "secondary",
              size: "xs",
              label: e.secondaryLabel,
              onClick: u[2] || (u[2] = (f) => t("secondary-click"))
            }, null, 8, ["label"])) : k("", !0)
          ], 2)) : k("", !0)
        ])
      ], 64))
    ], 2));
  }
}), h9 = ["aria-checked", "aria-disabled"], b9 = { class: "flex flex-col gap-1.5" }, qq = /* @__PURE__ */ ye({
  __name: "CardSelectable",
  props: {
    icon: { default: void 0 },
    title: { default: void 0 },
    description: { default: void 0 },
    selected: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    iconVariant: { default: "default" }
  },
  emits: ["click"],
  setup(e, { emit: n }) {
    const t = e, a = n;
    function l(r) {
      t.disabled || a("click", r);
    }
    return (r, o) => (c(), g("button", {
      type: "button",
      "data-testid": "card-selectable",
      "aria-checked": e.selected,
      "aria-disabled": e.disabled || void 0,
      class: C([
        "relative flex flex-col gap-3 p-6 rounded-xl border text-left w-full",
        "transition-colors duration-120 ease-in-out",
        "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-(--border-border-hover)",
        // Disabled wins over selected (a disabled card can't be the chosen option). Use the DS
        // disabled surface (grey fill + border) rather than a flat opacity so the disabled state
        // reads clearly against the enabled cards (OP-6222).
        e.disabled ? "bg-(--colors-background-disabled) border-(--colors-border-disabled) cursor-not-allowed pointer-events-none" : e.selected ? "bg-(--background-background-hover) border-(--border-border-hover) shadow-[0px_0px_2px_var(--border-border-hover)] cursor-pointer" : "bg-(--background-background-white) border-(--border-border-base-medium) hover:border-(--border-border-hover) active:bg-(--background-background-hover) cursor-pointer"
      ]),
      onClick: l
    }, [
      $e(r.$slots, "default", {}, () => [
        v("div", {
          class: C([
            "h-9 w-9 flex items-center justify-center rounded-lg border shrink-0",
            e.disabled ? "bg-(--colors-background-disabled) border-(--colors-border-disabled)" : e.iconVariant === "accent" ? "bg-(--background-background-white) border-(--border-border-hover) shadow-[0px_0px_1px_var(--background-background-hover)]" : "bg-(--background-background-white) border-(--border-border-base-medium)"
          ])
        }, [
          v("i", {
            class: C([e.icon, "text-[20px]", e.disabled ? "text-(--colors-icon-disabled)" : "text-(--icons-icon-accent)"]),
            "aria-hidden": "true"
          }, null, 2)
        ], 2),
        v("div", b9, [
          v("span", {
            class: C(["text-lg font-semibold", e.disabled ? "text-(--colors-text-disabled)" : "text-(--text-text-heading)"])
          }, P(e.title), 3),
          e.description ? (c(), g("span", {
            key: 0,
            class: C(["text-sm", e.disabled ? "text-(--colors-text-disabled)" : "text-(--text-text-body)"])
          }, P(e.description), 3)) : k("", !0)
        ])
      ])
    ], 10, h9));
  }
}), g9 = {
  "data-testid": "page-header",
  class: "flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 mb-6 sm:mb-8"
}, p9 = { class: "shrink-0" }, m9 = {
  "data-testid": "page-header-title",
  class: "text-2xl sm:text-3xl font-bold text-gray-900"
}, v9 = {
  key: 0,
  "data-testid": "page-header-subtitle",
  class: "text-sm sm:text-base text-gray-600 mt-1"
}, x9 = {
  key: 0,
  "data-testid": "page-header-actions",
  class: "flex items-center gap-3 shrink-0"
}, Uq = /* @__PURE__ */ ye({
  __name: "PageHeader",
  props: {
    title: {},
    subtitle: { default: void 0 }
  },
  setup(e) {
    const n = Ht();
    return (t, a) => (c(), g("div", g9, [
      v("div", p9, [
        v("h1", m9, P(e.title), 1),
        e.subtitle ? (c(), g("p", v9, P(e.subtitle), 1)) : k("", !0)
      ]),
      I(n)("actions") ? (c(), g("div", x9, [
        $e(t.$slots, "actions")
      ])) : k("", !0)
    ]));
  }
}), y9 = {
  key: 0,
  class: "flex"
}, k9 = { class: "flex flex-wrap md:flex-nowrap items-start gap-2" }, w9 = { class: "flex-1" }, C9 = { class: "leading-8.5 text-[1.75rem] font-bold mb-1 wrap-anywhere" }, S9 = {
  key: 0,
  class: "flex gap-1.5"
}, $9 = {
  key: 1,
  class: "flex flex-wrap gap-4 w-full md:w-auto justify-end"
}, I9 = {
  key: 1,
  class: "flex gap-1.5"
}, T9 = {
  key: 1,
  class: "flex flex-wrap gap-4 py-4"
}, L9 = {
  key: 0,
  class: "self-center overflow-y-auto me-auto"
}, Gq = /* @__PURE__ */ ye({
  __name: "DetailHeaderWrapper",
  props: {
    title: {}
  },
  setup(e) {
    const n = Mn(), t = (a) => !!n[a];
    return (a, l) => (c(), g("header", null, [
      t("topbar") ? (c(), g("div", y9, [
        $e(a.$slots, "topbar")
      ])) : k("", !0),
      v("div", k9, [
        t("avatar") ? $e(a.$slots, "avatar", { key: 0 }) : k("", !0),
        v("div", w9, [
          v("h1", C9, P(e.title) + " ", 1),
          t("facets") ? (c(), g("div", S9, [
            $e(a.$slots, "facets")
          ])) : k("", !0)
        ]),
        t("actions") || t("nav-actions") ? (c(), g("div", $9, [
          t("actions") ? $e(a.$slots, "actions", { key: 0 }) : k("", !0),
          t("nav-actions") ? (c(), g("div", I9, [
            $e(a.$slots, "nav-actions")
          ])) : k("", !0)
        ])) : k("", !0)
      ]),
      t("tabs") || t("save") ? (c(), g("div", T9, [
        t("tabs") ? (c(), g("div", L9, [
          $e(a.$slots, "tabs")
        ])) : k("", !0),
        t("save") ? $e(a.$slots, "save", { key: 1 }) : k("", !0)
      ])) : k("", !0)
    ]));
  }
}), Kq = /* @__PURE__ */ ye({
  __name: "Masonry",
  props: {
    gapX: { default: 20 },
    gapY: { default: 20 },
    breakpoint: { default: 640 },
    useViewport: { type: Boolean, default: !1 }
  },
  setup(e) {
    const n = e, t = Mn(), a = E([]), l = E(null), r = E([]), o = E(0), i = E(2), s = p(
      () => {
        var y;
        return (((y = t.default) == null ? void 0 : y.call(t)) ?? []).filter(
          (w) => w.type !== Mb
        );
      }
    );
    function d() {
      const y = a.value;
      if (!y.length) return;
      const w = i.value, S = Array(w).fill(0), $ = [];
      for (const T of y) {
        const L = S.indexOf(Math.min(...S));
        $.push({ col: L, top: S[L] }), S[L] += T.offsetHeight + n.gapY;
      }
      r.value = $, o.value = Math.max(...S) - n.gapY;
    }
    function u(y) {
      const w = r.value[y];
      if (!w) return { visibility: "hidden" };
      const S = i.value;
      if (S === 1)
        return { top: `${w.top}px`, left: "0", width: "100%" };
      const $ = 100 / S, T = n.gapX * (S - 1) / S;
      return {
        top: `${w.top}px`,
        left: w.col === 0 ? "0" : `calc(${w.col * $}% + ${w.col * n.gapX / S}px)`,
        width: `calc(${$}% - ${T}px)`
      };
    }
    let f, b, h;
    function m() {
      h !== void 0 && cancelAnimationFrame(h), h = requestAnimationFrame(() => {
        h = void 0, d();
      });
    }
    function x(y) {
      i.value = y.matches ? 1 : 2, m();
    }
    return ot(async () => {
      await qe(), n.useViewport ? (b = window.matchMedia(`(max-width: ${n.breakpoint}px)`), i.value = b.matches ? 1 : 2, b.addEventListener("change", x), d(), f = new ResizeObserver(m), a.value.forEach((y) => f.observe(y))) : (f = new ResizeObserver(() => {
        var w;
        const y = ((w = l.value) == null ? void 0 : w.offsetWidth) ?? 0;
        i.value = y < n.breakpoint ? 1 : 2, m();
      }), a.value.forEach((y) => f.observe(y)), l.value && f.observe(l.value));
    }), kt(() => {
      h !== void 0 && cancelAnimationFrame(h), f == null || f.disconnect(), b == null || b.removeEventListener("change", x);
    }), (y, w) => (c(), g("div", {
      ref_key: "containerRef",
      ref: l,
      class: "relative w-full",
      style: Ne({ height: `${o.value}px` })
    }, [
      (c(!0), g(se, null, Me(s.value, (S, $) => (c(), g("div", {
        key: $,
        ref_for: !0,
        ref_key: "itemRefs",
        ref: a,
        class: "absolute",
        style: Ne(u($))
      }, [
        (c(), K(dt(S)))
      ], 4))), 128))
    ], 4));
  }
}), E9 = { class: "group-hover:underline" }, A9 = /* @__PURE__ */ ye({
  inheritAttrs: !1,
  __name: "InlineLink",
  props: {
    as: {},
    iconLeft: {}
  },
  setup(e) {
    return (n, t) => (c(), K(dt(e.as), Oe(n.$attrs, { class: "flex items-center px-3 py-2 gap-1.5 group leading-5 text-sm text-(--text-text-black-default)" }), {
      default: ve(() => [
        e.iconLeft ? (c(), g("i", {
          key: 0,
          class: C(["text-current", e.iconLeft])
        }, null, 2)) : k("", !0),
        v("span", E9, [
          $e(n.$slots, "default")
        ])
      ]),
      _: 3
    }, 16));
  }
}), Yq = A9, R9 = ["aria-labelledby", "aria-busy"], B9 = {
  key: 0,
  class: "flex flex-col space-y-5"
}, M9 = {
  key: 0,
  class: "flex items-center gap-2"
}, D9 = {
  key: 0,
  class: "flex items-center gap-2 shrink-0"
}, z9 = {
  key: 1,
  class: "flex-1 min-w-0 flex flex-col gap-2"
}, O9 = ["id"], P9 = {
  key: 1,
  class: "text-base leading-6 text-(--colors-text-body) dark:text-(--colors-text-white-secondary)",
  "data-testid": "widget-shell-subtitle"
}, F9 = {
  key: 2,
  class: "flex items-center gap-3 shrink-0 ms-auto",
  "data-testid": "widget-shell-actions"
}, V9 = {
  key: 0,
  class: "flex items-center gap-1.5"
}, N9 = {
  key: 1,
  class: "flex items-center gap-1.5"
}, H9 = {
  key: 0,
  class: "flex-1 min-w-0 leading-6.5 text-num-16 font-medium truncate text-(--colors-text-heading) dark:text-(--colors-text-white-default)"
}, j9 = {
  key: 1,
  class: "flex items-center ms-auto shrink-0"
}, W9 = {
  key: 1,
  "data-testid": "widget-shell-footer"
}, Jq = /* @__PURE__ */ ye({
  __name: "WidgetShell",
  props: {
    header: {},
    subtitle: {},
    subheader: {},
    loading: { type: Boolean },
    flush: { type: Boolean },
    stretch: { type: Boolean },
    rounded: {},
    bordered: { type: Boolean, default: !0 }
  },
  setup(e) {
    const n = {
      xs: "rounded-(--border-border-radius-rounded-xs)",
      sm: "rounded-(--border-border-radius-rounded-sm)",
      m: "rounded-(--border-border-radius-rounded-l)",
      l: "rounded-(--border-border-radius-rounded-base)",
      xl: "rounded-(--border-border-radius-rounded-xl)",
      "2xl": "rounded-(--border-border-radius-rounded-xxl)"
    }, t = e, a = p(() => n[t.rounded ?? "m"]), l = Ve(), r = Fn(), o = p(
      () => !t.flush && t.header && !r["aria-label"] ? l : void 0
    ), i = Ht(), s = p(
      () => !!(t.header || t.subtitle || t.subheader) || i("before-actions") || i("actions") || i("nav-actions") || i("sub-info") || i("sub-actions")
    );
    return (d, u) => (c(), g("section", {
      "aria-labelledby": o.value,
      "aria-busy": e.loading || void 0,
      "data-testid": "widget-shell",
      class: C([
        a.value,
        e.bordered !== !1 ? "border border-(--border-border-base-soft) bg-(--colors-background-white) shadow-(--blur-shadow-s) break-inside-avoid" : void 0,
        e.bordered !== !1 ? "dark:border-(--colors-border-base) dark:bg-(--colors-background-black-default) dark:shadow-(--blur-shadow-m-dark)" : void 0,
        e.flush ? "overflow-hidden" : "p-6 space-y-6",
        e.stretch ? "flex flex-col flex-1" : "inline-block w-full"
      ])
    }, [
      e.flush ? $e(d.$slots, "default", { key: 0 }) : (c(), g(se, { key: 1 }, [
        s.value ? (c(), g("div", B9, [
          e.header || e.subtitle || I(i)("before-actions") || I(i)("actions") || I(i)("nav-actions") ? (c(), g("div", M9, [
            I(i)("before-actions") ? (c(), g("div", D9, [
              $e(d.$slots, "before-actions")
            ])) : k("", !0),
            e.header || e.subtitle ? (c(), g("div", z9, [
              e.header ? (c(), g("h2", {
                key: 0,
                id: I(l),
                class: "min-w-0 leading-6.5 text-[1.375rem] font-bold truncate text-(--colors-text-heading) dark:text-(--colors-text-white-default)"
              }, P(e.header), 9, O9)) : k("", !0),
              e.subtitle ? (c(), g("p", P9, P(e.subtitle), 1)) : k("", !0)
            ])) : k("", !0),
            I(i)("actions") || I(i)("nav-actions") ? (c(), g("div", F9, [
              $e(d.$slots, "actions"),
              I(i)("nav-actions") ? (c(), g("div", V9, [
                $e(d.$slots, "nav-actions")
              ])) : k("", !0)
            ])) : k("", !0)
          ])) : k("", !0),
          e.subheader || I(i)("sub-info") || I(i)("sub-actions") ? (c(), g("div", N9, [
            e.subheader ? (c(), g("h3", H9, P(e.subheader), 1)) : k("", !0),
            $e(d.$slots, "sub-info"),
            I(i)("sub-actions") ? (c(), g("div", j9, [
              $e(d.$slots, "sub-actions")
            ])) : k("", !0)
          ])) : k("", !0)
        ])) : k("", !0),
        v("div", {
          class: C(e.stretch ? "flex-1 flex flex-col" : "")
        }, [
          $e(d.$slots, "default")
        ], 2),
        I(i)("footer") ? (c(), g("div", W9, [
          $e(d.$slots, "footer")
        ])) : k("", !0)
      ], 64))
    ], 10, R9));
  }
}), q9 = { class: "flex flex-col min-h-0 h-full rounded-(--border-border-radius-rounded-l) border border-(--border-border-base-medium) bg-white shadow-[0px_0px_4px_rgba(0,0,0,0.1)] overflow-hidden" }, Zq = /* @__PURE__ */ ye({
  __name: "WidgetBlock",
  props: {
    headerBordered: { type: Boolean, default: !0 },
    footerBordered: { type: Boolean, default: !0 }
  },
  setup(e) {
    const n = Ht();
    return (t, a) => (c(), g("div", q9, [
      I(n)("header") ? (c(), g("div", {
        key: 0,
        "data-testid": "widget-block-header",
        class: C(["sticky top-0 z-10 bg-white px-6 py-5", e.headerBordered ? "border-b border-(--border-border-base-soft)" : ""])
      }, [
        $e(t.$slots, "header")
      ], 2)) : k("", !0),
      v("div", {
        "data-testid": "widget-block-main",
        class: C([
          "flex-1 min-h-0 overflow-y-auto overflow-x-hidden px-6 pb-6",
          I(n)("header") && !e.headerBordered ? "pt-0" : "pt-6"
        ])
      }, [
        $e(t.$slots, "default")
      ], 2),
      I(n)("footer") ? (c(), g("div", {
        key: 1,
        "data-testid": "widget-block-footer",
        class: C(["px-6 py-4", e.footerBordered ? "border-t border-(--border-border-base-soft)" : ""])
      }, [
        $e(t.$slots, "footer")
      ], 2)) : k("", !0)
    ]));
  }
}), U9 = {
  key: 0,
  class: "flex flex-col gap-1",
  "data-testid": "widget-section-header"
}, G9 = {
  key: 0,
  class: "text-lg font-semibold text-(--colors-text-black-default) m-0"
}, K9 = {
  key: 0,
  class: "text-sm text-(--text-text-body) m-0"
}, Xq = /* @__PURE__ */ ye({
  __name: "WidgetSection",
  props: {
    title: {},
    subtitle: {},
    bordered: { type: Boolean, default: !0 },
    padded: { type: Boolean, default: !0 },
    gap: { default: "md" }
  },
  setup(e) {
    const n = e, t = Ht(), a = p(
      () => !!n.title || !!n.subtitle || t("title") || t("subtitle")
    ), l = p(
      () => ({ sm: "gap-3", md: "gap-4", lg: "gap-5" })[n.gap]
    );
    return (r, o) => (c(), g("section", {
      class: C([
        "flex flex-col",
        l.value,
        e.bordered && "rounded-(--border-border-radius-rounded-l) border border-(--border-border-base-soft)",
        e.padded && "p-6"
      ]),
      "data-testid": "widget-section"
    }, [
      a.value ? (c(), g("header", U9, [
        $e(r.$slots, "title", {}, () => [
          e.title ? (c(), g("h3", G9, P(e.title), 1)) : k("", !0)
        ]),
        $e(r.$slots, "subtitle", {}, () => [
          e.subtitle ? (c(), g("p", K9, P(e.subtitle), 1)) : k("", !0)
        ])
      ])) : k("", !0),
      $e(r.$slots, "default")
    ], 2));
  }
}), Y9 = {
  "data-testid": "cta-widget",
  class: "flex flex-col sm:flex-row sm:items-center sm:justify-between gap-6 rounded-(--border-border-radius-rounded-l) border border-(--border-border-base-soft) shadow-[0px_0px_4px_rgba(0,0,0,0.1)] bg-white p-6",
  style: { "background-image": "var(--gradient-cta-widget)" }
}, J9 = { class: "flex flex-col gap-1.5 min-w-0" }, Z9 = { class: "flex items-center gap-1.5" }, X9 = { class: "text-(length:--size-l) leading-(--line-height-l) font-(--weight-bold) text-(--text-text-black-default)" }, Q9 = { class: "text-(length:--size-sm) leading-(--line-height-l) font-(--weight-regular) text-(--text-text-heading)" }, _9 = { class: "flex flex-col items-stretch sm:items-center sm:shrink-0" }, Qq = /* @__PURE__ */ ye({
  __name: "CtaWidget",
  props: {
    title: { default: "" },
    titleIcon: { default: void 0 },
    description: { default: "" },
    ctaLabel: { default: "" },
    ctaIcon: { default: "ri-add-line" },
    ctaDisabled: { type: Boolean, default: !1 }
  },
  emits: ["cta-click"],
  setup(e, { emit: n }) {
    const t = n;
    return (a, l) => (c(), g("div", Y9, [
      v("div", J9, [
        v("div", Z9, [
          e.titleIcon ? (c(), g("i", {
            key: 0,
            class: C([e.titleIcon, "text-(length:--size-l) text-(--text-text-black-default)"]),
            "aria-hidden": "true"
          }, null, 2)) : k("", !0),
          v("p", X9, [
            $e(a.$slots, "title", {}, () => [
              at(P(e.title), 1)
            ])
          ])
        ]),
        v("p", Q9, [
          $e(a.$slots, "description", {}, () => [
            at(P(e.description), 1)
          ])
        ])
      ]),
      v("div", _9, [
        $e(a.$slots, "actions", {}, () => [
          e.ctaLabel ? (c(), K(Re, {
            key: 0,
            variant: "primary",
            size: "xl",
            "icon-left": e.ctaIcon,
            label: e.ctaLabel,
            disabled: e.ctaDisabled,
            onClick: l[0] || (l[0] = (r) => t("cta-click", r))
          }, null, 8, ["icon-left", "label", "disabled"])) : k("", !0)
        ])
      ])
    ]));
  }
}), e7 = {
  "data-testid": "stats-widget",
  class: "flex flex-col justify-center gap-3 rounded-(--border-border-radius-rounded-l) border border-(--border-border-base-soft) bg-(--colors-background-white) p-6 shadow-(--blur-shadow-s) dark:border-(--colors-border-base) dark:bg-(--colors-background-black-default) dark:shadow-(--blur-shadow-m-dark)"
}, t7 = { class: "flex items-start gap-2" }, n7 = { class: "min-w-0 text-(length:--size-l) leading-(--line-height-xxl) font-(--weight-regular) text-(--colors-text-body) dark:text-(--colors-text-white-secondary)" }, a7 = { class: "flex flex-wrap items-end gap-x-2 gap-y-1" }, l7 = {
  class: "text-(length:--size-4xl) leading-(--line-height-4xl) font-(--weight-bold) text-(--colors-text-heading) dark:text-(--colors-text-white-default)",
  "data-testid": "stats-widget-value"
}, r7 = ["aria-hidden"], o7 = {
  key: 0,
  class: "sr-only"
}, i7 = {
  key: 1,
  class: "text-(length:--size-m) leading-(--line-height-l) font-(--weight-regular) text-(--colors-text-body-subtle) dark:text-(--colors-text-white-secondary)",
  "data-testid": "stats-widget-caption"
}, s7 = {
  key: 0,
  class: "text-(length:--size-m) leading-(--line-height-l) font-(--weight-regular) text-(--colors-text-body-subtle) dark:text-(--colors-text-white-secondary)",
  "data-testid": "stats-widget-caption"
}, _q = /* @__PURE__ */ ye({
  __name: "StatsWidget",
  props: {
    icon: { default: void 0 },
    label: { default: "" },
    value: { default: null },
    placeholder: { default: "—" },
    placeholderLabel: { default: "" },
    caption: { default: "" },
    captionInline: { type: Boolean, default: !1 },
    hint: { default: "" },
    valueHint: { default: "" },
    hintIcon: { default: "ri-question-line" }
  },
  setup(e) {
    const n = e, t = p(() => n.value === null || n.value === void 0 || n.value === "");
    return (a, l) => (c(), g("div", e7, [
      v("div", t7, [
        e.icon ? (c(), g("i", {
          key: 0,
          class: C([e.icon, "shrink-0 text-(length:--size-xxl) leading-(--line-height-xxl) text-(--colors-text-body) dark:text-(--colors-text-white-secondary)"]),
          "aria-hidden": "true"
        }, null, 2)) : k("", !0),
        v("p", n7, [
          $e(a.$slots, "label", {}, () => [
            at(P(e.label), 1)
          ])
        ]),
        e.hint ? (c(), K(ft, {
          key: 1,
          text: e.hint,
          as: "span",
          "labels-trigger": "",
          role: "img",
          tabindex: "0",
          "aria-label": e.hint,
          class: "shrink-0 cursor-help self-center rounded-(--border-border-radius-rounded-full) focus-visible:shadow-(--shadow-focus-l) focus-visible:outline-2 focus-visible:outline-transparent",
          "data-testid": "stats-widget-hint"
        }, {
          default: ve(() => [
            v("i", {
              class: C([e.hintIcon, "block text-(length:--size-m) leading-(--line-height-l) text-(--colors-text-body) dark:text-(--colors-text-white-secondary)"]),
              "data-testid": "stats-widget-hint-icon",
              "aria-hidden": "true"
            }, null, 2)
          ]),
          _: 1
        }, 8, ["text", "aria-label"])) : k("", !0)
      ]),
      v("div", a7, [
        v("p", l7, [
          $e(a.$slots, "value", {}, () => [
            t.value ? (c(), g(se, { key: 0 }, [
              v("span", {
                "aria-hidden": e.placeholderLabel ? "true" : void 0
              }, P(e.placeholder), 9, r7),
              e.placeholderLabel ? (c(), g("span", o7, P(e.placeholderLabel), 1)) : k("", !0)
            ], 64)) : (c(), g(se, { key: 1 }, [
              at(P(e.value), 1)
            ], 64))
          ])
        ]),
        e.valueHint ? (c(), K(ft, {
          key: 0,
          text: e.valueHint,
          as: "span",
          "labels-trigger": "",
          role: "img",
          tabindex: "0",
          "aria-label": e.valueHint,
          class: "shrink-0 cursor-help self-center rounded-(--border-border-radius-rounded-full) focus-visible:shadow-(--shadow-focus-l) focus-visible:outline-2 focus-visible:outline-transparent",
          "data-testid": "stats-widget-value-hint"
        }, {
          default: ve(() => [
            v("i", {
              class: C([e.hintIcon, "block text-(length:--size-m) leading-(--line-height-l) text-(--colors-text-body) dark:text-(--colors-text-white-secondary)"]),
              "data-testid": "stats-widget-value-hint-icon",
              "aria-hidden": "true"
            }, null, 2)
          ]),
          _: 1
        }, 8, ["text", "aria-label"])) : k("", !0),
        e.caption && e.captionInline ? (c(), g("p", i7, P(e.caption), 1)) : k("", !0)
      ]),
      e.caption && !e.captionInline ? (c(), g("p", s7, P(e.caption), 1)) : k("", !0)
    ]));
  }
}), d7 = ["aria-expanded", "aria-controls", "disabled"], u7 = { class: "flex-shrink-0" }, c7 = {
  key: 0,
  class: "flex h-6 w-6 items-center justify-center rounded-full bg-[#009966] border border-gray-200",
  "data-testid": "collapsible-section-validated"
}, f7 = {
  key: 1,
  class: "flex h-6 w-6 items-center justify-center rounded-full bg-gray-100 dark:bg-[rgba(255,255,255,0.08)]"
}, h7 = { class: "flex-1 min-w-0" }, b7 = { class: "text-base font-semibold text-text-black-default dark:text-(--colors-text-white-default)" }, g7 = {
  key: 0,
  class: "text-sm text-gray-500 dark:text-(--colors-text-white-secondary) mt-0.5 truncate"
}, p7 = { class: "flex-shrink-0" }, m7 = ["id", "inert", "aria-hidden"], v7 = { class: "px-14 py-5" }, x7 = ["disabled"], y7 = {
  key: 0,
  class: "ri-loader-4-line animate-spin text-sm"
}, k7 = {
  key: 1,
  class: "ri-check-line text-sm"
}, w7 = ["disabled"], C7 = /* @__PURE__ */ ye({
  __name: "CollapsibleSection",
  props: {
    title: {},
    subtitle: { default: void 0 },
    icon: { default: void 0 },
    expanded: { type: Boolean, default: !1 },
    validated: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    showActions: { type: Boolean, default: !0 },
    validateDisabled: { type: Boolean, default: !1 },
    cancelDisabled: { type: Boolean, default: !1 },
    validateLoading: { type: Boolean, default: !1 },
    warning: { default: void 0 },
    validateLabel: { default: "Validate" },
    cancelLabel: { default: "Cancel" },
    actionsAlignment: { default: "start" }
  },
  emits: ["update:expanded", "validate", "cancel"],
  setup(e, { emit: n }) {
    const t = e, a = n, l = E(!1), r = E(null), o = E(null), i = E(null), s = E(null), d = () => {
      var y, w;
      (y = o.value) == null || y.focus(), document.activeElement !== o.value && ((w = r.value) == null || w.focus());
    };
    Ie(
      () => t.expanded,
      (y) => {
        var w;
        y || (l.value = !1, (w = i.value) != null && w.contains(document.activeElement) && d());
      }
    ), Ie(
      () => t.validateDisabled || t.validateLoading,
      (y) => {
        y && s.value && document.activeElement === s.value && d();
      }
    );
    const u = (y) => {
      y.propertyName === "max-height" && t.expanded && (l.value = !0);
    }, f = Ve(), b = p(() => `${f}-content`), h = () => {
      t.disabled || a("update:expanded", !t.expanded);
    }, m = () => {
      a("validate");
    }, x = () => {
      a("cancel");
    };
    return (y, w) => (c(), g("div", {
      ref_key: "rootRef",
      ref: r,
      class: C(["rounded-xl border border-solid border-lightgray dark:border-(--colors-border-base) bg-white dark:bg-(--colors-background-black-default) overflow-hidden", { "opacity-60 cursor-not-allowed": e.disabled }]),
      "data-testid": "collapsible-section",
      tabindex: "-1"
    }, [
      v("button", {
        ref_key: "headerRef",
        ref: o,
        type: "button",
        class: C(["flex w-full items-center gap-6 px-6 py-5 text-left transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-(--border-border-hover)", [
          e.expanded ? "bg-gray-50 dark:bg-[rgba(255,255,255,0.03)]" : "",
          e.disabled ? "cursor-not-allowed" : "cursor-pointer hover:bg-gray-50 dark:hover:bg-[rgba(255,255,255,0.03)]"
        ]]),
        "aria-expanded": e.expanded,
        "aria-controls": b.value,
        disabled: e.disabled,
        "data-testid": "collapsible-section-header",
        onClick: h
      }, [
        v("div", u7, [
          e.validated ? (c(), g("div", c7, [...w[0] || (w[0] = [
            v("i", { class: "ri-check-fill text-white text-sm" }, null, -1)
          ])])) : e.icon ? (c(), g("div", f7, [
            v("i", {
              class: C([e.icon, "text-gray-500 dark:text-(--colors-text-white-secondary) text-base"])
            }, null, 2)
          ])) : k("", !0)
        ]),
        v("div", h7, [
          v("div", b7, P(e.title), 1),
          e.subtitle ? (c(), g("div", g7, P(e.subtitle), 1)) : k("", !0)
        ]),
        v("div", p7, [
          v("i", {
            class: C(["text-xl text-gray-400 dark:text-(--colors-text-white-secondary) transition-transform duration-200", e.expanded ? "ri-arrow-up-s-line" : "ri-arrow-down-s-line"])
          }, null, 2)
        ])
      ], 10, d7),
      v("div", {
        id: b.value,
        ref_key: "contentRef",
        ref: i,
        class: C(["collapsible-content", {
          "collapsible-content--expanded": e.expanded,
          "collapsible-content--open": l.value
        }]),
        role: "region",
        inert: !e.expanded || void 0,
        "aria-hidden": !e.expanded,
        onTransitionend: u
      }, [
        v("div", v7, [
          $e(y.$slots, "default", {}, void 0, !0),
          e.showActions ? (c(), g("div", {
            key: 0,
            class: C(["flex items-center gap-3 mt-4", e.actionsAlignment === "end" ? "flex-row-reverse" : ""])
          }, [
            $e(y.$slots, "actions", {
              validate: m,
              cancel: x
            }, () => [
              v("button", {
                ref_key: "validateRef",
                ref: s,
                type: "button",
                class: C([
                  "inline-flex items-center gap-1.5 rounded-full px-3 py-1.5 text-xs font-medium text-white border border-[#6a7282] transition-colors",
                  e.validateDisabled || e.validateLoading ? "bg-[#242424] opacity-50 cursor-not-allowed" : "bg-[#242424] hover:bg-[#3a3a3a] cursor-pointer"
                ]),
                disabled: e.validateDisabled || e.validateLoading,
                "data-testid": "collapsible-section-validate",
                onClick: Ue(m, ["stop"])
              }, [
                e.validateLoading ? (c(), g("i", y7)) : (c(), g("i", k7)),
                at(" " + P(e.validateLabel), 1)
              ], 10, x7),
              v("button", {
                type: "button",
                class: C([
                  "inline-flex items-center gap-1.5 rounded-full px-3 py-1.5 text-xs font-medium text-text-black-default dark:text-(--colors-text-white-default) bg-white dark:bg-(--colors-background-black-default) border border-solid border-[#919191] dark:border-(--colors-border-base) transition-colors",
                  e.cancelDisabled ? "opacity-50 cursor-not-allowed" : "hover:bg-gray-50 dark:hover:bg-[rgba(255,255,255,0.05)] cursor-pointer"
                ]),
                disabled: e.cancelDisabled,
                "data-testid": "collapsible-section-cancel",
                onClick: Ue(x, ["stop"])
              }, P(e.cancelLabel), 11, w7)
            ], !0)
          ], 2)) : k("", !0),
          e.warning ? (c(), K(I(Ul), {
            key: 1,
            color: "danger",
            heading: e.warning,
            class: "mt-4",
            "data-testid": "collapsible-section-warning"
          }, null, 8, ["heading"])) : k("", !0)
        ])
      ], 42, m7)
    ], 2));
  }
}), eU = /* @__PURE__ */ lt(C7, [["__scopeId", "data-v-fb7f3a92"]]), S7 = ["aria-label"], $7 = { class: "flex w-full flex-col items-center gap-5" }, I7 = { class: "flex w-full flex-col items-center gap-3.5" }, T7 = {
  key: 0,
  class: "max-w-full truncate rounded border border-(--colors-border-base-soft) bg-white px-1 py-0.5 text-xs font-medium leading-5 text-(--colors-text-black-default) dark:bg-(--colors-background-black-default) dark:text-(--colors-text-white-default)"
}, L7 = { class: "flex w-full flex-col items-center gap-2.5 text-center" }, E7 = { class: "min-h-[48px] w-full text-xl font-bold leading-6 text-(--colors-text-heading) line-clamp-2 dark:text-(--colors-text-white-default)" }, A7 = { class: "min-h-[20px] w-full truncate text-sm leading-5 text-(--colors-text-body-subtle) dark:text-(--colors-text-white-secondary)" }, tU = /* @__PURE__ */ ye({
  __name: "ProfileCard",
  props: {
    name: { default: void 0 },
    role: { default: void 0 },
    email: { default: void 0 },
    avatarUrl: { default: void 0 },
    buttonLabel: { default: void 0 },
    loading: { type: Boolean, default: !1 }
  },
  emits: ["click"],
  setup(e) {
    return (n, t) => (c(), g("article", {
      class: "flex w-full flex-col items-center gap-6",
      "aria-label": e.name
    }, [
      e.loading ? (c(), g(se, { key: 0 }, [
        t[1] || (t[1] = Xr('<div class="h-16 w-16 shrink-0 animate-pulse rounded-full bg-(--colors-border-base-soft)"></div><div class="flex w-full flex-col items-center gap-5"><div class="flex w-full flex-col items-center gap-3.5"><div class="h-5 w-28 animate-pulse rounded bg-(--colors-border-base-soft)"></div><div class="flex w-full flex-col items-center gap-2"><div class="h-6 w-4/5 animate-pulse rounded bg-(--colors-border-base-soft)"></div><div class="h-5 w-3/5 animate-pulse rounded bg-(--colors-border-base-soft)"></div></div></div><div class="h-7 w-32 animate-pulse rounded-full bg-(--colors-border-base-soft)"></div></div>', 2))
      ], 64)) : (c(), g(se, { key: 1 }, [
        te(Kt, {
          name: e.name ?? "",
          img: e.avatarUrl,
          size: "2xl",
          "avatar-style": "square",
          presentational: ""
        }, null, 8, ["name", "img"]),
        v("div", $7, [
          v("div", I7, [
            e.role ? (c(), g("span", T7, P(e.role), 1)) : k("", !0),
            v("div", L7, [
              v("p", E7, P(e.name), 1),
              v("p", A7, P(e.email), 1)
            ])
          ]),
          te(Re, {
            variant: "secondary",
            size: "xs",
            label: e.buttonLabel,
            "icon-right": "ri-external-link-line",
            "aria-label": `${e.buttonLabel}: ${e.name}`,
            onClick: t[0] || (t[0] = (a) => n.$emit("click"))
          }, null, 8, ["label", "aria-label"])
        ])
      ], 64))
    ], 8, S7));
  }
}), R7 = ["aria-label"], B7 = { class: "flex w-full items-center" }, M7 = ["aria-label"], D7 = { class: "px-5 flex justify-center w-full" }, z7 = { class: "flex w-full items-center" }, O7 = { class: "flex flex-col items-center gap-0.5 text-center w-full px-5" }, P7 = { class: "text-lg font-semibold leading-[22px] text-(--colors-text-heading) dark:text-(--colors-text-white-default)" }, F7 = {
  key: 0,
  class: "text-lg font-semibold leading-[22px] text-(--colors-text-heading) dark:text-(--colors-text-white-default)"
}, V7 = {
  key: 1,
  class: "text-base leading-6 text-(--colors-text-body) dark:text-(--colors-text-white-secondary)"
}, N7 = ["aria-label"], H7 = { class: "flex flex-col items-center" }, j7 = ["aria-label"], W7 = { class: "flex flex-col items-center" }, q7 = { class: "flex flex-col gap-1 pb-8 pt-0.5" }, U7 = { class: "text-lg font-semibold leading-[22px] text-(--colors-text-heading) dark:text-(--colors-text-white-default)" }, G7 = {
  key: 0,
  class: "text-lg font-semibold leading-[22px] text-(--colors-text-heading) dark:text-(--colors-text-white-default)"
}, K7 = {
  key: 1,
  class: "text-base leading-6 text-(--colors-text-body) dark:text-(--colors-text-white-secondary)"
}, nU = /* @__PURE__ */ ye({
  __name: "Timeline",
  props: {
    items: { default: () => [] },
    orientation: { default: "auto" },
    ariaLabel: { default: "Timeline" },
    loading: { type: Boolean, default: !1 },
    loadingCount: { default: 3 },
    itemMinWidth: { default: "160px" },
    showItemIcons: { type: Boolean, default: !0 }
  },
  setup(e) {
    const n = e, t = KN("(min-width: 768px)"), a = [
      "green",
      "violet",
      "yellow",
      "indigo",
      "cyan",
      "orange",
      "red",
      "purple",
      "neutral"
    ], l = (i, s) => i.badgeTheme ?? a[s % a.length], r = p(() => n.orientation === "horizontal" ? !0 : n.orientation === "vertical" ? !1 : t.value), o = p(() => Array.from({ length: n.loadingCount }));
    return (i, s) => r.value ? (c(), g("ol", {
      key: 0,
      "aria-label": e.ariaLabel,
      class: "flex w-full items-start overflow-x-auto pb-3"
    }, [
      e.loading ? (c(!0), g(se, { key: 0 }, Me(o.value, (d, u) => (c(), g("li", {
        key: u,
        class: "flex flex-1 flex-col items-center gap-4",
        style: Ne({ minWidth: e.itemMinWidth })
      }, [
        s[1] || (s[1] = v("div", { class: "px-5 flex justify-center w-full" }, [
          v("div", { class: "h-6 w-24 animate-pulse rounded bg-(--colors-border-base-soft)" })
        ], -1)),
        v("div", B7, [
          v("div", {
            class: C(["flex-1 h-px", u === 0 ? "invisible" : "bg-(--colors-border-base-soft)"])
          }, null, 2),
          s[0] || (s[0] = v("div", { class: "h-3 w-3 shrink-0 animate-pulse rounded-full bg-(--colors-border-base-soft)" }, null, -1)),
          v("div", {
            class: C([
              "flex-1 h-px",
              u === o.value.length - 1 ? "invisible" : "bg-(--colors-border-base-soft)"
            ])
          }, null, 2)
        ]),
        s[2] || (s[2] = v("div", { class: "flex flex-col items-center gap-2 w-full px-5" }, [
          v("div", { class: "h-5 w-28 animate-pulse rounded bg-(--colors-border-base-soft)" }),
          v("div", { class: "h-4 w-20 animate-pulse rounded bg-(--colors-border-base-soft)" })
        ], -1))
      ], 4))), 128)) : (c(!0), g(se, { key: 1 }, Me(e.items, (d, u) => (c(), g("li", {
        key: u,
        "aria-label": `${d.title}, ${d.date}`,
        class: "flex flex-1 flex-col items-center gap-4",
        style: Ne({ minWidth: e.itemMinWidth })
      }, [
        v("div", D7, [
          te(ct, {
            label: d.date,
            theme: l(d, u),
            "show-close-icon": !1,
            "show-left-icon": e.showItemIcons,
            size: "sm",
            class: "whitespace-nowrap",
            "left-icon": e.showItemIcons ? d.icon ?? "ri-calendar-line" : void 0
          }, null, 8, ["label", "theme", "show-left-icon", "left-icon"])
        ]),
        v("div", z7, [
          v("div", {
            class: C(["flex-1 h-px bg-(--colors-border-base-medium)", u === 0 ? "invisible" : ""])
          }, null, 2),
          s[3] || (s[3] = v("div", { class: "h-3 w-3 shrink-0 rounded-full border-2 border-white bg-(--icons-icon-disabled-light) dark:border-(--colors-border-base) z-10" }, null, -1)),
          v("div", {
            class: C([
              "flex-1 h-px bg-(--colors-border-base-medium)",
              u === e.items.length - 1 ? "invisible" : ""
            ])
          }, null, 2)
        ]),
        v("div", O7, [
          v("p", P7, P(d.title), 1),
          d.subtitle ? (c(), g("p", F7, P(d.subtitle), 1)) : k("", !0),
          d.description ? (c(), g("p", V7, P(d.description), 1)) : k("", !0)
        ])
      ], 12, M7))), 128))
    ], 8, R7)) : (c(), g("ol", {
      key: 1,
      "aria-label": e.ariaLabel,
      class: "flex flex-col"
    }, [
      e.loading ? (c(!0), g(se, { key: 0 }, Me(o.value, (d, u) => (c(), g("li", {
        key: u,
        class: "flex flex-row gap-4"
      }, [
        v("div", H7, [
          v("div", {
            class: C([
              "w-px flex-1 bg-(--colors-border-base-soft)",
              u === 0 ? "invisible" : "animate-pulse"
            ])
          }, null, 2),
          s[4] || (s[4] = v("div", { class: "h-3 w-3 shrink-0 animate-pulse rounded-full bg-(--colors-border-base-soft)" }, null, -1)),
          v("div", {
            class: C([
              "w-px flex-1 bg-(--colors-border-base-soft)",
              u === o.value.length - 1 ? "invisible" : "animate-pulse"
            ])
          }, null, 2)
        ]),
        s[5] || (s[5] = v("div", { class: "flex flex-col gap-2 pb-8 pt-0.5" }, [
          v("div", { class: "h-6 w-24 animate-pulse rounded bg-(--colors-border-base-soft)" }),
          v("div", { class: "h-5 w-36 animate-pulse rounded bg-(--colors-border-base-soft)" }),
          v("div", { class: "h-4 w-28 animate-pulse rounded bg-(--colors-border-base-soft)" })
        ], -1))
      ]))), 128)) : (c(!0), g(se, { key: 1 }, Me(e.items, (d, u) => (c(), g("li", {
        key: u,
        "aria-label": `${d.title}, ${d.date}`,
        class: "flex flex-row gap-4"
      }, [
        v("div", W7, [
          v("div", {
            class: C([
              "w-px h-[9px] shrink-0 bg-(--colors-border-base-medium)",
              u === 0 ? "invisible" : ""
            ])
          }, null, 2),
          s[6] || (s[6] = v("div", { class: "h-3 w-3 shrink-0 rounded-full border-2 border-white bg-(--icons-icon-disabled-light) dark:border-(--colors-border-base) z-10" }, null, -1)),
          v("div", {
            class: C([
              "w-px flex-1 bg-(--colors-border-base-medium)",
              u === e.items.length - 1 ? "invisible" : ""
            ])
          }, null, 2)
        ]),
        v("div", q7, [
          te(ct, {
            label: d.date,
            theme: l(d, u),
            "show-close-icon": !1,
            "show-left-icon": e.showItemIcons,
            size: "sm",
            class: "self-start",
            "left-icon": e.showItemIcons ? d.icon ?? "ri-calendar-line" : void 0
          }, null, 8, ["label", "theme", "show-left-icon", "left-icon"]),
          v("p", U7, P(d.title), 1),
          d.subtitle ? (c(), g("p", G7, P(d.subtitle), 1)) : k("", !0),
          d.description ? (c(), g("p", K7, P(d.description), 1)) : k("", !0)
        ])
      ], 8, j7))), 128))
    ], 8, N7));
  }
}), Y7 = ["aria-label"], J7 = ["aria-orientation", "tabindex"], Z7 = ["id", "data-testid", "aria-selected", "aria-disabled", "aria-controls", "tabindex", "onClick"], X7 = { class: "truncate" }, Q7 = {
  key: 1,
  class: "ri-lock-line text-(length:--icon-size-sm) leading-none text-(--icons-icon-disabled-strong)",
  "aria-hidden": "true"
}, _7 = ["aria-label"], eH = "before:pointer-events-none before:absolute before:inset-x-0 before:bottom-0 before:-z-1 before:border-b-3 before:border-(--border-border-base-soft)", gb = "nav-pill relative isolate border border-transparent py-[calc(--spacing(2.5)-1px)] px-[calc(--spacing(4)-1px)] before:absolute before:-inset-px before:-z-10 before:rounded-[inherit] before:opacity-0 before:[background:var(--nav-pill-ring)] after:absolute after:inset-[calc(var(--border-border-width-border-sm)-1px)] after:-z-10 after:rounded-[inherit] after:opacity-0 after:bg-(--background-background-white) focus-visible:after:opacity-100 focus-visible:after:shadow-(--shadow-focus-l-inset)", pb = "before:opacity-100 after:opacity-100 forced-colors:border-[Highlight]", xd = "text-(--text-text-disabled-strong)", tH = /* @__PURE__ */ ye({
  inheritAttrs: !1,
  __name: "NavTabs",
  props: {
    tabs: {},
    modelValue: {},
    fullWidth: { type: Boolean, default: !1 },
    overflowLabel: {},
    overflowPreviousLabel: {},
    type: { default: "border-bottom" }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: n }) {
    const t = p(() => e.type === "vertical-pills"), a = p(() => [
      "relative isolate max-w-full",
      e.fullWidth || t.value ? "w-full" : "w-fit",
      e.type === "border-bottom" && eH
    ]), l = {
      "border-bottom": "size-8",
      default: "size-6",
      pills: "size-10"
    }, r = {
      "border-bottom": "scroll-px-8",
      default: "scroll-px-6",
      pills: "scroll-px-10"
    }, o = (T) => [
      "absolute top-1/2 -translate-y-1/2 z-20 inline-flex items-center justify-center cursor-pointer",
      T,
      "rounded-(--border-border-radius-rounded-base) bg-(--background-background-white) hover:bg-(--background-background-hover)",
      "text-(--icons-icon-dark-default) transition-colors duration-150 motion-reduce:transition-none",
      "focus-visible:outline-hidden focus-visible:shadow-(--shadow-focus-l)",
      l[e.type]
    ], i = {
      "border-bottom": "flex items-end gap-3",
      default: "flex items-center gap-3",
      pills: "flex items-center gap-3",
      "vertical-pills": "flex flex-col justify-center gap-3"
    }, s = {
      "border-bottom": {
        // Figma pads 14 px above and below with a 3 px INSIDE stroke: the bottom padding gives the
        // border back, and the underline lands on the wrapper's rule.
        base: "px-0.5 pt-3.5 pb-[calc(--spacing(3.5)-3px)] border-b-3",
        activeMark: "border-solid [border-image:var(--gradient-brand-border)_1]",
        hoverMark: "border-transparent hover:[border-image:var(--gradient-brand-border)_1]",
        restMark: "border-transparent",
        activeText: "text-(--text-text-black-default)",
        hoverText: "hover:text-(--text-text-black-default)"
      },
      default: {
        base: "rounded-(--border-border-radius-rounded-xs)",
        activeMark: "underline",
        hoverMark: "hover:underline",
        restMark: "",
        activeText: "text-(--text-text-hover)",
        hoverText: "hover:text-(--text-text-hover)"
      },
      pills: {
        base: `${gb} rounded-(--border-border-radius-rounded-full)`,
        activeMark: pb,
        hoverMark: "hover:before:opacity-100 hover:after:opacity-100",
        restMark: "",
        activeText: "text-(--text-text-black-default)",
        hoverText: "hover:text-(--text-text-black-default)"
      },
      "vertical-pills": {
        base: `${gb} justify-start rounded-(--border-border-radius-rounded-l)`,
        activeMark: pb,
        hoverMark: "hover:before:opacity-100 hover:after:opacity-100",
        restMark: "",
        activeText: "text-(--text-text-black-default)",
        hoverText: "hover:text-(--text-text-black-default)"
      }
    };
    function d(T) {
      return T.locked === !0 || T.readOnly === !0;
    }
    function u(T) {
      const L = s[e.type], A = T.key === e.modelValue, R = e.type === "pills" || e.type === "vertical-pills";
      return T.locked ? [
        A ? L.activeMark : L.restMark,
        xd,
        "cursor-not-allowed",
        R && !A ? "bg-(--background-background-white)" : ""
      ] : A ? [L.activeMark, T.readOnly ? xd : L.activeText] : [L.hoverMark, T.readOnly ? xd : "text-(--text-text-body)", L.hoverText];
    }
    const f = n, b = E(null), h = E(null), m = E(null), x = cg({
      strip: b,
      arrow: h,
      backArrow: m,
      enabled: () => !t.value,
      selection: () => e.modelValue
    }), y = Fn(), w = p(() => {
      const { class: T, style: L, ...A } = y;
      return A;
    });
    function S(T) {
      T.locked || f("update:modelValue", T.key);
    }
    function $(T) {
      var D;
      const L = Array.from(
        T.currentTarget.querySelectorAll("[role=tab]")
      ), A = document.activeElement, R = A ? L.indexOf(A) : -1;
      let z;
      switch (T.key) {
        case (t.value ? "ArrowDown" : "ArrowRight"):
          z = R < 0 ? 0 : (R + 1) % L.length;
          break;
        case (t.value ? "ArrowUp" : "ArrowLeft"):
          z = R <= 0 ? L.length - 1 : R - 1;
          break;
        case "Home":
          z = 0;
          break;
        case "End":
          z = L.length - 1;
          break;
        case "Enter":
        case " ":
          if (A && A.getAttribute("aria-disabled") !== "true") {
            const V = e.tabs[R];
            V && f("update:modelValue", V.key);
          }
          T.preventDefault();
          return;
        default:
          return;
      }
      T.preventDefault(), (D = L[z]) == null || D.focus();
    }
    return (T, L) => (c(), g("div", {
      class: C([a.value, I(y).class]),
      style: Ne(I(y).style)
    }, [
      I(x).showBackArrow.value ? (c(), g("button", {
        key: 0,
        ref_key: "backArrowRef",
        ref: m,
        type: "button",
        "aria-label": e.overflowPreviousLabel,
        "data-testid": "nav-tabs-overflow-back-arrow",
        class: C(o("left-0")),
        onClick: L[0] || (L[0] = //@ts-ignore
        (...A) => I(x).scrollBack && I(x).scrollBack(...A))
      }, [...L[3] || (L[3] = [
        v("i", {
          class: "ri-arrow-left-line text-(length:--icon-size-sm) leading-(--icon-size-sm)",
          "aria-hidden": "true"
        }, null, -1)
      ])], 10, Y7)) : k("", !0),
      v("div", Oe({
        ref_key: "stripRef",
        ref: b
      }, w.value, {
        role: "tablist",
        "aria-orientation": t.value ? "vertical" : "horizontal",
        tabindex: I(x).overflowing.value ? -1 : void 0,
        class: [
          i[e.type],
          e.fullWidth || t.value ? "w-full" : "w-max max-w-full",
          !t.value && [
            "nav-tabs-scroll overflow-x-auto overflow-y-hidden",
            r[e.type]
          ]
        ],
        onKeydown: $,
        onScrollPassive: L[1] || (L[1] = //@ts-ignore
        (...A) => I(x).measure && I(x).measure(...A))
      }), [
        (c(!0), g(se, null, Me(e.tabs, (A) => (c(), K(ft, {
          key: A.key,
          class: C(t.value ? "w-full" : e.fullWidth ? "flex-1 min-w-0" : "shrink-0"),
          text: A.lockTooltip ?? "",
          disabled: !d(A) || !A.lockTooltip,
          position: t.value ? "right" : "bottom"
        }, {
          default: ve(() => [
            v("button", {
              id: A.id,
              type: "button",
              role: "tab",
              "data-testid": `nav-tab-${A.key}`,
              "aria-selected": A.key === e.modelValue,
              "aria-disabled": A.locked ? "true" : void 0,
              "aria-controls": A.panelId,
              tabindex: A.key === e.modelValue ? 0 : -1,
              class: C([
                "inline-flex min-w-0 items-center gap-1.5 whitespace-nowrap",
                "text-(length:--size-m) leading-(--line-height-l) font-(--weight-medium)",
                "transition-colors motion-reduce:transition-none",
                "focus-visible:outline-hidden focus-visible:shadow-(--shadow-focus-l-inset)",
                s[e.type].base,
                t.value ? "w-full" : e.fullWidth && "w-full justify-center",
                u(A)
              ]),
              onClick: (R) => S(A)
            }, [
              A.icon && !d(A) ? (c(), g("i", {
                key: 0,
                class: C([A.icon, "text-(length:--icon-size-sm) leading-none"]),
                "aria-hidden": "true"
              }, null, 2)) : k("", !0),
              v("span", X7, P(A.label), 1),
              d(A) ? (c(), g("i", Q7)) : k("", !0)
            ], 10, Z7)
          ]),
          _: 2
        }, 1032, ["class", "text", "disabled", "position"]))), 128))
      ], 16, J7),
      I(x).showArrow.value ? (c(), g("button", {
        key: 1,
        ref_key: "arrowRef",
        ref: h,
        type: "button",
        "aria-label": e.overflowLabel,
        "data-testid": "nav-tabs-overflow-arrow",
        class: C(o("right-0")),
        onClick: L[2] || (L[2] = //@ts-ignore
        (...A) => I(x).scrollForward && I(x).scrollForward(...A))
      }, [...L[4] || (L[4] = [
        v("i", {
          class: "ri-arrow-right-line text-(length:--icon-size-sm) leading-(--icon-size-sm)",
          "aria-hidden": "true"
        }, null, -1)
      ])], 10, _7)) : k("", !0)
    ], 6));
  }
}), aU = /* @__PURE__ */ lt(tH, [["__scopeId", "data-v-a1f63d2d"]]), mb = /* @__PURE__ */ ye({
  __name: "StepperWizardPhaseIcon",
  props: {
    icon: {},
    disabled: { type: Boolean }
  },
  setup(e) {
    return (n, t) => (c(), K(Xt, {
      size: "md",
      type: "circle",
      variant: "outlined",
      color: e.disabled ? "disabled" : "white",
      icon: e.icon
    }, null, 8, ["color", "icon"]));
  }
}), nH = ["data-testid", "aria-current", "aria-disabled", "onClick"], aH = { class: "truncate" }, lH = ["data-testid", "aria-expanded", "aria-disabled", "onClick"], rH = { class: "flex items-center gap-3 truncate" }, oH = { class: "truncate" }, iH = ["data-testid", "aria-current", "aria-disabled", "onClick"], sH = {
  key: 1,
  class: "h-6 w-9 shrink-0",
  "aria-hidden": "true"
}, dH = { class: "py-0.5" }, vb = "flex items-center gap-3 p-1 w-full text-left rounded-(--border-border-radius-rounded-xs) text-base font-medium leading-6", lU = /* @__PURE__ */ ye({
  __name: "StepperWizardSidenav",
  props: {
    groups: {},
    currentStepId: {},
    showStatusIcons: { type: Boolean },
    showPhaseIcons: { type: Boolean }
  },
  emits: ["step-click", "group-toggle"],
  setup(e, { emit: n }) {
    function t(h, m) {
      if (h) return "text-(--text-text-disabled-light) cursor-not-allowed";
      const x = "text-(--text-text-heading) transition-colors";
      return m ? `${x} bg-[image:var(--gradient-brand-row-highlight)]` : `${x} hover:bg-[image:var(--gradient-brand-row-highlight)]`;
    }
    const a = e, l = n, r = rl({});
    function o() {
      for (const h of a.groups)
        h.steps.length > 0 && (r[h.id] = h.defaultExpanded ?? !0);
    }
    o(), Ie(
      () => a.groups,
      (h) => {
        for (const m of h)
          m.steps.length > 0 && !(m.id in r) && (r[m.id] = m.defaultExpanded ?? !0);
      },
      { deep: !1 }
    );
    const i = p(() => {
      var h;
      if (a.currentStepId)
        return (h = a.groups.find(
          (m) => m.steps.some((x) => x.id === a.currentStepId)
        )) == null ? void 0 : h.id;
    });
    Ie(
      i,
      (h) => {
        h && (r[h] = !0);
      },
      { immediate: !0 }
    );
    function s(h, m) {
      return m != null && m.disabled ? "disabled" : h.id === a.currentStepId ? "current" : h.state ?? "upcoming";
    }
    function d(h) {
      switch (h) {
        case "done":
          return "ri-checkbox-circle-fill";
        case "current":
          return "ri-checkbox-circle-line";
        case "disabled":
          return "ri-checkbox-blank-circle-line";
        case "upcoming":
        default:
          return "ri-checkbox-blank-circle-line";
      }
    }
    function u(h) {
      l("step-click", h);
    }
    function f(h) {
      if (i.value === h) return;
      const m = !r[h];
      r[h] = m, l("group-toggle", h, m);
    }
    function b(h, m) {
      m != null && m.disabled || h.state !== "disabled" && (h.id, a.currentStepId, l("step-click", h.id));
    }
    return (h, m) => (c(), g("nav", {
      role: "navigation",
      class: C(["flex flex-col gap-3 pb-1.5 w-full min-w-72", h.$attrs.class])
    }, [
      (c(!0), g(se, null, Me(e.groups, (x) => (c(), g("div", {
        key: x.id,
        class: "flex flex-col gap-2 pr-1.5"
      }, [
        x.steps.length === 0 ? (c(), K(ft, {
          key: 0,
          class: "w-full",
          text: x.lockTooltip ?? "",
          disabled: !x.disabled || !x.lockTooltip,
          position: "bottom"
        }, {
          default: ve(() => [
            v("button", {
              type: "button",
              "data-testid": `sw-step-${x.id}`,
              "aria-current": x.id === e.currentStepId ? "step" : void 0,
              "aria-disabled": x.disabled ? "true" : void 0,
              class: C([vb, t(x.disabled, x.id === e.currentStepId)]),
              onClick: (y) => !x.disabled && u(x.id)
            }, [
              e.showPhaseIcons && x.icon ? (c(), K(mb, {
                key: 0,
                icon: x.icon,
                disabled: x.disabled
              }, null, 8, ["icon", "disabled"])) : k("", !0),
              v("span", aH, P(x.label), 1)
            ], 10, nH)
          ]),
          _: 2
        }, 1032, ["text", "disabled"])) : (c(), g(se, { key: 1 }, [
          te(ft, {
            class: "w-full",
            text: x.lockTooltip ?? "",
            disabled: !x.disabled || !x.lockTooltip,
            position: "bottom"
          }, {
            default: ve(() => [
              v("button", {
                type: "button",
                "data-testid": `sw-group-${x.id}`,
                "aria-expanded": r[x.id],
                "aria-disabled": x.disabled ? "true" : void 0,
                class: C([
                  vb,
                  "justify-between",
                  t(x.disabled, i.value === x.id)
                ]),
                onClick: (y) => !x.disabled && f(x.id)
              }, [
                v("span", rH, [
                  e.showPhaseIcons && x.icon ? (c(), K(mb, {
                    key: 0,
                    icon: x.icon,
                    disabled: x.disabled
                  }, null, 8, ["icon", "disabled"])) : k("", !0),
                  v("span", oH, P(x.label), 1)
                ]),
                v("i", {
                  class: C([
                    "ri-arrow-down-s-line text-xl shrink-0 transition-transform",
                    r[x.id] ? "-rotate-180" : ""
                  ]),
                  "aria-hidden": "true"
                }, null, 2)
              ], 10, lH)
            ]),
            _: 2
          }, 1032, ["text", "disabled"]),
          r[x.id] ? (c(!0), g(se, { key: 0 }, Me(x.steps, (y) => (c(), K(ft, {
            key: y.id,
            class: "w-full",
            text: y.lockTooltip ?? "",
            disabled: s(y, x) !== "disabled" || !y.lockTooltip,
            position: "bottom"
          }, {
            default: ve(() => [
              v("button", {
                type: "button",
                "data-testid": `sw-step-${y.id}`,
                "aria-current": s(y, x) === "current" ? "step" : void 0,
                "aria-disabled": s(y, x) === "disabled" ? "true" : void 0,
                class: C([
                  "flex items-start gap-3 px-1 w-full text-left text-sm font-medium leading-5",
                  s(y, x) === "disabled" ? "text-(--text-text-disabled-strong) cursor-not-allowed" : s(y, x) === "current" ? "text-(--text-text-hover)" : "text-(--text-text-body) hover:text-(--text-text-hover) transition-colors"
                ]),
                onClick: (w) => b(y, x)
              }, [
                e.showStatusIcons ? (c(), g("i", {
                  key: 0,
                  class: C([d(s(y, x)), "text-xl shrink-0"]),
                  "aria-hidden": "true"
                }, null, 2)) : (c(), g("span", sH)),
                v("span", dH, P(y.label), 1)
              ], 10, iH)
            ]),
            _: 2
          }, 1032, ["text", "disabled"]))), 128)) : k("", !0)
        ], 64))
      ]))), 128))
    ], 2));
  }
}), uH = {
  "data-testid": "segmented-pager",
  role: "group",
  class: "inline-flex items-center shadow-(--blur-shadow-xs)"
}, rU = /* @__PURE__ */ ye({
  __name: "SegmentedPager",
  props: {
    prevLabel: {},
    nextLabel: {},
    prevDisabled: { type: Boolean, default: !1 },
    nextDisabled: { type: Boolean, default: !1 }
  },
  emits: ["prev", "next"],
  setup(e, { emit: n }) {
    const t = n;
    return (a, l) => (c(), g("div", uH, [
      te(Re, {
        variant: "secondary",
        size: "md",
        "icon-left": "ri-arrow-left-s-line",
        label: e.prevLabel,
        disabled: e.prevDisabled,
        "data-testid": "segmented-pager-prev",
        class: C(I(Av)),
        onClick: l[0] || (l[0] = (r) => t("prev"))
      }, null, 8, ["label", "disabled", "class"]),
      te(Re, {
        variant: "secondary",
        size: "md",
        "icon-right": "ri-arrow-right-s-line",
        label: e.nextLabel,
        disabled: e.nextDisabled,
        "data-testid": "segmented-pager-next",
        class: C(I(Rv)),
        onClick: l[1] || (l[1] = (r) => t("next"))
      }, null, 8, ["label", "disabled", "class"])
    ]));
  }
}), cH = {
  role: "status",
  "aria-live": "polite",
  class: "sr-only"
}, fH = {
  key: 0,
  "data-testid": "actions-status",
  role: "status",
  "aria-live": "polite",
  class: "sr-only"
}, hH = ["aria-label"], bH = { class: "inline-flex items-center gap-3.5 shrink-0 ml-[50px]" }, gH = {
  key: 0,
  "data-testid": "actions-loading",
  class: "flex items-center gap-2 px-2 shrink-0",
  "aria-hidden": "true"
}, pH = ["inert"], mH = { class: "hidden sm:inline" }, yd = 640, xb = 560, vH = 960, kd = 20, xH = "__untagged__", yH = /* @__PURE__ */ ye({
  __name: "FloatActionBar",
  props: {
    selectionCount: {},
    allPagesSelected: { type: Boolean },
    totalAcrossAllPages: {},
    actions: {},
    maxVisibleActions: { default: 4 },
    isLoading: { type: Boolean, default: !1 },
    actionsLoading: { type: Boolean, default: !1 },
    actionsError: { type: Boolean, default: !1 },
    moduleLabels: { default: void 0 },
    ariaLabel: {},
    selectedItemLabel: {},
    selectedItemsLabel: {},
    selectAllPagesLabel: {},
    moreLabel: {},
    moreActionsTitle: {},
    totalUnavailableLabel: {},
    selectionClearedLabel: {},
    actionsLoadingLabel: { default: void 0 }
  },
  emits: ["dismiss", "action-click", "select-all-pages"],
  setup(e, { emit: n }) {
    const t = e, a = n, l = {
      primary: "primary",
      secondary: "secondary",
      text: "tertiary",
      destructive: "error-text"
    };
    function r(fe) {
      return fe.variant ? l[fe.variant] : fe.destructive ? "error-text" : "tertiary";
    }
    function o(fe) {
      return fe.variant === "destructive" || fe.destructive === !0;
    }
    function i(fe) {
      return fe.disabled ? fe.disabledReason : void 0;
    }
    const s = p(() => t.actions.some((fe) => fe.order !== void 0) ? t.actions.map((fe, de) => ({ action: fe, index: de })).sort(
      (fe, de) => (fe.action.order ?? Number.MAX_SAFE_INTEGER) - (de.action.order ?? Number.MAX_SAFE_INTEGER) || fe.index - de.index
    ).map((fe) => fe.action) : t.actions), d = p(
      () => t.actionsLoading || t.actionsError ? [] : s.value
    ), u = p(
      () => d.value.filter((fe) => fe.placement !== "overflow")
    ), f = E(typeof window < "u" ? window.innerWidth : 1024);
    function b() {
      f.value = window.innerWidth, B.value !== null && (B.value = N(B.value)), requestAnimationFrame(w);
    }
    ot(() => window.addEventListener("resize", b)), kt(() => window.removeEventListener("resize", b));
    const h = E(null), m = E([]), x = E(t.actions.length);
    function y(fe) {
      return (de) => {
        m.value[fe] = de instanceof HTMLElement ? de : null;
      };
    }
    function w() {
      const fe = h.value;
      if (!fe) {
        x.value = u.value.length;
        return;
      }
      const de = fe.getBoundingClientRect().right, ne = m.value.findIndex(
        (le) => le && le.getBoundingClientRect().right > de + 1
      );
      x.value = ne === -1 ? u.value.length : ne;
    }
    let S = null;
    Ie(
      h,
      (fe) => {
        S == null || S.disconnect(), fe && (S ?? (S = new ResizeObserver(() => requestAnimationFrame(w))), S.observe(fe), requestAnimationFrame(w));
      },
      { flush: "post", immediate: !0 }
    ), kt(() => S == null ? void 0 : S.disconnect());
    const $ = p(
      () => u.value.map((fe) => `${fe.id}${fe.label}${fe.icon ?? ""}`).join("\0")
    );
    Ie($, () => requestAnimationFrame(w));
    const T = p(() => f.value < yd ? 0 : Math.min(x.value, t.maxVisibleActions));
    function L(fe) {
      return fe >= t.maxVisibleActions || f.value < yd ? "hidden" : fe >= T.value ? "invisible" : "";
    }
    const A = p(() => {
      const fe = new Set(
        u.value.slice(0, T.value).map((de) => de.id)
      );
      return d.value.filter((de) => !fe.has(de.id));
    }), R = p(() => A.value.length > 0);
    Ie(
      () => A.value.length,
      (fe) => {
        fe > kd && console.warn(
          `[FloatActionBar] More menu has ${fe} actions; only the first ${kd} are rendered.`
        );
      },
      { immediate: !0 }
    );
    const z = p(
      () => A.value.slice(0, kd)
    );
    function D(fe) {
      return {
        label: fe.label,
        icon: fe.icon,
        danger: o(fe),
        disabled: fe.disabled || t.isLoading,
        loading: fe.loading,
        // Keeps the disabled reason keyboard-reachable inside the menu: DropdownItemButton
        // switches to aria-disabled (focusable) whenever an item carries a tooltip (R74).
        tooltip: i(fe),
        testId: "megamenu-nav-link",
        onClick: () => a("action-click", fe.id, j.value)
      };
    }
    const V = p(
      () => z.value.map(D)
    ), Y = p(() => {
      const fe = [
        ...new Set(
          z.value.map((le) => le.module).filter((le) => !!le)
        )
      ], de = z.value.filter((le) => !le.module);
      if (fe.length + (de.length > 0 ? 1 : 0) < 2) return;
      const ne = fe.map((le) => {
        var Le;
        return {
          key: le,
          // No fallback to the raw key: it is an identifier, and rendering it would ship
          // untranslated text to fr/nl users (R29). A heading-less column is the safe default.
          label: (Le = t.moduleLabels) == null ? void 0 : Le[le],
          items: z.value.filter((Te) => Te.module === le).map(D)
        };
      });
      return de.length > 0 && ne.push({ key: xH, items: de.map(D) }), ne;
    }), _ = p(() => {
      const fe = f.value < vH ? 2 : 4;
      return Y.value ? fe : fe === 2 ? 2 : A.value.length > 10 ? 4 : 2;
    }), j = p(() => ({
      selectedCount: t.selectionCount,
      allPagesSelected: t.allPagesSelected,
      totalCount: t.totalAcrossAllPages
    })), M = p(
      () => t.allPagesSelected && t.totalAcrossAllPages !== void 0 ? t.totalAcrossAllPages : t.selectionCount
    ), W = p(
      () => M.value === 1 ? t.selectedItemLabel : t.selectedItemsLabel
    ), G = E(null), B = E(null), F = E(!1);
    let X = 0, H = 0;
    function q() {
      var fe;
      return ((fe = G.value) == null ? void 0 : fe.offsetWidth) ?? 0;
    }
    function N(fe) {
      return Math.max(16, Math.min(fe, window.innerWidth - q() - 16));
    }
    function J(fe) {
      G.value && (F.value = !0, X = fe.clientX, H = B.value ?? (window.innerWidth - q()) / 2, fe.preventDefault());
    }
    function be(fe) {
      F.value && (B.value = N(H + (fe.clientX - X)));
    }
    function ke() {
      F.value = !1;
    }
    ot(() => {
      window.addEventListener("mousemove", be), window.addEventListener("mouseup", ke);
    }), kt(() => {
      window.removeEventListener("mousemove", be), window.removeEventListener("mouseup", ke);
    });
    const ee = E(null), oe = E(null), ge = E([]);
    function re(fe) {
      return (de) => {
        ge.value[fe] = de ?? null;
      };
    }
    function ue() {
      var fe;
      return (fe = oe.value) != null && fe.isVisible ? oe.value : ge.value.find((de) => de == null ? void 0 : de.isVisible) ?? null;
    }
    const O = Symbol("float-action-bar");
    function U(fe) {
      var ne, le;
      if (fe.key !== "Escape" || (ne = ee.value) != null && ne.isOpen) return;
      const de = ue();
      if (de) {
        fe.stopPropagation(), fe.preventDefault(), de.hide();
        return;
      }
      Q.value && Va(O) && (fe.preventDefault(), fe.target instanceof Node && ((le = G.value) != null && le.contains(fe.target)) && fe.stopPropagation(), a("dismiss"));
    }
    ot(() => window.addEventListener("keydown", U, !0)), kt(() => {
      window.removeEventListener("keydown", U, !0), An(O);
    });
    const Q = p(() => t.selectionCount > 0);
    let ae = null;
    Ie(
      Q,
      (fe) => fe ? Zn(O) : An(O)
    );
    let Z = !1;
    ot(() => {
      Z = !0, qe(() => {
        Z && Q.value && Zn(O);
      });
    }), kt(() => {
      Z = !1;
    }), Ie(Q, (fe) => {
      var de;
      if (fe) {
        ae = document.activeElement instanceof HTMLElement && document.activeElement !== document.body ? document.activeElement : null;
        return;
      }
      (de = G.value) != null && de.contains(document.activeElement) && ae && document.contains(ae) && ae.focus();
    });
    const ie = E("");
    return Ie(
      () => [t.selectionCount, t.allPagesSelected, t.totalAcrossAllPages],
      ([fe], de) => {
        const ne = de == null ? void 0 : de[0];
        fe > 0 ? ie.value = `${M.value} ${W.value}` : ne !== void 0 && ne > 0 && (ie.value = t.selectionClearedLabel);
      },
      { immediate: !0 }
    ), (fe, de) => (c(), g(se, null, [
      v("span", cH, P(ie.value), 1),
      e.actionsLoadingLabel ? (c(), g("span", fH, P(e.actionsLoading ? e.actionsLoadingLabel : ""), 1)) : k("", !0),
      te(wt, {
        name: "float-bar",
        appear: ""
      }, {
        default: ve(() => [
          e.selectionCount > 0 ? (c(), g("div", {
            key: 0,
            ref_key: "barRef",
            ref: G,
            "data-testid": "float-action-bar",
            role: "toolbar",
            "aria-label": e.ariaLabel,
            class: "inline-flex items-center gap-3.5 p-1.5 rounded-full overflow-hidden z-40 bg-(--background-background-black-default) shadow-(--shadow-float-bar)",
            style: Ne({
              position: "fixed",
              bottom: "24px",
              left: B.value !== null ? `${B.value}px` : "16px",
              right: B.value !== null ? void 0 : "16px",
              width: B.value !== null ? void 0 : "fit-content",
              margin: B.value !== null ? void 0 : "0 auto",
              maxWidth: "calc(100vw - 32px)",
              cursor: F.value ? "grabbing" : void 0
            })
          }, [
            v("button", {
              "data-testid": "drag-handle",
              tabindex: "-1",
              "aria-hidden": "true",
              class: "absolute left-1.5 top-1/2 -translate-y-1/2 flex items-center justify-center size-9 rounded-full bg-transparent border-none cursor-grab focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-1 focus-visible:ring-(--border-border-accent)",
              onMousedown: J,
              onClick: de[0] || (de[0] = Ue(() => {
              }, ["prevent"]))
            }, [...de[3] || (de[3] = [
              v("i", {
                class: "ri-draggable text-[20px] leading-none text-(--icons-icon-white-default)",
                "aria-hidden": "true"
              }, null, -1)
            ])], 32),
            v("div", bH, [
              te(Re, {
                "data-testid": "selection-count",
                variant: "secondary",
                size: "xs",
                label: f.value >= xb ? `${M.value} ${W.value}` : `${M.value}`,
                "icon-right": "ri-close-line",
                "aria-label": `${M.value} ${W.value}`,
                class: "shrink-0",
                onClick: de[1] || (de[1] = (ne) => a("dismiss"))
              }, null, 8, ["label", "aria-label"]),
              te(ft, {
                ref_key: "selectAllTooltipRef",
                ref: oe,
                text: e.totalUnavailableLabel,
                disabled: e.totalAcrossAllPages !== void 0,
                tabindex: e.totalAcrossAllPages === void 0 ? 0 : void 0
              }, {
                default: ve(() => [
                  te(Cn, {
                    variant: "dark",
                    "model-value": e.allPagesSelected,
                    label: f.value >= xb ? e.selectAllPagesLabel : "",
                    "aria-label": e.selectAllPagesLabel,
                    disabled: e.totalAcrossAllPages === void 0,
                    class: "px-1 shrink-0 w-auto!",
                    "onUpdate:modelValue": de[2] || (de[2] = (ne) => a("select-all-pages", ne))
                  }, null, 8, ["model-value", "label", "aria-label", "disabled"])
                ]),
                _: 1
              }, 8, ["text", "disabled", "tabindex"]),
              de[4] || (de[4] = v("span", {
                class: "hidden sm:block w-px h-4 shrink-0 opacity-30 bg-(--text-text-white-default)",
                "aria-hidden": "true"
              }, null, -1))
            ]),
            v("div", {
              ref_key: "btnAreaRef",
              ref: h,
              "data-testid": "action-buttons-area",
              class: "dark flex items-center overflow-hidden min-w-0"
            }, [
              e.actionsLoading ? (c(), g("div", gH, [...de[5] || (de[5] = [
                v("i", { class: "ri-loader-4-line animate-spin text-base leading-none text-(--icons-icon-white-default)" }, null, -1),
                v("span", { class: "h-2 w-16 rounded-full bg-(--text-text-white-default) opacity-30" }, null, -1),
                v("span", { class: "h-2 w-10 rounded-full bg-(--text-text-white-default) opacity-30" }, null, -1)
              ])])) : k("", !0),
              (c(!0), g(se, null, Me(u.value, (ne, le) => (c(), g("div", {
                key: ne.id,
                ref_for: !0,
                ref: y(le),
                class: C(["shrink-0", L(le)]),
                inert: le >= T.value || void 0
              }, [
                te(ft, {
                  ref_for: !0,
                  ref: re(le),
                  text: i(ne) ?? "",
                  disabled: !i(ne),
                  tabindex: i(ne) ? 0 : void 0
                }, {
                  default: ve(() => [
                    te(Re, {
                      "data-testid": `action-btn-${ne.id}`,
                      variant: r(ne),
                      size: "xs",
                      "icon-left": ne.icon,
                      "icon-only": f.value < yd,
                      loading: ne.loading,
                      disabled: ne.disabled || e.isLoading,
                      "aria-label": ne.label,
                      onClick: (Le) => a("action-click", ne.id, j.value)
                    }, {
                      default: ve(() => [
                        v("span", mH, P(ne.label), 1)
                      ]),
                      _: 2
                    }, 1032, ["data-testid", "variant", "icon-left", "icon-only", "loading", "disabled", "aria-label", "onClick"])
                  ]),
                  _: 2
                }, 1032, ["text", "disabled", "tabindex"])
              ], 10, pH))), 128))
            ], 512),
            R.value ? (c(), K(Sn, {
              key: 0,
              ref_key: "dropdownRef",
              ref: ee,
              class: "shrink-0",
              "menu-item-variant": "nav",
              items: V.value,
              groups: Y.value,
              columns: _.value,
              "menu-header": e.moreActionsTitle,
              closeable: "",
              "close-label": e.moreLabel,
              "menu-align": "right",
              "menu-offset": 10
            }, {
              trigger: ve(({ triggerProps: ne }) => [
                te(Re, Oe({
                  "data-testid": "more-btn",
                  variant: "secondary",
                  size: "xs",
                  "icon-left": "ri-more-line",
                  label: e.moreLabel,
                  class: "shrink-0"
                }, ne), null, 16, ["label"])
              ]),
              _: 1
            }, 8, ["items", "groups", "columns", "menu-header", "close-label"])) : k("", !0)
          ], 12, hH)) : k("", !0)
        ]),
        _: 1
      })
    ], 64));
  }
}), oU = /* @__PURE__ */ lt(yH, [["__scopeId", "data-v-0ea1f938"]]);
function iU(e, n = {}) {
  const t = Qr([]), a = E(!1), l = E(!1), r = E(null), o = E(void 0);
  let i = 0;
  async function s() {
    const d = ++i;
    a.value = !0, l.value = !1, r.value = null, t.value = [];
    try {
      const u = await e();
      if (d !== i) return;
      t.value = (u == null ? void 0 : u.actions) ?? [], o.value = u == null ? void 0 : u.version;
    } catch (u) {
      if (d !== i) return;
      l.value = !0, r.value = u, t.value = [];
    } finally {
      d === i && (a.value = !1);
    }
  }
  return n.immediate !== !1 && s(), { actions: t, isLoading: a, hasError: l, error: r, version: o, load: s };
}
const kH = {
  "data-testid": "field-skeleton",
  "aria-hidden": "true",
  class: "w-full"
}, wH = {
  key: 0,
  class: "flex items-center gap-2"
}, CH = {
  key: 0,
  class: "h-5 pb-0.5 flex items-center"
}, SH = /* @__PURE__ */ ye({
  __name: "FieldSkeleton",
  props: {
    variant: { default: "input" },
    size: { default: "md" },
    showLabel: { type: Boolean, default: !0 }
  },
  setup(e) {
    const n = {
      sm: "h-[32px]",
      md: "h-[36px]",
      lg: "h-[48px]",
      xl: "h-[52px]"
    };
    return (t, a) => (c(), g("div", kH, [
      e.variant === "checkbox" || e.variant === "toggle" ? (c(), g("div", wH, [
        v("div", {
          class: C([
            "skeleton shrink-0",
            e.variant === "toggle" ? "h-5 w-9 rounded-full" : "size-4 rounded"
          ])
        }, null, 2),
        a[0] || (a[0] = v("div", { class: "skeleton h-2.5 w-24 rounded-full" }, null, -1))
      ])) : (c(), g(se, { key: 1 }, [
        e.showLabel ? (c(), g("div", CH, [...a[1] || (a[1] = [
          v("div", { class: "skeleton h-2.5 w-24 rounded-full" }, null, -1)
        ])])) : k("", !0),
        v("div", {
          class: C([
            "skeleton w-full rounded-xl",
            e.variant === "textarea" ? "h-24" : n[e.size]
          ])
        }, null, 2)
      ], 64))
    ]));
  }
}), sU = /* @__PURE__ */ ye({
  __name: "FormSkeleton",
  props: {
    fields: { default: 6 },
    columns: { default: 2 },
    size: { default: "md" },
    showLabels: { type: Boolean, default: !0 }
  },
  setup(e) {
    return (n, t) => (c(), g("div", {
      "data-testid": "form-skeleton",
      "aria-hidden": "true",
      class: C(["grid gap-x-5 gap-y-4", e.columns === 2 ? "grid-cols-2" : "grid-cols-1"])
    }, [
      (c(!0), g(se, null, Me(e.fields, (a) => (c(), K(SH, {
        key: `form-skeleton-field-${a}`,
        size: e.size,
        "show-label": e.showLabels
      }, null, 8, ["size", "show-label"]))), 128))
    ], 2));
  }
}), $H = {
  class: "flex flex-col gap-(--spacing-3)",
  "data-testid": "color-picker-palette"
}, IH = { class: "flex min-w-0 flex-1 rounded-(--border-border-radius-rounded-xs) border border-solid border-(--border-border-base-soft) bg-(--background-background-white) p-[calc(var(--spacing-1)-1px)]" }, TH = { class: "whitespace-nowrap text-(length:--size-m) leading-(--line-height-l) font-(--weight-medium) text-(--colors-text-body)" }, LH = ["aria-label"], EH = ["aria-label", "aria-selected", "tabindex", "data-listbox-index", "onClick", "onFocus"], Po = 6, AH = /* @__PURE__ */ ye({
  __name: "ColorPickerPalette",
  props: {
    swatches: {},
    modelValue: {},
    labels: {},
    showReset: { type: Boolean }
  },
  emits: ["select", "reset", "custom"],
  setup(e, { expose: n, emit: t }) {
    const a = e, l = t, r = E(null), o = p(
      () => a.modelValue ? a.swatches.findIndex((h) => h.hex === a.modelValue) : -1
    ), i = E(Math.max(0, o.value));
    Ie(
      () => a.swatches.length,
      (h) => {
        i.value >= h && (i.value = Math.max(0, h - 1));
      }
    );
    function s() {
      const h = a.swatches[i.value];
      h && l("select", h.hex);
    }
    function d(h) {
      var m, x;
      i.value = h, (x = (m = r.value) == null ? void 0 : m.querySelector(`[data-listbox-index="${h}"]`)) == null || x.focus();
    }
    function u() {
      i.value = Math.max(0, o.value), qe(() => d(i.value));
    }
    function f(h) {
      const m = a.swatches.length - 1, x = i.value;
      let y;
      switch (h.key) {
        case "ArrowRight":
          y = Math.min(m, x + 1);
          break;
        case "ArrowLeft":
          y = Math.max(0, x - 1);
          break;
        case "ArrowDown":
          y = x + Po <= m ? x + Po : x;
          break;
        case "ArrowUp":
          y = x - Po >= 0 ? x - Po : x;
          break;
        case "Home":
          y = 0;
          break;
        case "End":
          y = m;
          break;
        case "Enter":
          h.preventDefault(), s();
          return;
        case " ":
          h.preventDefault();
          return;
        default:
          return;
      }
      h.preventDefault(), h.stopPropagation(), d(y);
    }
    function b(h) {
      h.key === " " && (h.preventDefault(), s());
    }
    return n({ focusInitial: u }), (h, m) => (c(), g("div", $H, [
      v("button", {
        type: "button",
        class: "flex w-full items-center gap-(--spacing-2) rounded-(--border-border-radius-rounded-xs) cursor-pointer focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-(--border-border-accent)",
        "data-testid": "color-picker-custom",
        onClick: m[0] || (m[0] = (x) => l("custom"))
      }, [
        v("span", IH, [
          v("span", {
            class: "h-(--spacing-6) w-full rounded-(--border-border-radius-rounded-xxs)",
            style: Ne({ backgroundColor: e.modelValue ?? "transparent" }),
            "data-testid": "color-picker-palette-preview"
          }, null, 4)
        ]),
        v("span", TH, P(e.labels.pickColor), 1)
      ]),
      v("div", {
        ref_key: "listboxRef",
        ref: r,
        role: "listbox",
        "aria-label": e.labels.palette,
        class: "grid w-fit grid-cols-6 gap-(--spacing-1)",
        "data-testid": "color-picker-swatches",
        onKeydown: f,
        onKeyup: b
      }, [
        (c(!0), g(se, null, Me(e.swatches, (x, y) => (c(), g("div", {
          key: y,
          role: "option",
          "aria-label": x.name,
          "aria-selected": y === o.value ? "true" : "false",
          tabindex: y === i.value ? 0 : -1,
          "data-listbox-index": y,
          class: C([
            "size-(--spacing-6) rounded-(--border-border-radius-rounded-xs) border border-solid cursor-pointer focus-visible:outline-none focus-visible:border-(--border-border-accent) focus-visible:shadow-[0px_0px_2px_0px_var(--background-background-hover)]",
            // Selected mark reuses the Button focus treatment: accent border + soft glow.
            y === o.value ? "border-(--border-border-accent) shadow-[0px_0px_2px_0px_var(--background-background-hover)]" : "border-(--border-border-base-soft)"
          ]),
          style: Ne({ backgroundColor: x.hex }),
          "data-testid": "color-picker-swatch",
          onClick: (w) => l("select", x.hex),
          onFocus: (w) => i.value = y
        }, null, 46, EH))), 128))
      ], 40, LH),
      e.showReset ? (c(), K(Re, {
        key: 0,
        class: "self-center",
        variant: "ghost",
        size: "xs",
        "icon-left": "ri-restart-line",
        label: e.labels.resetColor,
        "data-testid": "color-picker-reset",
        onClick: m[1] || (m[1] = (x) => l("reset"))
      }, null, 8, ["label"])) : k("", !0)
    ]));
  }
}), Wn = (e, n, t) => Math.min(t, Math.max(n, e));
function oa(e) {
  const n = e.trim().replace(/^#/, "");
  return /^[0-9a-f]{3}$/i.test(n) ? `#${n.split("").map((t) => t + t).join("").toUpperCase()}` : /^[0-9a-f]{6}$/i.test(n) ? `#${n.toUpperCase()}` : null;
}
function RH(e) {
  const n = oa(e) ?? "#000000", t = parseInt(n.slice(1), 16);
  return { r: t >> 16 & 255, g: t >> 8 & 255, b: t & 255 };
}
function yb({ r: e, g: n, b: t }) {
  const a = (l) => Math.round(Wn(l, 0, 255)).toString(16).padStart(2, "0");
  return `#${a(e)}${a(n)}${a(t)}`.toUpperCase();
}
function yu({ r: e, g: n, b: t }) {
  const a = e / 255, l = n / 255, r = t / 255, o = Math.max(a, l, r), i = o - Math.min(a, l, r);
  let s = 0;
  return i !== 0 && (o === a ? s = (l - r) / i % 6 : o === l ? s = (r - a) / i + 2 : s = (a - l) / i + 4, s = (s * 60 + 360) % 360), { h: s, s: o === 0 ? 0 : i / o * 100, v: o * 100 };
}
function Fo({ h: e, s: n, v: t }) {
  const a = Wn(n, 0, 100) / 100, l = Wn(t, 0, 100) / 100, r = (o) => {
    const i = (o + (e % 360 + 360) / 60) % 6;
    return l - l * a * Math.max(0, Math.min(i, 4 - i, 1));
  };
  return { r: Math.round(r(5) * 255), g: Math.round(r(3) * 255), b: Math.round(r(1) * 255) };
}
function kb({ r: e, g: n, b: t }) {
  const a = e / 255, l = n / 255, r = t / 255, o = Math.max(a, l, r), i = Math.min(a, l, r), s = (o + i) / 2, d = o - i, u = d === 0 ? 0 : d / (1 - Math.abs(2 * s - 1));
  return { h: yu({ r: e, g: n, b: t }).h, s: u * 100, l: s * 100 };
}
function BH({ h: e, s: n, l: t }) {
  const a = Wn(n, 0, 100) / 100, l = Wn(t, 0, 100) / 100, r = a * Math.min(l, 1 - l), o = (i) => {
    const s = (i + (e % 360 + 360) / 30) % 12;
    return l - r * Math.max(-1, Math.min(s - 3, 9 - s, 1));
  };
  return { r: Math.round(o(0) * 255), g: Math.round(o(8) * 255), b: Math.round(o(4) * 255) };
}
const MH = {
  class: "flex flex-col gap-(--spacing-3)",
  "data-testid": "color-picker-spectrum"
}, DH = ["value", "aria-label", "aria-valuetext"], zH = ["value", "aria-label", "aria-valuetext"], OH = { class: "flex items-center gap-(--spacing-2)" }, PH = ["aria-label"], FH = ["value", "aria-label", "aria-valuetext"], VH = { class: "flex items-end gap-(--spacing-1)" }, NH = { class: "flex min-w-0 flex-1 gap-(--spacing-2)" }, HH = { class: "flex w-[69px] shrink-0 flex-col items-center gap-[10px]" }, jH = ["id", "value", "onKeydown"], WH = ["for"], qH = ["id", "value", "aria-label", "data-testid", "onInput", "onKeydown"], UH = ["for"], GH = ["aria-label"], wb = "h-(--spacing-9) w-full min-w-0 rounded-(--border-border-radius-rounded-sm) border border-solid border-(--border-border-base-soft) bg-transparent px-(--spacing-1) text-center text-(length:--size-sm) leading-(--line-height-l) font-(--weight-medium) text-(--colors-text-heading) focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-(--border-border-accent)", Cb = "text-(length:--size-m) leading-(--line-height-l) font-(--weight-medium) text-(--colors-text-heading)", KH = /* @__PURE__ */ ye({
  __name: "ColorPickerSpectrum",
  props: {
    modelValue: {},
    labels: {}
  },
  emits: ["update", "commit"],
  setup(e, { expose: n, emit: t }) {
    const a = e, l = t, r = Ve(), o = E(null), i = E(null), s = E(null), d = E(null), u = E({ h: 0, s: 100, v: 100 }), f = p(() => yb(Fo(u.value))), b = p(() => `hsl(${u.value.h} 100% 50%)`);
    function h(ee) {
      if (!ee || oa(ee) === f.value) return;
      const oe = yu(RH(ee));
      u.value = oe.s === 0 || oe.v === 0 ? { ...oe, h: u.value.h } : oe;
    }
    Ie(() => a.modelValue, h, { immediate: !0 });
    function m(ee) {
      u.value = { ...u.value, ...ee }, l("update", f.value);
    }
    function x(ee) {
      h(ee), l("update", f.value);
    }
    const y = E(null);
    function w(ee, oe) {
      const ge = oe.getBoundingClientRect();
      return {
        x: ge.width ? Wn((ee.clientX - ge.left) / ge.width, 0, 1) : 0,
        y: ge.height ? Wn((ee.clientY - ge.top) / ge.height, 0, 1) : 0
      };
    }
    function S(ee) {
      if (y.value === "area" && o.value) {
        const { x: oe, y: ge } = w(ee, o.value);
        m({ s: oe * 100, v: (1 - ge) * 100 });
      } else y.value === "hue" && i.value && m({ h: w(ee, i.value).x * 360 });
    }
    function $(ee, oe) {
      var ge, re, ue;
      oe.preventDefault(), y.value = ee, (re = (ge = oe.currentTarget).setPointerCapture) == null || re.call(ge, oe.pointerId), S(oe), (ue = (ee === "area" ? s : d).value) == null || ue.focus();
    }
    function T(ee) {
      y.value && S(ee);
    }
    function L() {
      y.value && (y.value = null, l("commit"));
    }
    function A(ee, oe, ge) {
      if (!ee.shiftKey) return;
      const re = { ArrowRight: 10, ArrowUp: 10, ArrowLeft: -10, ArrowDown: -10 }[ee.key];
      re !== void 0 && (ee.preventDefault(), m({ [oe]: Wn(u.value[oe] + re, 0, ge) }), l("commit"));
    }
    const R = {
      ArrowRight: ["s", 1],
      ArrowLeft: ["s", -1],
      ArrowUp: ["v", 1],
      ArrowDown: ["v", -1],
      PageUp: ["v", 10],
      PageDown: ["v", -10]
    };
    function z(ee) {
      const oe = R[ee.key];
      if (!oe) return;
      const [ge, re] = oe;
      ee.preventDefault();
      const ue = ee.shiftKey && Math.abs(re) === 1 ? re * 10 : re;
      m({ [ge]: Wn(Math.round(u.value[ge]) + ue, 0, 100) }), l("commit");
    }
    function D(ee, oe) {
      m({ [oe]: Number(ee.target.value) });
    }
    const V = E(!1), Y = p(
      () => `${a.labels.saturation} ${Math.round(u.value.s)} %, ${a.labels.brightness} ${Math.round(u.value.v)} %`
    ), _ = E(!1), j = E("rgb"), M = E(null), W = E(null), G = p(() => {
      const ee = Fo(u.value);
      if (j.value === "rgb")
        return [
          { short: "R", name: a.labels.red, value: ee.r, max: 255 },
          { short: "G", name: a.labels.green, value: ee.g, max: 255 },
          { short: "B", name: a.labels.blue, value: ee.b, max: 255 }
        ];
      const oe = kb(ee);
      return [
        { short: "H", name: a.labels.hue, value: Math.round(u.value.h), max: 360 },
        { short: "S", name: a.labels.saturation, value: Math.round(oe.s), max: 100 },
        { short: "L", name: a.labels.lightness, value: Math.round(oe.l), max: 100 }
      ];
    });
    function B() {
      if (M.value === null) return;
      const ee = oa(M.value);
      M.value = null, !(!ee || ee === f.value) && (x(ee), l("commit"));
    }
    function F(ee, oe) {
      const ge = Wn(Math.round(oe), 0, G.value[ee].max);
      if (j.value === "rgb") {
        const O = Fo(u.value), U = [O.r, O.g, O.b];
        U[ee] = ge, x(yb({ r: U[0], g: U[1], b: U[2] }));
        return;
      }
      const re = kb(Fo(u.value)), ue = { h: u.value.h, s: re.s, l: re.l };
      ee === 0 ? ue.h = ge : ee === 1 ? ue.s = ge : ue.l = ge, m({ ...yu(BH(ue)), h: ue.h });
    }
    function X(ee, oe) {
      const ge = oe.target.value;
      W.value = { index: ee, text: ge };
      const re = Number.parseInt(ge, 10);
      Number.isFinite(re) && F(ee, re);
    }
    function H(ee, oe) {
      const ge = { ArrowUp: 1, ArrowDown: -1 }[oe.key];
      if (ge === void 0) {
        oe.key === "Enter" && (oe.preventDefault(), q());
        return;
      }
      oe.preventDefault(), W.value = null, F(ee, G.value[ee].value + ge * (oe.shiftKey ? 10 : 1)), l("commit");
    }
    function q() {
      W.value !== null && (W.value = null, l("commit"));
    }
    const N = E(!1);
    ot(() => {
      N.value = typeof window.EyeDropper == "function";
    });
    async function J() {
      const ee = window.EyeDropper;
      if (ee)
        try {
          const { sRGBHex: oe } = await new ee().open(), ge = oa(oe);
          if (!ge) return;
          x(ge), l("commit");
        } catch {
        }
    }
    const be = `linear-gradient(to right, ${[0, 60, 120, 180, 240, 300, 360].map((ee) => `hsl(${ee} 100% 50%)`).join(", ")})`;
    function ke() {
      var ee;
      (ee = s.value) == null || ee.focus();
    }
    return n({ focusInitial: ke }), (ee, oe) => (c(), g("div", MH, [
      v("div", {
        ref_key: "areaRef",
        ref: o,
        class: "relative h-[119px] w-full touch-none cursor-crosshair rounded-(--border-border-radius-rounded-xs) outline-1 outline-solid outline-(--border-border-base-soft)",
        style: Ne({
          backgroundImage: `linear-gradient(to top, var(--colors-color-picker-black), transparent), linear-gradient(to right, var(--colors-background-white), ${b.value})`
        }),
        "data-testid": "color-picker-area",
        onPointerdown: oe[8] || (oe[8] = (ge) => $("area", ge)),
        onMousedown: oe[9] || (oe[9] = Ue(() => {
        }, ["prevent"])),
        onPointermove: T,
        onPointerup: L,
        onPointercancel: L
      }, [
        v("span", {
          class: C([
            "pointer-events-none absolute size-[14px] -translate-x-1/2 translate-y-1/2 rounded-full border-3 border-solid border-(--colors-background-white) shadow-(--shadow-color-picker-handle)",
            V.value && "ring-2 ring-(--border-border-accent)"
          ]),
          style: Ne({ left: `${u.value.s}%`, bottom: `${u.value.v}%` }),
          "data-testid": "color-picker-area-handle"
        }, null, 6),
        v("input", {
          ref_key: "saturationInputRef",
          ref: s,
          type: "range",
          class: "sr-only",
          min: "0",
          max: "100",
          step: "1",
          value: Math.round(u.value.s),
          "aria-label": e.labels.saturation,
          "aria-valuetext": Y.value,
          "data-testid": "color-picker-saturation",
          onInput: oe[0] || (oe[0] = (ge) => D(ge, "s")),
          onChange: oe[1] || (oe[1] = (ge) => l("commit")),
          onKeydown: z,
          onFocus: oe[2] || (oe[2] = (ge) => V.value = !0),
          onBlur: oe[3] || (oe[3] = (ge) => V.value = !1)
        }, null, 40, DH),
        v("input", {
          type: "range",
          class: "sr-only",
          min: "0",
          max: "100",
          step: "1",
          value: Math.round(u.value.v),
          "aria-label": e.labels.brightness,
          "aria-valuetext": Y.value,
          tabindex: "-1",
          "data-testid": "color-picker-brightness",
          onInput: oe[4] || (oe[4] = (ge) => D(ge, "v")),
          onChange: oe[5] || (oe[5] = (ge) => l("commit")),
          onKeydown: z,
          onFocus: oe[6] || (oe[6] = (ge) => V.value = !0),
          onBlur: oe[7] || (oe[7] = (ge) => V.value = !1)
        }, null, 40, zH)
      ], 36),
      v("div", OH, [
        N.value ? (c(), g("button", {
          key: 0,
          type: "button",
          class: "relative flex size-(--icon-size-md) shrink-0 items-center justify-center cursor-pointer rounded-(--border-border-radius-rounded-xs) text-(length:--icon-size-md) text-(--icons-icon-dark-default) after:absolute after:-inset-0.5 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-(--border-border-accent)",
          "aria-label": e.labels.eyedropper,
          "data-testid": "color-picker-eyedropper",
          onClick: J
        }, [...oe[19] || (oe[19] = [
          v("i", {
            class: "ri-sip-line",
            "aria-hidden": "true"
          }, null, -1)
        ])], 8, PH)) : k("", !0),
        v("span", {
          class: "size-(--spacing-6) shrink-0 rounded-full",
          style: Ne({ backgroundColor: f.value }),
          "aria-hidden": "true",
          "data-testid": "color-picker-current"
        }, null, 4),
        v("div", {
          ref_key: "hueRef",
          ref: i,
          class: "relative h-[10px] min-w-0 flex-1 touch-none cursor-pointer rounded-(--border-border-radius-rounded-sm) outline-1 outline-solid outline-(--border-border-base-soft)",
          style: Ne({ backgroundImage: be }),
          "data-testid": "color-picker-hue",
          onPointerdown: oe[15] || (oe[15] = (ge) => $("hue", ge)),
          onMousedown: oe[16] || (oe[16] = Ue(() => {
          }, ["prevent"])),
          onPointermove: T,
          onPointerup: L,
          onPointercancel: L
        }, [
          v("span", {
            class: C([
              "pointer-events-none absolute top-1/2 size-(--spacing-4) -translate-x-1/2 -translate-y-1/2 rounded-full border-2 border-solid border-(--colors-background-white) shadow-(--shadow-color-picker-thumb)",
              _.value && "ring-2 ring-(--border-border-accent)"
            ]),
            style: Ne({ left: `${u.value.h / 360 * 100}%`, backgroundColor: b.value }),
            "data-testid": "color-picker-hue-thumb"
          }, null, 6),
          v("input", {
            ref_key: "hueInputRef",
            ref: d,
            type: "range",
            class: "sr-only",
            min: "0",
            max: "360",
            step: "1",
            value: Math.round(u.value.h),
            "aria-label": e.labels.hue,
            "aria-valuetext": `${Math.round(u.value.h)}°`,
            "data-testid": "color-picker-hue-input",
            onInput: oe[10] || (oe[10] = (ge) => D(ge, "h")),
            onChange: oe[11] || (oe[11] = (ge) => l("commit")),
            onKeydown: oe[12] || (oe[12] = (ge) => A(ge, "h", 360)),
            onFocus: oe[13] || (oe[13] = (ge) => _.value = !0),
            onBlur: oe[14] || (oe[14] = (ge) => _.value = !1)
          }, null, 40, FH)
        ], 36)
      ]),
      v("div", VH, [
        v("div", NH, [
          v("div", HH, [
            v("input", {
              id: `${I(r)}-hex`,
              type: "text",
              maxlength: "7",
              spellcheck: "false",
              class: C(wb),
              value: M.value ?? f.value,
              "data-testid": "color-picker-hex",
              onInput: oe[17] || (oe[17] = (ge) => M.value = ge.target.value),
              onBlur: B,
              onKeydown: ut(Ue(B, ["prevent"]), ["enter"])
            }, null, 40, jH),
            v("label", {
              for: `${I(r)}-hex`,
              class: C(Cb)
            }, P(e.labels.hex), 9, WH)
          ]),
          (c(!0), g(se, null, Me(G.value, (ge, re) => {
            var ue;
            return c(), g("div", {
              key: `${j.value}-${ge.short}`,
              class: "flex min-w-0 flex-1 flex-col items-center gap-[10px]"
            }, [
              v("input", {
                id: `${I(r)}-${ge.short}`,
                type: "text",
                inputmode: "numeric",
                class: C(wb),
                value: ((ue = W.value) == null ? void 0 : ue.index) === re ? W.value.text : ge.value,
                "aria-label": `${ge.name} (${ge.short})`,
                "data-testid": `color-picker-channel-${ge.short}`,
                onInput: (O) => X(re, O),
                onKeydown: (O) => H(re, O),
                onBlur: q
              }, null, 40, qH),
              v("label", {
                for: `${I(r)}-${ge.short}`,
                class: C(Cb),
                "aria-hidden": "true"
              }, P(ge.short), 9, UH)
            ]);
          }), 128))
        ]),
        v("button", {
          type: "button",
          class: "relative flex size-(--icon-size-sm) shrink-0 items-center justify-center cursor-pointer rounded-(--border-border-radius-rounded-xs) text-(length:--icon-size-sm) text-(--icons-icon-dark-default) after:absolute after:-inset-1 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-(--border-border-accent)",
          "aria-label": j.value === "rgb" ? e.labels.switchToHsl : e.labels.switchToRgb,
          "data-testid": "color-picker-format",
          onClick: oe[18] || (oe[18] = (ge) => j.value = j.value === "rgb" ? "hsl" : "rgb")
        }, [...oe[20] || (oe[20] = [
          v("i", {
            class: "ri-expand-up-down-line",
            "aria-hidden": "true"
          }, null, -1)
        ])], 8, GH)
      ])
    ]));
  }
}), YH = {
  dialog: "Color picker",
  openPicker: "Choose a color",
  pickColor: "Pick a color",
  resetColor: "Reset color",
  palette: "Colors",
  saturation: "Saturation",
  brightness: "Brightness",
  hue: "Hue",
  hex: "Hex",
  red: "Red",
  green: "Green",
  blue: "Blue",
  lightness: "Lightness",
  eyedropper: "Pick a color from the screen",
  switchToHsl: "Switch to HSL",
  switchToRgb: "Switch to RGB",
  invalidHex: "Enter a color in the #RRGGBB format"
}, JH = {
  fr: {
    dialog: "Sélecteur de couleur",
    openPicker: "Choisir une couleur",
    pickColor: "Choisir une couleur",
    resetColor: "Réinitialiser la couleur",
    palette: "Couleurs",
    saturation: "Saturation",
    brightness: "Brillance",
    hue: "Teinte",
    hex: "Hex",
    red: "Rouge",
    green: "Vert",
    blue: "Bleu",
    lightness: "Luminosité",
    eyedropper: "Prélever une couleur à l'écran",
    switchToHsl: "Passer en TSL",
    switchToRgb: "Passer en RVB",
    invalidHex: "Saisissez une couleur au format #RRGGBB"
  },
  nl: {
    dialog: "Kleurkiezer",
    openPicker: "Kies een kleur",
    pickColor: "Kies een kleur",
    resetColor: "Kleur resetten",
    palette: "Kleuren",
    saturation: "Verzadiging",
    brightness: "Helderheid",
    hue: "Tint",
    hex: "Hex",
    red: "Rood",
    green: "Groen",
    blue: "Blauw",
    lightness: "Lichtheid",
    eyedropper: "Kleur van het scherm kiezen",
    switchToHsl: "Wisselen naar HSL",
    switchToRgb: "Wisselen naar RGB",
    invalidHex: "Voer een kleur in als #RRGGBB"
  }
}, Sb = {
  en: {
    indigo: "Indigo",
    green: "Green",
    yellow: "Yellow",
    red: "Red",
    orange: "Orange",
    violet: "Violet",
    purple: "Purple",
    pink: "Pink",
    cyan: "Cyan",
    gray: "Gray",
    slate: "Slate"
  },
  fr: {
    indigo: "Indigo",
    green: "Vert",
    yellow: "Jaune",
    red: "Rouge",
    orange: "Orange",
    violet: "Violet",
    purple: "Pourpre",
    pink: "Rose",
    cyan: "Cyan",
    gray: "Gris",
    slate: "Ardoise"
  },
  nl: {
    indigo: "Indigo",
    green: "Groen",
    yellow: "Geel",
    red: "Rood",
    orange: "Oranje",
    violet: "Violet",
    purple: "Paars",
    pink: "Roze",
    cyan: "Cyaan",
    gray: "Grijs",
    slate: "Leisteen"
  }
}, ZH = [
  { hex: "#0A27FF", family: "indigo", shade: 700 },
  { hex: "#00A870", family: "green", shade: 500 },
  { hex: "#EECC01", family: "yellow", shade: 500 },
  { hex: "#F04438", family: "red", shade: 500 },
  { hex: "#FF881E", family: "orange", shade: 500 },
  { hex: "#00D492", family: "green", shade: 400 },
  { hex: "#615FFF", family: "indigo", shade: 400 },
  { hex: "#C4B4FF", family: "violet", shade: 300 },
  { hex: "#4542FF", family: "indigo", shade: 500 },
  { hex: "#FF993E", family: "orange", shade: 400 },
  { hex: "#FFDDC1", family: "orange", shade: 100 },
  { hex: "#DA9DFF", family: "purple", shade: 400 },
  { hex: "#C4B4FF", family: "violet", shade: 300 },
  { hex: "#D9D6FE", family: "violet", shade: 200 },
  { hex: "#FECDCA", family: "red", shade: 200 },
  { hex: "#FDA5D5", family: "pink", shade: 300 },
  { hex: "#FCD9BD", family: "orange", shade: 200 },
  { hex: "#E1FAFF", family: "cyan", shade: 100 },
  { hex: "#007595", family: "cyan", shade: 700 },
  { hex: "#BE5900", family: "orange", shade: 700 },
  { hex: "#FFF085", family: "yellow", shade: 200 },
  { hex: "#0A27FF", family: "indigo", shade: 700 },
  { hex: "#1430FF", family: "indigo", shade: 600 },
  { hex: "#52DBF5", family: "cyan", shade: 300 },
  { hex: "#E1FAFF", family: "cyan", shade: 100 },
  { hex: "#5EE9B5", family: "green", shade: 300 },
  { hex: "#F6339A", family: "pink", shade: 500 },
  { hex: "#E1FAFF", family: "cyan", shade: 100 },
  { hex: "#007A55", family: "green", shade: 700 },
  { hex: "#1E2939", family: "gray", shade: 800 },
  { hex: "#006045", family: "green", shade: 800 },
  { hex: "#6C3A8A", family: "purple", shade: 800 },
  { hex: "#CAD5E2", family: "slate", shade: 300 },
  { hex: "#F1F5F9", family: "slate", shade: 100 },
  { hex: "#F8FAFC", family: "slate", shade: 50 }
];
function XH(e) {
  const n = Sb[e] ?? Sb.en;
  return ZH.map(({ hex: t, family: a, shade: l }) => ({
    hex: t,
    name: `${n[a]} ${l}`
  }));
}
const QH = ["disabled", "aria-label", "aria-expanded", "aria-controls"], _H = ["aria-label"], dU = /* @__PURE__ */ ye({
  __name: "ColorPicker",
  props: {
    modelValue: { default: null },
    label: { default: void 0 },
    required: { type: Boolean, default: !1 },
    requiredIndicator: { default: "*" },
    disabled: { type: Boolean, default: !1 },
    error: { default: void 0 },
    hint: { default: void 0 },
    placeholder: { default: void 0 },
    id: { default: void 0 },
    name: { default: void 0 },
    width: { default: "384px" },
    fullWidth: { type: Boolean, default: !1 },
    language: { default: "en" },
    labels: { default: void 0 },
    swatches: { default: void 0 },
    showReset: { type: Boolean, default: !0 },
    resetValue: { default: null }
  },
  emits: ["update:modelValue", "change"],
  setup(e, { emit: n }) {
    const t = e, a = n, l = p(() => t.language.slice(0, 2).toLowerCase()), r = p(() => ({
      ...JH[l.value] ?? YH,
      ...t.labels
    })), o = p(
      () => (t.swatches ?? XH(l.value)).map((ee) => ({
        ...ee,
        hex: oa(ee.hex) ?? ee.hex
      }))
    ), i = p(() => t.modelValue ? oa(t.modelValue) : null), s = Ve(), d = p(() => t.id ?? `${s}-input`), u = `${s}-panel`, f = p(
      () => t.label ? `${r.value.openPicker}, ${t.label}` : r.value.openPicker
    ), b = E(null), h = E(null), m = E(null), x = E(null), y = E(null), w = E(!1), S = E("palette"), $ = Symbol("color-picker");
    let T = null;
    const L = E(i.value ?? t.modelValue ?? ""), A = E(!1);
    let R = null, z = null;
    Ie(
      () => t.modelValue,
      (ee) => {
        const oe = ee ? oa(ee) : null;
        L.value = oe ?? ee ?? "", A.value = !1, oe !== R && (R = null, z = oe);
      }
    );
    const D = p(
      () => t.error ?? (A.value ? r.value.invalidHex : void 0)
    );
    function V(ee, oe) {
      L.value = ee ?? "", A.value = !1, ee !== i.value && (a("update:modelValue", ee), oe && a("change", ee));
    }
    function Y() {
      const ee = L.value.trim();
      if (ee === "") {
        V(null, !0);
        return;
      }
      const oe = oa(ee);
      oe ? V(oe, !0) : A.value = !0;
    }
    async function _() {
      var ee;
      t.disabled || w.value || (S.value = "palette", R = null, w.value = !0, Zn($), await qe(), !(!w.value || T || !h.value || !m.value) && (T = Fa(h.value, m.value, {
        strategy: "fixed",
        placement: "bottom-start",
        modifiers: [
          { name: "offset", options: { offset: [0, 4] } },
          { name: "flip", options: { fallbackPlacements: ["top-start"] } },
          // altAxis keeps the panel inside a short viewport (200 % zoom) when neither side fits.
          { name: "preventOverflow", options: { padding: 8, altAxis: !0 } }
        ]
      }), (ee = x.value) == null || ee.focusInitial()));
    }
    function j(ee) {
      w.value && (S.value === "spectrum" && be(), w.value = !1, An($), T == null || T.destroy(), T = null, ee && qe(() => {
        var oe;
        return (oe = h.value) == null ? void 0 : oe.focus();
      }));
    }
    function M() {
      w.value ? j(!1) : _();
    }
    async function W() {
      var ee;
      S.value = "spectrum", z = i.value, await qe(), await (T == null ? void 0 : T.update()), (ee = y.value) == null || ee.focusInitial();
    }
    function G(ee) {
      ee.key !== "Escape" || !w.value || !Va($) || (ee.stopPropagation(), ee.preventDefault(), j(!0));
    }
    function B() {
      return m.value ? Array.from(
        m.value.querySelectorAll(
          "button:not([disabled]), input:not([disabled]), [tabindex]"
        )
      ).filter((ee) => {
        var oe;
        return !((oe = ee.getAttribute("tabindex")) != null && oe.startsWith("-"));
      }) : [];
    }
    function F(ee, oe) {
      oe && (ee.preventDefault(), ee.stopPropagation(), oe.focus());
    }
    function X(ee) {
      ee.key === "Tab" && !ee.shiftKey && w.value && F(ee, B()[0]);
    }
    function H(ee) {
      if (ee.key !== "Tab") {
        G(ee);
        return;
      }
      const oe = B();
      ee.shiftKey && document.activeElement === oe[0] ? F(ee, h.value) : !ee.shiftKey && document.activeElement === oe.at(-1) && F(ee, document.getElementById(d.value));
    }
    function q(ee) {
      var ge;
      const oe = ee.relatedTarget;
      oe && !((ge = m.value) != null && ge.contains(oe)) && oe !== h.value && j(!1);
    }
    Ji(b, () => j(!1), {
      isActive: () => w.value,
      ignoreElements: () => [m.value]
    }), Ie(
      () => t.disabled,
      (ee) => {
        ee && j(!1);
      }
    ), gt(() => j(!1));
    function N(ee) {
      V(ee, !0), j(!0);
    }
    function J(ee) {
      R = ee, V(ee, !1);
    }
    function be() {
      const ee = R ?? i.value;
      ee !== z && (z = ee, a("change", ee));
    }
    function ke() {
      V(t.resetValue ? oa(t.resetValue) : null, !0);
    }
    return (ee, oe) => (c(), g("div", {
      ref_key: "rootRef",
      ref: b,
      class: C(["relative flex min-w-0 items-start gap-(--spacing-1\\.5)", { "w-full": e.fullWidth }]),
      style: Ne(e.fullWidth ? void 0 : { width: e.width }),
      "data-testid": "color-picker",
      onKeydown: G
    }, [
      v("button", {
        ref_key: "triggerRef",
        ref: h,
        type: "button",
        disabled: e.disabled,
        "aria-label": f.value,
        "aria-haspopup": "dialog",
        "aria-expanded": w.value ? "true" : "false",
        "aria-controls": w.value ? u : void 0,
        class: C([
          // Figma strokes sit inside the box: the padding gives back the 1px border.
          "flex size-(--spacing-9) shrink-0 rounded-(--border-border-radius-rounded-xs) border border-solid border-(--border-border-base-soft) bg-(--background-background-white) p-[calc(var(--spacing-1)-1px)] focus-visible:outline-none focus-visible:border-(--border-border-accent) focus-visible:shadow-[0px_0px_2px_0px_var(--background-background-hover)]",
          // Aligns the swatch with the input row: TextInput's label line (20px) + its 2px gap.
          e.label && "mt-[calc(var(--line-height-l)+2px)]",
          e.disabled ? "cursor-not-allowed" : "cursor-pointer"
        ]),
        "data-testid": "color-picker-trigger",
        onClick: M,
        onKeydown: X
      }, [
        v("span", {
          class: "size-full rounded-(--border-border-radius-rounded-xs)",
          style: Ne({ backgroundColor: i.value ?? "transparent" }),
          "data-testid": "color-picker-trigger-preview"
        }, null, 4)
      ], 42, QH),
      (c(), K(Bn, { to: "body" }, [
        w.value ? (c(), g("div", {
          key: 0,
          id: u,
          ref_key: "panelRef",
          ref: m,
          role: "dialog",
          tabindex: "-1",
          "aria-label": r.value.dialog,
          "data-focus-trap-allow-outside": "",
          class: C([
            "fixed z-[350] flex flex-col rounded-(--border-border-radius-rounded-l) border border-solid border-(--border-border-base-soft) bg-(--background-background-white) p-[calc(var(--spacing-3)-1px)] shadow-(--blur-shadow-m) [backdrop-filter:blur(4px)] outline-none",
            S.value === "palette" ? "w-(--color-picker-width-palette)" : "w-(--color-picker-width-spectrum)"
          ]),
          "data-testid": "color-picker-panel",
          onFocusout: q,
          onKeydown: H
        }, [
          S.value === "palette" ? (c(), K(AH, {
            key: 0,
            ref_key: "paletteRef",
            ref: x,
            swatches: o.value,
            "model-value": i.value,
            labels: r.value,
            "show-reset": e.showReset,
            onSelect: N,
            onReset: ke,
            onCustom: W
          }, null, 8, ["swatches", "model-value", "labels", "show-reset"])) : (c(), K(KH, {
            key: 1,
            ref_key: "spectrumRef",
            ref: y,
            "model-value": i.value,
            labels: r.value,
            onUpdate: J,
            onCommit: be
          }, null, 8, ["model-value", "labels"]))
        ], 42, _H)) : k("", !0)
      ])),
      te(zt, {
        id: d.value,
        modelValue: L.value,
        "onUpdate:modelValue": oe[0] || (oe[0] = (ge) => L.value = ge),
        class: "min-w-0 flex-1",
        "full-width": "",
        size: "md",
        name: e.name,
        label: e.label,
        required: e.required,
        "required-indicator": e.requiredIndicator,
        disabled: e.disabled,
        error: D.value,
        hint: e.hint,
        placeholder: e.placeholder,
        onBlur: Y,
        onKeydown: ut(Y, ["enter"])
      }, {
        iconRight: ve(() => [...oe[1] || (oe[1] = [
          v("i", {
            class: "ri-search-line text-(length:--icon-size-sm) text-(--icons-icon-disabled-strong)",
            "aria-hidden": "true"
          }, null, -1)
        ])]),
        _: 1
      }, 8, ["id", "modelValue", "name", "label", "required", "required-indicator", "disabled", "error", "hint", "placeholder"])
    ], 38));
  }
}), ej = ["aria-label"], tj = {
  key: 1,
  role: "list",
  class: "stepper-navigation-scroll flex items-center gap-2 sm:gap-(--spacing-5) overflow-x-auto"
}, nj = ["aria-label"], aj = {
  key: 0,
  "aria-hidden": "true",
  class: "flex-1 border-t-(length:--border-border-width-border-base) border-(--border-border-base-soft)"
}, lj = {
  key: 2,
  role: "list",
  class: "stepper-navigation-scroll overflow-x-auto"
}, rj = { class: "relative flex w-max min-w-full items-center justify-between gap-2" }, oj = ["aria-label"], ij = ["aria-label"], sj = { class: "flex flex-col items-start gap-(--spacing-0.5)" }, dj = {
  key: 0,
  "aria-hidden": "true",
  class: "text-(length:--size-m) leading-(--line-height-l) text-(--text-text-body) whitespace-nowrap"
}, uj = {
  key: 4,
  role: "list",
  class: "flex flex-col items-start"
}, cj = ["aria-label"], fj = { class: "flex items-center gap-(--spacing-3)" }, hj = { class: "flex flex-col items-start gap-(--spacing-0.5)" }, bj = {
  key: 0,
  "aria-hidden": "true",
  class: "text-(length:--size-m) leading-(--line-height-l) text-(--text-text-body) whitespace-nowrap"
}, gj = {
  key: 5,
  role: "list",
  class: "stepper-navigation-scroll flex flex-col items-start gap-(--spacing-4) w-full overflow-x-auto"
}, pj = ["aria-label"], mj = {
  "aria-hidden": "true",
  class: "font-(--weight-medium) text-(length:--size-l) leading-(--line-height-xxl) whitespace-nowrap"
}, vj = {
  "aria-hidden": "true",
  class: "flex-1 font-(--weight-medium) text-(length:--size-l) leading-(--line-height-xxl)"
}, xj = /* @__PURE__ */ ye({
  __name: "StepperNavigation",
  props: {
    steps: {},
    type: { default: "default" },
    labels: {},
    breakpoint: { default: "auto" }
  },
  emits: ["step-click"],
  setup(e, { emit: n }) {
    const t = e, a = n, l = /* @__PURE__ */ new Set([
      "completed",
      "active",
      "error"
    ]);
    function r(W) {
      return l.has(W);
    }
    function o(W, G, B) {
      const F = t.labels.state[W.state];
      return `${W.label}, ${t.labels.step} ${G + 1} ${t.labels.of} ${B}, ${F}`;
    }
    function i(W) {
      a("step-click", W.id);
    }
    function s(W, G) {
      const B = r(W.state);
      return {
        type: B ? "button" : void 0,
        "data-testid": `stepper-navigation-step-${W.id}`,
        "aria-current": W.state === "active" ? "step" : void 0,
        "aria-disabled": B ? void 0 : "true",
        "aria-label": o(W, G, t.steps.length),
        onClick: B ? () => i(W) : void 0
      };
    }
    function d(W) {
      return r(W) ? "cursor-pointer focus:outline-none focus-visible:shadow-[0_0_2px_2px_var(--background-background-hover)]" : "";
    }
    const u = {
      upcoming: { variant: "outlined", color: "text" },
      active: { variant: "outlined", color: "gradient" },
      completed: { variant: "filled", color: "success" },
      error: { variant: "filled", color: "error" },
      disabled: { variant: "outlined", color: "disabled" }
    }, f = {
      completed: "ri-check-line",
      error: "ri-close-line"
    };
    function b(W, G) {
      const B = u[W.state], F = f[W.state];
      return F ? { ...B, icon: F } : { ...B, label: String(G + 1) };
    }
    function h(W, G) {
      const B = u[W.state], F = f[W.state];
      return F ? { ...B, icon: F } : W.icon ? { ...B, icon: W.icon, ...W.state === "upcoming" && { color: "white" } } : { ...B, label: String(G + 1) };
    }
    const m = {
      auto: "gap-2 sm:gap-(--spacing-4)",
      mobile: "gap-2",
      desktop: "gap-(--spacing-4)"
    }, x = {
      auto: "gap-1.5 sm:gap-(--spacing-2)",
      mobile: "gap-1.5",
      desktop: "gap-(--spacing-2)"
    }, y = {
      auto: "text-(length:--size-m) sm:text-(length:--size-l) leading-(--line-height-l) sm:leading-(--line-height-xxl)",
      mobile: "text-(length:--size-m) leading-(--line-height-l)",
      desktop: "text-(length:--size-l) leading-(--line-height-xxl)"
    }, w = p(() => t.type === "defaultVertical" ? "flex-col" : ""), S = p(() => t.breakpoint !== "mobile"), $ = p(() => t.breakpoint !== "desktop"), T = {
      auto: "flex-col gap-(--spacing-5) w-fit sm:w-auto sm:flex-row sm:items-center sm:gap-(--spacing-5) sm:overflow-x-auto",
      mobile: "flex-col gap-(--spacing-5) w-fit",
      desktop: "flex-row items-center gap-(--spacing-5) overflow-x-auto"
    }, L = {
      auto: "sm:w-36",
      mobile: "",
      desktop: "w-36"
    }, A = {
      upcoming: "text-(--text-text-body)",
      active: "text-(--text-text-accent)",
      completed: "text-(--text-text-body)",
      error: "text-(--text-text-body)",
      disabled: "text-(--text-text-disabled-light)"
    }, R = {
      upcoming: "bg-(--background-background-white) border border-(--border-border-base-soft)",
      active: "bg-(--background-background-white) stepper-navigation-gradient-border",
      completed: "bg-(--background-background-white) border border-(--border-border-success-strong)",
      error: "bg-(--background-background-white) border border-(--border-border-error-strong)",
      disabled: "bg-(--background-background-white) border border-(--border-border-disabled-subtle)"
    }, z = {
      upcoming: "text-(--text-text-body)",
      active: "text-(--text-text-accent)",
      completed: "text-(--text-text-success)",
      error: "text-(--text-text-error-strong)",
      disabled: "text-(--text-text-disabled-light)"
    }, D = {
      upcoming: "text-(--text-text-black-default)",
      active: "text-(--text-text-accent)",
      completed: "text-(--text-text-body)",
      error: "text-(--text-text-body)",
      disabled: "text-(--text-text-disabled-light)"
    }, V = {
      auto: "h-14 sm:h-10",
      mobile: "h-14",
      desktop: "h-10"
    }, Y = {
      auto: "top-9 sm:top-11",
      mobile: "top-9",
      desktop: "top-11"
    }, _ = {
      upcoming: "bg-(--background-background-white-secondary-soft) border-(--border-border-base-soft)",
      active: "bg-(--background-background-white) stepper-navigation-gradient-border",
      completed: "bg-(--background-background-success) border-(--border-border-success)",
      error: "bg-(--background-background-error) border-(--border-border-error-strong)",
      disabled: "bg-(--background-background-white-secondary-soft) border-(--border-border-base-soft)"
    }, j = {
      upcoming: "text-(--text-text-body)",
      active: "text-(--text-text-accent)",
      completed: "text-(--text-text-success)",
      error: "text-(--text-text-error-strong)",
      disabled: "text-(--text-text-body)"
    }, M = {
      active: "ri-arrow-right-line",
      completed: "ri-check-line",
      error: "ri-close-line"
    };
    return (W, G) => e.type === "default" || e.type === "defaultVertical" ? (c(), g("div", {
      key: 0,
      role: "list",
      class: C(["stepper-navigation-scroll flex items-center overflow-x-auto", m[e.breakpoint]])
    }, [
      (c(!0), g(se, null, Me(e.steps, (B, F) => (c(), g(se, {
        key: B.id
      }, [
        v("span", {
          role: "listitem",
          "aria-label": o(B, F, e.steps.length),
          class: "contents"
        }, [
          (c(), K(dt(r(B.state) ? "button" : "span"), Oe({ ref_for: !0 }, s(B, F), {
            class: [
              "flex items-center shrink-0",
              w.value,
              x[e.breakpoint],
              d(B.state)
            ]
          }), {
            default: ve(() => [
              te(Xt, Oe({
                type: "circle",
                size: "sm"
              }, { ref_for: !0 }, b(B, F)), null, 16),
              v("span", {
                "aria-hidden": "true",
                class: C([
                  "font-(--weight-medium) whitespace-nowrap",
                  y[e.breakpoint],
                  A[B.state]
                ])
              }, P(B.label), 3)
            ]),
            _: 2
          }, 1040, ["class"]))
        ], 8, ej),
        F < e.steps.length - 1 && S.value ? (c(), g("span", {
          key: 0,
          "aria-hidden": "true",
          class: C([
            e.breakpoint === "auto" ? "hidden sm:block" : "",
            "flex-1 border-t border-(--border-border-base-soft)"
          ])
        }, null, 2)) : k("", !0),
        F < e.steps.length - 1 && $.value ? (c(), g("span", {
          key: 1,
          "aria-hidden": "true",
          class: C([
            e.breakpoint === "auto" ? "sm:hidden" : "",
            "flex h-4 w-[3.5px] shrink-0 items-center justify-center"
          ])
        }, [...G[0] || (G[0] = [
          v("span", { class: "h-4 w-px rotate-[10.98deg] skew-x-[1.87deg] bg-(--border-border-base-soft)" }, null, -1)
        ])], 2)) : k("", !0)
      ], 64))), 128))
    ], 2)) : e.type === "onlyIcons" ? (c(), g("div", tj, [
      (c(!0), g(se, null, Me(e.steps, (B, F) => (c(), g(se, {
        key: B.id
      }, [
        v("span", {
          role: "listitem",
          "aria-label": o(B, F, e.steps.length),
          class: "contents"
        }, [
          (c(), K(dt(r(B.state) ? "button" : "span"), Oe({ ref_for: !0 }, s(B, F), {
            class: ["flex items-center shrink-0", d(B.state)]
          }), {
            default: ve(() => [
              te(Xt, Oe({
                type: "circle",
                size: "md"
              }, { ref_for: !0 }, h(B, F)), null, 16)
            ]),
            _: 2
          }, 1040, ["class"]))
        ], 8, nj),
        F < e.steps.length - 1 ? (c(), g("span", aj)) : k("", !0)
      ], 64))), 128))
    ])) : e.type === "withDots" ? (c(), g("div", lj, [
      v("div", rj, [
        v("span", {
          "aria-hidden": "true",
          class: C([
            "absolute inset-x-0 h-0 border-t-(length:--border-border-width-border-base) border-(--border-border-base-soft)",
            Y[e.breakpoint]
          ])
        }, null, 2),
        (c(!0), g(se, null, Me(e.steps, (B, F) => (c(), g("span", {
          key: B.id,
          role: "listitem",
          "aria-label": o(B, F, e.steps.length),
          class: "contents"
        }, [
          (c(), K(dt(r(B.state) ? "button" : "span"), Oe({ ref_for: !0 }, s(B, F), {
            class: [
              "relative flex flex-col items-center gap-(--spacing-3)",
              d(B.state)
            ]
          }), {
            default: ve(() => [
              v("span", {
                "aria-hidden": "true",
                class: C([
                  "font-(--weight-medium) text-(length:--size-l) leading-(--line-height-xxl) whitespace-nowrap",
                  z[B.state]
                ])
              }, P(B.label), 3),
              v("span", {
                "aria-hidden": "true",
                class: C(["h-4 w-4 rounded-full", R[B.state]])
              }, null, 2)
            ]),
            _: 2
          }, 1040, ["class"]))
        ], 8, oj))), 128))
      ])
    ])) : e.type === "iconsAndText" ? (c(), g("div", {
      key: 3,
      role: "list",
      class: C(["stepper-navigation-scroll flex", T[e.breakpoint]])
    }, [
      (c(!0), g(se, null, Me(e.steps, (B, F) => (c(), g(se, {
        key: B.id
      }, [
        v("span", {
          role: "listitem",
          "aria-label": o(B, F, e.steps.length),
          class: "contents"
        }, [
          (c(), K(dt(r(B.state) ? "button" : "span"), Oe({ ref_for: !0 }, s(B, F), {
            class: [
              "flex items-center gap-(--spacing-3) text-left shrink-0",
              F === 0 ? "" : L[e.breakpoint],
              d(B.state)
            ]
          }), {
            default: ve(() => [
              v("span", {
                class: C(e.breakpoint === "auto" ? "hidden sm:contents" : "contents")
              }, [
                S.value ? (c(), K(Xt, Oe({
                  key: 0,
                  type: "circle",
                  size: "sm"
                }, { ref_for: !0 }, h(B, F)), null, 16)) : k("", !0)
              ], 2),
              v("span", {
                class: C(e.breakpoint === "auto" ? "contents sm:hidden" : "contents")
              }, [
                $.value ? (c(), K(Xt, Oe({
                  key: 0,
                  type: "circle",
                  size: "md"
                }, { ref_for: !0 }, h(B, F)), null, 16)) : k("", !0)
              ], 2),
              v("span", sj, [
                v("span", {
                  "aria-hidden": "true",
                  class: C([
                    "font-(--weight-medium) text-(length:--size-l) leading-(--line-height-xxl) whitespace-nowrap",
                    A[B.state]
                  ])
                }, P(B.label), 3),
                B.helperText ? (c(), g("span", dj, P(B.helperText), 1)) : k("", !0)
              ])
            ]),
            _: 2
          }, 1040, ["class"]))
        ], 8, ij),
        F < e.steps.length - 1 && S.value ? (c(), g("span", {
          key: 0,
          "aria-hidden": "true",
          class: C([
            e.breakpoint === "auto" ? "hidden sm:block" : "",
            "flex-1 border-t-(length:--border-border-width-border-base) border-(--border-border-base-soft)"
          ])
        }, null, 2)) : k("", !0),
        F < e.steps.length - 1 && $.value ? (c(), g("span", {
          key: 1,
          "aria-hidden": "true",
          class: C([
            e.breakpoint === "auto" ? "block sm:hidden" : "",
            "self-center h-6 w-(--border-border-width-border-base) bg-(--border-border-base-soft)"
          ])
        }, null, 2)) : k("", !0)
      ], 64))), 128))
    ], 2)) : e.type === "vertical" ? (c(), g("div", uj, [
      (c(!0), g(se, null, Me(e.steps, (B, F) => (c(), g(se, {
        key: B.id
      }, [
        v("span", {
          role: "listitem",
          "aria-label": o(B, F, e.steps.length),
          class: "contents"
        }, [
          (c(), K(dt(r(B.state) ? "button" : "span"), Oe({ ref_for: !0 }, s(B, F), {
            class: ["flex items-center justify-between w-full text-left", d(B.state)]
          }), {
            default: ve(() => [
              v("span", fj, [
                te(Xt, Oe({
                  type: "circle",
                  size: "md"
                }, { ref_for: !0 }, b(B, F)), null, 16),
                v("span", hj, [
                  v("span", {
                    "aria-hidden": "true",
                    class: C([
                      "font-(--weight-medium) text-(length:--size-l) leading-(--line-height-xxl) whitespace-nowrap",
                      D[B.state]
                    ])
                  }, P(B.label), 3),
                  B.helperText ? (c(), g("span", bj, P(B.helperText), 1)) : k("", !0)
                ])
              ]),
              S.value ? (c(), g("i", {
                key: 0,
                "aria-hidden": "true",
                class: C([e.breakpoint === "auto" ? "hidden sm:block" : "", "ri-arrow-right-s-line text-base shrink-0"])
              }, null, 2)) : k("", !0)
            ]),
            _: 2
          }, 1040, ["class"]))
        ], 8, cj),
        F < e.steps.length - 1 ? (c(), g("span", {
          key: 0,
          "aria-hidden": "true",
          class: C(["ml-[17.5px] w-px bg-(--border-border-base-soft)", V[e.breakpoint]])
        }, null, 2)) : k("", !0)
      ], 64))), 128))
    ])) : e.type === "cards" ? (c(), g("div", gj, [
      (c(!0), g(se, null, Me(e.steps, (B, F) => (c(), g("span", {
        key: B.id,
        role: "listitem",
        "aria-label": o(B, F, e.steps.length),
        class: "contents"
      }, [
        (c(), K(dt(r(B.state) ? "button" : "span"), Oe({ ref_for: !0 }, s(B, F), {
          class: [
            "flex items-center gap-(--spacing-2) w-full min-w-40 p-(--spacing-4) rounded-(--border-border-radius-rounded-l) border border-solid text-left",
            _[B.state],
            j[B.state],
            d(B.state)
          ]
        }), {
          default: ve(() => [
            v("span", mj, P(F + 1), 1),
            v("span", vj, P(B.label), 1),
            M[B.state] ? (c(), g("i", {
              key: 0,
              "aria-hidden": "true",
              class: C([M[B.state], "text-xl leading-none shrink-0"])
            }, null, 2)) : k("", !0)
          ]),
          _: 2
        }, 1040, ["class"]))
      ], 8, pj))), 128))
    ])) : k("", !0);
  }
}), uU = /* @__PURE__ */ lt(xj, [["__scopeId", "data-v-4839e094"]]);
function Xv(e) {
  return "conditions" in e;
}
function Fc(e) {
  return e.kind === "group";
}
const yj = /* @__PURE__ */ new Set(["isNull", "isNotNull"]), kj = /* @__PURE__ */ new Set(["in", "notIn", "between"]);
function Zr(e) {
  return yj.has(e);
}
function Vc(e) {
  return kj.has(e);
}
function wj(e) {
  return !e.field || !e.op ? !1 : Zr(e.op) ? !0 : Vc(e.op) ? e.op === "between" ? e.values.length === 2 && e.values.every((n) => n !== "") : e.values.length > 0 : e.value !== null && e.value !== "";
}
function Vo(e) {
  return Qv(e);
}
function Qv(e) {
  const n = [];
  for (const t of e.children)
    if (Fc(t)) {
      const a = Qv(t);
      a.conditions.length > 0 && n.push(a);
    } else wj(t) && n.push(Cj(t));
  return { operator: e.operator, conditions: n };
}
function Cj(e) {
  const n = {
    field: e.field,
    op: e.op
  };
  return Zr(e.op) || (Vc(e.op) ? n.values = [...e.values] : n.value = e.value), n;
}
function $b(e, n) {
  return Xv(e) ? {
    _id: n(),
    kind: "group",
    operator: e.operator,
    children: e.conditions.map((t) => ku(t, n))
  } : {
    _id: n(),
    kind: "group",
    operator: "and",
    children: [ku(e, n)]
  };
}
function ku(e, n) {
  return Xv(e) ? {
    _id: n(),
    kind: "group",
    operator: e.operator,
    children: e.conditions.map((t) => ku(t, n))
  } : {
    _id: n(),
    kind: "criterion",
    field: e.field,
    op: e.op,
    value: e.value ?? null,
    values: e.values ? [...e.values] : []
  };
}
const Sj = /* @__PURE__ */ new Set(["lastNDays", "nextNDays"]);
function $j(e) {
  return e.field === null && e.op === null;
}
function Ij(e, n) {
  if (e === "DateTime") {
    const l = Date.parse(String(n[0])), r = Date.parse(String(n[1]));
    return Number.isNaN(l) || Number.isNaN(r) ? null : [l, r];
  }
  const t = Number(n[0]), a = Number(n[1]);
  return Number.isNaN(t) || Number.isNaN(a) ? null : [t, a];
}
function Tj(e, n) {
  if ($j(e))
    return [];
  const t = e.field ? n.find((l) => l.path === e.field) : void 0;
  if (e.field && !t)
    return ["fieldOrphan"];
  if (!e.field || !e.op || !t)
    return ["valueRequired"];
  const a = [];
  if (t.operators.includes(e.op) || a.push("operatorIllegal"), Zr(e.op))
    return a;
  if (Sj.has(e.op)) {
    const l = Number(e.value);
    return (e.value === null || e.value === "" || !Number.isInteger(l) || l < 1) && a.push("daysInvalid"), a;
  }
  if (e.op === "between") {
    if (e.values.length !== 2 || e.values.some((r) => r === ""))
      return a.push("valueRequired"), a;
    const l = Ij(t.type, e.values);
    return (l === null || l[0] > l[1]) && a.push("rangeInvalid"), a;
  }
  return Vc(e.op) ? (e.values.length === 0 && a.push("valueRequired"), a) : e.value === null || e.value === "" ? (a.push("valueRequired"), a) : (t.type === "Number" || t.type === "Decimal" ? (typeof e.value != "number" || Number.isNaN(e.value)) && a.push("valueInvalid") : t.type === "DateTime" && Number.isNaN(Date.parse(String(e.value))) && a.push("valueInvalid"), a);
}
function Ib(e, n) {
  const t = /* @__PURE__ */ new Map(), a = (l) => {
    for (const r of l.children)
      if (Fc(r))
        a(r);
      else {
        const o = Tj(r, n);
        o.length > 0 && t.set(r._id, o);
      }
  };
  return a(e), t;
}
let Tb = 0;
function Il() {
  return Tb += 1, `afb-${Tb}`;
}
function Lb() {
  return { _id: Il(), kind: "group", operator: "and", children: [] };
}
function Eb() {
  return { _id: Il(), kind: "criterion", field: null, op: null, value: null, values: [] };
}
function No(e) {
  const n = (t) => t.kind === "group" ? {
    _id: t._id,
    kind: "group",
    operator: t.operator,
    children: t.children.map(n)
  } : {
    _id: t._id,
    kind: "criterion",
    field: t.field,
    op: t.op,
    value: t.value,
    values: [...t.values]
  };
  return n(e);
}
function _v(e, n) {
  if (e.kind !== n.kind)
    return !1;
  if (e.kind === "group" && n.kind === "group")
    return e.operator === n.operator && e.children.length === n.children.length && e.children.every((l, r) => _v(l, n.children[r]));
  const t = e, a = n;
  return t.field === a.field && t.op === a.op && t.value === a.value && t.values.length === a.values.length && t.values.every((l, r) => l === a.values[r]);
}
function Lj(e, n) {
  const t = E(e ? $b(e, Il) : Lb()), a = E(No(t.value)), l = E(/* @__PURE__ */ new Map()), r = p(() => l.value.size > 0), o = p(() => Rt(n) ?? []), i = p(
    () => Ib(t.value, o.value).size === 0
  ), s = p(
    () => !_v(t.value, a.value)
  );
  function d(A) {
    A.children.push(Eb());
  }
  function u(A) {
    A.children.push({ _id: Il(), kind: "group", operator: "and", children: [Eb()] });
  }
  function f(A) {
    const R = [A._id];
    if (A.kind === "group")
      for (const z of A.children)
        R.push(...f(z));
    return R;
  }
  function b(A, R) {
    const z = A.children.find((V) => V._id === R), D = z ? f(z) : [R];
    A.children = A.children.filter((V) => V._id !== R);
    for (const V of D)
      S(V);
  }
  function h(A, R) {
    A.operator = R;
  }
  function m(A) {
    return A.children.length >= 2;
  }
  function x(A) {
    const R = (z, D) => {
      if (z._id === A._id)
        return D;
      if (z.kind === "group")
        for (const V of z.children) {
          const Y = R(V, D + 1);
          if (Y !== null)
            return Y;
        }
      return null;
    };
    return R(t.value, 1) ?? 1;
  }
  function y(A, R) {
    return x(A) < R;
  }
  function w(A) {
    return l.value = Ib(t.value, A), l.value.size === 0;
  }
  function S(A) {
    if (l.value.has(A)) {
      const R = new Map(l.value);
      R.delete(A), l.value = R;
    }
  }
  function $() {
    a.value = No(t.value);
  }
  function T() {
    t.value = No(a.value), l.value = /* @__PURE__ */ new Map();
  }
  function L(A) {
    t.value = A ? $b(A, Il) : Lb(), a.value = No(t.value), l.value = /* @__PURE__ */ new Map();
  }
  return {
    root: t,
    addCriterion: d,
    addGroup: u,
    removeNode: b,
    setConjunction: h,
    showConjunction: m,
    depthOf: x,
    canNest: y,
    snapshot: $,
    reset: T,
    reseed: L,
    newId: Il,
    errors: l,
    hasErrors: r,
    isValidLive: i,
    isDirty: s,
    validate: w,
    clearNodeErrors: S
  };
}
function ex(e) {
  const n = Lj(e.modelValue(), e.fields);
  function t() {
    n.root.value.children.length === 0 && (n.addCriterion(n.root.value), n.snapshot());
  }
  t(), ot(() => {
    n.snapshot();
  });
  function a(u) {
    n.reseed(u), t();
  }
  Ie(
    n.root,
    () => {
      e.emitUpdate(Vo(n.root.value));
    },
    { deep: !0 }
  );
  const l = p(
    () => Vo(n.root.value).conditions.length > 0
  ), r = p(
    () => !e.busy() && l.value && n.isValidLive.value
  ), o = p(() => r.value || e.busy() ? null : l.value ? e.labels().saveDisabledInvalid ?? null : e.labels().saveDisabledEmpty ?? null);
  function i() {
    e.busy() || n.validate(e.fields()) && e.emitApply(Vo(n.root.value));
  }
  function s() {
    e.busy() || (n.reset(), e.emitReset());
  }
  function d() {
    r.value && e.emitSave(Vo(n.root.value));
  }
  return {
    builder: n,
    hasCompleteCriterion: l,
    canSave: r,
    saveDisabledReason: o,
    onApply: i,
    onReset: s,
    onSave: d,
    reseedFrom: a
  };
}
const tx = '[data-testid="filter-field-select-panel"]', Ej = ["disabled", "aria-expanded"], Aj = {
  key: 0,
  "data-testid": "filter-field-select-trigger-label",
  class: "sr-only"
}, Rj = { class: "flex min-w-0 flex-1" }, Bj = {
  key: 0,
  class: "flex min-h-4.5 items-center gap-1 text-(length:--size-sm) leading-(--line-height-l) text-(--text-text-error-strong) dark:text-(--text-text-error)",
  role: "alert"
}, Mj = ["aria-label"], Dj = /* @__PURE__ */ ye({
  __name: "FilterFieldSelect",
  props: {
    fields: {},
    groups: { default: () => [] },
    modelValue: { default: "" },
    placeholder: {},
    searchPlaceholder: {},
    searchClearLabel: { default: "Clear search" },
    groupsLabel: {},
    noResultsLabel: {},
    resultsCountLabel: {},
    noFieldsLabel: {},
    emptyGroupLabel: {},
    size: { default: "md" },
    disabled: { type: Boolean, default: !1 },
    fullWidth: { type: Boolean, default: !1 },
    error: { default: void 0 }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: n }) {
    const t = e, a = n, l = E(null), r = E(null), o = E(""), i = E(""), { isOpen: s, dropdownRef: d, toggleDropdown: u, closeDropdown: f } = Yl({
      onClose: b,
      // The panel is teleported to <body>, so every click inside it reads as an
      // "outside" click to useDropdown unless it is explicitly ignored. The selector is
      // shared with the consumers that must ignore it too.
      ignoreSelectors: [tx]
    });
    function b() {
      o.value = "", i.value = "";
    }
    const h = E({}), m = 4, x = 8, y = 540, w = 240;
    function S() {
      var Q;
      const J = (Q = l.value) == null ? void 0 : Q.getBoundingClientRect();
      if (!J) return;
      const be = typeof window < "u" ? window.innerWidth : J.right, ke = typeof window < "u" ? window.innerHeight : J.bottom, ge = J.left + J.width / 2 > be / 2 ? { right: `${be - J.right}px` } : { left: `${J.left}px` }, re = ke - J.bottom - m - x, ue = J.top - m - x, O = re < w && ue > re, U = O ? { bottom: `${ke - J.top + m}px` } : { top: `${J.bottom + m}px` };
      h.value = {
        position: "fixed",
        ...ge,
        ...U,
        maxHeight: `${Math.min(y, Math.max(O ? ue : re, 0))}px`,
        zIndex: "50"
      };
    }
    function $() {
      typeof window > "u" || (window.addEventListener("scroll", S, !0), window.addEventListener("resize", S));
    }
    function T() {
      typeof window > "u" || (window.removeEventListener("scroll", S, !0), window.removeEventListener("resize", S));
    }
    Ie(s, (J) => {
      J ? qe(() => {
        var be;
        S(), $(), (be = r.value) == null || be.focusSearch();
      }) : T();
    }), gt(T);
    const L = p(
      () => t.modelValue ? t.fields.find((J) => J.path === t.modelValue) ?? null : null
    ), A = p(
      () => t.fields.map((J) => ({ key: J.path, label: J.label, icon: J.icon, group: J.group }))
    );
    function R() {
      var be, ke;
      const J = (be = L.value) == null ? void 0 : be.group;
      return J && t.groups.some((ee) => ee.value === J) ? J : ((ke = t.groups[0]) == null ? void 0 : ke.value) ?? "";
    }
    function z() {
      o.value = "", i.value = R(), u();
    }
    function D() {
      if (!t.disabled) {
        if (s.value) {
          f();
          return;
        }
        z();
      }
    }
    const V = E(null), Y = E(!1), _ = E(!1), j = p(() => _.value || s.value ? !1 : Y.value ? !0 : void 0);
    function M(J) {
      try {
        Y.value = J.target.matches(":focus-visible");
      } catch {
        Y.value = !0;
      }
    }
    function W() {
      Y.value = !1, _.value = !1;
    }
    function G(J) {
      var be;
      if (J.key === "Escape" && !s.value && !_.value && Y.value && ((be = V.value) != null && be.isTruncated)) {
        J.stopPropagation(), J.preventDefault(), _.value = !0;
        return;
      }
      t.disabled || s.value || J.key !== "ArrowDown" && J.key !== "ArrowUp" || (J.preventDefault(), z());
    }
    function B(J) {
      a("update:modelValue", J), f(), qe(() => {
        var be;
        return (be = l.value) == null ? void 0 : be.focus();
      });
    }
    function F(J) {
      s.value && (J.stopPropagation(), J.preventDefault(), f(), qe(() => {
        var be;
        return (be = l.value) == null ? void 0 : be.focus();
      }));
    }
    const X = {
      sm: {
        container: "h-[32px] px-[calc(--spacing(2)-1px)] gap-2",
        text: "text-(length:--size-m) leading-(--line-height-l)",
        icon: "text-(length:--icon-size-sm) leading-(--icon-size-sm)"
      },
      md: {
        container: "h-[36px] px-[calc(--spacing(3)-1px)] gap-2",
        text: "text-(length:--size-m) leading-(--line-height-l)",
        icon: "text-(length:--icon-size-sm) leading-(--icon-size-sm)"
      },
      lg: {
        container: "h-[48px] px-[calc(--spacing(3.5)-1px)] gap-2",
        text: "text-(length:--size-l) leading-(--line-height-xxl)",
        icon: "text-(length:--icon-size-md) leading-(--icon-size-md)"
      },
      xl: {
        container: "h-[52px] px-[calc(--spacing(4)-1px)] gap-2",
        text: "text-(length:--size-l) leading-(--line-height-xxl)",
        icon: "text-(length:--icon-size-md) leading-(--icon-size-md)"
      }
    }, H = p(() => X[t.size]), q = p(() => !!t.error), N = p(() => {
      const J = "relative flex min-w-0 items-center w-full rounded-(--border-border-radius-rounded-l) border border-solid box-border text-left font-inter transition-colors select-none focus-visible:outline-hidden focus-visible:shadow-(--shadow-focus-l)";
      return t.disabled ? `${J} cursor-not-allowed bg-gainsboro-200 border-border-disabled-subtle text-text-disabled dark:bg-(--colors-background-disabled) dark:border-(--colors-border-disabled-subtle) dark:text-(--colors-text-disabled)` : q.value ? `${J} cursor-pointer bg-white border-(--border-border-error-strong) text-text-black-default dark:bg-(--colors-background-black-default) dark:border-(--border-border-error) dark:text-(--colors-text-white-default)` : s.value ? `${J} cursor-pointer bg-(--background-background-selected) border-(--border-border-accent) shadow-[0px_0px_2px_var(--border-border-accent)] text-text-black-default dark:bg-(--colors-background-black-default) dark:text-(--colors-text-white-default)` : `${J} cursor-pointer bg-(--background-background-white) border-(--border-border-base-medium) hover:border-(--border-border-accent) text-text-black-default dark:bg-(--colors-background-black-default) dark:border-(--colors-border-base) dark:text-(--colors-text-white-default)`;
    });
    return (J, be) => {
      var ke;
      return c(), g("div", {
        ref_key: "dropdownRef",
        ref: d,
        class: C(["relative min-w-0 text-left", e.fullWidth ? "w-full" : "inline-block max-w-full"]),
        onKeydown: ut(F, ["escape"])
      }, [
        v("button", {
          ref_key: "triggerRef",
          ref: l,
          type: "button",
          "data-testid": "filter-field-select-trigger",
          class: C([N.value, H.value.container]),
          disabled: e.disabled,
          "aria-expanded": I(s),
          "aria-haspopup": "dialog",
          onClick: D,
          onKeydown: G,
          onFocus: M,
          onBlur: W
        }, [
          L.value ? (c(), g("span", Aj, P(e.placeholder), 1)) : k("", !0),
          v("span", Rj, [
            te(bt, {
              ref_key: "labelRef",
              ref: V,
              text: ((ke = L.value) == null ? void 0 : ke.label) ?? e.placeholder,
              focusable: !1,
              open: j.value,
              "text-class": [
                H.value.text,
                e.disabled ? "" : L.value ? "text-text-black-default dark:text-(--colors-text-white-default)" : "text-(--text-text-body-subtle) dark:text-(--colors-text-white-secondary)"
              ].join(" ")
            }, null, 8, ["text", "open", "text-class"])
          ]),
          v("i", {
            class: C(["ri-arrow-down-s-line shrink-0 transition-transform duration-200 ease-in-out", [
              H.value.icon,
              e.disabled ? "text-text-disabled" : "text-(--text-text-body-subtle)",
              I(s) ? "rotate-180" : "rotate-0"
            ]]),
            "aria-hidden": "true"
          }, null, 2)
        ], 42, Ej),
        e.error ? (c(), g("p", Bj, [
          be[2] || (be[2] = v("i", {
            class: "ri-error-warning-fill",
            "aria-hidden": "true"
          }, null, -1)),
          v("span", null, P(e.error), 1)
        ])) : k("", !0),
        (c(), K(Bn, { to: "body" }, [
          te(wt, {
            "enter-active-class": "transition duration-100 ease-out motion-reduce:transition-none",
            "enter-from-class": "transform scale-95 opacity-0",
            "enter-to-class": "transform scale-100 opacity-100",
            "leave-active-class": "transition duration-75 ease-out motion-reduce:transition-none",
            "leave-from-class": "transform scale-100 opacity-100",
            "leave-to-class": "transform scale-95 opacity-0"
          }, {
            default: ve(() => [
              I(s) ? (c(), g("div", {
                key: 0,
                role: "dialog",
                "aria-label": e.placeholder,
                "data-testid": "filter-field-select-panel",
                "data-focus-trap-allow-outside": "",
                style: Ne([{ width: I(Wu).l }, h.value]),
                class: C(["flex max-w-[calc(100vw-2rem)] flex-col overflow-hidden", I(Na)]),
                onKeydown: ut(F, ["escape"])
              }, [
                te(Nv, {
                  ref_key: "pickerRef",
                  ref: r,
                  "active-group": i.value,
                  "onUpdate:activeGroup": be[0] || (be[0] = (ee) => i.value = ee),
                  "search-query": o.value,
                  "onUpdate:searchQuery": be[1] || (be[1] = (ee) => o.value = ee),
                  fields: A.value,
                  groups: e.groups,
                  "strict-groups": "",
                  "groups-label": e.groupsLabel,
                  "search-placeholder": e.searchPlaceholder,
                  "search-clear-label": e.searchClearLabel,
                  "list-label": e.searchPlaceholder,
                  "selected-key": e.modelValue || void 0,
                  "no-results-label": e.noResultsLabel,
                  "results-count-label": e.resultsCountLabel,
                  "no-fields-label": e.noFieldsLabel,
                  "empty-group-label": e.emptyGroupLabel,
                  onSelect: B
                }, null, 8, ["active-group", "search-query", "fields", "groups", "groups-label", "search-placeholder", "search-clear-label", "list-label", "selected-key", "no-results-label", "results-count-label", "no-fields-label", "empty-group-label"])
              ], 46, Mj)) : k("", !0)
            ]),
            _: 1
          })
        ]))
      ], 34);
    };
  }
}), zj = ["aria-label"], Oj = { class: "flex flex-wrap items-start gap-3 py-1" }, Pj = { class: "w-[100px] shrink-0" }, Fj = ["aria-label"], Vj = {
  key: 1,
  class: "flex h-[36px] w-full items-center rounded-xl border border-solid border-(--colors-border-base-medium) bg-(--background-background-white) px-2.5 text-sm font-medium text-(--colors-text-body) dark:border-(--colors-border-base) dark:bg-(--colors-background-black-default) dark:text-(--colors-text-white-default)",
  "aria-hidden": "true"
}, Nj = { class: "min-w-0 flex-1" }, Hj = {
  key: 4,
  class: "flex items-start gap-2"
}, jj = {
  "data-testid": "afb-days-suffix",
  class: "flex h-9 shrink-0 items-center text-sm text-(--colors-text-body)"
}, Wj = ["data-testid"], qj = { class: "flex items-start gap-3" }, Uj = { class: "flex flex-wrap items-center gap-3 pt-1" }, Gj = /* @__PURE__ */ ye({
  __name: "CriteriaGroup",
  props: {
    group: {},
    fields: {},
    labels: {},
    maxDepth: {},
    builder: {},
    depth: {},
    fieldGroups: {}
  },
  setup(e) {
    const n = e;
    function t(V) {
      return V ? n.fields.find((Y) => Y.path === V) : void 0;
    }
    function a(V, Y) {
      const _ = V.type === "DateTime" ? n.labels.dateOperatorLabels : V.type === "String" ? n.labels.stringOperatorLabels : V.type === "Enum" || V.type === "Guid" ? n.labels.listOperatorLabels : void 0;
      return (_ == null ? void 0 : _[Y]) ?? n.labels.operatorLabels[Y] ?? Y;
    }
    function l(V) {
      const Y = t(V.field);
      return Y ? Y.operators.map((_) => ({
        value: _,
        label: a(Y, _)
      })) : [];
    }
    function r(V) {
      var _;
      if (V.field && !t(V.field))
        return "orphan";
      if (!V.field || !V.op)
        return "placeholder";
      if (Zr(V.op))
        return "none";
      const Y = (_ = t(V.field)) == null ? void 0 : _.type;
      return V.op === "lastNDays" || V.op === "nextNDays" ? "days" : V.op === "between" ? Y === "DateTime" ? "dateRange" : "numberRange" : V.op === "in" || V.op === "notIn" ? "tags" : Y === "Bool" ? "bool" : Y === "Number" || Y === "Decimal" ? "number" : Y === "DateTime" ? "date" : "text";
    }
    function o(V) {
      const Y = r(V);
      return Y === "dateRange" || Y === "numberRange" || Y === "tags";
    }
    const i = p(() => [
      { value: "and", label: n.labels.and },
      { value: "or", label: n.labels.or }
    ]);
    function s(V, Y) {
      n.builder.clearNodeErrors(V._id), V.field = Y || null, V.op = null, V.value = null, V.values = [];
    }
    function d(V) {
      return !V || Zr(V) ? "none" : V === "between" ? "between" : V === "in" || V === "notIn" ? "set" : V === "lastNDays" || V === "nextNDays" ? "days" : "scalar";
    }
    function u(V, Y) {
      n.builder.clearNodeErrors(V._id);
      const _ = V.op;
      V.op = Y || null, d(V.op) !== d(_) && (V.value = null, V.values = []);
    }
    function f(V, Y) {
      var j;
      n.builder.clearNodeErrors(V._id);
      const _ = (j = t(V.field)) == null ? void 0 : j.type;
      if (_ === "Number" || _ === "Decimal") {
        V.value = Y === "" ? null : Number(Y);
        return;
      }
      V.value = Y === "" ? null : Y;
    }
    function b(V, Y) {
      n.builder.clearNodeErrors(V._id), V.value = Y === "" ? null : Number(Y);
    }
    function h(V, Y, _) {
      n.builder.clearNodeErrors(V._id);
      const j = [V.values[0] ?? "", V.values[1] ?? ""];
      j[Y] = _ === null ? "" : _, V.values = j;
    }
    function m(V, Y) {
      var j;
      n.builder.clearNodeErrors(V._id);
      const _ = (j = t(V.field)) == null ? void 0 : j.type;
      if (_ === "Number" || _ === "Decimal") {
        V.values = Y.map(Number).filter((M) => Number.isFinite(M));
        return;
      }
      V.values = [...Y];
    }
    function x(V, Y) {
      n.builder.clearNodeErrors(V._id), V.value = Y === "" ? null : Y === "true";
    }
    function y(V) {
      return V.value === null || V.value === void 0 ? "" : String(V.value);
    }
    function w(V) {
      return Fc(V);
    }
    const S = {
      valueRequired: "errorValueRequired",
      valueInvalid: "errorValueInvalid",
      rangeInvalid: "errorRangeInvalid",
      daysInvalid: "errorDaysInvalid",
      operatorIllegal: "errorOperatorIllegal",
      fieldOrphan: "errorFieldOrphan"
    };
    function $(V) {
      const Y = n.builder.errors.value.get(V._id);
      return Y != null && Y.length ? n.labels[S[Y[0]]] : null;
    }
    function T() {
      n.builder.addCriterion(n.group);
    }
    function L() {
      n.builder.addGroup(n.group);
    }
    function A(V) {
      n.builder.removeNode(n.group, V);
    }
    function R(V) {
      n.builder.setConjunction(n.group, V);
    }
    const z = p(() => n.builder.canNest(n.group, n.maxDepth)), D = p(
      () => n.group.operator === "or" ? n.labels.or : n.labels.and
    );
    return (V, Y) => {
      const _ = cx("CriteriaGroup", !0);
      return c(), g("div", {
        class: C([
          "flex flex-col gap-2",
          // The root level sits directly on the modal body (no card, per Figma);
          // only nested groups get a neutral-gray bordered card so they read as a
          // sub-scope. The lavender accent card was a divergence from the design.
          e.depth > 1 ? "rounded-xl border border-solid border-(--colors-border-base-soft) bg-(--colors-background-white-secondary) p-4 dark:border-(--colors-border-base) dark:bg-(--colors-background-black-default)" : ""
        ]),
        role: "group",
        "aria-label": e.labels.title
      }, [
        (c(!0), g(se, null, Me(e.group.children, (j, M) => (c(), g(se, {
          key: j._id
        }, [
          v("div", Oj, [
            v("div", Pj, [
              M === 1 ? (c(), g("div", {
                key: 0,
                role: "group",
                "aria-label": `${e.labels.and} / ${e.labels.or}`
              }, [
                te(Tl, {
                  "data-testid": "afb-conjunction",
                  "model-value": e.group.operator,
                  options: i.value,
                  placeholder: e.labels.and,
                  "aria-label": `${e.labels.and} / ${e.labels.or}`,
                  size: "sm",
                  "full-width": "",
                  "onUpdate:modelValue": R
                }, null, 8, ["model-value", "options", "placeholder", "aria-label"])
              ], 8, Fj)) : M >= 2 ? (c(), g("span", Vj, P(D.value), 1)) : k("", !0)
            ]),
            w(j) ? (c(), g(se, { key: 0 }, [
              te(_, {
                class: "min-w-0 flex-1",
                group: j,
                fields: e.fields,
                labels: e.labels,
                "max-depth": e.maxDepth,
                builder: e.builder,
                depth: e.depth + 1,
                "field-groups": e.fieldGroups
              }, null, 8, ["group", "fields", "labels", "max-depth", "builder", "depth", "field-groups"]),
              te(Re, {
                "data-testid": `afb-remove-${M}`,
                variant: "text",
                "icon-only": "",
                "icon-left": "ri-delete-bin-6-line",
                size: "sm",
                "aria-label": e.labels.removeCriterion,
                class: "shrink-0 mt-1",
                onClick: (W) => A(j._id)
              }, null, 8, ["data-testid", "aria-label", "onClick"])
            ], 64)) : r(j) === "orphan" ? (c(), g(se, { key: 1 }, [
              v("div", Nj, [
                te(zt, {
                  "model-value": j.field ?? "",
                  disabled: "",
                  "full-width": "",
                  error: e.labels.errorFieldOrphan
                }, null, 8, ["model-value", "error"])
              ]),
              te(Re, {
                "data-testid": `afb-remove-${M}`,
                variant: "text",
                "icon-only": "",
                "icon-left": "ri-delete-bin-6-line",
                size: "sm",
                "aria-label": e.labels.removeCriterion,
                class: "shrink-0 mt-1",
                onClick: (W) => A(j._id)
              }, null, 8, ["data-testid", "aria-label", "onClick"])
            ], 64)) : (c(), g(se, { key: 2 }, [
              te(Dj, {
                "data-testid": `afb-field-${M}`,
                class: "min-w-0 flex-1",
                "model-value": j.field ?? "",
                fields: e.fields,
                groups: e.fieldGroups,
                placeholder: e.labels.fieldPlaceholder,
                "search-placeholder": e.labels.fieldSearchPlaceholder,
                "search-clear-label": e.labels.fieldSearchClear,
                "groups-label": e.labels.fieldGroupsLabel,
                "no-results-label": e.labels.fieldNoResults,
                "results-count-label": e.labels.fieldResultsCount,
                "no-fields-label": e.labels.fieldNoFields,
                "empty-group-label": e.labels.fieldEmptyGroup,
                "full-width": "",
                "onUpdate:modelValue": (W) => s(j, W)
              }, null, 8, ["data-testid", "model-value", "fields", "groups", "placeholder", "search-placeholder", "search-clear-label", "groups-label", "no-results-label", "results-count-label", "no-fields-label", "empty-group-label", "onUpdate:modelValue"]),
              te(Tl, {
                "data-testid": `afb-operator-${M}`,
                class: "min-w-0 flex-1",
                "model-value": j.op ?? "",
                options: l(j),
                placeholder: e.labels.operatorPlaceholder,
                "aria-label": e.labels.operatorPlaceholder,
                disabled: !j.field,
                "full-width": "",
                "onUpdate:modelValue": (W) => u(j, W)
              }, null, 8, ["data-testid", "model-value", "options", "placeholder", "aria-label", "disabled", "onUpdate:modelValue"]),
              v("div", {
                class: C(o(j) ? "order-last basis-full min-w-0 pl-[112px]" : "min-w-0 flex-1")
              }, [
                r(j) === "placeholder" ? (c(), K(zt, {
                  key: 0,
                  "model-value": "",
                  placeholder: e.labels.valuePlaceholder,
                  "aria-label": e.labels.valuePlaceholder,
                  disabled: "",
                  "full-width": ""
                }, null, 8, ["placeholder", "aria-label"])) : r(j) === "bool" ? (c(), K(Tl, {
                  key: 1,
                  "data-testid": `afb-value-${M}`,
                  "model-value": j.value === null ? "" : String(j.value),
                  options: [
                    { value: "true", label: e.labels.boolTrue },
                    { value: "false", label: e.labels.boolFalse }
                  ],
                  placeholder: e.labels.valuePlaceholder,
                  "aria-label": e.labels.valuePlaceholder,
                  "full-width": "",
                  "onUpdate:modelValue": (W) => x(j, W)
                }, null, 8, ["data-testid", "model-value", "options", "placeholder", "aria-label", "onUpdate:modelValue"])) : r(j) === "numberRange" ? (c(), K(Iv, {
                  key: 2,
                  "data-testid": `afb-value-${M}`,
                  "min-value": j.values[0] === void 0 || j.values[0] === "" ? null : Number(j.values[0]),
                  "max-value": j.values[1] === void 0 || j.values[1] === "" ? null : Number(j.values[1]),
                  "show-slider": !1,
                  "clamp-input-to-bounds": !1,
                  "min-placeholder": e.labels.rangeFrom,
                  "max-placeholder": e.labels.rangeTo,
                  "min-aria-label": e.labels.rangeFrom,
                  "max-aria-label": e.labels.rangeTo,
                  "separator-label": e.labels.rangeTo,
                  "onUpdate:minValue": (W) => h(j, 0, W),
                  "onUpdate:maxValue": (W) => h(j, 1, W)
                }, null, 8, ["data-testid", "min-value", "max-value", "min-placeholder", "max-placeholder", "min-aria-label", "max-aria-label", "separator-label", "onUpdate:minValue", "onUpdate:maxValue"])) : r(j) === "dateRange" ? (c(), K(E3, {
                  key: 3,
                  "data-testid": `afb-value-${M}`,
                  "start-date": String(j.values[0] ?? ""),
                  "end-date": String(j.values[1] ?? ""),
                  "start-placeholder": e.labels.rangeFrom,
                  "end-placeholder": e.labels.rangeTo,
                  "start-label": "",
                  "end-label": "",
                  language: e.labels.dateLocale ?? "en",
                  format: "yyyy-mm-dd",
                  "full-width": "",
                  "onUpdate:startDate": (W) => h(j, 0, W),
                  "onUpdate:endDate": (W) => h(j, 1, W)
                }, null, 8, ["data-testid", "start-date", "end-date", "start-placeholder", "end-placeholder", "language", "onUpdate:startDate", "onUpdate:endDate"])) : r(j) === "days" ? (c(), g("div", Hj, [
                  te(pf, {
                    "data-testid": `afb-value-${M}`,
                    "model-value": y(j),
                    placeholder: e.labels.valuePlaceholder,
                    "aria-label": e.labels.valuePlaceholder,
                    "full-width": "",
                    "onUpdate:modelValue": (W) => b(j, W)
                  }, null, 8, ["data-testid", "model-value", "placeholder", "aria-label", "onUpdate:modelValue"]),
                  v("span", jj, P(e.labels.daysSuffix), 1)
                ])) : r(j) === "tags" ? (c(), K(T4, {
                  key: 5,
                  "data-testid": `afb-value-${M}`,
                  "model-value": j.values.map(String),
                  placeholder: e.labels.valuePlaceholder,
                  "aria-label": e.labels.valuePlaceholder,
                  "remove-label": e.labels.removeValue,
                  "full-width": "",
                  "onUpdate:modelValue": (W) => m(j, W)
                }, null, 8, ["data-testid", "model-value", "placeholder", "aria-label", "remove-label", "onUpdate:modelValue"])) : r(j) === "number" ? (c(), K(pf, {
                  key: 6,
                  "data-testid": `afb-value-${M}`,
                  "model-value": y(j),
                  placeholder: e.labels.valuePlaceholder,
                  "aria-label": e.labels.valuePlaceholder,
                  "full-width": "",
                  "onUpdate:modelValue": (W) => f(j, W)
                }, null, 8, ["data-testid", "model-value", "placeholder", "aria-label", "onUpdate:modelValue"])) : r(j) === "date" ? (c(), K(fu, {
                  key: 7,
                  "data-testid": `afb-value-${M}`,
                  "model-value": y(j),
                  placeholder: e.labels.valuePlaceholder,
                  "aria-label": e.labels.valuePlaceholder,
                  language: e.labels.dateLocale ?? "en",
                  format: "yyyy-mm-dd",
                  "full-width": "",
                  "onUpdate:modelValue": (W) => f(j, W)
                }, null, 8, ["data-testid", "model-value", "placeholder", "aria-label", "language", "onUpdate:modelValue"])) : r(j) === "text" ? (c(), K(zt, {
                  key: 8,
                  "data-testid": `afb-value-${M}`,
                  "model-value": y(j),
                  placeholder: e.labels.valuePlaceholder,
                  "aria-label": e.labels.valuePlaceholder,
                  "full-width": "",
                  "onUpdate:modelValue": (W) => f(j, W)
                }, null, 8, ["data-testid", "model-value", "placeholder", "aria-label", "onUpdate:modelValue"])) : k("", !0)
              ], 2),
              te(Re, {
                "data-testid": `afb-remove-${M}`,
                variant: "text",
                "icon-only": "",
                "icon-left": "ri-delete-bin-6-line",
                size: "sm",
                "aria-label": e.labels.removeCriterion,
                class: "shrink-0 mt-1",
                onClick: (W) => A(j._id)
              }, null, 8, ["data-testid", "aria-label", "onClick"])
            ], 64))
          ]),
          !w(j) && $(j) ? (c(), g("p", {
            key: 0,
            "data-testid": `afb-error-${M}`,
            class: "ml-[112px] -mt-1 text-xs text-(--text-text-error-strong) dark:text-(--text-text-error)",
            role: "status"
          }, P($(j)), 9, Wj)) : k("", !0)
        ], 64))), 128)),
        v("div", qj, [
          Y[0] || (Y[0] = v("div", {
            class: "w-[100px] shrink-0",
            "aria-hidden": "true"
          }, null, -1)),
          v("div", Uj, [
            te($n, {
              "data-testid": "afb-add-criterion",
              "icon-left": "ri-add-line",
              size: "l",
              onClick: T
            }, {
              default: ve(() => [
                at(P(e.labels.addCriterion), 1)
              ]),
              _: 1
            }),
            z.value ? (c(), K($n, {
              key: 0,
              "data-testid": "afb-add-group",
              "icon-left": "ri-add-line",
              size: "l",
              onClick: L
            }, {
              default: ve(() => [
                at(P(e.labels.addGroup), 1)
              ]),
              _: 1
            })) : k("", !0)
          ])
        ])
      ], 10, zj);
    };
  }
}), Kj = /* @__PURE__ */ lt(Gj, [["__scopeId", "data-v-30236fdf"]]), Yj = {
  "data-testid": "afb-body",
  class: "flex flex-col gap-6"
}, nx = /* @__PURE__ */ ye({
  __name: "AdvancedFilterBody",
  props: {
    builder: {},
    fields: {},
    labels: {},
    maxDepth: { default: 2 },
    fieldGroups: {},
    showInfoAlert: { type: Boolean, default: !0 }
  },
  setup(e) {
    return (n, t) => (c(), g(se, null, [
      e.builder.hasErrors.value ? (c(), K(Ul, {
        key: 0,
        "data-testid": "afb-error-alert",
        color: "danger",
        surface: "card",
        layout: "inline",
        heading: e.labels.errorAlert
      }, null, 8, ["heading"])) : k("", !0),
      e.showInfoAlert ? (c(), K(Ul, {
        key: 1,
        color: "info",
        surface: "card",
        layout: "inline",
        heading: e.labels.alert
      }, null, 8, ["heading"])) : k("", !0),
      v("div", Yj, [
        te(Kj, {
          group: e.builder.root.value,
          fields: e.fields,
          labels: e.labels,
          "max-depth": e.maxDepth,
          builder: e.builder,
          depth: 1,
          "field-groups": e.fieldGroups
        }, null, 8, ["group", "fields", "labels", "max-depth", "builder", "field-groups"])
      ])
    ], 64));
  }
}), Jj = {
  "data-testid": "afb-footer-actions",
  class: "ms-auto flex flex-wrap items-center justify-end gap-4"
}, ax = /* @__PURE__ */ ye({
  __name: "AdvancedFilterFooter",
  props: {
    labels: {},
    busy: { type: Boolean, default: !1 },
    showCancel: { type: Boolean, default: !0 },
    showSave: { type: Boolean, default: !1 },
    canSave: { type: Boolean },
    saveDisabledReason: {}
  },
  emits: ["reset", "cancel", "save", "apply"],
  setup(e, { emit: n }) {
    const t = n;
    return (a, l) => (c(), g(se, null, [
      te(Re, {
        "data-testid": "afb-reset",
        variant: "secondary",
        size: "md",
        label: e.labels.reset,
        disabled: e.busy,
        "icon-left": "ri-refresh-line",
        onClick: l[0] || (l[0] = (r) => t("reset"))
      }, null, 8, ["label", "disabled"]),
      v("div", Jj, [
        e.showCancel ? (c(), K(Re, {
          key: 0,
          "data-testid": "afb-cancel",
          variant: "secondary",
          size: "md",
          label: e.labels.cancel,
          disabled: e.busy,
          onClick: l[1] || (l[1] = (r) => t("cancel"))
        }, null, 8, ["label", "disabled"])) : k("", !0),
        e.showSave ? (c(), K(ft, {
          key: 1,
          text: e.saveDisabledReason ?? "",
          disabled: e.saveDisabledReason === null,
          tabindex: e.saveDisabledReason ? 0 : void 0,
          "data-testid": "afb-save-tooltip",
          position: "top"
        }, {
          default: ve(() => [
            te(Re, {
              "data-testid": "afb-save",
              variant: "secondary",
              size: "md",
              label: e.labels.save,
              disabled: !e.canSave,
              "icon-left": "ri-save-3-fill",
              onClick: l[2] || (l[2] = (r) => t("save"))
            }, null, 8, ["label", "disabled"])
          ]),
          _: 1
        }, 8, ["text", "disabled", "tabindex"])) : k("", !0),
        te(Re, {
          "data-testid": "afb-apply",
          variant: "primary",
          size: "md",
          label: e.labels.apply,
          disabled: e.busy,
          loading: e.busy,
          "icon-left": "ri-check-fill",
          onClick: l[3] || (l[3] = (r) => t("apply"))
        }, null, 8, ["label", "disabled", "loading"])
      ])
    ], 64));
  }
}), Zj = { class: "flex w-full flex-col items-center gap-2 text-center" }, Xj = ["id"], cU = /* @__PURE__ */ ye({
  __name: "AdvancedFilterBuilder",
  props: {
    modelValue: {},
    fields: {},
    fieldGroups: {},
    maxDepth: { default: 2 },
    busy: { type: Boolean, default: !1 },
    labels: {},
    showSave: { type: Boolean, default: !1 },
    showCancel: { type: Boolean, default: !0 }
  },
  emits: ["update:modelValue", "apply", "reset", "cancel", "close", "save"],
  setup(e, { emit: n }) {
    const t = e, a = n, l = ex({
      modelValue: () => t.modelValue,
      fields: () => t.fields,
      busy: () => t.busy,
      labels: () => t.labels,
      emitUpdate: (d) => a("update:modelValue", d),
      emitApply: (d) => a("apply", d),
      emitReset: () => a("reset"),
      emitSave: (d) => a("save", d)
    }), r = Ve(), o = E(!0);
    function i() {
      t.busy || a("cancel");
    }
    function s() {
      o.value = !1, a("close");
    }
    return (d, u) => (c(), K(za, {
      modelValue: o.value,
      "onUpdate:modelValue": u[0] || (u[0] = (f) => o.value = f),
      size: "lg",
      "footer-position": "split",
      "show-header-border": !1,
      "aria-labelledby": I(r),
      onClose: s
    }, {
      header: ve(() => [
        v("div", Zj, [
          u[1] || (u[1] = v("span", {
            class: "flex h-12 w-12 shrink-0 items-center justify-center rounded-lg border border-solid border-(--colors-border-base-soft) bg-(--background-background-white) dark:border-(--colors-border-base) dark:bg-(--colors-background-black-default)",
            "aria-hidden": "true"
          }, [
            v("i", { class: "ri-shuffle-line text-2xl text-(--colors-text-heading)" })
          ], -1)),
          v("h2", {
            id: I(r),
            "data-testid": "afb-title",
            class: "text-xl font-bold text-(--colors-text-heading) dark:text-(--colors-text-white-default)"
          }, P(e.labels.title), 9, Xj)
        ])
      ]),
      footer: ve(() => [
        te(ax, {
          labels: e.labels,
          busy: e.busy,
          "show-cancel": e.showCancel,
          "show-save": e.showSave,
          "can-save": I(l).canSave.value,
          "save-disabled-reason": I(l).saveDisabledReason.value,
          onReset: I(l).onReset,
          onCancel: i,
          onSave: I(l).onSave,
          onApply: I(l).onApply
        }, null, 8, ["labels", "busy", "show-cancel", "show-save", "can-save", "save-disabled-reason", "onReset", "onSave", "onApply"])
      ]),
      default: ve(() => [
        te(nx, {
          builder: I(l).builder,
          fields: e.fields,
          labels: e.labels,
          "max-depth": e.maxDepth,
          "field-groups": e.fieldGroups,
          "show-info-alert": ""
        }, null, 8, ["builder", "fields", "labels", "max-depth", "field-groups"])
      ]),
      _: 1
    }, 8, ["modelValue", "aria-labelledby"]));
  }
}), Qj = ["aria-labelledby"], _j = {
  "data-testid": "afp-header",
  class: "flex min-w-0 shrink-0 items-center justify-between gap-2 max-sm:flex-wrap"
}, eW = ["aria-labelledby"], tW = {
  "data-testid": "afp-scroll",
  class: "flex min-h-0 min-w-0 flex-1 flex-col gap-4 overflow-y-auto px-6 py-5"
}, nW = {
  "data-testid": "afp-footer",
  class: "flex min-w-0 shrink-0 flex-wrap items-center justify-between gap-3 px-6"
}, fU = /* @__PURE__ */ ye({
  __name: "AdvancedFilterPopover",
  props: {
    open: { type: Boolean },
    anchorEl: {},
    modelValue: {},
    fields: {},
    fieldGroups: { default: void 0 },
    maxDepth: { default: 2 },
    busy: { type: Boolean, default: !1 },
    showSave: { type: Boolean, default: !1 },
    labels: {}
  },
  emits: ["update:open", "update:modelValue", "apply", "reset", "save", "view-all"],
  setup(e, { expose: n, emit: t }) {
    const a = e, l = t, r = ex({
      modelValue: () => a.modelValue,
      fields: () => a.fields,
      busy: () => a.busy,
      labels: () => a.labels,
      emitUpdate: (M) => l("update:modelValue", M),
      emitApply: (M) => l("apply", M),
      emitReset: () => l("reset"),
      emitSave: (M) => l("save", M)
    }), o = Ve(), i = E(null);
    Gi({
      active: qn(a, "open"),
      container: i,
      containFocus: !0,
      // AC 10 — restore focus to the STABLE "Filtrer" trigger, not whatever had focus when the
      // panel opened: the opening click can come from a transient, self-closing control (e.g.
      // TableFilterSelector's own step-1 "Créer un filtre avancé"/"Voir tous les filtres
      // avancés" items — TableFilterSelector.vue's handleCreateAdvanced/handleViewAdvanced emit
      // then immediately closeDropdown(), unmounting the very button that was just clicked).
      // useFocusTrap's default previousActive-based restore captures that transient node's live
      // reference at open time, but by close time it's detached from the document — `.focus()`
      // on a detached node is a silent no-op, so focus fell back to `<body>`. `anchorEl` is
      // already the stable anchor this popover receives for positioning; reusing it here covers
      // both the direct-anchorEl-click case and the transient-control case identically.
      restoreFocusTo: () => a.anchorEl
    });
    const s = [
      tx,
      '[data-testid="dropdown-menu"]',
      '[data-testid="datepicker-dropdown-menu"]',
      '[role="tooltip"]',
      '[role="dialog"]',
      '[data-testid="modal-backdrop"]'
    ], d = 996, u = 588, f = 8, b = 4, h = E({});
    function m() {
      var q;
      const M = (q = a.anchorEl) == null ? void 0 : q.getBoundingClientRect();
      if (!M) return;
      const W = window.innerWidth, G = window.innerHeight, B = Math.min(d, W - 2 * f), F = M.bottom + b, X = Math.min(
        Math.max(f, M.left),
        Math.max(f, W - B - f)
      ), H = Math.min(u, G - F - f);
      h.value = {
        position: "fixed",
        top: `${F}px`,
        left: `${X}px`,
        width: `${B}px`,
        maxHeight: `${H}px`,
        zIndex: "50"
      };
    }
    function x() {
      window.addEventListener("scroll", m, !0), window.addEventListener("resize", m);
    }
    function y() {
      window.removeEventListener("scroll", m, !0), window.removeEventListener("resize", m);
    }
    let w = a.modelValue;
    Ie(
      () => a.open,
      (M) => {
        if (M) {
          const W = a.modelValue !== w, G = r.builder.isDirty.value;
          (W || G) && (r.reseedFrom(a.modelValue), w = a.modelValue), qe(() => {
            m(), x();
          });
        } else
          y();
      },
      { immediate: !0 }
    );
    const S = Symbol("advanced-filter-popover");
    Ie(
      () => a.open,
      (M) => {
        M ? Zn(S) : An(S);
      },
      { immediate: !0 }
    ), gt(() => {
      y(), An(S);
    });
    const $ = E(!1), T = E(null);
    let L = !1;
    function A() {
      if (!r.builder.isDirty.value) {
        V();
        return;
      }
      $.value = !0;
    }
    function R() {
      T.value = () => l("view-all"), A();
    }
    function z(M) {
      T.value = M, A();
    }
    function D() {
      qe(() => {
        var M;
        return (M = a.anchorEl) == null ? void 0 : M.focus();
      });
    }
    function V() {
      if ($.value = !1, r.builder.reset(), l("update:open", !1), T.value) {
        L = !0;
        const M = T.value;
        T.value = null, M();
      } else
        D();
    }
    function Y() {
      $.value = !1, T.value = null;
    }
    function _() {
      if (r.builder.reset(), L) {
        L = !1;
        return;
      }
      D();
    }
    n({ requestCloseThen: z, discard: _ });
    function j(M) {
      a.open && Va(S) && (M.defaultPrevented || (M.stopPropagation(), M.preventDefault(), A()));
    }
    return Ji(i, A, {
      isActive: () => a.open,
      ignoreSelectors: s
    }), (M, W) => (c(), K(Bn, { to: "body" }, [
      e.open ? (c(), g("div", {
        key: 0,
        ref_key: "panelRef",
        ref: i,
        role: "dialog",
        "aria-modal": "true",
        "aria-labelledby": I(o),
        "data-testid": "afp-panel",
        style: Ne(h.value),
        class: "flex flex-col gap-2 rounded-(--border-border-radius-rounded-l) bg-(--background-background-white) px-3 py-4 shadow-(--blur-shadow-m) dark:bg-(--colors-background-black-default) dark:shadow-(--blur-shadow-m-dark)",
        onKeydown: ut(j, ["escape"])
      }, [
        v("div", _j, [
          v("h2", {
            "data-testid": "afp-title",
            class: "flex min-w-0",
            "aria-labelledby": I(o)
          }, [
            te(Or, {
              id: I(o),
              type: "h5",
              "icon-left": "ri-shuffle-line",
              label: e.labels.title,
              "info-right": e.labels.titleInfo,
              "data-testid": "afp-heading"
            }, null, 8, ["id", "label", "info-right"])
          ], 8, eW),
          te($n, {
            "data-testid": "afp-view-all",
            size: "l",
            class: "max-w-full shrink-0 text-left",
            onClick: R
          }, {
            default: ve(() => [
              at(P(e.labels.viewAllFilters), 1)
            ]),
            _: 1
          })
        ]),
        v("div", tW, [
          te(nx, {
            builder: I(r).builder,
            fields: e.fields,
            labels: e.labels,
            "max-depth": e.maxDepth,
            "field-groups": e.fieldGroups,
            "show-info-alert": !1
          }, null, 8, ["builder", "fields", "labels", "max-depth", "field-groups"])
        ]),
        v("div", nW, [
          te(ax, {
            labels: e.labels,
            busy: e.busy,
            "show-cancel": !1,
            "show-save": e.showSave,
            "can-save": I(r).canSave.value,
            "save-disabled-reason": I(r).saveDisabledReason.value,
            onReset: I(r).onReset,
            onSave: I(r).onSave,
            onApply: I(r).onApply
          }, null, 8, ["labels", "busy", "show-save", "can-save", "save-disabled-reason", "onReset", "onSave", "onApply"])
        ]),
        $.value ? (c(), K(kV, {
          key: 0,
          "model-value": $.value,
          title: e.labels.confirmCloseTitle,
          message: e.labels.confirmCloseMessage,
          "stay-label": e.labels.confirmCloseStay,
          "leave-label": e.labels.confirmCloseLeave,
          "onUpdate:modelValue": W[0] || (W[0] = (G) => $.value = G),
          onStay: Y,
          onLeave: V
        }, null, 8, ["model-value", "title", "message", "stay-label", "leave-label"])) : k("", !0)
      ], 44, Qj)) : k("", !0)
    ]));
  }
}), aW = ["aria-label"], lW = { class: "flex min-w-0 flex-wrap items-center gap-2.5 text-(length:--size-m) leading-(--line-height-l) font-(--weight-medium)" }, rW = {
  key: 1,
  class: "sr-only"
}, oW = ["aria-current"], iW = {
  key: 1,
  class: "sr-only"
}, sW = {
  key: 2,
  "data-testid": "breadcrumb-separator",
  class: "ri-arrow-right-s-line inline-flex size-3.5 shrink-0 items-center justify-center text-num-14 text-(--icons-icon-dark-default) dark:text-(--icons-icon-white-default)",
  "aria-hidden": "true"
}, Ab = "inline-flex min-w-0 max-w-full items-center gap-1.5 rounded-(--border-border-radius-rounded-xs)", dW = "text-(--text-text-heading) hover:text-(--text-text-body) dark:text-(--text-text-white-default) dark:hover:text-(--text-text-white-secondary) transition-colors duration-150 ease-in-out motion-reduce:transition-none focus-visible:outline-hidden focus-visible:shadow-(--shadow-focus-l)", Rb = "inline-flex size-4 shrink-0 items-center justify-center text-num-16 text-(--icons-icon-dark-default) dark:text-(--icons-icon-white-default)", hU = /* @__PURE__ */ ye({
  __name: "Breadcrumb",
  props: {
    items: {},
    type: { default: "default" },
    ariaLabel: {},
    linkAs: { default: "a" }
  },
  setup(e) {
    var y;
    const n = e, t = p(() => [
      "flex w-fit max-w-full min-w-0 items-center text-(--text-text-heading) dark:text-(--text-text-white-default)",
      n.type === "background" ? "border border-(--border-border-white-default) bg-(--background-background-white) p-[calc(--spacing(2.5)-1px)] rounded-(--border-border-radius-rounded-base) shadow-(--blur-shadow-xs) dark:bg-(--background-background-black-default) dark:border-(--border-border-base)" : "rounded-(--border-border-radius-rounded-xs)"
    ]);
    function a(w) {
      return w === n.items.length - 1;
    }
    function l(w) {
      return w.to != null && n.linkAs !== "a";
    }
    function r(w, S) {
      return !a(S) && (l(w) || w.href !== void 0);
    }
    const o = typeof process < "u" && ((y = process.env) == null ? void 0 : y.NODE_ENV) !== "production";
    Ie(
      () => n.items,
      (w) => {
        o && n.linkAs === "a" && w.some((S) => S.to != null) && console.warn(
          "[OPAL Breadcrumb] items with `to` need `linkAs` (e.g. RouterLink); they render as text."
        );
      },
      { immediate: !0 }
    );
    function i(w) {
      return !!(w.hideLabel && w.icon);
    }
    const s = E([]), d = E(null), u = E(!1);
    function f(w) {
      if (d.value === w)
        return !u.value;
    }
    function b(w, S) {
      let $;
      try {
        $ = S.target.matches(":focus-visible");
      } catch {
        $ = !0;
      }
      d.value = $ ? w : null;
    }
    function h() {
      d.value = null, u.value = !1;
    }
    function m(w, S) {
      var $;
      S.key !== "Escape" || u.value || d.value !== w || !(($ = s.value[w]) != null && $.isTruncated) || (S.stopPropagation(), S.preventDefault(), u.value = !0);
    }
    const x = E(null);
    return Ie(
      () => n.items,
      () => {
        var w;
        (w = x.value) != null && w.contains(document.activeElement) || h();
      },
      { deep: 1, flush: "post" }
    ), (w, S) => (c(), g("nav", {
      ref_key: "navEl",
      ref: x,
      "aria-label": e.ariaLabel,
      "data-testid": "breadcrumb",
      class: C(t.value)
    }, [
      v("ol", lW, [
        (c(!0), g(se, null, Me(e.items, ($, T) => (c(), g("li", {
          key: T,
          "data-testid": "breadcrumb-item",
          class: "flex min-w-0 max-w-full items-center gap-1.5"
        }, [
          r($, T) ? (c(), K(dt(l($) ? e.linkAs : "a"), Oe({
            key: 0,
            ref_for: !0
          }, l($) ? { to: $.to } : { href: $.href }, {
            "data-testid": "breadcrumb-link",
            class: [Ab, dW],
            onFocus: (L) => b(T, L),
            onBlur: h,
            onKeydown: (L) => m(T, L)
          }), {
            default: ve(() => [
              $.icon ? (c(), g("i", {
                key: 0,
                class: C([$.icon, Rb]),
                "aria-hidden": "true"
              }, null, 2)) : k("", !0),
              i($) ? (c(), g("span", rW, P($.label), 1)) : (c(), K(bt, {
                key: 2,
                ref_for: !0,
                ref: (L) => s.value[T] = L,
                text: $.label,
                focusable: !1,
                open: f(T)
              }, null, 8, ["text", "open"]))
            ]),
            _: 2
          }, 1040, ["class", "onFocus", "onKeydown"])) : (c(), g("span", {
            key: 1,
            "data-testid": "breadcrumb-text",
            "aria-current": a(T) && i($) ? "page" : void 0,
            class: C([
              Ab,
              a(T) ? "text-(--text-text-black-default) dark:text-(--text-text-white-default)" : "text-(--text-text-heading) dark:text-(--text-text-white-default)"
            ])
          }, [
            $.icon ? (c(), g("i", {
              key: 0,
              class: C([$.icon, Rb]),
              "aria-hidden": "true"
            }, null, 2)) : k("", !0),
            i($) ? (c(), g("span", iW, P($.label), 1)) : (c(), K(bt, {
              key: 2,
              text: $.label,
              "aria-current": a(T) ? "page" : void 0
            }, null, 8, ["text", "aria-current"]))
          ], 10, oW)),
          T < e.items.length - 1 ? (c(), g("i", sW)) : k("", !0)
        ]))), 128))
      ])
    ], 10, aW));
  }
}), uW = {
  key: 0,
  "data-testid": "banner",
  class: "@container/banner w-full min-w-0"
}, cW = {
  role: "status",
  "aria-live": "polite",
  "aria-atomic": "true",
  class: "sr-only",
  "data-testid": "banner-live"
}, fW = {
  key: 0,
  "data-testid": "banner-content",
  class: "flex min-w-0 flex-1 items-center justify-center gap-2.5"
}, hW = {
  key: 0,
  "data-testid": "banner-text",
  class: "min-w-0 wrap-break-word text-center text-(length:--size-m) leading-(--line-height-l) font-(--weight-regular) text-(--text-text-black-default) dark:text-(--text-text-white-default)"
}, bW = {
  key: 1,
  "data-testid": "banner-content",
  class: "flex min-w-0 flex-1 flex-col gap-4 @5xl/banner:flex-row @5xl/banner:items-center @5xl/banner:justify-between @5xl/banner:gap-0"
}, gW = {
  key: 0,
  "data-testid": "banner-text-group",
  class: "flex min-w-0 flex-1 flex-col gap-1"
}, pW = {
  key: 1,
  "data-testid": "banner-description",
  class: "wrap-break-word text-(length:--size-m) leading-(--line-height-l) font-(--weight-regular) text-(--text-text-body) dark:text-(--text-text-white-secondary)"
}, mW = {
  key: 1,
  "data-testid": "banner-text-group",
  class: "flex min-w-0 flex-1 items-center gap-4"
}, vW = {
  key: 0,
  "data-testid": "banner-logo",
  class: "flex shrink-0 items-center"
}, xW = {
  "data-testid": "banner-text",
  class: "min-w-0 wrap-break-word text-(length:--size-l) leading-(--line-height-xxl) font-(--weight-regular) text-(--text-text-black-default) dark:text-(--text-text-white-default)"
}, yW = 150, kW = 5e3, bU = /* @__PURE__ */ ye({
  __name: "Banner",
  props: {
    type: { default: "default" },
    text: { default: void 0 },
    heading: { default: void 0 },
    description: { default: void 0 },
    headingLevel: { default: 2 },
    icon: { default: "ri-notification-4-line" },
    link: { default: void 0 },
    primaryAction: { default: void 0 },
    secondaryAction: { default: void 0 },
    closeLabel: {}
  },
  emits: ["close", "link", "primary", "secondary"],
  setup(e, { emit: n }) {
    const t = e, a = n, l = E(!1), r = E("");
    let o;
    const i = p(
      () => (t.type === "heading" ? [t.heading, t.description] : [t.text]).filter(Boolean).join(" ")
    );
    function s() {
      clearTimeout(o), r.value = "", o = setTimeout(() => {
        r.value = i.value, o = setTimeout(() => r.value = "", kW);
      }, yW);
    }
    ot(s), Ie(i, () => qe(s)), gt(() => clearTimeout(o));
    const d = p(() => [
      "flex w-full min-w-0 p-4 bg-(--background-background-white) rounded-(--border-border-radius-rounded-l) dark:bg-(--background-background-black-default)",
      t.type === "logo" ? "items-start border border-(--border-border-base-soft) shadow-(--blur-shadow-s) dark:border-(--border-border-base) dark:shadow-(--blur-shadow-m-dark) @5xl/banner:items-center @5xl/banner:justify-between" : "border-b border-(--border-border-base-soft) dark:border-(--border-border-base)",
      t.type === "heading" ? "items-start @5xl/banner:items-center" : "",
      t.type === "default" ? "items-center" : ""
    ]);
    function u() {
      a("close"), l.value = !0;
    }
    return (f, b) => l.value ? k("", !0) : (c(), g("div", uW, [
      v("div", cW, P(r.value), 1),
      v("div", {
        "data-testid": "banner-surface",
        class: C(d.value)
      }, [
        e.type === "default" ? (c(), g("div", fW, [
          te(Xt, {
            icon: e.icon,
            color: "gradient",
            size: "sm",
            type: "circle",
            variant: "filled",
            class: "shrink-0"
          }, null, 8, ["icon"]),
          e.text ? (c(), g("p", hW, P(e.text), 1)) : k("", !0),
          e.link ? (c(), K($n, {
            key: 1,
            "data-testid": "banner-link",
            as: e.link.href ? "a" : "button",
            href: e.link.href,
            "aria-label": e.link.ariaLabel,
            size: "s",
            "icon-right": "ri-arrow-right-line",
            class: "shrink-0",
            onClick: b[0] || (b[0] = (h) => e.link.href || a("link"))
          }, {
            default: ve(() => [
              at(P(e.link.label), 1)
            ]),
            _: 1
          }, 8, ["as", "href", "aria-label"])) : k("", !0)
        ])) : (c(), g("div", bW, [
          e.type === "heading" ? (c(), g("div", gW, [
            e.heading ? (c(), K(dt(`h${e.headingLevel}`), {
              key: 0,
              "data-testid": "banner-heading",
              class: "wrap-break-word text-(length:--size-xl) leading-(--line-height-xl) font-(--weight-semi-bold) text-(--text-text-heading) dark:text-(--text-text-white-default)"
            }, {
              default: ve(() => [
                at(P(e.heading), 1)
              ]),
              _: 1
            })) : k("", !0),
            e.description ? (c(), g("p", pW, P(e.description), 1)) : k("", !0)
          ])) : (c(), g("div", mW, [
            f.$slots.logo ? (c(), g("div", vW, [
              $e(f.$slots, "logo")
            ])) : k("", !0),
            e.text ? (c(), g("div", {
              key: 1,
              "data-testid": "banner-text-frame",
              class: C(["flex min-w-0 flex-1 items-center", f.$slots.logo ? "border-l border-(--border-border-base-soft) pl-[calc(--spacing(4)-1px)] dark:border-(--border-border-base)" : ""])
            }, [
              v("p", xW, P(e.text), 1)
            ], 2)) : k("", !0)
          ])),
          e.secondaryAction || e.primaryAction ? (c(), g("div", {
            key: 2,
            "data-testid": "banner-actions",
            class: C(["flex shrink-0 flex-wrap items-center gap-3", e.type === "logo" ? "justify-end" : ""])
          }, [
            e.type === "heading" && e.secondaryAction ? (c(), K(Re, {
              key: 0,
              "data-testid": "banner-secondary",
              variant: "secondary",
              size: "xs",
              "icon-left": "ri-arrow-left-line",
              label: e.secondaryAction.label,
              onClick: b[1] || (b[1] = (h) => a("secondary"))
            }, null, 8, ["label"])) : k("", !0),
            e.primaryAction ? (c(), K(Re, {
              key: 1,
              "data-testid": "banner-primary",
              variant: "primary",
              size: "xs",
              "icon-right": e.type === "heading" ? "ri-arrow-right-line" : void 0,
              label: e.primaryAction.label,
              onClick: b[2] || (b[2] = (h) => a("primary"))
            }, null, 8, ["icon-right", "label"])) : k("", !0)
          ], 2)) : k("", !0)
        ])),
        te(Re, {
          "data-testid": "banner-close",
          variant: "tertiary",
          size: "xs",
          "icon-only": "",
          "icon-left": "ri-close-fill",
          "aria-label": e.closeLabel,
          class: C(["shrink-0", e.type === "default" ? "" : "@5xl/banner:ml-3"]),
          onClick: u
        }, null, 8, ["aria-label", "class"])
      ], 2)
    ]));
  }
}), gU = {
  "Background-background-black-default": "{Colors.Primary.800-base}",
  "Background-background-white": "{white}",
  "Background-background-white-secondary": "{Colors.Neutral.100}",
  "Background-background-white-secondary-soft": "{Colors.Neutral.050}",
  "Background-background-white-tertiary": "{Colors.Gray.100}",
  "Background-background-selected": "{Colors.Gray.050}",
  "Background-background-info": "{Colors.Violet.50}",
  "Background-background-success": "{Colors.Success.50}",
  "Background-background-warning": "{Colors.Warning.50}",
  "Background-background-error": "{Colors.Error.50}",
  "Background-background-hover": "{Colors.Indigo.50}",
  "Background-background-accent": "{Colors.Violet.50}",
  "Background-background-accent-strong": "{Colors.Indigo.600}",
  "Background-background-disabled": "{Colors.Gray.100}",
  "Background-background-disabled-strong": "{Colors.Gray.300}",
  "Background-background-disabled-opacity": "{Colors.Gray.200-opacity-medium}",
  "Background-background-disabled-subtle": "{Colors.Gray.050}",
  "Background-background-gray": "{Colors.Gray.200}",
  "Background-background-ia": "{Colors.Purple.50}",
  "Text-text-white-default": "{Colors.Neutral.050}",
  "Text-text-white-secondary": "{Colors.Neutral.100}",
  "Text-text-black-default": "{Colors.Primary.800-base}",
  "Text-text-brand-bold": "{Colors.Primary.800-opacity-bold}",
  "Text-text-heading": "{Colors.Primary.800-base}",
  "Text-text-body": "{Colors.Gray.700}",
  "Text-text-body-subtle": "{Colors.Gray.500}",
  "Text-text-disabled-strong": "{Colors.Gray.500}",
  "Text-text-disabled-light": "{Colors.Gray.400}",
  "Text-text-success-strong": "{Colors.Success.700}",
  "Text-text-success": "{Colors.Success.600}",
  "Text-text-success-subtle": "{Colors.Success.500}",
  "Text-text-warning": "{Colors.Warning.600}",
  "Text-Text-error": "{Colors.Error.600}",
  "Text-Text-error-strong": "{Colors.Error.700}",
  "Text-Text-error-subtle": "{Colors.Error.500}",
  "Text-Text-link": "{Colors.Violet.500}",
  "Text-Text-hover": "{Colors.Violet.800}",
  "Text-Text-info": "{Colors.Indigo.700}",
  "Text-Text-accent": "{Colors.Indigo.500}",
  "Icons-icon-black": "{black}",
  "Icons-icon-white": "{white}",
  "Icons-icon-dark-default": "{Colors.Primary.800-base}",
  "Icons-icon-white-default": "{Colors.Neutral.100}",
  "Icons-icon-disabled-strong": "{Colors.Gray.500}",
  "Icons-icon-disabled-light": "{Colors.Gray.400}",
  "Icons-icon-base": "{Colors.Gray.500}",
  "Icons-icon-base-strong": "{Colors.Gray.700}",
  "Icons-icon-link": "{Colors.Violet.500}",
  "Icons-icon-success": "{Colors.Success.500}",
  "Icons-icon-success-subtle": "{Colors.Success.400}",
  "Icons-icon-warning": "{Colors.Warning.600}",
  "Icons-icon-error": "{Colors.Error.700}",
  "Icons-icon-info": "{Colors.Indigo.700}",
  "Icons-icon-hover": "{Colors.Violet.800}",
  "Icons-icon-accent": "{Colors.Indigo.500}",
  "Icons-icon-accent-strong": "{Colors.Indigo.600}",
  "Icons-icon-ia": "{Colors.Purple.600}",
  "Icons-icon-cyan": "{Colors.Cyan.500}",
  "Icons-icon-color-default": "{Colors.Cyan.600}",
  "Components-Button-button-disabled": "{Colors.Gray.200-opacity-bold}",
  "Components-Button-Primary-button-primary": "{Colors.Primary.800-base}",
  "Components-Button-Primary-button-primary-hover": "{Colors.Gray.500}",
  "Components-Button-Secondary-button-secondary": "{white}",
  "Components-Button-Secondary-button-secondary-hover": "{Colors.Primary.800-opacity-bold}",
  "Components-Button-Secondary-button-secondary-focused": "{Colors.Indigo.400}",
  "Components-Button-Tertiary-button-tertiary-hover": "{Colors.Indigo.50}",
  "Components-Button-Tertiary-button-tertiary-focused": "{Colors.Indigo.50}",
  "Components-Button-Tab-button-tab-default": "{Colors.Gray.100}",
  "Components-Button-Tab-button-tab": "{white}",
  "Components-Button-Tab-button-tab-hover": "{Colors.Indigo.400}",
  "Components-Button-Tab-button-tab-active": "{white}",
  "Components-Button-Text-button-text": "{Colors.Primary.800-base}",
  "Components-Button-Text-button-text-hover": "{Colors.Indigo.700}",
  "Components-Button-Ghost-button-ghost-hover": "{Colors.Indigo.50}",
  "Components-Button-Functional-Success-button-success": "{Colors.Success.700}",
  "Components-Button-Functional-Success-button-success-hover": "{Colors.Success.800}",
  "Components-Button-Functional-Success-button-success-focused": "{Colors.Success.800}",
  "Components-Button-Functional-Desctructive error-Background-button-error": "{Colors.Error.600}",
  "Components-Button-Functional-Desctructive error-Background-button-error-hover": "{Colors.Error.700}",
  "Components-Button-Functional-Desctructive error-Background-button-error-focused": "{Colors.Error.900}",
  "Components-Button-Functional-Desctructive error-Icons-button-error-icon": "{Colors.Error.600}",
  "Components-Button-Functional-Desctructive error-Icons-button-error-hover-icon": "{Colors.Error.700}",
  "Components-Button-Functional-Desctructive error-Icons-button-error-focused-icon": "{Colors.Error.900}",
  "Components-Badge-Background-badge-disabled-bg": "{Colors.Gray.300}",
  "Components-Badge-Background-badge-gray-bg": "{Colors.Gray.500}",
  "Components-Badge-Background-badge-error-bg": "{Colors.Error.200}",
  "Components-Badge-Background-badge-error-strong-bg": "{Colors.Error.500}",
  "Components-Badge-Background-badge-orange-bg": "{Colors.Warning.100}",
  "Components-Badge-Background-badge-orange-strong-bg": "{Colors.Warning.500}",
  "Components-Badge-Background-badge-yellow-bg": "{Colors.Yellow.100}",
  "Components-Badge-Background-badge-yellow-strong-bg": "{Colors.Yellow.300}",
  "Components-Badge-Background-badge-green-bg": "{Colors.Success.100}",
  "Components-Badge-Background-badge-green-strong-bg": "{Colors.Success.500}",
  "Components-Badge-Background-badge-indigo-soft-bg": "{Colors.Indigo.100}",
  "Components-Badge-Background-badge-indigo-medium-bg": "{Colors.Indigo.300}",
  "Components-Badge-Background-badge-indigo-strong-bg": "{Colors.Indigo.500}",
  "Components-Badge-Background-badge-accent-bg": "{Colors.Indigo.80-opacity}",
  "Components-Badge-Background-badge-violet-bg": "{Colors.Violet.200}",
  "Components-Badge-Background-badge-violet-strong-bg": "{Colors.Violet.400}",
  "Components-Badge-Background-badge-purple-bg": "{Colors.Purple.100}",
  "Components-Badge-Background-badge-purple-strong-bg": "{Colors.Purple.400}",
  "Components-Badge-Background-badge-neutral-bg": "{Colors.Neutral.200}",
  "Components-Badge-Background-badge-neutral-strong-bg": "{Colors.Neutral.400}",
  "Components-Badge-Background-badge-cyan-bg": "{Colors.Cyan.100}",
  "Components-Badge-Background-badge-cyan-strong-bg": "{Colors.Cyan.400}",
  "Components-Badge-Background-badge-white-bg": "{white}",
  "Components-Badge-Background-badge-dark-bg": "{Colors.Neutral.700}",
  "Components-Badge-Icon-badge-disabled-icon": "{Colors.Gray.500}",
  "Components-Badge-Icon-badge-black-icon": "{black}",
  "Components-Badge-Icon-badge-white-icon": "{white}",
  "Components-Badge-Icon-badge-white-default-icon": "{Colors.Neutral.100}",
  "Components-Badge-Icon-badge-dark-icon": "{Colors.Neutral.700}",
  "Components-Badge-Icon-badge-black-default-icon": "{Colors.Primary.800-base}",
  "Components-Badge-Text-badge-disabled-strong-text": "{Colors.Gray.500}",
  "Components-Badge-Text-badge-white-text": "{white}",
  "Components-Badge-Text-badge-white-default-text": "{Colors.Neutral.050}",
  "Components-Badge-Text-badge-black-text": "{black}",
  "Components-Badge-Text-badge-black-default-text": "{Colors.Primary.800-base}",
  "Components-Badge-Text-badge-body-text": "{Colors.Gray.700}",
  "Components-Badge-Border-badge-disabled-border": "{Colors.Gray.300}",
  "Components-Badge-Border-badge-white-border": "{white}",
  "Components-Badge-Border-badge-white-default-border": "{Colors.Neutral.400}",
  "Components-Badge-Border-badge-base-soft-border": "{Colors.Gray.200}",
  "Components-Badge-Border-badge-black-border": "{black}",
  "Components-Badge-Border-badge-dark-default-border": "{Colors.Primary.800-base}",
  "Components-Icon shape-Background-iconshape-disabled-bg": "{Colors.Gray.200-opacity-medium}",
  "Components-Icon shape-Background-iconshape-red-bg": "{Colors.Error.100}",
  "Components-Icon shape-Background-iconshape-orange-bg": "{Colors.Warning.100}",
  "Components-Icon shape-Background-iconshape-yellow-bg": "{Colors.Yellow.100}",
  "Components-Icon shape-Background-iconshape-green-bg": "{Colors.Success.100}",
  "Components-Icon shape-Background-iconshape-indigo-bg": "{Colors.Indigo.100}",
  "Components-Icon shape-Background-iconshape-violet-bg": "{Colors.Violet.200}",
  "Components-Icon shape-Background-iconshape-purple-bg": "{Colors.Purple.100}",
  "Components-Icon shape-Background-iconshape-neutral-bg": "{Colors.Neutral.200}",
  "Components-Icon shape-Background-iconshape-cyan-bg": "{Colors.Cyan.100}",
  "Components-Icon shape-Background-iconshape-black-bg": "{black}",
  "Components-Icon shape-Background-iconshape-black-default-bg": "{Colors.Primary.800-base}",
  "Components-Icon shape-Background-iconshape-white-bg": "{white}",
  "Components-Icon shape-Background-iconshape-success-bg": "{Colors.Success.600}",
  "Components-Icon shape-Background-iconshape-error-bg": "{Colors.Error.500}",
  "Components-Icon shape-Background-iconshape-accent-bg": "{Colors.Indigo.50}",
  "Components-Icon shape-Icon-iconshape-black-icon": "{black}",
  "Components-Icon shape-Icon-iconshape-white-icon": "{white}",
  "Components-Icon shape-Icon-iconshape-white-default-icon": "{Colors.Neutral.100}",
  "Components-Icon shape-Icon-iconshape-disabled-icon": "{Colors.Gray.200-opacity-medium}",
  "Components-Icon shape-Icon-iconshape-disabled-strong-icon": "{Colors.Gray.500}",
  "Components-Icon shape-Icon-iconshape-success-icon": "{Colors.Success.600}",
  "Components-Icon shape-Icon-iconshape-red-icon": "{Colors.Error.700}",
  "Components-Icon shape-Icon-iconshape-error-icon": "{Colors.Error.500}",
  "Components-Icon shape-Icon-iconshape-brand-icon": "{Colors.Primary.800-base}",
  "Components-Icon shape-Icon-iconshape-accent-gradient-icon": "{Colors.Primary.800-opacity-bold}",
  "Components-Icon shape-Icon-iconshape-orange-icon": "{Colors.Warning.600}",
  "Components-Icon shape-Icon-iconshape-yellow-icon": "{Colors.Yellow.600}",
  "Components-Icon shape-Icon-iconshape-green-icon": "{Colors.Success.500}",
  "Components-Icon shape-Icon-iconshape-indigo-icon": "{Colors.Indigo.400}",
  "Components-Icon shape-Icon-iconshape-violet-icon": "{Colors.Violet.700}",
  "Components-Icon shape-Icon-iconshape-purple-icon": "{Colors.Purple.700}",
  "Components-Icon shape-Icon-iconshape-neutral-icon": "{Colors.Neutral.200}",
  "Components-Icon shape-Icon-iconshape-default-icon": "{Colors.Cyan.600}",
  "Components-Icon shape-Border-iconshape-disabled-border": "{Colors.Gray.300}",
  "Components-Icon shape-Border-iconshape-default-border": "{Colors.Neutral.200}",
  "Components-Icon shape-Border-iconshape-accent-border": "{Colors.Cyan.600}",
  "Components-Icon shape-Border-iconshape-error-border": "{Colors.Error.600}",
  "Components-Icon shape-Border-iconshape-success-border": "{Colors.Success.500}",
  "Components-Icon shape-Text-iconshape-disabled-text": "{Colors.Gray.500}",
  "Components-Icon shape-Text-iconshape-black-default-text": "{Colors.Primary.800-base}",
  "Components-Icon shape-Text-iconshape-default-text": "{Colors.Cyan.600}",
  "Components-Icon shape-Text-iconshape-accent-gradient-text": "{Colors.Primary.800-opacity-bold}",
  "Components-Icon shape-Text-iconshape-error-text": "{Colors.Error.600}",
  "Components-Icon shape-Text-iconshape-success-text": "{Colors.Success.500}",
  "Components-Icon shape-Text-iconshape-white-default-text": "{Colors.Neutral.050}",
  "Components-Toggle-Background-toggle-active": "{Colors.Indigo.400}",
  "Components-Toggle-Background-toggle-unactive": "{Colors.Neutral.050}",
  "Components-Toggle-Background-toggle-disabled": "{Colors.Gray.300}",
  "Components-Toggle-Background-toggle-active-switch": "{Background.background-white}",
  "Components-Toggle-Background-toggle-disabled-switch": "{Colors.Gray.500}",
  "Components-Toggle-Icon-toggle-icon": "{Colors.Indigo.400}",
  "Components-Toggle-Icon-toggle-icon-disabled": "{Colors.Gray.200}",
  "Components-Toggle-Border-toggle-active-border": "{Colors.Indigo.300}",
  "Components-Toggle-Border-toggle-unactive-border": "{Colors.Neutral.500}",
  "Components-Toggle-Border-toggle-disabled-border": "{Colors.Gray.400}",
  "Border-border-black-default": "{Colors.Primary.800-base}",
  "Border-border-white-default": "{Colors.Neutral.400}",
  "Border-border-base": "{Colors.Gray.500}",
  "Border-border-base-medium": "{Colors.Gray.300}",
  "Border-border-base-soft": "{Colors.Gray.200}",
  "Border-border-disabled": "{Colors.Gray.300}",
  "Border-border-disabled-subtle": "{Colors.Gray.200}",
  "Border-border-primary-button": "{Colors.Gray.500}",
  "Border-border-primary-button-hover": "{Colors.Indigo.100}",
  "Border-border-secondary-button": "{Colors.Neutral.400}",
  "Border-border-secondary-button-hover": "{Colors.Indigo.400}",
  "Border-border-secondary-button-focus": "{Colors.Cyan.500}",
  "Border-border-tertiary-hover": "{Colors.White opacity.50-opacity}",
  "Border-border-tab": "{white}",
  "Border-border-tab-hover": "{Colors.Indigo.400}",
  "Border-border-tab-hover 2": "{Colors.Indigo.400}",
  "Border-border-accent": "{Colors.Indigo.500}",
  "Border-border-accent-subtle": "{Colors.Indigo.200}",
  "Border-border-hover": "{Colors.Violet.800}",
  "Border-border-info": "{Colors.Indigo.500}",
  "Border-border-info-strong": "{Colors.Indigo.700}",
  "Border-border-info-subtle": "{Colors.Indigo.200}",
  "Border-border-success-strong": "{Colors.Success.700}",
  "Border-border-success": "{Colors.Success.500}",
  "Border-border-error-strong": "{Colors.Error.700}",
  "Border-border-error": "{Colors.Error.600}",
  "Border-border-error-subtle": "{Colors.Error.200}",
  "Border-border-warning": "{Colors.Warning.500}",
  "Border-border-warning-subtle": "{Colors.Warning.200}",
  "Border-border-ia": "{Colors.Purple.200}",
  "Border-border-accessibility": "{Colors.Neutral.400}",
  "Border-border-white-full": "{white}"
}, pU = {
  "Background-background-black-default": "{Colors.Primary.800-base}",
  "Background-background-white": "{white}",
  "Background-background-white-secondary": "{Colors.Neutral.100}",
  "Background-background-white-secondary-soft": "{Colors.Neutral.050}",
  "Background-background-white-tertiary": "{Colors.Gray.100}",
  "Background-background-selected": "{Colors.Gray.050}",
  "Background-background-info": "{Colors.Indigo.50}",
  "Background-background-success": "{Colors.Success.50}",
  "Background-background-warning": "{Colors.Warning.50}",
  "Background-background-error": "{Colors.Error.50}",
  "Background-background-hover": "{Colors.Indigo.50}",
  "Background-background-accent": "{Colors.Indigo.50}",
  "Background-background-accent-strong": "{Colors.Indigo.50}",
  "Background-background-disabled": "{Colors.Gray.100}",
  "Background-background-disabled-strong": "{Colors.Gray.400}",
  "Background-background-disabled-opacity": "{Colors.Gray.200-opacity-medium}",
  "Background-background-disabled-subtle": "{Colors.Gray.050}",
  "Background-background-gray": "{Colors.Gray.200}",
  "Background-background-ia": "{Colors.Purple.50}",
  "Text-text-white-default": "{Colors.Neutral.050}",
  "Text-text-white-secondary": "{Colors.Neutral.050}",
  "Text-text-black-default": "{Colors.Primary.800-base}",
  "Text-text-brand-bold": "{Colors.Gray.700}",
  "Text-text-heading": "{Colors.Primary.800-base}",
  "Text-text-body": "{Colors.Gray.700}",
  "Text-text-body-subtle": "{Colors.Gray.600}",
  "Text-text-disabled-strong": "{Colors.Gray.800}",
  "Text-text-disabled-light": "{Colors.Gray.300}",
  "Text-text-success-strong": "{Colors.Success.700}",
  "Text-text-success": "{Colors.Success.600}",
  "Text-text-success-subtle": "{Colors.Success.500}",
  "Text-text-warning": "{Colors.Warning.600}",
  "Text-Text-error": "{Colors.Error.600}",
  "Text-Text-error-strong": "{Colors.Error.700}",
  "Text-Text-error-subtle": "{Colors.Error.500}",
  "Text-Text-link": "{Colors.Indigo.400}",
  "Text-Text-hover": "{Colors.Indigo.300}",
  "Text-Text-info": "{Colors.Indigo.600}",
  "Text-Text-accent": "{Colors.Indigo.400}",
  "Icons-icon-black": "{Colors.Primary.800-base}",
  "Icons-icon-white": "{Colors.Primary.800-base}",
  "Icons-icon-dark-default": "{Colors.Primary.800-base}",
  "Icons-icon-white-default": "{Colors.Neutral.050}",
  "Icons-icon-disabled-strong": "{Colors.Gray.800}",
  "Icons-icon-disabled-light": "{Colors.Gray.300}",
  "Icons-icon-base": "{Colors.Gray.500}",
  "Icons-icon-base-strong": "{Colors.Gray.700}",
  "Icons-icon-link": "{Colors.Indigo.400}",
  "Icons-icon-success": "{Colors.Success.500}",
  "Icons-icon-success-subtle": "{Colors.Success.300}",
  "Icons-icon-warning": "{Colors.Warning.300}",
  "Icons-icon-error": "{Colors.Error.500}",
  "Icons-icon-info": "{Colors.Indigo.400}",
  "Icons-icon-hover": "{Colors.Indigo.300}",
  "Icons-icon-accent": "{Colors.Indigo.400}",
  "Icons-icon-accent-strong": "{Colors.Indigo.600}",
  "Icons-icon-ia": "{Colors.Purple.600}",
  "Icons-icon-cyan": "{Colors.Cyan.600}",
  "Icons-icon-color-default": "{Colors.Cyan.700}",
  "Components-Button-button-disabled": "{Colors.Gray.400}",
  "Components-Button-Primary-button-primary": "{Colors.Black opacity.50-opacity-bold}",
  "Components-Button-Primary-button-primary-hover": "{Colors.Gray.500}",
  "Components-Button-Secondary-button-secondary": "{Colors.Neutral.050}",
  "Components-Button-Secondary-button-secondary-hover": "{Colors.Primary.800-opacity-bold}",
  "Components-Button-Secondary-button-secondary-focused": "{Colors.Indigo.500}",
  "Components-Button-Tertiary-button-tertiary-hover": "{Colors.Indigo.400}",
  "Components-Button-Tertiary-button-tertiary-focused": "{Colors.Primary.800-base}",
  "Components-Button-Tab-button-tab-default": "{Colors.Gray.200-opacity-medium}",
  "Components-Button-Tab-button-tab": "{Colors.Neutral.050}",
  "Components-Button-Tab-button-tab-hover": "{Colors.Indigo.400}",
  "Components-Button-Tab-button-tab-active": "{Colors.Gray.050}",
  "Components-Button-Text-button-text": "{Colors.Primary.800-base}",
  "Components-Button-Text-button-text-hover": "{Colors.Indigo.700}",
  "Components-Button-Ghost-button-ghost-hover": "{Colors.Indigo.400}",
  "Components-Button-Functional-Success-button-success": "{Colors.Success.200}",
  "Components-Button-Functional-Success-button-success-hover": "{Colors.Success.500}",
  "Components-Button-Functional-Success-button-success-focused": "{Colors.Success.600}",
  "Components-Button-Functional-Desctructive error-Background-button-error": "{Colors.Error.400}",
  "Components-Button-Functional-Desctructive error-Background-button-error-hover": "{Colors.Error.300}",
  "Components-Button-Functional-Desctructive error-Background-button-error-focused": "{Colors.Error.400}",
  "Components-Button-Functional-Desctructive error-Icons-button-error-icon": "{Colors.Error.500}",
  "Components-Button-Functional-Desctructive error-Icons-button-error-hover-icon": "{Colors.Error.700}",
  "Components-Button-Functional-Desctructive error-Icons-button-error-focused-icon": "{Colors.Error.700}",
  "Components-Badge-Background-badge-disabled-bg": "{Colors.Gray.200-opacity-medium}",
  "Components-Badge-Background-badge-gray-bg": "{Colors.Gray.200-opacity-medium}",
  "Components-Badge-Background-badge-error-bg": "{Colors.Error.200}",
  "Components-Badge-Background-badge-error-strong-bg": "{Colors.Error.200}",
  "Components-Badge-Background-badge-orange-bg": "{Colors.Warning.100}",
  "Components-Badge-Background-badge-orange-strong-bg": "{Colors.Warning.100}",
  "Components-Badge-Background-badge-yellow-bg": "{Colors.Yellow.100}",
  "Components-Badge-Background-badge-yellow-strong-bg": "{Colors.Yellow.100}",
  "Components-Badge-Background-badge-green-bg": "{Colors.Success.100}",
  "Components-Badge-Background-badge-green-strong-bg": "{Colors.Success.100}",
  "Components-Badge-Background-badge-indigo-soft-bg": "{Colors.Indigo.100}",
  "Components-Badge-Background-badge-indigo-medium-bg": "{Colors.Indigo.100}",
  "Components-Badge-Background-badge-indigo-strong-bg": "{Colors.Indigo.600}",
  "Components-Badge-Background-badge-accent-bg": "{Colors.Indigo.80-opacity}",
  "Components-Badge-Background-badge-violet-bg": "{Colors.Violet.200}",
  "Components-Badge-Background-badge-violet-strong-bg": "{Colors.Violet.200}",
  "Components-Badge-Background-badge-purple-bg": "{Colors.Purple.100}",
  "Components-Badge-Background-badge-purple-strong-bg": "{Colors.Purple.100}",
  "Components-Badge-Background-badge-neutral-bg": "{Colors.Neutral.200}",
  "Components-Badge-Background-badge-neutral-strong-bg": "{Colors.Neutral.200}",
  "Components-Badge-Background-badge-cyan-bg": "{Colors.Cyan.100}",
  "Components-Badge-Background-badge-cyan-strong-bg": "{Colors.Cyan.100}",
  "Components-Badge-Background-badge-white-bg": "{white}",
  "Components-Badge-Background-badge-dark-bg": "{Colors.Neutral.700}",
  "Components-Badge-Icon-badge-disabled-icon": "{Colors.Gray.200-opacity-medium}",
  "Components-Badge-Icon-badge-black-icon": "{black}",
  "Components-Badge-Icon-badge-white-icon": "{white}",
  "Components-Badge-Icon-badge-white-default-icon": "{Colors.Neutral.100}",
  "Components-Badge-Icon-badge-dark-icon": "{Colors.Neutral.700}",
  "Components-Badge-Icon-badge-black-default-icon": "{Colors.Primary.800-base}",
  "Components-Badge-Text-badge-disabled-strong-text": "{Colors.Gray.200-opacity-medium}",
  "Components-Badge-Text-badge-white-text": "{white}",
  "Components-Badge-Text-badge-white-default-text": "{white}",
  "Components-Badge-Text-badge-black-text": "{Colors.Neutral.700}",
  "Components-Badge-Text-badge-black-default-text": "{Colors.Neutral.700}",
  "Components-Badge-Text-badge-body-text": "{Colors.Neutral.700}",
  "Components-Badge-Border-badge-disabled-border": "{Colors.Gray.200-opacity-medium}",
  "Components-Badge-Border-badge-white-border": "{white}",
  "Components-Badge-Border-badge-white-default-border": "{white}",
  "Components-Badge-Border-badge-base-soft-border": "{white}",
  "Components-Badge-Border-badge-black-border": "{Colors.Neutral.700}",
  "Components-Badge-Border-badge-dark-default-border": "{Colors.Neutral.700}",
  "Components-Icon shape-Background-iconshape-disabled-bg": "{Colors.Gray.200-opacity-medium}",
  "Components-Icon shape-Background-iconshape-red-bg": "{Colors.Error.100}",
  "Components-Icon shape-Background-iconshape-orange-bg": "{Colors.Warning.100}",
  "Components-Icon shape-Background-iconshape-yellow-bg": "{Colors.Yellow.100}",
  "Components-Icon shape-Background-iconshape-green-bg": "{Colors.Success.100}",
  "Components-Icon shape-Background-iconshape-indigo-bg": "{Colors.Indigo.100}",
  "Components-Icon shape-Background-iconshape-violet-bg": "{Colors.Violet.200}",
  "Components-Icon shape-Background-iconshape-purple-bg": "{Colors.Purple.100}",
  "Components-Icon shape-Background-iconshape-neutral-bg": "{Colors.Neutral.200}",
  "Components-Icon shape-Background-iconshape-cyan-bg": "{Colors.Cyan.100}",
  "Components-Icon shape-Background-iconshape-black-bg": "{black}",
  "Components-Icon shape-Background-iconshape-black-default-bg": "{Colors.Primary.800-base}",
  "Components-Icon shape-Background-iconshape-white-bg": "{white}",
  "Components-Icon shape-Background-iconshape-success-bg": "{Colors.Success.600}",
  "Components-Icon shape-Background-iconshape-error-bg": "{Colors.Error.500}",
  "Components-Icon shape-Background-iconshape-accent-bg": "{Colors.Indigo.50}",
  "Components-Icon shape-Icon-iconshape-black-icon": "{black}",
  "Components-Icon shape-Icon-iconshape-white-icon": "{white}",
  "Components-Icon shape-Icon-iconshape-white-default-icon": "{Colors.Neutral.100}",
  "Components-Icon shape-Icon-iconshape-disabled-icon": "{Colors.Gray.200-opacity-medium}",
  "Components-Icon shape-Icon-iconshape-disabled-strong-icon": "{Colors.Gray.200-opacity-medium}",
  "Components-Icon shape-Icon-iconshape-success-icon": "{Colors.Success.600}",
  "Components-Icon shape-Icon-iconshape-red-icon": "{Colors.Error.500}",
  "Components-Icon shape-Icon-iconshape-error-icon": "{Colors.Error.500}",
  "Components-Icon shape-Icon-iconshape-brand-icon": "{Colors.Primary.800-base}",
  "Components-Icon shape-Icon-iconshape-accent-gradient-icon": "{Colors.Indigo.50}",
  "Components-Icon shape-Icon-iconshape-orange-icon": "{Colors.Warning.100}",
  "Components-Icon shape-Icon-iconshape-yellow-icon": "{Colors.Yellow.100}",
  "Components-Icon shape-Icon-iconshape-green-icon": "{Colors.Success.100}",
  "Components-Icon shape-Icon-iconshape-indigo-icon": "{Colors.Indigo.100}",
  "Components-Icon shape-Icon-iconshape-violet-icon": "{Colors.Violet.100}",
  "Components-Icon shape-Icon-iconshape-purple-icon": "{Colors.Purple.700}",
  "Components-Icon shape-Icon-iconshape-neutral-icon": "{Colors.Neutral.200}",
  "Components-Icon shape-Icon-iconshape-default-icon": "{Colors.Cyan.600}",
  "Components-Icon shape-Border-iconshape-disabled-border": "{Colors.Gray.300}",
  "Components-Icon shape-Border-iconshape-default-border": "{Colors.Gray.500}",
  "Components-Icon shape-Border-iconshape-accent-border": "{Colors.Cyan.600}",
  "Components-Icon shape-Border-iconshape-error-border": "{Colors.Cyan.600}",
  "Components-Icon shape-Border-iconshape-success-border": "{Colors.Cyan.600}",
  "Components-Icon shape-Text-iconshape-disabled-text": "{Colors.Gray.300}",
  "Components-Icon shape-Text-iconshape-black-default-text": "{Colors.Gray.300}",
  "Components-Icon shape-Text-iconshape-default-text": "{Colors.Gray.300}",
  "Components-Icon shape-Text-iconshape-accent-gradient-text": "{Colors.Cyan.600}",
  "Components-Icon shape-Text-iconshape-error-text": "{Colors.Cyan.600}",
  "Components-Icon shape-Text-iconshape-success-text": "{Colors.Cyan.600}",
  "Components-Icon shape-Text-iconshape-white-default-text": "{Colors.Cyan.600}",
  "Components-Toggle-Background-toggle-active": "{Colors.Indigo.500}",
  "Components-Toggle-Background-toggle-unactive": "{Colors.Neutral.050}",
  "Components-Toggle-Background-toggle-disabled": "{Colors.Gray.300}",
  "Components-Toggle-Background-toggle-active-switch": "{Background.background-white}",
  "Components-Toggle-Background-toggle-disabled-switch": "{Colors.Gray.500}",
  "Components-Toggle-Icon-toggle-icon": "{Colors.Indigo.500}",
  "Components-Toggle-Icon-toggle-icon-disabled": "{Colors.Gray.200}",
  "Components-Toggle-Border-toggle-active-border": "{Colors.Indigo.400}",
  "Components-Toggle-Border-toggle-unactive-border": "{Colors.Neutral.500}",
  "Components-Toggle-Border-toggle-disabled-border": "{Colors.Gray.400}",
  "Border-border-black-default": "{Colors.Primary.800-base}",
  "Border-border-white-default": "{Colors.Neutral.400}",
  "Border-border-base": "{Colors.Gray.500}",
  "Border-border-base-medium": "{Colors.Gray.300}",
  "Border-border-base-soft": "{Colors.Gray.200}",
  "Border-border-disabled": "{Colors.Gray.200}",
  "Border-border-disabled-subtle": "{Colors.Gray.200}",
  "Border-border-primary-button": "{Colors.Gray.400}",
  "Border-border-primary-button-hover": "{Colors.Indigo.100}",
  "Border-border-secondary-button": "{Colors.Neutral.400}",
  "Border-border-secondary-button-hover": "{Colors.Indigo.400}",
  "Border-border-secondary-button-focus": "{Colors.Cyan.500}",
  "Border-border-tertiary-hover": "{Colors.White opacity.50-opacity-medium}",
  "Border-border-tab": "{white}",
  "Border-border-tab-hover": "{Colors.Indigo.400}",
  "Border-border-tab-hover 2": "{Colors.Indigo.300}",
  "Border-border-accent": "{Colors.Indigo.400}",
  "Border-border-accent-subtle": "{Colors.Indigo.200}",
  "Border-border-hover": "{Colors.Indigo.400}",
  "Border-border-info": "{Colors.Indigo.400}",
  "Border-border-info-strong": "{Colors.Indigo.700}",
  "Border-border-info-subtle": "{Colors.Indigo.200}",
  "Border-border-success-strong": "{Colors.Success.600}",
  "Border-border-success": "{Colors.Success.400}",
  "Border-border-error-strong": "{Colors.Error.700}",
  "Border-border-error": "{Colors.Error.500}",
  "Border-border-error-subtle": "{Colors.Error.300}",
  "Border-border-warning": "{Colors.Warning.500}",
  "Border-border-warning-subtle": "{Colors.Warning.200}",
  "Border-border-ia": "{Colors.Purple.200}",
  "Border-border-accessibility": "{Colors.Neutral.400}",
  "Border-border-white-full": "{white}"
}, mU = {
  "spacing-0": "{number.0}",
  "spacing-1": "{number.1}",
  "spacing-2": "{number.2}",
  "spacing-3": "{number.3}",
  "spacing-4": "{number.4}",
  "spacing-5": "{number.5}",
  "spacing-6": "{number.6}",
  "spacing-8": "{number.8}",
  "spacing-9": "{number.9}",
  "spacing-10": "{number.10}",
  "spacing-12": "{number.12}",
  "spacing-14": "{number.14}",
  "spacing-16": "{number.16}",
  "spacing-20": "{number.20}",
  "spacing-24": "{number.24}",
  "spacing-px": "{number.px}",
  "spacing-0.5": "{number.0.5}",
  "spacing-1.5": "{number.1.5}",
  "spacing-3.5": "{number.3.5}",
  "icon-size-xs": "{number.3.5}",
  "icon-size-sm": "{number.4}",
  "icon-size-md": "{number.5}",
  "icon-size-lg": "{number.6}",
  "border-border-radius-rounded-0": "{border.border-radius.rounded-0}",
  "border-border-radius-rounded-xxs": "{border.border-radius.rounded-xxs}",
  "border-border-radius-rounded-xs": "{border.border-radius.rounded-xs}",
  "border-border-radius-rounded-sm": "{border.border-radius.rounded-sm}",
  "border-border-radius-rounded-l": "{border.border-radius.rounded-l}",
  "border-border-radius-rounded-base": "{border.border-radius.rounded-base}",
  "border-border-radius-rounded-xl": "{border.border-radius.rounded-xl}",
  "border-border-radius-rounded-xxl": "{border.border-radius.rounded-xxl}",
  "border-border-radius-rounded-full": "{border.border-radius.rounded-full}",
  "border-border-width-border-0": "{border.border-width.border-0}",
  "border-border-width-border": "{border.border-width.border}",
  "border-border-width-border-sm": "{border.border-width.border-sm}",
  "border-border-width-border-base": "{border.border-width.border-2}",
  "border-border-width-border-md": "{border.border-width.border-3}",
  "border-border-width-border-lg": "{border.border-width.border-4}",
  "border-border-width-border-xl": "{border.border-width.border-8}"
}, vU = {
  "Family-heading": "inter",
  "Family-text": "inter",
  "Size-xs": 10,
  "Size-sm": 12,
  "Size-m": 14,
  "Size-l": 16,
  "Size-xl": 18,
  "Size-xxl": 20,
  "Size-3xl": 22,
  "Size-4xl": 24,
  "Size-5xl": 28,
  "Size-6xl": 36,
  "Size-7xl": 40,
  "Size-8xl": 48,
  "Size-9xl": 52,
  "Weight-thin": 100,
  "Weight-extra-light": 200,
  "Weight-light": 300,
  "Weight-regular": 400,
  "Weight-medium": 500,
  "Weight-semi-bold": 600,
  "Weight-bold": 700,
  "Weight-extra-bold": 800,
  "Weight-black": 900,
  "Line-height-xs": 12,
  "Line-height-s": 14,
  "Line-height-m": 18,
  "Line-height-l": 20,
  "Line-height-xl": 22,
  "Line-height-xxl": 24,
  "Line-height-3xl": 26,
  "Line-height-4xl": 29,
  "Line-height-5xl": 34,
  "Line-height-6xl": 43,
  "Letter-spacing-Letter-spacing": 0,
  "Letter-case-case-original": "none",
  "Letter-case-case-upper": "uppercase",
  "Letter-case-case-lower": "lowercase",
  "Letter-case-case-title": "capitalize",
  "Letter-case-case-smallcaps": "smallcaps"
}, xU = {
  "Grid-grid-columns-l": "{number.2}",
  "Grid-grid-columns-m": "{number.1}",
  "Grid-grid-columns-xs": "{number.px}",
  "Grid-margin-4xl": "{number.24}",
  "Grid-margin-l": "{number.24}",
  "Grid-gutter": "{number.5}",
  "Grid-Sidebar-sidebar-open": 317,
  "Grid-Sidebar-sidebar-close": 158,
  "Grid-Sidebar-sidebar-toolbox": 279,
  "Grid-Container-cont-size": 1563,
  "Grid-Container-cont-size-navclosed": 1762,
  "Grid-Container-cont-size-toolbox": 1664,
  "Grid-Navbar-navbar-size": 1601,
  "Grid-Navbar-navbarclosed-size": 1762,
  "Breakpoints-width-XL": 1440,
  "Breakpoints-width-XXL": 1920
};
export {
  Pb as ACCORDION_CONTEXT_KEY,
  Fb as ACCORDION_ITEM_CONTEXT_KEY,
  TW as AccessSettings,
  CW as Accordion,
  SW as AccordionItem,
  rq as AddressInput,
  nx as AdvancedFilterBody,
  cU as AdvancedFilterBuilder,
  ax as AdvancedFilterFooter,
  fU as AdvancedFilterPopover,
  Ul as Alert,
  W3 as AutoComplete,
  sq as AutoCompleteAllResultsModal,
  Kt as Avatar,
  pM as AvatarGroup,
  iq as AvatarLabel,
  ct as Badge,
  bU as Banner,
  hU as Breadcrumb,
  Re as Button,
  Hk as ButtonGroup,
  $W as ButtonLink,
  Wq as Card,
  qq as CardSelectable,
  Cn as Checkbox,
  HW as CheckboxForm,
  NW as CheckboxGroup,
  $4 as CollapsibleSearch,
  eU as CollapsibleSection,
  dU as ColorPicker,
  bq as CompactPager,
  zq as ConfirmDeleteModal,
  PW as CopyInput,
  Kj as CriteriaGroup,
  Qq as CtaWidget,
  Gh as DEFAULT_COUNTRY,
  Sl as DEFAULT_PHONE_FORMAT,
  Ov as DEFAULT_TABLE_LABELS,
  Vq as DataTable,
  TV as DataTableBody,
  Oq as DataTableCaption,
  hu as DataTableCell,
  IV as DataTableContainer,
  Pq as DataTableEmpty,
  Fq as DataTableFooter,
  HV as DataTableHead,
  jV as DataTableHeader,
  Zo as DataTableRow,
  jq as DataTableWrapper,
  XW as DateGroupHeader,
  fu as DatePickerInput,
  E3 as DateRangePickerInput,
  Er as DatepickerCell,
  d3 as DatepickerControls,
  o3 as DatepickerDobPicker,
  Mc as DatepickerDropdownMenu,
  yv as DatepickerPanel,
  Gq as DetailHeaderWrapper,
  fM as DraggableListItem,
  xP as Drawer,
  Sn as Dropdown,
  uf as DropdownItemButton,
  Gt as DropdownListItem,
  il as DropdownPanelFooter,
  sl as DropdownPanelHeader,
  Mq as DynamicFormField,
  WB as EditableTitle,
  jR as EmailInput,
  tx as FILTER_FIELD_SELECT_PANEL_SELECTOR,
  Ar as FROZEN_COLUMN_LIMIT,
  n8 as FacetedSearchDrawer,
  OW as FieldGroup,
  vt as FieldHelper,
  xt as FieldLabel,
  SH as FieldSkeleton,
  CS as FileUploadInput,
  qu as FilterDropdown,
  Nv as FilterFieldPicker,
  Dj as FilterFieldSelect,
  PO as FilterPill,
  oU as FloatActionBar,
  Bq as FormErrorSummary,
  Dq as FormSaveButton,
  sU as FormSkeleton,
  Xt as IconShape,
  jW as ImageInput,
  nq as ImageUploadInput,
  Yq as InlineLink,
  QW as InteractionListItem,
  Or as LabelDropdown,
  lD as ListItem,
  eq as ListItemAccordion,
  tq as ListItemAccordionRow,
  cM as ListItemCard,
  VB as ListItemGroup,
  hq as LookupInput,
  mq as MainDrawer,
  ZW as MaskedInput,
  Kq as Masonry,
  _W as MeetingListItem,
  zW as MetricCardAction,
  DW as MetricCardProgress,
  EW as MetricCardSimple,
  BW as MetricCardWithBadge,
  MW as MetricCardWithChart,
  AW as MetricCardWithIcon,
  RW as MetricCardWithTrend,
  za as Modal,
  s1 as MultipleSelect,
  aU as NavTabs,
  Eq as Navbar,
  pf as NumberInput,
  Iv as NumberRangeInput,
  fq as OtpInput,
  Un as PHONE_FORMATS,
  GR as PHONE_FORMATS_BY_DIAL_CODE,
  Uq as PageHeader,
  nO as Pager,
  GW as PasswordInput,
  JW as PhoneDisplay,
  aB as PhoneInput,
  $v as Popover,
  tU as ProfileCard,
  Vu as ProgressBar,
  U2 as RadioButton,
  FW as RadioForm,
  VW as RadioFormGroup,
  $q as RecordsTable,
  oq as RelationInput,
  UW as RichTextEditor,
  Yi as SearchInput,
  Lq as SecondarySidebar,
  rU as SegmentedPager,
  Tl as SelectInput,
  Tq as Sidebar,
  IW as SortDropdown,
  Aq as SpeedDial,
  Ru as Spinner,
  _q as StatsWidget,
  uU as StepperNavigation,
  lU as StepperWizardSidenav,
  uO as TABLE_COLUMN_SETTINGS_KEY,
  Mv as TABLE_LABELS_KEY,
  Bv as TABLE_PERMISSIONS_KEY,
  Xl as TABLE_QUERY_KEY,
  hs as TABLE_SEARCH_DEBOUNCE_MS,
  fs as TABLE_VIEWS_KEY,
  Iq as Table,
  Fv as TableControls,
  Vv as TableFilterBar,
  Sq as TableFilterSelector,
  yq as TableHeader,
  O8 as TablePanel,
  xq as TableShell,
  HO as TableSkeleton,
  Pv as TableTopbar,
  T4 as TagInput,
  zt as TextInput,
  $n as TextLink,
  WW as Textarea,
  dq as TimePickerInput,
  nU as Timeline,
  Rq as ToastContainer,
  aV as ToastItem,
  cq as ToggleGroup,
  uq as ToggleInput,
  Ga as ToggleSwitch,
  ft as Tooltip,
  bt as TruncatedText,
  kV as UnsavedChangesModal,
  lq as UrlInput,
  LW as WeekNavigator,
  Zq as WidgetBlock,
  Xq as WidgetSection,
  Jq as WidgetShell,
  aq as YearMonthPickerInput,
  hg as attachedPartClasses,
  yy as buttonGroupTabId,
  pU as colorsDark,
  gU as colorsLight,
  Nq as createPhoneValidator,
  gv as datePatternFromFormat,
  mv as deleteAcrossSeparator,
  qR as digitMaskFromPattern,
  Ra as fieldButtonSize,
  Du as formatCountLabel,
  Jr as formatGroupedDigits,
  KR as formatPhoneForDisplay,
  su as groupMaskFromPlaceholder,
  lr as groupPreservingTrunkZero,
  Fc as isDraftGroup,
  Xv as isGroupNode,
  Vc as isMultiValue,
  Zr as isValueless,
  gq as mapApiPaginated,
  Uh as maskGroupedInput,
  pv as maskLiveInput,
  $b as parse,
  xU as semanticBreakpoints,
  mU as semanticSpacing,
  vU as semanticTypography,
  Vo as serialize,
  Ac as significantDigitCount,
  Kh as stripTrunkZero,
  YW as toE164,
  ex as useAdvancedFilterActions,
  Cq as useColumnSettings,
  Lj as useCriteriaBuilder,
  GN as useDirtyState,
  Vb as useDisclosure,
  vq as useDrawer,
  Yl as useDropdown,
  iU as useFloatActionBarActions,
  Gi as useFocusTrap,
  Hq as useForm,
  UN as useFormSubmit,
  qN as useFormValidation,
  Ht as useHasSlot,
  xv as useListRowSurface,
  KN as useMediaQuery,
  wq as useResponsivePageSize,
  no as useRovingListbox,
  Dw as useSortable,
  io as useTableLabels,
  pq as useTableQuery,
  kq as useTableViews,
  jF as useToast,
  S0 as useTruncationDetector,
  KW as withHeuristicTrunkZero
};
